
/*!
 * Webflow: Front-end site library
 * @license MIT
 * Inline scripts may access the api using an async handler:
 *   var Webflow = Webflow || [];
 *   Webflow.push(readyFunction);
 */

(() => { // webpackBootstrap
var __webpack_modules__ = ({
41471: (function (module, exports) {
/*!
 * accounting.js v0.4.1
 * Copyright 2014 Open Exchange Rates
 *
 * Freely distributable under the MIT license.
 * Portions of accounting.js are inspired or borrowed from underscore.js
 *
 * Full details and documentation:
 * http://openexchangerates.github.io/accounting.js/
 */

(function(root, undefined) {

	/* --- Setup --- */

	// Create the local library object, to be exported or referenced globally later
	var lib = {};

	// Current version
	lib.version = '0.4.1';


	/* --- Exposed settings --- */

	// The library's settings configuration object. Contains default parameters for
	// currency and number formatting
	lib.settings = {
		currency: {
			symbol : "$",		// default currency symbol is '$'
			format : "%s%v",	// controls output: %s = symbol, %v = value (can be object, see docs)
			decimal : ".",		// decimal point separator
			thousand : ",",		// thousands separator
			precision : 2,		// decimal places
			grouping : 3		// digit grouping (not implemented yet)
		},
		number: {
			precision : 0,		// default precision on numbers is 0
			grouping : 3,		// digit grouping (not implemented yet)
			thousand : ",",
			decimal : "."
		}
	};


	/* --- Internal Helper Methods --- */

	// Store reference to possibly-available ECMAScript 5 methods for later
	var nativeMap = Array.prototype.map,
		nativeIsArray = Array.isArray,
		toString = Object.prototype.toString;

	/**
	 * Tests whether supplied parameter is a string
	 * from underscore.js
	 */
	function isString(obj) {
		return !!(obj === '' || (obj && obj.charCodeAt && obj.substr));
	}

	/**
	 * Tests whether supplied parameter is a string
	 * from underscore.js, delegates to ECMA5's native Array.isArray
	 */
	function isArray(obj) {
		return nativeIsArray ? nativeIsArray(obj) : toString.call(obj) === '[object Array]';
	}

	/**
	 * Tests whether supplied parameter is a true object
	 */
	function isObject(obj) {
		return obj && toString.call(obj) === '[object Object]';
	}

	/**
	 * Extends an object with a defaults object, similar to underscore's _.defaults
	 *
	 * Used for abstracting parameter handling from API methods
	 */
	function defaults(object, defs) {
		var key;
		object = object || {};
		defs = defs || {};
		// Iterate over object non-prototype properties:
		for (key in defs) {
			if (defs.hasOwnProperty(key)) {
				// Replace values with defaults only if undefined (allow empty/zero values):
				if (object[key] == null) object[key] = defs[key];
			}
		}
		return object;
	}

	/**
	 * Implementation of `Array.map()` for iteration loops
	 *
	 * Returns a new Array as a result of calling `iterator` on each array value.
	 * Defers to native Array.map if available
	 */
	function map(obj, iterator, context) {
		var results = [], i, j;

		if (!obj) return results;

		// Use native .map method if it exists:
		if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);

		// Fallback for native .map:
		for (i = 0, j = obj.length; i < j; i++ ) {
			results[i] = iterator.call(context, obj[i], i, obj);
		}
		return results;
	}

	/**
	 * Check and normalise the value of precision (must be positive integer)
	 */
	function checkPrecision(val, base) {
		val = Math.round(Math.abs(val));
		return isNaN(val)? base : val;
	}


	/**
	 * Parses a format string or object and returns format obj for use in rendering
	 *
	 * `format` is either a string with the default (positive) format, or object
	 * containing `pos` (required), `neg` and `zero` values (or a function returning
	 * either a string or object)
	 *
	 * Either string or format.pos must contain "%v" (value) to be valid
	 */
	function checkCurrencyFormat(format) {
		var defaults = lib.settings.currency.format;

		// Allow function as format parameter (should return string or object):
		if ( typeof format === "function" ) format = format();

		// Format can be a string, in which case `value` ("%v") must be present:
		if ( isString( format ) && format.match("%v") ) {

			// Create and return positive, negative and zero formats:
			return {
				pos : format,
				neg : format.replace("-", "").replace("%v", "-%v"),
				zero : format
			};

		// If no format, or object is missing valid positive value, use defaults:
		} else if ( !format || !format.pos || !format.pos.match("%v") ) {

			// If defaults is a string, casts it to an object for faster checking next time:
			return ( !isString( defaults ) ) ? defaults : lib.settings.currency.format = {
				pos : defaults,
				neg : defaults.replace("%v", "-%v"),
				zero : defaults
			};

		}
		// Otherwise, assume format was fine:
		return format;
	}


	/* --- API Methods --- */

	/**
	 * Takes a string/array of strings, removes all formatting/cruft and returns the raw float value
	 * Alias: `accounting.parse(string)`
	 *
	 * Decimal must be included in the regular expression to match floats (defaults to
	 * accounting.settings.number.decimal), so if the number uses a non-standard decimal 
	 * separator, provide it as the second argument.
	 *
	 * Also matches bracketed negatives (eg. "$ (1.99)" => -1.99)
	 *
	 * Doesn't throw any errors (`NaN`s become 0) but this may change in future
	 */
	var unformat = lib.unformat = lib.parse = function(value, decimal) {
		// Recursively unformat arrays:
		if (isArray(value)) {
			return map(value, function(val) {
				return unformat(val, decimal);
			});
		}

		// Fails silently (need decent errors):
		value = value || 0;

		// Return the value as-is if it's already a number:
		if (typeof value === "number") return value;

		// Default decimal point comes from settings, but could be set to eg. "," in opts:
		decimal = decimal || lib.settings.number.decimal;

		 // Build regex to strip out everything except digits, decimal point and minus sign:
		var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]),
			unformatted = parseFloat(
				("" + value)
				.replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
				.replace(regex, '')         // strip out any cruft
				.replace(decimal, '.')      // make sure decimal point is standard
			);

		// This will fail silently which may cause trouble, let's wait and see:
		return !isNaN(unformatted) ? unformatted : 0;
	};


	/**
	 * Implementation of toFixed() that treats floats more like decimals
	 *
	 * Fixes binary rounding issues (eg. (0.615).toFixed(2) === "0.61") that present
	 * problems for accounting- and finance-related software.
	 */
	var toFixed = lib.toFixed = function(value, precision) {
		precision = checkPrecision(precision, lib.settings.number.precision);
		var power = Math.pow(10, precision);

		// Multiply up by precision, round accurately, then divide and use native toFixed():
		return (Math.round(lib.unformat(value) * power) / power).toFixed(precision);
	};


	/**
	 * Format a number, with comma-separated thousands and custom precision/decimal places
	 * Alias: `accounting.format()`
	 *
	 * Localise by overriding the precision and thousand / decimal separators
	 * 2nd parameter `precision` can be an object matching `settings.number`
	 */
	var formatNumber = lib.formatNumber = lib.format = function(number, precision, thousand, decimal) {
		// Resursively format arrays:
		if (isArray(number)) {
			return map(number, function(val) {
				return formatNumber(val, precision, thousand, decimal);
			});
		}

		// Clean up number:
		number = unformat(number);

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(precision) ? precision : {
					precision : precision,
					thousand : thousand,
					decimal : decimal
				}),
				lib.settings.number
			),

			// Clean up precision
			usePrecision = checkPrecision(opts.precision),

			// Do some calc:
			negative = number < 0 ? "-" : "",
			base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "",
			mod = base.length > 3 ? base.length % 3 : 0;

		// Format the number:
		return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split('.')[1] : "");
	};


	/**
	 * Format a number into currency
	 *
	 * Usage: accounting.formatMoney(number, symbol, precision, thousandsSep, decimalSep, format)
	 * defaults: (0, "$", 2, ",", ".", "%s%v")
	 *
	 * Localise by overriding the symbol, precision, thousand / decimal separators and format
	 * Second param can be an object matching `settings.currency` which is the easiest way.
	 *
	 * To do: tidy up the parameters
	 */
	var formatMoney = lib.formatMoney = function(number, symbol, precision, thousand, decimal, format) {
		// Resursively format arrays:
		if (isArray(number)) {
			return map(number, function(val){
				return formatMoney(val, symbol, precision, thousand, decimal, format);
			});
		}

		// Clean up number:
		number = unformat(number);

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(symbol) ? symbol : {
					symbol : symbol,
					precision : precision,
					thousand : thousand,
					decimal : decimal,
					format : format
				}),
				lib.settings.currency
			),

			// Check format (returns object with pos, neg and zero):
			formats = checkCurrencyFormat(opts.format),

			// Choose which format to use for this value:
			useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;

		// Return with currency symbol added:
		return useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
	};


	/**
	 * Format a list of numbers into an accounting column, padding with whitespace
	 * to line up currency symbols, thousand separators and decimals places
	 *
	 * List should be an array of numbers
	 * Second parameter can be an object containing keys that match the params
	 *
	 * Returns array of accouting-formatted number strings of same length
	 *
	 * NB: `white-space:pre` CSS rule is required on the list container to prevent
	 * browsers from collapsing the whitespace in the output strings.
	 */
	lib.formatColumn = function(list, symbol, precision, thousand, decimal, format) {
		if (!list) return [];

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(symbol) ? symbol : {
					symbol : symbol,
					precision : precision,
					thousand : thousand,
					decimal : decimal,
					format : format
				}),
				lib.settings.currency
			),

			// Check format (returns object with pos, neg and zero), only need pos for now:
			formats = checkCurrencyFormat(opts.format),

			// Whether to pad at start of string or after currency symbol:
			padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false,

			// Store value for the length of the longest string in the column:
			maxLength = 0,

			// Format the list according to options, store the length of the longest string:
			formatted = map(list, function(val, i) {
				if (isArray(val)) {
					// Recursively format columns if list is a multi-dimensional array:
					return lib.formatColumn(val, opts);
				} else {
					// Clean up the value
					val = unformat(val);

					// Choose which format to use for this value (pos, neg or zero):
					var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero,

						// Format this value, push into formatted list and save the length:
						fVal = useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));

					if (fVal.length > maxLength) maxLength = fVal.length;
					return fVal;
				}
			});

		// Pad each number in the list and send back the column of numbers:
		return map(formatted, function(val, i) {
			// Only if this is a string (not a nested array, which would have already been padded):
			if (isString(val) && val.length < maxLength) {
				// Depending on symbol position, pad after symbol or at index 0:
				return padAfterSymbol ? val.replace(opts.symbol, opts.symbol+(new Array(maxLength - val.length + 1).join(" "))) : (new Array(maxLength - val.length + 1).join(" ")) + val;
			}
			return val;
		});
	};


	/* --- Module Definition --- */

	// Export accounting for CommonJS. If being loaded as an AMD module, define it as such.
	// Otherwise, just add `accounting` to the global object
	if (true) {
		if ( true && module.exports) {
			exports = module.exports = lib;
		}
		exports.accounting = lib;
	} else {}

	// Root will be `window` in browser or `global` on the server:
}(this));


}),
1361: (function (module) {
/**
 * https://github.com/gre/bezier-easing
 * BezierEasing - use bezier curve for transition easing function
 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
 */

// These values are established by empiricism with tests (tradeoff: performance VS precision)
var NEWTON_ITERATIONS = 4;
var NEWTON_MIN_SLOPE = 0.001;
var SUBDIVISION_PRECISION = 0.0000001;
var SUBDIVISION_MAX_ITERATIONS = 10;

var kSplineTableSize = 11;
var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

var float32ArraySupported = typeof Float32Array === 'function';

function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
function C (aA1)      { return 3.0 * aA1; }

// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
function calcBezier (aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT; }

// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
function getSlope (aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1); }

function binarySubdivide (aX, aA, aB, mX1, mX2) {
  var currentX, currentT, i = 0;
  do {
    currentT = aA + (aB - aA) / 2.0;
    currentX = calcBezier(currentT, mX1, mX2) - aX;
    if (currentX > 0.0) {
      aB = currentT;
    } else {
      aA = currentT;
    }
  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
  return currentT;
}

function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
 for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
   var currentSlope = getSlope(aGuessT, mX1, mX2);
   if (currentSlope === 0.0) {
     return aGuessT;
   }
   var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
   aGuessT -= currentX / currentSlope;
 }
 return aGuessT;
}

module.exports = function bezier (mX1, mY1, mX2, mY2) {
  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
    throw new Error('bezier x values must be in [0, 1] range');
  }

  // Precompute samples table
  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
  if (mX1 !== mY1 || mX2 !== mY2) {
    for (var i = 0; i < kSplineTableSize; ++i) {
      sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
    }
  }

  function getTForX (aX) {
    var intervalStart = 0.0;
    var currentSample = 1;
    var lastSample = kSplineTableSize - 1;

    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
      intervalStart += kSampleStepSize;
    }
    --currentSample;

    // Interpolate to provide an initial guess for t
    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
    var guessForT = intervalStart + dist * kSampleStepSize;

    var initialSlope = getSlope(guessForT, mX1, mX2);
    if (initialSlope >= NEWTON_MIN_SLOPE) {
      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
    } else if (initialSlope === 0.0) {
      return guessForT;
    } else {
      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    }
  }

  return function BezierEasing (x) {
    if (mX1 === mY1 && mX2 === mY2) {
      return x; // linear
    }
    // Because JavaScript number are imprecise, we should guarantee the extremes are right.
    if (x === 0) {
      return 0;
    }
    if (x === 1) {
      return 1;
    }
    return calcBezier(getTForX(x), mY1, mY2);
  };
};


}),
31024: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";


var bind = __webpack_require__(52106);

var $apply = __webpack_require__(59451);
var $call = __webpack_require__(97043);
var $reflectApply = __webpack_require__(24770);

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);


}),
59451: (function (module) {
"use strict";


/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;


}),
97043: (function (module) {
"use strict";


/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;


}),
46960: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";


var bind = __webpack_require__(52106);
var $TypeError = __webpack_require__(66671);

var $call = __webpack_require__(97043);
var $actualApply = __webpack_require__(31024);

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};


}),
24770: (function (module) {
"use strict";


/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


}),
3690: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";


var GetIntrinsic = __webpack_require__(7297);

var callBindBasic = __webpack_require__(46960);

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	/* eslint no-extra-parens: 0 */

	var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic(/** @type {const} */ ([intrinsic]));
	}
	return intrinsic;
};


}),
68439: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var isCallable = __webpack_require__(13422);
var tryToString = __webpack_require__(28295);

var TypeError = global.TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};


}),
17759: (function (module, __unused_webpack_exports, __webpack_require__) {
var wellKnownSymbol = __webpack_require__(33608);
var create = __webpack_require__(89638);
var definePropertyModule = __webpack_require__(95827);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


}),
70287: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var isObject = __webpack_require__(63292);

var String = global.String;
var TypeError = global.TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};


}),
59373: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";

var bind = __webpack_require__(14026);
var toObject = __webpack_require__(52631);
var isConstructor = __webpack_require__(38281);
var getAsyncIterator = __webpack_require__(6990);
var getIterator = __webpack_require__(60958);
var getIteratorMethod = __webpack_require__(80306);
var getMethod = __webpack_require__(65963);
var getVirtual = __webpack_require__(97755);
var getBuiltIn = __webpack_require__(19642);
var wellKnownSymbol = __webpack_require__(33608);
var AsyncFromSyncIterator = __webpack_require__(97769);
var toArray = (__webpack_require__(13488)/* .toArray */.toArray);

var ASYNC_ITERATOR = wellKnownSymbol('asyncIterator');
var arrayIterator = getVirtual('Array').values;

// `Array.fromAsync` method implementation
// https://github.com/tc39/proposal-array-from-async
module.exports = function fromAsync(asyncItems /* , mapfn = undefined, thisArg = undefined */) {
  var C = this;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var thisArg = argumentsLength > 2 ? arguments[2] : undefined;
  return new (getBuiltIn('Promise'))(function (resolve) {
    var O = toObject(asyncItems);
    if (mapfn !== undefined) mapfn = bind(mapfn, thisArg);
    var usingAsyncIterator = getMethod(O, ASYNC_ITERATOR);
    var usingSyncIterator = usingAsyncIterator ? undefined : getIteratorMethod(O) || arrayIterator;
    var A = isConstructor(C) ? new C() : [];
    var iterator = usingAsyncIterator
      ? getAsyncIterator(O, usingAsyncIterator)
      : new AsyncFromSyncIterator(getIterator(O, usingSyncIterator));
    resolve(toArray(iterator, mapfn, A));
  });
};


}),
74885: (function (module) {
module.exports = function (Constructor, list) {
  var index = 0;
  var length = list.length;
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};


}),
4655: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var bind = __webpack_require__(14026);
var uncurryThis = __webpack_require__(6201);
var IndexedObject = __webpack_require__(35249);
var toObject = __webpack_require__(52631);
var toPropertyKey = __webpack_require__(25024);
var lengthOfArrayLike = __webpack_require__(97218);
var objectCreate = __webpack_require__(89638);
var arrayFromConstructorAndList = __webpack_require__(74885);

var Array = global.Array;
var push = uncurryThis([].push);

module.exports = function ($this, callbackfn, that, specificConstructor) {
  var O = toObject($this);
  var self = IndexedObject(O);
  var boundFunction = bind(callbackfn, that);
  var target = objectCreate(null);
  var length = lengthOfArrayLike(self);
  var index = 0;
  var Constructor, key, value;
  for (;length > index; index++) {
    value = self[index];
    key = toPropertyKey(boundFunction(value, index, O));
    // in some IE10 builds, `hasOwnProperty` returns incorrect result on integer keys
    // but since it's a `null` prototype object, we can safely use `in`
    if (key in target) push(target[key], value);
    else target[key] = [value];
  }
  if (specificConstructor) {
    Constructor = specificConstructor(O);
    if (Constructor !== Array) {
      for (key in target) target[key] = arrayFromConstructorAndList(Constructor, target[key]);
    }
  } return target;
};


}),
96030: (function (module, __unused_webpack_exports, __webpack_require__) {
var toIndexedObject = __webpack_require__(14920);
var toAbsoluteIndex = __webpack_require__(19892);
var lengthOfArrayLike = __webpack_require__(97218);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


}),
93539: (function (module, __unused_webpack_exports, __webpack_require__) {
var bind = __webpack_require__(14026);
var uncurryThis = __webpack_require__(6201);
var IndexedObject = __webpack_require__(35249);
var toObject = __webpack_require__(52631);
var lengthOfArrayLike = __webpack_require__(97218);
var arraySpeciesCreate = __webpack_require__(38004);

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


}),
84609: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var isArray = __webpack_require__(16937);
var isConstructor = __webpack_require__(38281);
var isObject = __webpack_require__(63292);
var wellKnownSymbol = __webpack_require__(33608);

var SPECIES = wellKnownSymbol('species');
var Array = global.Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


}),
38004: (function (module, __unused_webpack_exports, __webpack_require__) {
var arraySpeciesConstructor = __webpack_require__(84609);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


}),
79022: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";

var getBuiltIn = __webpack_require__(19642);
var uncurryThis = __webpack_require__(6201);
var aCallable = __webpack_require__(68439);
var lengthOfArrayLike = __webpack_require__(97218);
var toObject = __webpack_require__(52631);
var arraySpeciesCreate = __webpack_require__(38004);

var Map = getBuiltIn('Map');
var MapPrototype = Map.prototype;
var mapForEach = uncurryThis(MapPrototype.forEach);
var mapHas = uncurryThis(MapPrototype.has);
var mapSet = uncurryThis(MapPrototype.set);
var push = uncurryThis([].push);

// `Array.prototype.uniqueBy` method
// https://github.com/tc39/proposal-array-unique
module.exports = function uniqueBy(resolver) {
  var that = toObject(this);
  var length = lengthOfArrayLike(that);
  var result = arraySpeciesCreate(that, 0);
  var map = new Map();
  var resolverFunction = resolver != null ? aCallable(resolver) : function (value) {
    return value;
  };
  var index, item, key;
  for (index = 0; index < length; index++) {
    item = that[index];
    key = resolverFunction(item);
    if (!mapHas(map, key)) mapSet(map, key, item);
  }
  mapForEach(map, function (value) {
    push(result, value);
  });
  return result;
};


}),
97769: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";

var apply = __webpack_require__(71168);
var anObject = __webpack_require__(70287);
var create = __webpack_require__(89638);
var getMethod = __webpack_require__(65963);
var redefineAll = __webpack_require__(62275);
var InternalStateModule = __webpack_require__(45723);
var getBuiltIn = __webpack_require__(19642);
var AsyncIteratorPrototype = __webpack_require__(38419);

var Promise = getBuiltIn('Promise');

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.get;

var asyncFromSyncIteratorContinuation = function (result, resolve, reject) {
  var done = result.done;
  Promise.resolve(result.value).then(function (value) {
    resolve({ done: done, value: value });
  }, reject);
};

var AsyncFromSyncIterator = function AsyncIterator(iterator) {
  setInternalState(this, {
    iterator: anObject(iterator),
    next: iterator.next
  });
};

AsyncFromSyncIterator.prototype = redefineAll(create(AsyncIteratorPrototype), {
  next: function next(arg) {
    var state = getInternalState(this);
    var hasArg = !!arguments.length;
    return new Promise(function (resolve, reject) {
      var result = anObject(apply(state.next, state.iterator, hasArg ? [arg] : []));
      asyncFromSyncIteratorContinuation(result, resolve, reject);
    });
  },
  'return': function (arg) {
    var iterator = getInternalState(this).iterator;
    var hasArg = !!arguments.length;
    return new Promise(function (resolve, reject) {
      var $return = getMethod(iterator, 'return');
      if ($return === undefined) return resolve({ done: true, value: arg });
      var result = anObject(apply($return, iterator, hasArg ? [arg] : []));
      asyncFromSyncIteratorContinuation(result, resolve, reject);
    });
  },
  'throw': function (arg) {
    var iterator = getInternalState(this).iterator;
    var hasArg = !!arguments.length;
    return new Promise(function (resolve, reject) {
      var $throw = getMethod(iterator, 'throw');
      if ($throw === undefined) return reject(arg);
      var result = anObject(apply($throw, iterator, hasArg ? [arg] : []));
      asyncFromSyncIteratorContinuation(result, resolve, reject);
    });
  }
});

module.exports = AsyncFromSyncIterator;


}),
13488: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";

// https://github.com/tc39/proposal-iterator-helpers
// https://github.com/tc39/proposal-array-from-async
var global = __webpack_require__(73442);
var call = __webpack_require__(13702);
var aCallable = __webpack_require__(68439);
var anObject = __webpack_require__(70287);
var getBuiltIn = __webpack_require__(19642);
var getMethod = __webpack_require__(65963);

var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var TypeError = global.TypeError;

var createMethod = function (TYPE) {
  var IS_TO_ARRAY = TYPE == 0;
  var IS_FOR_EACH = TYPE == 1;
  var IS_EVERY = TYPE == 2;
  var IS_SOME = TYPE == 3;
  return function (iterator, fn, target) {
    anObject(iterator);
    var Promise = getBuiltIn('Promise');
    var next = aCallable(iterator.next);
    var index = 0;
    var MAPPING = fn !== undefined;
    if (MAPPING || !IS_TO_ARRAY) aCallable(fn);

    return new Promise(function (resolve, reject) {
      var closeIteration = function (method, argument) {
        try {
          var returnMethod = getMethod(iterator, 'return');
          if (returnMethod) {
            return Promise.resolve(call(returnMethod, iterator)).then(function () {
              method(argument);
            }, function (error) {
              reject(error);
            });
          }
        } catch (error2) {
          return reject(error2);
        } method(argument);
      };

      var onError = function (error) {
        closeIteration(reject, error);
      };

      var loop = function () {
        try {
          if (IS_TO_ARRAY && (index > MAX_SAFE_INTEGER) && MAPPING) {
            throw TypeError('The allowed number of iterations has been exceeded');
          }
          Promise.resolve(anObject(call(next, iterator))).then(function (step) {
            try {
              if (anObject(step).done) {
                if (IS_TO_ARRAY) {
                  target.length = index;
                  resolve(target);
                } else resolve(IS_SOME ? false : IS_EVERY || undefined);
              } else {
                var value = step.value;
                if (MAPPING) {
                  Promise.resolve(IS_TO_ARRAY ? fn(value, index) : fn(value)).then(function (result) {
                    if (IS_FOR_EACH) {
                      loop();
                    } else if (IS_EVERY) {
                      result ? loop() : closeIteration(resolve, false);
                    } else if (IS_TO_ARRAY) {
                      target[index++] = result;
                      loop();
                    } else {
                      result ? closeIteration(resolve, IS_SOME || value) : loop();
                    }
                  }, onError);
                } else {
                  target[index++] = value;
                  loop();
                }
              }
            } catch (error) { onError(error); }
          }, onError);
        } catch (error2) { onError(error2); }
      };

      loop();
    });
  };
};

module.exports = {
  toArray: createMethod(0),
  forEach: createMethod(1),
  every: createMethod(2),
  some: createMethod(3),
  find: createMethod(4)
};


}),
38419: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var shared = __webpack_require__(21219);
var isCallable = __webpack_require__(13422);
var create = __webpack_require__(89638);
var getPrototypeOf = __webpack_require__(80327);
var redefine = __webpack_require__(78238);
var wellKnownSymbol = __webpack_require__(33608);
var IS_PURE = __webpack_require__(43581);

var USE_FUNCTION_CONSTRUCTOR = 'USE_FUNCTION_CONSTRUCTOR';
var ASYNC_ITERATOR = wellKnownSymbol('asyncIterator');
var AsyncIterator = global.AsyncIterator;
var PassedAsyncIteratorPrototype = shared.AsyncIteratorPrototype;
var AsyncIteratorPrototype, prototype;

if (PassedAsyncIteratorPrototype) {
  AsyncIteratorPrototype = PassedAsyncIteratorPrototype;
} else if (isCallable(AsyncIterator)) {
  AsyncIteratorPrototype = AsyncIterator.prototype;
} else if (shared[USE_FUNCTION_CONSTRUCTOR] || global[USE_FUNCTION_CONSTRUCTOR]) {
  try {
    // eslint-disable-next-line no-new-func -- we have no alternatives without usage of modern syntax
    prototype = getPrototypeOf(getPrototypeOf(getPrototypeOf(Function('return async function*(){}()')())));
    if (getPrototypeOf(prototype) === Object.prototype) AsyncIteratorPrototype = prototype;
  } catch (error) { /* empty */ }
}

if (!AsyncIteratorPrototype) AsyncIteratorPrototype = {};
else if (IS_PURE) AsyncIteratorPrototype = create(AsyncIteratorPrototype);

if (!isCallable(AsyncIteratorPrototype[ASYNC_ITERATOR])) {
  redefine(AsyncIteratorPrototype, ASYNC_ITERATOR, function () {
    return this;
  });
}

module.exports = AsyncIteratorPrototype;


}),
79674: (function (module, __unused_webpack_exports, __webpack_require__) {
var uncurryThis = __webpack_require__(6201);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


}),
70229: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var TO_STRING_TAG_SUPPORT = __webpack_require__(39892);
var isCallable = __webpack_require__(13422);
var classofRaw = __webpack_require__(79674);
var wellKnownSymbol = __webpack_require__(33608);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var Object = global.Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


}),
35111: (function (module, __unused_webpack_exports, __webpack_require__) {
var hasOwn = __webpack_require__(64831);
var ownKeys = __webpack_require__(68620);
var getOwnPropertyDescriptorModule = __webpack_require__(15722);
var definePropertyModule = __webpack_require__(95827);

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


}),
56738: (function (module, __unused_webpack_exports, __webpack_require__) {
var fails = __webpack_require__(64198);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


}),
61081: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";

var IteratorPrototype = (__webpack_require__(70926)/* .IteratorPrototype */.IteratorPrototype);
var create = __webpack_require__(89638);
var createPropertyDescriptor = __webpack_require__(58269);
var setToStringTag = __webpack_require__(64470);
var Iterators = __webpack_require__(13759);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


}),
29756: (function (module, __unused_webpack_exports, __webpack_require__) {
var DESCRIPTORS = __webpack_require__(94562);
var definePropertyModule = __webpack_require__(95827);
var createPropertyDescriptor = __webpack_require__(58269);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


}),
58269: (function (module) {
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


}),
6490: (function (module, __unused_webpack_exports, __webpack_require__) {
var path = __webpack_require__(35878);
var hasOwn = __webpack_require__(64831);
var wrappedWellKnownSymbolModule = __webpack_require__(2836);
var defineProperty = (__webpack_require__(95827)/* .f */.f);

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


}),
94562: (function (module, __unused_webpack_exports, __webpack_require__) {
var fails = __webpack_require__(64198);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


}),
24459: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var isObject = __webpack_require__(63292);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


}),
19841: (function (module, __unused_webpack_exports, __webpack_require__) {
var getBuiltIn = __webpack_require__(19642);

module.exports = getBuiltIn('navigator', 'userAgent') || '';


}),
34733: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var userAgent = __webpack_require__(19841);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


}),
97755: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);

module.exports = function (CONSTRUCTOR) {
  return global[CONSTRUCTOR].prototype;
};


}),
75906: (function (module) {
// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


}),
45861: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var getOwnPropertyDescriptor = (__webpack_require__(15722)/* .f */.f);
var createNonEnumerableProperty = __webpack_require__(29756);
var redefine = __webpack_require__(78238);
var setGlobal = __webpack_require__(44669);
var copyConstructorProperties = __webpack_require__(35111);
var isForced = __webpack_require__(88387);

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


}),
64198: (function (module) {
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


}),
71168: (function (module) {
var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (bind ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


}),
14026: (function (module, __unused_webpack_exports, __webpack_require__) {
var uncurryThis = __webpack_require__(6201);
var aCallable = __webpack_require__(68439);

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : bind ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


}),
13702: (function (module) {
var call = Function.prototype.call;

module.exports = call.bind ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


}),
87101: (function (module, __unused_webpack_exports, __webpack_require__) {
var DESCRIPTORS = __webpack_require__(94562);
var hasOwn = __webpack_require__(64831);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


}),
6201: (function (module) {
var FunctionPrototype = Function.prototype;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;
var callBind = bind && bind.bind(call);

module.exports = bind ? function (fn) {
  return fn && callBind(call, fn);
} : function (fn) {
  return fn && function () {
    return call.apply(fn, arguments);
  };
};


}),
6990: (function (module, __unused_webpack_exports, __webpack_require__) {
var call = __webpack_require__(13702);
var AsyncFromSyncIterator = __webpack_require__(97769);
var anObject = __webpack_require__(70287);
var getIterator = __webpack_require__(60958);
var getMethod = __webpack_require__(65963);
var wellKnownSymbol = __webpack_require__(33608);

var ASYNC_ITERATOR = wellKnownSymbol('asyncIterator');

module.exports = function (it, usingIterator) {
  var method = arguments.length < 2 ? getMethod(it, ASYNC_ITERATOR) : usingIterator;
  return method ? anObject(call(method, it)) : new AsyncFromSyncIterator(getIterator(it));
};


}),
19642: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var isCallable = __webpack_require__(13422);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


}),
80306: (function (module, __unused_webpack_exports, __webpack_require__) {
var classof = __webpack_require__(70229);
var getMethod = __webpack_require__(65963);
var Iterators = __webpack_require__(13759);
var wellKnownSymbol = __webpack_require__(33608);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


}),
60958: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var call = __webpack_require__(13702);
var aCallable = __webpack_require__(68439);
var anObject = __webpack_require__(70287);
var tryToString = __webpack_require__(28295);
var getIteratorMethod = __webpack_require__(80306);

var TypeError = global.TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw TypeError(tryToString(argument) + ' is not iterable');
};


}),
65963: (function (module, __unused_webpack_exports, __webpack_require__) {
var aCallable = __webpack_require__(68439);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};


}),
73442: (function (module, __unused_webpack_exports, __webpack_require__) {
var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();


}),
64831: (function (module, __unused_webpack_exports, __webpack_require__) {
var uncurryThis = __webpack_require__(6201);
var toObject = __webpack_require__(52631);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


}),
82511: (function (module) {
module.exports = {};


}),
15231: (function (module, __unused_webpack_exports, __webpack_require__) {
var getBuiltIn = __webpack_require__(19642);

module.exports = getBuiltIn('document', 'documentElement');


}),
28907: (function (module, __unused_webpack_exports, __webpack_require__) {
var DESCRIPTORS = __webpack_require__(94562);
var fails = __webpack_require__(64198);
var createElement = __webpack_require__(24459);

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


}),
35249: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var uncurryThis = __webpack_require__(6201);
var fails = __webpack_require__(64198);
var classof = __webpack_require__(79674);

var Object = global.Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : Object(it);
} : Object;


}),
20705: (function (module, __unused_webpack_exports, __webpack_require__) {
var uncurryThis = __webpack_require__(6201);
var isCallable = __webpack_require__(13422);
var store = __webpack_require__(21219);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


}),
45723: (function (module, __unused_webpack_exports, __webpack_require__) {
var NATIVE_WEAK_MAP = __webpack_require__(31585);
var global = __webpack_require__(73442);
var uncurryThis = __webpack_require__(6201);
var isObject = __webpack_require__(63292);
var createNonEnumerableProperty = __webpack_require__(29756);
var hasOwn = __webpack_require__(64831);
var shared = __webpack_require__(21219);
var sharedKey = __webpack_require__(15511);
var hiddenKeys = __webpack_require__(82511);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis(store.get);
  var wmhas = uncurryThis(store.has);
  var wmset = uncurryThis(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


}),
16937: (function (module, __unused_webpack_exports, __webpack_require__) {
var classof = __webpack_require__(79674);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


}),
13422: (function (module) {
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument == 'function';
};


}),
38281: (function (module, __unused_webpack_exports, __webpack_require__) {
var uncurryThis = __webpack_require__(6201);
var fails = __webpack_require__(64198);
var isCallable = __webpack_require__(13422);
var classof = __webpack_require__(70229);
var getBuiltIn = __webpack_require__(19642);
var inspectSource = __webpack_require__(20705);

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function (argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function (argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
    // we can't check .prototype since constructors produced by .bind haven't it
  } return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
};

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


}),
88387: (function (module, __unused_webpack_exports, __webpack_require__) {
var fails = __webpack_require__(64198);
var isCallable = __webpack_require__(13422);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


}),
63292: (function (module, __unused_webpack_exports, __webpack_require__) {
var isCallable = __webpack_require__(13422);

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


}),
43581: (function (module) {
module.exports = false;


}),
78924: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var getBuiltIn = __webpack_require__(19642);
var isCallable = __webpack_require__(13422);
var isPrototypeOf = __webpack_require__(69914);
var USE_SYMBOL_AS_UID = __webpack_require__(25545);

var Object = global.Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, Object(it));
};


}),
70926: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";

var fails = __webpack_require__(64198);
var isCallable = __webpack_require__(13422);
var create = __webpack_require__(89638);
var getPrototypeOf = __webpack_require__(80327);
var redefine = __webpack_require__(78238);
var wellKnownSymbol = __webpack_require__(33608);
var IS_PURE = __webpack_require__(43581);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  redefine(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


}),
13759: (function (module) {
module.exports = {};


}),
97218: (function (module, __unused_webpack_exports, __webpack_require__) {
var toLength = __webpack_require__(95248);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


}),
65555: (function (module, __unused_webpack_exports, __webpack_require__) {
/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(34733);
var fails = __webpack_require__(64198);

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


}),
31585: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var isCallable = __webpack_require__(13422);
var inspectSource = __webpack_require__(20705);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));


}),
18780: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var fails = __webpack_require__(64198);
var uncurryThis = __webpack_require__(6201);
var toString = __webpack_require__(58513);
var trim = (__webpack_require__(12967)/* .trim */.trim);
var whitespaces = __webpack_require__(31465);

var $parseInt = global.parseInt;
var Symbol = global.Symbol;
var ITERATOR = Symbol && Symbol.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis(hex.exec);
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR && !fails(function () { $parseInt(Object(ITERATOR)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(toString(string));
  return $parseInt(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
} : $parseInt;


}),
34010: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";

var global = __webpack_require__(73442);
var InternalStateModule = __webpack_require__(45723);
var createIteratorConstructor = __webpack_require__(61081);
var isObject = __webpack_require__(63292);
var defineProperties = __webpack_require__(73561);
var DESCRIPTORS = __webpack_require__(94562);

var INCORRECT_RANGE = 'Incorrect Number.range arguments';
var NUMERIC_RANGE_ITERATOR = 'NumericRangeIterator';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(NUMERIC_RANGE_ITERATOR);

var RangeError = global.RangeError;
var TypeError = global.TypeError;

var $RangeIterator = createIteratorConstructor(function NumericRangeIterator(start, end, option, type, zero, one) {
  if (typeof start != type || (end !== Infinity && end !== -Infinity && typeof end != type)) {
    throw new TypeError(INCORRECT_RANGE);
  }
  if (start === Infinity || start === -Infinity) {
    throw new RangeError(INCORRECT_RANGE);
  }
  var ifIncrease = end > start;
  var inclusiveEnd = false;
  var step;
  if (option === undefined) {
    step = undefined;
  } else if (isObject(option)) {
    step = option.step;
    inclusiveEnd = !!option.inclusive;
  } else if (typeof option == type) {
    step = option;
  } else {
    throw new TypeError(INCORRECT_RANGE);
  }
  if (step == null) {
    step = ifIncrease ? one : -one;
  }
  if (typeof step != type) {
    throw new TypeError(INCORRECT_RANGE);
  }
  if (step === Infinity || step === -Infinity || (step === zero && start !== end)) {
    throw new RangeError(INCORRECT_RANGE);
  }
  // eslint-disable-next-line no-self-compare -- NaN check
  var hitsEnd = start != start || end != end || step != step || (end > start) !== (step > zero);
  setInternalState(this, {
    type: NUMERIC_RANGE_ITERATOR,
    start: start,
    end: end,
    step: step,
    inclusiveEnd: inclusiveEnd,
    hitsEnd: hitsEnd,
    currentCount: zero,
    zero: zero
  });
  if (!DESCRIPTORS) {
    this.start = start;
    this.end = end;
    this.step = step;
    this.inclusive = inclusiveEnd;
  }
}, NUMERIC_RANGE_ITERATOR, function next() {
  var state = getInternalState(this);
  if (state.hitsEnd) return { value: undefined, done: true };
  var start = state.start;
  var end = state.end;
  var step = state.step;
  var currentYieldingValue = start + (step * state.currentCount++);
  if (currentYieldingValue === end) state.hitsEnd = true;
  var inclusiveEnd = state.inclusiveEnd;
  var endCondition;
  if (end > start) {
    endCondition = inclusiveEnd ? currentYieldingValue > end : currentYieldingValue >= end;
  } else {
    endCondition = inclusiveEnd ? end > currentYieldingValue : end >= currentYieldingValue;
  }
  if (endCondition) {
    return { value: undefined, done: state.hitsEnd = true };
  } return { value: currentYieldingValue, done: false };
});

var getter = function (fn) {
  return { get: fn, set: function () { /* empty */ }, configurable: true, enumerable: false };
};

if (DESCRIPTORS) {
  defineProperties($RangeIterator.prototype, {
    start: getter(function () {
      return getInternalState(this).start;
    }),
    end: getter(function () {
      return getInternalState(this).end;
    }),
    inclusive: getter(function () {
      return getInternalState(this).inclusiveEnd;
    }),
    step: getter(function () {
      return getInternalState(this).step;
    })
  });
}

module.exports = $RangeIterator;


}),
89638: (function (module, __unused_webpack_exports, __webpack_require__) {
/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(70287);
var defineProperties = __webpack_require__(73561);
var enumBugKeys = __webpack_require__(75906);
var hiddenKeys = __webpack_require__(82511);
var html = __webpack_require__(15231);
var documentCreateElement = __webpack_require__(24459);
var sharedKey = __webpack_require__(15511);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


}),
73561: (function (module, __unused_webpack_exports, __webpack_require__) {
var DESCRIPTORS = __webpack_require__(94562);
var definePropertyModule = __webpack_require__(95827);
var anObject = __webpack_require__(70287);
var toIndexedObject = __webpack_require__(14920);
var objectKeys = __webpack_require__(52475);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


}),
95827: (function (__unused_webpack_module, exports, __webpack_require__) {
var global = __webpack_require__(73442);
var DESCRIPTORS = __webpack_require__(94562);
var IE8_DOM_DEFINE = __webpack_require__(28907);
var anObject = __webpack_require__(70287);
var toPropertyKey = __webpack_require__(25024);

var TypeError = global.TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


}),
15722: (function (__unused_webpack_module, exports, __webpack_require__) {
var DESCRIPTORS = __webpack_require__(94562);
var call = __webpack_require__(13702);
var propertyIsEnumerableModule = __webpack_require__(89626);
var createPropertyDescriptor = __webpack_require__(58269);
var toIndexedObject = __webpack_require__(14920);
var toPropertyKey = __webpack_require__(25024);
var hasOwn = __webpack_require__(64831);
var IE8_DOM_DEFINE = __webpack_require__(28907);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


}),
54671: (function (__unused_webpack_module, exports, __webpack_require__) {
var internalObjectKeys = __webpack_require__(28834);
var enumBugKeys = __webpack_require__(75906);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


}),
81089: (function (__unused_webpack_module, exports) {
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


}),
80327: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var hasOwn = __webpack_require__(64831);
var isCallable = __webpack_require__(13422);
var toObject = __webpack_require__(52631);
var sharedKey = __webpack_require__(15511);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(56738);

var IE_PROTO = sharedKey('IE_PROTO');
var Object = global.Object;
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object ? ObjectPrototype : null;
};


}),
69914: (function (module, __unused_webpack_exports, __webpack_require__) {
var uncurryThis = __webpack_require__(6201);

module.exports = uncurryThis({}.isPrototypeOf);


}),
28834: (function (module, __unused_webpack_exports, __webpack_require__) {
var uncurryThis = __webpack_require__(6201);
var hasOwn = __webpack_require__(64831);
var toIndexedObject = __webpack_require__(14920);
var indexOf = (__webpack_require__(96030)/* .indexOf */.indexOf);
var hiddenKeys = __webpack_require__(82511);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


}),
52475: (function (module, __unused_webpack_exports, __webpack_require__) {
var internalObjectKeys = __webpack_require__(28834);
var enumBugKeys = __webpack_require__(75906);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


}),
89626: (function (__unused_webpack_module, exports) {
"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


}),
99295: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var call = __webpack_require__(13702);
var isCallable = __webpack_require__(13422);
var isObject = __webpack_require__(63292);

var TypeError = global.TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


}),
68620: (function (module, __unused_webpack_exports, __webpack_require__) {
var getBuiltIn = __webpack_require__(19642);
var uncurryThis = __webpack_require__(6201);
var getOwnPropertyNamesModule = __webpack_require__(54671);
var getOwnPropertySymbolsModule = __webpack_require__(81089);
var anObject = __webpack_require__(70287);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


}),
35878: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);

module.exports = global;


}),
62275: (function (module, __unused_webpack_exports, __webpack_require__) {
var redefine = __webpack_require__(78238);

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


}),
78238: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var isCallable = __webpack_require__(13422);
var hasOwn = __webpack_require__(64831);
var createNonEnumerableProperty = __webpack_require__(29756);
var setGlobal = __webpack_require__(44669);
var inspectSource = __webpack_require__(20705);
var InternalStateModule = __webpack_require__(45723);
var CONFIGURABLE_FUNCTION_NAME = (__webpack_require__(87101)/* .CONFIGURABLE */.CONFIGURABLE);

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
      createNonEnumerableProperty(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
});


}),
98369: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);

var TypeError = global.TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


}),
44669: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


}),
64470: (function (module, __unused_webpack_exports, __webpack_require__) {
var defineProperty = (__webpack_require__(95827)/* .f */.f);
var hasOwn = __webpack_require__(64831);
var wellKnownSymbol = __webpack_require__(33608);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !hasOwn(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


}),
15511: (function (module, __unused_webpack_exports, __webpack_require__) {
var shared = __webpack_require__(64147);
var uid = __webpack_require__(6760);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


}),
21219: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var setGlobal = __webpack_require__(44669);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


}),
64147: (function (module, __unused_webpack_exports, __webpack_require__) {
var IS_PURE = __webpack_require__(43581);
var store = __webpack_require__(21219);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.19.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


}),
12967: (function (module, __unused_webpack_exports, __webpack_require__) {
var uncurryThis = __webpack_require__(6201);
var requireObjectCoercible = __webpack_require__(98369);
var toString = __webpack_require__(58513);
var whitespaces = __webpack_require__(31465);

var replace = uncurryThis(''.replace);
var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


}),
19892: (function (module, __unused_webpack_exports, __webpack_require__) {
var toIntegerOrInfinity = __webpack_require__(78063);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


}),
14920: (function (module, __unused_webpack_exports, __webpack_require__) {
// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(35249);
var requireObjectCoercible = __webpack_require__(98369);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


}),
78063: (function (module) {
var ceil = Math.ceil;
var floor = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
};


}),
95248: (function (module, __unused_webpack_exports, __webpack_require__) {
var toIntegerOrInfinity = __webpack_require__(78063);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


}),
52631: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var requireObjectCoercible = __webpack_require__(98369);

var Object = global.Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


}),
20194: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var call = __webpack_require__(13702);
var isObject = __webpack_require__(63292);
var isSymbol = __webpack_require__(78924);
var getMethod = __webpack_require__(65963);
var ordinaryToPrimitive = __webpack_require__(99295);
var wellKnownSymbol = __webpack_require__(33608);

var TypeError = global.TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


}),
25024: (function (module, __unused_webpack_exports, __webpack_require__) {
var toPrimitive = __webpack_require__(20194);
var isSymbol = __webpack_require__(78924);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


}),
39892: (function (module, __unused_webpack_exports, __webpack_require__) {
var wellKnownSymbol = __webpack_require__(33608);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


}),
58513: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var classof = __webpack_require__(70229);

var String = global.String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};


}),
28295: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);

var String = global.String;

module.exports = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};


}),
6760: (function (module, __unused_webpack_exports, __webpack_require__) {
var uncurryThis = __webpack_require__(6201);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


}),
25545: (function (module, __unused_webpack_exports, __webpack_require__) {
/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(65555);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


}),
2836: (function (__unused_webpack_module, exports, __webpack_require__) {
var wellKnownSymbol = __webpack_require__(33608);

exports.f = wellKnownSymbol;


}),
33608: (function (module, __unused_webpack_exports, __webpack_require__) {
var global = __webpack_require__(73442);
var shared = __webpack_require__(64147);
var hasOwn = __webpack_require__(64831);
var uid = __webpack_require__(6760);
var NATIVE_SYMBOL = __webpack_require__(65555);
var USE_SYMBOL_AS_UID = __webpack_require__(25545);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};


}),
31465: (function (module) {
// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


}),
233: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
"use strict";

// TODO: remove from `core-js@4`
var $ = __webpack_require__(45861);
var $filterReject = (__webpack_require__(93539)/* .filterReject */.filterReject);
var addToUnscopables = __webpack_require__(17759);

// `Array.prototype.filterOut` method
// https://github.com/tc39/proposal-array-filtering
$({ target: 'Array', proto: true }, {
  filterOut: function filterOut(callbackfn /* , thisArg */) {
    return $filterReject(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

addToUnscopables('filterOut');


}),
49754: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
"use strict";

var $ = __webpack_require__(45861);
var $filterReject = (__webpack_require__(93539)/* .filterReject */.filterReject);
var addToUnscopables = __webpack_require__(17759);

// `Array.prototype.filterReject` method
// https://github.com/tc39/proposal-array-filtering
$({ target: 'Array', proto: true }, {
  filterReject: function filterReject(callbackfn /* , thisArg */) {
    return $filterReject(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

addToUnscopables('filterReject');


}),
52897: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
var $ = __webpack_require__(45861);
var fromAsync = __webpack_require__(59373);

// `Array.fromAsync` method
// https://github.com/tc39/proposal-array-from-async
$({ target: 'Array', stat: true }, {
  fromAsync: fromAsync
});


}),
30971: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
"use strict";

var $ = __webpack_require__(45861);
var $groupBy = __webpack_require__(4655);
var arraySpeciesConstructor = __webpack_require__(84609);
var addToUnscopables = __webpack_require__(17759);

// `Array.prototype.groupBy` method
// https://github.com/tc39/proposal-array-grouping
$({ target: 'Array', proto: true }, {
  groupBy: function groupBy(callbackfn /* , thisArg */) {
    var thisArg = arguments.length > 1 ? arguments[1] : undefined;
    return $groupBy(this, callbackfn, thisArg, arraySpeciesConstructor);
  }
});

addToUnscopables('groupBy');


}),
62374: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
var $ = __webpack_require__(45861);
var isArray = __webpack_require__(16937);

// eslint-disable-next-line es/no-object-isfrozen -- safe
var isFrozen = Object.isFrozen;

var isFrozenStringArray = function (array, allowUndefined) {
  if (!isFrozen || !isArray(array) || !isFrozen(array)) return false;
  var index = 0;
  var length = array.length;
  var element;
  while (index < length) {
    element = array[index++];
    if (!(typeof element == 'string' || (allowUndefined && typeof element == 'undefined'))) {
      return false;
    }
  } return length !== 0;
};

// `Array.isTemplateObject` method
// https://github.com/tc39/proposal-array-is-template-object
$({ target: 'Array', stat: true }, {
  isTemplateObject: function isTemplateObject(value) {
    if (!isFrozenStringArray(value, true)) return false;
    var raw = value.raw;
    if (raw.length !== value.length || !isFrozenStringArray(raw, false)) return false;
    return true;
  }
});


}),
55152: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
"use strict";

var DESCRIPTORS = __webpack_require__(94562);
var addToUnscopables = __webpack_require__(17759);
var toObject = __webpack_require__(52631);
var lengthOfArrayLike = __webpack_require__(97218);
var defineProperty = (__webpack_require__(95827)/* .f */.f);

// `Array.prototype.lastIndex` getter
// https://github.com/keithamus/proposal-array-last
if (DESCRIPTORS && !('lastIndex' in [])) {
  defineProperty(Array.prototype, 'lastIndex', {
    configurable: true,
    get: function lastIndex() {
      var O = toObject(this);
      var len = lengthOfArrayLike(O);
      return len == 0 ? 0 : len - 1;
    }
  });

  addToUnscopables('lastIndex');
}


}),
35273: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
"use strict";

var DESCRIPTORS = __webpack_require__(94562);
var addToUnscopables = __webpack_require__(17759);
var toObject = __webpack_require__(52631);
var lengthOfArrayLike = __webpack_require__(97218);
var defineProperty = (__webpack_require__(95827)/* .f */.f);

// `Array.prototype.lastIndex` accessor
// https://github.com/keithamus/proposal-array-last
if (DESCRIPTORS && !('lastItem' in [])) {
  defineProperty(Array.prototype, 'lastItem', {
    configurable: true,
    get: function lastItem() {
      var O = toObject(this);
      var len = lengthOfArrayLike(O);
      return len == 0 ? undefined : O[len - 1];
    },
    set: function lastItem(value) {
      var O = toObject(this);
      var len = lengthOfArrayLike(O);
      return O[len == 0 ? 0 : len - 1] = value;
    }
  });

  addToUnscopables('lastItem');
}


}),
30172: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
"use strict";

var $ = __webpack_require__(45861);
var addToUnscopables = __webpack_require__(17759);
var uniqueBy = __webpack_require__(79022);

// `Array.prototype.uniqueBy` method
// https://github.com/tc39/proposal-array-unique
$({ target: 'Array', proto: true }, {
  uniqueBy: uniqueBy
});

addToUnscopables('uniqueBy');


}),
65723: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
"use strict";

var $ = __webpack_require__(45861);
var global = __webpack_require__(73442);
var uncurryThis = __webpack_require__(6201);
var toIntegerOrInfinity = __webpack_require__(78063);
var parseInt = __webpack_require__(18780);

var INVALID_NUMBER_REPRESENTATION = 'Invalid number representation';
var INVALID_RADIX = 'Invalid radix';
var RangeError = global.RangeError;
var SyntaxError = global.SyntaxError;
var TypeError = global.TypeError;
var valid = /^[\da-z]+$/;
var charAt = uncurryThis(''.charAt);
var exec = uncurryThis(valid.exec);
var numberToString = uncurryThis(1.0.toString);
var stringSlice = uncurryThis(''.slice);

// `Number.fromString` method
// https://github.com/tc39/proposal-number-fromstring
$({ target: 'Number', stat: true }, {
  fromString: function fromString(string, radix) {
    var sign = 1;
    var R, mathNum;
    if (typeof string != 'string') throw TypeError(INVALID_NUMBER_REPRESENTATION);
    if (!string.length) throw SyntaxError(INVALID_NUMBER_REPRESENTATION);
    if (charAt(string, 0) == '-') {
      sign = -1;
      string = stringSlice(string, 1);
      if (!string.length) throw SyntaxError(INVALID_NUMBER_REPRESENTATION);
    }
    R = radix === undefined ? 10 : toIntegerOrInfinity(radix);
    if (R < 2 || R > 36) throw RangeError(INVALID_RADIX);
    if (!exec(valid, string) || numberToString(mathNum = parseInt(string, R), R) !== string) {
      throw SyntaxError(INVALID_NUMBER_REPRESENTATION);
    }
    return sign * mathNum;
  }
});


}),
48258: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
"use strict";

var $ = __webpack_require__(45861);
var NumericRangeIterator = __webpack_require__(34010);

// `Number.range` method
// https://github.com/tc39/proposal-Number.range
$({ target: 'Number', stat: true }, {
  range: function range(start, end, option) {
    return new NumericRangeIterator(start, end, option, 'number', 0, 1);
  }
});


}),
84037: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
var defineWellKnownSymbol = __webpack_require__(6490);

// `Symbol.matcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol('matcher');


}),
68259: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
var defineWellKnownSymbol = __webpack_require__(6490);

// `Symbol.metadata` well-known symbol
// https://github.com/tc39/proposal-decorators
defineWellKnownSymbol('metadata');


}),
60033: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
var defineWellKnownSymbol = __webpack_require__(6490);

// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
defineWellKnownSymbol('observable');


}),
9246: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
// TODO: remove from `core-js@4`
var defineWellKnownSymbol = __webpack_require__(6490);

// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol('patternMatch');


}),
67321: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
// TODO: remove from `core-js@4`
var defineWellKnownSymbol = __webpack_require__(6490);

defineWellKnownSymbol('replaceAll');


}),
89433: (function () {
// Polyfill for creating CustomEvents on IE9/10/11

// code pulled from:
// https://github.com/d4tocchini/customevent-polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent#Polyfill

(function() {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    var ce = new window.CustomEvent('test', { cancelable: true });
    ce.preventDefault();
    if (ce.defaultPrevented !== true) {
      // IE has problems with .preventDefault() on custom events
      // http://stackoverflow.com/questions/23349191
      throw new Error('Could not prevent default');
    }
  } catch (e) {
    var CustomEvent = function(event, params) {
      var evt, origPrevent;
      params = params || {};
      params.bubbles = !!params.bubbles;
      params.cancelable = !!params.cancelable;

      evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(
        event,
        params.bubbles,
        params.cancelable,
        params.detail
      );
      origPrevent = evt.preventDefault;
      evt.preventDefault = function() {
        origPrevent.call(this);
        try {
          Object.defineProperty(this, 'defaultPrevented', {
            get: function() {
              return true;
            }
          });
        } catch (e) {
          this.defaultPrevented = true;
        }
      };
      return evt;
    };

    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent; // expose definition to window
  }
})();


}),
66674: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";


var callBind = __webpack_require__(46960);
var gOPD = __webpack_require__(21536);

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;


}),
88093: (function (module) {
"use strict";


/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


}),
23413: (function (module) {
"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


}),
52137: (function (module) {
"use strict";


/** @type {import('.')} */
module.exports = Error;


}),
7344: (function (module) {
"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


}),
85783: (function (module) {
"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


}),
6214: (function (module) {
"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


}),
66671: (function (module) {
"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


}),
60908: (function (module) {
"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


}),
95391: (function (module) {
"use strict";


/** @type {import('.')} */
module.exports = Object;


}),
38365: (function (module) {
"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


}),
52106: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";


var implementation = __webpack_require__(38365);

module.exports = Function.prototype.bind || implementation;


}),
7297: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";


var undefined;

var $Object = __webpack_require__(95391);

var $Error = __webpack_require__(52137);
var $EvalError = __webpack_require__(23413);
var $RangeError = __webpack_require__(7344);
var $ReferenceError = __webpack_require__(85783);
var $SyntaxError = __webpack_require__(6214);
var $TypeError = __webpack_require__(66671);
var $URIError = __webpack_require__(60908);

var abs = __webpack_require__(97660);
var floor = __webpack_require__(28041);
var max = __webpack_require__(10475);
var min = __webpack_require__(4126);
var pow = __webpack_require__(1054);
var round = __webpack_require__(19946);
var sign = __webpack_require__(8035);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = __webpack_require__(21536);
var $defineProperty = __webpack_require__(88093);

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(10931)();

var getProto = __webpack_require__(86320);
var $ObjectGPO = __webpack_require__(80146);
var $ReflectGPO = __webpack_require__(5277);

var $apply = __webpack_require__(59451);
var $call = __webpack_require__(97043);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(52106);
var hasOwn = __webpack_require__(13271);
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


}),
80146: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";


var $Object = __webpack_require__(95391);

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;


}),
5277: (function (module) {
"use strict";


/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;


}),
86320: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";


var reflectGetProto = __webpack_require__(5277);
var originalGetProto = __webpack_require__(80146);

var getDunderProto = __webpack_require__(66674);

/** @type {import('.')} */
module.exports = reflectGetProto
	? function getProto(O) {
		// @ts-expect-error TS can't narrow inside a closure, for some reason
		return reflectGetProto(O);
	}
	: originalGetProto
		? function getProto(O) {
			if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
				throw new TypeError('getProto: not an object');
			}
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return originalGetProto(O);
		}
		: getDunderProto
			? function getProto(O) {
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return getDunderProto(O);
			}
			: null;


}),
38344: (function (module) {
"use strict";


/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;


}),
21536: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";


/** @type {import('.')} */
var $gOPD = __webpack_require__(38344);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


}),
28160: (function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ lib),
  disableExperimentalFragmentVariables: () => (/* binding */ disableExperimentalFragmentVariables),
  enableExperimentalFragmentVariables: () => (/* binding */ enableExperimentalFragmentVariables),
  gql: () => (/* binding */ gql),
  disableFragmentWarnings: () => (/* binding */ disableFragmentWarnings),
  resetCaches: () => (/* binding */ resetCaches)
});

// EXTERNAL MODULE: ../../app/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(68948);
;// CONCATENATED MODULE: ../../app/node_modules/graphql/jsutils/isObjectLike.mjs
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return typeof value == 'object' && value !== null;
}

;// CONCATENATED MODULE: ../../app/node_modules/graphql/jsutils/invariant.mjs
function invariant(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(
      message != null ? message : 'Unexpected invariant triggered.',
    );
  }
}

;// CONCATENATED MODULE: ../../app/node_modules/graphql/language/location.mjs

const LineRegExp = /\r\n|[\n\r]/g;
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  let lastLineStart = 0;
  let line = 1;

  for (const match of source.body.matchAll(LineRegExp)) {
    typeof match.index === 'number' || invariant(false);

    if (match.index >= position) {
      break;
    }

    lastLineStart = match.index + match[0].length;
    line += 1;
  }

  return {
    line,
    column: position + 1 - lastLineStart,
  };
}

;// CONCATENATED MODULE: ../../app/node_modules/graphql/language/printLocation.mjs


/**
 * Render a helpful description of the location in the GraphQL Source document.
 */
function printLocation(location) {
  return printSourceLocation(
    location.source,
    getLocation(location.source, location.start),
  );
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  const firstLineColumnOffset = source.locationOffset.column - 1;
  const body = ''.padStart(firstLineColumnOffset) + source.body;
  const lineIndex = sourceLocation.line - 1;
  const lineOffset = source.locationOffset.line - 1;
  const lineNum = sourceLocation.line + lineOffset;
  const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  const columnNum = sourceLocation.column + columnOffset;
  const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
  const lines = body.split(/\r\n|[\n\r]/g);
  const locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    const subLineIndex = Math.floor(columnNum / 80);
    const subLineColumnNum = columnNum % 80;
    const subLines = [];

    for (let i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return (
      locationStr +
      printPrefixedLines([
        [`${lineNum} |`, subLines[0]],
        ...subLines.slice(1, subLineIndex + 1).map((subLine) => ['|', subLine]),
        ['|', '^'.padStart(subLineColumnNum)],
        ['|', subLines[subLineIndex + 1]],
      ])
    );
  }

  return (
    locationStr +
    printPrefixedLines([
      // Lines specified like this: ["prefix", "string"],
      [`${lineNum - 1} |`, lines[lineIndex - 1]],
      [`${lineNum} |`, locationLine],
      ['|', '^'.padStart(columnNum)],
      [`${lineNum + 1} |`, lines[lineIndex + 1]],
    ])
  );
}

function printPrefixedLines(lines) {
  const existingLines = lines.filter(([_, line]) => line !== undefined);
  const padLen = Math.max(...existingLines.map(([prefix]) => prefix.length));
  return existingLines
    .map(([prefix, line]) => prefix.padStart(padLen) + (line ? ' ' + line : ''))
    .join('\n');
}

;// CONCATENATED MODULE: ../../app/node_modules/graphql/error/GraphQLError.mjs




function toNormalizedOptions(args) {
  const firstArg = args[0];

  if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) {
    return {
      nodes: firstArg,
      source: args[1],
      positions: args[2],
      path: args[3],
      originalError: args[4],
      extensions: args[5],
    };
  }

  return firstArg;
}
/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

class GraphQLError extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */

  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(message, ...rawArgs) {
    var _this$nodes, _nodeLocations$, _ref;

    const { nodes, source, positions, path, originalError, extensions } =
      toNormalizedOptions(rawArgs);
    super(message);
    this.name = 'GraphQLError';
    this.path = path !== null && path !== void 0 ? path : undefined;
    this.originalError =
      originalError !== null && originalError !== void 0
        ? originalError
        : undefined; // Compute list of blame nodes.

    this.nodes = undefinedIfEmpty(
      Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined,
    );
    const nodeLocations = undefinedIfEmpty(
      (_this$nodes = this.nodes) === null || _this$nodes === void 0
        ? void 0
        : _this$nodes.map((node) => node.loc).filter((loc) => loc != null),
    ); // Compute locations in the source for the given nodes/positions.

    this.source =
      source !== null && source !== void 0
        ? source
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : (_nodeLocations$ = nodeLocations[0]) === null ||
          _nodeLocations$ === void 0
        ? void 0
        : _nodeLocations$.source;
    this.positions =
      positions !== null && positions !== void 0
        ? positions
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => loc.start);
    this.locations =
      positions && source
        ? positions.map((pos) => getLocation(source, pos))
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => getLocation(loc.source, loc.start));
    const originalExtensions = isObjectLike(
      originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions,
    )
      ? originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions
      : undefined;
    this.extensions =
      (_ref =
        extensions !== null && extensions !== void 0
          ? extensions
          : originalExtensions) !== null && _ref !== void 0
        ? _ref
        : Object.create(null); // Only properties prescribed by the spec should be enumerable.
    // Keep the rest as non-enumerable.

    Object.defineProperties(this, {
      message: {
        writable: true,
        enumerable: true,
      },
      name: {
        enumerable: false,
      },
      nodes: {
        enumerable: false,
      },
      source: {
        enumerable: false,
      },
      positions: {
        enumerable: false,
      },
      originalError: {
        enumerable: false,
      },
    }); // Include (non-enumerable) stack trace.

    /* c8 ignore start */
    // FIXME: https://github.com/graphql/graphql-js/issues/2317

    if (
      originalError !== null &&
      originalError !== void 0 &&
      originalError.stack
    ) {
      Object.defineProperty(this, 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true,
      });
    } else if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GraphQLError);
    } else {
      Object.defineProperty(this, 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true,
      });
    }
    /* c8 ignore stop */
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLError';
  }

  toString() {
    let output = this.message;

    if (this.nodes) {
      for (const node of this.nodes) {
        if (node.loc) {
          output += '\n\n' + printLocation(node.loc);
        }
      }
    } else if (this.source && this.locations) {
      for (const location of this.locations) {
        output += '\n\n' + printSourceLocation(this.source, location);
      }
    }

    return output;
  }

  toJSON() {
    const formattedError = {
      message: this.message,
    };

    if (this.locations != null) {
      formattedError.locations = this.locations;
    }

    if (this.path != null) {
      formattedError.path = this.path;
    }

    if (this.extensions != null && Object.keys(this.extensions).length > 0) {
      formattedError.extensions = this.extensions;
    }

    return formattedError;
  }
}

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * See: https://spec.graphql.org/draft/#sec-Errors
 */

/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 *
 * @deprecated Please use `error.toString` instead. Will be removed in v17
 */
function printError(error) {
  return error.toString();
}
/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 *
 * @deprecated Please use `error.toJSON` instead. Will be removed in v17
 */

function formatError(error) {
  return error.toJSON();
}

;// CONCATENATED MODULE: ../../app/node_modules/graphql/error/syntaxError.mjs

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError(`Syntax Error: ${description}`, {
    source,
    positions: [position],
  });
}

// EXTERNAL MODULE: ../../app/node_modules/graphql/language/ast.mjs
var language_ast = __webpack_require__(61432);
;// CONCATENATED MODULE: ../../app/node_modules/graphql/language/directiveLocation.mjs
/**
 * The set of allowed directive location values.
 */
var directiveLocation_DirectiveLocation;

(function (DirectiveLocation) {
  DirectiveLocation['QUERY'] = 'QUERY';
  DirectiveLocation['MUTATION'] = 'MUTATION';
  DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
  DirectiveLocation['FIELD'] = 'FIELD';
  DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
  DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
  DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
  DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
  DirectiveLocation['SCHEMA'] = 'SCHEMA';
  DirectiveLocation['SCALAR'] = 'SCALAR';
  DirectiveLocation['OBJECT'] = 'OBJECT';
  DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
  DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
  DirectiveLocation['INTERFACE'] = 'INTERFACE';
  DirectiveLocation['UNION'] = 'UNION';
  DirectiveLocation['ENUM'] = 'ENUM';
  DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
  DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
  DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})(directiveLocation_DirectiveLocation || (directiveLocation_DirectiveLocation = {}));


/**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */

// EXTERNAL MODULE: ../../app/node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(44361);
// EXTERNAL MODULE: ../../app/node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(44885);
// EXTERNAL MODULE: ../../app/node_modules/graphql/language/characterClasses.mjs
var characterClasses = __webpack_require__(56763);
;// CONCATENATED MODULE: ../../app/node_modules/graphql/language/tokenKind.mjs
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var tokenKind_TokenKind;

(function (TokenKind) {
  TokenKind['SOF'] = '<SOF>';
  TokenKind['EOF'] = '<EOF>';
  TokenKind['BANG'] = '!';
  TokenKind['DOLLAR'] = '$';
  TokenKind['AMP'] = '&';
  TokenKind['PAREN_L'] = '(';
  TokenKind['PAREN_R'] = ')';
  TokenKind['SPREAD'] = '...';
  TokenKind['COLON'] = ':';
  TokenKind['EQUALS'] = '=';
  TokenKind['AT'] = '@';
  TokenKind['BRACKET_L'] = '[';
  TokenKind['BRACKET_R'] = ']';
  TokenKind['BRACE_L'] = '{';
  TokenKind['PIPE'] = '|';
  TokenKind['BRACE_R'] = '}';
  TokenKind['NAME'] = 'Name';
  TokenKind['INT'] = 'Int';
  TokenKind['FLOAT'] = 'Float';
  TokenKind['STRING'] = 'String';
  TokenKind['BLOCK_STRING'] = 'BlockString';
  TokenKind['COMMENT'] = 'Comment';
})(tokenKind_TokenKind || (tokenKind_TokenKind = {}));


/**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */

;// CONCATENATED MODULE: ../../app/node_modules/graphql/language/lexer.mjs





/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

class Lexer {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  constructor(source) {
    const startOfFileToken = new language_ast/* Token */.WU(tokenKind_TokenKind.SOF, 0, 0, 0, 0);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }

  get [Symbol.toStringTag]() {
    return 'Lexer';
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */

  advance() {
    this.lastToken = this.token;
    const token = (this.token = this.lookahead());
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */

  lookahead() {
    let token = this.token;

    if (token.kind !== tokenKind_TokenKind.EOF) {
      do {
        if (token.next) {
          token = token.next;
        } else {
          // Read the next token and form a link in the token linked-list.
          const nextToken = readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.

          token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.

          nextToken.prev = token;
          token = nextToken;
        }
      } while (token.kind === tokenKind_TokenKind.COMMENT);
    }

    return token;
  }
}
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return (
    kind === tokenKind_TokenKind.BANG ||
    kind === tokenKind_TokenKind.DOLLAR ||
    kind === tokenKind_TokenKind.AMP ||
    kind === tokenKind_TokenKind.PAREN_L ||
    kind === tokenKind_TokenKind.PAREN_R ||
    kind === tokenKind_TokenKind.SPREAD ||
    kind === tokenKind_TokenKind.COLON ||
    kind === tokenKind_TokenKind.EQUALS ||
    kind === tokenKind_TokenKind.AT ||
    kind === tokenKind_TokenKind.BRACKET_L ||
    kind === tokenKind_TokenKind.BRACKET_R ||
    kind === tokenKind_TokenKind.BRACE_L ||
    kind === tokenKind_TokenKind.PIPE ||
    kind === tokenKind_TokenKind.BRACE_R
  );
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */

function isUnicodeScalarValue(code) {
  return (
    (code >= 0x0000 && code <= 0xd7ff) || (code >= 0xe000 && code <= 0x10ffff)
  );
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */

function isSupplementaryCodePoint(body, location) {
  return (
    isLeadingSurrogate(body.charCodeAt(location)) &&
    isTrailingSurrogate(body.charCodeAt(location + 1))
  );
}

function isLeadingSurrogate(code) {
  return code >= 0xd800 && code <= 0xdbff;
}

function isTrailingSurrogate(code) {
  return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */

function printCodePointAt(lexer, location) {
  const code = lexer.source.body.codePointAt(location);

  if (code === undefined) {
    return tokenKind_TokenKind.EOF;
  } else if (code >= 0x0020 && code <= 0x007e) {
    // Printable ASCII
    const char = String.fromCodePoint(code);
    return char === '"' ? "'\"'" : `"${char}"`;
  } // Unicode code point

  return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
/**
 * Create a token with line and column location information.
 */

function createToken(lexer, kind, start, end, value) {
  const line = lexer.line;
  const col = 1 + start - lexer.lineStart;
  return new language_ast/* Token */.WU(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */

function readNextToken(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // SourceCharacter

    switch (code) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 0xfeff: // <BOM>

      case 0x0009: // \t

      case 0x0020: // <space>

      case 0x002c:
        // ,
        ++position;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"

      case 0x000a:
        // \n
        ++position;
        ++lexer.line;
        lexer.lineStart = position;
        continue;

      case 0x000d:
        // \r
        if (body.charCodeAt(position + 1) === 0x000a) {
          position += 2;
        } else {
          ++position;
        }

        ++lexer.line;
        lexer.lineStart = position;
        continue;
      // Comment

      case 0x0023:
        // #
        return readComment(lexer, position);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }

      case 0x0021:
        // !
        return createToken(lexer, tokenKind_TokenKind.BANG, position, position + 1);

      case 0x0024:
        // $
        return createToken(lexer, tokenKind_TokenKind.DOLLAR, position, position + 1);

      case 0x0026:
        // &
        return createToken(lexer, tokenKind_TokenKind.AMP, position, position + 1);

      case 0x0028:
        // (
        return createToken(lexer, tokenKind_TokenKind.PAREN_L, position, position + 1);

      case 0x0029:
        // )
        return createToken(lexer, tokenKind_TokenKind.PAREN_R, position, position + 1);

      case 0x002e:
        // .
        if (
          body.charCodeAt(position + 1) === 0x002e &&
          body.charCodeAt(position + 2) === 0x002e
        ) {
          return createToken(lexer, tokenKind_TokenKind.SPREAD, position, position + 3);
        }

        break;

      case 0x003a:
        // :
        return createToken(lexer, tokenKind_TokenKind.COLON, position, position + 1);

      case 0x003d:
        // =
        return createToken(lexer, tokenKind_TokenKind.EQUALS, position, position + 1);

      case 0x0040:
        // @
        return createToken(lexer, tokenKind_TokenKind.AT, position, position + 1);

      case 0x005b:
        // [
        return createToken(lexer, tokenKind_TokenKind.BRACKET_L, position, position + 1);

      case 0x005d:
        // ]
        return createToken(lexer, tokenKind_TokenKind.BRACKET_R, position, position + 1);

      case 0x007b:
        // {
        return createToken(lexer, tokenKind_TokenKind.BRACE_L, position, position + 1);

      case 0x007c:
        // |
        return createToken(lexer, tokenKind_TokenKind.PIPE, position, position + 1);

      case 0x007d:
        // }
        return createToken(lexer, tokenKind_TokenKind.BRACE_R, position, position + 1);
      // StringValue

      case 0x0022:
        // "
        if (
          body.charCodeAt(position + 1) === 0x0022 &&
          body.charCodeAt(position + 2) === 0x0022
        ) {
          return readBlockString(lexer, position);
        }

        return readString(lexer, position);
    } // IntValue | FloatValue (Digit | -)

    if ((0,characterClasses/* isDigit */.X1)(code) || code === 0x002d) {
      return readNumber(lexer, position, code);
    } // Name

    if ((0,characterClasses/* isNameStart */.LQ)(code)) {
      return readName(lexer, position);
    }

    throw syntaxError(
      lexer.source,
      position,
      code === 0x0027
        ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?'
        : isUnicodeScalarValue(code) || isSupplementaryCodePoint(body, position)
        ? `Unexpected character: ${printCodePointAt(lexer, position)}.`
        : `Invalid character: ${printCodePointAt(lexer, position)}.`,
    );
  }

  return createToken(lexer, tokenKind_TokenKind.EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */

function readComment(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    tokenKind_TokenKind.COMMENT,
    start,
    position,
    body.slice(start + 1, position),
  );
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */

function readNumber(lexer, start, firstCode) {
  const body = lexer.source.body;
  let position = start;
  let code = firstCode;
  let isFloat = false; // NegativeSign (-)

  if (code === 0x002d) {
    code = body.charCodeAt(++position);
  } // Zero (0)

  if (code === 0x0030) {
    code = body.charCodeAt(++position);

    if ((0,characterClasses/* isDigit */.X1)(code)) {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid number, unexpected digit after 0: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  } else {
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Full stop (.)

  if (code === 0x002e) {
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // E e

  if (code === 0x0045 || code === 0x0065) {
    isFloat = true;
    code = body.charCodeAt(++position); // + -

    if (code === 0x002b || code === 0x002d) {
      code = body.charCodeAt(++position);
    }

    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart

  if (code === 0x002e || (0,characterClasses/* isNameStart */.LQ)(code)) {
    throw syntaxError(
      lexer.source,
      position,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        position,
      )}.`,
    );
  }

  return createToken(
    lexer,
    isFloat ? tokenKind_TokenKind.FLOAT : tokenKind_TokenKind.INT,
    start,
    position,
    body.slice(start, position),
  );
}
/**
 * Returns the new position in the source after reading one or more digits.
 */

function readDigits(lexer, start, firstCode) {
  if (!(0,characterClasses/* isDigit */.X1)(firstCode)) {
    throw syntaxError(
      lexer.source,
      start,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        start,
      )}.`,
    );
  }

  const body = lexer.source.body;
  let position = start + 1; // +1 to skip first firstCode

  while ((0,characterClasses/* isDigit */.X1)(body.charCodeAt(position))) {
    ++position;
  }

  return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */

function readString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;
  let chunkStart = position;
  let value = '';

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Quote (")

    if (code === 0x0022) {
      value += body.slice(chunkStart, position);
      return createToken(lexer, tokenKind_TokenKind.STRING, start, position + 1, value);
    } // Escape Sequence (\)

    if (code === 0x005c) {
      value += body.slice(chunkStart, position);
      const escape =
        body.charCodeAt(position + 1) === 0x0075 // u
          ? body.charCodeAt(position + 2) === 0x007b // {
            ? readEscapedUnicodeVariableWidth(lexer, position)
            : readEscapedUnicodeFixedWidth(lexer, position)
          : readEscapedCharacter(lexer, position);
      value += escape.value;
      position += escape.size;
      chunkStart = position;
      continue;
    } // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.

function readEscapedUnicodeVariableWidth(lexer, position) {
  const body = lexer.source.body;
  let point = 0;
  let size = 3; // Cannot be larger than 12 chars (\u{00000000}).

  while (size < 12) {
    const code = body.charCodeAt(position + size++); // Closing Brace (})

    if (code === 0x007d) {
      // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
      if (size < 5 || !isUnicodeScalarValue(point)) {
        break;
      }

      return {
        value: String.fromCodePoint(point),
        size,
      };
    } // Append this hex digit to the code point.

    point = (point << 4) | readHexDigit(code);

    if (point < 0) {
      break;
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(
      position,
      position + size,
    )}".`,
  );
}

function readEscapedUnicodeFixedWidth(lexer, position) {
  const body = lexer.source.body;
  const code = read16BitHexCode(body, position + 2);

  if (isUnicodeScalarValue(code)) {
    return {
      value: String.fromCodePoint(code),
      size: 6,
    };
  } // GraphQL allows JSON-style surrogate pair escape sequences, but only when
  // a valid pair is formed.

  if (isLeadingSurrogate(code)) {
    // \u
    if (
      body.charCodeAt(position + 6) === 0x005c &&
      body.charCodeAt(position + 7) === 0x0075
    ) {
      const trailingCode = read16BitHexCode(body, position + 8);

      if (isTrailingSurrogate(trailingCode)) {
        // JavaScript defines strings as a sequence of UTF-16 code units and
        // encodes Unicode code points above U+FFFF using a surrogate pair of
        // code units. Since this is a surrogate pair escape sequence, just
        // include both codes into the JavaScript string value. Had JavaScript
        // not been internally based on UTF-16, then this surrogate pair would
        // be decoded to retrieve the supplementary code point.
        return {
          value: String.fromCodePoint(code, trailingCode),
          size: 12,
        };
      }
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`,
  );
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */

function read16BitHexCode(body, position) {
  // readHexDigit() returns -1 on error. ORing a negative value with any other
  // value always produces a negative value.
  return (
    (readHexDigit(body.charCodeAt(position)) << 12) |
    (readHexDigit(body.charCodeAt(position + 1)) << 8) |
    (readHexDigit(body.charCodeAt(position + 2)) << 4) |
    readHexDigit(body.charCodeAt(position + 3))
  );
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */

function readHexDigit(code) {
  return code >= 0x0030 && code <= 0x0039 // 0-9
    ? code - 0x0030
    : code >= 0x0041 && code <= 0x0046 // A-F
    ? code - 0x0037
    : code >= 0x0061 && code <= 0x0066 // a-f
    ? code - 0x0057
    : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */

function readEscapedCharacter(lexer, position) {
  const body = lexer.source.body;
  const code = body.charCodeAt(position + 1);

  switch (code) {
    case 0x0022:
      // "
      return {
        value: '\u0022',
        size: 2,
      };

    case 0x005c:
      // \
      return {
        value: '\u005c',
        size: 2,
      };

    case 0x002f:
      // /
      return {
        value: '\u002f',
        size: 2,
      };

    case 0x0062:
      // b
      return {
        value: '\u0008',
        size: 2,
      };

    case 0x0066:
      // f
      return {
        value: '\u000c',
        size: 2,
      };

    case 0x006e:
      // n
      return {
        value: '\u000a',
        size: 2,
      };

    case 0x0072:
      // r
      return {
        value: '\u000d',
        size: 2,
      };

    case 0x0074:
      // t
      return {
        value: '\u0009',
        size: 2,
      };
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid character escape sequence: "${body.slice(
      position,
      position + 2,
    )}".`,
  );
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */

function readBlockString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let lineStart = lexer.lineStart;
  let position = start + 3;
  let chunkStart = position;
  let currentLine = '';
  const blockLines = [];

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Triple-Quote (""")

    if (
      code === 0x0022 &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);
      const token = createToken(
        lexer,
        tokenKind_TokenKind.BLOCK_STRING,
        start,
        position + 3, // Return a string of the lines joined with U+000A.
        (0,blockString/* dedentBlockStringLines */.wv)(blockLines).join('\n'),
      );
      lexer.line += blockLines.length - 1;
      lexer.lineStart = lineStart;
      return token;
    } // Escaped Triple-Quote (\""")

    if (
      code === 0x005c &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022 &&
      body.charCodeAt(position + 3) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      chunkStart = position + 1; // skip only slash

      position += 4;
      continue;
    } // LineTerminator

    if (code === 0x000a || code === 0x000d) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);

      if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) {
        position += 2;
      } else {
        ++position;
      }

      currentLine = '';
      chunkStart = position;
      lineStart = position;
      continue;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */

function readName(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position);

    if ((0,characterClasses/* isNameContinue */.HQ)(code)) {
      ++position;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    tokenKind_TokenKind.NAME,
    start,
    position,
    body.slice(start, position),
  );
}

// EXTERNAL MODULE: ../../app/node_modules/graphql/jsutils/devAssert.mjs
var devAssert = __webpack_require__(3606);
// EXTERNAL MODULE: ../../app/node_modules/graphql/jsutils/inspect.mjs
var inspect = __webpack_require__(44498);
;// CONCATENATED MODULE: ../../app/node_modules/graphql/jsutils/instanceOf.mjs

/* c8 ignore next 3 */

const isProduction =
  globalThis.process && // eslint-disable-next-line no-undef
  "production" === 'production';
/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 * See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
 * See: https://webpack.js.org/guides/production/
 */

const instanceOf_instanceOf =
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  isProduction
    ? function instanceOf(value, constructor) {
        return value instanceof constructor;
      }
    : function instanceOf(value, constructor) {
        if (value instanceof constructor) {
          return true;
        }

        if (typeof value === 'object' && value !== null) {
          var _value$constructor;

          // Prefer Symbol.toStringTag since it is immune to minification.
          const className = constructor.prototype[Symbol.toStringTag];
          const valueClassName = // We still need to support constructor's name to detect conflicts with older versions of this library.
            Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
              ? value[Symbol.toStringTag]
              : (_value$constructor = value.constructor) === null ||
                _value$constructor === void 0
              ? void 0
              : _value$constructor.name;

          if (className === valueClassName) {
            const stringifiedValue = (0,inspect/* inspect */.X)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
          }
        }

        return false;
      };

;// CONCATENATED MODULE: ../../app/node_modules/graphql/language/source.mjs




/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
class Source {
  constructor(
    body,
    name = 'GraphQL request',
    locationOffset = {
      line: 1,
      column: 1,
    },
  ) {
    typeof body === 'string' ||
      (0,devAssert/* devAssert */.a)(false, `Body must be a string. Received: ${(0,inspect/* inspect */.X)(body)}.`);
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 ||
      (0,devAssert/* devAssert */.a)(
        false,
        'line in locationOffset is 1-indexed and must be positive.',
      );
    this.locationOffset.column > 0 ||
      (0,devAssert/* devAssert */.a)(
        false,
        'column in locationOffset is 1-indexed and must be positive.',
      );
  }

  get [Symbol.toStringTag]() {
    return 'Source';
  }
}
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

function isSource(source) {
  return instanceOf_instanceOf(source, Source);
}

;// CONCATENATED MODULE: ../../app/node_modules/graphql/language/parser.mjs







/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  const parser = new Parser(source, options);
  const document = parser.parseDocument();
  Object.defineProperty(document, 'tokenCount', {
    enumerable: false,
    value: parser.tokenCount,
  });
  return document;
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */

function parseValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseValueLiteral(false);
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Similar to parseValue(), but raises a parse error if it encounters a
 * variable. The return type will be a constant value.
 */

function parseConstValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseConstValueLiteral();
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */

function parseType(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const type = parser.parseTypeReference();
  parser.expectToken(TokenKind.EOF);
  return type;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

class Parser {
  constructor(source, options = {}) {
    const sourceObj = isSource(source) ? source : new Source(source);
    this._lexer = new Lexer(sourceObj);
    this._options = options;
    this._tokenCounter = 0;
  }

  get tokenCount() {
    return this._tokenCounter;
  }
  /**
   * Converts a name lex token into a name parse node.
   */

  parseName() {
    const token = this.expectToken(tokenKind_TokenKind.NAME);
    return this.node(token, {
      kind: kinds/* Kind,NAME */.h.NAME,
      value: token.value,
    });
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */

  parseDocument() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind,DOCUMENT */.h.DOCUMENT,
      definitions: this.many(
        tokenKind_TokenKind.SOF,
        this.parseDefinition,
        tokenKind_TokenKind.EOF,
      ),
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */

  parseDefinition() {
    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } // Many definitions begin with a description and require a lookahead.

    const hasDescription = this.peekDescription();
    const keywordToken = hasDescription
      ? this._lexer.lookahead()
      : this._lexer.token;

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }

      if (hasDescription) {
        throw syntaxError(
          this._lexer.source,
          this._lexer.token.start,
          'Unexpected description, descriptions are supported only on type definitions.',
        );
      }

      switch (keywordToken.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    }

    throw this.unexpected(keywordToken);
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */

  parseOperationDefinition() {
    const start = this._lexer.token;

    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.node(start, {
        kind: kinds/* Kind,OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
        operation: language_ast/* OperationTypeNode,QUERY */.ku.QUERY,
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
      });
    }

    const operation = this.parseOperationType();
    let name;

    if (this.peek(tokenKind_TokenKind.NAME)) {
      name = this.parseName();
    }

    return this.node(start, {
      kind: kinds/* Kind,OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
      operation,
      name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */

  parseOperationType() {
    const operationToken = this.expectToken(tokenKind_TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return language_ast/* OperationTypeNode,QUERY */.ku.QUERY;

      case 'mutation':
        return language_ast/* OperationTypeNode,MUTATION */.ku.MUTATION;

      case 'subscription':
        return language_ast/* OperationTypeNode,SUBSCRIPTION */.ku.SUBSCRIPTION;
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */

  parseVariableDefinitions() {
    return this.optionalMany(
      tokenKind_TokenKind.PAREN_L,
      this.parseVariableDefinition,
      tokenKind_TokenKind.PAREN_R,
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */

  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind,VARIABLE_DEFINITION */.h.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(tokenKind_TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(tokenKind_TokenKind.EQUALS)
        ? this.parseConstValueLiteral()
        : undefined,
      directives: this.parseConstDirectives(),
    });
  }
  /**
   * Variable : $ Name
   */

  parseVariable() {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.DOLLAR);
    return this.node(start, {
      kind: kinds/* Kind,VARIABLE */.h.VARIABLE,
      name: this.parseName(),
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */

  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind,SELECTION_SET */.h.SELECTION_SET,
      selections: this.many(
        tokenKind_TokenKind.BRACE_L,
        this.parseSelection,
        tokenKind_TokenKind.BRACE_R,
      ),
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */

  parseSelection() {
    return this.peek(tokenKind_TokenKind.SPREAD)
      ? this.parseFragment()
      : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */

  parseField() {
    const start = this._lexer.token;
    const nameOrAlias = this.parseName();
    let alias;
    let name;

    if (this.expectOptionalToken(tokenKind_TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return this.node(start, {
      kind: kinds/* Kind,FIELD */.h.FIELD,
      alias,
      name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(tokenKind_TokenKind.BRACE_L)
        ? this.parseSelectionSet()
        : undefined,
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */

  parseArguments(isConst) {
    const item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, item, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */

  parseArgument(isConst = false) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return this.node(start, {
      kind: kinds/* Kind,ARGUMENT */.h.ARGUMENT,
      name,
      value: this.parseValueLiteral(isConst),
    });
  }

  parseConstArgument() {
    return this.parseArgument(true);
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */

  parseFragment() {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.SPREAD);
    const hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(tokenKind_TokenKind.NAME)) {
      return this.node(start, {
        kind: kinds/* Kind,FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
      });
    }

    return this.node(start, {
      kind: kinds/* Kind,INLINE_FRAGMENT */.h.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */

  parseFragmentDefinition() {
    const start = this._lexer.token;
    this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (this._options.allowLegacyFragmentVariables === true) {
      return this.node(start, {
        kind: kinds/* Kind,FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
      });
    }

    return this.node(start, {
      kind: kinds/* Kind,FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentName : Name but not `on`
   */

  parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseValueLiteral(isConst) {
    const token = this._lexer.token;

    switch (token.kind) {
      case tokenKind_TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case tokenKind_TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case tokenKind_TokenKind.INT:
        this.advanceLexer();
        return this.node(token, {
          kind: kinds/* Kind,INT */.h.INT,
          value: token.value,
        });

      case tokenKind_TokenKind.FLOAT:
        this.advanceLexer();
        return this.node(token, {
          kind: kinds/* Kind,FLOAT */.h.FLOAT,
          value: token.value,
        });

      case tokenKind_TokenKind.STRING:
      case tokenKind_TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case tokenKind_TokenKind.NAME:
        this.advanceLexer();

        switch (token.value) {
          case 'true':
            return this.node(token, {
              kind: kinds/* Kind,BOOLEAN */.h.BOOLEAN,
              value: true,
            });

          case 'false':
            return this.node(token, {
              kind: kinds/* Kind,BOOLEAN */.h.BOOLEAN,
              value: false,
            });

          case 'null':
            return this.node(token, {
              kind: kinds/* Kind,NULL */.h.NULL,
            });

          default:
            return this.node(token, {
              kind: kinds/* Kind,ENUM */.h.ENUM,
              value: token.value,
            });
        }

      case tokenKind_TokenKind.DOLLAR:
        if (isConst) {
          this.expectToken(tokenKind_TokenKind.DOLLAR);

          if (this._lexer.token.kind === tokenKind_TokenKind.NAME) {
            const varName = this._lexer.token.value;
            throw syntaxError(
              this._lexer.source,
              token.start,
              `Unexpected variable "$${varName}" in constant value.`,
            );
          } else {
            throw this.unexpected(token);
          }
        }

        return this.parseVariable();

      default:
        throw this.unexpected();
    }
  }

  parseConstValueLiteral() {
    return this.parseValueLiteral(true);
  }

  parseStringLiteral() {
    const token = this._lexer.token;
    this.advanceLexer();
    return this.node(token, {
      kind: kinds/* Kind,STRING */.h.STRING,
      value: token.value,
      block: token.kind === tokenKind_TokenKind.BLOCK_STRING,
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */

  parseList(isConst) {
    const item = () => this.parseValueLiteral(isConst);

    return this.node(this._lexer.token, {
      kind: kinds/* Kind,LIST */.h.LIST,
      values: this.any(tokenKind_TokenKind.BRACKET_L, item, tokenKind_TokenKind.BRACKET_R),
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */

  parseObject(isConst) {
    const item = () => this.parseObjectField(isConst);

    return this.node(this._lexer.token, {
      kind: kinds/* Kind,OBJECT */.h.OBJECT,
      fields: this.any(tokenKind_TokenKind.BRACE_L, item, tokenKind_TokenKind.BRACE_R),
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */

  parseObjectField(isConst) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return this.node(start, {
      kind: kinds/* Kind,OBJECT_FIELD */.h.OBJECT_FIELD,
      name,
      value: this.parseValueLiteral(isConst),
    });
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */

  parseDirectives(isConst) {
    const directives = [];

    while (this.peek(tokenKind_TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }

  parseConstDirectives() {
    return this.parseDirectives(true);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */

  parseDirective(isConst) {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.AT);
    return this.node(start, {
      kind: kinds/* Kind,DIRECTIVE */.h.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
    });
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */

  parseTypeReference() {
    const start = this._lexer.token;
    let type;

    if (this.expectOptionalToken(tokenKind_TokenKind.BRACKET_L)) {
      const innerType = this.parseTypeReference();
      this.expectToken(tokenKind_TokenKind.BRACKET_R);
      type = this.node(start, {
        kind: kinds/* Kind,LIST_TYPE */.h.LIST_TYPE,
        type: innerType,
      });
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(tokenKind_TokenKind.BANG)) {
      return this.node(start, {
        kind: kinds/* Kind,NON_NULL_TYPE */.h.NON_NULL_TYPE,
        type,
      });
    }

    return type;
  }
  /**
   * NamedType : Name
   */

  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind,NAMED_TYPE */.h.NAMED_TYPE,
      name: this.parseName(),
    });
  } // Implements the parsing rules in the Type Definition section.

  peekDescription() {
    return this.peek(tokenKind_TokenKind.STRING) || this.peek(tokenKind_TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */

  parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */

  parseSchemaDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.many(
      tokenKind_TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
    return this.node(start, {
      kind: kinds/* Kind,SCHEMA_DEFINITION */.h.SCHEMA_DEFINITION,
      description,
      directives,
      operationTypes,
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */

  parseOperationTypeDefinition() {
    const start = this._lexer.token;
    const operation = this.parseOperationType();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseNamedType();
    return this.node(start, {
      kind: kinds/* Kind,OPERATION_TYPE_DEFINITION */.h.OPERATION_TYPE_DEFINITION,
      operation,
      type,
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */

  parseScalarTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind,SCALAR_TYPE_DEFINITION */.h.SCALAR_TYPE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */

  parseObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind,OBJECT_TYPE_DEFINITION */.h.OBJECT_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */

  parseImplementsInterfaces() {
    return this.expectOptionalKeyword('implements')
      ? this.delimitedMany(tokenKind_TokenKind.AMP, this.parseNamedType)
      : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */

  parseFieldsDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseFieldDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */

  parseFieldDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseTypeReference();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind,FIELD_DEFINITION */.h.FIELD_DEFINITION,
      description,
      name,
      arguments: args,
      type,
      directives,
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */

  parseArgumentDefs() {
    return this.optionalMany(
      tokenKind_TokenKind.PAREN_L,
      this.parseInputValueDef,
      tokenKind_TokenKind.PAREN_R,
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */

  parseInputValueDef() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseTypeReference();
    let defaultValue;

    if (this.expectOptionalToken(tokenKind_TokenKind.EQUALS)) {
      defaultValue = this.parseConstValueLiteral();
    }

    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind,INPUT_VALUE_DEFINITION */.h.INPUT_VALUE_DEFINITION,
      description,
      name,
      type,
      defaultValue,
      directives,
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */

  parseInterfaceTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind,INTERFACE_TYPE_DEFINITION */.h.INTERFACE_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */

  parseUnionTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();
    return this.node(start, {
      kind: kinds/* Kind,UNION_TYPE_DEFINITION */.h.UNION_TYPE_DEFINITION,
      description,
      name,
      directives,
      types,
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */

  parseUnionMemberTypes() {
    return this.expectOptionalToken(tokenKind_TokenKind.EQUALS)
      ? this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseNamedType)
      : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */

  parseEnumTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();
    return this.node(start, {
      kind: kinds/* Kind,ENUM_TYPE_DEFINITION */.h.ENUM_TYPE_DEFINITION,
      description,
      name,
      directives,
      values,
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */

  parseEnumValuesDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseEnumValueDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */

  parseEnumValueDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseEnumValueName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind,ENUM_VALUE_DEFINITION */.h.ENUM_VALUE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseEnumValueName() {
    if (
      this._lexer.token.value === 'true' ||
      this._lexer.token.value === 'false' ||
      this._lexer.token.value === 'null'
    ) {
      throw syntaxError(
        this._lexer.source,
        this._lexer.token.start,
        `${getTokenDesc(
          this._lexer.token,
        )} is reserved and cannot be used for an enum value.`,
      );
    }

    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */

  parseInputObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind,INPUT_OBJECT_TYPE_DEFINITION */.h.INPUT_OBJECT_TYPE_DEFINITION,
      description,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */

  parseInputFieldsDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseInputValueDef,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */

  parseTypeSystemExtension() {
    const keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */

  parseSchemaExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      tokenKind_TokenKind.BRACE_R,
    );

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind,SCHEMA_EXTENSION */.h.SCHEMA_EXTENSION,
      directives,
      operationTypes,
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */

  parseScalarTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind,SCALAR_TYPE_EXTENSION */.h.SCALAR_TYPE_EXTENSION,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */

  parseObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind,OBJECT_TYPE_EXTENSION */.h.OBJECT_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */

  parseInterfaceTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind,INTERFACE_TYPE_EXTENSION */.h.INTERFACE_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */

  parseUnionTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind,UNION_TYPE_EXTENSION */.h.UNION_TYPE_EXTENSION,
      name,
      directives,
      types,
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */

  parseEnumTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind,ENUM_TYPE_EXTENSION */.h.ENUM_TYPE_EXTENSION,
      name,
      directives,
      values,
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */

  parseInputObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind,INPUT_OBJECT_TYPE_EXTENSION */.h.INPUT_OBJECT_TYPE_EXTENSION,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */

  parseDirectiveDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(tokenKind_TokenKind.AT);
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    const repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    const locations = this.parseDirectiveLocations();
    return this.node(start, {
      kind: kinds/* Kind,DIRECTIVE_DEFINITION */.h.DIRECTIVE_DEFINITION,
      description,
      name,
      arguments: args,
      repeatable,
      locations,
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */

  parseDirectiveLocations() {
    return this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */

  parseDirectiveLocation() {
    const start = this._lexer.token;
    const name = this.parseName();

    if (Object.prototype.hasOwnProperty.call(directiveLocation_DirectiveLocation, name.value)) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */

  node(startToken, node) {
    if (this._options.noLocation !== true) {
      node.loc = new language_ast/* Location */.Ye(
        startToken,
        this._lexer.lastToken,
        this._lexer.source,
      );
    }

    return node;
  }
  /**
   * Determines if the next token is of a given kind
   */

  peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return token;
    }

    throw syntaxError(
      this._lexer.source,
      token.start,
      `Expected ${getTokenKindDesc(kind)}, found ${getTokenDesc(token)}.`,
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this.advanceLexer();
    } else {
      throw syntaxError(
        this._lexer.source,
        token.start,
        `Expected "${value}", found ${getTokenDesc(token)}.`,
      );
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */

  unexpected(atToken) {
    const token =
      atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(
      this._lexer.source,
      token.start,
      `Unexpected ${getTokenDesc(token)}.`,
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      const nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */

  delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  }

  advanceLexer() {
    const { maxTokens } = this._options;

    const token = this._lexer.advance();

    if (token.kind !== tokenKind_TokenKind.EOF) {
      ++this._tokenCounter;

      if (maxTokens !== undefined && this._tokenCounter > maxTokens) {
        throw syntaxError(
          this._lexer.source,
          token.start,
          `Document contains more that ${maxTokens} tokens. Parsing aborted.`,
        );
      }
    }
  }
}
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  const value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */

function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? `"${kind}"` : kind;
}

;// CONCATENATED MODULE: ../../app/node_modules/graphql-tag/lib/index.js


var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = parse(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
/* ESM default export */ const lib = (gql);
//# sourceMappingURL=index.js.map

}),
10931: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(15461);

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


}),
15461: (function (module) {
"use strict";


/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


}),
13271: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(52106);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


}),
98172: (function (module, __unused_webpack_exports, __webpack_require__) {
var getNative = __webpack_require__(40440),
    root = __webpack_require__(75238);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


}),
51796: (function (module, __unused_webpack_exports, __webpack_require__) {
var hashClear = __webpack_require__(87322),
    hashDelete = __webpack_require__(32937),
    hashGet = __webpack_require__(207),
    hashHas = __webpack_require__(2165),
    hashSet = __webpack_require__(7523);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


}),
84281: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseCreate = __webpack_require__(45940),
    baseLodash = __webpack_require__(64382);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


}),
80283: (function (module, __unused_webpack_exports, __webpack_require__) {
var listCacheClear = __webpack_require__(97435),
    listCacheDelete = __webpack_require__(18438),
    listCacheGet = __webpack_require__(63067),
    listCacheHas = __webpack_require__(69679),
    listCacheSet = __webpack_require__(82426);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


}),
29675: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseCreate = __webpack_require__(45940),
    baseLodash = __webpack_require__(64382);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


}),
9036: (function (module, __unused_webpack_exports, __webpack_require__) {
var getNative = __webpack_require__(40440),
    root = __webpack_require__(75238);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


}),
24544: (function (module, __unused_webpack_exports, __webpack_require__) {
var mapCacheClear = __webpack_require__(6409),
    mapCacheDelete = __webpack_require__(85335),
    mapCacheGet = __webpack_require__(35601),
    mapCacheHas = __webpack_require__(71533),
    mapCacheSet = __webpack_require__(20151);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


}),
60044: (function (module, __unused_webpack_exports, __webpack_require__) {
var getNative = __webpack_require__(40440),
    root = __webpack_require__(75238);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


}),
66656: (function (module, __unused_webpack_exports, __webpack_require__) {
var getNative = __webpack_require__(40440),
    root = __webpack_require__(75238);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


}),
83290: (function (module, __unused_webpack_exports, __webpack_require__) {
var MapCache = __webpack_require__(24544),
    setCacheAdd = __webpack_require__(41760),
    setCacheHas = __webpack_require__(75484);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


}),
91902: (function (module, __unused_webpack_exports, __webpack_require__) {
var ListCache = __webpack_require__(80283),
    stackClear = __webpack_require__(86063),
    stackDelete = __webpack_require__(27727),
    stackGet = __webpack_require__(13281),
    stackHas = __webpack_require__(66667),
    stackSet = __webpack_require__(91270);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


}),
4886: (function (module, __unused_webpack_exports, __webpack_require__) {
var root = __webpack_require__(75238);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


}),
68965: (function (module, __unused_webpack_exports, __webpack_require__) {
var root = __webpack_require__(75238);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


}),
73283: (function (module, __unused_webpack_exports, __webpack_require__) {
var getNative = __webpack_require__(40440),
    root = __webpack_require__(75238);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


}),
19198: (function (module) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


}),
59652: (function (module) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


}),
74970: (function (module) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


}),
72654: (function (module) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


}),
94979: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseTimes = __webpack_require__(58023),
    isArguments = __webpack_require__(79732),
    isArray = __webpack_require__(36377),
    isBuffer = __webpack_require__(26018),
    isIndex = __webpack_require__(89251),
    isTypedArray = __webpack_require__(58586);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


}),
21098: (function (module) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


}),
85741: (function (module) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


}),
72607: (function (module) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


}),
53955: (function (module) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


}),
50609: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseProperty = __webpack_require__(92726);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;


}),
69013: (function (module) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


}),
30782: (function (module) {
/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


}),
64868: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseAssignValue = __webpack_require__(12676),
    eq = __webpack_require__(84071);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


}),
63615: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseAssignValue = __webpack_require__(12676),
    eq = __webpack_require__(84071);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


}),
68357: (function (module, __unused_webpack_exports, __webpack_require__) {
var eq = __webpack_require__(84071);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


}),
37608: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseEach = __webpack_require__(48264);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


}),
96103: (function (module, __unused_webpack_exports, __webpack_require__) {
var copyObject = __webpack_require__(68284),
    keys = __webpack_require__(47361);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


}),
86436: (function (module, __unused_webpack_exports, __webpack_require__) {
var copyObject = __webpack_require__(68284),
    keysIn = __webpack_require__(33747);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


}),
12676: (function (module, __unused_webpack_exports, __webpack_require__) {
var defineProperty = __webpack_require__(59833);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


}),
52009: (function (module) {
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


}),
66512: (function (module, __unused_webpack_exports, __webpack_require__) {
var Stack = __webpack_require__(91902),
    arrayEach = __webpack_require__(74970),
    assignValue = __webpack_require__(63615),
    baseAssign = __webpack_require__(96103),
    baseAssignIn = __webpack_require__(86436),
    cloneBuffer = __webpack_require__(84193),
    copyArray = __webpack_require__(38606),
    copySymbols = __webpack_require__(15317),
    copySymbolsIn = __webpack_require__(9790),
    getAllKeys = __webpack_require__(43948),
    getAllKeysIn = __webpack_require__(19254),
    getTag = __webpack_require__(69937),
    initCloneArray = __webpack_require__(60424),
    initCloneByTag = __webpack_require__(93956),
    initCloneObject = __webpack_require__(27608),
    isArray = __webpack_require__(36377),
    isBuffer = __webpack_require__(26018),
    isMap = __webpack_require__(14986),
    isObject = __webpack_require__(28532),
    isSet = __webpack_require__(87975),
    keys = __webpack_require__(47361),
    keysIn = __webpack_require__(33747);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


}),
45940: (function (module, __unused_webpack_exports, __webpack_require__) {
var isObject = __webpack_require__(28532);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


}),
48264: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseForOwn = __webpack_require__(93406),
    createBaseEach = __webpack_require__(32679);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


}),
82056: (function (module) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


}),
25265: (function (module, __unused_webpack_exports, __webpack_require__) {
var arrayPush = __webpack_require__(85741),
    isFlattenable = __webpack_require__(11668);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


}),
20001: (function (module, __unused_webpack_exports, __webpack_require__) {
var createBaseFor = __webpack_require__(10132);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


}),
93406: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseFor = __webpack_require__(20001),
    keys = __webpack_require__(47361);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


}),
11957: (function (module, __unused_webpack_exports, __webpack_require__) {
var castPath = __webpack_require__(33835),
    toKey = __webpack_require__(78481);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


}),
7743: (function (module, __unused_webpack_exports, __webpack_require__) {
var arrayPush = __webpack_require__(85741),
    isArray = __webpack_require__(36377);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


}),
23757: (function (module, __unused_webpack_exports, __webpack_require__) {
var Symbol = __webpack_require__(4886),
    getRawTag = __webpack_require__(75118),
    objectToString = __webpack_require__(77070);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


}),
66993: (function (module) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


}),
7948: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseForOwn = __webpack_require__(93406);

/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */
function baseInverter(object, setter, iteratee, accumulator) {
  baseForOwn(object, function(value, key, object) {
    setter(accumulator, iteratee(value), key, object);
  });
  return accumulator;
}

module.exports = baseInverter;


}),
50841: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseGetTag = __webpack_require__(23757),
    isObjectLike = __webpack_require__(27013);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


}),
25447: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseIsEqualDeep = __webpack_require__(70906),
    isObjectLike = __webpack_require__(27013);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


}),
70906: (function (module, __unused_webpack_exports, __webpack_require__) {
var Stack = __webpack_require__(91902),
    equalArrays = __webpack_require__(34476),
    equalByTag = __webpack_require__(29027),
    equalObjects = __webpack_require__(58714),
    getTag = __webpack_require__(69937),
    isArray = __webpack_require__(36377),
    isBuffer = __webpack_require__(26018),
    isTypedArray = __webpack_require__(58586);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


}),
10518: (function (module, __unused_webpack_exports, __webpack_require__) {
var getTag = __webpack_require__(69937),
    isObjectLike = __webpack_require__(27013);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


}),
57293: (function (module, __unused_webpack_exports, __webpack_require__) {
var Stack = __webpack_require__(91902),
    baseIsEqual = __webpack_require__(25447);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


}),
40692: (function (module, __unused_webpack_exports, __webpack_require__) {
var isFunction = __webpack_require__(56644),
    isMasked = __webpack_require__(13417),
    isObject = __webpack_require__(28532),
    toSource = __webpack_require__(61473);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


}),
70185: (function (module, __unused_webpack_exports, __webpack_require__) {
var getTag = __webpack_require__(69937),
    isObjectLike = __webpack_require__(27013);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


}),
42195: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseGetTag = __webpack_require__(23757),
    isLength = __webpack_require__(57924),
    isObjectLike = __webpack_require__(27013);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


}),
35462: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseMatches = __webpack_require__(6358),
    baseMatchesProperty = __webpack_require__(84503),
    identity = __webpack_require__(21622),
    isArray = __webpack_require__(36377),
    property = __webpack_require__(78303);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


}),
57407: (function (module, __unused_webpack_exports, __webpack_require__) {
var isPrototype = __webpack_require__(88857),
    nativeKeys = __webpack_require__(22440);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


}),
79237: (function (module, __unused_webpack_exports, __webpack_require__) {
var isObject = __webpack_require__(28532),
    isPrototype = __webpack_require__(88857),
    nativeKeysIn = __webpack_require__(61308);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


}),
64382: (function (module) {
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


}),
6358: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseIsMatch = __webpack_require__(57293),
    getMatchData = __webpack_require__(47145),
    matchesStrictComparable = __webpack_require__(64167);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


}),
84503: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseIsEqual = __webpack_require__(25447),
    get = __webpack_require__(24738),
    hasIn = __webpack_require__(29290),
    isKey = __webpack_require__(17074),
    isStrictComparable = __webpack_require__(81542),
    matchesStrictComparable = __webpack_require__(64167),
    toKey = __webpack_require__(78481);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


}),
50222: (function (module, __unused_webpack_exports, __webpack_require__) {
var Stack = __webpack_require__(91902),
    assignMergeValue = __webpack_require__(64868),
    baseFor = __webpack_require__(20001),
    baseMergeDeep = __webpack_require__(26400),
    isObject = __webpack_require__(28532),
    keysIn = __webpack_require__(33747),
    safeGet = __webpack_require__(1780);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


}),
26400: (function (module, __unused_webpack_exports, __webpack_require__) {
var assignMergeValue = __webpack_require__(64868),
    cloneBuffer = __webpack_require__(84193),
    cloneTypedArray = __webpack_require__(26739),
    copyArray = __webpack_require__(38606),
    initCloneObject = __webpack_require__(27608),
    isArguments = __webpack_require__(79732),
    isArray = __webpack_require__(36377),
    isArrayLikeObject = __webpack_require__(50753),
    isBuffer = __webpack_require__(26018),
    isFunction = __webpack_require__(56644),
    isObject = __webpack_require__(28532),
    isPlainObject = __webpack_require__(41968),
    isTypedArray = __webpack_require__(58586),
    safeGet = __webpack_require__(1780),
    toPlainObject = __webpack_require__(57132);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


}),
77100: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseGet = __webpack_require__(11957),
    baseSet = __webpack_require__(35495),
    castPath = __webpack_require__(33835);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


}),
92726: (function (module) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


}),
21374: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseGet = __webpack_require__(11957);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


}),
64664: (function (module) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


}),
39864: (function (module) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


}),
47605: (function (module, __unused_webpack_exports, __webpack_require__) {
var identity = __webpack_require__(21622),
    overRest = __webpack_require__(16813),
    setToString = __webpack_require__(12413);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


}),
35495: (function (module, __unused_webpack_exports, __webpack_require__) {
var assignValue = __webpack_require__(63615),
    castPath = __webpack_require__(33835),
    isIndex = __webpack_require__(89251),
    isObject = __webpack_require__(28532),
    toKey = __webpack_require__(78481);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


}),
62422: (function (module, __unused_webpack_exports, __webpack_require__) {
var constant = __webpack_require__(25055),
    defineProperty = __webpack_require__(59833),
    identity = __webpack_require__(21622);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


}),
96708: (function (module) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


}),
58023: (function (module) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


}),
99653: (function (module, __unused_webpack_exports, __webpack_require__) {
var Symbol = __webpack_require__(4886),
    arrayMap = __webpack_require__(21098),
    isArray = __webpack_require__(36377),
    isSymbol = __webpack_require__(61359);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


}),
1072: (function (module, __unused_webpack_exports, __webpack_require__) {
var trimmedEndIndex = __webpack_require__(73230);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


}),
57509: (function (module) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


}),
52471: (function (module) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


}),
28269: (function (module, __unused_webpack_exports, __webpack_require__) {
var identity = __webpack_require__(21622);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


}),
33835: (function (module, __unused_webpack_exports, __webpack_require__) {
var isArray = __webpack_require__(36377),
    isKey = __webpack_require__(17074),
    stringToPath = __webpack_require__(78997),
    toString = __webpack_require__(36214);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


}),
93084: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseSlice = __webpack_require__(96708);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


}),
41029: (function (module, __unused_webpack_exports, __webpack_require__) {
var Uint8Array = __webpack_require__(68965);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


}),
84193: (function (module, exports, __webpack_require__) {
/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(75238);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


}),
60551: (function (module, __unused_webpack_exports, __webpack_require__) {
var cloneArrayBuffer = __webpack_require__(41029);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


}),
16985: (function (module) {
/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


}),
86584: (function (module, __unused_webpack_exports, __webpack_require__) {
var Symbol = __webpack_require__(4886);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


}),
26739: (function (module, __unused_webpack_exports, __webpack_require__) {
var cloneArrayBuffer = __webpack_require__(41029);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


}),
38606: (function (module) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


}),
68284: (function (module, __unused_webpack_exports, __webpack_require__) {
var assignValue = __webpack_require__(63615),
    baseAssignValue = __webpack_require__(12676);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


}),
15317: (function (module, __unused_webpack_exports, __webpack_require__) {
var copyObject = __webpack_require__(68284),
    getSymbols = __webpack_require__(26230);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


}),
9790: (function (module, __unused_webpack_exports, __webpack_require__) {
var copyObject = __webpack_require__(68284),
    getSymbolsIn = __webpack_require__(2992);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


}),
75772: (function (module, __unused_webpack_exports, __webpack_require__) {
var root = __webpack_require__(75238);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


}),
32297: (function (module, __unused_webpack_exports, __webpack_require__) {
var arrayAggregator = __webpack_require__(59652),
    baseAggregator = __webpack_require__(37608),
    baseIteratee = __webpack_require__(35462),
    isArray = __webpack_require__(36377);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


}),
61826: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseRest = __webpack_require__(47605),
    isIterateeCall = __webpack_require__(78693);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


}),
32679: (function (module, __unused_webpack_exports, __webpack_require__) {
var isArrayLike = __webpack_require__(30508);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


}),
10132: (function (module) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


}),
19978: (function (module, __unused_webpack_exports, __webpack_require__) {
var castSlice = __webpack_require__(93084),
    hasUnicode = __webpack_require__(49520),
    stringToArray = __webpack_require__(97265),
    toString = __webpack_require__(36214);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


}),
19179: (function (module, __unused_webpack_exports, __webpack_require__) {
var arrayReduce = __webpack_require__(72607),
    deburr = __webpack_require__(23541),
    words = __webpack_require__(18067);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


}),
80727: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseIteratee = __webpack_require__(35462),
    isArrayLike = __webpack_require__(30508),
    keys = __webpack_require__(47361);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


}),
30914: (function (module, __unused_webpack_exports, __webpack_require__) {
var LodashWrapper = __webpack_require__(29675),
    flatRest = __webpack_require__(54502),
    getData = __webpack_require__(56007),
    getFuncName = __webpack_require__(20195),
    isArray = __webpack_require__(36377),
    isLaziable = __webpack_require__(46252);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) &&
            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && isLaziable(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

module.exports = createFlow;


}),
9530: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseInverter = __webpack_require__(7948);

/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */
function createInverter(setter, toIteratee) {
  return function(object, iteratee) {
    return baseInverter(object, setter, toIteratee(iteratee), {});
  };
}

module.exports = createInverter;


}),
9148: (function (module, __unused_webpack_exports, __webpack_require__) {
var basePropertyOf = __webpack_require__(64664);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


}),
59833: (function (module, __unused_webpack_exports, __webpack_require__) {
var getNative = __webpack_require__(40440);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


}),
34476: (function (module, __unused_webpack_exports, __webpack_require__) {
var SetCache = __webpack_require__(83290),
    arraySome = __webpack_require__(53955),
    cacheHas = __webpack_require__(52471);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


}),
29027: (function (module, __unused_webpack_exports, __webpack_require__) {
var Symbol = __webpack_require__(4886),
    Uint8Array = __webpack_require__(68965),
    eq = __webpack_require__(84071),
    equalArrays = __webpack_require__(34476),
    mapToArray = __webpack_require__(97170),
    setToArray = __webpack_require__(32779);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


}),
58714: (function (module, __unused_webpack_exports, __webpack_require__) {
var getAllKeys = __webpack_require__(43948);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


}),
62395: (function (module, __unused_webpack_exports, __webpack_require__) {
var basePropertyOf = __webpack_require__(64664);

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

module.exports = escapeHtmlChar;


}),
54502: (function (module, __unused_webpack_exports, __webpack_require__) {
var flatten = __webpack_require__(96380),
    overRest = __webpack_require__(16813),
    setToString = __webpack_require__(12413);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


}),
72593: (function (module, __unused_webpack_exports, __webpack_require__) {
/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


}),
43948: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseGetAllKeys = __webpack_require__(7743),
    getSymbols = __webpack_require__(26230),
    keys = __webpack_require__(47361);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


}),
19254: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseGetAllKeys = __webpack_require__(7743),
    getSymbolsIn = __webpack_require__(2992),
    keysIn = __webpack_require__(33747);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


}),
56007: (function (module, __unused_webpack_exports, __webpack_require__) {
var metaMap = __webpack_require__(50900),
    noop = __webpack_require__(6032);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


}),
20195: (function (module, __unused_webpack_exports, __webpack_require__) {
var realNames = __webpack_require__(58564);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


}),
51143: (function (module, __unused_webpack_exports, __webpack_require__) {
var isKeyable = __webpack_require__(46669);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


}),
47145: (function (module, __unused_webpack_exports, __webpack_require__) {
var isStrictComparable = __webpack_require__(81542),
    keys = __webpack_require__(47361);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


}),
40440: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseIsNative = __webpack_require__(40692),
    getValue = __webpack_require__(28974);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


}),
16095: (function (module, __unused_webpack_exports, __webpack_require__) {
var overArg = __webpack_require__(16512);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


}),
75118: (function (module, __unused_webpack_exports, __webpack_require__) {
var Symbol = __webpack_require__(4886);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


}),
26230: (function (module, __unused_webpack_exports, __webpack_require__) {
var arrayFilter = __webpack_require__(72654),
    stubArray = __webpack_require__(71036);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


}),
2992: (function (module, __unused_webpack_exports, __webpack_require__) {
var arrayPush = __webpack_require__(85741),
    getPrototype = __webpack_require__(16095),
    getSymbols = __webpack_require__(26230),
    stubArray = __webpack_require__(71036);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


}),
69937: (function (module, __unused_webpack_exports, __webpack_require__) {
var DataView = __webpack_require__(98172),
    Map = __webpack_require__(9036),
    Promise = __webpack_require__(60044),
    Set = __webpack_require__(66656),
    WeakMap = __webpack_require__(73283),
    baseGetTag = __webpack_require__(23757),
    toSource = __webpack_require__(61473);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


}),
28974: (function (module) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


}),
87635: (function (module, __unused_webpack_exports, __webpack_require__) {
var castPath = __webpack_require__(33835),
    isArguments = __webpack_require__(79732),
    isArray = __webpack_require__(36377),
    isIndex = __webpack_require__(89251),
    isLength = __webpack_require__(57924),
    toKey = __webpack_require__(78481);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


}),
49520: (function (module) {
/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


}),
49160: (function (module) {
/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


}),
87322: (function (module, __unused_webpack_exports, __webpack_require__) {
var nativeCreate = __webpack_require__(7305);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


}),
32937: (function (module) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


}),
207: (function (module, __unused_webpack_exports, __webpack_require__) {
var nativeCreate = __webpack_require__(7305);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


}),
2165: (function (module, __unused_webpack_exports, __webpack_require__) {
var nativeCreate = __webpack_require__(7305);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


}),
7523: (function (module, __unused_webpack_exports, __webpack_require__) {
var nativeCreate = __webpack_require__(7305);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


}),
60424: (function (module) {
/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


}),
93956: (function (module, __unused_webpack_exports, __webpack_require__) {
var cloneArrayBuffer = __webpack_require__(41029),
    cloneDataView = __webpack_require__(60551),
    cloneRegExp = __webpack_require__(16985),
    cloneSymbol = __webpack_require__(86584),
    cloneTypedArray = __webpack_require__(26739);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


}),
27608: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseCreate = __webpack_require__(45940),
    getPrototype = __webpack_require__(16095),
    isPrototype = __webpack_require__(88857);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


}),
11668: (function (module, __unused_webpack_exports, __webpack_require__) {
var Symbol = __webpack_require__(4886),
    isArguments = __webpack_require__(79732),
    isArray = __webpack_require__(36377);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


}),
89251: (function (module) {
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


}),
78693: (function (module, __unused_webpack_exports, __webpack_require__) {
var eq = __webpack_require__(84071),
    isArrayLike = __webpack_require__(30508),
    isIndex = __webpack_require__(89251),
    isObject = __webpack_require__(28532);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


}),
17074: (function (module, __unused_webpack_exports, __webpack_require__) {
var isArray = __webpack_require__(36377),
    isSymbol = __webpack_require__(61359);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


}),
46669: (function (module) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


}),
46252: (function (module, __unused_webpack_exports, __webpack_require__) {
var LazyWrapper = __webpack_require__(84281),
    getData = __webpack_require__(56007),
    getFuncName = __webpack_require__(20195),
    lodash = __webpack_require__(26985);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


}),
13417: (function (module, __unused_webpack_exports, __webpack_require__) {
var coreJsData = __webpack_require__(75772);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


}),
88857: (function (module) {
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


}),
81542: (function (module, __unused_webpack_exports, __webpack_require__) {
var isObject = __webpack_require__(28532);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


}),
97435: (function (module) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


}),
18438: (function (module, __unused_webpack_exports, __webpack_require__) {
var assocIndexOf = __webpack_require__(68357);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


}),
63067: (function (module, __unused_webpack_exports, __webpack_require__) {
var assocIndexOf = __webpack_require__(68357);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


}),
69679: (function (module, __unused_webpack_exports, __webpack_require__) {
var assocIndexOf = __webpack_require__(68357);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


}),
82426: (function (module, __unused_webpack_exports, __webpack_require__) {
var assocIndexOf = __webpack_require__(68357);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


}),
6409: (function (module, __unused_webpack_exports, __webpack_require__) {
var Hash = __webpack_require__(51796),
    ListCache = __webpack_require__(80283),
    Map = __webpack_require__(9036);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


}),
85335: (function (module, __unused_webpack_exports, __webpack_require__) {
var getMapData = __webpack_require__(51143);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


}),
35601: (function (module, __unused_webpack_exports, __webpack_require__) {
var getMapData = __webpack_require__(51143);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


}),
71533: (function (module, __unused_webpack_exports, __webpack_require__) {
var getMapData = __webpack_require__(51143);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


}),
20151: (function (module, __unused_webpack_exports, __webpack_require__) {
var getMapData = __webpack_require__(51143);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


}),
97170: (function (module) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


}),
64167: (function (module) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


}),
86141: (function (module, __unused_webpack_exports, __webpack_require__) {
var memoize = __webpack_require__(84984);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


}),
50900: (function (module, __unused_webpack_exports, __webpack_require__) {
var WeakMap = __webpack_require__(73283);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


}),
7305: (function (module, __unused_webpack_exports, __webpack_require__) {
var getNative = __webpack_require__(40440);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


}),
22440: (function (module, __unused_webpack_exports, __webpack_require__) {
var overArg = __webpack_require__(16512);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


}),
61308: (function (module) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


}),
20895: (function (module, exports, __webpack_require__) {
/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(72593);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


}),
77070: (function (module) {
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


}),
16512: (function (module) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


}),
16813: (function (module, __unused_webpack_exports, __webpack_require__) {
var apply = __webpack_require__(19198);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


}),
58564: (function (module) {
/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


}),
75238: (function (module, __unused_webpack_exports, __webpack_require__) {
var freeGlobal = __webpack_require__(72593);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


}),
1780: (function (module) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


}),
41760: (function (module) {
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


}),
75484: (function (module) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


}),
32779: (function (module) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


}),
12413: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseSetToString = __webpack_require__(62422),
    shortOut = __webpack_require__(87890);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


}),
87890: (function (module) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


}),
86063: (function (module, __unused_webpack_exports, __webpack_require__) {
var ListCache = __webpack_require__(80283);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


}),
27727: (function (module) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


}),
13281: (function (module) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


}),
66667: (function (module) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


}),
91270: (function (module, __unused_webpack_exports, __webpack_require__) {
var ListCache = __webpack_require__(80283),
    Map = __webpack_require__(9036),
    MapCache = __webpack_require__(24544);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


}),
66749: (function (module, __unused_webpack_exports, __webpack_require__) {
var asciiSize = __webpack_require__(50609),
    hasUnicode = __webpack_require__(49520),
    unicodeSize = __webpack_require__(59668);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

module.exports = stringSize;


}),
97265: (function (module, __unused_webpack_exports, __webpack_require__) {
var asciiToArray = __webpack_require__(69013),
    hasUnicode = __webpack_require__(49520),
    unicodeToArray = __webpack_require__(68334);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


}),
78997: (function (module, __unused_webpack_exports, __webpack_require__) {
var memoizeCapped = __webpack_require__(86141);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


}),
78481: (function (module, __unused_webpack_exports, __webpack_require__) {
var isSymbol = __webpack_require__(61359);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


}),
61473: (function (module) {
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


}),
73230: (function (module) {
/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


}),
99477: (function (module, __unused_webpack_exports, __webpack_require__) {
var basePropertyOf = __webpack_require__(64664);

/** Used to map HTML entities to characters. */
var htmlUnescapes = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'"
};

/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */
var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

module.exports = unescapeHtmlChar;


}),
59668: (function (module) {
/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

module.exports = unicodeSize;


}),
68334: (function (module) {
/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


}),
5957: (function (module) {
/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


}),
219: (function (module, __unused_webpack_exports, __webpack_require__) {
var LazyWrapper = __webpack_require__(84281),
    LodashWrapper = __webpack_require__(29675),
    copyArray = __webpack_require__(38606);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


}),
56034: (function (module, __unused_webpack_exports, __webpack_require__) {
var capitalize = __webpack_require__(44511),
    createCompounder = __webpack_require__(19179);

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

module.exports = camelCase;


}),
44511: (function (module, __unused_webpack_exports, __webpack_require__) {
var toString = __webpack_require__(36214),
    upperFirst = __webpack_require__(14943);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


}),
43789: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseClamp = __webpack_require__(52009),
    toNumber = __webpack_require__(96127);

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = toNumber(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = toNumber(lower);
    lower = lower === lower ? lower : 0;
  }
  return baseClamp(toNumber(number), lower, upper);
}

module.exports = clamp;


}),
37252: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseClone = __webpack_require__(66512);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


}),
25055: (function (module) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


}),
18305: (function (module, __unused_webpack_exports, __webpack_require__) {
var isObject = __webpack_require__(28532),
    now = __webpack_require__(70806),
    toNumber = __webpack_require__(96127);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


}),
23541: (function (module, __unused_webpack_exports, __webpack_require__) {
var deburrLetter = __webpack_require__(9148),
    toString = __webpack_require__(36214);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


}),
34075: (function (module) {
/**
 * Checks `value` to determine whether a default value should be returned in
 * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
 * or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.14.0
 * @category Util
 * @param {*} value The value to check.
 * @param {*} defaultValue The default value.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * _.defaultTo(1, 10);
 * // => 1
 *
 * _.defaultTo(undefined, 10);
 * // => 10
 */
function defaultTo(value, defaultValue) {
  return (value == null || value !== value) ? defaultValue : value;
}

module.exports = defaultTo;


}),
84071: (function (module) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


}),
28929: (function (module, __unused_webpack_exports, __webpack_require__) {
var escapeHtmlChar = __webpack_require__(62395),
    toString = __webpack_require__(36214);

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"']/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/**
 * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
 * corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape(string) {
  string = toString(string);
  return (string && reHasUnescapedHtml.test(string))
    ? string.replace(reUnescapedHtml, escapeHtmlChar)
    : string;
}

module.exports = escape;


}),
19777: (function (module, __unused_webpack_exports, __webpack_require__) {
var createFind = __webpack_require__(80727),
    findIndex = __webpack_require__(33142);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


}),
33142: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseFindIndex = __webpack_require__(82056),
    baseIteratee = __webpack_require__(35462),
    toInteger = __webpack_require__(8536);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


}),
45720: (function (module, __unused_webpack_exports, __webpack_require__) {
var createFind = __webpack_require__(80727),
    findLastIndex = __webpack_require__(23758);

/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */
var findLast = createFind(findLastIndex);

module.exports = findLast;


}),
23758: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseFindIndex = __webpack_require__(82056),
    baseIteratee = __webpack_require__(35462),
    toInteger = __webpack_require__(8536);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */
function findLastIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length - 1;
  if (fromIndex !== undefined) {
    index = toInteger(fromIndex);
    index = fromIndex < 0
      ? nativeMax(length + index, 0)
      : nativeMin(index, length - 1);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index, true);
}

module.exports = findLastIndex;


}),
96380: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseFlatten = __webpack_require__(25265);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


}),
85801: (function (module, __unused_webpack_exports, __webpack_require__) {
var createFlow = __webpack_require__(30914);

/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */
var flow = createFlow();

module.exports = flow;


}),
32397: (function (module, __unused_webpack_exports, __webpack_require__) {
var arrayEach = __webpack_require__(74970),
    baseEach = __webpack_require__(48264),
    castFunction = __webpack_require__(28269),
    isArray = __webpack_require__(36377);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


}),
24738: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseGet = __webpack_require__(11957);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


}),
29290: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseHasIn = __webpack_require__(66993),
    hasPath = __webpack_require__(87635);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


}),
21622: (function (module) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


}),
61576: (function (module, __unused_webpack_exports, __webpack_require__) {
var constant = __webpack_require__(25055),
    createInverter = __webpack_require__(9530),
    identity = __webpack_require__(21622);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */
var invert = createInverter(function(result, value, key) {
  if (value != null &&
      typeof value.toString != 'function') {
    value = nativeObjectToString.call(value);
  }

  result[value] = key;
}, constant(identity));

module.exports = invert;


}),
79732: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseIsArguments = __webpack_require__(50841),
    isObjectLike = __webpack_require__(27013);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


}),
36377: (function (module) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


}),
30508: (function (module, __unused_webpack_exports, __webpack_require__) {
var isFunction = __webpack_require__(56644),
    isLength = __webpack_require__(57924);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


}),
50753: (function (module, __unused_webpack_exports, __webpack_require__) {
var isArrayLike = __webpack_require__(30508),
    isObjectLike = __webpack_require__(27013);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


}),
81247: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseGetTag = __webpack_require__(23757),
    isObjectLike = __webpack_require__(27013);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

module.exports = isBoolean;


}),
26018: (function (module, exports, __webpack_require__) {
/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(75238),
    stubFalse = __webpack_require__(65786);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


}),
86633: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseKeys = __webpack_require__(57407),
    getTag = __webpack_require__(69937),
    isArguments = __webpack_require__(79732),
    isArray = __webpack_require__(36377),
    isArrayLike = __webpack_require__(30508),
    isBuffer = __webpack_require__(26018),
    isPrototype = __webpack_require__(88857),
    isTypedArray = __webpack_require__(58586);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


}),
56644: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseGetTag = __webpack_require__(23757),
    isObject = __webpack_require__(28532);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


}),
80023: (function (module, __unused_webpack_exports, __webpack_require__) {
var toInteger = __webpack_require__(8536);

/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == toInteger(value);
}

module.exports = isInteger;


}),
57924: (function (module) {
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


}),
14986: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseIsMap = __webpack_require__(10518),
    baseUnary = __webpack_require__(57509),
    nodeUtil = __webpack_require__(20895);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


}),
91464: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseGetTag = __webpack_require__(23757),
    isObjectLike = __webpack_require__(27013);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


}),
28532: (function (module) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


}),
27013: (function (module) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


}),
41968: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseGetTag = __webpack_require__(23757),
    getPrototype = __webpack_require__(16095),
    isObjectLike = __webpack_require__(27013);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


}),
87975: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseIsSet = __webpack_require__(70185),
    baseUnary = __webpack_require__(57509),
    nodeUtil = __webpack_require__(20895);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


}),
81098: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseGetTag = __webpack_require__(23757),
    isArray = __webpack_require__(36377),
    isObjectLike = __webpack_require__(27013);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


}),
61359: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseGetTag = __webpack_require__(23757),
    isObjectLike = __webpack_require__(27013);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


}),
58586: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseIsTypedArray = __webpack_require__(42195),
    baseUnary = __webpack_require__(57509),
    nodeUtil = __webpack_require__(20895);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


}),
3350: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseAssignValue = __webpack_require__(12676),
    createAggregator = __webpack_require__(32297);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;


}),
47361: (function (module, __unused_webpack_exports, __webpack_require__) {
var arrayLikeKeys = __webpack_require__(94979),
    baseKeys = __webpack_require__(57407),
    isArrayLike = __webpack_require__(30508);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


}),
33747: (function (module, __unused_webpack_exports, __webpack_require__) {
var arrayLikeKeys = __webpack_require__(94979),
    baseKeysIn = __webpack_require__(79237),
    isArrayLike = __webpack_require__(30508);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


}),
53729: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseAssignValue = __webpack_require__(12676),
    baseForOwn = __webpack_require__(93406),
    baseIteratee = __webpack_require__(35462);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


}),
84984: (function (module, __unused_webpack_exports, __webpack_require__) {
var MapCache = __webpack_require__(24544);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


}),
90139: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseMerge = __webpack_require__(50222),
    createAssigner = __webpack_require__(61826);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


}),
93794: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseMerge = __webpack_require__(50222),
    createAssigner = __webpack_require__(61826);

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;


}),
23103: (function (module) {
/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

module.exports = negate;


}),
6032: (function (module) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


}),
70806: (function (module, __unused_webpack_exports, __webpack_require__) {
var root = __webpack_require__(75238);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


}),
13452: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseIteratee = __webpack_require__(35462),
    negate = __webpack_require__(23103),
    pickBy = __webpack_require__(74103);

/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return pickBy(object, negate(baseIteratee(predicate)));
}

module.exports = omitBy;


}),
74103: (function (module, __unused_webpack_exports, __webpack_require__) {
var arrayMap = __webpack_require__(21098),
    baseIteratee = __webpack_require__(35462),
    basePickBy = __webpack_require__(77100),
    getAllKeysIn = __webpack_require__(19254);

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;


}),
78303: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseProperty = __webpack_require__(92726),
    basePropertyDeep = __webpack_require__(21374),
    isKey = __webpack_require__(17074),
    toKey = __webpack_require__(78481);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


}),
51455: (function (module, __unused_webpack_exports, __webpack_require__) {
var arrayReduce = __webpack_require__(72607),
    baseEach = __webpack_require__(48264),
    baseIteratee = __webpack_require__(35462),
    baseReduce = __webpack_require__(39864),
    isArray = __webpack_require__(36377);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


}),
64659: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseKeys = __webpack_require__(57407),
    getTag = __webpack_require__(69937),
    isArrayLike = __webpack_require__(30508),
    isString = __webpack_require__(81098),
    stringSize = __webpack_require__(66749);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  if (collection == null) {
    return 0;
  }
  if (isArrayLike(collection)) {
    return isString(collection) ? stringSize(collection) : collection.length;
  }
  var tag = getTag(collection);
  if (tag == mapTag || tag == setTag) {
    return collection.size;
  }
  return baseKeys(collection).length;
}

module.exports = size;


}),
71036: (function (module) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


}),
65786: (function (module) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


}),
35082: (function (module, __unused_webpack_exports, __webpack_require__) {
var debounce = __webpack_require__(18305),
    isObject = __webpack_require__(28532);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


}),
95597: (function (module, __unused_webpack_exports, __webpack_require__) {
var toNumber = __webpack_require__(96127);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


}),
8536: (function (module, __unused_webpack_exports, __webpack_require__) {
var toFinite = __webpack_require__(95597);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


}),
96127: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseTrim = __webpack_require__(1072),
    isObject = __webpack_require__(28532),
    isSymbol = __webpack_require__(61359);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


}),
57132: (function (module, __unused_webpack_exports, __webpack_require__) {
var copyObject = __webpack_require__(68284),
    keysIn = __webpack_require__(33747);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


}),
36214: (function (module, __unused_webpack_exports, __webpack_require__) {
var baseToString = __webpack_require__(99653);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


}),
16089: (function (module, __unused_webpack_exports, __webpack_require__) {
var arrayEach = __webpack_require__(74970),
    baseCreate = __webpack_require__(45940),
    baseForOwn = __webpack_require__(93406),
    baseIteratee = __webpack_require__(35462),
    getPrototype = __webpack_require__(16095),
    isArray = __webpack_require__(36377),
    isBuffer = __webpack_require__(26018),
    isFunction = __webpack_require__(56644),
    isObject = __webpack_require__(28532),
    isTypedArray = __webpack_require__(58586);

/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */
function transform(object, iteratee, accumulator) {
  var isArr = isArray(object),
      isArrLike = isArr || isBuffer(object) || isTypedArray(object);

  iteratee = baseIteratee(iteratee, 4);
  if (accumulator == null) {
    var Ctor = object && object.constructor;
    if (isArrLike) {
      accumulator = isArr ? new Ctor : [];
    }
    else if (isObject(object)) {
      accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
    }
    else {
      accumulator = {};
    }
  }
  (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
    return iteratee(accumulator, value, index, object);
  });
  return accumulator;
}

module.exports = transform;


}),
94891: (function (module, __unused_webpack_exports, __webpack_require__) {
var toString = __webpack_require__(36214),
    unescapeHtmlChar = __webpack_require__(99477);

/** Used to match HTML entities and HTML characters. */
var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
    reHasEscapedHtml = RegExp(reEscapedHtml.source);

/**
 * The inverse of `_.escape`; this method converts the HTML entities
 * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
 * their corresponding characters.
 *
 * **Note:** No other HTML entities are unescaped. To unescape additional
 * HTML entities use a third-party library like [_he_](https://mths.be/he).
 *
 * @static
 * @memberOf _
 * @since 0.6.0
 * @category String
 * @param {string} [string=''] The string to unescape.
 * @returns {string} Returns the unescaped string.
 * @example
 *
 * _.unescape('fred, barney, &amp; pebbles');
 * // => 'fred, barney, & pebbles'
 */
function unescape(string) {
  string = toString(string);
  return (string && reHasEscapedHtml.test(string))
    ? string.replace(reEscapedHtml, unescapeHtmlChar)
    : string;
}

module.exports = unescape;


}),
14943: (function (module, __unused_webpack_exports, __webpack_require__) {
var createCaseFirst = __webpack_require__(19978);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


}),
18067: (function (module, __unused_webpack_exports, __webpack_require__) {
var asciiWords = __webpack_require__(30782),
    hasUnicodeWord = __webpack_require__(49160),
    toString = __webpack_require__(36214),
    unicodeWords = __webpack_require__(5957);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


}),
26985: (function (module, __unused_webpack_exports, __webpack_require__) {
var LazyWrapper = __webpack_require__(84281),
    LodashWrapper = __webpack_require__(29675),
    baseLodash = __webpack_require__(64382),
    isArray = __webpack_require__(36377),
    isObjectLike = __webpack_require__(27013),
    wrapperClone = __webpack_require__(219);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


}),
97660: (function (module) {
"use strict";


/** @type {import('./abs')} */
module.exports = Math.abs;


}),
28041: (function (module) {
"use strict";


/** @type {import('./floor')} */
module.exports = Math.floor;


}),
99273: (function (module) {
"use strict";


/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


}),
10475: (function (module) {
"use strict";


/** @type {import('./max')} */
module.exports = Math.max;


}),
4126: (function (module) {
"use strict";


/** @type {import('./min')} */
module.exports = Math.min;


}),
1054: (function (module) {
"use strict";


/** @type {import('./pow')} */
module.exports = Math.pow;


}),
19946: (function (module) {
"use strict";


/** @type {import('./round')} */
module.exports = Math.round;


}),
8035: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";


var $isNaN = __webpack_require__(99273);

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};


}),
47636: (function (module, __unused_webpack_exports, __webpack_require__) {
var moment = module.exports = __webpack_require__(13597);
moment.tz.load(__webpack_require__(94530));


}),
13597: (function (module, __unused_webpack_exports, __webpack_require__) {
//! moment-timezone.js
//! version : 0.5.31
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if ( true && module.exports) {
		module.exports = factory(__webpack_require__(72450)); // Node
	} else if (typeof define === 'function' && define.amd) {
		define(['moment'], factory);                 // AMD
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Resolves es6 module loading issue
	if (moment.version === undefined && moment.default) {
		moment = moment.default;
	}

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.31",
		zones = {},
		links = {},
		countries = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		countries : function () {
			var zone_name = this.name;
			return Object.keys(countries).filter(function (country_code) {
				return countries[country_code].zones.indexOf(zone_name) !== -1;
			});
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Country object
	************************************/

	function Country (country_name, zone_names) {
		this.name = country_name;
		this.zones = zone_names;
	}

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function getCountryNames () {
		return Object.keys(countries);
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function addCountries (data) {
		var i, country_code, country_zones, split;
		if (!data || !data.length) return;
		for (i = 0; i < data.length; i++) {
			split = data[i].split('|');
			country_code = split[0].toUpperCase();
			country_zones = split[1].split(' ');
			countries[country_code] = new Country(
				country_code,
				country_zones
			);
		}
	}

	function getCountry (name) {
		name = name.toUpperCase();
		return countries[name] || null;
	}

	function zonesForCountry(country, with_offset) {
		country = getCountry(country);

		if (!country) return null;

		var zones = country.zones.sort();

		if (with_offset) {
			return zones.map(function (zone_name) {
				var zone = getZone(zone_name);
				return {
					name: zone_name,
					offset: zone.utcOffset(new Date())
				};
			});
		}

		return zones;
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		addCountries(data.countries);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz._countries	= countries;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;
	tz.countries    = getCountryNames;
	tz.zonesForCountry = zonesForCountry;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


}),
44445: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    return af;

})));


}),
30230: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arDz;

})));


}),
37885: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arKw;

})));


}),
18449: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Arabic (Libya) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arLy;

})));


}),
30721: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arMa;

})));


}),
39707: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arSa;

})));


}),
79625: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arTn;

})));


}),
8779: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ar;

})));


}),
84507: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays:
            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
                '_'
            ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return az;

})));


}),
91008: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone:
                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                    '_'
                ),
        },
        monthsShort:
            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone:
                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                    '_'
                ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return be;

})));


}),
1574: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bg;

})));


}),
60821: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return bm;

})));


}),
3012: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bnBd = moment.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bnBd;

})));


}),
92129: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bn;

})));


}),
64080: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort:
            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
                '_'
            ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays:
            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
                '_'
            ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bo;

})));


}),
77473: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex =
            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    return br;

})));


}),
87110: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bs;

})));


}),
43008: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone:
                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                    '_'
                ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
                '_'
            ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ca;

})));


}),
20743: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = {
            format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
                '_'
            ),
            standalone:
                'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
                    '_'
                ),
        },
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex =
            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex:
            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex:
            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cs;

})));


}),
35233: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays:
            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
                '_'
            ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                    ? 'тан'
                    : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return cv;

})));


}),
24880: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays:
            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
                '_'
            ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cy;

})));


}),
76103: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return da;

})));


}),
54828: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deAt;

})));


}),
98941: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deCh;

})));


}),
2781: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


}),
22699: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return dv;

})));


}),
45997: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl:
            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
                '_'
            ),
        monthsGenitiveEl:
            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
                '_'
            ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    return el;

})));


}),
94829: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));


}),
83136: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enCa;

})));


}),
55266: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));


}),
69585: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));


}),
4793: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enIl;

})));


}),
79131: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return enIn;

})));


}),
19192: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enNz;

})));


}),
65831: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enSg;

})));


}),
8923: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eo;

})));


}),
84268: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return esDo;

})));


}),
58594: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esMx = moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return esMx;

})));


}),
1742: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return esUs;

})));


}),
3905: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


}),
87344: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort:
            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays:
            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
                '_'
            ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return et;

})));


}),
68732: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort:
            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
                '_'
            ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eu;

})));


}),
33074: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort:
            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
                '_'
            ),
        weekdays:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysShort:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return fa;

})));


}),
22266: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersPast =
            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
                ' '
            ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort:
            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
                '_'
            ),
        weekdays:
            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
                '_'
            ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fi;

})));


}),
29030: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fil;

})));


}),
51062: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays:
            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fo;

})));


}),
50255: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));


}),
4946: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return frCh;

})));


}),
21115: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex =
            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


}),
738: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fy;

})));


}),
23555: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ga;

})));


}),
62064: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gd;

})));


}),
69906: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort:
            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gl;

})));


}),
47743: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone:
                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                    '_'
                ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    return gomDeva;

})));


}),
8219: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone:
                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                    '_'
                ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    return gomLatn;

})));


}),
47324: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort:
            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return gu;

})));


}),
44376: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort:
            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse:
            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    return he;

})));


}),
70525: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    var hi = moment.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone:
                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                    '_'
                ),
        },
        monthsShort:
            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: shortMonthsParse,

        monthsRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex:
            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex:
            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return hi;

})));


}),
74953: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone:
                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                    '_'
                ),
        },
        monthsShort:
            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hr;

})));


}),
77162: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var weekEndings =
        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return hu;

})));


}),
8269: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone:
                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                    '_'
                ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays:
            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
                '_'
            ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hyAm;

})));


}),
56133: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return id;

})));


}),
34248: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays:
            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return is;

})));


}),
37968: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return itCh;

})));


}),
5432: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


}),
60605: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    return ja;

})));


}),
12073: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return jv;

})));


}),
99208: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone:
                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                    '_'
                ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(
                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
                    function ($0, $1, $2) {
                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                    }
                );
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    return ka;

})));


}),
70357: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return kk;

})));


}),
68406: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort:
            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
                '_'
            ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return km;

})));


}),
58094: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort:
            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return kn;

})));


}),
52755: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


}),
36091: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays:
            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
                '_'
            ),
        weekdaysShort:
            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ku;

})));


}),
51121: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ky;

})));


}),
9323: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
                '_'
            ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lb;

})));


}),
68017: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort:
            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
                '_'
            ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    return lo;

})));


}),
28422: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
            ? forms(key)[1]
            : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone:
                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                    '_'
                ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone:
                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                    '_'
                ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lt;

})));


}),
42078: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays:
            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
                '_'
            ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lv;

})));


}),
825: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return me;

})));


}),
41773: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort:
            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
                '_'
            ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mi;

})));


}),
60775: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return mk;

})));


}),
13727: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort:
            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
                '_'
            ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    return ml;

})));


}),
97445: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort:
            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    return mn;

})));


}),
78969: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort:
            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return mr;

})));


}),
32178: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return msMy;

})));


}),
26092: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ms;

})));


}),
80909: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays:
            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
                '_'
            ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mt;

})));


}),
98378: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return my;

})));


}),
46463: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dager',
            w: 'en uke',
            ww: '%d uker',
            M: 'en måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nb;

})));


}),
89333: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort:
            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ne;

})));


}),
87496: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nlBe;

})));


}),
64212: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


}),
81250: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nn;

})));


}),
1728: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone:
                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                    '_'
                ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    return ocLnc;

})));


}),
82338: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort:
            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
                '_'
            ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return paIn;

})));


}),
25586: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsNominative =
            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
                '_'
            ),
        monthsSubjective =
            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
                '_'
            ),
        monthsParse = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays:
            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate,
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pl;

})));


}),
63124: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
                '_'
            ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    return ptBr;

})));


}),
56166: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
                '_'
            ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


}),
84715: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort:
            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            w: 'o săptămână',
            ww: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ro;

})));


}),
59599: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone:
                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                    '_'
                ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone:
                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                    '_'
                ),
        },
        weekdays: {
            standalone:
                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                    '_'
                ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex:
            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex:
            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ru;

})));


}),
86592: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sd;

})));


}),
48916: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort:
            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays:
            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
                '_'
            ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return se;

})));


}),
84228: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays:
            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
                '_'
            ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    return si;

})));


}),
17819: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months =
            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
                '_'
            ),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sk;

})));


}),
50786: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sl;

})));


}),
4905: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sq;

})));


}),
47955: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једног минута'],
            mm: ['минут', 'минута', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            d: ['један дан', 'једног дана'],
            dd: ['дан', 'дана', 'дана'],
            M: ['један месец', 'једног месеца'],
            MM: ['месец', 'месеца', 'месеци'],
            y: ['једну годину', 'једне године'],
            yy: ['годину', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'једна година';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'годину') {
                return number + ' година';
            }

            return number + ' ' + word;
        },
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort:
            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return srCyrl;

})));


}),
15478: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            d: ['jedan dan', 'jednog dana'],
            dd: ['dan', 'dana', 'dana'],
            M: ['jedan mesec', 'jednog meseca'],
            MM: ['mesec', 'meseca', 'meseci'],
            y: ['jednu godinu', 'jedne godine'],
            yy: ['godinu', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'jedna godina';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'godinu') {
                return number + ' godina';
            }

            return number + ' ' + word;
        },
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sr;

})));


}),
43220: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays:
            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
                '_'
            ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ss;

})));


}),
22591: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                        ? ':a'
                        : b === 2
                        ? ':a'
                        : b === 3
                        ? ':e'
                        : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sv;

})));


}),
42626: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays:
            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
                '_'
            ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sw;

})));


}),
59138: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort:
            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
                '_'
            ),
        weekdays:
            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
                '_'
            ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ta;

})));


}),
91821: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort:
            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
                '_'
            ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return te;

})));


}),
53034: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tet;

})));


}),
61561: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone:
                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                    '_'
                ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    return tg;

})));


}),
20370: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort:
            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    return th;

})));


}),
48113: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    var tk = moment.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tk;

})));


}),
97743: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlPh;

})));


}),
85970: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'waQ'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'nem'
                : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'wen'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'ben'
                : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort:
            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlh;

})));


}),
16267: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tr;

})));


}),
42925: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
            ? format[key][0]
            : format[key][1];
    }

    return tzl;

})));


}),
73987: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort:
            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
                '_'
            ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzmLatn;

})));


}),
13483: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort:
            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
                '_'
            ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzm;

})));


}),
2433: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort:
            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
                '_'
            ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return ugCn;

})));


}),
7451: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative:
                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                        '_'
                    ),
                accusative:
                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                        '_'
                    ),
                genitive:
                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                        '_'
                    ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
            ? 'genitive'
            : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone:
                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                    '_'
                ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uk;

})));


}),
30097: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ur;

})));


}),
41928: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays:
            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
                '_'
            ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uzLatn;

})));


}),
24174: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return uz;

})));


}),
73780: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort:
            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return vi;

})));


}),
10391: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort:
            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
                '_'
            ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return xPseudo;

})));


}),
35775: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return yo;

})));


}),
20635: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return zhCn;

})));


}),
84000: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhHk;

})));


}),
30360: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhMo;

})));


}),
64314: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(72450)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


}),
12372: (function (module, __unused_webpack_exports, __webpack_require__) {
var map = {
  "./af": "44445",
  "./af.js": "44445",
  "./ar": "8779",
  "./ar-dz": "30230",
  "./ar-dz.js": "30230",
  "./ar-kw": "37885",
  "./ar-kw.js": "37885",
  "./ar-ly": "18449",
  "./ar-ly.js": "18449",
  "./ar-ma": "30721",
  "./ar-ma.js": "30721",
  "./ar-sa": "39707",
  "./ar-sa.js": "39707",
  "./ar-tn": "79625",
  "./ar-tn.js": "79625",
  "./ar.js": "8779",
  "./az": "84507",
  "./az.js": "84507",
  "./be": "91008",
  "./be.js": "91008",
  "./bg": "1574",
  "./bg.js": "1574",
  "./bm": "60821",
  "./bm.js": "60821",
  "./bn": "92129",
  "./bn-bd": "3012",
  "./bn-bd.js": "3012",
  "./bn.js": "92129",
  "./bo": "64080",
  "./bo.js": "64080",
  "./br": "77473",
  "./br.js": "77473",
  "./bs": "87110",
  "./bs.js": "87110",
  "./ca": "43008",
  "./ca.js": "43008",
  "./cs": "20743",
  "./cs.js": "20743",
  "./cv": "35233",
  "./cv.js": "35233",
  "./cy": "24880",
  "./cy.js": "24880",
  "./da": "76103",
  "./da.js": "76103",
  "./de": "2781",
  "./de-at": "54828",
  "./de-at.js": "54828",
  "./de-ch": "98941",
  "./de-ch.js": "98941",
  "./de.js": "2781",
  "./dv": "22699",
  "./dv.js": "22699",
  "./el": "45997",
  "./el.js": "45997",
  "./en-au": "94829",
  "./en-au.js": "94829",
  "./en-ca": "83136",
  "./en-ca.js": "83136",
  "./en-gb": "55266",
  "./en-gb.js": "55266",
  "./en-ie": "69585",
  "./en-ie.js": "69585",
  "./en-il": "4793",
  "./en-il.js": "4793",
  "./en-in": "79131",
  "./en-in.js": "79131",
  "./en-nz": "19192",
  "./en-nz.js": "19192",
  "./en-sg": "65831",
  "./en-sg.js": "65831",
  "./eo": "8923",
  "./eo.js": "8923",
  "./es": "3905",
  "./es-do": "84268",
  "./es-do.js": "84268",
  "./es-mx": "58594",
  "./es-mx.js": "58594",
  "./es-us": "1742",
  "./es-us.js": "1742",
  "./es.js": "3905",
  "./et": "87344",
  "./et.js": "87344",
  "./eu": "68732",
  "./eu.js": "68732",
  "./fa": "33074",
  "./fa.js": "33074",
  "./fi": "22266",
  "./fi.js": "22266",
  "./fil": "29030",
  "./fil.js": "29030",
  "./fo": "51062",
  "./fo.js": "51062",
  "./fr": "21115",
  "./fr-ca": "50255",
  "./fr-ca.js": "50255",
  "./fr-ch": "4946",
  "./fr-ch.js": "4946",
  "./fr.js": "21115",
  "./fy": "738",
  "./fy.js": "738",
  "./ga": "23555",
  "./ga.js": "23555",
  "./gd": "62064",
  "./gd.js": "62064",
  "./gl": "69906",
  "./gl.js": "69906",
  "./gom-deva": "47743",
  "./gom-deva.js": "47743",
  "./gom-latn": "8219",
  "./gom-latn.js": "8219",
  "./gu": "47324",
  "./gu.js": "47324",
  "./he": "44376",
  "./he.js": "44376",
  "./hi": "70525",
  "./hi.js": "70525",
  "./hr": "74953",
  "./hr.js": "74953",
  "./hu": "77162",
  "./hu.js": "77162",
  "./hy-am": "8269",
  "./hy-am.js": "8269",
  "./id": "56133",
  "./id.js": "56133",
  "./is": "34248",
  "./is.js": "34248",
  "./it": "5432",
  "./it-ch": "37968",
  "./it-ch.js": "37968",
  "./it.js": "5432",
  "./ja": "60605",
  "./ja.js": "60605",
  "./jv": "12073",
  "./jv.js": "12073",
  "./ka": "99208",
  "./ka.js": "99208",
  "./kk": "70357",
  "./kk.js": "70357",
  "./km": "68406",
  "./km.js": "68406",
  "./kn": "58094",
  "./kn.js": "58094",
  "./ko": "52755",
  "./ko.js": "52755",
  "./ku": "36091",
  "./ku.js": "36091",
  "./ky": "51121",
  "./ky.js": "51121",
  "./lb": "9323",
  "./lb.js": "9323",
  "./lo": "68017",
  "./lo.js": "68017",
  "./lt": "28422",
  "./lt.js": "28422",
  "./lv": "42078",
  "./lv.js": "42078",
  "./me": "825",
  "./me.js": "825",
  "./mi": "41773",
  "./mi.js": "41773",
  "./mk": "60775",
  "./mk.js": "60775",
  "./ml": "13727",
  "./ml.js": "13727",
  "./mn": "97445",
  "./mn.js": "97445",
  "./mr": "78969",
  "./mr.js": "78969",
  "./ms": "26092",
  "./ms-my": "32178",
  "./ms-my.js": "32178",
  "./ms.js": "26092",
  "./mt": "80909",
  "./mt.js": "80909",
  "./my": "98378",
  "./my.js": "98378",
  "./nb": "46463",
  "./nb.js": "46463",
  "./ne": "89333",
  "./ne.js": "89333",
  "./nl": "64212",
  "./nl-be": "87496",
  "./nl-be.js": "87496",
  "./nl.js": "64212",
  "./nn": "81250",
  "./nn.js": "81250",
  "./oc-lnc": "1728",
  "./oc-lnc.js": "1728",
  "./pa-in": "82338",
  "./pa-in.js": "82338",
  "./pl": "25586",
  "./pl.js": "25586",
  "./pt": "56166",
  "./pt-br": "63124",
  "./pt-br.js": "63124",
  "./pt.js": "56166",
  "./ro": "84715",
  "./ro.js": "84715",
  "./ru": "59599",
  "./ru.js": "59599",
  "./sd": "86592",
  "./sd.js": "86592",
  "./se": "48916",
  "./se.js": "48916",
  "./si": "84228",
  "./si.js": "84228",
  "./sk": "17819",
  "./sk.js": "17819",
  "./sl": "50786",
  "./sl.js": "50786",
  "./sq": "4905",
  "./sq.js": "4905",
  "./sr": "15478",
  "./sr-cyrl": "47955",
  "./sr-cyrl.js": "47955",
  "./sr.js": "15478",
  "./ss": "43220",
  "./ss.js": "43220",
  "./sv": "22591",
  "./sv.js": "22591",
  "./sw": "42626",
  "./sw.js": "42626",
  "./ta": "59138",
  "./ta.js": "59138",
  "./te": "91821",
  "./te.js": "91821",
  "./tet": "53034",
  "./tet.js": "53034",
  "./tg": "61561",
  "./tg.js": "61561",
  "./th": "20370",
  "./th.js": "20370",
  "./tk": "48113",
  "./tk.js": "48113",
  "./tl-ph": "97743",
  "./tl-ph.js": "97743",
  "./tlh": "85970",
  "./tlh.js": "85970",
  "./tr": "16267",
  "./tr.js": "16267",
  "./tzl": "42925",
  "./tzl.js": "42925",
  "./tzm": "13483",
  "./tzm-latn": "73987",
  "./tzm-latn.js": "73987",
  "./tzm.js": "13483",
  "./ug-cn": "2433",
  "./ug-cn.js": "2433",
  "./uk": "7451",
  "./uk.js": "7451",
  "./ur": "30097",
  "./ur.js": "30097",
  "./uz": "24174",
  "./uz-latn": "41928",
  "./uz-latn.js": "41928",
  "./uz.js": "24174",
  "./vi": "73780",
  "./vi.js": "73780",
  "./x-pseudo": "10391",
  "./x-pseudo.js": "10391",
  "./yo": "35775",
  "./yo.js": "35775",
  "./zh-cn": "20635",
  "./zh-cn.js": "20635",
  "./zh-hk": "84000",
  "./zh-hk.js": "84000",
  "./zh-mo": "30360",
  "./zh-mo.js": "30360",
  "./zh-tw": "64314",
  "./zh-tw.js": "64314"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12372;


}),
72450: (function (module, __unused_webpack_exports, __webpack_require__) {
/* module decorator */ module = __webpack_require__.nmd(module);
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    0
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            'object' !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = undefined;
                __webpack_require__(12372)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.4';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));


}),
89242: (function (module, __unused_webpack_exports, __webpack_require__) {
var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(2292);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof __webpack_require__.g !== 'undefined' && obj === __webpack_require__.g)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function canTrustToString(obj) {
    return !toStringTag || !(typeof obj === 'object' && (toStringTag in obj || typeof obj[toStringTag] !== 'undefined'));
}
function isArray(obj) { return toStr(obj) === '[object Array]' && canTrustToString(obj); }
function isDate(obj) { return toStr(obj) === '[object Date]' && canTrustToString(obj); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && canTrustToString(obj); }
function isError(obj) { return toStr(obj) === '[object Error]' && canTrustToString(obj); }
function isString(obj) { return toStr(obj) === '[object String]' && canTrustToString(obj); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && canTrustToString(obj); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && canTrustToString(obj); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


}),
67304: (function (__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {
"use strict";

;// CONCATENATED MODULE: ../../app/node_modules/promise-polyfill/src/finally.js
/* ESM default export */ function src_finally(callback) {
  var constructor = this.constructor;
  return this.then(
    function(value) {
      return constructor.resolve(callback()).then(function() {
        return value;
      });
    },
    function(reason) {
      return constructor.resolve(callback()).then(function() {
        return constructor.reject(reason);
      });
    }
  );
}

;// CONCATENATED MODULE: ../../app/node_modules/promise-polyfill/src/index.js


// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

function Promise(fn) {
  if (!(this instanceof Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  this._state = 0;
  this._handled = false;
  this._value = undefined;
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? src_resolve : src_reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      src_reject(deferred.promise, e);
      return;
    }
    src_resolve(deferred.promise, ret);
  });
}

function src_resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    src_reject(self, e);
  }
}

function src_reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function() {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        src_resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        src_reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    src_reject(self, ex);
  }
}

Promise.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

Promise.prototype.then = function(onFulfilled, onRejected) {
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.prototype['finally'] = src_finally;

Promise.all = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!arr || typeof arr.length === 'undefined')
      throw new TypeError('Promise.all accepts an array');
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function(resolve) {
    resolve(value);
  });
};

Promise.reject = function(value) {
  return new Promise(function(resolve, reject) {
    reject(value);
  });
};

Promise.race = function(values) {
  return new Promise(function(resolve, reject) {
    for (var i = 0, len = values.length; i < len; i++) {
      values[i].then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn =
  (typeof setImmediate === 'function' &&
    function(fn) {
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

/* ESM default export */ const src = (Promise);

;// CONCATENATED MODULE: ../../app/node_modules/promise-polyfill/src/polyfill.js



var globalNS = (function() {
  // the only reliable means to get the global object is
  // `Function('return this')()`
  // However, this causes CSP violations in Chrome apps.
  if (typeof self !== 'undefined') {
    return self;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof __webpack_require__.g !== 'undefined') {
    return __webpack_require__.g;
  }
  throw new Error('unable to locate global object');
})();

if (!globalNS.Promise) {
  globalNS.Promise = src;
} else if (!globalNS.Promise.prototype['finally']) {
  globalNS.Promise.prototype['finally'] = src_finally;
}


}),
57421: (function (module) {
"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


}),
26882: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";


var stringify = __webpack_require__(54123);
var parse = __webpack_require__(94490);
var formats = __webpack_require__(57421);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


}),
94490: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";


var utils = __webpack_require__(84360);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(String(val));
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        var existing = has.call(obj, key);
        if (existing && options.duplicates === 'combine') {
            obj[key] = utils.combine(obj[key], val);
        } else if (!existing || options.duplicates === 'last') {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                ? []
                : [].concat(leaf);
        } else {
            obj = options.plainObjects ? { __proto__: null } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, check strictDepth option for throw, else just add whatever is left

    if (segment) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? { __proto__: null } : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? { __proto__: null } : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


}),
54123: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";


var getSideChannel = __webpack_require__(20560);
var utils = __webpack_require__(84360);
var formats = __webpack_require__(57421);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    filter: void undefined,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined'
            ? key.value
            : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        var value = obj[key];

        if (options.skipNulls && value === null) {
            continue;
        }
        pushToArray(keys, stringify(
            value,
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


}),
84360: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";


var formats = __webpack_require__(57421);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? { __proto__: null } : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object' && typeof source !== 'function') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if (
                (options && (options.plainObjects || options.allowPrototypes))
                || !has.call(Object.prototype, source)
            ) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || c === 0x7E // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            i += 1;
            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));

            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                + hexTable[0x80 | ((c >> 12) & 0x3F)]
                + hexTable[0x80 | ((c >> 6) & 0x3F)]
                + hexTable[0x80 | (c & 0x3F)];
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


}),
19516: (function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  compose: () => (/* reexport */ compose),
  createStore: () => (/* reexport */ createStore_createStore),
  bindActionCreators: () => (/* reexport */ bindActionCreators),
  combineReducers: () => (/* reexport */ combineReducers),
  applyMiddleware: () => (/* reexport */ applyMiddleware)
});

;// CONCATENATED MODULE: ../../app/node_modules/lodash-es/_freeGlobal.js
/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* ESM default export */ const _freeGlobal = (freeGlobal);

;// CONCATENATED MODULE: ../../app/node_modules/lodash-es/_root.js


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

/* ESM default export */ const _root = (root);

;// CONCATENATED MODULE: ../../app/node_modules/lodash-es/_Symbol.js


/** Built-in value references. */
var Symbol = _root.Symbol;

/* ESM default export */ const _Symbol = (Symbol);

;// CONCATENATED MODULE: ../../app/node_modules/lodash-es/_getRawTag.js


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _getRawTag_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = _getRawTag_hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* ESM default export */ const _getRawTag = (getRawTag);

;// CONCATENATED MODULE: ../../app/node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* ESM default export */ const _objectToString = (objectToString);

;// CONCATENATED MODULE: ../../app/node_modules/lodash-es/_baseGetTag.js




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var _baseGetTag_symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (_baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

/* ESM default export */ const _baseGetTag = (baseGetTag);

;// CONCATENATED MODULE: ../../app/node_modules/lodash-es/_overArg.js
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* ESM default export */ const _overArg = (overArg);

;// CONCATENATED MODULE: ../../app/node_modules/lodash-es/_getPrototype.js


/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

/* ESM default export */ const _getPrototype = (getPrototype);

;// CONCATENATED MODULE: ../../app/node_modules/lodash-es/isObjectLike.js
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* ESM default export */ const lodash_es_isObjectLike = (isObjectLike);

;// CONCATENATED MODULE: ../../app/node_modules/lodash-es/isPlainObject.js




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    isPlainObject_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var isPlainObject_hasOwnProperty = isPlainObject_objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject_isPlainObject(value) {
  if (!lodash_es_isObjectLike(value) || _baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = isPlainObject_hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* ESM default export */ const lodash_es_isPlainObject = (isPlainObject_isPlainObject);

// EXTERNAL MODULE: ../../app/node_modules/redux/node_modules/symbol-observable/es/index.js + 1 modules
var es = __webpack_require__(13485);
;// CONCATENATED MODULE: ../../app/node_modules/redux/es/createStore.js



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var createStore_ActionTypes = {
  INIT: '@@redux/INIT'
};

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} enhancer The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore_createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore_createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!lodash_es_isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: createStore_ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/zenparsing/es-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[es/* default */.Z] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: createStore_ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[es/* default */.Z] = observable, _ref2;
}
;// CONCATENATED MODULE: ../../app/node_modules/redux/es/combineReducers.js




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerSanity(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: createStore_ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + createStore_ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  if (false) { var unexpectedKeyCache }

  var sanityError;
  try {
    assertReducerSanity(finalReducers);
  } catch (e) {
    sanityError = e;
  }

  return function combination() {
    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    var action = arguments[1];

    if (sanityError) {
      throw sanityError;
    }

    if (false) { var warningMessage }

    var hasChanged = false;
    var nextState = {};
    for (var i = 0; i < finalReducerKeys.length; i++) {
      var key = finalReducerKeys[i];
      var reducer = finalReducers[key];
      var previousStateForKey = state[key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(key, action);
        throw new Error(errorMessage);
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}
;// CONCATENATED MODULE: ../../app/node_modules/redux/es/bindActionCreators.js
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}
;// CONCATENATED MODULE: ../../app/node_modules/redux/es/compose.js
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  var last = funcs[funcs.length - 1];
  var rest = funcs.slice(0, -1);
  return function () {
    return rest.reduceRight(function (composed, f) {
      return f(composed);
    }, last.apply(undefined, arguments));
  };
}
;// CONCATENATED MODULE: ../../app/node_modules/redux/es/applyMiddleware.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}
;// CONCATENATED MODULE: ../../app/node_modules/redux/es/index.js







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {}



}),
13485: (function (module, __webpack_exports__, __webpack_require__) {
"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ es)
});

;// CONCATENATED MODULE: ../../app/node_modules/redux/node_modules/symbol-observable/es/ponyfill.js
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

;// CONCATENATED MODULE: ../../app/node_modules/redux/node_modules/symbol-observable/es/index.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* global window */


var es_root;

if (typeof self !== 'undefined') {
  es_root = self;
} else if (typeof window !== 'undefined') {
  es_root = window;
} else if (typeof __webpack_require__.g !== 'undefined') {
  es_root = __webpack_require__.g;
} else if (true) {
  es_root = module;
} else {}

var es_result = symbolObservablePonyfill(es_root);
/* ESM default export */ const es = (es_result);


}),
34043: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.interval = exports.iif = exports.generate = exports.fromEventPattern = exports.fromEvent = exports.from = exports.forkJoin = exports.empty = exports.defer = exports.connectable = exports.concat = exports.combineLatest = exports.bindNodeCallback = exports.bindCallback = exports.UnsubscriptionError = exports.TimeoutError = exports.SequenceError = exports.ObjectUnsubscribedError = exports.NotFoundError = exports.EmptyError = exports.ArgumentOutOfRangeError = exports.firstValueFrom = exports.lastValueFrom = exports.isObservable = exports.identity = exports.noop = exports.pipe = exports.NotificationKind = exports.Notification = exports.Subscriber = exports.Subscription = exports.Scheduler = exports.VirtualAction = exports.VirtualTimeScheduler = exports.animationFrameScheduler = exports.animationFrame = exports.queueScheduler = exports.queue = exports.asyncScheduler = exports.async = exports.asapScheduler = exports.asap = exports.AsyncSubject = exports.ReplaySubject = exports.BehaviorSubject = exports.Subject = exports.animationFrames = exports.observable = exports.ConnectableObservable = exports.Observable = void 0;
exports.filter = exports.expand = exports.exhaustMap = exports.exhaustAll = exports.exhaust = exports.every = exports.endWith = exports.elementAt = exports.distinctUntilKeyChanged = exports.distinctUntilChanged = exports.distinct = exports.dematerialize = exports.delayWhen = exports.delay = exports.defaultIfEmpty = exports.debounceTime = exports.debounce = exports.count = exports.connect = exports.concatWith = exports.concatMapTo = exports.concatMap = exports.concatAll = exports.combineLatestWith = exports.combineLatestAll = exports.combineAll = exports.catchError = exports.bufferWhen = exports.bufferToggle = exports.bufferTime = exports.bufferCount = exports.buffer = exports.auditTime = exports.audit = exports.config = exports.NEVER = exports.EMPTY = exports.scheduled = exports.zip = exports.using = exports.timer = exports.throwError = exports.range = exports.race = exports.partition = exports.pairs = exports.onErrorResumeNext = exports.of = exports.never = exports.merge = void 0;
exports.switchMap = exports.switchAll = exports.subscribeOn = exports.startWith = exports.skipWhile = exports.skipUntil = exports.skipLast = exports.skip = exports.single = exports.shareReplay = exports.share = exports.sequenceEqual = exports.scan = exports.sampleTime = exports.sample = exports.refCount = exports.retryWhen = exports.retry = exports.repeatWhen = exports.repeat = exports.reduce = exports.raceWith = exports.publishReplay = exports.publishLast = exports.publishBehavior = exports.publish = exports.pluck = exports.pairwise = exports.onErrorResumeNextWith = exports.observeOn = exports.multicast = exports.min = exports.mergeWith = exports.mergeScan = exports.mergeMapTo = exports.mergeMap = exports.flatMap = exports.mergeAll = exports.max = exports.materialize = exports.mapTo = exports.map = exports.last = exports.isEmpty = exports.ignoreElements = exports.groupBy = exports.first = exports.findIndex = exports.find = exports.finalize = void 0;
exports.zipWith = exports.zipAll = exports.withLatestFrom = exports.windowWhen = exports.windowToggle = exports.windowTime = exports.windowCount = exports.window = exports.toArray = exports.timestamp = exports.timeoutWith = exports.timeout = exports.timeInterval = exports.throwIfEmpty = exports.throttleTime = exports.throttle = exports.tap = exports.takeWhile = exports.takeUntil = exports.takeLast = exports.take = exports.switchScan = exports.switchMapTo = void 0;
var Observable_1 = __webpack_require__(18547);
Object.defineProperty(exports, "Observable", ({ enumerable: true, get: function () { return Observable_1.Observable; } }));
var ConnectableObservable_1 = __webpack_require__(23987);
Object.defineProperty(exports, "ConnectableObservable", ({ enumerable: true, get: function () { return ConnectableObservable_1.ConnectableObservable; } }));
var observable_1 = __webpack_require__(58432);
Object.defineProperty(exports, "observable", ({ enumerable: true, get: function () { return observable_1.observable; } }));
var animationFrames_1 = __webpack_require__(1411);
Object.defineProperty(exports, "animationFrames", ({ enumerable: true, get: function () { return animationFrames_1.animationFrames; } }));
var Subject_1 = __webpack_require__(30250);
Object.defineProperty(exports, "Subject", ({ enumerable: true, get: function () { return Subject_1.Subject; } }));
var BehaviorSubject_1 = __webpack_require__(33850);
Object.defineProperty(exports, "BehaviorSubject", ({ enumerable: true, get: function () { return BehaviorSubject_1.BehaviorSubject; } }));
var ReplaySubject_1 = __webpack_require__(68838);
Object.defineProperty(exports, "ReplaySubject", ({ enumerable: true, get: function () { return ReplaySubject_1.ReplaySubject; } }));
var AsyncSubject_1 = __webpack_require__(65076);
Object.defineProperty(exports, "AsyncSubject", ({ enumerable: true, get: function () { return AsyncSubject_1.AsyncSubject; } }));
var asap_1 = __webpack_require__(69343);
Object.defineProperty(exports, "asap", ({ enumerable: true, get: function () { return asap_1.asap; } }));
Object.defineProperty(exports, "asapScheduler", ({ enumerable: true, get: function () { return asap_1.asapScheduler; } }));
var async_1 = __webpack_require__(6341);
Object.defineProperty(exports, "async", ({ enumerable: true, get: function () { return async_1.async; } }));
Object.defineProperty(exports, "asyncScheduler", ({ enumerable: true, get: function () { return async_1.asyncScheduler; } }));
var queue_1 = __webpack_require__(34171);
Object.defineProperty(exports, "queue", ({ enumerable: true, get: function () { return queue_1.queue; } }));
Object.defineProperty(exports, "queueScheduler", ({ enumerable: true, get: function () { return queue_1.queueScheduler; } }));
var animationFrame_1 = __webpack_require__(33824);
Object.defineProperty(exports, "animationFrame", ({ enumerable: true, get: function () { return animationFrame_1.animationFrame; } }));
Object.defineProperty(exports, "animationFrameScheduler", ({ enumerable: true, get: function () { return animationFrame_1.animationFrameScheduler; } }));
var VirtualTimeScheduler_1 = __webpack_require__(16531);
Object.defineProperty(exports, "VirtualTimeScheduler", ({ enumerable: true, get: function () { return VirtualTimeScheduler_1.VirtualTimeScheduler; } }));
Object.defineProperty(exports, "VirtualAction", ({ enumerable: true, get: function () { return VirtualTimeScheduler_1.VirtualAction; } }));
var Scheduler_1 = __webpack_require__(86694);
Object.defineProperty(exports, "Scheduler", ({ enumerable: true, get: function () { return Scheduler_1.Scheduler; } }));
var Subscription_1 = __webpack_require__(68631);
Object.defineProperty(exports, "Subscription", ({ enumerable: true, get: function () { return Subscription_1.Subscription; } }));
var Subscriber_1 = __webpack_require__(87378);
Object.defineProperty(exports, "Subscriber", ({ enumerable: true, get: function () { return Subscriber_1.Subscriber; } }));
var Notification_1 = __webpack_require__(60713);
Object.defineProperty(exports, "Notification", ({ enumerable: true, get: function () { return Notification_1.Notification; } }));
Object.defineProperty(exports, "NotificationKind", ({ enumerable: true, get: function () { return Notification_1.NotificationKind; } }));
var pipe_1 = __webpack_require__(27754);
Object.defineProperty(exports, "pipe", ({ enumerable: true, get: function () { return pipe_1.pipe; } }));
var noop_1 = __webpack_require__(72777);
Object.defineProperty(exports, "noop", ({ enumerable: true, get: function () { return noop_1.noop; } }));
var identity_1 = __webpack_require__(6033);
Object.defineProperty(exports, "identity", ({ enumerable: true, get: function () { return identity_1.identity; } }));
var isObservable_1 = __webpack_require__(25268);
Object.defineProperty(exports, "isObservable", ({ enumerable: true, get: function () { return isObservable_1.isObservable; } }));
var lastValueFrom_1 = __webpack_require__(3109);
Object.defineProperty(exports, "lastValueFrom", ({ enumerable: true, get: function () { return lastValueFrom_1.lastValueFrom; } }));
var firstValueFrom_1 = __webpack_require__(15783);
Object.defineProperty(exports, "firstValueFrom", ({ enumerable: true, get: function () { return firstValueFrom_1.firstValueFrom; } }));
var ArgumentOutOfRangeError_1 = __webpack_require__(56985);
Object.defineProperty(exports, "ArgumentOutOfRangeError", ({ enumerable: true, get: function () { return ArgumentOutOfRangeError_1.ArgumentOutOfRangeError; } }));
var EmptyError_1 = __webpack_require__(20431);
Object.defineProperty(exports, "EmptyError", ({ enumerable: true, get: function () { return EmptyError_1.EmptyError; } }));
var NotFoundError_1 = __webpack_require__(25943);
Object.defineProperty(exports, "NotFoundError", ({ enumerable: true, get: function () { return NotFoundError_1.NotFoundError; } }));
var ObjectUnsubscribedError_1 = __webpack_require__(15993);
Object.defineProperty(exports, "ObjectUnsubscribedError", ({ enumerable: true, get: function () { return ObjectUnsubscribedError_1.ObjectUnsubscribedError; } }));
var SequenceError_1 = __webpack_require__(16348);
Object.defineProperty(exports, "SequenceError", ({ enumerable: true, get: function () { return SequenceError_1.SequenceError; } }));
var timeout_1 = __webpack_require__(59204);
Object.defineProperty(exports, "TimeoutError", ({ enumerable: true, get: function () { return timeout_1.TimeoutError; } }));
var UnsubscriptionError_1 = __webpack_require__(88829);
Object.defineProperty(exports, "UnsubscriptionError", ({ enumerable: true, get: function () { return UnsubscriptionError_1.UnsubscriptionError; } }));
var bindCallback_1 = __webpack_require__(4723);
Object.defineProperty(exports, "bindCallback", ({ enumerable: true, get: function () { return bindCallback_1.bindCallback; } }));
var bindNodeCallback_1 = __webpack_require__(84646);
Object.defineProperty(exports, "bindNodeCallback", ({ enumerable: true, get: function () { return bindNodeCallback_1.bindNodeCallback; } }));
var combineLatest_1 = __webpack_require__(94331);
Object.defineProperty(exports, "combineLatest", ({ enumerable: true, get: function () { return combineLatest_1.combineLatest; } }));
var concat_1 = __webpack_require__(29982);
Object.defineProperty(exports, "concat", ({ enumerable: true, get: function () { return concat_1.concat; } }));
var connectable_1 = __webpack_require__(54907);
Object.defineProperty(exports, "connectable", ({ enumerable: true, get: function () { return connectable_1.connectable; } }));
var defer_1 = __webpack_require__(80363);
Object.defineProperty(exports, "defer", ({ enumerable: true, get: function () { return defer_1.defer; } }));
var empty_1 = __webpack_require__(88930);
Object.defineProperty(exports, "empty", ({ enumerable: true, get: function () { return empty_1.empty; } }));
var forkJoin_1 = __webpack_require__(20524);
Object.defineProperty(exports, "forkJoin", ({ enumerable: true, get: function () { return forkJoin_1.forkJoin; } }));
var from_1 = __webpack_require__(16609);
Object.defineProperty(exports, "from", ({ enumerable: true, get: function () { return from_1.from; } }));
var fromEvent_1 = __webpack_require__(86983);
Object.defineProperty(exports, "fromEvent", ({ enumerable: true, get: function () { return fromEvent_1.fromEvent; } }));
var fromEventPattern_1 = __webpack_require__(22791);
Object.defineProperty(exports, "fromEventPattern", ({ enumerable: true, get: function () { return fromEventPattern_1.fromEventPattern; } }));
var generate_1 = __webpack_require__(90884);
Object.defineProperty(exports, "generate", ({ enumerable: true, get: function () { return generate_1.generate; } }));
var iif_1 = __webpack_require__(77958);
Object.defineProperty(exports, "iif", ({ enumerable: true, get: function () { return iif_1.iif; } }));
var interval_1 = __webpack_require__(88531);
Object.defineProperty(exports, "interval", ({ enumerable: true, get: function () { return interval_1.interval; } }));
var merge_1 = __webpack_require__(29835);
Object.defineProperty(exports, "merge", ({ enumerable: true, get: function () { return merge_1.merge; } }));
var never_1 = __webpack_require__(19945);
Object.defineProperty(exports, "never", ({ enumerable: true, get: function () { return never_1.never; } }));
var of_1 = __webpack_require__(27294);
Object.defineProperty(exports, "of", ({ enumerable: true, get: function () { return of_1.of; } }));
var onErrorResumeNext_1 = __webpack_require__(90941);
Object.defineProperty(exports, "onErrorResumeNext", ({ enumerable: true, get: function () { return onErrorResumeNext_1.onErrorResumeNext; } }));
var pairs_1 = __webpack_require__(31372);
Object.defineProperty(exports, "pairs", ({ enumerable: true, get: function () { return pairs_1.pairs; } }));
var partition_1 = __webpack_require__(45790);
Object.defineProperty(exports, "partition", ({ enumerable: true, get: function () { return partition_1.partition; } }));
var race_1 = __webpack_require__(96628);
Object.defineProperty(exports, "race", ({ enumerable: true, get: function () { return race_1.race; } }));
var range_1 = __webpack_require__(65369);
Object.defineProperty(exports, "range", ({ enumerable: true, get: function () { return range_1.range; } }));
var throwError_1 = __webpack_require__(77297);
Object.defineProperty(exports, "throwError", ({ enumerable: true, get: function () { return throwError_1.throwError; } }));
var timer_1 = __webpack_require__(44779);
Object.defineProperty(exports, "timer", ({ enumerable: true, get: function () { return timer_1.timer; } }));
var using_1 = __webpack_require__(81043);
Object.defineProperty(exports, "using", ({ enumerable: true, get: function () { return using_1.using; } }));
var zip_1 = __webpack_require__(14534);
Object.defineProperty(exports, "zip", ({ enumerable: true, get: function () { return zip_1.zip; } }));
var scheduled_1 = __webpack_require__(29143);
Object.defineProperty(exports, "scheduled", ({ enumerable: true, get: function () { return scheduled_1.scheduled; } }));
var empty_2 = __webpack_require__(88930);
Object.defineProperty(exports, "EMPTY", ({ enumerable: true, get: function () { return empty_2.EMPTY; } }));
var never_2 = __webpack_require__(19945);
Object.defineProperty(exports, "NEVER", ({ enumerable: true, get: function () { return never_2.NEVER; } }));
__exportStar(__webpack_require__(39416), exports);
var config_1 = __webpack_require__(56622);
Object.defineProperty(exports, "config", ({ enumerable: true, get: function () { return config_1.config; } }));
var audit_1 = __webpack_require__(49885);
Object.defineProperty(exports, "audit", ({ enumerable: true, get: function () { return audit_1.audit; } }));
var auditTime_1 = __webpack_require__(32322);
Object.defineProperty(exports, "auditTime", ({ enumerable: true, get: function () { return auditTime_1.auditTime; } }));
var buffer_1 = __webpack_require__(61353);
Object.defineProperty(exports, "buffer", ({ enumerable: true, get: function () { return buffer_1.buffer; } }));
var bufferCount_1 = __webpack_require__(9956);
Object.defineProperty(exports, "bufferCount", ({ enumerable: true, get: function () { return bufferCount_1.bufferCount; } }));
var bufferTime_1 = __webpack_require__(61201);
Object.defineProperty(exports, "bufferTime", ({ enumerable: true, get: function () { return bufferTime_1.bufferTime; } }));
var bufferToggle_1 = __webpack_require__(25843);
Object.defineProperty(exports, "bufferToggle", ({ enumerable: true, get: function () { return bufferToggle_1.bufferToggle; } }));
var bufferWhen_1 = __webpack_require__(47383);
Object.defineProperty(exports, "bufferWhen", ({ enumerable: true, get: function () { return bufferWhen_1.bufferWhen; } }));
var catchError_1 = __webpack_require__(34097);
Object.defineProperty(exports, "catchError", ({ enumerable: true, get: function () { return catchError_1.catchError; } }));
var combineAll_1 = __webpack_require__(44740);
Object.defineProperty(exports, "combineAll", ({ enumerable: true, get: function () { return combineAll_1.combineAll; } }));
var combineLatestAll_1 = __webpack_require__(85488);
Object.defineProperty(exports, "combineLatestAll", ({ enumerable: true, get: function () { return combineLatestAll_1.combineLatestAll; } }));
var combineLatestWith_1 = __webpack_require__(19144);
Object.defineProperty(exports, "combineLatestWith", ({ enumerable: true, get: function () { return combineLatestWith_1.combineLatestWith; } }));
var concatAll_1 = __webpack_require__(84438);
Object.defineProperty(exports, "concatAll", ({ enumerable: true, get: function () { return concatAll_1.concatAll; } }));
var concatMap_1 = __webpack_require__(62187);
Object.defineProperty(exports, "concatMap", ({ enumerable: true, get: function () { return concatMap_1.concatMap; } }));
var concatMapTo_1 = __webpack_require__(36873);
Object.defineProperty(exports, "concatMapTo", ({ enumerable: true, get: function () { return concatMapTo_1.concatMapTo; } }));
var concatWith_1 = __webpack_require__(99930);
Object.defineProperty(exports, "concatWith", ({ enumerable: true, get: function () { return concatWith_1.concatWith; } }));
var connect_1 = __webpack_require__(43325);
Object.defineProperty(exports, "connect", ({ enumerable: true, get: function () { return connect_1.connect; } }));
var count_1 = __webpack_require__(46452);
Object.defineProperty(exports, "count", ({ enumerable: true, get: function () { return count_1.count; } }));
var debounce_1 = __webpack_require__(42093);
Object.defineProperty(exports, "debounce", ({ enumerable: true, get: function () { return debounce_1.debounce; } }));
var debounceTime_1 = __webpack_require__(26090);
Object.defineProperty(exports, "debounceTime", ({ enumerable: true, get: function () { return debounceTime_1.debounceTime; } }));
var defaultIfEmpty_1 = __webpack_require__(13444);
Object.defineProperty(exports, "defaultIfEmpty", ({ enumerable: true, get: function () { return defaultIfEmpty_1.defaultIfEmpty; } }));
var delay_1 = __webpack_require__(26983);
Object.defineProperty(exports, "delay", ({ enumerable: true, get: function () { return delay_1.delay; } }));
var delayWhen_1 = __webpack_require__(73954);
Object.defineProperty(exports, "delayWhen", ({ enumerable: true, get: function () { return delayWhen_1.delayWhen; } }));
var dematerialize_1 = __webpack_require__(54102);
Object.defineProperty(exports, "dematerialize", ({ enumerable: true, get: function () { return dematerialize_1.dematerialize; } }));
var distinct_1 = __webpack_require__(54997);
Object.defineProperty(exports, "distinct", ({ enumerable: true, get: function () { return distinct_1.distinct; } }));
var distinctUntilChanged_1 = __webpack_require__(53833);
Object.defineProperty(exports, "distinctUntilChanged", ({ enumerable: true, get: function () { return distinctUntilChanged_1.distinctUntilChanged; } }));
var distinctUntilKeyChanged_1 = __webpack_require__(92892);
Object.defineProperty(exports, "distinctUntilKeyChanged", ({ enumerable: true, get: function () { return distinctUntilKeyChanged_1.distinctUntilKeyChanged; } }));
var elementAt_1 = __webpack_require__(81272);
Object.defineProperty(exports, "elementAt", ({ enumerable: true, get: function () { return elementAt_1.elementAt; } }));
var endWith_1 = __webpack_require__(28839);
Object.defineProperty(exports, "endWith", ({ enumerable: true, get: function () { return endWith_1.endWith; } }));
var every_1 = __webpack_require__(38187);
Object.defineProperty(exports, "every", ({ enumerable: true, get: function () { return every_1.every; } }));
var exhaust_1 = __webpack_require__(51998);
Object.defineProperty(exports, "exhaust", ({ enumerable: true, get: function () { return exhaust_1.exhaust; } }));
var exhaustAll_1 = __webpack_require__(97156);
Object.defineProperty(exports, "exhaustAll", ({ enumerable: true, get: function () { return exhaustAll_1.exhaustAll; } }));
var exhaustMap_1 = __webpack_require__(13970);
Object.defineProperty(exports, "exhaustMap", ({ enumerable: true, get: function () { return exhaustMap_1.exhaustMap; } }));
var expand_1 = __webpack_require__(24837);
Object.defineProperty(exports, "expand", ({ enumerable: true, get: function () { return expand_1.expand; } }));
var filter_1 = __webpack_require__(84653);
Object.defineProperty(exports, "filter", ({ enumerable: true, get: function () { return filter_1.filter; } }));
var finalize_1 = __webpack_require__(72489);
Object.defineProperty(exports, "finalize", ({ enumerable: true, get: function () { return finalize_1.finalize; } }));
var find_1 = __webpack_require__(35457);
Object.defineProperty(exports, "find", ({ enumerable: true, get: function () { return find_1.find; } }));
var findIndex_1 = __webpack_require__(20363);
Object.defineProperty(exports, "findIndex", ({ enumerable: true, get: function () { return findIndex_1.findIndex; } }));
var first_1 = __webpack_require__(91457);
Object.defineProperty(exports, "first", ({ enumerable: true, get: function () { return first_1.first; } }));
var groupBy_1 = __webpack_require__(39103);
Object.defineProperty(exports, "groupBy", ({ enumerable: true, get: function () { return groupBy_1.groupBy; } }));
var ignoreElements_1 = __webpack_require__(71042);
Object.defineProperty(exports, "ignoreElements", ({ enumerable: true, get: function () { return ignoreElements_1.ignoreElements; } }));
var isEmpty_1 = __webpack_require__(6426);
Object.defineProperty(exports, "isEmpty", ({ enumerable: true, get: function () { return isEmpty_1.isEmpty; } }));
var last_1 = __webpack_require__(16406);
Object.defineProperty(exports, "last", ({ enumerable: true, get: function () { return last_1.last; } }));
var map_1 = __webpack_require__(92619);
Object.defineProperty(exports, "map", ({ enumerable: true, get: function () { return map_1.map; } }));
var mapTo_1 = __webpack_require__(83597);
Object.defineProperty(exports, "mapTo", ({ enumerable: true, get: function () { return mapTo_1.mapTo; } }));
var materialize_1 = __webpack_require__(48461);
Object.defineProperty(exports, "materialize", ({ enumerable: true, get: function () { return materialize_1.materialize; } }));
var max_1 = __webpack_require__(3330);
Object.defineProperty(exports, "max", ({ enumerable: true, get: function () { return max_1.max; } }));
var mergeAll_1 = __webpack_require__(21329);
Object.defineProperty(exports, "mergeAll", ({ enumerable: true, get: function () { return mergeAll_1.mergeAll; } }));
var flatMap_1 = __webpack_require__(99124);
Object.defineProperty(exports, "flatMap", ({ enumerable: true, get: function () { return flatMap_1.flatMap; } }));
var mergeMap_1 = __webpack_require__(18244);
Object.defineProperty(exports, "mergeMap", ({ enumerable: true, get: function () { return mergeMap_1.mergeMap; } }));
var mergeMapTo_1 = __webpack_require__(38119);
Object.defineProperty(exports, "mergeMapTo", ({ enumerable: true, get: function () { return mergeMapTo_1.mergeMapTo; } }));
var mergeScan_1 = __webpack_require__(57426);
Object.defineProperty(exports, "mergeScan", ({ enumerable: true, get: function () { return mergeScan_1.mergeScan; } }));
var mergeWith_1 = __webpack_require__(95280);
Object.defineProperty(exports, "mergeWith", ({ enumerable: true, get: function () { return mergeWith_1.mergeWith; } }));
var min_1 = __webpack_require__(40884);
Object.defineProperty(exports, "min", ({ enumerable: true, get: function () { return min_1.min; } }));
var multicast_1 = __webpack_require__(88591);
Object.defineProperty(exports, "multicast", ({ enumerable: true, get: function () { return multicast_1.multicast; } }));
var observeOn_1 = __webpack_require__(89329);
Object.defineProperty(exports, "observeOn", ({ enumerable: true, get: function () { return observeOn_1.observeOn; } }));
var onErrorResumeNextWith_1 = __webpack_require__(46851);
Object.defineProperty(exports, "onErrorResumeNextWith", ({ enumerable: true, get: function () { return onErrorResumeNextWith_1.onErrorResumeNextWith; } }));
var pairwise_1 = __webpack_require__(48069);
Object.defineProperty(exports, "pairwise", ({ enumerable: true, get: function () { return pairwise_1.pairwise; } }));
var pluck_1 = __webpack_require__(40331);
Object.defineProperty(exports, "pluck", ({ enumerable: true, get: function () { return pluck_1.pluck; } }));
var publish_1 = __webpack_require__(69837);
Object.defineProperty(exports, "publish", ({ enumerable: true, get: function () { return publish_1.publish; } }));
var publishBehavior_1 = __webpack_require__(35420);
Object.defineProperty(exports, "publishBehavior", ({ enumerable: true, get: function () { return publishBehavior_1.publishBehavior; } }));
var publishLast_1 = __webpack_require__(35315);
Object.defineProperty(exports, "publishLast", ({ enumerable: true, get: function () { return publishLast_1.publishLast; } }));
var publishReplay_1 = __webpack_require__(33274);
Object.defineProperty(exports, "publishReplay", ({ enumerable: true, get: function () { return publishReplay_1.publishReplay; } }));
var raceWith_1 = __webpack_require__(10898);
Object.defineProperty(exports, "raceWith", ({ enumerable: true, get: function () { return raceWith_1.raceWith; } }));
var reduce_1 = __webpack_require__(71653);
Object.defineProperty(exports, "reduce", ({ enumerable: true, get: function () { return reduce_1.reduce; } }));
var repeat_1 = __webpack_require__(45882);
Object.defineProperty(exports, "repeat", ({ enumerable: true, get: function () { return repeat_1.repeat; } }));
var repeatWhen_1 = __webpack_require__(77693);
Object.defineProperty(exports, "repeatWhen", ({ enumerable: true, get: function () { return repeatWhen_1.repeatWhen; } }));
var retry_1 = __webpack_require__(47280);
Object.defineProperty(exports, "retry", ({ enumerable: true, get: function () { return retry_1.retry; } }));
var retryWhen_1 = __webpack_require__(44965);
Object.defineProperty(exports, "retryWhen", ({ enumerable: true, get: function () { return retryWhen_1.retryWhen; } }));
var refCount_1 = __webpack_require__(17988);
Object.defineProperty(exports, "refCount", ({ enumerable: true, get: function () { return refCount_1.refCount; } }));
var sample_1 = __webpack_require__(72412);
Object.defineProperty(exports, "sample", ({ enumerable: true, get: function () { return sample_1.sample; } }));
var sampleTime_1 = __webpack_require__(94815);
Object.defineProperty(exports, "sampleTime", ({ enumerable: true, get: function () { return sampleTime_1.sampleTime; } }));
var scan_1 = __webpack_require__(32115);
Object.defineProperty(exports, "scan", ({ enumerable: true, get: function () { return scan_1.scan; } }));
var sequenceEqual_1 = __webpack_require__(70495);
Object.defineProperty(exports, "sequenceEqual", ({ enumerable: true, get: function () { return sequenceEqual_1.sequenceEqual; } }));
var share_1 = __webpack_require__(66644);
Object.defineProperty(exports, "share", ({ enumerable: true, get: function () { return share_1.share; } }));
var shareReplay_1 = __webpack_require__(30970);
Object.defineProperty(exports, "shareReplay", ({ enumerable: true, get: function () { return shareReplay_1.shareReplay; } }));
var single_1 = __webpack_require__(60236);
Object.defineProperty(exports, "single", ({ enumerable: true, get: function () { return single_1.single; } }));
var skip_1 = __webpack_require__(21006);
Object.defineProperty(exports, "skip", ({ enumerable: true, get: function () { return skip_1.skip; } }));
var skipLast_1 = __webpack_require__(16701);
Object.defineProperty(exports, "skipLast", ({ enumerable: true, get: function () { return skipLast_1.skipLast; } }));
var skipUntil_1 = __webpack_require__(86778);
Object.defineProperty(exports, "skipUntil", ({ enumerable: true, get: function () { return skipUntil_1.skipUntil; } }));
var skipWhile_1 = __webpack_require__(85720);
Object.defineProperty(exports, "skipWhile", ({ enumerable: true, get: function () { return skipWhile_1.skipWhile; } }));
var startWith_1 = __webpack_require__(45251);
Object.defineProperty(exports, "startWith", ({ enumerable: true, get: function () { return startWith_1.startWith; } }));
var subscribeOn_1 = __webpack_require__(91205);
Object.defineProperty(exports, "subscribeOn", ({ enumerable: true, get: function () { return subscribeOn_1.subscribeOn; } }));
var switchAll_1 = __webpack_require__(47622);
Object.defineProperty(exports, "switchAll", ({ enumerable: true, get: function () { return switchAll_1.switchAll; } }));
var switchMap_1 = __webpack_require__(62443);
Object.defineProperty(exports, "switchMap", ({ enumerable: true, get: function () { return switchMap_1.switchMap; } }));
var switchMapTo_1 = __webpack_require__(96525);
Object.defineProperty(exports, "switchMapTo", ({ enumerable: true, get: function () { return switchMapTo_1.switchMapTo; } }));
var switchScan_1 = __webpack_require__(74814);
Object.defineProperty(exports, "switchScan", ({ enumerable: true, get: function () { return switchScan_1.switchScan; } }));
var take_1 = __webpack_require__(54424);
Object.defineProperty(exports, "take", ({ enumerable: true, get: function () { return take_1.take; } }));
var takeLast_1 = __webpack_require__(45033);
Object.defineProperty(exports, "takeLast", ({ enumerable: true, get: function () { return takeLast_1.takeLast; } }));
var takeUntil_1 = __webpack_require__(28436);
Object.defineProperty(exports, "takeUntil", ({ enumerable: true, get: function () { return takeUntil_1.takeUntil; } }));
var takeWhile_1 = __webpack_require__(8891);
Object.defineProperty(exports, "takeWhile", ({ enumerable: true, get: function () { return takeWhile_1.takeWhile; } }));
var tap_1 = __webpack_require__(75667);
Object.defineProperty(exports, "tap", ({ enumerable: true, get: function () { return tap_1.tap; } }));
var throttle_1 = __webpack_require__(10832);
Object.defineProperty(exports, "throttle", ({ enumerable: true, get: function () { return throttle_1.throttle; } }));
var throttleTime_1 = __webpack_require__(92312);
Object.defineProperty(exports, "throttleTime", ({ enumerable: true, get: function () { return throttleTime_1.throttleTime; } }));
var throwIfEmpty_1 = __webpack_require__(19645);
Object.defineProperty(exports, "throwIfEmpty", ({ enumerable: true, get: function () { return throwIfEmpty_1.throwIfEmpty; } }));
var timeInterval_1 = __webpack_require__(664);
Object.defineProperty(exports, "timeInterval", ({ enumerable: true, get: function () { return timeInterval_1.timeInterval; } }));
var timeout_2 = __webpack_require__(59204);
Object.defineProperty(exports, "timeout", ({ enumerable: true, get: function () { return timeout_2.timeout; } }));
var timeoutWith_1 = __webpack_require__(24710);
Object.defineProperty(exports, "timeoutWith", ({ enumerable: true, get: function () { return timeoutWith_1.timeoutWith; } }));
var timestamp_1 = __webpack_require__(26694);
Object.defineProperty(exports, "timestamp", ({ enumerable: true, get: function () { return timestamp_1.timestamp; } }));
var toArray_1 = __webpack_require__(3223);
Object.defineProperty(exports, "toArray", ({ enumerable: true, get: function () { return toArray_1.toArray; } }));
var window_1 = __webpack_require__(86727);
Object.defineProperty(exports, "window", ({ enumerable: true, get: function () { return window_1.window; } }));
var windowCount_1 = __webpack_require__(78806);
Object.defineProperty(exports, "windowCount", ({ enumerable: true, get: function () { return windowCount_1.windowCount; } }));
var windowTime_1 = __webpack_require__(54645);
Object.defineProperty(exports, "windowTime", ({ enumerable: true, get: function () { return windowTime_1.windowTime; } }));
var windowToggle_1 = __webpack_require__(98131);
Object.defineProperty(exports, "windowToggle", ({ enumerable: true, get: function () { return windowToggle_1.windowToggle; } }));
var windowWhen_1 = __webpack_require__(61621);
Object.defineProperty(exports, "windowWhen", ({ enumerable: true, get: function () { return windowWhen_1.windowWhen; } }));
var withLatestFrom_1 = __webpack_require__(83655);
Object.defineProperty(exports, "withLatestFrom", ({ enumerable: true, get: function () { return withLatestFrom_1.withLatestFrom; } }));
var zipAll_1 = __webpack_require__(35684);
Object.defineProperty(exports, "zipAll", ({ enumerable: true, get: function () { return zipAll_1.zipAll; } }));
var zipWith_1 = __webpack_require__(71262);
Object.defineProperty(exports, "zipWith", ({ enumerable: true, get: function () { return zipWith_1.zipWith; } }));
//# sourceMappingURL=index.js.map

}),
65076: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AsyncSubject = void 0;
var Subject_1 = __webpack_require__(30250);
var AsyncSubject = (function (_super) {
    __extends(AsyncSubject, _super);
    function AsyncSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._value = null;
        _this._hasValue = false;
        _this._isComplete = false;
        return _this;
    }
    AsyncSubject.prototype._checkFinalizedStatuses = function (subscriber) {
        var _a = this, hasError = _a.hasError, _hasValue = _a._hasValue, _value = _a._value, thrownError = _a.thrownError, isStopped = _a.isStopped, _isComplete = _a._isComplete;
        if (hasError) {
            subscriber.error(thrownError);
        }
        else if (isStopped || _isComplete) {
            _hasValue && subscriber.next(_value);
            subscriber.complete();
        }
    };
    AsyncSubject.prototype.next = function (value) {
        if (!this.isStopped) {
            this._value = value;
            this._hasValue = true;
        }
    };
    AsyncSubject.prototype.complete = function () {
        var _a = this, _hasValue = _a._hasValue, _value = _a._value, _isComplete = _a._isComplete;
        if (!_isComplete) {
            this._isComplete = true;
            _hasValue && _super.prototype.next.call(this, _value);
            _super.prototype.complete.call(this);
        }
    };
    return AsyncSubject;
}(Subject_1.Subject));
exports.AsyncSubject = AsyncSubject;
//# sourceMappingURL=AsyncSubject.js.map

}),
33850: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BehaviorSubject = void 0;
var Subject_1 = __webpack_require__(30250);
var BehaviorSubject = (function (_super) {
    __extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function () {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function (subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function () {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) {
            throw thrownError;
        }
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function (value) {
        _super.prototype.next.call(this, (this._value = value));
    };
    return BehaviorSubject;
}(Subject_1.Subject));
exports.BehaviorSubject = BehaviorSubject;
//# sourceMappingURL=BehaviorSubject.js.map

}),
60713: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.observeNotification = exports.Notification = exports.NotificationKind = void 0;
var empty_1 = __webpack_require__(88930);
var of_1 = __webpack_require__(27294);
var throwError_1 = __webpack_require__(77297);
var isFunction_1 = __webpack_require__(64061);
var NotificationKind;
(function (NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})(NotificationKind = exports.NotificationKind || (exports.NotificationKind = {}));
var Notification = (function () {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    Notification.prototype.observe = function (observer) {
        return observeNotification(this, observer);
    };
    Notification.prototype.do = function (nextHandler, errorHandler, completeHandler) {
        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
        return kind === 'N' ? nextHandler === null || nextHandler === void 0 ? void 0 : nextHandler(value) : kind === 'E' ? errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(error) : completeHandler === null || completeHandler === void 0 ? void 0 : completeHandler();
    };
    Notification.prototype.accept = function (nextOrObserver, error, complete) {
        var _a;
        return isFunction_1.isFunction((_a = nextOrObserver) === null || _a === void 0 ? void 0 : _a.next)
            ? this.observe(nextOrObserver)
            : this.do(nextOrObserver, error, complete);
    };
    Notification.prototype.toObservable = function () {
        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
        var result = kind === 'N'
            ?
                of_1.of(value)
            :
                kind === 'E'
                    ?
                        throwError_1.throwError(function () { return error; })
                    :
                        kind === 'C'
                            ?
                                empty_1.EMPTY
                            :
                                0;
        if (!result) {
            throw new TypeError("Unexpected notification kind " + kind);
        }
        return result;
    };
    Notification.createNext = function (value) {
        return new Notification('N', value);
    };
    Notification.createError = function (err) {
        return new Notification('E', undefined, err);
    };
    Notification.createComplete = function () {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    return Notification;
}());
exports.Notification = Notification;
function observeNotification(notification, observer) {
    var _a, _b, _c;
    var _d = notification, kind = _d.kind, value = _d.value, error = _d.error;
    if (typeof kind !== 'string') {
        throw new TypeError('Invalid notification, missing "kind"');
    }
    kind === 'N' ? (_a = observer.next) === null || _a === void 0 ? void 0 : _a.call(observer, value) : kind === 'E' ? (_b = observer.error) === null || _b === void 0 ? void 0 : _b.call(observer, error) : (_c = observer.complete) === null || _c === void 0 ? void 0 : _c.call(observer);
}
exports.observeNotification = observeNotification;
//# sourceMappingURL=Notification.js.map

}),
26441: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createNotification = exports.nextNotification = exports.errorNotification = exports.COMPLETE_NOTIFICATION = void 0;
exports.COMPLETE_NOTIFICATION = (function () { return createNotification('C', undefined, undefined); })();
function errorNotification(error) {
    return createNotification('E', undefined, error);
}
exports.errorNotification = errorNotification;
function nextNotification(value) {
    return createNotification('N', value, undefined);
}
exports.nextNotification = nextNotification;
function createNotification(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error,
    };
}
exports.createNotification = createNotification;
//# sourceMappingURL=NotificationFactories.js.map

}),
18547: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Observable = void 0;
var Subscriber_1 = __webpack_require__(87378);
var Subscription_1 = __webpack_require__(68631);
var observable_1 = __webpack_require__(58432);
var pipe_1 = __webpack_require__(27754);
var config_1 = __webpack_require__(56622);
var isFunction_1 = __webpack_require__(64061);
var errorContext_1 = __webpack_require__(40021);
var Observable = (function () {
    function Observable(subscribe) {
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var _this = this;
        var subscriber = isSubscriber(observerOrNext) ? observerOrNext : new Subscriber_1.SafeSubscriber(observerOrNext, error, complete);
        errorContext_1.errorContext(function () {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator
                ?
                    operator.call(subscriber, source)
                : source
                    ?
                        _this._subscribe(subscriber)
                    :
                        _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function (next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var subscriber = new Subscriber_1.SafeSubscriber({
                next: function (value) {
                    try {
                        next(value);
                    }
                    catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve,
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[observable_1.observable] = function () {
        return this;
    };
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i] = arguments[_i];
        }
        return pipe_1.pipeFromArray(operations)(this);
    };
    Observable.prototype.toPromise = function (promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return (value = x); }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());
exports.Observable = Observable;
function getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : config_1.config.Promise) !== null && _a !== void 0 ? _a : Promise;
}
function isObserver(value) {
    return value && isFunction_1.isFunction(value.next) && isFunction_1.isFunction(value.error) && isFunction_1.isFunction(value.complete);
}
function isSubscriber(value) {
    return (value && value instanceof Subscriber_1.Subscriber) || (isObserver(value) && Subscription_1.isSubscription(value));
}
//# sourceMappingURL=Observable.js.map

}),
68838: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ReplaySubject = void 0;
var Subject_1 = __webpack_require__(30250);
var dateTimestampProvider_1 = __webpack_require__(37300);
var ReplaySubject = (function (_super) {
    __extends(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) { _bufferSize = Infinity; }
        if (_windowTime === void 0) { _windowTime = Infinity; }
        if (_timestampProvider === void 0) { _timestampProvider = dateTimestampProvider_1.dateTimestampProvider; }
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
    }
    ReplaySubject.prototype.next = function (value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
            _buffer.push(value);
            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function (subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for (var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2) {
            subscriber.next(copy[i]);
        }
        this._checkFinalizedStatuses(subscriber);
        return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function () {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
            var now = _timestampProvider.now();
            var last = 0;
            for (var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2) {
                last = i;
            }
            last && _buffer.splice(0, last + 1);
        }
    };
    return ReplaySubject;
}(Subject_1.Subject));
exports.ReplaySubject = ReplaySubject;
//# sourceMappingURL=ReplaySubject.js.map

}),
86694: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Scheduler = void 0;
var dateTimestampProvider_1 = __webpack_require__(37300);
var Scheduler = (function () {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) { now = Scheduler.now; }
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) { delay = 0; }
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = dateTimestampProvider_1.dateTimestampProvider.now;
    return Scheduler;
}());
exports.Scheduler = Scheduler;
//# sourceMappingURL=Scheduler.js.map

}),
30250: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AnonymousSubject = exports.Subject = void 0;
var Observable_1 = __webpack_require__(18547);
var Subscription_1 = __webpack_require__(68631);
var ObjectUnsubscribedError_1 = __webpack_require__(15993);
var arrRemove_1 = __webpack_require__(59836);
var errorContext_1 = __webpack_require__(40021);
var Subject = (function (_super) {
    __extends(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function (operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function () {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
    };
    Subject.prototype.next = function (value) {
        var _this = this;
        errorContext_1.errorContext(function () {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) {
                    _this.currentObservers = Array.from(_this.observers);
                }
                try {
                    for (var _b = __values(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var observer = _c.value;
                        observer.next(value);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        });
    };
    Subject.prototype.error = function (err) {
        var _this = this;
        errorContext_1.errorContext(function () {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while (observers.length) {
                    observers.shift().error(err);
                }
            }
        });
    };
    Subject.prototype.complete = function () {
        var _this = this;
        errorContext_1.errorContext(function () {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while (observers.length) {
                    observers.shift().complete();
                }
            }
        });
    };
    Subject.prototype.unsubscribe = function () {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function () {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function (subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function (subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function (subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) {
            return Subscription_1.EMPTY_SUBSCRIPTION;
        }
        this.currentObservers = null;
        observers.push(subscriber);
        return new Subscription_1.Subscription(function () {
            _this.currentObservers = null;
            arrRemove_1.arrRemove(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function (subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) {
            subscriber.error(thrownError);
        }
        else if (isStopped) {
            subscriber.complete();
        }
    };
    Subject.prototype.asObservable = function () {
        var observable = new Observable_1.Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}(Observable_1.Observable));
exports.Subject = Subject;
var AnonymousSubject = (function (_super) {
    __extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function (value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function (err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function () {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function (subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : Subscription_1.EMPTY_SUBSCRIPTION;
    };
    return AnonymousSubject;
}(Subject));
exports.AnonymousSubject = AnonymousSubject;
//# sourceMappingURL=Subject.js.map

}),
87378: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EMPTY_OBSERVER = exports.SafeSubscriber = exports.Subscriber = void 0;
var isFunction_1 = __webpack_require__(64061);
var Subscription_1 = __webpack_require__(68631);
var config_1 = __webpack_require__(56622);
var reportUnhandledError_1 = __webpack_require__(86723);
var noop_1 = __webpack_require__(72777);
var NotificationFactories_1 = __webpack_require__(26441);
var timeoutProvider_1 = __webpack_require__(80933);
var errorContext_1 = __webpack_require__(40021);
var Subscriber = (function (_super) {
    __extends(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if (Subscription_1.isSubscription(destination)) {
                destination.add(_this);
            }
        }
        else {
            _this.destination = exports.EMPTY_OBSERVER;
        }
        return _this;
    }
    Subscriber.create = function (next, error, complete) {
        return new SafeSubscriber(next, error, complete);
    };
    Subscriber.prototype.next = function (value) {
        if (this.isStopped) {
            handleStoppedNotification(NotificationFactories_1.nextNotification(value), this);
        }
        else {
            this._next(value);
        }
    };
    Subscriber.prototype.error = function (err) {
        if (this.isStopped) {
            handleStoppedNotification(NotificationFactories_1.errorNotification(err), this);
        }
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function () {
        if (this.isStopped) {
            handleStoppedNotification(NotificationFactories_1.COMPLETE_NOTIFICATION, this);
        }
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        try {
            this.destination.error(err);
        }
        finally {
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function () {
        try {
            this.destination.complete();
        }
        finally {
            this.unsubscribe();
        }
    };
    return Subscriber;
}(Subscription_1.Subscription));
exports.Subscriber = Subscriber;
var _bind = Function.prototype.bind;
function bind(fn, thisArg) {
    return _bind.call(fn, thisArg);
}
var ConsumerObserver = (function () {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function (value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) {
            try {
                partialObserver.next(value);
            }
            catch (error) {
                handleUnhandledError(error);
            }
        }
    };
    ConsumerObserver.prototype.error = function (err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) {
            try {
                partialObserver.error(err);
            }
            catch (error) {
                handleUnhandledError(error);
            }
        }
        else {
            handleUnhandledError(err);
        }
    };
    ConsumerObserver.prototype.complete = function () {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) {
            try {
                partialObserver.complete();
            }
            catch (error) {
                handleUnhandledError(error);
            }
        }
    };
    return ConsumerObserver;
}());
var SafeSubscriber = (function (_super) {
    __extends(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if (isFunction_1.isFunction(observerOrNext) || !observerOrNext) {
            partialObserver = {
                next: (observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined),
                error: error !== null && error !== void 0 ? error : undefined,
                complete: complete !== null && complete !== void 0 ? complete : undefined,
            };
        }
        else {
            var context_1;
            if (_this && config_1.config.useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function () { return _this.unsubscribe(); };
                partialObserver = {
                    next: observerOrNext.next && bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && bind(observerOrNext.complete, context_1),
                };
            }
            else {
                partialObserver = observerOrNext;
            }
        }
        _this.destination = new ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}(Subscriber));
exports.SafeSubscriber = SafeSubscriber;
function handleUnhandledError(error) {
    if (config_1.config.useDeprecatedSynchronousErrorHandling) {
        errorContext_1.captureError(error);
    }
    else {
        reportUnhandledError_1.reportUnhandledError(error);
    }
}
function defaultErrorHandler(err) {
    throw err;
}
function handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = config_1.config.onStoppedNotification;
    onStoppedNotification && timeoutProvider_1.timeoutProvider.setTimeout(function () { return onStoppedNotification(notification, subscriber); });
}
exports.EMPTY_OBSERVER = {
    closed: true,
    next: noop_1.noop,
    error: defaultErrorHandler,
    complete: noop_1.noop,
};
//# sourceMappingURL=Subscriber.js.map

}),
68631: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isSubscription = exports.EMPTY_SUBSCRIPTION = exports.Subscription = void 0;
var isFunction_1 = __webpack_require__(64061);
var UnsubscriptionError_1 = __webpack_require__(88829);
var arrRemove_1 = __webpack_require__(59836);
var Subscription = (function () {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function () {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) {
                    try {
                        for (var _parentage_1 = __values(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()) {
                            var parent_1 = _parentage_1_1.value;
                            parent_1.remove(this);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                else {
                    _parentage.remove(this);
                }
            }
            var initialFinalizer = this.initialTeardown;
            if (isFunction_1.isFunction(initialFinalizer)) {
                try {
                    initialFinalizer();
                }
                catch (e) {
                    errors = e instanceof UnsubscriptionError_1.UnsubscriptionError ? e.errors : [e];
                }
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for (var _finalizers_1 = __values(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()) {
                        var finalizer = _finalizers_1_1.value;
                        try {
                            execFinalizer(finalizer);
                        }
                        catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
                                errors = __spreadArray(__spreadArray([], __read(errors)), __read(err.errors));
                            }
                            else {
                                errors.push(err);
                            }
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
            if (errors) {
                throw new UnsubscriptionError_1.UnsubscriptionError(errors);
            }
        }
    };
    Subscription.prototype.add = function (teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) {
                execFinalizer(teardown);
            }
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) {
                        return;
                    }
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function (parent) {
        var _parentage = this._parentage;
        return _parentage === parent || (Array.isArray(_parentage) && _parentage.includes(parent));
    };
    Subscription.prototype._addParent = function (parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [_parentage, parent] : parent;
    };
    Subscription.prototype._removeParent = function (parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) {
            this._parentage = null;
        }
        else if (Array.isArray(_parentage)) {
            arrRemove_1.arrRemove(_parentage, parent);
        }
    };
    Subscription.prototype.remove = function (teardown) {
        var _finalizers = this._finalizers;
        _finalizers && arrRemove_1.arrRemove(_finalizers, teardown);
        if (teardown instanceof Subscription) {
            teardown._removeParent(this);
        }
    };
    Subscription.EMPTY = (function () {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    })();
    return Subscription;
}());
exports.Subscription = Subscription;
exports.EMPTY_SUBSCRIPTION = Subscription.EMPTY;
function isSubscription(value) {
    return (value instanceof Subscription ||
        (value && 'closed' in value && isFunction_1.isFunction(value.remove) && isFunction_1.isFunction(value.add) && isFunction_1.isFunction(value.unsubscribe)));
}
exports.isSubscription = isSubscription;
function execFinalizer(finalizer) {
    if (isFunction_1.isFunction(finalizer)) {
        finalizer();
    }
    else {
        finalizer.unsubscribe();
    }
}
//# sourceMappingURL=Subscription.js.map

}),
56622: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.config = void 0;
exports.config = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false,
};
//# sourceMappingURL=config.js.map

}),
15783: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.firstValueFrom = void 0;
var EmptyError_1 = __webpack_require__(20431);
var Subscriber_1 = __webpack_require__(87378);
function firstValueFrom(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function (resolve, reject) {
        var subscriber = new Subscriber_1.SafeSubscriber({
            next: function (value) {
                resolve(value);
                subscriber.unsubscribe();
            },
            error: reject,
            complete: function () {
                if (hasConfig) {
                    resolve(config.defaultValue);
                }
                else {
                    reject(new EmptyError_1.EmptyError());
                }
            },
        });
        source.subscribe(subscriber);
    });
}
exports.firstValueFrom = firstValueFrom;
//# sourceMappingURL=firstValueFrom.js.map

}),
3109: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.lastValueFrom = void 0;
var EmptyError_1 = __webpack_require__(20431);
function lastValueFrom(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function (resolve, reject) {
        var _hasValue = false;
        var _value;
        source.subscribe({
            next: function (value) {
                _value = value;
                _hasValue = true;
            },
            error: reject,
            complete: function () {
                if (_hasValue) {
                    resolve(_value);
                }
                else if (hasConfig) {
                    resolve(config.defaultValue);
                }
                else {
                    reject(new EmptyError_1.EmptyError());
                }
            },
        });
    });
}
exports.lastValueFrom = lastValueFrom;
//# sourceMappingURL=lastValueFrom.js.map

}),
23987: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ConnectableObservable = void 0;
var Observable_1 = __webpack_require__(18547);
var Subscription_1 = __webpack_require__(68631);
var refCount_1 = __webpack_require__(17988);
var OperatorSubscriber_1 = __webpack_require__(11729);
var lift_1 = __webpack_require__(54360);
var ConnectableObservable = (function (_super) {
    __extends(ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._subject = null;
        _this._refCount = 0;
        _this._connection = null;
        if (lift_1.hasLift(source)) {
            _this.lift = source.lift;
        }
        return _this;
    }
    ConnectableObservable.prototype._subscribe = function (subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function () {
        var subject = this._subject;
        if (!subject || subject.isStopped) {
            this._subject = this.subjectFactory();
        }
        return this._subject;
    };
    ConnectableObservable.prototype._teardown = function () {
        this._refCount = 0;
        var _connection = this._connection;
        this._subject = this._connection = null;
        _connection === null || _connection === void 0 ? void 0 : _connection.unsubscribe();
    };
    ConnectableObservable.prototype.connect = function () {
        var _this = this;
        var connection = this._connection;
        if (!connection) {
            connection = this._connection = new Subscription_1.Subscription();
            var subject_1 = this.getSubject();
            connection.add(this.source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subject_1, undefined, function () {
                _this._teardown();
                subject_1.complete();
            }, function (err) {
                _this._teardown();
                subject_1.error(err);
            }, function () { return _this._teardown(); })));
            if (connection.closed) {
                this._connection = null;
                connection = Subscription_1.Subscription.EMPTY;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function () {
        return refCount_1.refCount()(this);
    };
    return ConnectableObservable;
}(Observable_1.Observable));
exports.ConnectableObservable = ConnectableObservable;
//# sourceMappingURL=ConnectableObservable.js.map

}),
4723: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.bindCallback = void 0;
var bindCallbackInternals_1 = __webpack_require__(48383);
function bindCallback(callbackFunc, resultSelector, scheduler) {
    return bindCallbackInternals_1.bindCallbackInternals(false, callbackFunc, resultSelector, scheduler);
}
exports.bindCallback = bindCallback;
//# sourceMappingURL=bindCallback.js.map

}),
48383: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.bindCallbackInternals = void 0;
var isScheduler_1 = __webpack_require__(11611);
var Observable_1 = __webpack_require__(18547);
var subscribeOn_1 = __webpack_require__(91205);
var mapOneOrManyArgs_1 = __webpack_require__(92869);
var observeOn_1 = __webpack_require__(89329);
var AsyncSubject_1 = __webpack_require__(65076);
function bindCallbackInternals(isNodeStyle, callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if (isScheduler_1.isScheduler(resultSelector)) {
            scheduler = resultSelector;
        }
        else {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return bindCallbackInternals(isNodeStyle, callbackFunc, scheduler)
                    .apply(this, args)
                    .pipe(mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector));
            };
        }
    }
    if (scheduler) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return bindCallbackInternals(isNodeStyle, callbackFunc)
                .apply(this, args)
                .pipe(subscribeOn_1.subscribeOn(scheduler), observeOn_1.observeOn(scheduler));
        };
    }
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var subject = new AsyncSubject_1.AsyncSubject();
        var uninitialized = true;
        return new Observable_1.Observable(function (subscriber) {
            var subs = subject.subscribe(subscriber);
            if (uninitialized) {
                uninitialized = false;
                var isAsync_1 = false;
                var isComplete_1 = false;
                callbackFunc.apply(_this, __spreadArray(__spreadArray([], __read(args)), [
                    function () {
                        var results = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            results[_i] = arguments[_i];
                        }
                        if (isNodeStyle) {
                            var err = results.shift();
                            if (err != null) {
                                subject.error(err);
                                return;
                            }
                        }
                        subject.next(1 < results.length ? results : results[0]);
                        isComplete_1 = true;
                        if (isAsync_1) {
                            subject.complete();
                        }
                    },
                ]));
                if (isComplete_1) {
                    subject.complete();
                }
                isAsync_1 = true;
            }
            return subs;
        });
    };
}
exports.bindCallbackInternals = bindCallbackInternals;
//# sourceMappingURL=bindCallbackInternals.js.map

}),
84646: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.bindNodeCallback = void 0;
var bindCallbackInternals_1 = __webpack_require__(48383);
function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
    return bindCallbackInternals_1.bindCallbackInternals(true, callbackFunc, resultSelector, scheduler);
}
exports.bindNodeCallback = bindNodeCallback;
//# sourceMappingURL=bindNodeCallback.js.map

}),
94331: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.combineLatestInit = exports.combineLatest = void 0;
var Observable_1 = __webpack_require__(18547);
var argsArgArrayOrObject_1 = __webpack_require__(36795);
var from_1 = __webpack_require__(16609);
var identity_1 = __webpack_require__(6033);
var mapOneOrManyArgs_1 = __webpack_require__(92869);
var args_1 = __webpack_require__(84446);
var createObject_1 = __webpack_require__(54690);
var OperatorSubscriber_1 = __webpack_require__(11729);
var executeSchedule_1 = __webpack_require__(98726);
function combineLatest() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = args_1.popScheduler(args);
    var resultSelector = args_1.popResultSelector(args);
    var _a = argsArgArrayOrObject_1.argsArgArrayOrObject(args), observables = _a.args, keys = _a.keys;
    if (observables.length === 0) {
        return from_1.from([], scheduler);
    }
    var result = new Observable_1.Observable(combineLatestInit(observables, scheduler, keys
        ?
            function (values) { return createObject_1.createObject(keys, values); }
        :
            identity_1.identity));
    return resultSelector ? result.pipe(mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector)) : result;
}
exports.combineLatest = combineLatest;
function combineLatestInit(observables, scheduler, valueTransform) {
    if (valueTransform === void 0) { valueTransform = identity_1.identity; }
    return function (subscriber) {
        maybeSchedule(scheduler, function () {
            var length = observables.length;
            var values = new Array(length);
            var active = length;
            var remainingFirstValues = length;
            var _loop_1 = function (i) {
                maybeSchedule(scheduler, function () {
                    var source = from_1.from(observables[i], scheduler);
                    var hasFirstValue = false;
                    source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
                        values[i] = value;
                        if (!hasFirstValue) {
                            hasFirstValue = true;
                            remainingFirstValues--;
                        }
                        if (!remainingFirstValues) {
                            subscriber.next(valueTransform(values.slice()));
                        }
                    }, function () {
                        if (!--active) {
                            subscriber.complete();
                        }
                    }));
                }, subscriber);
            };
            for (var i = 0; i < length; i++) {
                _loop_1(i);
            }
        }, subscriber);
    };
}
exports.combineLatestInit = combineLatestInit;
function maybeSchedule(scheduler, execute, subscription) {
    if (scheduler) {
        executeSchedule_1.executeSchedule(subscription, scheduler, execute);
    }
    else {
        execute();
    }
}
//# sourceMappingURL=combineLatest.js.map

}),
29982: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.concat = void 0;
var concatAll_1 = __webpack_require__(84438);
var args_1 = __webpack_require__(84446);
var from_1 = __webpack_require__(16609);
function concat() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return concatAll_1.concatAll()(from_1.from(args, args_1.popScheduler(args)));
}
exports.concat = concat;
//# sourceMappingURL=concat.js.map

}),
54907: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.connectable = void 0;
var Subject_1 = __webpack_require__(30250);
var Observable_1 = __webpack_require__(18547);
var defer_1 = __webpack_require__(80363);
var DEFAULT_CONFIG = {
    connector: function () { return new Subject_1.Subject(); },
    resetOnDisconnect: true,
};
function connectable(source, config) {
    if (config === void 0) { config = DEFAULT_CONFIG; }
    var connection = null;
    var connector = config.connector, _a = config.resetOnDisconnect, resetOnDisconnect = _a === void 0 ? true : _a;
    var subject = connector();
    var result = new Observable_1.Observable(function (subscriber) {
        return subject.subscribe(subscriber);
    });
    result.connect = function () {
        if (!connection || connection.closed) {
            connection = defer_1.defer(function () { return source; }).subscribe(subject);
            if (resetOnDisconnect) {
                connection.add(function () { return (subject = connector()); });
            }
        }
        return connection;
    };
    return result;
}
exports.connectable = connectable;
//# sourceMappingURL=connectable.js.map

}),
80363: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defer = void 0;
var Observable_1 = __webpack_require__(18547);
var innerFrom_1 = __webpack_require__(68196);
function defer(observableFactory) {
    return new Observable_1.Observable(function (subscriber) {
        innerFrom_1.innerFrom(observableFactory()).subscribe(subscriber);
    });
}
exports.defer = defer;
//# sourceMappingURL=defer.js.map

}),
1411: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.animationFrames = void 0;
var Observable_1 = __webpack_require__(18547);
var performanceTimestampProvider_1 = __webpack_require__(87731);
var animationFrameProvider_1 = __webpack_require__(85158);
function animationFrames(timestampProvider) {
    return timestampProvider ? animationFramesFactory(timestampProvider) : DEFAULT_ANIMATION_FRAMES;
}
exports.animationFrames = animationFrames;
function animationFramesFactory(timestampProvider) {
    return new Observable_1.Observable(function (subscriber) {
        var provider = timestampProvider || performanceTimestampProvider_1.performanceTimestampProvider;
        var start = provider.now();
        var id = 0;
        var run = function () {
            if (!subscriber.closed) {
                id = animationFrameProvider_1.animationFrameProvider.requestAnimationFrame(function (timestamp) {
                    id = 0;
                    var now = provider.now();
                    subscriber.next({
                        timestamp: timestampProvider ? now : timestamp,
                        elapsed: now - start,
                    });
                    run();
                });
            }
        };
        run();
        return function () {
            if (id) {
                animationFrameProvider_1.animationFrameProvider.cancelAnimationFrame(id);
            }
        };
    });
}
var DEFAULT_ANIMATION_FRAMES = animationFramesFactory();
//# sourceMappingURL=animationFrames.js.map

}),
88930: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.empty = exports.EMPTY = void 0;
var Observable_1 = __webpack_require__(18547);
exports.EMPTY = new Observable_1.Observable(function (subscriber) { return subscriber.complete(); });
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : exports.EMPTY;
}
exports.empty = empty;
function emptyScheduled(scheduler) {
    return new Observable_1.Observable(function (subscriber) { return scheduler.schedule(function () { return subscriber.complete(); }); });
}
//# sourceMappingURL=empty.js.map

}),
20524: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.forkJoin = void 0;
var Observable_1 = __webpack_require__(18547);
var argsArgArrayOrObject_1 = __webpack_require__(36795);
var innerFrom_1 = __webpack_require__(68196);
var args_1 = __webpack_require__(84446);
var OperatorSubscriber_1 = __webpack_require__(11729);
var mapOneOrManyArgs_1 = __webpack_require__(92869);
var createObject_1 = __webpack_require__(54690);
function forkJoin() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var resultSelector = args_1.popResultSelector(args);
    var _a = argsArgArrayOrObject_1.argsArgArrayOrObject(args), sources = _a.args, keys = _a.keys;
    var result = new Observable_1.Observable(function (subscriber) {
        var length = sources.length;
        if (!length) {
            subscriber.complete();
            return;
        }
        var values = new Array(length);
        var remainingCompletions = length;
        var remainingEmissions = length;
        var _loop_1 = function (sourceIndex) {
            var hasValue = false;
            innerFrom_1.innerFrom(sources[sourceIndex]).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
                if (!hasValue) {
                    hasValue = true;
                    remainingEmissions--;
                }
                values[sourceIndex] = value;
            }, function () { return remainingCompletions--; }, undefined, function () {
                if (!remainingCompletions || !hasValue) {
                    if (!remainingEmissions) {
                        subscriber.next(keys ? createObject_1.createObject(keys, values) : values);
                    }
                    subscriber.complete();
                }
            }));
        };
        for (var sourceIndex = 0; sourceIndex < length; sourceIndex++) {
            _loop_1(sourceIndex);
        }
    });
    return resultSelector ? result.pipe(mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector)) : result;
}
exports.forkJoin = forkJoin;
//# sourceMappingURL=forkJoin.js.map

}),
16609: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.from = void 0;
var scheduled_1 = __webpack_require__(29143);
var innerFrom_1 = __webpack_require__(68196);
function from(input, scheduler) {
    return scheduler ? scheduled_1.scheduled(input, scheduler) : innerFrom_1.innerFrom(input);
}
exports.from = from;
//# sourceMappingURL=from.js.map

}),
86983: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromEvent = void 0;
var innerFrom_1 = __webpack_require__(68196);
var Observable_1 = __webpack_require__(18547);
var mergeMap_1 = __webpack_require__(18244);
var isArrayLike_1 = __webpack_require__(79128);
var isFunction_1 = __webpack_require__(64061);
var mapOneOrManyArgs_1 = __webpack_require__(92869);
var nodeEventEmitterMethods = ['addListener', 'removeListener'];
var eventTargetMethods = ['addEventListener', 'removeEventListener'];
var jqueryMethods = ['on', 'off'];
function fromEvent(target, eventName, options, resultSelector) {
    if (isFunction_1.isFunction(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) {
        return fromEvent(target, eventName, options).pipe(mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector));
    }
    var _a = __read(isEventTarget(target)
        ? eventTargetMethods.map(function (methodName) { return function (handler) { return target[methodName](eventName, handler, options); }; })
        :
            isNodeStyleEventEmitter(target)
                ? nodeEventEmitterMethods.map(toCommonHandlerRegistry(target, eventName))
                : isJQueryStyleEventEmitter(target)
                    ? jqueryMethods.map(toCommonHandlerRegistry(target, eventName))
                    : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if (isArrayLike_1.isArrayLike(target)) {
            return mergeMap_1.mergeMap(function (subTarget) { return fromEvent(subTarget, eventName, options); })(innerFrom_1.innerFrom(target));
        }
    }
    if (!add) {
        throw new TypeError('Invalid event target');
    }
    return new Observable_1.Observable(function (subscriber) {
        var handler = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function () { return remove(handler); };
    });
}
exports.fromEvent = fromEvent;
function toCommonHandlerRegistry(target, eventName) {
    return function (methodName) { return function (handler) { return target[methodName](eventName, handler); }; };
}
function isNodeStyleEventEmitter(target) {
    return isFunction_1.isFunction(target.addListener) && isFunction_1.isFunction(target.removeListener);
}
function isJQueryStyleEventEmitter(target) {
    return isFunction_1.isFunction(target.on) && isFunction_1.isFunction(target.off);
}
function isEventTarget(target) {
    return isFunction_1.isFunction(target.addEventListener) && isFunction_1.isFunction(target.removeEventListener);
}
//# sourceMappingURL=fromEvent.js.map

}),
22791: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromEventPattern = void 0;
var Observable_1 = __webpack_require__(18547);
var isFunction_1 = __webpack_require__(64061);
var mapOneOrManyArgs_1 = __webpack_require__(92869);
function fromEventPattern(addHandler, removeHandler, resultSelector) {
    if (resultSelector) {
        return fromEventPattern(addHandler, removeHandler).pipe(mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector));
    }
    return new Observable_1.Observable(function (subscriber) {
        var handler = function () {
            var e = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                e[_i] = arguments[_i];
            }
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue = addHandler(handler);
        return isFunction_1.isFunction(removeHandler) ? function () { return removeHandler(handler, retValue); } : undefined;
    });
}
exports.fromEventPattern = fromEventPattern;
//# sourceMappingURL=fromEventPattern.js.map

}),
76445: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromSubscribable = void 0;
var Observable_1 = __webpack_require__(18547);
function fromSubscribable(subscribable) {
    return new Observable_1.Observable(function (subscriber) { return subscribable.subscribe(subscriber); });
}
exports.fromSubscribable = fromSubscribable;
//# sourceMappingURL=fromSubscribable.js.map

}),
90884: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.generate = void 0;
var identity_1 = __webpack_require__(6033);
var isScheduler_1 = __webpack_require__(11611);
var defer_1 = __webpack_require__(80363);
var scheduleIterable_1 = __webpack_require__(35955);
function generate(initialStateOrOptions, condition, iterate, resultSelectorOrScheduler, scheduler) {
    var _a, _b;
    var resultSelector;
    var initialState;
    if (arguments.length === 1) {
        (_a = initialStateOrOptions, initialState = _a.initialState, condition = _a.condition, iterate = _a.iterate, _b = _a.resultSelector, resultSelector = _b === void 0 ? identity_1.identity : _b, scheduler = _a.scheduler);
    }
    else {
        initialState = initialStateOrOptions;
        if (!resultSelectorOrScheduler || isScheduler_1.isScheduler(resultSelectorOrScheduler)) {
            resultSelector = identity_1.identity;
            scheduler = resultSelectorOrScheduler;
        }
        else {
            resultSelector = resultSelectorOrScheduler;
        }
    }
    function gen() {
        var state;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = initialState;
                    _a.label = 1;
                case 1:
                    if (!(!condition || condition(state))) return [3, 4];
                    return [4, resultSelector(state)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    state = iterate(state);
                    return [3, 1];
                case 4: return [2];
            }
        });
    }
    return defer_1.defer((scheduler
        ?
            function () { return scheduleIterable_1.scheduleIterable(gen(), scheduler); }
        :
            gen));
}
exports.generate = generate;
//# sourceMappingURL=generate.js.map

}),
77958: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.iif = void 0;
var defer_1 = __webpack_require__(80363);
function iif(condition, trueResult, falseResult) {
    return defer_1.defer(function () { return (condition() ? trueResult : falseResult); });
}
exports.iif = iif;
//# sourceMappingURL=iif.js.map

}),
68196: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromReadableStreamLike = exports.fromAsyncIterable = exports.fromIterable = exports.fromPromise = exports.fromArrayLike = exports.fromInteropObservable = exports.innerFrom = void 0;
var isArrayLike_1 = __webpack_require__(79128);
var isPromise_1 = __webpack_require__(94283);
var Observable_1 = __webpack_require__(18547);
var isInteropObservable_1 = __webpack_require__(78244);
var isAsyncIterable_1 = __webpack_require__(18806);
var throwUnobservableError_1 = __webpack_require__(76282);
var isIterable_1 = __webpack_require__(14886);
var isReadableStreamLike_1 = __webpack_require__(70393);
var isFunction_1 = __webpack_require__(64061);
var reportUnhandledError_1 = __webpack_require__(86723);
var observable_1 = __webpack_require__(58432);
function innerFrom(input) {
    if (input instanceof Observable_1.Observable) {
        return input;
    }
    if (input != null) {
        if (isInteropObservable_1.isInteropObservable(input)) {
            return fromInteropObservable(input);
        }
        if (isArrayLike_1.isArrayLike(input)) {
            return fromArrayLike(input);
        }
        if (isPromise_1.isPromise(input)) {
            return fromPromise(input);
        }
        if (isAsyncIterable_1.isAsyncIterable(input)) {
            return fromAsyncIterable(input);
        }
        if (isIterable_1.isIterable(input)) {
            return fromIterable(input);
        }
        if (isReadableStreamLike_1.isReadableStreamLike(input)) {
            return fromReadableStreamLike(input);
        }
    }
    throw throwUnobservableError_1.createInvalidObservableTypeError(input);
}
exports.innerFrom = innerFrom;
function fromInteropObservable(obj) {
    return new Observable_1.Observable(function (subscriber) {
        var obs = obj[observable_1.observable]();
        if (isFunction_1.isFunction(obs.subscribe)) {
            return obs.subscribe(subscriber);
        }
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
exports.fromInteropObservable = fromInteropObservable;
function fromArrayLike(array) {
    return new Observable_1.Observable(function (subscriber) {
        for (var i = 0; i < array.length && !subscriber.closed; i++) {
            subscriber.next(array[i]);
        }
        subscriber.complete();
    });
}
exports.fromArrayLike = fromArrayLike;
function fromPromise(promise) {
    return new Observable_1.Observable(function (subscriber) {
        promise
            .then(function (value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function (err) { return subscriber.error(err); })
            .then(null, reportUnhandledError_1.reportUnhandledError);
    });
}
exports.fromPromise = fromPromise;
function fromIterable(iterable) {
    return new Observable_1.Observable(function (subscriber) {
        var e_1, _a;
        try {
            for (var iterable_1 = __values(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()) {
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) {
                    return;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        subscriber.complete();
    });
}
exports.fromIterable = fromIterable;
function fromAsyncIterable(asyncIterable) {
    return new Observable_1.Observable(function (subscriber) {
        process(asyncIterable, subscriber).catch(function (err) { return subscriber.error(err); });
    });
}
exports.fromAsyncIterable = fromAsyncIterable;
function fromReadableStreamLike(readableStream) {
    return fromAsyncIterable(isReadableStreamLike_1.readableStreamLikeToAsyncGenerator(readableStream));
}
exports.fromReadableStreamLike = fromReadableStreamLike;
function process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return __awaiter(this, void 0, void 0, function () {
        var value, e_2_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, 6, 11]);
                    asyncIterable_1 = __asyncValues(asyncIterable);
                    _b.label = 1;
                case 1: return [4, asyncIterable_1.next()];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [3, 4];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) {
                        return [2];
                    }
                    _b.label = 3;
                case 3: return [3, 1];
                case 4: return [3, 11];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = { error: e_2_1 };
                    return [3, 11];
                case 6:
                    _b.trys.push([6, , 9, 10]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [3, 8];
                    return [4, _a.call(asyncIterable_1)];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8: return [3, 10];
                case 9:
                    if (e_2) throw e_2.error;
                    return [7];
                case 10: return [7];
                case 11:
                    subscriber.complete();
                    return [2];
            }
        });
    });
}
//# sourceMappingURL=innerFrom.js.map

}),
88531: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.interval = void 0;
var async_1 = __webpack_require__(6341);
var timer_1 = __webpack_require__(44779);
function interval(period, scheduler) {
    if (period === void 0) { period = 0; }
    if (scheduler === void 0) { scheduler = async_1.asyncScheduler; }
    if (period < 0) {
        period = 0;
    }
    return timer_1.timer(period, period, scheduler);
}
exports.interval = interval;
//# sourceMappingURL=interval.js.map

}),
29835: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.merge = void 0;
var mergeAll_1 = __webpack_require__(21329);
var innerFrom_1 = __webpack_require__(68196);
var empty_1 = __webpack_require__(88930);
var args_1 = __webpack_require__(84446);
var from_1 = __webpack_require__(16609);
function merge() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = args_1.popScheduler(args);
    var concurrent = args_1.popNumber(args, Infinity);
    var sources = args;
    return !sources.length
        ?
            empty_1.EMPTY
        : sources.length === 1
            ?
                innerFrom_1.innerFrom(sources[0])
            :
                mergeAll_1.mergeAll(concurrent)(from_1.from(sources, scheduler));
}
exports.merge = merge;
//# sourceMappingURL=merge.js.map

}),
19945: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.never = exports.NEVER = void 0;
var Observable_1 = __webpack_require__(18547);
var noop_1 = __webpack_require__(72777);
exports.NEVER = new Observable_1.Observable(noop_1.noop);
function never() {
    return exports.NEVER;
}
exports.never = never;
//# sourceMappingURL=never.js.map

}),
27294: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.of = void 0;
var args_1 = __webpack_require__(84446);
var from_1 = __webpack_require__(16609);
function of() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = args_1.popScheduler(args);
    return from_1.from(args, scheduler);
}
exports.of = of;
//# sourceMappingURL=of.js.map

}),
90941: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.onErrorResumeNext = void 0;
var Observable_1 = __webpack_require__(18547);
var argsOrArgArray_1 = __webpack_require__(59925);
var OperatorSubscriber_1 = __webpack_require__(11729);
var noop_1 = __webpack_require__(72777);
var innerFrom_1 = __webpack_require__(68196);
function onErrorResumeNext() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var nextSources = argsOrArgArray_1.argsOrArgArray(sources);
    return new Observable_1.Observable(function (subscriber) {
        var sourceIndex = 0;
        var subscribeNext = function () {
            if (sourceIndex < nextSources.length) {
                var nextSource = void 0;
                try {
                    nextSource = innerFrom_1.innerFrom(nextSources[sourceIndex++]);
                }
                catch (err) {
                    subscribeNext();
                    return;
                }
                var innerSubscriber = new OperatorSubscriber_1.OperatorSubscriber(subscriber, undefined, noop_1.noop, noop_1.noop);
                nextSource.subscribe(innerSubscriber);
                innerSubscriber.add(subscribeNext);
            }
            else {
                subscriber.complete();
            }
        };
        subscribeNext();
    });
}
exports.onErrorResumeNext = onErrorResumeNext;
//# sourceMappingURL=onErrorResumeNext.js.map

}),
31372: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pairs = void 0;
var from_1 = __webpack_require__(16609);
function pairs(obj, scheduler) {
    return from_1.from(Object.entries(obj), scheduler);
}
exports.pairs = pairs;
//# sourceMappingURL=pairs.js.map

}),
45790: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.partition = void 0;
var not_1 = __webpack_require__(59345);
var filter_1 = __webpack_require__(84653);
var innerFrom_1 = __webpack_require__(68196);
function partition(source, predicate, thisArg) {
    return [filter_1.filter(predicate, thisArg)(innerFrom_1.innerFrom(source)), filter_1.filter(not_1.not(predicate, thisArg))(innerFrom_1.innerFrom(source))];
}
exports.partition = partition;
//# sourceMappingURL=partition.js.map

}),
96628: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.raceInit = exports.race = void 0;
var Observable_1 = __webpack_require__(18547);
var innerFrom_1 = __webpack_require__(68196);
var argsOrArgArray_1 = __webpack_require__(59925);
var OperatorSubscriber_1 = __webpack_require__(11729);
function race() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    sources = argsOrArgArray_1.argsOrArgArray(sources);
    return sources.length === 1 ? innerFrom_1.innerFrom(sources[0]) : new Observable_1.Observable(raceInit(sources));
}
exports.race = race;
function raceInit(sources) {
    return function (subscriber) {
        var subscriptions = [];
        var _loop_1 = function (i) {
            subscriptions.push(innerFrom_1.innerFrom(sources[i]).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
                if (subscriptions) {
                    for (var s = 0; s < subscriptions.length; s++) {
                        s !== i && subscriptions[s].unsubscribe();
                    }
                    subscriptions = null;
                }
                subscriber.next(value);
            })));
        };
        for (var i = 0; subscriptions && !subscriber.closed && i < sources.length; i++) {
            _loop_1(i);
        }
    };
}
exports.raceInit = raceInit;
//# sourceMappingURL=race.js.map

}),
65369: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.range = void 0;
var Observable_1 = __webpack_require__(18547);
var empty_1 = __webpack_require__(88930);
function range(start, count, scheduler) {
    if (count == null) {
        count = start;
        start = 0;
    }
    if (count <= 0) {
        return empty_1.EMPTY;
    }
    var end = count + start;
    return new Observable_1.Observable(scheduler
        ?
            function (subscriber) {
                var n = start;
                return scheduler.schedule(function () {
                    if (n < end) {
                        subscriber.next(n++);
                        this.schedule();
                    }
                    else {
                        subscriber.complete();
                    }
                });
            }
        :
            function (subscriber) {
                var n = start;
                while (n < end && !subscriber.closed) {
                    subscriber.next(n++);
                }
                subscriber.complete();
            });
}
exports.range = range;
//# sourceMappingURL=range.js.map

}),
77297: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.throwError = void 0;
var Observable_1 = __webpack_require__(18547);
var isFunction_1 = __webpack_require__(64061);
function throwError(errorOrErrorFactory, scheduler) {
    var errorFactory = isFunction_1.isFunction(errorOrErrorFactory) ? errorOrErrorFactory : function () { return errorOrErrorFactory; };
    var init = function (subscriber) { return subscriber.error(errorFactory()); };
    return new Observable_1.Observable(scheduler ? function (subscriber) { return scheduler.schedule(init, 0, subscriber); } : init);
}
exports.throwError = throwError;
//# sourceMappingURL=throwError.js.map

}),
44779: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.timer = void 0;
var Observable_1 = __webpack_require__(18547);
var async_1 = __webpack_require__(6341);
var isScheduler_1 = __webpack_require__(11611);
var isDate_1 = __webpack_require__(51003);
function timer(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) { dueTime = 0; }
    if (scheduler === void 0) { scheduler = async_1.async; }
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if (isScheduler_1.isScheduler(intervalOrScheduler)) {
            scheduler = intervalOrScheduler;
        }
        else {
            intervalDuration = intervalOrScheduler;
        }
    }
    return new Observable_1.Observable(function (subscriber) {
        var due = isDate_1.isValidDate(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) {
            due = 0;
        }
        var n = 0;
        return scheduler.schedule(function () {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) {
                    this.schedule(undefined, intervalDuration);
                }
                else {
                    subscriber.complete();
                }
            }
        }, due);
    });
}
exports.timer = timer;
//# sourceMappingURL=timer.js.map

}),
81043: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.using = void 0;
var Observable_1 = __webpack_require__(18547);
var innerFrom_1 = __webpack_require__(68196);
var empty_1 = __webpack_require__(88930);
function using(resourceFactory, observableFactory) {
    return new Observable_1.Observable(function (subscriber) {
        var resource = resourceFactory();
        var result = observableFactory(resource);
        var source = result ? innerFrom_1.innerFrom(result) : empty_1.EMPTY;
        source.subscribe(subscriber);
        return function () {
            if (resource) {
                resource.unsubscribe();
            }
        };
    });
}
exports.using = using;
//# sourceMappingURL=using.js.map

}),
14534: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.zip = void 0;
var Observable_1 = __webpack_require__(18547);
var innerFrom_1 = __webpack_require__(68196);
var argsOrArgArray_1 = __webpack_require__(59925);
var empty_1 = __webpack_require__(88930);
var OperatorSubscriber_1 = __webpack_require__(11729);
var args_1 = __webpack_require__(84446);
function zip() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var resultSelector = args_1.popResultSelector(args);
    var sources = argsOrArgArray_1.argsOrArgArray(args);
    return sources.length
        ? new Observable_1.Observable(function (subscriber) {
            var buffers = sources.map(function () { return []; });
            var completed = sources.map(function () { return false; });
            subscriber.add(function () {
                buffers = completed = null;
            });
            var _loop_1 = function (sourceIndex) {
                innerFrom_1.innerFrom(sources[sourceIndex]).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
                    buffers[sourceIndex].push(value);
                    if (buffers.every(function (buffer) { return buffer.length; })) {
                        var result = buffers.map(function (buffer) { return buffer.shift(); });
                        subscriber.next(resultSelector ? resultSelector.apply(void 0, __spreadArray([], __read(result))) : result);
                        if (buffers.some(function (buffer, i) { return !buffer.length && completed[i]; })) {
                            subscriber.complete();
                        }
                    }
                }, function () {
                    completed[sourceIndex] = true;
                    !buffers[sourceIndex].length && subscriber.complete();
                }));
            };
            for (var sourceIndex = 0; !subscriber.closed && sourceIndex < sources.length; sourceIndex++) {
                _loop_1(sourceIndex);
            }
            return function () {
                buffers = completed = null;
            };
        })
        : empty_1.EMPTY;
}
exports.zip = zip;
//# sourceMappingURL=zip.js.map

}),
11729: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.OperatorSubscriber = exports.createOperatorSubscriber = void 0;
var Subscriber_1 = __webpack_require__(87378);
function createOperatorSubscriber(destination, onNext, onComplete, onError, onFinalize) {
    return new OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize);
}
exports.createOperatorSubscriber = createOperatorSubscriber;
var OperatorSubscriber = (function (_super) {
    __extends(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext
            ? function (value) {
                try {
                    onNext(value);
                }
                catch (err) {
                    destination.error(err);
                }
            }
            : _super.prototype._next;
        _this._error = onError
            ? function (err) {
                try {
                    onError(err);
                }
                catch (err) {
                    destination.error(err);
                }
                finally {
                    this.unsubscribe();
                }
            }
            : _super.prototype._error;
        _this._complete = onComplete
            ? function () {
                try {
                    onComplete();
                }
                catch (err) {
                    destination.error(err);
                }
                finally {
                    this.unsubscribe();
                }
            }
            : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function () {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 ? void 0 : _a.call(this));
        }
    };
    return OperatorSubscriber;
}(Subscriber_1.Subscriber));
exports.OperatorSubscriber = OperatorSubscriber;
//# sourceMappingURL=OperatorSubscriber.js.map

}),
49885: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.audit = void 0;
var lift_1 = __webpack_require__(54360);
var innerFrom_1 = __webpack_require__(68196);
var OperatorSubscriber_1 = __webpack_require__(11729);
function audit(durationSelector) {
    return lift_1.operate(function (source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        var durationSubscriber = null;
        var isComplete = false;
        var endDuration = function () {
            durationSubscriber === null || durationSubscriber === void 0 ? void 0 : durationSubscriber.unsubscribe();
            durationSubscriber = null;
            if (hasValue) {
                hasValue = false;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
            isComplete && subscriber.complete();
        };
        var cleanupDuration = function () {
            durationSubscriber = null;
            isComplete && subscriber.complete();
        };
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            hasValue = true;
            lastValue = value;
            if (!durationSubscriber) {
                innerFrom_1.innerFrom(durationSelector(value)).subscribe((durationSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, endDuration, cleanupDuration)));
            }
        }, function () {
            isComplete = true;
            (!hasValue || !durationSubscriber || durationSubscriber.closed) && subscriber.complete();
        }));
    });
}
exports.audit = audit;
//# sourceMappingURL=audit.js.map

}),
32322: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.auditTime = void 0;
var async_1 = __webpack_require__(6341);
var audit_1 = __webpack_require__(49885);
var timer_1 = __webpack_require__(44779);
function auditTime(duration, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.asyncScheduler; }
    return audit_1.audit(function () { return timer_1.timer(duration, scheduler); });
}
exports.auditTime = auditTime;
//# sourceMappingURL=auditTime.js.map

}),
61353: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.buffer = void 0;
var lift_1 = __webpack_require__(54360);
var noop_1 = __webpack_require__(72777);
var OperatorSubscriber_1 = __webpack_require__(11729);
var innerFrom_1 = __webpack_require__(68196);
function buffer(closingNotifier) {
    return lift_1.operate(function (source, subscriber) {
        var currentBuffer = [];
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return currentBuffer.push(value); }, function () {
            subscriber.next(currentBuffer);
            subscriber.complete();
        }));
        innerFrom_1.innerFrom(closingNotifier).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
            var b = currentBuffer;
            currentBuffer = [];
            subscriber.next(b);
        }, noop_1.noop));
        return function () {
            currentBuffer = null;
        };
    });
}
exports.buffer = buffer;
//# sourceMappingURL=buffer.js.map

}),
9956: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.bufferCount = void 0;
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
var arrRemove_1 = __webpack_require__(59836);
function bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) { startBufferEvery = null; }
    startBufferEvery = startBufferEvery !== null && startBufferEvery !== void 0 ? startBufferEvery : bufferSize;
    return lift_1.operate(function (source, subscriber) {
        var buffers = [];
        var count = 0;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            var e_1, _a, e_2, _b;
            var toEmit = null;
            if (count++ % startBufferEvery === 0) {
                buffers.push([]);
            }
            try {
                for (var buffers_1 = __values(buffers), buffers_1_1 = buffers_1.next(); !buffers_1_1.done; buffers_1_1 = buffers_1.next()) {
                    var buffer = buffers_1_1.value;
                    buffer.push(value);
                    if (bufferSize <= buffer.length) {
                        toEmit = toEmit !== null && toEmit !== void 0 ? toEmit : [];
                        toEmit.push(buffer);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (buffers_1_1 && !buffers_1_1.done && (_a = buffers_1.return)) _a.call(buffers_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if (toEmit) {
                try {
                    for (var toEmit_1 = __values(toEmit), toEmit_1_1 = toEmit_1.next(); !toEmit_1_1.done; toEmit_1_1 = toEmit_1.next()) {
                        var buffer = toEmit_1_1.value;
                        arrRemove_1.arrRemove(buffers, buffer);
                        subscriber.next(buffer);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (toEmit_1_1 && !toEmit_1_1.done && (_b = toEmit_1.return)) _b.call(toEmit_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }, function () {
            var e_3, _a;
            try {
                for (var buffers_2 = __values(buffers), buffers_2_1 = buffers_2.next(); !buffers_2_1.done; buffers_2_1 = buffers_2.next()) {
                    var buffer = buffers_2_1.value;
                    subscriber.next(buffer);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (buffers_2_1 && !buffers_2_1.done && (_a = buffers_2.return)) _a.call(buffers_2);
                }
                finally { if (e_3) throw e_3.error; }
            }
            subscriber.complete();
        }, undefined, function () {
            buffers = null;
        }));
    });
}
exports.bufferCount = bufferCount;
//# sourceMappingURL=bufferCount.js.map

}),
61201: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.bufferTime = void 0;
var Subscription_1 = __webpack_require__(68631);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
var arrRemove_1 = __webpack_require__(59836);
var async_1 = __webpack_require__(6341);
var args_1 = __webpack_require__(84446);
var executeSchedule_1 = __webpack_require__(98726);
function bufferTime(bufferTimeSpan) {
    var _a, _b;
    var otherArgs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        otherArgs[_i - 1] = arguments[_i];
    }
    var scheduler = (_a = args_1.popScheduler(otherArgs)) !== null && _a !== void 0 ? _a : async_1.asyncScheduler;
    var bufferCreationInterval = (_b = otherArgs[0]) !== null && _b !== void 0 ? _b : null;
    var maxBufferSize = otherArgs[1] || Infinity;
    return lift_1.operate(function (source, subscriber) {
        var bufferRecords = [];
        var restartOnEmit = false;
        var emit = function (record) {
            var buffer = record.buffer, subs = record.subs;
            subs.unsubscribe();
            arrRemove_1.arrRemove(bufferRecords, record);
            subscriber.next(buffer);
            restartOnEmit && startBuffer();
        };
        var startBuffer = function () {
            if (bufferRecords) {
                var subs = new Subscription_1.Subscription();
                subscriber.add(subs);
                var buffer = [];
                var record_1 = {
                    buffer: buffer,
                    subs: subs,
                };
                bufferRecords.push(record_1);
                executeSchedule_1.executeSchedule(subs, scheduler, function () { return emit(record_1); }, bufferTimeSpan);
            }
        };
        if (bufferCreationInterval !== null && bufferCreationInterval >= 0) {
            executeSchedule_1.executeSchedule(subscriber, scheduler, startBuffer, bufferCreationInterval, true);
        }
        else {
            restartOnEmit = true;
        }
        startBuffer();
        var bufferTimeSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            var e_1, _a;
            var recordsCopy = bufferRecords.slice();
            try {
                for (var recordsCopy_1 = __values(recordsCopy), recordsCopy_1_1 = recordsCopy_1.next(); !recordsCopy_1_1.done; recordsCopy_1_1 = recordsCopy_1.next()) {
                    var record = recordsCopy_1_1.value;
                    var buffer = record.buffer;
                    buffer.push(value);
                    maxBufferSize <= buffer.length && emit(record);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (recordsCopy_1_1 && !recordsCopy_1_1.done && (_a = recordsCopy_1.return)) _a.call(recordsCopy_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }, function () {
            while (bufferRecords === null || bufferRecords === void 0 ? void 0 : bufferRecords.length) {
                subscriber.next(bufferRecords.shift().buffer);
            }
            bufferTimeSubscriber === null || bufferTimeSubscriber === void 0 ? void 0 : bufferTimeSubscriber.unsubscribe();
            subscriber.complete();
            subscriber.unsubscribe();
        }, undefined, function () { return (bufferRecords = null); });
        source.subscribe(bufferTimeSubscriber);
    });
}
exports.bufferTime = bufferTime;
//# sourceMappingURL=bufferTime.js.map

}),
25843: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.bufferToggle = void 0;
var Subscription_1 = __webpack_require__(68631);
var lift_1 = __webpack_require__(54360);
var innerFrom_1 = __webpack_require__(68196);
var OperatorSubscriber_1 = __webpack_require__(11729);
var noop_1 = __webpack_require__(72777);
var arrRemove_1 = __webpack_require__(59836);
function bufferToggle(openings, closingSelector) {
    return lift_1.operate(function (source, subscriber) {
        var buffers = [];
        innerFrom_1.innerFrom(openings).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (openValue) {
            var buffer = [];
            buffers.push(buffer);
            var closingSubscription = new Subscription_1.Subscription();
            var emitBuffer = function () {
                arrRemove_1.arrRemove(buffers, buffer);
                subscriber.next(buffer);
                closingSubscription.unsubscribe();
            };
            closingSubscription.add(innerFrom_1.innerFrom(closingSelector(openValue)).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, emitBuffer, noop_1.noop)));
        }, noop_1.noop));
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            var e_1, _a;
            try {
                for (var buffers_1 = __values(buffers), buffers_1_1 = buffers_1.next(); !buffers_1_1.done; buffers_1_1 = buffers_1.next()) {
                    var buffer = buffers_1_1.value;
                    buffer.push(value);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (buffers_1_1 && !buffers_1_1.done && (_a = buffers_1.return)) _a.call(buffers_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }, function () {
            while (buffers.length > 0) {
                subscriber.next(buffers.shift());
            }
            subscriber.complete();
        }));
    });
}
exports.bufferToggle = bufferToggle;
//# sourceMappingURL=bufferToggle.js.map

}),
47383: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.bufferWhen = void 0;
var lift_1 = __webpack_require__(54360);
var noop_1 = __webpack_require__(72777);
var OperatorSubscriber_1 = __webpack_require__(11729);
var innerFrom_1 = __webpack_require__(68196);
function bufferWhen(closingSelector) {
    return lift_1.operate(function (source, subscriber) {
        var buffer = null;
        var closingSubscriber = null;
        var openBuffer = function () {
            closingSubscriber === null || closingSubscriber === void 0 ? void 0 : closingSubscriber.unsubscribe();
            var b = buffer;
            buffer = [];
            b && subscriber.next(b);
            innerFrom_1.innerFrom(closingSelector()).subscribe((closingSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, openBuffer, noop_1.noop)));
        };
        openBuffer();
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return buffer === null || buffer === void 0 ? void 0 : buffer.push(value); }, function () {
            buffer && subscriber.next(buffer);
            subscriber.complete();
        }, undefined, function () { return (buffer = closingSubscriber = null); }));
    });
}
exports.bufferWhen = bufferWhen;
//# sourceMappingURL=bufferWhen.js.map

}),
34097: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.catchError = void 0;
var innerFrom_1 = __webpack_require__(68196);
var OperatorSubscriber_1 = __webpack_require__(11729);
var lift_1 = __webpack_require__(54360);
function catchError(selector) {
    return lift_1.operate(function (source, subscriber) {
        var innerSub = null;
        var syncUnsub = false;
        var handledResult;
        innerSub = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, undefined, undefined, function (err) {
            handledResult = innerFrom_1.innerFrom(selector(err, catchError(selector)(source)));
            if (innerSub) {
                innerSub.unsubscribe();
                innerSub = null;
                handledResult.subscribe(subscriber);
            }
            else {
                syncUnsub = true;
            }
        }));
        if (syncUnsub) {
            innerSub.unsubscribe();
            innerSub = null;
            handledResult.subscribe(subscriber);
        }
    });
}
exports.catchError = catchError;
//# sourceMappingURL=catchError.js.map

}),
44740: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.combineAll = void 0;
var combineLatestAll_1 = __webpack_require__(85488);
exports.combineAll = combineLatestAll_1.combineLatestAll;
//# sourceMappingURL=combineAll.js.map

}),
96486: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.combineLatest = void 0;
var combineLatest_1 = __webpack_require__(94331);
var lift_1 = __webpack_require__(54360);
var argsOrArgArray_1 = __webpack_require__(59925);
var mapOneOrManyArgs_1 = __webpack_require__(92869);
var pipe_1 = __webpack_require__(27754);
var args_1 = __webpack_require__(84446);
function combineLatest() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var resultSelector = args_1.popResultSelector(args);
    return resultSelector
        ? pipe_1.pipe(combineLatest.apply(void 0, __spreadArray([], __read(args))), mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector))
        : lift_1.operate(function (source, subscriber) {
            combineLatest_1.combineLatestInit(__spreadArray([source], __read(argsOrArgArray_1.argsOrArgArray(args))))(subscriber);
        });
}
exports.combineLatest = combineLatest;
//# sourceMappingURL=combineLatest.js.map

}),
85488: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.combineLatestAll = void 0;
var combineLatest_1 = __webpack_require__(94331);
var joinAllInternals_1 = __webpack_require__(96669);
function combineLatestAll(project) {
    return joinAllInternals_1.joinAllInternals(combineLatest_1.combineLatest, project);
}
exports.combineLatestAll = combineLatestAll;
//# sourceMappingURL=combineLatestAll.js.map

}),
19144: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.combineLatestWith = void 0;
var combineLatest_1 = __webpack_require__(96486);
function combineLatestWith() {
    var otherSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        otherSources[_i] = arguments[_i];
    }
    return combineLatest_1.combineLatest.apply(void 0, __spreadArray([], __read(otherSources)));
}
exports.combineLatestWith = combineLatestWith;
//# sourceMappingURL=combineLatestWith.js.map

}),
4081: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.concat = void 0;
var lift_1 = __webpack_require__(54360);
var concatAll_1 = __webpack_require__(84438);
var args_1 = __webpack_require__(84446);
var from_1 = __webpack_require__(16609);
function concat() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = args_1.popScheduler(args);
    return lift_1.operate(function (source, subscriber) {
        concatAll_1.concatAll()(from_1.from(__spreadArray([source], __read(args)), scheduler)).subscribe(subscriber);
    });
}
exports.concat = concat;
//# sourceMappingURL=concat.js.map

}),
84438: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.concatAll = void 0;
var mergeAll_1 = __webpack_require__(21329);
function concatAll() {
    return mergeAll_1.mergeAll(1);
}
exports.concatAll = concatAll;
//# sourceMappingURL=concatAll.js.map

}),
62187: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.concatMap = void 0;
var mergeMap_1 = __webpack_require__(18244);
var isFunction_1 = __webpack_require__(64061);
function concatMap(project, resultSelector) {
    return isFunction_1.isFunction(resultSelector) ? mergeMap_1.mergeMap(project, resultSelector, 1) : mergeMap_1.mergeMap(project, 1);
}
exports.concatMap = concatMap;
//# sourceMappingURL=concatMap.js.map

}),
36873: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.concatMapTo = void 0;
var concatMap_1 = __webpack_require__(62187);
var isFunction_1 = __webpack_require__(64061);
function concatMapTo(innerObservable, resultSelector) {
    return isFunction_1.isFunction(resultSelector) ? concatMap_1.concatMap(function () { return innerObservable; }, resultSelector) : concatMap_1.concatMap(function () { return innerObservable; });
}
exports.concatMapTo = concatMapTo;
//# sourceMappingURL=concatMapTo.js.map

}),
99930: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.concatWith = void 0;
var concat_1 = __webpack_require__(4081);
function concatWith() {
    var otherSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        otherSources[_i] = arguments[_i];
    }
    return concat_1.concat.apply(void 0, __spreadArray([], __read(otherSources)));
}
exports.concatWith = concatWith;
//# sourceMappingURL=concatWith.js.map

}),
43325: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.connect = void 0;
var Subject_1 = __webpack_require__(30250);
var innerFrom_1 = __webpack_require__(68196);
var lift_1 = __webpack_require__(54360);
var fromSubscribable_1 = __webpack_require__(76445);
var DEFAULT_CONFIG = {
    connector: function () { return new Subject_1.Subject(); },
};
function connect(selector, config) {
    if (config === void 0) { config = DEFAULT_CONFIG; }
    var connector = config.connector;
    return lift_1.operate(function (source, subscriber) {
        var subject = connector();
        innerFrom_1.innerFrom(selector(fromSubscribable_1.fromSubscribable(subject))).subscribe(subscriber);
        subscriber.add(source.subscribe(subject));
    });
}
exports.connect = connect;
//# sourceMappingURL=connect.js.map

}),
46452: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.count = void 0;
var reduce_1 = __webpack_require__(71653);
function count(predicate) {
    return reduce_1.reduce(function (total, value, i) { return (!predicate || predicate(value, i) ? total + 1 : total); }, 0);
}
exports.count = count;
//# sourceMappingURL=count.js.map

}),
42093: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.debounce = void 0;
var lift_1 = __webpack_require__(54360);
var noop_1 = __webpack_require__(72777);
var OperatorSubscriber_1 = __webpack_require__(11729);
var innerFrom_1 = __webpack_require__(68196);
function debounce(durationSelector) {
    return lift_1.operate(function (source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        var durationSubscriber = null;
        var emit = function () {
            durationSubscriber === null || durationSubscriber === void 0 ? void 0 : durationSubscriber.unsubscribe();
            durationSubscriber = null;
            if (hasValue) {
                hasValue = false;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            durationSubscriber === null || durationSubscriber === void 0 ? void 0 : durationSubscriber.unsubscribe();
            hasValue = true;
            lastValue = value;
            durationSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, emit, noop_1.noop);
            innerFrom_1.innerFrom(durationSelector(value)).subscribe(durationSubscriber);
        }, function () {
            emit();
            subscriber.complete();
        }, undefined, function () {
            lastValue = durationSubscriber = null;
        }));
    });
}
exports.debounce = debounce;
//# sourceMappingURL=debounce.js.map

}),
26090: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.debounceTime = void 0;
var async_1 = __webpack_require__(6341);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.asyncScheduler; }
    return lift_1.operate(function (source, subscriber) {
        var activeTask = null;
        var lastValue = null;
        var lastTime = null;
        var emit = function () {
            if (activeTask) {
                activeTask.unsubscribe();
                activeTask = null;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        function emitWhenIdle() {
            var targetTime = lastTime + dueTime;
            var now = scheduler.now();
            if (now < targetTime) {
                activeTask = this.schedule(undefined, targetTime - now);
                subscriber.add(activeTask);
                return;
            }
            emit();
        }
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            lastValue = value;
            lastTime = scheduler.now();
            if (!activeTask) {
                activeTask = scheduler.schedule(emitWhenIdle, dueTime);
                subscriber.add(activeTask);
            }
        }, function () {
            emit();
            subscriber.complete();
        }, undefined, function () {
            lastValue = activeTask = null;
        }));
    });
}
exports.debounceTime = debounceTime;
//# sourceMappingURL=debounceTime.js.map

}),
13444: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultIfEmpty = void 0;
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function defaultIfEmpty(defaultValue) {
    return lift_1.operate(function (source, subscriber) {
        var hasValue = false;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            hasValue = true;
            subscriber.next(value);
        }, function () {
            if (!hasValue) {
                subscriber.next(defaultValue);
            }
            subscriber.complete();
        }));
    });
}
exports.defaultIfEmpty = defaultIfEmpty;
//# sourceMappingURL=defaultIfEmpty.js.map

}),
26983: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.delay = void 0;
var async_1 = __webpack_require__(6341);
var delayWhen_1 = __webpack_require__(73954);
var timer_1 = __webpack_require__(44779);
function delay(due, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.asyncScheduler; }
    var duration = timer_1.timer(due, scheduler);
    return delayWhen_1.delayWhen(function () { return duration; });
}
exports.delay = delay;
//# sourceMappingURL=delay.js.map

}),
73954: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.delayWhen = void 0;
var concat_1 = __webpack_require__(29982);
var take_1 = __webpack_require__(54424);
var ignoreElements_1 = __webpack_require__(71042);
var mapTo_1 = __webpack_require__(83597);
var mergeMap_1 = __webpack_require__(18244);
var innerFrom_1 = __webpack_require__(68196);
function delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) {
        return function (source) {
            return concat_1.concat(subscriptionDelay.pipe(take_1.take(1), ignoreElements_1.ignoreElements()), source.pipe(delayWhen(delayDurationSelector)));
        };
    }
    return mergeMap_1.mergeMap(function (value, index) { return innerFrom_1.innerFrom(delayDurationSelector(value, index)).pipe(take_1.take(1), mapTo_1.mapTo(value)); });
}
exports.delayWhen = delayWhen;
//# sourceMappingURL=delayWhen.js.map

}),
54102: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.dematerialize = void 0;
var Notification_1 = __webpack_require__(60713);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function dematerialize() {
    return lift_1.operate(function (source, subscriber) {
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (notification) { return Notification_1.observeNotification(notification, subscriber); }));
    });
}
exports.dematerialize = dematerialize;
//# sourceMappingURL=dematerialize.js.map

}),
54997: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.distinct = void 0;
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
var noop_1 = __webpack_require__(72777);
var innerFrom_1 = __webpack_require__(68196);
function distinct(keySelector, flushes) {
    return lift_1.operate(function (source, subscriber) {
        var distinctKeys = new Set();
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            var key = keySelector ? keySelector(value) : value;
            if (!distinctKeys.has(key)) {
                distinctKeys.add(key);
                subscriber.next(value);
            }
        }));
        flushes && innerFrom_1.innerFrom(flushes).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () { return distinctKeys.clear(); }, noop_1.noop));
    });
}
exports.distinct = distinct;
//# sourceMappingURL=distinct.js.map

}),
53833: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.distinctUntilChanged = void 0;
var identity_1 = __webpack_require__(6033);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function distinctUntilChanged(comparator, keySelector) {
    if (keySelector === void 0) { keySelector = identity_1.identity; }
    comparator = comparator !== null && comparator !== void 0 ? comparator : defaultCompare;
    return lift_1.operate(function (source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
exports.distinctUntilChanged = distinctUntilChanged;
function defaultCompare(a, b) {
    return a === b;
}
//# sourceMappingURL=distinctUntilChanged.js.map

}),
92892: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.distinctUntilKeyChanged = void 0;
var distinctUntilChanged_1 = __webpack_require__(53833);
function distinctUntilKeyChanged(key, compare) {
    return distinctUntilChanged_1.distinctUntilChanged(function (x, y) { return compare ? compare(x[key], y[key]) : x[key] === y[key]; });
}
exports.distinctUntilKeyChanged = distinctUntilKeyChanged;
//# sourceMappingURL=distinctUntilKeyChanged.js.map

}),
81272: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementAt = void 0;
var ArgumentOutOfRangeError_1 = __webpack_require__(56985);
var filter_1 = __webpack_require__(84653);
var throwIfEmpty_1 = __webpack_require__(19645);
var defaultIfEmpty_1 = __webpack_require__(13444);
var take_1 = __webpack_require__(54424);
function elementAt(index, defaultValue) {
    if (index < 0) {
        throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError();
    }
    var hasDefaultValue = arguments.length >= 2;
    return function (source) {
        return source.pipe(filter_1.filter(function (v, i) { return i === index; }), take_1.take(1), hasDefaultValue ? defaultIfEmpty_1.defaultIfEmpty(defaultValue) : throwIfEmpty_1.throwIfEmpty(function () { return new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError(); }));
    };
}
exports.elementAt = elementAt;
//# sourceMappingURL=elementAt.js.map

}),
28839: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.endWith = void 0;
var concat_1 = __webpack_require__(29982);
var of_1 = __webpack_require__(27294);
function endWith() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return function (source) { return concat_1.concat(source, of_1.of.apply(void 0, __spreadArray([], __read(values)))); };
}
exports.endWith = endWith;
//# sourceMappingURL=endWith.js.map

}),
38187: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.every = void 0;
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function every(predicate, thisArg) {
    return lift_1.operate(function (source, subscriber) {
        var index = 0;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            if (!predicate.call(thisArg, value, index++, source)) {
                subscriber.next(false);
                subscriber.complete();
            }
        }, function () {
            subscriber.next(true);
            subscriber.complete();
        }));
    });
}
exports.every = every;
//# sourceMappingURL=every.js.map

}),
51998: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.exhaust = void 0;
var exhaustAll_1 = __webpack_require__(97156);
exports.exhaust = exhaustAll_1.exhaustAll;
//# sourceMappingURL=exhaust.js.map

}),
97156: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.exhaustAll = void 0;
var exhaustMap_1 = __webpack_require__(13970);
var identity_1 = __webpack_require__(6033);
function exhaustAll() {
    return exhaustMap_1.exhaustMap(identity_1.identity);
}
exports.exhaustAll = exhaustAll;
//# sourceMappingURL=exhaustAll.js.map

}),
13970: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.exhaustMap = void 0;
var map_1 = __webpack_require__(92619);
var innerFrom_1 = __webpack_require__(68196);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function exhaustMap(project, resultSelector) {
    if (resultSelector) {
        return function (source) {
            return source.pipe(exhaustMap(function (a, i) { return innerFrom_1.innerFrom(project(a, i)).pipe(map_1.map(function (b, ii) { return resultSelector(a, b, i, ii); })); }));
        };
    }
    return lift_1.operate(function (source, subscriber) {
        var index = 0;
        var innerSub = null;
        var isComplete = false;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (outerValue) {
            if (!innerSub) {
                innerSub = OperatorSubscriber_1.createOperatorSubscriber(subscriber, undefined, function () {
                    innerSub = null;
                    isComplete && subscriber.complete();
                });
                innerFrom_1.innerFrom(project(outerValue, index++)).subscribe(innerSub);
            }
        }, function () {
            isComplete = true;
            !innerSub && subscriber.complete();
        }));
    });
}
exports.exhaustMap = exhaustMap;
//# sourceMappingURL=exhaustMap.js.map

}),
24837: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.expand = void 0;
var lift_1 = __webpack_require__(54360);
var mergeInternals_1 = __webpack_require__(60790);
function expand(project, concurrent, scheduler) {
    if (concurrent === void 0) { concurrent = Infinity; }
    concurrent = (concurrent || 0) < 1 ? Infinity : concurrent;
    return lift_1.operate(function (source, subscriber) {
        return mergeInternals_1.mergeInternals(source, subscriber, project, concurrent, undefined, true, scheduler);
    });
}
exports.expand = expand;
//# sourceMappingURL=expand.js.map

}),
84653: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.filter = void 0;
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function filter(predicate, thisArg) {
    return lift_1.operate(function (source, subscriber) {
        var index = 0;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return predicate.call(thisArg, value, index++) && subscriber.next(value); }));
    });
}
exports.filter = filter;
//# sourceMappingURL=filter.js.map

}),
72489: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.finalize = void 0;
var lift_1 = __webpack_require__(54360);
function finalize(callback) {
    return lift_1.operate(function (source, subscriber) {
        try {
            source.subscribe(subscriber);
        }
        finally {
            subscriber.add(callback);
        }
    });
}
exports.finalize = finalize;
//# sourceMappingURL=finalize.js.map

}),
35457: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createFind = exports.find = void 0;
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function find(predicate, thisArg) {
    return lift_1.operate(createFind(predicate, thisArg, 'value'));
}
exports.find = find;
function createFind(predicate, thisArg, emit) {
    var findIndex = emit === 'index';
    return function (source, subscriber) {
        var index = 0;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            var i = index++;
            if (predicate.call(thisArg, value, i, source)) {
                subscriber.next(findIndex ? i : value);
                subscriber.complete();
            }
        }, function () {
            subscriber.next(findIndex ? -1 : undefined);
            subscriber.complete();
        }));
    };
}
exports.createFind = createFind;
//# sourceMappingURL=find.js.map

}),
20363: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.findIndex = void 0;
var lift_1 = __webpack_require__(54360);
var find_1 = __webpack_require__(35457);
function findIndex(predicate, thisArg) {
    return lift_1.operate(find_1.createFind(predicate, thisArg, 'index'));
}
exports.findIndex = findIndex;
//# sourceMappingURL=findIndex.js.map

}),
91457: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.first = void 0;
var EmptyError_1 = __webpack_require__(20431);
var filter_1 = __webpack_require__(84653);
var take_1 = __webpack_require__(54424);
var defaultIfEmpty_1 = __webpack_require__(13444);
var throwIfEmpty_1 = __webpack_require__(19645);
var identity_1 = __webpack_require__(6033);
function first(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function (source) {
        return source.pipe(predicate ? filter_1.filter(function (v, i) { return predicate(v, i, source); }) : identity_1.identity, take_1.take(1), hasDefaultValue ? defaultIfEmpty_1.defaultIfEmpty(defaultValue) : throwIfEmpty_1.throwIfEmpty(function () { return new EmptyError_1.EmptyError(); }));
    };
}
exports.first = first;
//# sourceMappingURL=first.js.map

}),
99124: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.flatMap = void 0;
var mergeMap_1 = __webpack_require__(18244);
exports.flatMap = mergeMap_1.mergeMap;
//# sourceMappingURL=flatMap.js.map

}),
39103: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.groupBy = void 0;
var Observable_1 = __webpack_require__(18547);
var innerFrom_1 = __webpack_require__(68196);
var Subject_1 = __webpack_require__(30250);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function groupBy(keySelector, elementOrOptions, duration, connector) {
    return lift_1.operate(function (source, subscriber) {
        var element;
        if (!elementOrOptions || typeof elementOrOptions === 'function') {
            element = elementOrOptions;
        }
        else {
            (duration = elementOrOptions.duration, element = elementOrOptions.element, connector = elementOrOptions.connector);
        }
        var groups = new Map();
        var notify = function (cb) {
            groups.forEach(cb);
            cb(subscriber);
        };
        var handleError = function (err) { return notify(function (consumer) { return consumer.error(err); }); };
        var activeGroups = 0;
        var teardownAttempted = false;
        var groupBySourceSubscriber = new OperatorSubscriber_1.OperatorSubscriber(subscriber, function (value) {
            try {
                var key_1 = keySelector(value);
                var group_1 = groups.get(key_1);
                if (!group_1) {
                    groups.set(key_1, (group_1 = connector ? connector() : new Subject_1.Subject()));
                    var grouped = createGroupedObservable(key_1, group_1);
                    subscriber.next(grouped);
                    if (duration) {
                        var durationSubscriber_1 = OperatorSubscriber_1.createOperatorSubscriber(group_1, function () {
                            group_1.complete();
                            durationSubscriber_1 === null || durationSubscriber_1 === void 0 ? void 0 : durationSubscriber_1.unsubscribe();
                        }, undefined, undefined, function () { return groups.delete(key_1); });
                        groupBySourceSubscriber.add(innerFrom_1.innerFrom(duration(grouped)).subscribe(durationSubscriber_1));
                    }
                }
                group_1.next(element ? element(value) : value);
            }
            catch (err) {
                handleError(err);
            }
        }, function () { return notify(function (consumer) { return consumer.complete(); }); }, handleError, function () { return groups.clear(); }, function () {
            teardownAttempted = true;
            return activeGroups === 0;
        });
        source.subscribe(groupBySourceSubscriber);
        function createGroupedObservable(key, groupSubject) {
            var result = new Observable_1.Observable(function (groupSubscriber) {
                activeGroups++;
                var innerSub = groupSubject.subscribe(groupSubscriber);
                return function () {
                    innerSub.unsubscribe();
                    --activeGroups === 0 && teardownAttempted && groupBySourceSubscriber.unsubscribe();
                };
            });
            result.key = key;
            return result;
        }
    });
}
exports.groupBy = groupBy;
//# sourceMappingURL=groupBy.js.map

}),
71042: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ignoreElements = void 0;
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
var noop_1 = __webpack_require__(72777);
function ignoreElements() {
    return lift_1.operate(function (source, subscriber) {
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, noop_1.noop));
    });
}
exports.ignoreElements = ignoreElements;
//# sourceMappingURL=ignoreElements.js.map

}),
6426: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isEmpty = void 0;
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function isEmpty() {
    return lift_1.operate(function (source, subscriber) {
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
            subscriber.next(false);
            subscriber.complete();
        }, function () {
            subscriber.next(true);
            subscriber.complete();
        }));
    });
}
exports.isEmpty = isEmpty;
//# sourceMappingURL=isEmpty.js.map

}),
96669: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.joinAllInternals = void 0;
var identity_1 = __webpack_require__(6033);
var mapOneOrManyArgs_1 = __webpack_require__(92869);
var pipe_1 = __webpack_require__(27754);
var mergeMap_1 = __webpack_require__(18244);
var toArray_1 = __webpack_require__(3223);
function joinAllInternals(joinFn, project) {
    return pipe_1.pipe(toArray_1.toArray(), mergeMap_1.mergeMap(function (sources) { return joinFn(sources); }), project ? mapOneOrManyArgs_1.mapOneOrManyArgs(project) : identity_1.identity);
}
exports.joinAllInternals = joinAllInternals;
//# sourceMappingURL=joinAllInternals.js.map

}),
16406: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.last = void 0;
var EmptyError_1 = __webpack_require__(20431);
var filter_1 = __webpack_require__(84653);
var takeLast_1 = __webpack_require__(45033);
var throwIfEmpty_1 = __webpack_require__(19645);
var defaultIfEmpty_1 = __webpack_require__(13444);
var identity_1 = __webpack_require__(6033);
function last(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function (source) {
        return source.pipe(predicate ? filter_1.filter(function (v, i) { return predicate(v, i, source); }) : identity_1.identity, takeLast_1.takeLast(1), hasDefaultValue ? defaultIfEmpty_1.defaultIfEmpty(defaultValue) : throwIfEmpty_1.throwIfEmpty(function () { return new EmptyError_1.EmptyError(); }));
    };
}
exports.last = last;
//# sourceMappingURL=last.js.map

}),
92619: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.map = void 0;
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function map(project, thisArg) {
    return lift_1.operate(function (source, subscriber) {
        var index = 0;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}
exports.map = map;
//# sourceMappingURL=map.js.map

}),
83597: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mapTo = void 0;
var map_1 = __webpack_require__(92619);
function mapTo(value) {
    return map_1.map(function () { return value; });
}
exports.mapTo = mapTo;
//# sourceMappingURL=mapTo.js.map

}),
48461: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.materialize = void 0;
var Notification_1 = __webpack_require__(60713);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function materialize() {
    return lift_1.operate(function (source, subscriber) {
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            subscriber.next(Notification_1.Notification.createNext(value));
        }, function () {
            subscriber.next(Notification_1.Notification.createComplete());
            subscriber.complete();
        }, function (err) {
            subscriber.next(Notification_1.Notification.createError(err));
            subscriber.complete();
        }));
    });
}
exports.materialize = materialize;
//# sourceMappingURL=materialize.js.map

}),
3330: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.max = void 0;
var reduce_1 = __webpack_require__(71653);
var isFunction_1 = __webpack_require__(64061);
function max(comparer) {
    return reduce_1.reduce(isFunction_1.isFunction(comparer) ? function (x, y) { return (comparer(x, y) > 0 ? x : y); } : function (x, y) { return (x > y ? x : y); });
}
exports.max = max;
//# sourceMappingURL=max.js.map

}),
80276: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.merge = void 0;
var lift_1 = __webpack_require__(54360);
var argsOrArgArray_1 = __webpack_require__(59925);
var mergeAll_1 = __webpack_require__(21329);
var args_1 = __webpack_require__(84446);
var from_1 = __webpack_require__(16609);
function merge() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = args_1.popScheduler(args);
    var concurrent = args_1.popNumber(args, Infinity);
    args = argsOrArgArray_1.argsOrArgArray(args);
    return lift_1.operate(function (source, subscriber) {
        mergeAll_1.mergeAll(concurrent)(from_1.from(__spreadArray([source], __read(args)), scheduler)).subscribe(subscriber);
    });
}
exports.merge = merge;
//# sourceMappingURL=merge.js.map

}),
21329: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mergeAll = void 0;
var mergeMap_1 = __webpack_require__(18244);
var identity_1 = __webpack_require__(6033);
function mergeAll(concurrent) {
    if (concurrent === void 0) { concurrent = Infinity; }
    return mergeMap_1.mergeMap(identity_1.identity, concurrent);
}
exports.mergeAll = mergeAll;
//# sourceMappingURL=mergeAll.js.map

}),
60790: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mergeInternals = void 0;
var innerFrom_1 = __webpack_require__(68196);
var executeSchedule_1 = __webpack_require__(98726);
var OperatorSubscriber_1 = __webpack_require__(11729);
function mergeInternals(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function () {
        if (isComplete && !buffer.length && !active) {
            subscriber.complete();
        }
    };
    var outerNext = function (value) { return (active < concurrent ? doInnerSub(value) : buffer.push(value)); };
    var doInnerSub = function (value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        innerFrom_1.innerFrom(project(value, index++)).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 ? void 0 : onBeforeNext(innerValue);
            if (expand) {
                outerNext(innerValue);
            }
            else {
                subscriber.next(innerValue);
            }
        }, function () {
            innerComplete = true;
        }, undefined, function () {
            if (innerComplete) {
                try {
                    active--;
                    var _loop_1 = function () {
                        var bufferedValue = buffer.shift();
                        if (innerSubScheduler) {
                            executeSchedule_1.executeSchedule(subscriber, innerSubScheduler, function () { return doInnerSub(bufferedValue); });
                        }
                        else {
                            doInnerSub(bufferedValue);
                        }
                    };
                    while (buffer.length && active < concurrent) {
                        _loop_1();
                    }
                    checkComplete();
                }
                catch (err) {
                    subscriber.error(err);
                }
            }
        }));
    };
    source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, outerNext, function () {
        isComplete = true;
        checkComplete();
    }));
    return function () {
        additionalFinalizer === null || additionalFinalizer === void 0 ? void 0 : additionalFinalizer();
    };
}
exports.mergeInternals = mergeInternals;
//# sourceMappingURL=mergeInternals.js.map

}),
18244: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mergeMap = void 0;
var map_1 = __webpack_require__(92619);
var innerFrom_1 = __webpack_require__(68196);
var lift_1 = __webpack_require__(54360);
var mergeInternals_1 = __webpack_require__(60790);
var isFunction_1 = __webpack_require__(64061);
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Infinity; }
    if (isFunction_1.isFunction(resultSelector)) {
        return mergeMap(function (a, i) { return map_1.map(function (b, ii) { return resultSelector(a, b, i, ii); })(innerFrom_1.innerFrom(project(a, i))); }, concurrent);
    }
    else if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return lift_1.operate(function (source, subscriber) { return mergeInternals_1.mergeInternals(source, subscriber, project, concurrent); });
}
exports.mergeMap = mergeMap;
//# sourceMappingURL=mergeMap.js.map

}),
38119: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mergeMapTo = void 0;
var mergeMap_1 = __webpack_require__(18244);
var isFunction_1 = __webpack_require__(64061);
function mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Infinity; }
    if (isFunction_1.isFunction(resultSelector)) {
        return mergeMap_1.mergeMap(function () { return innerObservable; }, resultSelector, concurrent);
    }
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return mergeMap_1.mergeMap(function () { return innerObservable; }, concurrent);
}
exports.mergeMapTo = mergeMapTo;
//# sourceMappingURL=mergeMapTo.js.map

}),
57426: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mergeScan = void 0;
var lift_1 = __webpack_require__(54360);
var mergeInternals_1 = __webpack_require__(60790);
function mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) { concurrent = Infinity; }
    return lift_1.operate(function (source, subscriber) {
        var state = seed;
        return mergeInternals_1.mergeInternals(source, subscriber, function (value, index) { return accumulator(state, value, index); }, concurrent, function (value) {
            state = value;
        }, false, undefined, function () { return (state = null); });
    });
}
exports.mergeScan = mergeScan;
//# sourceMappingURL=mergeScan.js.map

}),
95280: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mergeWith = void 0;
var merge_1 = __webpack_require__(80276);
function mergeWith() {
    var otherSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        otherSources[_i] = arguments[_i];
    }
    return merge_1.merge.apply(void 0, __spreadArray([], __read(otherSources)));
}
exports.mergeWith = mergeWith;
//# sourceMappingURL=mergeWith.js.map

}),
40884: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.min = void 0;
var reduce_1 = __webpack_require__(71653);
var isFunction_1 = __webpack_require__(64061);
function min(comparer) {
    return reduce_1.reduce(isFunction_1.isFunction(comparer) ? function (x, y) { return (comparer(x, y) < 0 ? x : y); } : function (x, y) { return (x < y ? x : y); });
}
exports.min = min;
//# sourceMappingURL=min.js.map

}),
88591: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.multicast = void 0;
var ConnectableObservable_1 = __webpack_require__(23987);
var isFunction_1 = __webpack_require__(64061);
var connect_1 = __webpack_require__(43325);
function multicast(subjectOrSubjectFactory, selector) {
    var subjectFactory = isFunction_1.isFunction(subjectOrSubjectFactory) ? subjectOrSubjectFactory : function () { return subjectOrSubjectFactory; };
    if (isFunction_1.isFunction(selector)) {
        return connect_1.connect(selector, {
            connector: subjectFactory,
        });
    }
    return function (source) { return new ConnectableObservable_1.ConnectableObservable(source, subjectFactory); };
}
exports.multicast = multicast;
//# sourceMappingURL=multicast.js.map

}),
89329: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.observeOn = void 0;
var executeSchedule_1 = __webpack_require__(98726);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function observeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return lift_1.operate(function (source, subscriber) {
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return executeSchedule_1.executeSchedule(subscriber, scheduler, function () { return subscriber.next(value); }, delay); }, function () { return executeSchedule_1.executeSchedule(subscriber, scheduler, function () { return subscriber.complete(); }, delay); }, function (err) { return executeSchedule_1.executeSchedule(subscriber, scheduler, function () { return subscriber.error(err); }, delay); }));
    });
}
exports.observeOn = observeOn;
//# sourceMappingURL=observeOn.js.map

}),
46851: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.onErrorResumeNext = exports.onErrorResumeNextWith = void 0;
var argsOrArgArray_1 = __webpack_require__(59925);
var onErrorResumeNext_1 = __webpack_require__(90941);
function onErrorResumeNextWith() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var nextSources = argsOrArgArray_1.argsOrArgArray(sources);
    return function (source) { return onErrorResumeNext_1.onErrorResumeNext.apply(void 0, __spreadArray([source], __read(nextSources))); };
}
exports.onErrorResumeNextWith = onErrorResumeNextWith;
exports.onErrorResumeNext = onErrorResumeNextWith;
//# sourceMappingURL=onErrorResumeNextWith.js.map

}),
48069: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pairwise = void 0;
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function pairwise() {
    return lift_1.operate(function (source, subscriber) {
        var prev;
        var hasPrev = false;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            var p = prev;
            prev = value;
            hasPrev && subscriber.next([p, value]);
            hasPrev = true;
        }));
    });
}
exports.pairwise = pairwise;
//# sourceMappingURL=pairwise.js.map

}),
40331: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pluck = void 0;
var map_1 = __webpack_require__(92619);
function pluck() {
    var properties = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        properties[_i] = arguments[_i];
    }
    var length = properties.length;
    if (length === 0) {
        throw new Error('list of properties cannot be empty.');
    }
    return map_1.map(function (x) {
        var currentProp = x;
        for (var i = 0; i < length; i++) {
            var p = currentProp === null || currentProp === void 0 ? void 0 : currentProp[properties[i]];
            if (typeof p !== 'undefined') {
                currentProp = p;
            }
            else {
                return undefined;
            }
        }
        return currentProp;
    });
}
exports.pluck = pluck;
//# sourceMappingURL=pluck.js.map

}),
69837: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.publish = void 0;
var Subject_1 = __webpack_require__(30250);
var multicast_1 = __webpack_require__(88591);
var connect_1 = __webpack_require__(43325);
function publish(selector) {
    return selector ? function (source) { return connect_1.connect(selector)(source); } : function (source) { return multicast_1.multicast(new Subject_1.Subject())(source); };
}
exports.publish = publish;
//# sourceMappingURL=publish.js.map

}),
35420: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.publishBehavior = void 0;
var BehaviorSubject_1 = __webpack_require__(33850);
var ConnectableObservable_1 = __webpack_require__(23987);
function publishBehavior(initialValue) {
    return function (source) {
        var subject = new BehaviorSubject_1.BehaviorSubject(initialValue);
        return new ConnectableObservable_1.ConnectableObservable(source, function () { return subject; });
    };
}
exports.publishBehavior = publishBehavior;
//# sourceMappingURL=publishBehavior.js.map

}),
35315: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.publishLast = void 0;
var AsyncSubject_1 = __webpack_require__(65076);
var ConnectableObservable_1 = __webpack_require__(23987);
function publishLast() {
    return function (source) {
        var subject = new AsyncSubject_1.AsyncSubject();
        return new ConnectableObservable_1.ConnectableObservable(source, function () { return subject; });
    };
}
exports.publishLast = publishLast;
//# sourceMappingURL=publishLast.js.map

}),
33274: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.publishReplay = void 0;
var ReplaySubject_1 = __webpack_require__(68838);
var multicast_1 = __webpack_require__(88591);
var isFunction_1 = __webpack_require__(64061);
function publishReplay(bufferSize, windowTime, selectorOrScheduler, timestampProvider) {
    if (selectorOrScheduler && !isFunction_1.isFunction(selectorOrScheduler)) {
        timestampProvider = selectorOrScheduler;
    }
    var selector = isFunction_1.isFunction(selectorOrScheduler) ? selectorOrScheduler : undefined;
    return function (source) { return multicast_1.multicast(new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, timestampProvider), selector)(source); };
}
exports.publishReplay = publishReplay;
//# sourceMappingURL=publishReplay.js.map

}),
10898: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.raceWith = void 0;
var race_1 = __webpack_require__(96628);
var lift_1 = __webpack_require__(54360);
var identity_1 = __webpack_require__(6033);
function raceWith() {
    var otherSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        otherSources[_i] = arguments[_i];
    }
    return !otherSources.length
        ? identity_1.identity
        : lift_1.operate(function (source, subscriber) {
            race_1.raceInit(__spreadArray([source], __read(otherSources)))(subscriber);
        });
}
exports.raceWith = raceWith;
//# sourceMappingURL=raceWith.js.map

}),
71653: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.reduce = void 0;
var scanInternals_1 = __webpack_require__(27049);
var lift_1 = __webpack_require__(54360);
function reduce(accumulator, seed) {
    return lift_1.operate(scanInternals_1.scanInternals(accumulator, seed, arguments.length >= 2, false, true));
}
exports.reduce = reduce;
//# sourceMappingURL=reduce.js.map

}),
17988: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.refCount = void 0;
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function refCount() {
    return lift_1.operate(function (source, subscriber) {
        var connection = null;
        source._refCount++;
        var refCounter = OperatorSubscriber_1.createOperatorSubscriber(subscriber, undefined, undefined, undefined, function () {
            if (!source || source._refCount <= 0 || 0 < --source._refCount) {
                connection = null;
                return;
            }
            var sharedConnection = source._connection;
            var conn = connection;
            connection = null;
            if (sharedConnection && (!conn || sharedConnection === conn)) {
                sharedConnection.unsubscribe();
            }
            subscriber.unsubscribe();
        });
        source.subscribe(refCounter);
        if (!refCounter.closed) {
            connection = source.connect();
        }
    });
}
exports.refCount = refCount;
//# sourceMappingURL=refCount.js.map

}),
45882: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.repeat = void 0;
var empty_1 = __webpack_require__(88930);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
var innerFrom_1 = __webpack_require__(68196);
var timer_1 = __webpack_require__(44779);
function repeat(countOrConfig) {
    var _a;
    var count = Infinity;
    var delay;
    if (countOrConfig != null) {
        if (typeof countOrConfig === 'object') {
            (_a = countOrConfig.count, count = _a === void 0 ? Infinity : _a, delay = countOrConfig.delay);
        }
        else {
            count = countOrConfig;
        }
    }
    return count <= 0
        ? function () { return empty_1.EMPTY; }
        : lift_1.operate(function (source, subscriber) {
            var soFar = 0;
            var sourceSub;
            var resubscribe = function () {
                sourceSub === null || sourceSub === void 0 ? void 0 : sourceSub.unsubscribe();
                sourceSub = null;
                if (delay != null) {
                    var notifier = typeof delay === 'number' ? timer_1.timer(delay) : innerFrom_1.innerFrom(delay(soFar));
                    var notifierSubscriber_1 = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
                        notifierSubscriber_1.unsubscribe();
                        subscribeToSource();
                    });
                    notifier.subscribe(notifierSubscriber_1);
                }
                else {
                    subscribeToSource();
                }
            };
            var subscribeToSource = function () {
                var syncUnsub = false;
                sourceSub = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, undefined, function () {
                    if (++soFar < count) {
                        if (sourceSub) {
                            resubscribe();
                        }
                        else {
                            syncUnsub = true;
                        }
                    }
                    else {
                        subscriber.complete();
                    }
                }));
                if (syncUnsub) {
                    resubscribe();
                }
            };
            subscribeToSource();
        });
}
exports.repeat = repeat;
//# sourceMappingURL=repeat.js.map

}),
77693: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.repeatWhen = void 0;
var innerFrom_1 = __webpack_require__(68196);
var Subject_1 = __webpack_require__(30250);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function repeatWhen(notifier) {
    return lift_1.operate(function (source, subscriber) {
        var innerSub;
        var syncResub = false;
        var completions$;
        var isNotifierComplete = false;
        var isMainComplete = false;
        var checkComplete = function () { return isMainComplete && isNotifierComplete && (subscriber.complete(), true); };
        var getCompletionSubject = function () {
            if (!completions$) {
                completions$ = new Subject_1.Subject();
                innerFrom_1.innerFrom(notifier(completions$)).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
                    if (innerSub) {
                        subscribeForRepeatWhen();
                    }
                    else {
                        syncResub = true;
                    }
                }, function () {
                    isNotifierComplete = true;
                    checkComplete();
                }));
            }
            return completions$;
        };
        var subscribeForRepeatWhen = function () {
            isMainComplete = false;
            innerSub = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, undefined, function () {
                isMainComplete = true;
                !checkComplete() && getCompletionSubject().next();
            }));
            if (syncResub) {
                innerSub.unsubscribe();
                innerSub = null;
                syncResub = false;
                subscribeForRepeatWhen();
            }
        };
        subscribeForRepeatWhen();
    });
}
exports.repeatWhen = repeatWhen;
//# sourceMappingURL=repeatWhen.js.map

}),
47280: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.retry = void 0;
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
var identity_1 = __webpack_require__(6033);
var timer_1 = __webpack_require__(44779);
var innerFrom_1 = __webpack_require__(68196);
function retry(configOrCount) {
    if (configOrCount === void 0) { configOrCount = Infinity; }
    var config;
    if (configOrCount && typeof configOrCount === 'object') {
        config = configOrCount;
    }
    else {
        config = {
            count: configOrCount,
        };
    }
    var _a = config.count, count = _a === void 0 ? Infinity : _a, delay = config.delay, _b = config.resetOnSuccess, resetOnSuccess = _b === void 0 ? false : _b;
    return count <= 0
        ? identity_1.identity
        : lift_1.operate(function (source, subscriber) {
            var soFar = 0;
            var innerSub;
            var subscribeForRetry = function () {
                var syncUnsub = false;
                innerSub = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
                    if (resetOnSuccess) {
                        soFar = 0;
                    }
                    subscriber.next(value);
                }, undefined, function (err) {
                    if (soFar++ < count) {
                        var resub_1 = function () {
                            if (innerSub) {
                                innerSub.unsubscribe();
                                innerSub = null;
                                subscribeForRetry();
                            }
                            else {
                                syncUnsub = true;
                            }
                        };
                        if (delay != null) {
                            var notifier = typeof delay === 'number' ? timer_1.timer(delay) : innerFrom_1.innerFrom(delay(err, soFar));
                            var notifierSubscriber_1 = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
                                notifierSubscriber_1.unsubscribe();
                                resub_1();
                            }, function () {
                                subscriber.complete();
                            });
                            notifier.subscribe(notifierSubscriber_1);
                        }
                        else {
                            resub_1();
                        }
                    }
                    else {
                        subscriber.error(err);
                    }
                }));
                if (syncUnsub) {
                    innerSub.unsubscribe();
                    innerSub = null;
                    subscribeForRetry();
                }
            };
            subscribeForRetry();
        });
}
exports.retry = retry;
//# sourceMappingURL=retry.js.map

}),
44965: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.retryWhen = void 0;
var innerFrom_1 = __webpack_require__(68196);
var Subject_1 = __webpack_require__(30250);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function retryWhen(notifier) {
    return lift_1.operate(function (source, subscriber) {
        var innerSub;
        var syncResub = false;
        var errors$;
        var subscribeForRetryWhen = function () {
            innerSub = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, undefined, undefined, function (err) {
                if (!errors$) {
                    errors$ = new Subject_1.Subject();
                    innerFrom_1.innerFrom(notifier(errors$)).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
                        return innerSub ? subscribeForRetryWhen() : (syncResub = true);
                    }));
                }
                if (errors$) {
                    errors$.next(err);
                }
            }));
            if (syncResub) {
                innerSub.unsubscribe();
                innerSub = null;
                syncResub = false;
                subscribeForRetryWhen();
            }
        };
        subscribeForRetryWhen();
    });
}
exports.retryWhen = retryWhen;
//# sourceMappingURL=retryWhen.js.map

}),
72412: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sample = void 0;
var innerFrom_1 = __webpack_require__(68196);
var lift_1 = __webpack_require__(54360);
var noop_1 = __webpack_require__(72777);
var OperatorSubscriber_1 = __webpack_require__(11729);
function sample(notifier) {
    return lift_1.operate(function (source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            hasValue = true;
            lastValue = value;
        }));
        innerFrom_1.innerFrom(notifier).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
            if (hasValue) {
                hasValue = false;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        }, noop_1.noop));
    });
}
exports.sample = sample;
//# sourceMappingURL=sample.js.map

}),
94815: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sampleTime = void 0;
var async_1 = __webpack_require__(6341);
var sample_1 = __webpack_require__(72412);
var interval_1 = __webpack_require__(88531);
function sampleTime(period, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.asyncScheduler; }
    return sample_1.sample(interval_1.interval(period, scheduler));
}
exports.sampleTime = sampleTime;
//# sourceMappingURL=sampleTime.js.map

}),
32115: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.scan = void 0;
var lift_1 = __webpack_require__(54360);
var scanInternals_1 = __webpack_require__(27049);
function scan(accumulator, seed) {
    return lift_1.operate(scanInternals_1.scanInternals(accumulator, seed, arguments.length >= 2, true));
}
exports.scan = scan;
//# sourceMappingURL=scan.js.map

}),
27049: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.scanInternals = void 0;
var OperatorSubscriber_1 = __webpack_require__(11729);
function scanInternals(accumulator, seed, hasSeed, emitOnNext, emitBeforeComplete) {
    return function (source, subscriber) {
        var hasState = hasSeed;
        var state = seed;
        var index = 0;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            var i = index++;
            state = hasState
                ?
                    accumulator(state, value, i)
                :
                    ((hasState = true), value);
            emitOnNext && subscriber.next(state);
        }, emitBeforeComplete &&
            (function () {
                hasState && subscriber.next(state);
                subscriber.complete();
            })));
    };
}
exports.scanInternals = scanInternals;
//# sourceMappingURL=scanInternals.js.map

}),
70495: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sequenceEqual = void 0;
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
var innerFrom_1 = __webpack_require__(68196);
function sequenceEqual(compareTo, comparator) {
    if (comparator === void 0) { comparator = function (a, b) { return a === b; }; }
    return lift_1.operate(function (source, subscriber) {
        var aState = createState();
        var bState = createState();
        var emit = function (isEqual) {
            subscriber.next(isEqual);
            subscriber.complete();
        };
        var createSubscriber = function (selfState, otherState) {
            var sequenceEqualSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (a) {
                var buffer = otherState.buffer, complete = otherState.complete;
                if (buffer.length === 0) {
                    complete ? emit(false) : selfState.buffer.push(a);
                }
                else {
                    !comparator(a, buffer.shift()) && emit(false);
                }
            }, function () {
                selfState.complete = true;
                var complete = otherState.complete, buffer = otherState.buffer;
                complete && emit(buffer.length === 0);
                sequenceEqualSubscriber === null || sequenceEqualSubscriber === void 0 ? void 0 : sequenceEqualSubscriber.unsubscribe();
            });
            return sequenceEqualSubscriber;
        };
        source.subscribe(createSubscriber(aState, bState));
        innerFrom_1.innerFrom(compareTo).subscribe(createSubscriber(bState, aState));
    });
}
exports.sequenceEqual = sequenceEqual;
function createState() {
    return {
        buffer: [],
        complete: false,
    };
}
//# sourceMappingURL=sequenceEqual.js.map

}),
66644: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.share = void 0;
var innerFrom_1 = __webpack_require__(68196);
var Subject_1 = __webpack_require__(30250);
var Subscriber_1 = __webpack_require__(87378);
var lift_1 = __webpack_require__(54360);
function share(options) {
    if (options === void 0) { options = {}; }
    var _a = options.connector, connector = _a === void 0 ? function () { return new Subject_1.Subject(); } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function (wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function () {
            resetConnection === null || resetConnection === void 0 ? void 0 : resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function () {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function () {
            var conn = connection;
            reset();
            conn === null || conn === void 0 ? void 0 : conn.unsubscribe();
        };
        return lift_1.operate(function (source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) {
                cancelReset();
            }
            var dest = (subject = subject !== null && subject !== void 0 ? subject : connector());
            subscriber.add(function () {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) {
                    resetConnection = handleReset(resetAndUnsubscribe, resetOnRefCountZero);
                }
            });
            dest.subscribe(subscriber);
            if (!connection &&
                refCount > 0) {
                connection = new Subscriber_1.SafeSubscriber({
                    next: function (value) { return dest.next(value); },
                    error: function (err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function () {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = handleReset(reset, resetOnComplete);
                        dest.complete();
                    },
                });
                innerFrom_1.innerFrom(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
exports.share = share;
function handleReset(reset, on) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (on === true) {
        reset();
        return;
    }
    if (on === false) {
        return;
    }
    var onSubscriber = new Subscriber_1.SafeSubscriber({
        next: function () {
            onSubscriber.unsubscribe();
            reset();
        },
    });
    return innerFrom_1.innerFrom(on.apply(void 0, __spreadArray([], __read(args)))).subscribe(onSubscriber);
}
//# sourceMappingURL=share.js.map

}),
30970: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.shareReplay = void 0;
var ReplaySubject_1 = __webpack_require__(68838);
var share_1 = __webpack_require__(66644);
function shareReplay(configOrBufferSize, windowTime, scheduler) {
    var _a, _b, _c;
    var bufferSize;
    var refCount = false;
    if (configOrBufferSize && typeof configOrBufferSize === 'object') {
        (_a = configOrBufferSize.bufferSize, bufferSize = _a === void 0 ? Infinity : _a, _b = configOrBufferSize.windowTime, windowTime = _b === void 0 ? Infinity : _b, _c = configOrBufferSize.refCount, refCount = _c === void 0 ? false : _c, scheduler = configOrBufferSize.scheduler);
    }
    else {
        bufferSize = (configOrBufferSize !== null && configOrBufferSize !== void 0 ? configOrBufferSize : Infinity);
    }
    return share_1.share({
        connector: function () { return new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler); },
        resetOnError: true,
        resetOnComplete: false,
        resetOnRefCountZero: refCount,
    });
}
exports.shareReplay = shareReplay;
//# sourceMappingURL=shareReplay.js.map

}),
60236: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.single = void 0;
var EmptyError_1 = __webpack_require__(20431);
var SequenceError_1 = __webpack_require__(16348);
var NotFoundError_1 = __webpack_require__(25943);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function single(predicate) {
    return lift_1.operate(function (source, subscriber) {
        var hasValue = false;
        var singleValue;
        var seenValue = false;
        var index = 0;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            seenValue = true;
            if (!predicate || predicate(value, index++, source)) {
                hasValue && subscriber.error(new SequenceError_1.SequenceError('Too many matching values'));
                hasValue = true;
                singleValue = value;
            }
        }, function () {
            if (hasValue) {
                subscriber.next(singleValue);
                subscriber.complete();
            }
            else {
                subscriber.error(seenValue ? new NotFoundError_1.NotFoundError('No matching values') : new EmptyError_1.EmptyError());
            }
        }));
    });
}
exports.single = single;
//# sourceMappingURL=single.js.map

}),
21006: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.skip = void 0;
var filter_1 = __webpack_require__(84653);
function skip(count) {
    return filter_1.filter(function (_, index) { return count <= index; });
}
exports.skip = skip;
//# sourceMappingURL=skip.js.map

}),
16701: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.skipLast = void 0;
var identity_1 = __webpack_require__(6033);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function skipLast(skipCount) {
    return skipCount <= 0
        ?
            identity_1.identity
        : lift_1.operate(function (source, subscriber) {
            var ring = new Array(skipCount);
            var seen = 0;
            source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
                var valueIndex = seen++;
                if (valueIndex < skipCount) {
                    ring[valueIndex] = value;
                }
                else {
                    var index = valueIndex % skipCount;
                    var oldValue = ring[index];
                    ring[index] = value;
                    subscriber.next(oldValue);
                }
            }));
            return function () {
                ring = null;
            };
        });
}
exports.skipLast = skipLast;
//# sourceMappingURL=skipLast.js.map

}),
86778: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.skipUntil = void 0;
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
var innerFrom_1 = __webpack_require__(68196);
var noop_1 = __webpack_require__(72777);
function skipUntil(notifier) {
    return lift_1.operate(function (source, subscriber) {
        var taking = false;
        var skipSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
            skipSubscriber === null || skipSubscriber === void 0 ? void 0 : skipSubscriber.unsubscribe();
            taking = true;
        }, noop_1.noop);
        innerFrom_1.innerFrom(notifier).subscribe(skipSubscriber);
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return taking && subscriber.next(value); }));
    });
}
exports.skipUntil = skipUntil;
//# sourceMappingURL=skipUntil.js.map

}),
85720: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.skipWhile = void 0;
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function skipWhile(predicate) {
    return lift_1.operate(function (source, subscriber) {
        var taking = false;
        var index = 0;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return (taking || (taking = !predicate(value, index++))) && subscriber.next(value); }));
    });
}
exports.skipWhile = skipWhile;
//# sourceMappingURL=skipWhile.js.map

}),
45251: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.startWith = void 0;
var concat_1 = __webpack_require__(29982);
var args_1 = __webpack_require__(84446);
var lift_1 = __webpack_require__(54360);
function startWith() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    var scheduler = args_1.popScheduler(values);
    return lift_1.operate(function (source, subscriber) {
        (scheduler ? concat_1.concat(values, source, scheduler) : concat_1.concat(values, source)).subscribe(subscriber);
    });
}
exports.startWith = startWith;
//# sourceMappingURL=startWith.js.map

}),
91205: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.subscribeOn = void 0;
var lift_1 = __webpack_require__(54360);
function subscribeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return lift_1.operate(function (source, subscriber) {
        subscriber.add(scheduler.schedule(function () { return source.subscribe(subscriber); }, delay));
    });
}
exports.subscribeOn = subscribeOn;
//# sourceMappingURL=subscribeOn.js.map

}),
47622: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.switchAll = void 0;
var switchMap_1 = __webpack_require__(62443);
var identity_1 = __webpack_require__(6033);
function switchAll() {
    return switchMap_1.switchMap(identity_1.identity);
}
exports.switchAll = switchAll;
//# sourceMappingURL=switchAll.js.map

}),
62443: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.switchMap = void 0;
var innerFrom_1 = __webpack_require__(68196);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function switchMap(project, resultSelector) {
    return lift_1.operate(function (source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function () { return isComplete && !innerSubscriber && subscriber.complete(); };
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            innerSubscriber === null || innerSubscriber === void 0 ? void 0 : innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            innerFrom_1.innerFrom(project(value, outerIndex)).subscribe((innerSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (innerValue) { return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue); }, function () {
                innerSubscriber = null;
                checkComplete();
            })));
        }, function () {
            isComplete = true;
            checkComplete();
        }));
    });
}
exports.switchMap = switchMap;
//# sourceMappingURL=switchMap.js.map

}),
96525: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.switchMapTo = void 0;
var switchMap_1 = __webpack_require__(62443);
var isFunction_1 = __webpack_require__(64061);
function switchMapTo(innerObservable, resultSelector) {
    return isFunction_1.isFunction(resultSelector) ? switchMap_1.switchMap(function () { return innerObservable; }, resultSelector) : switchMap_1.switchMap(function () { return innerObservable; });
}
exports.switchMapTo = switchMapTo;
//# sourceMappingURL=switchMapTo.js.map

}),
74814: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.switchScan = void 0;
var switchMap_1 = __webpack_require__(62443);
var lift_1 = __webpack_require__(54360);
function switchScan(accumulator, seed) {
    return lift_1.operate(function (source, subscriber) {
        var state = seed;
        switchMap_1.switchMap(function (value, index) { return accumulator(state, value, index); }, function (_, innerValue) { return ((state = innerValue), innerValue); })(source).subscribe(subscriber);
        return function () {
            state = null;
        };
    });
}
exports.switchScan = switchScan;
//# sourceMappingURL=switchScan.js.map

}),
54424: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.take = void 0;
var empty_1 = __webpack_require__(88930);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function take(count) {
    return count <= 0
        ?
            function () { return empty_1.EMPTY; }
        : lift_1.operate(function (source, subscriber) {
            var seen = 0;
            source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
                if (++seen <= count) {
                    subscriber.next(value);
                    if (count <= seen) {
                        subscriber.complete();
                    }
                }
            }));
        });
}
exports.take = take;
//# sourceMappingURL=take.js.map

}),
45033: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.takeLast = void 0;
var empty_1 = __webpack_require__(88930);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function takeLast(count) {
    return count <= 0
        ? function () { return empty_1.EMPTY; }
        : lift_1.operate(function (source, subscriber) {
            var buffer = [];
            source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
                buffer.push(value);
                count < buffer.length && buffer.shift();
            }, function () {
                var e_1, _a;
                try {
                    for (var buffer_1 = __values(buffer), buffer_1_1 = buffer_1.next(); !buffer_1_1.done; buffer_1_1 = buffer_1.next()) {
                        var value = buffer_1_1.value;
                        subscriber.next(value);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (buffer_1_1 && !buffer_1_1.done && (_a = buffer_1.return)) _a.call(buffer_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                subscriber.complete();
            }, undefined, function () {
                buffer = null;
            }));
        });
}
exports.takeLast = takeLast;
//# sourceMappingURL=takeLast.js.map

}),
28436: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.takeUntil = void 0;
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
var innerFrom_1 = __webpack_require__(68196);
var noop_1 = __webpack_require__(72777);
function takeUntil(notifier) {
    return lift_1.operate(function (source, subscriber) {
        innerFrom_1.innerFrom(notifier).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () { return subscriber.complete(); }, noop_1.noop));
        !subscriber.closed && source.subscribe(subscriber);
    });
}
exports.takeUntil = takeUntil;
//# sourceMappingURL=takeUntil.js.map

}),
8891: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.takeWhile = void 0;
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function takeWhile(predicate, inclusive) {
    if (inclusive === void 0) { inclusive = false; }
    return lift_1.operate(function (source, subscriber) {
        var index = 0;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            var result = predicate(value, index++);
            (result || inclusive) && subscriber.next(value);
            !result && subscriber.complete();
        }));
    });
}
exports.takeWhile = takeWhile;
//# sourceMappingURL=takeWhile.js.map

}),
75667: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.tap = void 0;
var isFunction_1 = __webpack_require__(64061);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
var identity_1 = __webpack_require__(6033);
function tap(observerOrNext, error, complete) {
    var tapObserver = isFunction_1.isFunction(observerOrNext) || error || complete
        ?
            { next: observerOrNext, error: error, complete: complete }
        : observerOrNext;
    return tapObserver
        ? lift_1.operate(function (source, subscriber) {
            var _a;
            (_a = tapObserver.subscribe) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
            var isUnsub = true;
            source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
                var _a;
                (_a = tapObserver.next) === null || _a === void 0 ? void 0 : _a.call(tapObserver, value);
                subscriber.next(value);
            }, function () {
                var _a;
                isUnsub = false;
                (_a = tapObserver.complete) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
                subscriber.complete();
            }, function (err) {
                var _a;
                isUnsub = false;
                (_a = tapObserver.error) === null || _a === void 0 ? void 0 : _a.call(tapObserver, err);
                subscriber.error(err);
            }, function () {
                var _a, _b;
                if (isUnsub) {
                    (_a = tapObserver.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
                }
                (_b = tapObserver.finalize) === null || _b === void 0 ? void 0 : _b.call(tapObserver);
            }));
        })
        :
            identity_1.identity;
}
exports.tap = tap;
//# sourceMappingURL=tap.js.map

}),
10832: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.throttle = void 0;
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
var innerFrom_1 = __webpack_require__(68196);
function throttle(durationSelector, config) {
    return lift_1.operate(function (source, subscriber) {
        var _a = config !== null && config !== void 0 ? config : {}, _b = _a.leading, leading = _b === void 0 ? true : _b, _c = _a.trailing, trailing = _c === void 0 ? false : _c;
        var hasValue = false;
        var sendValue = null;
        var throttled = null;
        var isComplete = false;
        var endThrottling = function () {
            throttled === null || throttled === void 0 ? void 0 : throttled.unsubscribe();
            throttled = null;
            if (trailing) {
                send();
                isComplete && subscriber.complete();
            }
        };
        var cleanupThrottling = function () {
            throttled = null;
            isComplete && subscriber.complete();
        };
        var startThrottle = function (value) {
            return (throttled = innerFrom_1.innerFrom(durationSelector(value)).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, endThrottling, cleanupThrottling)));
        };
        var send = function () {
            if (hasValue) {
                hasValue = false;
                var value = sendValue;
                sendValue = null;
                subscriber.next(value);
                !isComplete && startThrottle(value);
            }
        };
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            hasValue = true;
            sendValue = value;
            !(throttled && !throttled.closed) && (leading ? send() : startThrottle(value));
        }, function () {
            isComplete = true;
            !(trailing && hasValue && throttled && !throttled.closed) && subscriber.complete();
        }));
    });
}
exports.throttle = throttle;
//# sourceMappingURL=throttle.js.map

}),
92312: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.throttleTime = void 0;
var async_1 = __webpack_require__(6341);
var throttle_1 = __webpack_require__(10832);
var timer_1 = __webpack_require__(44779);
function throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) { scheduler = async_1.asyncScheduler; }
    var duration$ = timer_1.timer(duration, scheduler);
    return throttle_1.throttle(function () { return duration$; }, config);
}
exports.throttleTime = throttleTime;
//# sourceMappingURL=throttleTime.js.map

}),
19645: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.throwIfEmpty = void 0;
var EmptyError_1 = __webpack_require__(20431);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function throwIfEmpty(errorFactory) {
    if (errorFactory === void 0) { errorFactory = defaultErrorFactory; }
    return lift_1.operate(function (source, subscriber) {
        var hasValue = false;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            hasValue = true;
            subscriber.next(value);
        }, function () { return (hasValue ? subscriber.complete() : subscriber.error(errorFactory())); }));
    });
}
exports.throwIfEmpty = throwIfEmpty;
function defaultErrorFactory() {
    return new EmptyError_1.EmptyError();
}
//# sourceMappingURL=throwIfEmpty.js.map

}),
664: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TimeInterval = exports.timeInterval = void 0;
var async_1 = __webpack_require__(6341);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function timeInterval(scheduler) {
    if (scheduler === void 0) { scheduler = async_1.asyncScheduler; }
    return lift_1.operate(function (source, subscriber) {
        var last = scheduler.now();
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            var now = scheduler.now();
            var interval = now - last;
            last = now;
            subscriber.next(new TimeInterval(value, interval));
        }));
    });
}
exports.timeInterval = timeInterval;
var TimeInterval = (function () {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}());
exports.TimeInterval = TimeInterval;
//# sourceMappingURL=timeInterval.js.map

}),
59204: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.timeout = exports.TimeoutError = void 0;
var async_1 = __webpack_require__(6341);
var isDate_1 = __webpack_require__(51003);
var lift_1 = __webpack_require__(54360);
var innerFrom_1 = __webpack_require__(68196);
var createErrorClass_1 = __webpack_require__(14288);
var OperatorSubscriber_1 = __webpack_require__(11729);
var executeSchedule_1 = __webpack_require__(98726);
exports.TimeoutError = createErrorClass_1.createErrorClass(function (_super) {
    return function TimeoutErrorImpl(info) {
        if (info === void 0) { info = null; }
        _super(this);
        this.message = 'Timeout has occurred';
        this.name = 'TimeoutError';
        this.info = info;
    };
});
function timeout(config, schedulerArg) {
    var _a = (isDate_1.isValidDate(config) ? { first: config } : typeof config === 'number' ? { each: config } : config), first = _a.first, each = _a.each, _b = _a.with, _with = _b === void 0 ? timeoutErrorFactory : _b, _c = _a.scheduler, scheduler = _c === void 0 ? schedulerArg !== null && schedulerArg !== void 0 ? schedulerArg : async_1.asyncScheduler : _c, _d = _a.meta, meta = _d === void 0 ? null : _d;
    if (first == null && each == null) {
        throw new TypeError('No timeout provided.');
    }
    return lift_1.operate(function (source, subscriber) {
        var originalSourceSubscription;
        var timerSubscription;
        var lastValue = null;
        var seen = 0;
        var startTimer = function (delay) {
            timerSubscription = executeSchedule_1.executeSchedule(subscriber, scheduler, function () {
                try {
                    originalSourceSubscription.unsubscribe();
                    innerFrom_1.innerFrom(_with({
                        meta: meta,
                        lastValue: lastValue,
                        seen: seen,
                    })).subscribe(subscriber);
                }
                catch (err) {
                    subscriber.error(err);
                }
            }, delay);
        };
        originalSourceSubscription = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.unsubscribe();
            seen++;
            subscriber.next((lastValue = value));
            each > 0 && startTimer(each);
        }, undefined, undefined, function () {
            if (!(timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.closed)) {
                timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.unsubscribe();
            }
            lastValue = null;
        }));
        !seen && startTimer(first != null ? (typeof first === 'number' ? first : +first - scheduler.now()) : each);
    });
}
exports.timeout = timeout;
function timeoutErrorFactory(info) {
    throw new exports.TimeoutError(info);
}
//# sourceMappingURL=timeout.js.map

}),
24710: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.timeoutWith = void 0;
var async_1 = __webpack_require__(6341);
var isDate_1 = __webpack_require__(51003);
var timeout_1 = __webpack_require__(59204);
function timeoutWith(due, withObservable, scheduler) {
    var first;
    var each;
    var _with;
    scheduler = scheduler !== null && scheduler !== void 0 ? scheduler : async_1.async;
    if (isDate_1.isValidDate(due)) {
        first = due;
    }
    else if (typeof due === 'number') {
        each = due;
    }
    if (withObservable) {
        _with = function () { return withObservable; };
    }
    else {
        throw new TypeError('No observable provided to switch to');
    }
    if (first == null && each == null) {
        throw new TypeError('No timeout provided.');
    }
    return timeout_1.timeout({
        first: first,
        each: each,
        scheduler: scheduler,
        with: _with,
    });
}
exports.timeoutWith = timeoutWith;
//# sourceMappingURL=timeoutWith.js.map

}),
26694: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.timestamp = void 0;
var dateTimestampProvider_1 = __webpack_require__(37300);
var map_1 = __webpack_require__(92619);
function timestamp(timestampProvider) {
    if (timestampProvider === void 0) { timestampProvider = dateTimestampProvider_1.dateTimestampProvider; }
    return map_1.map(function (value) { return ({ value: value, timestamp: timestampProvider.now() }); });
}
exports.timestamp = timestamp;
//# sourceMappingURL=timestamp.js.map

}),
3223: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.toArray = void 0;
var reduce_1 = __webpack_require__(71653);
var lift_1 = __webpack_require__(54360);
var arrReducer = function (arr, value) { return (arr.push(value), arr); };
function toArray() {
    return lift_1.operate(function (source, subscriber) {
        reduce_1.reduce(arrReducer, [])(source).subscribe(subscriber);
    });
}
exports.toArray = toArray;
//# sourceMappingURL=toArray.js.map

}),
86727: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.window = void 0;
var Subject_1 = __webpack_require__(30250);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
var noop_1 = __webpack_require__(72777);
var innerFrom_1 = __webpack_require__(68196);
function window(windowBoundaries) {
    return lift_1.operate(function (source, subscriber) {
        var windowSubject = new Subject_1.Subject();
        subscriber.next(windowSubject.asObservable());
        var errorHandler = function (err) {
            windowSubject.error(err);
            subscriber.error(err);
        };
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return windowSubject === null || windowSubject === void 0 ? void 0 : windowSubject.next(value); }, function () {
            windowSubject.complete();
            subscriber.complete();
        }, errorHandler));
        innerFrom_1.innerFrom(windowBoundaries).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
            windowSubject.complete();
            subscriber.next((windowSubject = new Subject_1.Subject()));
        }, noop_1.noop, errorHandler));
        return function () {
            windowSubject === null || windowSubject === void 0 ? void 0 : windowSubject.unsubscribe();
            windowSubject = null;
        };
    });
}
exports.window = window;
//# sourceMappingURL=window.js.map

}),
78806: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.windowCount = void 0;
var Subject_1 = __webpack_require__(30250);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
function windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) { startWindowEvery = 0; }
    var startEvery = startWindowEvery > 0 ? startWindowEvery : windowSize;
    return lift_1.operate(function (source, subscriber) {
        var windows = [new Subject_1.Subject()];
        var starts = [];
        var count = 0;
        subscriber.next(windows[0].asObservable());
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            var e_1, _a;
            try {
                for (var windows_1 = __values(windows), windows_1_1 = windows_1.next(); !windows_1_1.done; windows_1_1 = windows_1.next()) {
                    var window_1 = windows_1_1.value;
                    window_1.next(value);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (windows_1_1 && !windows_1_1.done && (_a = windows_1.return)) _a.call(windows_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            var c = count - windowSize + 1;
            if (c >= 0 && c % startEvery === 0) {
                windows.shift().complete();
            }
            if (++count % startEvery === 0) {
                var window_2 = new Subject_1.Subject();
                windows.push(window_2);
                subscriber.next(window_2.asObservable());
            }
        }, function () {
            while (windows.length > 0) {
                windows.shift().complete();
            }
            subscriber.complete();
        }, function (err) {
            while (windows.length > 0) {
                windows.shift().error(err);
            }
            subscriber.error(err);
        }, function () {
            starts = null;
            windows = null;
        }));
    });
}
exports.windowCount = windowCount;
//# sourceMappingURL=windowCount.js.map

}),
54645: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.windowTime = void 0;
var Subject_1 = __webpack_require__(30250);
var async_1 = __webpack_require__(6341);
var Subscription_1 = __webpack_require__(68631);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
var arrRemove_1 = __webpack_require__(59836);
var args_1 = __webpack_require__(84446);
var executeSchedule_1 = __webpack_require__(98726);
function windowTime(windowTimeSpan) {
    var _a, _b;
    var otherArgs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        otherArgs[_i - 1] = arguments[_i];
    }
    var scheduler = (_a = args_1.popScheduler(otherArgs)) !== null && _a !== void 0 ? _a : async_1.asyncScheduler;
    var windowCreationInterval = (_b = otherArgs[0]) !== null && _b !== void 0 ? _b : null;
    var maxWindowSize = otherArgs[1] || Infinity;
    return lift_1.operate(function (source, subscriber) {
        var windowRecords = [];
        var restartOnClose = false;
        var closeWindow = function (record) {
            var window = record.window, subs = record.subs;
            window.complete();
            subs.unsubscribe();
            arrRemove_1.arrRemove(windowRecords, record);
            restartOnClose && startWindow();
        };
        var startWindow = function () {
            if (windowRecords) {
                var subs = new Subscription_1.Subscription();
                subscriber.add(subs);
                var window_1 = new Subject_1.Subject();
                var record_1 = {
                    window: window_1,
                    subs: subs,
                    seen: 0,
                };
                windowRecords.push(record_1);
                subscriber.next(window_1.asObservable());
                executeSchedule_1.executeSchedule(subs, scheduler, function () { return closeWindow(record_1); }, windowTimeSpan);
            }
        };
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            executeSchedule_1.executeSchedule(subscriber, scheduler, startWindow, windowCreationInterval, true);
        }
        else {
            restartOnClose = true;
        }
        startWindow();
        var loop = function (cb) { return windowRecords.slice().forEach(cb); };
        var terminate = function (cb) {
            loop(function (_a) {
                var window = _a.window;
                return cb(window);
            });
            cb(subscriber);
            subscriber.unsubscribe();
        };
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            loop(function (record) {
                record.window.next(value);
                maxWindowSize <= ++record.seen && closeWindow(record);
            });
        }, function () { return terminate(function (consumer) { return consumer.complete(); }); }, function (err) { return terminate(function (consumer) { return consumer.error(err); }); }));
        return function () {
            windowRecords = null;
        };
    });
}
exports.windowTime = windowTime;
//# sourceMappingURL=windowTime.js.map

}),
98131: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.windowToggle = void 0;
var Subject_1 = __webpack_require__(30250);
var Subscription_1 = __webpack_require__(68631);
var lift_1 = __webpack_require__(54360);
var innerFrom_1 = __webpack_require__(68196);
var OperatorSubscriber_1 = __webpack_require__(11729);
var noop_1 = __webpack_require__(72777);
var arrRemove_1 = __webpack_require__(59836);
function windowToggle(openings, closingSelector) {
    return lift_1.operate(function (source, subscriber) {
        var windows = [];
        var handleError = function (err) {
            while (0 < windows.length) {
                windows.shift().error(err);
            }
            subscriber.error(err);
        };
        innerFrom_1.innerFrom(openings).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (openValue) {
            var window = new Subject_1.Subject();
            windows.push(window);
            var closingSubscription = new Subscription_1.Subscription();
            var closeWindow = function () {
                arrRemove_1.arrRemove(windows, window);
                window.complete();
                closingSubscription.unsubscribe();
            };
            var closingNotifier;
            try {
                closingNotifier = innerFrom_1.innerFrom(closingSelector(openValue));
            }
            catch (err) {
                handleError(err);
                return;
            }
            subscriber.next(window.asObservable());
            closingSubscription.add(closingNotifier.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, closeWindow, noop_1.noop, handleError)));
        }, noop_1.noop));
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            var e_1, _a;
            var windowsCopy = windows.slice();
            try {
                for (var windowsCopy_1 = __values(windowsCopy), windowsCopy_1_1 = windowsCopy_1.next(); !windowsCopy_1_1.done; windowsCopy_1_1 = windowsCopy_1.next()) {
                    var window_1 = windowsCopy_1_1.value;
                    window_1.next(value);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (windowsCopy_1_1 && !windowsCopy_1_1.done && (_a = windowsCopy_1.return)) _a.call(windowsCopy_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }, function () {
            while (0 < windows.length) {
                windows.shift().complete();
            }
            subscriber.complete();
        }, handleError, function () {
            while (0 < windows.length) {
                windows.shift().unsubscribe();
            }
        }));
    });
}
exports.windowToggle = windowToggle;
//# sourceMappingURL=windowToggle.js.map

}),
61621: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.windowWhen = void 0;
var Subject_1 = __webpack_require__(30250);
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
var innerFrom_1 = __webpack_require__(68196);
function windowWhen(closingSelector) {
    return lift_1.operate(function (source, subscriber) {
        var window;
        var closingSubscriber;
        var handleError = function (err) {
            window.error(err);
            subscriber.error(err);
        };
        var openWindow = function () {
            closingSubscriber === null || closingSubscriber === void 0 ? void 0 : closingSubscriber.unsubscribe();
            window === null || window === void 0 ? void 0 : window.complete();
            window = new Subject_1.Subject();
            subscriber.next(window.asObservable());
            var closingNotifier;
            try {
                closingNotifier = innerFrom_1.innerFrom(closingSelector());
            }
            catch (err) {
                handleError(err);
                return;
            }
            closingNotifier.subscribe((closingSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, openWindow, openWindow, handleError)));
        };
        openWindow();
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return window.next(value); }, function () {
            window.complete();
            subscriber.complete();
        }, handleError, function () {
            closingSubscriber === null || closingSubscriber === void 0 ? void 0 : closingSubscriber.unsubscribe();
            window = null;
        }));
    });
}
exports.windowWhen = windowWhen;
//# sourceMappingURL=windowWhen.js.map

}),
83655: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.withLatestFrom = void 0;
var lift_1 = __webpack_require__(54360);
var OperatorSubscriber_1 = __webpack_require__(11729);
var innerFrom_1 = __webpack_require__(68196);
var identity_1 = __webpack_require__(6033);
var noop_1 = __webpack_require__(72777);
var args_1 = __webpack_require__(84446);
function withLatestFrom() {
    var inputs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        inputs[_i] = arguments[_i];
    }
    var project = args_1.popResultSelector(inputs);
    return lift_1.operate(function (source, subscriber) {
        var len = inputs.length;
        var otherValues = new Array(len);
        var hasValue = inputs.map(function () { return false; });
        var ready = false;
        var _loop_1 = function (i) {
            innerFrom_1.innerFrom(inputs[i]).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
                otherValues[i] = value;
                if (!ready && !hasValue[i]) {
                    hasValue[i] = true;
                    (ready = hasValue.every(identity_1.identity)) && (hasValue = null);
                }
            }, noop_1.noop));
        };
        for (var i = 0; i < len; i++) {
            _loop_1(i);
        }
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
            if (ready) {
                var values = __spreadArray([value], __read(otherValues));
                subscriber.next(project ? project.apply(void 0, __spreadArray([], __read(values))) : values);
            }
        }));
    });
}
exports.withLatestFrom = withLatestFrom;
//# sourceMappingURL=withLatestFrom.js.map

}),
96880: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.zip = void 0;
var zip_1 = __webpack_require__(14534);
var lift_1 = __webpack_require__(54360);
function zip() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return lift_1.operate(function (source, subscriber) {
        zip_1.zip.apply(void 0, __spreadArray([source], __read(sources))).subscribe(subscriber);
    });
}
exports.zip = zip;
//# sourceMappingURL=zip.js.map

}),
35684: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.zipAll = void 0;
var zip_1 = __webpack_require__(14534);
var joinAllInternals_1 = __webpack_require__(96669);
function zipAll(project) {
    return joinAllInternals_1.joinAllInternals(zip_1.zip, project);
}
exports.zipAll = zipAll;
//# sourceMappingURL=zipAll.js.map

}),
71262: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.zipWith = void 0;
var zip_1 = __webpack_require__(96880);
function zipWith() {
    var otherInputs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        otherInputs[_i] = arguments[_i];
    }
    return zip_1.zip.apply(void 0, __spreadArray([], __read(otherInputs)));
}
exports.zipWith = zipWith;
//# sourceMappingURL=zipWith.js.map

}),
46443: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.scheduleArray = void 0;
var Observable_1 = __webpack_require__(18547);
function scheduleArray(input, scheduler) {
    return new Observable_1.Observable(function (subscriber) {
        var i = 0;
        return scheduler.schedule(function () {
            if (i === input.length) {
                subscriber.complete();
            }
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) {
                    this.schedule();
                }
            }
        });
    });
}
exports.scheduleArray = scheduleArray;
//# sourceMappingURL=scheduleArray.js.map

}),
81264: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.scheduleAsyncIterable = void 0;
var Observable_1 = __webpack_require__(18547);
var executeSchedule_1 = __webpack_require__(98726);
function scheduleAsyncIterable(input, scheduler) {
    if (!input) {
        throw new Error('Iterable cannot be null');
    }
    return new Observable_1.Observable(function (subscriber) {
        executeSchedule_1.executeSchedule(subscriber, scheduler, function () {
            var iterator = input[Symbol.asyncIterator]();
            executeSchedule_1.executeSchedule(subscriber, scheduler, function () {
                iterator.next().then(function (result) {
                    if (result.done) {
                        subscriber.complete();
                    }
                    else {
                        subscriber.next(result.value);
                    }
                });
            }, 0, true);
        });
    });
}
exports.scheduleAsyncIterable = scheduleAsyncIterable;
//# sourceMappingURL=scheduleAsyncIterable.js.map

}),
35955: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.scheduleIterable = void 0;
var Observable_1 = __webpack_require__(18547);
var iterator_1 = __webpack_require__(68559);
var isFunction_1 = __webpack_require__(64061);
var executeSchedule_1 = __webpack_require__(98726);
function scheduleIterable(input, scheduler) {
    return new Observable_1.Observable(function (subscriber) {
        var iterator;
        executeSchedule_1.executeSchedule(subscriber, scheduler, function () {
            iterator = input[iterator_1.iterator]();
            executeSchedule_1.executeSchedule(subscriber, scheduler, function () {
                var _a;
                var value;
                var done;
                try {
                    (_a = iterator.next(), value = _a.value, done = _a.done);
                }
                catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) {
                    subscriber.complete();
                }
                else {
                    subscriber.next(value);
                }
            }, 0, true);
        });
        return function () { return isFunction_1.isFunction(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return(); };
    });
}
exports.scheduleIterable = scheduleIterable;
//# sourceMappingURL=scheduleIterable.js.map

}),
93861: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.scheduleObservable = void 0;
var innerFrom_1 = __webpack_require__(68196);
var observeOn_1 = __webpack_require__(89329);
var subscribeOn_1 = __webpack_require__(91205);
function scheduleObservable(input, scheduler) {
    return innerFrom_1.innerFrom(input).pipe(subscribeOn_1.subscribeOn(scheduler), observeOn_1.observeOn(scheduler));
}
exports.scheduleObservable = scheduleObservable;
//# sourceMappingURL=scheduleObservable.js.map

}),
70359: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.schedulePromise = void 0;
var innerFrom_1 = __webpack_require__(68196);
var observeOn_1 = __webpack_require__(89329);
var subscribeOn_1 = __webpack_require__(91205);
function schedulePromise(input, scheduler) {
    return innerFrom_1.innerFrom(input).pipe(subscribeOn_1.subscribeOn(scheduler), observeOn_1.observeOn(scheduler));
}
exports.schedulePromise = schedulePromise;
//# sourceMappingURL=schedulePromise.js.map

}),
16516: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.scheduleReadableStreamLike = void 0;
var scheduleAsyncIterable_1 = __webpack_require__(81264);
var isReadableStreamLike_1 = __webpack_require__(70393);
function scheduleReadableStreamLike(input, scheduler) {
    return scheduleAsyncIterable_1.scheduleAsyncIterable(isReadableStreamLike_1.readableStreamLikeToAsyncGenerator(input), scheduler);
}
exports.scheduleReadableStreamLike = scheduleReadableStreamLike;
//# sourceMappingURL=scheduleReadableStreamLike.js.map

}),
29143: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.scheduled = void 0;
var scheduleObservable_1 = __webpack_require__(93861);
var schedulePromise_1 = __webpack_require__(70359);
var scheduleArray_1 = __webpack_require__(46443);
var scheduleIterable_1 = __webpack_require__(35955);
var scheduleAsyncIterable_1 = __webpack_require__(81264);
var isInteropObservable_1 = __webpack_require__(78244);
var isPromise_1 = __webpack_require__(94283);
var isArrayLike_1 = __webpack_require__(79128);
var isIterable_1 = __webpack_require__(14886);
var isAsyncIterable_1 = __webpack_require__(18806);
var throwUnobservableError_1 = __webpack_require__(76282);
var isReadableStreamLike_1 = __webpack_require__(70393);
var scheduleReadableStreamLike_1 = __webpack_require__(16516);
function scheduled(input, scheduler) {
    if (input != null) {
        if (isInteropObservable_1.isInteropObservable(input)) {
            return scheduleObservable_1.scheduleObservable(input, scheduler);
        }
        if (isArrayLike_1.isArrayLike(input)) {
            return scheduleArray_1.scheduleArray(input, scheduler);
        }
        if (isPromise_1.isPromise(input)) {
            return schedulePromise_1.schedulePromise(input, scheduler);
        }
        if (isAsyncIterable_1.isAsyncIterable(input)) {
            return scheduleAsyncIterable_1.scheduleAsyncIterable(input, scheduler);
        }
        if (isIterable_1.isIterable(input)) {
            return scheduleIterable_1.scheduleIterable(input, scheduler);
        }
        if (isReadableStreamLike_1.isReadableStreamLike(input)) {
            return scheduleReadableStreamLike_1.scheduleReadableStreamLike(input, scheduler);
        }
    }
    throw throwUnobservableError_1.createInvalidObservableTypeError(input);
}
exports.scheduled = scheduled;
//# sourceMappingURL=scheduled.js.map

}),
85906: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Action = void 0;
var Subscription_1 = __webpack_require__(68631);
var Action = (function (_super) {
    __extends(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        return this;
    };
    return Action;
}(Subscription_1.Subscription));
exports.Action = Action;
//# sourceMappingURL=Action.js.map

}),
53044: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AnimationFrameAction = void 0;
var AsyncAction_1 = __webpack_require__(35902);
var animationFrameProvider_1 = __webpack_require__(85158);
var AnimationFrameAction = (function (_super) {
    __extends(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler._scheduled || (scheduler._scheduled = animationFrameProvider_1.animationFrameProvider.requestAnimationFrame(function () { return scheduler.flush(undefined); }));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        var _a;
        if (delay === void 0) { delay = 0; }
        if (delay != null ? delay > 0 : this.delay > 0) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        var actions = scheduler.actions;
        if (id != null && ((_a = actions[actions.length - 1]) === null || _a === void 0 ? void 0 : _a.id) !== id) {
            animationFrameProvider_1.animationFrameProvider.cancelAnimationFrame(id);
            scheduler._scheduled = undefined;
        }
        return undefined;
    };
    return AnimationFrameAction;
}(AsyncAction_1.AsyncAction));
exports.AnimationFrameAction = AnimationFrameAction;
//# sourceMappingURL=AnimationFrameAction.js.map

}),
44734: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AnimationFrameScheduler = void 0;
var AsyncScheduler_1 = __webpack_require__(76790);
var AnimationFrameScheduler = (function (_super) {
    __extends(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationFrameScheduler.prototype.flush = function (action) {
        this._active = true;
        var flushId = this._scheduled;
        this._scheduled = undefined;
        var actions = this.actions;
        var error;
        action = action || actions.shift();
        do {
            if ((error = action.execute(action.state, action.delay))) {
                break;
            }
        } while ((action = actions[0]) && action.id === flushId && actions.shift());
        this._active = false;
        if (error) {
            while ((action = actions[0]) && action.id === flushId && actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AnimationFrameScheduler;
}(AsyncScheduler_1.AsyncScheduler));
exports.AnimationFrameScheduler = AnimationFrameScheduler;
//# sourceMappingURL=AnimationFrameScheduler.js.map

}),
53742: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AsapAction = void 0;
var AsyncAction_1 = __webpack_require__(35902);
var immediateProvider_1 = __webpack_require__(18760);
var AsapAction = (function (_super) {
    __extends(AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler._scheduled || (scheduler._scheduled = immediateProvider_1.immediateProvider.setImmediate(scheduler.flush.bind(scheduler, undefined)));
    };
    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        var _a;
        if (delay === void 0) { delay = 0; }
        if (delay != null ? delay > 0 : this.delay > 0) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        var actions = scheduler.actions;
        if (id != null && ((_a = actions[actions.length - 1]) === null || _a === void 0 ? void 0 : _a.id) !== id) {
            immediateProvider_1.immediateProvider.clearImmediate(id);
            if (scheduler._scheduled === id) {
                scheduler._scheduled = undefined;
            }
        }
        return undefined;
    };
    return AsapAction;
}(AsyncAction_1.AsyncAction));
exports.AsapAction = AsapAction;
//# sourceMappingURL=AsapAction.js.map

}),
90607: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AsapScheduler = void 0;
var AsyncScheduler_1 = __webpack_require__(76790);
var AsapScheduler = (function (_super) {
    __extends(AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function (action) {
        this._active = true;
        var flushId = this._scheduled;
        this._scheduled = undefined;
        var actions = this.actions;
        var error;
        action = action || actions.shift();
        do {
            if ((error = action.execute(action.state, action.delay))) {
                break;
            }
        } while ((action = actions[0]) && action.id === flushId && actions.shift());
        this._active = false;
        if (error) {
            while ((action = actions[0]) && action.id === flushId && actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsapScheduler;
}(AsyncScheduler_1.AsyncScheduler));
exports.AsapScheduler = AsapScheduler;
//# sourceMappingURL=AsapScheduler.js.map

}),
35902: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AsyncAction = void 0;
var Action_1 = __webpack_require__(85906);
var intervalProvider_1 = __webpack_require__(36545);
var arrRemove_1 = __webpack_require__(59836);
var AsyncAction = (function (_super) {
    __extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function (state, delay) {
        var _a;
        if (delay === void 0) { delay = 0; }
        if (this.closed) {
            return this;
        }
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function (scheduler, _id, delay) {
        if (delay === void 0) { delay = 0; }
        return intervalProvider_1.intervalProvider.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function (_scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay != null && this.delay === delay && this.pending === false) {
            return id;
        }
        if (id != null) {
            intervalProvider_1.intervalProvider.clearInterval(id);
        }
        return undefined;
    };
    AsyncAction.prototype.execute = function (state, delay) {
        if (this.closed) {
            return new Error('executing a cancelled action');
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
            return error;
        }
        else if (this.pending === false && this.id != null) {
            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
    };
    AsyncAction.prototype._execute = function (state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        }
        catch (e) {
            errored = true;
            errorValue = e ? e : new Error('Scheduled action threw falsy error');
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function () {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            arrRemove_1.arrRemove(actions, this);
            if (id != null) {
                this.id = this.recycleAsyncId(scheduler, id, null);
            }
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}(Action_1.Action));
exports.AsyncAction = AsyncAction;
//# sourceMappingURL=AsyncAction.js.map

}),
76790: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AsyncScheduler = void 0;
var Scheduler_1 = __webpack_require__(86694);
var AsyncScheduler = (function (_super) {
    __extends(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) { now = Scheduler_1.Scheduler.now; }
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function (action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if ((error = action.execute(action.state, action.delay))) {
                break;
            }
        } while ((action = actions.shift()));
        this._active = false;
        if (error) {
            while ((action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsyncScheduler;
}(Scheduler_1.Scheduler));
exports.AsyncScheduler = AsyncScheduler;
//# sourceMappingURL=AsyncScheduler.js.map

}),
9703: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueueAction = void 0;
var AsyncAction_1 = __webpack_require__(35902);
var QueueAction = (function (_super) {
    __extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay > 0) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function (state, delay) {
        return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if ((delay != null && delay > 0) || (delay == null && this.delay > 0)) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.flush(this);
        return 0;
    };
    return QueueAction;
}(AsyncAction_1.AsyncAction));
exports.QueueAction = QueueAction;
//# sourceMappingURL=QueueAction.js.map

}),
55908: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueueScheduler = void 0;
var AsyncScheduler_1 = __webpack_require__(76790);
var QueueScheduler = (function (_super) {
    __extends(QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}(AsyncScheduler_1.AsyncScheduler));
exports.QueueScheduler = QueueScheduler;
//# sourceMappingURL=QueueScheduler.js.map

}),
16531: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.VirtualAction = exports.VirtualTimeScheduler = void 0;
var AsyncAction_1 = __webpack_require__(35902);
var Subscription_1 = __webpack_require__(68631);
var AsyncScheduler_1 = __webpack_require__(76790);
var VirtualTimeScheduler = (function (_super) {
    __extends(VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(schedulerActionCtor, maxFrames) {
        if (schedulerActionCtor === void 0) { schedulerActionCtor = VirtualAction; }
        if (maxFrames === void 0) { maxFrames = Infinity; }
        var _this = _super.call(this, schedulerActionCtor, function () { return _this.frame; }) || this;
        _this.maxFrames = maxFrames;
        _this.frame = 0;
        _this.index = -1;
        return _this;
    }
    VirtualTimeScheduler.prototype.flush = function () {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error;
        var action;
        while ((action = actions[0]) && action.delay <= maxFrames) {
            actions.shift();
            this.frame = action.delay;
            if ((error = action.execute(action.state, action.delay))) {
                break;
            }
        }
        if (error) {
            while ((action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}(AsyncScheduler_1.AsyncScheduler));
exports.VirtualTimeScheduler = VirtualTimeScheduler;
var VirtualAction = (function (_super) {
    __extends(VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) { index = (scheduler.index += 1); }
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.index = index;
        _this.active = true;
        _this.index = scheduler.index = index;
        return _this;
    }
    VirtualAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (Number.isFinite(delay)) {
            if (!this.id) {
                return _super.prototype.schedule.call(this, state, delay);
            }
            this.active = false;
            var action = new VirtualAction(this.scheduler, this.work);
            this.add(action);
            return action.schedule(state, delay);
        }
        else {
            return Subscription_1.Subscription.EMPTY;
        }
    };
    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return 1;
    };
    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        return undefined;
    };
    VirtualAction.prototype._execute = function (state, delay) {
        if (this.active === true) {
            return _super.prototype._execute.call(this, state, delay);
        }
    };
    VirtualAction.sortActions = function (a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) {
                return 0;
            }
            else if (a.index > b.index) {
                return 1;
            }
            else {
                return -1;
            }
        }
        else if (a.delay > b.delay) {
            return 1;
        }
        else {
            return -1;
        }
    };
    return VirtualAction;
}(AsyncAction_1.AsyncAction));
exports.VirtualAction = VirtualAction;
//# sourceMappingURL=VirtualTimeScheduler.js.map

}),
33824: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.animationFrame = exports.animationFrameScheduler = void 0;
var AnimationFrameAction_1 = __webpack_require__(53044);
var AnimationFrameScheduler_1 = __webpack_require__(44734);
exports.animationFrameScheduler = new AnimationFrameScheduler_1.AnimationFrameScheduler(AnimationFrameAction_1.AnimationFrameAction);
exports.animationFrame = exports.animationFrameScheduler;
//# sourceMappingURL=animationFrame.js.map

}),
85158: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.animationFrameProvider = void 0;
var Subscription_1 = __webpack_require__(68631);
exports.animationFrameProvider = {
    schedule: function (callback) {
        var request = requestAnimationFrame;
        var cancel = cancelAnimationFrame;
        var delegate = exports.animationFrameProvider.delegate;
        if (delegate) {
            request = delegate.requestAnimationFrame;
            cancel = delegate.cancelAnimationFrame;
        }
        var handle = request(function (timestamp) {
            cancel = undefined;
            callback(timestamp);
        });
        return new Subscription_1.Subscription(function () { return cancel === null || cancel === void 0 ? void 0 : cancel(handle); });
    },
    requestAnimationFrame: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var delegate = exports.animationFrameProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.requestAnimationFrame) || requestAnimationFrame).apply(void 0, __spreadArray([], __read(args)));
    },
    cancelAnimationFrame: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var delegate = exports.animationFrameProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.cancelAnimationFrame) || cancelAnimationFrame).apply(void 0, __spreadArray([], __read(args)));
    },
    delegate: undefined,
};
//# sourceMappingURL=animationFrameProvider.js.map

}),
69343: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.asap = exports.asapScheduler = void 0;
var AsapAction_1 = __webpack_require__(53742);
var AsapScheduler_1 = __webpack_require__(90607);
exports.asapScheduler = new AsapScheduler_1.AsapScheduler(AsapAction_1.AsapAction);
exports.asap = exports.asapScheduler;
//# sourceMappingURL=asap.js.map

}),
6341: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.async = exports.asyncScheduler = void 0;
var AsyncAction_1 = __webpack_require__(35902);
var AsyncScheduler_1 = __webpack_require__(76790);
exports.asyncScheduler = new AsyncScheduler_1.AsyncScheduler(AsyncAction_1.AsyncAction);
exports.async = exports.asyncScheduler;
//# sourceMappingURL=async.js.map

}),
37300: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.dateTimestampProvider = void 0;
exports.dateTimestampProvider = {
    now: function () {
        return (exports.dateTimestampProvider.delegate || Date).now();
    },
    delegate: undefined,
};
//# sourceMappingURL=dateTimestampProvider.js.map

}),
18760: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.immediateProvider = void 0;
var Immediate_1 = __webpack_require__(68443);
var setImmediate = Immediate_1.Immediate.setImmediate, clearImmediate = Immediate_1.Immediate.clearImmediate;
exports.immediateProvider = {
    setImmediate: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var delegate = exports.immediateProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.setImmediate) || setImmediate).apply(void 0, __spreadArray([], __read(args)));
    },
    clearImmediate: function (handle) {
        var delegate = exports.immediateProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearImmediate) || clearImmediate)(handle);
    },
    delegate: undefined,
};
//# sourceMappingURL=immediateProvider.js.map

}),
36545: (function (__unused_webpack_module, exports) {
"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.intervalProvider = void 0;
exports.intervalProvider = {
    setInterval: function (handler, timeout) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        var delegate = exports.intervalProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) {
            return delegate.setInterval.apply(delegate, __spreadArray([handler, timeout], __read(args)));
        }
        return setInterval.apply(void 0, __spreadArray([handler, timeout], __read(args)));
    },
    clearInterval: function (handle) {
        var delegate = exports.intervalProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined,
};
//# sourceMappingURL=intervalProvider.js.map

}),
87731: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.performanceTimestampProvider = void 0;
exports.performanceTimestampProvider = {
    now: function () {
        return (exports.performanceTimestampProvider.delegate || performance).now();
    },
    delegate: undefined,
};
//# sourceMappingURL=performanceTimestampProvider.js.map

}),
34171: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.queue = exports.queueScheduler = void 0;
var QueueAction_1 = __webpack_require__(9703);
var QueueScheduler_1 = __webpack_require__(55908);
exports.queueScheduler = new QueueScheduler_1.QueueScheduler(QueueAction_1.QueueAction);
exports.queue = exports.queueScheduler;
//# sourceMappingURL=queue.js.map

}),
80933: (function (__unused_webpack_module, exports) {
"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.timeoutProvider = void 0;
exports.timeoutProvider = {
    setTimeout: function (handler, timeout) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        var delegate = exports.timeoutProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) {
            return delegate.setTimeout.apply(delegate, __spreadArray([handler, timeout], __read(args)));
        }
        return setTimeout.apply(void 0, __spreadArray([handler, timeout], __read(args)));
    },
    clearTimeout: function (handle) {
        var delegate = exports.timeoutProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined,
};
//# sourceMappingURL=timeoutProvider.js.map

}),
68559: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.iterator = exports.getSymbolIterator = void 0;
function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) {
        return '@@iterator';
    }
    return Symbol.iterator;
}
exports.getSymbolIterator = getSymbolIterator;
exports.iterator = getSymbolIterator();
//# sourceMappingURL=iterator.js.map

}),
58432: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.observable = void 0;
exports.observable = (function () { return (typeof Symbol === 'function' && Symbol.observable) || '@@observable'; })();
//# sourceMappingURL=observable.js.map

}),
39416: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=types.js.map

}),
56985: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ArgumentOutOfRangeError = void 0;
var createErrorClass_1 = __webpack_require__(14288);
exports.ArgumentOutOfRangeError = createErrorClass_1.createErrorClass(function (_super) {
    return function ArgumentOutOfRangeErrorImpl() {
        _super(this);
        this.name = 'ArgumentOutOfRangeError';
        this.message = 'argument out of range';
    };
});
//# sourceMappingURL=ArgumentOutOfRangeError.js.map

}),
20431: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EmptyError = void 0;
var createErrorClass_1 = __webpack_require__(14288);
exports.EmptyError = createErrorClass_1.createErrorClass(function (_super) { return function EmptyErrorImpl() {
    _super(this);
    this.name = 'EmptyError';
    this.message = 'no elements in sequence';
}; });
//# sourceMappingURL=EmptyError.js.map

}),
68443: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TestTools = exports.Immediate = void 0;
var nextHandle = 1;
var resolved;
var activeHandles = {};
function findAndClearHandle(handle) {
    if (handle in activeHandles) {
        delete activeHandles[handle];
        return true;
    }
    return false;
}
exports.Immediate = {
    setImmediate: function (cb) {
        var handle = nextHandle++;
        activeHandles[handle] = true;
        if (!resolved) {
            resolved = Promise.resolve();
        }
        resolved.then(function () { return findAndClearHandle(handle) && cb(); });
        return handle;
    },
    clearImmediate: function (handle) {
        findAndClearHandle(handle);
    },
};
exports.TestTools = {
    pending: function () {
        return Object.keys(activeHandles).length;
    }
};
//# sourceMappingURL=Immediate.js.map

}),
25943: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NotFoundError = void 0;
var createErrorClass_1 = __webpack_require__(14288);
exports.NotFoundError = createErrorClass_1.createErrorClass(function (_super) {
    return function NotFoundErrorImpl(message) {
        _super(this);
        this.name = 'NotFoundError';
        this.message = message;
    };
});
//# sourceMappingURL=NotFoundError.js.map

}),
15993: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ObjectUnsubscribedError = void 0;
var createErrorClass_1 = __webpack_require__(14288);
exports.ObjectUnsubscribedError = createErrorClass_1.createErrorClass(function (_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = 'ObjectUnsubscribedError';
        this.message = 'object unsubscribed';
    };
});
//# sourceMappingURL=ObjectUnsubscribedError.js.map

}),
16348: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SequenceError = void 0;
var createErrorClass_1 = __webpack_require__(14288);
exports.SequenceError = createErrorClass_1.createErrorClass(function (_super) {
    return function SequenceErrorImpl(message) {
        _super(this);
        this.name = 'SequenceError';
        this.message = message;
    };
});
//# sourceMappingURL=SequenceError.js.map

}),
88829: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UnsubscriptionError = void 0;
var createErrorClass_1 = __webpack_require__(14288);
exports.UnsubscriptionError = createErrorClass_1.createErrorClass(function (_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors
            ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ')
            : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});
//# sourceMappingURL=UnsubscriptionError.js.map

}),
84446: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.popNumber = exports.popScheduler = exports.popResultSelector = void 0;
var isFunction_1 = __webpack_require__(64061);
var isScheduler_1 = __webpack_require__(11611);
function last(arr) {
    return arr[arr.length - 1];
}
function popResultSelector(args) {
    return isFunction_1.isFunction(last(args)) ? args.pop() : undefined;
}
exports.popResultSelector = popResultSelector;
function popScheduler(args) {
    return isScheduler_1.isScheduler(last(args)) ? args.pop() : undefined;
}
exports.popScheduler = popScheduler;
function popNumber(args, defaultValue) {
    return typeof last(args) === 'number' ? args.pop() : defaultValue;
}
exports.popNumber = popNumber;
//# sourceMappingURL=args.js.map

}),
36795: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.argsArgArrayOrObject = void 0;
var isArray = Array.isArray;
var getPrototypeOf = Object.getPrototypeOf, objectProto = Object.prototype, getKeys = Object.keys;
function argsArgArrayOrObject(args) {
    if (args.length === 1) {
        var first_1 = args[0];
        if (isArray(first_1)) {
            return { args: first_1, keys: null };
        }
        if (isPOJO(first_1)) {
            var keys = getKeys(first_1);
            return {
                args: keys.map(function (key) { return first_1[key]; }),
                keys: keys,
            };
        }
    }
    return { args: args, keys: null };
}
exports.argsArgArrayOrObject = argsArgArrayOrObject;
function isPOJO(obj) {
    return obj && typeof obj === 'object' && getPrototypeOf(obj) === objectProto;
}
//# sourceMappingURL=argsArgArrayOrObject.js.map

}),
59925: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.argsOrArgArray = void 0;
var isArray = Array.isArray;
function argsOrArgArray(args) {
    return args.length === 1 && isArray(args[0]) ? args[0] : args;
}
exports.argsOrArgArray = argsOrArgArray;
//# sourceMappingURL=argsOrArgArray.js.map

}),
59836: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.arrRemove = void 0;
function arrRemove(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}
exports.arrRemove = arrRemove;
//# sourceMappingURL=arrRemove.js.map

}),
14288: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createErrorClass = void 0;
function createErrorClass(createImpl) {
    var _super = function (instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}
exports.createErrorClass = createErrorClass;
//# sourceMappingURL=createErrorClass.js.map

}),
54690: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createObject = void 0;
function createObject(keys, values) {
    return keys.reduce(function (result, key, i) { return ((result[key] = values[i]), result); }, {});
}
exports.createObject = createObject;
//# sourceMappingURL=createObject.js.map

}),
40021: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.captureError = exports.errorContext = void 0;
var config_1 = __webpack_require__(56622);
var context = null;
function errorContext(cb) {
    if (config_1.config.useDeprecatedSynchronousErrorHandling) {
        var isRoot = !context;
        if (isRoot) {
            context = { errorThrown: false, error: null };
        }
        cb();
        if (isRoot) {
            var _a = context, errorThrown = _a.errorThrown, error = _a.error;
            context = null;
            if (errorThrown) {
                throw error;
            }
        }
    }
    else {
        cb();
    }
}
exports.errorContext = errorContext;
function captureError(err) {
    if (config_1.config.useDeprecatedSynchronousErrorHandling && context) {
        context.errorThrown = true;
        context.error = err;
    }
}
exports.captureError = captureError;
//# sourceMappingURL=errorContext.js.map

}),
98726: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.executeSchedule = void 0;
function executeSchedule(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) { delay = 0; }
    if (repeat === void 0) { repeat = false; }
    var scheduleSubscription = scheduler.schedule(function () {
        work();
        if (repeat) {
            parentSubscription.add(this.schedule(null, delay));
        }
        else {
            this.unsubscribe();
        }
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) {
        return scheduleSubscription;
    }
}
exports.executeSchedule = executeSchedule;
//# sourceMappingURL=executeSchedule.js.map

}),
6033: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.identity = void 0;
function identity(x) {
    return x;
}
exports.identity = identity;
//# sourceMappingURL=identity.js.map

}),
79128: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isArrayLike = void 0;
exports.isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });
//# sourceMappingURL=isArrayLike.js.map

}),
18806: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isAsyncIterable = void 0;
var isFunction_1 = __webpack_require__(64061);
function isAsyncIterable(obj) {
    return Symbol.asyncIterator && isFunction_1.isFunction(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}
exports.isAsyncIterable = isAsyncIterable;
//# sourceMappingURL=isAsyncIterable.js.map

}),
51003: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isValidDate = void 0;
function isValidDate(value) {
    return value instanceof Date && !isNaN(value);
}
exports.isValidDate = isValidDate;
//# sourceMappingURL=isDate.js.map

}),
64061: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isFunction = void 0;
function isFunction(value) {
    return typeof value === 'function';
}
exports.isFunction = isFunction;
//# sourceMappingURL=isFunction.js.map

}),
78244: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isInteropObservable = void 0;
var observable_1 = __webpack_require__(58432);
var isFunction_1 = __webpack_require__(64061);
function isInteropObservable(input) {
    return isFunction_1.isFunction(input[observable_1.observable]);
}
exports.isInteropObservable = isInteropObservable;
//# sourceMappingURL=isInteropObservable.js.map

}),
14886: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isIterable = void 0;
var iterator_1 = __webpack_require__(68559);
var isFunction_1 = __webpack_require__(64061);
function isIterable(input) {
    return isFunction_1.isFunction(input === null || input === void 0 ? void 0 : input[iterator_1.iterator]);
}
exports.isIterable = isIterable;
//# sourceMappingURL=isIterable.js.map

}),
25268: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isObservable = void 0;
var Observable_1 = __webpack_require__(18547);
var isFunction_1 = __webpack_require__(64061);
function isObservable(obj) {
    return !!obj && (obj instanceof Observable_1.Observable || (isFunction_1.isFunction(obj.lift) && isFunction_1.isFunction(obj.subscribe)));
}
exports.isObservable = isObservable;
//# sourceMappingURL=isObservable.js.map

}),
94283: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isPromise = void 0;
var isFunction_1 = __webpack_require__(64061);
function isPromise(value) {
    return isFunction_1.isFunction(value === null || value === void 0 ? void 0 : value.then);
}
exports.isPromise = isPromise;
//# sourceMappingURL=isPromise.js.map

}),
70393: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isReadableStreamLike = exports.readableStreamLikeToAsyncGenerator = void 0;
var isFunction_1 = __webpack_require__(64061);
function readableStreamLikeToAsyncGenerator(readableStream) {
    return __asyncGenerator(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, , 9, 10]);
                    _b.label = 2;
                case 2:
                    if (false) {}
                    return [4, __await(reader.read())];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [3, 5];
                    return [4, __await(void 0)];
                case 4: return [2, _b.sent()];
                case 5: return [4, __await(value)];
                case 6: return [4, _b.sent()];
                case 7:
                    _b.sent();
                    return [3, 2];
                case 8: return [3, 10];
                case 9:
                    reader.releaseLock();
                    return [7];
                case 10: return [2];
            }
        });
    });
}
exports.readableStreamLikeToAsyncGenerator = readableStreamLikeToAsyncGenerator;
function isReadableStreamLike(obj) {
    return isFunction_1.isFunction(obj === null || obj === void 0 ? void 0 : obj.getReader);
}
exports.isReadableStreamLike = isReadableStreamLike;
//# sourceMappingURL=isReadableStreamLike.js.map

}),
11611: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isScheduler = void 0;
var isFunction_1 = __webpack_require__(64061);
function isScheduler(value) {
    return value && isFunction_1.isFunction(value.schedule);
}
exports.isScheduler = isScheduler;
//# sourceMappingURL=isScheduler.js.map

}),
54360: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.operate = exports.hasLift = void 0;
var isFunction_1 = __webpack_require__(64061);
function hasLift(source) {
    return isFunction_1.isFunction(source === null || source === void 0 ? void 0 : source.lift);
}
exports.hasLift = hasLift;
function operate(init) {
    return function (source) {
        if (hasLift(source)) {
            return source.lift(function (liftedSource) {
                try {
                    return init(liftedSource, this);
                }
                catch (err) {
                    this.error(err);
                }
            });
        }
        throw new TypeError('Unable to lift unknown Observable type');
    };
}
exports.operate = operate;
//# sourceMappingURL=lift.js.map

}),
92869: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mapOneOrManyArgs = void 0;
var map_1 = __webpack_require__(92619);
var isArray = Array.isArray;
function callOrApply(fn, args) {
    return isArray(args) ? fn.apply(void 0, __spreadArray([], __read(args))) : fn(args);
}
function mapOneOrManyArgs(fn) {
    return map_1.map(function (args) { return callOrApply(fn, args); });
}
exports.mapOneOrManyArgs = mapOneOrManyArgs;
//# sourceMappingURL=mapOneOrManyArgs.js.map

}),
72777: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.noop = void 0;
function noop() { }
exports.noop = noop;
//# sourceMappingURL=noop.js.map

}),
59345: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.not = void 0;
function not(pred, thisArg) {
    return function (value, index) { return !pred.call(thisArg, value, index); };
}
exports.not = not;
//# sourceMappingURL=not.js.map

}),
27754: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pipeFromArray = exports.pipe = void 0;
var identity_1 = __webpack_require__(6033);
function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return pipeFromArray(fns);
}
exports.pipe = pipe;
function pipeFromArray(fns) {
    if (fns.length === 0) {
        return identity_1.identity;
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}
exports.pipeFromArray = pipeFromArray;
//# sourceMappingURL=pipe.js.map

}),
86723: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.reportUnhandledError = void 0;
var config_1 = __webpack_require__(56622);
var timeoutProvider_1 = __webpack_require__(80933);
function reportUnhandledError(err) {
    timeoutProvider_1.timeoutProvider.setTimeout(function () {
        var onUnhandledError = config_1.config.onUnhandledError;
        if (onUnhandledError) {
            onUnhandledError(err);
        }
        else {
            throw err;
        }
    });
}
exports.reportUnhandledError = reportUnhandledError;
//# sourceMappingURL=reportUnhandledError.js.map

}),
76282: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createInvalidObservableTypeError = void 0;
function createInvalidObservableTypeError(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
exports.createInvalidObservableTypeError = createInvalidObservableTypeError;
//# sourceMappingURL=throwUnobservableError.js.map

}),
87252: (function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  y: () => (/* binding */ Observable_Observable)
});

// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/Subscriber.js + 2 modules
var Subscriber = __webpack_require__(75591);
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/Subscription.js + 1 modules
var Subscription = __webpack_require__(80205);
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/symbol/observable.js
var symbol_observable = __webpack_require__(55066);
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/identity.js
var identity = __webpack_require__(77496);
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/pipe.js

function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return pipeFromArray(fns);
}
function pipeFromArray(fns) {
    if (fns.length === 0) {
        return identity/* identity */.y;
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}
//# sourceMappingURL=pipe.js.map
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/config.js
var config = __webpack_require__(76396);
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/isFunction.js
var isFunction = __webpack_require__(65008);
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/errorContext.js
var errorContext = __webpack_require__(18633);
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/Observable.js







var Observable_Observable = (function () {
    function Observable(subscribe) {
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var _this = this;
        var subscriber = isSubscriber(observerOrNext) ? observerOrNext : new Subscriber/* SafeSubscriber */.Hp(observerOrNext, error, complete);
        (0,errorContext/* errorContext */.x)(function () {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator
                ?
                    operator.call(subscriber, source)
                : source
                    ?
                        _this._subscribe(subscriber)
                    :
                        _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function (next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var subscriber = new Subscriber/* SafeSubscriber */.Hp({
                next: function (value) {
                    try {
                        next(value);
                    }
                    catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve,
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[symbol_observable/* observable */.L] = function () {
        return this;
    };
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i] = arguments[_i];
        }
        return pipeFromArray(operations)(this);
    };
    Observable.prototype.toPromise = function (promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return (value = x); }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());

function getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : config/* config,Promise */.v.Promise) !== null && _a !== void 0 ? _a : Promise;
}
function isObserver(value) {
    return value && (0,isFunction/* isFunction */.m)(value.next) && (0,isFunction/* isFunction */.m)(value.error) && (0,isFunction/* isFunction */.m)(value.complete);
}
function isSubscriber(value) {
    return (value && value instanceof Subscriber/* Subscriber */.Lv) || (isObserver(value) && (0,Subscription/* isSubscription */.Nn)(value));
}
//# sourceMappingURL=Observable.js.map

}),
75591: (function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Hp: () => (/* binding */ Subscriber_SafeSubscriber),
  Lv: () => (/* binding */ Subscriber_Subscriber)
});

// UNUSED EXPORTS: EMPTY_OBSERVER

// EXTERNAL MODULE: ../../app/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(68948);
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/isFunction.js
var isFunction = __webpack_require__(65008);
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/Subscription.js + 1 modules
var Subscription = __webpack_require__(80205);
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/config.js
var config = __webpack_require__(76396);
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/reportUnhandledError.js
var reportUnhandledError = __webpack_require__(77220);
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/noop.js
function noop() { }
//# sourceMappingURL=noop.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/NotificationFactories.js
var COMPLETE_NOTIFICATION = (function () { return createNotification('C', undefined, undefined); })();
function errorNotification(error) {
    return createNotification('E', undefined, error);
}
function nextNotification(value) {
    return createNotification('N', value, undefined);
}
function createNotification(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error,
    };
}
//# sourceMappingURL=NotificationFactories.js.map
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/scheduler/timeoutProvider.js
var timeoutProvider = __webpack_require__(17148);
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/errorContext.js
var errorContext = __webpack_require__(18633);
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/Subscriber.js









var Subscriber_Subscriber = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0,Subscription/* isSubscription */.Nn)(destination)) {
                destination.add(_this);
            }
        }
        else {
            _this.destination = EMPTY_OBSERVER;
        }
        return _this;
    }
    Subscriber.create = function (next, error, complete) {
        return new Subscriber_SafeSubscriber(next, error, complete);
    };
    Subscriber.prototype.next = function (value) {
        if (this.isStopped) {
            handleStoppedNotification(nextNotification(value), this);
        }
        else {
            this._next(value);
        }
    };
    Subscriber.prototype.error = function (err) {
        if (this.isStopped) {
            handleStoppedNotification(errorNotification(err), this);
        }
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function () {
        if (this.isStopped) {
            handleStoppedNotification(COMPLETE_NOTIFICATION, this);
        }
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        try {
            this.destination.error(err);
        }
        finally {
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function () {
        try {
            this.destination.complete();
        }
        finally {
            this.unsubscribe();
        }
    };
    return Subscriber;
}(Subscription/* Subscription */.w0));

var _bind = Function.prototype.bind;
function bind(fn, thisArg) {
    return _bind.call(fn, thisArg);
}
var Subscriber_ConsumerObserver = (function () {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function (value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) {
            try {
                partialObserver.next(value);
            }
            catch (error) {
                handleUnhandledError(error);
            }
        }
    };
    ConsumerObserver.prototype.error = function (err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) {
            try {
                partialObserver.error(err);
            }
            catch (error) {
                handleUnhandledError(error);
            }
        }
        else {
            handleUnhandledError(err);
        }
    };
    ConsumerObserver.prototype.complete = function () {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) {
            try {
                partialObserver.complete();
            }
            catch (error) {
                handleUnhandledError(error);
            }
        }
    };
    return ConsumerObserver;
}());
var Subscriber_SafeSubscriber = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0,isFunction/* isFunction */.m)(observerOrNext) || !observerOrNext) {
            partialObserver = {
                next: (observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined),
                error: error !== null && error !== void 0 ? error : undefined,
                complete: complete !== null && complete !== void 0 ? complete : undefined,
            };
        }
        else {
            var context_1;
            if (_this && config/* config,useDeprecatedNextContext */.v.useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function () { return _this.unsubscribe(); };
                partialObserver = {
                    next: observerOrNext.next && bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && bind(observerOrNext.complete, context_1),
                };
            }
            else {
                partialObserver = observerOrNext;
            }
        }
        _this.destination = new Subscriber_ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}(Subscriber_Subscriber));

function handleUnhandledError(error) {
    if (config/* config,useDeprecatedSynchronousErrorHandling */.v.useDeprecatedSynchronousErrorHandling) {
        (0,errorContext/* captureError */.O)(error);
    }
    else {
        (0,reportUnhandledError/* reportUnhandledError */.h)(error);
    }
}
function defaultErrorHandler(err) {
    throw err;
}
function handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = config/* config,onStoppedNotification */.v.onStoppedNotification;
    onStoppedNotification && timeoutProvider/* timeoutProvider,setTimeout */.z.setTimeout(function () { return onStoppedNotification(notification, subscriber); });
}
var EMPTY_OBSERVER = {
    closed: true,
    next: noop,
    error: defaultErrorHandler,
    complete: noop,
};
//# sourceMappingURL=Subscriber.js.map

}),
80205: (function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Lc: () => (/* binding */ EMPTY_SUBSCRIPTION),
  w0: () => (/* binding */ Subscription_Subscription),
  Nn: () => (/* binding */ isSubscription)
});

// EXTERNAL MODULE: ../../app/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(68948);
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/isFunction.js
var isFunction = __webpack_require__(65008);
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/createErrorClass.js
var createErrorClass = __webpack_require__(38282);
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/UnsubscriptionError.js

var UnsubscriptionError = (0,createErrorClass/* createErrorClass */.d)(function (_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors
            ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ')
            : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});
//# sourceMappingURL=UnsubscriptionError.js.map
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/arrRemove.js
var arrRemove = __webpack_require__(69677);
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/Subscription.js




var Subscription_Subscription = (function () {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function () {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) {
                    try {
                        for (var _parentage_1 = (0,tslib_es6/* __values */.XA)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()) {
                            var parent_1 = _parentage_1_1.value;
                            parent_1.remove(this);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                else {
                    _parentage.remove(this);
                }
            }
            var initialFinalizer = this.initialTeardown;
            if ((0,isFunction/* isFunction */.m)(initialFinalizer)) {
                try {
                    initialFinalizer();
                }
                catch (e) {
                    errors = e instanceof UnsubscriptionError ? e.errors : [e];
                }
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for (var _finalizers_1 = (0,tslib_es6/* __values */.XA)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()) {
                        var finalizer = _finalizers_1_1.value;
                        try {
                            execFinalizer(finalizer);
                        }
                        catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof UnsubscriptionError) {
                                errors = (0,tslib_es6/* __spreadArray */.ev)((0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(errors)), (0,tslib_es6/* __read */.CR)(err.errors));
                            }
                            else {
                                errors.push(err);
                            }
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
            if (errors) {
                throw new UnsubscriptionError(errors);
            }
        }
    };
    Subscription.prototype.add = function (teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) {
                execFinalizer(teardown);
            }
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) {
                        return;
                    }
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function (parent) {
        var _parentage = this._parentage;
        return _parentage === parent || (Array.isArray(_parentage) && _parentage.includes(parent));
    };
    Subscription.prototype._addParent = function (parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [_parentage, parent] : parent;
    };
    Subscription.prototype._removeParent = function (parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) {
            this._parentage = null;
        }
        else if (Array.isArray(_parentage)) {
            (0,arrRemove/* arrRemove */.P)(_parentage, parent);
        }
    };
    Subscription.prototype.remove = function (teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0,arrRemove/* arrRemove */.P)(_finalizers, teardown);
        if (teardown instanceof Subscription) {
            teardown._removeParent(this);
        }
    };
    Subscription.EMPTY = (function () {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    })();
    return Subscription;
}());

var EMPTY_SUBSCRIPTION = Subscription_Subscription.EMPTY;
function isSubscription(value) {
    return (value instanceof Subscription_Subscription ||
        (value && 'closed' in value && (0,isFunction/* isFunction */.m)(value.remove) && (0,isFunction/* isFunction */.m)(value.add) && (0,isFunction/* isFunction */.m)(value.unsubscribe)));
}
function execFinalizer(finalizer) {
    if ((0,isFunction/* isFunction */.m)(finalizer)) {
        finalizer();
    }
    else {
        finalizer.unsubscribe();
    }
}
//# sourceMappingURL=Subscription.js.map

}),
76396: (function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  v: () => (config)
});
var config = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false,
};
//# sourceMappingURL=config.js.map

}),
21287: (function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  E: () => (EMPTY)
});
/* ESM import */var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87252);

var EMPTY = new _Observable__WEBPACK_IMPORTED_MODULE_0__/* .Observable */.y(function (subscriber) { return subscriber.complete(); });
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
    return new Observable(function (subscriber) { return scheduler.schedule(function () { return subscriber.complete(); }); });
}
//# sourceMappingURL=empty.js.map

}),
82693: (function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  _: () => (throwError)
});
/* ESM import */var _Observable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87252);
/* ESM import */var _util_isFunction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65008);


function throwError(errorOrErrorFactory, scheduler) {
    var errorFactory = (0,_util_isFunction__WEBPACK_IMPORTED_MODULE_0__/* .isFunction */.m)(errorOrErrorFactory) ? errorOrErrorFactory : function () { return errorOrErrorFactory; };
    var init = function (subscriber) { return subscriber.error(errorFactory()); };
    return new _Observable__WEBPACK_IMPORTED_MODULE_1__/* .Observable */.y(scheduler ? function (subscriber) { return scheduler.schedule(init, 0, subscriber); } : init);
}
//# sourceMappingURL=throwError.js.map

}),
17148: (function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  z: () => (timeoutProvider)
});
/* ESM import */var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68948);

var timeoutProvider = {
    setTimeout: function (handler, timeout) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        var delegate = timeoutProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) {
            return delegate.setTimeout.apply(delegate, (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spreadArray */.ev)([handler, timeout], (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__read */.CR)(args)));
        }
        return setTimeout.apply(void 0, (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spreadArray */.ev)([handler, timeout], (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__read */.CR)(args)));
    },
    clearTimeout: function (handle) {
        var delegate = timeoutProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined,
};
//# sourceMappingURL=timeoutProvider.js.map

}),
55066: (function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  L: () => (observable)
});
var observable = (function () { return (typeof Symbol === 'function' && Symbol.observable) || '@@observable'; })();
//# sourceMappingURL=observable.js.map

}),
69677: (function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  P: () => (arrRemove)
});
function arrRemove(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}
//# sourceMappingURL=arrRemove.js.map

}),
38282: (function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  d: () => (createErrorClass)
});
function createErrorClass(createImpl) {
    var _super = function (instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}
//# sourceMappingURL=createErrorClass.js.map

}),
18633: (function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  O: () => (captureError),
  x: () => (errorContext)
});
/* ESM import */var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76396);

var context = null;
function errorContext(cb) {
    if (_config__WEBPACK_IMPORTED_MODULE_0__/* .config.useDeprecatedSynchronousErrorHandling */.v.useDeprecatedSynchronousErrorHandling) {
        var isRoot = !context;
        if (isRoot) {
            context = { errorThrown: false, error: null };
        }
        cb();
        if (isRoot) {
            var _a = context, errorThrown = _a.errorThrown, error = _a.error;
            context = null;
            if (errorThrown) {
                throw error;
            }
        }
    }
    else {
        cb();
    }
}
function captureError(err) {
    if (_config__WEBPACK_IMPORTED_MODULE_0__/* .config.useDeprecatedSynchronousErrorHandling */.v.useDeprecatedSynchronousErrorHandling && context) {
        context.errorThrown = true;
        context.error = err;
    }
}
//# sourceMappingURL=errorContext.js.map

}),
77496: (function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  y: () => (identity)
});
function identity(x) {
    return x;
}
//# sourceMappingURL=identity.js.map

}),
65008: (function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  m: () => (isFunction)
});
function isFunction(value) {
    return typeof value === 'function';
}
//# sourceMappingURL=isFunction.js.map

}),
77220: (function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  h: () => (reportUnhandledError)
});
/* ESM import */var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76396);
/* ESM import */var _scheduler_timeoutProvider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17148);


function reportUnhandledError(err) {
    _scheduler_timeoutProvider__WEBPACK_IMPORTED_MODULE_0__/* .timeoutProvider.setTimeout */.z.setTimeout(function () {
        var onUnhandledError = _config__WEBPACK_IMPORTED_MODULE_1__/* .config.onUnhandledError */.v.onUnhandledError;
        if (onUnhandledError) {
            onUnhandledError(err);
        }
        else {
            throw err;
        }
    });
}
//# sourceMappingURL=reportUnhandledError.js.map

}),
33271: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";


var inspect = __webpack_require__(89242);

var $TypeError = __webpack_require__(66671);

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('./list.d.ts').listGetNode} */
// eslint-disable-next-line consistent-return
var listGetNode = function (list, key, isDelete) {
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	// eslint-disable-next-line eqeqeq
	for (; (curr = prev.next) != null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			if (!isDelete) {
				// eslint-disable-next-line no-extra-parens
				curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
				list.next = curr; // eslint-disable-line no-param-reassign
			}
			return curr;
		}
	}
};

/** @type {import('./list.d.ts').listGet} */
var listGet = function (objects, key) {
	if (!objects) {
		return void undefined;
	}
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('./list.d.ts').listHas} */
var listHas = function (objects, key) {
	if (!objects) {
		return false;
	}
	return !!listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */
// eslint-disable-next-line consistent-return
var listDelete = function (objects, key) {
	if (objects) {
		return listGetNode(objects, key, true);
	}
};

/** @type {import('.')} */
module.exports = function getSideChannelList() {
	/** @typedef {ReturnType<typeof getSideChannelList>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			var root = $o && $o.next;
			var deletedNode = listDelete($o, key);
			if (deletedNode && root && root === deletedNode) {
				$o = void undefined;
			}
			return !!deletedNode;
		},
		get: function (key) {
			return listGet($o, key);
		},
		has: function (key) {
			return listHas($o, key);
		},
		set: function (key, value) {
			if (!$o) {
				// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
				$o = {
					next: void undefined
				};
			}
			// eslint-disable-next-line no-extra-parens
			listSet(/** @type {NonNullable<typeof $o>} */ ($o), key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


}),
41866: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";


var GetIntrinsic = __webpack_require__(7297);
var callBound = __webpack_require__(3690);
var inspect = __webpack_require__(89242);

var $TypeError = __webpack_require__(66671);
var $Map = GetIntrinsic('%Map%', true);

/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */
var $mapGet = callBound('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */
var $mapSet = callBound('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapHas = callBound('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapDelete = callBound('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */
var $mapSize = callBound('Map.prototype.size', true);

/** @type {import('.')} */
module.exports = !!$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
	/** @typedef {ReturnType<typeof getSideChannelMap>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {Map<K, V> | undefined} */ var $m;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			if ($m) {
				var result = $mapDelete($m, key);
				if ($mapSize($m) === 0) {
					$m = void undefined;
				}
				return result;
			}
			return false;
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($m) {
				return $mapGet($m, key);
			}
		},
		has: function (key) {
			if ($m) {
				return $mapHas($m, key);
			}
			return false;
		},
		set: function (key, value) {
			if (!$m) {
				// @ts-expect-error TS can't handle narrowing a variable inside a closure
				$m = new $Map();
			}
			$mapSet($m, key, value);
		}
	};

	// @ts-expect-error TODO: figure out why TS is erroring here
	return channel;
};


}),
72638: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";


var GetIntrinsic = __webpack_require__(7297);
var callBound = __webpack_require__(3690);
var inspect = __webpack_require__(89242);
var getSideChannelMap = __webpack_require__(41866);

var $TypeError = __webpack_require__(66671);
var $WeakMap = GetIntrinsic('%WeakMap%', true);

/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */
var $weakMapGet = callBound('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */
var $weakMapSet = callBound('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapHas = callBound('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapDelete = callBound('WeakMap.prototype.delete', true);

/** @type {import('.')} */
module.exports = $WeakMap
	? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
		/** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */

		/** @type {WeakMap<K & object, V> | undefined} */ var $wm;
		/** @type {Channel | undefined} */ var $m;

		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapDelete($wm, key);
					}
				} else if (getSideChannelMap) {
					if ($m) {
						return $m['delete'](key);
					}
				}
				return false;
			},
			get: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapGet($wm, key);
					}
				}
				return $m && $m.get(key);
			},
			has: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapHas($wm, key);
					}
				}
				return !!$m && $m.has(key);
			},
			set: function (key, value) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if (!$wm) {
						$wm = new $WeakMap();
					}
					$weakMapSet($wm, key, value);
				} else if (getSideChannelMap) {
					if (!$m) {
						$m = getSideChannelMap();
					}
					// eslint-disable-next-line no-extra-parens
					/** @type {NonNullable<typeof $m>} */ ($m).set(key, value);
				}
			}
		};

		// @ts-expect-error TODO: figure out why this is erroring
		return channel;
	}
	: getSideChannelMap;


}),
20560: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";


var $TypeError = __webpack_require__(66671);
var inspect = __webpack_require__(89242);
var getSideChannelList = __webpack_require__(33271);
var getSideChannelMap = __webpack_require__(41866);
var getSideChannelWeakMap = __webpack_require__(72638);

var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @typedef {ReturnType<typeof getSideChannel>} Channel */

	/** @type {Channel | undefined} */ var $channelData;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			return !!$channelData && $channelData['delete'](key);
		},
		get: function (key) {
			return $channelData && $channelData.get(key);
		},
		has: function (key) {
			return !!$channelData && $channelData.has(key);
		},
		set: function (key, value) {
			if (!$channelData) {
				$channelData = makeChannel();
			}

			$channelData.set(key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


}),
81185: (function (__unused_webpack_module, exports) {
"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.clone = clone;
exports.addLast = addLast;
exports.addFirst = addFirst;
exports.removeLast = removeLast;
exports.removeFirst = removeFirst;
exports.insert = insert;
exports.removeAt = removeAt;
exports.replaceAt = replaceAt;
exports.getIn = getIn;
exports.set = set;
exports.setIn = setIn;
exports.update = update;
exports.updateIn = updateIn;
exports.merge = merge;
exports.mergeDeep = mergeDeep;
exports.mergeIn = mergeIn;
exports.omit = omit;
exports.addDefaults = addDefaults;


/*!
 * Timm
 *
 * Immutability helpers with fast reads and acceptable writes.
 *
 * @copyright Guillermo Grau Panea 2016
 * @license MIT
 */

var INVALID_ARGS = 'INVALID_ARGS';

// ===============================================
// ### Helpers
// ===============================================


function throwStr(msg) {
  throw new Error(msg);
}

function getKeysAndSymbols(obj) {
  var keys = Object.keys(obj);
  if (Object.getOwnPropertySymbols) {
    return keys.concat(Object.getOwnPropertySymbols(obj));
  }
  return keys;
}

var hasOwnProperty = {}.hasOwnProperty;

function clone(obj) {
  if (Array.isArray(obj)) return obj.slice();
  var keys = getKeysAndSymbols(obj);
  var out = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    out[key] = obj[key];
  }
  return out;
}

function doMerge(fAddDefaults, fDeep, first) {
  var out = first;
  !(out != null) && throwStr( false ? 0 : INVALID_ARGS);
  var fChanged = false;

  for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    rest[_key - 3] = arguments[_key];
  }

  for (var idx = 0; idx < rest.length; idx++) {
    var obj = rest[idx];
    if (obj == null) continue;
    var keys = getKeysAndSymbols(obj);
    if (!keys.length) continue;
    for (var j = 0; j <= keys.length; j++) {
      var key = keys[j];
      if (fAddDefaults && out[key] !== undefined) continue;
      var nextVal = obj[key];
      if (fDeep && isObject(out[key]) && isObject(nextVal)) {
        nextVal = doMerge(fAddDefaults, fDeep, out[key], nextVal);
      }
      if (nextVal === undefined || nextVal === out[key]) continue;
      if (!fChanged) {
        fChanged = true;
        out = clone(out);
      }
      out[key] = nextVal;
    }
  }
  return out;
}

function isObject(o) {
  var type = typeof o === 'undefined' ? 'undefined' : _typeof(o);
  return o != null && (type === 'object' || type === 'function');
}

// _deepFreeze = (obj) ->
//   Object.freeze obj
//   for key in Object.getOwnPropertyNames obj
//     val = obj[key]
//     if isObject(val) and not Object.isFrozen val
//       _deepFreeze val
//   obj

// ===============================================
// -- ### Arrays
// ===============================================

// -- #### addLast()
// -- Returns a new array with an appended item or items.
// --
// -- Usage: `addLast<T>(array: Array<T>, val: Array<T>|T): Array<T>`
// --
// -- ```js
// -- arr = ['a', 'b']
// -- arr2 = addLast(arr, 'c')
// -- // ['a', 'b', 'c']
// -- arr2 === arr
// -- // false
// -- arr3 = addLast(arr, ['c', 'd'])
// -- // ['a', 'b', 'c', 'd']
// -- ```
// `array.concat(val)` also handles the scalar case,
// but is apparently very slow
function addLast(array, val) {
  if (Array.isArray(val)) return array.concat(val);
  return array.concat([val]);
}

// -- #### addFirst()
// -- Returns a new array with a prepended item or items.
// --
// -- Usage: `addFirst<T>(array: Array<T>, val: Array<T>|T): Array<T>`
// --
// -- ```js
// -- arr = ['a', 'b']
// -- arr2 = addFirst(arr, 'c')
// -- // ['c', 'a', 'b']
// -- arr2 === arr
// -- // false
// -- arr3 = addFirst(arr, ['c', 'd'])
// -- // ['c', 'd', 'a', 'b']
// -- ```
function addFirst(array, val) {
  if (Array.isArray(val)) return val.concat(array);
  return [val].concat(array);
}

// -- #### removeLast()
// -- Returns a new array removing the last item.
// --
// -- Usage: `removeLast<T>(array: Array<T>): Array<T>`
// --
// -- ```js
// -- arr = ['a', 'b']
// -- arr2 = removeLast(arr)
// -- // ['a']
// -- arr2 === arr
// -- // false
// --
// -- // The same array is returned if there are no changes:
// -- arr3 = []
// -- removeLast(arr3) === arr3
// -- // true
// -- ```
function removeLast(array) {
  if (!array.length) return array;
  return array.slice(0, array.length - 1);
}

// -- #### removeFirst()
// -- Returns a new array removing the first item.
// --
// -- Usage: `removeFirst<T>(array: Array<T>): Array<T>`
// --
// -- ```js
// -- arr = ['a', 'b']
// -- arr2 = removeFirst(arr)
// -- // ['b']
// -- arr2 === arr
// -- // false
// --
// -- // The same array is returned if there are no changes:
// -- arr3 = []
// -- removeFirst(arr3) === arr3
// -- // true
// -- ```
function removeFirst(array) {
  if (!array.length) return array;
  return array.slice(1);
}

// -- #### insert()
// -- Returns a new array obtained by inserting an item or items
// -- at a specified index.
// --
// -- Usage: `insert<T>(array: Array<T>, idx: number, val: Array<T>|T): Array<T>`
// --
// -- ```js
// -- arr = ['a', 'b', 'c']
// -- arr2 = insert(arr, 1, 'd')
// -- // ['a', 'd', 'b', 'c']
// -- arr2 === arr
// -- // false
// -- insert(arr, 1, ['d', 'e'])
// -- // ['a', 'd', 'e', 'b', 'c']
// -- ```
function insert(array, idx, val) {
  return array.slice(0, idx).concat(Array.isArray(val) ? val : [val]).concat(array.slice(idx));
}

// -- #### removeAt()
// -- Returns a new array obtained by removing an item at
// -- a specified index.
// --
// -- Usage: `removeAt<T>(array: Array<T>, idx: number): Array<T>`
// --
// -- ```js
// -- arr = ['a', 'b', 'c']
// -- arr2 = removeAt(arr, 1)
// -- // ['a', 'c']
// -- arr2 === arr
// -- // false
// --
// -- // The same array is returned if there are no changes:
// -- removeAt(arr, 4) === arr
// -- // true
// -- ```
function removeAt(array, idx) {
  if (idx >= array.length || idx < 0) return array;
  return array.slice(0, idx).concat(array.slice(idx + 1));
}

// -- #### replaceAt()
// -- Returns a new array obtained by replacing an item at
// -- a specified index. If the provided item is the same as
// -- (*referentially equal to*) the previous item at that position,
// -- the original array is returned.
// --
// -- Usage: `replaceAt<T>(array: Array<T>, idx: number, newItem: T): Array<T>`
// --
// -- ```js
// -- arr = ['a', 'b', 'c']
// -- arr2 = replaceAt(arr, 1, 'd')
// -- // ['a', 'd', 'c']
// -- arr2 === arr
// -- // false
// --
// -- // The same object is returned if there are no changes:
// -- replaceAt(arr, 1, 'b') === arr
// -- // true
// -- ```
function replaceAt(array, idx, newItem) {
  if (array[idx] === newItem) return array;
  var len = array.length;
  var result = Array(len);
  for (var i = 0; i < len; i++) {
    result[i] = array[i];
  }
  result[idx] = newItem;
  return result;
}

// ===============================================
// -- ### Collections (objects and arrays)
// ===============================================
// -- The following types are used throughout this section
// -- ```js
// -- type ArrayOrObject = Array<any>|Object;
// -- type Key = number|string;
// -- ```

// -- #### getIn()
// -- Returns a value from an object at a given path. Works with
// -- nested arrays and objects. If the path does not exist, it returns
// -- `undefined`.
// --
// -- Usage: `getIn(obj: ?ArrayOrObject, path: Array<Key>): any`
// --
// -- ```js
// -- obj = { a: 1, b: 2, d: { d1: 3, d2: 4 }, e: ['a', 'b', 'c'] }
// -- getIn(obj, ['d', 'd1'])
// -- // 3
// -- getIn(obj, ['e', 1])
// -- // 'b'
// -- ```
function getIn(obj, path) {
  !Array.isArray(path) && throwStr( false ? 0 : INVALID_ARGS);
  if (obj == null) return undefined;
  var ptr = obj;
  for (var i = 0; i < path.length; i++) {
    var key = path[i];
    ptr = ptr != null ? ptr[key] : undefined;
    if (ptr === undefined) return ptr;
  }
  return ptr;
}

// -- #### set()
// -- Returns a new object with a modified attribute.
// -- If the provided value is the same as (*referentially equal to*)
// -- the previous value, the original object is returned.
// --
// -- Usage: `set<T>(obj: ?T, key: Key, val: any): T`
// --
// -- ```js
// -- obj = { a: 1, b: 2, c: 3 }
// -- obj2 = set(obj, 'b', 5)
// -- // { a: 1, b: 5, c: 3 }
// -- obj2 === obj
// -- // false
// --
// -- // The same object is returned if there are no changes:
// -- set(obj, 'b', 2) === obj
// -- // true
// -- ```
function set(obj, key, val) {
  var fallback = typeof key === 'number' ? [] : {};
  var finalObj = obj == null ? fallback : obj;
  if (finalObj[key] === val) return finalObj;
  var obj2 = clone(finalObj);
  obj2[key] = val;
  return obj2;
}

// -- #### setIn()
// -- Returns a new object with a modified **nested** attribute.
// --
// -- Notes:
// --
// -- * If the provided value is the same as (*referentially equal to*)
// -- the previous value, the original object is returned.
// -- * If the path does not exist, it will be created before setting
// -- the new value.
// --
// -- Usage: `setIn<T: ArrayOrObject>(obj: T, path: Array<Key>, val: any): T`
// --
// -- ```js
// -- obj = { a: 1, b: 2, d: { d1: 3, d2: 4 }, e: { e1: 'foo', e2: 'bar' } }
// -- obj2 = setIn(obj, ['d', 'd1'], 4)
// -- // { a: 1, b: 2, d: { d1: 4, d2: 4 }, e: { e1: 'foo', e2: 'bar' } }
// -- obj2 === obj
// -- // false
// -- obj2.d === obj.d
// -- // false
// -- obj2.e === obj.e
// -- // true
// --
// -- // The same object is returned if there are no changes:
// -- obj3 = setIn(obj, ['d', 'd1'], 3)
// -- // { a: 1, b: 2, d: { d1: 3, d2: 4 }, e: { e1: 'foo', e2: 'bar' } }
// -- obj3 === obj
// -- // true
// -- obj3.d === obj.d
// -- // true
// -- obj3.e === obj.e
// -- // true
// --
// -- // ... unknown paths create intermediate keys. Numeric segments are treated as array indices:
// -- setIn({ a: 3 }, ['unknown', 0, 'path'], 4)
// -- // { a: 3, unknown: [{ path: 4 }] }
// -- ```
function doSetIn(obj, path, val, idx) {
  var newValue = void 0;
  var key = path[idx];
  if (idx === path.length - 1) {
    newValue = val;
  } else {
    var nestedObj = isObject(obj) && isObject(obj[key]) ? obj[key] : typeof path[idx + 1] === 'number' ? [] : {};
    newValue = doSetIn(nestedObj, path, val, idx + 1);
  }
  return set(obj, key, newValue);
}

function setIn(obj, path, val) {
  if (!path.length) return val;
  return doSetIn(obj, path, val, 0);
}

// -- #### update()
// -- Returns a new object with a modified attribute,
// -- calculated via a user-provided callback based on the current value.
// -- If the calculated value is the same as (*referentially equal to*)
// -- the previous value, the original object is returned.
// --
// -- Usage: `update<T: ArrayOrObject>(obj: T, key: Key,
// -- fnUpdate: (prevValue: any) => any): T`
// --
// -- ```js
// -- obj = { a: 1, b: 2, c: 3 }
// -- obj2 = update(obj, 'b', (val) => val + 1)
// -- // { a: 1, b: 3, c: 3 }
// -- obj2 === obj
// -- // false
// --
// -- // The same object is returned if there are no changes:
// -- update(obj, 'b', (val) => val) === obj
// -- // true
// -- ```
function update(obj, key, fnUpdate) {
  var prevVal = obj == null ? undefined : obj[key];
  var nextVal = fnUpdate(prevVal);
  return set(obj, key, nextVal);
}

// -- #### updateIn()
// -- Returns a new object with a modified **nested** attribute,
// -- calculated via a user-provided callback based on the current value.
// -- If the calculated value is the same as (*referentially equal to*)
// -- the previous value, the original object is returned.
// --
// -- Usage: `updateIn<T: ArrayOrObject>(obj: T, path: Array<Key>,
// -- fnUpdate: (prevValue: any) => any): T`
// --
// -- ```js
// -- obj = { a: 1, d: { d1: 3, d2: 4 } }
// -- obj2 = updateIn(obj, ['d', 'd1'], (val) => val + 1)
// -- // { a: 1, d: { d1: 4, d2: 4 } }
// -- obj2 === obj
// -- // false
// --
// -- // The same object is returned if there are no changes:
// -- obj3 = updateIn(obj, ['d', 'd1'], (val) => val)
// -- // { a: 1, d: { d1: 3, d2: 4 } }
// -- obj3 === obj
// -- // true
// -- ```
function updateIn(obj, path, fnUpdate) {
  var prevVal = getIn(obj, path);
  var nextVal = fnUpdate(prevVal);
  return setIn(obj, path, nextVal);
}

// -- #### merge()
// -- Returns a new object built as follows: the overlapping keys from the
// -- second one overwrite the corresponding entries from the first one.
// -- Similar to `Object.assign()`, but immutable.
// --
// -- Usage:
// --
// -- * `merge(obj1: Object, obj2: ?Object): Object`
// -- * `merge(obj1: Object, ...objects: Array<?Object>): Object`
// --
// -- The unmodified `obj1` is returned if `obj2` does not *provide something
// -- new to* `obj1`, i.e. if either of the following
// -- conditions are true:
// --
// -- * `obj2` is `null` or `undefined`
// -- * `obj2` is an object, but it is empty
// -- * All attributes of `obj2` are `undefined`
// -- * All attributes of `obj2` are referentially equal to the
// --   corresponding attributes of `obj1`
// --
// -- Note that `undefined` attributes in `obj2` do not modify the
// -- corresponding attributes in `obj1`.
// --
// -- ```js
// -- obj1 = { a: 1, b: 2, c: 3 }
// -- obj2 = { c: 4, d: 5 }
// -- obj3 = merge(obj1, obj2)
// -- // { a: 1, b: 2, c: 4, d: 5 }
// -- obj3 === obj1
// -- // false
// --
// -- // The same object is returned if there are no changes:
// -- merge(obj1, { c: 3 }) === obj1
// -- // true
// -- ```
function merge(a, b, c, d, e, f) {
  for (var _len2 = arguments.length, rest = Array(_len2 > 6 ? _len2 - 6 : 0), _key2 = 6; _key2 < _len2; _key2++) {
    rest[_key2 - 6] = arguments[_key2];
  }

  return rest.length ? doMerge.call.apply(doMerge, [null, false, false, a, b, c, d, e, f].concat(rest)) : doMerge(false, false, a, b, c, d, e, f);
}

// -- #### mergeDeep()
// -- Returns a new object built as follows: the overlapping keys from the
// -- second one overwrite the corresponding entries from the first one.
// -- If both the first and second entries are objects they are merged recursively.
// -- Similar to `Object.assign()`, but immutable, and deeply merging.
// --
// -- Usage:
// --
// -- * `mergeDeep(obj1: Object, obj2: ?Object): Object`
// -- * `mergeDeep(obj1: Object, ...objects: Array<?Object>): Object`
// --
// -- The unmodified `obj1` is returned if `obj2` does not *provide something
// -- new to* `obj1`, i.e. if either of the following
// -- conditions are true:
// --
// -- * `obj2` is `null` or `undefined`
// -- * `obj2` is an object, but it is empty
// -- * All attributes of `obj2` are `undefined`
// -- * All attributes of `obj2` are referentially equal to the
// --   corresponding attributes of `obj1`
// --
// -- Note that `undefined` attributes in `obj2` do not modify the
// -- corresponding attributes in `obj1`.
// --
// -- ```js
// -- obj1 = { a: 1, b: 2, c: { a: 1 } }
// -- obj2 = { b: 3, c: { b: 2 } }
// -- obj3 = mergeDeep(obj1, obj2)
// -- // { a: 1, b: 3, c: { a: 1, b: 2 }  }
// -- obj3 === obj1
// -- // false
// --
// -- // The same object is returned if there are no changes:
// -- mergeDeep(obj1, { c: { a: 1 } }) === obj1
// -- // true
// -- ```
function mergeDeep(a, b, c, d, e, f) {
  for (var _len3 = arguments.length, rest = Array(_len3 > 6 ? _len3 - 6 : 0), _key3 = 6; _key3 < _len3; _key3++) {
    rest[_key3 - 6] = arguments[_key3];
  }

  return rest.length ? doMerge.call.apply(doMerge, [null, false, true, a, b, c, d, e, f].concat(rest)) : doMerge(false, true, a, b, c, d, e, f);
}

// -- #### mergeIn()
// -- Similar to `merge()`, but merging the value at a given nested path.
// -- Note that the returned type is the same as that of the first argument.
// --
// -- Usage:
// --
// -- * `mergeIn<T: ArrayOrObject>(obj1: T, path: Array<Key>, obj2: ?Object): T`
// -- * `mergeIn<T: ArrayOrObject>(obj1: T, path: Array<Key>,
// -- ...objects: Array<?Object>): T`
// --
// -- ```js
// -- obj1 = { a: 1, d: { b: { d1: 3, d2: 4 } } }
// -- obj2 = { d3: 5 }
// -- obj3 = mergeIn(obj1, ['d', 'b'], obj2)
// -- // { a: 1, d: { b: { d1: 3, d2: 4, d3: 5 } } }
// -- obj3 === obj1
// -- // false
// --
// -- // The same object is returned if there are no changes:
// -- mergeIn(obj1, ['d', 'b'], { d2: 4 }) === obj1
// -- // true
// -- ```
function mergeIn(a, path, b, c, d, e, f) {
  var prevVal = getIn(a, path);
  if (prevVal == null) prevVal = {};
  var nextVal = void 0;

  for (var _len4 = arguments.length, rest = Array(_len4 > 7 ? _len4 - 7 : 0), _key4 = 7; _key4 < _len4; _key4++) {
    rest[_key4 - 7] = arguments[_key4];
  }

  if (rest.length) {
    nextVal = doMerge.call.apply(doMerge, [null, false, false, prevVal, b, c, d, e, f].concat(rest));
  } else {
    nextVal = doMerge(false, false, prevVal, b, c, d, e, f);
  }
  return setIn(a, path, nextVal);
}

// -- #### omit()
// -- Returns an object excluding one or several attributes.
// --
// -- Usage: `omit(obj: Object, attrs: Array<string>|string): Object`
//
// -- ```js
// -- obj = { a: 1, b: 2, c: 3, d: 4 }
// -- omit(obj, 'a')
// -- // { b: 2, c: 3, d: 4 }
// -- omit(obj, ['b', 'c'])
// -- // { a: 1, d: 4 }
// --
// -- // The same object is returned if there are no changes:
// -- omit(obj, 'z') === obj1
// -- // true
// -- ```
function omit(obj, attrs) {
  var omitList = Array.isArray(attrs) ? attrs : [attrs];
  var fDoSomething = false;
  for (var i = 0; i < omitList.length; i++) {
    if (hasOwnProperty.call(obj, omitList[i])) {
      fDoSomething = true;
      break;
    }
  }
  if (!fDoSomething) return obj;
  var out = {};
  var keys = getKeysAndSymbols(obj);
  for (var _i = 0; _i < keys.length; _i++) {
    var key = keys[_i];
    if (omitList.indexOf(key) >= 0) continue;
    out[key] = obj[key];
  }
  return out;
}

// -- #### addDefaults()
// -- Returns a new object built as follows: `undefined` keys in the first one
// -- are filled in with the corresponding values from the second one
// -- (even if they are `null`).
// --
// -- Usage:
// --
// -- * `addDefaults(obj: Object, defaults: Object): Object`
// -- * `addDefaults(obj: Object, ...defaultObjects: Array<?Object>): Object`
// --
// -- ```js
// -- obj1 = { a: 1, b: 2, c: 3 }
// -- obj2 = { c: 4, d: 5, e: null }
// -- obj3 = addDefaults(obj1, obj2)
// -- // { a: 1, b: 2, c: 3, d: 5, e: null }
// -- obj3 === obj1
// -- // false
// --
// -- // The same object is returned if there are no changes:
// -- addDefaults(obj1, { c: 4 }) === obj1
// -- // true
// -- ```
function addDefaults(a, b, c, d, e, f) {
  for (var _len5 = arguments.length, rest = Array(_len5 > 6 ? _len5 - 6 : 0), _key5 = 6; _key5 < _len5; _key5++) {
    rest[_key5 - 6] = arguments[_key5];
  }

  return rest.length ? doMerge.call.apply(doMerge, [null, true, false, a, b, c, d, e, f].concat(rest)) : doMerge(true, false, a, b, c, d, e, f);
}

// ===============================================
// ### Public API
// ===============================================
var timm = {
  clone: clone,
  addLast: addLast,
  addFirst: addFirst,
  removeLast: removeLast,
  removeFirst: removeFirst,
  insert: insert,
  removeAt: removeAt,
  replaceAt: replaceAt,

  getIn: getIn,
  // eslint-disable-next-line object-shorthand
  set: set, // so that flow doesn't complain
  setIn: setIn,
  update: update,
  updateIn: updateIn,
  merge: merge,
  mergeDeep: mergeDeep,
  mergeIn: mergeIn,
  omit: omit,
  addDefaults: addDefaults
};

exports["default"] = timm;


}),
86304: (function (module) {
// TinyColor v1.3.0
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;

function tinycolor (color, opts) {

    color = (color) ? color : '';
    opts = opts || { };

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
       return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
    }

    var rgb = inputToRGB(color);
    this._originalInput = color,
    this._r = rgb.r,
    this._g = rgb.g,
    this._b = rgb.b,
    this._a = rgb.a,
    this._roundA = mathRound(100*this._a) / 100,
    this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) { this._r = mathRound(this._r); }
    if (this._g < 1) { this._g = mathRound(this._g); }
    if (this._b < 1) { this._b = mathRound(this._b); }

    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
}

tinycolor.prototype = {
    isDark: function() {
        return this.getBrightness() < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    isValid: function() {
        return this._ok;
    },
    getOriginalInput: function() {
      return this._originalInput;
    },
    getFormat: function() {
        return this._format;
    },
    getAlpha: function() {
        return this._a;
    },
    getBrightness: function() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
    },
    setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100*this._a) / 100;
        return this;
    },
    toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
    },
    toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
    },
    toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
    },
    toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
    },
    toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
    },
    toHex8: function(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function(allow4Char) {
        return '#' + this.toHex8(allow4Char);
    },
    toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
    },
    toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
    },
    toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function() {
        if (this._a === 0) {
            return "transparent";
        }

        if (this._a < 1) {
            return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
    },
    toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === "rgb") {
            formattedString = this.toRgbString();
        }
        if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
        }
        if (format === "hex3") {
            formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
            formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
            formattedString = this.toHex8String();
        }
        if (format === "name") {
            formattedString = this.toName();
        }
        if (format === "hsl") {
            formattedString = this.toHslString();
        }
        if (format === "hsv") {
            formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
    },
    clone: function() {
        return tinycolor(this.toString());
    },

    _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function() {
        return this._applyModification(lighten, arguments);
    },
    brighten: function() {
        return this._applyModification(brighten, arguments);
    },
    darken: function() {
        return this._applyModification(darken, arguments);
    },
    desaturate: function() {
        return this._applyModification(desaturate, arguments);
    },
    saturate: function() {
        return this._applyModification(saturate, arguments);
    },
    greyscale: function() {
        return this._applyModification(greyscale, arguments);
    },
    spin: function() {
        return this._applyModification(spin, arguments);
    },

    _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function() {
        return this._applyCombination(analogous, arguments);
    },
    complement: function() {
        return this._applyCombination(complement, arguments);
    },
    monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
    },
    splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
    },
    triad: function() {
        return this._applyCombination(triad, arguments);
    },
    tetrad: function() {
        return this._applyCombination(tetrad, arguments);
    }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function(color, opts) {
    if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
            if (color.hasOwnProperty(i)) {
                if (i === "a") {
                    newColor[i] = color[i];
                }
                else {
                    newColor[i] = convertToPercentage(color[i]);
                }
            }
        }
        color = newColor;
    }

    return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {

    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;

    if (typeof color == "string") {
        color = stringInputToObject(color);
    }

    if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
            a = color.a;
        }
    }

    a = boundAlpha(a);

    return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
    };
}


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b){
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
    };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    return { h: h, s: s, l: l };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
    var r, g, b;

    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);

    function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }

    if(s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, v = max;

    var d = max - min;
    s = max === 0 ? 0 : d / max;

    if(max == min) {
        h = 0; // achromatic
    }
    else {
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
 function hsvToRgb(h, s, v) {

    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);

    var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }

    return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16)),
        pad2(convertDecimalToHex(a))
    ];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }

    return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {

    var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) { return false; }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function() {
    return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
    });
};


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function desaturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function saturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function greyscale(color) {
    return tinycolor(color).desaturate(100);
}

function lighten (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

function brighten(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
    return tinycolor(rgb);
}

function darken (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
}

function triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
    ];
}

function tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
    ];
}

function splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
    ];
}

function analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;

    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];

    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
    }
    return ret;
}

function monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;

    while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
    }

    return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function(color1, color2, amount) {
    amount = (amount === 0) ? 0 : (amount || 50);

    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();

    var p = amount / 100;

    var rgba = {
        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
    };

    return tinycolor(rgba);
};


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function(color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function(color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;

    out = false;

    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;

};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size ;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors ;
    level = args.level;
    size = args.size;

    for (var i= 0; i < colorList.length ; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
        }
    }

    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
        return bestColor;
    }
    else {
        args.includeFallbackColors=false;
        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
    }
};


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
    var flipped = { };
    for (var i in o) {
        if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
        }
    }
    return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
    a = parseFloat(a);

    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }

    return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
    if (isOnePointZero(n)) { n = "100%"; }

    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
        n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return (n % max) / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
    return mathMin(1, mathMax(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
    if (n <= 1) {
        n = (n * 100) + "%";
    }

    return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
    return (parseIntFromHex(h) / 255);
}

var matchers = (function() {

    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
})();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {

    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    if ((match = matchers.hex8.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex6.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
    }
    if ((match = matchers.hex4.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex3.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
    }

    return false;
}

function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {"level":"AA", "size":"small"};
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
        level = "AA";
    }
    if (size !== "small" && size !== "large") {
        size = "small";
    }
    return {"level":level, "size":size};
}

// Node: Export function
if ( true && module.exports) {
    module.exports = tinycolor;
}
// AMD/requirejs: Define the module
else if (typeof define === 'function' && define.amd) {
    define(function () {return tinycolor;});
}
// Browser: Expose to window
else {
    window.tinycolor = tinycolor;
}

})(Math);


}),
70133: (function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
  "default": () => (__WEBPACK_DEFAULT_EXPORT__)
});
var index = typeof fetch=='function' ? fetch.bind() : function(url, options) {
	options = options || {};
	return new Promise( function (resolve, reject) {
		var request = new XMLHttpRequest();

		request.open(options.method || 'get', url, true);

		for (var i in options.headers) {
			request.setRequestHeader(i, options.headers[i]);
		}

		request.withCredentials = options.credentials=='include';

		request.onload = function () {
			resolve(response());
		};

		request.onerror = reject;

		request.send(options.body);

		function response() {
			var keys = [],
				all = [],
				headers = {},
				header;

			request.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (m, key, value) {
				keys.push(key = key.toLowerCase());
				all.push([key, value]);
				header = headers[key];
				headers[key] = header ? (header + "," + value) : value;
			});

			return {
				ok: (request.status/100|0) == 2,		// 200-299
				status: request.status,
				statusText: request.statusText,
				url: request.responseURL,
				clone: response,
				text: function () { return Promise.resolve(request.responseText); },
				json: function () { return Promise.resolve(request.responseText).then(JSON.parse); },
				blob: function () { return Promise.resolve(new Blob([request.response])); },
				headers: {
					keys: function () { return keys; },
					entries: function () { return all; },
					get: function (n) { return headers[n.toLowerCase()]; },
					has: function (n) { return n.toLowerCase() in headers; }
				}
			};
		}
	});
};

/* ESM default export */ const __WEBPACK_DEFAULT_EXPORT__ = (index);
//# sourceMappingURL=unfetch.es.js.map


}),
14362: (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
if (!window.fetch) window.fetch = (__webpack_require__(70133)/* ["default"] */["default"]) || __webpack_require__(70133);


}),
95487: (function () {
"use strict";
/* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /*!
 * tram.js v0.8.2-global
 * Cross-browser CSS3 transitions in JavaScript
 * https://github.com/bkwld/tram
 * MIT License
 */ /* prettier-ignore */ 
window.tram = function(a) {
    function b(a, b) {
        var c = new M.Bare;
        return c.init(a, b);
    }
    function c(a) {
        return a.replace(/[A-Z]/g, function(a) {
            return "-" + a.toLowerCase();
        });
    }
    function d(a) {
        var b = parseInt(a.slice(1), 16), c = b >> 16 & 255, d = b >> 8 & 255, e = 255 & b;
        return [
            c,
            d,
            e
        ];
    }
    function e(a, b, c) {
        return "#" + (1 << 24 | a << 16 | b << 8 | c).toString(16).slice(1);
    }
    function f() {}
    function g(a, b) {
        j("Type warning: Expected: [" + a + "] Got: [" + typeof b + "] " + b);
    }
    function h(a, b, c) {
        j("Units do not match [" + a + "]: " + b + ", " + c);
    }
    function i(a, b, c) {
        if (void 0 !== b && (c = b), void 0 === a) return c;
        var d = c;
        return $.test(a) || !_.test(a) ? d = parseInt(a, 10) : _.test(a) && (d = 1e3 * parseFloat(a)), 0 > d && (d = 0), d === d ? d : c;
    }
    function j(a) {
        U.debug && window && window.console.warn(a);
    }
    function k(a) {
        for(var b = -1, c = a ? a.length : 0, d = []; ++b < c;){
            var e = a[b];
            e && d.push(e);
        }
        return d;
    }
    var l = function(a, b, c) {
        function d(a) {
            return "object" == typeof a;
        }
        function e(a) {
            return "function" == typeof a;
        }
        function f() {}
        function g(h, i) {
            function j() {
                var a = new k;
                return e(a.init) && a.init.apply(a, arguments), a;
            }
            function k() {}
            i === c && (i = h, h = Object), j.Bare = k;
            var l, m = f[a] = h[a], n = k[a] = j[a] = new f;
            return n.constructor = j, j.mixin = function(b) {
                return k[a] = j[a] = g(j, b)[a], j;
            }, j.open = function(a) {
                if (l = {}, e(a) ? l = a.call(j, n, m, j, h) : d(a) && (l = a), d(l)) for(var c in l)b.call(l, c) && (n[c] = l[c]);
                return e(n.init) || (n.init = h), j;
            }, j.open(i);
        }
        return g;
    }("prototype", {}.hasOwnProperty), m = {
        ease: [
            "ease",
            function(a, b, c, d) {
                var e = (a /= d) * a, f = e * a;
                return b + c * (-2.75 * f * e + 11 * e * e + -15.5 * f + 8 * e + .25 * a);
            }
        ],
        "ease-in": [
            "ease-in",
            function(a, b, c, d) {
                var e = (a /= d) * a, f = e * a;
                return b + c * (-1 * f * e + 3 * e * e + -3 * f + 2 * e);
            }
        ],
        "ease-out": [
            "ease-out",
            function(a, b, c, d) {
                var e = (a /= d) * a, f = e * a;
                return b + c * (.3 * f * e + -1.6 * e * e + 2.2 * f + -1.8 * e + 1.9 * a);
            }
        ],
        "ease-in-out": [
            "ease-in-out",
            function(a, b, c, d) {
                var e = (a /= d) * a, f = e * a;
                return b + c * (2 * f * e + -5 * e * e + 2 * f + 2 * e);
            }
        ],
        linear: [
            "linear",
            function(a, b, c, d) {
                return c * a / d + b;
            }
        ],
        "ease-in-quad": [
            "cubic-bezier(0.550, 0.085, 0.680, 0.530)",
            function(a, b, c, d) {
                return c * (a /= d) * a + b;
            }
        ],
        "ease-out-quad": [
            "cubic-bezier(0.250, 0.460, 0.450, 0.940)",
            function(a, b, c, d) {
                return -c * (a /= d) * (a - 2) + b;
            }
        ],
        "ease-in-out-quad": [
            "cubic-bezier(0.455, 0.030, 0.515, 0.955)",
            function(a, b, c, d) {
                return (a /= d / 2) < 1 ? c / 2 * a * a + b : -c / 2 * (--a * (a - 2) - 1) + b;
            }
        ],
        "ease-in-cubic": [
            "cubic-bezier(0.550, 0.055, 0.675, 0.190)",
            function(a, b, c, d) {
                return c * (a /= d) * a * a + b;
            }
        ],
        "ease-out-cubic": [
            "cubic-bezier(0.215, 0.610, 0.355, 1)",
            function(a, b, c, d) {
                return c * ((a = a / d - 1) * a * a + 1) + b;
            }
        ],
        "ease-in-out-cubic": [
            "cubic-bezier(0.645, 0.045, 0.355, 1)",
            function(a, b, c, d) {
                return (a /= d / 2) < 1 ? c / 2 * a * a * a + b : c / 2 * ((a -= 2) * a * a + 2) + b;
            }
        ],
        "ease-in-quart": [
            "cubic-bezier(0.895, 0.030, 0.685, 0.220)",
            function(a, b, c, d) {
                return c * (a /= d) * a * a * a + b;
            }
        ],
        "ease-out-quart": [
            "cubic-bezier(0.165, 0.840, 0.440, 1)",
            function(a, b, c, d) {
                return -c * ((a = a / d - 1) * a * a * a - 1) + b;
            }
        ],
        "ease-in-out-quart": [
            "cubic-bezier(0.770, 0, 0.175, 1)",
            function(a, b, c, d) {
                return (a /= d / 2) < 1 ? c / 2 * a * a * a * a + b : -c / 2 * ((a -= 2) * a * a * a - 2) + b;
            }
        ],
        "ease-in-quint": [
            "cubic-bezier(0.755, 0.050, 0.855, 0.060)",
            function(a, b, c, d) {
                return c * (a /= d) * a * a * a * a + b;
            }
        ],
        "ease-out-quint": [
            "cubic-bezier(0.230, 1, 0.320, 1)",
            function(a, b, c, d) {
                return c * ((a = a / d - 1) * a * a * a * a + 1) + b;
            }
        ],
        "ease-in-out-quint": [
            "cubic-bezier(0.860, 0, 0.070, 1)",
            function(a, b, c, d) {
                return (a /= d / 2) < 1 ? c / 2 * a * a * a * a * a + b : c / 2 * ((a -= 2) * a * a * a * a + 2) + b;
            }
        ],
        "ease-in-sine": [
            "cubic-bezier(0.470, 0, 0.745, 0.715)",
            function(a, b, c, d) {
                return -c * Math.cos(a / d * (Math.PI / 2)) + c + b;
            }
        ],
        "ease-out-sine": [
            "cubic-bezier(0.390, 0.575, 0.565, 1)",
            function(a, b, c, d) {
                return c * Math.sin(a / d * (Math.PI / 2)) + b;
            }
        ],
        "ease-in-out-sine": [
            "cubic-bezier(0.445, 0.050, 0.550, 0.950)",
            function(a, b, c, d) {
                return -c / 2 * (Math.cos(Math.PI * a / d) - 1) + b;
            }
        ],
        "ease-in-expo": [
            "cubic-bezier(0.950, 0.050, 0.795, 0.035)",
            function(a, b, c, d) {
                return 0 === a ? b : c * Math.pow(2, 10 * (a / d - 1)) + b;
            }
        ],
        "ease-out-expo": [
            "cubic-bezier(0.190, 1, 0.220, 1)",
            function(a, b, c, d) {
                return a === d ? b + c : c * (-Math.pow(2, -10 * a / d) + 1) + b;
            }
        ],
        "ease-in-out-expo": [
            "cubic-bezier(1, 0, 0, 1)",
            function(a, b, c, d) {
                return 0 === a ? b : a === d ? b + c : (a /= d / 2) < 1 ? c / 2 * Math.pow(2, 10 * (a - 1)) + b : c / 2 * (-Math.pow(2, -10 * --a) + 2) + b;
            }
        ],
        "ease-in-circ": [
            "cubic-bezier(0.600, 0.040, 0.980, 0.335)",
            function(a, b, c, d) {
                return -c * (Math.sqrt(1 - (a /= d) * a) - 1) + b;
            }
        ],
        "ease-out-circ": [
            "cubic-bezier(0.075, 0.820, 0.165, 1)",
            function(a, b, c, d) {
                return c * Math.sqrt(1 - (a = a / d - 1) * a) + b;
            }
        ],
        "ease-in-out-circ": [
            "cubic-bezier(0.785, 0.135, 0.150, 0.860)",
            function(a, b, c, d) {
                return (a /= d / 2) < 1 ? -c / 2 * (Math.sqrt(1 - a * a) - 1) + b : c / 2 * (Math.sqrt(1 - (a -= 2) * a) + 1) + b;
            }
        ],
        "ease-in-back": [
            "cubic-bezier(0.600, -0.280, 0.735, 0.045)",
            function(a, b, c, d, e) {
                return void 0 === e && (e = 1.70158), c * (a /= d) * a * ((e + 1) * a - e) + b;
            }
        ],
        "ease-out-back": [
            "cubic-bezier(0.175, 0.885, 0.320, 1.275)",
            function(a, b, c, d, e) {
                return void 0 === e && (e = 1.70158), c * ((a = a / d - 1) * a * ((e + 1) * a + e) + 1) + b;
            }
        ],
        "ease-in-out-back": [
            "cubic-bezier(0.680, -0.550, 0.265, 1.550)",
            function(a, b, c, d, e) {
                return void 0 === e && (e = 1.70158), (a /= d / 2) < 1 ? c / 2 * a * a * (((e *= 1.525) + 1) * a - e) + b : c / 2 * ((a -= 2) * a * (((e *= 1.525) + 1) * a + e) + 2) + b;
            }
        ]
    }, n = {
        "ease-in-back": "cubic-bezier(0.600, 0, 0.735, 0.045)",
        "ease-out-back": "cubic-bezier(0.175, 0.885, 0.320, 1)",
        "ease-in-out-back": "cubic-bezier(0.680, 0, 0.265, 1)"
    }, o = document, p = window, q = "bkwld-tram", r = /[\-\.0-9]/g, s = /[A-Z]/, t = "number", u = /^(rgb|#)/, v = /(em|cm|mm|in|pt|pc|px)$/, w = /(em|cm|mm|in|pt|pc|px|%)$/, x = /(deg|rad|turn)$/, y = "unitless", z = /(all|none) 0s ease 0s/, A = /^(width|height)$/, B = " ", C = o.createElement("a"), D = [
        "Webkit",
        "Moz",
        "O",
        "ms"
    ], E = [
        "-webkit-",
        "-moz-",
        "-o-",
        "-ms-"
    ], F = function(a) {
        if (a in C.style) return {
            dom: a,
            css: a
        };
        var b, c, d = "", e = a.split("-");
        for(b = 0; b < e.length; b++)d += e[b].charAt(0).toUpperCase() + e[b].slice(1);
        for(b = 0; b < D.length; b++)if (c = D[b] + d, c in C.style) return {
            dom: c,
            css: E[b] + a
        };
    }, G = b.support = {
        bind: Function.prototype.bind,
        transform: F("transform"),
        transition: F("transition"),
        backface: F("backface-visibility"),
        timing: F("transition-timing-function")
    };
    if (G.transition) {
        var H = G.timing.dom;
        if (C.style[H] = m["ease-in-back"][0], !C.style[H]) for(var I in n)m[I][0] = n[I];
    }
    var J = b.frame = function() {
        var a = p.requestAnimationFrame || p.webkitRequestAnimationFrame || p.mozRequestAnimationFrame || p.oRequestAnimationFrame || p.msRequestAnimationFrame;
        return a && G.bind ? a.bind(p) : function(a) {
            p.setTimeout(a, 16);
        };
    }(), K = b.now = function() {
        var a = p.performance, b = a && (a.now || a.webkitNow || a.msNow || a.mozNow);
        return b && G.bind ? b.bind(a) : Date.now || function() {
            return +new Date;
        };
    }(), L = l(function(b) {
        function d(a, b) {
            var c = k(("" + a).split(B)), d = c[0];
            b = b || {};
            var e = Y[d];
            if (!e) return j("Unsupported property: " + d);
            if (!b.weak || !this.props[d]) {
                var f = e[0], g = this.props[d];
                return g || (g = this.props[d] = new f.Bare), g.init(this.$el, c, e, b), g;
            }
        }
        function e(a, b, c) {
            if (a) {
                var e = typeof a;
                if (b || (this.timer && this.timer.destroy(), this.queue = [], this.active = !1), "number" == e && b) return this.timer = new S({
                    duration: a,
                    context: this,
                    complete: h
                }), void (this.active = !0);
                if ("string" == e && b) {
                    switch(a){
                        case "hide":
                            o.call(this);
                            break;
                        case "stop":
                            l.call(this);
                            break;
                        case "redraw":
                            p.call(this);
                            break;
                        default:
                            d.call(this, a, c && c[1]);
                    }
                    return h.call(this);
                }
                if ("function" == e) return void a.call(this, this);
                if ("object" == e) {
                    var f = 0;
                    u.call(this, a, function(a, b) {
                        a.span > f && (f = a.span), a.stop(), a.animate(b);
                    }, function(a) {
                        "wait" in a && (f = i(a.wait, 0));
                    }), t.call(this), f > 0 && (this.timer = new S({
                        duration: f,
                        context: this
                    }), this.active = !0, b && (this.timer.complete = h));
                    var g = this, j = !1, k = {};
                    J(function() {
                        u.call(g, a, function(a) {
                            a.active && (j = !0, k[a.name] = a.nextStyle);
                        }), j && g.$el.css(k);
                    });
                }
            }
        }
        function f(a) {
            a = i(a, 0), this.active ? this.queue.push({
                options: a
            }) : (this.timer = new S({
                duration: a,
                context: this,
                complete: h
            }), this.active = !0);
        }
        function g(a) {
            return this.active ? (this.queue.push({
                options: a,
                args: arguments
            }), void (this.timer.complete = h)) : j("No active transition timer. Use start() or wait() before then().");
        }
        function h() {
            if (this.timer && this.timer.destroy(), this.active = !1, this.queue.length) {
                var a = this.queue.shift();
                e.call(this, a.options, !0, a.args);
            }
        }
        function l(a) {
            this.timer && this.timer.destroy(), this.queue = [], this.active = !1;
            var b;
            "string" == typeof a ? (b = {}, b[a] = 1) : b = "object" == typeof a && null != a ? a : this.props, u.call(this, b, v), t.call(this);
        }
        function m(a) {
            l.call(this, a), u.call(this, a, w, x);
        }
        function n(a) {
            "string" != typeof a && (a = "block"), this.el.style.display = a;
        }
        function o() {
            l.call(this), this.el.style.display = "none";
        }
        function p() {
            this.el.offsetHeight;
        }
        function r() {
            l.call(this), a.removeData(this.el, q), this.$el = this.el = null;
        }
        function t() {
            var a, b, c = [];
            this.upstream && c.push(this.upstream);
            for(a in this.props)b = this.props[a], b.active && c.push(b.string);
            c = c.join(","), this.style !== c && (this.style = c, this.el.style[G.transition.dom] = c);
        }
        function u(a, b, e) {
            var f, g, h, i, j = b !== v, k = {};
            for(f in a)h = a[f], f in Z ? (k.transform || (k.transform = {}), k.transform[f] = h) : (s.test(f) && (f = c(f)), f in Y ? k[f] = h : (i || (i = {}), i[f] = h));
            for(f in k){
                if (h = k[f], g = this.props[f], !g) {
                    if (!j) continue;
                    g = d.call(this, f);
                }
                b.call(this, g, h);
            }
            e && i && e.call(this, i);
        }
        function v(a) {
            a.stop();
        }
        function w(a, b) {
            a.set(b);
        }
        function x(a) {
            this.$el.css(a);
        }
        function y(a, c) {
            b[a] = function() {
                return this.children ? A.call(this, c, arguments) : (this.el && c.apply(this, arguments), this);
            };
        }
        function A(a, b) {
            var c, d = this.children.length;
            for(c = 0; d > c; c++)a.apply(this.children[c], b);
            return this;
        }
        b.init = function(b) {
            if (this.$el = a(b), this.el = this.$el[0], this.props = {}, this.queue = [], this.style = "", this.active = !1, U.keepInherited && !U.fallback) {
                var c = W(this.el, "transition");
                c && !z.test(c) && (this.upstream = c);
            }
            G.backface && U.hideBackface && V(this.el, G.backface.css, "hidden");
        }, y("add", d), y("start", e), y("wait", f), y("then", g), y("next", h), y("stop", l), y("set", m), y("show", n), y("hide", o), y("redraw", p), y("destroy", r);
    }), M = l(L, function(b) {
        function c(b, c) {
            var d = a.data(b, q) || a.data(b, q, new L.Bare);
            return d.el || d.init(b), c ? d.start(c) : d;
        }
        b.init = function(b, d) {
            var e = a(b);
            if (!e.length) return this;
            if (1 === e.length) return c(e[0], d);
            var f = [];
            return e.each(function(a, b) {
                f.push(c(b, d));
            }), this.children = f, this;
        };
    }), N = l(function(a) {
        function b() {
            var a = this.get();
            this.update("auto");
            var b = this.get();
            return this.update(a), b;
        }
        function c(a, b, c) {
            return void 0 !== b && (c = b), a in m ? a : c;
        }
        function d(a) {
            var b = /rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(a);
            return (b ? e(b[1], b[2], b[3]) : a).replace(/#(\w)(\w)(\w)$/, "#$1$1$2$2$3$3");
        }
        var f = {
            duration: 500,
            ease: "ease",
            delay: 0
        };
        a.init = function(a, b, d, e) {
            this.$el = a, this.el = a[0];
            var g = b[0];
            d[2] && (g = d[2]), X[g] && (g = X[g]), this.name = g, this.type = d[1], this.duration = i(b[1], this.duration, f.duration), this.ease = c(b[2], this.ease, f.ease), this.delay = i(b[3], this.delay, f.delay), this.span = this.duration + this.delay, this.active = !1, this.nextStyle = null, this.auto = A.test(this.name), this.unit = e.unit || this.unit || U.defaultUnit, this.angle = e.angle || this.angle || U.defaultAngle, U.fallback || e.fallback ? this.animate = this.fallback : (this.animate = this.transition, this.string = this.name + B + this.duration + "ms" + ("ease" != this.ease ? B + m[this.ease][0] : "") + (this.delay ? B + this.delay + "ms" : ""));
        }, a.set = function(a) {
            a = this.convert(a, this.type), this.update(a), this.redraw();
        }, a.transition = function(a) {
            this.active = !0, a = this.convert(a, this.type), this.auto && ("auto" == this.el.style[this.name] && (this.update(this.get()), this.redraw()), "auto" == a && (a = b.call(this))), this.nextStyle = a;
        }, a.fallback = function(a) {
            var c = this.el.style[this.name] || this.convert(this.get(), this.type);
            a = this.convert(a, this.type), this.auto && ("auto" == c && (c = this.convert(this.get(), this.type)), "auto" == a && (a = b.call(this))), this.tween = new R({
                from: c,
                to: a,
                duration: this.duration,
                delay: this.delay,
                ease: this.ease,
                update: this.update,
                context: this
            });
        }, a.get = function() {
            return W(this.el, this.name);
        }, a.update = function(a) {
            V(this.el, this.name, a);
        }, a.stop = function() {
            (this.active || this.nextStyle) && (this.active = !1, this.nextStyle = null, V(this.el, this.name, this.get()));
            var a = this.tween;
            a && a.context && a.destroy();
        }, a.convert = function(a, b) {
            if ("auto" == a && this.auto) return a;
            var c, e = "number" == typeof a, f = "string" == typeof a;
            switch(b){
                case t:
                    if (e) return a;
                    if (f && "" === a.replace(r, "")) return +a;
                    c = "number(unitless)";
                    break;
                case u:
                    if (f) {
                        if ("" === a && this.original) return this.original;
                        if (b.test(a)) return "#" == a.charAt(0) && 7 == a.length ? a : d(a);
                    }
                    c = "hex or rgb string";
                    break;
                case v:
                    if (e) return a + this.unit;
                    if (f && b.test(a)) return a;
                    c = "number(px) or string(unit)";
                    break;
                case w:
                    if (e) return a + this.unit;
                    if (f && b.test(a)) return a;
                    c = "number(px) or string(unit or %)";
                    break;
                case x:
                    if (e) return a + this.angle;
                    if (f && b.test(a)) return a;
                    c = "number(deg) or string(angle)";
                    break;
                case y:
                    if (e) return a;
                    if (f && w.test(a)) return a;
                    c = "number(unitless) or string(unit or %)";
            }
            return g(c, a), a;
        }, a.redraw = function() {
            this.el.offsetHeight;
        };
    }), O = l(N, function(a, b) {
        a.init = function() {
            b.init.apply(this, arguments), this.original || (this.original = this.convert(this.get(), u));
        };
    }), P = l(N, function(a, b) {
        a.init = function() {
            b.init.apply(this, arguments), this.animate = this.fallback;
        }, a.get = function() {
            return this.$el[this.name]();
        }, a.update = function(a) {
            this.$el[this.name](a);
        };
    }), Q = l(N, function(a, b) {
        function c(a, b) {
            var c, d, e, f, g;
            for(c in a)f = Z[c], e = f[0], d = f[1] || c, g = this.convert(a[c], e), b.call(this, d, g, e);
        }
        a.init = function() {
            b.init.apply(this, arguments), this.current || (this.current = {}, Z.perspective && U.perspective && (this.current.perspective = U.perspective, V(this.el, this.name, this.style(this.current)), this.redraw()));
        }, a.set = function(a) {
            c.call(this, a, function(a, b) {
                this.current[a] = b;
            }), V(this.el, this.name, this.style(this.current)), this.redraw();
        }, a.transition = function(a) {
            var b = this.values(a);
            this.tween = new T({
                current: this.current,
                values: b,
                duration: this.duration,
                delay: this.delay,
                ease: this.ease
            });
            var c, d = {};
            for(c in this.current)d[c] = c in b ? b[c] : this.current[c];
            this.active = !0, this.nextStyle = this.style(d);
        }, a.fallback = function(a) {
            var b = this.values(a);
            this.tween = new T({
                current: this.current,
                values: b,
                duration: this.duration,
                delay: this.delay,
                ease: this.ease,
                update: this.update,
                context: this
            });
        }, a.update = function() {
            V(this.el, this.name, this.style(this.current));
        }, a.style = function(a) {
            var b, c = "";
            for(b in a)c += b + "(" + a[b] + ") ";
            return c;
        }, a.values = function(a) {
            var b, d = {};
            return c.call(this, a, function(a, c, e) {
                d[a] = c, void 0 === this.current[a] && (b = 0, ~a.indexOf("scale") && (b = 1), this.current[a] = this.convert(b, e));
            }), d;
        };
    }), R = l(function(b) {
        function c(a) {
            1 === n.push(a) && J(g);
        }
        function g() {
            var a, b, c, d = n.length;
            if (d) for(J(g), b = K(), a = d; a--;)c = n[a], c && c.render(b);
        }
        function i(b) {
            var c, d = a.inArray(b, n);
            d >= 0 && (c = n.slice(d + 1), n.length = d, c.length && (n = n.concat(c)));
        }
        function j(a) {
            return Math.round(a * o) / o;
        }
        function k(a, b, c) {
            return e(a[0] + c * (b[0] - a[0]), a[1] + c * (b[1] - a[1]), a[2] + c * (b[2] - a[2]));
        }
        var l = {
            ease: m.ease[1],
            from: 0,
            to: 1
        };
        b.init = function(a) {
            this.duration = a.duration || 0, this.delay = a.delay || 0;
            var b = a.ease || l.ease;
            m[b] && (b = m[b][1]), "function" != typeof b && (b = l.ease), this.ease = b, this.update = a.update || f, this.complete = a.complete || f, this.context = a.context || this, this.name = a.name;
            var c = a.from, d = a.to;
            void 0 === c && (c = l.from), void 0 === d && (d = l.to), this.unit = a.unit || "", "number" == typeof c && "number" == typeof d ? (this.begin = c, this.change = d - c) : this.format(d, c), this.value = this.begin + this.unit, this.start = K(), a.autoplay !== !1 && this.play();
        }, b.play = function() {
            this.active || (this.start || (this.start = K()), this.active = !0, c(this));
        }, b.stop = function() {
            this.active && (this.active = !1, i(this));
        }, b.render = function(a) {
            var b, c = a - this.start;
            if (this.delay) {
                if (c <= this.delay) return;
                c -= this.delay;
            }
            if (c < this.duration) {
                var d = this.ease(c, 0, 1, this.duration);
                return b = this.startRGB ? k(this.startRGB, this.endRGB, d) : j(this.begin + d * this.change), this.value = b + this.unit, void this.update.call(this.context, this.value);
            }
            b = this.endHex || this.begin + this.change, this.value = b + this.unit, this.update.call(this.context, this.value), this.complete.call(this.context), this.destroy();
        }, b.format = function(a, b) {
            if (b += "", a += "", "#" == a.charAt(0)) return this.startRGB = d(b), this.endRGB = d(a), this.endHex = a, this.begin = 0, void (this.change = 1);
            if (!this.unit) {
                var c = b.replace(r, ""), e = a.replace(r, "");
                c !== e && h("tween", b, a), this.unit = c;
            }
            b = parseFloat(b), a = parseFloat(a), this.begin = this.value = b, this.change = a - b;
        }, b.destroy = function() {
            this.stop(), this.context = null, this.ease = this.update = this.complete = f;
        };
        var n = [], o = 1e3;
    }), S = l(R, function(a) {
        a.init = function(a) {
            this.duration = a.duration || 0, this.complete = a.complete || f, this.context = a.context, this.play();
        }, a.render = function(a) {
            var b = a - this.start;
            b < this.duration || (this.complete.call(this.context), this.destroy());
        };
    }), T = l(R, function(a, b) {
        a.init = function(a) {
            this.context = a.context, this.update = a.update, this.tweens = [], this.current = a.current;
            var b, c;
            for(b in a.values)c = a.values[b], this.current[b] !== c && this.tweens.push(new R({
                name: b,
                from: this.current[b],
                to: c,
                duration: a.duration,
                delay: a.delay,
                ease: a.ease,
                autoplay: !1
            }));
            this.play();
        }, a.render = function(a) {
            var b, c, d = this.tweens.length, e = !1;
            for(b = d; b--;)c = this.tweens[b], c.context && (c.render(a), this.current[c.name] = c.value, e = !0);
            return e ? void (this.update && this.update.call(this.context)) : this.destroy();
        }, a.destroy = function() {
            if (b.destroy.call(this), this.tweens) {
                var a, c = this.tweens.length;
                for(a = c; a--;)this.tweens[a].destroy();
                this.tweens = null, this.current = null;
            }
        };
    }), U = b.config = {
        debug: !1,
        defaultUnit: "px",
        defaultAngle: "deg",
        keepInherited: !1,
        hideBackface: !1,
        perspective: "",
        fallback: !G.transition,
        agentTests: []
    };
    b.fallback = function(a) {
        if (!G.transition) return U.fallback = !0;
        U.agentTests.push("(" + a + ")");
        var b = new RegExp(U.agentTests.join("|"), "i");
        U.fallback = b.test(navigator.userAgent);
    }, b.fallback("6.0.[2-5] Safari"), b.tween = function(a) {
        return new R(a);
    }, b.delay = function(a, b, c) {
        return new S({
            complete: b,
            duration: a,
            context: c
        });
    }, a.fn.tram = function(a) {
        return b.call(null, this, a);
    };
    var V = a.style, W = a.css, X = {
        transform: G.transform && G.transform.css
    }, Y = {
        color: [
            O,
            u
        ],
        background: [
            O,
            u,
            "background-color"
        ],
        "outline-color": [
            O,
            u
        ],
        "border-color": [
            O,
            u
        ],
        "border-top-color": [
            O,
            u
        ],
        "border-right-color": [
            O,
            u
        ],
        "border-bottom-color": [
            O,
            u
        ],
        "border-left-color": [
            O,
            u
        ],
        "border-width": [
            N,
            v
        ],
        "border-top-width": [
            N,
            v
        ],
        "border-right-width": [
            N,
            v
        ],
        "border-bottom-width": [
            N,
            v
        ],
        "border-left-width": [
            N,
            v
        ],
        "border-spacing": [
            N,
            v
        ],
        "letter-spacing": [
            N,
            v
        ],
        margin: [
            N,
            v
        ],
        "margin-top": [
            N,
            v
        ],
        "margin-right": [
            N,
            v
        ],
        "margin-bottom": [
            N,
            v
        ],
        "margin-left": [
            N,
            v
        ],
        padding: [
            N,
            v
        ],
        "padding-top": [
            N,
            v
        ],
        "padding-right": [
            N,
            v
        ],
        "padding-bottom": [
            N,
            v
        ],
        "padding-left": [
            N,
            v
        ],
        "outline-width": [
            N,
            v
        ],
        opacity: [
            N,
            t
        ],
        top: [
            N,
            w
        ],
        right: [
            N,
            w
        ],
        bottom: [
            N,
            w
        ],
        left: [
            N,
            w
        ],
        "font-size": [
            N,
            w
        ],
        "text-indent": [
            N,
            w
        ],
        "word-spacing": [
            N,
            w
        ],
        width: [
            N,
            w
        ],
        "min-width": [
            N,
            w
        ],
        "max-width": [
            N,
            w
        ],
        height: [
            N,
            w
        ],
        "min-height": [
            N,
            w
        ],
        "max-height": [
            N,
            w
        ],
        "line-height": [
            N,
            y
        ],
        "scroll-top": [
            P,
            t,
            "scrollTop"
        ],
        "scroll-left": [
            P,
            t,
            "scrollLeft"
        ]
    }, Z = {};
    G.transform && (Y.transform = [
        Q
    ], Z = {
        x: [
            w,
            "translateX"
        ],
        y: [
            w,
            "translateY"
        ],
        rotate: [
            x
        ],
        rotateX: [
            x
        ],
        rotateY: [
            x
        ],
        scale: [
            t
        ],
        scaleX: [
            t
        ],
        scaleY: [
            t
        ],
        skew: [
            x
        ],
        skewX: [
            x
        ],
        skewY: [
            x
        ]
    }), G.transform && G.backface && (Z.z = [
        w,
        "translateZ"
    ], Z.rotateZ = [
        x
    ], Z.scaleZ = [
        t
    ], Z.perspective = [
        v
    ]);
    var $ = /ms/, _ = /s|\./;
    return a.tram = b;
}(window.jQuery);

//# sourceMappingURL=data:application/json;base64,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

}),
35756: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";
// Include tram for frame-throttling
/* globals window */ 
var $ = window.$;
var tram = __webpack_require__(95487) && $.tram;
/*!
 * Webflow._ (aka) Underscore.js 1.6.0 (custom build)
 *
 * http://underscorejs.org
 * (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Underscore may be freely distributed under the MIT license.
 * @license MIT
 */ /**
 * Webflow custom build of Underscore.js 1.6.0
 * https://github.com/jashkenas/underscore/tree/1.6.0
 *
 * _.each
 * _.map
 * _.find
 * _.filter
 * _.any
 * _.contains
 * _.delay
 * _.defer
 * _.throttle (webflow)
 * _.debounce
 * _.keys
 * _.has
 * _.now
 * _.template (webflow: upgraded to 1.13.6)
 */ module.exports = function() {
    var _ = {};
    // Current version.
    _.VERSION = '1.6.0-Webflow';
    // Establish the object that gets returned to break out of a loop iteration.
    var breaker = {};
    // Save bytes in the minified (but not gzipped) version:
    /* eslint-disable one-var */ var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
    /* eslint-enable one-var */ // Create quick reference variables for speed access to core prototypes.
    /* eslint-disable one-var, unused-imports/no-unused-vars */ var push = ArrayProto.push, slice = ArrayProto.slice, concat = ArrayProto.concat, toString = ObjProto.toString, hasOwnProperty = ObjProto.hasOwnProperty;
    /* eslint-enable one-var, unused-imports/no-unused-vars */ // All **ECMAScript 5** native function implementations that we hope to use
    // are declared here.
    /* eslint-disable one-var, unused-imports/no-unused-vars */ var nativeForEach = ArrayProto.forEach, nativeMap = ArrayProto.map, nativeReduce = ArrayProto.reduce, nativeReduceRight = ArrayProto.reduceRight, nativeFilter = ArrayProto.filter, nativeEvery = ArrayProto.every, nativeSome = ArrayProto.some, nativeIndexOf = ArrayProto.indexOf, nativeLastIndexOf = ArrayProto.lastIndexOf, nativeIsArray = Array.isArray, nativeKeys = Object.keys, nativeBind = FuncProto.bind;
    /* eslint-enable one-var, unused-imports/no-unused-vars */ // Collection Functions
    // --------------------
    // The cornerstone, an `each` implementation, aka `forEach`.
    // Handles objects with the built-in `forEach`, arrays, and raw objects.
    // Delegates to **ECMAScript 5**'s native `forEach` if available.
    var each = _.each = _.forEach = function(obj, iterator, context) {
        /* jshint shadow:true */ if (obj == null) return obj;
        if (nativeForEach && obj.forEach === nativeForEach) {
            obj.forEach(iterator, context);
        // eslint-disable-next-line no-implicit-coercion
        } else if (obj.length === +obj.length) {
            for(var i = 0, length = obj.length; i < length; i++){
                if (iterator.call(context, obj[i], i, obj) === breaker) return;
            }
        } else {
            var keys = _.keys(obj);
            // eslint-disable-next-line no-redeclare
            for(var i = 0, length = keys.length; i < length; i++){
                if (iterator.call(context, obj[keys[i]], keys[i], obj) === breaker) return;
            }
        }
        return obj;
    };
    // Return the results of applying the iterator to each element.
    // Delegates to **ECMAScript 5**'s native `map` if available.
    _.map = _.collect = function(obj, iterator, context) {
        var results = [];
        if (obj == null) return results;
        if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
        each(obj, function(value, index, list) {
            results.push(iterator.call(context, value, index, list));
        });
        return results;
    };
    // Return the first value which passes a truth test. Aliased as `detect`.
    _.find = _.detect = function(obj, predicate, context) {
        var result;
        any(obj, function(value, index, list) {
            if (predicate.call(context, value, index, list)) {
                result = value;
                return true;
            }
        });
        return result;
    };
    // Return all the elements that pass a truth test.
    // Delegates to **ECMAScript 5**'s native `filter` if available.
    // Aliased as `select`.
    _.filter = _.select = function(obj, predicate, context) {
        var results = [];
        if (obj == null) return results;
        if (nativeFilter && obj.filter === nativeFilter) return obj.filter(predicate, context);
        each(obj, function(value, index, list) {
            if (predicate.call(context, value, index, list)) results.push(value);
        });
        return results;
    };
    // Determine if at least one element in the object matches a truth test.
    // Delegates to **ECMAScript 5**'s native `some` if available.
    // Aliased as `any`.
    var any = _.some = _.any = function(obj, predicate, context) {
        predicate || (predicate = _.identity);
        var result = false;
        if (obj == null) return result;
        if (nativeSome && obj.some === nativeSome) return obj.some(predicate, context);
        each(obj, function(value, index, list) {
            if (result || (result = predicate.call(context, value, index, list))) return breaker;
        });
        return !!result; // eslint-disable-line no-implicit-coercion
    };
    // Determine if the array or object contains a given value (using `===`).
    // Aliased as `include`.
    _.contains = _.include = function(obj, target) {
        if (obj == null) return false;
        if (nativeIndexOf && obj.indexOf === nativeIndexOf) // eslint-disable-next-line eqeqeq
        return obj.indexOf(target) != -1;
        return any(obj, function(value) {
            return value === target;
        });
    };
    // Function (ahem) Functions
    // --------------------
    // Delays a function for the given number of milliseconds, and then calls
    // it with the arguments supplied.
    _.delay = function(func, wait) {
        var args = slice.call(arguments, 2);
        return setTimeout(function() {
            return func.apply(null, args);
        }, wait);
    };
    // Defers a function, scheduling it to run after the current call stack has
    // cleared.
    _.defer = function(func) {
        return _.delay.apply(_, [
            func,
            1
        ].concat(slice.call(arguments, 1)));
    };
    // Returns a function, that, when invoked, will only be triggered once every
    // browser animation frame - using tram's requestAnimationFrame polyfill.
    _.throttle = function(func) {
        // eslint-disable-next-line one-var
        var wait, args, context;
        return function() {
            if (wait) return;
            wait = true;
            args = arguments;
            context = this;
            tram.frame(function() {
                wait = false;
                func.apply(context, args);
            });
        };
    };
    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    _.debounce = function(func, wait, immediate) {
        // eslint-disable-next-line one-var
        var timeout, args, context, timestamp, result;
        var later = function() {
            var last = _.now() - timestamp;
            if (last < wait) {
                timeout = setTimeout(later, wait - last);
            } else {
                timeout = null;
                if (!immediate) {
                    result = func.apply(context, args);
                    context = args = null;
                }
            }
        };
        return function() {
            context = this;
            args = arguments;
            timestamp = _.now();
            var callNow = immediate && !timeout;
            if (!timeout) {
                timeout = setTimeout(later, wait);
            }
            if (callNow) {
                result = func.apply(context, args);
                context = args = null;
            }
            return result;
        };
    };
    // Object Functions
    // ----------------
    // Fill in a given object with default properties.
    _.defaults = function(obj) {
        if (!_.isObject(obj)) return obj;
        for(var i = 1, length = arguments.length; i < length; i++){
            var source = arguments[i];
            for(var prop in source){
                // eslint-disable-next-line no-void
                if (obj[prop] === void 0) obj[prop] = source[prop];
            }
        }
        return obj;
    };
    // Retrieve the names of an object's properties.
    // Delegates to **ECMAScript 5**'s native `Object.keys`
    _.keys = function(obj) {
        if (!_.isObject(obj)) return [];
        if (nativeKeys) return nativeKeys(obj);
        var keys = [];
        for(var key in obj)if (_.has(obj, key)) keys.push(key);
        return keys;
    };
    // Shortcut function for checking if an object has a given property directly
    // on itself (in other words, not on a prototype).
    _.has = function(obj, key) {
        return hasOwnProperty.call(obj, key);
    };
    // Is a given variable an object?
    _.isObject = function(obj) {
        return obj === Object(obj);
    };
    // Utility Functions
    // -----------------
    // A (possibly faster) way to get the current timestamp as an integer.
    _.now = Date.now || function() {
        return new Date().getTime();
    };
    // By default, Underscore uses ERB-style template delimiters, change the
    // following template settings to use alternative delimiters.
    _.templateSettings = {
        evaluate: /<%([\s\S]+?)%>/g,
        interpolate: /<%=([\s\S]+?)%>/g,
        escape: /<%-([\s\S]+?)%>/g
    };
    // When customizing `templateSettings`, if you don't want to define an
    // interpolation, evaluation or escaping regex, we need one that is
    // guaranteed not to match.
    var noMatch = /(.)^/;
    // Certain characters need to be escaped so that they can be put into a
    // string literal.
    var escapes = {
        "'": "'",
        '\\': '\\',
        '\r': 'r',
        '\n': 'n',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
    var escapeChar = function(match) {
        return '\\' + escapes[match];
    };
    // In order to prevent third-party code injection through
    // `_.templateSettings.variable`, we test it against the following regular
    // expression. It is intentionally a bit more liberal than just matching valid
    // identifiers, but still prevents possible loopholes through defaults or
    // destructuring assignment.
    var bareIdentifier = /^\s*(\w|\$)+\s*$/;
    // JavaScript micro-templating, similar to John Resig's implementation.
    // Underscore templating handles arbitrary delimiters, preserves whitespace,
    // and correctly escapes quotes within interpolated code.
    // NB: `oldSettings` only exists for backwards compatibility.
    _.template = function(text, settings, oldSettings) {
        if (!settings && oldSettings) settings = oldSettings;
        settings = _.defaults({}, settings, _.templateSettings);
        // Combine delimiters into one regular expression via alternation.
        var matcher = RegExp([
            (settings.escape || noMatch).source,
            (settings.interpolate || noMatch).source,
            (settings.evaluate || noMatch).source
        ].join('|') + '|$', 'g');
        // Compile the template source, escaping string literals appropriately.
        var index = 0;
        var source = "__p+='";
        text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
            source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
            index = offset + match.length;
            if (escape) {
                source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
            } else if (interpolate) {
                source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
            } else if (evaluate) {
                source += "';\n" + evaluate + "\n__p+='";
            }
            // Adobe VMs need the match returned to produce the correct offset.
            return match;
        });
        source += "';\n";
        var argument = settings.variable;
        if (argument) {
            // Insure against third-party code injection. (CVE-2021-23358)
            if (!bareIdentifier.test(argument)) throw new Error('variable is not a bare identifier: ' + argument);
        } else {
            // If a variable is not specified, place data values in local scope.
            source = 'with(obj||{}){\n' + source + '}\n';
            argument = 'obj';
        }
        source = "var __t,__p='',__j=Array.prototype.join," + "print=function(){__p+=__j.call(arguments,'');};\n" + source + 'return __p;\n';
        var render;
        try {
            // eslint-disable-next-line no-new-func
            render = new Function(settings.variable || 'obj', '_', source);
        } catch (e) {
            e.source = source;
            throw e;
        }
        var template = function(data) {
            return render.call(this, data, _);
        };
        // Provide the compiled source as a convenience for precompilation.
        template.source = 'function(' + argument + '){\n' + source + '}';
        return template;
    };
    // Export underscore
    return _;
}();

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInVuZGVyc2NvcmUtY3VzdG9tLmpzIl0sInNvdXJjZXNDb250ZW50IjpbIi8vIEluY2x1ZGUgdHJhbSBmb3IgZnJhbWUtdGhyb3R0bGluZ1xuLyogZ2xvYmFscyB3aW5kb3cgKi9cblxudmFyICQgPSB3aW5kb3cuJDtcbnZhciB0cmFtID0gcmVxdWlyZSgnLi90cmFtLW1pbicpICYmICQudHJhbTtcblxuLyohXG4gKiBXZWJmbG93Ll8gKGFrYSkgVW5kZXJzY29yZS5qcyAxLjYuMCAoY3VzdG9tIGJ1aWxkKVxuICpcbiAqIGh0dHA6Ly91bmRlcnNjb3JlanMub3JnXG4gKiAoYykgMjAwOS0yMDEzIEplcmVteSBBc2hrZW5hcywgRG9jdW1lbnRDbG91ZCBhbmQgSW52ZXN0aWdhdGl2ZSBSZXBvcnRlcnMgJiBFZGl0b3JzXG4gKiBVbmRlcnNjb3JlIG1heSBiZSBmcmVlbHkgZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIE1JVCBsaWNlbnNlLlxuICogQGxpY2Vuc2UgTUlUXG4gKi9cbi8qKlxuICogV2ViZmxvdyBjdXN0b20gYnVpbGQgb2YgVW5kZXJzY29yZS5qcyAxLjYuMFxuICogaHR0cHM6Ly9naXRodWIuY29tL2phc2hrZW5hcy91bmRlcnNjb3JlL3RyZWUvMS42LjBcbiAqXG4gKiBfLmVhY2hcbiAqIF8ubWFwXG4gKiBfLmZpbmRcbiAqIF8uZmlsdGVyXG4gKiBfLmFueVxuICogXy5jb250YWluc1xuICogXy5kZWxheVxuICogXy5kZWZlclxuICogXy50aHJvdHRsZSAod2ViZmxvdylcbiAqIF8uZGVib3VuY2VcbiAqIF8ua2V5c1xuICogXy5oYXNcbiAqIF8ubm93XG4gKiBfLnRlbXBsYXRlICh3ZWJmbG93OiB1cGdyYWRlZCB0byAxLjEzLjYpXG4gKi9cbm1vZHVsZS5leHBvcnRzID0gKGZ1bmN0aW9uICgpIHtcbiAgdmFyIF8gPSB7fTtcblxuICAvLyBDdXJyZW50IHZlcnNpb24uXG4gIF8uVkVSU0lPTiA9ICcxLjYuMC1XZWJmbG93JztcblxuICAvLyBFc3RhYmxpc2ggdGhlIG9iamVjdCB0aGF0IGdldHMgcmV0dXJuZWQgdG8gYnJlYWsgb3V0IG9mIGEgbG9vcCBpdGVyYXRpb24uXG4gIHZhciBicmVha2VyID0ge307XG5cbiAgLy8gU2F2ZSBieXRlcyBpbiB0aGUgbWluaWZpZWQgKGJ1dCBub3QgZ3ppcHBlZCkgdmVyc2lvbjpcbiAgLyogZXNsaW50LWRpc2FibGUgb25lLXZhciAqL1xuICB2YXIgQXJyYXlQcm90byA9IEFycmF5LnByb3RvdHlwZSxcbiAgICBPYmpQcm90byA9IE9iamVjdC5wcm90b3R5cGUsXG4gICAgRnVuY1Byb3RvID0gRnVuY3Rpb24ucHJvdG90eXBlO1xuICAvKiBlc2xpbnQtZW5hYmxlIG9uZS12YXIgKi9cblxuICAvLyBDcmVhdGUgcXVpY2sgcmVmZXJlbmNlIHZhcmlhYmxlcyBmb3Igc3BlZWQgYWNjZXNzIHRvIGNvcmUgcHJvdG90eXBlcy5cbiAgLyogZXNsaW50LWRpc2FibGUgb25lLXZhciwgdW51c2VkLWltcG9ydHMvbm8tdW51c2VkLXZhcnMgKi9cbiAgdmFyIHB1c2ggPSBBcnJheVByb3RvLnB1c2gsXG4gICAgc2xpY2UgPSBBcnJheVByb3RvLnNsaWNlLFxuICAgIGNvbmNhdCA9IEFycmF5UHJvdG8uY29uY2F0LFxuICAgIHRvU3RyaW5nID0gT2JqUHJvdG8udG9TdHJpbmcsXG4gICAgaGFzT3duUHJvcGVydHkgPSBPYmpQcm90by5oYXNPd25Qcm9wZXJ0eTtcbiAgLyogZXNsaW50LWVuYWJsZSBvbmUtdmFyLCB1bnVzZWQtaW1wb3J0cy9uby11bnVzZWQtdmFycyAqL1xuXG4gIC8vIEFsbCAqKkVDTUFTY3JpcHQgNSoqIG5hdGl2ZSBmdW5jdGlvbiBpbXBsZW1lbnRhdGlvbnMgdGhhdCB3ZSBob3BlIHRvIHVzZVxuICAvLyBhcmUgZGVjbGFyZWQgaGVyZS5cbiAgLyogZXNsaW50LWRpc2FibGUgb25lLXZhciwgdW51c2VkLWltcG9ydHMvbm8tdW51c2VkLXZhcnMgKi9cbiAgdmFyIG5hdGl2ZUZvckVhY2ggPSBBcnJheVByb3RvLmZvckVhY2gsXG4gICAgbmF0aXZlTWFwID0gQXJyYXlQcm90by5tYXAsXG4gICAgbmF0aXZlUmVkdWNlID0gQXJyYXlQcm90by5yZWR1Y2UsXG4gICAgbmF0aXZlUmVkdWNlUmlnaHQgPSBBcnJheVByb3RvLnJlZHVjZVJpZ2h0LFxuICAgIG5hdGl2ZUZpbHRlciA9IEFycmF5UHJvdG8uZmlsdGVyLFxuICAgIG5hdGl2ZUV2ZXJ5ID0gQXJyYXlQcm90by5ldmVyeSxcbiAgICBuYXRpdmVTb21lID0gQXJyYXlQcm90by5zb21lLFxuICAgIG5hdGl2ZUluZGV4T2YgPSBBcnJheVByb3RvLmluZGV4T2YsXG4gICAgbmF0aXZlTGFzdEluZGV4T2YgPSBBcnJheVByb3RvLmxhc3RJbmRleE9mLFxuICAgIG5hdGl2ZUlzQXJyYXkgPSBBcnJheS5pc0FycmF5LFxuICAgIG5hdGl2ZUtleXMgPSBPYmplY3Qua2V5cyxcbiAgICBuYXRpdmVCaW5kID0gRnVuY1Byb3RvLmJpbmQ7XG4gIC8qIGVzbGludC1lbmFibGUgb25lLXZhciwgdW51c2VkLWltcG9ydHMvbm8tdW51c2VkLXZhcnMgKi9cblxuICAvLyBDb2xsZWN0aW9uIEZ1bmN0aW9uc1xuICAvLyAtLS0tLS0tLS0tLS0tLS0tLS0tLVxuXG4gIC8vIFRoZSBjb3JuZXJzdG9uZSwgYW4gYGVhY2hgIGltcGxlbWVudGF0aW9uLCBha2EgYGZvckVhY2hgLlxuICAvLyBIYW5kbGVzIG9iamVjdHMgd2l0aCB0aGUgYnVpbHQtaW4gYGZvckVhY2hgLCBhcnJheXMsIGFuZCByYXcgb2JqZWN0cy5cbiAgLy8gRGVsZWdhdGVzIHRvICoqRUNNQVNjcmlwdCA1KioncyBuYXRpdmUgYGZvckVhY2hgIGlmIGF2YWlsYWJsZS5cbiAgdmFyIGVhY2ggPVxuICAgIChfLmVhY2ggPVxuICAgIF8uZm9yRWFjaCA9XG4gICAgICBmdW5jdGlvbiAob2JqLCBpdGVyYXRvciwgY29udGV4dCkge1xuICAgICAgICAvKiBqc2hpbnQgc2hhZG93OnRydWUgKi9cbiAgICAgICAgaWYgKG9iaiA9PSBudWxsKSByZXR1cm4gb2JqO1xuICAgICAgICBpZiAobmF0aXZlRm9yRWFjaCAmJiBvYmouZm9yRWFjaCA9PT0gbmF0aXZlRm9yRWFjaCkge1xuICAgICAgICAgIG9iai5mb3JFYWNoKGl0ZXJhdG9yLCBjb250ZXh0KTtcbiAgICAgICAgICAvLyBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgbm8taW1wbGljaXQtY29lcmNpb25cbiAgICAgICAgfSBlbHNlIGlmIChvYmoubGVuZ3RoID09PSArb2JqLmxlbmd0aCkge1xuICAgICAgICAgIGZvciAodmFyIGkgPSAwLCBsZW5ndGggPSBvYmoubGVuZ3RoOyBpIDwgbGVuZ3RoOyBpKyspIHtcbiAgICAgICAgICAgIGlmIChpdGVyYXRvci5jYWxsKGNvbnRleHQsIG9ialtpXSwgaSwgb2JqKSA9PT0gYnJlYWtlcikgcmV0dXJuO1xuICAgICAgICAgIH1cbiAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICB2YXIga2V5cyA9IF8ua2V5cyhvYmopO1xuICAgICAgICAgIC8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSBuby1yZWRlY2xhcmVcbiAgICAgICAgICBmb3IgKHZhciBpID0gMCwgbGVuZ3RoID0ga2V5cy5sZW5ndGg7IGkgPCBsZW5ndGg7IGkrKykge1xuICAgICAgICAgICAgaWYgKGl0ZXJhdG9yLmNhbGwoY29udGV4dCwgb2JqW2tleXNbaV1dLCBrZXlzW2ldLCBvYmopID09PSBicmVha2VyKVxuICAgICAgICAgICAgICByZXR1cm47XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICAgIHJldHVybiBvYmo7XG4gICAgICB9KTtcblxuICAvLyBSZXR1cm4gdGhlIHJlc3VsdHMgb2YgYXBwbHlpbmcgdGhlIGl0ZXJhdG9yIHRvIGVhY2ggZWxlbWVudC5cbiAgLy8gRGVsZWdhdGVzIHRvICoqRUNNQVNjcmlwdCA1KioncyBuYXRpdmUgYG1hcGAgaWYgYXZhaWxhYmxlLlxuICBfLm1hcCA9IF8uY29sbGVjdCA9IGZ1bmN0aW9uIChvYmosIGl0ZXJhdG9yLCBjb250ZXh0KSB7XG4gICAgdmFyIHJlc3VsdHMgPSBbXTtcbiAgICBpZiAob2JqID09IG51bGwpIHJldHVybiByZXN1bHRzO1xuICAgIGlmIChuYXRpdmVNYXAgJiYgb2JqLm1hcCA9PT0gbmF0aXZlTWFwKSByZXR1cm4gb2JqLm1hcChpdGVyYXRvciwgY29udGV4dCk7XG4gICAgZWFjaChvYmosIGZ1bmN0aW9uICh2YWx1ZSwgaW5kZXgsIGxpc3QpIHtcbiAgICAgIHJlc3VsdHMucHVzaChpdGVyYXRvci5jYWxsKGNvbnRleHQsIHZhbHVlLCBpbmRleCwgbGlzdCkpO1xuICAgIH0pO1xuICAgIHJldHVybiByZXN1bHRzO1xuICB9O1xuXG4gIC8vIFJldHVybiB0aGUgZmlyc3QgdmFsdWUgd2hpY2ggcGFzc2VzIGEgdHJ1dGggdGVzdC4gQWxpYXNlZCBhcyBgZGV0ZWN0YC5cbiAgXy5maW5kID0gXy5kZXRlY3QgPSBmdW5jdGlvbiAob2JqLCBwcmVkaWNhdGUsIGNvbnRleHQpIHtcbiAgICB2YXIgcmVzdWx0O1xuICAgIGFueShvYmosIGZ1bmN0aW9uICh2YWx1ZSwgaW5kZXgsIGxpc3QpIHtcbiAgICAgIGlmIChwcmVkaWNhdGUuY2FsbChjb250ZXh0LCB2YWx1ZSwgaW5kZXgsIGxpc3QpKSB7XG4gICAgICAgIHJlc3VsdCA9IHZhbHVlO1xuICAgICAgICByZXR1cm4gdHJ1ZTtcbiAgICAgIH1cbiAgICB9KTtcbiAgICByZXR1cm4gcmVzdWx0O1xuICB9O1xuXG4gIC8vIFJldHVybiBhbGwgdGhlIGVsZW1lbnRzIHRoYXQgcGFzcyBhIHRydXRoIHRlc3QuXG4gIC8vIERlbGVnYXRlcyB0byAqKkVDTUFTY3JpcHQgNSoqJ3MgbmF0aXZlIGBmaWx0ZXJgIGlmIGF2YWlsYWJsZS5cbiAgLy8gQWxpYXNlZCBhcyBgc2VsZWN0YC5cbiAgXy5maWx0ZXIgPSBfLnNlbGVjdCA9IGZ1bmN0aW9uIChvYmosIHByZWRpY2F0ZSwgY29udGV4dCkge1xuICAgIHZhciByZXN1bHRzID0gW107XG4gICAgaWYgKG9iaiA9PSBudWxsKSByZXR1cm4gcmVzdWx0cztcbiAgICBpZiAobmF0aXZlRmlsdGVyICYmIG9iai5maWx0ZXIgPT09IG5hdGl2ZUZpbHRlcilcbiAgICAgIHJldHVybiBvYmouZmlsdGVyKHByZWRpY2F0ZSwgY29udGV4dCk7XG4gICAgZWFjaChvYmosIGZ1bmN0aW9uICh2YWx1ZSwgaW5kZXgsIGxpc3QpIHtcbiAgICAgIGlmIChwcmVkaWNhdGUuY2FsbChjb250ZXh0LCB2YWx1ZSwgaW5kZXgsIGxpc3QpKSByZXN1bHRzLnB1c2godmFsdWUpO1xuICAgIH0pO1xuICAgIHJldHVybiByZXN1bHRzO1xuICB9O1xuXG4gIC8vIERldGVybWluZSBpZiBhdCBsZWFzdCBvbmUgZWxlbWVudCBpbiB0aGUgb2JqZWN0IG1hdGNoZXMgYSB0cnV0aCB0ZXN0LlxuICAvLyBEZWxlZ2F0ZXMgdG8gKipFQ01BU2NyaXB0IDUqKidzIG5hdGl2ZSBgc29tZWAgaWYgYXZhaWxhYmxlLlxuICAvLyBBbGlhc2VkIGFzIGBhbnlgLlxuICB2YXIgYW55ID1cbiAgICAoXy5zb21lID1cbiAgICBfLmFueSA9XG4gICAgICBmdW5jdGlvbiAob2JqLCBwcmVkaWNhdGUsIGNvbnRleHQpIHtcbiAgICAgICAgcHJlZGljYXRlIHx8IChwcmVkaWNhdGUgPSBfLmlkZW50aXR5KTtcbiAgICAgICAgdmFyIHJlc3VsdCA9IGZhbHNlO1xuICAgICAgICBpZiAob2JqID09IG51bGwpIHJldHVybiByZXN1bHQ7XG4gICAgICAgIGlmIChuYXRpdmVTb21lICYmIG9iai5zb21lID09PSBuYXRpdmVTb21lKVxuICAgICAgICAgIHJldHVybiBvYmouc29tZShwcmVkaWNhdGUsIGNvbnRleHQpO1xuICAgICAgICBlYWNoKG9iaiwgZnVuY3Rpb24gKHZhbHVlLCBpbmRleCwgbGlzdCkge1xuICAgICAgICAgIGlmIChyZXN1bHQgfHwgKHJlc3VsdCA9IHByZWRpY2F0ZS5jYWxsKGNvbnRleHQsIHZhbHVlLCBpbmRleCwgbGlzdCkpKVxuICAgICAgICAgICAgcmV0dXJuIGJyZWFrZXI7XG4gICAgICAgIH0pO1xuICAgICAgICByZXR1cm4gISFyZXN1bHQ7IC8vIGVzbGludC1kaXNhYmxlLWxpbmUgbm8taW1wbGljaXQtY29lcmNpb25cbiAgICAgIH0pO1xuXG4gIC8vIERldGVybWluZSBpZiB0aGUgYXJyYXkgb3Igb2JqZWN0IGNvbnRhaW5zIGEgZ2l2ZW4gdmFsdWUgKHVzaW5nIGA9PT1gKS5cbiAgLy8gQWxpYXNlZCBhcyBgaW5jbHVkZWAuXG4gIF8uY29udGFpbnMgPSBfLmluY2x1ZGUgPSBmdW5jdGlvbiAob2JqLCB0YXJnZXQpIHtcbiAgICBpZiAob2JqID09IG51bGwpIHJldHVybiBmYWxzZTtcbiAgICBpZiAobmF0aXZlSW5kZXhPZiAmJiBvYmouaW5kZXhPZiA9PT0gbmF0aXZlSW5kZXhPZilcbiAgICAgIC8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSBlcWVxZXFcbiAgICAgIHJldHVybiBvYmouaW5kZXhPZih0YXJnZXQpICE9IC0xO1xuICAgIHJldHVybiBhbnkob2JqLCBmdW5jdGlvbiAodmFsdWUpIHtcbiAgICAgIHJldHVybiB2YWx1ZSA9PT0gdGFyZ2V0O1xuICAgIH0pO1xuICB9O1xuXG4gIC8vIEZ1bmN0aW9uIChhaGVtKSBGdW5jdGlvbnNcbiAgLy8gLS0tLS0tLS0tLS0tLS0tLS0tLS1cblxuICAvLyBEZWxheXMgYSBmdW5jdGlvbiBmb3IgdGhlIGdpdmVuIG51bWJlciBvZiBtaWxsaXNlY29uZHMsIGFuZCB0aGVuIGNhbGxzXG4gIC8vIGl0IHdpdGggdGhlIGFyZ3VtZW50cyBzdXBwbGllZC5cbiAgXy5kZWxheSA9IGZ1bmN0aW9uIChmdW5jLCB3YWl0KSB7XG4gICAgdmFyIGFyZ3MgPSBzbGljZS5jYWxsKGFyZ3VtZW50cywgMik7XG4gICAgcmV0dXJuIHNldFRpbWVvdXQoZnVuY3Rpb24gKCkge1xuICAgICAgcmV0dXJuIGZ1bmMuYXBwbHkobnVsbCwgYXJncyk7XG4gICAgfSwgd2FpdCk7XG4gIH07XG5cbiAgLy8gRGVmZXJzIGEgZnVuY3Rpb24sIHNjaGVkdWxpbmcgaXQgdG8gcnVuIGFmdGVyIHRoZSBjdXJyZW50IGNhbGwgc3RhY2sgaGFzXG4gIC8vIGNsZWFyZWQuXG4gIF8uZGVmZXIgPSBmdW5jdGlvbiAoZnVuYykge1xuICAgIHJldHVybiBfLmRlbGF5LmFwcGx5KF8sIFtmdW5jLCAxXS5jb25jYXQoc2xpY2UuY2FsbChhcmd1bWVudHMsIDEpKSk7XG4gIH07XG5cbiAgLy8gUmV0dXJucyBhIGZ1bmN0aW9uLCB0aGF0LCB3aGVuIGludm9rZWQsIHdpbGwgb25seSBiZSB0cmlnZ2VyZWQgb25jZSBldmVyeVxuICAvLyBicm93c2VyIGFuaW1hdGlvbiBmcmFtZSAtIHVzaW5nIHRyYW0ncyByZXF1ZXN0QW5pbWF0aW9uRnJhbWUgcG9seWZpbGwuXG4gIF8udGhyb3R0bGUgPSBmdW5jdGlvbiAoZnVuYykge1xuICAgIC8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSBvbmUtdmFyXG4gICAgdmFyIHdhaXQsIGFyZ3MsIGNvbnRleHQ7XG4gICAgcmV0dXJuIGZ1bmN0aW9uICgpIHtcbiAgICAgIGlmICh3YWl0KSByZXR1cm47XG4gICAgICB3YWl0ID0gdHJ1ZTtcbiAgICAgIGFyZ3MgPSBhcmd1bWVudHM7XG4gICAgICBjb250ZXh0ID0gdGhpcztcbiAgICAgIHRyYW0uZnJhbWUoZnVuY3Rpb24gKCkge1xuICAgICAgICB3YWl0ID0gZmFsc2U7XG4gICAgICAgIGZ1bmMuYXBwbHkoY29udGV4dCwgYXJncyk7XG4gICAgICB9KTtcbiAgICB9O1xuICB9O1xuXG4gIC8vIFJldHVybnMgYSBmdW5jdGlvbiwgdGhhdCwgYXMgbG9uZyBhcyBpdCBjb250aW51ZXMgdG8gYmUgaW52b2tlZCwgd2lsbCBub3RcbiAgLy8gYmUgdHJpZ2dlcmVkLiBUaGUgZnVuY3Rpb24gd2lsbCBiZSBjYWxsZWQgYWZ0ZXIgaXQgc3RvcHMgYmVpbmcgY2FsbGVkIGZvclxuICAvLyBOIG1pbGxpc2Vjb25kcy4gSWYgYGltbWVkaWF0ZWAgaXMgcGFzc2VkLCB0cmlnZ2VyIHRoZSBmdW5jdGlvbiBvbiB0aGVcbiAgLy8gbGVhZGluZyBlZGdlLCBpbnN0ZWFkIG9mIHRoZSB0cmFpbGluZy5cbiAgXy5kZWJvdW5jZSA9IGZ1bmN0aW9uIChmdW5jLCB3YWl0LCBpbW1lZGlhdGUpIHtcbiAgICAvLyBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgb25lLXZhclxuICAgIHZhciB0aW1lb3V0LCBhcmdzLCBjb250ZXh0LCB0aW1lc3RhbXAsIHJlc3VsdDtcblxuICAgIHZhciBsYXRlciA9IGZ1bmN0aW9uICgpIHtcbiAgICAgIHZhciBsYXN0ID0gXy5ub3coKSAtIHRpbWVzdGFtcDtcbiAgICAgIGlmIChsYXN0IDwgd2FpdCkge1xuICAgICAgICB0aW1lb3V0ID0gc2V0VGltZW91dChsYXRlciwgd2FpdCAtIGxhc3QpO1xuICAgICAgfSBlbHNlIHtcbiAgICAgICAgdGltZW91dCA9IG51bGw7XG4gICAgICAgIGlmICghaW1tZWRpYXRlKSB7XG4gICAgICAgICAgcmVzdWx0ID0gZnVuYy5hcHBseShjb250ZXh0LCBhcmdzKTtcbiAgICAgICAgICBjb250ZXh0ID0gYXJncyA9IG51bGw7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9O1xuXG4gICAgcmV0dXJuIGZ1bmN0aW9uICgpIHtcbiAgICAgIGNvbnRleHQgPSB0aGlzO1xuICAgICAgYXJncyA9IGFyZ3VtZW50cztcbiAgICAgIHRpbWVzdGFtcCA9IF8ubm93KCk7XG4gICAgICB2YXIgY2FsbE5vdyA9IGltbWVkaWF0ZSAmJiAhdGltZW91dDtcbiAgICAgIGlmICghdGltZW91dCkge1xuICAgICAgICB0aW1lb3V0ID0gc2V0VGltZW91dChsYXRlciwgd2FpdCk7XG4gICAgICB9XG4gICAgICBpZiAoY2FsbE5vdykge1xuICAgICAgICByZXN1bHQgPSBmdW5jLmFwcGx5KGNvbnRleHQsIGFyZ3MpO1xuICAgICAgICBjb250ZXh0ID0gYXJncyA9IG51bGw7XG4gICAgICB9XG5cbiAgICAgIHJldHVybiByZXN1bHQ7XG4gICAgfTtcbiAgfTtcblxuICAvLyBPYmplY3QgRnVuY3Rpb25zXG4gIC8vIC0tLS0tLS0tLS0tLS0tLS1cblxuICAvLyBGaWxsIGluIGEgZ2l2ZW4gb2JqZWN0IHdpdGggZGVmYXVsdCBwcm9wZXJ0aWVzLlxuICBfLmRlZmF1bHRzID0gZnVuY3Rpb24gKG9iaikge1xuICAgIGlmICghXy5pc09iamVjdChvYmopKSByZXR1cm4gb2JqO1xuICAgIGZvciAodmFyIGkgPSAxLCBsZW5ndGggPSBhcmd1bWVudHMubGVuZ3RoOyBpIDwgbGVuZ3RoOyBpKyspIHtcbiAgICAgIHZhciBzb3VyY2UgPSBhcmd1bWVudHNbaV07XG4gICAgICBmb3IgKHZhciBwcm9wIGluIHNvdXJjZSkge1xuICAgICAgICAvLyBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgbm8tdm9pZFxuICAgICAgICBpZiAob2JqW3Byb3BdID09PSB2b2lkIDApIG9ialtwcm9wXSA9IHNvdXJjZVtwcm9wXTtcbiAgICAgIH1cbiAgICB9XG4gICAgcmV0dXJuIG9iajtcbiAgfTtcblxuICAvLyBSZXRyaWV2ZSB0aGUgbmFtZXMgb2YgYW4gb2JqZWN0J3MgcHJvcGVydGllcy5cbiAgLy8gRGVsZWdhdGVzIHRvICoqRUNNQVNjcmlwdCA1KioncyBuYXRpdmUgYE9iamVjdC5rZXlzYFxuICBfLmtleXMgPSBmdW5jdGlvbiAob2JqKSB7XG4gICAgaWYgKCFfLmlzT2JqZWN0KG9iaikpIHJldHVybiBbXTtcbiAgICBpZiAobmF0aXZlS2V5cykgcmV0dXJuIG5hdGl2ZUtleXMob2JqKTtcbiAgICB2YXIga2V5cyA9IFtdO1xuICAgIGZvciAodmFyIGtleSBpbiBvYmopIGlmIChfLmhhcyhvYmosIGtleSkpIGtleXMucHVzaChrZXkpO1xuICAgIHJldHVybiBrZXlzO1xuICB9O1xuXG4gIC8vIFNob3J0Y3V0IGZ1bmN0aW9uIGZvciBjaGVja2luZyBpZiBhbiBvYmplY3QgaGFzIGEgZ2l2ZW4gcHJvcGVydHkgZGlyZWN0bHlcbiAgLy8gb24gaXRzZWxmIChpbiBvdGhlciB3b3Jkcywgbm90IG9uIGEgcHJvdG90eXBlKS5cbiAgXy5oYXMgPSBmdW5jdGlvbiAob2JqLCBrZXkpIHtcbiAgICByZXR1cm4gaGFzT3duUHJvcGVydHkuY2FsbChvYmosIGtleSk7XG4gIH07XG5cbiAgLy8gSXMgYSBnaXZlbiB2YXJpYWJsZSBhbiBvYmplY3Q/XG4gIF8uaXNPYmplY3QgPSBmdW5jdGlvbiAob2JqKSB7XG4gICAgcmV0dXJuIG9iaiA9PT0gT2JqZWN0KG9iaik7XG4gIH07XG5cbiAgLy8gVXRpbGl0eSBGdW5jdGlvbnNcbiAgLy8gLS0tLS0tLS0tLS0tLS0tLS1cblxuICAvLyBBIChwb3NzaWJseSBmYXN0ZXIpIHdheSB0byBnZXQgdGhlIGN1cnJlbnQgdGltZXN0YW1wIGFzIGFuIGludGVnZXIuXG4gIF8ubm93ID1cbiAgICBEYXRlLm5vdyB8fFxuICAgIGZ1bmN0aW9uICgpIHtcbiAgICAgIHJldHVybiBuZXcgRGF0ZSgpLmdldFRpbWUoKTtcbiAgICB9O1xuXG4gIC8vIEJ5IGRlZmF1bHQsIFVuZGVyc2NvcmUgdXNlcyBFUkItc3R5bGUgdGVtcGxhdGUgZGVsaW1pdGVycywgY2hhbmdlIHRoZVxuICAvLyBmb2xsb3dpbmcgdGVtcGxhdGUgc2V0dGluZ3MgdG8gdXNlIGFsdGVybmF0aXZlIGRlbGltaXRlcnMuXG4gIF8udGVtcGxhdGVTZXR0aW5ncyA9IHtcbiAgICBldmFsdWF0ZTogLzwlKFtcXHNcXFNdKz8pJT4vZyxcbiAgICBpbnRlcnBvbGF0ZTogLzwlPShbXFxzXFxTXSs/KSU+L2csXG4gICAgZXNjYXBlOiAvPCUtKFtcXHNcXFNdKz8pJT4vZyxcbiAgfTtcblxuICAvLyBXaGVuIGN1c3RvbWl6aW5nIGB0ZW1wbGF0ZVNldHRpbmdzYCwgaWYgeW91IGRvbid0IHdhbnQgdG8gZGVmaW5lIGFuXG4gIC8vIGludGVycG9sYXRpb24sIGV2YWx1YXRpb24gb3IgZXNjYXBpbmcgcmVnZXgsIHdlIG5lZWQgb25lIHRoYXQgaXNcbiAgLy8gZ3VhcmFudGVlZCBub3QgdG8gbWF0Y2guXG4gIHZhciBub01hdGNoID0gLyguKV4vO1xuXG4gIC8vIENlcnRhaW4gY2hhcmFjdGVycyBuZWVkIHRvIGJlIGVzY2FwZWQgc28gdGhhdCB0aGV5IGNhbiBiZSBwdXQgaW50byBhXG4gIC8vIHN0cmluZyBsaXRlcmFsLlxuICB2YXIgZXNjYXBlcyA9IHtcbiAgICBcIidcIjogXCInXCIsXG4gICAgJ1xcXFwnOiAnXFxcXCcsXG4gICAgJ1xccic6ICdyJyxcbiAgICAnXFxuJzogJ24nLFxuICAgICdcXHUyMDI4JzogJ3UyMDI4JyxcbiAgICAnXFx1MjAyOSc6ICd1MjAyOScsXG4gIH07XG5cbiAgdmFyIGVzY2FwZVJlZ0V4cCA9IC9cXFxcfCd8XFxyfFxcbnxcXHUyMDI4fFxcdTIwMjkvZztcblxuICB2YXIgZXNjYXBlQ2hhciA9IGZ1bmN0aW9uIChtYXRjaCkge1xuICAgIHJldHVybiAnXFxcXCcgKyBlc2NhcGVzW21hdGNoXTtcbiAgfTtcblxuICAvLyBJbiBvcmRlciB0byBwcmV2ZW50IHRoaXJkLXBhcnR5IGNvZGUgaW5qZWN0aW9uIHRocm91Z2hcbiAgLy8gYF8udGVtcGxhdGVTZXR0aW5ncy52YXJpYWJsZWAsIHdlIHRlc3QgaXQgYWdhaW5zdCB0aGUgZm9sbG93aW5nIHJlZ3VsYXJcbiAgLy8gZXhwcmVzc2lvbi4gSXQgaXMgaW50ZW50aW9uYWxseSBhIGJpdCBtb3JlIGxpYmVyYWwgdGhhbiBqdXN0IG1hdGNoaW5nIHZhbGlkXG4gIC8vIGlkZW50aWZpZXJzLCBidXQgc3RpbGwgcHJldmVudHMgcG9zc2libGUgbG9vcGhvbGVzIHRocm91Z2ggZGVmYXVsdHMgb3JcbiAgLy8gZGVzdHJ1Y3R1cmluZyBhc3NpZ25tZW50LlxuICB2YXIgYmFyZUlkZW50aWZpZXIgPSAvXlxccyooXFx3fFxcJCkrXFxzKiQvO1xuXG4gIC8vIEphdmFTY3JpcHQgbWljcm8tdGVtcGxhdGluZywgc2ltaWxhciB0byBKb2huIFJlc2lnJ3MgaW1wbGVtZW50YXRpb24uXG4gIC8vIFVuZGVyc2NvcmUgdGVtcGxhdGluZyBoYW5kbGVzIGFyYml0cmFyeSBkZWxpbWl0ZXJzLCBwcmVzZXJ2ZXMgd2hpdGVzcGFjZSxcbiAgLy8gYW5kIGNvcnJlY3RseSBlc2NhcGVzIHF1b3RlcyB3aXRoaW4gaW50ZXJwb2xhdGVkIGNvZGUuXG4gIC8vIE5COiBgb2xkU2V0dGluZ3NgIG9ubHkgZXhpc3RzIGZvciBiYWNrd2FyZHMgY29tcGF0aWJpbGl0eS5cbiAgXy50ZW1wbGF0ZSA9IGZ1bmN0aW9uICh0ZXh0LCBzZXR0aW5ncywgb2xkU2V0dGluZ3MpIHtcbiAgICBpZiAoIXNldHRpbmdzICYmIG9sZFNldHRpbmdzKSBzZXR0aW5ncyA9IG9sZFNldHRpbmdzO1xuICAgIHNldHRpbmdzID0gXy5kZWZhdWx0cyh7fSwgc2V0dGluZ3MsIF8udGVtcGxhdGVTZXR0aW5ncyk7XG5cbiAgICAvLyBDb21iaW5lIGRlbGltaXRlcnMgaW50byBvbmUgcmVndWxhciBleHByZXNzaW9uIHZpYSBhbHRlcm5hdGlvbi5cbiAgICB2YXIgbWF0Y2hlciA9IFJlZ0V4cChcbiAgICAgIFtcbiAgICAgICAgKHNldHRpbmdzLmVzY2FwZSB8fCBub01hdGNoKS5zb3VyY2UsXG4gICAgICAgIChzZXR0aW5ncy5pbnRlcnBvbGF0ZSB8fCBub01hdGNoKS5zb3VyY2UsXG4gICAgICAgIChzZXR0aW5ncy5ldmFsdWF0ZSB8fCBub01hdGNoKS5zb3VyY2UsXG4gICAgICBdLmpvaW4oJ3wnKSArICd8JCcsXG4gICAgICAnZydcbiAgICApO1xuXG4gICAgLy8gQ29tcGlsZSB0aGUgdGVtcGxhdGUgc291cmNlLCBlc2NhcGluZyBzdHJpbmcgbGl0ZXJhbHMgYXBwcm9wcmlhdGVseS5cbiAgICB2YXIgaW5kZXggPSAwO1xuICAgIHZhciBzb3VyY2UgPSBcIl9fcCs9J1wiO1xuICAgIHRleHQucmVwbGFjZShcbiAgICAgIG1hdGNoZXIsXG4gICAgICBmdW5jdGlvbiAobWF0Y2gsIGVzY2FwZSwgaW50ZXJwb2xhdGUsIGV2YWx1YXRlLCBvZmZzZXQpIHtcbiAgICAgICAgc291cmNlICs9IHRleHQuc2xpY2UoaW5kZXgsIG9mZnNldCkucmVwbGFjZShlc2NhcGVSZWdFeHAsIGVzY2FwZUNoYXIpO1xuICAgICAgICBpbmRleCA9IG9mZnNldCArIG1hdGNoLmxlbmd0aDtcblxuICAgICAgICBpZiAoZXNjYXBlKSB7XG4gICAgICAgICAgc291cmNlICs9IFwiJytcXG4oKF9fdD0oXCIgKyBlc2NhcGUgKyBcIikpPT1udWxsPycnOl8uZXNjYXBlKF9fdCkpK1xcbidcIjtcbiAgICAgICAgfSBlbHNlIGlmIChpbnRlcnBvbGF0ZSkge1xuICAgICAgICAgIHNvdXJjZSArPSBcIicrXFxuKChfX3Q9KFwiICsgaW50ZXJwb2xhdGUgKyBcIikpPT1udWxsPycnOl9fdCkrXFxuJ1wiO1xuICAgICAgICB9IGVsc2UgaWYgKGV2YWx1YXRlKSB7XG4gICAgICAgICAgc291cmNlICs9IFwiJztcXG5cIiArIGV2YWx1YXRlICsgXCJcXG5fX3ArPSdcIjtcbiAgICAgICAgfVxuXG4gICAgICAgIC8vIEFkb2JlIFZNcyBuZWVkIHRoZSBtYXRjaCByZXR1cm5lZCB0byBwcm9kdWNlIHRoZSBjb3JyZWN0IG9mZnNldC5cbiAgICAgICAgcmV0dXJuIG1hdGNoO1xuICAgICAgfVxuICAgICk7XG4gICAgc291cmNlICs9IFwiJztcXG5cIjtcblxuICAgIHZhciBhcmd1bWVudCA9IHNldHRpbmdzLnZhcmlhYmxlO1xuICAgIGlmIChhcmd1bWVudCkge1xuICAgICAgLy8gSW5zdXJlIGFnYWluc3QgdGhpcmQtcGFydHkgY29kZSBpbmplY3Rpb24uIChDVkUtMjAyMS0yMzM1OClcbiAgICAgIGlmICghYmFyZUlkZW50aWZpZXIudGVzdChhcmd1bWVudCkpXG4gICAgICAgIHRocm93IG5ldyBFcnJvcigndmFyaWFibGUgaXMgbm90IGEgYmFyZSBpZGVudGlmaWVyOiAnICsgYXJndW1lbnQpO1xuICAgIH0gZWxzZSB7XG4gICAgICAvLyBJZiBhIHZhcmlhYmxlIGlzIG5vdCBzcGVjaWZpZWQsIHBsYWNlIGRhdGEgdmFsdWVzIGluIGxvY2FsIHNjb3BlLlxuICAgICAgc291cmNlID0gJ3dpdGgob2JqfHx7fSl7XFxuJyArIHNvdXJjZSArICd9XFxuJztcbiAgICAgIGFyZ3VtZW50ID0gJ29iaic7XG4gICAgfVxuXG4gICAgc291cmNlID1cbiAgICAgIFwidmFyIF9fdCxfX3A9JycsX19qPUFycmF5LnByb3RvdHlwZS5qb2luLFwiICtcbiAgICAgIFwicHJpbnQ9ZnVuY3Rpb24oKXtfX3ArPV9fai5jYWxsKGFyZ3VtZW50cywnJyk7fTtcXG5cIiArXG4gICAgICBzb3VyY2UgK1xuICAgICAgJ3JldHVybiBfX3A7XFxuJztcblxuICAgIHZhciByZW5kZXI7XG4gICAgdHJ5IHtcbiAgICAgIC8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSBuby1uZXctZnVuY1xuICAgICAgcmVuZGVyID0gbmV3IEZ1bmN0aW9uKHNldHRpbmdzLnZhcmlhYmxlIHx8ICdvYmonLCAnXycsIHNvdXJjZSk7XG4gICAgfSBjYXRjaCAoZSkge1xuICAgICAgZS5zb3VyY2UgPSBzb3VyY2U7XG4gICAgICB0aHJvdyBlO1xuICAgIH1cblxuICAgIHZhciB0ZW1wbGF0ZSA9IGZ1bmN0aW9uIChkYXRhKSB7XG4gICAgICByZXR1cm4gcmVuZGVyLmNhbGwodGhpcywgZGF0YSwgXyk7XG4gICAgfTtcblxuICAgIC8vIFByb3ZpZGUgdGhlIGNvbXBpbGVkIHNvdXJjZSBhcyBhIGNvbnZlbmllbmNlIGZvciBwcmVjb21waWxhdGlvbi5cbiAgICB0ZW1wbGF0ZS5zb3VyY2UgPSAnZnVuY3Rpb24oJyArIGFyZ3VtZW50ICsgJyl7XFxuJyArIHNvdXJjZSArICd9JztcblxuICAgIHJldHVybiB0ZW1wbGF0ZTtcbiAgfTtcblxuICAvLyBFeHBvcnQgdW5kZXJzY29yZVxuICByZXR1cm4gXztcbn0pKCk7XG4iXSwibmFtZXMiOlsiJCIsIndpbmRvdyIsInRyYW0iLCJyZXF1aXJlIiwibW9kdWxlIiwiZXhwb3J0cyIsIl8iLCJWRVJTSU9OIiwiYnJlYWtlciIsIkFycmF5UHJvdG8iLCJBcnJheSIsInByb3RvdHlwZSIsIk9ialByb3RvIiwiT2JqZWN0IiwiRnVuY1Byb3RvIiwiRnVuY3Rpb24iLCJwdXNoIiwic2xpY2UiLCJjb25jYXQiLCJ0b1N0cmluZyIsImhhc093blByb3BlcnR5IiwibmF0aXZlRm9yRWFjaCIsImZvckVhY2giLCJuYXRpdmVNYXAiLCJtYXAiLCJuYXRpdmVSZWR1Y2UiLCJyZWR1Y2UiLCJuYXRpdmVSZWR1Y2VSaWdodCIsInJlZHVjZVJpZ2h0IiwibmF0aXZlRmlsdGVyIiwiZmlsdGVyIiwibmF0aXZlRXZlcnkiLCJldmVyeSIsIm5hdGl2ZVNvbWUiLCJzb21lIiwibmF0aXZlSW5kZXhPZiIsImluZGV4T2YiLCJuYXRpdmVMYXN0SW5kZXhPZiIsImxhc3RJbmRleE9mIiwibmF0aXZlSXNBcnJheSIsImlzQXJyYXkiLCJuYXRpdmVLZXlzIiwia2V5cyIsIm5hdGl2ZUJpbmQiLCJiaW5kIiwiZWFjaCIsIm9iaiIsIml0ZXJhdG9yIiwiY29udGV4dCIsImxlbmd0aCIsImkiLCJjYWxsIiwiY29sbGVjdCIsInJlc3VsdHMiLCJ2YWx1ZSIsImluZGV4IiwibGlzdCIsImZpbmQiLCJkZXRlY3QiLCJwcmVkaWNhdGUiLCJyZXN1bHQiLCJhbnkiLCJzZWxlY3QiLCJpZGVudGl0eSIsImNvbnRhaW5zIiwiaW5jbHVkZSIsInRhcmdldCIsImRlbGF5IiwiZnVuYyIsIndhaXQiLCJhcmdzIiwiYXJndW1lbnRzIiwic2V0VGltZW91dCIsImFwcGx5IiwiZGVmZXIiLCJ0aHJvdHRsZSIsImZyYW1lIiwiZGVib3VuY2UiLCJpbW1lZGlhdGUiLCJ0aW1lb3V0IiwidGltZXN0YW1wIiwibGF0ZXIiLCJsYXN0Iiwibm93IiwiY2FsbE5vdyIsImRlZmF1bHRzIiwiaXNPYmplY3QiLCJzb3VyY2UiLCJwcm9wIiwia2V5IiwiaGFzIiwiRGF0ZSIsImdldFRpbWUiLCJ0ZW1wbGF0ZVNldHRpbmdzIiwiZXZhbHVhdGUiLCJpbnRlcnBvbGF0ZSIsImVzY2FwZSIsIm5vTWF0Y2giLCJlc2NhcGVzIiwiZXNjYXBlUmVnRXhwIiwiZXNjYXBlQ2hhciIsIm1hdGNoIiwiYmFyZUlkZW50aWZpZXIiLCJ0ZW1wbGF0ZSIsInRleHQiLCJzZXR0aW5ncyIsIm9sZFNldHRpbmdzIiwibWF0Y2hlciIsIlJlZ0V4cCIsImpvaW4iLCJyZXBsYWNlIiwib2Zmc2V0IiwiYXJndW1lbnQiLCJ2YXJpYWJsZSIsInRlc3QiLCJFcnJvciIsInJlbmRlciIsImUiLCJkYXRhIl0sIm1hcHBpbmdzIjoiQUFBQSxvQ0FBb0M7QUFDcEMsa0JBQWtCO0FBRWxCLElBQUlBLElBQUlDLE9BQU9ELENBQUM7QUFDaEIsSUFBSUUsT0FBT0MsUUFBUSxpQkFBaUJILEVBQUVFLElBQUk7QUFFMUM7Ozs7Ozs7Q0FPQyxHQUNEOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FrQkMsR0FDREUsT0FBT0MsT0FBTyxHQUFHLEFBQUM7SUFDaEIsSUFBSUMsSUFBSSxDQUFDO0lBRVQsbUJBQW1CO0lBQ25CQSxFQUFFQyxPQUFPLEdBQUc7SUFFWiw0RUFBNEU7SUFDNUUsSUFBSUMsVUFBVSxDQUFDO0lBRWYsd0RBQXdEO0lBQ3hELDBCQUEwQixHQUMxQixJQUFJQyxhQUFhQyxNQUFNQyxTQUFTLEVBQzlCQyxXQUFXQyxPQUFPRixTQUFTLEVBQzNCRyxZQUFZQyxTQUFTSixTQUFTO0lBQ2hDLHlCQUF5QixHQUV6Qix3RUFBd0U7SUFDeEUseURBQXlELEdBQ3pELElBQUlLLE9BQU9QLFdBQVdPLElBQUksRUFDeEJDLFFBQVFSLFdBQVdRLEtBQUssRUFDeEJDLFNBQVNULFdBQVdTLE1BQU0sRUFDMUJDLFdBQVdQLFNBQVNPLFFBQVEsRUFDNUJDLGlCQUFpQlIsU0FBU1EsY0FBYztJQUMxQyx3REFBd0QsR0FFeEQsMkVBQTJFO0lBQzNFLHFCQUFxQjtJQUNyQix5REFBeUQsR0FDekQsSUFBSUMsZ0JBQWdCWixXQUFXYSxPQUFPLEVBQ3BDQyxZQUFZZCxXQUFXZSxHQUFHLEVBQzFCQyxlQUFlaEIsV0FBV2lCLE1BQU0sRUFDaENDLG9CQUFvQmxCLFdBQVdtQixXQUFXLEVBQzFDQyxlQUFlcEIsV0FBV3FCLE1BQU0sRUFDaENDLGNBQWN0QixXQUFXdUIsS0FBSyxFQUM5QkMsYUFBYXhCLFdBQVd5QixJQUFJLEVBQzVCQyxnQkFBZ0IxQixXQUFXMkIsT0FBTyxFQUNsQ0Msb0JBQW9CNUIsV0FBVzZCLFdBQVcsRUFDMUNDLGdCQUFnQjdCLE1BQU04QixPQUFPLEVBQzdCQyxhQUFhNUIsT0FBTzZCLElBQUksRUFDeEJDLGFBQWE3QixVQUFVOEIsSUFBSTtJQUM3Qix3REFBd0QsR0FFeEQsdUJBQXVCO0lBQ3ZCLHVCQUF1QjtJQUV2Qiw0REFBNEQ7SUFDNUQsd0VBQXdFO0lBQ3hFLGlFQUFpRTtJQUNqRSxJQUFJQyxPQUNEdkMsRUFBRXVDLElBQUksR0FDUHZDLEVBQUVnQixPQUFPLEdBQ1AsU0FBVXdCLEdBQUcsRUFBRUMsUUFBUSxFQUFFQyxPQUFPO1FBQzlCLHNCQUFzQixHQUN0QixJQUFJRixPQUFPLE1BQU0sT0FBT0E7UUFDeEIsSUFBSXpCLGlCQUFpQnlCLElBQUl4QixPQUFPLEtBQUtELGVBQWU7WUFDbER5QixJQUFJeEIsT0FBTyxDQUFDeUIsVUFBVUM7UUFDdEIsZ0RBQWdEO1FBQ2xELE9BQU8sSUFBSUYsSUFBSUcsTUFBTSxLQUFLLENBQUNILElBQUlHLE1BQU0sRUFBRTtZQUNyQyxJQUFLLElBQUlDLElBQUksR0FBR0QsU0FBU0gsSUFBSUcsTUFBTSxFQUFFQyxJQUFJRCxRQUFRQyxJQUFLO2dCQUNwRCxJQUFJSCxTQUFTSSxJQUFJLENBQUNILFNBQVNGLEdBQUcsQ0FBQ0ksRUFBRSxFQUFFQSxHQUFHSixTQUFTdEMsU0FBUztZQUMxRDtRQUNGLE9BQU87WUFDTCxJQUFJa0MsT0FBT3BDLEVBQUVvQyxJQUFJLENBQUNJO1lBQ2xCLHdDQUF3QztZQUN4QyxJQUFLLElBQUlJLElBQUksR0FBR0QsU0FBU1AsS0FBS08sTUFBTSxFQUFFQyxJQUFJRCxRQUFRQyxJQUFLO2dCQUNyRCxJQUFJSCxTQUFTSSxJQUFJLENBQUNILFNBQVNGLEdBQUcsQ0FBQ0osSUFBSSxDQUFDUSxFQUFFLENBQUMsRUFBRVIsSUFBSSxDQUFDUSxFQUFFLEVBQUVKLFNBQVN0QyxTQUN6RDtZQUNKO1FBQ0Y7UUFDQSxPQUFPc0M7SUFDVDtJQUVKLCtEQUErRDtJQUMvRCw2REFBNkQ7SUFDN0R4QyxFQUFFa0IsR0FBRyxHQUFHbEIsRUFBRThDLE9BQU8sR0FBRyxTQUFVTixHQUFHLEVBQUVDLFFBQVEsRUFBRUMsT0FBTztRQUNsRCxJQUFJSyxVQUFVLEVBQUU7UUFDaEIsSUFBSVAsT0FBTyxNQUFNLE9BQU9PO1FBQ3hCLElBQUk5QixhQUFhdUIsSUFBSXRCLEdBQUcsS0FBS0QsV0FBVyxPQUFPdUIsSUFBSXRCLEdBQUcsQ0FBQ3VCLFVBQVVDO1FBQ2pFSCxLQUFLQyxLQUFLLFNBQVVRLEtBQUssRUFBRUMsS0FBSyxFQUFFQyxJQUFJO1lBQ3BDSCxRQUFRckMsSUFBSSxDQUFDK0IsU0FBU0ksSUFBSSxDQUFDSCxTQUFTTSxPQUFPQyxPQUFPQztRQUNwRDtRQUNBLE9BQU9IO0lBQ1Q7SUFFQSx5RUFBeUU7SUFDekUvQyxFQUFFbUQsSUFBSSxHQUFHbkQsRUFBRW9ELE1BQU0sR0FBRyxTQUFVWixHQUFHLEVBQUVhLFNBQVMsRUFBRVgsT0FBTztRQUNuRCxJQUFJWTtRQUNKQyxJQUFJZixLQUFLLFNBQVVRLEtBQUssRUFBRUMsS0FBSyxFQUFFQyxJQUFJO1lBQ25DLElBQUlHLFVBQVVSLElBQUksQ0FBQ0gsU0FBU00sT0FBT0MsT0FBT0MsT0FBTztnQkFDL0NJLFNBQVNOO2dCQUNULE9BQU87WUFDVDtRQUNGO1FBQ0EsT0FBT007SUFDVDtJQUVBLGtEQUFrRDtJQUNsRCxnRUFBZ0U7SUFDaEUsdUJBQXVCO0lBQ3ZCdEQsRUFBRXdCLE1BQU0sR0FBR3hCLEVBQUV3RCxNQUFNLEdBQUcsU0FBVWhCLEdBQUcsRUFBRWEsU0FBUyxFQUFFWCxPQUFPO1FBQ3JELElBQUlLLFVBQVUsRUFBRTtRQUNoQixJQUFJUCxPQUFPLE1BQU0sT0FBT087UUFDeEIsSUFBSXhCLGdCQUFnQmlCLElBQUloQixNQUFNLEtBQUtELGNBQ2pDLE9BQU9pQixJQUFJaEIsTUFBTSxDQUFDNkIsV0FBV1g7UUFDL0JILEtBQUtDLEtBQUssU0FBVVEsS0FBSyxFQUFFQyxLQUFLLEVBQUVDLElBQUk7WUFDcEMsSUFBSUcsVUFBVVIsSUFBSSxDQUFDSCxTQUFTTSxPQUFPQyxPQUFPQyxPQUFPSCxRQUFRckMsSUFBSSxDQUFDc0M7UUFDaEU7UUFDQSxPQUFPRDtJQUNUO0lBRUEsd0VBQXdFO0lBQ3hFLDhEQUE4RDtJQUM5RCxvQkFBb0I7SUFDcEIsSUFBSVEsTUFDRHZELEVBQUU0QixJQUFJLEdBQ1A1QixFQUFFdUQsR0FBRyxHQUNILFNBQVVmLEdBQUcsRUFBRWEsU0FBUyxFQUFFWCxPQUFPO1FBQy9CVyxhQUFjQSxDQUFBQSxZQUFZckQsRUFBRXlELFFBQVEsQUFBRDtRQUNuQyxJQUFJSCxTQUFTO1FBQ2IsSUFBSWQsT0FBTyxNQUFNLE9BQU9jO1FBQ3hCLElBQUkzQixjQUFjYSxJQUFJWixJQUFJLEtBQUtELFlBQzdCLE9BQU9hLElBQUlaLElBQUksQ0FBQ3lCLFdBQVdYO1FBQzdCSCxLQUFLQyxLQUFLLFNBQVVRLEtBQUssRUFBRUMsS0FBSyxFQUFFQyxJQUFJO1lBQ3BDLElBQUlJLFVBQVdBLENBQUFBLFNBQVNELFVBQVVSLElBQUksQ0FBQ0gsU0FBU00sT0FBT0MsT0FBT0MsS0FBSSxHQUNoRSxPQUFPaEQ7UUFDWDtRQUNBLE9BQU8sQ0FBQyxDQUFDb0QsUUFBUSwyQ0FBMkM7SUFDOUQ7SUFFSix5RUFBeUU7SUFDekUsd0JBQXdCO0lBQ3hCdEQsRUFBRTBELFFBQVEsR0FBRzFELEVBQUUyRCxPQUFPLEdBQUcsU0FBVW5CLEdBQUcsRUFBRW9CLE1BQU07UUFDNUMsSUFBSXBCLE9BQU8sTUFBTSxPQUFPO1FBQ3hCLElBQUlYLGlCQUFpQlcsSUFBSVYsT0FBTyxLQUFLRCxlQUNuQyxrQ0FBa0M7UUFDbEMsT0FBT1csSUFBSVYsT0FBTyxDQUFDOEIsV0FBVyxDQUFDO1FBQ2pDLE9BQU9MLElBQUlmLEtBQUssU0FBVVEsS0FBSztZQUM3QixPQUFPQSxVQUFVWTtRQUNuQjtJQUNGO0lBRUEsNEJBQTRCO0lBQzVCLHVCQUF1QjtJQUV2Qix5RUFBeUU7SUFDekUsa0NBQWtDO0lBQ2xDNUQsRUFBRTZELEtBQUssR0FBRyxTQUFVQyxJQUFJLEVBQUVDLElBQUk7UUFDNUIsSUFBSUMsT0FBT3JELE1BQU1rQyxJQUFJLENBQUNvQixXQUFXO1FBQ2pDLE9BQU9DLFdBQVc7WUFDaEIsT0FBT0osS0FBS0ssS0FBSyxDQUFDLE1BQU1IO1FBQzFCLEdBQUdEO0lBQ0w7SUFFQSwyRUFBMkU7SUFDM0UsV0FBVztJQUNYL0QsRUFBRW9FLEtBQUssR0FBRyxTQUFVTixJQUFJO1FBQ3RCLE9BQU85RCxFQUFFNkQsS0FBSyxDQUFDTSxLQUFLLENBQUNuRSxHQUFHO1lBQUM4RDtZQUFNO1NBQUUsQ0FBQ2xELE1BQU0sQ0FBQ0QsTUFBTWtDLElBQUksQ0FBQ29CLFdBQVc7SUFDakU7SUFFQSw0RUFBNEU7SUFDNUUseUVBQXlFO0lBQ3pFakUsRUFBRXFFLFFBQVEsR0FBRyxTQUFVUCxJQUFJO1FBQ3pCLG1DQUFtQztRQUNuQyxJQUFJQyxNQUFNQyxNQUFNdEI7UUFDaEIsT0FBTztZQUNMLElBQUlxQixNQUFNO1lBQ1ZBLE9BQU87WUFDUEMsT0FBT0M7WUFDUHZCLFVBQVUsSUFBSTtZQUNkOUMsS0FBSzBFLEtBQUssQ0FBQztnQkFDVFAsT0FBTztnQkFDUEQsS0FBS0ssS0FBSyxDQUFDekIsU0FBU3NCO1lBQ3RCO1FBQ0Y7SUFDRjtJQUVBLDRFQUE0RTtJQUM1RSw0RUFBNEU7SUFDNUUsd0VBQXdFO0lBQ3hFLHlDQUF5QztJQUN6Q2hFLEVBQUV1RSxRQUFRLEdBQUcsU0FBVVQsSUFBSSxFQUFFQyxJQUFJLEVBQUVTLFNBQVM7UUFDMUMsbUNBQW1DO1FBQ25DLElBQUlDLFNBQVNULE1BQU10QixTQUFTZ0MsV0FBV3BCO1FBRXZDLElBQUlxQixRQUFRO1lBQ1YsSUFBSUMsT0FBTzVFLEVBQUU2RSxHQUFHLEtBQUtIO1lBQ3JCLElBQUlFLE9BQU9iLE1BQU07Z0JBQ2ZVLFVBQVVQLFdBQVdTLE9BQU9aLE9BQU9hO1lBQ3JDLE9BQU87Z0JBQ0xILFVBQVU7Z0JBQ1YsSUFBSSxDQUFDRCxXQUFXO29CQUNkbEIsU0FBU1EsS0FBS0ssS0FBSyxDQUFDekIsU0FBU3NCO29CQUM3QnRCLFVBQVVzQixPQUFPO2dCQUNuQjtZQUNGO1FBQ0Y7UUFFQSxPQUFPO1lBQ0x0QixVQUFVLElBQUk7WUFDZHNCLE9BQU9DO1lBQ1BTLFlBQVkxRSxFQUFFNkUsR0FBRztZQUNqQixJQUFJQyxVQUFVTixhQUFhLENBQUNDO1lBQzVCLElBQUksQ0FBQ0EsU0FBUztnQkFDWkEsVUFBVVAsV0FBV1MsT0FBT1o7WUFDOUI7WUFDQSxJQUFJZSxTQUFTO2dCQUNYeEIsU0FBU1EsS0FBS0ssS0FBSyxDQUFDekIsU0FBU3NCO2dCQUM3QnRCLFVBQVVzQixPQUFPO1lBQ25CO1lBRUEsT0FBT1Y7UUFDVDtJQUNGO0lBRUEsbUJBQW1CO0lBQ25CLG1CQUFtQjtJQUVuQixrREFBa0Q7SUFDbER0RCxFQUFFK0UsUUFBUSxHQUFHLFNBQVV2QyxHQUFHO1FBQ3hCLElBQUksQ0FBQ3hDLEVBQUVnRixRQUFRLENBQUN4QyxNQUFNLE9BQU9BO1FBQzdCLElBQUssSUFBSUksSUFBSSxHQUFHRCxTQUFTc0IsVUFBVXRCLE1BQU0sRUFBRUMsSUFBSUQsUUFBUUMsSUFBSztZQUMxRCxJQUFJcUMsU0FBU2hCLFNBQVMsQ0FBQ3JCLEVBQUU7WUFDekIsSUFBSyxJQUFJc0MsUUFBUUQsT0FBUTtnQkFDdkIsbUNBQW1DO2dCQUNuQyxJQUFJekMsR0FBRyxDQUFDMEMsS0FBSyxLQUFLLEtBQUssR0FBRzFDLEdBQUcsQ0FBQzBDLEtBQUssR0FBR0QsTUFBTSxDQUFDQyxLQUFLO1lBQ3BEO1FBQ0Y7UUFDQSxPQUFPMUM7SUFDVDtJQUVBLGdEQUFnRDtJQUNoRCx1REFBdUQ7SUFDdkR4QyxFQUFFb0MsSUFBSSxHQUFHLFNBQVVJLEdBQUc7UUFDcEIsSUFBSSxDQUFDeEMsRUFBRWdGLFFBQVEsQ0FBQ3hDLE1BQU0sT0FBTyxFQUFFO1FBQy9CLElBQUlMLFlBQVksT0FBT0EsV0FBV0s7UUFDbEMsSUFBSUosT0FBTyxFQUFFO1FBQ2IsSUFBSyxJQUFJK0MsT0FBTzNDLElBQUssSUFBSXhDLEVBQUVvRixHQUFHLENBQUM1QyxLQUFLMkMsTUFBTS9DLEtBQUsxQixJQUFJLENBQUN5RTtRQUNwRCxPQUFPL0M7SUFDVDtJQUVBLDRFQUE0RTtJQUM1RSxrREFBa0Q7SUFDbERwQyxFQUFFb0YsR0FBRyxHQUFHLFNBQVU1QyxHQUFHLEVBQUUyQyxHQUFHO1FBQ3hCLE9BQU9yRSxlQUFlK0IsSUFBSSxDQUFDTCxLQUFLMkM7SUFDbEM7SUFFQSxpQ0FBaUM7SUFDakNuRixFQUFFZ0YsUUFBUSxHQUFHLFNBQVV4QyxHQUFHO1FBQ3hCLE9BQU9BLFFBQVFqQyxPQUFPaUM7SUFDeEI7SUFFQSxvQkFBb0I7SUFDcEIsb0JBQW9CO0lBRXBCLHNFQUFzRTtJQUN0RXhDLEVBQUU2RSxHQUFHLEdBQ0hRLEtBQUtSLEdBQUcsSUFDUjtRQUNFLE9BQU8sSUFBSVEsT0FBT0MsT0FBTztJQUMzQjtJQUVGLHdFQUF3RTtJQUN4RSw2REFBNkQ7SUFDN0R0RixFQUFFdUYsZ0JBQWdCLEdBQUc7UUFDbkJDLFVBQVU7UUFDVkMsYUFBYTtRQUNiQyxRQUFRO0lBQ1Y7SUFFQSxzRUFBc0U7SUFDdEUsbUVBQW1FO0lBQ25FLDJCQUEyQjtJQUMzQixJQUFJQyxVQUFVO0lBRWQsdUVBQXVFO0lBQ3ZFLGtCQUFrQjtJQUNsQixJQUFJQyxVQUFVO1FBQ1osS0FBSztRQUNMLE1BQU07UUFDTixNQUFNO1FBQ04sTUFBTTtRQUNOLFVBQVU7UUFDVixVQUFVO0lBQ1o7SUFFQSxJQUFJQyxlQUFlO0lBRW5CLElBQUlDLGFBQWEsU0FBVUMsS0FBSztRQUM5QixPQUFPLE9BQU9ILE9BQU8sQ0FBQ0csTUFBTTtJQUM5QjtJQUVBLHlEQUF5RDtJQUN6RCwwRUFBMEU7SUFDMUUsOEVBQThFO0lBQzlFLHlFQUF5RTtJQUN6RSw0QkFBNEI7SUFDNUIsSUFBSUMsaUJBQWlCO0lBRXJCLHVFQUF1RTtJQUN2RSw0RUFBNEU7SUFDNUUseURBQXlEO0lBQ3pELDZEQUE2RDtJQUM3RGhHLEVBQUVpRyxRQUFRLEdBQUcsU0FBVUMsSUFBSSxFQUFFQyxRQUFRLEVBQUVDLFdBQVc7UUFDaEQsSUFBSSxDQUFDRCxZQUFZQyxhQUFhRCxXQUFXQztRQUN6Q0QsV0FBV25HLEVBQUUrRSxRQUFRLENBQUMsQ0FBQyxHQUFHb0IsVUFBVW5HLEVBQUV1RixnQkFBZ0I7UUFFdEQsa0VBQWtFO1FBQ2xFLElBQUljLFVBQVVDLE9BQ1o7WUFDR0gsQ0FBQUEsU0FBU1QsTUFBTSxJQUFJQyxPQUFNLEVBQUdWLE1BQU07WUFDbENrQixDQUFBQSxTQUFTVixXQUFXLElBQUlFLE9BQU0sRUFBR1YsTUFBTTtZQUN2Q2tCLENBQUFBLFNBQVNYLFFBQVEsSUFBSUcsT0FBTSxFQUFHVixNQUFNO1NBQ3RDLENBQUNzQixJQUFJLENBQUMsT0FBTyxNQUNkO1FBR0YsdUVBQXVFO1FBQ3ZFLElBQUl0RCxRQUFRO1FBQ1osSUFBSWdDLFNBQVM7UUFDYmlCLEtBQUtNLE9BQU8sQ0FDVkgsU0FDQSxTQUFVTixLQUFLLEVBQUVMLE1BQU0sRUFBRUQsV0FBVyxFQUFFRCxRQUFRLEVBQUVpQixNQUFNO1lBQ3BEeEIsVUFBVWlCLEtBQUt2RixLQUFLLENBQUNzQyxPQUFPd0QsUUFBUUQsT0FBTyxDQUFDWCxjQUFjQztZQUMxRDdDLFFBQVF3RCxTQUFTVixNQUFNcEQsTUFBTTtZQUU3QixJQUFJK0MsUUFBUTtnQkFDVlQsVUFBVSxnQkFBZ0JTLFNBQVM7WUFDckMsT0FBTyxJQUFJRCxhQUFhO2dCQUN0QlIsVUFBVSxnQkFBZ0JRLGNBQWM7WUFDMUMsT0FBTyxJQUFJRCxVQUFVO2dCQUNuQlAsVUFBVSxTQUFTTyxXQUFXO1lBQ2hDO1lBRUEsbUVBQW1FO1lBQ25FLE9BQU9PO1FBQ1Q7UUFFRmQsVUFBVTtRQUVWLElBQUl5QixXQUFXUCxTQUFTUSxRQUFRO1FBQ2hDLElBQUlELFVBQVU7WUFDWiw4REFBOEQ7WUFDOUQsSUFBSSxDQUFDVixlQUFlWSxJQUFJLENBQUNGLFdBQ3ZCLE1BQU0sSUFBSUcsTUFBTSx3Q0FBd0NIO1FBQzVELE9BQU87WUFDTCxvRUFBb0U7WUFDcEV6QixTQUFTLHFCQUFxQkEsU0FBUztZQUN2Q3lCLFdBQVc7UUFDYjtRQUVBekIsU0FDRSw2Q0FDQSxzREFDQUEsU0FDQTtRQUVGLElBQUk2QjtRQUNKLElBQUk7WUFDRix1Q0FBdUM7WUFDdkNBLFNBQVMsSUFBSXJHLFNBQVMwRixTQUFTUSxRQUFRLElBQUksT0FBTyxLQUFLMUI7UUFDekQsRUFBRSxPQUFPOEIsR0FBRztZQUNWQSxFQUFFOUIsTUFBTSxHQUFHQTtZQUNYLE1BQU04QjtRQUNSO1FBRUEsSUFBSWQsV0FBVyxTQUFVZSxJQUFJO1lBQzNCLE9BQU9GLE9BQU9qRSxJQUFJLENBQUMsSUFBSSxFQUFFbUUsTUFBTWhIO1FBQ2pDO1FBRUEsbUVBQW1FO1FBQ25FaUcsU0FBU2hCLE1BQU0sR0FBRyxjQUFjeUIsV0FBVyxTQUFTekIsU0FBUztRQUU3RCxPQUFPZ0I7SUFDVDtJQUVBLG9CQUFvQjtJQUNwQixPQUFPakc7QUFDVCJ9

}),
9461: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";
/* globals document, window, navigator */ /**
 * Webflow: Brand pages on the subdomain
 */ 
var Webflow = __webpack_require__(43949);
Webflow.define('brand', module.exports = function($) {
    var api = {};
    var doc = document;
    var $html = $('html');
    var $body = $('body');
    var namespace = '.w-webflow-badge';
    var location = window.location;
    var isPhantom = /PhantomJS/i.test(navigator.userAgent);
    var fullScreenEvents = 'fullscreenchange webkitfullscreenchange mozfullscreenchange msfullscreenchange';
    var brandElement;
    // -----------------------------------
    // Module methods
    api.ready = function() {
        var shouldBrand = $html.attr('data-wf-status');
        var publishedDomain = $html.attr('data-wf-domain') || '';
        if (/\.webflow\.io$/i.test(publishedDomain) && location.hostname !== publishedDomain) {
            shouldBrand = true;
        }
        if (shouldBrand && !isPhantom) {
            brandElement = brandElement || createBadge();
            ensureBrand();
            setTimeout(ensureBrand, 500);
            $(doc).off(fullScreenEvents, onFullScreenChange).on(fullScreenEvents, onFullScreenChange);
        }
    };
    function onFullScreenChange() {
        var fullScreen = doc.fullScreen || doc.mozFullScreen || doc.webkitIsFullScreen || doc.msFullscreenElement || Boolean(doc.webkitFullscreenElement);
        $(brandElement).attr('style', fullScreen ? 'display: none !important;' : '');
    }
    function createBadge() {
        var $brand = $('<a class="w-webflow-badge"></a>').attr('href', 'https://webflow.com?utm_campaign=brandjs');
        var $logoArt = $('<img>').attr('src', 'https://d3e54v103j8qbb.cloudfront.net/img/webflow-badge-icon-d2.89e12c322e.svg').attr('alt', '').css({
            marginRight: '4px',
            width: '26px'
        });
        var $logoText = $('<img>').attr('src', 'https://d3e54v103j8qbb.cloudfront.net/img/webflow-badge-text-d2.c82cec3b78.svg').attr('alt', 'Made in Webflow');
        $brand.append($logoArt, $logoText);
        return $brand[0];
    }
    function ensureBrand() {
        var found = $body.children(namespace);
        var match = found.length && found.get(0) === brandElement;
        var inEditor = Webflow.env('editor');
        if (match) {
            // Remove brand when Editor is active
            if (inEditor) {
                found.remove();
            }
            // Exit early, brand is in place
            return;
        }
        // Remove any invalid brand elements
        if (found.length) {
            found.remove();
        }
        // Append the brand (unless Editor is active)
        if (!inEditor) {
            $body.append(brandElement);
        }
    }
    // Export module
    return api;
});

//# sourceMappingURL=data:application/json;base64,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

}),
12338: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";
/* globals window, document */ /**
 * Webflow: focus-visible
 */ 
var Webflow = __webpack_require__(43949);
/*
 * This polyfill comes from https://github.com/WICG/focus-visible
 */ Webflow.define('focus-visible', module.exports = function() {
    /**
     * Applies the :focus-visible polyfill at the given scope.
     * A scope in this case is either the top-level Document or a Shadow Root.
     *
     * @param {(Document|ShadowRoot)} scope
     * @see https://github.com/WICG/focus-visible
     */ function applyFocusVisiblePolyfill(scope) {
        var hadKeyboardEvent = true;
        var hadFocusVisibleRecently = false;
        var hadFocusVisibleRecentlyTimeout = null;
        var inputTypesAllowlist = {
            text: true,
            search: true,
            url: true,
            tel: true,
            email: true,
            password: true,
            number: true,
            date: true,
            month: true,
            week: true,
            time: true,
            datetime: true,
            'datetime-local': true
        };
        /**
       * Helper function for legacy browsers and iframes which sometimes focus
       * elements like document, body, and non-interactive SVG.
       * @param {Element} el
       */ function isValidFocusTarget(el) {
            if (el && el !== document && el.nodeName !== 'HTML' && el.nodeName !== 'BODY' && 'classList' in el && 'contains' in el.classList) {
                return true;
            }
            return false;
        }
        /**
       * Computes whether the given element should automatically trigger the
       * `focus-visible` class being added, i.e. whether it should always match
       * `:focus-visible` when focused.
       * @param {Element} el
       * @return {boolean}
       */ function focusTriggersKeyboardModality(el) {
            var type = el.type;
            var tagName = el.tagName;
            if (tagName === 'INPUT' && inputTypesAllowlist[type] && !el.readOnly) {
                return true;
            }
            if (tagName === 'TEXTAREA' && !el.readOnly) {
                return true;
            }
            if (el.isContentEditable) {
                return true;
            }
            return false;
        }
        function addFocusVisibleAttribute(el) {
            if (el.getAttribute('data-wf-focus-visible')) {
                return;
            }
            el.setAttribute('data-wf-focus-visible', 'true');
        }
        function removeFocusVisibleAttribute(el) {
            if (!el.getAttribute('data-wf-focus-visible')) {
                return;
            }
            el.removeAttribute('data-wf-focus-visible');
        }
        /**
       * If the most recent user interaction was via the keyboard;
       * and the key press did not include a meta, alt/option, or control key;
       * then the modality is keyboard. Otherwise, the modality is not keyboard.
       * Apply `focus-visible` to any current active element and keep track
       * of our keyboard modality state with `hadKeyboardEvent`.
       * @param {KeyboardEvent} e
       */ function onKeyDown(e) {
            if (e.metaKey || e.altKey || e.ctrlKey) {
                return;
            }
            if (isValidFocusTarget(scope.activeElement)) {
                addFocusVisibleAttribute(scope.activeElement);
            }
            hadKeyboardEvent = true;
        }
        /**
       * If at any point a user clicks with a pointing device, ensure that we change
       * the modality away from keyboard.
       * This avoids the situation where a user presses a key on an already focused
       * element, and then clicks on a different element, focusing it with a
       * pointing device, while we still think we're in keyboard modality.
       * @param {Event} e
       */ function onPointerDown() {
            hadKeyboardEvent = false;
        }
        /**
       * On `focus`, add the `focus-visible` class to the target if:
       * - the target received focus as a result of keyboard navigation, or
       * - the event target is an element that will likely require interaction
       *   via the keyboard (e.g. a text box)
       * @param {Event} e
       */ function onFocus(e) {
            // Prevent IE from focusing the document or HTML element.
            if (!isValidFocusTarget(e.target)) {
                return;
            }
            if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
                addFocusVisibleAttribute(e.target);
            }
        }
        /**
       * On `blur`, remove the `focus-visible` class from the target.
       * @param {Event} e
       */ function onBlur(e) {
            if (!isValidFocusTarget(e.target)) {
                return;
            }
            if (e.target.hasAttribute('data-wf-focus-visible')) {
                // To detect a tab/window switch, we look for a blur event followed
                // rapidly by a visibility change.
                // If we don't see a visibility change within 100ms, it's probably a
                // regular focus change.
                hadFocusVisibleRecently = true;
                window.clearTimeout(hadFocusVisibleRecentlyTimeout);
                hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
                    hadFocusVisibleRecently = false;
                }, 100);
                removeFocusVisibleAttribute(e.target);
            }
        }
        /**
       * If the user changes tabs, keep track of whether or not the previously
       * focused element had .focus-visible.
       * @param {Event} e
       */ function onVisibilityChange() {
            if (document.visibilityState === 'hidden') {
                // If the tab becomes active again, the browser will handle calling focus
                // on the element (Safari actually calls it twice).
                // If this tab change caused a blur on an element with focus-visible,
                // re-apply the class when the user switches back to the tab.
                if (hadFocusVisibleRecently) {
                    hadKeyboardEvent = true;
                }
                addInitialPointerMoveListeners();
            }
        }
        /**
       * Add a group of listeners to detect usage of any pointing devices.
       * These listeners will be added when the polyfill first loads, and anytime
       * the window is blurred, so that they are active when the window regains
       * focus.
       */ function addInitialPointerMoveListeners() {
            document.addEventListener('mousemove', onInitialPointerMove);
            document.addEventListener('mousedown', onInitialPointerMove);
            document.addEventListener('mouseup', onInitialPointerMove);
            document.addEventListener('pointermove', onInitialPointerMove);
            document.addEventListener('pointerdown', onInitialPointerMove);
            document.addEventListener('pointerup', onInitialPointerMove);
            document.addEventListener('touchmove', onInitialPointerMove);
            document.addEventListener('touchstart', onInitialPointerMove);
            document.addEventListener('touchend', onInitialPointerMove);
        }
        function removeInitialPointerMoveListeners() {
            document.removeEventListener('mousemove', onInitialPointerMove);
            document.removeEventListener('mousedown', onInitialPointerMove);
            document.removeEventListener('mouseup', onInitialPointerMove);
            document.removeEventListener('pointermove', onInitialPointerMove);
            document.removeEventListener('pointerdown', onInitialPointerMove);
            document.removeEventListener('pointerup', onInitialPointerMove);
            document.removeEventListener('touchmove', onInitialPointerMove);
            document.removeEventListener('touchstart', onInitialPointerMove);
            document.removeEventListener('touchend', onInitialPointerMove);
        }
        /**
       * When the polfyill first loads, assume the user is in keyboard modality.
       * If any event is received from a pointing device (e.g. mouse, pointer,
       * touch), turn off keyboard modality.
       * This accounts for situations where focus enters the page from the URL bar.
       * @param {Event} e
       */ function onInitialPointerMove(e) {
            // Work around a Safari quirk that fires a mousemove on <html> whenever the
            // window blurs, even if you're tabbing out of the page. ¯\_(ツ)_/¯
            if (e.target.nodeName && e.target.nodeName.toLowerCase() === 'html') {
                return;
            }
            hadKeyboardEvent = false;
            removeInitialPointerMoveListeners();
        }
        // For some kinds of state, we are interested in changes at the global scope
        // only. For example, global pointer input, global key presses and global
        // visibility change should affect the state at every scope:
        document.addEventListener('keydown', onKeyDown, true);
        document.addEventListener('mousedown', onPointerDown, true);
        document.addEventListener('pointerdown', onPointerDown, true);
        document.addEventListener('touchstart', onPointerDown, true);
        document.addEventListener('visibilitychange', onVisibilityChange, true);
        addInitialPointerMoveListeners();
        // For focus and blur, we specifically care about state changes in the local
        // scope. This is because focus / blur events that originate from within a
        // shadow root are not re-dispatched from the host element if it was already
        // the active element in its own scope:
        scope.addEventListener('focus', onFocus, true);
        scope.addEventListener('blur', onBlur, true);
    }
    function ready() {
        if (typeof document !== 'undefined') {
            try {
                // check for native support; this will throw if the selector is not considered valid
                document.querySelector(':focus-visible');
            } catch (e) {
                // :focus-visible pseudo-selector is not supported natively
                applyFocusVisiblePolyfill(document);
            }
        }
    }
    // Export module
    return {
        ready
    };
});

//# sourceMappingURL=data:application/json;base64,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

}),
8334: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";
/* globals document, MouseEvent */ /**
 * Webflow: focus
 */ 
var Webflow = __webpack_require__(43949);
/*
 * Safari has a weird bug where it doesn't support :focus for links with hrefs,
 * buttons, and input[type=button|submit], so we listen for mousedown events
 * instead and force the element to emit a focus event in those cases.

 * See these webkit bugs for reference:
 * https://bugs.webkit.org/show_bug.cgi?id=22261
 * https://bugs.webkit.org/show_bug.cgi?id=229895
 */ Webflow.define('focus', module.exports = function() {
    var capturedEvents = [];
    var capturing = false;
    function captureEvent(e) {
        if (capturing) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            capturedEvents.unshift(e);
        }
    }
    /*
     * The only mousedown events we care about here are ones emanating from
     * (A) anchor links with href attribute,
     * (B) non-disabled buttons,
     * (C) non-disabled textarea,
     * (D) non-disabled inputs of type "button", "reset", "checkbox", "radio", "submit"
     * (E) non-interactive elements (button, a, input, textarea, select) that have a tabindex with a numeric value
     * (F) audio elements
     * (G) video elements with controls attribute
     */ function isPolyfilledFocusEvent(e) {
        var el = e.target;
        var tag = el.tagName;
        return /^a$/i.test(tag) && el.href != null || // (A)
        /^(button|textarea)$/i.test(tag) && el.disabled !== true || // (B) (C)
        /^input$/i.test(tag) && /^(button|reset|submit|radio|checkbox)$/i.test(el.type) && !el.disabled || // (D)
        !/^(button|input|textarea|select|a)$/i.test(tag) && !Number.isNaN(Number.parseFloat(el.tabIndex)) || // (E)
        /^audio$/i.test(tag) || // (F)
        /^video$/i.test(tag) && el.controls === true // (G)
        ;
    }
    function handler(e) {
        if (isPolyfilledFocusEvent(e)) {
            // start capturing possible out-of-order mouse events
            capturing = true;
            /*
         * enqueue the focus event _after_ the current batch of events, which
         * includes any blur events. The correct order of events is:
         *
         * [this element] MOUSEDOWN               <-- this event
         * [previously active element] BLUR
         * [previously active element] FOCUSOUT
         * [this element] FOCUS                   <-- forced event
         * [this element] FOCUSIN                 <-- forced event
         * [this element] MOUSEUP                 <-- possibly captured event (it may have fired _before_ the FOCUS event)
         * [this element] CLICK                   <-- possibly captured event (it may have fired _before_ the FOCUS event)
         */ setTimeout(()=>{
                // stop capturing possible out-of-order mouse events
                capturing = false;
                // trigger focus event
                e.target.focus();
                // re-dispatch captured mouse events in order
                while(capturedEvents.length > 0){
                    var event = capturedEvents.pop();
                    event.target.dispatchEvent(new MouseEvent(event.type, event));
                }
            }, 0);
        }
    }
    function ready() {
        if (typeof document !== 'undefined' && document.body.hasAttribute('data-wf-focus-within') && Webflow.env.safari) {
            document.addEventListener('mousedown', handler, true);
            document.addEventListener('mouseup', captureEvent, true);
            document.addEventListener('click', captureEvent, true);
        }
    }
    // Export module
    return {
        ready
    };
});

//# sourceMappingURL=data:application/json;base64,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

}),
7199: (function (module) {
"use strict";
/* globals window */ /**
 * Webflow: IX Event triggers for other modules
 */ 
var $ = window.jQuery;
var api = {};
var eventQueue = [];
var namespace = '.w-ix';
var eventTriggers = {
    reset: function(i, el) {
        el.__wf_intro = null;
    },
    intro: function(i, el) {
        if (el.__wf_intro) {
            return;
        }
        el.__wf_intro = true;
        $(el).triggerHandler(api.types.INTRO);
    },
    outro: function(i, el) {
        if (!el.__wf_intro) {
            return;
        }
        el.__wf_intro = null;
        $(el).triggerHandler(api.types.OUTRO);
    }
};
api.triggers = {};
api.types = {
    INTRO: 'w-ix-intro' + namespace,
    OUTRO: 'w-ix-outro' + namespace
};
// Trigger any events in queue + restore trigger methods
api.init = function() {
    var count = eventQueue.length;
    for(var i = 0; i < count; i++){
        var memo = eventQueue[i];
        memo[0](0, memo[1]);
    }
    eventQueue = [];
    $.extend(api.triggers, eventTriggers);
};
// Replace all triggers with async wrapper to queue events until init
api.async = function() {
    for(var key in eventTriggers){
        var func = eventTriggers[key];
        if (!eventTriggers.hasOwnProperty(key)) {
            continue;
        }
        // Replace trigger method with async wrapper
        api.triggers[key] = function(i, el) {
            eventQueue.push([
                func,
                el
            ]);
        };
    }
};
// Default triggers to async queue
api.async();
module.exports = api;

//# sourceMappingURL=data:application/json;base64,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

}),
65134: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";
/* globals window, document */ 
var IXEvents = __webpack_require__(7199);
function dispatchCustomEvent(element, eventName) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventName, true, true, null);
    element.dispatchEvent(event);
}
/**
 * Webflow: IX Event triggers for other modules
 */ var $ = window.jQuery;
var api = {};
var namespace = '.w-ix';
var eventTriggers = {
    reset: function(i, el) {
        IXEvents.triggers.reset(i, el);
    },
    intro: function(i, el) {
        IXEvents.triggers.intro(i, el);
        dispatchCustomEvent(el, 'COMPONENT_ACTIVE');
    },
    outro: function(i, el) {
        IXEvents.triggers.outro(i, el);
        dispatchCustomEvent(el, 'COMPONENT_INACTIVE');
    }
};
api.triggers = {};
api.types = {
    INTRO: 'w-ix-intro' + namespace,
    OUTRO: 'w-ix-outro' + namespace
};
$.extend(api.triggers, eventTriggers);
module.exports = api;

//# sourceMappingURL=data:application/json;base64,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

}),
40941: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";
/**
 * Webflow: Interactions 2
 */ 
var Webflow = __webpack_require__(43949);
var ix2 = __webpack_require__(46011);
ix2.setEnv(Webflow.env);
Webflow.define('ix2', module.exports = function() {
    return ix2;
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYmZsb3ctaXgyLmpzIl0sInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogV2ViZmxvdzogSW50ZXJhY3Rpb25zIDJcbiAqL1xudmFyIFdlYmZsb3cgPSByZXF1aXJlKCcuL3dlYmZsb3ctbGliJyk7XG52YXIgaXgyID0gcmVxdWlyZSgnQHBhY2thZ2VzL3N5c3RlbXMvaXgyL2VuZ2luZScpO1xuXG5peDIuc2V0RW52KFdlYmZsb3cuZW52KTtcblxuV2ViZmxvdy5kZWZpbmUoXG4gICdpeDInLFxuICAobW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbiAoKSB7XG4gICAgcmV0dXJuIGl4MjtcbiAgfSlcbik7XG4iXSwibmFtZXMiOlsiV2ViZmxvdyIsInJlcXVpcmUiLCJpeDIiLCJzZXRFbnYiLCJlbnYiLCJkZWZpbmUiLCJtb2R1bGUiLCJleHBvcnRzIl0sIm1hcHBpbmdzIjoiQUFBQTs7Q0FFQztBQUNELElBQUlBLFVBQVVDLFFBQVE7QUFDdEIsSUFBSUMsTUFBTUQsUUFBUTtBQUVsQkMsSUFBSUMsTUFBTSxDQUFDSCxRQUFRSSxHQUFHO0FBRXRCSixRQUFRSyxNQUFNLENBQ1osT0FDQ0MsT0FBT0MsT0FBTyxHQUFHO0lBQ2hCLE9BQU9MO0FBQ1QifQ==

}),
43949: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";
/* globals window, document, navigator, WEBFLOW_ENV_TEST */ /**
 * Webflow: Core site library
 */ 
var Webflow = {};
var modules = {};
var primary = [];
var secondary = window.Webflow || [];
var $ = window.jQuery;
var $win = $(window);
var $doc = $(document);
var isFunction = $.isFunction;
var _ = Webflow._ = __webpack_require__(35756);
var tram = Webflow.tram = __webpack_require__(95487) && $.tram;
var domready = false;
var destroyed = false;
tram.config.hideBackface = false;
tram.config.keepInherited = true;
/**
 * Webflow.define - Define a named module
 * @param  {string} name
 * @param  {function} factory
 * @param  {object} [options]
 * @return {object}
 */ Webflow.define = function(name, factory, options) {
    if (modules[name]) {
        unbindModule(modules[name]);
    }
    var instance = modules[name] = factory($, _, options) || {};
    bindModule(instance);
    return instance;
};
/**
 * Webflow.require - Require a named module
 * @param  {string} name
 * @return {object}
 */ Webflow.require = function(name) {
    return modules[name];
};
function bindModule(module1) {
    // If running in Webflow app, subscribe to design/preview events
    if (Webflow.env()) {
        isFunction(module1.design) && $win.on('__wf_design', module1.design);
        isFunction(module1.preview) && $win.on('__wf_preview', module1.preview);
    }
    // Subscribe to front-end destroy event
    isFunction(module1.destroy) && $win.on('__wf_destroy', module1.destroy);
    // Look for ready method on module
    if (module1.ready && isFunction(module1.ready)) {
        addReady(module1);
    }
}
function addReady(module1) {
    // If domready has already happened, run ready method
    if (domready) {
        module1.ready();
        return;
    }
    // Otherwise add ready method to the primary queue (only once)
    if (_.contains(primary, module1.ready)) {
        return;
    }
    primary.push(module1.ready);
}
function unbindModule(module1) {
    // Unsubscribe module from window events
    isFunction(module1.design) && $win.off('__wf_design', module1.design);
    isFunction(module1.preview) && $win.off('__wf_preview', module1.preview);
    isFunction(module1.destroy) && $win.off('__wf_destroy', module1.destroy);
    // Remove ready method from primary queue
    if (module1.ready && isFunction(module1.ready)) {
        removeReady(module1);
    }
}
function removeReady(module1) {
    primary = _.filter(primary, function(readyFn) {
        return readyFn !== module1.ready;
    });
}
/**
 * Webflow.push - Add a ready handler into secondary queue
 * @param {function} ready  Callback to invoke on domready
 */ Webflow.push = function(ready) {
    // If domready has already happened, invoke handler
    if (domready) {
        isFunction(ready) && ready();
        return;
    }
    // Otherwise push into secondary queue
    secondary.push(ready);
};
/**
 * Webflow.env - Get the state of the Webflow app
 * @param {string} mode [optional]
 * @return {boolean}
 */ Webflow.env = function(mode) {
    var designFlag = window.__wf_design;
    var inApp = typeof designFlag !== 'undefined';
    if (!mode) {
        return inApp;
    }
    if (mode === 'design') {
        return inApp && designFlag;
    }
    if (mode === 'preview') {
        return inApp && !designFlag;
    }
    if (mode === 'slug') {
        return inApp && window.__wf_slug;
    }
    if (mode === 'editor') {
        return window.WebflowEditor;
    }
    if (mode === 'test') {
        return  false || window.__wf_test;
    }
    if (mode === 'frame') {
        return window !== window.top;
    }
};
// Feature detects + browser sniffs  ಠ_ಠ
var userAgent = navigator.userAgent.toLowerCase();
var touch = Webflow.env.touch = 'ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch;
var chrome = Webflow.env.chrome = /chrome/.test(userAgent) && /Google/.test(navigator.vendor) && parseInt(userAgent.match(/chrome\/(\d+)\./)[1], 10);
var ios = Webflow.env.ios = /(ipod|iphone|ipad)/.test(userAgent);
Webflow.env.safari = /safari/.test(userAgent) && !chrome && !ios;
// Maintain current touch target to prevent late clicks on touch devices
var touchTarget;
// Listen for both events to support touch/mouse hybrid devices
touch && $doc.on('touchstart mousedown', function(evt) {
    touchTarget = evt.target;
});
/**
 * Webflow.validClick - validate click target against current touch target
 * @param  {HTMLElement} clickTarget  Element being clicked
 * @return {Boolean}  True if click target is valid (always true on non-touch)
 */ Webflow.validClick = touch ? function(clickTarget) {
    return clickTarget === touchTarget || $.contains(clickTarget, touchTarget);
} : function() {
    return true;
};
/**
 * Webflow.resize, Webflow.scroll - throttled event proxies
 */ var resizeEvents = 'resize.webflow orientationchange.webflow load.webflow';
var scrollEvents = 'scroll.webflow ' + resizeEvents;
Webflow.resize = eventProxy($win, resizeEvents);
Webflow.scroll = eventProxy($win, scrollEvents);
Webflow.redraw = eventProxy();
// Create a proxy instance for throttled events
function eventProxy(target, types) {
    // Set up throttled method (using custom frame-based _.throttle)
    var handlers = [];
    var proxy = {};
    proxy.up = _.throttle(function(evt) {
        _.each(handlers, function(h) {
            h(evt);
        });
    });
    // Bind events to target
    if (target && types) {
        target.on(types, proxy.up);
    }
    /**
   * Add an event handler
   * @param  {function} handler
   */ proxy.on = function(handler) {
        if (typeof handler !== 'function') {
            return;
        }
        if (_.contains(handlers, handler)) {
            return;
        }
        handlers.push(handler);
    };
    /**
   * Remove an event handler
   * @param  {function} handler
   */ proxy.off = function(handler) {
        // If no arguments supplied, clear all handlers
        if (!arguments.length) {
            handlers = [];
            return;
        }
        // Otherwise, remove handler from the list
        handlers = _.filter(handlers, function(h) {
            return h !== handler;
        });
    };
    return proxy;
}
// Webflow.location - Wrap window.location in api
Webflow.location = function(url) {
    window.location = url;
};
if (Webflow.env()) {
    // Ignore redirects inside a Webflow design/edit environment
    Webflow.location = function() {};
}
// Webflow.ready - Call primary and secondary handlers
Webflow.ready = function() {
    domready = true;
    // Restore modules after destroy
    if (destroyed) {
        restoreModules();
    // Otherwise run primary ready methods
    } else {
        _.each(primary, callReady);
    }
    // Run secondary ready methods
    _.each(secondary, callReady);
    // Trigger resize
    Webflow.resize.up();
};
function callReady(readyFn) {
    isFunction(readyFn) && readyFn();
}
function restoreModules() {
    destroyed = false;
    _.each(modules, bindModule);
}
/**
 * Webflow.load - Add a window load handler that will run even if load event has already happened
 * @param  {function} handler
 */ var deferLoad;
Webflow.load = function(handler) {
    deferLoad.then(handler);
};
function bindLoad() {
    // Reject any previous deferred (to support destroy)
    if (deferLoad) {
        deferLoad.reject();
        $win.off('load', deferLoad.resolve);
    }
    // Create deferred and bind window load event
    deferLoad = new $.Deferred();
    $win.on('load', deferLoad.resolve);
}
// Webflow.destroy - Trigger a destroy event for all modules
Webflow.destroy = function(options) {
    options = options || {};
    destroyed = true;
    $win.triggerHandler('__wf_destroy');
    // Allow domready reset for tests
    if (options.domready != null) {
        domready = options.domready;
    }
    // Unbind modules
    _.each(modules, unbindModule);
    // Clear any proxy event handlers
    Webflow.resize.off();
    Webflow.scroll.off();
    Webflow.redraw.off();
    // Clear any queued ready methods
    primary = [];
    secondary = [];
    // If load event has not yet fired, replace the deferred
    if (deferLoad.state() === 'pending') {
        bindLoad();
    }
};
// Listen for domready
$(Webflow.ready);
// Listen for window.onload and resolve deferred
bindLoad();
// Export commonjs module
module.exports = window.Webflow = Webflow;

//# sourceMappingURL=data:application/json;base64,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

}),
27624: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";
/* globals window, document */ /**
 * Webflow: Auto-select links to current page or section
 */ 
var Webflow = __webpack_require__(43949);
Webflow.define('links', module.exports = function($, _) {
    var api = {};
    var $win = $(window);
    var designer;
    var inApp = Webflow.env();
    var location = window.location;
    var tempLink = document.createElement('a');
    var linkCurrent = 'w--current';
    var indexPage = /index\.(html|php)$/;
    var dirList = /\/$/;
    var anchors;
    var slug;
    // -----------------------------------
    // Module methods
    api.ready = api.design = api.preview = init;
    // -----------------------------------
    // Private methods
    function init() {
        designer = inApp && Webflow.env('design');
        slug = Webflow.env('slug') || location.pathname || '';
        // Reset scroll listener, init anchors
        Webflow.scroll.off(scroll);
        anchors = [];
        // Test all links for a selectable href
        var links = document.links;
        for(var i = 0; i < links.length; ++i){
            select(links[i]);
        }
        // Listen for scroll if any anchors exist
        if (anchors.length) {
            Webflow.scroll.on(scroll);
            scroll();
        }
    }
    function select(link) {
        // Ignore localized links
        if (link.getAttribute('hreflang')) {
            return;
        }
        var href = designer && link.getAttribute('href-disabled') || link.getAttribute('href');
        tempLink.href = href;
        // Ignore any hrefs with a colon to safely avoid all uri schemes
        if (href.indexOf(':') >= 0) {
            return;
        }
        var $link = $(link);
        // Check for all links with hash (eg (this-host)(/this-path)#section) to this page
        if (tempLink.hash.length > 1 && tempLink.host + tempLink.pathname === location.host + location.pathname) {
            // Ignore any hrefs with Google Translate type hash
            // Example: jQuery can't parse $('#googtrans(en|es)')
            // https://forum.webflow.com/t/dropdown-menus-not-working-on-site/87140
            if (!/^#[a-zA-Z0-9\-\_]+$/.test(tempLink.hash)) {
                return;
            }
            var $section = $(tempLink.hash);
            $section.length && anchors.push({
                link: $link,
                sec: $section,
                active: false
            });
            return;
        }
        // Ignore empty # links
        if (href === '#' || href === '') {
            return;
        }
        // Determine whether the link should be selected
        var match = !inApp && tempLink.href === location.href || href === slug || indexPage.test(href) && dirList.test(slug);
        setClass($link, linkCurrent, match);
    }
    function scroll() {
        var viewTop = $win.scrollTop();
        var viewHeight = $win.height();
        // Check each anchor for a section in view
        _.each(anchors, function(anchor) {
            // Ignore localized links
            if (anchor.link.attr('hreflang')) {
                return;
            }
            var $link = anchor.link;
            var $section = anchor.sec;
            var top = $section.offset().top;
            var height = $section.outerHeight();
            var offset = viewHeight * 0.5;
            var active = $section.is(':visible') && top + height - offset >= viewTop && top + offset <= viewTop + viewHeight;
            if (anchor.active === active) {
                return;
            }
            anchor.active = active;
            setClass($link, linkCurrent, active);
        });
    }
    function setClass($elem, className, add) {
        var exists = $elem.hasClass(className);
        if (add && exists) {
            return;
        }
        if (!add && !exists) {
            return;
        }
        add ? $elem.addClass(className) : $elem.removeClass(className);
    }
    // Export module
    return api;
});

//# sourceMappingURL=data:application/json;base64,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

}),
30286: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";
/* globals window, document */ /**
 * Webflow: Smooth scroll
 */ 
var Webflow = __webpack_require__(43949);
Webflow.define('scroll', module.exports = function($) {
    /**
     * A collection of namespaced events found in this module.
     * Namespaced events encapsulate our code, and make it safer and easier
     * for designers to apply custom code overrides.
     * @see https://api.jquery.com/on/#event-names
     * @typedef {Object.<string>} NamespacedEventsCollection
     */ var NS_EVENTS = {
        WF_CLICK_EMPTY: 'click.wf-empty-link',
        WF_CLICK_SCROLL: 'click.wf-scroll'
    };
    var loc = window.location;
    var history = inIframe() ? null : window.history;
    var $win = $(window);
    var $doc = $(document);
    var $body = $(document.body);
    var animate = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(fn) {
        window.setTimeout(fn, 15);
    };
    var rootTag = Webflow.env('editor') ? '.w-editor-body' : 'body';
    var headerSelector = 'header, ' + rootTag + ' > .header, ' + rootTag + ' > .w-nav:not([data-no-scroll])';
    var emptyHrefSelector = 'a[href="#"]';
    /**
     * Select only links whose href:
     * - contains a #
     * - is not one of our namespaced TabLink elements
     * - is not _only_ a #
     */ var localHrefSelector = 'a[href*="#"]:not(.w-tab-link):not(' + emptyHrefSelector + ')';
    var scrollTargetOutlineCSS = '.wf-force-outline-none[tabindex="-1"]:focus{outline:none;}';
    var focusStylesEl = document.createElement('style');
    focusStylesEl.appendChild(document.createTextNode(scrollTargetOutlineCSS));
    function inIframe() {
        try {
            return Boolean(window.frameElement);
        } catch (e) {
            return true;
        }
    }
    var validHash = /^#[a-zA-Z0-9][\w:.-]*$/;
    /**
     * Determine if link navigates to current page
     * @param {HTMLAnchorElement} link
     */ function linksToCurrentPage(link) {
        return validHash.test(link.hash) && link.host + link.pathname === loc.host + loc.pathname;
    }
    /**
     * Check if the designer has indicated that this page should
     * have no scroll animation, or if the end user has set
     * prefers-reduced-motion in their OS
     */ const reducedMotionMediaQuery = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)');
    function reducedMotionEnabled() {
        return document.body.getAttribute('data-wf-scroll-motion') === 'none' || reducedMotionMediaQuery.matches;
    }
    function setFocusable($el, action) {
        var initialTabindex;
        switch(action){
            case 'add':
                initialTabindex = $el.attr('tabindex');
                if (initialTabindex) {
                    $el.attr('data-wf-tabindex-swap', initialTabindex);
                } else {
                    $el.attr('tabindex', '-1');
                }
                break;
            case 'remove':
                initialTabindex = $el.attr('data-wf-tabindex-swap');
                if (initialTabindex) {
                    $el.attr('tabindex', initialTabindex);
                    $el.removeAttr('data-wf-tabindex-swap');
                } else {
                    $el.removeAttr('tabindex');
                }
                break;
        }
        $el.toggleClass('wf-force-outline-none', action === 'add');
    }
    /**
     * Determine if we should execute custom scroll
     */ function validateScroll(evt) {
        var target = evt.currentTarget;
        if (// Bail if in Designer
        Webflow.env('design') || // Ignore links being used by jQuery mobile
        window.$.mobile && /(?:^|\s)ui-link(?:$|\s)/.test(target.className)) {
            return;
        }
        var hash = linksToCurrentPage(target) ? target.hash : '';
        if (hash === '') return;
        var $el = $(hash);
        if (!$el.length) {
            return;
        }
        if (evt) {
            evt.preventDefault();
            evt.stopPropagation();
        }
        updateHistory(hash, evt);
        window.setTimeout(function() {
            scroll($el, function setFocus() {
                setFocusable($el, 'add');
                $el.get(0).focus({
                    preventScroll: true
                });
                setFocusable($el, 'remove');
            });
        }, evt ? 0 : 300);
    }
    function updateHistory(hash) {
        // Push new history state
        if (loc.hash !== hash && history && history.pushState && // Navigation breaks Chrome when the protocol is `file:`.
        !(Webflow.env.chrome && loc.protocol === 'file:')) {
            var oldHash = history.state && history.state.hash;
            if (oldHash !== hash) {
                history.pushState({
                    hash
                }, '', hash);
            }
        }
    }
    function scroll($targetEl, cb) {
        var start = $win.scrollTop();
        var end = calculateScrollEndPosition($targetEl);
        if (start === end) return;
        var duration = calculateScrollDuration($targetEl, start, end);
        var clock = Date.now();
        var step = function() {
            var elapsed = Date.now() - clock;
            window.scroll(0, getY(start, end, elapsed, duration));
            if (elapsed <= duration) {
                animate(step);
            } else if (typeof cb === 'function') {
                cb();
            }
        };
        animate(step);
    }
    function calculateScrollEndPosition($targetEl) {
        // If a fixed header exists, offset for the height
        var $header = $(headerSelector);
        var offsetY = $header.css('position') === 'fixed' ? $header.outerHeight() : 0;
        var end = $targetEl.offset().top - offsetY;
        // If specified, scroll so that the element ends up in the middle of the viewport
        if ($targetEl.data('scroll') === 'mid') {
            var available = $win.height() - offsetY;
            var elHeight = $targetEl.outerHeight();
            if (elHeight < available) {
                end -= Math.round((available - elHeight) / 2);
            }
        }
        return end;
    }
    function calculateScrollDuration($targetEl, start, end) {
        if (reducedMotionEnabled()) return 0;
        var mult = 1;
        // Check for custom time multiplier on the body and the scroll target
        $body.add($targetEl).each(function(_, el) {
            var time = parseFloat(el.getAttribute('data-scroll-time'));
            if (!isNaN(time) && time >= 0) {
                mult = time;
            }
        });
        return (472.143 * Math.log(Math.abs(start - end) + 125) - 2000) * mult;
    }
    function getY(start, end, elapsed, duration) {
        if (elapsed > duration) {
            return end;
        }
        return start + (end - start) * ease(elapsed / duration);
    }
    function ease(t) {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    }
    function ready() {
        var { WF_CLICK_EMPTY, WF_CLICK_SCROLL } = NS_EVENTS;
        $doc.on(WF_CLICK_SCROLL, localHrefSelector, validateScroll);
        /**
       * Prevent empty hash links from triggering scroll.
       * Legacy feature to preserve: use the default "#" link
       * to trigger an interaction, and do not want the page
       * to scroll to the top.
       */ $doc.on(WF_CLICK_EMPTY, emptyHrefSelector, function(e) {
            e.preventDefault();
        });
        document.head.insertBefore(focusStylesEl, document.head.firstChild);
    }
    // Export module
    return {
        ready
    };
});

//# sourceMappingURL=data:application/json;base64,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

}),
93695: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";
/* globals document, window */ /**
 * Webflow: Touch events
 * Supports legacy 'tap' event
 * Adds a 'swipe' event to desktop and mobile
 */ 
var Webflow = __webpack_require__(43949);
Webflow.define('touch', module.exports = function($) {
    var api = {};
    var getSelection = window.getSelection;
    // Delegate all legacy 'tap' events to 'click'
    $.event.special.tap = {
        bindType: 'click',
        delegateType: 'click'
    };
    api.init = function(el) {
        el = typeof el === 'string' ? $(el).get(0) : el;
        return el ? new Touch(el) : null;
    };
    function Touch(el) {
        var active = false;
        var useTouch = false;
        var thresholdX = Math.min(Math.round(window.innerWidth * 0.04), 40);
        var startX;
        var lastX;
        el.addEventListener('touchstart', start, false);
        el.addEventListener('touchmove', move, false);
        el.addEventListener('touchend', end, false);
        el.addEventListener('touchcancel', cancel, false);
        el.addEventListener('mousedown', start, false);
        el.addEventListener('mousemove', move, false);
        el.addEventListener('mouseup', end, false);
        el.addEventListener('mouseout', cancel, false);
        function start(evt) {
            // We don’t handle multi-touch events yet.
            var touches = evt.touches;
            if (touches && touches.length > 1) {
                return;
            }
            active = true;
            if (touches) {
                useTouch = true;
                startX = touches[0].clientX;
            } else {
                startX = evt.clientX;
            }
            lastX = startX;
        }
        function move(evt) {
            if (!active) {
                return;
            }
            if (useTouch && evt.type === 'mousemove') {
                evt.preventDefault();
                evt.stopPropagation();
                return;
            }
            var touches = evt.touches;
            var x = touches ? touches[0].clientX : evt.clientX;
            var velocityX = x - lastX;
            lastX = x;
            // Allow swipes while pointer is down, but prevent them during text selection
            if (Math.abs(velocityX) > thresholdX && getSelection && String(getSelection()) === '') {
                triggerEvent('swipe', evt, {
                    direction: velocityX > 0 ? 'right' : 'left'
                });
                cancel();
            }
        }
        function end(evt) {
            if (!active) {
                return;
            }
            active = false;
            if (useTouch && evt.type === 'mouseup') {
                evt.preventDefault();
                evt.stopPropagation();
                useTouch = false;
                return;
            }
        }
        function cancel() {
            active = false;
        }
        function destroy() {
            el.removeEventListener('touchstart', start, false);
            el.removeEventListener('touchmove', move, false);
            el.removeEventListener('touchend', end, false);
            el.removeEventListener('touchcancel', cancel, false);
            el.removeEventListener('mousedown', start, false);
            el.removeEventListener('mousemove', move, false);
            el.removeEventListener('mouseup', end, false);
            el.removeEventListener('mouseout', cancel, false);
            el = null;
        }
        // Public instance methods
        this.destroy = destroy;
    }
    // Wrap native event to supoprt preventdefault + stopPropagation
    function triggerEvent(type, evt, data) {
        var newEvent = $.Event(type, {
            originalEvent: evt
        });
        $(evt.target).trigger(newEvent, data);
    }
    // Listen for touch events on all nodes by default.
    api.instance = api.init(document);
    // Export module
    return api;
});

//# sourceMappingURL=data:application/json;base64,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

}),
69147: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return StyleMapObserver;
    }
}));
const _merge = /*#__PURE__*/ _interop_require_default(__webpack_require__(90139));
const _tinycolor2 = /*#__PURE__*/ _interop_require_default(__webpack_require__(86304));
const _breakpointsconfig = __webpack_require__(66725);
const _breakpointids = __webpack_require__(82216);
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const STYLE_MAP_ATTR = 'data-wf-style-map';
/**
 * In order of application, where each query values
 * overrides the media queries above it.
 */ const orderedBreakpointIds = [
    _breakpointids.BREAKPOINT_ID_MAIN,
    _breakpointids.BREAKPOINT_ID_LARGE,
    _breakpointids.BREAKPOINT_ID_XL,
    _breakpointids.BREAKPOINT_ID_XXL,
    _breakpointids.BREAKPOINT_ID_MEDIUM,
    _breakpointids.BREAKPOINT_ID_SMALL,
    _breakpointids.BREAKPOINT_ID_TINY
];
const ORDERED_MEDIA_QUERIES = orderedBreakpointIds.map((breakpointId)=>{
    const config = _breakpointsconfig.LARGER_BREAKPOINTS_CONFIG[breakpointId];
    let prop;
    let value;
    // @ts-expect-error - TS18048 - 'config' is possibly 'undefined'.
    if ('minWidth' in config) {
        prop = 'min-width';
        value = config.minWidth;
    }
    // @ts-expect-error - TS18048 - 'config' is possibly 'undefined'.
    if ('maxWidth' in config) {
        prop = 'max-width';
        value = config.maxWidth;
    }
    if (prop === undefined || value === undefined) {
        throw new Error('Bad breakpoint config, expected either "minWidth" or "maxWidth".');
    }
    return {
        name: breakpointId,
        query: `(${prop}: ${value}px)`
    };
});
class StyleMapObserver {
    styles = undefined;
    observer = undefined;
    mediaQueries = [];
    options = {
        onChange: ()=>{}
    };
    static appliedStylesToStripeElementStyles = (appliedStylesMap)=>{
        if (!appliedStylesMap) {
            return {};
        }
        // Need to update color values to rgba because Stripe doesn't accept hsla format
        const appliedStylesMapWithUpdatedColorValues = Object.keys(appliedStylesMap).reduce((updatedStyles, styleKey)=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"lang" | "active" | "placeholder" | "focus" | "after" | "before" | "hover" | "empty" | "noPseudo" | "nth-child(odd)" | "nth-child(even)" | "first-child" | "last-child" | "pressed" | "visited" | "focus-visible" | "focus-within", { ...; }>>'.
            const colorVal = appliedStylesMap[styleKey].color;
            const textShadowVal = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"lang" | "active" | "placeholder" | "focus" | "after" | "before" | "hover" | "empty" | "noPseudo" | "nth-child(odd)" | "nth-child(even)" | "first-child" | "last-child" | "pressed" | "visited" | "focus-visible" | "focus-within", { ...; }>>'.
            appliedStylesMap[styleKey].textShadow && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"lang" | "active" | "placeholder" | "focus" | "after" | "before" | "hover" | "empty" | "noPseudo" | "nth-child(odd)" | "nth-child(even)" | "first-child" | "last-child" | "pressed" | "visited" | "focus-visible" | "focus-within", { ...; }>>'.
            appliedStylesMap[styleKey].textShadow.split(/(?=hsla)/);
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"lang" | "active" | "placeholder" | "focus" | "after" | "before" | "hover" | "empty" | "noPseudo" | "nth-child(odd)" | "nth-child(even)" | "first-child" | "last-child" | "pressed" | "visited" | "focus-visible" | "focus-within", { ...; }>>'.
            updatedStyles[styleKey] = appliedStylesMap[styleKey];
            // Update color to rgba string
            if (colorVal) {
                updatedStyles[styleKey].color = (0, _tinycolor2.default)(colorVal).toRgbString();
            }
            // Want to update only if hsla val is within textShaodw string
            if (textShadowVal && textShadowVal.length > 1) {
                updatedStyles[styleKey].textShadow = textShadowVal[0] + (0, _tinycolor2.default)(textShadowVal[1]).toRgbString();
            }
            return updatedStyles;
        }, {});
        const styles = {
            ...appliedStylesMapWithUpdatedColorValues.noPseudo,
            ':hover': appliedStylesMapWithUpdatedColorValues.hover,
            ':focus': appliedStylesMapWithUpdatedColorValues.focus,
            '::placeholder': appliedStylesMapWithUpdatedColorValues.placeholder
        };
        return {
            base: styles,
            invalid: styles,
            empty: styles,
            complete: styles
        };
    };
    constructor(element, options){
        this.options = options;
        if (element.hasAttribute(STYLE_MAP_ATTR)) {
            const styleMapJSON = element.getAttribute(STYLE_MAP_ATTR);
            if (styleMapJSON) {
                this.setStylesFromJSON(styleMapJSON);
                const doc = element.ownerDocument;
                const win = doc.defaultView;
                this.mediaQueries = ORDERED_MEDIA_QUERIES.map((mq)=>({
                        ...mq,
                        // @ts-expect-error - TS18047 - 'win' is possibly 'null'.
                        listener: win.matchMedia(mq.query)
                    }));
                // @ts-expect-error - TS18047 - 'win' is possibly 'null'.
                this.observer = new win.MutationObserver(this.handleMutationObserver);
                this.observer.observe(element, {
                    attributes: true
                });
                this.mediaQueries.forEach(({ listener })=>{
                    listener.addListener(this.dispatch);
                });
                this.dispatch();
            }
        }
    }
    setStylesFromJSON(styleMapJSON) {
        try {
            this.styles = JSON.parse(styleMapJSON);
        } catch (e) {
            this.styles = {};
        }
    }
    getAppliedStyles() {
        if (!this.styles) {
            return;
        }
        const styles = this.styles;
        const appliedStyles = this.mediaQueries.reduce((stylesMap, { listener, name })=>listener.matches ? (0, _merge.default)(stylesMap, styles[name]) : stylesMap, {});
        return appliedStyles;
    }
    dispatch = ()=>{
        this.options.onChange(this.getAppliedStyles());
    };
    handleMutationObserver = (mutationList)=>{
        mutationList.forEach((mutation)=>{
            if (mutation.type === 'attributes' && mutation.attributeName === STYLE_MAP_ATTR && mutation.target.hasAttribute(STYLE_MAP_ATTR)) {
                const styleMapJSON = mutation.target.getAttribute(STYLE_MAP_ATTR);
                if (styleMapJSON) {
                    this.setStylesFromJSON(styleMapJSON);
                    this.dispatch();
                }
            }
        });
    };
    destroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
        this.mediaQueries.forEach(({ listener })=>{
            listener.removeListener(this.dispatch);
        });
    }
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN0eWxlTWFwT2JzZXJ2ZXIudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IG1lcmdlIGZyb20gJ2xvZGFzaC9tZXJnZSc7XG5pbXBvcnQgdGlueWNvbG9yIGZyb20gJ3Rpbnljb2xvcjInO1xuaW1wb3J0IHR5cGUge0JyZWFrcG9pbnRJRH0gZnJvbSAnQHBhY2thZ2VzL3N5c3RlbXMvc3R5bGUvdHlwZXMnO1xuaW1wb3J0IHR5cGUge1BzZXVkb1N0YXRlS2V5fSBmcm9tICdAcGFja2FnZXMvc3lzdGVtcy9jb3JlL3V0aWxzL1N0eWxlVHlwZXMnO1xuaW1wb3J0IHtMQVJHRVJfQlJFQUtQT0lOVFNfQ09ORklHfSBmcm9tICdAcGFja2FnZXMvc3lzdGVtcy9zdHlsZS9icmVha3BvaW50cy1jb25maWcnO1xuaW1wb3J0IHtcbiAgQlJFQUtQT0lOVF9JRF9YWEwsXG4gIEJSRUFLUE9JTlRfSURfWEwsXG4gIEJSRUFLUE9JTlRfSURfTEFSR0UsXG4gIEJSRUFLUE9JTlRfSURfTUFJTixcbiAgQlJFQUtQT0lOVF9JRF9NRURJVU0sXG4gIEJSRUFLUE9JTlRfSURfU01BTEwsXG4gIEJSRUFLUE9JTlRfSURfVElOWSxcbn0gZnJvbSAnQHBhY2thZ2VzL3N5c3RlbXMvc3R5bGUvYnJlYWtwb2ludC1pZHMnO1xuXG5jb25zdCBTVFlMRV9NQVBfQVRUUiA9ICdkYXRhLXdmLXN0eWxlLW1hcCc7XG5cbmV4cG9ydCB0eXBlIEFwcGxpZWRTdHlsZXNNYXAgPSBQYXJ0aWFsPFxuICBSZWNvcmQ8XG4gICAgUHNldWRvU3RhdGVLZXksXG4gICAge1xuICAgICAgW2tleTogc3RyaW5nXTogc3RyaW5nO1xuICAgIH1cbiAgPlxuPjtcbnR5cGUgU3R5bGVzTWFwID0gUGFydGlhbDxSZWNvcmQ8QnJlYWtwb2ludElELCBBcHBsaWVkU3R5bGVzTWFwPj47XG5cbi8qKlxuICogSW4gb3JkZXIgb2YgYXBwbGljYXRpb24sIHdoZXJlIGVhY2ggcXVlcnkgdmFsdWVzXG4gKiBvdmVycmlkZXMgdGhlIG1lZGlhIHF1ZXJpZXMgYWJvdmUgaXQuXG4gKi9cblxuY29uc3Qgb3JkZXJlZEJyZWFrcG9pbnRJZHMgPSBbXG4gIEJSRUFLUE9JTlRfSURfTUFJTixcbiAgQlJFQUtQT0lOVF9JRF9MQVJHRSxcbiAgQlJFQUtQT0lOVF9JRF9YTCxcbiAgQlJFQUtQT0lOVF9JRF9YWEwsXG4gIEJSRUFLUE9JTlRfSURfTUVESVVNLFxuICBCUkVBS1BPSU5UX0lEX1NNQUxMLFxuICBCUkVBS1BPSU5UX0lEX1RJTlksXG5dO1xuXG5jb25zdCBPUkRFUkVEX01FRElBX1FVRVJJRVM6IEFycmF5PHtcbiAgbmFtZTogQnJlYWtwb2ludElEO1xuICBxdWVyeTogc3RyaW5nO1xufT4gPSBvcmRlcmVkQnJlYWtwb2ludElkcy5tYXAoKGJyZWFrcG9pbnRJZCkgPT4ge1xuICBjb25zdCBjb25maWcgPSBMQVJHRVJfQlJFQUtQT0lOVFNfQ09ORklHW2JyZWFrcG9pbnRJZF07XG4gIGxldCBwcm9wO1xuICBsZXQgdmFsdWU7XG5cbiAgLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTMTgwNDggLSAnY29uZmlnJyBpcyBwb3NzaWJseSAndW5kZWZpbmVkJy5cbiAgaWYgKCdtaW5XaWR0aCcgaW4gY29uZmlnKSB7XG4gICAgcHJvcCA9ICdtaW4td2lkdGgnO1xuICAgIHZhbHVlID0gY29uZmlnLm1pbldpZHRoO1xuICB9XG4gIC8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzE4MDQ4IC0gJ2NvbmZpZycgaXMgcG9zc2libHkgJ3VuZGVmaW5lZCcuXG4gIGlmICgnbWF4V2lkdGgnIGluIGNvbmZpZykge1xuICAgIHByb3AgPSAnbWF4LXdpZHRoJztcbiAgICB2YWx1ZSA9IGNvbmZpZy5tYXhXaWR0aDtcbiAgfVxuXG4gIGlmIChwcm9wID09PSB1bmRlZmluZWQgfHwgdmFsdWUgPT09IHVuZGVmaW5lZCkge1xuICAgIHRocm93IG5ldyBFcnJvcihcbiAgICAgICdCYWQgYnJlYWtwb2ludCBjb25maWcsIGV4cGVjdGVkIGVpdGhlciBcIm1pbldpZHRoXCIgb3IgXCJtYXhXaWR0aFwiLidcbiAgICApO1xuICB9XG5cbiAgcmV0dXJuIHtcbiAgICBuYW1lOiBicmVha3BvaW50SWQsXG4gICAgcXVlcnk6IGAoJHtwcm9wfTogJHt2YWx1ZX1weClgLFxuICB9O1xufSk7XG5cbnR5cGUgT3B0aW9ucyA9IHtcbiAgb25DaGFuZ2U6IChhcmcxOiBBcHBsaWVkU3R5bGVzTWFwIHwgdW5kZWZpbmVkKSA9PiB2b2lkO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgU3R5bGVNYXBPYnNlcnZlciB7XG4gIHN0eWxlczogdW5kZWZpbmVkIHwgU3R5bGVzTWFwID0gdW5kZWZpbmVkO1xuICBvYnNlcnZlcjogdW5kZWZpbmVkIHwgYW55ID0gdW5kZWZpbmVkO1xuXG4gIG1lZGlhUXVlcmllczogQXJyYXk8e1xuICAgIGxpc3RlbmVyOiBhbnk7XG4gICAgbmFtZTogQnJlYWtwb2ludElEO1xuICAgIHF1ZXJ5OiBzdHJpbmc7XG4gIH0+ID0gW107XG4gIG9wdGlvbnM6IE9wdGlvbnMgPSB7b25DaGFuZ2U6ICgpID0+IHt9fTtcblxuICBzdGF0aWMgYXBwbGllZFN0eWxlc1RvU3RyaXBlRWxlbWVudFN0eWxlcyA9IChcbiAgICBhcHBsaWVkU3R5bGVzTWFwPzogQXBwbGllZFN0eWxlc01hcFxuICApID0+IHtcbiAgICBpZiAoIWFwcGxpZWRTdHlsZXNNYXApIHtcbiAgICAgIHJldHVybiB7fTtcbiAgICB9XG5cbiAgICAvLyBOZWVkIHRvIHVwZGF0ZSBjb2xvciB2YWx1ZXMgdG8gcmdiYSBiZWNhdXNlIFN0cmlwZSBkb2Vzbid0IGFjY2VwdCBoc2xhIGZvcm1hdFxuICAgIGNvbnN0IGFwcGxpZWRTdHlsZXNNYXBXaXRoVXBkYXRlZENvbG9yVmFsdWVzID0gT2JqZWN0LmtleXMoXG4gICAgICBhcHBsaWVkU3R5bGVzTWFwXG4gICAgKS5yZWR1Y2U8UmVjb3JkPHN0cmluZywgYW55Pj4oKHVwZGF0ZWRTdHlsZXMsIHN0eWxlS2V5KSA9PiB7XG4gICAgICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFM3MDUzIC0gRWxlbWVudCBpbXBsaWNpdGx5IGhhcyBhbiAnYW55JyB0eXBlIGJlY2F1c2UgZXhwcmVzc2lvbiBvZiB0eXBlICdzdHJpbmcnIGNhbid0IGJlIHVzZWQgdG8gaW5kZXggdHlwZSAnUGFydGlhbDxSZWNvcmQ8XCJsYW5nXCIgfCBcImFjdGl2ZVwiIHwgXCJwbGFjZWhvbGRlclwiIHwgXCJmb2N1c1wiIHwgXCJhZnRlclwiIHwgXCJiZWZvcmVcIiB8IFwiaG92ZXJcIiB8IFwiZW1wdHlcIiB8IFwibm9Qc2V1ZG9cIiB8IFwibnRoLWNoaWxkKG9kZClcIiB8IFwibnRoLWNoaWxkKGV2ZW4pXCIgfCBcImZpcnN0LWNoaWxkXCIgfCBcImxhc3QtY2hpbGRcIiB8IFwicHJlc3NlZFwiIHwgXCJ2aXNpdGVkXCIgfCBcImZvY3VzLXZpc2libGVcIiB8IFwiZm9jdXMtd2l0aGluXCIsIHsgLi4uOyB9Pj4nLlxuICAgICAgY29uc3QgY29sb3JWYWwgPSBhcHBsaWVkU3R5bGVzTWFwW3N0eWxlS2V5XS5jb2xvcjtcbiAgICAgIGNvbnN0IHRleHRTaGFkb3dWYWwgPVxuICAgICAgICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFM3MDUzIC0gRWxlbWVudCBpbXBsaWNpdGx5IGhhcyBhbiAnYW55JyB0eXBlIGJlY2F1c2UgZXhwcmVzc2lvbiBvZiB0eXBlICdzdHJpbmcnIGNhbid0IGJlIHVzZWQgdG8gaW5kZXggdHlwZSAnUGFydGlhbDxSZWNvcmQ8XCJsYW5nXCIgfCBcImFjdGl2ZVwiIHwgXCJwbGFjZWhvbGRlclwiIHwgXCJmb2N1c1wiIHwgXCJhZnRlclwiIHwgXCJiZWZvcmVcIiB8IFwiaG92ZXJcIiB8IFwiZW1wdHlcIiB8IFwibm9Qc2V1ZG9cIiB8IFwibnRoLWNoaWxkKG9kZClcIiB8IFwibnRoLWNoaWxkKGV2ZW4pXCIgfCBcImZpcnN0LWNoaWxkXCIgfCBcImxhc3QtY2hpbGRcIiB8IFwicHJlc3NlZFwiIHwgXCJ2aXNpdGVkXCIgfCBcImZvY3VzLXZpc2libGVcIiB8IFwiZm9jdXMtd2l0aGluXCIsIHsgLi4uOyB9Pj4nLlxuICAgICAgICBhcHBsaWVkU3R5bGVzTWFwW3N0eWxlS2V5XS50ZXh0U2hhZG93ICYmXG4gICAgICAgIC8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzcwNTMgLSBFbGVtZW50IGltcGxpY2l0bHkgaGFzIGFuICdhbnknIHR5cGUgYmVjYXVzZSBleHByZXNzaW9uIG9mIHR5cGUgJ3N0cmluZycgY2FuJ3QgYmUgdXNlZCB0byBpbmRleCB0eXBlICdQYXJ0aWFsPFJlY29yZDxcImxhbmdcIiB8IFwiYWN0aXZlXCIgfCBcInBsYWNlaG9sZGVyXCIgfCBcImZvY3VzXCIgfCBcImFmdGVyXCIgfCBcImJlZm9yZVwiIHwgXCJob3ZlclwiIHwgXCJlbXB0eVwiIHwgXCJub1BzZXVkb1wiIHwgXCJudGgtY2hpbGQob2RkKVwiIHwgXCJudGgtY2hpbGQoZXZlbilcIiB8IFwiZmlyc3QtY2hpbGRcIiB8IFwibGFzdC1jaGlsZFwiIHwgXCJwcmVzc2VkXCIgfCBcInZpc2l0ZWRcIiB8IFwiZm9jdXMtdmlzaWJsZVwiIHwgXCJmb2N1cy13aXRoaW5cIiwgeyAuLi47IH0+PicuXG4gICAgICAgIGFwcGxpZWRTdHlsZXNNYXBbc3R5bGVLZXldLnRleHRTaGFkb3cuc3BsaXQoLyg/PWhzbGEpLyk7XG5cbiAgICAgIC8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzcwNTMgLSBFbGVtZW50IGltcGxpY2l0bHkgaGFzIGFuICdhbnknIHR5cGUgYmVjYXVzZSBleHByZXNzaW9uIG9mIHR5cGUgJ3N0cmluZycgY2FuJ3QgYmUgdXNlZCB0byBpbmRleCB0eXBlICdQYXJ0aWFsPFJlY29yZDxcImxhbmdcIiB8IFwiYWN0aXZlXCIgfCBcInBsYWNlaG9sZGVyXCIgfCBcImZvY3VzXCIgfCBcImFmdGVyXCIgfCBcImJlZm9yZVwiIHwgXCJob3ZlclwiIHwgXCJlbXB0eVwiIHwgXCJub1BzZXVkb1wiIHwgXCJudGgtY2hpbGQob2RkKVwiIHwgXCJudGgtY2hpbGQoZXZlbilcIiB8IFwiZmlyc3QtY2hpbGRcIiB8IFwibGFzdC1jaGlsZFwiIHwgXCJwcmVzc2VkXCIgfCBcInZpc2l0ZWRcIiB8IFwiZm9jdXMtdmlzaWJsZVwiIHwgXCJmb2N1cy13aXRoaW5cIiwgeyAuLi47IH0+PicuXG4gICAgICB1cGRhdGVkU3R5bGVzW3N0eWxlS2V5XSA9IGFwcGxpZWRTdHlsZXNNYXBbc3R5bGVLZXldO1xuXG4gICAgICAvLyBVcGRhdGUgY29sb3IgdG8gcmdiYSBzdHJpbmdcbiAgICAgIGlmIChjb2xvclZhbCkge1xuICAgICAgICB1cGRhdGVkU3R5bGVzW3N0eWxlS2V5XS5jb2xvciA9IHRpbnljb2xvcihjb2xvclZhbCkudG9SZ2JTdHJpbmcoKTtcbiAgICAgIH1cbiAgICAgIC8vIFdhbnQgdG8gdXBkYXRlIG9ubHkgaWYgaHNsYSB2YWwgaXMgd2l0aGluIHRleHRTaGFvZHcgc3RyaW5nXG4gICAgICBpZiAodGV4dFNoYWRvd1ZhbCAmJiB0ZXh0U2hhZG93VmFsLmxlbmd0aCA+IDEpIHtcbiAgICAgICAgdXBkYXRlZFN0eWxlc1tzdHlsZUtleV0udGV4dFNoYWRvdyA9XG4gICAgICAgICAgdGV4dFNoYWRvd1ZhbFswXSArIHRpbnljb2xvcih0ZXh0U2hhZG93VmFsWzFdKS50b1JnYlN0cmluZygpO1xuICAgICAgfVxuXG4gICAgICByZXR1cm4gdXBkYXRlZFN0eWxlcztcbiAgICB9LCB7fSk7XG5cbiAgICBjb25zdCBzdHlsZXMgPSB7XG4gICAgICAuLi5hcHBsaWVkU3R5bGVzTWFwV2l0aFVwZGF0ZWRDb2xvclZhbHVlcy5ub1BzZXVkbyxcbiAgICAgICc6aG92ZXInOiBhcHBsaWVkU3R5bGVzTWFwV2l0aFVwZGF0ZWRDb2xvclZhbHVlcy5ob3ZlcixcbiAgICAgICc6Zm9jdXMnOiBhcHBsaWVkU3R5bGVzTWFwV2l0aFVwZGF0ZWRDb2xvclZhbHVlcy5mb2N1cyxcbiAgICAgICc6OnBsYWNlaG9sZGVyJzogYXBwbGllZFN0eWxlc01hcFdpdGhVcGRhdGVkQ29sb3JWYWx1ZXMucGxhY2Vob2xkZXIsXG4gICAgfSBhcyBjb25zdDtcblxuICAgIHJldHVybiB7XG4gICAgICBiYXNlOiBzdHlsZXMsXG4gICAgICBpbnZhbGlkOiBzdHlsZXMsXG4gICAgICBlbXB0eTogc3R5bGVzLFxuICAgICAgY29tcGxldGU6IHN0eWxlcyxcbiAgICB9O1xuICB9O1xuXG4gIGNvbnN0cnVjdG9yKGVsZW1lbnQ6IEVsZW1lbnQsIG9wdGlvbnM6IE9wdGlvbnMpIHtcbiAgICB0aGlzLm9wdGlvbnMgPSBvcHRpb25zO1xuICAgIGlmIChlbGVtZW50Lmhhc0F0dHJpYnV0ZShTVFlMRV9NQVBfQVRUUikpIHtcbiAgICAgIGNvbnN0IHN0eWxlTWFwSlNPTiA9IGVsZW1lbnQuZ2V0QXR0cmlidXRlKFNUWUxFX01BUF9BVFRSKTtcbiAgICAgIGlmIChzdHlsZU1hcEpTT04pIHtcbiAgICAgICAgdGhpcy5zZXRTdHlsZXNGcm9tSlNPTihzdHlsZU1hcEpTT04pO1xuXG4gICAgICAgIGNvbnN0IGRvYyA9IGVsZW1lbnQub3duZXJEb2N1bWVudDtcbiAgICAgICAgY29uc3Qgd2luID0gZG9jLmRlZmF1bHRWaWV3O1xuXG4gICAgICAgIHRoaXMubWVkaWFRdWVyaWVzID0gT1JERVJFRF9NRURJQV9RVUVSSUVTLm1hcCgobXEpID0+ICh7XG4gICAgICAgICAgLi4ubXEsXG4gICAgICAgICAgLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTMTgwNDcgLSAnd2luJyBpcyBwb3NzaWJseSAnbnVsbCcuXG4gICAgICAgICAgbGlzdGVuZXI6IHdpbi5tYXRjaE1lZGlhKG1xLnF1ZXJ5KSxcbiAgICAgICAgfSkpO1xuXG4gICAgICAgIC8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzE4MDQ3IC0gJ3dpbicgaXMgcG9zc2libHkgJ251bGwnLlxuICAgICAgICB0aGlzLm9ic2VydmVyID0gbmV3IHdpbi5NdXRhdGlvbk9ic2VydmVyKHRoaXMuaGFuZGxlTXV0YXRpb25PYnNlcnZlcik7XG4gICAgICAgIHRoaXMub2JzZXJ2ZXIub2JzZXJ2ZShlbGVtZW50LCB7XG4gICAgICAgICAgYXR0cmlidXRlczogdHJ1ZSxcbiAgICAgICAgfSk7XG5cbiAgICAgICAgdGhpcy5tZWRpYVF1ZXJpZXMuZm9yRWFjaCgoe2xpc3RlbmVyfSkgPT4ge1xuICAgICAgICAgIGxpc3RlbmVyLmFkZExpc3RlbmVyKHRoaXMuZGlzcGF0Y2gpO1xuICAgICAgICB9KTtcblxuICAgICAgICB0aGlzLmRpc3BhdGNoKCk7XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgc2V0U3R5bGVzRnJvbUpTT04oc3R5bGVNYXBKU09OOiBzdHJpbmcpIHtcbiAgICB0cnkge1xuICAgICAgdGhpcy5zdHlsZXMgPSBKU09OLnBhcnNlKHN0eWxlTWFwSlNPTikgYXMgU3R5bGVzTWFwO1xuICAgIH0gY2F0Y2ggKGU6IGFueSkge1xuICAgICAgdGhpcy5zdHlsZXMgPSB7fTtcbiAgICB9XG4gIH1cblxuICBnZXRBcHBsaWVkU3R5bGVzKCkge1xuICAgIGlmICghdGhpcy5zdHlsZXMpIHtcbiAgICAgIHJldHVybjtcbiAgICB9XG5cbiAgICBjb25zdCBzdHlsZXMgPSB0aGlzLnN0eWxlcztcblxuICAgIGNvbnN0IGFwcGxpZWRTdHlsZXM6IEFwcGxpZWRTdHlsZXNNYXAgPSB0aGlzLm1lZGlhUXVlcmllcy5yZWR1Y2U8XG4gICAgICBSZWNvcmQ8c3RyaW5nLCBhbnk+XG4gICAgPihcbiAgICAgIChzdHlsZXNNYXAsIHtsaXN0ZW5lciwgbmFtZX0pID0+XG4gICAgICAgIGxpc3RlbmVyLm1hdGNoZXMgPyBtZXJnZShzdHlsZXNNYXAsIHN0eWxlc1tuYW1lXSkgOiBzdHlsZXNNYXAsXG4gICAgICB7fVxuICAgICk7XG5cbiAgICByZXR1cm4gYXBwbGllZFN0eWxlcztcbiAgfVxuXG4gIGRpc3BhdGNoID0gKCkgPT4ge1xuICAgIHRoaXMub3B0aW9ucy5vbkNoYW5nZSh0aGlzLmdldEFwcGxpZWRTdHlsZXMoKSk7XG4gIH07XG5cbiAgaGFuZGxlTXV0YXRpb25PYnNlcnZlciA9IChtdXRhdGlvbkxpc3Q6IEFycmF5PGFueT4pID0+IHtcbiAgICBtdXRhdGlvbkxpc3QuZm9yRWFjaCgobXV0YXRpb24pID0+IHtcbiAgICAgIGlmIChcbiAgICAgICAgbXV0YXRpb24udHlwZSA9PT0gJ2F0dHJpYnV0ZXMnICYmXG4gICAgICAgIG11dGF0aW9uLmF0dHJpYnV0ZU5hbWUgPT09IFNUWUxFX01BUF9BVFRSICYmXG4gICAgICAgIG11dGF0aW9uLnRhcmdldC5oYXNBdHRyaWJ1dGUoU1RZTEVfTUFQX0FUVFIpXG4gICAgICApIHtcbiAgICAgICAgY29uc3Qgc3R5bGVNYXBKU09OID0gbXV0YXRpb24udGFyZ2V0LmdldEF0dHJpYnV0ZShTVFlMRV9NQVBfQVRUUik7XG5cbiAgICAgICAgaWYgKHN0eWxlTWFwSlNPTikge1xuICAgICAgICAgIHRoaXMuc2V0U3R5bGVzRnJvbUpTT04oc3R5bGVNYXBKU09OKTtcbiAgICAgICAgICB0aGlzLmRpc3BhdGNoKCk7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9KTtcbiAgfTtcblxuICBkZXN0cm95KCkge1xuICAgIGlmICh0aGlzLm9ic2VydmVyKSB7XG4gICAgICB0aGlzLm9ic2VydmVyLmRpc2Nvbm5lY3QoKTtcbiAgICB9XG4gICAgdGhpcy5tZWRpYVF1ZXJpZXMuZm9yRWFjaCgoe2xpc3RlbmVyfSkgPT4ge1xuICAgICAgbGlzdGVuZXIucmVtb3ZlTGlzdGVuZXIodGhpcy5kaXNwYXRjaCk7XG4gICAgfSk7XG4gIH1cbn1cbiJdLCJuYW1lcyI6WyJTdHlsZU1hcE9ic2VydmVyIiwiU1RZTEVfTUFQX0FUVFIiLCJvcmRlcmVkQnJlYWtwb2ludElkcyIsIkJSRUFLUE9JTlRfSURfTUFJTiIsIkJSRUFLUE9JTlRfSURfTEFSR0UiLCJCUkVBS1BPSU5UX0lEX1hMIiwiQlJFQUtQT0lOVF9JRF9YWEwiLCJCUkVBS1BPSU5UX0lEX01FRElVTSIsIkJSRUFLUE9JTlRfSURfU01BTEwiLCJCUkVBS1BPSU5UX0lEX1RJTlkiLCJPUkRFUkVEX01FRElBX1FVRVJJRVMiLCJtYXAiLCJicmVha3BvaW50SWQiLCJjb25maWciLCJMQVJHRVJfQlJFQUtQT0lOVFNfQ09ORklHIiwicHJvcCIsInZhbHVlIiwibWluV2lkdGgiLCJtYXhXaWR0aCIsInVuZGVmaW5lZCIsIkVycm9yIiwibmFtZSIsInF1ZXJ5Iiwic3R5bGVzIiwib2JzZXJ2ZXIiLCJtZWRpYVF1ZXJpZXMiLCJvcHRpb25zIiwib25DaGFuZ2UiLCJhcHBsaWVkU3R5bGVzVG9TdHJpcGVFbGVtZW50U3R5bGVzIiwiYXBwbGllZFN0eWxlc01hcCIsImFwcGxpZWRTdHlsZXNNYXBXaXRoVXBkYXRlZENvbG9yVmFsdWVzIiwiT2JqZWN0Iiwia2V5cyIsInJlZHVjZSIsInVwZGF0ZWRTdHlsZXMiLCJzdHlsZUtleSIsImNvbG9yVmFsIiwiY29sb3IiLCJ0ZXh0U2hhZG93VmFsIiwidGV4dFNoYWRvdyIsInNwbGl0IiwidGlueWNvbG9yIiwidG9SZ2JTdHJpbmciLCJsZW5ndGgiLCJub1BzZXVkbyIsImhvdmVyIiwiZm9jdXMiLCJwbGFjZWhvbGRlciIsImJhc2UiLCJpbnZhbGlkIiwiZW1wdHkiLCJjb21wbGV0ZSIsImNvbnN0cnVjdG9yIiwiZWxlbWVudCIsImhhc0F0dHJpYnV0ZSIsInN0eWxlTWFwSlNPTiIsImdldEF0dHJpYnV0ZSIsInNldFN0eWxlc0Zyb21KU09OIiwiZG9jIiwib3duZXJEb2N1bWVudCIsIndpbiIsImRlZmF1bHRWaWV3IiwibXEiLCJsaXN0ZW5lciIsIm1hdGNoTWVkaWEiLCJNdXRhdGlvbk9ic2VydmVyIiwiaGFuZGxlTXV0YXRpb25PYnNlcnZlciIsIm9ic2VydmUiLCJhdHRyaWJ1dGVzIiwiZm9yRWFjaCIsImFkZExpc3RlbmVyIiwiZGlzcGF0Y2giLCJKU09OIiwicGFyc2UiLCJlIiwiZ2V0QXBwbGllZFN0eWxlcyIsImFwcGxpZWRTdHlsZXMiLCJzdHlsZXNNYXAiLCJtYXRjaGVzIiwibWVyZ2UiLCJtdXRhdGlvbkxpc3QiLCJtdXRhdGlvbiIsInR5cGUiLCJhdHRyaWJ1dGVOYW1lIiwidGFyZ2V0IiwiZGVzdHJveSIsImRpc2Nvbm5lY3QiLCJyZW1vdmVMaXN0ZW5lciJdLCJtYXBwaW5ncyI6Ijs7OzsrQkE2RUE7OztlQUFxQkE7Ozs4REE3RUg7bUVBQ0k7bUNBR2tCOytCQVNqQzs7Ozs7O0FBRVAsTUFBTUMsaUJBQWlCO0FBWXZCOzs7Q0FHQyxHQUVELE1BQU1DLHVCQUF1QjtJQUMzQkMsaUNBQWtCO0lBQ2xCQyxrQ0FBbUI7SUFDbkJDLCtCQUFnQjtJQUNoQkMsZ0NBQWlCO0lBQ2pCQyxtQ0FBb0I7SUFDcEJDLGtDQUFtQjtJQUNuQkMsaUNBQWtCO0NBQ25CO0FBRUQsTUFBTUMsd0JBR0RSLHFCQUFxQlMsR0FBRyxDQUFDLENBQUNDO0lBQzdCLE1BQU1DLFNBQVNDLDRDQUF5QixDQUFDRixhQUFhO0lBQ3RELElBQUlHO0lBQ0osSUFBSUM7SUFFSixpRUFBaUU7SUFDakUsSUFBSSxjQUFjSCxRQUFRO1FBQ3hCRSxPQUFPO1FBQ1BDLFFBQVFILE9BQU9JLFFBQVE7SUFDekI7SUFDQSxpRUFBaUU7SUFDakUsSUFBSSxjQUFjSixRQUFRO1FBQ3hCRSxPQUFPO1FBQ1BDLFFBQVFILE9BQU9LLFFBQVE7SUFDekI7SUFFQSxJQUFJSCxTQUFTSSxhQUFhSCxVQUFVRyxXQUFXO1FBQzdDLE1BQU0sSUFBSUMsTUFDUjtJQUVKO0lBRUEsT0FBTztRQUNMQyxNQUFNVDtRQUNOVSxPQUFPLENBQUMsQ0FBQyxFQUFFUCxLQUFLLEVBQUUsRUFBRUMsTUFBTSxHQUFHLENBQUM7SUFDaEM7QUFDRjtBQU1lLE1BQU1oQjtJQUNuQnVCLFNBQWdDSixVQUFVO0lBQzFDSyxXQUE0QkwsVUFBVTtJQUV0Q00sZUFJSyxFQUFFLENBQUM7SUFDUkMsVUFBbUI7UUFBQ0MsVUFBVSxLQUFPO0lBQUMsRUFBRTtJQUV4QyxPQUFPQyxxQ0FBcUMsQ0FDMUNDO1FBRUEsSUFBSSxDQUFDQSxrQkFBa0I7WUFDckIsT0FBTyxDQUFDO1FBQ1Y7UUFFQSxnRkFBZ0Y7UUFDaEYsTUFBTUMseUNBQXlDQyxPQUFPQyxJQUFJLENBQ3hESCxrQkFDQUksTUFBTSxDQUFzQixDQUFDQyxlQUFlQztZQUM1QyxvWUFBb1k7WUFDcFksTUFBTUMsV0FBV1AsZ0JBQWdCLENBQUNNLFNBQVMsQ0FBQ0UsS0FBSztZQUNqRCxNQUFNQyxnQkFDSixvWUFBb1k7WUFDcFlULGdCQUFnQixDQUFDTSxTQUFTLENBQUNJLFVBQVUsSUFDckMsb1lBQW9ZO1lBQ3BZVixnQkFBZ0IsQ0FBQ00sU0FBUyxDQUFDSSxVQUFVLENBQUNDLEtBQUssQ0FBQztZQUU5QyxvWUFBb1k7WUFDcFlOLGFBQWEsQ0FBQ0MsU0FBUyxHQUFHTixnQkFBZ0IsQ0FBQ00sU0FBUztZQUVwRCw4QkFBOEI7WUFDOUIsSUFBSUMsVUFBVTtnQkFDWkYsYUFBYSxDQUFDQyxTQUFTLENBQUNFLEtBQUssR0FBR0ksSUFBQUEsbUJBQVMsRUFBQ0wsVUFBVU0sV0FBVztZQUNqRTtZQUNBLDhEQUE4RDtZQUM5RCxJQUFJSixpQkFBaUJBLGNBQWNLLE1BQU0sR0FBRyxHQUFHO2dCQUM3Q1QsYUFBYSxDQUFDQyxTQUFTLENBQUNJLFVBQVUsR0FDaENELGFBQWEsQ0FBQyxFQUFFLEdBQUdHLElBQUFBLG1CQUFTLEVBQUNILGFBQWEsQ0FBQyxFQUFFLEVBQUVJLFdBQVc7WUFDOUQ7WUFFQSxPQUFPUjtRQUNULEdBQUcsQ0FBQztRQUVKLE1BQU1YLFNBQVM7WUFDYixHQUFHTyx1Q0FBdUNjLFFBQVE7WUFDbEQsVUFBVWQsdUNBQXVDZSxLQUFLO1lBQ3RELFVBQVVmLHVDQUF1Q2dCLEtBQUs7WUFDdEQsaUJBQWlCaEIsdUNBQXVDaUIsV0FBVztRQUNyRTtRQUVBLE9BQU87WUFDTEMsTUFBTXpCO1lBQ04wQixTQUFTMUI7WUFDVDJCLE9BQU8zQjtZQUNQNEIsVUFBVTVCO1FBQ1o7SUFDRixFQUFFO0lBRUY2QixZQUFZQyxPQUFnQixFQUFFM0IsT0FBZ0IsQ0FBRTtRQUM5QyxJQUFJLENBQUNBLE9BQU8sR0FBR0E7UUFDZixJQUFJMkIsUUFBUUMsWUFBWSxDQUFDckQsaUJBQWlCO1lBQ3hDLE1BQU1zRCxlQUFlRixRQUFRRyxZQUFZLENBQUN2RDtZQUMxQyxJQUFJc0QsY0FBYztnQkFDaEIsSUFBSSxDQUFDRSxpQkFBaUIsQ0FBQ0Y7Z0JBRXZCLE1BQU1HLE1BQU1MLFFBQVFNLGFBQWE7Z0JBQ2pDLE1BQU1DLE1BQU1GLElBQUlHLFdBQVc7Z0JBRTNCLElBQUksQ0FBQ3BDLFlBQVksR0FBR2Ysc0JBQXNCQyxHQUFHLENBQUMsQ0FBQ21ELEtBQVEsQ0FBQTt3QkFDckQsR0FBR0EsRUFBRTt3QkFDTCx5REFBeUQ7d0JBQ3pEQyxVQUFVSCxJQUFJSSxVQUFVLENBQUNGLEdBQUd4QyxLQUFLO29CQUNuQyxDQUFBO2dCQUVBLHlEQUF5RDtnQkFDekQsSUFBSSxDQUFDRSxRQUFRLEdBQUcsSUFBSW9DLElBQUlLLGdCQUFnQixDQUFDLElBQUksQ0FBQ0Msc0JBQXNCO2dCQUNwRSxJQUFJLENBQUMxQyxRQUFRLENBQUMyQyxPQUFPLENBQUNkLFNBQVM7b0JBQzdCZSxZQUFZO2dCQUNkO2dCQUVBLElBQUksQ0FBQzNDLFlBQVksQ0FBQzRDLE9BQU8sQ0FBQyxDQUFDLEVBQUNOLFFBQVEsRUFBQztvQkFDbkNBLFNBQVNPLFdBQVcsQ0FBQyxJQUFJLENBQUNDLFFBQVE7Z0JBQ3BDO2dCQUVBLElBQUksQ0FBQ0EsUUFBUTtZQUNmO1FBQ0Y7SUFDRjtJQUVBZCxrQkFBa0JGLFlBQW9CLEVBQUU7UUFDdEMsSUFBSTtZQUNGLElBQUksQ0FBQ2hDLE1BQU0sR0FBR2lELEtBQUtDLEtBQUssQ0FBQ2xCO1FBQzNCLEVBQUUsT0FBT21CLEdBQVE7WUFDZixJQUFJLENBQUNuRCxNQUFNLEdBQUcsQ0FBQztRQUNqQjtJQUNGO0lBRUFvRCxtQkFBbUI7UUFDakIsSUFBSSxDQUFDLElBQUksQ0FBQ3BELE1BQU0sRUFBRTtZQUNoQjtRQUNGO1FBRUEsTUFBTUEsU0FBUyxJQUFJLENBQUNBLE1BQU07UUFFMUIsTUFBTXFELGdCQUFrQyxJQUFJLENBQUNuRCxZQUFZLENBQUNRLE1BQU0sQ0FHOUQsQ0FBQzRDLFdBQVcsRUFBQ2QsUUFBUSxFQUFFMUMsSUFBSSxFQUFDLEdBQzFCMEMsU0FBU2UsT0FBTyxHQUFHQyxJQUFBQSxjQUFLLEVBQUNGLFdBQVd0RCxNQUFNLENBQUNGLEtBQUssSUFBSXdELFdBQ3RELENBQUM7UUFHSCxPQUFPRDtJQUNUO0lBRUFMLFdBQVc7UUFDVCxJQUFJLENBQUM3QyxPQUFPLENBQUNDLFFBQVEsQ0FBQyxJQUFJLENBQUNnRCxnQkFBZ0I7SUFDN0MsRUFBRTtJQUVGVCx5QkFBeUIsQ0FBQ2M7UUFDeEJBLGFBQWFYLE9BQU8sQ0FBQyxDQUFDWTtZQUNwQixJQUNFQSxTQUFTQyxJQUFJLEtBQUssZ0JBQ2xCRCxTQUFTRSxhQUFhLEtBQUtsRixrQkFDM0JnRixTQUFTRyxNQUFNLENBQUM5QixZQUFZLENBQUNyRCxpQkFDN0I7Z0JBQ0EsTUFBTXNELGVBQWUwQixTQUFTRyxNQUFNLENBQUM1QixZQUFZLENBQUN2RDtnQkFFbEQsSUFBSXNELGNBQWM7b0JBQ2hCLElBQUksQ0FBQ0UsaUJBQWlCLENBQUNGO29CQUN2QixJQUFJLENBQUNnQixRQUFRO2dCQUNmO1lBQ0Y7UUFDRjtJQUNGLEVBQUU7SUFFRmMsVUFBVTtRQUNSLElBQUksSUFBSSxDQUFDN0QsUUFBUSxFQUFFO1lBQ2pCLElBQUksQ0FBQ0EsUUFBUSxDQUFDOEQsVUFBVTtRQUMxQjtRQUNBLElBQUksQ0FBQzdELFlBQVksQ0FBQzRDLE9BQU8sQ0FBQyxDQUFDLEVBQUNOLFFBQVEsRUFBQztZQUNuQ0EsU0FBU3dCLGNBQWMsQ0FBQyxJQUFJLENBQUNoQixRQUFRO1FBQ3ZDO0lBQ0Y7QUFDRiJ9

}),
84303: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/* globals document, window, Element, HTMLElement, CustomEvent, HTMLFormElement, HTMLInputElement, HTMLSelectElement, HTMLAnchorElement*/ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    register: function() {
        return register;
    }
});
const _client = __webpack_require__(22805);
const _graphqltag = /*#__PURE__*/ _interop_require_default(__webpack_require__(28160));
const _constants = __webpack_require__(10873);
const _constants1 = __webpack_require__(7462);
const _constants2 = __webpack_require__(29197);
const _constants3 = __webpack_require__(48935);
const _utils = __webpack_require__(73392);
const _get = /*#__PURE__*/ _interop_require_default(__webpack_require__(24738));
const _site = __webpack_require__(32949);
const _commerceUtils = __webpack_require__(54556);
const _RenderingUtils = __webpack_require__(86078);
const _CurrencyUtils = __webpack_require__(60937);
const _debug = /*#__PURE__*/ _interop_require_default(__webpack_require__(85986));
const _forEach = /*#__PURE__*/ _interop_require_default(__webpack_require__(32397));
const _find = /*#__PURE__*/ _interop_require_default(__webpack_require__(19777));
const _rendering = __webpack_require__(91898);
const _addToCartStore = __webpack_require__(21465);
const _PillGroup = __webpack_require__(14155);
const _siteBundles = __webpack_require__(66551);
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const { fetchFromStore, updateStore, addStoreWatcher } = (0, _addToCartStore.createNewStore)();
const getInstanceId = (form)=>{
    const instanceId = form.getAttribute(_constants.DATA_ATTR_COMMERCE_PRODUCT_ID);
    if (instanceId) {
        return instanceId;
    } else {
        throw new Error('Incorrect form instance provided, has no instance ID');
    }
};
function trackAddToCartUsage(skuId, count, itemPrice) {
    const { decimalValue, unit } = itemPrice;
    if (typeof fbq === 'function') {
        fbq('track', 'AddToCart', {
            value: count * decimalValue,
            currency: unit,
            content_ids: [
                skuId
            ],
            content_type: 'product',
            contents: [
                {
                    id: skuId,
                    quantity: count,
                    item_price: decimalValue
                }
            ]
        });
    }
    if (typeof gtag === 'function') {
        gtag('event', 'add_to_cart', {
            items: [
                {
                    id: skuId,
                    quantity: count,
                    price: decimalValue
                }
            ]
        });
    }
}
const addToCartMutation = (0, _graphqltag.default)`
  mutation AddToCart($skuId: String!, $count: Int!, $buyNow: Boolean) {
    ecommerceAddToCart(sku: $skuId, count: $count, buyNow: $buyNow) {
      ok
      itemId
      itemCount
      itemPrice {
        unit
        decimalValue
      }
    }
  }
`;
const collectionsQuery = `
      collections {
        c_sku_ {
          id
          items(filter: {f_product_: {eq: $productId}}) {
            id
            f_price_ {
              value
              unit
            }
            f_weight_
            f_width_
            f_length_
            f_height_
            f_sku_
            f_main_image_4dr {
              url
            }
            f_more_images_4dr {
              url
              alt
              file {
                origFileName
              }
            }
            f_sku_values_3dr {
              value {
                id
              }
              property {
                id
              }
            }
            inventory {
              type
              quantity
            }
            f_compare_at_price_7dr10dr {
              unit
              value
            }
            f_ec_sku_billing_method_2dr6dr14dr
          }
        }
        c_product_ {
          id
          items(filter: {id: {eq: $productId}}) {
            id
            f_default_sku_7dr {
              id
            }
            f_ec_product_type_2dr10dr {
              name
            }
          }
        }
      }`;
const getAllVariants = (0, _graphqltag.default)`
  query FetchAllVariants($productId: BasicId!) {
    database {
      id
      ${collectionsQuery}
    }
  }
`;
const getAllVariantsAndMemberships = (0, _graphqltag.default)`
  query FetchAllVariantsAndMemberships($productId: BasicId!) {
    database {
      id
      ${collectionsQuery}
      commerceMemberships(productIds: [$productId]) {
        productId
        orderId
        active
      }
    }
  }
`;
// @ts-expect-error - TS7006 - Parameter 'node' implicitly has an 'any' type.
const findCollectionItemWrapper = (node)=>{
    const dynamoItemSelector = `.${_constants3.CLASS_NAME_DYNAMIC_LIST_ITEM}:not(.${_constants3.CLASS_NAME_DYNAMIC_LIST_REPEATER_ITEM})`;
    return $(node).closest(dynamoItemSelector)[0] || document.body;
};
const addToCartFormEventTargetMatcher = (event)=>{
    if (event != null && event.target instanceof HTMLElement && event.target.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_ADD_TO_CART_FORM) {
        return event.target;
    }
    return false;
};
const getErrorType = (error)=>{
    const defaultErrorType = 'general';
    if (_client.CombinedGraphQLErrors.is(error) && error.errors.length > 0 && error.errors[0] && 'code' in error.errors[0]) {
        switch(error.errors[0].code){
            case 'OutOfInventory':
                return 'quantity';
            case 'MixedCartError':
                return 'mixed-cart';
            default:
                return defaultErrorType;
        }
    }
    return defaultErrorType;
};
const handleAtcSubmit = (event, apolloClient)=>{
    event.preventDefault();
    const eventTarget = event.currentTarget;
    if (!(eventTarget instanceof HTMLFormElement && eventTarget.parentNode instanceof Element) || eventTarget.hasAttribute(_constants.ADD_TO_CART_LOADING)) {
        return;
    }
    const { parentNode } = eventTarget;
    const inputButton = eventTarget.querySelector('input[type="submit"]');
    if (!(0, _commerceUtils.isProtocolHttps)()) {
        window.alert('This site is currently unsecured so you cannot add products to your cart.');
        return;
    }
    if (!(inputButton instanceof HTMLInputElement)) {
        return;
    }
    const errorElement = parentNode.querySelector(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_ERROR}"]`);
    if (errorElement instanceof Element) {
        // @ts-expect-error - TS2339 - Property 'style' does not exist on type 'Element'.
        errorElement.style.display = 'none';
    }
    eventTarget.setAttribute(_constants.ADD_TO_CART_LOADING, '');
    const previousButtonValue = inputButton.value;
    // We moved the data here to the actual button node but will fallback to old value on the wrapper if not set
    const loadingTextFromButton = inputButton.getAttribute(_constants.DATA_ATTR_LOADING_TEXT);
    inputButton.value = loadingTextFromButton ? loadingTextFromButton : eventTarget.getAttribute(_constants.DATA_ATTR_LOADING_TEXT) || '';
    inputButton.setAttribute('aria-busy', 'true');
    const skuId = fetchFromStore(getInstanceId(eventTarget), 'selectedSku') || '';
    const formData = (0, _commerceUtils.formToObject)(eventTarget);
    const formCount = formData[_constants.NODE_NAME_COMMERCE_ADD_TO_CART_QUANTITY_INPUT];
    const count = formCount ? parseInt(formCount, 10) : 1;
    // if no SKU id, then all options need to be selected
    // this is only shown for pills, as dropdowns will be caught by reportValidity above
    if (!skuId && errorElement instanceof Element) {
        eventTarget.removeAttribute(_constants.ADD_TO_CART_LOADING);
        inputButton.value = previousButtonValue;
        inputButton.setAttribute('aria-busy', 'false');
        const errorMsg = errorElement.querySelector(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_ADD_TO_CART_ERROR}"]`);
        if (!errorMsg) {
            return;
        }
        const errorText = errorMsg.getAttribute((0, _constants.getATCErrorMessageForType)('select-all-options')) || 'Please select an option in each set.';
        errorMsg.textContent = errorText;
        // @ts-expect-error - TS2339 - Property 'style' does not exist on type 'Element'.
        errorElement.style.removeProperty('display');
        return;
    }
    // Redirect to sign up if the purchase requires a user session and there is none
    const requiresUserSession = fetchFromStore(getInstanceId(eventTarget), 'requiresUserSession');
    const hasUserSession = document.cookie.split(';').some((cookie)=>cookie.indexOf(_constants1.LOGGEDIN_COOKIE_NAME) > -1);
    if (requiresUserSession && !hasUserSession) {
        (0, _siteBundles.redirectWithUsrdir)(`/${_constants1.USYS_PAGE_SETTINGS.signup.slug}`);
        return;
    }
    apolloClient.mutate({
        mutation: addToCartMutation,
        variables: {
            skuId,
            count,
            buyNow: false
        }
    }).then(({ data })=>{
        (0, _commerceUtils.addLoadingCallback)(()=>{
            eventTarget.removeAttribute(_constants.ADD_TO_CART_LOADING);
            inputButton.value = previousButtonValue;
            inputButton.setAttribute('aria-busy', 'false');
            const cartElements = document.querySelectorAll(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_CART_WRAPPER}"][${_constants.DATA_ATTR_OPEN_PRODUCT}]`);
            cartElements.forEach((cart)=>{
                const evt = new CustomEvent(_constants.CHANGE_CART_EVENT, {
                    bubbles: true,
                    detail: {
                        open: true
                    }
                });
                cart.dispatchEvent(evt);
            });
        });
        (0, _commerceUtils.triggerRender)(null);
        // @ts-expect-error - TS18046: data is of type unknown
        const itemPrice = data.ecommerceAddToCart.itemPrice || {};
        trackAddToCartUsage(skuId, count, itemPrice);
    }).catch((error)=>{
        eventTarget.removeAttribute(_constants.ADD_TO_CART_LOADING);
        inputButton.value = previousButtonValue;
        inputButton.setAttribute('aria-busy', 'false');
        if (errorElement) {
            // @ts-expect-error - TS2339 - Property 'style' does not exist on type 'Element'.
            errorElement.style.removeProperty('display');
            const errorMsg = errorElement.querySelector(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_ADD_TO_CART_ERROR}"]`);
            if (!errorMsg) {
                return;
            }
            const errorMessage = (0, _constants.getATCErrorMessageForType)(getErrorType(error));
            const errorText = errorMsg.getAttribute(errorMessage) || '';
            errorMsg.textContent = errorText;
        }
        _debug.default.error(error);
        (0, _commerceUtils.triggerRender)(null);
    });
};
const addToCartOptionSelectEventTargetMatcher = (event)=>{
    if (event != null && event.target instanceof HTMLElement && event.target.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_SELECT) {
        return event.target;
    }
    return false;
};
const queryAllWithoutOtherItemWrapperContents = (collectionItemWrapper, selector)=>{
    return Array.from(collectionItemWrapper.querySelectorAll(selector)).filter((node)=>findCollectionItemWrapper(node) === collectionItemWrapper);
};
const queryAllReferenceRepeaters = (collectionItemWrapper)=>{
    return Array.from(collectionItemWrapper.querySelectorAll(`.${_constants3.CLASS_NAME_DYNAMIC_LIST_REPEATER_REF}`));
};
const removeClass = (element, className)=>{
    element && element.classList instanceof DOMTokenList && element.classList.remove(className);
    if (element.classList.length === 0) {
        element.removeAttribute('class');
    }
};
const showElement = (element)=>removeClass(element, 'w-dyn-hide');
const hideElement = (element)=>element && element.classList instanceof DOMTokenList && element.classList.add('w-dyn-hide');
const updateEmptyStateVisibility = (node, fn1, fn2)=>{
    const emptyStateNodes = Array.from(node.querySelectorAll('.w-dyn-empty'));
    const emptyStateMoreImageFieldNodes = emptyStateNodes.filter((n)=>{
        // @ts-expect-error - TS18046 - 'n' is of type 'unknown'.
        const itemsList = n.parentElement.querySelector('.w-dyn-items');
        return itemsList.dataset && itemsList.dataset.wfCollection && itemsList.dataset.wfCollection === 'f_more_images_4dr';
    });
    return emptyStateMoreImageFieldNodes && emptyStateMoreImageFieldNodes.map((n)=>{
        fn1(n);
        // @ts-expect-error - TS18046 - 'n' is of type 'unknown'.
        const itemsList = n.parentElement.querySelector('.w-dyn-items');
        if (itemsList && itemsList.dataset && itemsList.dataset.wfCollection && itemsList.dataset.wfCollection === 'f_more_images_4dr' && itemsList.classList instanceof DOMTokenList && itemsList.parentElement.classList.contains(_constants3.CLASS_NAME_DYNAMIC_LIST_REPEATER_REF)) {
            return fn2(itemsList);
        }
    });
};
const showEmptyStateAndHideItemsList = (node)=>{
    updateEmptyStateVisibility(node, showElement, hideElement);
};
const hideEmptyStateAndShowItemsList = (node)=>{
    updateEmptyStateVisibility(node, hideElement, showElement);
};
const updateDropdownsOnPage = (instanceId)=>(newSkuValues)=>{
        const dropdownsForProduct = Array.from(document.querySelectorAll(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_LIST}"][${_constants.DATA_ATTR_COMMERCE_PRODUCT_ID}="${instanceId}"] [${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_SELECT}"]`));
        for (const optionSetId of Object.keys(newSkuValues)){
            const optionSetValue = newSkuValues[optionSetId];
            const matchingDropdownsForOptionSet = dropdownsForProduct.filter((d)=>d.getAttribute(_constants.DATA_ATTR_COMMERCE_OPTION_SET_ID) === optionSetId);
            for (const dropdown of matchingDropdownsForOptionSet){
                dropdown.value = String(optionSetValue);
            }
        }
    };
const disableOptionsOnChange = ({ apolloClient, productId, optionSets, optionSetId })=>{
    apolloClient.query({
        query: getAllVariants,
        variables: {
            productId
        }
    }).then(({ data })=>{
        // That's a lot of question marks! What do they mean?
        // The `?.` is optional chaining, which lets you safely access deeply nested properties,
        // with it bailing out if the property doesn't exist: https://github.com/TC39/proposal-optional-chaining
        // The `??` is nullish coalescing, which is similar to `||` when wanting to ensure something is defined,
        // but only tripping if the value it's checking `null` or `undefined`, to prevent odd `false` and `false`-ish tripping false positives
        // https://github.com/tc39/proposal-nullish-coalescing
        // @ts-expect-error - TS2339: Property database does not exist on type {}
        const items = data?.database?.collections?.c_sku_?.items ?? [];
        // Get all the data we're going to use, we need to know which selectors were previously selected, which are currently
        // selected vs. which are not, and the most recently updated one
        const optionSetData = optionSets.reduce((parsedSelectorOptionSets, selectorOptionSet)=>{
            if (selectorOptionSet.value) {
                parsedSelectorOptionSets.selectedOptionSets.push(selectorOptionSet);
                if (selectorOptionSet.getAttribute(_constants.DATA_ATTR_COMMERCE_OPTION_SET_ID) === optionSetId) {
                    parsedSelectorOptionSets.recentlySelectedOptionSet = selectorOptionSet;
                } else {
                    parsedSelectorOptionSets.previouslySelectedOptionSets.push(selectorOptionSet);
                }
            } else {
                parsedSelectorOptionSets.unselectedOptionSets.push(selectorOptionSet);
            }
            return parsedSelectorOptionSets;
        }, {
            selectedOptionSets: [],
            recentlySelectedOptionSet: undefined,
            previouslySelectedOptionSets: [],
            unselectedOptionSets: []
        });
        let { selectedOptionSets, unselectedOptionSets } = optionSetData;
        const { recentlySelectedOptionSet, previouslySelectedOptionSets } = optionSetData;
        // Deselect previously selected option sets if they are uncompatible with the current selection.
        if (recentlySelectedOptionSet && selectedOptionSets.length > 1) {
            const recentlySelectedOptionSetValue = recentlySelectedOptionSet.value;
            (0, _forEach.default)(previouslySelectedOptionSets, (previouslySelectedOptionSet)=>{
                const optionSetValueCombinationWithMostRecent = [
                    recentlySelectedOptionSetValue,
                    previouslySelectedOptionSet.value
                ];
                // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
                const someAvailableItem = items.some((item)=>{
                    if (item.inventory.type === _constants.INVENTORY_TYPE_FINITE && item.inventory.quantity <= 0) {
                        return false;
                    }
                    const itemMappedBySkuValues = item.f_sku_values_3dr.map(// @ts-expect-error - TS7006 - Parameter 'skuValues' implicitly has an 'any' type.
                    (skuValues)=>skuValues.value.id);
                    return optionSetValueCombinationWithMostRecent.every((value)=>itemMappedBySkuValues.includes(value));
                });
                if (!someAvailableItem) {
                    previouslySelectedOptionSet.selectedIndex = 0;
                    selectedOptionSets = selectedOptionSets.filter(// @ts-expect-error - TS7006 - Parameter 'selectedOptionSet' implicitly has an 'any' type.
                    (selectedOptionSet)=>selectedOptionSet.getAttribute(_constants.DATA_ATTR_COMMERCE_OPTION_SET_ID) !== previouslySelectedOptionSet.getAttribute(_constants.DATA_ATTR_COMMERCE_OPTION_SET_ID));
                    unselectedOptionSets = unselectedOptionSets.concat(previouslySelectedOptionSet);
                }
            });
        }
        // For the (remaining after above deselection) selected ones we want to disable any options that simply have no possible stock
        (0, _forEach.default)(selectedOptionSets, (optionSet)=>{
            const id = optionSet.getAttribute(_constants.DATA_ATTR_COMMERCE_OPTION_SET_ID);
            (0, _forEach.default)(optionSet.options, (option)=>{
                if (!option.value) {
                    option.enabled = true;
                } else {
                    disableVariantsWithNoStock(items, id, option);
                }
            });
        });
        // For the remaining unselected ones we want to disable any options that aren't possible given current selections
        (0, _forEach.default)(unselectedOptionSets, (optionSet)=>{
            const id = optionSet.getAttribute(_constants.DATA_ATTR_COMMERCE_OPTION_SET_ID);
            disableVariantsWithNoStockForRemainingSelections(items, selectedOptionSets, optionSet, id);
        });
    });
};
const handleAtcOptionSelectChange = (event, apolloClient)=>{
    const eventTarget = event.currentTarget;
    if (!(eventTarget instanceof HTMLSelectElement)) {
        return;
    }
    // @ts-expect-error - TS2339 - Property 'jQuery' does not exist on type 'Window & typeof globalThis'.
    const $1 = window.jQuery;
    const optionSetId = eventTarget.getAttribute(_constants.DATA_ATTR_COMMERCE_OPTION_SET_ID);
    const optionSetValue = eventTarget.value;
    const optionListElement = $1(eventTarget).closest(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_LIST}"]`)[0];
    const addToCartForm = $1(eventTarget).closest(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_FORM}"]`)[0];
    if (!(optionListElement instanceof Element) || !optionSetId || !(addToCartForm instanceof HTMLFormElement)) {
        return;
    }
    const instanceId = getInstanceId(addToCartForm);
    const currentSkuValues = fetchFromStore(instanceId, 'skuValues');
    const newSkuValues = {
        ...currentSkuValues,
        [optionSetId]: optionSetValue
    };
    updateStore(instanceId, {
        skuValues: newSkuValues
    });
    const productId = optionListElement && optionListElement.getAttribute(_constants.DATA_ATTR_COMMERCE_PRODUCT_ID);
    const allVariantSelectorsInCartForm = (0, _commerceUtils.findAllElementsByNodeType)(_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_SELECT, addToCartForm);
    if (productId && allVariantSelectorsInCartForm.length > 0) {
        disableOptionsOnChange({
            apolloClient,
            productId,
            optionSets: allVariantSelectorsInCartForm,
            optionSetId
        });
    }
};
const updateSkuBindings = (binding, node, newSkuItem)=>{
    if ([
        'f_weight_',
        'f_width_',
        'f_length_',
        'f_height_',
        'f_sku_'
    ].some((slug)=>binding.from === slug)) {
        node[binding.to === 'innerHTML' ? 'innerText' : binding.to] = newSkuItem[binding.from] || '';
        updateTextNodeVisibility(node);
    }
    if (binding.from === 'f_price_' && newSkuItem.f_price_) {
        node[binding.to === 'innerHTML' ? 'innerText' : binding.to] = (0, _CurrencyUtils.renderPriceFromSettings)(newSkuItem.f_price_, // @ts-expect-error - TS2339 - Property '__WEBFLOW_CURRENCY_SETTINGS' does not exist on type 'Window & typeof globalThis'.
        window.__WEBFLOW_CURRENCY_SETTINGS);
        updateTextNodeVisibility(node);
    }
    if (binding.from === 'f_compare_at_price_7dr10dr') {
        if (newSkuItem.f_compare_at_price_7dr10dr) {
            // if compare-at is available, apply the binding
            node[binding.to === 'innerHTML' ? 'innerText' : binding.to] = (0, _CurrencyUtils.renderPriceFromSettings)(newSkuItem.f_compare_at_price_7dr10dr, // @ts-expect-error - TS2339 - Property '__WEBFLOW_CURRENCY_SETTINGS' does not exist on type 'Window & typeof globalThis'.
            window.__WEBFLOW_CURRENCY_SETTINGS);
        } else {
            // otherwise, we need to specifically clear it; it could have been set
            // by a previously-selected product option
            node[binding.to === 'innerHTML' ? 'innerText' : binding.to] = '';
        }
        updateTextNodeVisibility(node);
    }
    if (binding.from === 'f_main_image_4dr' || binding.from === 'f_main_image_4dr.url') {
        const mainImage = (0, _get.default)(newSkuItem, binding.from.replace(/\.url$/, ''));
        if (binding.to === 'style.background-image') {
            node.style.backgroundImage = mainImage && mainImage.url ? `url("${mainImage.url}")` : 'none';
        } else if (binding.to === 'media') {
            if (node.classList.contains('w-lightbox')) {
                updateLightboxJson(node, mainImage);
            }
        } else if (binding.to === 'src') {
            if (mainImage && mainImage.url) {
                node.src = mainImage.url;
                (0, _RenderingUtils.removeWDynBindEmptyClass)(node);
                // Temporary solution for responsive images for product variants
                if (node.hasAttribute('srcset')) {
                    node.removeAttribute('srcset');
                }
            } else {
                node.removeAttribute('src');
                node.classList.add(_constants2.CLASS_NAME_W_DYN_BIND_EMPTY);
            }
        }
    }
    if (binding.from === 'f_more_images_4dr' || binding.from.startsWith('f_more_images_4dr.')) {
        const image = (0, _get.default)(newSkuItem, binding.from.replace(/\.url$/, ''));
        if (binding.to === 'style.background-image') {
            node.style.backgroundImage = image ? `url("${image.url}")` : 'none';
        } else if (binding.to === 'media') {
            if (node.classList.contains('w-lightbox')) {
                updateLightboxJson(node, image);
            }
        } else if (binding.to === 'src') {
            if (image && image.url) {
                node.src = image.url;
                node.alt = image.alt || '';
                (0, _RenderingUtils.removeWDynBindEmptyClass)(node);
                // Temporary solution for responsive images for product variants
                if (node.hasAttribute('srcset')) {
                    node.removeAttribute('srcset');
                    node.removeAttribute('sizes');
                }
            } else {
                node.removeAttribute('src');
                node.removeAttribute('srcset');
                node.removeAttribute('sizes');
                node.removeAttribute('alt');
                node.classList.add(_constants2.CLASS_NAME_W_DYN_BIND_EMPTY);
            }
        }
    }
    if (binding.from === 'ecSkuInventoryQuantity') {
        const inventoryQuantity = (0, _get.default)(newSkuItem, 'inventory.type') === 'infinite' ? null : (0, _get.default)(newSkuItem, 'inventory.quantity');
        node[binding.to === 'innerHTML' ? 'innerText' : binding.to] = inventoryQuantity;
        updateTextNodeVisibility(node);
    }
};
const updatePageWithNewSkuValuesData = (instanceId, apolloClient)=>(newSkuValues)=>{
        // @ts-expect-error - TS2339 - Property 'jQuery' does not exist on type 'Window & typeof globalThis'.
        const $1 = window.jQuery;
        apolloClient.query({
            query: getAllVariants,
            variables: {
                productId: instanceId
            }
        }).then(({ data })=>{
            // @ts-expect-error - TS2339: Property database does not exist on type {}
            const items = data?.database?.collections?.c_sku_?.items ?? [];
            // @ts-expect-error - TS2339: Property database does not exist on type {}
            const products = data?.database?.collections?.c_product_?.items ?? [];
            const productType = products[0] ? products[0].f_ec_product_type_2dr10dr.name : 'Advanced';
            const newSkuItem = (0, _find.default)(items, (item)=>{
                if (item.f_sku_values_3dr && Array.isArray(item.f_sku_values_3dr)) {
                    const skuValues = (0, _site.simplifySkuValues)(item.f_sku_values_3dr);
                    return Object.keys(newSkuValues).every((key)=>newSkuValues[key] === skuValues[key]);
                }
            });
            if (newSkuItem && newSkuItem.id) {
                updateStore(instanceId, {
                    selectedSku: newSkuItem.id
                });
                if (newSkuItem['f_ec_sku_billing_method_2dr6dr14dr'] === 'subscription' || productType === 'Membership') {
                    updateStore(instanceId, {
                        requiresUserSession: true
                    });
                }
                const formsForProduct = document.querySelectorAll(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_FORM}"][${_constants.DATA_ATTR_COMMERCE_PRODUCT_ID}="${instanceId}"]`);
                Array.from(formsForProduct).forEach((addToCartForm)=>{
                    const collectionItemWrapper = findCollectionItemWrapper(addToCartForm);
                    const referenceRepeaters = queryAllReferenceRepeaters(collectionItemWrapper);
                    // Update the state of the buy now button text to handle subscription
                    const buyNowButton = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_BUY_NOW_BUTTON, addToCartForm);
                    if (buyNowButton) {
                        if (newSkuItem['f_ec_sku_billing_method_2dr6dr14dr'] === 'subscription') {
                            const addToCartButton = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_BUTTON, addToCartForm);
                            const buyNowSubscriptionText = buyNowButton.getAttribute(_constants.DATA_ATTR_SUBSCRIPTION_TEXT) || 'Subscribe now';
                            hideElement(addToCartButton);
                            buyNowButton.innerText = buyNowSubscriptionText;
                        } else {
                            const buyNowDefaultText = buyNowButton.getAttribute(_constants.DATA_ATTR_DEFAULT_TEXT) || 'Buy now';
                            buyNowButton.innerText = buyNowDefaultText;
                        }
                    }
                    const moreImagesFieldLength = newSkuItem.f_more_images_4dr && newSkuItem.f_more_images_4dr.length || 0;
                    if (referenceRepeaters.length > 0) {
                        referenceRepeaters.forEach((referenceRepeater)=>{
                            // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'Element'.
                            (0, _rendering.renderTree)(referenceRepeater, {
                                data: newSkuItem
                            });
                            if (moreImagesFieldLength > 0) {
                                hideEmptyStateAndShowItemsList(referenceRepeater);
                            } else {
                                showEmptyStateAndHideItemsList(referenceRepeater);
                            }
                        });
                    }
                    const skuBoundNodes = queryAllWithoutOtherItemWrapperContents(collectionItemWrapper, `[${_constants.WF_SKU_BINDING_DATA_KEY}]`);
                    (0, _forEach.default)(skuBoundNodes, (node)=>{
                        // @ts-expect-error - TS18046 - 'node' is of type 'unknown'.
                        const skuBindingsData = node.getAttribute(_constants.WF_SKU_BINDING_DATA_KEY);
                        if (skuBindingsData) {
                            const skuBindings = (0, _commerceUtils.safeParseJson)(skuBindingsData);
                            if (Array.isArray(skuBindings)) {
                                skuBindings.forEach((binding)=>updateSkuBindings(binding, node, newSkuItem));
                            }
                        }
                    });
                    const skuConditionBoundNodes = queryAllWithoutOtherItemWrapperContents(collectionItemWrapper, `[${_constants.WF_SKU_CONDITION_DATA_KEY}]`);
                    (0, _forEach.default)(skuConditionBoundNodes, (node)=>{
                        const conditionData = (0, _commerceUtils.safeParseJson)(// @ts-expect-error - TS18046 - 'node' is of type 'unknown'.
                        node.getAttribute(_constants.WF_SKU_CONDITION_DATA_KEY));
                        if (conditionData) {
                            (0, _rendering.applySkuBoundConditionalVisibility)({
                                conditionData,
                                newSkuItem,
                                // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'Element'.
                                node
                            });
                        }
                    });
                    const errorElement = $1(collectionItemWrapper).siblings(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_ERROR}"]`)[0];
                    if (errorElement instanceof Element) {
                        // @ts-expect-error - TS2339 - Property 'style' does not exist on type 'Element'.
                        errorElement.style.display = 'none';
                    }
                });
                // In case there are lightboxes bound, we need to initialize the events again after each script
                // was updated with the right data in updateSkuBindings
                if (window.Webflow.require('lightbox')) {
                    window.Webflow.require('lightbox').ready();
                }
            } else {
                // if we can't find a valid SKU, we've deselected one of the variant selectors
                // as such, we need to clear the selected SKU in the store
                updateStore(instanceId, {
                    selectedSku: ''
                });
            }
        });
    };
const updateSkuValuesOnPillSelect = (instanceId, apolloClient)=>// @ts-expect-error - TS7031 - Binding element 'optionId' implicitly has an 'any' type. | TS7031 - Binding element 'optionSetId' implicitly has an 'any' type. | TS7031 - Binding element 'groups' implicitly has an 'any' type.
    ({ optionId, optionSetId, groups })=>{
        const currentSkuValues = fetchFromStore(instanceId, 'skuValues');
        const newSkuValues = {
            ...currentSkuValues,
            [optionSetId]: optionId
        };
        updateStore(instanceId, {
            skuValues: newSkuValues
        });
        disableOptionsOnChange({
            apolloClient,
            productId: instanceId,
            optionSets: Object.values(groups),
            optionSetId
        });
    };
const handleAtcPageLoad = (event, apolloClient, stripeStore)=>{
    if (!(event instanceof CustomEvent && event.type === _constants.RENDER_TREE_EVENT)) {
        return;
    }
    const addToCartForms = document.querySelectorAll(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_FORM}"]`);
    // allow pills to work only in preview
    if (window.Webflow.env('preview')) {
        if (event.detail.isInitial) {
            (0, _forEach.default)(addToCartForms, (addToCartForm)=>{
                // set up pill groups
                const groups = new _PillGroup.PillGroups(// @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
                addToCartForm, ({ optionId, optionSetId })=>{
                    groups.setSelectedPillsForSkuValues({
                        [optionSetId]: optionId
                    });
                });
                groups.init();
            });
        }
        return;
    }
    // otherwise, return for designer
    if (window.Webflow.env('design')) {
        return;
    }
    (0, _forEach.default)(addToCartForms, (addToCartForm)=>{
        const addToCartButton = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_BUTTON, addToCartForm);
        // If this form has an add to cart button, set the `aria-haspopup` to `dialog` or `false`
        // depending on at least one Cart element having the setting for "Open when product is added"
        if (addToCartButton) {
            const cartElementsThatOpenOnAdd = document.querySelectorAll(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_CART_WRAPPER}"][${_constants.DATA_ATTR_OPEN_PRODUCT}]`);
            addToCartButton.setAttribute('aria-haspopup', cartElementsThatOpenOnAdd.length > 0 ? 'dialog' : 'false');
        }
        const buyNowButton = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_BUY_NOW_BUTTON, addToCartForm);
        // Hide the Buy now button if Stripe is not connected
        if (stripeStore && !stripeStore.isInitialized()) {
            if (buyNowButton) {
                hideElement(buyNowButton);
            }
        }
        // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLFormElement'.
        const instanceId = getInstanceId(addToCartForm);
        if (event.detail.isInitial) {
            // only set the selected SKU from the DOM on the initial render event, as after that we want to
            // rely on the store as the source of truth. without this, the selected SKU could get reset on any render
            updateStore(instanceId, {
                // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string | undefined'.
                selectedSku: addToCartForm instanceof Element ? addToCartForm.getAttribute(_constants.DATA_ATTR_COMMERCE_SKU_ID) : ''
            });
            // add watcher for sku values change to update the page as needed
            addStoreWatcher(instanceId, 'skuValues', updatePageWithNewSkuValuesData(instanceId, apolloClient));
            // add watcher for dropdowns to update on sku change
            addStoreWatcher(instanceId, 'skuValues', updateDropdownsOnPage(instanceId));
            // set up pill groups
            // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
            if (_PillGroup.PillGroups.hasPillGroups(addToCartForm)) {
                const pillGroup = new _PillGroup.PillGroups(// @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
                addToCartForm, updateSkuValuesOnPillSelect(instanceId, apolloClient));
                addStoreWatcher(instanceId, 'skuValues', (newSkuValues)=>{
                    pillGroup.setSelectedPillsForSkuValues(newSkuValues);
                });
                pillGroup.init();
            }
        }
        const currentSkuId = fetchFromStore(instanceId, 'selectedSku');
        if (!currentSkuId) {
            return;
        }
        const productId = addToCartForm && addToCartForm.getAttribute(_constants.DATA_ATTR_COMMERCE_PRODUCT_ID);
        if (productId) {
            apolloClient.query({
                query: getAllVariantsAndMemberships,
                variables: {
                    productId
                }
            }).then(({ data })=>{
                // @ts-expect-error - TS2339: Property database does not exist on type {}
                const items = data?.database?.collections?.c_sku_?.items ?? [];
                // @ts-expect-error - TS2339: Property database does not exist on type {}
                const products = data?.database?.collections?.c_product_?.items ?? [];
                const productType = products[0] ? products[0].f_ec_product_type_2dr10dr.name : 'Advanced';
                // build the possible sku values for the given product
                // since all items have the same sku values, we just use the first
                // then we iterate over the skus, and create an object of [propertyId: string]: ''
                // to represent that by default, no property has been selected yet
                if (event.detail.isInitial && items[0].f_sku_values_3dr && items[0].f_sku_values_3dr.length > 0) {
                    const skuValuesMap = items[0].f_sku_values_3dr.reduce((map, sku)=>{
                        map[sku.property.id] = '';
                        return map;
                    }, {});
                    updateStore(instanceId, {
                        skuValues: skuValuesMap
                    });
                }
                // @ts-expect-error - TS2339: Property database does not exist on type {}
                const memberships = data?.database?.commerceMemberships ?? [];
                const hasActiveMemebership = Boolean(memberships[0]?.active);
                if (hasActiveMemebership) {
                    if (buyNowButton) {
                        buyNowButton.removeAttribute('href');
                        // without href <a> doesn't have an implicit role, so adding it back here for accesibility
                        buyNowButton.setAttribute('role', 'link');
                        buyNowButton.setAttribute('aria-disabled', 'true');
                        buyNowButton.classList.add('w--ecommerce-buy-now-disabled');
                    }
                    if (addToCartButton) {
                        addToCartButton.setAttribute('disabled', 'true');
                        addToCartButton.classList.add('w--ecommerce-add-to-cart-disabled');
                    }
                }
                // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
                const currentSku = items.find((item)=>item.id === currentSkuId);
                if (currentSku) {
                    if (currentSku['f_ec_sku_billing_method_2dr6dr14dr'] === 'subscription' || productType === 'Membership') {
                        updateStore(instanceId, {
                            requiresUserSession: true
                        });
                    }
                    // Set buy now text to subscription state if subscription
                    if (currentSku['f_ec_sku_billing_method_2dr6dr14dr'] === 'subscription') {
                        hideElement(addToCartButton);
                        if (buyNowButton) {
                            const buyNowSubscriptionText = buyNowButton.getAttribute(_constants.DATA_ATTR_SUBSCRIPTION_TEXT) || 'Subscribe now';
                            buyNowButton.innerText = buyNowSubscriptionText;
                        }
                    } else if (buyNowButton) {
                        const buyNowDefaultText = buyNowButton.getAttribute(_constants.DATA_ATTR_DEFAULT_TEXT) || 'Buy now';
                        buyNowButton.innerText = buyNowDefaultText;
                    }
                    const addToCartWrapper = addToCartForm.parentElement;
                    const optionListElement = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_LIST, // @ts-expect-error - TS2345 - Argument of type 'HTMLElement | null' is not assignable to parameter of type 'Document | Element | undefined'.
                    addToCartWrapper);
                    const outOfStockState = addToCartWrapper && addToCartWrapper.getElementsByClassName('w-commerce-commerceaddtocartoutofstock')[0];
                    // Check if exist a variant with stock
                    const hasVariantsWithStock = items.some(// @ts-expect-error - TS7006 - Parameter 'variant' implicitly has an 'any' type.
                    (variant)=>variant.inventory.type === _constants.INVENTORY_TYPE_FINITE && variant.inventory.quantity > 0 || variant.inventory.type === _constants.INVENTORY_TYPE_INFINITE);
                    if (!hasVariantsWithStock && outOfStockState) {
                        // @ts-expect-error - TS2339 - Property 'style' does not exist on type 'Element'.
                        outOfStockState.style.display = '';
                        // @ts-expect-error - TS2339 - Property 'style' does not exist on type 'Element'.
                        addToCartForm.style.display = 'none';
                    }
                    // Update select options based on stock
                    const optionSetsToUpdate = items[0].f_sku_values_3dr.map(// @ts-expect-error - TS7006 - Parameter 'skuValue' implicitly has an 'any' type.
                    (skuValue)=>skuValue.property.id);
                    // @ts-expect-error - TS7006 - Parameter 'optionToUpdateSetId' implicitly has an 'any' type.
                    optionSetsToUpdate.forEach((optionToUpdateSetId)=>{
                        // Get the select we will update
                        let optionSet = addToCartForm.querySelector(`[${_constants.DATA_ATTR_COMMERCE_OPTION_SET_ID}="${optionToUpdateSetId}"]`);
                        if (!(optionSet instanceof HTMLElement)) {
                            return;
                        }
                        const optionSetId = optionSet.getAttribute(_constants.DATA_ATTR_COMMERCE_OPTION_SET_ID);
                        if (optionSet.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_ADD_TO_CART_PILL_GROUP) {
                            // if we're using a pill group, we need to get the PillGroup class for the given element
                            // so that we have access to the getters we defined to give us compatibility with the `select` API
                            // @ts-expect-error - TS2339 - Property '_wfPillGroup' does not exist on type 'HTMLElement'.
                            optionSet = optionSet._wfPillGroup;
                        }
                        // @ts-expect-error - TS18047 - 'optionSet' is possibly 'null'. | TS2339 - Property 'options' does not exist on type 'Element'.
                        (0, _forEach.default)(optionSet.options, (option)=>{
                            // Get the variant that has the current option combined with other selected options that in this case, since it's in the on load
                            // it will be the default variant
                            if (!option.value) {
                                // The default options should be always enabled
                                option.enabled = true;
                            } else {
                                disableVariantsWithNoStock(items, optionSetId, option);
                            }
                        });
                        // Make sure that if this is render occurs with option sets already selected that we disable based on available options
                        const selectedOptionSets = optionSetsToUpdate.filter(// @ts-expect-error - TS7006 - Parameter 'optionSetToUpdate' implicitly has an 'any' type.
                        (optionSetToUpdate)=>optionSetToUpdate.value);
                        disableVariantsWithNoStockForRemainingSelections(items, selectedOptionSets, optionSet, optionSetId);
                        // Preselect the default variant if setting has been enabled and initial render
                        if (event.detail.isInitial && optionListElement && optionListElement.getAttribute(_constants.DATA_ATTR_PRESELECT_DEFAULT_VARIANT) === 'true') {
                            const defaultSkuId = (0, _get.default)(data, [
                                'database',
                                'collections',
                                'c_product_',
                                'items',
                                0,
                                'f_default_sku_7dr',
                                'id'
                            ]);
                            const defaultSku = items.find(// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
                            (item)=>item.id === defaultSkuId);
                            // Ensure the default variant is in stock before preselecting
                            if (defaultSku && !(defaultSku.inventory.type === _constants.INVENTORY_TYPE_FINITE && defaultSku.inventory.quantity <= 0)) {
                                const defaultSkuIndex = Array.from(// @ts-expect-error - TS18047 - 'optionSet' is possibly 'null'. | TS2339 - Property 'options' does not exist on type 'Element'.
                                optionSet.options).findIndex((option)=>defaultSku.f_sku_values_3dr.some(// @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type. | TS18046 - 'option' is of type 'unknown'.
                                    (value)=>value.value.id === option.value));
                                if (defaultSkuIndex > -1) {
                                    // @ts-expect-error - TS18047 - 'optionSet' is possibly 'null'. | TS2339 - Property 'selectedIndex' does not exist on type 'Element'.
                                    optionSet.selectedIndex = defaultSkuIndex;
                                    updateStore(instanceId, {
                                        selectedSku: defaultSku.id,
                                        // update the sku values map to set each property id to the value id
                                        // for the current variant
                                        skuValues: (0, _site.simplifySkuValues)(defaultSku.f_sku_values_3dr)
                                    });
                                }
                            }
                        }
                    });
                }
            });
        }
    });
};
const disableVariantsWithNoStockForRemainingSelections = (items, // @ts-expect-error - TS7006 - Parameter 'selectedOptionSets' implicitly has an 'any' type.
selectedOptionSets, optionSet, id)=>{
    // Get all the possible variants given our current selections
    // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    let possibleVariantSelections = items.filter((item)=>{
        const itemMappedBySkuValues = item.f_sku_values_3dr.map(// @ts-expect-error - TS7006 - Parameter 'skuValues' implicitly has an 'any' type.
        (skuValues)=>skuValues.value.id);
        const currentlySelectedSkuValues = selectedOptionSets.map(// @ts-expect-error - TS7006 - Parameter 'selectedOptionSet' implicitly has an 'any' type.
        (selectedOptionSet)=>selectedOptionSet.value);
        // @ts-expect-error - TS7006 - Parameter 'selectedValue' implicitly has an 'any' type.
        return currentlySelectedSkuValues.every((selectedValue)=>itemMappedBySkuValues.includes(selectedValue));
    });
    // Reset them if there is only 1 left i.e. user has selected all 3 options
    if (possibleVariantSelections.length === 1) {
        possibleVariantSelections = items;
    }
    (0, _forEach.default)(optionSet.options, (option)=>{
        // Get the variant that has the current option combined with other selected options that in this case, since it's in the on load
        // it will be the default variant
        if (!option.value) {
            // The default options should be always enabled
            option.enabled = true;
        } else {
            // @ts-expect-error - TS7006 - Parameter 'variant' implicitly has an 'any' type.
            const variantsFiltered = possibleVariantSelections.filter((variant)=>{
                const sku = variant.f_sku_values_3dr.find(// @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type.
                (value)=>value.property.id === id);
                return sku.value.id === option.value;
            });
            const hasVariantsWithStock = variantsFiltered.some(// @ts-expect-error - TS7006 - Parameter 'variant' implicitly has an 'any' type.
            (variant)=>variant.inventory.type === _constants.INVENTORY_TYPE_FINITE && variant.inventory.quantity > 0 || variant.inventory.type === _constants.INVENTORY_TYPE_INFINITE);
            if (!hasVariantsWithStock) {
                option.disabled = true;
            } else {
                option.disabled = false;
            }
        }
    });
};
const disableVariantsWithNoStock = (items, optionSetId, option)=>{
    if (!option.value) {
        return;
    }
    // @ts-expect-error - TS7006 - Parameter 'variant' implicitly has an 'any' type.
    const variantsFiltered = items.filter((variant)=>{
        const sku = variant.f_sku_values_3dr.find(// @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type.
        (value)=>value.property.id === optionSetId);
        return sku.value.id === option.value;
    });
    const hasVariantsWithStock = variantsFiltered.some(// @ts-expect-error - TS7006 - Parameter 'variant' implicitly has an 'any' type.
    (variant)=>variant.inventory.type === _constants.INVENTORY_TYPE_FINITE && variant.inventory.quantity > 0 || variant.inventory.type === _constants.INVENTORY_TYPE_INFINITE);
    if (!hasVariantsWithStock) {
        option.disabled = true;
    } else {
        option.disabled = false;
    }
};
const updateTextNodeVisibility = (node)=>{
    if (node.innerText) {
        (0, _RenderingUtils.removeWDynBindEmptyClass)(node);
    }
    if (!node.innerText && !node.classList.contains(_constants2.CLASS_NAME_W_DYN_BIND_EMPTY)) {
        node.classList.add(_constants2.CLASS_NAME_W_DYN_BIND_EMPTY);
    }
};
const updateLightboxJson = (node, binding)=>{
    const lightboxScript = node.querySelector('script.w-json');
    if (lightboxScript) {
        const nodeJsonData = JSON.parse(lightboxScript.innerHTML);
        // if the JSON created from bound media is `null`,
        // we replace `script` tag contents with placeholder data
        // that retains the `group` property
        lightboxScript.innerHTML = JSON.stringify((0, _utils.createJsonFromBoundMedia)(binding, nodeJsonData) || {
            items: [],
            group: nodeJsonData && nodeJsonData.group
        });
    }
};
// @ts-expect-error - TS7031 - Binding element 'target' implicitly has an 'any' type.
const isBuyNowButtonEvent = ({ target })=>target instanceof Element && target.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_BUY_NOW_BUTTON;
const handleBuyNow = (event, apolloClient)=>{
    event.preventDefault();
    // Don't try and do anything in preview mode
    if (window.Webflow.env('preview')) {
        return;
    }
    const buyNowButton = event.target;
    const addToCartForm = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_FORM, // @ts-expect-error - TS2345 - Argument of type 'EventTarget | null' is not assignable to parameter of type 'EventTarget'.
    buyNowButton);
    if (!(buyNowButton instanceof HTMLAnchorElement) || !(addToCartForm instanceof HTMLFormElement)) {
        return;
    }
    if (buyNowButton.classList.contains('w--ecommerce-buy-now-disabled')) {
        return;
    }
    const addToCartWrapper = addToCartForm.parentElement;
    if (!(addToCartWrapper instanceof Element)) {
        return;
    }
    const addToCartErrorElement = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_ERROR, addToCartWrapper);
    if (!(addToCartErrorElement instanceof Element)) {
        return;
    }
    addToCartErrorElement.style.display = 'none';
    if (!(0, _commerceUtils.isProtocolHttps)()) {
        window.alert('This site is currently unsecured so you cannot purchase this item.');
        return;
    }
    // Confirm atc selection is valid
    if (!addToCartForm.reportValidity()) {
        return;
    }
    // Redirect to sign up if the purchase requires a user session and there is none
    const requiresUserSession = fetchFromStore(getInstanceId(addToCartForm), 'requiresUserSession');
    const hasUserSession = document.cookie.split(';').some((cookie)=>cookie.indexOf(_constants1.LOGGEDIN_COOKIE_NAME) > -1);
    if (requiresUserSession && !hasUserSession) {
        (0, _siteBundles.redirectWithUsrdir)(`/${_constants1.USYS_PAGE_SETTINGS.signup.slug}`);
        return;
    }
    const publishableKey = buyNowButton.getAttribute(_constants.DATA_ATTR_PUBLISHABLE_KEY);
    // If no publishable key checkout is not enabled
    if (!publishableKey) {
        const errorMsg = addToCartErrorElement.querySelector(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_ADD_TO_CART_ERROR}"]`);
        if (!errorMsg) {
            return;
        }
        const errorText = errorMsg.getAttribute(_constants.CHECKOUT_DISABLED_ERROR_MESSAGE) || 'Checkout is disabled.';
        errorMsg.textContent = errorText;
        addToCartErrorElement.style.removeProperty('display');
        return;
    }
    const skuId = fetchFromStore(getInstanceId(addToCartForm), 'selectedSku') || '';
    const formData = (0, _commerceUtils.formToObject)(addToCartForm);
    const formCount = formData[_constants.NODE_NAME_COMMERCE_ADD_TO_CART_QUANTITY_INPUT];
    const count = formCount ? parseInt(formCount, 10) : 1;
    // if no SKU id, then all options need to be selected
    // this is only shown for pills, as dropdowns will be caught by reportValidity above
    if (!skuId) {
        const errorMsg = addToCartErrorElement.querySelector(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_ADD_TO_CART_ERROR}"]`);
        if (!errorMsg) {
            return;
        }
        const errorText = errorMsg.getAttribute((0, _constants.getATCErrorMessageForType)('select-all-options')) || 'Please select an option in each set.';
        errorMsg.textContent = errorText;
        addToCartErrorElement.style.removeProperty('display');
        return;
    }
    apolloClient.mutate({
        mutation: addToCartMutation,
        variables: {
            skuId,
            count,
            buyNow: true
        }
    }).then(({ data })=>{
        // @ts-expect-error - TS18046: data is of type unknown
        const itemPrice = data.ecommerceAddToCart.itemPrice || {};
        trackAddToCartUsage(skuId, count, itemPrice);
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Location | (string & Location)'.
        window.location = buyNowButton.href;
    }).catch((error)=>{
        if (addToCartErrorElement) {
            addToCartErrorElement.style.removeProperty('display');
            const errorMsg = addToCartErrorElement.querySelector(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_ADD_TO_CART_ERROR}"]`);
            if (!errorMsg) {
                return;
            }
            const errorType = _client.CombinedGraphQLErrors.is(error) && error.errors.length > 0 && error.errors[0] && 'code' in error.errors[0] && error.errors[0].code === 'OutOfInventory' ? 'quantity' : 'buy-now';
            const errorText = errorMsg.getAttribute((0, _constants.getATCErrorMessageForType)(errorType)) || '';
            errorMsg.textContent = errorText;
        }
        _debug.default.error(error);
        (0, _commerceUtils.triggerRender)(null);
    });
};
const register = (handlerProxy)=>{
    handlerProxy.on('submit', addToCartFormEventTargetMatcher, handleAtcSubmit);
    handlerProxy.on('change', addToCartOptionSelectEventTargetMatcher, handleAtcOptionSelectChange);
    handlerProxy.on('click', isBuyNowButtonEvent, handleBuyNow);
    handlerProxy.on(_constants.RENDER_TREE_EVENT, Boolean, handleAtcPageLoad);
};
const _default = {
    register
};

//# sourceMappingURL=data:application/json;base64,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

}),
21465: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "createNewStore", ({
    enumerable: true,
    get: function() {
        return createNewStore;
    }
}));
const initialState = {
    selectedSku: '',
    skuValues: {},
    requiresUserSession: false
};
const createNewStore = ()=>{
    const store = {};
    const watchers = {};
    const fetchFromStore = (instanceId, key)=>{
        return store[instanceId] ? store[instanceId][key] : undefined;
    };
    const updateStore = (instanceId, newValues)=>{
        if (!store[instanceId]) {
            store[instanceId] = {
                ...initialState
            };
        }
        for (const key of Object.keys(newValues)){
            if (!store[instanceId].hasOwnProperty(key)) {
                continue;
            }
            const previousValue = store[instanceId][key];
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<StoreShape>'.
            store[instanceId][key] = newValues[key];
            if (watchers[instanceId] && watchers[instanceId][key]) {
                for (const watcher of watchers[instanceId][key]){
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<StoreShape>'.
                    watcher(newValues[key], previousValue);
                }
            }
        }
    };
    const addStoreWatcher = (instanceId, key, cb)=>{
        if (!watchers[instanceId]) {
            watchers[instanceId] = {};
        }
        if (watchers[instanceId][key]) {
            watchers[instanceId][key].push(cb);
        } else {
            watchers[instanceId][key] = [
                cb
            ];
        }
    };
    return {
        fetchFromStore,
        updateStore,
        addStoreWatcher
    };
};

//# sourceMappingURL=data:application/json;base64,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

}),
82150: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/* globals document, window, Element, HTMLElement, CustomEvent, HTMLFormElement, HTMLInputElement, HTMLCollection, HTMLAnchorElement */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    register: function() {
        return register;
    },
    renderCart: function() {
        return renderCart;
    }
});
const _graphqltag = /*#__PURE__*/ _interop_require_default(__webpack_require__(28160));
const _mergeWith = /*#__PURE__*/ _interop_require_default(__webpack_require__(93794));
const _forEach = /*#__PURE__*/ _interop_require_default(__webpack_require__(32397));
const _constants = __webpack_require__(10873);
const _commerceUtils = __webpack_require__(54556);
const _debug = /*#__PURE__*/ _interop_require_default(__webpack_require__(85986));
const _webPaymentsEvents = __webpack_require__(94492);
const _rendering = __webpack_require__(91898);
const _defaultTo = /*#__PURE__*/ _interop_require_default(__webpack_require__(34075));
const _client = __webpack_require__(22805);
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const { MODAL, LEFT_SIDEBAR, RIGHT_SIDEBAR, LEFT_DROPDOWN, RIGHT_DROPDOWN } = _constants.CART_TYPES;
const { REMOVE_ITEM, UPDATE_ITEM_QUANTITY } = _constants.COMMERCE_CART_PUBLISHED_SITE_ACTIONS;
const updateItemQuantityMutation = (0, _graphqltag.default)`
  mutation AddToCart($skuId: String!, $count: Int!) {
    ecommerceUpdateCartItem(sku: $skuId, count: $count) {
      ok
      itemId
      itemCount
    }
  }
`;
const forEachElementInForm = (form, callback)=>{
    if (form instanceof HTMLFormElement && form.elements instanceof HTMLCollection) {
        Array.from(form.elements).forEach((input)=>{
            if (input instanceof HTMLInputElement) {
                callback(input);
            }
        });
    }
};
const disableAllFormElements = (form)=>{
    forEachElementInForm(form, (input)=>{
        input.disabled = true;
    });
};
const enableAllFormElements = (form)=>{
    forEachElementInForm(form, (input)=>{
        input.disabled = false;
    });
};
// Recursively searches up the tree to find the remove link anchor element
// @ts-expect-error - TS7023 - 'searchTreeForRemoveLink' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions.
const searchTreeForRemoveLink = (element)=>{
    if (element instanceof Element && element.hasAttribute(_constants.COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR) && element.getAttribute(_constants.COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR) === REMOVE_ITEM && element.hasAttribute(_constants.DATA_ATTR_COMMERCE_SKU_ID)) {
        return element;
    } else {
        return element instanceof Element && element.parentElement ? searchTreeForRemoveLink(element.parentElement) : false;
    }
};
// Matchers:
const isItemRemovedEvent = (event)=>{
    // @ts-expect-error - TS2345 - Argument of type 'EventTarget | null' is not assignable to parameter of type 'EventTarget | Element'.
    return searchTreeForRemoveLink(event.target);
};
const isItemQuantityChangedEvent = (event)=>event.target instanceof Element && event.target.hasAttribute(_constants.COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR) && event.target.getAttribute(_constants.COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR) === UPDATE_ITEM_QUANTITY && event.target.hasAttribute(_constants.DATA_ATTR_COMMERCE_SKU_ID) && event.target;
const isItemQuantityInputEvent = (event)=>event.target instanceof Element && event.target.hasAttribute(_constants.COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR) && event.target.getAttribute(_constants.COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR) === UPDATE_ITEM_QUANTITY && event.target.hasAttribute(_constants.DATA_ATTR_COMMERCE_SKU_ID) && event.target;
// @ts-expect-error - TS7031 - Binding element 'target' implicitly has an 'any' type.
const isCartButtonEvent = ({ target })=>{
    const cartOpenLink = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_OPEN_LINK, target);
    const cartCloseLink = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_CLOSE_LINK, target);
    if (cartOpenLink) {
        return cartOpenLink;
    } else if (cartCloseLink) {
        return cartCloseLink;
    } else {
        return false;
    }
};
// @ts-expect-error - TS7031 - Binding element 'target' implicitly has an 'any' type.
const isCartCheckoutButtonEvent = ({ target })=>{
    const cartCheckoutButton = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_CHECKOUT_BUTTON, target);
    if (cartCheckoutButton) {
        return cartCheckoutButton;
    } else {
        return false;
    }
};
// @ts-expect-error - TS7031 - Binding element 'target' implicitly has an 'any' type.
const isCartWrapperEvent = ({ target })=>target instanceof Element && target.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_CART_WRAPPER && target;
// @ts-expect-error - TS7031 - Binding element 'target' implicitly has an 'any' type.
const isCartFormEvent = ({ target })=>target instanceof Element && target.hasAttribute(_constants.DATA_ATTR_NODE_TYPE) && target.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_CART_FORM;
// @ts-expect-error - TS7023 - 'getFormElement' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions.
const getFormElement = (element)=>{
    if (!(element instanceof Element)) {
        return null;
    }
    return element instanceof HTMLFormElement ? element : getFormElement(element.parentElement);
};
// Event handlers:
const handleItemRemoved = (event, apolloClient)=>{
    if (window.Webflow.env('design') || window.Webflow.env('preview')) {
        return;
    }
    event.preventDefault();
    const { currentTarget } = event;
    if (!(currentTarget instanceof HTMLElement)) {
        return;
    }
    const commerceCartWrapper = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_WRAPPER, currentTarget);
    if (!(commerceCartWrapper instanceof Element)) {
        return;
    }
    const errorElement = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_ERROR, commerceCartWrapper);
    if (!(errorElement instanceof Element)) {
        return;
    }
    errorElement.style.setProperty('display', 'none');
    const skuId = currentTarget.getAttribute(_constants.DATA_ATTR_COMMERCE_SKU_ID);
    const count = 0;
    const form = getFormElement(currentTarget);
    disableAllFormElements(form);
    const cartItem = (0, _commerceUtils.findClosestElementByClassName)('w-commerce-commercecartitem', currentTarget);
    if (!(cartItem instanceof Element)) {
        return;
    }
    (0, _commerceUtils.addLoadingCallback)((0, _commerceUtils.setElementLoading)(cartItem));
    // @ts-expect-error - TS2345 - Argument of type 'EventTarget | null' is not assignable to parameter of type 'EventTarget | Element'.
    const removeLinkElement = searchTreeForRemoveLink(event.target);
    // It always will be an anchor element here, but this is mostly a Flow-complaint-fixer
    if (removeLinkElement instanceof HTMLAnchorElement) {
        // Disable click events on the Remove link
        removeLinkElement.style.pointerEvents = 'none';
    }
    apolloClient.mutate({
        mutation: updateItemQuantityMutation,
        variables: {
            skuId,
            count
        }
    }).then(()=>{
        (0, _commerceUtils.triggerRender)(null);
    }, (error)=>{
        _debug.default.error(error);
        errorElement.style.removeProperty('display');
        const errorMsg = errorElement.querySelector(_constants.CART_ERROR_MESSAGE_SELECTOR);
        if (!errorMsg) {
            return;
        }
        // Only general error should be triggered when removing items
        const errorText = errorMsg.getAttribute(_constants.CART_GENERAL_ERROR_MESSAGE) || '';
        errorMsg.textContent = errorText;
        (0, _commerceUtils.triggerRender)(error);
    }).then(()=>{
        if (removeLinkElement instanceof HTMLAnchorElement) {
            // Re-enable click events on the Remove link
            removeLinkElement.style.pointerEvents = 'auto';
        }
        // When cart is becoming empty, focus on the first thing that can be focused
        const cartContainer = currentTarget.closest('.w-commerce-commercecartcontainer');
        if (cartContainer instanceof HTMLElement) {
            const itemContainer = cartContainer.getElementsByClassName('w-commerce-commercecartitem');
            const focusableContent = getFocusableElements(cartContainer);
            if (itemContainer.length === 1 && focusableContent.length > 0) {
                // @ts-expect-error - TS2339 - Property 'focus' does not exist on type 'Element'.
                focusableContent[0].focus();
            }
        }
    });
};
const handleItemQuantityChanged = (event, apolloClient)=>{
    if (window.Webflow.env('design') || window.Webflow.env('preview')) {
        return;
    }
    event.preventDefault();
    const { currentTarget } = event;
    if (!(currentTarget instanceof HTMLInputElement)) {
        return;
    }
    if (currentTarget.form instanceof HTMLFormElement && currentTarget.form.reportValidity() === false) {
        return;
    }
    const commerceCartWrapper = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_WRAPPER, currentTarget);
    if (!(commerceCartWrapper instanceof Element)) {
        return;
    }
    const errorElement = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_ERROR, commerceCartWrapper);
    if (!(errorElement instanceof Element)) {
        return;
    }
    errorElement.style.setProperty('display', 'none');
    const cartItem = currentTarget.parentElement;
    if (!(cartItem instanceof Element)) {
        return;
    }
    (0, _commerceUtils.addLoadingCallback)((0, _commerceUtils.setElementLoading)(cartItem));
    const skuId = currentTarget.getAttribute(_constants.DATA_ATTR_COMMERCE_SKU_ID);
    const count = currentTarget.value;
    disableAllFormElements(currentTarget.form);
    apolloClient.mutate({
        mutation: updateItemQuantityMutation,
        variables: {
            skuId,
            count
        }
    }).then(()=>{
        enableAllFormElements(currentTarget.form);
        (0, _commerceUtils.triggerRender)(null);
    }, (error)=>{
        enableAllFormElements(currentTarget.form);
        _debug.default.error(error);
        errorElement.style.removeProperty('display');
        const errorMsg = errorElement.querySelector(_constants.CART_ERROR_MESSAGE_SELECTOR);
        if (!errorMsg) {
            return;
        }
        const errorType = _client.CombinedGraphQLErrors.is(error) && error.errors.length > 0 && error.errors[0] && 'code' in error.errors[0] && error.errors[0].code === 'OutOfInventory' ? 'quantity' : 'general';
        const errorText = errorMsg.getAttribute((0, _constants.getCartErrorMessageForType)(errorType)) || '';
        errorMsg.textContent = errorText;
        (0, _commerceUtils.triggerRender)(error);
    });
};
const handleItemInputChanged = (event)=>{
    if (window.Webflow.env('design') || window.Webflow.env('preview')) {
        return;
    }
    event.preventDefault();
    const { currentTarget } = event;
    if (!(currentTarget instanceof HTMLInputElement)) {
        return;
    }
    if (currentTarget.validity.valid === false && currentTarget.form instanceof HTMLFormElement) {
        currentTarget.form.reportValidity();
    }
};
const handleChangeCartStateEvent = (event)=>{
    if (!(event.currentTarget instanceof Element) || !(event instanceof CustomEvent)) {
        return;
    }
    const { currentTarget, detail } = event;
    const isOpen = currentTarget.hasAttribute(_constants.CART_OPEN);
    const shouldOpen = detail && detail.open != null ? detail.open : !isOpen;
    const wrapper = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_CONTAINER_WRAPPER, currentTarget);
    if (!wrapper) {
        return;
    }
    const cartContainer = getCartContainer(wrapper);
    if (!cartContainer) {
        return;
    }
    const cartElement = wrapper.parentElement;
    if (!cartElement) {
        return;
    }
    const cartType = cartElement.getAttribute(_constants.CART_TYPE);
    const duration = (0, _defaultTo.default)(cartElement.getAttribute(_constants.DATA_ATTR_ANIMATION_DURATION), _constants.ANIMATION_DURATION_DEFAULT) + 'ms';
    const containerEasing = (0, _defaultTo.default)(cartElement.getAttribute(_constants.DATA_ATTR_ANIMATION_EASING), _constants.ANIMATION_EASING_DEFAULT);
    const wrapperTransition = `opacity ${duration} ease 0ms`;
    const containerOutDelay = '50ms';
    const shouldAnimate = duration !== '0ms';
    let containerStepA;
    let containerStepB;
    switch(cartType){
        case MODAL:
            {
                containerStepA = {
                    scale: 0.95
                };
                containerStepB = {
                    scale: 1.0
                };
                break;
            }
        case LEFT_SIDEBAR:
            {
                containerStepA = {
                    x: -30
                };
                containerStepB = {
                    x: 0
                };
                break;
            }
        case RIGHT_SIDEBAR:
            {
                containerStepA = {
                    x: 30
                };
                containerStepB = {
                    x: 0
                };
                break;
            }
        case LEFT_DROPDOWN:
        case RIGHT_DROPDOWN:
            {
                containerStepA = {
                    y: -10
                };
                containerStepB = {
                    y: 0
                };
                break;
            }
    }
    if (shouldOpen) {
        document.addEventListener('keydown', handleCartFocusTrap);
        currentTarget.setAttribute(_constants.CART_OPEN, '');
        wrapper.style.removeProperty('display');
        // Ensures that the first focusable element in the cart gets focus
        // on cart launching.
        const focusableContent = getFocusableElements(cartContainer);
        if (focusableContent.length > 0) {
            // @ts-expect-error - TS2339 - Property 'focus' does not exist on type 'Element'.
            focusableContent[0].focus();
        }
        if (shouldAnimate && !isOpen) {
            // @ts-expect-error - TS2339 - Property 'Webflow' does not exist on type 'Window & typeof globalThis'.
            window.Webflow.tram(wrapper).add(wrapperTransition).set({
                opacity: 0
            }).start({
                opacity: 1
            });
            // @ts-expect-error - TS2339 - Property 'Webflow' does not exist on type 'Window & typeof globalThis'.
            window.Webflow.tram(cartContainer).add(`transform ${duration} ${containerEasing} 0ms`).set(containerStepA).start(containerStepB);
        }
    } else {
        document.removeEventListener('keydown', handleCartFocusTrap);
        currentTarget.removeAttribute(_constants.CART_OPEN);
        if (shouldAnimate) {
            // @ts-expect-error - TS2339 - Property 'Webflow' does not exist on type 'Window & typeof globalThis'.
            window.Webflow.tram(wrapper).add(wrapperTransition).start({
                opacity: 0
            }).then(()=>{
                wrapper.style.display = 'none';
                // @ts-expect-error - TS2339 - Property 'Webflow' does not exist on type 'Window & typeof globalThis'.
                window.Webflow.tram(cartContainer).stop();
            });
            // @ts-expect-error - TS2339 - Property 'Webflow' does not exist on type 'Window & typeof globalThis'.
            window.Webflow.tram(cartContainer).add(`transform ${duration} ${containerEasing} ${containerOutDelay}`).start(containerStepA);
        } else {
            wrapper.style.display = 'none';
        }
        const cartOpenButton = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_OPEN_LINK, cartElement);
        if (cartOpenButton instanceof Element) {
            cartOpenButton.focus();
        }
    }
};
const handleCartButton = (event)=>{
    // Don't handle events when we're in design mode
    if (window.Webflow.env('design')) {
        return;
    }
    const { currentTarget, type } = event;
    if (!(currentTarget instanceof Element)) {
        return;
    }
    const commerceCartWrapper = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_WRAPPER, currentTarget);
    if (!(commerceCartWrapper instanceof Element)) {
        return;
    }
    const cartContainerWrapper = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_CONTAINER_WRAPPER, commerceCartWrapper);
    let evt;
    if (type === 'click' && (currentTarget.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_CART_CLOSE_LINK || currentTarget.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_CART_OPEN_LINK && !commerceCartWrapper.hasAttribute(_constants.DATA_ATTR_OPEN_ON_HOVER))) {
        evt = new CustomEvent(_constants.CHANGE_CART_EVENT, {
            bubbles: true
        });
        if (cartContainerWrapper && currentTarget.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_CART_CLOSE_LINK) {
            cartContainerWrapper.removeEventListener('mouseleave', handleCartContainerLeave);
            // @ts-expect-error - TS2769 - No overload matches this call.
            commerceCartWrapper.removeEventListener('mouseleave', handleCartContainerLeave);
        }
    } else if (type === 'mouseover' && commerceCartWrapper.hasAttribute(_constants.DATA_ATTR_OPEN_ON_HOVER) && currentTarget.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_CART_OPEN_LINK) {
        evt = new CustomEvent(_constants.CHANGE_CART_EVENT, {
            bubbles: true,
            detail: {
                open: true
            }
        });
        if (cartContainerWrapper) {
            cartContainerWrapper.addEventListener('mouseleave', handleCartContainerLeave);
            // @ts-expect-error - TS2769 - No overload matches this call.
            currentTarget.addEventListener('mouseleave', handleCartContainerLeave);
        }
    }
    if (evt) {
        commerceCartWrapper.dispatchEvent(evt);
    }
};
const handleCartCheckoutButton = (event)=>{
    // Don't want to continue with validation in preview mode
    if (window.Webflow.env('preview')) {
        return;
    }
    event.preventDefault();
    const { currentTarget: checkoutButton } = event;
    if (!(checkoutButton instanceof Element)) {
        return;
    }
    if (!(0, _commerceUtils.isProtocolHttps)()) {
        window.alert('This site is currently unsecured so you cannot enter checkout.');
        return;
    }
    const loadingText = checkoutButton.getAttribute(_constants.DATA_ATTR_LOADING_TEXT);
    const buttonText = checkoutButton.innerHTML;
    checkoutButton.innerHTML = loadingText ? loadingText : _constants.CART_CHECKOUT_LOADING_TEXT_DEFAULT;
    const commerceCartWrapper = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_WRAPPER, checkoutButton);
    if (!(commerceCartWrapper instanceof Element)) {
        return;
    }
    // To determine if we should continue with checkout, we check for the existence of
    // either the Stripe publishable key (only added when Stripe is enabled), or the
    // PayPal script element. If neither exists, we want to block checkout, as this means
    // no payment gateway has been enabled, and therefore, checkout cannot be enabled.
    // In the future, we may need to expand this to be more comprehensive, if we allow
    // for free orders on sites without a payment gateway attached, or if/when we add
    // more possible payment gateways.
    const publishableKey = checkoutButton.getAttribute(_constants.DATA_ATTR_PUBLISHABLE_KEY);
    const paypalElement = document.querySelector(`[${_constants.PAYPAL_ELEMENT_INSTANCE}]`);
    if (!publishableKey && !paypalElement) {
        const errorElement = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_ERROR, commerceCartWrapper);
        if (!(errorElement instanceof Element)) {
            return;
        }
        errorElement.style.setProperty('display', 'none');
        errorElement.style.removeProperty('display');
        const errorMsg = errorElement.querySelector('.w-cart-error-msg');
        if (!errorMsg) {
            return;
        }
        // Render checkout error message
        const errorText = errorMsg.getAttribute(`data-w-cart-checkout-error`) || '';
        errorMsg.textContent = errorText;
        checkoutButton.innerHTML = buttonText ? buttonText : _constants.CART_CHECKOUT_BUTTON_TEXT_DEFAULT;
        return;
    }
    if (!(checkoutButton instanceof HTMLAnchorElement)) {
        checkoutButton.innerHTML = buttonText ? buttonText : _constants.CART_CHECKOUT_BUTTON_TEXT_DEFAULT;
        return;
    }
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Location | (string & Location)'.
    window.location = checkoutButton.href;
};
const handleSubmitForm = (event)=>{
    if (window.Webflow.env('preview')) {
        return;
    }
    event.preventDefault();
};
const handleCartContainerLeave = (event)=>{
    const { target, relatedTarget } = event;
    if (!(target instanceof Element) || !(relatedTarget instanceof Element)) {
        return;
    }
    const { parentElement } = target;
    if (!(parentElement instanceof Element)) {
        return;
    }
    // Don't want to close cart if switching between the button and the container
    const cartWrapper = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_WRAPPER, relatedTarget);
    const cartContainer = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_CONTAINER, relatedTarget);
    if (cartWrapper || cartContainer) {
        return;
    }
    const evt = new CustomEvent(_constants.CHANGE_CART_EVENT, {
        bubbles: true,
        detail: {
            open: false
        }
    });
    parentElement.dispatchEvent(evt);
    cartWrapper && // @ts-expect-error - TS2358 - The left-hand side of an 'instanceof' expression must be of type 'any', an object type or a type parameter.
    cartWrapper instanceof Element && // @ts-expect-error - TS2339 - Property 'removeEventListener' does not exist on type 'never'.
    cartWrapper.removeEventListener('mouseleave', handleCartContainerLeave);
    cartContainer && // @ts-expect-error - TS2358 - The left-hand side of an 'instanceof' expression must be of type 'any', an object type or a type parameter.
    cartContainer instanceof Element && // @ts-expect-error - TS2339 - Property 'removeEventListener' does not exist on type 'never'.
    cartContainer.removeEventListener('mouseleave', handleCartContainerLeave);
};
let cartContainerStates = [];
const handlePreviewMode = ()=>{
    // When we change to preview mode, we start by getting all of the cart wrappers on the page
    const cartContainerElements = (0, _commerceUtils.findAllElementsByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_CONTAINER_WRAPPER);
    cartContainerElements.forEach((element)=>{
        // We then store the container element and its state in the designer
        const wasOpen = element.style.display !== 'none';
        cartContainerStates.push({
            element,
            wasOpen
        });
        // If it was open, we then dispatch the cart change event on the wrapper outside
        // to mirror what the functionality is in the `handleCartButton` function, so that
        // when the user tries to close the cart in the preview, it works as expected
        if (wasOpen) {
            const evt = new CustomEvent(_constants.CHANGE_CART_EVENT, {
                bubbles: true,
                detail: {
                    open: true
                }
            });
            const { parentElement } = element;
            if (parentElement) {
                parentElement.dispatchEvent(evt);
            }
        }
    });
};
const handleDesignMode = ()=>{
    // When we change back to design mode, we iterate over all the stored elements and states
    // and return them back to what they were when the user changed to preview mode.
    // While it would be nice if we could update the state that's stored in the designer,
    // this would require some ugly hacks to access the outer frame of the designer.
    cartContainerStates.forEach(({ element: wrapper, wasOpen })=>{
        // Remove quick animation style data
        // @ts-expect-error - TS2339 - Property 'Webflow' does not exist on type 'Window & typeof globalThis'.
        window.Webflow.tram(wrapper).destroy();
        wrapper.style.opacity = '1';
        const cartContainer = getCartContainer(wrapper);
        if (cartContainer) {
            // @ts-expect-error - TS2339 - Property 'Webflow' does not exist on type 'Window & typeof globalThis'.
            window.Webflow.tram(cartContainer).destroy();
            cartContainer.style.transform = '';
        }
        // Reset the wrapper display property
        if (wasOpen) {
            wrapper.style.removeProperty('display');
        } else {
            wrapper.style.display = 'none';
        }
        // We reset the associated outer wrapper's state, so that we're back exactly to the state
        // of the DOM as it was in the designer.
        const cartElement = wrapper.parentElement;
        if (cartElement) {
            cartElement.removeAttribute(_constants.CART_OPEN);
        }
    });
    // We then clear out the states after the iteration has completed. It's possible we could keep them, and then
    // do some diff-ing or something so we don't have to iterate over them again in `handlePreviewMode`, but I think
    // that would be more computational work than just re-querying the DOM.
    cartContainerStates = [];
};
const doForAllMatchingClass = (cart, className, // @ts-expect-error - TS7006 - Parameter 'fn' implicitly has an 'any' type.
fn)=>Array.from(cart.getElementsByClassName(className)).forEach(fn);
const showCartDefaultState = (cart)=>{
    doForAllMatchingClass(cart, 'w-commerce-commercecartemptystate', _commerceUtils.hideElement);
    doForAllMatchingClass(cart, 'w-commerce-commercecartform', _commerceUtils.showElement);
};
const showCartEmptyState = (cart)=>{
    doForAllMatchingClass(cart, 'w-commerce-commercecartemptystate', _commerceUtils.showElement);
    doForAllMatchingClass(cart, 'w-commerce-commercecartform', _commerceUtils.hideElement);
};
const hideErrorState = (cart)=>{
    doForAllMatchingClass(cart, 'w-commerce-commercecarterrorstate', _commerceUtils.hideElement);
};
const showErrorState = (cart)=>{
    doForAllMatchingClass(cart, 'w-commerce-commercecarterrorstate', _commerceUtils.showElement);
};
const hasItems = (response)=>response && response.data && response.data.database && response.data.database.commerceOrder && response.data.database.commerceOrder.userItems && response.data.database.commerceOrder.userItems.length > 0;
const hasErrors = (response)=>response && response.errors && response.errors.length > 0;
const updateCartA11Y = (cart)=>{
    doForAllMatchingClass(cart, 'w-commerce-commercecartopenlinkcount', // @ts-expect-error - TS7006 - Parameter 'element' implicitly has an 'any' type.
    (element)=>{
        doForAllMatchingClass(cart, 'w-commerce-commercecartopenlink', // @ts-expect-error - TS7006 - Parameter 'openLinkElement' implicitly has an 'any' type.
        (openLinkElement)=>{
            openLinkElement.setAttribute('aria-label', element.textContent === '0' ? 'Open empty cart' : `Open cart containing ${element.textContent} items`);
        });
    });
};
const renderCart = (cart, data, stripeStore)=>{
    hideErrorState(cart);
    if (hasErrors(data)) {
        showErrorState(cart);
    }
    doForAllMatchingClass(cart, 'w-commerce-commercecartopenlinkcount', // @ts-expect-error - TS7006 - Parameter 'element' implicitly has an 'any' type.
    (element)=>{
        const hideRule = element.getAttribute(_constants.DATA_ATTR_COUNT_HIDE_RULE);
        if (hideRule === _constants.CART_COUNT_HIDE_RULES.ALWAYS || hideRule === _constants.CART_COUNT_HIDE_RULES.EMPTY && !hasItems(data)) {
            (0, _commerceUtils.hideElement)(element);
        } else {
            (0, _commerceUtils.showElement)(element);
        }
    });
    // If it is a newly published site the commerceOrder will be null, causing the cart counter to render
    // an empty div if hide cart when empty is false and userItemsCount is not set to 0
    const dataWithDefaults = (0, _mergeWith.default)({}, data, (obj, src, key)=>{
        if (key === 'commerceOrder' && src === null) {
            return {
                userItemsCount: 0
            };
        }
    });
    (0, _rendering.renderTree)(cart, dataWithDefaults);
    if (hasItems(data)) {
        showCartDefaultState(cart);
    } else {
        showCartEmptyState(cart);
    }
    const cartForm = cart.querySelector('form');
    if (cartForm instanceof HTMLFormElement) {
        enableAllFormElements(cartForm);
    }
    // we hide the button when the paypal sdk is on the page (only appears when paypal linked and checkout enabled)
    // and when the stripe store reports that it's not initialized. we don't pass stripe store for some errors,
    // so this ensures that the button will be shown still if there was an error.
    const paypalElement = document.querySelector(`[${_constants.PAYPAL_ELEMENT_INSTANCE}]`);
    const checkoutButton = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_CHECKOUT_BUTTON, cart);
    if (checkoutButton && paypalElement && stripeStore && !stripeStore.isInitialized()) {
        if ((0, _commerceUtils.isFreeOrder)(data)) {
            (0, _commerceUtils.showElement)(checkoutButton);
        } else {
            (0, _commerceUtils.hideElement)(checkoutButton);
        }
    }
    const paypalButton = cart.querySelector(`[${_constants.PAYPAL_BUTTON_ELEMENT_INSTANCE}]`);
    if (paypalElement && paypalButton) {
        if ((0, _commerceUtils.isFreeOrder)(data) || (0, _commerceUtils.hasSubscription)(data)) {
            // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
            (0, _commerceUtils.hideElement)(paypalButton);
        } else {
            // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
            (0, _commerceUtils.showElement)(paypalButton);
        }
    }
    (0, _webPaymentsEvents.updateWebPaymentsButton)(cart, data, stripeStore);
    return cart;
};
const handleRenderCart = (event, apolloClient, stripeStore)=>{
    if (window.Webflow.env('design') || window.Webflow.env('preview')) {
        return;
    }
    if (!(event instanceof CustomEvent && event.type === _constants.RENDER_TREE_EVENT)) {
        return;
    }
    const errors = [];
    const { detail } = event;
    if (detail != null && detail.error) {
        errors.push(detail.error);
    }
    const orderConfirmationContainer = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_ORDER_CONFIRMATION_WRAPPER);
    // stop cart render on order confirmation page as it will always be empty, this query was setting commerceOrder to null
    // and overwritting a second query in `handleRenderOrderConfirmation`
    if (orderConfirmationContainer) {
        return;
    }
    const carts = (0, _commerceUtils.findAllElementsByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_WRAPPER);
    if (!carts.length) {
        (0, _commerceUtils.executeLoadingCallbacks)();
        return;
    }
    carts.forEach((cart)=>{
        apolloClient.query({
            query: (0, _graphqltag.default)`
          ${cart.getAttribute(_constants.CART_QUERY)}
        `,
            fetchPolicy: 'network-only',
            errorPolicy: 'all'
        }).then((data)=>{
            (0, _commerceUtils.executeLoadingCallbacks)();
            renderCart(cart, {
                ...data,
                errors: errors.concat(data.error).filter(Boolean)
            }, stripeStore);
            updateCartA11Y(cart);
        }).catch((err)=>{
            (0, _commerceUtils.executeLoadingCallbacks)();
            errors.push(err);
            renderCart(cart, {
                errors
            });
            updateCartA11Y(cart);
        });
    });
};
const handleCartKeyUp = (event)=>{
    // Escape
    // @ts-expect-error - TS2339 - Property 'keyCode' does not exist on type 'Event | KeyboardEvent'.
    if (event.keyCode === 27) {
        const openCarts = Array.from(document.querySelectorAll(`[${_constants.CART_OPEN}]`));
        (0, _forEach.default)(openCarts, (cart)=>{
            const evt = new CustomEvent(_constants.CHANGE_CART_EVENT, {
                bubbles: true,
                detail: {
                    open: false
                }
            });
            cart.dispatchEvent(evt);
        });
    }
    // Spacebar
    // @ts-expect-error - TS2339 - Property 'keyCode' does not exist on type 'Event | KeyboardEvent'.
    if (event.keyCode === 32 && event.target instanceof HTMLElement) {
        // Flow was being a bit strange with typing and only assuming HTMLElement
        // the first time it was used. So setting it as a new variable here to
        // persist that type.
        const htmlElement = event.target;
        // Make sure element being checked is intended to work as a link or button and
        // is a child of `commerce-cart-wrapper`
        // This will prevent the keyboard trigger applying to elements that don't
        // belong to the Cart or otherwise shouldn't be interactable in this manner.
        if ((htmlElement.getAttribute('role') === 'button' || htmlElement.getAttribute('role') === 'link' || htmlElement.hasAttribute('href') || htmlElement.hasAttribute('onClick')) && (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_WRAPPER, event.target) != null) {
            event.preventDefault();
            htmlElement.click();
        }
    }
};
const getCartContainer = (parent)=>(0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_CONTAINER, parent);
const handleClickCloseCart = ({ target })=>{
    if (!(target instanceof Element)) {
        return;
    }
    const openCarts = Array.from(document.querySelectorAll(`[${_constants.CART_OPEN}]`));
    (0, _forEach.default)(openCarts, (cart)=>{
        // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
        const cartContainer = getCartContainer(cart);
        const cartOpenButton = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_OPEN_LINK, cart);
        if (!(cartContainer instanceof Element) || !(cartOpenButton instanceof Element)) {
            return;
        }
        const cartType = cart.getAttribute(_constants.CART_TYPE);
        // on dropdown, we close if outside the cart is clicked, and on modal/sidebar, we close if outside the container or open button is clicked
        const isNotInside = cartType === LEFT_DROPDOWN || cartType === RIGHT_DROPDOWN ? !cart.contains(target) : !cartContainer.contains(target) && !cartOpenButton.contains(target);
        if (isNotInside) {
            const evt = new CustomEvent(_constants.CHANGE_CART_EVENT, {
                bubbles: true,
                detail: {
                    open: false
                }
            });
            cart.dispatchEvent(evt);
        }
    });
};
const getFocusableElements = (container)=>{
    const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    return [
        ...container.querySelectorAll(focusableElements)
    ].filter(// @ts-expect-error - TS2339 - Property 'offsetHeight' does not exist on type 'Element'.
    (element)=>!element.hasAttribute('disabled') && element.offsetHeight > 0);
};
const handleCartFocusTrap = (event)=>{
    // @ts-expect-error - TS2339 - Property 'key' does not exist on type 'Event | KeyboardEvent'. | TS2339 - Property 'keyCode' does not exist on type 'Event | KeyboardEvent'.
    if (event.key !== 'Tab' && event.keyCode !== 9) {
        return;
    }
    const openCarts = Array.from(document.querySelectorAll(`[${_constants.CART_OPEN}]`));
    (0, _forEach.default)(openCarts, (cart)=>{
        // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
        const cartContainer = getCartContainer(cart);
        if (!(cartContainer instanceof Element)) {
            return;
        }
        const focusableContent = getFocusableElements(cartContainer);
        const firstFocusableElement = focusableContent[0];
        const lastFocusableElement = focusableContent[focusableContent.length - 1];
        // @ts-expect-error - TS2339 - Property 'shiftKey' does not exist on type 'Event | KeyboardEvent'.
        if (event.shiftKey) {
            if (document.activeElement === firstFocusableElement) {
                // @ts-expect-error - TS2339 - Property 'focus' does not exist on type 'Element'.
                lastFocusableElement.focus();
                event.preventDefault();
            }
        } else {
            if (document.activeElement === lastFocusableElement) {
                // @ts-expect-error - TS2339 - Property 'focus' does not exist on type 'Element'.
                firstFocusableElement.focus();
                event.preventDefault();
            }
        }
    });
};
const register = (handlerProxy)=>{
    handlerProxy.on('click', isItemRemovedEvent, handleItemRemoved);
    handlerProxy.on('change', isItemQuantityChangedEvent, handleItemQuantityChanged);
    handlerProxy.on('focus', isItemQuantityInputEvent, handleItemInputChanged);
    handlerProxy.on('click', isCartButtonEvent, handleCartButton);
    handlerProxy.on('click', isCartCheckoutButtonEvent, handleCartCheckoutButton);
    handlerProxy.on('mouseover', isCartButtonEvent, handleCartButton);
    handlerProxy.on(_constants.CHANGE_CART_EVENT, isCartWrapperEvent, handleChangeCartStateEvent);
    handlerProxy.on(_constants.RENDER_TREE_EVENT, Boolean, handleRenderCart);
    // Needed to avoid submission of cart form when only one item is in cart and user hits
    // enter key while in quantity input (acts as submit if only 1 input and no submit)
    handlerProxy.on('submit', isCartFormEvent, handleSubmitForm);
    handlerProxy.on('keyup', Boolean, handleCartKeyUp);
    handlerProxy.on('click', Boolean, handleClickCloseCart);
    // These events are for handling the back and forth between preview and designer
    // and must be registered directly to the window, otherwise they are not registered
    // when the canvas is created.
    if (window.Webflow.env('design') || window.Webflow.env('preview')) {
        window.addEventListener('__wf_preview', handlePreviewMode);
        window.addEventListener('__wf_design', handleDesignMode);
    }
};
const _default = {
    register
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNhcnRFdmVudHMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiLyogZ2xvYmFscyBkb2N1bWVudCwgd2luZG93LCBFbGVtZW50LCBIVE1MRWxlbWVudCwgQ3VzdG9tRXZlbnQsIEhUTUxGb3JtRWxlbWVudCwgSFRNTElucHV0RWxlbWVudCwgSFRNTENvbGxlY3Rpb24sIEhUTUxBbmNob3JFbGVtZW50ICovXG5pbXBvcnQgZ3FsIGZyb20gJ2dyYXBocWwtdGFnJztcbmltcG9ydCBtZXJnZVdpdGggZnJvbSAnbG9kYXNoL21lcmdlV2l0aCc7XG5pbXBvcnQgZm9yRWFjaCBmcm9tICdsb2Rhc2gvZm9yRWFjaCc7XG5pbXBvcnQge1xuICBDT01NRVJDRV9DQVJUX1BVQkxJU0hFRF9TSVRFX0FDVElPTl9BVFRSLFxuICBDT01NRVJDRV9DQVJUX1BVQkxJU0hFRF9TSVRFX0FDVElPTlMsXG4gIERBVEFfQVRUUl9DT01NRVJDRV9TS1VfSUQsXG4gIERBVEFfQVRUUl9OT0RFX1RZUEUsXG4gIE5PREVfVFlQRV9DT01NRVJDRV9DQVJUX1dSQVBQRVIsXG4gIE5PREVfVFlQRV9DT01NRVJDRV9DQVJUX09QRU5fTElOSyxcbiAgTk9ERV9UWVBFX0NPTU1FUkNFX0NBUlRfQ0xPU0VfTElOSyxcbiAgTk9ERV9UWVBFX0NPTU1FUkNFX0NBUlRfQ09OVEFJTkVSX1dSQVBQRVIsXG4gIE5PREVfVFlQRV9DT01NRVJDRV9DQVJUX0NPTlRBSU5FUixcbiAgREFUQV9BVFRSX0NPVU5UX0hJREVfUlVMRSxcbiAgQ0FSVF9DT1VOVF9ISURFX1JVTEVTLFxuICBDQVJUX1RZUEVTLFxuICBBTklNQVRJT05fRUFTSU5HX0RFRkFVTFQsXG4gIEFOSU1BVElPTl9EVVJBVElPTl9ERUZBVUxULFxuICBEQVRBX0FUVFJfQU5JTUFUSU9OX0VBU0lORyxcbiAgREFUQV9BVFRSX0FOSU1BVElPTl9EVVJBVElPTixcbiAgTk9ERV9UWVBFX0NPTU1FUkNFX0NBUlRfQ0hFQ0tPVVRfQlVUVE9OLFxuICBEQVRBX0FUVFJfTE9BRElOR19URVhULFxuICBDQVJUX0NIRUNLT1VUX0JVVFRPTl9URVhUX0RFRkFVTFQsXG4gIENBUlRfQ0hFQ0tPVVRfTE9BRElOR19URVhUX0RFRkFVTFQsXG4gIE5PREVfVFlQRV9DT01NRVJDRV9DQVJUX0VSUk9SLFxuICBEQVRBX0FUVFJfUFVCTElTSEFCTEVfS0VZLFxuICBOT0RFX1RZUEVfQ09NTUVSQ0VfQ0FSVF9GT1JNLFxuICBOT0RFX1RZUEVfQ09NTUVSQ0VfT1JERVJfQ09ORklSTUFUSU9OX1dSQVBQRVIsXG4gIENBUlRfR0VORVJBTF9FUlJPUl9NRVNTQUdFLFxuICBDQVJUX0VSUk9SX01FU1NBR0VfU0VMRUNUT1IsXG4gIENBUlRfT1BFTixcbiAgQ0FSVF9UWVBFLFxuICBDQVJUX1FVRVJZLFxuICBQQVlQQUxfRUxFTUVOVF9JTlNUQU5DRSxcbiAgZ2V0Q2FydEVycm9yTWVzc2FnZUZvclR5cGUsXG4gIERBVEFfQVRUUl9PUEVOX09OX0hPVkVSLFxuICBDSEFOR0VfQ0FSVF9FVkVOVCxcbiAgUkVOREVSX1RSRUVfRVZFTlQsXG4gIFBBWVBBTF9CVVRUT05fRUxFTUVOVF9JTlNUQU5DRSxcbn0gZnJvbSAnQHBhY2thZ2VzL3N5c3RlbXMvY29tbWVyY2UvY29uc3RhbnRzJztcbmltcG9ydCBFdmVudEhhbmRsZXJQcm94eVdpdGhBcG9sbG9DbGllbnQgZnJvbSAnLi9ldmVudEhhbmRsZXJQcm94eVdpdGhBcG9sbG9DbGllbnQnO1xuaW1wb3J0IHtcbiAgdHJpZ2dlclJlbmRlcixcbiAgZmluZEVsZW1lbnRCeU5vZGVUeXBlLFxuICBpc1Byb3RvY29sSHR0cHMsXG4gIGZpbmRBbGxFbGVtZW50c0J5Tm9kZVR5cGUsXG4gIGZpbmRDbG9zZXN0RWxlbWVudEJ5Tm9kZVR5cGUsXG4gIGZpbmRDbG9zZXN0RWxlbWVudEJ5Q2xhc3NOYW1lLFxuICBzZXRFbGVtZW50TG9hZGluZyxcbiAgYWRkTG9hZGluZ0NhbGxiYWNrLFxuICBleGVjdXRlTG9hZGluZ0NhbGxiYWNrcyxcbiAgaXNGcmVlT3JkZXIsXG4gIGhhc1N1YnNjcmlwdGlvbixcbiAgc2hvd0VsZW1lbnQsXG4gIGhpZGVFbGVtZW50LFxufSBmcm9tICcuL2NvbW1lcmNlVXRpbHMnO1xuaW1wb3J0IHtTdHJpcGVTdG9yZX0gZnJvbSAnLi9zdHJpcGVTdG9yZSc7XG5pbXBvcnQgZGVidWcgZnJvbSAnLi9kZWJ1Zyc7XG5pbXBvcnQge3VwZGF0ZVdlYlBheW1lbnRzQnV0dG9ufSBmcm9tICcuL3dlYlBheW1lbnRzRXZlbnRzJztcblxuaW1wb3J0IHtyZW5kZXJUcmVlfSBmcm9tICcuL3JlbmRlcmluZyc7XG5cbmltcG9ydCBkZWZhdWx0VG8gZnJvbSAnbG9kYXNoL2RlZmF1bHRUbyc7XG5pbXBvcnQge0Fwb2xsb0NsaWVudCwgQ29tYmluZWRHcmFwaFFMRXJyb3JzfSBmcm9tICdAYXBvbGxvL2NsaWVudCc7XG5cbmNvbnN0IHtNT0RBTCwgTEVGVF9TSURFQkFSLCBSSUdIVF9TSURFQkFSLCBMRUZUX0RST1BET1dOLCBSSUdIVF9EUk9QRE9XTn0gPVxuICBDQVJUX1RZUEVTO1xuXG5jb25zdCB7UkVNT1ZFX0lURU0sIFVQREFURV9JVEVNX1FVQU5USVRZfSA9XG4gIENPTU1FUkNFX0NBUlRfUFVCTElTSEVEX1NJVEVfQUNUSU9OUztcblxuY29uc3QgdXBkYXRlSXRlbVF1YW50aXR5TXV0YXRpb24gPSBncWxgXG4gIG11dGF0aW9uIEFkZFRvQ2FydCgkc2t1SWQ6IFN0cmluZyEsICRjb3VudDogSW50ISkge1xuICAgIGVjb21tZXJjZVVwZGF0ZUNhcnRJdGVtKHNrdTogJHNrdUlkLCBjb3VudDogJGNvdW50KSB7XG4gICAgICBva1xuICAgICAgaXRlbUlkXG4gICAgICBpdGVtQ291bnRcbiAgICB9XG4gIH1cbmA7XG5cbmNvbnN0IGZvckVhY2hFbGVtZW50SW5Gb3JtID0gKFxuICBmb3JtOiBIVE1MRm9ybUVsZW1lbnQgfCBudWxsIHwgdW5kZWZpbmVkLFxuICBjYWxsYmFjazogKGFyZzE6IEhUTUxJbnB1dEVsZW1lbnQpID0+IHZvaWRcbikgPT4ge1xuICBpZiAoXG4gICAgZm9ybSBpbnN0YW5jZW9mIEhUTUxGb3JtRWxlbWVudCAmJlxuICAgIGZvcm0uZWxlbWVudHMgaW5zdGFuY2VvZiBIVE1MQ29sbGVjdGlvblxuICApIHtcbiAgICBBcnJheS5mcm9tKGZvcm0uZWxlbWVudHMpLmZvckVhY2goKGlucHV0KSA9PiB7XG4gICAgICBpZiAoaW5wdXQgaW5zdGFuY2VvZiBIVE1MSW5wdXRFbGVtZW50KSB7XG4gICAgICAgIGNhbGxiYWNrKGlucHV0KTtcbiAgICAgIH1cbiAgICB9KTtcbiAgfVxufTtcblxuY29uc3QgZGlzYWJsZUFsbEZvcm1FbGVtZW50cyA9IChmb3JtPzogSFRNTEZvcm1FbGVtZW50IHwgbnVsbCkgPT4ge1xuICBmb3JFYWNoRWxlbWVudEluRm9ybShmb3JtLCAoaW5wdXQpID0+IHtcbiAgICBpbnB1dC5kaXNhYmxlZCA9IHRydWU7XG4gIH0pO1xufTtcblxuY29uc3QgZW5hYmxlQWxsRm9ybUVsZW1lbnRzID0gKGZvcm0/OiBIVE1MRm9ybUVsZW1lbnQgfCBudWxsKSA9PiB7XG4gIGZvckVhY2hFbGVtZW50SW5Gb3JtKGZvcm0sIChpbnB1dCkgPT4ge1xuICAgIGlucHV0LmRpc2FibGVkID0gZmFsc2U7XG4gIH0pO1xufTtcblxuLy8gUmVjdXJzaXZlbHkgc2VhcmNoZXMgdXAgdGhlIHRyZWUgdG8gZmluZCB0aGUgcmVtb3ZlIGxpbmsgYW5jaG9yIGVsZW1lbnRcbi8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzcwMjMgLSAnc2VhcmNoVHJlZUZvclJlbW92ZUxpbmsnIGltcGxpY2l0bHkgaGFzIHJldHVybiB0eXBlICdhbnknIGJlY2F1c2UgaXQgZG9lcyBub3QgaGF2ZSBhIHJldHVybiB0eXBlIGFubm90YXRpb24gYW5kIGlzIHJlZmVyZW5jZWQgZGlyZWN0bHkgb3IgaW5kaXJlY3RseSBpbiBvbmUgb2YgaXRzIHJldHVybiBleHByZXNzaW9ucy5cbmNvbnN0IHNlYXJjaFRyZWVGb3JSZW1vdmVMaW5rID0gKGVsZW1lbnQ6IEVsZW1lbnQgfCBFdmVudFRhcmdldCkgPT4ge1xuICBpZiAoXG4gICAgZWxlbWVudCBpbnN0YW5jZW9mIEVsZW1lbnQgJiZcbiAgICBlbGVtZW50Lmhhc0F0dHJpYnV0ZShDT01NRVJDRV9DQVJUX1BVQkxJU0hFRF9TSVRFX0FDVElPTl9BVFRSKSAmJlxuICAgIGVsZW1lbnQuZ2V0QXR0cmlidXRlKENPTU1FUkNFX0NBUlRfUFVCTElTSEVEX1NJVEVfQUNUSU9OX0FUVFIpID09PVxuICAgICAgUkVNT1ZFX0lURU0gJiZcbiAgICBlbGVtZW50Lmhhc0F0dHJpYnV0ZShEQVRBX0FUVFJfQ09NTUVSQ0VfU0tVX0lEKVxuICApIHtcbiAgICByZXR1cm4gZWxlbWVudDtcbiAgfSBlbHNlIHtcbiAgICByZXR1cm4gZWxlbWVudCBpbnN0YW5jZW9mIEVsZW1lbnQgJiYgZWxlbWVudC5wYXJlbnRFbGVtZW50XG4gICAgICA/IHNlYXJjaFRyZWVGb3JSZW1vdmVMaW5rKGVsZW1lbnQucGFyZW50RWxlbWVudClcbiAgICAgIDogZmFsc2U7XG4gIH1cbn07XG5cbi8vIE1hdGNoZXJzOlxuY29uc3QgaXNJdGVtUmVtb3ZlZEV2ZW50ID0gKGV2ZW50OiBFdmVudCkgPT4ge1xuICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFMyMzQ1IC0gQXJndW1lbnQgb2YgdHlwZSAnRXZlbnRUYXJnZXQgfCBudWxsJyBpcyBub3QgYXNzaWduYWJsZSB0byBwYXJhbWV0ZXIgb2YgdHlwZSAnRXZlbnRUYXJnZXQgfCBFbGVtZW50Jy5cbiAgcmV0dXJuIHNlYXJjaFRyZWVGb3JSZW1vdmVMaW5rKGV2ZW50LnRhcmdldCk7XG59O1xuXG5jb25zdCBpc0l0ZW1RdWFudGl0eUNoYW5nZWRFdmVudCA9IChldmVudDogRXZlbnQpID0+XG4gIGV2ZW50LnRhcmdldCBpbnN0YW5jZW9mIEVsZW1lbnQgJiZcbiAgZXZlbnQudGFyZ2V0Lmhhc0F0dHJpYnV0ZShDT01NRVJDRV9DQVJUX1BVQkxJU0hFRF9TSVRFX0FDVElPTl9BVFRSKSAmJlxuICBldmVudC50YXJnZXQuZ2V0QXR0cmlidXRlKENPTU1FUkNFX0NBUlRfUFVCTElTSEVEX1NJVEVfQUNUSU9OX0FUVFIpID09PVxuICAgIFVQREFURV9JVEVNX1FVQU5USVRZICYmXG4gIGV2ZW50LnRhcmdldC5oYXNBdHRyaWJ1dGUoREFUQV9BVFRSX0NPTU1FUkNFX1NLVV9JRCkgJiZcbiAgZXZlbnQudGFyZ2V0O1xuXG5jb25zdCBpc0l0ZW1RdWFudGl0eUlucHV0RXZlbnQgPSAoZXZlbnQ6IEV2ZW50KSA9PlxuICBldmVudC50YXJnZXQgaW5zdGFuY2VvZiBFbGVtZW50ICYmXG4gIGV2ZW50LnRhcmdldC5oYXNBdHRyaWJ1dGUoQ09NTUVSQ0VfQ0FSVF9QVUJMSVNIRURfU0lURV9BQ1RJT05fQVRUUikgJiZcbiAgZXZlbnQudGFyZ2V0LmdldEF0dHJpYnV0ZShDT01NRVJDRV9DQVJUX1BVQkxJU0hFRF9TSVRFX0FDVElPTl9BVFRSKSA9PT1cbiAgICBVUERBVEVfSVRFTV9RVUFOVElUWSAmJlxuICBldmVudC50YXJnZXQuaGFzQXR0cmlidXRlKERBVEFfQVRUUl9DT01NRVJDRV9TS1VfSUQpICYmXG4gIGV2ZW50LnRhcmdldDtcblxuLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTNzAzMSAtIEJpbmRpbmcgZWxlbWVudCAndGFyZ2V0JyBpbXBsaWNpdGx5IGhhcyBhbiAnYW55JyB0eXBlLlxuY29uc3QgaXNDYXJ0QnV0dG9uRXZlbnQgPSAoe3RhcmdldH0pID0+IHtcbiAgY29uc3QgY2FydE9wZW5MaW5rID0gZmluZENsb3Nlc3RFbGVtZW50QnlOb2RlVHlwZShcbiAgICBOT0RFX1RZUEVfQ09NTUVSQ0VfQ0FSVF9PUEVOX0xJTkssXG4gICAgdGFyZ2V0XG4gICk7XG4gIGNvbnN0IGNhcnRDbG9zZUxpbmsgPSBmaW5kQ2xvc2VzdEVsZW1lbnRCeU5vZGVUeXBlKFxuICAgIE5PREVfVFlQRV9DT01NRVJDRV9DQVJUX0NMT1NFX0xJTkssXG4gICAgdGFyZ2V0XG4gICk7XG5cbiAgaWYgKGNhcnRPcGVuTGluaykge1xuICAgIHJldHVybiBjYXJ0T3Blbkxpbms7XG4gIH0gZWxzZSBpZiAoY2FydENsb3NlTGluaykge1xuICAgIHJldHVybiBjYXJ0Q2xvc2VMaW5rO1xuICB9IGVsc2Uge1xuICAgIHJldHVybiBmYWxzZTtcbiAgfVxufTtcblxuLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTNzAzMSAtIEJpbmRpbmcgZWxlbWVudCAndGFyZ2V0JyBpbXBsaWNpdGx5IGhhcyBhbiAnYW55JyB0eXBlLlxuY29uc3QgaXNDYXJ0Q2hlY2tvdXRCdXR0b25FdmVudCA9ICh7dGFyZ2V0fSkgPT4ge1xuICBjb25zdCBjYXJ0Q2hlY2tvdXRCdXR0b24gPSBmaW5kQ2xvc2VzdEVsZW1lbnRCeU5vZGVUeXBlKFxuICAgIE5PREVfVFlQRV9DT01NRVJDRV9DQVJUX0NIRUNLT1VUX0JVVFRPTixcbiAgICB0YXJnZXRcbiAgKTtcbiAgaWYgKGNhcnRDaGVja291dEJ1dHRvbikge1xuICAgIHJldHVybiBjYXJ0Q2hlY2tvdXRCdXR0b247XG4gIH0gZWxzZSB7XG4gICAgcmV0dXJuIGZhbHNlO1xuICB9XG59O1xuXG4vLyBAdHMtZXhwZWN0LWVycm9yIC0gVFM3MDMxIC0gQmluZGluZyBlbGVtZW50ICd0YXJnZXQnIGltcGxpY2l0bHkgaGFzIGFuICdhbnknIHR5cGUuXG5jb25zdCBpc0NhcnRXcmFwcGVyRXZlbnQgPSAoe3RhcmdldH0pID0+XG4gIHRhcmdldCBpbnN0YW5jZW9mIEVsZW1lbnQgJiZcbiAgdGFyZ2V0LmdldEF0dHJpYnV0ZShEQVRBX0FUVFJfTk9ERV9UWVBFKSA9PT1cbiAgICBOT0RFX1RZUEVfQ09NTUVSQ0VfQ0FSVF9XUkFQUEVSICYmXG4gIHRhcmdldDtcblxuLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTNzAzMSAtIEJpbmRpbmcgZWxlbWVudCAndGFyZ2V0JyBpbXBsaWNpdGx5IGhhcyBhbiAnYW55JyB0eXBlLlxuY29uc3QgaXNDYXJ0Rm9ybUV2ZW50ID0gKHt0YXJnZXR9KSA9PlxuICB0YXJnZXQgaW5zdGFuY2VvZiBFbGVtZW50ICYmXG4gIHRhcmdldC5oYXNBdHRyaWJ1dGUoREFUQV9BVFRSX05PREVfVFlQRSkgJiZcbiAgdGFyZ2V0LmdldEF0dHJpYnV0ZShEQVRBX0FUVFJfTk9ERV9UWVBFKSA9PT0gTk9ERV9UWVBFX0NPTU1FUkNFX0NBUlRfRk9STTtcblxuLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTNzAyMyAtICdnZXRGb3JtRWxlbWVudCcgaW1wbGljaXRseSBoYXMgcmV0dXJuIHR5cGUgJ2FueScgYmVjYXVzZSBpdCBkb2VzIG5vdCBoYXZlIGEgcmV0dXJuIHR5cGUgYW5ub3RhdGlvbiBhbmQgaXMgcmVmZXJlbmNlZCBkaXJlY3RseSBvciBpbmRpcmVjdGx5IGluIG9uZSBvZiBpdHMgcmV0dXJuIGV4cHJlc3Npb25zLlxuY29uc3QgZ2V0Rm9ybUVsZW1lbnQgPSAoXG4gIGVsZW1lbnQ6IEVsZW1lbnQgfCBudWxsIHwgdW5kZWZpbmVkIHwgSFRNTEVsZW1lbnQgfCBIVE1MRm9ybUVsZW1lbnRcbikgPT4ge1xuICBpZiAoIShlbGVtZW50IGluc3RhbmNlb2YgRWxlbWVudCkpIHtcbiAgICByZXR1cm4gbnVsbDtcbiAgfVxuICByZXR1cm4gZWxlbWVudCBpbnN0YW5jZW9mIEhUTUxGb3JtRWxlbWVudFxuICAgID8gZWxlbWVudFxuICAgIDogZ2V0Rm9ybUVsZW1lbnQoZWxlbWVudC5wYXJlbnRFbGVtZW50KTtcbn07XG5cbi8vIEV2ZW50IGhhbmRsZXJzOlxuY29uc3QgaGFuZGxlSXRlbVJlbW92ZWQgPSAoZXZlbnQ6IEV2ZW50LCBhcG9sbG9DbGllbnQ6IEFwb2xsb0NsaWVudCkgPT4ge1xuICBpZiAod2luZG93LldlYmZsb3cuZW52KCdkZXNpZ24nKSB8fCB3aW5kb3cuV2ViZmxvdy5lbnYoJ3ByZXZpZXcnKSkge1xuICAgIHJldHVybjtcbiAgfVxuICBldmVudC5wcmV2ZW50RGVmYXVsdCgpO1xuXG4gIGNvbnN0IHtjdXJyZW50VGFyZ2V0fSA9IGV2ZW50O1xuXG4gIGlmICghKGN1cnJlbnRUYXJnZXQgaW5zdGFuY2VvZiBIVE1MRWxlbWVudCkpIHtcbiAgICByZXR1cm47XG4gIH1cblxuICBjb25zdCBjb21tZXJjZUNhcnRXcmFwcGVyID0gZmluZENsb3Nlc3RFbGVtZW50QnlOb2RlVHlwZShcbiAgICBOT0RFX1RZUEVfQ09NTUVSQ0VfQ0FSVF9XUkFQUEVSLFxuICAgIGN1cnJlbnRUYXJnZXRcbiAgKTtcbiAgaWYgKCEoY29tbWVyY2VDYXJ0V3JhcHBlciBpbnN0YW5jZW9mIEVsZW1lbnQpKSB7XG4gICAgcmV0dXJuO1xuICB9XG5cbiAgY29uc3QgZXJyb3JFbGVtZW50ID0gZmluZEVsZW1lbnRCeU5vZGVUeXBlKFxuICAgIE5PREVfVFlQRV9DT01NRVJDRV9DQVJUX0VSUk9SLFxuICAgIGNvbW1lcmNlQ2FydFdyYXBwZXJcbiAgKTtcbiAgaWYgKCEoZXJyb3JFbGVtZW50IGluc3RhbmNlb2YgRWxlbWVudCkpIHtcbiAgICByZXR1cm47XG4gIH1cbiAgZXJyb3JFbGVtZW50LnN0eWxlLnNldFByb3BlcnR5KCdkaXNwbGF5JywgJ25vbmUnKTtcblxuICBjb25zdCBza3VJZCA9IGN1cnJlbnRUYXJnZXQuZ2V0QXR0cmlidXRlKERBVEFfQVRUUl9DT01NRVJDRV9TS1VfSUQpO1xuICBjb25zdCBjb3VudCA9IDA7XG4gIGNvbnN0IGZvcm0gPSBnZXRGb3JtRWxlbWVudChjdXJyZW50VGFyZ2V0KTtcbiAgZGlzYWJsZUFsbEZvcm1FbGVtZW50cyhmb3JtKTtcblxuICBjb25zdCBjYXJ0SXRlbSA9IGZpbmRDbG9zZXN0RWxlbWVudEJ5Q2xhc3NOYW1lKFxuICAgICd3LWNvbW1lcmNlLWNvbW1lcmNlY2FydGl0ZW0nLFxuICAgIGN1cnJlbnRUYXJnZXRcbiAgKTtcbiAgaWYgKCEoY2FydEl0ZW0gaW5zdGFuY2VvZiBFbGVtZW50KSkge1xuICAgIHJldHVybjtcbiAgfVxuICBhZGRMb2FkaW5nQ2FsbGJhY2soc2V0RWxlbWVudExvYWRpbmcoY2FydEl0ZW0pKTtcblxuICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFMyMzQ1IC0gQXJndW1lbnQgb2YgdHlwZSAnRXZlbnRUYXJnZXQgfCBudWxsJyBpcyBub3QgYXNzaWduYWJsZSB0byBwYXJhbWV0ZXIgb2YgdHlwZSAnRXZlbnRUYXJnZXQgfCBFbGVtZW50Jy5cbiAgY29uc3QgcmVtb3ZlTGlua0VsZW1lbnQgPSBzZWFyY2hUcmVlRm9yUmVtb3ZlTGluayhldmVudC50YXJnZXQpO1xuXG4gIC8vIEl0IGFsd2F5cyB3aWxsIGJlIGFuIGFuY2hvciBlbGVtZW50IGhlcmUsIGJ1dCB0aGlzIGlzIG1vc3RseSBhIEZsb3ctY29tcGxhaW50LWZpeGVyXG4gIGlmIChyZW1vdmVMaW5rRWxlbWVudCBpbnN0YW5jZW9mIEhUTUxBbmNob3JFbGVtZW50KSB7XG4gICAgLy8gRGlzYWJsZSBjbGljayBldmVudHMgb24gdGhlIFJlbW92ZSBsaW5rXG4gICAgcmVtb3ZlTGlua0VsZW1lbnQuc3R5bGUucG9pbnRlckV2ZW50cyA9ICdub25lJztcbiAgfVxuXG4gIGFwb2xsb0NsaWVudFxuICAgIC5tdXRhdGUoe1xuICAgICAgbXV0YXRpb246IHVwZGF0ZUl0ZW1RdWFudGl0eU11dGF0aW9uLFxuICAgICAgdmFyaWFibGVzOiB7c2t1SWQsIGNvdW50fSxcbiAgICB9KVxuICAgIC50aGVuKFxuICAgICAgKCkgPT4ge1xuICAgICAgICB0cmlnZ2VyUmVuZGVyKG51bGwpO1xuICAgICAgfSxcbiAgICAgIChlcnJvcikgPT4ge1xuICAgICAgICBkZWJ1Zy5lcnJvcihlcnJvcik7XG4gICAgICAgIGVycm9yRWxlbWVudC5zdHlsZS5yZW1vdmVQcm9wZXJ0eSgnZGlzcGxheScpO1xuICAgICAgICBjb25zdCBlcnJvck1zZyA9IGVycm9yRWxlbWVudC5xdWVyeVNlbGVjdG9yKFxuICAgICAgICAgIENBUlRfRVJST1JfTUVTU0FHRV9TRUxFQ1RPUlxuICAgICAgICApO1xuICAgICAgICBpZiAoIWVycm9yTXNnKSB7XG4gICAgICAgICAgcmV0dXJuO1xuICAgICAgICB9XG4gICAgICAgIC8vIE9ubHkgZ2VuZXJhbCBlcnJvciBzaG91bGQgYmUgdHJpZ2dlcmVkIHdoZW4gcmVtb3ZpbmcgaXRlbXNcbiAgICAgICAgY29uc3QgZXJyb3JUZXh0ID1cbiAgICAgICAgICBlcnJvck1zZy5nZXRBdHRyaWJ1dGUoQ0FSVF9HRU5FUkFMX0VSUk9SX01FU1NBR0UpIHx8ICcnO1xuICAgICAgICBlcnJvck1zZy50ZXh0Q29udGVudCA9IGVycm9yVGV4dDtcbiAgICAgICAgdHJpZ2dlclJlbmRlcihlcnJvcik7XG4gICAgICB9XG4gICAgKVxuICAgIC50aGVuKCgpID0+IHtcbiAgICAgIGlmIChyZW1vdmVMaW5rRWxlbWVudCBpbnN0YW5jZW9mIEhUTUxBbmNob3JFbGVtZW50KSB7XG4gICAgICAgIC8vIFJlLWVuYWJsZSBjbGljayBldmVudHMgb24gdGhlIFJlbW92ZSBsaW5rXG4gICAgICAgIHJlbW92ZUxpbmtFbGVtZW50LnN0eWxlLnBvaW50ZXJFdmVudHMgPSAnYXV0byc7XG4gICAgICB9XG5cbiAgICAgIC8vIFdoZW4gY2FydCBpcyBiZWNvbWluZyBlbXB0eSwgZm9jdXMgb24gdGhlIGZpcnN0IHRoaW5nIHRoYXQgY2FuIGJlIGZvY3VzZWRcbiAgICAgIGNvbnN0IGNhcnRDb250YWluZXIgPSBjdXJyZW50VGFyZ2V0LmNsb3Nlc3QoXG4gICAgICAgICcudy1jb21tZXJjZS1jb21tZXJjZWNhcnRjb250YWluZXInXG4gICAgICApO1xuICAgICAgaWYgKGNhcnRDb250YWluZXIgaW5zdGFuY2VvZiBIVE1MRWxlbWVudCkge1xuICAgICAgICBjb25zdCBpdGVtQ29udGFpbmVyID0gY2FydENvbnRhaW5lci5nZXRFbGVtZW50c0J5Q2xhc3NOYW1lKFxuICAgICAgICAgICd3LWNvbW1lcmNlLWNvbW1lcmNlY2FydGl0ZW0nXG4gICAgICAgICk7XG4gICAgICAgIGNvbnN0IGZvY3VzYWJsZUNvbnRlbnQgPSBnZXRGb2N1c2FibGVFbGVtZW50cyhjYXJ0Q29udGFpbmVyKTtcbiAgICAgICAgaWYgKGl0ZW1Db250YWluZXIubGVuZ3RoID09PSAxICYmIGZvY3VzYWJsZUNvbnRlbnQubGVuZ3RoID4gMCkge1xuICAgICAgICAgIC8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzIzMzkgLSBQcm9wZXJ0eSAnZm9jdXMnIGRvZXMgbm90IGV4aXN0IG9uIHR5cGUgJ0VsZW1lbnQnLlxuICAgICAgICAgIGZvY3VzYWJsZUNvbnRlbnRbMF0uZm9jdXMoKTtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH0pO1xufTtcblxuY29uc3QgaGFuZGxlSXRlbVF1YW50aXR5Q2hhbmdlZCA9IChcbiAgZXZlbnQ6IEV2ZW50LFxuICBhcG9sbG9DbGllbnQ6IEFwb2xsb0NsaWVudFxuKSA9PiB7XG4gIGlmICh3aW5kb3cuV2ViZmxvdy5lbnYoJ2Rlc2lnbicpIHx8IHdpbmRvdy5XZWJmbG93LmVudigncHJldmlldycpKSB7XG4gICAgcmV0dXJuO1xuICB9XG5cbiAgZXZlbnQucHJldmVudERlZmF1bHQoKTtcbiAgY29uc3Qge2N1cnJlbnRUYXJnZXR9ID0gZXZlbnQ7XG4gIGlmICghKGN1cnJlbnRUYXJnZXQgaW5zdGFuY2VvZiBIVE1MSW5wdXRFbGVtZW50KSkge1xuICAgIHJldHVybjtcbiAgfVxuICBpZiAoXG4gICAgY3VycmVudFRhcmdldC5mb3JtIGluc3RhbmNlb2YgSFRNTEZvcm1FbGVtZW50ICYmXG4gICAgY3VycmVudFRhcmdldC5mb3JtLnJlcG9ydFZhbGlkaXR5KCkgPT09IGZhbHNlXG4gICkge1xuICAgIHJldHVybjtcbiAgfVxuXG4gIGNvbnN0IGNvbW1lcmNlQ2FydFdyYXBwZXIgPSBmaW5kQ2xvc2VzdEVsZW1lbnRCeU5vZGVUeXBlKFxuICAgIE5PREVfVFlQRV9DT01NRVJDRV9DQVJUX1dSQVBQRVIsXG4gICAgY3VycmVudFRhcmdldFxuICApO1xuICBpZiAoIShjb21tZXJjZUNhcnRXcmFwcGVyIGluc3RhbmNlb2YgRWxlbWVudCkpIHtcbiAgICByZXR1cm47XG4gIH1cblxuICBjb25zdCBlcnJvckVsZW1lbnQgPSBmaW5kRWxlbWVudEJ5Tm9kZVR5cGUoXG4gICAgTk9ERV9UWVBFX0NPTU1FUkNFX0NBUlRfRVJST1IsXG4gICAgY29tbWVyY2VDYXJ0V3JhcHBlclxuICApO1xuXG4gIGlmICghKGVycm9yRWxlbWVudCBpbnN0YW5jZW9mIEVsZW1lbnQpKSB7XG4gICAgcmV0dXJuO1xuICB9XG4gIGVycm9yRWxlbWVudC5zdHlsZS5zZXRQcm9wZXJ0eSgnZGlzcGxheScsICdub25lJyk7XG5cbiAgY29uc3QgY2FydEl0ZW0gPSBjdXJyZW50VGFyZ2V0LnBhcmVudEVsZW1lbnQ7XG4gIGlmICghKGNhcnRJdGVtIGluc3RhbmNlb2YgRWxlbWVudCkpIHtcbiAgICByZXR1cm47XG4gIH1cbiAgYWRkTG9hZGluZ0NhbGxiYWNrKHNldEVsZW1lbnRMb2FkaW5nKGNhcnRJdGVtKSk7XG5cbiAgY29uc3Qgc2t1SWQgPSBjdXJyZW50VGFyZ2V0LmdldEF0dHJpYnV0ZShEQVRBX0FUVFJfQ09NTUVSQ0VfU0tVX0lEKTtcbiAgY29uc3QgY291bnQgPSBjdXJyZW50VGFyZ2V0LnZhbHVlO1xuICBkaXNhYmxlQWxsRm9ybUVsZW1lbnRzKGN1cnJlbnRUYXJnZXQuZm9ybSk7XG4gIGFwb2xsb0NsaWVudFxuICAgIC5tdXRhdGUoe1xuICAgICAgbXV0YXRpb246IHVwZGF0ZUl0ZW1RdWFudGl0eU11dGF0aW9uLFxuICAgICAgdmFyaWFibGVzOiB7c2t1SWQsIGNvdW50fSxcbiAgICB9KVxuICAgIC50aGVuKFxuICAgICAgKCkgPT4ge1xuICAgICAgICBlbmFibGVBbGxGb3JtRWxlbWVudHMoY3VycmVudFRhcmdldC5mb3JtKTtcbiAgICAgICAgdHJpZ2dlclJlbmRlcihudWxsKTtcbiAgICAgIH0sXG4gICAgICAoZXJyb3IpID0+IHtcbiAgICAgICAgZW5hYmxlQWxsRm9ybUVsZW1lbnRzKGN1cnJlbnRUYXJnZXQuZm9ybSk7XG4gICAgICAgIGRlYnVnLmVycm9yKGVycm9yKTtcbiAgICAgICAgZXJyb3JFbGVtZW50LnN0eWxlLnJlbW92ZVByb3BlcnR5KCdkaXNwbGF5Jyk7XG4gICAgICAgIGNvbnN0IGVycm9yTXNnID0gZXJyb3JFbGVtZW50LnF1ZXJ5U2VsZWN0b3IoXG4gICAgICAgICAgQ0FSVF9FUlJPUl9NRVNTQUdFX1NFTEVDVE9SXG4gICAgICAgICk7XG4gICAgICAgIGlmICghZXJyb3JNc2cpIHtcbiAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cblxuICAgICAgICBjb25zdCBlcnJvclR5cGUgPVxuICAgICAgICAgIENvbWJpbmVkR3JhcGhRTEVycm9ycy5pcyhlcnJvcikgJiZcbiAgICAgICAgICBlcnJvci5lcnJvcnMubGVuZ3RoID4gMCAmJlxuICAgICAgICAgIGVycm9yLmVycm9yc1swXSAmJlxuICAgICAgICAgICdjb2RlJyBpbiBlcnJvci5lcnJvcnNbMF0gJiZcbiAgICAgICAgICBlcnJvci5lcnJvcnNbMF0uY29kZSA9PT0gJ091dE9mSW52ZW50b3J5J1xuICAgICAgICAgICAgPyAncXVhbnRpdHknXG4gICAgICAgICAgICA6ICdnZW5lcmFsJztcbiAgICAgICAgY29uc3QgZXJyb3JUZXh0ID1cbiAgICAgICAgICBlcnJvck1zZy5nZXRBdHRyaWJ1dGUoZ2V0Q2FydEVycm9yTWVzc2FnZUZvclR5cGUoZXJyb3JUeXBlKSkgfHwgJyc7XG4gICAgICAgIGVycm9yTXNnLnRleHRDb250ZW50ID0gZXJyb3JUZXh0O1xuICAgICAgICB0cmlnZ2VyUmVuZGVyKGVycm9yKTtcbiAgICAgIH1cbiAgICApO1xufTtcblxuY29uc3QgaGFuZGxlSXRlbUlucHV0Q2hhbmdlZCA9IChldmVudDogRXZlbnQpID0+IHtcbiAgaWYgKHdpbmRvdy5XZWJmbG93LmVudignZGVzaWduJykgfHwgd2luZG93LldlYmZsb3cuZW52KCdwcmV2aWV3JykpIHtcbiAgICByZXR1cm47XG4gIH1cbiAgZXZlbnQucHJldmVudERlZmF1bHQoKTtcbiAgY29uc3Qge2N1cnJlbnRUYXJnZXR9ID0gZXZlbnQ7XG4gIGlmICghKGN1cnJlbnRUYXJnZXQgaW5zdGFuY2VvZiBIVE1MSW5wdXRFbGVtZW50KSkge1xuICAgIHJldHVybjtcbiAgfVxuICBpZiAoXG4gICAgY3VycmVudFRhcmdldC52YWxpZGl0eS52YWxpZCA9PT0gZmFsc2UgJiZcbiAgICBjdXJyZW50VGFyZ2V0LmZvcm0gaW5zdGFuY2VvZiBIVE1MRm9ybUVsZW1lbnRcbiAgKSB7XG4gICAgY3VycmVudFRhcmdldC5mb3JtLnJlcG9ydFZhbGlkaXR5KCk7XG4gIH1cbn07XG5cbmNvbnN0IGhhbmRsZUNoYW5nZUNhcnRTdGF0ZUV2ZW50ID0gKGV2ZW50OiBFdmVudCB8IEN1c3RvbUV2ZW50KSA9PiB7XG4gIGlmIChcbiAgICAhKGV2ZW50LmN1cnJlbnRUYXJnZXQgaW5zdGFuY2VvZiBFbGVtZW50KSB8fFxuICAgICEoZXZlbnQgaW5zdGFuY2VvZiBDdXN0b21FdmVudClcbiAgKSB7XG4gICAgcmV0dXJuO1xuICB9XG5cbiAgY29uc3Qge2N1cnJlbnRUYXJnZXQsIGRldGFpbH0gPSBldmVudDtcbiAgY29uc3QgaXNPcGVuID0gY3VycmVudFRhcmdldC5oYXNBdHRyaWJ1dGUoQ0FSVF9PUEVOKTtcbiAgY29uc3Qgc2hvdWxkT3BlbiA9IGRldGFpbCAmJiBkZXRhaWwub3BlbiAhPSBudWxsID8gZGV0YWlsLm9wZW4gOiAhaXNPcGVuO1xuXG4gIGNvbnN0IHdyYXBwZXIgPSBmaW5kRWxlbWVudEJ5Tm9kZVR5cGUoXG4gICAgTk9ERV9UWVBFX0NPTU1FUkNFX0NBUlRfQ09OVEFJTkVSX1dSQVBQRVIsXG4gICAgY3VycmVudFRhcmdldFxuICApO1xuICBpZiAoIXdyYXBwZXIpIHtcbiAgICByZXR1cm47XG4gIH1cblxuICBjb25zdCBjYXJ0Q29udGFpbmVyID0gZ2V0Q2FydENvbnRhaW5lcih3cmFwcGVyKTtcbiAgaWYgKCFjYXJ0Q29udGFpbmVyKSB7XG4gICAgcmV0dXJuO1xuICB9XG5cbiAgY29uc3QgY2FydEVsZW1lbnQgPSB3cmFwcGVyLnBhcmVudEVsZW1lbnQ7XG4gIGlmICghY2FydEVsZW1lbnQpIHtcbiAgICByZXR1cm47XG4gIH1cblxuICBjb25zdCBjYXJ0VHlwZSA9IGNhcnRFbGVtZW50LmdldEF0dHJpYnV0ZShDQVJUX1RZUEUpO1xuICBjb25zdCBkdXJhdGlvbiA9XG4gICAgZGVmYXVsdFRvKFxuICAgICAgY2FydEVsZW1lbnQuZ2V0QXR0cmlidXRlKERBVEFfQVRUUl9BTklNQVRJT05fRFVSQVRJT04pLFxuICAgICAgQU5JTUFUSU9OX0RVUkFUSU9OX0RFRkFVTFRcbiAgICApICsgJ21zJztcbiAgY29uc3QgY29udGFpbmVyRWFzaW5nID0gZGVmYXVsdFRvKFxuICAgIGNhcnRFbGVtZW50LmdldEF0dHJpYnV0ZShEQVRBX0FUVFJfQU5JTUFUSU9OX0VBU0lORyksXG4gICAgQU5JTUFUSU9OX0VBU0lOR19ERUZBVUxUXG4gICk7XG4gIGNvbnN0IHdyYXBwZXJUcmFuc2l0aW9uID0gYG9wYWNpdHkgJHtkdXJhdGlvbn0gZWFzZSAwbXNgO1xuICBjb25zdCBjb250YWluZXJPdXREZWxheSA9ICc1MG1zJztcbiAgY29uc3Qgc2hvdWxkQW5pbWF0ZSA9IGR1cmF0aW9uICE9PSAnMG1zJztcblxuICBsZXQgY29udGFpbmVyU3RlcEE7XG4gIGxldCBjb250YWluZXJTdGVwQjtcbiAgc3dpdGNoIChjYXJ0VHlwZSkge1xuICAgIGNhc2UgTU9EQUw6IHtcbiAgICAgIGNvbnRhaW5lclN0ZXBBID0ge3NjYWxlOiAwLjk1fTtcbiAgICAgIGNvbnRhaW5lclN0ZXBCID0ge3NjYWxlOiAxLjB9O1xuICAgICAgYnJlYWs7XG4gICAgfVxuICAgIGNhc2UgTEVGVF9TSURFQkFSOiB7XG4gICAgICBjb250YWluZXJTdGVwQSA9IHt4OiAtMzB9O1xuICAgICAgY29udGFpbmVyU3RlcEIgPSB7eDogMH07XG4gICAgICBicmVhaztcbiAgICB9XG4gICAgY2FzZSBSSUdIVF9TSURFQkFSOiB7XG4gICAgICBjb250YWluZXJTdGVwQSA9IHt4OiAzMH07XG4gICAgICBjb250YWluZXJTdGVwQiA9IHt4OiAwfTtcbiAgICAgIGJyZWFrO1xuICAgIH1cbiAgICBjYXNlIExFRlRfRFJPUERPV046XG4gICAgY2FzZSBSSUdIVF9EUk9QRE9XTjoge1xuICAgICAgY29udGFpbmVyU3RlcEEgPSB7eTogLTEwfTtcbiAgICAgIGNvbnRhaW5lclN0ZXBCID0ge3k6IDB9O1xuICAgICAgYnJlYWs7XG4gICAgfVxuICB9XG5cbiAgaWYgKHNob3VsZE9wZW4pIHtcbiAgICBkb2N1bWVudC5hZGRFdmVudExpc3RlbmVyKCdrZXlkb3duJywgaGFuZGxlQ2FydEZvY3VzVHJhcCk7XG5cbiAgICBjdXJyZW50VGFyZ2V0LnNldEF0dHJpYnV0ZShDQVJUX09QRU4sICcnKTtcbiAgICB3cmFwcGVyLnN0eWxlLnJlbW92ZVByb3BlcnR5KCdkaXNwbGF5Jyk7XG5cbiAgICAvLyBFbnN1cmVzIHRoYXQgdGhlIGZpcnN0IGZvY3VzYWJsZSBlbGVtZW50IGluIHRoZSBjYXJ0IGdldHMgZm9jdXNcbiAgICAvLyBvbiBjYXJ0IGxhdW5jaGluZy5cbiAgICBjb25zdCBmb2N1c2FibGVDb250ZW50ID0gZ2V0Rm9jdXNhYmxlRWxlbWVudHMoY2FydENvbnRhaW5lcik7XG4gICAgaWYgKGZvY3VzYWJsZUNvbnRlbnQubGVuZ3RoID4gMCkge1xuICAgICAgLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTMjMzOSAtIFByb3BlcnR5ICdmb2N1cycgZG9lcyBub3QgZXhpc3Qgb24gdHlwZSAnRWxlbWVudCcuXG4gICAgICBmb2N1c2FibGVDb250ZW50WzBdLmZvY3VzKCk7XG4gICAgfVxuXG4gICAgaWYgKHNob3VsZEFuaW1hdGUgJiYgIWlzT3Blbikge1xuICAgICAgLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTMjMzOSAtIFByb3BlcnR5ICdXZWJmbG93JyBkb2VzIG5vdCBleGlzdCBvbiB0eXBlICdXaW5kb3cgJiB0eXBlb2YgZ2xvYmFsVGhpcycuXG4gICAgICB3aW5kb3cuV2ViZmxvdy50cmFtKHdyYXBwZXIpXG4gICAgICAgIC5hZGQod3JhcHBlclRyYW5zaXRpb24pXG4gICAgICAgIC5zZXQoe29wYWNpdHk6IDB9KVxuICAgICAgICAuc3RhcnQoe29wYWNpdHk6IDF9KTtcblxuICAgICAgLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTMjMzOSAtIFByb3BlcnR5ICdXZWJmbG93JyBkb2VzIG5vdCBleGlzdCBvbiB0eXBlICdXaW5kb3cgJiB0eXBlb2YgZ2xvYmFsVGhpcycuXG4gICAgICB3aW5kb3cuV2ViZmxvdy50cmFtKGNhcnRDb250YWluZXIpXG4gICAgICAgIC5hZGQoYHRyYW5zZm9ybSAke2R1cmF0aW9ufSAke2NvbnRhaW5lckVhc2luZ30gMG1zYClcbiAgICAgICAgLnNldChjb250YWluZXJTdGVwQSlcbiAgICAgICAgLnN0YXJ0KGNvbnRhaW5lclN0ZXBCKTtcbiAgICB9XG4gIH0gZWxzZSB7XG4gICAgZG9jdW1lbnQucmVtb3ZlRXZlbnRMaXN0ZW5lcigna2V5ZG93bicsIGhhbmRsZUNhcnRGb2N1c1RyYXApO1xuXG4gICAgY3VycmVudFRhcmdldC5yZW1vdmVBdHRyaWJ1dGUoQ0FSVF9PUEVOKTtcblxuICAgIGlmIChzaG91bGRBbmltYXRlKSB7XG4gICAgICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFMyMzM5IC0gUHJvcGVydHkgJ1dlYmZsb3cnIGRvZXMgbm90IGV4aXN0IG9uIHR5cGUgJ1dpbmRvdyAmIHR5cGVvZiBnbG9iYWxUaGlzJy5cbiAgICAgIHdpbmRvdy5XZWJmbG93LnRyYW0od3JhcHBlcilcbiAgICAgICAgLmFkZCh3cmFwcGVyVHJhbnNpdGlvbilcbiAgICAgICAgLnN0YXJ0KHtvcGFjaXR5OiAwfSlcbiAgICAgICAgLnRoZW4oKCkgPT4ge1xuICAgICAgICAgIHdyYXBwZXIuc3R5bGUuZGlzcGxheSA9ICdub25lJztcbiAgICAgICAgICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFMyMzM5IC0gUHJvcGVydHkgJ1dlYmZsb3cnIGRvZXMgbm90IGV4aXN0IG9uIHR5cGUgJ1dpbmRvdyAmIHR5cGVvZiBnbG9iYWxUaGlzJy5cbiAgICAgICAgICB3aW5kb3cuV2ViZmxvdy50cmFtKGNhcnRDb250YWluZXIpLnN0b3AoKTtcbiAgICAgICAgfSk7XG5cbiAgICAgIC8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzIzMzkgLSBQcm9wZXJ0eSAnV2ViZmxvdycgZG9lcyBub3QgZXhpc3Qgb24gdHlwZSAnV2luZG93ICYgdHlwZW9mIGdsb2JhbFRoaXMnLlxuICAgICAgd2luZG93LldlYmZsb3cudHJhbShjYXJ0Q29udGFpbmVyKVxuICAgICAgICAuYWRkKGB0cmFuc2Zvcm0gJHtkdXJhdGlvbn0gJHtjb250YWluZXJFYXNpbmd9ICR7Y29udGFpbmVyT3V0RGVsYXl9YClcbiAgICAgICAgLnN0YXJ0KGNvbnRhaW5lclN0ZXBBKTtcbiAgICB9IGVsc2Uge1xuICAgICAgd3JhcHBlci5zdHlsZS5kaXNwbGF5ID0gJ25vbmUnO1xuICAgIH1cblxuICAgIGNvbnN0IGNhcnRPcGVuQnV0dG9uID0gZmluZEVsZW1lbnRCeU5vZGVUeXBlKFxuICAgICAgTk9ERV9UWVBFX0NPTU1FUkNFX0NBUlRfT1BFTl9MSU5LLFxuICAgICAgY2FydEVsZW1lbnRcbiAgICApO1xuICAgIGlmIChjYXJ0T3BlbkJ1dHRvbiBpbnN0YW5jZW9mIEVsZW1lbnQpIHtcbiAgICAgIGNhcnRPcGVuQnV0dG9uLmZvY3VzKCk7XG4gICAgfVxuICB9XG59O1xuXG5jb25zdCBoYW5kbGVDYXJ0QnV0dG9uID0gKGV2ZW50OiBFdmVudCkgPT4ge1xuICAvLyBEb24ndCBoYW5kbGUgZXZlbnRzIHdoZW4gd2UncmUgaW4gZGVzaWduIG1vZGVcbiAgaWYgKHdpbmRvdy5XZWJmbG93LmVudignZGVzaWduJykpIHtcbiAgICByZXR1cm47XG4gIH1cblxuICBjb25zdCB7Y3VycmVudFRhcmdldCwgdHlwZX0gPSBldmVudDtcblxuICBpZiAoIShjdXJyZW50VGFyZ2V0IGluc3RhbmNlb2YgRWxlbWVudCkpIHtcbiAgICByZXR1cm47XG4gIH1cblxuICBjb25zdCBjb21tZXJjZUNhcnRXcmFwcGVyID0gZmluZENsb3Nlc3RFbGVtZW50QnlOb2RlVHlwZShcbiAgICBOT0RFX1RZUEVfQ09NTUVSQ0VfQ0FSVF9XUkFQUEVSLFxuICAgIGN1cnJlbnRUYXJnZXRcbiAgKTtcbiAgaWYgKCEoY29tbWVyY2VDYXJ0V3JhcHBlciBpbnN0YW5jZW9mIEVsZW1lbnQpKSB7XG4gICAgcmV0dXJuO1xuICB9XG5cbiAgY29uc3QgY2FydENvbnRhaW5lcldyYXBwZXIgPSBmaW5kRWxlbWVudEJ5Tm9kZVR5cGUoXG4gICAgTk9ERV9UWVBFX0NPTU1FUkNFX0NBUlRfQ09OVEFJTkVSX1dSQVBQRVIsXG4gICAgY29tbWVyY2VDYXJ0V3JhcHBlclxuICApO1xuXG4gIGxldCBldnQ7XG4gIGlmIChcbiAgICB0eXBlID09PSAnY2xpY2snICYmXG4gICAgKGN1cnJlbnRUYXJnZXQuZ2V0QXR0cmlidXRlKERBVEFfQVRUUl9OT0RFX1RZUEUpID09PVxuICAgICAgTk9ERV9UWVBFX0NPTU1FUkNFX0NBUlRfQ0xPU0VfTElOSyB8fFxuICAgICAgKGN1cnJlbnRUYXJnZXQuZ2V0QXR0cmlidXRlKERBVEFfQVRUUl9OT0RFX1RZUEUpID09PVxuICAgICAgICBOT0RFX1RZUEVfQ09NTUVSQ0VfQ0FSVF9PUEVOX0xJTksgJiZcbiAgICAgICAgIWNvbW1lcmNlQ2FydFdyYXBwZXIuaGFzQXR0cmlidXRlKERBVEFfQVRUUl9PUEVOX09OX0hPVkVSKSkpXG4gICkge1xuICAgIGV2dCA9IG5ldyBDdXN0b21FdmVudChDSEFOR0VfQ0FSVF9FVkVOVCwge1xuICAgICAgYnViYmxlczogdHJ1ZSxcbiAgICB9KTtcbiAgICBpZiAoXG4gICAgICBjYXJ0Q29udGFpbmVyV3JhcHBlciAmJlxuICAgICAgY3VycmVudFRhcmdldC5nZXRBdHRyaWJ1dGUoREFUQV9BVFRSX05PREVfVFlQRSkgPT09XG4gICAgICAgIE5PREVfVFlQRV9DT01NRVJDRV9DQVJUX0NMT1NFX0xJTktcbiAgICApIHtcbiAgICAgIGNhcnRDb250YWluZXJXcmFwcGVyLnJlbW92ZUV2ZW50TGlzdGVuZXIoXG4gICAgICAgICdtb3VzZWxlYXZlJyxcbiAgICAgICAgaGFuZGxlQ2FydENvbnRhaW5lckxlYXZlXG4gICAgICApO1xuICAgICAgLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTMjc2OSAtIE5vIG92ZXJsb2FkIG1hdGNoZXMgdGhpcyBjYWxsLlxuICAgICAgY29tbWVyY2VDYXJ0V3JhcHBlci5yZW1vdmVFdmVudExpc3RlbmVyKFxuICAgICAgICAnbW91c2VsZWF2ZScsXG4gICAgICAgIGhhbmRsZUNhcnRDb250YWluZXJMZWF2ZVxuICAgICAgKTtcbiAgICB9XG4gIH0gZWxzZSBpZiAoXG4gICAgdHlwZSA9PT0gJ21vdXNlb3ZlcicgJiZcbiAgICBjb21tZXJjZUNhcnRXcmFwcGVyLmhhc0F0dHJpYnV0ZShEQVRBX0FUVFJfT1BFTl9PTl9IT1ZFUikgJiZcbiAgICBjdXJyZW50VGFyZ2V0LmdldEF0dHJpYnV0ZShEQVRBX0FUVFJfTk9ERV9UWVBFKSA9PT1cbiAgICAgIE5PREVfVFlQRV9DT01NRVJDRV9DQVJUX09QRU5fTElOS1xuICApIHtcbiAgICBldnQgPSBuZXcgQ3VzdG9tRXZlbnQoQ0hBTkdFX0NBUlRfRVZFTlQsIHtcbiAgICAgIGJ1YmJsZXM6IHRydWUsXG4gICAgICBkZXRhaWw6IHtcbiAgICAgICAgb3BlbjogdHJ1ZSxcbiAgICAgIH0sXG4gICAgfSk7XG4gICAgaWYgKGNhcnRDb250YWluZXJXcmFwcGVyKSB7XG4gICAgICBjYXJ0Q29udGFpbmVyV3JhcHBlci5hZGRFdmVudExpc3RlbmVyKFxuICAgICAgICAnbW91c2VsZWF2ZScsXG4gICAgICAgIGhhbmRsZUNhcnRDb250YWluZXJMZWF2ZVxuICAgICAgKTtcbiAgICAgIC8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzI3NjkgLSBObyBvdmVybG9hZCBtYXRjaGVzIHRoaXMgY2FsbC5cbiAgICAgIGN1cnJlbnRUYXJnZXQuYWRkRXZlbnRMaXN0ZW5lcignbW91c2VsZWF2ZScsIGhhbmRsZUNhcnRDb250YWluZXJMZWF2ZSk7XG4gICAgfVxuICB9XG5cbiAgaWYgKGV2dCkge1xuICAgIGNvbW1lcmNlQ2FydFdyYXBwZXIuZGlzcGF0Y2hFdmVudChldnQpO1xuICB9XG59O1xuXG5jb25zdCBoYW5kbGVDYXJ0Q2hlY2tvdXRCdXR0b24gPSAoZXZlbnQ6IEV2ZW50KSA9PiB7XG4gIC8vIERvbid0IHdhbnQgdG8gY29udGludWUgd2l0aCB2YWxpZGF0aW9uIGluIHByZXZpZXcgbW9kZVxuICBpZiAod2luZG93LldlYmZsb3cuZW52KCdwcmV2aWV3JykpIHtcbiAgICByZXR1cm47XG4gIH1cbiAgZXZlbnQucHJldmVudERlZmF1bHQoKTtcbiAgY29uc3Qge2N1cnJlbnRUYXJnZXQ6IGNoZWNrb3V0QnV0dG9ufSA9IGV2ZW50O1xuXG4gIGlmICghKGNoZWNrb3V0QnV0dG9uIGluc3RhbmNlb2YgRWxlbWVudCkpIHtcbiAgICByZXR1cm47XG4gIH1cblxuICBpZiAoIWlzUHJvdG9jb2xIdHRwcygpKSB7XG4gICAgd2luZG93LmFsZXJ0KFxuICAgICAgJ1RoaXMgc2l0ZSBpcyBjdXJyZW50bHkgdW5zZWN1cmVkIHNvIHlvdSBjYW5ub3QgZW50ZXIgY2hlY2tvdXQuJ1xuICAgICk7XG4gICAgcmV0dXJuO1xuICB9XG5cbiAgY29uc3QgbG9hZGluZ1RleHQgPSBjaGVja291dEJ1dHRvbi5nZXRBdHRyaWJ1dGUoREFUQV9BVFRSX0xPQURJTkdfVEVYVCk7XG4gIGNvbnN0IGJ1dHRvblRleHQgPSBjaGVja291dEJ1dHRvbi5pbm5lckhUTUw7XG4gIGNoZWNrb3V0QnV0dG9uLmlubmVySFRNTCA9IGxvYWRpbmdUZXh0XG4gICAgPyBsb2FkaW5nVGV4dFxuICAgIDogQ0FSVF9DSEVDS09VVF9MT0FESU5HX1RFWFRfREVGQVVMVDtcblxuICBjb25zdCBjb21tZXJjZUNhcnRXcmFwcGVyID0gZmluZENsb3Nlc3RFbGVtZW50QnlOb2RlVHlwZShcbiAgICBOT0RFX1RZUEVfQ09NTUVSQ0VfQ0FSVF9XUkFQUEVSLFxuICAgIGNoZWNrb3V0QnV0dG9uXG4gICk7XG4gIGlmICghKGNvbW1lcmNlQ2FydFdyYXBwZXIgaW5zdGFuY2VvZiBFbGVtZW50KSkge1xuICAgIHJldHVybjtcbiAgfVxuXG4gIC8vIFRvIGRldGVybWluZSBpZiB3ZSBzaG91bGQgY29udGludWUgd2l0aCBjaGVja291dCwgd2UgY2hlY2sgZm9yIHRoZSBleGlzdGVuY2Ugb2ZcbiAgLy8gZWl0aGVyIHRoZSBTdHJpcGUgcHVibGlzaGFibGUga2V5IChvbmx5IGFkZGVkIHdoZW4gU3RyaXBlIGlzIGVuYWJsZWQpLCBvciB0aGVcbiAgLy8gUGF5UGFsIHNjcmlwdCBlbGVtZW50LiBJZiBuZWl0aGVyIGV4aXN0cywgd2Ugd2FudCB0byBibG9jayBjaGVja291dCwgYXMgdGhpcyBtZWFuc1xuICAvLyBubyBwYXltZW50IGdhdGV3YXkgaGFzIGJlZW4gZW5hYmxlZCwgYW5kIHRoZXJlZm9yZSwgY2hlY2tvdXQgY2Fubm90IGJlIGVuYWJsZWQuXG4gIC8vIEluIHRoZSBmdXR1cmUsIHdlIG1heSBuZWVkIHRvIGV4cGFuZCB0aGlzIHRvIGJlIG1vcmUgY29tcHJlaGVuc2l2ZSwgaWYgd2UgYWxsb3dcbiAgLy8gZm9yIGZyZWUgb3JkZXJzIG9uIHNpdGVzIHdpdGhvdXQgYSBwYXltZW50IGdhdGV3YXkgYXR0YWNoZWQsIG9yIGlmL3doZW4gd2UgYWRkXG4gIC8vIG1vcmUgcG9zc2libGUgcGF5bWVudCBnYXRld2F5cy5cbiAgY29uc3QgcHVibGlzaGFibGVLZXkgPSBjaGVja291dEJ1dHRvbi5nZXRBdHRyaWJ1dGUoREFUQV9BVFRSX1BVQkxJU0hBQkxFX0tFWSk7XG4gIGNvbnN0IHBheXBhbEVsZW1lbnQgPSBkb2N1bWVudC5xdWVyeVNlbGVjdG9yKGBbJHtQQVlQQUxfRUxFTUVOVF9JTlNUQU5DRX1dYCk7XG5cbiAgaWYgKCFwdWJsaXNoYWJsZUtleSAmJiAhcGF5cGFsRWxlbWVudCkge1xuICAgIGNvbnN0IGVycm9yRWxlbWVudCA9IGZpbmRFbGVtZW50QnlOb2RlVHlwZShcbiAgICAgIE5PREVfVFlQRV9DT01NRVJDRV9DQVJUX0VSUk9SLFxuICAgICAgY29tbWVyY2VDYXJ0V3JhcHBlclxuICAgICk7XG5cbiAgICBpZiAoIShlcnJvckVsZW1lbnQgaW5zdGFuY2VvZiBFbGVtZW50KSkge1xuICAgICAgcmV0dXJuO1xuICAgIH1cbiAgICBlcnJvckVsZW1lbnQuc3R5bGUuc2V0UHJvcGVydHkoJ2Rpc3BsYXknLCAnbm9uZScpO1xuICAgIGVycm9yRWxlbWVudC5zdHlsZS5yZW1vdmVQcm9wZXJ0eSgnZGlzcGxheScpO1xuICAgIGNvbnN0IGVycm9yTXNnID0gZXJyb3JFbGVtZW50LnF1ZXJ5U2VsZWN0b3IoJy53LWNhcnQtZXJyb3ItbXNnJyk7XG4gICAgaWYgKCFlcnJvck1zZykge1xuICAgICAgcmV0dXJuO1xuICAgIH1cbiAgICAvLyBSZW5kZXIgY2hlY2tvdXQgZXJyb3IgbWVzc2FnZVxuICAgIGNvbnN0IGVycm9yVGV4dCA9IGVycm9yTXNnLmdldEF0dHJpYnV0ZShgZGF0YS13LWNhcnQtY2hlY2tvdXQtZXJyb3JgKSB8fCAnJztcbiAgICBlcnJvck1zZy50ZXh0Q29udGVudCA9IGVycm9yVGV4dDtcbiAgICBjaGVja291dEJ1dHRvbi5pbm5lckhUTUwgPSBidXR0b25UZXh0XG4gICAgICA/IGJ1dHRvblRleHRcbiAgICAgIDogQ0FSVF9DSEVDS09VVF9CVVRUT05fVEVYVF9ERUZBVUxUO1xuICAgIHJldHVybjtcbiAgfVxuXG4gIGlmICghKGNoZWNrb3V0QnV0dG9uIGluc3RhbmNlb2YgSFRNTEFuY2hvckVsZW1lbnQpKSB7XG4gICAgY2hlY2tvdXRCdXR0b24uaW5uZXJIVE1MID0gYnV0dG9uVGV4dFxuICAgICAgPyBidXR0b25UZXh0XG4gICAgICA6IENBUlRfQ0hFQ0tPVVRfQlVUVE9OX1RFWFRfREVGQVVMVDtcbiAgICByZXR1cm47XG4gIH1cblxuICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFMyMzIyIC0gVHlwZSAnc3RyaW5nJyBpcyBub3QgYXNzaWduYWJsZSB0byB0eXBlICdMb2NhdGlvbiB8IChzdHJpbmcgJiBMb2NhdGlvbiknLlxuICB3aW5kb3cubG9jYXRpb24gPSBjaGVja291dEJ1dHRvbi5ocmVmO1xufTtcblxuY29uc3QgaGFuZGxlU3VibWl0Rm9ybSA9IChldmVudDogRXZlbnQpID0+IHtcbiAgaWYgKHdpbmRvdy5XZWJmbG93LmVudigncHJldmlldycpKSB7XG4gICAgcmV0dXJuO1xuICB9XG4gIGV2ZW50LnByZXZlbnREZWZhdWx0KCk7XG59O1xuXG5jb25zdCBoYW5kbGVDYXJ0Q29udGFpbmVyTGVhdmUgPSAoZXZlbnQ6IE1vdXNlRXZlbnQpID0+IHtcbiAgY29uc3Qge3RhcmdldCwgcmVsYXRlZFRhcmdldH0gPSBldmVudDtcbiAgaWYgKCEodGFyZ2V0IGluc3RhbmNlb2YgRWxlbWVudCkgfHwgIShyZWxhdGVkVGFyZ2V0IGluc3RhbmNlb2YgRWxlbWVudCkpIHtcbiAgICByZXR1cm47XG4gIH1cblxuICBjb25zdCB7cGFyZW50RWxlbWVudH0gPSB0YXJnZXQ7XG5cbiAgaWYgKCEocGFyZW50RWxlbWVudCBpbnN0YW5jZW9mIEVsZW1lbnQpKSB7XG4gICAgcmV0dXJuO1xuICB9XG5cbiAgLy8gRG9uJ3Qgd2FudCB0byBjbG9zZSBjYXJ0IGlmIHN3aXRjaGluZyBiZXR3ZWVuIHRoZSBidXR0b24gYW5kIHRoZSBjb250YWluZXJcbiAgY29uc3QgY2FydFdyYXBwZXIgPSBmaW5kQ2xvc2VzdEVsZW1lbnRCeU5vZGVUeXBlKFxuICAgIE5PREVfVFlQRV9DT01NRVJDRV9DQVJUX1dSQVBQRVIsXG4gICAgcmVsYXRlZFRhcmdldFxuICApO1xuICBjb25zdCBjYXJ0Q29udGFpbmVyID0gZmluZENsb3Nlc3RFbGVtZW50QnlOb2RlVHlwZShcbiAgICBOT0RFX1RZUEVfQ09NTUVSQ0VfQ0FSVF9DT05UQUlORVIsXG4gICAgcmVsYXRlZFRhcmdldFxuICApO1xuICBpZiAoY2FydFdyYXBwZXIgfHwgY2FydENvbnRhaW5lcikge1xuICAgIHJldHVybjtcbiAgfVxuICBjb25zdCBldnQgPSBuZXcgQ3VzdG9tRXZlbnQoQ0hBTkdFX0NBUlRfRVZFTlQsIHtcbiAgICBidWJibGVzOiB0cnVlLFxuICAgIGRldGFpbDoge1xuICAgICAgb3BlbjogZmFsc2UsXG4gICAgfSxcbiAgfSk7XG4gIHBhcmVudEVsZW1lbnQuZGlzcGF0Y2hFdmVudChldnQpO1xuICBjYXJ0V3JhcHBlciAmJlxuICAgIC8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzIzNTggLSBUaGUgbGVmdC1oYW5kIHNpZGUgb2YgYW4gJ2luc3RhbmNlb2YnIGV4cHJlc3Npb24gbXVzdCBiZSBvZiB0eXBlICdhbnknLCBhbiBvYmplY3QgdHlwZSBvciBhIHR5cGUgcGFyYW1ldGVyLlxuICAgIGNhcnRXcmFwcGVyIGluc3RhbmNlb2YgRWxlbWVudCAmJlxuICAgIC8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzIzMzkgLSBQcm9wZXJ0eSAncmVtb3ZlRXZlbnRMaXN0ZW5lcicgZG9lcyBub3QgZXhpc3Qgb24gdHlwZSAnbmV2ZXInLlxuICAgIGNhcnRXcmFwcGVyLnJlbW92ZUV2ZW50TGlzdGVuZXIoJ21vdXNlbGVhdmUnLCBoYW5kbGVDYXJ0Q29udGFpbmVyTGVhdmUpO1xuICBjYXJ0Q29udGFpbmVyICYmXG4gICAgLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTMjM1OCAtIFRoZSBsZWZ0LWhhbmQgc2lkZSBvZiBhbiAnaW5zdGFuY2VvZicgZXhwcmVzc2lvbiBtdXN0IGJlIG9mIHR5cGUgJ2FueScsIGFuIG9iamVjdCB0eXBlIG9yIGEgdHlwZSBwYXJhbWV0ZXIuXG4gICAgY2FydENvbnRhaW5lciBpbnN0YW5jZW9mIEVsZW1lbnQgJiZcbiAgICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFMyMzM5IC0gUHJvcGVydHkgJ3JlbW92ZUV2ZW50TGlzdGVuZXInIGRvZXMgbm90IGV4aXN0IG9uIHR5cGUgJ25ldmVyJy5cbiAgICBjYXJ0Q29udGFpbmVyLnJlbW92ZUV2ZW50TGlzdGVuZXIoJ21vdXNlbGVhdmUnLCBoYW5kbGVDYXJ0Q29udGFpbmVyTGVhdmUpO1xufTtcblxubGV0IGNhcnRDb250YWluZXJTdGF0ZXM6IEFycmF5PFxuICB8IGFueVxuICB8IHtcbiAgICAgIGVsZW1lbnQ6IEhUTUxFbGVtZW50O1xuICAgICAgd2FzT3BlbjogYm9vbGVhbjtcbiAgICB9XG4+ID0gW107XG5cbmNvbnN0IGhhbmRsZVByZXZpZXdNb2RlID0gKCkgPT4ge1xuICAvLyBXaGVuIHdlIGNoYW5nZSB0byBwcmV2aWV3IG1vZGUsIHdlIHN0YXJ0IGJ5IGdldHRpbmcgYWxsIG9mIHRoZSBjYXJ0IHdyYXBwZXJzIG9uIHRoZSBwYWdlXG4gIGNvbnN0IGNhcnRDb250YWluZXJFbGVtZW50cyA9IGZpbmRBbGxFbGVtZW50c0J5Tm9kZVR5cGUoXG4gICAgTk9ERV9UWVBFX0NPTU1FUkNFX0NBUlRfQ09OVEFJTkVSX1dSQVBQRVJcbiAgKTtcblxuICBjYXJ0Q29udGFpbmVyRWxlbWVudHMuZm9yRWFjaCgoZWxlbWVudCkgPT4ge1xuICAgIC8vIFdlIHRoZW4gc3RvcmUgdGhlIGNvbnRhaW5lciBlbGVtZW50IGFuZCBpdHMgc3RhdGUgaW4gdGhlIGRlc2lnbmVyXG4gICAgY29uc3Qgd2FzT3BlbiA9IGVsZW1lbnQuc3R5bGUuZGlzcGxheSAhPT0gJ25vbmUnO1xuICAgIGNhcnRDb250YWluZXJTdGF0ZXMucHVzaCh7XG4gICAgICBlbGVtZW50LFxuICAgICAgd2FzT3BlbixcbiAgICB9KTtcblxuICAgIC8vIElmIGl0IHdhcyBvcGVuLCB3ZSB0aGVuIGRpc3BhdGNoIHRoZSBjYXJ0IGNoYW5nZSBldmVudCBvbiB0aGUgd3JhcHBlciBvdXRzaWRlXG4gICAgLy8gdG8gbWlycm9yIHdoYXQgdGhlIGZ1bmN0aW9uYWxpdHkgaXMgaW4gdGhlIGBoYW5kbGVDYXJ0QnV0dG9uYCBmdW5jdGlvbiwgc28gdGhhdFxuICAgIC8vIHdoZW4gdGhlIHVzZXIgdHJpZXMgdG8gY2xvc2UgdGhlIGNhcnQgaW4gdGhlIHByZXZpZXcsIGl0IHdvcmtzIGFzIGV4cGVjdGVkXG4gICAgaWYgKHdhc09wZW4pIHtcbiAgICAgIGNvbnN0IGV2dCA9IG5ldyBDdXN0b21FdmVudChDSEFOR0VfQ0FSVF9FVkVOVCwge1xuICAgICAgICBidWJibGVzOiB0cnVlLFxuICAgICAgICBkZXRhaWw6IHtcbiAgICAgICAgICBvcGVuOiB0cnVlLFxuICAgICAgICB9LFxuICAgICAgfSk7XG4gICAgICBjb25zdCB7cGFyZW50RWxlbWVudH0gPSBlbGVtZW50O1xuICAgICAgaWYgKHBhcmVudEVsZW1lbnQpIHtcbiAgICAgICAgcGFyZW50RWxlbWVudC5kaXNwYXRjaEV2ZW50KGV2dCk7XG4gICAgICB9XG4gICAgfVxuICB9KTtcbn07XG5cbmNvbnN0IGhhbmRsZURlc2lnbk1vZGUgPSAoKSA9PiB7XG4gIC8vIFdoZW4gd2UgY2hhbmdlIGJhY2sgdG8gZGVzaWduIG1vZGUsIHdlIGl0ZXJhdGUgb3ZlciBhbGwgdGhlIHN0b3JlZCBlbGVtZW50cyBhbmQgc3RhdGVzXG4gIC8vIGFuZCByZXR1cm4gdGhlbSBiYWNrIHRvIHdoYXQgdGhleSB3ZXJlIHdoZW4gdGhlIHVzZXIgY2hhbmdlZCB0byBwcmV2aWV3IG1vZGUuXG4gIC8vIFdoaWxlIGl0IHdvdWxkIGJlIG5pY2UgaWYgd2UgY291bGQgdXBkYXRlIHRoZSBzdGF0ZSB0aGF0J3Mgc3RvcmVkIGluIHRoZSBkZXNpZ25lcixcbiAgLy8gdGhpcyB3b3VsZCByZXF1aXJlIHNvbWUgdWdseSBoYWNrcyB0byBhY2Nlc3MgdGhlIG91dGVyIGZyYW1lIG9mIHRoZSBkZXNpZ25lci5cbiAgY2FydENvbnRhaW5lclN0YXRlcy5mb3JFYWNoKCh7ZWxlbWVudDogd3JhcHBlciwgd2FzT3Blbn0pID0+IHtcbiAgICAvLyBSZW1vdmUgcXVpY2sgYW5pbWF0aW9uIHN0eWxlIGRhdGFcbiAgICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFMyMzM5IC0gUHJvcGVydHkgJ1dlYmZsb3cnIGRvZXMgbm90IGV4aXN0IG9uIHR5cGUgJ1dpbmRvdyAmIHR5cGVvZiBnbG9iYWxUaGlzJy5cbiAgICB3aW5kb3cuV2ViZmxvdy50cmFtKHdyYXBwZXIpLmRlc3Ryb3koKTtcbiAgICB3cmFwcGVyLnN0eWxlLm9wYWNpdHkgPSAnMSc7XG4gICAgY29uc3QgY2FydENvbnRhaW5lciA9IGdldENhcnRDb250YWluZXIod3JhcHBlcik7XG4gICAgaWYgKGNhcnRDb250YWluZXIpIHtcbiAgICAgIC8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzIzMzkgLSBQcm9wZXJ0eSAnV2ViZmxvdycgZG9lcyBub3QgZXhpc3Qgb24gdHlwZSAnV2luZG93ICYgdHlwZW9mIGdsb2JhbFRoaXMnLlxuICAgICAgd2luZG93LldlYmZsb3cudHJhbShjYXJ0Q29udGFpbmVyKS5kZXN0cm95KCk7XG4gICAgICBjYXJ0Q29udGFpbmVyLnN0eWxlLnRyYW5zZm9ybSA9ICcnO1xuICAgIH1cblxuICAgIC8vIFJlc2V0IHRoZSB3cmFwcGVyIGRpc3BsYXkgcHJvcGVydHlcbiAgICBpZiAod2FzT3Blbikge1xuICAgICAgd3JhcHBlci5zdHlsZS5yZW1vdmVQcm9wZXJ0eSgnZGlzcGxheScpO1xuICAgIH0gZWxzZSB7XG4gICAgICB3cmFwcGVyLnN0eWxlLmRpc3BsYXkgPSAnbm9uZSc7XG4gICAgfVxuXG4gICAgLy8gV2UgcmVzZXQgdGhlIGFzc29jaWF0ZWQgb3V0ZXIgd3JhcHBlcidzIHN0YXRlLCBzbyB0aGF0IHdlJ3JlIGJhY2sgZXhhY3RseSB0byB0aGUgc3RhdGVcbiAgICAvLyBvZiB0aGUgRE9NIGFzIGl0IHdhcyBpbiB0aGUgZGVzaWduZXIuXG4gICAgY29uc3QgY2FydEVsZW1lbnQgPSB3cmFwcGVyLnBhcmVudEVsZW1lbnQ7XG4gICAgaWYgKGNhcnRFbGVtZW50KSB7XG4gICAgICBjYXJ0RWxlbWVudC5yZW1vdmVBdHRyaWJ1dGUoQ0FSVF9PUEVOKTtcbiAgICB9XG4gIH0pO1xuXG4gIC8vIFdlIHRoZW4gY2xlYXIgb3V0IHRoZSBzdGF0ZXMgYWZ0ZXIgdGhlIGl0ZXJhdGlvbiBoYXMgY29tcGxldGVkLiBJdCdzIHBvc3NpYmxlIHdlIGNvdWxkIGtlZXAgdGhlbSwgYW5kIHRoZW5cbiAgLy8gZG8gc29tZSBkaWZmLWluZyBvciBzb21ldGhpbmcgc28gd2UgZG9uJ3QgaGF2ZSB0byBpdGVyYXRlIG92ZXIgdGhlbSBhZ2FpbiBpbiBgaGFuZGxlUHJldmlld01vZGVgLCBidXQgSSB0aGlua1xuICAvLyB0aGF0IHdvdWxkIGJlIG1vcmUgY29tcHV0YXRpb25hbCB3b3JrIHRoYW4ganVzdCByZS1xdWVyeWluZyB0aGUgRE9NLlxuICBjYXJ0Q29udGFpbmVyU3RhdGVzID0gW107XG59O1xuXG5jb25zdCBkb0ZvckFsbE1hdGNoaW5nQ2xhc3MgPSAoXG4gIGNhcnQ6IEVsZW1lbnQgfCBIVE1MRWxlbWVudCxcbiAgY2xhc3NOYW1lOiBzdHJpbmcsXG4gIC8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzcwMDYgLSBQYXJhbWV0ZXIgJ2ZuJyBpbXBsaWNpdGx5IGhhcyBhbiAnYW55JyB0eXBlLlxuICBmblxuKSA9PiBBcnJheS5mcm9tKGNhcnQuZ2V0RWxlbWVudHNCeUNsYXNzTmFtZShjbGFzc05hbWUpKS5mb3JFYWNoKGZuKTtcblxuY29uc3Qgc2hvd0NhcnREZWZhdWx0U3RhdGUgPSAoY2FydDogRWxlbWVudCkgPT4ge1xuICBkb0ZvckFsbE1hdGNoaW5nQ2xhc3MoY2FydCwgJ3ctY29tbWVyY2UtY29tbWVyY2VjYXJ0ZW1wdHlzdGF0ZScsIGhpZGVFbGVtZW50KTtcbiAgZG9Gb3JBbGxNYXRjaGluZ0NsYXNzKGNhcnQsICd3LWNvbW1lcmNlLWNvbW1lcmNlY2FydGZvcm0nLCBzaG93RWxlbWVudCk7XG59O1xuXG5jb25zdCBzaG93Q2FydEVtcHR5U3RhdGUgPSAoY2FydDogRWxlbWVudCkgPT4ge1xuICBkb0ZvckFsbE1hdGNoaW5nQ2xhc3MoY2FydCwgJ3ctY29tbWVyY2UtY29tbWVyY2VjYXJ0ZW1wdHlzdGF0ZScsIHNob3dFbGVtZW50KTtcbiAgZG9Gb3JBbGxNYXRjaGluZ0NsYXNzKGNhcnQsICd3LWNvbW1lcmNlLWNvbW1lcmNlY2FydGZvcm0nLCBoaWRlRWxlbWVudCk7XG59O1xuXG5jb25zdCBoaWRlRXJyb3JTdGF0ZSA9IChjYXJ0OiBFbGVtZW50KSA9PiB7XG4gIGRvRm9yQWxsTWF0Y2hpbmdDbGFzcyhjYXJ0LCAndy1jb21tZXJjZS1jb21tZXJjZWNhcnRlcnJvcnN0YXRlJywgaGlkZUVsZW1lbnQpO1xufTtcblxuY29uc3Qgc2hvd0Vycm9yU3RhdGUgPSAoY2FydDogRWxlbWVudCkgPT4ge1xuICBkb0ZvckFsbE1hdGNoaW5nQ2xhc3MoY2FydCwgJ3ctY29tbWVyY2UtY29tbWVyY2VjYXJ0ZXJyb3JzdGF0ZScsIHNob3dFbGVtZW50KTtcbn07XG5cbmNvbnN0IGhhc0l0ZW1zID0gKHJlc3BvbnNlOiBhbnkpID0+XG4gIHJlc3BvbnNlICYmXG4gIHJlc3BvbnNlLmRhdGEgJiZcbiAgcmVzcG9uc2UuZGF0YS5kYXRhYmFzZSAmJlxuICByZXNwb25zZS5kYXRhLmRhdGFiYXNlLmNvbW1lcmNlT3JkZXIgJiZcbiAgcmVzcG9uc2UuZGF0YS5kYXRhYmFzZS5jb21tZXJjZU9yZGVyLnVzZXJJdGVtcyAmJlxuICByZXNwb25zZS5kYXRhLmRhdGFiYXNlLmNvbW1lcmNlT3JkZXIudXNlckl0ZW1zLmxlbmd0aCA+IDA7XG5cbmNvbnN0IGhhc0Vycm9ycyA9IChyZXNwb25zZTogYW55KSA9PlxuICByZXNwb25zZSAmJiByZXNwb25zZS5lcnJvcnMgJiYgcmVzcG9uc2UuZXJyb3JzLmxlbmd0aCA+IDA7XG5cbmNvbnN0IHVwZGF0ZUNhcnRBMTFZID0gKGNhcnQ6IEhUTUxFbGVtZW50KSA9PiB7XG4gIGRvRm9yQWxsTWF0Y2hpbmdDbGFzcyhcbiAgICBjYXJ0LFxuICAgICd3LWNvbW1lcmNlLWNvbW1lcmNlY2FydG9wZW5saW5rY291bnQnLFxuICAgIC8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzcwMDYgLSBQYXJhbWV0ZXIgJ2VsZW1lbnQnIGltcGxpY2l0bHkgaGFzIGFuICdhbnknIHR5cGUuXG4gICAgKGVsZW1lbnQpID0+IHtcbiAgICAgIGRvRm9yQWxsTWF0Y2hpbmdDbGFzcyhcbiAgICAgICAgY2FydCxcbiAgICAgICAgJ3ctY29tbWVyY2UtY29tbWVyY2VjYXJ0b3BlbmxpbmsnLFxuICAgICAgICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFM3MDA2IC0gUGFyYW1ldGVyICdvcGVuTGlua0VsZW1lbnQnIGltcGxpY2l0bHkgaGFzIGFuICdhbnknIHR5cGUuXG4gICAgICAgIChvcGVuTGlua0VsZW1lbnQpID0+IHtcbiAgICAgICAgICBvcGVuTGlua0VsZW1lbnQuc2V0QXR0cmlidXRlKFxuICAgICAgICAgICAgJ2FyaWEtbGFiZWwnLFxuICAgICAgICAgICAgZWxlbWVudC50ZXh0Q29udGVudCA9PT0gJzAnXG4gICAgICAgICAgICAgID8gJ09wZW4gZW1wdHkgY2FydCdcbiAgICAgICAgICAgICAgOiBgT3BlbiBjYXJ0IGNvbnRhaW5pbmcgJHtlbGVtZW50LnRleHRDb250ZW50fSBpdGVtc2BcbiAgICAgICAgICApO1xuICAgICAgICB9XG4gICAgICApO1xuICAgIH1cbiAgKTtcbn07XG5cbmV4cG9ydCBjb25zdCByZW5kZXJDYXJ0ID0gKFxuICBjYXJ0OiBFbGVtZW50LFxuICBkYXRhOiBSZWNvcmQ8YW55LCBhbnk+LFxuICBzdHJpcGVTdG9yZT86IFN0cmlwZVN0b3JlXG4pID0+IHtcbiAgaGlkZUVycm9yU3RhdGUoY2FydCk7XG5cbiAgaWYgKGhhc0Vycm9ycyhkYXRhKSkge1xuICAgIHNob3dFcnJvclN0YXRlKGNhcnQpO1xuICB9XG5cbiAgZG9Gb3JBbGxNYXRjaGluZ0NsYXNzKFxuICAgIGNhcnQsXG4gICAgJ3ctY29tbWVyY2UtY29tbWVyY2VjYXJ0b3Blbmxpbmtjb3VudCcsXG4gICAgLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTNzAwNiAtIFBhcmFtZXRlciAnZWxlbWVudCcgaW1wbGljaXRseSBoYXMgYW4gJ2FueScgdHlwZS5cbiAgICAoZWxlbWVudCkgPT4ge1xuICAgICAgY29uc3QgaGlkZVJ1bGUgPSBlbGVtZW50LmdldEF0dHJpYnV0ZShEQVRBX0FUVFJfQ09VTlRfSElERV9SVUxFKTtcblxuICAgICAgaWYgKFxuICAgICAgICBoaWRlUnVsZSA9PT0gQ0FSVF9DT1VOVF9ISURFX1JVTEVTLkFMV0FZUyB8fFxuICAgICAgICAoaGlkZVJ1bGUgPT09IENBUlRfQ09VTlRfSElERV9SVUxFUy5FTVBUWSAmJiAhaGFzSXRlbXMoZGF0YSkpXG4gICAgICApIHtcbiAgICAgICAgaGlkZUVsZW1lbnQoZWxlbWVudCk7XG4gICAgICB9IGVsc2Uge1xuICAgICAgICBzaG93RWxlbWVudChlbGVtZW50KTtcbiAgICAgIH1cbiAgICB9XG4gICk7XG5cbiAgLy8gSWYgaXQgaXMgYSBuZXdseSBwdWJsaXNoZWQgc2l0ZSB0aGUgY29tbWVyY2VPcmRlciB3aWxsIGJlIG51bGwsIGNhdXNpbmcgdGhlIGNhcnQgY291bnRlciB0byByZW5kZXJcbiAgLy8gYW4gZW1wdHkgZGl2IGlmIGhpZGUgY2FydCB3aGVuIGVtcHR5IGlzIGZhbHNlIGFuZCB1c2VySXRlbXNDb3VudCBpcyBub3Qgc2V0IHRvIDBcbiAgY29uc3QgZGF0YVdpdGhEZWZhdWx0cyA9IG1lcmdlV2l0aCh7fSwgZGF0YSwgKG9iaiwgc3JjLCBrZXkpID0+IHtcbiAgICBpZiAoa2V5ID09PSAnY29tbWVyY2VPcmRlcicgJiYgc3JjID09PSBudWxsKSB7XG4gICAgICByZXR1cm4ge3VzZXJJdGVtc0NvdW50OiAwfTtcbiAgICB9XG4gIH0pO1xuXG4gIHJlbmRlclRyZWUoY2FydCwgZGF0YVdpdGhEZWZhdWx0cyk7XG5cbiAgaWYgKGhhc0l0ZW1zKGRhdGEpKSB7XG4gICAgc2hvd0NhcnREZWZhdWx0U3RhdGUoY2FydCk7XG4gIH0gZWxzZSB7XG4gICAgc2hvd0NhcnRFbXB0eVN0YXRlKGNhcnQpO1xuICB9XG4gIGNvbnN0IGNhcnRGb3JtID0gY2FydC5xdWVyeVNlbGVjdG9yKCdmb3JtJyk7XG4gIGlmIChjYXJ0Rm9ybSBpbnN0YW5jZW9mIEhUTUxGb3JtRWxlbWVudCkge1xuICAgIGVuYWJsZUFsbEZvcm1FbGVtZW50cyhjYXJ0Rm9ybSk7XG4gIH1cblxuICAvLyB3ZSBoaWRlIHRoZSBidXR0b24gd2hlbiB0aGUgcGF5cGFsIHNkayBpcyBvbiB0aGUgcGFnZSAob25seSBhcHBlYXJzIHdoZW4gcGF5cGFsIGxpbmtlZCBhbmQgY2hlY2tvdXQgZW5hYmxlZClcbiAgLy8gYW5kIHdoZW4gdGhlIHN0cmlwZSBzdG9yZSByZXBvcnRzIHRoYXQgaXQncyBub3QgaW5pdGlhbGl6ZWQuIHdlIGRvbid0IHBhc3Mgc3RyaXBlIHN0b3JlIGZvciBzb21lIGVycm9ycyxcbiAgLy8gc28gdGhpcyBlbnN1cmVzIHRoYXQgdGhlIGJ1dHRvbiB3aWxsIGJlIHNob3duIHN0aWxsIGlmIHRoZXJlIHdhcyBhbiBlcnJvci5cbiAgY29uc3QgcGF5cGFsRWxlbWVudCA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IoYFske1BBWVBBTF9FTEVNRU5UX0lOU1RBTkNFfV1gKTtcbiAgY29uc3QgY2hlY2tvdXRCdXR0b24gPSBmaW5kRWxlbWVudEJ5Tm9kZVR5cGUoXG4gICAgTk9ERV9UWVBFX0NPTU1FUkNFX0NBUlRfQ0hFQ0tPVVRfQlVUVE9OLFxuICAgIGNhcnRcbiAgKTtcbiAgaWYgKFxuICAgIGNoZWNrb3V0QnV0dG9uICYmXG4gICAgcGF5cGFsRWxlbWVudCAmJlxuICAgIHN0cmlwZVN0b3JlICYmXG4gICAgIXN0cmlwZVN0b3JlLmlzSW5pdGlhbGl6ZWQoKVxuICApIHtcbiAgICBpZiAoaXNGcmVlT3JkZXIoZGF0YSkpIHtcbiAgICAgIHNob3dFbGVtZW50KGNoZWNrb3V0QnV0dG9uKTtcbiAgICB9IGVsc2Uge1xuICAgICAgaGlkZUVsZW1lbnQoY2hlY2tvdXRCdXR0b24pO1xuICAgIH1cbiAgfVxuXG4gIGNvbnN0IHBheXBhbEJ1dHRvbiA9IGNhcnQucXVlcnlTZWxlY3RvcihcbiAgICBgWyR7UEFZUEFMX0JVVFRPTl9FTEVNRU5UX0lOU1RBTkNFfV1gXG4gICk7XG4gIGlmIChwYXlwYWxFbGVtZW50ICYmIHBheXBhbEJ1dHRvbikge1xuICAgIGlmIChpc0ZyZWVPcmRlcihkYXRhKSB8fCBoYXNTdWJzY3JpcHRpb24oZGF0YSkpIHtcbiAgICAgIC8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzIzNDUgLSBBcmd1bWVudCBvZiB0eXBlICdFbGVtZW50JyBpcyBub3QgYXNzaWduYWJsZSB0byBwYXJhbWV0ZXIgb2YgdHlwZSAnSFRNTEVsZW1lbnQnLlxuICAgICAgaGlkZUVsZW1lbnQocGF5cGFsQnV0dG9uKTtcbiAgICB9IGVsc2Uge1xuICAgICAgLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTMjM0NSAtIEFyZ3VtZW50IG9mIHR5cGUgJ0VsZW1lbnQnIGlzIG5vdCBhc3NpZ25hYmxlIHRvIHBhcmFtZXRlciBvZiB0eXBlICdIVE1MRWxlbWVudCcuXG4gICAgICBzaG93RWxlbWVudChwYXlwYWxCdXR0b24pO1xuICAgIH1cbiAgfVxuXG4gIHVwZGF0ZVdlYlBheW1lbnRzQnV0dG9uKGNhcnQsIGRhdGEsIHN0cmlwZVN0b3JlKTtcblxuICByZXR1cm4gY2FydDtcbn07XG5cbmNvbnN0IGhhbmRsZVJlbmRlckNhcnQgPSAoXG4gIGV2ZW50OiBFdmVudCB8IEN1c3RvbUV2ZW50LFxuICBhcG9sbG9DbGllbnQ6IEFwb2xsb0NsaWVudCxcbiAgc3RyaXBlU3RvcmU6IFN0cmlwZVN0b3JlXG4pID0+IHtcbiAgaWYgKHdpbmRvdy5XZWJmbG93LmVudignZGVzaWduJykgfHwgd2luZG93LldlYmZsb3cuZW52KCdwcmV2aWV3JykpIHtcbiAgICByZXR1cm47XG4gIH1cbiAgaWYgKCEoZXZlbnQgaW5zdGFuY2VvZiBDdXN0b21FdmVudCAmJiBldmVudC50eXBlID09PSBSRU5ERVJfVFJFRV9FVkVOVCkpIHtcbiAgICByZXR1cm47XG4gIH1cbiAgY29uc3QgZXJyb3JzOiBBcnJheTxhbnk+ID0gW107XG4gIGNvbnN0IHtkZXRhaWx9ID0gZXZlbnQ7XG4gIGlmIChkZXRhaWwgIT0gbnVsbCAmJiBkZXRhaWwuZXJyb3IpIHtcbiAgICBlcnJvcnMucHVzaChkZXRhaWwuZXJyb3IpO1xuICB9XG4gIGNvbnN0IG9yZGVyQ29uZmlybWF0aW9uQ29udGFpbmVyID0gZmluZEVsZW1lbnRCeU5vZGVUeXBlKFxuICAgIE5PREVfVFlQRV9DT01NRVJDRV9PUkRFUl9DT05GSVJNQVRJT05fV1JBUFBFUlxuICApO1xuICAvLyBzdG9wIGNhcnQgcmVuZGVyIG9uIG9yZGVyIGNvbmZpcm1hdGlvbiBwYWdlIGFzIGl0IHdpbGwgYWx3YXlzIGJlIGVtcHR5LCB0aGlzIHF1ZXJ5IHdhcyBzZXR0aW5nIGNvbW1lcmNlT3JkZXIgdG8gbnVsbFxuICAvLyBhbmQgb3ZlcndyaXR0aW5nIGEgc2Vjb25kIHF1ZXJ5IGluIGBoYW5kbGVSZW5kZXJPcmRlckNvbmZpcm1hdGlvbmBcbiAgaWYgKG9yZGVyQ29uZmlybWF0aW9uQ29udGFpbmVyKSB7XG4gICAgcmV0dXJuO1xuICB9XG5cbiAgY29uc3QgY2FydHMgPSBmaW5kQWxsRWxlbWVudHNCeU5vZGVUeXBlKE5PREVfVFlQRV9DT01NRVJDRV9DQVJUX1dSQVBQRVIpO1xuXG4gIGlmICghY2FydHMubGVuZ3RoKSB7XG4gICAgZXhlY3V0ZUxvYWRpbmdDYWxsYmFja3MoKTtcbiAgICByZXR1cm47XG4gIH1cblxuICBjYXJ0cy5mb3JFYWNoKChjYXJ0OiBIVE1MRWxlbWVudCkgPT4ge1xuICAgIGFwb2xsb0NsaWVudFxuICAgICAgLnF1ZXJ5KHtcbiAgICAgICAgcXVlcnk6IGdxbGBcbiAgICAgICAgICAke2NhcnQuZ2V0QXR0cmlidXRlKENBUlRfUVVFUlkpfVxuICAgICAgICBgLFxuICAgICAgICBmZXRjaFBvbGljeTogJ25ldHdvcmstb25seScsXG4gICAgICAgIGVycm9yUG9saWN5OiAnYWxsJyxcbiAgICAgIH0pXG4gICAgICAudGhlbigoZGF0YSkgPT4ge1xuICAgICAgICBleGVjdXRlTG9hZGluZ0NhbGxiYWNrcygpO1xuICAgICAgICByZW5kZXJDYXJ0KFxuICAgICAgICAgIGNhcnQsXG4gICAgICAgICAge1xuICAgICAgICAgICAgLi4uZGF0YSxcbiAgICAgICAgICAgIGVycm9yczogZXJyb3JzLmNvbmNhdChkYXRhLmVycm9yKS5maWx0ZXIoQm9vbGVhbiksXG4gICAgICAgICAgfSxcbiAgICAgICAgICBzdHJpcGVTdG9yZVxuICAgICAgICApO1xuICAgICAgICB1cGRhdGVDYXJ0QTExWShjYXJ0KTtcbiAgICAgIH0pXG4gICAgICAuY2F0Y2goKGVycikgPT4ge1xuICAgICAgICBleGVjdXRlTG9hZGluZ0NhbGxiYWNrcygpO1xuICAgICAgICBlcnJvcnMucHVzaChlcnIpO1xuICAgICAgICByZW5kZXJDYXJ0KGNhcnQsIHtlcnJvcnN9KTtcbiAgICAgICAgdXBkYXRlQ2FydEExMVkoY2FydCk7XG4gICAgICB9KTtcbiAgfSk7XG59O1xuXG5jb25zdCBoYW5kbGVDYXJ0S2V5VXAgPSAoZXZlbnQ6IEV2ZW50IHwgS2V5Ym9hcmRFdmVudCkgPT4ge1xuICAvLyBFc2NhcGVcbiAgLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTMjMzOSAtIFByb3BlcnR5ICdrZXlDb2RlJyBkb2VzIG5vdCBleGlzdCBvbiB0eXBlICdFdmVudCB8IEtleWJvYXJkRXZlbnQnLlxuICBpZiAoZXZlbnQua2V5Q29kZSA9PT0gMjcpIHtcbiAgICBjb25zdCBvcGVuQ2FydHMgPSBBcnJheS5mcm9tKGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3JBbGwoYFske0NBUlRfT1BFTn1dYCkpO1xuICAgIGZvckVhY2gob3BlbkNhcnRzLCAoY2FydCkgPT4ge1xuICAgICAgY29uc3QgZXZ0ID0gbmV3IEN1c3RvbUV2ZW50KENIQU5HRV9DQVJUX0VWRU5ULCB7XG4gICAgICAgIGJ1YmJsZXM6IHRydWUsXG4gICAgICAgIGRldGFpbDoge1xuICAgICAgICAgIG9wZW46IGZhbHNlLFxuICAgICAgICB9LFxuICAgICAgfSk7XG4gICAgICBjYXJ0LmRpc3BhdGNoRXZlbnQoZXZ0KTtcbiAgICB9KTtcbiAgfVxuXG4gIC8vIFNwYWNlYmFyXG4gIC8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzIzMzkgLSBQcm9wZXJ0eSAna2V5Q29kZScgZG9lcyBub3QgZXhpc3Qgb24gdHlwZSAnRXZlbnQgfCBLZXlib2FyZEV2ZW50Jy5cbiAgaWYgKGV2ZW50LmtleUNvZGUgPT09IDMyICYmIGV2ZW50LnRhcmdldCBpbnN0YW5jZW9mIEhUTUxFbGVtZW50KSB7XG4gICAgLy8gRmxvdyB3YXMgYmVpbmcgYSBiaXQgc3RyYW5nZSB3aXRoIHR5cGluZyBhbmQgb25seSBhc3N1bWluZyBIVE1MRWxlbWVudFxuICAgIC8vIHRoZSBmaXJzdCB0aW1lIGl0IHdhcyB1c2VkLiBTbyBzZXR0aW5nIGl0IGFzIGEgbmV3IHZhcmlhYmxlIGhlcmUgdG9cbiAgICAvLyBwZXJzaXN0IHRoYXQgdHlwZS5cbiAgICBjb25zdCBodG1sRWxlbWVudCA9IGV2ZW50LnRhcmdldDtcblxuICAgIC8vIE1ha2Ugc3VyZSBlbGVtZW50IGJlaW5nIGNoZWNrZWQgaXMgaW50ZW5kZWQgdG8gd29yayBhcyBhIGxpbmsgb3IgYnV0dG9uIGFuZFxuICAgIC8vIGlzIGEgY2hpbGQgb2YgYGNvbW1lcmNlLWNhcnQtd3JhcHBlcmBcbiAgICAvLyBUaGlzIHdpbGwgcHJldmVudCB0aGUga2V5Ym9hcmQgdHJpZ2dlciBhcHBseWluZyB0byBlbGVtZW50cyB0aGF0IGRvbid0XG4gICAgLy8gYmVsb25nIHRvIHRoZSBDYXJ0IG9yIG90aGVyd2lzZSBzaG91bGRuJ3QgYmUgaW50ZXJhY3RhYmxlIGluIHRoaXMgbWFubmVyLlxuICAgIGlmIChcbiAgICAgIChodG1sRWxlbWVudC5nZXRBdHRyaWJ1dGUoJ3JvbGUnKSA9PT0gJ2J1dHRvbicgfHxcbiAgICAgICAgaHRtbEVsZW1lbnQuZ2V0QXR0cmlidXRlKCdyb2xlJykgPT09ICdsaW5rJyB8fFxuICAgICAgICBodG1sRWxlbWVudC5oYXNBdHRyaWJ1dGUoJ2hyZWYnKSB8fFxuICAgICAgICBodG1sRWxlbWVudC5oYXNBdHRyaWJ1dGUoJ29uQ2xpY2snKSkgJiZcbiAgICAgIGZpbmRDbG9zZXN0RWxlbWVudEJ5Tm9kZVR5cGUoXG4gICAgICAgIE5PREVfVFlQRV9DT01NRVJDRV9DQVJUX1dSQVBQRVIsXG4gICAgICAgIGV2ZW50LnRhcmdldFxuICAgICAgKSAhPSBudWxsXG4gICAgKSB7XG4gICAgICBldmVudC5wcmV2ZW50RGVmYXVsdCgpO1xuICAgICAgaHRtbEVsZW1lbnQuY2xpY2soKTtcbiAgICB9XG4gIH1cbn07XG5cbmNvbnN0IGdldENhcnRDb250YWluZXIgPSAoXG4gIHBhcmVudDogSFRNTEVsZW1lbnRcbik6IEhUTUxFbGVtZW50IHwgbnVsbCB8IHVuZGVmaW5lZCA9PlxuICBmaW5kRWxlbWVudEJ5Tm9kZVR5cGUoTk9ERV9UWVBFX0NPTU1FUkNFX0NBUlRfQ09OVEFJTkVSLCBwYXJlbnQpO1xuXG5jb25zdCBoYW5kbGVDbGlja0Nsb3NlQ2FydCA9ICh7dGFyZ2V0fTogRXZlbnQpID0+IHtcbiAgaWYgKCEodGFyZ2V0IGluc3RhbmNlb2YgRWxlbWVudCkpIHtcbiAgICByZXR1cm47XG4gIH1cblxuICBjb25zdCBvcGVuQ2FydHMgPSBBcnJheS5mcm9tKGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3JBbGwoYFske0NBUlRfT1BFTn1dYCkpO1xuICBmb3JFYWNoKG9wZW5DYXJ0cywgKGNhcnQpID0+IHtcbiAgICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFMyMzQ1IC0gQXJndW1lbnQgb2YgdHlwZSAnRWxlbWVudCcgaXMgbm90IGFzc2lnbmFibGUgdG8gcGFyYW1ldGVyIG9mIHR5cGUgJ0hUTUxFbGVtZW50Jy5cbiAgICBjb25zdCBjYXJ0Q29udGFpbmVyID0gZ2V0Q2FydENvbnRhaW5lcihjYXJ0KTtcbiAgICBjb25zdCBjYXJ0T3BlbkJ1dHRvbiA9IGZpbmRFbGVtZW50QnlOb2RlVHlwZShcbiAgICAgIE5PREVfVFlQRV9DT01NRVJDRV9DQVJUX09QRU5fTElOSyxcbiAgICAgIGNhcnRcbiAgICApO1xuICAgIGlmIChcbiAgICAgICEoY2FydENvbnRhaW5lciBpbnN0YW5jZW9mIEVsZW1lbnQpIHx8XG4gICAgICAhKGNhcnRPcGVuQnV0dG9uIGluc3RhbmNlb2YgRWxlbWVudClcbiAgICApIHtcbiAgICAgIHJldHVybjtcbiAgICB9XG5cbiAgICBjb25zdCBjYXJ0VHlwZSA9IGNhcnQuZ2V0QXR0cmlidXRlKENBUlRfVFlQRSk7XG4gICAgLy8gb24gZHJvcGRvd24sIHdlIGNsb3NlIGlmIG91dHNpZGUgdGhlIGNhcnQgaXMgY2xpY2tlZCwgYW5kIG9uIG1vZGFsL3NpZGViYXIsIHdlIGNsb3NlIGlmIG91dHNpZGUgdGhlIGNvbnRhaW5lciBvciBvcGVuIGJ1dHRvbiBpcyBjbGlja2VkXG4gICAgY29uc3QgaXNOb3RJbnNpZGUgPVxuICAgICAgY2FydFR5cGUgPT09IExFRlRfRFJPUERPV04gfHwgY2FydFR5cGUgPT09IFJJR0hUX0RST1BET1dOXG4gICAgICAgID8gIWNhcnQuY29udGFpbnModGFyZ2V0KVxuICAgICAgICA6ICFjYXJ0Q29udGFpbmVyLmNvbnRhaW5zKHRhcmdldCkgJiYgIWNhcnRPcGVuQnV0dG9uLmNvbnRhaW5zKHRhcmdldCk7XG5cbiAgICBpZiAoaXNOb3RJbnNpZGUpIHtcbiAgICAgIGNvbnN0IGV2dCA9IG5ldyBDdXN0b21FdmVudChDSEFOR0VfQ0FSVF9FVkVOVCwge1xuICAgICAgICBidWJibGVzOiB0cnVlLFxuICAgICAgICBkZXRhaWw6IHtcbiAgICAgICAgICBvcGVuOiBmYWxzZSxcbiAgICAgICAgfSxcbiAgICAgIH0pO1xuICAgICAgY2FydC5kaXNwYXRjaEV2ZW50KGV2dCk7XG4gICAgfVxuICB9KTtcbn07XG5cbmNvbnN0IGdldEZvY3VzYWJsZUVsZW1lbnRzID0gKGNvbnRhaW5lcjogSFRNTEVsZW1lbnQpID0+IHtcbiAgY29uc3QgZm9jdXNhYmxlRWxlbWVudHMgPVxuICAgICdidXR0b24sIFtocmVmXSwgaW5wdXQsIHNlbGVjdCwgdGV4dGFyZWEsIFt0YWJpbmRleF06bm90KFt0YWJpbmRleD1cIi0xXCJdKSc7XG5cbiAgcmV0dXJuIFsuLi5jb250YWluZXIucXVlcnlTZWxlY3RvckFsbChmb2N1c2FibGVFbGVtZW50cyldLmZpbHRlcihcbiAgICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFMyMzM5IC0gUHJvcGVydHkgJ29mZnNldEhlaWdodCcgZG9lcyBub3QgZXhpc3Qgb24gdHlwZSAnRWxlbWVudCcuXG4gICAgKGVsZW1lbnQpID0+ICFlbGVtZW50Lmhhc0F0dHJpYnV0ZSgnZGlzYWJsZWQnKSAmJiBlbGVtZW50Lm9mZnNldEhlaWdodCA+IDBcbiAgKTtcbn07XG5cbmNvbnN0IGhhbmRsZUNhcnRGb2N1c1RyYXAgPSAoZXZlbnQ6IEV2ZW50IHwgS2V5Ym9hcmRFdmVudCkgPT4ge1xuICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFMyMzM5IC0gUHJvcGVydHkgJ2tleScgZG9lcyBub3QgZXhpc3Qgb24gdHlwZSAnRXZlbnQgfCBLZXlib2FyZEV2ZW50Jy4gfCBUUzIzMzkgLSBQcm9wZXJ0eSAna2V5Q29kZScgZG9lcyBub3QgZXhpc3Qgb24gdHlwZSAnRXZlbnQgfCBLZXlib2FyZEV2ZW50Jy5cbiAgaWYgKGV2ZW50LmtleSAhPT0gJ1RhYicgJiYgZXZlbnQua2V5Q29kZSAhPT0gOSkge1xuICAgIHJldHVybjtcbiAgfVxuXG4gIGNvbnN0IG9wZW5DYXJ0cyA9IEFycmF5LmZyb20oZG9jdW1lbnQucXVlcnlTZWxlY3RvckFsbChgWyR7Q0FSVF9PUEVOfV1gKSk7XG4gIGZvckVhY2gob3BlbkNhcnRzLCAoY2FydCkgPT4ge1xuICAgIC8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzIzNDUgLSBBcmd1bWVudCBvZiB0eXBlICdFbGVtZW50JyBpcyBub3QgYXNzaWduYWJsZSB0byBwYXJhbWV0ZXIgb2YgdHlwZSAnSFRNTEVsZW1lbnQnLlxuICAgIGNvbnN0IGNhcnRDb250YWluZXIgPSBnZXRDYXJ0Q29udGFpbmVyKGNhcnQpO1xuICAgIGlmICghKGNhcnRDb250YWluZXIgaW5zdGFuY2VvZiBFbGVtZW50KSkge1xuICAgICAgcmV0dXJuO1xuICAgIH1cblxuICAgIGNvbnN0IGZvY3VzYWJsZUNvbnRlbnQgPSBnZXRGb2N1c2FibGVFbGVtZW50cyhjYXJ0Q29udGFpbmVyKTtcbiAgICBjb25zdCBmaXJzdEZvY3VzYWJsZUVsZW1lbnQgPSBmb2N1c2FibGVDb250ZW50WzBdO1xuICAgIGNvbnN0IGxhc3RGb2N1c2FibGVFbGVtZW50ID0gZm9jdXNhYmxlQ29udGVudFtmb2N1c2FibGVDb250ZW50Lmxlbmd0aCAtIDFdO1xuXG4gICAgLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTMjMzOSAtIFByb3BlcnR5ICdzaGlmdEtleScgZG9lcyBub3QgZXhpc3Qgb24gdHlwZSAnRXZlbnQgfCBLZXlib2FyZEV2ZW50Jy5cbiAgICBpZiAoZXZlbnQuc2hpZnRLZXkpIHtcbiAgICAgIGlmIChkb2N1bWVudC5hY3RpdmVFbGVtZW50ID09PSBmaXJzdEZvY3VzYWJsZUVsZW1lbnQpIHtcbiAgICAgICAgLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTMjMzOSAtIFByb3BlcnR5ICdmb2N1cycgZG9lcyBub3QgZXhpc3Qgb24gdHlwZSAnRWxlbWVudCcuXG4gICAgICAgIGxhc3RGb2N1c2FibGVFbGVtZW50LmZvY3VzKCk7XG4gICAgICAgIGV2ZW50LnByZXZlbnREZWZhdWx0KCk7XG4gICAgICB9XG4gICAgfSBlbHNlIHtcbiAgICAgIGlmIChkb2N1bWVudC5hY3RpdmVFbGVtZW50ID09PSBsYXN0Rm9jdXNhYmxlRWxlbWVudCkge1xuICAgICAgICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFMyMzM5IC0gUHJvcGVydHkgJ2ZvY3VzJyBkb2VzIG5vdCBleGlzdCBvbiB0eXBlICdFbGVtZW50Jy5cbiAgICAgICAgZmlyc3RGb2N1c2FibGVFbGVtZW50LmZvY3VzKCk7XG4gICAgICAgIGV2ZW50LnByZXZlbnREZWZhdWx0KCk7XG4gICAgICB9XG4gICAgfVxuICB9KTtcbn07XG5cbmV4cG9ydCBjb25zdCByZWdpc3RlciA9IChoYW5kbGVyUHJveHk6IEV2ZW50SGFuZGxlclByb3h5V2l0aEFwb2xsb0NsaWVudCkgPT4ge1xuICBoYW5kbGVyUHJveHkub24oJ2NsaWNrJywgaXNJdGVtUmVtb3ZlZEV2ZW50LCBoYW5kbGVJdGVtUmVtb3ZlZCk7XG4gIGhhbmRsZXJQcm94eS5vbihcbiAgICAnY2hhbmdlJyxcbiAgICBpc0l0ZW1RdWFudGl0eUNoYW5nZWRFdmVudCxcbiAgICBoYW5kbGVJdGVtUXVhbnRpdHlDaGFuZ2VkXG4gICk7XG4gIGhhbmRsZXJQcm94eS5vbignZm9jdXMnLCBpc0l0ZW1RdWFudGl0eUlucHV0RXZlbnQsIGhhbmRsZUl0ZW1JbnB1dENoYW5nZWQpO1xuICBoYW5kbGVyUHJveHkub24oJ2NsaWNrJywgaXNDYXJ0QnV0dG9uRXZlbnQsIGhhbmRsZUNhcnRCdXR0b24pO1xuICBoYW5kbGVyUHJveHkub24oJ2NsaWNrJywgaXNDYXJ0Q2hlY2tvdXRCdXR0b25FdmVudCwgaGFuZGxlQ2FydENoZWNrb3V0QnV0dG9uKTtcbiAgaGFuZGxlclByb3h5Lm9uKCdtb3VzZW92ZXInLCBpc0NhcnRCdXR0b25FdmVudCwgaGFuZGxlQ2FydEJ1dHRvbik7XG4gIGhhbmRsZXJQcm94eS5vbihcbiAgICBDSEFOR0VfQ0FSVF9FVkVOVCxcbiAgICBpc0NhcnRXcmFwcGVyRXZlbnQsXG4gICAgaGFuZGxlQ2hhbmdlQ2FydFN0YXRlRXZlbnRcbiAgKTtcbiAgaGFuZGxlclByb3h5Lm9uKFJFTkRFUl9UUkVFX0VWRU5ULCBCb29sZWFuLCBoYW5kbGVSZW5kZXJDYXJ0KTtcbiAgLy8gTmVlZGVkIHRvIGF2b2lkIHN1Ym1pc3Npb24gb2YgY2FydCBmb3JtIHdoZW4gb25seSBvbmUgaXRlbSBpcyBpbiBjYXJ0IGFuZCB1c2VyIGhpdHNcbiAgLy8gZW50ZXIga2V5IHdoaWxlIGluIHF1YW50aXR5IGlucHV0IChhY3RzIGFzIHN1Ym1pdCBpZiBvbmx5IDEgaW5wdXQgYW5kIG5vIHN1Ym1pdClcbiAgaGFuZGxlclByb3h5Lm9uKCdzdWJtaXQnLCBpc0NhcnRGb3JtRXZlbnQsIGhhbmRsZVN1Ym1pdEZvcm0pO1xuICBoYW5kbGVyUHJveHkub24oJ2tleXVwJywgQm9vbGVhbiwgaGFuZGxlQ2FydEtleVVwKTtcbiAgaGFuZGxlclByb3h5Lm9uKCdjbGljaycsIEJvb2xlYW4sIGhhbmRsZUNsaWNrQ2xvc2VDYXJ0KTtcblxuICAvLyBUaGVzZSBldmVudHMgYXJlIGZvciBoYW5kbGluZyB0aGUgYmFjayBhbmQgZm9ydGggYmV0d2VlbiBwcmV2aWV3IGFuZCBkZXNpZ25lclxuICAvLyBhbmQgbXVzdCBiZSByZWdpc3RlcmVkIGRpcmVjdGx5IHRvIHRoZSB3aW5kb3csIG90aGVyd2lzZSB0aGV5IGFyZSBub3QgcmVnaXN0ZXJlZFxuICAvLyB3aGVuIHRoZSBjYW52YXMgaXMgY3JlYXRlZC5cbiAgaWYgKHdpbmRvdy5XZWJmbG93LmVudignZGVzaWduJykgfHwgd2luZG93LldlYmZsb3cuZW52KCdwcmV2aWV3JykpIHtcbiAgICB3aW5kb3cuYWRkRXZlbnRMaXN0ZW5lcignX193Zl9wcmV2aWV3JywgaGFuZGxlUHJldmlld01vZGUpO1xuICAgIHdpbmRvdy5hZGRFdmVudExpc3RlbmVyKCdfX3dmX2Rlc2lnbicsIGhhbmRsZURlc2lnbk1vZGUpO1xuICB9XG59O1xuXG5leHBvcnQgZGVmYXVsdCB7cmVnaXN0ZXJ9O1xuIl0sIm5hbWVzIjpbInJlZ2lzdGVyIiwicmVuZGVyQ2FydCIsIk1PREFMIiwiTEVGVF9TSURFQkFSIiwiUklHSFRfU0lERUJBUiIsIkxFRlRfRFJPUERPV04iLCJSSUdIVF9EUk9QRE9XTiIsIkNBUlRfVFlQRVMiLCJSRU1PVkVfSVRFTSIsIlVQREFURV9JVEVNX1FVQU5USVRZIiwiQ09NTUVSQ0VfQ0FSVF9QVUJMSVNIRURfU0lURV9BQ1RJT05TIiwidXBkYXRlSXRlbVF1YW50aXR5TXV0YXRpb24iLCJncWwiLCJmb3JFYWNoRWxlbWVudEluRm9ybSIsImZvcm0iLCJjYWxsYmFjayIsIkhUTUxGb3JtRWxlbWVudCIsImVsZW1lbnRzIiwiSFRNTENvbGxlY3Rpb24iLCJBcnJheSIsImZyb20iLCJmb3JFYWNoIiwiaW5wdXQiLCJIVE1MSW5wdXRFbGVtZW50IiwiZGlzYWJsZUFsbEZvcm1FbGVtZW50cyIsImRpc2FibGVkIiwiZW5hYmxlQWxsRm9ybUVsZW1lbnRzIiwic2VhcmNoVHJlZUZvclJlbW92ZUxpbmsiLCJlbGVtZW50IiwiRWxlbWVudCIsImhhc0F0dHJpYnV0ZSIsIkNPTU1FUkNFX0NBUlRfUFVCTElTSEVEX1NJVEVfQUNUSU9OX0FUVFIiLCJnZXRBdHRyaWJ1dGUiLCJEQVRBX0FUVFJfQ09NTUVSQ0VfU0tVX0lEIiwicGFyZW50RWxlbWVudCIsImlzSXRlbVJlbW92ZWRFdmVudCIsImV2ZW50IiwidGFyZ2V0IiwiaXNJdGVtUXVhbnRpdHlDaGFuZ2VkRXZlbnQiLCJpc0l0ZW1RdWFudGl0eUlucHV0RXZlbnQiLCJpc0NhcnRCdXR0b25FdmVudCIsImNhcnRPcGVuTGluayIsImZpbmRDbG9zZXN0RWxlbWVudEJ5Tm9kZVR5cGUiLCJOT0RFX1RZUEVfQ09NTUVSQ0VfQ0FSVF9PUEVOX0xJTksiLCJjYXJ0Q2xvc2VMaW5rIiwiTk9ERV9UWVBFX0NPTU1FUkNFX0NBUlRfQ0xPU0VfTElOSyIsImlzQ2FydENoZWNrb3V0QnV0dG9uRXZlbnQiLCJjYXJ0Q2hlY2tvdXRCdXR0b24iLCJOT0RFX1RZUEVfQ09NTUVSQ0VfQ0FSVF9DSEVDS09VVF9CVVRUT04iLCJpc0NhcnRXcmFwcGVyRXZlbnQiLCJEQVRBX0FUVFJfTk9ERV9UWVBFIiwiTk9ERV9UWVBFX0NPTU1FUkNFX0NBUlRfV1JBUFBFUiIsImlzQ2FydEZvcm1FdmVudCIsIk5PREVfVFlQRV9DT01NRVJDRV9DQVJUX0ZPUk0iLCJnZXRGb3JtRWxlbWVudCIsImhhbmRsZUl0ZW1SZW1vdmVkIiwiYXBvbGxvQ2xpZW50Iiwid2luZG93IiwiV2ViZmxvdyIsImVudiIsInByZXZlbnREZWZhdWx0IiwiY3VycmVudFRhcmdldCIsIkhUTUxFbGVtZW50IiwiY29tbWVyY2VDYXJ0V3JhcHBlciIsImVycm9yRWxlbWVudCIsImZpbmRFbGVtZW50QnlOb2RlVHlwZSIsIk5PREVfVFlQRV9DT01NRVJDRV9DQVJUX0VSUk9SIiwic3R5bGUiLCJzZXRQcm9wZXJ0eSIsInNrdUlkIiwiY291bnQiLCJjYXJ0SXRlbSIsImZpbmRDbG9zZXN0RWxlbWVudEJ5Q2xhc3NOYW1lIiwiYWRkTG9hZGluZ0NhbGxiYWNrIiwic2V0RWxlbWVudExvYWRpbmciLCJyZW1vdmVMaW5rRWxlbWVudCIsIkhUTUxBbmNob3JFbGVtZW50IiwicG9pbnRlckV2ZW50cyIsIm11dGF0ZSIsIm11dGF0aW9uIiwidmFyaWFibGVzIiwidGhlbiIsInRyaWdnZXJSZW5kZXIiLCJlcnJvciIsImRlYnVnIiwicmVtb3ZlUHJvcGVydHkiLCJlcnJvck1zZyIsInF1ZXJ5U2VsZWN0b3IiLCJDQVJUX0VSUk9SX01FU1NBR0VfU0VMRUNUT1IiLCJlcnJvclRleHQiLCJDQVJUX0dFTkVSQUxfRVJST1JfTUVTU0FHRSIsInRleHRDb250ZW50IiwiY2FydENvbnRhaW5lciIsImNsb3Nlc3QiLCJpdGVtQ29udGFpbmVyIiwiZ2V0RWxlbWVudHNCeUNsYXNzTmFtZSIsImZvY3VzYWJsZUNvbnRlbnQiLCJnZXRGb2N1c2FibGVFbGVtZW50cyIsImxlbmd0aCIsImZvY3VzIiwiaGFuZGxlSXRlbVF1YW50aXR5Q2hhbmdlZCIsInJlcG9ydFZhbGlkaXR5IiwidmFsdWUiLCJlcnJvclR5cGUiLCJDb21iaW5lZEdyYXBoUUxFcnJvcnMiLCJpcyIsImVycm9ycyIsImNvZGUiLCJnZXRDYXJ0RXJyb3JNZXNzYWdlRm9yVHlwZSIsImhhbmRsZUl0ZW1JbnB1dENoYW5nZWQiLCJ2YWxpZGl0eSIsInZhbGlkIiwiaGFuZGxlQ2hhbmdlQ2FydFN0YXRlRXZlbnQiLCJDdXN0b21FdmVudCIsImRldGFpbCIsImlzT3BlbiIsIkNBUlRfT1BFTiIsInNob3VsZE9wZW4iLCJvcGVuIiwid3JhcHBlciIsIk5PREVfVFlQRV9DT01NRVJDRV9DQVJUX0NPTlRBSU5FUl9XUkFQUEVSIiwiZ2V0Q2FydENvbnRhaW5lciIsImNhcnRFbGVtZW50IiwiY2FydFR5cGUiLCJDQVJUX1RZUEUiLCJkdXJhdGlvbiIsImRlZmF1bHRUbyIsIkRBVEFfQVRUUl9BTklNQVRJT05fRFVSQVRJT04iLCJBTklNQVRJT05fRFVSQVRJT05fREVGQVVMVCIsImNvbnRhaW5lckVhc2luZyIsIkRBVEFfQVRUUl9BTklNQVRJT05fRUFTSU5HIiwiQU5JTUFUSU9OX0VBU0lOR19ERUZBVUxUIiwid3JhcHBlclRyYW5zaXRpb24iLCJjb250YWluZXJPdXREZWxheSIsInNob3VsZEFuaW1hdGUiLCJjb250YWluZXJTdGVwQSIsImNvbnRhaW5lclN0ZXBCIiwic2NhbGUiLCJ4IiwieSIsImRvY3VtZW50IiwiYWRkRXZlbnRMaXN0ZW5lciIsImhhbmRsZUNhcnRGb2N1c1RyYXAiLCJzZXRBdHRyaWJ1dGUiLCJ0cmFtIiwiYWRkIiwic2V0Iiwib3BhY2l0eSIsInN0YXJ0IiwicmVtb3ZlRXZlbnRMaXN0ZW5lciIsInJlbW92ZUF0dHJpYnV0ZSIsImRpc3BsYXkiLCJzdG9wIiwiY2FydE9wZW5CdXR0b24iLCJoYW5kbGVDYXJ0QnV0dG9uIiwidHlwZSIsImNhcnRDb250YWluZXJXcmFwcGVyIiwiZXZ0IiwiREFUQV9BVFRSX09QRU5fT05fSE9WRVIiLCJDSEFOR0VfQ0FSVF9FVkVOVCIsImJ1YmJsZXMiLCJoYW5kbGVDYXJ0Q29udGFpbmVyTGVhdmUiLCJkaXNwYXRjaEV2ZW50IiwiaGFuZGxlQ2FydENoZWNrb3V0QnV0dG9uIiwiY2hlY2tvdXRCdXR0b24iLCJpc1Byb3RvY29sSHR0cHMiLCJhbGVydCIsImxvYWRpbmdUZXh0IiwiREFUQV9BVFRSX0xPQURJTkdfVEVYVCIsImJ1dHRvblRleHQiLCJpbm5lckhUTUwiLCJDQVJUX0NIRUNLT1VUX0xPQURJTkdfVEVYVF9ERUZBVUxUIiwicHVibGlzaGFibGVLZXkiLCJEQVRBX0FUVFJfUFVCTElTSEFCTEVfS0VZIiwicGF5cGFsRWxlbWVudCIsIlBBWVBBTF9FTEVNRU5UX0lOU1RBTkNFIiwiQ0FSVF9DSEVDS09VVF9CVVRUT05fVEVYVF9ERUZBVUxUIiwibG9jYXRpb24iLCJocmVmIiwiaGFuZGxlU3VibWl0Rm9ybSIsInJlbGF0ZWRUYXJnZXQiLCJjYXJ0V3JhcHBlciIsIk5PREVfVFlQRV9DT01NRVJDRV9DQVJUX0NPTlRBSU5FUiIsImNhcnRDb250YWluZXJTdGF0ZXMiLCJoYW5kbGVQcmV2aWV3TW9kZSIsImNhcnRDb250YWluZXJFbGVtZW50cyIsImZpbmRBbGxFbGVtZW50c0J5Tm9kZVR5cGUiLCJ3YXNPcGVuIiwicHVzaCIsImhhbmRsZURlc2lnbk1vZGUiLCJkZXN0cm95IiwidHJhbnNmb3JtIiwiZG9Gb3JBbGxNYXRjaGluZ0NsYXNzIiwiY2FydCIsImNsYXNzTmFtZSIsImZuIiwic2hvd0NhcnREZWZhdWx0U3RhdGUiLCJoaWRlRWxlbWVudCIsInNob3dFbGVtZW50Iiwic2hvd0NhcnRFbXB0eVN0YXRlIiwiaGlkZUVycm9yU3RhdGUiLCJzaG93RXJyb3JTdGF0ZSIsImhhc0l0ZW1zIiwicmVzcG9uc2UiLCJkYXRhIiwiZGF0YWJhc2UiLCJjb21tZXJjZU9yZGVyIiwidXNlckl0ZW1zIiwiaGFzRXJyb3JzIiwidXBkYXRlQ2FydEExMVkiLCJvcGVuTGlua0VsZW1lbnQiLCJzdHJpcGVTdG9yZSIsImhpZGVSdWxlIiwiREFUQV9BVFRSX0NPVU5UX0hJREVfUlVMRSIsIkNBUlRfQ09VTlRfSElERV9SVUxFUyIsIkFMV0FZUyIsIkVNUFRZIiwiZGF0YVdpdGhEZWZhdWx0cyIsIm1lcmdlV2l0aCIsIm9iaiIsInNyYyIsImtleSIsInVzZXJJdGVtc0NvdW50IiwicmVuZGVyVHJlZSIsImNhcnRGb3JtIiwiaXNJbml0aWFsaXplZCIsImlzRnJlZU9yZGVyIiwicGF5cGFsQnV0dG9uIiwiUEFZUEFMX0JVVFRPTl9FTEVNRU5UX0lOU1RBTkNFIiwiaGFzU3Vic2NyaXB0aW9uIiwidXBkYXRlV2ViUGF5bWVudHNCdXR0b24iLCJoYW5kbGVSZW5kZXJDYXJ0IiwiUkVOREVSX1RSRUVfRVZFTlQiLCJvcmRlckNvbmZpcm1hdGlvbkNvbnRhaW5lciIsIk5PREVfVFlQRV9DT01NRVJDRV9PUkRFUl9DT05GSVJNQVRJT05fV1JBUFBFUiIsImNhcnRzIiwiZXhlY3V0ZUxvYWRpbmdDYWxsYmFja3MiLCJxdWVyeSIsIkNBUlRfUVVFUlkiLCJmZXRjaFBvbGljeSIsImVycm9yUG9saWN5IiwiY29uY2F0IiwiZmlsdGVyIiwiQm9vbGVhbiIsImNhdGNoIiwiZXJyIiwiaGFuZGxlQ2FydEtleVVwIiwia2V5Q29kZSIsIm9wZW5DYXJ0cyIsInF1ZXJ5U2VsZWN0b3JBbGwiLCJodG1sRWxlbWVudCIsImNsaWNrIiwicGFyZW50IiwiaGFuZGxlQ2xpY2tDbG9zZUNhcnQiLCJpc05vdEluc2lkZSIsImNvbnRhaW5zIiwiY29udGFpbmVyIiwiZm9jdXNhYmxlRWxlbWVudHMiLCJvZmZzZXRIZWlnaHQiLCJmaXJzdEZvY3VzYWJsZUVsZW1lbnQiLCJsYXN0Rm9jdXNhYmxlRWxlbWVudCIsInNoaWZ0S2V5IiwiYWN0aXZlRWxlbWVudCIsImhhbmRsZXJQcm94eSIsIm9uIl0sIm1hcHBpbmdzIjoiQUFBQSxxSUFBcUk7Ozs7Ozs7Ozs7O0lBZ3JDckksT0FBMEI7ZUFBMUI7O0lBaENhQSxRQUFRO2VBQVJBOztJQTNSQUMsVUFBVTtlQUFWQTs7O21FQXAzQkc7a0VBQ007Z0VBQ0Y7MkJBcUNiOytCQWdCQTs4REFFVzttQ0FDb0I7MkJBRWI7a0VBRUg7d0JBQzRCOzs7Ozs7QUFFbEQsTUFBTSxFQUFDQyxLQUFLLEVBQUVDLFlBQVksRUFBRUMsYUFBYSxFQUFFQyxhQUFhLEVBQUVDLGNBQWMsRUFBQyxHQUN2RUMscUJBQVU7QUFFWixNQUFNLEVBQUNDLFdBQVcsRUFBRUMsb0JBQW9CLEVBQUMsR0FDdkNDLCtDQUFvQztBQUV0QyxNQUFNQyw2QkFBNkJDLElBQUFBLG1CQUFHLENBQUEsQ0FBQzs7Ozs7Ozs7QUFRdkMsQ0FBQztBQUVELE1BQU1DLHVCQUF1QixDQUMzQkMsTUFDQUM7SUFFQSxJQUNFRCxnQkFBZ0JFLG1CQUNoQkYsS0FBS0csUUFBUSxZQUFZQyxnQkFDekI7UUFDQUMsTUFBTUMsSUFBSSxDQUFDTixLQUFLRyxRQUFRLEVBQUVJLE9BQU8sQ0FBQyxDQUFDQztZQUNqQyxJQUFJQSxpQkFBaUJDLGtCQUFrQjtnQkFDckNSLFNBQVNPO1lBQ1g7UUFDRjtJQUNGO0FBQ0Y7QUFFQSxNQUFNRSx5QkFBeUIsQ0FBQ1Y7SUFDOUJELHFCQUFxQkMsTUFBTSxDQUFDUTtRQUMxQkEsTUFBTUcsUUFBUSxHQUFHO0lBQ25CO0FBQ0Y7QUFFQSxNQUFNQyx3QkFBd0IsQ0FBQ1o7SUFDN0JELHFCQUFxQkMsTUFBTSxDQUFDUTtRQUMxQkEsTUFBTUcsUUFBUSxHQUFHO0lBQ25CO0FBQ0Y7QUFFQSwwRUFBMEU7QUFDMUUsc05BQXNOO0FBQ3ROLE1BQU1FLDBCQUEwQixDQUFDQztJQUMvQixJQUNFQSxtQkFBbUJDLFdBQ25CRCxRQUFRRSxZQUFZLENBQUNDLG1EQUF3QyxLQUM3REgsUUFBUUksWUFBWSxDQUFDRCxtREFBd0MsTUFDM0R2QixlQUNGb0IsUUFBUUUsWUFBWSxDQUFDRyxvQ0FBeUIsR0FDOUM7UUFDQSxPQUFPTDtJQUNULE9BQU87UUFDTCxPQUFPQSxtQkFBbUJDLFdBQVdELFFBQVFNLGFBQWEsR0FDdERQLHdCQUF3QkMsUUFBUU0sYUFBYSxJQUM3QztJQUNOO0FBQ0Y7QUFFQSxZQUFZO0FBQ1osTUFBTUMscUJBQXFCLENBQUNDO0lBQzFCLG9JQUFvSTtJQUNwSSxPQUFPVCx3QkFBd0JTLE1BQU1DLE1BQU07QUFDN0M7QUFFQSxNQUFNQyw2QkFBNkIsQ0FBQ0YsUUFDbENBLE1BQU1DLE1BQU0sWUFBWVIsV0FDeEJPLE1BQU1DLE1BQU0sQ0FBQ1AsWUFBWSxDQUFDQyxtREFBd0MsS0FDbEVLLE1BQU1DLE1BQU0sQ0FBQ0wsWUFBWSxDQUFDRCxtREFBd0MsTUFDaEV0Qix3QkFDRjJCLE1BQU1DLE1BQU0sQ0FBQ1AsWUFBWSxDQUFDRyxvQ0FBeUIsS0FDbkRHLE1BQU1DLE1BQU07QUFFZCxNQUFNRSwyQkFBMkIsQ0FBQ0gsUUFDaENBLE1BQU1DLE1BQU0sWUFBWVIsV0FDeEJPLE1BQU1DLE1BQU0sQ0FBQ1AsWUFBWSxDQUFDQyxtREFBd0MsS0FDbEVLLE1BQU1DLE1BQU0sQ0FBQ0wsWUFBWSxDQUFDRCxtREFBd0MsTUFDaEV0Qix3QkFDRjJCLE1BQU1DLE1BQU0sQ0FBQ1AsWUFBWSxDQUFDRyxvQ0FBeUIsS0FDbkRHLE1BQU1DLE1BQU07QUFFZCxxRkFBcUY7QUFDckYsTUFBTUcsb0JBQW9CLENBQUMsRUFBQ0gsTUFBTSxFQUFDO0lBQ2pDLE1BQU1JLGVBQWVDLElBQUFBLDJDQUE0QixFQUMvQ0MsNENBQWlDLEVBQ2pDTjtJQUVGLE1BQU1PLGdCQUFnQkYsSUFBQUEsMkNBQTRCLEVBQ2hERyw2Q0FBa0MsRUFDbENSO0lBR0YsSUFBSUksY0FBYztRQUNoQixPQUFPQTtJQUNULE9BQU8sSUFBSUcsZUFBZTtRQUN4QixPQUFPQTtJQUNULE9BQU87UUFDTCxPQUFPO0lBQ1Q7QUFDRjtBQUVBLHFGQUFxRjtBQUNyRixNQUFNRSw0QkFBNEIsQ0FBQyxFQUFDVCxNQUFNLEVBQUM7SUFDekMsTUFBTVUscUJBQXFCTCxJQUFBQSwyQ0FBNEIsRUFDckRNLGtEQUF1QyxFQUN2Q1g7SUFFRixJQUFJVSxvQkFBb0I7UUFDdEIsT0FBT0E7SUFDVCxPQUFPO1FBQ0wsT0FBTztJQUNUO0FBQ0Y7QUFFQSxxRkFBcUY7QUFDckYsTUFBTUUscUJBQXFCLENBQUMsRUFBQ1osTUFBTSxFQUFDLEdBQ2xDQSxrQkFBa0JSLFdBQ2xCUSxPQUFPTCxZQUFZLENBQUNrQiw4QkFBbUIsTUFDckNDLDBDQUErQixJQUNqQ2Q7QUFFRixxRkFBcUY7QUFDckYsTUFBTWUsa0JBQWtCLENBQUMsRUFBQ2YsTUFBTSxFQUFDLEdBQy9CQSxrQkFBa0JSLFdBQ2xCUSxPQUFPUCxZQUFZLENBQUNvQiw4QkFBbUIsS0FDdkNiLE9BQU9MLFlBQVksQ0FBQ2tCLDhCQUFtQixNQUFNRyx1Q0FBNEI7QUFFM0UsNk1BQTZNO0FBQzdNLE1BQU1DLGlCQUFpQixDQUNyQjFCO0lBRUEsSUFBSSxDQUFFQSxDQUFBQSxtQkFBbUJDLE9BQU0sR0FBSTtRQUNqQyxPQUFPO0lBQ1Q7SUFDQSxPQUFPRCxtQkFBbUJaLGtCQUN0QlksVUFDQTBCLGVBQWUxQixRQUFRTSxhQUFhO0FBQzFDO0FBRUEsa0JBQWtCO0FBQ2xCLE1BQU1xQixvQkFBb0IsQ0FBQ25CLE9BQWNvQjtJQUN2QyxJQUFJQyxPQUFPQyxPQUFPLENBQUNDLEdBQUcsQ0FBQyxhQUFhRixPQUFPQyxPQUFPLENBQUNDLEdBQUcsQ0FBQyxZQUFZO1FBQ2pFO0lBQ0Y7SUFDQXZCLE1BQU13QixjQUFjO0lBRXBCLE1BQU0sRUFBQ0MsYUFBYSxFQUFDLEdBQUd6QjtJQUV4QixJQUFJLENBQUV5QixDQUFBQSx5QkFBeUJDLFdBQVUsR0FBSTtRQUMzQztJQUNGO0lBRUEsTUFBTUMsc0JBQXNCckIsSUFBQUEsMkNBQTRCLEVBQ3REUywwQ0FBK0IsRUFDL0JVO0lBRUYsSUFBSSxDQUFFRSxDQUFBQSwrQkFBK0JsQyxPQUFNLEdBQUk7UUFDN0M7SUFDRjtJQUVBLE1BQU1tQyxlQUFlQyxJQUFBQSxvQ0FBcUIsRUFDeENDLHdDQUE2QixFQUM3Qkg7SUFFRixJQUFJLENBQUVDLENBQUFBLHdCQUF3Qm5DLE9BQU0sR0FBSTtRQUN0QztJQUNGO0lBQ0FtQyxhQUFhRyxLQUFLLENBQUNDLFdBQVcsQ0FBQyxXQUFXO0lBRTFDLE1BQU1DLFFBQVFSLGNBQWM3QixZQUFZLENBQUNDLG9DQUF5QjtJQUNsRSxNQUFNcUMsUUFBUTtJQUNkLE1BQU14RCxPQUFPd0MsZUFBZU87SUFDNUJyQyx1QkFBdUJWO0lBRXZCLE1BQU15RCxXQUFXQyxJQUFBQSw0Q0FBNkIsRUFDNUMsK0JBQ0FYO0lBRUYsSUFBSSxDQUFFVSxDQUFBQSxvQkFBb0IxQyxPQUFNLEdBQUk7UUFDbEM7SUFDRjtJQUNBNEMsSUFBQUEsaUNBQWtCLEVBQUNDLElBQUFBLGdDQUFpQixFQUFDSDtJQUVyQyxvSUFBb0k7SUFDcEksTUFBTUksb0JBQW9CaEQsd0JBQXdCUyxNQUFNQyxNQUFNO0lBRTlELHNGQUFzRjtJQUN0RixJQUFJc0MsNkJBQTZCQyxtQkFBbUI7UUFDbEQsMENBQTBDO1FBQzFDRCxrQkFBa0JSLEtBQUssQ0FBQ1UsYUFBYSxHQUFHO0lBQzFDO0lBRUFyQixhQUNHc0IsTUFBTSxDQUFDO1FBQ05DLFVBQVVwRTtRQUNWcUUsV0FBVztZQUFDWDtZQUFPQztRQUFLO0lBQzFCLEdBQ0NXLElBQUksQ0FDSDtRQUNFQyxJQUFBQSw0QkFBYSxFQUFDO0lBQ2hCLEdBQ0EsQ0FBQ0M7UUFDQ0MsY0FBSyxDQUFDRCxLQUFLLENBQUNBO1FBQ1puQixhQUFhRyxLQUFLLENBQUNrQixjQUFjLENBQUM7UUFDbEMsTUFBTUMsV0FBV3RCLGFBQWF1QixhQUFhLENBQ3pDQyxzQ0FBMkI7UUFFN0IsSUFBSSxDQUFDRixVQUFVO1lBQ2I7UUFDRjtRQUNBLDZEQUE2RDtRQUM3RCxNQUFNRyxZQUNKSCxTQUFTdEQsWUFBWSxDQUFDMEQscUNBQTBCLEtBQUs7UUFDdkRKLFNBQVNLLFdBQVcsR0FBR0Y7UUFDdkJQLElBQUFBLDRCQUFhLEVBQUNDO0lBQ2hCLEdBRURGLElBQUksQ0FBQztRQUNKLElBQUlOLDZCQUE2QkMsbUJBQW1CO1lBQ2xELDRDQUE0QztZQUM1Q0Qsa0JBQWtCUixLQUFLLENBQUNVLGFBQWEsR0FBRztRQUMxQztRQUVBLDRFQUE0RTtRQUM1RSxNQUFNZSxnQkFBZ0IvQixjQUFjZ0MsT0FBTyxDQUN6QztRQUVGLElBQUlELHlCQUF5QjlCLGFBQWE7WUFDeEMsTUFBTWdDLGdCQUFnQkYsY0FBY0csc0JBQXNCLENBQ3hEO1lBRUYsTUFBTUMsbUJBQW1CQyxxQkFBcUJMO1lBQzlDLElBQUlFLGNBQWNJLE1BQU0sS0FBSyxLQUFLRixpQkFBaUJFLE1BQU0sR0FBRyxHQUFHO2dCQUM3RCxpRkFBaUY7Z0JBQ2pGRixnQkFBZ0IsQ0FBQyxFQUFFLENBQUNHLEtBQUs7WUFDM0I7UUFDRjtJQUNGO0FBQ0o7QUFFQSxNQUFNQyw0QkFBNEIsQ0FDaENoRSxPQUNBb0I7SUFFQSxJQUFJQyxPQUFPQyxPQUFPLENBQUNDLEdBQUcsQ0FBQyxhQUFhRixPQUFPQyxPQUFPLENBQUNDLEdBQUcsQ0FBQyxZQUFZO1FBQ2pFO0lBQ0Y7SUFFQXZCLE1BQU13QixjQUFjO0lBQ3BCLE1BQU0sRUFBQ0MsYUFBYSxFQUFDLEdBQUd6QjtJQUN4QixJQUFJLENBQUV5QixDQUFBQSx5QkFBeUJ0QyxnQkFBZSxHQUFJO1FBQ2hEO0lBQ0Y7SUFDQSxJQUNFc0MsY0FBYy9DLElBQUksWUFBWUUsbUJBQzlCNkMsY0FBYy9DLElBQUksQ0FBQ3VGLGNBQWMsT0FBTyxPQUN4QztRQUNBO0lBQ0Y7SUFFQSxNQUFNdEMsc0JBQXNCckIsSUFBQUEsMkNBQTRCLEVBQ3REUywwQ0FBK0IsRUFDL0JVO0lBRUYsSUFBSSxDQUFFRSxDQUFBQSwrQkFBK0JsQyxPQUFNLEdBQUk7UUFDN0M7SUFDRjtJQUVBLE1BQU1tQyxlQUFlQyxJQUFBQSxvQ0FBcUIsRUFDeENDLHdDQUE2QixFQUM3Qkg7SUFHRixJQUFJLENBQUVDLENBQUFBLHdCQUF3Qm5DLE9BQU0sR0FBSTtRQUN0QztJQUNGO0lBQ0FtQyxhQUFhRyxLQUFLLENBQUNDLFdBQVcsQ0FBQyxXQUFXO0lBRTFDLE1BQU1HLFdBQVdWLGNBQWMzQixhQUFhO0lBQzVDLElBQUksQ0FBRXFDLENBQUFBLG9CQUFvQjFDLE9BQU0sR0FBSTtRQUNsQztJQUNGO0lBQ0E0QyxJQUFBQSxpQ0FBa0IsRUFBQ0MsSUFBQUEsZ0NBQWlCLEVBQUNIO0lBRXJDLE1BQU1GLFFBQVFSLGNBQWM3QixZQUFZLENBQUNDLG9DQUF5QjtJQUNsRSxNQUFNcUMsUUFBUVQsY0FBY3lDLEtBQUs7SUFDakM5RSx1QkFBdUJxQyxjQUFjL0MsSUFBSTtJQUN6QzBDLGFBQ0dzQixNQUFNLENBQUM7UUFDTkMsVUFBVXBFO1FBQ1ZxRSxXQUFXO1lBQUNYO1lBQU9DO1FBQUs7SUFDMUIsR0FDQ1csSUFBSSxDQUNIO1FBQ0V2RCxzQkFBc0JtQyxjQUFjL0MsSUFBSTtRQUN4Q29FLElBQUFBLDRCQUFhLEVBQUM7SUFDaEIsR0FDQSxDQUFDQztRQUNDekQsc0JBQXNCbUMsY0FBYy9DLElBQUk7UUFDeENzRSxjQUFLLENBQUNELEtBQUssQ0FBQ0E7UUFDWm5CLGFBQWFHLEtBQUssQ0FBQ2tCLGNBQWMsQ0FBQztRQUNsQyxNQUFNQyxXQUFXdEIsYUFBYXVCLGFBQWEsQ0FDekNDLHNDQUEyQjtRQUU3QixJQUFJLENBQUNGLFVBQVU7WUFDYjtRQUNGO1FBRUEsTUFBTWlCLFlBQ0pDLDZCQUFxQixDQUFDQyxFQUFFLENBQUN0QixVQUN6QkEsTUFBTXVCLE1BQU0sQ0FBQ1IsTUFBTSxHQUFHLEtBQ3RCZixNQUFNdUIsTUFBTSxDQUFDLEVBQUUsSUFDZixVQUFVdkIsTUFBTXVCLE1BQU0sQ0FBQyxFQUFFLElBQ3pCdkIsTUFBTXVCLE1BQU0sQ0FBQyxFQUFFLENBQUNDLElBQUksS0FBSyxtQkFDckIsYUFDQTtRQUNOLE1BQU1sQixZQUNKSCxTQUFTdEQsWUFBWSxDQUFDNEUsSUFBQUEscUNBQTBCLEVBQUNMLGVBQWU7UUFDbEVqQixTQUFTSyxXQUFXLEdBQUdGO1FBQ3ZCUCxJQUFBQSw0QkFBYSxFQUFDQztJQUNoQjtBQUVOO0FBRUEsTUFBTTBCLHlCQUF5QixDQUFDekU7SUFDOUIsSUFBSXFCLE9BQU9DLE9BQU8sQ0FBQ0MsR0FBRyxDQUFDLGFBQWFGLE9BQU9DLE9BQU8sQ0FBQ0MsR0FBRyxDQUFDLFlBQVk7UUFDakU7SUFDRjtJQUNBdkIsTUFBTXdCLGNBQWM7SUFDcEIsTUFBTSxFQUFDQyxhQUFhLEVBQUMsR0FBR3pCO0lBQ3hCLElBQUksQ0FBRXlCLENBQUFBLHlCQUF5QnRDLGdCQUFlLEdBQUk7UUFDaEQ7SUFDRjtJQUNBLElBQ0VzQyxjQUFjaUQsUUFBUSxDQUFDQyxLQUFLLEtBQUssU0FDakNsRCxjQUFjL0MsSUFBSSxZQUFZRSxpQkFDOUI7UUFDQTZDLGNBQWMvQyxJQUFJLENBQUN1RixjQUFjO0lBQ25DO0FBQ0Y7QUFFQSxNQUFNVyw2QkFBNkIsQ0FBQzVFO0lBQ2xDLElBQ0UsQ0FBRUEsQ0FBQUEsTUFBTXlCLGFBQWEsWUFBWWhDLE9BQU0sS0FDdkMsQ0FBRU8sQ0FBQUEsaUJBQWlCNkUsV0FBVSxHQUM3QjtRQUNBO0lBQ0Y7SUFFQSxNQUFNLEVBQUNwRCxhQUFhLEVBQUVxRCxNQUFNLEVBQUMsR0FBRzlFO0lBQ2hDLE1BQU0rRSxTQUFTdEQsY0FBYy9CLFlBQVksQ0FBQ3NGLG9CQUFTO0lBQ25ELE1BQU1DLGFBQWFILFVBQVVBLE9BQU9JLElBQUksSUFBSSxPQUFPSixPQUFPSSxJQUFJLEdBQUcsQ0FBQ0g7SUFFbEUsTUFBTUksVUFBVXRELElBQUFBLG9DQUFxQixFQUNuQ3VELG9EQUF5QyxFQUN6QzNEO0lBRUYsSUFBSSxDQUFDMEQsU0FBUztRQUNaO0lBQ0Y7SUFFQSxNQUFNM0IsZ0JBQWdCNkIsaUJBQWlCRjtJQUN2QyxJQUFJLENBQUMzQixlQUFlO1FBQ2xCO0lBQ0Y7SUFFQSxNQUFNOEIsY0FBY0gsUUFBUXJGLGFBQWE7SUFDekMsSUFBSSxDQUFDd0YsYUFBYTtRQUNoQjtJQUNGO0lBRUEsTUFBTUMsV0FBV0QsWUFBWTFGLFlBQVksQ0FBQzRGLG9CQUFTO0lBQ25ELE1BQU1DLFdBQ0pDLElBQUFBLGtCQUFTLEVBQ1BKLFlBQVkxRixZQUFZLENBQUMrRix1Q0FBNEIsR0FDckRDLHFDQUEwQixJQUN4QjtJQUNOLE1BQU1DLGtCQUFrQkgsSUFBQUEsa0JBQVMsRUFDL0JKLFlBQVkxRixZQUFZLENBQUNrRyxxQ0FBMEIsR0FDbkRDLG1DQUF3QjtJQUUxQixNQUFNQyxvQkFBb0IsQ0FBQyxRQUFRLEVBQUVQLFNBQVMsU0FBUyxDQUFDO0lBQ3hELE1BQU1RLG9CQUFvQjtJQUMxQixNQUFNQyxnQkFBZ0JULGFBQWE7SUFFbkMsSUFBSVU7SUFDSixJQUFJQztJQUNKLE9BQVFiO1FBQ04sS0FBS3pIO1lBQU87Z0JBQ1ZxSSxpQkFBaUI7b0JBQUNFLE9BQU87Z0JBQUk7Z0JBQzdCRCxpQkFBaUI7b0JBQUNDLE9BQU87Z0JBQUc7Z0JBQzVCO1lBQ0Y7UUFDQSxLQUFLdEk7WUFBYztnQkFDakJvSSxpQkFBaUI7b0JBQUNHLEdBQUcsQ0FBQztnQkFBRTtnQkFDeEJGLGlCQUFpQjtvQkFBQ0UsR0FBRztnQkFBQztnQkFDdEI7WUFDRjtRQUNBLEtBQUt0STtZQUFlO2dCQUNsQm1JLGlCQUFpQjtvQkFBQ0csR0FBRztnQkFBRTtnQkFDdkJGLGlCQUFpQjtvQkFBQ0UsR0FBRztnQkFBQztnQkFDdEI7WUFDRjtRQUNBLEtBQUtySTtRQUNMLEtBQUtDO1lBQWdCO2dCQUNuQmlJLGlCQUFpQjtvQkFBQ0ksR0FBRyxDQUFDO2dCQUFFO2dCQUN4QkgsaUJBQWlCO29CQUFDRyxHQUFHO2dCQUFDO2dCQUN0QjtZQUNGO0lBQ0Y7SUFFQSxJQUFJdEIsWUFBWTtRQUNkdUIsU0FBU0MsZ0JBQWdCLENBQUMsV0FBV0M7UUFFckNqRixjQUFja0YsWUFBWSxDQUFDM0Isb0JBQVMsRUFBRTtRQUN0Q0csUUFBUXBELEtBQUssQ0FBQ2tCLGNBQWMsQ0FBQztRQUU3QixrRUFBa0U7UUFDbEUscUJBQXFCO1FBQ3JCLE1BQU1XLG1CQUFtQkMscUJBQXFCTDtRQUM5QyxJQUFJSSxpQkFBaUJFLE1BQU0sR0FBRyxHQUFHO1lBQy9CLGlGQUFpRjtZQUNqRkYsZ0JBQWdCLENBQUMsRUFBRSxDQUFDRyxLQUFLO1FBQzNCO1FBRUEsSUFBSW1DLGlCQUFpQixDQUFDbkIsUUFBUTtZQUM1QixzR0FBc0c7WUFDdEcxRCxPQUFPQyxPQUFPLENBQUNzRixJQUFJLENBQUN6QixTQUNqQjBCLEdBQUcsQ0FBQ2IsbUJBQ0pjLEdBQUcsQ0FBQztnQkFBQ0MsU0FBUztZQUFDLEdBQ2ZDLEtBQUssQ0FBQztnQkFBQ0QsU0FBUztZQUFDO1lBRXBCLHNHQUFzRztZQUN0RzFGLE9BQU9DLE9BQU8sQ0FBQ3NGLElBQUksQ0FBQ3BELGVBQ2pCcUQsR0FBRyxDQUFDLENBQUMsVUFBVSxFQUFFcEIsU0FBUyxDQUFDLEVBQUVJLGdCQUFnQixJQUFJLENBQUMsRUFDbERpQixHQUFHLENBQUNYLGdCQUNKYSxLQUFLLENBQUNaO1FBQ1g7SUFDRixPQUFPO1FBQ0xJLFNBQVNTLG1CQUFtQixDQUFDLFdBQVdQO1FBRXhDakYsY0FBY3lGLGVBQWUsQ0FBQ2xDLG9CQUFTO1FBRXZDLElBQUlrQixlQUFlO1lBQ2pCLHNHQUFzRztZQUN0RzdFLE9BQU9DLE9BQU8sQ0FBQ3NGLElBQUksQ0FBQ3pCLFNBQ2pCMEIsR0FBRyxDQUFDYixtQkFDSmdCLEtBQUssQ0FBQztnQkFBQ0QsU0FBUztZQUFDLEdBQ2pCbEUsSUFBSSxDQUFDO2dCQUNKc0MsUUFBUXBELEtBQUssQ0FBQ29GLE9BQU8sR0FBRztnQkFDeEIsc0dBQXNHO2dCQUN0RzlGLE9BQU9DLE9BQU8sQ0FBQ3NGLElBQUksQ0FBQ3BELGVBQWU0RCxJQUFJO1lBQ3pDO1lBRUYsc0dBQXNHO1lBQ3RHL0YsT0FBT0MsT0FBTyxDQUFDc0YsSUFBSSxDQUFDcEQsZUFDakJxRCxHQUFHLENBQUMsQ0FBQyxVQUFVLEVBQUVwQixTQUFTLENBQUMsRUFBRUksZ0JBQWdCLENBQUMsRUFBRUksa0JBQWtCLENBQUMsRUFDbkVlLEtBQUssQ0FBQ2I7UUFDWCxPQUFPO1lBQ0xoQixRQUFRcEQsS0FBSyxDQUFDb0YsT0FBTyxHQUFHO1FBQzFCO1FBRUEsTUFBTUUsaUJBQWlCeEYsSUFBQUEsb0NBQXFCLEVBQzFDdEIsNENBQWlDLEVBQ2pDK0U7UUFFRixJQUFJK0IsMEJBQTBCNUgsU0FBUztZQUNyQzRILGVBQWV0RCxLQUFLO1FBQ3RCO0lBQ0Y7QUFDRjtBQUVBLE1BQU11RCxtQkFBbUIsQ0FBQ3RIO0lBQ3hCLGdEQUFnRDtJQUNoRCxJQUFJcUIsT0FBT0MsT0FBTyxDQUFDQyxHQUFHLENBQUMsV0FBVztRQUNoQztJQUNGO0lBRUEsTUFBTSxFQUFDRSxhQUFhLEVBQUU4RixJQUFJLEVBQUMsR0FBR3ZIO0lBRTlCLElBQUksQ0FBRXlCLENBQUFBLHlCQUF5QmhDLE9BQU0sR0FBSTtRQUN2QztJQUNGO0lBRUEsTUFBTWtDLHNCQUFzQnJCLElBQUFBLDJDQUE0QixFQUN0RFMsMENBQStCLEVBQy9CVTtJQUVGLElBQUksQ0FBRUUsQ0FBQUEsK0JBQStCbEMsT0FBTSxHQUFJO1FBQzdDO0lBQ0Y7SUFFQSxNQUFNK0gsdUJBQXVCM0YsSUFBQUEsb0NBQXFCLEVBQ2hEdUQsb0RBQXlDLEVBQ3pDekQ7SUFHRixJQUFJOEY7SUFDSixJQUNFRixTQUFTLFdBQ1I5RixDQUFBQSxjQUFjN0IsWUFBWSxDQUFDa0IsOEJBQW1CLE1BQzdDTCw2Q0FBa0MsSUFDakNnQixjQUFjN0IsWUFBWSxDQUFDa0IsOEJBQW1CLE1BQzdDUCw0Q0FBaUMsSUFDakMsQ0FBQ29CLG9CQUFvQmpDLFlBQVksQ0FBQ2dJLGtDQUF1QixDQUFDLEdBQzlEO1FBQ0FELE1BQU0sSUFBSTVDLFlBQVk4Qyw0QkFBaUIsRUFBRTtZQUN2Q0MsU0FBUztRQUNYO1FBQ0EsSUFDRUosd0JBQ0EvRixjQUFjN0IsWUFBWSxDQUFDa0IsOEJBQW1CLE1BQzVDTCw2Q0FBa0MsRUFDcEM7WUFDQStHLHFCQUFxQlAsbUJBQW1CLENBQ3RDLGNBQ0FZO1lBRUYsNkRBQTZEO1lBQzdEbEcsb0JBQW9Cc0YsbUJBQW1CLENBQ3JDLGNBQ0FZO1FBRUo7SUFDRixPQUFPLElBQ0xOLFNBQVMsZUFDVDVGLG9CQUFvQmpDLFlBQVksQ0FBQ2dJLGtDQUF1QixLQUN4RGpHLGNBQWM3QixZQUFZLENBQUNrQiw4QkFBbUIsTUFDNUNQLDRDQUFpQyxFQUNuQztRQUNBa0gsTUFBTSxJQUFJNUMsWUFBWThDLDRCQUFpQixFQUFFO1lBQ3ZDQyxTQUFTO1lBQ1Q5QyxRQUFRO2dCQUNOSSxNQUFNO1lBQ1I7UUFDRjtRQUNBLElBQUlzQyxzQkFBc0I7WUFDeEJBLHFCQUFxQmYsZ0JBQWdCLENBQ25DLGNBQ0FvQjtZQUVGLDZEQUE2RDtZQUM3RHBHLGNBQWNnRixnQkFBZ0IsQ0FBQyxjQUFjb0I7UUFDL0M7SUFDRjtJQUVBLElBQUlKLEtBQUs7UUFDUDlGLG9CQUFvQm1HLGFBQWEsQ0FBQ0w7SUFDcEM7QUFDRjtBQUVBLE1BQU1NLDJCQUEyQixDQUFDL0g7SUFDaEMseURBQXlEO0lBQ3pELElBQUlxQixPQUFPQyxPQUFPLENBQUNDLEdBQUcsQ0FBQyxZQUFZO1FBQ2pDO0lBQ0Y7SUFDQXZCLE1BQU13QixjQUFjO0lBQ3BCLE1BQU0sRUFBQ0MsZUFBZXVHLGNBQWMsRUFBQyxHQUFHaEk7SUFFeEMsSUFBSSxDQUFFZ0ksQ0FBQUEsMEJBQTBCdkksT0FBTSxHQUFJO1FBQ3hDO0lBQ0Y7SUFFQSxJQUFJLENBQUN3SSxJQUFBQSw4QkFBZSxLQUFJO1FBQ3RCNUcsT0FBTzZHLEtBQUssQ0FDVjtRQUVGO0lBQ0Y7SUFFQSxNQUFNQyxjQUFjSCxlQUFlcEksWUFBWSxDQUFDd0ksaUNBQXNCO0lBQ3RFLE1BQU1DLGFBQWFMLGVBQWVNLFNBQVM7SUFDM0NOLGVBQWVNLFNBQVMsR0FBR0gsY0FDdkJBLGNBQ0FJLDZDQUFrQztJQUV0QyxNQUFNNUcsc0JBQXNCckIsSUFBQUEsMkNBQTRCLEVBQ3REUywwQ0FBK0IsRUFDL0JpSDtJQUVGLElBQUksQ0FBRXJHLENBQUFBLCtCQUErQmxDLE9BQU0sR0FBSTtRQUM3QztJQUNGO0lBRUEsa0ZBQWtGO0lBQ2xGLGdGQUFnRjtJQUNoRixxRkFBcUY7SUFDckYsa0ZBQWtGO0lBQ2xGLGtGQUFrRjtJQUNsRixpRkFBaUY7SUFDakYsa0NBQWtDO0lBQ2xDLE1BQU0rSSxpQkFBaUJSLGVBQWVwSSxZQUFZLENBQUM2SSxvQ0FBeUI7SUFDNUUsTUFBTUMsZ0JBQWdCbEMsU0FBU3JELGFBQWEsQ0FBQyxDQUFDLENBQUMsRUFBRXdGLGtDQUF1QixDQUFDLENBQUMsQ0FBQztJQUUzRSxJQUFJLENBQUNILGtCQUFrQixDQUFDRSxlQUFlO1FBQ3JDLE1BQU05RyxlQUFlQyxJQUFBQSxvQ0FBcUIsRUFDeENDLHdDQUE2QixFQUM3Qkg7UUFHRixJQUFJLENBQUVDLENBQUFBLHdCQUF3Qm5DLE9BQU0sR0FBSTtZQUN0QztRQUNGO1FBQ0FtQyxhQUFhRyxLQUFLLENBQUNDLFdBQVcsQ0FBQyxXQUFXO1FBQzFDSixhQUFhRyxLQUFLLENBQUNrQixjQUFjLENBQUM7UUFDbEMsTUFBTUMsV0FBV3RCLGFBQWF1QixhQUFhLENBQUM7UUFDNUMsSUFBSSxDQUFDRCxVQUFVO1lBQ2I7UUFDRjtRQUNBLGdDQUFnQztRQUNoQyxNQUFNRyxZQUFZSCxTQUFTdEQsWUFBWSxDQUFDLENBQUMsMEJBQTBCLENBQUMsS0FBSztRQUN6RXNELFNBQVNLLFdBQVcsR0FBR0Y7UUFDdkIyRSxlQUFlTSxTQUFTLEdBQUdELGFBQ3ZCQSxhQUNBTyw0Q0FBaUM7UUFDckM7SUFDRjtJQUVBLElBQUksQ0FBRVosQ0FBQUEsMEJBQTBCeEYsaUJBQWdCLEdBQUk7UUFDbER3RixlQUFlTSxTQUFTLEdBQUdELGFBQ3ZCQSxhQUNBTyw0Q0FBaUM7UUFDckM7SUFDRjtJQUVBLHdHQUF3RztJQUN4R3ZILE9BQU93SCxRQUFRLEdBQUdiLGVBQWVjLElBQUk7QUFDdkM7QUFFQSxNQUFNQyxtQkFBbUIsQ0FBQy9JO0lBQ3hCLElBQUlxQixPQUFPQyxPQUFPLENBQUNDLEdBQUcsQ0FBQyxZQUFZO1FBQ2pDO0lBQ0Y7SUFDQXZCLE1BQU13QixjQUFjO0FBQ3RCO0FBRUEsTUFBTXFHLDJCQUEyQixDQUFDN0g7SUFDaEMsTUFBTSxFQUFDQyxNQUFNLEVBQUUrSSxhQUFhLEVBQUMsR0FBR2hKO0lBQ2hDLElBQUksQ0FBRUMsQ0FBQUEsa0JBQWtCUixPQUFNLEtBQU0sQ0FBRXVKLENBQUFBLHlCQUF5QnZKLE9BQU0sR0FBSTtRQUN2RTtJQUNGO0lBRUEsTUFBTSxFQUFDSyxhQUFhLEVBQUMsR0FBR0c7SUFFeEIsSUFBSSxDQUFFSCxDQUFBQSx5QkFBeUJMLE9BQU0sR0FBSTtRQUN2QztJQUNGO0lBRUEsNkVBQTZFO0lBQzdFLE1BQU13SixjQUFjM0ksSUFBQUEsMkNBQTRCLEVBQzlDUywwQ0FBK0IsRUFDL0JpSTtJQUVGLE1BQU14RixnQkFBZ0JsRCxJQUFBQSwyQ0FBNEIsRUFDaEQ0SSw0Q0FBaUMsRUFDakNGO0lBRUYsSUFBSUMsZUFBZXpGLGVBQWU7UUFDaEM7SUFDRjtJQUNBLE1BQU1pRSxNQUFNLElBQUk1QyxZQUFZOEMsNEJBQWlCLEVBQUU7UUFDN0NDLFNBQVM7UUFDVDlDLFFBQVE7WUFDTkksTUFBTTtRQUNSO0lBQ0Y7SUFDQXBGLGNBQWNnSSxhQUFhLENBQUNMO0lBQzVCd0IsZUFDRSwwSUFBMEk7SUFDMUlBLHVCQUF1QnhKLFdBQ3ZCLDZGQUE2RjtJQUM3RndKLFlBQVloQyxtQkFBbUIsQ0FBQyxjQUFjWTtJQUNoRHJFLGlCQUNFLDBJQUEwSTtJQUMxSUEseUJBQXlCL0QsV0FDekIsNkZBQTZGO0lBQzdGK0QsY0FBY3lELG1CQUFtQixDQUFDLGNBQWNZO0FBQ3BEO0FBRUEsSUFBSXNCLHNCQU1BLEVBQUU7QUFFTixNQUFNQyxvQkFBb0I7SUFDeEIsMkZBQTJGO0lBQzNGLE1BQU1DLHdCQUF3QkMsSUFBQUEsd0NBQXlCLEVBQ3JEbEUsb0RBQXlDO0lBRzNDaUUsc0JBQXNCcEssT0FBTyxDQUFDLENBQUNPO1FBQzdCLG9FQUFvRTtRQUNwRSxNQUFNK0osVUFBVS9KLFFBQVF1QyxLQUFLLENBQUNvRixPQUFPLEtBQUs7UUFDMUNnQyxvQkFBb0JLLElBQUksQ0FBQztZQUN2QmhLO1lBQ0ErSjtRQUNGO1FBRUEsZ0ZBQWdGO1FBQ2hGLGtGQUFrRjtRQUNsRiw2RUFBNkU7UUFDN0UsSUFBSUEsU0FBUztZQUNYLE1BQU05QixNQUFNLElBQUk1QyxZQUFZOEMsNEJBQWlCLEVBQUU7Z0JBQzdDQyxTQUFTO2dCQUNUOUMsUUFBUTtvQkFDTkksTUFBTTtnQkFDUjtZQUNGO1lBQ0EsTUFBTSxFQUFDcEYsYUFBYSxFQUFDLEdBQUdOO1lBQ3hCLElBQUlNLGVBQWU7Z0JBQ2pCQSxjQUFjZ0ksYUFBYSxDQUFDTDtZQUM5QjtRQUNGO0lBQ0Y7QUFDRjtBQUVBLE1BQU1nQyxtQkFBbUI7SUFDdkIseUZBQXlGO0lBQ3pGLGdGQUFnRjtJQUNoRixxRkFBcUY7SUFDckYsZ0ZBQWdGO0lBQ2hGTixvQkFBb0JsSyxPQUFPLENBQUMsQ0FBQyxFQUFDTyxTQUFTMkYsT0FBTyxFQUFFb0UsT0FBTyxFQUFDO1FBQ3RELG9DQUFvQztRQUNwQyxzR0FBc0c7UUFDdEdsSSxPQUFPQyxPQUFPLENBQUNzRixJQUFJLENBQUN6QixTQUFTdUUsT0FBTztRQUNwQ3ZFLFFBQVFwRCxLQUFLLENBQUNnRixPQUFPLEdBQUc7UUFDeEIsTUFBTXZELGdCQUFnQjZCLGlCQUFpQkY7UUFDdkMsSUFBSTNCLGVBQWU7WUFDakIsc0dBQXNHO1lBQ3RHbkMsT0FBT0MsT0FBTyxDQUFDc0YsSUFBSSxDQUFDcEQsZUFBZWtHLE9BQU87WUFDMUNsRyxjQUFjekIsS0FBSyxDQUFDNEgsU0FBUyxHQUFHO1FBQ2xDO1FBRUEscUNBQXFDO1FBQ3JDLElBQUlKLFNBQVM7WUFDWHBFLFFBQVFwRCxLQUFLLENBQUNrQixjQUFjLENBQUM7UUFDL0IsT0FBTztZQUNMa0MsUUFBUXBELEtBQUssQ0FBQ29GLE9BQU8sR0FBRztRQUMxQjtRQUVBLHlGQUF5RjtRQUN6Rix3Q0FBd0M7UUFDeEMsTUFBTTdCLGNBQWNILFFBQVFyRixhQUFhO1FBQ3pDLElBQUl3RixhQUFhO1lBQ2ZBLFlBQVk0QixlQUFlLENBQUNsQyxvQkFBUztRQUN2QztJQUNGO0lBRUEsNkdBQTZHO0lBQzdHLGdIQUFnSDtJQUNoSCx1RUFBdUU7SUFDdkVtRSxzQkFBc0IsRUFBRTtBQUMxQjtBQUVBLE1BQU1TLHdCQUF3QixDQUM1QkMsTUFDQUMsV0FDQSwyRUFBMkU7QUFDM0VDLEtBQ0doTCxNQUFNQyxJQUFJLENBQUM2SyxLQUFLbEcsc0JBQXNCLENBQUNtRyxZQUFZN0ssT0FBTyxDQUFDOEs7QUFFaEUsTUFBTUMsdUJBQXVCLENBQUNIO0lBQzVCRCxzQkFBc0JDLE1BQU0scUNBQXFDSSwwQkFBVztJQUM1RUwsc0JBQXNCQyxNQUFNLCtCQUErQkssMEJBQVc7QUFDeEU7QUFFQSxNQUFNQyxxQkFBcUIsQ0FBQ047SUFDMUJELHNCQUFzQkMsTUFBTSxxQ0FBcUNLLDBCQUFXO0lBQzVFTixzQkFBc0JDLE1BQU0sK0JBQStCSSwwQkFBVztBQUN4RTtBQUVBLE1BQU1HLGlCQUFpQixDQUFDUDtJQUN0QkQsc0JBQXNCQyxNQUFNLHFDQUFxQ0ksMEJBQVc7QUFDOUU7QUFFQSxNQUFNSSxpQkFBaUIsQ0FBQ1I7SUFDdEJELHNCQUFzQkMsTUFBTSxxQ0FBcUNLLDBCQUFXO0FBQzlFO0FBRUEsTUFBTUksV0FBVyxDQUFDQyxXQUNoQkEsWUFDQUEsU0FBU0MsSUFBSSxJQUNiRCxTQUFTQyxJQUFJLENBQUNDLFFBQVEsSUFDdEJGLFNBQVNDLElBQUksQ0FBQ0MsUUFBUSxDQUFDQyxhQUFhLElBQ3BDSCxTQUFTQyxJQUFJLENBQUNDLFFBQVEsQ0FBQ0MsYUFBYSxDQUFDQyxTQUFTLElBQzlDSixTQUFTQyxJQUFJLENBQUNDLFFBQVEsQ0FBQ0MsYUFBYSxDQUFDQyxTQUFTLENBQUM3RyxNQUFNLEdBQUc7QUFFMUQsTUFBTThHLFlBQVksQ0FBQ0wsV0FDakJBLFlBQVlBLFNBQVNqRyxNQUFNLElBQUlpRyxTQUFTakcsTUFBTSxDQUFDUixNQUFNLEdBQUc7QUFFMUQsTUFBTStHLGlCQUFpQixDQUFDaEI7SUFDdEJELHNCQUNFQyxNQUNBLHdDQUNBLGdGQUFnRjtJQUNoRixDQUFDcks7UUFDQ29LLHNCQUNFQyxNQUNBLG1DQUNBLHdGQUF3RjtRQUN4RixDQUFDaUI7WUFDQ0EsZ0JBQWdCbkUsWUFBWSxDQUMxQixjQUNBbkgsUUFBUStELFdBQVcsS0FBSyxNQUNwQixvQkFDQSxDQUFDLHFCQUFxQixFQUFFL0QsUUFBUStELFdBQVcsQ0FBQyxNQUFNLENBQUM7UUFFM0Q7SUFFSjtBQUVKO0FBRU8sTUFBTTFGLGFBQWEsQ0FDeEJnTSxNQUNBVyxNQUNBTztJQUVBWCxlQUFlUDtJQUVmLElBQUllLFVBQVVKLE9BQU87UUFDbkJILGVBQWVSO0lBQ2pCO0lBRUFELHNCQUNFQyxNQUNBLHdDQUNBLGdGQUFnRjtJQUNoRixDQUFDcks7UUFDQyxNQUFNd0wsV0FBV3hMLFFBQVFJLFlBQVksQ0FBQ3FMLG9DQUF5QjtRQUUvRCxJQUNFRCxhQUFhRSxnQ0FBcUIsQ0FBQ0MsTUFBTSxJQUN4Q0gsYUFBYUUsZ0NBQXFCLENBQUNFLEtBQUssSUFBSSxDQUFDZCxTQUFTRSxPQUN2RDtZQUNBUCxJQUFBQSwwQkFBVyxFQUFDeks7UUFDZCxPQUFPO1lBQ0wwSyxJQUFBQSwwQkFBVyxFQUFDMUs7UUFDZDtJQUNGO0lBR0YscUdBQXFHO0lBQ3JHLG1GQUFtRjtJQUNuRixNQUFNNkwsbUJBQW1CQyxJQUFBQSxrQkFBUyxFQUFDLENBQUMsR0FBR2QsTUFBTSxDQUFDZSxLQUFLQyxLQUFLQztRQUN0RCxJQUFJQSxRQUFRLG1CQUFtQkQsUUFBUSxNQUFNO1lBQzNDLE9BQU87Z0JBQUNFLGdCQUFnQjtZQUFDO1FBQzNCO0lBQ0Y7SUFFQUMsSUFBQUEscUJBQVUsRUFBQzlCLE1BQU13QjtJQUVqQixJQUFJZixTQUFTRSxPQUFPO1FBQ2xCUixxQkFBcUJIO0lBQ3ZCLE9BQU87UUFDTE0sbUJBQW1CTjtJQUNyQjtJQUNBLE1BQU0rQixXQUFXL0IsS0FBSzFHLGFBQWEsQ0FBQztJQUNwQyxJQUFJeUksb0JBQW9CaE4saUJBQWlCO1FBQ3ZDVSxzQkFBc0JzTTtJQUN4QjtJQUVBLCtHQUErRztJQUMvRywyR0FBMkc7SUFDM0csNkVBQTZFO0lBQzdFLE1BQU1sRCxnQkFBZ0JsQyxTQUFTckQsYUFBYSxDQUFDLENBQUMsQ0FBQyxFQUFFd0Ysa0NBQXVCLENBQUMsQ0FBQyxDQUFDO0lBQzNFLE1BQU1YLGlCQUFpQm5HLElBQUFBLG9DQUFxQixFQUMxQ2pCLGtEQUF1QyxFQUN2Q2lKO0lBRUYsSUFDRTdCLGtCQUNBVSxpQkFDQXFDLGVBQ0EsQ0FBQ0EsWUFBWWMsYUFBYSxJQUMxQjtRQUNBLElBQUlDLElBQUFBLDBCQUFXLEVBQUN0QixPQUFPO1lBQ3JCTixJQUFBQSwwQkFBVyxFQUFDbEM7UUFDZCxPQUFPO1lBQ0xpQyxJQUFBQSwwQkFBVyxFQUFDakM7UUFDZDtJQUNGO0lBRUEsTUFBTStELGVBQWVsQyxLQUFLMUcsYUFBYSxDQUNyQyxDQUFDLENBQUMsRUFBRTZJLHlDQUE4QixDQUFDLENBQUMsQ0FBQztJQUV2QyxJQUFJdEQsaUJBQWlCcUQsY0FBYztRQUNqQyxJQUFJRCxJQUFBQSwwQkFBVyxFQUFDdEIsU0FBU3lCLElBQUFBLDhCQUFlLEVBQUN6QixPQUFPO1lBQzlDLCtHQUErRztZQUMvR1AsSUFBQUEsMEJBQVcsRUFBQzhCO1FBQ2QsT0FBTztZQUNMLCtHQUErRztZQUMvRzdCLElBQUFBLDBCQUFXLEVBQUM2QjtRQUNkO0lBQ0Y7SUFFQUcsSUFBQUEsMENBQXVCLEVBQUNyQyxNQUFNVyxNQUFNTztJQUVwQyxPQUFPbEI7QUFDVDtBQUVBLE1BQU1zQyxtQkFBbUIsQ0FDdkJuTSxPQUNBb0IsY0FDQTJKO0lBRUEsSUFBSTFKLE9BQU9DLE9BQU8sQ0FBQ0MsR0FBRyxDQUFDLGFBQWFGLE9BQU9DLE9BQU8sQ0FBQ0MsR0FBRyxDQUFDLFlBQVk7UUFDakU7SUFDRjtJQUNBLElBQUksQ0FBRXZCLENBQUFBLGlCQUFpQjZFLGVBQWU3RSxNQUFNdUgsSUFBSSxLQUFLNkUsNEJBQWlCLEFBQUQsR0FBSTtRQUN2RTtJQUNGO0lBQ0EsTUFBTTlILFNBQXFCLEVBQUU7SUFDN0IsTUFBTSxFQUFDUSxNQUFNLEVBQUMsR0FBRzlFO0lBQ2pCLElBQUk4RSxVQUFVLFFBQVFBLE9BQU8vQixLQUFLLEVBQUU7UUFDbEN1QixPQUFPa0YsSUFBSSxDQUFDMUUsT0FBTy9CLEtBQUs7SUFDMUI7SUFDQSxNQUFNc0osNkJBQTZCeEssSUFBQUEsb0NBQXFCLEVBQ3REeUssd0RBQTZDO0lBRS9DLHVIQUF1SDtJQUN2SCxxRUFBcUU7SUFDckUsSUFBSUQsNEJBQTRCO1FBQzlCO0lBQ0Y7SUFFQSxNQUFNRSxRQUFRakQsSUFBQUEsd0NBQXlCLEVBQUN2SSwwQ0FBK0I7SUFFdkUsSUFBSSxDQUFDd0wsTUFBTXpJLE1BQU0sRUFBRTtRQUNqQjBJLElBQUFBLHNDQUF1QjtRQUN2QjtJQUNGO0lBRUFELE1BQU10TixPQUFPLENBQUMsQ0FBQzRLO1FBQ2J6SSxhQUNHcUwsS0FBSyxDQUFDO1lBQ0xBLE9BQU9qTyxJQUFBQSxtQkFBRyxDQUFBLENBQUM7VUFDVCxFQUFFcUwsS0FBS2pLLFlBQVksQ0FBQzhNLHFCQUFVLEVBQUU7UUFDbEMsQ0FBQztZQUNEQyxhQUFhO1lBQ2JDLGFBQWE7UUFDZixHQUNDL0osSUFBSSxDQUFDLENBQUMySDtZQUNMZ0MsSUFBQUEsc0NBQXVCO1lBQ3ZCM08sV0FDRWdNLE1BQ0E7Z0JBQ0UsR0FBR1csSUFBSTtnQkFDUGxHLFFBQVFBLE9BQU91SSxNQUFNLENBQUNyQyxLQUFLekgsS0FBSyxFQUFFK0osTUFBTSxDQUFDQztZQUMzQyxHQUNBaEM7WUFFRkYsZUFBZWhCO1FBQ2pCLEdBQ0NtRCxLQUFLLENBQUMsQ0FBQ0M7WUFDTlQsSUFBQUEsc0NBQXVCO1lBQ3ZCbEksT0FBT2tGLElBQUksQ0FBQ3lEO1lBQ1pwUCxXQUFXZ00sTUFBTTtnQkFBQ3ZGO1lBQU07WUFDeEJ1RyxlQUFlaEI7UUFDakI7SUFDSjtBQUNGO0FBRUEsTUFBTXFELGtCQUFrQixDQUFDbE47SUFDdkIsU0FBUztJQUNULGlHQUFpRztJQUNqRyxJQUFJQSxNQUFNbU4sT0FBTyxLQUFLLElBQUk7UUFDeEIsTUFBTUMsWUFBWXJPLE1BQU1DLElBQUksQ0FBQ3dILFNBQVM2RyxnQkFBZ0IsQ0FBQyxDQUFDLENBQUMsRUFBRXJJLG9CQUFTLENBQUMsQ0FBQyxDQUFDO1FBQ3ZFL0YsSUFBQUEsZ0JBQU8sRUFBQ21PLFdBQVcsQ0FBQ3ZEO1lBQ2xCLE1BQU1wQyxNQUFNLElBQUk1QyxZQUFZOEMsNEJBQWlCLEVBQUU7Z0JBQzdDQyxTQUFTO2dCQUNUOUMsUUFBUTtvQkFDTkksTUFBTTtnQkFDUjtZQUNGO1lBQ0EyRSxLQUFLL0IsYUFBYSxDQUFDTDtRQUNyQjtJQUNGO0lBRUEsV0FBVztJQUNYLGlHQUFpRztJQUNqRyxJQUFJekgsTUFBTW1OLE9BQU8sS0FBSyxNQUFNbk4sTUFBTUMsTUFBTSxZQUFZeUIsYUFBYTtRQUMvRCx5RUFBeUU7UUFDekUsc0VBQXNFO1FBQ3RFLHFCQUFxQjtRQUNyQixNQUFNNEwsY0FBY3ROLE1BQU1DLE1BQU07UUFFaEMsOEVBQThFO1FBQzlFLHdDQUF3QztRQUN4Qyx5RUFBeUU7UUFDekUsNEVBQTRFO1FBQzVFLElBQ0UsQUFBQ3FOLENBQUFBLFlBQVkxTixZQUFZLENBQUMsWUFBWSxZQUNwQzBOLFlBQVkxTixZQUFZLENBQUMsWUFBWSxVQUNyQzBOLFlBQVk1TixZQUFZLENBQUMsV0FDekI0TixZQUFZNU4sWUFBWSxDQUFDLFVBQVMsS0FDcENZLElBQUFBLDJDQUE0QixFQUMxQlMsMENBQStCLEVBQy9CZixNQUFNQyxNQUFNLEtBQ1QsTUFDTDtZQUNBRCxNQUFNd0IsY0FBYztZQUNwQjhMLFlBQVlDLEtBQUs7UUFDbkI7SUFDRjtBQUNGO0FBRUEsTUFBTWxJLG1CQUFtQixDQUN2Qm1JLFNBRUEzTCxJQUFBQSxvQ0FBcUIsRUFBQ3FILDRDQUFpQyxFQUFFc0U7QUFFM0QsTUFBTUMsdUJBQXVCLENBQUMsRUFBQ3hOLE1BQU0sRUFBUTtJQUMzQyxJQUFJLENBQUVBLENBQUFBLGtCQUFrQlIsT0FBTSxHQUFJO1FBQ2hDO0lBQ0Y7SUFFQSxNQUFNMk4sWUFBWXJPLE1BQU1DLElBQUksQ0FBQ3dILFNBQVM2RyxnQkFBZ0IsQ0FBQyxDQUFDLENBQUMsRUFBRXJJLG9CQUFTLENBQUMsQ0FBQyxDQUFDO0lBQ3ZFL0YsSUFBQUEsZ0JBQU8sRUFBQ21PLFdBQVcsQ0FBQ3ZEO1FBQ2xCLCtHQUErRztRQUMvRyxNQUFNckcsZ0JBQWdCNkIsaUJBQWlCd0U7UUFDdkMsTUFBTXhDLGlCQUFpQnhGLElBQUFBLG9DQUFxQixFQUMxQ3RCLDRDQUFpQyxFQUNqQ3NKO1FBRUYsSUFDRSxDQUFFckcsQ0FBQUEseUJBQXlCL0QsT0FBTSxLQUNqQyxDQUFFNEgsQ0FBQUEsMEJBQTBCNUgsT0FBTSxHQUNsQztZQUNBO1FBQ0Y7UUFFQSxNQUFNOEYsV0FBV3NFLEtBQUtqSyxZQUFZLENBQUM0RixvQkFBUztRQUM1QywwSUFBMEk7UUFDMUksTUFBTWtJLGNBQ0puSSxhQUFhdEgsaUJBQWlCc0gsYUFBYXJILGlCQUN2QyxDQUFDMkwsS0FBSzhELFFBQVEsQ0FBQzFOLFVBQ2YsQ0FBQ3VELGNBQWNtSyxRQUFRLENBQUMxTixXQUFXLENBQUNvSCxlQUFlc0csUUFBUSxDQUFDMU47UUFFbEUsSUFBSXlOLGFBQWE7WUFDZixNQUFNakcsTUFBTSxJQUFJNUMsWUFBWThDLDRCQUFpQixFQUFFO2dCQUM3Q0MsU0FBUztnQkFDVDlDLFFBQVE7b0JBQ05JLE1BQU07Z0JBQ1I7WUFDRjtZQUNBMkUsS0FBSy9CLGFBQWEsQ0FBQ0w7UUFDckI7SUFDRjtBQUNGO0FBRUEsTUFBTTVELHVCQUF1QixDQUFDK0o7SUFDNUIsTUFBTUMsb0JBQ0o7SUFFRixPQUFPO1dBQUlELFVBQVVQLGdCQUFnQixDQUFDUTtLQUFtQixDQUFDZixNQUFNLENBQzlELHdGQUF3RjtJQUN4RixDQUFDdE4sVUFBWSxDQUFDQSxRQUFRRSxZQUFZLENBQUMsZUFBZUYsUUFBUXNPLFlBQVksR0FBRztBQUU3RTtBQUVBLE1BQU1wSCxzQkFBc0IsQ0FBQzFHO0lBQzNCLDJLQUEySztJQUMzSyxJQUFJQSxNQUFNeUwsR0FBRyxLQUFLLFNBQVN6TCxNQUFNbU4sT0FBTyxLQUFLLEdBQUc7UUFDOUM7SUFDRjtJQUVBLE1BQU1DLFlBQVlyTyxNQUFNQyxJQUFJLENBQUN3SCxTQUFTNkcsZ0JBQWdCLENBQUMsQ0FBQyxDQUFDLEVBQUVySSxvQkFBUyxDQUFDLENBQUMsQ0FBQztJQUN2RS9GLElBQUFBLGdCQUFPLEVBQUNtTyxXQUFXLENBQUN2RDtRQUNsQiwrR0FBK0c7UUFDL0csTUFBTXJHLGdCQUFnQjZCLGlCQUFpQndFO1FBQ3ZDLElBQUksQ0FBRXJHLENBQUFBLHlCQUF5Qi9ELE9BQU0sR0FBSTtZQUN2QztRQUNGO1FBRUEsTUFBTW1FLG1CQUFtQkMscUJBQXFCTDtRQUM5QyxNQUFNdUssd0JBQXdCbkssZ0JBQWdCLENBQUMsRUFBRTtRQUNqRCxNQUFNb0ssdUJBQXVCcEssZ0JBQWdCLENBQUNBLGlCQUFpQkUsTUFBTSxHQUFHLEVBQUU7UUFFMUUsa0dBQWtHO1FBQ2xHLElBQUk5RCxNQUFNaU8sUUFBUSxFQUFFO1lBQ2xCLElBQUl6SCxTQUFTMEgsYUFBYSxLQUFLSCx1QkFBdUI7Z0JBQ3BELGlGQUFpRjtnQkFDakZDLHFCQUFxQmpLLEtBQUs7Z0JBQzFCL0QsTUFBTXdCLGNBQWM7WUFDdEI7UUFDRixPQUFPO1lBQ0wsSUFBSWdGLFNBQVMwSCxhQUFhLEtBQUtGLHNCQUFzQjtnQkFDbkQsaUZBQWlGO2dCQUNqRkQsc0JBQXNCaEssS0FBSztnQkFDM0IvRCxNQUFNd0IsY0FBYztZQUN0QjtRQUNGO0lBQ0Y7QUFDRjtBQUVPLE1BQU01RCxXQUFXLENBQUN1UTtJQUN2QkEsYUFBYUMsRUFBRSxDQUFDLFNBQVNyTyxvQkFBb0JvQjtJQUM3Q2dOLGFBQWFDLEVBQUUsQ0FDYixVQUNBbE8sNEJBQ0E4RDtJQUVGbUssYUFBYUMsRUFBRSxDQUFDLFNBQVNqTywwQkFBMEJzRTtJQUNuRDBKLGFBQWFDLEVBQUUsQ0FBQyxTQUFTaE8sbUJBQW1Ca0g7SUFDNUM2RyxhQUFhQyxFQUFFLENBQUMsU0FBUzFOLDJCQUEyQnFIO0lBQ3BEb0csYUFBYUMsRUFBRSxDQUFDLGFBQWFoTyxtQkFBbUJrSDtJQUNoRDZHLGFBQWFDLEVBQUUsQ0FDYnpHLDRCQUFpQixFQUNqQjlHLG9CQUNBK0Q7SUFFRnVKLGFBQWFDLEVBQUUsQ0FBQ2hDLDRCQUFpQixFQUFFVyxTQUFTWjtJQUM1QyxzRkFBc0Y7SUFDdEYsbUZBQW1GO0lBQ25GZ0MsYUFBYUMsRUFBRSxDQUFDLFVBQVVwTixpQkFBaUIrSDtJQUMzQ29GLGFBQWFDLEVBQUUsQ0FBQyxTQUFTckIsU0FBU0c7SUFDbENpQixhQUFhQyxFQUFFLENBQUMsU0FBU3JCLFNBQVNVO0lBRWxDLGdGQUFnRjtJQUNoRixtRkFBbUY7SUFDbkYsOEJBQThCO0lBQzlCLElBQUlwTSxPQUFPQyxPQUFPLENBQUNDLEdBQUcsQ0FBQyxhQUFhRixPQUFPQyxPQUFPLENBQUNDLEdBQUcsQ0FBQyxZQUFZO1FBQ2pFRixPQUFPb0YsZ0JBQWdCLENBQUMsZ0JBQWdCMkM7UUFDeEMvSCxPQUFPb0YsZ0JBQWdCLENBQUMsZUFBZWdEO0lBQ3pDO0FBQ0Y7TUFFQSxXQUFlO0lBQUM3TDtBQUFRIn0=

}),
69773: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/* globals window */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    isCartOpen: function() {
        return isCartOpen;
    },
    showErrorMessageForError: function() {
        return showErrorMessageForError;
    }
});
const _constants = __webpack_require__(10873);
const _commerceUtils = __webpack_require__(54556);
const _client = __webpack_require__(22805);
const isCartOpen = ()=>{
    const cartContainerEl = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_CONTAINER_WRAPPER);
    if (!cartContainerEl) return false;
    return window.getComputedStyle(cartContainerEl).display !== 'none';
};
const updateErrorMessage = (element, error)=>{
    const errorText = element.querySelector(_constants.CART_ERROR_MESSAGE_SELECTOR);
    if (!errorText) return;
    const errorType = getErrorType(error);
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly QUANTITY: { readonly id: "QUANTITY_ERROR"; readonly name: "Quantity not available"; readonly category: { readonly id: "GENERAL"; readonly label: "General Errors"; }; readonly copy: "Product is not available in this quantity."; readonly path: readonly [...]; }; readonly GENERAL: { ...; }; readonly CHECKOUT...'.
    const errorData = _constants.CART_ERRORS[errorType.toUpperCase()] || {};
    const defaultErrorMessage = errorData.msg;
    const errorMessage = errorText.getAttribute((0, _constants.getCheckoutErrorMessageForType)(errorType)) || defaultErrorMessage;
    errorText.textContent = errorMessage;
    if (errorData.requiresRefresh) {
        errorText.setAttribute(_constants.NEEDS_REFRESH, 'true');
    } else {
        errorText.removeAttribute(_constants.NEEDS_REFRESH);
    }
};
const errorCodeToCartErrorType = (code, msg)=>{
    switch(code){
        case 'OrderTotalRange':
            {
                if (msg && msg.match(/too small/i)) {
                    return 'cart_order_min';
                }
                return 'general';
            }
        default:
            return 'general';
    }
};
const getErrorType = (error)=>{
    if (_client.CombinedGraphQLErrors.is(error) && error.errors.length > 0) {
        const errorCode = error.errors[0] && 'code' in error.errors[0] ? error.errors[0].code : null;
        const errorMessage = error.errors[0]?.message;
        return errorCodeToCartErrorType(typeof errorCode === 'string' ? errorCode : undefined, errorMessage);
    }
    if (error.code) {
        return errorCodeToCartErrorType(error.code, error.message);
    }
    return 'general';
};
const showErrorMessageForError = (err, scope)=>{
    const cartErrorState = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_ERROR, scope);
    if (cartErrorState) {
        cartErrorState.style.removeProperty('display');
        updateErrorMessage(cartErrorState, err);
    }
};

//# sourceMappingURL=data:application/json;base64,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

}),
82333: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/* globals window, Element, CustomEvent, HTMLElement */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    register: function() {
        return register;
    }
});
const _debounce = /*#__PURE__*/ _interop_require_default(__webpack_require__(18305));
const _constants = __webpack_require__(10873);
const _commerceUtils = __webpack_require__(54556);
const _checkoutUtils = __webpack_require__(17696);
const _debug = /*#__PURE__*/ _interop_require_default(__webpack_require__(85986));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// @ts-expect-error - TS7031 - Binding element 'target' implicitly has an 'any' type.
const isInputInsideCustomerInfoEvent = ({ target })=>{
    // ensures this event's logic doesn't run on non-checkout pages
    const checkoutFormContainer = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER);
    if (!checkoutFormContainer) {
        return false;
    }
    const customerInfoWrapper = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_CUSTOMER_INFO_WRAPPER, target);
    if (customerInfoWrapper && target instanceof Element && target.tagName === 'INPUT') {
        return target;
    } else {
        return false;
    }
};
// @ts-expect-error - TS7031 - Binding element 'target' implicitly has an 'any' type.
const isInputInsideAddressWrapperEvent = ({ target })=>{
    // ensures this event's logic doesn't run on non-checkout pages
    const checkoutFormContainer = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER);
    if (!checkoutFormContainer || !(target instanceof Element)) {
        return false;
    }
    const shippingAddressWrapper = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_WRAPPER, target);
    const billingAddressWrapper = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_WRAPPER, target);
    if (shippingAddressWrapper) {
        return shippingAddressWrapper;
    } else if (billingAddressWrapper) {
        return billingAddressWrapper;
    } else {
        return false;
    }
};
// @ts-expect-error - TS7031 - Binding element 'target' implicitly has an 'any' type.
const isInputInsideShippingMethodEvent = ({ target })=>{
    // ensures this event's logic doesn't run on non-checkout pages
    const checkoutFormContainer = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER) || (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_FORM_CONTAINER);
    if (!checkoutFormContainer) {
        return false;
    }
    const shippingMethodWrapper = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_WRAPPER, target);
    if (shippingMethodWrapper && target instanceof Element && target.tagName === 'INPUT') {
        return target;
    } else {
        return false;
    }
};
// @ts-expect-error - TS7031 - Binding element 'target' implicitly has an 'any' type.
const isBillingAddressToggleEvent = ({ target })=>{
    if (target instanceof Element && target.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_TOGGLE_CHECKBOX) {
        return target;
    } else {
        return false;
    }
};
// @ts-expect-error - TS7031 - Binding element 'target' implicitly has an 'any' type.
const isPlaceOrderButtonEvent = ({ target })=>{
    const placeOrderButton = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_PLACE_ORDER_BUTTON, target);
    if (placeOrderButton && target instanceof Element) {
        return target;
    } else {
        return false;
    }
};
// @ts-expect-error - TS7031 - Binding element 'target' implicitly has an 'any' type.
const isApplyDiscountFormEvent = ({ target })=>{
    if (target instanceof Element && target.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_FORM) {
        return target;
    } else {
        return false;
    }
};
// @ts-expect-error - TS7031 - Binding element 'target' implicitly has an 'any' type.
const isFormInsideCheckoutContainerEvent = ({ target })=>{
    const checkoutForm = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER, target);
    if (target instanceof HTMLFormElement && checkoutForm) {
        return target;
    } else {
        return false;
    }
};
// @ts-expect-error - TS7031 - Binding element 'target' implicitly has an 'any' type.
const isInputInsideCheckoutFormEvent = ({ target })=>{
    const checkoutForm = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER, target);
    if (target instanceof HTMLInputElement && checkoutForm) {
        return target;
    } else {
        return false;
    }
};
const handleRenderCheckout = (event, apolloClient, stripeStore)=>{
    if (window.Webflow.env('design') || window.Webflow.env('preview')) {
        return;
    }
    if (!(event instanceof CustomEvent && event.type === _constants.RENDER_TREE_EVENT)) {
        return;
    }
    const errors = [];
    const { detail } = event;
    if (detail != null && detail.error) {
        errors.push(detail.error);
    }
    const focusedEle = window.document.activeElement;
    const checkoutForm = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER, // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'EventTarget'.
    focusedEle);
    let prevFocusedInput = null;
    // Only trigger for focused elements in a checkout form
    if (focusedEle instanceof HTMLInputElement && checkoutForm) {
        prevFocusedInput = focusedEle.id;
        if (!prevFocusedInput) {
            prevFocusedInput = focusedEle.getAttribute('data-wf-bindings');
        }
        // Move from empty string to null
        prevFocusedInput = prevFocusedInput ? null : prevFocusedInput;
    }
    const checkoutFormContainers = (0, _commerceUtils.findAllElementsByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER);
    (0, _checkoutUtils.renderCheckoutFormContainers)(checkoutFormContainers, errors, apolloClient, stripeStore, prevFocusedInput);
};
const checkFormValidity = ({ customerInfo, shippingAddress, shippingInfo, billingAddress, billingAddressToggle, additionalInfo, requiresShipping })=>{
    // reportValidity isn't supported in IE, so we need to check if it exists
    // for our IE users. they'll have to rely on the server error, which isn't
    // too bad from a UX experience, since they'll still know something went wrong
    if (!HTMLFormElement.prototype.reportValidity) {
        return true;
    }
    // because we have multiple form elements, what we do is ask the browser to report
    // the validity of each form, which triggers the UI that would usually be seen
    // when someone submitted a regular form. we return if it's not valid, so that
    // the browser doesn't jump ahead to the next element, allowing the user to
    // fix their mistakes. we don't check the stripe elements, since we can't
    // directly get the status of those, as that's handled by stripe. however, if
    // the user is missing a field and tries to submit the form, they will get
    // an error when we try to create the token, so we'll display an error then
    if (!customerInfo.reportValidity() || requiresShipping && !shippingAddress.reportValidity() || requiresShipping && !shippingInfo.reportValidity() || // only check the billing address if the toggle is off, i.e. the billing address
    // form is being shown or if it does not require shipping
    (!requiresShipping || !billingAddressToggle.checked) && !billingAddress.reportValidity() || additionalInfo && additionalInfo instanceof HTMLFormElement && !additionalInfo.reportValidity()) {
        return false;
    }
    return true;
};
let placingOrder = false;
const startOrderFlow = (placeOrderButton)=>{
    placingOrder = true;
    window.addEventListener('beforeunload', _checkoutUtils.beforeUnloadHandler);
    const buttonText = placeOrderButton.innerHTML;
    const loadingText = placeOrderButton.getAttribute(_constants.DATA_ATTR_LOADING_TEXT);
    placeOrderButton.innerHTML = loadingText ? loadingText : _constants.CHECKOUT_PLACE_ORDER_LOADING_TEXT_DEFAULT;
    const finishOrderFlow = (isRedirecting = false)=>{
        // we only set `placingOrder` to false if we're not redirecting to the
        // confirmation page. this is so that while waiting for the confirmation
        // page to load, the user can't attempt to submit the order again
        if (!isRedirecting) {
            placingOrder = false;
        }
        window.removeEventListener('beforeunload', _checkoutUtils.beforeUnloadHandler);
        placeOrderButton.innerHTML = buttonText ? buttonText : _constants.CHECKOUT_PLACE_ORDER_BUTTON_TEXT_DEFAULT;
    };
    return finishOrderFlow;
};
const handlePlaceOrder = (event, apolloClient, stripeStore)=>{
    // Want to skip placing order if in design/preview mode, or an order place is in progress
    if (window.Webflow.env('design') || window.Webflow.env('preview') || placingOrder) {
        return;
    }
    const { currentTarget } = event;
    if (!(currentTarget instanceof Element)) {
        return;
    }
    const checkoutFormContainer = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER, currentTarget);
    if (!(checkoutFormContainer instanceof Element)) {
        return;
    }
    const errorState = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_ERROR_STATE, checkoutFormContainer);
    const customerInfo = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_CUSTOMER_INFO_WRAPPER, checkoutFormContainer);
    const shippingAddress = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_WRAPPER, checkoutFormContainer);
    const shippingInfo = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_WRAPPER, checkoutFormContainer);
    const billingAddress = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_WRAPPER, checkoutFormContainer);
    const billingAddressToggle = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_TOGGLE_CHECKBOX, checkoutFormContainer);
    const placeOrderButton = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_PLACE_ORDER_BUTTON, checkoutFormContainer);
    const additionalInfo = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_ADDITIONAL_INFO, checkoutFormContainer);
    if (!(errorState instanceof HTMLElement) || !(customerInfo instanceof HTMLFormElement) || !(shippingAddress instanceof HTMLFormElement) || !(shippingInfo instanceof HTMLFormElement) || !(billingAddress instanceof HTMLFormElement) || !(billingAddressToggle instanceof HTMLInputElement) || !(placeOrderButton instanceof Element)) {
        return;
    }
    const errorMessage = errorState.querySelector(_constants.CART_CHECKOUT_ERROR_MESSAGE_SELECTOR);
    // If the error message has this attribute, we want to block the order from
    // being submitted as the user is being forced to refresh the checkout page.
    if (errorMessage && errorMessage.hasAttribute(_constants.NEEDS_REFRESH)) {
        return;
    }
    const hasAdditionalInfo = additionalInfo && additionalInfo instanceof HTMLElement;
    const finishOrderFlow = startOrderFlow(placeOrderButton);
    errorState.style.setProperty('display', 'none');
    (0, _commerceUtils.fetchOrderStatusFlags)(apolloClient).then(({ requiresShipping, isFreeOrder })=>{
        const isFormValid = checkFormValidity({
            customerInfo,
            shippingAddress,
            shippingInfo,
            billingAddress,
            billingAddressToggle,
            additionalInfo,
            requiresShipping
        });
        if (!isFormValid) {
            finishOrderFlow();
            return;
        }
        // final sync with server, to ensure validity
        const customerInfoFormData = (0, _commerceUtils.formToObject)(customerInfo);
        const email = String(customerInfoFormData.email).trim();
        const shippingAddressInfo = {
            type: 'shipping',
            ...(0, _commerceUtils.formToObject)(shippingAddress, true)
        };
        const billingAddressInfo = {
            type: 'billing',
            ...(0, _commerceUtils.formToObject)(!billingAddressToggle.checked || !requiresShipping ? billingAddress : shippingAddress, true)
        };
        const stripeBillingAddressInfo = {
            billing_details: {
                // @ts-expect-error - TS2339 - Property 'name' does not exist on type '{ readonly type: "billing"; }'.
                name: billingAddressInfo.name,
                email,
                address: {
                    // @ts-expect-error - TS2339 - Property 'address_line1' does not exist on type '{ readonly type: "billing"; }'.
                    line1: billingAddressInfo.address_line1,
                    // @ts-expect-error - TS2339 - Property 'address_line2' does not exist on type '{ readonly type: "billing"; }'.
                    line2: billingAddressInfo.address_line2,
                    // @ts-expect-error - TS2339 - Property 'address_city' does not exist on type '{ readonly type: "billing"; }'.
                    city: billingAddressInfo.address_city,
                    // @ts-expect-error - TS2339 - Property 'address_state' does not exist on type '{ readonly type: "billing"; }'.
                    state: billingAddressInfo.address_state,
                    // @ts-expect-error - TS2339 - Property 'address_country' does not exist on type '{ readonly type: "billing"; }'.
                    country: billingAddressInfo.address_country,
                    // @ts-expect-error - TS2339 - Property 'address_zip' does not exist on type '{ readonly type: "billing"; }'.
                    postal_code: billingAddressInfo.address_zip
                }
            }
        };
        let shippingMethodId = '';
        // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
        if (requiresShipping && shippingInfo.elements['shipping-method-choice']) {
            // this is an IE11-safe way of just doing shippingInfo.elements['shipping-method-choice'].value
            const shippingMethodChoice = shippingInfo.querySelector('input[name="shipping-method-choice"]:checked');
            // this should never be falsey, but Flow
            if (shippingMethodChoice) {
                shippingMethodId = shippingMethodChoice.value;
            }
        }
        const customData = hasAdditionalInfo ? (0, _commerceUtils.customDataFormToArray)(additionalInfo) : [];
        const syncCheckoutForm = Promise.all([
            (0, _checkoutUtils.createOrderIdentityMutation)(apolloClient, email),
            (0, _checkoutUtils.createOrderAddressMutation)(apolloClient, billingAddressInfo),
            requiresShipping ? (0, _checkoutUtils.createOrderAddressMutation)(apolloClient, shippingAddressInfo) : Promise.resolve(),
            requiresShipping ? (0, _checkoutUtils.createOrderShippingMethodMutation)(apolloClient, shippingMethodId) : Promise.resolve(),
            hasAdditionalInfo ? (0, _checkoutUtils.createCustomDataMutation)(apolloClient, customData) : Promise.resolve()
        ]);
        syncCheckoutForm.then(()=>{
            if (isFreeOrder) {
                return Promise.resolve();
            }
            if (!stripeStore.isInitialized()) {
                return Promise.reject(new Error("Stripe has not been set up for this project – Go to the project's Ecommerce Payment settings in the Designer to link Stripe."));
            }
            const stripe = stripeStore.getStripeInstance();
            const checkoutFormInstance = parseInt(// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
            checkoutFormContainer.getAttribute(_constants.STRIPE_ELEMENT_INSTANCE), 10);
            const card = stripeStore.getElement('cardNumber', checkoutFormInstance);
            return stripe.createPaymentMethod('card', card, stripeBillingAddressInfo);
        })// @ts-expect-error - Argument of type '(data: any) => Promise<FetchResult<any>> | Promise<void>' is not assignable to parameter of type '(value: any) => FetchResult<any> | PromiseLike<FetchResult<any>>'.
        .then((data)=>{
            if (!data || isFreeOrder) {
                return Promise.resolve();
            }
            if (data.error) {
                return Promise.reject(data.error);
            }
            return (0, _checkoutUtils.createStripePaymentMethodMutation)(apolloClient, data.paymentMethod.id);
        }).then(()=>{
            return (0, _checkoutUtils.createAttemptSubmitOrderRequest)(apolloClient, {
                checkoutType: 'normal'
            });
        }).then((data)=>{
            _debug.default.log(data);
            const order = (0, _checkoutUtils.getOrderDataFromGraphQLResponse)(data);
            if ((0, _checkoutUtils.orderRequiresAdditionalAction)(order.status)) {
                const stripe = stripeStore.getStripeInstance();
                return stripe.retrievePaymentIntent(order.clientSecret)// @ts-expect-error - TS7006 - Parameter 'retrieveResult' implicitly has an 'any' type.
                .then((retrieveResult)=>{
                    const intent = retrieveResult && retrieveResult.paymentIntent || {};
                    const actionPromise = intent.confirmation_method === 'automatic' ? stripe.confirmCardPayment(order.clientSecret) : stripe.handleCardAction(order.clientSecret);
                    // @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type.
                    return actionPromise.then((result)=>{
                        if (result.error) {
                            return Promise.reject(result.error);
                        }
                        return (0, _checkoutUtils.createAttemptSubmitOrderRequest)(apolloClient, {
                            checkoutType: 'normal',
                            paymentIntentId: result.paymentIntent.id
                        }).then((resp)=>{
                            const finishedOrder = (0, _checkoutUtils.getOrderDataFromGraphQLResponse)(resp);
                            if (finishedOrder.ok) {
                                finishOrderFlow(true);
                                (0, _checkoutUtils.redirectToOrderConfirmation)(finishedOrder);
                            }
                        });
                    });
                });
            }
            if (order.ok) {
                finishOrderFlow(true);
                (0, _checkoutUtils.redirectToOrderConfirmation)(order);
            }
        }).catch((err)=>{
            finishOrderFlow();
            _debug.default.error(err);
            errorState.style.removeProperty('display');
            (0, _checkoutUtils.updateErrorMessage)(errorState, err);
        });
    });
};
const handleApplyDiscount = (event, apolloClient)=>{
    event.preventDefault(); // prevent submit
    event.stopImmediatePropagation(); // do not trigger submission of any other forms (we have forms in forms :())
    const { currentTarget } = event;
    if (!(currentTarget instanceof Element)) {
        return;
    }
    const inputEl = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_INPUT, currentTarget);
    const checkoutFormContainer = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER, currentTarget) || (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_FORM_CONTAINER, currentTarget);
    if (!checkoutFormContainer) {
        return;
    }
    const errorStateEl = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_ERROR_STATE, checkoutFormContainer);
    if (!(inputEl instanceof HTMLInputElement && errorStateEl instanceof HTMLElement)) {
        return;
    }
    const discountCode = inputEl.value.trim().toUpperCase();
    (0, _checkoutUtils.applyDiscount)(apolloClient, {
        discountCode
    }).then(()=>{
        inputEl.value = '';
        errorStateEl.style.display = 'none';
        (0, _commerceUtils.triggerRender)(null);
    }).catch((error)=>(0, _checkoutUtils.showErrorMessageForError)(error, checkoutFormContainer));
};
const handleUpdateCustomerInfo = (event, apolloClient)=>{
    const { currentTarget } = event;
    if (!(currentTarget instanceof HTMLInputElement)) {
        return;
    }
    const value = currentTarget.value.trim();
    const email = value == null || value === '' ? null : value;
    (0, _checkoutUtils.createOrderIdentityMutation)(apolloClient, email).then(()=>{
        (0, _commerceUtils.triggerRender)(null);
    }).catch((err)=>{
        (0, _commerceUtils.triggerRender)(err);
    });
};
const handleUpdateAddress = (0, _debounce.default)((event, apolloClient)=>{
    const { currentTarget } = event;
    if (!(currentTarget instanceof HTMLFormElement)) {
        return;
    }
    const type = currentTarget.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_WRAPPER ? 'shipping' : 'billing';
    const addressInfo = {
        type,
        ...(0, _commerceUtils.formToObject)(currentTarget, true)
    };
    (0, _checkoutUtils.createOrderAddressMutation)(apolloClient, addressInfo).then(()=>{
        (0, _commerceUtils.triggerRender)(null);
    }).catch((err)=>{
        (0, _commerceUtils.triggerRender)(err);
    });
}, 500);
// @ts-expect-error - TS7031 - Binding element 'currentTarget' implicitly has an 'any' type.
const handleToggleBillingAddress = ({ currentTarget })=>{
    const checkoutFormContainer = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER, currentTarget);
    if (!checkoutFormContainer) {
        return;
    }
    const billingAddressWrapper = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_WRAPPER, checkoutFormContainer);
    if (!billingAddressWrapper || !(currentTarget instanceof HTMLInputElement)) {
        return;
    }
    if (currentTarget.checked) {
        billingAddressWrapper.style.setProperty('display', 'none');
    } else {
        billingAddressWrapper.style.removeProperty('display');
    }
};
const handleChooseShippingMethod = (// @ts-expect-error - TS7031 - Binding element 'currentTarget' implicitly has an 'any' type.
{ currentTarget }, apolloClient)=>{
    if (!(currentTarget instanceof HTMLInputElement)) {
        return;
    }
    (0, _checkoutUtils.createOrderShippingMethodMutation)(apolloClient, currentTarget.id).then(()=>{
        (0, _commerceUtils.triggerRender)(null);
    }).catch((err)=>{
        (0, _commerceUtils.triggerRender)(err);
    });
};
const handleSubmitFormInsideCheckoutContainer = (event, apolloClient)=>{
    if (event.type === 'submit') {
        event.preventDefault();
    }
    if (// @ts-expect-error - TS2339 - Property 'keyCode' does not exist on type 'Event | KeyboardEvent'.
    event.type === 'keyup' && event.keyCode !== 13 || !(event.currentTarget instanceof Element)) {
        return;
    }
    if (event.target === (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_INPUT)) {
        return;
    }
    const checkoutFormContainer = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER, event.currentTarget);
    if (!(checkoutFormContainer instanceof Element)) {
        return;
    }
    const customerInfo = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_CUSTOMER_INFO_WRAPPER, checkoutFormContainer);
    const shippingAddress = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_WRAPPER, checkoutFormContainer);
    const shippingInfo = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_WRAPPER, checkoutFormContainer);
    const billingAddress = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_WRAPPER, checkoutFormContainer);
    const billingAddressToggle = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_TOGGLE_CHECKBOX, checkoutFormContainer);
    const additionalInfo = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_ADDITIONAL_INFO, checkoutFormContainer);
    if (!(customerInfo instanceof HTMLFormElement) || !(shippingAddress instanceof HTMLFormElement) || !(shippingInfo instanceof HTMLFormElement) || !(billingAddress instanceof HTMLFormElement) || !(billingAddressToggle instanceof HTMLInputElement)) {
        return;
    }
    const hasAdditionalInfo = additionalInfo && additionalInfo instanceof HTMLFormElement;
    (0, _commerceUtils.fetchOrderStatusFlags)(apolloClient).then(({ requiresShipping })=>{
        checkFormValidity({
            customerInfo,
            shippingAddress,
            shippingInfo,
            billingAddress,
            billingAddressToggle,
            additionalInfo: hasAdditionalInfo ? additionalInfo : null,
            requiresShipping
        });
    });
};
const register = (handlerProxy)=>{
    handlerProxy.on(_constants.RENDER_TREE_EVENT, Boolean, handleRenderCheckout);
    handlerProxy.on('click', isPlaceOrderButtonEvent, handlePlaceOrder);
    handlerProxy.on('keydown', isPlaceOrderButtonEvent, // eslint-disable-next-line @typescript-eslint/no-shadow
    (event, apolloClient, StripeStore)=>{
        // @ts-expect-error - TS2339 - Property 'which' does not exist on type 'Event'.
        if (event.which === 32) {
            // prevent scrolling on spacebar key press
            event.preventDefault();
        }
        // @ts-expect-error - TS2339 - Property 'which' does not exist on type 'Event'.
        if (event.which === 13) {
            // enter key press
            return handlePlaceOrder(event, apolloClient, StripeStore);
        }
    });
    handlerProxy.on('keyup', isPlaceOrderButtonEvent, // eslint-disable-next-line @typescript-eslint/no-shadow
    (event, apolloClient, StripeStore)=>{
        // @ts-expect-error - TS2339 - Property 'which' does not exist on type 'Event'.
        if (event.which === 32) {
            // spacebar key press
            return handlePlaceOrder(event, apolloClient, StripeStore);
        }
    });
    handlerProxy.on('submit', isApplyDiscountFormEvent, handleApplyDiscount);
    // we use blur events on the text inputs, and change event on the country select
    // so that we update faster (blur on a select element requires going into another field)
    handlerProxy.on('change', isInputInsideCustomerInfoEvent, handleUpdateCustomerInfo);
    handlerProxy.on('change', isInputInsideAddressWrapperEvent, handleUpdateAddress);
    handlerProxy.on('change', isBillingAddressToggleEvent, handleToggleBillingAddress);
    handlerProxy.on('change', isInputInsideShippingMethodEvent, handleChooseShippingMethod);
    handlerProxy.on('submit', isFormInsideCheckoutContainerEvent, handleSubmitFormInsideCheckoutContainer);
    // we have to add a keyup event for the enter key on forms to run the validity check
    // as forms with multiple inputs but no submit input don't fire the submit event
    // however we do still need that above submit check, as the email form only has one
    // input, and a browser will fire the submit event if the form has just one input
    // even if it has no submit input
    handlerProxy.on('keyup', isInputInsideCheckoutFormEvent, handleSubmitFormInsideCheckoutContainer);
};
const _default = {
    register
};

//# sourceMappingURL=data:application/json;base64,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

}),
94797: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    applyDiscountMutation: function() {
        return applyDiscountMutation;
    },
    attemptSubmitOrderMutation: function() {
        return attemptSubmitOrderMutation;
    },
    estimateOrderTaxesMutation: function() {
        return estimateOrderTaxesMutation;
    },
    recalcOrderEstimationsMutation: function() {
        return recalcOrderEstimationsMutation;
    },
    requestPayPalOrderMutation: function() {
        return requestPayPalOrderMutation;
    },
    syncPayPalOrderInfo: function() {
        return syncPayPalOrderInfo;
    },
    updateCustomData: function() {
        return updateCustomData;
    },
    updateObfuscatedOrderAddressMutation: function() {
        return updateObfuscatedOrderAddressMutation;
    },
    updateOrderAddressMutation: function() {
        return updateOrderAddressMutation;
    },
    updateOrderIdentityMutation: function() {
        return updateOrderIdentityMutation;
    },
    updateOrderShippingMethodMutation: function() {
        return updateOrderShippingMethodMutation;
    },
    updateOrderStripePaymentMethodMutation: function() {
        return updateOrderStripePaymentMethodMutation;
    }
});
const _graphqltag = /*#__PURE__*/ _interop_require_default(__webpack_require__(28160));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const updateOrderIdentityMutation = (0, _graphqltag.default)`
  mutation CheckoutUpdateOrderIdentity($email: String) {
    ecommerceUpdateIdentity(email: $email) {
      ok
    }
  }
`;
const updateOrderAddressMutation = (0, _graphqltag.default)`
  mutation CheckoutUpdateOrderAddress(
    $type: String!
    $name: String
    $address_line1: String
    $address_line2: String
    $address_city: String
    $address_state: String
    $address_country: String
    $address_zip: String
  ) {
    ecommerceUpdateAddress(
      type: $type
      addressee: $name
      line1: $address_line1
      line2: $address_line2
      city: $address_city
      state: $address_state
      country: $address_country
      postalCode: $address_zip
    ) {
      ok
    }
  }
`;
const updateObfuscatedOrderAddressMutation = (0, _graphqltag.default)`
  mutation CheckoutUpdateObfuscatedOrderAddress(
    $type: String!
    $name: String
    $address_line1: String
    $address_line2: String
    $address_city: String
    $address_state: String
    $address_country: String
    $address_zip: String
  ) {
    ecommerceUpdateObfuscatedAddress(
      type: $type
      addressee: $name
      line1: $address_line1
      line2: $address_line2
      city: $address_city
      state: $address_state
      country: $address_country
      postalCode: $address_zip
    ) {
      ok
    }
  }
`;
const updateOrderShippingMethodMutation = (0, _graphqltag.default)`
  mutation CheckoutUpdateShippingMethod($id: String) {
    ecommerceUpdateShippingMethod(methodId: $id) {
      ok
    }
  }
`;
const updateOrderStripePaymentMethodMutation = (0, _graphqltag.default)`
  mutation CheckoutUpdateStripePaymentMethod($paymentMethod: String!) {
    ecommerceStoreStripePaymentMethod(paymentMethod: $paymentMethod) {
      ok
    }
  }
`;
const updateCustomData = (0, _graphqltag.default)`
  mutation CheckoutUpdateCustomData(
    $customData: [mutation_commerce_update_custom_data]!
  ) {
    ecommerceUpdateCustomData(customData: $customData) {
      ok
    }
  }
`;
const estimateOrderTaxesMutation = (0, _graphqltag.default)`
  mutation CheckoutEstimateOrderTaxes {
    ecommerceEstimateTaxes {
      ok
    }
  }
`;
const recalcOrderEstimationsMutation = (0, _graphqltag.default)`
  mutation CheckoutRecalcOrderEstimations {
    ecommerceRecalcEstimations {
      ok
    }
  }
`;
const requestPayPalOrderMutation = (0, _graphqltag.default)`
  mutation CheckoutRequestPayPalOrder {
    ecommercePaypalOrderRequest {
      orderId
    }
  }
`;
const syncPayPalOrderInfo = (0, _graphqltag.default)`
  mutation CheckoutSyncPayPalInfo {
    ecommerceSyncPaypalOrderInfoToWF {
      ok
    }
  }
`;
const attemptSubmitOrderMutation = (0, _graphqltag.default)`
  mutation CheckoutAttemptSubmitOrder(
    $checkoutType: mutation_commerce_checkout_type
    $paymentIntentId: String
  ) {
    ecommerceAttemptSubmitOrder(
      checkoutType: $checkoutType
      paymentIntentId: $paymentIntentId
    ) {
      orderId
      token
      ok
      customerPaid {
        decimalValue
        unit
      }
      purchasedItems {
        id
        name
        count
        price {
          decimalValue
        }
      }
      status
      clientSecret
      nextAction
    }
  }
`;
const applyDiscountMutation = (0, _graphqltag.default)`
  mutation CheckoutApplyDiscount($discountCode: String!) {
    ecommerceApplyDiscount(discountCode: $discountCode) {
      ok
    }
  }
`;

//# sourceMappingURL=data:application/json;base64,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

}),
17696: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/* globals window, document, HTMLInputElement */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    applyDiscount: function() {
        return applyDiscount;
    },
    beforeUnloadHandler: function() {
        return beforeUnloadHandler;
    },
    createAttemptSubmitOrderRequest: function() {
        return createAttemptSubmitOrderRequest;
    },
    createCustomDataMutation: function() {
        return createCustomDataMutation;
    },
    createOrderAddressMutation: function() {
        return createOrderAddressMutation;
    },
    createOrderIdentityMutation: function() {
        return createOrderIdentityMutation;
    },
    createOrderShippingMethodMutation: function() {
        return createOrderShippingMethodMutation;
    },
    createRecalcOrderEstimationsMutation: function() {
        return createRecalcOrderEstimationsMutation;
    },
    createStripePaymentMethodMutation: function() {
        return createStripePaymentMethodMutation;
    },
    createUpdateObfuscatedOrderAddressMutation: function() {
        return createUpdateObfuscatedOrderAddressMutation;
    },
    getOrderDataFromGraphQLResponse: function() {
        return getOrderDataFromGraphQLResponse;
    },
    initializeStripeElements: function() {
        return initializeStripeElements;
    },
    orderRequiresAdditionalAction: function() {
        return orderRequiresAdditionalAction;
    },
    redirectToOrderConfirmation: function() {
        return redirectToOrderConfirmation;
    },
    renderCheckoutFormContainers: function() {
        return renderCheckoutFormContainers;
    },
    showErrorMessageForError: function() {
        return showErrorMessageForError;
    },
    updateErrorMessage: function() {
        return updateErrorMessage;
    }
});
const _client = __webpack_require__(22805);
const _graphqltag = /*#__PURE__*/ _interop_require_default(__webpack_require__(28160));
const _commerceUtils = __webpack_require__(54556);
const _StyleMapObserver = /*#__PURE__*/ _interop_require_default(__webpack_require__(69147));
const _constants = __webpack_require__(10873);
const _rendering = __webpack_require__(91898);
const _webPaymentsEvents = __webpack_require__(94492);
const _checkoutMutations = __webpack_require__(94797);
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const syncStylesToStripeElement = (stripeElement)=>(appliedStyles)=>{
        stripeElement.update({
            style: _StyleMapObserver.default.appliedStylesToStripeElementStyles(appliedStyles)
        });
    };
const initializeStripeElements = (store)=>{
    if (window.Webflow.env('design') || window.Webflow.env('preview') || !store.isInitialized()) {
        return;
    }
    const checkoutFormContainers = (0, _commerceUtils.findAllElementsByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER);
    const cartWrappers = (0, _commerceUtils.findAllElementsByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_WRAPPER);
    const allStripeElements = [
        ...checkoutFormContainers,
        ...cartWrappers
    ];
    allStripeElements.forEach((element, index)=>{
        store.createElementsInstance(index);
        element.setAttribute(_constants.STRIPE_ELEMENT_INSTANCE, String(index));
    });
    const stripeElements = document.querySelectorAll(`[${_constants.STRIPE_ELEMENT_TYPE}]`);
    Array.from(stripeElements).forEach((element)=>{
        const type = element.getAttribute(_constants.STRIPE_ELEMENT_TYPE);
        if (!type) {
            throw new Error('Stripe element missing type string');
        }
        const checkoutFormContainer = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER, element);
        if (!checkoutFormContainer) {
            return;
        }
        const index = parseInt(// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        checkoutFormContainer.getAttribute(_constants.STRIPE_ELEMENT_INSTANCE), 10);
        const el = store.createElement(type, index, {
            style: (0, _commerceUtils.safeParseJson)(element.getAttribute(_constants.STRIPE_ELEMENT_STYLE) || '{}'),
            classes: {
                focus: '-wfp-focus'
            }
        });
        el.mount(element);
        // eslint-disable-next-line unused-imports/no-unused-vars, unused-imports/no-unused-vars
        const styleMapObserver = new _StyleMapObserver.default(element, {
            onChange: syncStylesToStripeElement(el)
        });
    });
};
const errorCodeToCheckoutErrorType = (code, msg)=>{
    switch(code){
        case 'OrderTotalRange':
            if (msg && msg.match(/too small/i)) {
                return 'minimum';
            } else {
                return 'info';
            }
        case 'OrderExtrasChanged':
            return 'extras';
        case 'PriceChanged':
            return 'pricing';
        case 'StripeRejected':
            return 'billing';
        case 'NeedShippingAddress':
        case 'InvalidShippingAddress':
        case 'NeedShippingMethod':
            return 'shipping';
        case 'NeedPaymentMethod':
        case 'StripeFailure':
            return 'payment';
        case 'ItemNotFound':
            return 'product';
        // 'InvalidDiscount' has been renamed to 'DiscountInvalid', but it needs
        // to be listed here to support sites that haven't been published since this change.
        case 'InvalidDiscount':
        case 'DiscountInvalid':
        case 'DiscountDoesNotExist':
            {
                return 'invalid-discount';
            }
        case 'DiscountExpired':
            {
                return 'expired-discount';
            }
        case 'DiscountUsageReached':
            {
                return 'usage-reached-discount';
            }
        case 'DiscountRequirementsNotMet':
            {
                return 'requirements-not-met';
            }
        default:
            return 'info';
    }
};
const getErrorType = (error)=>{
    if (_client.CombinedGraphQLErrors.is(error) && error.errors.length > 0) {
        const errorCode = error.errors[0]?.extensions?.code;
        const errorMessage = error.errors[0]?.message;
        return errorCodeToCheckoutErrorType(typeof errorCode === 'string' ? errorCode : undefined, errorMessage);
    }
    if (error.code) {
        return errorCodeToCheckoutErrorType(error.code, error.message);
    }
    return 'info';
};
const updateErrorMessage = (element, error)=>{
    const errorText = element.querySelector(_constants.CART_CHECKOUT_ERROR_MESSAGE_SELECTOR);
    if (!errorText) {
        return;
    }
    // Handle Stripe.js client-side errors. We use Stripe.js's error message
    // as this error typically indicates that the user forgot to enter part of
    // their CC, or entered invalid data. The more specific the error, the more
    // helpful it will be for the user.
    if (error.type && error.type === 'validation_error') {
        errorText.textContent = error.message;
        return;
    }
    const errorType = getErrorType(error);
    // Get the default error message incase the node does not have the error attribute yet.
    const errorData = // @ts-expect-error Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{...}'
    _constants.CHECKOUT_ERRORS[errorType.toUpperCase().replace(/\W/g, '_')] || {};
    const defaultErrorMessage = errorData.copy;
    const errorMessage = errorText.getAttribute((0, _constants.getCheckoutErrorMessageForType)(errorType)) || defaultErrorMessage;
    errorText.textContent = errorMessage;
    if (errorData.requiresRefresh) {
        errorText.setAttribute(_constants.NEEDS_REFRESH, 'true');
    } else {
        errorText.removeAttribute(_constants.NEEDS_REFRESH);
    }
    if (errorType === 'shipping') {
        updateRequiredFields(error);
    }
};
const elementNameByGraphQLError = {
    MISSING_STATE: 'address_state'
};
const updateRequiredFields = (error)=>{
    if (!_client.CombinedGraphQLErrors.is(error) || error.errors.length === 0) {
        return;
    }
    const invalidShippingAddressError = error.errors.find((gqlError)=>'code' in gqlError && gqlError.code === 'InvalidShippingAddress');
    if (!invalidShippingAddressError) {
        return;
    }
    // @ts-expect-error - TS7006 - Parameter 'problem' implicitly has an 'any' type.
    invalidShippingAddressError.problems.forEach((problem)=>{
        const { type } = problem;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly MISSING_STATE: "address_state"; }'.
        const elementName = elementNameByGraphQLError[type];
        if (!elementName) {
            return;
        }
        const element = document.getElementsByName(elementName)[0];
        if (!(element instanceof HTMLInputElement)) {
            return;
        }
        element.required = true;
        // IE11 doesn't support the reportValidity API
        if (typeof element.reportValidity === 'function') {
            element.reportValidity();
        }
    });
};
const showErrorMessageForError = (err, scope)=>{
    const errorState = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_ERROR_STATE, scope);
    if (errorState) {
        errorState.style.removeProperty('display');
        updateErrorMessage(errorState, err);
    }
};
const beforeUnloadHandler = (e)=>{
    e.preventDefault();
    e.returnValue = '';
};
const createOrderIdentityMutation = (apolloClient, email)=>apolloClient.mutate({
        mutation: _checkoutMutations.updateOrderIdentityMutation,
        variables: {
            email
        }
    });
const createOrderAddressMutation = (apolloClient, addressInfo)=>apolloClient.mutate({
        mutation: _checkoutMutations.updateOrderAddressMutation,
        variables: addressInfo
    });
const createOrderShippingMethodMutation = (apolloClient, id)=>apolloClient.mutate({
        mutation: _checkoutMutations.updateOrderShippingMethodMutation,
        variables: {
            id
        }
    });
const createCustomDataMutation = (apolloClient, customData)=>apolloClient.mutate({
        mutation: _checkoutMutations.updateCustomData,
        variables: {
            customData
        }
    });
const createStripePaymentMethodMutation = (apolloClient, id)=>apolloClient.mutate({
        mutation: _checkoutMutations.updateOrderStripePaymentMethodMutation,
        variables: {
            paymentMethod: id
        }
    });
const createRecalcOrderEstimationsMutation = (apolloClient)=>apolloClient.mutate({
        mutation: _checkoutMutations.recalcOrderEstimationsMutation,
        errorPolicy: 'ignore'
    });
const createUpdateObfuscatedOrderAddressMutation = (apolloClient, addressInfo)=>apolloClient.mutate({
        mutation: _checkoutMutations.updateObfuscatedOrderAddressMutation,
        variables: addressInfo
    });
const renderCheckout = (checkout, data, prevFocusedInput)=>{
    (0, _rendering.renderTree)(checkout, data);
    const shippingMethodsList = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_LIST, checkout);
    const shippingMethodsEmpty = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_EMPTY_STATE, checkout);
    const shippingAddressWrapper = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_WRAPPER, checkout);
    const billingAddressWrapper = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_WRAPPER, checkout);
    const billingAddressToggle = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_TOGGLE_CHECKBOX, checkout);
    const paymentInfoWrapper = checkout.querySelector('.w-commerce-commercecheckoutpaymentinfowrapper');
    if (!(shippingMethodsList instanceof Element) || !(shippingAddressWrapper instanceof Element) || !(billingAddressWrapper instanceof Element) || !(billingAddressToggle instanceof HTMLInputElement) || !(paymentInfoWrapper instanceof Element)) {
        return;
    }
    if (data.data && data.data.database && data.data.database.commerceOrder) {
        const { data: { database: { commerceOrder: { availableShippingMethods, statusFlags: { requiresShipping, isFreeOrder, shippingAddressRequiresPostalCode, billingAddressRequiresPostalCode, hasSubscription } } } } } = data;
        const shippingZipField = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_ZIP_FIELD, shippingAddressWrapper);
        if (shippingZipField instanceof HTMLInputElement) {
            shippingZipField.required = shippingAddressRequiresPostalCode;
        }
        const billingZipField = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_ZIP_FIELD, billingAddressWrapper);
        if (billingZipField instanceof HTMLInputElement) {
            billingZipField.required = billingAddressRequiresPostalCode;
        }
        const paypalElement = document.querySelector(`[${_constants.PAYPAL_ELEMENT_INSTANCE}]`);
        const paypalButton = checkout.querySelector(`[${_constants.PAYPAL_BUTTON_ELEMENT_INSTANCE}]`);
        if (paypalElement && paypalButton) {
            if (isFreeOrder || hasSubscription) {
                // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
                (0, _commerceUtils.hideElement)(paypalButton);
            } else {
                // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
                (0, _commerceUtils.showElement)(paypalButton);
            }
        }
        // Edge case: need to make sure if billing address is hidden because of default "same as shipping" checked, but
        // toggle itself is hidden because doesn't require shipping, the billing address is still visible
        if (!requiresShipping && billingAddressToggle.checked && billingAddressToggle.parentElement && billingAddressToggle.parentElement.classList.contains('w-condition-invisible')) {
            (0, _commerceUtils.showElement)(billingAddressWrapper);
        }
        if (!availableShippingMethods || availableShippingMethods.length < 1) {
            (0, _commerceUtils.hideElement)(shippingMethodsList);
            // TODO: remove this ugliness when we've properly constrained & restructured the checkout form
            // It is possible to remove the empty state so we can't return early, but don't want to crash here
            if (shippingMethodsEmpty instanceof Element) {
                (0, _commerceUtils.showElement)(shippingMethodsEmpty);
            }
        } else {
            // TODO remove after migration
            if (shippingMethodsEmpty instanceof Element) {
                (0, _commerceUtils.hideElement)(shippingMethodsEmpty);
            }
            (0, _commerceUtils.showElement)(shippingMethodsList);
        }
        if (isFreeOrder) {
            // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
            (0, _commerceUtils.hideElement)(paymentInfoWrapper);
        } else if (!isFreeOrder && // @ts-expect-error - TS2339 - Property 'style' does not exist on type 'Element'.
        paymentInfoWrapper.style.getPropertyValue('display') === 'none') {
            // was previously hidden
            // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
            (0, _commerceUtils.showElement)(paymentInfoWrapper);
        }
    } else {
        (0, _commerceUtils.hideElement)(shippingMethodsList);
        // TODO remove after migration
        if (shippingMethodsEmpty instanceof Element) {
            (0, _commerceUtils.showElement)(shippingMethodsEmpty);
        }
        // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
        (0, _commerceUtils.showElement)(paymentInfoWrapper);
    }
    if (data.errors.length === 0 && prevFocusedInput) {
        let prevFocusedInputEle = document.getElementById(prevFocusedInput);
        if (!prevFocusedInputEle) {
            prevFocusedInputEle = document.querySelector(`[data-wf-bindings="${prevFocusedInput}"]`);
        }
        if (prevFocusedInputEle) {
            prevFocusedInputEle.focus();
        }
    }
};
const runRenderOnCheckoutElement = (checkoutFormContainer, data, errors, stripeStore, prevFocusedInput)=>{
    renderCheckout(checkoutFormContainer, {
        ...data,
        errors: errors.concat(data.error).filter(Boolean)
    }, prevFocusedInput);
    if (stripeStore) {
        (0, _webPaymentsEvents.updateWebPaymentsButton)(checkoutFormContainer, data, stripeStore);
    }
};
const renderCheckoutFormContainers = (checkoutFormContainers, errors, apolloClient, stripeStore, prevFocusedInput)=>{
    if (checkoutFormContainers.length === 0) {
        return;
    }
    checkoutFormContainers.forEach((checkoutFormContainer)=>{
        const queryOptions = {
            query: (0, _graphqltag.default)`
        ${checkoutFormContainer.getAttribute(_constants.CHECKOUT_QUERY)}
      `,
            fetchPolicy: 'network-only',
            // errorPolicy is set to `all` so that we continue to get the cart data when an error occurs
            // this is important in cases like when the address entered doesn't have a shipping zone, as that returns
            // a graphQL error, but we still want to render what the customer has entered
            errorPolicy: 'all'
        };
        apolloClient.query(queryOptions).then((data)=>{
            if (data.data && // @ts-expect-error - TS2339: Property database does not exist on type {}
            data.data.database && // @ts-expect-error - TS2339: Property database does not exist on type {}
            data.data.database.commerceOrder && // @ts-expect-error - TS2339: Property database does not exist on type {}
            data.data.database.commerceOrder.availableShippingMethods) {
                const { data: { // @ts-expect-error - TS2339: Property database does not exist on type {}
                database: { commerceOrder: { availableShippingMethods, statusFlags: { requiresShipping } } } } } = data;
                const selectedMethod = availableShippingMethods.find(// @ts-expect-error - TS7006 - Parameter 'method' implicitly has an 'any' type.
                (method)=>method.selected === true);
                if (!selectedMethod && requiresShipping) {
                    const id = availableShippingMethods[0] ? availableShippingMethods[0].id : null;
                    return createOrderShippingMethodMutation(apolloClient, id).then(()=>{
                        return createRecalcOrderEstimationsMutation(apolloClient);
                    }).then(()=>{
                        return apolloClient.query(queryOptions);
                    }).then((newData)=>{
                        runRenderOnCheckoutElement(checkoutFormContainer, newData, errors, stripeStore, prevFocusedInput);
                    });
                }
            }
            if (data.data && // @ts-expect-error - TS2339: Property database does not exist on type {}
            data.data.database && // @ts-expect-error - TS2339: Property database does not exist on type {}
            data.data.database.commerceOrder && // @ts-expect-error - TS2339: Property database does not exist on type {}
            data.data.database.commerceOrder.statusFlags && // @ts-expect-error - TS2339: Property database does not exist on type {}
            data.data.database.commerceOrder.statusFlags.shouldRecalc) {
                return createRecalcOrderEstimationsMutation(apolloClient).then(()=>{
                    return apolloClient.query(queryOptions);
                }).then((newData)=>{
                    runRenderOnCheckoutElement(checkoutFormContainer, newData, errors, stripeStore, prevFocusedInput);
                });
            } else {
                runRenderOnCheckoutElement(checkoutFormContainer, data, errors, stripeStore, prevFocusedInput);
            }
        }).catch((err)=>{
            errors.push(err);
            renderCheckout(checkoutFormContainer, {
                errors
            }, prevFocusedInput);
        });
    });
};
const createAttemptSubmitOrderRequest = (apolloClient, variables)=>{
    return apolloClient.mutate({
        mutation: _checkoutMutations.attemptSubmitOrderMutation,
        variables
    });
};
const getOrderDataFromGraphQLResponse = (data)=>{
    return data && data.data && data.data.ecommerceAttemptSubmitOrder;
};
const orderRequiresAdditionalAction = (status)=>status === _constants.REQUIRES_ACTION;
const redirectToOrderConfirmation = (order, isPayPal = false)=>{
    const redirectUrl = `/order-confirmation?orderId=${order.orderId}&token=${order.token}`;
    if (isPayPal) {
        const message = {
            isWebflow: true,
            type: 'success',
            detail: redirectUrl
        };
        window.parent.postMessage(JSON.stringify(message), window.location.origin);
    } else {
        window.location.href = redirectUrl;
    }
};
const applyDiscount = (apolloClient, variables)=>{
    return apolloClient.mutate({
        mutation: _checkoutMutations.applyDiscountMutation,
        variables
    });
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNoZWNrb3V0VXRpbHMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiLyogZ2xvYmFscyB3aW5kb3csIGRvY3VtZW50LCBIVE1MSW5wdXRFbGVtZW50ICovXG5pbXBvcnQge0Fwb2xsb0NsaWVudCwgQ29tYmluZWRHcmFwaFFMRXJyb3JzfSBmcm9tICdAYXBvbGxvL2NsaWVudCc7XG5pbXBvcnQgZ3FsIGZyb20gJ2dyYXBocWwtdGFnJztcbmltcG9ydCB7XG4gIHNhZmVQYXJzZUpzb24sXG4gIGZpbmRDbG9zZXN0RWxlbWVudEJ5Tm9kZVR5cGUsXG4gIGZpbmRBbGxFbGVtZW50c0J5Tm9kZVR5cGUsXG4gIGZpbmRFbGVtZW50QnlOb2RlVHlwZSxcbiAgc2hvd0VsZW1lbnQsXG4gIGhpZGVFbGVtZW50LFxufSBmcm9tICcuL2NvbW1lcmNlVXRpbHMnO1xuaW1wb3J0IFN0eWxlTWFwT2JzZXJ2ZXIsIHtBcHBsaWVkU3R5bGVzTWFwfSBmcm9tICcuLi9TdHlsZU1hcE9ic2VydmVyJztcbmltcG9ydCB7U3RyaXBlU3RvcmV9IGZyb20gJy4vc3RyaXBlU3RvcmUnO1xuaW1wb3J0IHtcbiAgTk9ERV9UWVBFX0NPTU1FUkNFX0NIRUNLT1VUX0VSUk9SX1NUQVRFLFxuICBOT0RFX1RZUEVfQ09NTUVSQ0VfQ0hFQ0tPVVRfRk9STV9DT05UQUlORVIsXG4gIE5PREVfVFlQRV9DT01NRVJDRV9DQVJUX1dSQVBQRVIsXG4gIE5PREVfVFlQRV9DT01NRVJDRV9DSEVDS09VVF9TSElQUElOR19NRVRIT0RTX0xJU1QsXG4gIE5PREVfVFlQRV9DT01NRVJDRV9DSEVDS09VVF9TSElQUElOR19NRVRIT0RTX0VNUFRZX1NUQVRFLFxuICBOT0RFX1RZUEVfQ09NTUVSQ0VfQ0hFQ0tPVVRfU0hJUFBJTkdfQUREUkVTU19XUkFQUEVSLFxuICBOT0RFX1RZUEVfQ09NTUVSQ0VfQ0hFQ0tPVVRfU0hJUFBJTkdfQUREUkVTU19aSVBfRklFTEQsXG4gIE5PREVfVFlQRV9DT01NRVJDRV9DSEVDS09VVF9CSUxMSU5HX0FERFJFU1NfV1JBUFBFUixcbiAgTk9ERV9UWVBFX0NPTU1FUkNFX0NIRUNLT1VUX0JJTExJTkdfQUREUkVTU19UT0dHTEVfQ0hFQ0tCT1gsXG4gIE5PREVfVFlQRV9DT01NRVJDRV9DSEVDS09VVF9CSUxMSU5HX0FERFJFU1NfWklQX0ZJRUxELFxuICBDSEVDS09VVF9FUlJPUlMsXG4gIENIRUNLT1VUX1FVRVJZLFxuICBTVFJJUEVfRUxFTUVOVF9JTlNUQU5DRSxcbiAgU1RSSVBFX0VMRU1FTlRfVFlQRSxcbiAgU1RSSVBFX0VMRU1FTlRfU1RZTEUsXG4gIGdldENoZWNrb3V0RXJyb3JNZXNzYWdlRm9yVHlwZSxcbiAgUkVRVUlSRVNfQUNUSU9OLFxuICBORUVEU19SRUZSRVNILFxuICBDQVJUX0NIRUNLT1VUX0VSUk9SX01FU1NBR0VfU0VMRUNUT1IsXG4gIFBBWVBBTF9FTEVNRU5UX0lOU1RBTkNFLFxuICBQQVlQQUxfQlVUVE9OX0VMRU1FTlRfSU5TVEFOQ0UsXG59IGZyb20gJ0BwYWNrYWdlcy9zeXN0ZW1zL2NvbW1lcmNlL2NvbnN0YW50cyc7XG5pbXBvcnQge3JlbmRlclRyZWV9IGZyb20gJy4vcmVuZGVyaW5nJztcbmltcG9ydCB7dXBkYXRlV2ViUGF5bWVudHNCdXR0b259IGZyb20gJy4vd2ViUGF5bWVudHNFdmVudHMnO1xuaW1wb3J0IHtcbiAgdXBkYXRlT3JkZXJTaGlwcGluZ01ldGhvZE11dGF0aW9uLFxuICByZWNhbGNPcmRlckVzdGltYXRpb25zTXV0YXRpb24sXG4gIGF0dGVtcHRTdWJtaXRPcmRlck11dGF0aW9uLFxuICB1cGRhdGVPcmRlcklkZW50aXR5TXV0YXRpb24sXG4gIHVwZGF0ZU9yZGVyQWRkcmVzc011dGF0aW9uLFxuICB1cGRhdGVDdXN0b21EYXRhLFxuICB1cGRhdGVPcmRlclN0cmlwZVBheW1lbnRNZXRob2RNdXRhdGlvbixcbiAgdXBkYXRlT2JmdXNjYXRlZE9yZGVyQWRkcmVzc011dGF0aW9uLFxuICBhcHBseURpc2NvdW50TXV0YXRpb24sXG59IGZyb20gJy4vY2hlY2tvdXRNdXRhdGlvbnMnO1xuXG5pbnRlcmZhY2UgQmVmb3JlVW5sb2FkRXZlbnQgZXh0ZW5kcyBFdmVudCB7XG4gIHJldHVyblZhbHVlOiBhbnk7XG59XG5cbmNvbnN0IHN5bmNTdHlsZXNUb1N0cmlwZUVsZW1lbnQgPVxuICAoc3RyaXBlRWxlbWVudDogYW55KSA9PiAoYXBwbGllZFN0eWxlczogdW5kZWZpbmVkIHwgQXBwbGllZFN0eWxlc01hcCkgPT4ge1xuICAgIHN0cmlwZUVsZW1lbnQudXBkYXRlKHtcbiAgICAgIHN0eWxlOiBTdHlsZU1hcE9ic2VydmVyLmFwcGxpZWRTdHlsZXNUb1N0cmlwZUVsZW1lbnRTdHlsZXMoYXBwbGllZFN0eWxlcyksXG4gICAgfSk7XG4gIH07XG5cbmV4cG9ydCBjb25zdCBpbml0aWFsaXplU3RyaXBlRWxlbWVudHMgPSAoc3RvcmU6IFN0cmlwZVN0b3JlKSA9PiB7XG4gIGlmIChcbiAgICB3aW5kb3cuV2ViZmxvdy5lbnYoJ2Rlc2lnbicpIHx8XG4gICAgd2luZG93LldlYmZsb3cuZW52KCdwcmV2aWV3JykgfHxcbiAgICAhc3RvcmUuaXNJbml0aWFsaXplZCgpXG4gICkge1xuICAgIHJldHVybjtcbiAgfVxuXG4gIGNvbnN0IGNoZWNrb3V0Rm9ybUNvbnRhaW5lcnMgPSBmaW5kQWxsRWxlbWVudHNCeU5vZGVUeXBlKFxuICAgIE5PREVfVFlQRV9DT01NRVJDRV9DSEVDS09VVF9GT1JNX0NPTlRBSU5FUlxuICApO1xuICBjb25zdCBjYXJ0V3JhcHBlcnMgPSBmaW5kQWxsRWxlbWVudHNCeU5vZGVUeXBlKFxuICAgIE5PREVfVFlQRV9DT01NRVJDRV9DQVJUX1dSQVBQRVJcbiAgKTtcblxuICBjb25zdCBhbGxTdHJpcGVFbGVtZW50cyA9IFsuLi5jaGVja291dEZvcm1Db250YWluZXJzLCAuLi5jYXJ0V3JhcHBlcnNdO1xuXG4gIGFsbFN0cmlwZUVsZW1lbnRzLmZvckVhY2goKGVsZW1lbnQsIGluZGV4KSA9PiB7XG4gICAgc3RvcmUuY3JlYXRlRWxlbWVudHNJbnN0YW5jZShpbmRleCk7XG4gICAgZWxlbWVudC5zZXRBdHRyaWJ1dGUoU1RSSVBFX0VMRU1FTlRfSU5TVEFOQ0UsIFN0cmluZyhpbmRleCkpO1xuICB9KTtcblxuICBjb25zdCBzdHJpcGVFbGVtZW50cyA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3JBbGwoYFske1NUUklQRV9FTEVNRU5UX1RZUEV9XWApO1xuXG4gIEFycmF5LmZyb20oc3RyaXBlRWxlbWVudHMpLmZvckVhY2goKGVsZW1lbnQpID0+IHtcbiAgICBjb25zdCB0eXBlID0gZWxlbWVudC5nZXRBdHRyaWJ1dGUoU1RSSVBFX0VMRU1FTlRfVFlQRSk7XG4gICAgaWYgKCF0eXBlKSB7XG4gICAgICB0aHJvdyBuZXcgRXJyb3IoJ1N0cmlwZSBlbGVtZW50IG1pc3NpbmcgdHlwZSBzdHJpbmcnKTtcbiAgICB9XG5cbiAgICBjb25zdCBjaGVja291dEZvcm1Db250YWluZXIgPSBmaW5kQ2xvc2VzdEVsZW1lbnRCeU5vZGVUeXBlKFxuICAgICAgTk9ERV9UWVBFX0NPTU1FUkNFX0NIRUNLT1VUX0ZPUk1fQ09OVEFJTkVSLFxuICAgICAgZWxlbWVudFxuICAgICk7XG4gICAgaWYgKCFjaGVja291dEZvcm1Db250YWluZXIpIHtcbiAgICAgIHJldHVybjtcbiAgICB9XG5cbiAgICBjb25zdCBpbmRleCA9IHBhcnNlSW50KFxuICAgICAgLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTMjM0NSAtIEFyZ3VtZW50IG9mIHR5cGUgJ3N0cmluZyB8IG51bGwnIGlzIG5vdCBhc3NpZ25hYmxlIHRvIHBhcmFtZXRlciBvZiB0eXBlICdzdHJpbmcnLlxuICAgICAgY2hlY2tvdXRGb3JtQ29udGFpbmVyLmdldEF0dHJpYnV0ZShTVFJJUEVfRUxFTUVOVF9JTlNUQU5DRSksXG4gICAgICAxMFxuICAgICk7XG5cbiAgICBjb25zdCBlbCA9IHN0b3JlLmNyZWF0ZUVsZW1lbnQodHlwZSwgaW5kZXgsIHtcbiAgICAgIHN0eWxlOiBzYWZlUGFyc2VKc29uKGVsZW1lbnQuZ2V0QXR0cmlidXRlKFNUUklQRV9FTEVNRU5UX1NUWUxFKSB8fCAne30nKSxcbiAgICAgIGNsYXNzZXM6IHtcbiAgICAgICAgZm9jdXM6ICctd2ZwLWZvY3VzJyxcbiAgICAgIH0sXG4gICAgfSk7XG4gICAgZWwubW91bnQoZWxlbWVudCk7XG4gICAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIHVudXNlZC1pbXBvcnRzL25vLXVudXNlZC12YXJzLCB1bnVzZWQtaW1wb3J0cy9uby11bnVzZWQtdmFyc1xuICAgIGNvbnN0IHN0eWxlTWFwT2JzZXJ2ZXIgPSBuZXcgU3R5bGVNYXBPYnNlcnZlcihlbGVtZW50LCB7XG4gICAgICBvbkNoYW5nZTogc3luY1N0eWxlc1RvU3RyaXBlRWxlbWVudChlbCksXG4gICAgfSk7XG4gIH0pO1xufTtcblxuY29uc3QgZXJyb3JDb2RlVG9DaGVja291dEVycm9yVHlwZSA9IChjb2RlPzogc3RyaW5nLCBtc2c/OiBzdHJpbmcpID0+IHtcbiAgc3dpdGNoIChjb2RlKSB7XG4gICAgY2FzZSAnT3JkZXJUb3RhbFJhbmdlJzpcbiAgICAgIGlmIChtc2cgJiYgbXNnLm1hdGNoKC90b28gc21hbGwvaSkpIHtcbiAgICAgICAgcmV0dXJuICdtaW5pbXVtJztcbiAgICAgIH0gZWxzZSB7XG4gICAgICAgIHJldHVybiAnaW5mbyc7XG4gICAgICB9XG4gICAgY2FzZSAnT3JkZXJFeHRyYXNDaGFuZ2VkJzpcbiAgICAgIHJldHVybiAnZXh0cmFzJztcbiAgICBjYXNlICdQcmljZUNoYW5nZWQnOlxuICAgICAgcmV0dXJuICdwcmljaW5nJztcbiAgICBjYXNlICdTdHJpcGVSZWplY3RlZCc6XG4gICAgICByZXR1cm4gJ2JpbGxpbmcnO1xuICAgIGNhc2UgJ05lZWRTaGlwcGluZ0FkZHJlc3MnOlxuICAgIGNhc2UgJ0ludmFsaWRTaGlwcGluZ0FkZHJlc3MnOlxuICAgIGNhc2UgJ05lZWRTaGlwcGluZ01ldGhvZCc6XG4gICAgICByZXR1cm4gJ3NoaXBwaW5nJztcbiAgICBjYXNlICdOZWVkUGF5bWVudE1ldGhvZCc6XG4gICAgY2FzZSAnU3RyaXBlRmFpbHVyZSc6XG4gICAgICByZXR1cm4gJ3BheW1lbnQnO1xuICAgIGNhc2UgJ0l0ZW1Ob3RGb3VuZCc6XG4gICAgICByZXR1cm4gJ3Byb2R1Y3QnO1xuICAgIC8vICdJbnZhbGlkRGlzY291bnQnIGhhcyBiZWVuIHJlbmFtZWQgdG8gJ0Rpc2NvdW50SW52YWxpZCcsIGJ1dCBpdCBuZWVkc1xuICAgIC8vIHRvIGJlIGxpc3RlZCBoZXJlIHRvIHN1cHBvcnQgc2l0ZXMgdGhhdCBoYXZlbid0IGJlZW4gcHVibGlzaGVkIHNpbmNlIHRoaXMgY2hhbmdlLlxuICAgIGNhc2UgJ0ludmFsaWREaXNjb3VudCc6XG4gICAgY2FzZSAnRGlzY291bnRJbnZhbGlkJzpcbiAgICBjYXNlICdEaXNjb3VudERvZXNOb3RFeGlzdCc6IHtcbiAgICAgIHJldHVybiAnaW52YWxpZC1kaXNjb3VudCc7XG4gICAgfVxuICAgIGNhc2UgJ0Rpc2NvdW50RXhwaXJlZCc6IHtcbiAgICAgIHJldHVybiAnZXhwaXJlZC1kaXNjb3VudCc7XG4gICAgfVxuICAgIGNhc2UgJ0Rpc2NvdW50VXNhZ2VSZWFjaGVkJzoge1xuICAgICAgcmV0dXJuICd1c2FnZS1yZWFjaGVkLWRpc2NvdW50JztcbiAgICB9XG4gICAgY2FzZSAnRGlzY291bnRSZXF1aXJlbWVudHNOb3RNZXQnOiB7XG4gICAgICByZXR1cm4gJ3JlcXVpcmVtZW50cy1ub3QtbWV0JztcbiAgICB9XG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiAnaW5mbyc7XG4gIH1cbn07XG5cbmNvbnN0IGdldEVycm9yVHlwZSA9IChlcnJvcjogUmVjb3JkPGFueSwgYW55PikgPT4ge1xuICBpZiAoQ29tYmluZWRHcmFwaFFMRXJyb3JzLmlzKGVycm9yKSAmJiBlcnJvci5lcnJvcnMubGVuZ3RoID4gMCkge1xuICAgIGNvbnN0IGVycm9yQ29kZSA9IGVycm9yLmVycm9yc1swXT8uZXh0ZW5zaW9ucz8uY29kZTtcbiAgICBjb25zdCBlcnJvck1lc3NhZ2UgPSBlcnJvci5lcnJvcnNbMF0/Lm1lc3NhZ2U7XG4gICAgcmV0dXJuIGVycm9yQ29kZVRvQ2hlY2tvdXRFcnJvclR5cGUoXG4gICAgICB0eXBlb2YgZXJyb3JDb2RlID09PSAnc3RyaW5nJyA/IGVycm9yQ29kZSA6IHVuZGVmaW5lZCxcbiAgICAgIGVycm9yTWVzc2FnZVxuICAgICk7XG4gIH1cblxuICBpZiAoZXJyb3IuY29kZSkge1xuICAgIHJldHVybiBlcnJvckNvZGVUb0NoZWNrb3V0RXJyb3JUeXBlKGVycm9yLmNvZGUsIGVycm9yLm1lc3NhZ2UpO1xuICB9XG5cbiAgcmV0dXJuICdpbmZvJztcbn07XG5cbmV4cG9ydCBjb25zdCB1cGRhdGVFcnJvck1lc3NhZ2UgPSAoXG4gIGVsZW1lbnQ6IEVsZW1lbnQsXG4gIGVycm9yOiBSZWNvcmQ8YW55LCBhbnk+XG4pID0+IHtcbiAgY29uc3QgZXJyb3JUZXh0ID0gZWxlbWVudC5xdWVyeVNlbGVjdG9yKENBUlRfQ0hFQ0tPVVRfRVJST1JfTUVTU0FHRV9TRUxFQ1RPUik7XG4gIGlmICghZXJyb3JUZXh0KSB7XG4gICAgcmV0dXJuO1xuICB9XG5cbiAgLy8gSGFuZGxlIFN0cmlwZS5qcyBjbGllbnQtc2lkZSBlcnJvcnMuIFdlIHVzZSBTdHJpcGUuanMncyBlcnJvciBtZXNzYWdlXG4gIC8vIGFzIHRoaXMgZXJyb3IgdHlwaWNhbGx5IGluZGljYXRlcyB0aGF0IHRoZSB1c2VyIGZvcmdvdCB0byBlbnRlciBwYXJ0IG9mXG4gIC8vIHRoZWlyIENDLCBvciBlbnRlcmVkIGludmFsaWQgZGF0YS4gVGhlIG1vcmUgc3BlY2lmaWMgdGhlIGVycm9yLCB0aGUgbW9yZVxuICAvLyBoZWxwZnVsIGl0IHdpbGwgYmUgZm9yIHRoZSB1c2VyLlxuICBpZiAoZXJyb3IudHlwZSAmJiBlcnJvci50eXBlID09PSAndmFsaWRhdGlvbl9lcnJvcicpIHtcbiAgICBlcnJvclRleHQudGV4dENvbnRlbnQgPSBlcnJvci5tZXNzYWdlO1xuICAgIHJldHVybjtcbiAgfVxuXG4gIGNvbnN0IGVycm9yVHlwZSA9IGdldEVycm9yVHlwZShlcnJvcik7XG5cbiAgLy8gR2V0IHRoZSBkZWZhdWx0IGVycm9yIG1lc3NhZ2UgaW5jYXNlIHRoZSBub2RlIGRvZXMgbm90IGhhdmUgdGhlIGVycm9yIGF0dHJpYnV0ZSB5ZXQuXG4gIGNvbnN0IGVycm9yRGF0YSA9XG4gICAgLy8gQHRzLWV4cGVjdC1lcnJvciBFbGVtZW50IGltcGxpY2l0bHkgaGFzIGFuICdhbnknIHR5cGUgYmVjYXVzZSBleHByZXNzaW9uIG9mIHR5cGUgJ3N0cmluZycgY2FuJ3QgYmUgdXNlZCB0byBpbmRleCB0eXBlICd7Li4ufSdcbiAgICBDSEVDS09VVF9FUlJPUlNbZXJyb3JUeXBlLnRvVXBwZXJDYXNlKCkucmVwbGFjZSgvXFxXL2csICdfJyldIHx8IHt9O1xuICBjb25zdCBkZWZhdWx0RXJyb3JNZXNzYWdlID0gZXJyb3JEYXRhLmNvcHk7XG5cbiAgY29uc3QgZXJyb3JNZXNzYWdlID1cbiAgICBlcnJvclRleHQuZ2V0QXR0cmlidXRlKGdldENoZWNrb3V0RXJyb3JNZXNzYWdlRm9yVHlwZShlcnJvclR5cGUpKSB8fFxuICAgIGRlZmF1bHRFcnJvck1lc3NhZ2U7XG5cbiAgZXJyb3JUZXh0LnRleHRDb250ZW50ID0gZXJyb3JNZXNzYWdlO1xuXG4gIGlmIChlcnJvckRhdGEucmVxdWlyZXNSZWZyZXNoKSB7XG4gICAgZXJyb3JUZXh0LnNldEF0dHJpYnV0ZShORUVEU19SRUZSRVNILCAndHJ1ZScpO1xuICB9IGVsc2Uge1xuICAgIGVycm9yVGV4dC5yZW1vdmVBdHRyaWJ1dGUoTkVFRFNfUkVGUkVTSCk7XG4gIH1cblxuICBpZiAoZXJyb3JUeXBlID09PSAnc2hpcHBpbmcnKSB7XG4gICAgdXBkYXRlUmVxdWlyZWRGaWVsZHMoZXJyb3IpO1xuICB9XG59O1xuXG5jb25zdCBlbGVtZW50TmFtZUJ5R3JhcGhRTEVycm9yID0ge1xuICBNSVNTSU5HX1NUQVRFOiAnYWRkcmVzc19zdGF0ZScsXG59IGFzIGNvbnN0O1xuXG5jb25zdCB1cGRhdGVSZXF1aXJlZEZpZWxkcyA9IChlcnJvcjogYW55KSA9PiB7XG4gIGlmICghQ29tYmluZWRHcmFwaFFMRXJyb3JzLmlzKGVycm9yKSB8fCBlcnJvci5lcnJvcnMubGVuZ3RoID09PSAwKSB7XG4gICAgcmV0dXJuO1xuICB9XG5cbiAgY29uc3QgaW52YWxpZFNoaXBwaW5nQWRkcmVzc0Vycm9yID0gZXJyb3IuZXJyb3JzLmZpbmQoXG4gICAgKGdxbEVycm9yKSA9PlxuICAgICAgJ2NvZGUnIGluIGdxbEVycm9yICYmIGdxbEVycm9yLmNvZGUgPT09ICdJbnZhbGlkU2hpcHBpbmdBZGRyZXNzJ1xuICApO1xuXG4gIGlmICghaW52YWxpZFNoaXBwaW5nQWRkcmVzc0Vycm9yKSB7XG4gICAgcmV0dXJuO1xuICB9XG5cbiAgLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTNzAwNiAtIFBhcmFtZXRlciAncHJvYmxlbScgaW1wbGljaXRseSBoYXMgYW4gJ2FueScgdHlwZS5cbiAgaW52YWxpZFNoaXBwaW5nQWRkcmVzc0Vycm9yLnByb2JsZW1zLmZvckVhY2goKHByb2JsZW0pID0+IHtcbiAgICBjb25zdCB7dHlwZX0gPSBwcm9ibGVtO1xuXG4gICAgLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTNzA1MyAtIEVsZW1lbnQgaW1wbGljaXRseSBoYXMgYW4gJ2FueScgdHlwZSBiZWNhdXNlIGV4cHJlc3Npb24gb2YgdHlwZSAnYW55JyBjYW4ndCBiZSB1c2VkIHRvIGluZGV4IHR5cGUgJ3sgcmVhZG9ubHkgTUlTU0lOR19TVEFURTogXCJhZGRyZXNzX3N0YXRlXCI7IH0nLlxuICAgIGNvbnN0IGVsZW1lbnROYW1lID0gZWxlbWVudE5hbWVCeUdyYXBoUUxFcnJvclt0eXBlXTtcblxuICAgIGlmICghZWxlbWVudE5hbWUpIHtcbiAgICAgIHJldHVybjtcbiAgICB9XG5cbiAgICBjb25zdCBlbGVtZW50ID0gZG9jdW1lbnQuZ2V0RWxlbWVudHNCeU5hbWUoZWxlbWVudE5hbWUpWzBdO1xuXG4gICAgaWYgKCEoZWxlbWVudCBpbnN0YW5jZW9mIEhUTUxJbnB1dEVsZW1lbnQpKSB7XG4gICAgICByZXR1cm47XG4gICAgfVxuXG4gICAgZWxlbWVudC5yZXF1aXJlZCA9IHRydWU7XG5cbiAgICAvLyBJRTExIGRvZXNuJ3Qgc3VwcG9ydCB0aGUgcmVwb3J0VmFsaWRpdHkgQVBJXG4gICAgaWYgKHR5cGVvZiBlbGVtZW50LnJlcG9ydFZhbGlkaXR5ID09PSAnZnVuY3Rpb24nKSB7XG4gICAgICBlbGVtZW50LnJlcG9ydFZhbGlkaXR5KCk7XG4gICAgfVxuICB9KTtcbn07XG5cbmV4cG9ydCBjb25zdCBzaG93RXJyb3JNZXNzYWdlRm9yRXJyb3IgPSAoXG4gIGVycjogRXJyb3IsXG4gIHNjb3BlPzogRWxlbWVudCB8IERvY3VtZW50XG4pID0+IHtcbiAgY29uc3QgZXJyb3JTdGF0ZSA9IGZpbmRFbGVtZW50QnlOb2RlVHlwZShcbiAgICBOT0RFX1RZUEVfQ09NTUVSQ0VfQ0hFQ0tPVVRfRVJST1JfU1RBVEUsXG4gICAgc2NvcGVcbiAgKTtcbiAgaWYgKGVycm9yU3RhdGUpIHtcbiAgICBlcnJvclN0YXRlLnN0eWxlLnJlbW92ZVByb3BlcnR5KCdkaXNwbGF5Jyk7XG4gICAgdXBkYXRlRXJyb3JNZXNzYWdlKGVycm9yU3RhdGUsIGVycik7XG4gIH1cbn07XG5cbmV4cG9ydCBjb25zdCBiZWZvcmVVbmxvYWRIYW5kbGVyID0gKGU6IEJlZm9yZVVubG9hZEV2ZW50KSA9PiB7XG4gIGUucHJldmVudERlZmF1bHQoKTtcbiAgZS5yZXR1cm5WYWx1ZSA9ICcnO1xufTtcblxuZXhwb3J0IGNvbnN0IGNyZWF0ZU9yZGVySWRlbnRpdHlNdXRhdGlvbiA9IChcbiAgYXBvbGxvQ2xpZW50OiBBcG9sbG9DbGllbnQsXG4gIGVtYWlsOiBzdHJpbmcgfCBudWxsXG4pID0+XG4gIGFwb2xsb0NsaWVudC5tdXRhdGUoe1xuICAgIG11dGF0aW9uOiB1cGRhdGVPcmRlcklkZW50aXR5TXV0YXRpb24sXG4gICAgdmFyaWFibGVzOiB7ZW1haWx9LFxuICB9KTtcblxuZXhwb3J0IGNvbnN0IGNyZWF0ZU9yZGVyQWRkcmVzc011dGF0aW9uID0gKFxuICBhcG9sbG9DbGllbnQ6IEFwb2xsb0NsaWVudCxcbiAgYWRkcmVzc0luZm86IFJlY29yZDxhbnksIGFueT5cbikgPT5cbiAgYXBvbGxvQ2xpZW50Lm11dGF0ZSh7XG4gICAgbXV0YXRpb246IHVwZGF0ZU9yZGVyQWRkcmVzc011dGF0aW9uLFxuICAgIHZhcmlhYmxlczogYWRkcmVzc0luZm8sXG4gIH0pO1xuXG5leHBvcnQgY29uc3QgY3JlYXRlT3JkZXJTaGlwcGluZ01ldGhvZE11dGF0aW9uID0gKFxuICBhcG9sbG9DbGllbnQ6IEFwb2xsb0NsaWVudCxcbiAgaWQ6IHN0cmluZyB8IG51bGxcbikgPT5cbiAgYXBvbGxvQ2xpZW50Lm11dGF0ZSh7XG4gICAgbXV0YXRpb246IHVwZGF0ZU9yZGVyU2hpcHBpbmdNZXRob2RNdXRhdGlvbixcbiAgICB2YXJpYWJsZXM6IHtpZH0sXG4gIH0pO1xuXG5leHBvcnQgY29uc3QgY3JlYXRlQ3VzdG9tRGF0YU11dGF0aW9uID0gKFxuICBhcG9sbG9DbGllbnQ6IEFwb2xsb0NsaWVudCxcbiAgY3VzdG9tRGF0YTogW11cbikgPT5cbiAgYXBvbGxvQ2xpZW50Lm11dGF0ZSh7XG4gICAgbXV0YXRpb246IHVwZGF0ZUN1c3RvbURhdGEsXG4gICAgdmFyaWFibGVzOiB7Y3VzdG9tRGF0YX0sXG4gIH0pO1xuXG5leHBvcnQgY29uc3QgY3JlYXRlU3RyaXBlUGF5bWVudE1ldGhvZE11dGF0aW9uID0gKFxuICBhcG9sbG9DbGllbnQ6IEFwb2xsb0NsaWVudCxcbiAgaWQ6IHN0cmluZ1xuKSA9PlxuICBhcG9sbG9DbGllbnQubXV0YXRlKHtcbiAgICBtdXRhdGlvbjogdXBkYXRlT3JkZXJTdHJpcGVQYXltZW50TWV0aG9kTXV0YXRpb24sXG4gICAgdmFyaWFibGVzOiB7XG4gICAgICBwYXltZW50TWV0aG9kOiBpZCxcbiAgICB9LFxuICB9KTtcblxuZXhwb3J0IGNvbnN0IGNyZWF0ZVJlY2FsY09yZGVyRXN0aW1hdGlvbnNNdXRhdGlvbiA9IChcbiAgYXBvbGxvQ2xpZW50OiBBcG9sbG9DbGllbnRcbikgPT5cbiAgYXBvbGxvQ2xpZW50Lm11dGF0ZSh7XG4gICAgbXV0YXRpb246IHJlY2FsY09yZGVyRXN0aW1hdGlvbnNNdXRhdGlvbixcbiAgICBlcnJvclBvbGljeTogJ2lnbm9yZScsXG4gIH0pO1xuXG5leHBvcnQgY29uc3QgY3JlYXRlVXBkYXRlT2JmdXNjYXRlZE9yZGVyQWRkcmVzc011dGF0aW9uID0gKFxuICBhcG9sbG9DbGllbnQ6IEFwb2xsb0NsaWVudCxcbiAgYWRkcmVzc0luZm86IFJlY29yZDxhbnksIGFueT5cbikgPT5cbiAgYXBvbGxvQ2xpZW50Lm11dGF0ZSh7XG4gICAgbXV0YXRpb246IHVwZGF0ZU9iZnVzY2F0ZWRPcmRlckFkZHJlc3NNdXRhdGlvbixcbiAgICB2YXJpYWJsZXM6IGFkZHJlc3NJbmZvLFxuICB9KTtcblxuY29uc3QgcmVuZGVyQ2hlY2tvdXQgPSAoXG4gIGNoZWNrb3V0OiBFbGVtZW50LFxuICBkYXRhOiBSZWNvcmQ8YW55LCBhbnk+LFxuICBwcmV2Rm9jdXNlZElucHV0OiBzdHJpbmcgfCBudWxsXG4pID0+IHtcbiAgcmVuZGVyVHJlZShjaGVja291dCwgZGF0YSk7XG5cbiAgY29uc3Qgc2hpcHBpbmdNZXRob2RzTGlzdCA9IGZpbmRFbGVtZW50QnlOb2RlVHlwZShcbiAgICBOT0RFX1RZUEVfQ09NTUVSQ0VfQ0hFQ0tPVVRfU0hJUFBJTkdfTUVUSE9EU19MSVNULFxuICAgIGNoZWNrb3V0XG4gICk7XG4gIGNvbnN0IHNoaXBwaW5nTWV0aG9kc0VtcHR5ID0gZmluZEVsZW1lbnRCeU5vZGVUeXBlKFxuICAgIE5PREVfVFlQRV9DT01NRVJDRV9DSEVDS09VVF9TSElQUElOR19NRVRIT0RTX0VNUFRZX1NUQVRFLFxuICAgIGNoZWNrb3V0XG4gICk7XG4gIGNvbnN0IHNoaXBwaW5nQWRkcmVzc1dyYXBwZXIgPSBmaW5kRWxlbWVudEJ5Tm9kZVR5cGUoXG4gICAgTk9ERV9UWVBFX0NPTU1FUkNFX0NIRUNLT1VUX1NISVBQSU5HX0FERFJFU1NfV1JBUFBFUixcbiAgICBjaGVja291dFxuICApO1xuICBjb25zdCBiaWxsaW5nQWRkcmVzc1dyYXBwZXIgPSBmaW5kRWxlbWVudEJ5Tm9kZVR5cGUoXG4gICAgTk9ERV9UWVBFX0NPTU1FUkNFX0NIRUNLT1VUX0JJTExJTkdfQUREUkVTU19XUkFQUEVSLFxuICAgIGNoZWNrb3V0XG4gICk7XG4gIGNvbnN0IGJpbGxpbmdBZGRyZXNzVG9nZ2xlID0gZmluZEVsZW1lbnRCeU5vZGVUeXBlKFxuICAgIE5PREVfVFlQRV9DT01NRVJDRV9DSEVDS09VVF9CSUxMSU5HX0FERFJFU1NfVE9HR0xFX0NIRUNLQk9YLFxuICAgIGNoZWNrb3V0XG4gICk7XG4gIGNvbnN0IHBheW1lbnRJbmZvV3JhcHBlciA9IGNoZWNrb3V0LnF1ZXJ5U2VsZWN0b3IoXG4gICAgJy53LWNvbW1lcmNlLWNvbW1lcmNlY2hlY2tvdXRwYXltZW50aW5mb3dyYXBwZXInXG4gICk7XG4gIGlmIChcbiAgICAhKHNoaXBwaW5nTWV0aG9kc0xpc3QgaW5zdGFuY2VvZiBFbGVtZW50KSB8fFxuICAgICEoc2hpcHBpbmdBZGRyZXNzV3JhcHBlciBpbnN0YW5jZW9mIEVsZW1lbnQpIHx8XG4gICAgIShiaWxsaW5nQWRkcmVzc1dyYXBwZXIgaW5zdGFuY2VvZiBFbGVtZW50KSB8fFxuICAgICEoYmlsbGluZ0FkZHJlc3NUb2dnbGUgaW5zdGFuY2VvZiBIVE1MSW5wdXRFbGVtZW50KSB8fFxuICAgICEocGF5bWVudEluZm9XcmFwcGVyIGluc3RhbmNlb2YgRWxlbWVudClcbiAgKSB7XG4gICAgcmV0dXJuO1xuICB9XG5cbiAgaWYgKGRhdGEuZGF0YSAmJiBkYXRhLmRhdGEuZGF0YWJhc2UgJiYgZGF0YS5kYXRhLmRhdGFiYXNlLmNvbW1lcmNlT3JkZXIpIHtcbiAgICBjb25zdCB7XG4gICAgICBkYXRhOiB7XG4gICAgICAgIGRhdGFiYXNlOiB7XG4gICAgICAgICAgY29tbWVyY2VPcmRlcjoge1xuICAgICAgICAgICAgYXZhaWxhYmxlU2hpcHBpbmdNZXRob2RzLFxuICAgICAgICAgICAgc3RhdHVzRmxhZ3M6IHtcbiAgICAgICAgICAgICAgcmVxdWlyZXNTaGlwcGluZyxcbiAgICAgICAgICAgICAgaXNGcmVlT3JkZXIsXG4gICAgICAgICAgICAgIHNoaXBwaW5nQWRkcmVzc1JlcXVpcmVzUG9zdGFsQ29kZSxcbiAgICAgICAgICAgICAgYmlsbGluZ0FkZHJlc3NSZXF1aXJlc1Bvc3RhbENvZGUsXG4gICAgICAgICAgICAgIGhhc1N1YnNjcmlwdGlvbixcbiAgICAgICAgICAgIH0sXG4gICAgICAgICAgfSxcbiAgICAgICAgfSxcbiAgICAgIH0sXG4gICAgfSA9IGRhdGE7XG5cbiAgICBjb25zdCBzaGlwcGluZ1ppcEZpZWxkID0gZmluZEVsZW1lbnRCeU5vZGVUeXBlKFxuICAgICAgTk9ERV9UWVBFX0NPTU1FUkNFX0NIRUNLT1VUX1NISVBQSU5HX0FERFJFU1NfWklQX0ZJRUxELFxuICAgICAgc2hpcHBpbmdBZGRyZXNzV3JhcHBlclxuICAgICk7XG4gICAgaWYgKHNoaXBwaW5nWmlwRmllbGQgaW5zdGFuY2VvZiBIVE1MSW5wdXRFbGVtZW50KSB7XG4gICAgICBzaGlwcGluZ1ppcEZpZWxkLnJlcXVpcmVkID0gc2hpcHBpbmdBZGRyZXNzUmVxdWlyZXNQb3N0YWxDb2RlO1xuICAgIH1cblxuICAgIGNvbnN0IGJpbGxpbmdaaXBGaWVsZCA9IGZpbmRFbGVtZW50QnlOb2RlVHlwZShcbiAgICAgIE5PREVfVFlQRV9DT01NRVJDRV9DSEVDS09VVF9CSUxMSU5HX0FERFJFU1NfWklQX0ZJRUxELFxuICAgICAgYmlsbGluZ0FkZHJlc3NXcmFwcGVyXG4gICAgKTtcbiAgICBpZiAoYmlsbGluZ1ppcEZpZWxkIGluc3RhbmNlb2YgSFRNTElucHV0RWxlbWVudCkge1xuICAgICAgYmlsbGluZ1ppcEZpZWxkLnJlcXVpcmVkID0gYmlsbGluZ0FkZHJlc3NSZXF1aXJlc1Bvc3RhbENvZGU7XG4gICAgfVxuXG4gICAgY29uc3QgcGF5cGFsRWxlbWVudCA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IoXG4gICAgICBgWyR7UEFZUEFMX0VMRU1FTlRfSU5TVEFOQ0V9XWBcbiAgICApO1xuICAgIGNvbnN0IHBheXBhbEJ1dHRvbiA9IGNoZWNrb3V0LnF1ZXJ5U2VsZWN0b3IoXG4gICAgICBgWyR7UEFZUEFMX0JVVFRPTl9FTEVNRU5UX0lOU1RBTkNFfV1gXG4gICAgKTtcbiAgICBpZiAocGF5cGFsRWxlbWVudCAmJiBwYXlwYWxCdXR0b24pIHtcbiAgICAgIGlmIChpc0ZyZWVPcmRlciB8fCBoYXNTdWJzY3JpcHRpb24pIHtcbiAgICAgICAgLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTMjM0NSAtIEFyZ3VtZW50IG9mIHR5cGUgJ0VsZW1lbnQnIGlzIG5vdCBhc3NpZ25hYmxlIHRvIHBhcmFtZXRlciBvZiB0eXBlICdIVE1MRWxlbWVudCcuXG4gICAgICAgIGhpZGVFbGVtZW50KHBheXBhbEJ1dHRvbik7XG4gICAgICB9IGVsc2Uge1xuICAgICAgICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFMyMzQ1IC0gQXJndW1lbnQgb2YgdHlwZSAnRWxlbWVudCcgaXMgbm90IGFzc2lnbmFibGUgdG8gcGFyYW1ldGVyIG9mIHR5cGUgJ0hUTUxFbGVtZW50Jy5cbiAgICAgICAgc2hvd0VsZW1lbnQocGF5cGFsQnV0dG9uKTtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAvLyBFZGdlIGNhc2U6IG5lZWQgdG8gbWFrZSBzdXJlIGlmIGJpbGxpbmcgYWRkcmVzcyBpcyBoaWRkZW4gYmVjYXVzZSBvZiBkZWZhdWx0IFwic2FtZSBhcyBzaGlwcGluZ1wiIGNoZWNrZWQsIGJ1dFxuICAgIC8vIHRvZ2dsZSBpdHNlbGYgaXMgaGlkZGVuIGJlY2F1c2UgZG9lc24ndCByZXF1aXJlIHNoaXBwaW5nLCB0aGUgYmlsbGluZyBhZGRyZXNzIGlzIHN0aWxsIHZpc2libGVcbiAgICBpZiAoXG4gICAgICAhcmVxdWlyZXNTaGlwcGluZyAmJlxuICAgICAgYmlsbGluZ0FkZHJlc3NUb2dnbGUuY2hlY2tlZCAmJlxuICAgICAgYmlsbGluZ0FkZHJlc3NUb2dnbGUucGFyZW50RWxlbWVudCAmJlxuICAgICAgYmlsbGluZ0FkZHJlc3NUb2dnbGUucGFyZW50RWxlbWVudC5jbGFzc0xpc3QuY29udGFpbnMoXG4gICAgICAgICd3LWNvbmRpdGlvbi1pbnZpc2libGUnXG4gICAgICApXG4gICAgKSB7XG4gICAgICBzaG93RWxlbWVudChiaWxsaW5nQWRkcmVzc1dyYXBwZXIpO1xuICAgIH1cbiAgICBpZiAoIWF2YWlsYWJsZVNoaXBwaW5nTWV0aG9kcyB8fCBhdmFpbGFibGVTaGlwcGluZ01ldGhvZHMubGVuZ3RoIDwgMSkge1xuICAgICAgaGlkZUVsZW1lbnQoc2hpcHBpbmdNZXRob2RzTGlzdCk7XG4gICAgICAvLyBUT0RPOiByZW1vdmUgdGhpcyB1Z2xpbmVzcyB3aGVuIHdlJ3ZlIHByb3Blcmx5IGNvbnN0cmFpbmVkICYgcmVzdHJ1Y3R1cmVkIHRoZSBjaGVja291dCBmb3JtXG4gICAgICAvLyBJdCBpcyBwb3NzaWJsZSB0byByZW1vdmUgdGhlIGVtcHR5IHN0YXRlIHNvIHdlIGNhbid0IHJldHVybiBlYXJseSwgYnV0IGRvbid0IHdhbnQgdG8gY3Jhc2ggaGVyZVxuICAgICAgaWYgKHNoaXBwaW5nTWV0aG9kc0VtcHR5IGluc3RhbmNlb2YgRWxlbWVudCkge1xuICAgICAgICBzaG93RWxlbWVudChzaGlwcGluZ01ldGhvZHNFbXB0eSk7XG4gICAgICB9XG4gICAgfSBlbHNlIHtcbiAgICAgIC8vIFRPRE8gcmVtb3ZlIGFmdGVyIG1pZ3JhdGlvblxuICAgICAgaWYgKHNoaXBwaW5nTWV0aG9kc0VtcHR5IGluc3RhbmNlb2YgRWxlbWVudCkge1xuICAgICAgICBoaWRlRWxlbWVudChzaGlwcGluZ01ldGhvZHNFbXB0eSk7XG4gICAgICB9XG4gICAgICBzaG93RWxlbWVudChzaGlwcGluZ01ldGhvZHNMaXN0KTtcbiAgICB9XG5cbiAgICBpZiAoaXNGcmVlT3JkZXIpIHtcbiAgICAgIC8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzIzNDUgLSBBcmd1bWVudCBvZiB0eXBlICdFbGVtZW50JyBpcyBub3QgYXNzaWduYWJsZSB0byBwYXJhbWV0ZXIgb2YgdHlwZSAnSFRNTEVsZW1lbnQnLlxuICAgICAgaGlkZUVsZW1lbnQocGF5bWVudEluZm9XcmFwcGVyKTtcbiAgICB9IGVsc2UgaWYgKFxuICAgICAgIWlzRnJlZU9yZGVyICYmXG4gICAgICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFMyMzM5IC0gUHJvcGVydHkgJ3N0eWxlJyBkb2VzIG5vdCBleGlzdCBvbiB0eXBlICdFbGVtZW50Jy5cbiAgICAgIHBheW1lbnRJbmZvV3JhcHBlci5zdHlsZS5nZXRQcm9wZXJ0eVZhbHVlKCdkaXNwbGF5JykgPT09ICdub25lJ1xuICAgICkge1xuICAgICAgLy8gd2FzIHByZXZpb3VzbHkgaGlkZGVuXG4gICAgICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFMyMzQ1IC0gQXJndW1lbnQgb2YgdHlwZSAnRWxlbWVudCcgaXMgbm90IGFzc2lnbmFibGUgdG8gcGFyYW1ldGVyIG9mIHR5cGUgJ0hUTUxFbGVtZW50Jy5cbiAgICAgIHNob3dFbGVtZW50KHBheW1lbnRJbmZvV3JhcHBlcik7XG4gICAgfVxuICB9IGVsc2Uge1xuICAgIGhpZGVFbGVtZW50KHNoaXBwaW5nTWV0aG9kc0xpc3QpO1xuICAgIC8vIFRPRE8gcmVtb3ZlIGFmdGVyIG1pZ3JhdGlvblxuICAgIGlmIChzaGlwcGluZ01ldGhvZHNFbXB0eSBpbnN0YW5jZW9mIEVsZW1lbnQpIHtcbiAgICAgIHNob3dFbGVtZW50KHNoaXBwaW5nTWV0aG9kc0VtcHR5KTtcbiAgICB9XG4gICAgLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTMjM0NSAtIEFyZ3VtZW50IG9mIHR5cGUgJ0VsZW1lbnQnIGlzIG5vdCBhc3NpZ25hYmxlIHRvIHBhcmFtZXRlciBvZiB0eXBlICdIVE1MRWxlbWVudCcuXG4gICAgc2hvd0VsZW1lbnQocGF5bWVudEluZm9XcmFwcGVyKTtcbiAgfVxuXG4gIGlmIChkYXRhLmVycm9ycy5sZW5ndGggPT09IDAgJiYgcHJldkZvY3VzZWRJbnB1dCkge1xuICAgIGxldCBwcmV2Rm9jdXNlZElucHV0RWxlID0gZG9jdW1lbnQuZ2V0RWxlbWVudEJ5SWQocHJldkZvY3VzZWRJbnB1dCk7XG4gICAgaWYgKCFwcmV2Rm9jdXNlZElucHV0RWxlKSB7XG4gICAgICBwcmV2Rm9jdXNlZElucHV0RWxlID0gZG9jdW1lbnQucXVlcnlTZWxlY3RvcihcbiAgICAgICAgYFtkYXRhLXdmLWJpbmRpbmdzPVwiJHtwcmV2Rm9jdXNlZElucHV0fVwiXWBcbiAgICAgICk7XG4gICAgfVxuICAgIGlmIChwcmV2Rm9jdXNlZElucHV0RWxlKSB7XG4gICAgICBwcmV2Rm9jdXNlZElucHV0RWxlLmZvY3VzKCk7XG4gICAgfVxuICB9XG59O1xuXG5jb25zdCBydW5SZW5kZXJPbkNoZWNrb3V0RWxlbWVudCA9IChcbiAgY2hlY2tvdXRGb3JtQ29udGFpbmVyOiBFbGVtZW50LFxuICBkYXRhOiBSZWNvcmQ8YW55LCBhbnk+LFxuICBlcnJvcnM6IEFycmF5PGFueT4sXG4gIHN0cmlwZVN0b3JlOiBTdHJpcGVTdG9yZSB8IG51bGwgfCB1bmRlZmluZWQsXG4gIHByZXZGb2N1c2VkSW5wdXQ6IHN0cmluZyB8IG51bGxcbikgPT4ge1xuICByZW5kZXJDaGVja291dChcbiAgICBjaGVja291dEZvcm1Db250YWluZXIsXG4gICAge1xuICAgICAgLi4uZGF0YSxcbiAgICAgIGVycm9yczogZXJyb3JzLmNvbmNhdChkYXRhLmVycm9yKS5maWx0ZXIoQm9vbGVhbiksXG4gICAgfSxcbiAgICBwcmV2Rm9jdXNlZElucHV0XG4gICk7XG5cbiAgaWYgKHN0cmlwZVN0b3JlKSB7XG4gICAgdXBkYXRlV2ViUGF5bWVudHNCdXR0b24oY2hlY2tvdXRGb3JtQ29udGFpbmVyLCBkYXRhLCBzdHJpcGVTdG9yZSk7XG4gIH1cbn07XG5cbmV4cG9ydCBjb25zdCByZW5kZXJDaGVja291dEZvcm1Db250YWluZXJzID0gKFxuICBjaGVja291dEZvcm1Db250YWluZXJzOiBBcnJheTxIVE1MRWxlbWVudD4sXG4gIGVycm9yczogQXJyYXk8YW55PixcbiAgYXBvbGxvQ2xpZW50OiBBcG9sbG9DbGllbnQsXG4gIHN0cmlwZVN0b3JlOiBTdHJpcGVTdG9yZSB8IG51bGwgfCB1bmRlZmluZWQsXG4gIHByZXZGb2N1c2VkSW5wdXQ6IHN0cmluZyB8IG51bGxcbikgPT4ge1xuICBpZiAoY2hlY2tvdXRGb3JtQ29udGFpbmVycy5sZW5ndGggPT09IDApIHtcbiAgICByZXR1cm47XG4gIH1cblxuICBjaGVja291dEZvcm1Db250YWluZXJzLmZvckVhY2goKGNoZWNrb3V0Rm9ybUNvbnRhaW5lcikgPT4ge1xuICAgIGNvbnN0IHF1ZXJ5T3B0aW9ucyA9IHtcbiAgICAgIHF1ZXJ5OiBncWxgXG4gICAgICAgICR7Y2hlY2tvdXRGb3JtQ29udGFpbmVyLmdldEF0dHJpYnV0ZShDSEVDS09VVF9RVUVSWSl9XG4gICAgICBgLFxuICAgICAgZmV0Y2hQb2xpY3k6ICduZXR3b3JrLW9ubHknLFxuICAgICAgLy8gZXJyb3JQb2xpY3kgaXMgc2V0IHRvIGBhbGxgIHNvIHRoYXQgd2UgY29udGludWUgdG8gZ2V0IHRoZSBjYXJ0IGRhdGEgd2hlbiBhbiBlcnJvciBvY2N1cnNcbiAgICAgIC8vIHRoaXMgaXMgaW1wb3J0YW50IGluIGNhc2VzIGxpa2Ugd2hlbiB0aGUgYWRkcmVzcyBlbnRlcmVkIGRvZXNuJ3QgaGF2ZSBhIHNoaXBwaW5nIHpvbmUsIGFzIHRoYXQgcmV0dXJuc1xuICAgICAgLy8gYSBncmFwaFFMIGVycm9yLCBidXQgd2Ugc3RpbGwgd2FudCB0byByZW5kZXIgd2hhdCB0aGUgY3VzdG9tZXIgaGFzIGVudGVyZWRcbiAgICAgIGVycm9yUG9saWN5OiAnYWxsJyxcbiAgICB9IGFzIGNvbnN0O1xuICAgIGFwb2xsb0NsaWVudFxuICAgICAgLnF1ZXJ5KHF1ZXJ5T3B0aW9ucylcbiAgICAgIC50aGVuKChkYXRhKSA9PiB7XG4gICAgICAgIGlmIChcbiAgICAgICAgICBkYXRhLmRhdGEgJiZcbiAgICAgICAgICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFMyMzM5OiBQcm9wZXJ0eSBkYXRhYmFzZSBkb2VzIG5vdCBleGlzdCBvbiB0eXBlIHt9XG4gICAgICAgICAgZGF0YS5kYXRhLmRhdGFiYXNlICYmXG4gICAgICAgICAgLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTMjMzOTogUHJvcGVydHkgZGF0YWJhc2UgZG9lcyBub3QgZXhpc3Qgb24gdHlwZSB7fVxuICAgICAgICAgIGRhdGEuZGF0YS5kYXRhYmFzZS5jb21tZXJjZU9yZGVyICYmXG4gICAgICAgICAgLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTMjMzOTogUHJvcGVydHkgZGF0YWJhc2UgZG9lcyBub3QgZXhpc3Qgb24gdHlwZSB7fVxuICAgICAgICAgIGRhdGEuZGF0YS5kYXRhYmFzZS5jb21tZXJjZU9yZGVyLmF2YWlsYWJsZVNoaXBwaW5nTWV0aG9kc1xuICAgICAgICApIHtcbiAgICAgICAgICBjb25zdCB7XG4gICAgICAgICAgICBkYXRhOiB7XG4gICAgICAgICAgICAgIC8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzIzMzk6IFByb3BlcnR5IGRhdGFiYXNlIGRvZXMgbm90IGV4aXN0IG9uIHR5cGUge31cbiAgICAgICAgICAgICAgZGF0YWJhc2U6IHtcbiAgICAgICAgICAgICAgICBjb21tZXJjZU9yZGVyOiB7XG4gICAgICAgICAgICAgICAgICBhdmFpbGFibGVTaGlwcGluZ01ldGhvZHMsXG4gICAgICAgICAgICAgICAgICBzdGF0dXNGbGFnczoge3JlcXVpcmVzU2hpcHBpbmd9LFxuICAgICAgICAgICAgICAgIH0sXG4gICAgICAgICAgICAgIH0sXG4gICAgICAgICAgICB9LFxuICAgICAgICAgIH0gPSBkYXRhO1xuXG4gICAgICAgICAgY29uc3Qgc2VsZWN0ZWRNZXRob2QgPSBhdmFpbGFibGVTaGlwcGluZ01ldGhvZHMuZmluZChcbiAgICAgICAgICAgIC8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzcwMDYgLSBQYXJhbWV0ZXIgJ21ldGhvZCcgaW1wbGljaXRseSBoYXMgYW4gJ2FueScgdHlwZS5cbiAgICAgICAgICAgIChtZXRob2QpID0+IG1ldGhvZC5zZWxlY3RlZCA9PT0gdHJ1ZVxuICAgICAgICAgICk7XG4gICAgICAgICAgaWYgKCFzZWxlY3RlZE1ldGhvZCAmJiByZXF1aXJlc1NoaXBwaW5nKSB7XG4gICAgICAgICAgICBjb25zdCBpZCA9IGF2YWlsYWJsZVNoaXBwaW5nTWV0aG9kc1swXVxuICAgICAgICAgICAgICA/IGF2YWlsYWJsZVNoaXBwaW5nTWV0aG9kc1swXS5pZFxuICAgICAgICAgICAgICA6IG51bGw7XG4gICAgICAgICAgICByZXR1cm4gY3JlYXRlT3JkZXJTaGlwcGluZ01ldGhvZE11dGF0aW9uKGFwb2xsb0NsaWVudCwgaWQpXG4gICAgICAgICAgICAgIC50aGVuKCgpID0+IHtcbiAgICAgICAgICAgICAgICByZXR1cm4gY3JlYXRlUmVjYWxjT3JkZXJFc3RpbWF0aW9uc011dGF0aW9uKGFwb2xsb0NsaWVudCk7XG4gICAgICAgICAgICAgIH0pXG4gICAgICAgICAgICAgIC50aGVuKCgpID0+IHtcbiAgICAgICAgICAgICAgICByZXR1cm4gYXBvbGxvQ2xpZW50LnF1ZXJ5KHF1ZXJ5T3B0aW9ucyk7XG4gICAgICAgICAgICAgIH0pXG5cbiAgICAgICAgICAgICAgLnRoZW4oKG5ld0RhdGEpID0+IHtcbiAgICAgICAgICAgICAgICBydW5SZW5kZXJPbkNoZWNrb3V0RWxlbWVudChcbiAgICAgICAgICAgICAgICAgIGNoZWNrb3V0Rm9ybUNvbnRhaW5lcixcbiAgICAgICAgICAgICAgICAgIG5ld0RhdGEsXG4gICAgICAgICAgICAgICAgICBlcnJvcnMsXG4gICAgICAgICAgICAgICAgICBzdHJpcGVTdG9yZSxcbiAgICAgICAgICAgICAgICAgIHByZXZGb2N1c2VkSW5wdXRcbiAgICAgICAgICAgICAgICApO1xuICAgICAgICAgICAgICB9KTtcbiAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgICAgaWYgKFxuICAgICAgICAgIGRhdGEuZGF0YSAmJlxuICAgICAgICAgIC8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzIzMzk6IFByb3BlcnR5IGRhdGFiYXNlIGRvZXMgbm90IGV4aXN0IG9uIHR5cGUge31cbiAgICAgICAgICBkYXRhLmRhdGEuZGF0YWJhc2UgJiZcbiAgICAgICAgICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFMyMzM5OiBQcm9wZXJ0eSBkYXRhYmFzZSBkb2VzIG5vdCBleGlzdCBvbiB0eXBlIHt9XG4gICAgICAgICAgZGF0YS5kYXRhLmRhdGFiYXNlLmNvbW1lcmNlT3JkZXIgJiZcbiAgICAgICAgICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFMyMzM5OiBQcm9wZXJ0eSBkYXRhYmFzZSBkb2VzIG5vdCBleGlzdCBvbiB0eXBlIHt9XG4gICAgICAgICAgZGF0YS5kYXRhLmRhdGFiYXNlLmNvbW1lcmNlT3JkZXIuc3RhdHVzRmxhZ3MgJiZcbiAgICAgICAgICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFMyMzM5OiBQcm9wZXJ0eSBkYXRhYmFzZSBkb2VzIG5vdCBleGlzdCBvbiB0eXBlIHt9XG4gICAgICAgICAgZGF0YS5kYXRhLmRhdGFiYXNlLmNvbW1lcmNlT3JkZXIuc3RhdHVzRmxhZ3Muc2hvdWxkUmVjYWxjXG4gICAgICAgICkge1xuICAgICAgICAgIHJldHVybiBjcmVhdGVSZWNhbGNPcmRlckVzdGltYXRpb25zTXV0YXRpb24oYXBvbGxvQ2xpZW50KVxuICAgICAgICAgICAgLnRoZW4oKCkgPT4ge1xuICAgICAgICAgICAgICByZXR1cm4gYXBvbGxvQ2xpZW50LnF1ZXJ5KHF1ZXJ5T3B0aW9ucyk7XG4gICAgICAgICAgICB9KVxuXG4gICAgICAgICAgICAudGhlbigobmV3RGF0YSkgPT4ge1xuICAgICAgICAgICAgICBydW5SZW5kZXJPbkNoZWNrb3V0RWxlbWVudChcbiAgICAgICAgICAgICAgICBjaGVja291dEZvcm1Db250YWluZXIsXG4gICAgICAgICAgICAgICAgbmV3RGF0YSxcbiAgICAgICAgICAgICAgICBlcnJvcnMsXG4gICAgICAgICAgICAgICAgc3RyaXBlU3RvcmUsXG4gICAgICAgICAgICAgICAgcHJldkZvY3VzZWRJbnB1dFxuICAgICAgICAgICAgICApO1xuICAgICAgICAgICAgfSk7XG4gICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgcnVuUmVuZGVyT25DaGVja291dEVsZW1lbnQoXG4gICAgICAgICAgICBjaGVja291dEZvcm1Db250YWluZXIsXG4gICAgICAgICAgICBkYXRhLFxuICAgICAgICAgICAgZXJyb3JzLFxuICAgICAgICAgICAgc3RyaXBlU3RvcmUsXG4gICAgICAgICAgICBwcmV2Rm9jdXNlZElucHV0XG4gICAgICAgICAgKTtcbiAgICAgICAgfVxuICAgICAgfSlcbiAgICAgIC5jYXRjaCgoZXJyKSA9PiB7XG4gICAgICAgIGVycm9ycy5wdXNoKGVycik7XG4gICAgICAgIHJlbmRlckNoZWNrb3V0KGNoZWNrb3V0Rm9ybUNvbnRhaW5lciwge2Vycm9yc30sIHByZXZGb2N1c2VkSW5wdXQpO1xuICAgICAgfSk7XG4gIH0pO1xufTtcblxuZXhwb3J0IGNvbnN0IGNyZWF0ZUF0dGVtcHRTdWJtaXRPcmRlclJlcXVlc3QgPSAoXG4gIGFwb2xsb0NsaWVudDogQXBvbGxvQ2xpZW50LFxuICB2YXJpYWJsZXM6IHtcbiAgICBjaGVja291dFR5cGU6IHN0cmluZztcbiAgICBwYXltZW50SW50ZW50SWQ/OiBzdHJpbmc7XG4gIH1cbikgPT4ge1xuICByZXR1cm4gYXBvbGxvQ2xpZW50Lm11dGF0ZSh7XG4gICAgbXV0YXRpb246IGF0dGVtcHRTdWJtaXRPcmRlck11dGF0aW9uLFxuICAgIHZhcmlhYmxlcyxcbiAgfSk7XG59O1xuXG5leHBvcnQgY29uc3QgZ2V0T3JkZXJEYXRhRnJvbUdyYXBoUUxSZXNwb25zZSA9IChkYXRhOiBSZWNvcmQ8YW55LCBhbnk+KSA9PiB7XG4gIHJldHVybiBkYXRhICYmIGRhdGEuZGF0YSAmJiBkYXRhLmRhdGEuZWNvbW1lcmNlQXR0ZW1wdFN1Ym1pdE9yZGVyO1xufTtcblxuZXhwb3J0IGNvbnN0IG9yZGVyUmVxdWlyZXNBZGRpdGlvbmFsQWN0aW9uID0gKHN0YXR1czogc3RyaW5nKSA9PlxuICBzdGF0dXMgPT09IFJFUVVJUkVTX0FDVElPTjtcblxuZXhwb3J0IGNvbnN0IHJlZGlyZWN0VG9PcmRlckNvbmZpcm1hdGlvbiA9IChcbiAgb3JkZXI6IFJlY29yZDxhbnksIGFueT4sXG4gIGlzUGF5UGFsOiBib29sZWFuID0gZmFsc2VcbikgPT4ge1xuICBjb25zdCByZWRpcmVjdFVybCA9IGAvb3JkZXItY29uZmlybWF0aW9uP29yZGVySWQ9JHtvcmRlci5vcmRlcklkfSZ0b2tlbj0ke29yZGVyLnRva2VufWA7XG4gIGlmIChpc1BheVBhbCkge1xuICAgIGNvbnN0IG1lc3NhZ2UgPSB7XG4gICAgICBpc1dlYmZsb3c6IHRydWUsXG4gICAgICB0eXBlOiAnc3VjY2VzcycsXG4gICAgICBkZXRhaWw6IHJlZGlyZWN0VXJsLFxuICAgIH0gYXMgY29uc3Q7XG4gICAgd2luZG93LnBhcmVudC5wb3N0TWVzc2FnZShKU09OLnN0cmluZ2lmeShtZXNzYWdlKSwgd2luZG93LmxvY2F0aW9uLm9yaWdpbik7XG4gIH0gZWxzZSB7XG4gICAgd2luZG93LmxvY2F0aW9uLmhyZWYgPSByZWRpcmVjdFVybDtcbiAgfVxufTtcblxuZXhwb3J0IGNvbnN0IGFwcGx5RGlzY291bnQgPSAoXG4gIGFwb2xsb0NsaWVudDogQXBvbGxvQ2xpZW50LFxuICB2YXJpYWJsZXM6IHtcbiAgICBkaXNjb3VudENvZGU6IHN0cmluZztcbiAgfVxuKSA9PiB7XG4gIHJldHVybiBhcG9sbG9DbGllbnQubXV0YXRlKHtcbiAgICBtdXRhdGlvbjogYXBwbHlEaXNjb3VudE11dGF0aW9uLFxuICAgIHZhcmlhYmxlcyxcbiAgfSk7XG59O1xuIl0sIm5hbWVzIjpbImFwcGx5RGlzY291bnQiLCJiZWZvcmVVbmxvYWRIYW5kbGVyIiwiY3JlYXRlQXR0ZW1wdFN1Ym1pdE9yZGVyUmVxdWVzdCIsImNyZWF0ZUN1c3RvbURhdGFNdXRhdGlvbiIsImNyZWF0ZU9yZGVyQWRkcmVzc011dGF0aW9uIiwiY3JlYXRlT3JkZXJJZGVudGl0eU11dGF0aW9uIiwiY3JlYXRlT3JkZXJTaGlwcGluZ01ldGhvZE11dGF0aW9uIiwiY3JlYXRlUmVjYWxjT3JkZXJFc3RpbWF0aW9uc011dGF0aW9uIiwiY3JlYXRlU3RyaXBlUGF5bWVudE1ldGhvZE11dGF0aW9uIiwiY3JlYXRlVXBkYXRlT2JmdXNjYXRlZE9yZGVyQWRkcmVzc011dGF0aW9uIiwiZ2V0T3JkZXJEYXRhRnJvbUdyYXBoUUxSZXNwb25zZSIsImluaXRpYWxpemVTdHJpcGVFbGVtZW50cyIsIm9yZGVyUmVxdWlyZXNBZGRpdGlvbmFsQWN0aW9uIiwicmVkaXJlY3RUb09yZGVyQ29uZmlybWF0aW9uIiwicmVuZGVyQ2hlY2tvdXRGb3JtQ29udGFpbmVycyIsInNob3dFcnJvck1lc3NhZ2VGb3JFcnJvciIsInVwZGF0ZUVycm9yTWVzc2FnZSIsInN5bmNTdHlsZXNUb1N0cmlwZUVsZW1lbnQiLCJzdHJpcGVFbGVtZW50IiwiYXBwbGllZFN0eWxlcyIsInVwZGF0ZSIsInN0eWxlIiwiU3R5bGVNYXBPYnNlcnZlciIsImFwcGxpZWRTdHlsZXNUb1N0cmlwZUVsZW1lbnRTdHlsZXMiLCJzdG9yZSIsIndpbmRvdyIsIldlYmZsb3ciLCJlbnYiLCJpc0luaXRpYWxpemVkIiwiY2hlY2tvdXRGb3JtQ29udGFpbmVycyIsImZpbmRBbGxFbGVtZW50c0J5Tm9kZVR5cGUiLCJOT0RFX1RZUEVfQ09NTUVSQ0VfQ0hFQ0tPVVRfRk9STV9DT05UQUlORVIiLCJjYXJ0V3JhcHBlcnMiLCJOT0RFX1RZUEVfQ09NTUVSQ0VfQ0FSVF9XUkFQUEVSIiwiYWxsU3RyaXBlRWxlbWVudHMiLCJmb3JFYWNoIiwiZWxlbWVudCIsImluZGV4IiwiY3JlYXRlRWxlbWVudHNJbnN0YW5jZSIsInNldEF0dHJpYnV0ZSIsIlNUUklQRV9FTEVNRU5UX0lOU1RBTkNFIiwiU3RyaW5nIiwic3RyaXBlRWxlbWVudHMiLCJkb2N1bWVudCIsInF1ZXJ5U2VsZWN0b3JBbGwiLCJTVFJJUEVfRUxFTUVOVF9UWVBFIiwiQXJyYXkiLCJmcm9tIiwidHlwZSIsImdldEF0dHJpYnV0ZSIsIkVycm9yIiwiY2hlY2tvdXRGb3JtQ29udGFpbmVyIiwiZmluZENsb3Nlc3RFbGVtZW50QnlOb2RlVHlwZSIsInBhcnNlSW50IiwiZWwiLCJjcmVhdGVFbGVtZW50Iiwic2FmZVBhcnNlSnNvbiIsIlNUUklQRV9FTEVNRU5UX1NUWUxFIiwiY2xhc3NlcyIsImZvY3VzIiwibW91bnQiLCJzdHlsZU1hcE9ic2VydmVyIiwib25DaGFuZ2UiLCJlcnJvckNvZGVUb0NoZWNrb3V0RXJyb3JUeXBlIiwiY29kZSIsIm1zZyIsIm1hdGNoIiwiZ2V0RXJyb3JUeXBlIiwiZXJyb3IiLCJDb21iaW5lZEdyYXBoUUxFcnJvcnMiLCJpcyIsImVycm9ycyIsImxlbmd0aCIsImVycm9yQ29kZSIsImV4dGVuc2lvbnMiLCJlcnJvck1lc3NhZ2UiLCJtZXNzYWdlIiwidW5kZWZpbmVkIiwiZXJyb3JUZXh0IiwicXVlcnlTZWxlY3RvciIsIkNBUlRfQ0hFQ0tPVVRfRVJST1JfTUVTU0FHRV9TRUxFQ1RPUiIsInRleHRDb250ZW50IiwiZXJyb3JUeXBlIiwiZXJyb3JEYXRhIiwiQ0hFQ0tPVVRfRVJST1JTIiwidG9VcHBlckNhc2UiLCJyZXBsYWNlIiwiZGVmYXVsdEVycm9yTWVzc2FnZSIsImNvcHkiLCJnZXRDaGVja291dEVycm9yTWVzc2FnZUZvclR5cGUiLCJyZXF1aXJlc1JlZnJlc2giLCJORUVEU19SRUZSRVNIIiwicmVtb3ZlQXR0cmlidXRlIiwidXBkYXRlUmVxdWlyZWRGaWVsZHMiLCJlbGVtZW50TmFtZUJ5R3JhcGhRTEVycm9yIiwiTUlTU0lOR19TVEFURSIsImludmFsaWRTaGlwcGluZ0FkZHJlc3NFcnJvciIsImZpbmQiLCJncWxFcnJvciIsInByb2JsZW1zIiwicHJvYmxlbSIsImVsZW1lbnROYW1lIiwiZ2V0RWxlbWVudHNCeU5hbWUiLCJIVE1MSW5wdXRFbGVtZW50IiwicmVxdWlyZWQiLCJyZXBvcnRWYWxpZGl0eSIsImVyciIsInNjb3BlIiwiZXJyb3JTdGF0ZSIsImZpbmRFbGVtZW50QnlOb2RlVHlwZSIsIk5PREVfVFlQRV9DT01NRVJDRV9DSEVDS09VVF9FUlJPUl9TVEFURSIsInJlbW92ZVByb3BlcnR5IiwiZSIsInByZXZlbnREZWZhdWx0IiwicmV0dXJuVmFsdWUiLCJhcG9sbG9DbGllbnQiLCJlbWFpbCIsIm11dGF0ZSIsIm11dGF0aW9uIiwidXBkYXRlT3JkZXJJZGVudGl0eU11dGF0aW9uIiwidmFyaWFibGVzIiwiYWRkcmVzc0luZm8iLCJ1cGRhdGVPcmRlckFkZHJlc3NNdXRhdGlvbiIsImlkIiwidXBkYXRlT3JkZXJTaGlwcGluZ01ldGhvZE11dGF0aW9uIiwiY3VzdG9tRGF0YSIsInVwZGF0ZUN1c3RvbURhdGEiLCJ1cGRhdGVPcmRlclN0cmlwZVBheW1lbnRNZXRob2RNdXRhdGlvbiIsInBheW1lbnRNZXRob2QiLCJyZWNhbGNPcmRlckVzdGltYXRpb25zTXV0YXRpb24iLCJlcnJvclBvbGljeSIsInVwZGF0ZU9iZnVzY2F0ZWRPcmRlckFkZHJlc3NNdXRhdGlvbiIsInJlbmRlckNoZWNrb3V0IiwiY2hlY2tvdXQiLCJkYXRhIiwicHJldkZvY3VzZWRJbnB1dCIsInJlbmRlclRyZWUiLCJzaGlwcGluZ01ldGhvZHNMaXN0IiwiTk9ERV9UWVBFX0NPTU1FUkNFX0NIRUNLT1VUX1NISVBQSU5HX01FVEhPRFNfTElTVCIsInNoaXBwaW5nTWV0aG9kc0VtcHR5IiwiTk9ERV9UWVBFX0NPTU1FUkNFX0NIRUNLT1VUX1NISVBQSU5HX01FVEhPRFNfRU1QVFlfU1RBVEUiLCJzaGlwcGluZ0FkZHJlc3NXcmFwcGVyIiwiTk9ERV9UWVBFX0NPTU1FUkNFX0NIRUNLT1VUX1NISVBQSU5HX0FERFJFU1NfV1JBUFBFUiIsImJpbGxpbmdBZGRyZXNzV3JhcHBlciIsIk5PREVfVFlQRV9DT01NRVJDRV9DSEVDS09VVF9CSUxMSU5HX0FERFJFU1NfV1JBUFBFUiIsImJpbGxpbmdBZGRyZXNzVG9nZ2xlIiwiTk9ERV9UWVBFX0NPTU1FUkNFX0NIRUNLT1VUX0JJTExJTkdfQUREUkVTU19UT0dHTEVfQ0hFQ0tCT1giLCJwYXltZW50SW5mb1dyYXBwZXIiLCJFbGVtZW50IiwiZGF0YWJhc2UiLCJjb21tZXJjZU9yZGVyIiwiYXZhaWxhYmxlU2hpcHBpbmdNZXRob2RzIiwic3RhdHVzRmxhZ3MiLCJyZXF1aXJlc1NoaXBwaW5nIiwiaXNGcmVlT3JkZXIiLCJzaGlwcGluZ0FkZHJlc3NSZXF1aXJlc1Bvc3RhbENvZGUiLCJiaWxsaW5nQWRkcmVzc1JlcXVpcmVzUG9zdGFsQ29kZSIsImhhc1N1YnNjcmlwdGlvbiIsInNoaXBwaW5nWmlwRmllbGQiLCJOT0RFX1RZUEVfQ09NTUVSQ0VfQ0hFQ0tPVVRfU0hJUFBJTkdfQUREUkVTU19aSVBfRklFTEQiLCJiaWxsaW5nWmlwRmllbGQiLCJOT0RFX1RZUEVfQ09NTUVSQ0VfQ0hFQ0tPVVRfQklMTElOR19BRERSRVNTX1pJUF9GSUVMRCIsInBheXBhbEVsZW1lbnQiLCJQQVlQQUxfRUxFTUVOVF9JTlNUQU5DRSIsInBheXBhbEJ1dHRvbiIsIlBBWVBBTF9CVVRUT05fRUxFTUVOVF9JTlNUQU5DRSIsImhpZGVFbGVtZW50Iiwic2hvd0VsZW1lbnQiLCJjaGVja2VkIiwicGFyZW50RWxlbWVudCIsImNsYXNzTGlzdCIsImNvbnRhaW5zIiwiZ2V0UHJvcGVydHlWYWx1ZSIsInByZXZGb2N1c2VkSW5wdXRFbGUiLCJnZXRFbGVtZW50QnlJZCIsInJ1blJlbmRlck9uQ2hlY2tvdXRFbGVtZW50Iiwic3RyaXBlU3RvcmUiLCJjb25jYXQiLCJmaWx0ZXIiLCJCb29sZWFuIiwidXBkYXRlV2ViUGF5bWVudHNCdXR0b24iLCJxdWVyeU9wdGlvbnMiLCJxdWVyeSIsImdxbCIsIkNIRUNLT1VUX1FVRVJZIiwiZmV0Y2hQb2xpY3kiLCJ0aGVuIiwic2VsZWN0ZWRNZXRob2QiLCJtZXRob2QiLCJzZWxlY3RlZCIsIm5ld0RhdGEiLCJzaG91bGRSZWNhbGMiLCJjYXRjaCIsInB1c2giLCJhdHRlbXB0U3VibWl0T3JkZXJNdXRhdGlvbiIsImVjb21tZXJjZUF0dGVtcHRTdWJtaXRPcmRlciIsInN0YXR1cyIsIlJFUVVJUkVTX0FDVElPTiIsIm9yZGVyIiwiaXNQYXlQYWwiLCJyZWRpcmVjdFVybCIsIm9yZGVySWQiLCJ0b2tlbiIsImlzV2ViZmxvdyIsImRldGFpbCIsInBhcmVudCIsInBvc3RNZXNzYWdlIiwiSlNPTiIsInN0cmluZ2lmeSIsImxvY2F0aW9uIiwib3JpZ2luIiwiaHJlZiIsImFwcGx5RGlzY291bnRNdXRhdGlvbiJdLCJtYXBwaW5ncyI6IkFBQUEsOENBQThDOzs7Ozs7Ozs7OztJQW9xQmpDQSxhQUFhO2VBQWJBOztJQTFZQUMsbUJBQW1CO2VBQW5CQTs7SUFxV0FDLCtCQUErQjtlQUEvQkE7O0lBclVBQyx3QkFBd0I7ZUFBeEJBOztJQWxCQUMsMEJBQTBCO2VBQTFCQTs7SUFUQUMsMkJBQTJCO2VBQTNCQTs7SUFrQkFDLGlDQUFpQztlQUFqQ0E7O0lBNkJBQyxvQ0FBb0M7ZUFBcENBOztJQVhBQyxpQ0FBaUM7ZUFBakNBOztJQW1CQUMsMENBQTBDO2VBQTFDQTs7SUFzVEFDLCtCQUErQjtlQUEvQkE7O0lBL2tCQUMsd0JBQXdCO2VBQXhCQTs7SUFtbEJBQyw2QkFBNkI7ZUFBN0JBOztJQUdBQywyQkFBMkI7ZUFBM0JBOztJQXZJQUMsNEJBQTRCO2VBQTVCQTs7SUFoUUFDLHdCQUF3QjtlQUF4QkE7O0lBdkZBQyxrQkFBa0I7ZUFBbEJBOzs7d0JBcExxQzttRUFDbEM7K0JBUVQ7eUVBQzBDOzJCQXdCMUM7MkJBQ2tCO21DQUNhO21DQVcvQjs7Ozs7O0FBTVAsTUFBTUMsNEJBQ0osQ0FBQ0MsZ0JBQXVCLENBQUNDO1FBQ3ZCRCxjQUFjRSxNQUFNLENBQUM7WUFDbkJDLE9BQU9DLHlCQUFnQixDQUFDQyxrQ0FBa0MsQ0FBQ0o7UUFDN0Q7SUFDRjtBQUVLLE1BQU1SLDJCQUEyQixDQUFDYTtJQUN2QyxJQUNFQyxPQUFPQyxPQUFPLENBQUNDLEdBQUcsQ0FBQyxhQUNuQkYsT0FBT0MsT0FBTyxDQUFDQyxHQUFHLENBQUMsY0FDbkIsQ0FBQ0gsTUFBTUksYUFBYSxJQUNwQjtRQUNBO0lBQ0Y7SUFFQSxNQUFNQyx5QkFBeUJDLElBQUFBLHdDQUF5QixFQUN0REMscURBQTBDO0lBRTVDLE1BQU1DLGVBQWVGLElBQUFBLHdDQUF5QixFQUM1Q0csMENBQStCO0lBR2pDLE1BQU1DLG9CQUFvQjtXQUFJTDtXQUEyQkc7S0FBYTtJQUV0RUUsa0JBQWtCQyxPQUFPLENBQUMsQ0FBQ0MsU0FBU0M7UUFDbENiLE1BQU1jLHNCQUFzQixDQUFDRDtRQUM3QkQsUUFBUUcsWUFBWSxDQUFDQyxrQ0FBdUIsRUFBRUMsT0FBT0o7SUFDdkQ7SUFFQSxNQUFNSyxpQkFBaUJDLFNBQVNDLGdCQUFnQixDQUFDLENBQUMsQ0FBQyxFQUFFQyw4QkFBbUIsQ0FBQyxDQUFDLENBQUM7SUFFM0VDLE1BQU1DLElBQUksQ0FBQ0wsZ0JBQWdCUCxPQUFPLENBQUMsQ0FBQ0M7UUFDbEMsTUFBTVksT0FBT1osUUFBUWEsWUFBWSxDQUFDSiw4QkFBbUI7UUFDckQsSUFBSSxDQUFDRyxNQUFNO1lBQ1QsTUFBTSxJQUFJRSxNQUFNO1FBQ2xCO1FBRUEsTUFBTUMsd0JBQXdCQyxJQUFBQSwyQ0FBNEIsRUFDeERyQixxREFBMEMsRUFDMUNLO1FBRUYsSUFBSSxDQUFDZSx1QkFBdUI7WUFDMUI7UUFDRjtRQUVBLE1BQU1kLFFBQVFnQixTQUNaLGdIQUFnSDtRQUNoSEYsc0JBQXNCRixZQUFZLENBQUNULGtDQUF1QixHQUMxRDtRQUdGLE1BQU1jLEtBQUs5QixNQUFNK0IsYUFBYSxDQUFDUCxNQUFNWCxPQUFPO1lBQzFDaEIsT0FBT21DLElBQUFBLDRCQUFhLEVBQUNwQixRQUFRYSxZQUFZLENBQUNRLCtCQUFvQixLQUFLO1lBQ25FQyxTQUFTO2dCQUNQQyxPQUFPO1lBQ1Q7UUFDRjtRQUNBTCxHQUFHTSxLQUFLLENBQUN4QjtRQUNULHdGQUF3RjtRQUN4RixNQUFNeUIsbUJBQW1CLElBQUl2Qyx5QkFBZ0IsQ0FBQ2MsU0FBUztZQUNyRDBCLFVBQVU3QywwQkFBMEJxQztRQUN0QztJQUNGO0FBQ0Y7QUFFQSxNQUFNUywrQkFBK0IsQ0FBQ0MsTUFBZUM7SUFDbkQsT0FBUUQ7UUFDTixLQUFLO1lBQ0gsSUFBSUMsT0FBT0EsSUFBSUMsS0FBSyxDQUFDLGVBQWU7Z0JBQ2xDLE9BQU87WUFDVCxPQUFPO2dCQUNMLE9BQU87WUFDVDtRQUNGLEtBQUs7WUFDSCxPQUFPO1FBQ1QsS0FBSztZQUNILE9BQU87UUFDVCxLQUFLO1lBQ0gsT0FBTztRQUNULEtBQUs7UUFDTCxLQUFLO1FBQ0wsS0FBSztZQUNILE9BQU87UUFDVCxLQUFLO1FBQ0wsS0FBSztZQUNILE9BQU87UUFDVCxLQUFLO1lBQ0gsT0FBTztRQUNULHdFQUF3RTtRQUN4RSxvRkFBb0Y7UUFDcEYsS0FBSztRQUNMLEtBQUs7UUFDTCxLQUFLO1lBQXdCO2dCQUMzQixPQUFPO1lBQ1Q7UUFDQSxLQUFLO1lBQW1CO2dCQUN0QixPQUFPO1lBQ1Q7UUFDQSxLQUFLO1lBQXdCO2dCQUMzQixPQUFPO1lBQ1Q7UUFDQSxLQUFLO1lBQThCO2dCQUNqQyxPQUFPO1lBQ1Q7UUFDQTtZQUNFLE9BQU87SUFDWDtBQUNGO0FBRUEsTUFBTUMsZUFBZSxDQUFDQztJQUNwQixJQUFJQyw2QkFBcUIsQ0FBQ0MsRUFBRSxDQUFDRixVQUFVQSxNQUFNRyxNQUFNLENBQUNDLE1BQU0sR0FBRyxHQUFHO1FBQzlELE1BQU1DLFlBQVlMLE1BQU1HLE1BQU0sQ0FBQyxFQUFFLEVBQUVHLFlBQVlWO1FBQy9DLE1BQU1XLGVBQWVQLE1BQU1HLE1BQU0sQ0FBQyxFQUFFLEVBQUVLO1FBQ3RDLE9BQU9iLDZCQUNMLE9BQU9VLGNBQWMsV0FBV0EsWUFBWUksV0FDNUNGO0lBRUo7SUFFQSxJQUFJUCxNQUFNSixJQUFJLEVBQUU7UUFDZCxPQUFPRCw2QkFBNkJLLE1BQU1KLElBQUksRUFBRUksTUFBTVEsT0FBTztJQUMvRDtJQUVBLE9BQU87QUFDVDtBQUVPLE1BQU01RCxxQkFBcUIsQ0FDaENvQixTQUNBZ0M7SUFFQSxNQUFNVSxZQUFZMUMsUUFBUTJDLGFBQWEsQ0FBQ0MsK0NBQW9DO0lBQzVFLElBQUksQ0FBQ0YsV0FBVztRQUNkO0lBQ0Y7SUFFQSx3RUFBd0U7SUFDeEUsMEVBQTBFO0lBQzFFLDJFQUEyRTtJQUMzRSxtQ0FBbUM7SUFDbkMsSUFBSVYsTUFBTXBCLElBQUksSUFBSW9CLE1BQU1wQixJQUFJLEtBQUssb0JBQW9CO1FBQ25EOEIsVUFBVUcsV0FBVyxHQUFHYixNQUFNUSxPQUFPO1FBQ3JDO0lBQ0Y7SUFFQSxNQUFNTSxZQUFZZixhQUFhQztJQUUvQix1RkFBdUY7SUFDdkYsTUFBTWUsWUFDSixnSUFBZ0k7SUFDaElDLDBCQUFlLENBQUNGLFVBQVVHLFdBQVcsR0FBR0MsT0FBTyxDQUFDLE9BQU8sS0FBSyxJQUFJLENBQUM7SUFDbkUsTUFBTUMsc0JBQXNCSixVQUFVSyxJQUFJO0lBRTFDLE1BQU1iLGVBQ0pHLFVBQVU3QixZQUFZLENBQUN3QyxJQUFBQSx5Q0FBOEIsRUFBQ1AsZUFDdERLO0lBRUZULFVBQVVHLFdBQVcsR0FBR047SUFFeEIsSUFBSVEsVUFBVU8sZUFBZSxFQUFFO1FBQzdCWixVQUFVdkMsWUFBWSxDQUFDb0Qsd0JBQWEsRUFBRTtJQUN4QyxPQUFPO1FBQ0xiLFVBQVVjLGVBQWUsQ0FBQ0Qsd0JBQWE7SUFDekM7SUFFQSxJQUFJVCxjQUFjLFlBQVk7UUFDNUJXLHFCQUFxQnpCO0lBQ3ZCO0FBQ0Y7QUFFQSxNQUFNMEIsNEJBQTRCO0lBQ2hDQyxlQUFlO0FBQ2pCO0FBRUEsTUFBTUYsdUJBQXVCLENBQUN6QjtJQUM1QixJQUFJLENBQUNDLDZCQUFxQixDQUFDQyxFQUFFLENBQUNGLFVBQVVBLE1BQU1HLE1BQU0sQ0FBQ0MsTUFBTSxLQUFLLEdBQUc7UUFDakU7SUFDRjtJQUVBLE1BQU13Qiw4QkFBOEI1QixNQUFNRyxNQUFNLENBQUMwQixJQUFJLENBQ25ELENBQUNDLFdBQ0MsVUFBVUEsWUFBWUEsU0FBU2xDLElBQUksS0FBSztJQUc1QyxJQUFJLENBQUNnQyw2QkFBNkI7UUFDaEM7SUFDRjtJQUVBLGdGQUFnRjtJQUNoRkEsNEJBQTRCRyxRQUFRLENBQUNoRSxPQUFPLENBQUMsQ0FBQ2lFO1FBQzVDLE1BQU0sRUFBQ3BELElBQUksRUFBQyxHQUFHb0Q7UUFFZixnTEFBZ0w7UUFDaEwsTUFBTUMsY0FBY1AseUJBQXlCLENBQUM5QyxLQUFLO1FBRW5ELElBQUksQ0FBQ3FELGFBQWE7WUFDaEI7UUFDRjtRQUVBLE1BQU1qRSxVQUFVTyxTQUFTMkQsaUJBQWlCLENBQUNELFlBQVksQ0FBQyxFQUFFO1FBRTFELElBQUksQ0FBRWpFLENBQUFBLG1CQUFtQm1FLGdCQUFlLEdBQUk7WUFDMUM7UUFDRjtRQUVBbkUsUUFBUW9FLFFBQVEsR0FBRztRQUVuQiw4Q0FBOEM7UUFDOUMsSUFBSSxPQUFPcEUsUUFBUXFFLGNBQWMsS0FBSyxZQUFZO1lBQ2hEckUsUUFBUXFFLGNBQWM7UUFDeEI7SUFDRjtBQUNGO0FBRU8sTUFBTTFGLDJCQUEyQixDQUN0QzJGLEtBQ0FDO0lBRUEsTUFBTUMsYUFBYUMsSUFBQUEsb0NBQXFCLEVBQ3RDQyxrREFBdUMsRUFDdkNIO0lBRUYsSUFBSUMsWUFBWTtRQUNkQSxXQUFXdkYsS0FBSyxDQUFDMEYsY0FBYyxDQUFDO1FBQ2hDL0YsbUJBQW1CNEYsWUFBWUY7SUFDakM7QUFDRjtBQUVPLE1BQU16RyxzQkFBc0IsQ0FBQytHO0lBQ2xDQSxFQUFFQyxjQUFjO0lBQ2hCRCxFQUFFRSxXQUFXLEdBQUc7QUFDbEI7QUFFTyxNQUFNN0csOEJBQThCLENBQ3pDOEcsY0FDQUMsUUFFQUQsYUFBYUUsTUFBTSxDQUFDO1FBQ2xCQyxVQUFVQyw4Q0FBMkI7UUFDckNDLFdBQVc7WUFBQ0o7UUFBSztJQUNuQjtBQUVLLE1BQU1oSCw2QkFBNkIsQ0FDeEMrRyxjQUNBTSxjQUVBTixhQUFhRSxNQUFNLENBQUM7UUFDbEJDLFVBQVVJLDZDQUEwQjtRQUNwQ0YsV0FBV0M7SUFDYjtBQUVLLE1BQU1uSCxvQ0FBb0MsQ0FDL0M2RyxjQUNBUSxLQUVBUixhQUFhRSxNQUFNLENBQUM7UUFDbEJDLFVBQVVNLG9EQUFpQztRQUMzQ0osV0FBVztZQUFDRztRQUFFO0lBQ2hCO0FBRUssTUFBTXhILDJCQUEyQixDQUN0Q2dILGNBQ0FVLGFBRUFWLGFBQWFFLE1BQU0sQ0FBQztRQUNsQkMsVUFBVVEsbUNBQWdCO1FBQzFCTixXQUFXO1lBQUNLO1FBQVU7SUFDeEI7QUFFSyxNQUFNckgsb0NBQW9DLENBQy9DMkcsY0FDQVEsS0FFQVIsYUFBYUUsTUFBTSxDQUFDO1FBQ2xCQyxVQUFVUyx5REFBc0M7UUFDaERQLFdBQVc7WUFDVFEsZUFBZUw7UUFDakI7SUFDRjtBQUVLLE1BQU1wSCx1Q0FBdUMsQ0FDbEQ0RyxlQUVBQSxhQUFhRSxNQUFNLENBQUM7UUFDbEJDLFVBQVVXLGlEQUE4QjtRQUN4Q0MsYUFBYTtJQUNmO0FBRUssTUFBTXpILDZDQUE2QyxDQUN4RDBHLGNBQ0FNLGNBRUFOLGFBQWFFLE1BQU0sQ0FBQztRQUNsQkMsVUFBVWEsdURBQW9DO1FBQzlDWCxXQUFXQztJQUNiO0FBRUYsTUFBTVcsaUJBQWlCLENBQ3JCQyxVQUNBQyxNQUNBQztJQUVBQyxJQUFBQSxxQkFBVSxFQUFDSCxVQUFVQztJQUVyQixNQUFNRyxzQkFBc0I1QixJQUFBQSxvQ0FBcUIsRUFDL0M2Qiw0REFBaUQsRUFDakRMO0lBRUYsTUFBTU0sdUJBQXVCOUIsSUFBQUEsb0NBQXFCLEVBQ2hEK0IsbUVBQXdELEVBQ3hEUDtJQUVGLE1BQU1RLHlCQUF5QmhDLElBQUFBLG9DQUFxQixFQUNsRGlDLCtEQUFvRCxFQUNwRFQ7SUFFRixNQUFNVSx3QkFBd0JsQyxJQUFBQSxvQ0FBcUIsRUFDakRtQyw4REFBbUQsRUFDbkRYO0lBRUYsTUFBTVksdUJBQXVCcEMsSUFBQUEsb0NBQXFCLEVBQ2hEcUMsc0VBQTJELEVBQzNEYjtJQUVGLE1BQU1jLHFCQUFxQmQsU0FBU3RELGFBQWEsQ0FDL0M7SUFFRixJQUNFLENBQUUwRCxDQUFBQSwrQkFBK0JXLE9BQU0sS0FDdkMsQ0FBRVAsQ0FBQUEsa0NBQWtDTyxPQUFNLEtBQzFDLENBQUVMLENBQUFBLGlDQUFpQ0ssT0FBTSxLQUN6QyxDQUFFSCxDQUFBQSxnQ0FBZ0MxQyxnQkFBZSxLQUNqRCxDQUFFNEMsQ0FBQUEsOEJBQThCQyxPQUFNLEdBQ3RDO1FBQ0E7SUFDRjtJQUVBLElBQUlkLEtBQUtBLElBQUksSUFBSUEsS0FBS0EsSUFBSSxDQUFDZSxRQUFRLElBQUlmLEtBQUtBLElBQUksQ0FBQ2UsUUFBUSxDQUFDQyxhQUFhLEVBQUU7UUFDdkUsTUFBTSxFQUNKaEIsTUFBTSxFQUNKZSxVQUFVLEVBQ1JDLGVBQWUsRUFDYkMsd0JBQXdCLEVBQ3hCQyxhQUFhLEVBQ1hDLGdCQUFnQixFQUNoQkMsV0FBVyxFQUNYQyxpQ0FBaUMsRUFDakNDLGdDQUFnQyxFQUNoQ0MsZUFBZSxFQUNoQixFQUNGLEVBQ0YsRUFDRixFQUNGLEdBQUd2QjtRQUVKLE1BQU13QixtQkFBbUJqRCxJQUFBQSxvQ0FBcUIsRUFDNUNrRCxpRUFBc0QsRUFDdERsQjtRQUVGLElBQUlpQiw0QkFBNEJ2RCxrQkFBa0I7WUFDaER1RCxpQkFBaUJ0RCxRQUFRLEdBQUdtRDtRQUM5QjtRQUVBLE1BQU1LLGtCQUFrQm5ELElBQUFBLG9DQUFxQixFQUMzQ29ELGdFQUFxRCxFQUNyRGxCO1FBRUYsSUFBSWlCLDJCQUEyQnpELGtCQUFrQjtZQUMvQ3lELGdCQUFnQnhELFFBQVEsR0FBR29EO1FBQzdCO1FBRUEsTUFBTU0sZ0JBQWdCdkgsU0FBU29DLGFBQWEsQ0FDMUMsQ0FBQyxDQUFDLEVBQUVvRixrQ0FBdUIsQ0FBQyxDQUFDLENBQUM7UUFFaEMsTUFBTUMsZUFBZS9CLFNBQVN0RCxhQUFhLENBQ3pDLENBQUMsQ0FBQyxFQUFFc0YseUNBQThCLENBQUMsQ0FBQyxDQUFDO1FBRXZDLElBQUlILGlCQUFpQkUsY0FBYztZQUNqQyxJQUFJVixlQUFlRyxpQkFBaUI7Z0JBQ2xDLCtHQUErRztnQkFDL0dTLElBQUFBLDBCQUFXLEVBQUNGO1lBQ2QsT0FBTztnQkFDTCwrR0FBK0c7Z0JBQy9HRyxJQUFBQSwwQkFBVyxFQUFDSDtZQUNkO1FBQ0Y7UUFFQSwrR0FBK0c7UUFDL0csaUdBQWlHO1FBQ2pHLElBQ0UsQ0FBQ1gsb0JBQ0RSLHFCQUFxQnVCLE9BQU8sSUFDNUJ2QixxQkFBcUJ3QixhQUFhLElBQ2xDeEIscUJBQXFCd0IsYUFBYSxDQUFDQyxTQUFTLENBQUNDLFFBQVEsQ0FDbkQsMEJBRUY7WUFDQUosSUFBQUEsMEJBQVcsRUFBQ3hCO1FBQ2Q7UUFDQSxJQUFJLENBQUNRLDRCQUE0QkEseUJBQXlCL0UsTUFBTSxHQUFHLEdBQUc7WUFDcEU4RixJQUFBQSwwQkFBVyxFQUFDN0I7WUFDWiw4RkFBOEY7WUFDOUYsa0dBQWtHO1lBQ2xHLElBQUlFLGdDQUFnQ1MsU0FBUztnQkFDM0NtQixJQUFBQSwwQkFBVyxFQUFDNUI7WUFDZDtRQUNGLE9BQU87WUFDTCw4QkFBOEI7WUFDOUIsSUFBSUEsZ0NBQWdDUyxTQUFTO2dCQUMzQ2tCLElBQUFBLDBCQUFXLEVBQUMzQjtZQUNkO1lBQ0E0QixJQUFBQSwwQkFBVyxFQUFDOUI7UUFDZDtRQUVBLElBQUlpQixhQUFhO1lBQ2YsK0dBQStHO1lBQy9HWSxJQUFBQSwwQkFBVyxFQUFDbkI7UUFDZCxPQUFPLElBQ0wsQ0FBQ08sZUFDRCxpRkFBaUY7UUFDakZQLG1CQUFtQjlILEtBQUssQ0FBQ3VKLGdCQUFnQixDQUFDLGVBQWUsUUFDekQ7WUFDQSx3QkFBd0I7WUFDeEIsK0dBQStHO1lBQy9HTCxJQUFBQSwwQkFBVyxFQUFDcEI7UUFDZDtJQUNGLE9BQU87UUFDTG1CLElBQUFBLDBCQUFXLEVBQUM3QjtRQUNaLDhCQUE4QjtRQUM5QixJQUFJRSxnQ0FBZ0NTLFNBQVM7WUFDM0NtQixJQUFBQSwwQkFBVyxFQUFDNUI7UUFDZDtRQUNBLCtHQUErRztRQUMvRzRCLElBQUFBLDBCQUFXLEVBQUNwQjtJQUNkO0lBRUEsSUFBSWIsS0FBSy9ELE1BQU0sQ0FBQ0MsTUFBTSxLQUFLLEtBQUsrRCxrQkFBa0I7UUFDaEQsSUFBSXNDLHNCQUFzQmxJLFNBQVNtSSxjQUFjLENBQUN2QztRQUNsRCxJQUFJLENBQUNzQyxxQkFBcUI7WUFDeEJBLHNCQUFzQmxJLFNBQVNvQyxhQUFhLENBQzFDLENBQUMsbUJBQW1CLEVBQUV3RCxpQkFBaUIsRUFBRSxDQUFDO1FBRTlDO1FBQ0EsSUFBSXNDLHFCQUFxQjtZQUN2QkEsb0JBQW9CbEgsS0FBSztRQUMzQjtJQUNGO0FBQ0Y7QUFFQSxNQUFNb0gsNkJBQTZCLENBQ2pDNUgsdUJBQ0FtRixNQUNBL0QsUUFDQXlHLGFBQ0F6QztJQUVBSCxlQUNFakYsdUJBQ0E7UUFDRSxHQUFHbUYsSUFBSTtRQUNQL0QsUUFBUUEsT0FBTzBHLE1BQU0sQ0FBQzNDLEtBQUtsRSxLQUFLLEVBQUU4RyxNQUFNLENBQUNDO0lBQzNDLEdBQ0E1QztJQUdGLElBQUl5QyxhQUFhO1FBQ2ZJLElBQUFBLDBDQUF1QixFQUFDakksdUJBQXVCbUYsTUFBTTBDO0lBQ3ZEO0FBQ0Y7QUFFTyxNQUFNbEssK0JBQStCLENBQzFDZSx3QkFDQTBDLFFBQ0E0QyxjQUNBNkQsYUFDQXpDO0lBRUEsSUFBSTFHLHVCQUF1QjJDLE1BQU0sS0FBSyxHQUFHO1FBQ3ZDO0lBQ0Y7SUFFQTNDLHVCQUF1Qk0sT0FBTyxDQUFDLENBQUNnQjtRQUM5QixNQUFNa0ksZUFBZTtZQUNuQkMsT0FBT0MsSUFBQUEsbUJBQUcsQ0FBQSxDQUFDO1FBQ1QsRUFBRXBJLHNCQUFzQkYsWUFBWSxDQUFDdUkseUJBQWMsRUFBRTtNQUN2RCxDQUFDO1lBQ0RDLGFBQWE7WUFDYiw0RkFBNEY7WUFDNUYseUdBQXlHO1lBQ3pHLDZFQUE2RTtZQUM3RXZELGFBQWE7UUFDZjtRQUNBZixhQUNHbUUsS0FBSyxDQUFDRCxjQUNOSyxJQUFJLENBQUMsQ0FBQ3BEO1lBQ0wsSUFDRUEsS0FBS0EsSUFBSSxJQUNULHlFQUF5RTtZQUN6RUEsS0FBS0EsSUFBSSxDQUFDZSxRQUFRLElBQ2xCLHlFQUF5RTtZQUN6RWYsS0FBS0EsSUFBSSxDQUFDZSxRQUFRLENBQUNDLGFBQWEsSUFDaEMseUVBQXlFO1lBQ3pFaEIsS0FBS0EsSUFBSSxDQUFDZSxRQUFRLENBQUNDLGFBQWEsQ0FBQ0Msd0JBQXdCLEVBQ3pEO2dCQUNBLE1BQU0sRUFDSmpCLE1BQU0sRUFDSix5RUFBeUU7Z0JBQ3pFZSxVQUFVLEVBQ1JDLGVBQWUsRUFDYkMsd0JBQXdCLEVBQ3hCQyxhQUFhLEVBQUNDLGdCQUFnQixFQUFDLEVBQ2hDLEVBQ0YsRUFDRixFQUNGLEdBQUduQjtnQkFFSixNQUFNcUQsaUJBQWlCcEMseUJBQXlCdEQsSUFBSSxDQUNsRCwrRUFBK0U7Z0JBQy9FLENBQUMyRixTQUFXQSxPQUFPQyxRQUFRLEtBQUs7Z0JBRWxDLElBQUksQ0FBQ0Ysa0JBQWtCbEMsa0JBQWtCO29CQUN2QyxNQUFNOUIsS0FBSzRCLHdCQUF3QixDQUFDLEVBQUUsR0FDbENBLHdCQUF3QixDQUFDLEVBQUUsQ0FBQzVCLEVBQUUsR0FDOUI7b0JBQ0osT0FBT3JILGtDQUFrQzZHLGNBQWNRLElBQ3BEK0QsSUFBSSxDQUFDO3dCQUNKLE9BQU9uTCxxQ0FBcUM0RztvQkFDOUMsR0FDQ3VFLElBQUksQ0FBQzt3QkFDSixPQUFPdkUsYUFBYW1FLEtBQUssQ0FBQ0Q7b0JBQzVCLEdBRUNLLElBQUksQ0FBQyxDQUFDSTt3QkFDTGYsMkJBQ0U1SCx1QkFDQTJJLFNBQ0F2SCxRQUNBeUcsYUFDQXpDO29CQUVKO2dCQUNKO1lBQ0Y7WUFDQSxJQUNFRCxLQUFLQSxJQUFJLElBQ1QseUVBQXlFO1lBQ3pFQSxLQUFLQSxJQUFJLENBQUNlLFFBQVEsSUFDbEIseUVBQXlFO1lBQ3pFZixLQUFLQSxJQUFJLENBQUNlLFFBQVEsQ0FBQ0MsYUFBYSxJQUNoQyx5RUFBeUU7WUFDekVoQixLQUFLQSxJQUFJLENBQUNlLFFBQVEsQ0FBQ0MsYUFBYSxDQUFDRSxXQUFXLElBQzVDLHlFQUF5RTtZQUN6RWxCLEtBQUtBLElBQUksQ0FBQ2UsUUFBUSxDQUFDQyxhQUFhLENBQUNFLFdBQVcsQ0FBQ3VDLFlBQVksRUFDekQ7Z0JBQ0EsT0FBT3hMLHFDQUFxQzRHLGNBQ3pDdUUsSUFBSSxDQUFDO29CQUNKLE9BQU92RSxhQUFhbUUsS0FBSyxDQUFDRDtnQkFDNUIsR0FFQ0ssSUFBSSxDQUFDLENBQUNJO29CQUNMZiwyQkFDRTVILHVCQUNBMkksU0FDQXZILFFBQ0F5RyxhQUNBekM7Z0JBRUo7WUFDSixPQUFPO2dCQUNMd0MsMkJBQ0U1SCx1QkFDQW1GLE1BQ0EvRCxRQUNBeUcsYUFDQXpDO1lBRUo7UUFDRixHQUNDeUQsS0FBSyxDQUFDLENBQUN0RjtZQUNObkMsT0FBTzBILElBQUksQ0FBQ3ZGO1lBQ1owQixlQUFlakYsdUJBQXVCO2dCQUFDb0I7WUFBTSxHQUFHZ0U7UUFDbEQ7SUFDSjtBQUNGO0FBRU8sTUFBTXJJLGtDQUFrQyxDQUM3Q2lILGNBQ0FLO0lBS0EsT0FBT0wsYUFBYUUsTUFBTSxDQUFDO1FBQ3pCQyxVQUFVNEUsNkNBQTBCO1FBQ3BDMUU7SUFDRjtBQUNGO0FBRU8sTUFBTTlHLGtDQUFrQyxDQUFDNEg7SUFDOUMsT0FBT0EsUUFBUUEsS0FBS0EsSUFBSSxJQUFJQSxLQUFLQSxJQUFJLENBQUM2RCwyQkFBMkI7QUFDbkU7QUFFTyxNQUFNdkwsZ0NBQWdDLENBQUN3TCxTQUM1Q0EsV0FBV0MsMEJBQWU7QUFFckIsTUFBTXhMLDhCQUE4QixDQUN6Q3lMLE9BQ0FDLFdBQW9CLEtBQUs7SUFFekIsTUFBTUMsY0FBYyxDQUFDLDRCQUE0QixFQUFFRixNQUFNRyxPQUFPLENBQUMsT0FBTyxFQUFFSCxNQUFNSSxLQUFLLENBQUMsQ0FBQztJQUN2RixJQUFJSCxVQUFVO1FBQ1osTUFBTTNILFVBQVU7WUFDZCtILFdBQVc7WUFDWDNKLE1BQU07WUFDTjRKLFFBQVFKO1FBQ1Y7UUFDQS9LLE9BQU9vTCxNQUFNLENBQUNDLFdBQVcsQ0FBQ0MsS0FBS0MsU0FBUyxDQUFDcEksVUFBVW5ELE9BQU93TCxRQUFRLENBQUNDLE1BQU07SUFDM0UsT0FBTztRQUNMekwsT0FBT3dMLFFBQVEsQ0FBQ0UsSUFBSSxHQUFHWDtJQUN6QjtBQUNGO0FBRU8sTUFBTXhNLGdCQUFnQixDQUMzQm1ILGNBQ0FLO0lBSUEsT0FBT0wsYUFBYUUsTUFBTSxDQUFDO1FBQ3pCQyxVQUFVOEYsd0NBQXFCO1FBQy9CNUY7SUFDRjtBQUNGIn0=

}),
54556: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/* globals document, window, CustomEvent */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    addLoadingCallback: function() {
        return addLoadingCallback;
    },
    customDataFormToArray: function() {
        return customDataFormToArray;
    },
    executeLoadingCallbacks: function() {
        return executeLoadingCallbacks;
    },
    fetchOrderStatusFlags: function() {
        return fetchOrderStatusFlags;
    },
    findAllElementsByNodeType: function() {
        return findAllElementsByNodeType;
    },
    findClosestElementByClassName: function() {
        return findClosestElementByClassName;
    },
    findClosestElementByNodeType: function() {
        return findClosestElementByNodeType;
    },
    findClosestElementWithAttribute: function() {
        return findClosestElementWithAttribute;
    },
    findElementByNodeType: function() {
        return findElementByNodeType;
    },
    formToObject: function() {
        return formToObject;
    },
    hasSubscription: function() {
        return hasSubscription;
    },
    hideElement: function() {
        return hideElement;
    },
    isFreeOrder: function() {
        return isFreeOrder;
    },
    isProductionLikeEnv: function() {
        return isProductionLikeEnv;
    },
    isProtocolHttps: function() {
        return isProtocolHttps;
    },
    safeParseJson: function() {
        return safeParseJson;
    },
    setElementLoading: function() {
        return setElementLoading;
    },
    showElement: function() {
        return showElement;
    },
    trackOrder: function() {
        return trackOrder;
    },
    triggerRender: function() {
        return triggerRender;
    }
});
const _graphqltag = /*#__PURE__*/ _interop_require_default(__webpack_require__(28160));
const _constants = __webpack_require__(10873);
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const safeParseJson = (jsonString)=>{
    let json = null;
    try {
        if (jsonString != null) {
            json = JSON.parse(decodeURIComponent(jsonString));
        }
    } catch (e) {
        if (!(e instanceof SyntaxError && e.message.match(/\bJSON\b/i))) {
            throw e;
        }
    } finally{
        return json;
    }
};
const findElementByNodeType = (type, scope = document)=>{
    // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'HTMLElement | null | undefined'.
    return scope.querySelector(`[${_constants.DATA_ATTR_NODE_TYPE}="${type}"]`);
};
const findAllElementsByNodeType = (type, scope = document)=>{
    return Array.from(scope.querySelectorAll(`[${_constants.DATA_ATTR_NODE_TYPE}="${type}"]`));
};
const findClosestElementByNodeType = (nodeType, element)=>{
    let target = element;
    while(target){
        if (target instanceof Element && target.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === nodeType) {
            return target;
        } else {
            // @ts-expect-error - TS2322 - Type 'HTMLElement | null' is not assignable to type 'EventTarget'.
            target = target instanceof Element ? target.parentElement : null;
        }
    }
    return target;
};
const findClosestElementWithAttribute = (dataAttribute, element)=>{
    let target = element;
    while(target){
        if (target instanceof Element && target.hasAttribute(dataAttribute)) {
            return target;
        } else {
            // @ts-expect-error - TS2322 - Type 'HTMLElement | null' is not assignable to type 'EventTarget'.
            target = target instanceof Element ? target.parentElement : null;
        }
    }
    return target;
};
const findClosestElementByClassName = (className, element)=>{
    let target = element;
    while(target){
        if (target instanceof Element && target.classList.contains(className)) {
            return target;
        } else {
            // @ts-expect-error - TS2322 - Type 'HTMLElement | null' is not assignable to type 'EventTarget'.
            target = target instanceof Element ? target.parentElement : null;
        }
    }
    return target;
};
const triggerRender = (error, isInitial = false)=>{
    const renderEvent = new CustomEvent(_constants.RENDER_TREE_EVENT, {
        detail: {
            error,
            isInitial
        }
    });
    window.dispatchEvent(renderEvent);
};
const isProductionLikeEnv = ()=> true || 0;
const isProtocolHttps = ()=>!isProductionLikeEnv() || window.location.protocol === 'https:';
const formToObject = (form, toString)=>{
    const values = {};
    // @ts-expect-error - TS2345 - Argument of type '(element: ElementWithValue) => void' is not assignable to parameter of type '(value: Element, index: number, array: Element[]) => void'.
    Array.from(form.elements).forEach((element)=>{
        const name = element.getAttribute('name');
        if (name && name !== '') {
            const value = toString ? String(element.value).trim() : element.value;
            values[name] = value == null || value === '' ? null : value;
        }
    });
    return values;
};
const customDataFormToArray = (form)=>{
    // @ts-expect-error - TS7034 - Variable 'customData' implicitly has type 'any[]' in some locations where its type cannot be determined.
    const customData = [];
    if (!form || !(form instanceof HTMLFormElement)) {
        // @ts-expect-error - TS7005 - Variable 'customData' implicitly has an 'any[]' type.
        return customData;
    }
    Array.from(form.elements).forEach(// @ts-expect-error - TS2345 - Argument of type '(element: HTMLElement | HTMLInputElement | HTMLTextAreaElement) => void' is not assignable to parameter of type '(value: Element, index: number, array: Element[]) => void'.
    (element)=>{
        const name = element.getAttribute('name');
        if (element instanceof HTMLTextAreaElement && element.value) {
            customData.push({
                name: name ? name : 'Textarea',
                textArea: element.value
            });
        } else if (element instanceof HTMLInputElement) {
            if (element.type === 'checkbox') {
                customData.push({
                    name: name ? name : 'Checkbox',
                    checkbox: element.checked
                });
            } else if (element.value) {
                customData.push({
                    name: name ? name : 'Text Input',
                    textInput: element.value
                });
            }
        }
    });
    // @ts-expect-error - TS7005 - Variable 'customData' implicitly has an 'any[]' type.
    return customData;
};
const setElementLoading = (el)=>{
    // @ts-expect-error - TS2339 - Property 'Webflow' does not exist on type 'Window & typeof globalThis'.
    const tr = window.Webflow.tram(el);
    tr.set({
        opacity: 0.2
    });
    tr.add('opacity 500ms ease-in-out');
    const animate = ()=>{
        tr.start({
            opacity: 0.2
        }).then({
            opacity: 0.4
        }).then(animate);
    };
    animate();
    return ()=>tr.destroy();
};
const loadingCallbacks = [];
const addLoadingCallback = (cb)=>{
    loadingCallbacks.push(cb);
};
const executeLoadingCallbacks = ()=>{
    let finishLoading;
    while((finishLoading = loadingCallbacks.shift()) !== undefined){
        finishLoading();
    }
};
const isFreeOrder = (response)=>response && response.data && response.data.database && response.data.database.commerceOrder && response.data.database.commerceOrder.statusFlags && response.data.database.commerceOrder.statusFlags.isFreeOrder === true;
const hasSubscription = (response)=>response && response.data && response.data.database && response.data.database.commerceOrder && response.data.database.commerceOrder.statusFlags && response.data.database.commerceOrder.statusFlags.hasSubscription === true;
const showElement = (element)=>element.style.removeProperty('display');
const hideElement = (element)=>element.style.setProperty('display', 'none');
// the @client directive ensures we only fetch this from the local cache so that we don't wait on network
// we can only use this safely inside a rendered cart/checkout/confirmation container
// as to render that view, a query had to be made which *always* includes the flags listed below.
// if you are adding new flags to this, please ensure that the flags are *always* included
// for all types of commerce elements in `packages/systems/dynamo/utils/DynamoQuery/DynamoQuery.js`
const orderStatusFlagsQuery = (0, _graphqltag.default)`
  query FetchCartInfo {
    database @client {
      id
      commerceOrder {
        id
        statusFlags {
          requiresShipping
          isFreeOrder
          hasSubscription
        }
      }
    }
  }
`;
const fetchOrderStatusFlags = (apolloClient)=>apolloClient.query({
        query: orderStatusFlagsQuery
    }).then((data)=>{
        return data && data.data && // @ts-expect-error - TS2339: Property database does not exist on type {}
        data.data.database && // @ts-expect-error - TS2339: Property database does not exist on type {}
        data.data.database.commerceOrder && // @ts-expect-error - TS2339: Property database does not exist on type {}
        data.data.database.commerceOrder.statusFlags;
    });
const acceptedOrderDataQuery = (0, _graphqltag.default)`
  query FetchAcceptedOrderData(
    $finalizedOrder: commerce_order_finalized_order_args
  ) {
    database {
      id
      commerceOrder(finalizedOrder: $finalizedOrder) {
        id
        total {
          decimalValue
          unit
        }
        userItems {
          id
          count
          product {
            id
            f_name_
          }
          sku {
            id
          }
          price {
            decimalValue
          }
        }
      }
    }
  }
`;
const fetchAcceptedOrderData = (apolloClient, finalizedOrder)=>apolloClient.query({
        query: acceptedOrderDataQuery,
        variables: {
            finalizedOrder
        }
    })// @ts-expect-error - TS2339: Property database does not exist on type {}
    .then((data)=>data?.data?.database?.commerceOrder);
const trackOrder = (apolloClient, finalizedOrder)=>{
    // early return if both facebook and google don't exist on the page
    // we don't need to fetch this data if we're not doing any analytics
    if (typeof fbq === 'undefined' && typeof gtag === 'undefined') {
        return;
    }
    // check to see if this order was tracked already, and if it was, return early
    let trackedOrders = {};
    try {
        const storedTrackedOrders = window.localStorage.getItem('wf-seen-orders');
        if (storedTrackedOrders) {
            trackedOrders = JSON.parse(storedTrackedOrders);
        }
    } catch (err) {
        return;
    }
    if (trackedOrders[finalizedOrder.orderId]) {
        return;
    }
    // we have to fetch the accepted order data, instead of relying on the pending order data
    // that's fetched on the order confirmation page, because we only get the purchased items
    // data if the user has an Order Items element on the page. while i would presume that most
    // people would keep that element on the page, it's not a guarantee, so we need to separately
    // fetch it here to ensure that we always send the analytics, regardless of how the user has
    // customized their order confirmation page.
    fetchAcceptedOrderData(apolloClient, finalizedOrder).then((order)=>{
        if (!order) {
            return;
        }
        const { decimalValue, unit } = order.total;
        if (typeof fbq !== 'undefined' && typeof fbq === 'function') {
            fbq('track', 'Purchase', {
                value: decimalValue,
                currency: unit,
                // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
                content_ids: (order.userItems || []).map((item)=>item.sku.id),
                content_type: 'product',
                // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
                contents: (order.userItems || []).map((item)=>({
                        id: item.sku.id,
                        quantity: item.count,
                        item_price: item.price.decimalValue
                    }))
            });
        }
        if (typeof gtag !== 'undefined' && typeof gtag === 'function') {
            gtag('event', 'purchase', {
                transaction_id: order.id,
                value: decimalValue,
                currency: unit,
                // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
                items: (order.userItems || []).map((item)=>({
                        id: item.sku.id,
                        name: item.product.f_name_,
                        quantity: item.count,
                        price: item.price.decimalValue
                    }))
            });
        }
        trackedOrders[finalizedOrder.orderId] = true;
        try {
            window.localStorage.setItem('wf-seen-orders', JSON.stringify(trackedOrders));
        } catch (err) {
            return;
        }
    });
};

//# sourceMappingURL=data:application/json;base64,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

}),
14155: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "PillGroups", ({
    enumerable: true,
    get: function() {
        return PillGroups;
    }
}));
const _constants = __webpack_require__(10873);
const KEY_CODES = Object.freeze({
    RETURN: 13,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40
});
class PillGroups {
    form;
    pillGroups;
    onSelect;
    static hasPillGroups(form) {
        return form.querySelectorAll(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_PILL_GROUP}"]`).length > 0;
    }
    constructor(form, onSelect){
        this.form = form;
        this.pillGroups = {};
        this.onSelect = onSelect;
    }
    init() {
        const groupNodes = this.form.querySelectorAll(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_PILL_GROUP}"]`);
        for (const group of groupNodes){
            // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
            const pillGroup = new PillGroup(group, this.onSelect, this);
            pillGroup.init();
            this.pillGroups[pillGroup.optionSetId] = pillGroup;
        }
    }
    setSelectedPillsForSkuValues(skuValues) {
        for (const optionSetId of Object.keys(skuValues)){
            const optionId = skuValues[optionSetId];
            const pillGroup = this.pillGroups[optionSetId];
            if (pillGroup) {
                const pill = pillGroup.findPillById(String(optionId));
                pillGroup.updatePillsWithNewSelected(pill);
            }
        }
    }
}
class PillGroup {
    node;
    optionSetId;
    onSelect;
    pills;
    groups;
    constructor(node, onSelect, groups){
        this.node = node;
        this.optionSetId = String(node.getAttribute(_constants.DATA_ATTR_COMMERCE_OPTION_SET_ID));
        this.onSelect = onSelect;
        this.pills = [];
        this.groups = groups;
    }
    get firstEnabledPill() {
        // find returns the first one it finds, and the pills are in order
        return this.pills.find((pill)=>pill.disabled === false);
    }
    // hacky fake option set compat
    get value() {
        const possiblePill = this.pills.find((pill)=>pill.checked === true);
        return possiblePill ? possiblePill.value : '';
    }
    // hacky fake option set compat
    get options() {
        return this.pills;
    }
    // hacky fake option set compat
    // eslint-disable-next-line accessor-pairs
    set selectedIndex(index) {
        const pill = this.pills[index] || null;
        // @ts-expect-error - TS2345 - Argument of type 'Pill | null' is not assignable to parameter of type 'Pill'.
        this.emitSelected(pill);
    }
    // hacky fake option set compat
    // we only want to support the one DOM attribute, which we have on this group, just not
    // directly exposed, as we don't directly expose the DOM element for the group
    getAttribute(attr) {
        if (attr === _constants.DATA_ATTR_COMMERCE_OPTION_SET_ID) {
            return this.optionSetId;
        } else {
            throw new Error(`PillGroup: Attempted to fetch unsupported attribute ${attr}`);
        }
    }
    init() {
        const pills = this.node.querySelectorAll(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_PILL}"]`);
        this.pills = Array.from(pills).map((pillNode)=>{
            // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
            const pill = new Pill(pillNode, this);
            pill.init();
            return pill;
        });
        // if this group has any enabled pills, we set the first one's tab index so it can be focused
        if (this.firstEnabledPill) {
            this.firstEnabledPill.tabIndex = 0;
        }
        // @zach: store reference to this group on the node so we can access it later
        // we shouldn't be doing this but it's a lot easier than creating some global store
        // i tried the global store method first but the problem is our instance IDs are just the product IDs
        // so if you have two ATCs for the same product, they'd overwrite each other, and only one option list would work
        // so just storing it on the DOM element, and then grabbing it when updating all the option sets is a lot easier :)
        // @ts-expect-error - TS2339 - Property '_wfPillGroup' does not exist on type 'HTMLElement'.
        this.node._wfPillGroup = this;
    }
    findPillById(optionId) {
        return this.pills.find((pill)=>pill.optionId === optionId);
    }
    updatePillsWithNewSelected(selectedPill) {
        // we unselect all of the pills in the pill group
        for (const pill of this.pills){
            pill.tabIndex = -1;
            pill.checked = false;
        }
        if (selectedPill instanceof Pill) {
            // if passed a pill, we give it the proper tab index, and set the aria checked
            selectedPill.tabIndex = 0;
            selectedPill.checked = true;
        } else {
            // if not passed a pill, we're deselecting any option in this group
            // so we call set the tabIndex to the first enabled pill,
            // so tab focus goes back to the first pill on the next enter
            if (this.firstEnabledPill) {
                this.firstEnabledPill.tabIndex = 0;
            }
        }
    }
    emitSelected(selectedPill) {
        this.onSelect({
            optionId: selectedPill.optionId,
            optionSetId: this.optionSetId,
            groups: Object.values(this.groups.pillGroups)
        });
    }
    traverseAndEmitSelected(currentPill, direction) {
        const currentIndex = this.pills.indexOf(currentPill);
        let found = false;
        let idx = currentIndex;
        let nextIndex;
        while(!found){
            if (direction === 'previous') {
                nextIndex = idx - 1;
                // if we reached the start of the list, go to the end
                if (nextIndex < 0) {
                    nextIndex = this.pills.length - 1;
                }
            } else if (direction === 'next') {
                nextIndex = idx + 1;
                // if we reached the end of the list, go to the start
                if (nextIndex === this.pills.length) {
                    nextIndex = 0;
                }
            } else {
                throw new Error(`Unknown pill traversal direction "${direction}", use "previous" or "next"`);
            }
            // if we're back at the pill we started with, we went through the entire list
            // and didn't find any other enabled pills, so we keep this one selected
            if (nextIndex === currentIndex) {
                break;
            }
            const pill = this.pills[nextIndex];
            // @ts-expect-error - TS18048 - 'pill' is possibly 'undefined'.
            if (!pill.disabled) {
                // if the next pill is enabled, we emit it as selected, focus it now that we know what pill should be
                // and finally, break the loop
                // @ts-expect-error - TS2345 - Argument of type 'Pill | undefined' is not assignable to parameter of type 'Pill'.
                this.emitSelected(pill);
                // @ts-expect-error - TS18048 - 'pill' is possibly 'undefined'.
                pill.focus();
                found = true;
            } else {
                // otherwise, we increment our loop index, so we can start the loop again
                // and check the next pill
                idx = nextIndex;
            }
        }
    }
}
class Pill {
    node;
    optionId;
    group;
    constructor(node, group){
        this.node = node;
        this.optionId = String(this.node.getAttribute('data-option-id'));
        this.group = group;
    }
    init() {
        this.tabIndex = -1;
        this.checked = false;
        this.node.addEventListener('keydown', this.handleKeyDown);
        this.node.addEventListener('click', this.handleClick);
    }
    get tabIndex() {
        return this.node.tabIndex;
    }
    set tabIndex(index) {
        this.node.tabIndex = index;
    }
    get value() {
        return this.optionId;
    }
    get checked() {
        return this.node.getAttribute('aria-checked') === 'true';
    }
    set checked(checked) {
        this.node.setAttribute('aria-checked', String(checked));
        if (checked) {
            this.node.classList.add('w--ecommerce-pill-selected');
        } else {
            this.node.classList.remove('w--ecommerce-pill-selected');
        }
    }
    get disabled() {
        return this.node.getAttribute('aria-disabled') === 'true';
    }
    set disabled(disabled) {
        this.node.setAttribute('aria-disabled', String(disabled));
        if (disabled) {
            // if we pragmatically disable a pill, we want to make sure it's not checked
            // and that it can't be focused by the browser
            this.node.classList.add('w--ecommerce-pill-disabled');
            this.checked = false;
            this.tabIndex = -1;
        } else {
            this.node.classList.remove('w--ecommerce-pill-disabled');
        }
    }
    get enabled() {
        return !this.disabled;
    }
    set enabled(enabled) {
        this.disabled = !enabled;
    }
    focus() {
        this.node.focus();
    }
    handleKeyDown = (ev)=>{
        let eventHandled = false;
        // we don't want to handle events when holding down alt or cmd
        // as these are navigation shortcuts that we don't want to break
        if (ev.altKey || ev.metaKey) {
            return;
        }
        switch(ev.keyCode){
            // return and space should act like a click on the pill, selecting/deselecting as needed
            case KEY_CODES.RETURN:
            case KEY_CODES.SPACE:
                this.handleClick();
                eventHandled = true;
                break;
            // up and left go to the previous pill in the group
            case KEY_CODES.UP:
            case KEY_CODES.LEFT:
                this.group.traverseAndEmitSelected(this, 'previous');
                eventHandled = true;
                break;
            // down and right go to the next pill in the group
            case KEY_CODES.DOWN:
            case KEY_CODES.RIGHT:
                this.group.traverseAndEmitSelected(this, 'next');
                eventHandled = true;
                break;
            default:
                break;
        }
        // we only want to stop keyboard events for the keys we're trying to intercept
        if (eventHandled) {
            ev.stopPropagation();
            ev.preventDefault();
        }
    };
    handleClick = ()=>{
        if (this.disabled || this.checked) {
            return;
        }
        this.focus();
        this.group.emitSelected(this);
    };
}

//# sourceMappingURL=data:application/json;base64,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

}),
85986: (function (__unused_webpack_module, exports) {
"use strict";
// Added a Flow type here since
// our bundle builder when stripping Flow types
// uses a newer version of flow-parser (0.203)
// which requires a variable declaration to have
// a type
// eslint-disable-next-line no-var

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
const _default = {
    log: (...args)=>{
        if (false) {}
    },
    error: (...args)=>{
        if (false) {}
    }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImRlYnVnLnRzIl0sInNvdXJjZXNDb250ZW50IjpbIi8vIEFkZGVkIGEgRmxvdyB0eXBlIGhlcmUgc2luY2Vcbi8vIG91ciBidW5kbGUgYnVpbGRlciB3aGVuIHN0cmlwcGluZyBGbG93IHR5cGVzXG4vLyB1c2VzIGEgbmV3ZXIgdmVyc2lvbiBvZiBmbG93LXBhcnNlciAoMC4yMDMpXG4vLyB3aGljaCByZXF1aXJlcyBhIHZhcmlhYmxlIGRlY2xhcmF0aW9uIHRvIGhhdmVcbi8vIGEgdHlwZVxuLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIG5vLXZhclxuZGVjbGFyZSB2YXIgcHJvY2VzczogYW55O1xuXG5leHBvcnQgZGVmYXVsdCB7XG4gIGxvZzogKC4uLmFyZ3M6IEFycmF5PHVua25vd24+KSA9PiB7XG4gICAgaWYgKHByb2Nlc3MuZW52Lk5PREVfRU5WID09PSAnZGV2ZWxvcG1lbnQnKSB7XG4gICAgICBjb25zb2xlLmxvZyguLi5hcmdzKTtcbiAgICB9XG4gIH0sXG4gIGVycm9yOiAoLi4uYXJnczogQXJyYXk8dW5rbm93bj4pID0+IHtcbiAgICBpZiAocHJvY2Vzcy5lbnYuTk9ERV9FTlYgPT09ICdkZXZlbG9wbWVudCcpIHtcbiAgICAgIGNvbnNvbGUubG9nKC4uLmFyZ3MpO1xuICAgIH1cbiAgfSxcbn07XG4iXSwibmFtZXMiOlsibG9nIiwiYXJncyIsInByb2Nlc3MiLCJlbnYiLCJOT0RFX0VOViIsImNvbnNvbGUiLCJlcnJvciJdLCJtYXBwaW5ncyI6IkFBQUEsK0JBQStCO0FBQy9CLCtDQUErQztBQUMvQyw4Q0FBOEM7QUFDOUMsZ0RBQWdEO0FBQ2hELFNBQVM7QUFDVCxrQ0FBa0M7Ozs7OytCQUdsQzs7O2VBQUE7OztNQUFBLFdBQWU7SUFDYkEsS0FBSyxDQUFDLEdBQUdDO1FBQ1AsSUFBSUMsUUFBUUMsR0FBRyxDQUFDQyxRQUFRLEtBQUssZUFBZTtZQUMxQ0MsUUFBUUwsR0FBRyxJQUFJQztRQUNqQjtJQUNGO0lBQ0FLLE9BQU8sQ0FBQyxHQUFHTDtRQUNULElBQUlDLFFBQVFDLEdBQUcsQ0FBQ0MsUUFBUSxLQUFLLGVBQWU7WUFDMUNDLFFBQVFMLEdBQUcsSUFBSUM7UUFDakI7SUFDRjtBQUNGIn0=

}),
48873: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return EventHandlerProxyWithApolloClient;
    }
}));
// @ts-expect-error - TS7023 - 'enumeratePrototypeProps' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions.
const enumeratePrototypeProps = (obj, propNames = [])=>{
    if (obj == null) {
        return propNames;
    }
    return propNames.concat(enumeratePrototypeProps(Object.getPrototypeOf(obj)))// @ts-expect-error - TS2769 - No overload matches this call.
    .concat(Object.keys(obj));
};
const createEventProxy = (event, currentTarget)=>{
    // @ts-expect-error - TS2347 - Untyped function calls may not accept type arguments.
    const propertyDefinitions = enumeratePrototypeProps(event)// @ts-expect-error - TS7006 - Parameter 'propName' implicitly has an 'any' type.
    .filter((propName)=>propName !== 'currentTarget')// @ts-expect-error - TS7006 - Parameter 'proxies' implicitly has an 'any' type. | TS7006 - Parameter 'propName' implicitly has an 'any' type.
    .reduce((proxies, propName)=>{
        proxies[propName] = // @ts-expect-error Object.keys is "unsound", always infers `string` as output
        typeof event[propName] === 'function' ? // @ts-expect-error Object.keys is "unsound", always infers `string` as output
        {
            value: (...args)=>event[propName](...args)
        } : // @ts-expect-error Object.keys is "unsound", always infers `string` as output
        {
            get: ()=>event[propName]
        };
        return proxies;
    }, {});
    const retargetedEvent = Object.create(event, {
        // set currentTarget to the matched node:
        currentTarget: {
            value: currentTarget
        },
        ...propertyDefinitions
    });
    return retargetedEvent;
};
class EventHandlerProxyWithApolloClient {
    apolloClient;
    stripeStore;
    eventHandlers;
    constructor(apolloClient, stripeStore){
        this.eventHandlers = {};
        this.apolloClient = apolloClient;
        this.stripeStore = stripeStore;
    }
    on = (eventName, eventMatcher, handler)=>{
        const existingHandlers = this.eventHandlers[eventName] instanceof Array ? this.eventHandlers[eventName] : [];
        this.eventHandlers[eventName] = [
            ...existingHandlers,
            this.createHandlerProxy(eventName, eventMatcher, handler)
        ];
        return this;
    };
    createHandlerProxy = (eventName, eventMatcher, handler)=>(event)=>{
            const match = eventMatcher(event);
            const eventProxy = match instanceof Element ? createEventProxy(event, match) : event;
            if (match) {
                handler(eventProxy, this.apolloClient, this.stripeStore);
            }
        };
    attachHandlers = (target)=>{
        Object.keys(this.eventHandlers).forEach((eventName)=>{
            const handlerProxies = this.eventHandlers[eventName];
            // @ts-expect-error - TS18048 - 'handlerProxies' is possibly 'undefined'.
            handlerProxies.forEach((handlerProxy)=>target.addEventListener(eventName, handlerProxy, true));
        });
        return this;
    };
    removeHandlers = (target)=>{
        Object.keys(this.eventHandlers).forEach((eventName)=>{
            const handlerProxies = this.eventHandlers[eventName];
            // @ts-expect-error - TS18048 - 'handlerProxies' is possibly 'undefined'.
            handlerProxies.forEach((handlerProxy)=>target.removeEventListener(eventName, handlerProxy, true));
        });
        return this;
    };
}

//# sourceMappingURL=data:application/json;base64,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

}),
2330: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/* globals window, document */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    design: function() {
        return design;
    },
    destroy: function() {
        return destroy;
    },
    init: function() {
        return init;
    },
    preview: function() {
        return preview;
    }
});
__webpack_require__(84037);
__webpack_require__(68259);
__webpack_require__(60033);
__webpack_require__(9246);
__webpack_require__(67321);
__webpack_require__(52897);
__webpack_require__(233);
__webpack_require__(49754);
__webpack_require__(30971);
__webpack_require__(62374);
__webpack_require__(55152);
__webpack_require__(35273);
__webpack_require__(30172);
__webpack_require__(65723);
__webpack_require__(48258);
__webpack_require__(89433);
const _apolloClient = __webpack_require__(25195);
const _eventHandlerProxyWithApolloClient = /*#__PURE__*/ _interop_require_default(__webpack_require__(48873));
const _addToCartEvents = /*#__PURE__*/ _interop_require_default(__webpack_require__(84303));
const _cartEvents = /*#__PURE__*/ _interop_require_default(__webpack_require__(82150));
const _checkoutEvents = /*#__PURE__*/ _interop_require_default(__webpack_require__(82333));
const _orderConfirmationEvents = /*#__PURE__*/ _interop_require_default(__webpack_require__(45870));
const _webPaymentsEvents = /*#__PURE__*/ _interop_require_default(__webpack_require__(94492));
const _stripeStore = __webpack_require__(5841);
const _commerceUtils = __webpack_require__(54556);
__webpack_require__(67304);
__webpack_require__(14362);
const _checkoutUtils = __webpack_require__(17696);
const _paypalEvents = /*#__PURE__*/ _interop_require_wildcard(__webpack_require__(86365));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const GQL_QUERY_PATH = '/.wf_graphql/apollo';
// @ts-expect-error - TS7034 - Variable 'handlerProxy' implicitly has type 'any' in some locations where its type cannot be determined.
let handlerProxy;
// @ts-expect-error - TS7034 - Variable 'apolloClient' implicitly has type 'any' in some locations where its type cannot be determined.
let apolloClient;
let stripeStore;
function attachHandlers() {
    // @ts-expect-error - TS7005 - Variable 'handlerProxy' implicitly has an 'any' type.
    handlerProxy && handlerProxy.attachHandlers(window);
}
function detachHandlers() {
    // @ts-expect-error - TS7005 - Variable 'handlerProxy' implicitly has an 'any' type.
    handlerProxy && handlerProxy.removeHandlers(window);
}
// Can be called from published sites or the Designer engine
// Published sites: call point is defined in /models/site.js
// Designer: call point is in CommerceProxyEngine
function init({ siteId }) {
    const designerOrPreview = window.Webflow.env('design') || window.Webflow.env('preview');
    apolloClient = (0, _apolloClient.createApolloClient)({
        path: designerOrPreview ? `/api/v2/sites/${siteId}/apollo` : GQL_QUERY_PATH,
        retryConfig: {
            maxAttempts: 5
        },
        useCsrf: true,
        // Disable batching with reverse proxy. Solves an edge case in E-commerce
        // where legacy and new queries are mixed in the same batch.
        disableBatching: !designerOrPreview
    });
    stripeStore = new _stripeStore.StripeStore(document);
    handlerProxy = new _eventHandlerProxyWithApolloClient.default(apolloClient, stripeStore);
    _addToCartEvents.default.register(handlerProxy);
    _cartEvents.default.register(handlerProxy);
    _checkoutEvents.default.register(handlerProxy);
    _orderConfirmationEvents.default.register(handlerProxy);
    _webPaymentsEvents.default.register(handlerProxy);
    _paypalEvents.default.register(handlerProxy);
    (0, _checkoutUtils.initializeStripeElements)(stripeStore);
    detachHandlers();
    attachHandlers();
    (0, _commerceUtils.triggerRender)(null, true);
    // @ts-expect-error - TS2339 - Property 'Webflow' does not exist on type 'Window & typeof globalThis'.
    if (!window.Webflow.env()) {
        // @ts-expect-error - TS2339 - Property 'Webflow' does not exist on type 'Window & typeof globalThis'.
        window.Webflow.load((0, _paypalEvents.renderPaypalButtons)(apolloClient));
    }
}
// `preview` should always be called after `init`
function preview() {
    detachHandlers();
    attachHandlers();
    (0, _commerceUtils.triggerRender)(null, true);
}
// `design` should always be called after `init`
function design() {
    detachHandlers();
    // When variant option is changed, we need to reset the Apollo cache in oder to
    // render the right data for the selected variant (main-images, more-images, etc)
    // @ts-expect-error - TS7005 - Variable 'apolloClient' implicitly has an 'any' type.
    if (apolloClient && apolloClient.store) {
        apolloClient.resetStore();
    }
}
function destroy() {
    detachHandlers();
}

//# sourceMappingURL=data:application/json;base64,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

}),
45870: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/* globals window, CustomEvent */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    register: function() {
        return register;
    }
});
const _graphqltag = /*#__PURE__*/ _interop_require_default(__webpack_require__(28160));
const _qs = /*#__PURE__*/ _interop_require_default(__webpack_require__(26882));
const _commerceUtils = __webpack_require__(54556);
const _rendering = __webpack_require__(91898);
const _constants = __webpack_require__(10873);
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const renderOrderConfirmation = (orderConfirmation, data)=>{
    (0, _rendering.renderTree)(orderConfirmation, data);
};
const handleRenderOrderConfirmation = (event, apolloClient)=>{
    if (window.Webflow.env('design') || window.Webflow.env('preview')) {
        return;
    }
    if (!(event instanceof CustomEvent && event.type === _constants.RENDER_TREE_EVENT)) {
        return;
    }
    const errors = [];
    const { detail } = event;
    if (detail != null && detail.error) {
        errors.push(detail.error);
    }
    const orderConfirmationContainer = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_ORDER_CONFIRMATION_WRAPPER);
    if (!orderConfirmationContainer) {
        return;
    }
    const { orderId, token } = _qs.default.parse(window.location.search.substring(1));
    if (!orderId || !token) {
        return;
    }
    const finalizedOrder = {
        orderId,
        token
    };
    // runs the analytics (facebook and google pixel)
    // we don't block on it, since this isn't needed for any rendering
    // so it if fails, it can just fail silently
    (0, _commerceUtils.trackOrder)(apolloClient, finalizedOrder);
    const allOrderConfirmationContainers = (0, _commerceUtils.findAllElementsByNodeType)(_constants.NODE_TYPE_COMMERCE_ORDER_CONFIRMATION_WRAPPER);
    apolloClient.query({
        query: (0, _graphqltag.default)`
        ${orderConfirmationContainer.getAttribute(_constants.ORDER_QUERY)}
      `,
        variables: {
            finalizedOrder
        },
        fetchPolicy: 'network-only',
        // errorPolicy is set to `all` so that we continue to get the cart data when an error occurs
        // this is important in cases like when the address entered doesn't have a shipping zone, as that returns
        // a graphQL error, but we still want to render what the customer has entered
        errorPolicy: 'all'
    }).then((data)=>{
        allOrderConfirmationContainers.forEach((orderConfirmationContainerNode)=>{
            renderOrderConfirmation(orderConfirmationContainerNode, {
                ...data,
                errors: errors.concat(data.error).filter(Boolean)
            });
        });
    }).catch((err)=>{
        errors.push(err);
        allOrderConfirmationContainers.forEach((orderConfirmationContainerNode)=>{
            renderOrderConfirmation(orderConfirmationContainerNode, {
                errors
            });
        });
    });
};
const register = (handlerProxy)=>{
    handlerProxy.on(_constants.RENDER_TREE_EVENT, Boolean, handleRenderOrderConfirmation);
};
const _default = {
    register
};

//# sourceMappingURL=data:application/json;base64,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

}),
86365: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/* global window, document, Element, CustomEvent, HTMLElement, HTMLFormElement */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    renderPaypalButtons: function() {
        return renderPaypalButtons;
    }
});
const _commerceUtils = __webpack_require__(54556);
const _checkoutUtils = __webpack_require__(17696);
const _cartUtils = __webpack_require__(69773);
const _debug = /*#__PURE__*/ _interop_require_default(__webpack_require__(85986));
const _checkoutMutations = __webpack_require__(94797);
const _constants = __webpack_require__(10873);
const _client = __webpack_require__(22805);
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// @ts-expect-error - TS7031 - Binding element 'target' implicitly has an 'any' type.
const isPlaceOrderButtonEvent = ({ target })=>{
    const placeOrderButton = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_PLACE_ORDER_BUTTON, target);
    if (placeOrderButton && target instanceof Element) {
        return target;
    } else {
        return false;
    }
};
let hasSyncedWithPaypal = false;
const handleRenderPayPalCheckout = (event, apolloClient)=>{
    if (window.Webflow.env('design') || window.Webflow.env('preview')) {
        return;
    }
    if (!(event instanceof CustomEvent && event.type === _constants.RENDER_TREE_EVENT)) {
        return;
    }
    const checkoutFormContainers = (0, _commerceUtils.findAllElementsByNodeType)(_constants.NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_FORM_CONTAINER);
    if (!checkoutFormContainers || checkoutFormContainers.length === 0) {
        return;
    }
    const errors = [];
    const { detail } = event;
    if (detail != null && detail.error) {
        errors.push(detail.error);
    }
    const focusedEle = window.document.activeElement;
    const checkoutForm = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_FORM_CONTAINER, // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'EventTarget'.
    focusedEle);
    let prevFocusedInput = null;
    // Only trigger for focused elements in a checkout form
    if (focusedEle instanceof HTMLInputElement && checkoutForm) {
        prevFocusedInput = focusedEle.id;
        if (!prevFocusedInput) {
            prevFocusedInput = focusedEle.getAttribute('data-wf-bindings');
        }
        // Move from empty string to null
        prevFocusedInput = prevFocusedInput ? null : prevFocusedInput;
    }
    const syncWithPayPalIfNeeded = !hasSyncedWithPaypal ? apolloClient.mutate({
        mutation: _checkoutMutations.syncPayPalOrderInfo
    }) : Promise.resolve();
    syncWithPayPalIfNeeded.then(()=>{
        hasSyncedWithPaypal = true;
        (0, _checkoutUtils.renderCheckoutFormContainers)(checkoutFormContainers, errors, apolloClient, undefined, prevFocusedInput);
    });
};
let placingOrder = false;
const startOrderFlow = (placeOrderButton)=>{
    placingOrder = true;
    window.addEventListener('beforeunload', _checkoutUtils.beforeUnloadHandler);
    const buttonText = placeOrderButton.innerHTML;
    const loadingText = placeOrderButton.getAttribute(_constants.DATA_ATTR_LOADING_TEXT);
    placeOrderButton.innerHTML = loadingText ? loadingText : _constants.CHECKOUT_PLACE_ORDER_LOADING_TEXT_DEFAULT;
    const finishOrderFlow = (isRedirecting = false)=>{
        // we only set `placingOrder` to false if we're not redirecting to the
        // confirmation page. this is so that while waiting for the confirmation
        // page to load, the user can't attempt to submit the order again
        if (!isRedirecting) {
            placingOrder = false;
        }
        window.removeEventListener('beforeunload', _checkoutUtils.beforeUnloadHandler);
        placeOrderButton.innerHTML = buttonText ? buttonText : _constants.CHECKOUT_PLACE_ORDER_BUTTON_TEXT_DEFAULT;
    };
    return finishOrderFlow;
};
const checkFormValidity = ({ shippingInfo, additionalInfo, requiresShipping })=>{
    if (!HTMLFormElement.prototype.reportValidity) {
        return true;
    }
    if (requiresShipping && !shippingInfo.reportValidity() || additionalInfo && additionalInfo instanceof HTMLFormElement && !additionalInfo.reportValidity()) {
        return false;
    }
    return true;
};
const handlePlaceOrder = (event, apolloClient)=>{
    // Want to skip placing order if in design/preview mode, or an order place is in progress
    if (window.Webflow.env('design') || window.Webflow.env('preview') || placingOrder) {
        return;
    }
    const { currentTarget } = event;
    if (!(currentTarget instanceof Element)) {
        return;
    }
    const checkoutFormContainer = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_FORM_CONTAINER, currentTarget);
    if (!(checkoutFormContainer instanceof Element)) {
        return;
    }
    const errorState = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_ERROR_STATE, checkoutFormContainer);
    const shippingInfo = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_WRAPPER, checkoutFormContainer);
    const placeOrderButton = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_PLACE_ORDER_BUTTON, checkoutFormContainer);
    const additionalInfo = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_ADDITIONAL_INFO, checkoutFormContainer);
    if (!(errorState instanceof HTMLElement) || !(shippingInfo instanceof HTMLFormElement) || !(placeOrderButton instanceof Element)) {
        return;
    }
    const errorMessage = errorState.querySelector(_constants.CART_CHECKOUT_ERROR_MESSAGE_SELECTOR);
    // If the error message has this attribute, we want to block the order from
    // being submitted as the user is being forced to refresh the checkout page.
    if (errorMessage && errorMessage.hasAttribute(_constants.NEEDS_REFRESH)) {
        return;
    }
    const hasAdditionalInfo = additionalInfo && additionalInfo instanceof HTMLElement;
    const finishOrderFlow = startOrderFlow(placeOrderButton);
    errorState.style.setProperty('display', 'none');
    (0, _commerceUtils.fetchOrderStatusFlags)(apolloClient).then(({ requiresShipping })=>{
        const isFormValid = checkFormValidity({
            shippingInfo,
            additionalInfo,
            requiresShipping
        });
        if (!isFormValid) {
            finishOrderFlow();
            return;
        }
        // final sync with server, to ensure validity
        let shippingMethodId = '';
        // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
        if (requiresShipping && shippingInfo.elements['shipping-method-choice']) {
            // this is an IE11-safe way of just doing shippingInfo.elements['shipping-method-choice'].value
            const shippingMethodChoice = shippingInfo.querySelector('input[name="shipping-method-choice"]:checked');
            // this should never be falsey, but Flow
            if (shippingMethodChoice) {
                shippingMethodId = shippingMethodChoice.value;
            }
        }
        const customData = hasAdditionalInfo ? (0, _commerceUtils.customDataFormToArray)(additionalInfo) : [];
        const syncPayPalCheckoutForm = Promise.all([
            requiresShipping ? (0, _checkoutUtils.createOrderShippingMethodMutation)(apolloClient, shippingMethodId) : Promise.resolve(),
            hasAdditionalInfo ? (0, _checkoutUtils.createCustomDataMutation)(apolloClient, customData) : Promise.resolve()
        ]);
        syncPayPalCheckoutForm.then(()=>{
            return (0, _checkoutUtils.createAttemptSubmitOrderRequest)(apolloClient, {
                checkoutType: 'paypal'
            });
        }).then((data)=>{
            _debug.default.log(data);
            const order = (0, _checkoutUtils.getOrderDataFromGraphQLResponse)(data);
            if (order.ok) {
                finishOrderFlow(true);
                (0, _checkoutUtils.redirectToOrderConfirmation)(order, true);
            }
        }).catch((err)=>{
            finishOrderFlow();
            _debug.default.error(err);
            errorState.style.removeProperty('display');
            (0, _checkoutUtils.updateErrorMessage)(errorState, err);
            if (_client.CombinedGraphQLErrors.is(err) && err.errors[0] && err.errors[0].message) {
                const parsedError = (0, _commerceUtils.safeParseJson)(err.errors[0].message);
                if (!parsedError) {
                    return;
                }
                if (parsedError.details && parsedError.details[0] && parsedError.details[0].issue === 'INSTRUMENT_DECLINED') {
                    const message = {
                        isWebflow: true,
                        type: 'error',
                        detail: parsedError
                    };
                    window.parent.postMessage(JSON.stringify(message), window.location.origin);
                }
            }
        });
    });
};
// width and height is defined twice, so that on older browsers that
// don't support vw/vh, we get the 100% instead
const iframeStyle = `
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  width: 100vw;
  height: 100vh;
  min-width: 100%;
  min-height: 100%;
  max-width: 100%;
  max-height: 100%;
  z-index: 2147483647;
  border: 0;
  background-color: #ffffff;
`;
const createConfirmationIframe = (actions)=>{
    const documentRoot = document.documentElement;
    // we use this instead of document.body to appease the flow gods
    const documentBody = document.querySelector('body');
    if (!documentRoot || !documentBody) {
        return;
    }
    const iframe = document.createElement('iframe');
    iframe.setAttribute('style', iframeStyle);
    iframe.setAttribute('src', '/paypal-checkout');
    if (!documentBody.parentNode) {
        return;
    }
    documentBody.parentNode.appendChild(iframe);
    const previousRootOverflow = documentRoot.style.overflow;
    documentRoot.style.overflow = 'hidden';
    const previousBodyDisplay = documentBody.style.display;
    documentBody.style.display = 'none';
    const paypalMessageHandler = (event)=>{
        if (event.origin !== window.location.origin) {
            return;
        }
        const data = (0, _commerceUtils.safeParseJson)(String(event.data));
        // we include an `isWebflow` since paypal sends some messages on the page
        // and we want to make sure that we don't accidentally intercept one of their messages
        if (!data || data.isWebflow !== true || !data.type || !data.detail) {
            return;
        }
        if (data.type === 'success') {
            window.removeEventListener('message', paypalMessageHandler);
            window.location.href = data.detail;
        }
        if (data.type === 'error') {
            window.removeEventListener('message', paypalMessageHandler);
            if (previousRootOverflow) {
                documentRoot.style.overflow = previousRootOverflow;
            } else {
                documentRoot.style.overflow = '';
            }
            if (previousBodyDisplay) {
                documentBody.style.display = previousBodyDisplay;
            } else {
                documentBody.style.display = '';
            }
            if (documentBody.parentNode) {
                documentBody.parentNode.removeChild(iframe);
            }
            actions.restart();
        }
    };
    window.addEventListener('message', paypalMessageHandler);
};
const renderPaypalButtons = (apolloClient)=>()=>{
        const paypalElement = document.querySelector(`[${_constants.PAYPAL_ELEMENT_INSTANCE}]`);
        const buttons = Array.from(document.querySelectorAll(`[${_constants.PAYPAL_BUTTON_ELEMENT_INSTANCE}]`));
        if (paypalElement && buttons && buttons.length > 0) {
            buttons.forEach((button)=>{
                const style = (0, _commerceUtils.safeParseJson)(button.getAttribute(_constants.PAYPAL_BUTTON_ELEMENT_INSTANCE));
                // @ts-expect-error - TS2551 - Property 'paypal' does not exist on type 'Window & typeof globalThis'. Did you mean 'Papa'?
                window.paypal.Buttons({
                    style,
                    createOrder () {
                        return apolloClient.mutate({
                            mutation: _checkoutMutations.requestPayPalOrderMutation
                        }).then((data)=>{
                            const { data: { // @ts-expect-error - TS2339: Property ecommercePaypalOrderRequest does not exist on type unknown
                            ecommercePaypalOrderRequest: { orderId } } } = data;
                            return orderId;
                        }).catch((err)=>{
                            (0, _checkoutUtils.showErrorMessageForError)(err);
                            if ((0, _cartUtils.isCartOpen)()) {
                                (0, _cartUtils.showErrorMessageForError)(err);
                            }
                            throw err;
                        });
                    },
                    onApprove (data, actions) {
                        createConfirmationIframe(actions);
                    }
                }).render(button);
            });
        }
    };
const register = (handlerProxy)=>{
    handlerProxy.on(_constants.RENDER_TREE_EVENT, Boolean, handleRenderPayPalCheckout);
    handlerProxy.on('click', isPlaceOrderButtonEvent, handlePlaceOrder);
    handlerProxy.on('keydown', isPlaceOrderButtonEvent, (event, apolloClient)=>{
        // @ts-expect-error - TS2339 - Property 'which' does not exist on type 'Event'.
        if (event.which === 32) {
            // prevent scrolling on spacebar key press
            event.preventDefault();
        }
        // @ts-expect-error - TS2339 - Property 'which' does not exist on type 'Event'.
        if (event.which === 13) {
            // enter key press
            return handlePlaceOrder(event, apolloClient);
        }
    });
    handlerProxy.on('keyup', isPlaceOrderButtonEvent, (event, apolloClient)=>{
        // @ts-expect-error - TS2339 - Property 'which' does not exist on type 'Event'.
        if (event.which === 32) {
            // spacebar key press
            return handlePlaceOrder(event, apolloClient);
        }
    });
};
const _default = {
    register
};

//# sourceMappingURL=data:application/json;base64,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

}),
91898: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/* globals window, document, HTMLElement */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    applySkuBoundConditionalVisibility: function() {
        return applySkuBoundConditionalVisibility;
    },
    renderTree: function() {
        return renderTree;
    }
});
const _Transformers = __webpack_require__(61649);
const _escape = /*#__PURE__*/ _interop_require_default(__webpack_require__(28929));
const _cloneDeep = /*#__PURE__*/ _interop_require_default(__webpack_require__(37252));
const _transform = /*#__PURE__*/ _interop_require_default(__webpack_require__(16089));
const _constants = __webpack_require__(10873);
const _constants1 = __webpack_require__(29197);
const _RenderingUtils = __webpack_require__(86078);
const _commerceUtils = __webpack_require__(54556);
const _DynamoFormattingUtils = __webpack_require__(82688);
const _site = __webpack_require__(32949);
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const allowedFieldTypes = {
    ..._constants1.SHARED_ALLOWED_FIELD_TYPES,
    'data-commerce-sku-id': [
        'ItemRef'
    ]
};
const isBindingPropToFieldTypeAllowed = (// @ts-expect-error - TS7006 - Parameter 'bindingProperty' implicitly has an 'any' type.
bindingProperty, type)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly 'data-commerce-sku-id': readonly ["ItemRef"]; readonly innerHTML: { PlainText: string; HighlightedText: string; RichText: string; Number: string; Video: string; Option: string; Date: string; Phone: string; ... 6 more ...; CommercePropValues: string; }; ... 11 more ...; readonly dataWHref: string[]; }'.
    const allowedTypes = allowedFieldTypes[bindingProperty];
    return allowedTypes instanceof Array ? allowedTypes.indexOf(type) > -1 : allowedTypes && type in allowedTypes;
};
// @ts-expect-error - TS7023 - 'getIn' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions. | TS7006 - Parameter 'object' implicitly has an 'any' type.
const getIn = (object, path)=>{
    const nextDotIndex = path.indexOf('.');
    if (object == null) {
        return null;
    }
    if (nextDotIndex !== -1) {
        const pathPart = path.slice(0, nextDotIndex);
        const restOfPath = path.slice(nextDotIndex + 1, path.length);
        return getIn(object[pathPart], restOfPath);
    }
    return object[path];
};
const applyBindingsMutation = ({ // @ts-expect-error - TS7031 - Binding element 'bindingProperty' implicitly has an 'any' type.
bindingProperty, // @ts-expect-error - TS7031 - Binding element 'type' implicitly has an 'any' type.
type, // @ts-expect-error - TS7031 - Binding element 'filter' implicitly has an 'any' type.
filter, // @ts-expect-error - TS7031 - Binding element 'path' implicitly has an 'any' type.
path, // @ts-expect-error - TS7031 - Binding element 'timezone' implicitly has an 'any' type.
timezone, // @ts-expect-error - TS7031 - Binding element 'pageLinkHrefPrefix' implicitly has an 'any' type.
pageLinkHrefPrefix, collectionSlugMap = {}, // @ts-expect-error - TS7031 - Binding element 'data' implicitly has an 'any' type.
data, // @ts-expect-error - TS7031 - Binding element 'node' implicitly has an 'any' type.
node, emailLinkSubject = '' })=>{
    if (!isBindingPropToFieldTypeAllowed(bindingProperty, type)) {
        return;
    }
    const prefix = 'data.';
    let suffix = '';
    if (type === 'ImageRef' && bindingProperty === 'src') {
        suffix = '.url';
    }
    let rawValue;
    if (type === 'CommercePropValues') {
        rawValue = getCommercePropValue(data, `${prefix}${path}`);
    } else {
        rawValue = getIn(data, `${prefix}${path}${suffix}`);
    }
    const transformedValue = (0, _Transformers.transformers)(rawValue, filter, {
        timezone,
        pageLinkHrefPrefix,
        collectionSlugMap,
        // @ts-expect-error - TS2339 - Property '__WEBFLOW_CURRENCY_SETTINGS' does not exist on type 'Window & typeof globalThis'.
        currencySettings: window.__WEBFLOW_CURRENCY_SETTINGS
    });
    const propertyMutator = getPropertyMutator(bindingProperty, emailLinkSubject);
    if (typeof propertyMutator === 'function') {
        propertyMutator(node, type, transformedValue);
    }
};
const applyBindings = (bindings, data, node)=>{
    if (bindings == null) {
        return;
    }
    bindings.forEach((binding)=>{
        Object.keys(binding).forEach((bindingProperty)=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"value" | "id" | "alt" | "data-commerce-sku-id" | "innerHTML" | "src" | "checked" | "for" | "style.color" | "style.background-color" | "style.border-color" | "style.background-image", Binding>>'.
            const bindingValue = binding[bindingProperty];
            const { type, filter, dataPath: path, timezone, pageLinkHrefPrefix, collectionSlugMap, emailLinkSubject } = bindingValue;
            applyBindingsMutation({
                bindingProperty,
                type,
                filter,
                path,
                timezone,
                pageLinkHrefPrefix,
                collectionSlugMap,
                data,
                node,
                emailLinkSubject
            });
        });
    });
};
const applyConditionalVisibility = (// @ts-expect-error - TS7006 - Parameter 'conditionData' implicitly has an 'any' type.
conditionData, data, node)=>{
    if (!conditionData) {
        return;
    }
    const { dataPath, meta } = conditionData;
    const prefixedDataPath = `data.${dataPath}`;
    // manually construct item when the condition is bound to Product Options
    const item = meta && meta.type === 'CommercePropValues' ? {
        name: getIn(data, `${prefixedDataPath}.name`),
        value: getCommercePropValue(data, prefixedDataPath)
    } : getIn(data, prefixedDataPath);
    (0, _RenderingUtils.applyConditionToNode)(node, item, conditionData, true);
};
const applySkuBoundConditionalVisibility = ({ conditionData, newSkuItem, node })=>{
    const { condition } = conditionData;
    const skuConditionData = (0, _transform.default)(condition.fields, (data, val, field)=>{
        const skuField = field.split('default-sku:');
        if (skuField.length > 1) {
            // @ts-expect-error - TS18046 - 'data' is of type 'unknown'.
            data[skuField[1]] = val;
            return data;
        }
    });
    // Need to flatten the inventory quantity to allow cond vis bound to inventory counts
    const inventoryQuantity = newSkuItem.inventory.type === 'infinite' ? null : newSkuItem.inventory.quantity;
    const itemWithFlattenedInventory = {
        ...newSkuItem,
        ecSkuInventoryQuantity: inventoryQuantity
    };
    (0, _RenderingUtils.applyConditionToNode)(node, itemWithFlattenedInventory, {
        ...conditionData,
        condition: {
            fields: skuConditionData
        }
    }, true);
};
const createStyleMutator = // @ts-expect-error - TS7006 - Parameter 'node' implicitly has an 'any' type. | TS7006 - Parameter 'type' implicitly has an 'any' type.
(property)=>(node, type, value)=>{
        if (!(node instanceof HTMLElement && typeof value === 'string')) {
            return;
        }
        if (type === 'ImageRef') {
            node.style.setProperty(property, `url(${value})`);
        }
        node.style.setProperty(property, value);
    };
const createAttributeMutator = // @ts-expect-error - TS7006 - Parameter 'node' implicitly has an 'any' type. | TS7006 - Parameter 'type' implicitly has an 'any' type.
(attribute)=>(node, type, value)=>{
        const sanitizedString = value != null ? String(value) : '';
        node.setAttribute(attribute, sanitizedString);
        if (attribute === 'src' && sanitizedString) {
            (0, _RenderingUtils.removeWDynBindEmptyClass)(node);
        }
    };
const valueMutator = (node, type, value)=>{
    if (node.hasRendered) {
        return;
    }
    let sanitizedString;
    // if it's a select element, and we have no value, we default to the last value
    // this was added for the case of the first render of the country select field
    // so that it isn't a blank select box when it's a new order without a country set
    if (node.tagName === 'SELECT') {
        sanitizedString = value != null ? String(value) : node.value || '';
    } else {
        sanitizedString = value != null ? String(value) : '';
    }
    node.setAttribute('value', sanitizedString);
    if (node.tagName === 'INPUT' && String(node.type).toLowerCase() === 'text') {
        node.hasRendered = true;
    }
    node.value = sanitizedString;
};
const checkedMutator = (node, type, value)=>{
    node.checked = Boolean(value);
};
// @ts-expect-error - TS7031 - Binding element 'height' implicitly has an 'any' type. | TS7031 - Binding element 'width' implicitly has an 'any' type.
const aspectRatio = ({ height, width })=>{
    return height && width ? height / width : 0;
};
const mutators = {
    // @ts-expect-error - TS7006 - Parameter 'node' implicitly has an 'any' type. | TS7006 - Parameter 'type' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
    innerHTML: (node, type, value)=>{
        const originalValue = value;
        if (type === 'Video') {
            /*
      TODO handle also innerHTML Video Links
      For example,
      innerHTML: [
        {
          id: 'video-id',
          slug: 'video',
          type: 'Video',
        },
        {
          id: 'url',
          slug: 'url',
          type: 'Link',
        },
      ],
       */ value = value != null && value.metadata != null && typeof value.metadata.html === 'string' ? value.metadata.html : null;
        }
        const valueString = value != null ? String(value) : '';
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ PlainText: string; HighlightedText: string; RichText: string; Number: string; Video: string; Option: string; Date: string; Phone: string; Email: string; CommercePrice: string; Link: string; ImageRef: boolean; FileRef: boolean; ItemRef: boolean; CommercePropValues: string; }'.
        if (allowedFieldTypes.innerHTML[type] === 'innerHTML') {
            node.innerHTML = valueString;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ PlainText: string; HighlightedText: string; RichText: string; Number: string; Video: string; Option: string; Date: string; Phone: string; Email: string; CommercePrice: string; Link: string; ImageRef: boolean; FileRef: boolean; ItemRef: boolean; CommercePropValues: string; }'.
        } else if (allowedFieldTypes.innerHTML[type] === 'innerText') {
            node.innerHTML = (0, _escape.default)(valueString);
        }
        // Videos have their `padding-top` style set automatically to make them responsive, and are a locked style.
        // This is usually done in `shared/render/plugins/Embed/Video.jsx` on the server render. However, the render-time value
        // when rendering the cart is `0`, as the server does not have the associated data from the binding passed to it at
        // render-time, since we're not getting that data until we do the client-side render, after fetching the cart data.
        // So, along with setting the proper innerHTML binding for the embed itself, we also have to do an exception here
        // and set the `padding-top` to the video's aspect ratio (height over width).
        if (type === 'Video' && originalValue && originalValue.metadata && node instanceof HTMLElement) {
            node.style.setProperty('padding-top', `${aspectRatio(originalValue.metadata) * 100}%`);
        }
        if (node.innerHTML) {
            (0, _RenderingUtils.removeWDynBindEmptyClass)(node);
        }
    },
    'style.color': createStyleMutator('color'),
    'style.background-color': createStyleMutator('background-color'),
    'style.border-color': createStyleMutator('border-color'),
    'style.background-image': createStyleMutator('background-image'),
    src: createAttributeMutator('src'),
    alt: createAttributeMutator('alt'),
    id: createAttributeMutator('id'),
    for: createAttributeMutator('for'),
    value: valueMutator,
    checked: checkedMutator,
    'data-commerce-sku-id': createAttributeMutator('data-commerce-sku-id')
};
const hrefMutator = (emailLinkSubject)=>(node, type, value)=>{
        if (value) {
            const href = String(value);
            switch(type){
                case 'Phone':
                    {
                        node.setAttribute('href', (0, _DynamoFormattingUtils.formatPhone)(href, 'href'));
                        break;
                    }
                case 'Email':
                    {
                        let subject;
                        try {
                            subject = encodeURIComponent(emailLinkSubject);
                        } catch (e) {
                            subject = '';
                        }
                        const formattedEmail = (0, _DynamoFormattingUtils.formatEmail)(href, subject, 'href');
                        node.setAttribute('href', formattedEmail || '#');
                        break;
                    }
                default:
                    {
                        node.setAttribute('href', href);
                        break;
                    }
            }
        } else {
            node.setAttribute('href', '#');
        }
    };
// @ts-expect-error - TS7006 - Parameter 'bindingProperty' implicitly has an 'any' type.
const getPropertyMutator = (bindingProperty, emailLinkSubject)=>{
    if (bindingProperty === 'href' || bindingProperty === 'dataWHref') {
        return hrefMutator(emailLinkSubject);
    }
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly innerHTML: (node: any, type: any, value: any) => void; readonly 'style.color': (node: any, type: any, value: unknown) => void; readonly 'style.background-color': (node: any, type: any, value: unknown) => void; ... 8 more ...; readonly 'data-commerce-sku-id': (node: any, type: any, value: unknown) => void; }'.
    if (typeof mutators[bindingProperty] === 'function') {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly innerHTML: (node: any, type: any, value: any) => void; readonly 'style.color': (node: any, type: any, value: unknown) => void; readonly 'style.background-color': (node: any, type: any, value: unknown) => void; ... 8 more ...; readonly 'data-commerce-sku-id': (node: any, type: any, value: unknown) => void; }'.
        return mutators[bindingProperty];
    }
    return null;
};
const getCommercePropValue = (data, path)=>{
    const option = getIn(data, path);
    if (option) {
        const pathToOptionAsArray = path.split('.');
        const pathToCommercePropValues = pathToOptionAsArray.slice(0, pathToOptionAsArray.indexOf('product')).concat([
            'sku',
            'f_sku_values_3dr'
        ]).join('.');
        const skuValues = getIn(data, pathToCommercePropValues);
        if (Array.isArray(skuValues)) {
            return (0, _site.getProductOptionValueName)(option, (0, _site.simplifySkuValues)(skuValues));
        }
    }
    return '';
};
const getTemplateScript = (node)=>{
    const templateId = node.getAttribute(_constants.WF_TEMPLATE_ID_DATA_KEY);
    const templateScript = templateId && node.parentElement && node.parentElement.querySelector(`#${templateId}`);
    return templateScript;
};
const createDomFragment = (html)=>{
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.children[0];
};
const getTemplateString = (node, index)=>{
    const templateScript = getTemplateScript(node);
    const rawTemplateContent = templateScript && templateScript.textContent;
    const instanceRegEx = /([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}_instance-)\d+/gi;
    const decodedTemplate = rawTemplateContent && decodeURIComponent(rawTemplateContent).replace(instanceRegEx, `$1${index}`);
    if (Boolean(decodedTemplate) && node.hasAttribute(_constants.WF_COLLECTION_DATA_KEY)) {
        const collectionPath = node.getAttribute(_constants.WF_COLLECTION_DATA_KEY);
        if (collectionPath && typeof collectionPath === 'string') {
            const searchTerm = encodeURIComponent(`${(0, _escape.default)(collectionPath)}[]`).replace(/\./g, '\\.');
            const templateSearchTerm = encodeURIComponent(`${(0, _escape.default)(collectionPath)}${encodeURIComponent('[]')}`).replace(/\./g, '\\.');
            const collectionPathRegExp = new RegExp(`${searchTerm}|${templateSearchTerm}`, 'g');
            return decodedTemplate && decodedTemplate.replace(collectionPathRegExp, `${collectionPath}.${index}`);
        }
    }
    return decodedTemplate;
};
const getTemplateCollection = (node, data)=>{
    const collectionPath = node.hasAttribute(_constants.WF_COLLECTION_DATA_KEY) && node.getAttribute(_constants.WF_COLLECTION_DATA_KEY);
    return collectionPath ? getIn(data, `data.${collectionPath}`) : [];
};
const checkForAndApplyTemplateCollection = (node, data)=>{
    if (node && node.hasAttribute(_constants.WF_TEMPLATE_ID_DATA_KEY)) {
        const collection = getTemplateCollection(node, data);
        node.innerHTML = '';
        if (collection != null && collection.length > 0) {
            for(let index = 0; index < collection.length; index++){
                const templateString = getTemplateString(node, index);
                const template = templateString && createDomFragment(templateString);
                if (template instanceof Element) {
                    if (typeof node.append === 'function') {
                        node.append(renderTree(template, data));
                    } else if (typeof node.appendChild === 'function') {
                        node.appendChild(renderTree(template, data));
                    } else {
                        throw new Error('Could not append child to node');
                    }
                }
            }
        }
    }
};
const checkForAndApplyBindings = (node, data)=>{
    if (node && node.hasAttribute(_constants.WF_BINDING_DATA_KEY)) {
        const bindingData = (0, _commerceUtils.safeParseJson)(node.getAttribute(_constants.WF_BINDING_DATA_KEY));
        applyBindings(bindingData, data, node);
    }
};
const checkForAndApplyConditionalVisibility = (node, data)=>{
    if (node && node.hasAttribute(_constants.WF_CONDITION_DATA_KEY)) {
        const conditionData = (0, _commerceUtils.safeParseJson)(node.getAttribute(_constants.WF_CONDITION_DATA_KEY));
        applyConditionalVisibility(conditionData, data, node);
    }
};
const renderTree = (tree, data)=>{
    data = flattenOrderData(data);
    return (0, _RenderingUtils.walkDOM)(tree, (node)=>{
        checkForAndApplyTemplateCollection(node, data);
        checkForAndApplyBindings(node, data);
        checkForAndApplyConditionalVisibility(node, data);
    });
};
const shippingDataReplacementPaths = {
    cardProvider: [
        'customerInfo',
        'stripePayment',
        'card',
        'provider'
    ],
    cardLastFour: [
        'customerInfo',
        'stripePayment',
        'card',
        'last4'
    ],
    cardExpiresMonth: [
        'customerInfo',
        'stripePayment',
        'card',
        'expires',
        'month'
    ],
    cardExpiresYear: [
        'customerInfo',
        'stripePayment',
        'card',
        'expires',
        'year'
    ],
    customerEmail: [
        'customerInfo',
        'identity',
        'email'
    ],
    shippingAddressAddressee: [
        'customerInfo',
        'shippingAddress',
        'addressee'
    ],
    shippingAddressLine1: [
        'customerInfo',
        'shippingAddress',
        'line1'
    ],
    shippingAddressLine2: [
        'customerInfo',
        'shippingAddress',
        'line2'
    ],
    shippingAddressCity: [
        'customerInfo',
        'shippingAddress',
        'city'
    ],
    shippingAddressState: [
        'customerInfo',
        'shippingAddress',
        'state'
    ],
    shippingAddressCountry: [
        'customerInfo',
        'shippingAddress',
        'country'
    ],
    shippingAddressPostalCode: [
        'customerInfo',
        'shippingAddress',
        'postalCode'
    ],
    billingAddressAddressee: [
        'customerInfo',
        'billingAddress',
        'addressee'
    ],
    billingAddressLine1: [
        'customerInfo',
        'billingAddress',
        'line1'
    ],
    billingAddressLine2: [
        'customerInfo',
        'billingAddress',
        'line2'
    ],
    billingAddressCity: [
        'customerInfo',
        'billingAddress',
        'city'
    ],
    billingAddressPostalCode: [
        'customerInfo',
        'billingAddress',
        'postalCode'
    ],
    billingAddressState: [
        'customerInfo',
        'billingAddress',
        'state'
    ],
    billingAddressCountry: [
        'customerInfo',
        'billingAddress',
        'country'
    ],
    requiresShipping: [
        'statusFlags',
        'requiresShipping'
    ],
    hasDownloads: [
        'statusFlags',
        'hasDownloads'
    ]
};
const flattenCustomData = (customData)=>// @ts-expect-error - Flow 0.121.0
    customData.reduce((flattenedData, data)=>{
        if (data.textArea) {
            flattenedData.additionalTextArea = data.textArea;
        } else if (data.textInput) {
            flattenedData.additionalTextInput = data.textInput;
        } else if (data.checkbox !== null) {
            flattenedData.additionalCheckbox = data.checkbox;
        }
        return flattenedData;
    }, {});
const flattenOrderData = (data)=>{
    const orderExists = data && data.data && data.data.database && data.data.database.commerceOrder !== null;
    if (!orderExists) {
        return data;
    }
    // @ts-expect-error - TS2339 - Property 'commerceOrder' does not exist on type '{ commerceOrder?: { availableShippingMethods?: [] | undefined; } | undefined; } | undefined'. | TS18048 - 'data.data' is possibly 'undefined'.
    const { commerceOrder } = data.data.database;
    const paymentProcessor = commerceOrder.paymentProcessor;
    const availableShippingMethods = commerceOrder.availableShippingMethods || [];
    const selectedShippingMethod = availableShippingMethods.find(// @ts-expect-error - TS7006 - Parameter 'shippingMethod' implicitly has an 'any' type.
    (shippingMethod)=>shippingMethod.selected === true);
    const flattenedCustomData = commerceOrder.customData ? flattenCustomData(commerceOrder.customData) : {};
    const flattenedOrderData = {
        ...commerceOrder,
        shippingMethodName: selectedShippingMethod && selectedShippingMethod.name,
        shippingMethodDescription: selectedShippingMethod && selectedShippingMethod.description,
        ...flattenedCustomData
    };
    // We have to deep clone the data here, as the properties from the data
    // returned by Apollo are read-only.
    const clonedData = (0, _cloneDeep.default)(data);
    // @ts-expect-error - TS18048 - 'clonedData.data' is possibly 'undefined'.
    clonedData.data.database.commerceOrder = Object.keys(shippingDataReplacementPaths).reduce((updatedData, flattenPath)=>{
        // Override cardProvider for PayPal order
        if (flattenPath === 'cardProvider' && paymentProcessor === 'paypal') {
            updatedData = {
                ...updatedData,
                cardProvider: 'PayPal'
            };
            return updatedData;
        }
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly cardProvider: readonly ["customerInfo", "stripePayment", "card", "provider"]; readonly cardLastFour: readonly ["customerInfo", "stripePayment", "card", "last4"]; readonly cardExpiresMonth: readonly [...]; ... 17 more ...; readonly hasDownloads: readonly [...]; }'.
        const replacementFrom = shippingDataReplacementPaths[flattenPath];
        const replacementData = replacementFrom.reduce((acc, key)=>acc && acc[key], updatedData);
        updatedData[flattenPath] = replacementData;
        return updatedData;
    }, flattenedOrderData);
    return clonedData;
};

//# sourceMappingURL=data:application/json;base64,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

}),
5841: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/* globals window */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    StripeStore: function() {
        return StripeStore;
    },
    generateDisplayItemsFromOrder: function() {
        return generateDisplayItemsFromOrder;
    },
    generateShippingOptionsFromMethods: function() {
        return generateShippingOptionsFromMethods;
    }
});
const _debug = /*#__PURE__*/ _interop_require_default(__webpack_require__(85986));
const _constants = __webpack_require__(10873);
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class StripeStore {
    constructor(docElement){
        if (window.Webflow.env('design') || window.Webflow.env('preview')) {
            return;
        }
        const stripeJsElement = docElement.querySelector(`[${_constants.STRIPE_ECOMMERCE_KEY}]`);
        if (!stripeJsElement) {
            this.store = {
                initialized: false,
                stripe: {},
                elements: [],
                elementInstances: [],
                cartPaymentRequests: [],
                styleMapObservers: {}
            };
            // @ts-expect-error - TS2322 - Type 'void' is not assignable to type 'StripeStore'. | TS2409 - Return type of constructor signature must be assignable to the instance type of the class.
            return _debug.default.error("Stripe has not been set up for this project – Go to the project's Ecommerce Payment settings in the Designer to link Stripe.");
        }
        const ecommKey = stripeJsElement.getAttribute(_constants.STRIPE_ECOMMERCE_KEY);
        const ecommAccountId = stripeJsElement.getAttribute(_constants.STRIPE_ECOMMERCE_ACCOUNT_ID);
        const stripeOpts = ecommAccountId ? {
            stripeAccount: ecommAccountId,
            apiVersion: '2020-03-02'
        } : null;
        // @ts-expect-error - TS2339 - Property 'Stripe' does not exist on type 'Window & typeof globalThis'.
        const stripe = window.Stripe(ecommKey, stripeOpts);
        this.store = {
            initialized: true,
            stripe,
            elements: [],
            elementInstances: [],
            cartPaymentRequests: [],
            styleMapObservers: {}
        };
    }
    isInitialized() {
        return this.store.initialized;
    }
    getStripeInstance() {
        return this.store.stripe;
    }
    getElementsInstance(index) {
        return this.store.elements[index];
    }
    getElement(type, index) {
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        return this.store.elementInstances[index][type];
    }
    createElementsInstance(index) {
        if (this.store.elements[index]) {
            throw new Error(`Storage already exists for checkout form instance ${index}`);
        } else {
            const stripeInstance = this.getStripeInstance();
            this.store.elements[index] = stripeInstance.elements();
            this.store.elementInstances[index] = {};
        }
    }
    createElement(type, index, options) {
        if (!this.isInitialized()) {
            throw new Error("Stripe has not been set up for this project – Go to the project's Ecommerce Payment settings in the Designer to link Stripe.");
        }
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        if (this.store.elementInstances[index][type]) {
            throw new Error(`Stripe Element of type ${type} for instance ${index} already exists on this page`);
        }
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        const el = this.store.elements[index].create(type, options);
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        this.store.elementInstances[index][type] = el;
        return el;
    }
    updateCartPaymentRequest(index, orderData, siteData) {
        const stripeInstance = this.getStripeInstance();
        const requiresShipping = Boolean(orderData.statusFlags.requiresShipping);
        const options = {
            country: siteData.businessAddress.country || siteData.defaultCountry || 'US',
            currency: siteData.defaultCurrency.toLowerCase(),
            total: {
                amount: orderData.subtotal.value,
                label: 'Subtotal',
                pending: true
            },
            displayItems: generateDisplayItemsFromOrder(orderData, false),
            requestPayerName: true,
            requestPayerEmail: true,
            requestPayerPhone: false,
            requestShipping: requiresShipping
        };
        try {
            this.store.cartPaymentRequests[index] = stripeInstance.paymentRequest(options);
        } catch (error) {
            let ignoreError = false;
            // Stripe errors are `IntegrationError`s
            if (error.name === 'IntegrationError') {
                const unsupportedCountryPattern = /country should be one of the following strings(?:.*)You specified: (.*)./;
                const matches = error.message.match(unsupportedCountryPattern);
                ignoreError = Boolean(matches);
            }
            // We want the error to carry on if it's not exactly what we're looking for.
            if (!ignoreError) {
                throw error;
            } else {
                console.error(error);
            }
        }
        return this.store.cartPaymentRequests[index];
    }
    getCartPaymentRequest(index) {
        return this.store.cartPaymentRequests[index];
    }
}
const generateDisplayItemsFromOrder = (orderData, showExtraItems)=>[
        // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
        ...orderData.userItems.map((item)=>({
                label: `${item.product.f_name_} ${item.count > 1 ? `(${item.count})` : ''}`,
                amount: item.rowTotal.value
            })),
        ...showExtraItems ? orderData.extraItems.map((item)=>({
                label: item.name,
                amount: item.price.value
            })) : []
    ];
const generateShippingOptionsFromMethods = (shippingMethods)=>shippingMethods.map((method)=>({
            id: method.id,
            label: method.name,
            detail: method.description || '',
            amount: method.price.value
        }));

//# sourceMappingURL=data:application/json;base64,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

}),
94492: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/* globals window */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    register: function() {
        return register;
    },
    updateWebPaymentsButton: function() {
        return updateWebPaymentsButton;
    }
});
const _graphqltag = /*#__PURE__*/ _interop_require_default(__webpack_require__(28160));
const _commerceUtils = __webpack_require__(54556);
const _stripeStore = __webpack_require__(5841);
const _checkoutUtils = __webpack_require__(17696);
const _cartUtils = __webpack_require__(69773);
const _constants = __webpack_require__(10873);
const _debug = /*#__PURE__*/ _interop_require_default(__webpack_require__(85986));
const _client = __webpack_require__(22805);
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const hasItems = (response)=>response && response.data && response.data.database && response.data.database.commerceOrder && response.data.database.commerceOrder.userItems && response.data.database.commerceOrder.userItems.length > 0;
// @ts-expect-error - TS7031 - Binding element 'target' implicitly has an 'any' type.
const isWebPaymentsButtonEvent = ({ target })=>{
    const cartCheckoutButton = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_QUICK_CHECKOUT_BUTTON, target);
    const cartApplePayButton = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_APPLE_PAY_BUTTON, target);
    if (cartCheckoutButton) {
        return cartCheckoutButton;
    } else if (cartApplePayButton) {
        return cartApplePayButton;
    } else {
        return false;
    }
};
const updateWebPaymentsButton = (wrapper, data, stripeStore)=>{
    const webPaymentsActionsElements = (0, _commerceUtils.findAllElementsByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_QUICK_CHECKOUT_ACTIONS, wrapper);
    if (!webPaymentsActionsElements || webPaymentsActionsElements.length === 0 || !hasItems(data)) {
        return;
    }
    webPaymentsActionsElements.forEach((webPaymentsActions)=>{
        (0, _commerceUtils.hideElement)(webPaymentsActions);
        if (!stripeStore || !stripeStore.isInitialized() || !data.data.site.commerce.quickCheckoutEnabled) {
            return;
        }
        const stripeInstance = parseInt(// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        wrapper.getAttribute(_constants.STRIPE_ELEMENT_INSTANCE), 10);
        const paymentRequest = stripeStore.updateCartPaymentRequest(stripeInstance, data.data.database.commerceOrder, data.data.site.commerce);
        if (!paymentRequest || typeof paymentRequest.canMakePayment !== 'function') {
            return;
        }
        if ((0, _commerceUtils.isFreeOrder)(data)) {
            return;
        }
        paymentRequest.canMakePayment()// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type.
        .then((result)=>{
            if (!result) {
                return;
            }
            const { applePay } = result;
            (0, _commerceUtils.showElement)(webPaymentsActions);
            const cartCheckoutButton = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_QUICK_CHECKOUT_BUTTON, webPaymentsActions);
            const cartApplePayButton = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_APPLE_PAY_BUTTON, webPaymentsActions);
            if (!cartCheckoutButton || !cartApplePayButton) {
                return;
            }
            if (applePay) {
                (0, _commerceUtils.hideElement)(cartCheckoutButton);
                (0, _commerceUtils.showElement)(cartApplePayButton);
            } else {
                (0, _commerceUtils.hideElement)(cartApplePayButton);
                (0, _commerceUtils.showElement)(cartCheckoutButton);
            }
        }).catch(()=>{
            _debug.default.log('PaymentRequest not available in this browser – silently exiting');
        });
    });
};
const getShippingMethodsQuery = (0, _graphqltag.default)`
  query FetchShippingMethods {
    database {
      id
      commerceOrder {
        id
        availableShippingMethods {
          id
          name
          description
          price {
            value
          }
        }
      }
    }
  }
`;
const handleWebPaymentsButton = (event, apolloClient, stripeStore)=>{
    event.preventDefault();
    if (window.Webflow.env('design') || window.Webflow.env('preview')) {
        if (window.Webflow.env('preview')) {
            window.alert('Web Payments is not available in preview mode.');
        }
        return;
    }
    const { currentTarget } = event;
    const stripeElement = (0, _commerceUtils.findClosestElementWithAttribute)(_constants.STRIPE_ELEMENT_INSTANCE, // @ts-expect-error - TS2345 - Argument of type 'EventTarget | null' is not assignable to parameter of type 'EventTarget'.
    currentTarget);
    if (!(stripeElement instanceof Element)) {
        return;
    }
    const stripeInstance = parseInt(// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
    stripeElement.getAttribute(_constants.STRIPE_ELEMENT_INSTANCE), 10);
    const paymentRequest = stripeStore.getCartPaymentRequest(stripeInstance);
    // @ts-expect-error - TS18048 - 'paymentRequest' is possibly 'undefined'.
    paymentRequest.show();
    // @ts-expect-error - TS18048 - 'paymentRequest' is possibly 'undefined'.
    if (paymentRequest.hasRegisteredListener('paymentmethod')) {
        // we remove any existing event listeners, which can happen if the modal
        // was closed before a successful payment occurred
        // @ts-expect-error - TS18048 - 'paymentRequest' is possibly 'undefined'.
        paymentRequest.removeAllListeners();
    }
    // @ts-expect-error - TS18048 - 'paymentRequest' is possibly 'undefined'.
    paymentRequest.on('shippingaddresschange', // @ts-expect-error - TS7031 - Binding element 'updateWith' implicitly has an 'any' type. | TS7031 - Binding element 'shippingAddress' implicitly has an 'any' type.
    ({ updateWith, shippingAddress })=>{
        // @ts-expect-error - TS7034 - Variable 'shippingMethods' implicitly has type 'any[]' in some locations where its type cannot be determined.
        let shippingMethods = [];
        const graphQlQuery = stripeElement.getAttribute(_constants.CART_QUERY) || stripeElement.getAttribute(_constants.CHECKOUT_QUERY);
        // In some cases we receive an obfuscated address from quick checkout service (e.g. Apple pay)
        // We're using a different mutation to mark such address as 'obfuscated' in order to skip address validation when calculating taxes
        (0, _checkoutUtils.createUpdateObfuscatedOrderAddressMutation)(apolloClient, {
            type: 'shipping',
            name: shippingAddress.recipient,
            address_line1: shippingAddress.addressLine[0],
            address_line2: shippingAddress.addressLine[1],
            address_city: shippingAddress.city,
            address_state: shippingAddress.region,
            address_country: shippingAddress.country,
            address_zip: shippingAddress.postalCode
        }).then(()=>{
            return apolloClient.query({
                query: getShippingMethodsQuery,
                fetchPolicy: 'network-only',
                errorPolicy: 'all'
            });
        }).then(({ data })=>{
            if (// @ts-expect-error - TS18046: data is of type unknown
            !data.database.commerceOrder.availableShippingMethods || // @ts-expect-error - TS18046: data is of type unknown
            data.database.commerceOrder.availableShippingMethods.length === 0) {
                updateWith({
                    status: 'invalid_shipping_address'
                });
                return Promise.reject('No valid shipping addresses');
            } else {
                shippingMethods = // @ts-expect-error - TS18046: data is of type unknown
                data.database.commerceOrder.availableShippingMethods;
                return (0, _checkoutUtils.createOrderShippingMethodMutation)(apolloClient, // @ts-expect-error - TS18046: data is of type unknown
                data.database.commerceOrder.availableShippingMethods[0].id);
            }
        }).then(()=>{
            return (0, _checkoutUtils.createRecalcOrderEstimationsMutation)(apolloClient);
        }).then(()=>{
            return apolloClient.query({
                query: (0, _graphqltag.default)`
              ${graphQlQuery}
            `,
                fetchPolicy: 'network-only',
                errorPolicy: 'all'
            });
        }).then(({ data })=>{
            updateWith({
                status: 'success',
                displayItems: (0, _stripeStore.generateDisplayItemsFromOrder)(// @ts-expect-error - TS18046: data is of type unknown
                data.database.commerceOrder, true),
                shippingOptions: // @ts-expect-error - TS7005 - Variable 'shippingMethods' implicitly has an 'any[]' type.
                (0, _stripeStore.generateShippingOptionsFromMethods)(shippingMethods),
                total: {
                    // @ts-expect-error - TS18046: data is of type unknown
                    amount: data.database.commerceOrder.total.value,
                    label: 'Total',
                    pending: false
                }
            });
        });
    });
    // @ts-expect-error - TS7031 - Binding element 'updateWith' implicitly has an 'any' type. | TS7031 - Binding element 'shippingOption' implicitly has an 'any' type.
    paymentRequest.on('shippingoptionchange', ({ updateWith, shippingOption })=>{
        const graphQlQuery = stripeElement.getAttribute(_constants.CART_QUERY) || stripeElement.getAttribute(_constants.CHECKOUT_QUERY);
        (0, _checkoutUtils.createOrderShippingMethodMutation)(apolloClient, shippingOption.id).then(()=>{
            return (0, _checkoutUtils.createRecalcOrderEstimationsMutation)(apolloClient);
        }).then(()=>{
            return apolloClient.query({
                query: (0, _graphqltag.default)`
            ${graphQlQuery}
          `,
                fetchPolicy: 'network-only',
                errorPolicy: 'all'
            });
        }).then(({ data })=>{
            updateWith({
                status: 'success',
                displayItems: (0, _stripeStore.generateDisplayItemsFromOrder)(// @ts-expect-error - TS18046: data is of type unknown
                data.database.commerceOrder, true),
                total: {
                    // @ts-expect-error - TS18046: data is of type unknown
                    amount: data.database.commerceOrder.total.value,
                    label: 'Total',
                    pending: false
                }
            });
        });
    });
    // @ts-expect-error - TS7006 - Parameter 'ev' implicitly has an 'any' type.
    paymentRequest.on('paymentmethod', (ev)=>{
        (0, _commerceUtils.fetchOrderStatusFlags)(apolloClient).then(({ requiresShipping })=>{
            return Promise.all([
                (0, _checkoutUtils.createOrderIdentityMutation)(apolloClient, ev.payerEmail),
                requiresShipping ? (0, _checkoutUtils.createOrderAddressMutation)(apolloClient, {
                    type: 'shipping',
                    name: ev.shippingAddress.recipient,
                    address_line1: ev.shippingAddress.addressLine[0],
                    address_line2: ev.shippingAddress.addressLine[1],
                    address_city: ev.shippingAddress.city,
                    address_state: ev.shippingAddress.region,
                    address_country: ev.shippingAddress.country,
                    address_zip: ev.shippingAddress.postalCode
                }) : Promise.resolve(),
                (0, _checkoutUtils.createOrderAddressMutation)(apolloClient, {
                    type: 'billing',
                    name: ev.paymentMethod.billing_details.name,
                    address_line1: ev.paymentMethod.billing_details.address.line1,
                    address_line2: ev.paymentMethod.billing_details.address.line2,
                    address_city: ev.paymentMethod.billing_details.address.city,
                    address_state: ev.paymentMethod.billing_details.address.state,
                    address_country: ev.paymentMethod.billing_details.address.country,
                    address_zip: ev.paymentMethod.billing_details.address.postal_code
                }),
                requiresShipping ? (0, _checkoutUtils.createOrderShippingMethodMutation)(apolloClient, ev.shippingOption.id) : Promise.resolve(),
                (0, _checkoutUtils.createStripePaymentMethodMutation)(apolloClient, ev.paymentMethod.id)
            ]);
        }).then(()=>{
            return (0, _checkoutUtils.createAttemptSubmitOrderRequest)(apolloClient, {
                checkoutType: 'quickCheckout'
            });
        }).then((data)=>{
            const order = (0, _checkoutUtils.getOrderDataFromGraphQLResponse)(data);
            if ((0, _checkoutUtils.orderRequiresAdditionalAction)(order.status)) {
                ev.complete('success');
                const stripe = stripeStore.getStripeInstance();
                // @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type.
                return stripe.handleCardAction(order.clientSecret).then((result)=>{
                    if (result.error) {
                        return Promise.reject(new Error('payment_intent_failed'));
                    }
                    return (0, _checkoutUtils.createAttemptSubmitOrderRequest)(apolloClient, {
                        checkoutType: 'quickCheckout',
                        paymentIntentId: result.paymentIntent.id
                    }).then((resp)=>{
                        const finishedOrder = (0, _checkoutUtils.getOrderDataFromGraphQLResponse)(resp);
                        if (finishedOrder.ok) {
                            (0, _checkoutUtils.redirectToOrderConfirmation)(finishedOrder);
                        } else {
                            return Promise.reject(new Error('payment_intent_failed'));
                        }
                    });
                });
            }
            if (order.ok) {
                ev.complete('success');
                (0, _checkoutUtils.redirectToOrderConfirmation)(order);
            } else {
                return Promise.reject(new Error('order_failed'));
            }
        }).catch((err)=>{
            const hasGraphQLErrors = _client.CombinedGraphQLErrors.is(err) && err.errors.length > 0;
            if (hasGraphQLErrors) {
                const error = err.errors[0];
                const errorCode = error && 'code' in error && error.code;
                switch(errorCode){
                    case 'PriceChanged':
                        {
                            ev.complete('success');
                            // We have to wrap this in a small timeout or else the error won't show up and the payment dialog will time out
                            setTimeout(()=>{
                                window.alert('The prices of one or more items in your cart have changed. Please refresh this page and try again.');
                            }, 100);
                            return;
                        }
                    case 'ItemNotFound':
                        {
                            ev.complete('success');
                            setTimeout(()=>{
                                window.alert('One or more of the products in your cart have been removed. Please refresh the page and try again.');
                            }, 100);
                            return;
                        }
                    case 'OrderTotalRange':
                        {
                            ev.complete('success');
                            (0, _checkoutUtils.showErrorMessageForError)(err, ev.currentTarget);
                            if ((0, _cartUtils.isCartOpen)()) {
                                (0, _cartUtils.showErrorMessageForError)(err, ev.currentTarget);
                            }
                            return;
                        }
                    default:
                }
            }
            if (err && err.message && err.message === 'payment_intent_failed') {
                // in the case that we failed outside of the browser UI (i.e. when we had to fall back to the page for 3d secure)
                // we're going to not call the `ev.complete`, since we already had to mark it with `success` to get back to the page
                // and since we don't have an error element, we're going to pop up an alert informing them of the issue
                window.alert('There was an error processing your payment. Please try again, or contact us if you continue to have problems.');
            } else {
                // otherwise, since we're still in the native browser UI, we can rely on the browser to tell them that something went wrong
                ev.complete('fail');
            }
        });
    });
};
const register = (handlerProxy)=>{
    handlerProxy.on('click', isWebPaymentsButtonEvent, handleWebPaymentsButton);
    handlerProxy.on('keydown', isWebPaymentsButtonEvent, (event, ...rest)=>{
        // @ts-expect-error - TS2339 - Property 'which' does not exist on type 'Event'.
        if (event.which === 32) {
            // prevent scrolling on spacebar key press
            event.preventDefault();
        }
        // @ts-expect-error - TS2339 - Property 'which' does not exist on type 'Event'.
        if (event.which === 13) {
            // enter key press
            return handleWebPaymentsButton(event, ...rest);
        }
    });
    handlerProxy.on('keyup', isWebPaymentsButtonEvent, (event, ...rest)=>{
        // @ts-expect-error - TS2339 - Property 'which' does not exist on type 'Event'.
        if (event.which === 32) {
            // spacebar key press
            return handleWebPaymentsButton(event, ...rest);
        }
    });
};
const _default = {
    register
};

//# sourceMappingURL=data:application/json;base64,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

}),
64054: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";
/**
 * Webflow: E-commerce
 */ 
const Webflow = __webpack_require__(43949);
// $FlowFixMe[cannot-resolve-module] Added when migrating to TypeScript
const { design, destroy, init, preview } = __webpack_require__(2330);
Webflow.define('commerce', module.exports = function() {
    return {
        design,
        destroy,
        init,
        preview
    };
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYmZsb3ctY29tbWVyY2UuanMiXSwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBXZWJmbG93OiBFLWNvbW1lcmNlXG4gKi9cbmNvbnN0IFdlYmZsb3cgPSByZXF1aXJlKCcuLi9CYXNlU2l0ZU1vZHVsZXMvd2ViZmxvdy1saWInKTtcbi8vICRGbG93Rml4TWVbY2Fubm90LXJlc29sdmUtbW9kdWxlXSBBZGRlZCB3aGVuIG1pZ3JhdGluZyB0byBUeXBlU2NyaXB0XG5jb25zdCB7ZGVzaWduLCBkZXN0cm95LCBpbml0LCBwcmV2aWV3fSA9IHJlcXVpcmUoJy4vbW9kdWxlcycpO1xuXG5XZWJmbG93LmRlZmluZShcbiAgJ2NvbW1lcmNlJyxcbiAgKG1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24gKCkge1xuICAgIHJldHVybiB7ZGVzaWduLCBkZXN0cm95LCBpbml0LCBwcmV2aWV3fTtcbiAgfSlcbik7XG4iXSwibmFtZXMiOlsiV2ViZmxvdyIsInJlcXVpcmUiLCJkZXNpZ24iLCJkZXN0cm95IiwiaW5pdCIsInByZXZpZXciLCJkZWZpbmUiLCJtb2R1bGUiLCJleHBvcnRzIl0sIm1hcHBpbmdzIjoiQUFBQTs7Q0FFQztBQUNELE1BQU1BLFVBQVVDLFFBQVE7QUFDeEIsdUVBQXVFO0FBQ3ZFLE1BQU0sRUFBQ0MsTUFBTSxFQUFFQyxPQUFPLEVBQUVDLElBQUksRUFBRUMsT0FBTyxFQUFDLEdBQUdKLFFBQVE7QUFFakRELFFBQVFNLE1BQU0sQ0FDWixZQUNDQyxPQUFPQyxPQUFPLEdBQUc7SUFDaEIsT0FBTztRQUFDTjtRQUFRQztRQUFTQztRQUFNQztJQUFPO0FBQ3hDIn0=

}),
79858: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";
/* globals window, document */ /**
 * Webflow: Dropdown component
 */ 
var Webflow = __webpack_require__(43949);
var IXEvents = __webpack_require__(65134);
const KEY_CODES = {
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40,
    ESCAPE: 27,
    SPACE: 32,
    ENTER: 13,
    HOME: 36,
    END: 35
};
const FORCE_CLOSE = true;
/**
 * This pattern matches links that begin with a `#` AND have some alphanumeric
 * characters after it, including also hyphens and underscores
 *
 * Matches:
 * #foo
 * #999
 * #foo-bar_baz
 *
 * Does not match:
 * #
 */ const INTERNAL_PAGE_LINK_HASHES_PATTERN = /^#[a-zA-Z0-9\-_]+$/;
Webflow.define('dropdown', module.exports = function($, _) {
    var debounce = _.debounce;
    var api = {};
    var inApp = Webflow.env();
    var inPreview = false;
    var inDesigner;
    var touch = Webflow.env.touch;
    var namespace = '.w-dropdown';
    var openStateClassName = 'w--open';
    var ix = IXEvents.triggers;
    var defaultZIndex = 900; // @dropdown-depth
    var focusOutEvent = 'focusout' + namespace;
    var keydownEvent = 'keydown' + namespace;
    var mouseEnterEvent = 'mouseenter' + namespace;
    var mouseMoveEvent = 'mousemove' + namespace;
    var mouseLeaveEvent = 'mouseleave' + namespace;
    var mouseUpEvent = (touch ? 'click' : 'mouseup') + namespace;
    var closeEvent = 'w-close' + namespace;
    var settingEvent = 'setting' + namespace;
    var $doc = $(document);
    var $dropdowns;
    // -----------------------------------
    // Module methods
    api.ready = init;
    api.design = function() {
        // Close all when returning from preview
        if (inPreview) {
            closeAll();
        }
        inPreview = false;
        init();
    };
    api.preview = function() {
        inPreview = true;
        init();
    };
    // -----------------------------------
    // Private methods
    function init() {
        inDesigner = inApp && Webflow.env('design');
        // Find all instances on the page
        $dropdowns = $doc.find(namespace);
        $dropdowns.each(build);
    }
    function build(i, el) {
        var $el = $(el);
        // Store state in data
        var data = $.data(el, namespace);
        if (!data) {
            data = $.data(el, namespace, {
                open: false,
                el: $el,
                config: {},
                selectedIdx: -1
            });
        }
        data.toggle = data.el.children('.w-dropdown-toggle');
        data.list = data.el.children('.w-dropdown-list');
        data.links = data.list.find('a:not(.w-dropdown .w-dropdown a)');
        data.complete = complete(data);
        data.mouseLeave = makeMouseLeaveHandler(data);
        data.mouseUpOutside = outside(data);
        data.mouseMoveOutside = moveOutside(data);
        // Set config from data attributes
        configure(data);
        // Store the IDs of the toggle button & list
        var toggleId = data.toggle.attr('id');
        var listId = data.list.attr('id');
        // If user did not provide toggle ID, set it
        if (!toggleId) {
            toggleId = 'w-dropdown-toggle-' + i;
        }
        // If user did not provide list ID, set it
        if (!listId) {
            listId = 'w-dropdown-list-' + i;
        }
        // Add attributes to toggle element
        data.toggle.attr('id', toggleId);
        data.toggle.attr('aria-controls', listId);
        data.toggle.attr('aria-haspopup', 'menu');
        data.toggle.attr('aria-expanded', 'false');
        // Hide toggle icon from ATs
        data.toggle.find('.w-icon-dropdown-toggle').attr('aria-hidden', 'true');
        // If toggle element is not a button
        if (data.toggle.prop('tagName') !== 'BUTTON') {
            // Give it an appropriate role
            data.toggle.attr('role', 'button');
            // And give it a tabindex if user has not provided one
            if (!data.toggle.attr('tabindex')) {
                data.toggle.attr('tabindex', '0');
            }
        }
        // Add attributes to list element
        data.list.attr('id', listId);
        data.list.attr('aria-labelledby', toggleId);
        data.links.each(function(idx, link) {
            /**
         * In macOS Safari, links don't take focus on click unless they have
         * a tabindex. Without this, the dropdown will break.
         * @see https://gist.github.com/cvrebert/68659d0333a578d75372
         */ if (!link.hasAttribute('tabindex')) link.setAttribute('tabindex', '0');
            // We want to close the drop down if the href links somewhere internally
            // to the page
            if (INTERNAL_PAGE_LINK_HASHES_PATTERN.test(link.hash)) {
                link.addEventListener('click', close.bind(null, data));
            }
        });
        // Remove old events
        data.el.off(namespace);
        data.toggle.off(namespace);
        if (data.nav) {
            data.nav.off(namespace);
        }
        var initialToggler = makeToggler(data, FORCE_CLOSE);
        if (inDesigner) {
            data.el.on(settingEvent, makeSettingEventHandler(data));
        }
        if (!inDesigner) {
            // Close in preview mode and clean the data.hovering state
            if (inApp) {
                data.hovering = false;
                close(data);
            }
            if (data.config.hover) {
                data.toggle.on(mouseEnterEvent, makeMouseEnterHandler(data));
            }
            data.el.on(closeEvent, initialToggler);
            data.el.on(keydownEvent, makeDropdownKeydownHandler(data));
            data.el.on(focusOutEvent, makeDropdownFocusOutHandler(data));
            data.toggle.on(mouseUpEvent, initialToggler);
            data.toggle.on(keydownEvent, makeToggleKeydownHandler(data));
            data.nav = data.el.closest('.w-nav');
            data.nav.on(closeEvent, initialToggler);
        }
    }
    /**
     * Mutate the data object with a new config property
     */ function configure(data) {
        // Determine if z-index should be managed
        var zIndex = Number(data.el.css('z-index'));
        data.manageZ = zIndex === defaultZIndex || zIndex === defaultZIndex + 1;
        data.config = {
            hover: data.el.attr('data-hover') === 'true' && !touch,
            delay: data.el.attr('data-delay')
        };
    }
    function makeSettingEventHandler(data) {
        return function(evt, options) {
            options = options || {};
            configure(data);
            options.open === true && open(data);
            options.open === false && close(data, {
                immediate: true
            });
        };
    }
    function makeToggler(data, forceClose) {
        return debounce(function(evt) {
            if (data.open || evt && evt.type === 'w-close') {
                return close(data, {
                    forceClose
                });
            }
            open(data);
        });
    }
    function open(data) {
        if (data.open) {
            return;
        }
        closeOthers(data);
        data.open = true;
        data.list.addClass(openStateClassName);
        data.toggle.addClass(openStateClassName);
        data.toggle.attr('aria-expanded', 'true'); // ARIA
        ix.intro(0, data.el[0]);
        Webflow.redraw.up();
        // Increase z-index to keep above other managed dropdowns
        data.manageZ && data.el.css('z-index', defaultZIndex + 1);
        // Listen for click outside events
        var isEditor = Webflow.env('editor');
        if (!inDesigner) {
            $doc.on(mouseUpEvent, data.mouseUpOutside);
        }
        if (data.hovering && !isEditor) {
            data.el.on(mouseLeaveEvent, data.mouseLeave);
        }
        if (data.hovering && isEditor) {
            $doc.on(mouseMoveEvent, data.mouseMoveOutside);
        }
        // Clear previous delay
        window.clearTimeout(data.delayId);
    }
    function close(data, { immediate, forceClose } = {}) {
        if (!data.open) {
            return;
        }
        // Do not close hover-based menus if currently hovering
        if (data.config.hover && data.hovering && !forceClose) {
            return;
        }
        data.toggle.attr('aria-expanded', 'false');
        data.open = false;
        var config = data.config;
        ix.outro(0, data.el[0]);
        // Stop listening for click outside events
        $doc.off(mouseUpEvent, data.mouseUpOutside);
        $doc.off(mouseMoveEvent, data.mouseMoveOutside);
        data.el.off(mouseLeaveEvent, data.mouseLeave);
        // Clear previous delay
        window.clearTimeout(data.delayId);
        // Skip delay during immediate
        if (!config.delay || immediate) {
            return data.complete();
        }
        // Optionally wait for delay before close
        data.delayId = window.setTimeout(data.complete, config.delay);
    }
    function closeAll() {
        $doc.find(namespace).each(function(i, el) {
            $(el).triggerHandler(closeEvent);
        });
    }
    function closeOthers(data) {
        var self = data.el[0];
        $dropdowns.each(function(i, other) {
            var $other = $(other);
            if ($other.is(self) || $other.has(self).length) {
                return;
            }
            $other.triggerHandler(closeEvent);
        });
    }
    function outside(data) {
        // Unbind previous click handler if it exists
        if (data.mouseUpOutside) {
            $doc.off(mouseUpEvent, data.mouseUpOutside);
        }
        // Close menu when clicked outside
        return debounce(function(evt) {
            if (!data.open) {
                return;
            }
            var $target = $(evt.target);
            if ($target.closest('.w-dropdown-toggle').length) {
                return;
            }
            var isEventOutsideDropdowns = $.inArray(data.el[0], $target.parents(namespace)) === -1;
            var isEditor = Webflow.env('editor');
            if (isEventOutsideDropdowns) {
                if (isEditor) {
                    var isEventOnDetachedSvg = $target.parents().length === 1 && $target.parents('svg').length === 1;
                    var isEventOnHoverControls = $target.parents('.w-editor-bem-EditorHoverControls').length;
                    if (isEventOnDetachedSvg || isEventOnHoverControls) {
                        return;
                    }
                }
                close(data);
            }
        });
    }
    function complete(data) {
        return function() {
            data.list.removeClass(openStateClassName);
            data.toggle.removeClass(openStateClassName);
            // Reset z-index for managed dropdowns
            data.manageZ && data.el.css('z-index', '');
        };
    }
    function makeMouseEnterHandler(data) {
        return function() {
            data.hovering = true;
            open(data);
        };
    }
    function makeMouseLeaveHandler(data) {
        return function() {
            data.hovering = false;
            // We do not want the list to close upon mouseleave
            // if one of the links has focus
            if (!data.links.is(':focus')) {
                close(data);
            }
        };
    }
    function moveOutside(data) {
        return debounce(function(evt) {
            if (!data.open) {
                return;
            }
            var $target = $(evt.target);
            var isEventOutsideDropdowns = $.inArray(data.el[0], $target.parents(namespace)) === -1;
            if (isEventOutsideDropdowns) {
                var isEventOnHoverControls = $target.parents('.w-editor-bem-EditorHoverControls').length;
                var isEventOnHoverToolbar = $target.parents('.w-editor-bem-RTToolbar').length;
                var $editorOverlay = $('.w-editor-bem-EditorOverlay');
                var isDropdownInEdition = $editorOverlay.find('.w-editor-edit-outline').length || $editorOverlay.find('.w-editor-bem-RTToolbar').length;
                if (isEventOnHoverControls || isEventOnHoverToolbar || isDropdownInEdition) {
                    return;
                }
                data.hovering = false;
                close(data);
            }
        });
    }
    function makeDropdownKeydownHandler(data) {
        return function(evt) {
            // Don't respond to keyboard in designer or if the list is not open
            if (inDesigner || !data.open) {
                return;
            }
            // Realign selectedIdx with the menu item that is currently in focus.
            // We need this because we do not track the `Tab` key activity!
            data.selectedIdx = data.links.index(document.activeElement);
            // Evaluate item-selection logic
            switch(evt.keyCode){
                case KEY_CODES.HOME:
                    {
                        if (!data.open) return;
                        data.selectedIdx = 0;
                        focusSelectedLink(data);
                        return evt.preventDefault();
                    }
                case KEY_CODES.END:
                    {
                        if (!data.open) return;
                        data.selectedIdx = data.links.length - 1;
                        focusSelectedLink(data);
                        return evt.preventDefault();
                    }
                case KEY_CODES.ESCAPE:
                    {
                        close(data);
                        data.toggle.focus();
                        return evt.stopPropagation();
                    }
                case KEY_CODES.ARROW_RIGHT:
                case KEY_CODES.ARROW_DOWN:
                    {
                        data.selectedIdx = Math.min(data.links.length - 1, data.selectedIdx + 1);
                        focusSelectedLink(data);
                        return evt.preventDefault();
                    }
                case KEY_CODES.ARROW_LEFT:
                case KEY_CODES.ARROW_UP:
                    {
                        data.selectedIdx = Math.max(-1, data.selectedIdx - 1);
                        focusSelectedLink(data);
                        return evt.preventDefault();
                    }
            }
        };
    }
    function focusSelectedLink(data) {
        if (data.links[data.selectedIdx]) {
            data.links[data.selectedIdx].focus();
        }
    }
    function makeToggleKeydownHandler(data) {
        // We want to close immediately
        // if interacting via keyboard
        var toggler = makeToggler(data, FORCE_CLOSE);
        return function(evt) {
            if (inDesigner) return;
            // If the menu is not open, we don't want
            // the up or Down arrows to do anything
            if (!data.open) {
                switch(evt.keyCode){
                    case KEY_CODES.ARROW_UP:
                    case KEY_CODES.ARROW_DOWN:
                        {
                            return evt.stopPropagation();
                        }
                }
            }
            switch(evt.keyCode){
                case KEY_CODES.SPACE:
                case KEY_CODES.ENTER:
                    {
                        toggler();
                        evt.stopPropagation();
                        return evt.preventDefault();
                    }
            }
        };
    }
    function makeDropdownFocusOutHandler(data) {
        return debounce(function(evt) {
            var { relatedTarget, target } = evt;
            var menuEl = data.el[0];
            /**
         * Close menu
         * With focusout events, the `relatedTarget` is the element that will next receive focus.
         * @see: https://developer.mozilla.org/en-US/docs/Web/API/FocusEvent/relatedTarget
         */ var menuContainsFocus = menuEl.contains(relatedTarget) || menuEl.contains(target);
            if (!menuContainsFocus) {
                close(data);
            }
            return evt.stopPropagation();
        });
    }
    // Export module
    return api;
});

//# sourceMappingURL=data:application/json;base64,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

}),
48935: (function (__unused_webpack_module, exports) {
"use strict";
// Please keep this file small: it gets imported by published site code.

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CLASS_NAME_DYNAMIC_LIST: function() {
        return CLASS_NAME_DYNAMIC_LIST;
    },
    CLASS_NAME_DYNAMIC_LIST_COLUMN: function() {
        return CLASS_NAME_DYNAMIC_LIST_COLUMN;
    },
    CLASS_NAME_DYNAMIC_LIST_ITEM: function() {
        return CLASS_NAME_DYNAMIC_LIST_ITEM;
    },
    CLASS_NAME_DYNAMIC_LIST_REPEATER_ITEM: function() {
        return CLASS_NAME_DYNAMIC_LIST_REPEATER_ITEM;
    },
    CLASS_NAME_DYNAMIC_LIST_REPEATER_REF: function() {
        return CLASS_NAME_DYNAMIC_LIST_REPEATER_REF;
    },
    CLASS_NAME_DYNAMIC_LIST_ROW: function() {
        return CLASS_NAME_DYNAMIC_LIST_ROW;
    },
    CLASS_NAME_DYNAMIC_WRAPPER: function() {
        return CLASS_NAME_DYNAMIC_WRAPPER;
    },
    getColumnNumberClassName: function() {
        return getColumnNumberClassName;
    }
});
const CLASS_NAME_DYNAMIC_WRAPPER = 'w-dyn-list';
const CLASS_NAME_DYNAMIC_LIST = 'w-dyn-items';
const CLASS_NAME_DYNAMIC_LIST_REPEATER_REF = 'w-dyn-items-repeater-ref';
const CLASS_NAME_DYNAMIC_LIST_ITEM = 'w-dyn-item';
const CLASS_NAME_DYNAMIC_LIST_REPEATER_ITEM = 'w-dyn-repeater-item';
const CLASS_NAME_DYNAMIC_LIST_ROW = 'w-row';
const CLASS_NAME_DYNAMIC_LIST_COLUMN = 'w-col';
const getColumnNumberClassName = (cols)=>`w-col-${cols}`;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbnN0YW50cy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIvLyBQbGVhc2Uga2VlcCB0aGlzIGZpbGUgc21hbGw6IGl0IGdldHMgaW1wb3J0ZWQgYnkgcHVibGlzaGVkIHNpdGUgY29kZS5cblxuZXhwb3J0IGNvbnN0IENMQVNTX05BTUVfRFlOQU1JQ19XUkFQUEVSID0gJ3ctZHluLWxpc3QnO1xuZXhwb3J0IGNvbnN0IENMQVNTX05BTUVfRFlOQU1JQ19MSVNUID0gJ3ctZHluLWl0ZW1zJztcbmV4cG9ydCBjb25zdCBDTEFTU19OQU1FX0RZTkFNSUNfTElTVF9SRVBFQVRFUl9SRUYgPSAndy1keW4taXRlbXMtcmVwZWF0ZXItcmVmJztcbmV4cG9ydCBjb25zdCBDTEFTU19OQU1FX0RZTkFNSUNfTElTVF9JVEVNID0gJ3ctZHluLWl0ZW0nO1xuZXhwb3J0IGNvbnN0IENMQVNTX05BTUVfRFlOQU1JQ19MSVNUX1JFUEVBVEVSX0lURU0gPSAndy1keW4tcmVwZWF0ZXItaXRlbSc7XG5leHBvcnQgY29uc3QgQ0xBU1NfTkFNRV9EWU5BTUlDX0xJU1RfUk9XID0gJ3ctcm93JztcbmV4cG9ydCBjb25zdCBDTEFTU19OQU1FX0RZTkFNSUNfTElTVF9DT0xVTU4gPSAndy1jb2wnO1xuXG5leHBvcnQgY29uc3QgZ2V0Q29sdW1uTnVtYmVyQ2xhc3NOYW1lID0gKGNvbHM6IHN0cmluZykgPT4gYHctY29sLSR7Y29sc31gO1xuIl0sIm5hbWVzIjpbIkNMQVNTX05BTUVfRFlOQU1JQ19MSVNUIiwiQ0xBU1NfTkFNRV9EWU5BTUlDX0xJU1RfQ09MVU1OIiwiQ0xBU1NfTkFNRV9EWU5BTUlDX0xJU1RfSVRFTSIsIkNMQVNTX05BTUVfRFlOQU1JQ19MSVNUX1JFUEVBVEVSX0lURU0iLCJDTEFTU19OQU1FX0RZTkFNSUNfTElTVF9SRVBFQVRFUl9SRUYiLCJDTEFTU19OQU1FX0RZTkFNSUNfTElTVF9ST1ciLCJDTEFTU19OQU1FX0RZTkFNSUNfV1JBUFBFUiIsImdldENvbHVtbk51bWJlckNsYXNzTmFtZSIsImNvbHMiXSwibWFwcGluZ3MiOiJBQUFBLHdFQUF3RTs7Ozs7Ozs7Ozs7O0lBRzNEQSx1QkFBdUI7ZUFBdkJBOztJQUtBQyw4QkFBOEI7ZUFBOUJBOztJQUhBQyw0QkFBNEI7ZUFBNUJBOztJQUNBQyxxQ0FBcUM7ZUFBckNBOztJQUZBQyxvQ0FBb0M7ZUFBcENBOztJQUdBQywyQkFBMkI7ZUFBM0JBOztJQUxBQywwQkFBMEI7ZUFBMUJBOztJQVFBQyx3QkFBd0I7ZUFBeEJBOzs7QUFSTixNQUFNRCw2QkFBNkI7QUFDbkMsTUFBTU4sMEJBQTBCO0FBQ2hDLE1BQU1JLHVDQUF1QztBQUM3QyxNQUFNRiwrQkFBK0I7QUFDckMsTUFBTUMsd0NBQXdDO0FBQzlDLE1BQU1FLDhCQUE4QjtBQUNwQyxNQUFNSixpQ0FBaUM7QUFFdkMsTUFBTU0sMkJBQTJCLENBQUNDLE9BQWlCLENBQUMsTUFBTSxFQUFFQSxLQUFLLENBQUMifQ==

}),
27527: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";
/* globals
  window,
  document,
  WEBFLOW_FORM_API_HOST,
  WEBFLOW_FORM_OLDIE_HOST,
  WEBFLOW_EXPORT_MODE,
  turnstile
*/ /**
 * Webflow: Forms
 */ 
var Webflow = __webpack_require__(43949);
const renderTurnstileCaptcha = (siteKey, formElement, cb, errorCallback // () => void | boolean
)=>{
    const captchaContainer = document.createElement('div');
    formElement.appendChild(captchaContainer);
    // Render the captcha
    turnstile.render(captchaContainer, {
        sitekey: siteKey,
        callback: function(token) {
            cb(token);
        },
        'error-callback': function() {
            errorCallback();
        }
    });
};
Webflow.define('forms', module.exports = function($, _) {
    const TURNSTILE_LOADED_EVENT = 'TURNSTILE_LOADED';
    var api = {};
    var $doc = $(document);
    var $forms;
    var loc = window.location;
    var retro = window.XDomainRequest && !window.atob;
    var namespace = '.w-form';
    var siteId;
    var emailField = /e(-)?mail/i;
    var emailValue = /^\S+@\S+$/;
    var alert = window.alert;
    var inApp = Webflow.env();
    var listening;
    var formUrl;
    var signFileUrl;
    const turnstileSiteKey = $doc.find('[data-turnstile-sitekey]').data('turnstile-sitekey');
    let turnstileScript;
    // MailChimp domains: list-manage.com + mirrors
    var chimpRegex = /list-manage[1-9]?.com/i;
    var disconnected = _.debounce(function() {
        console.warn('Oops! This page has improperly configured forms. Please contact your website administrator to fix this issue.');
    }, 100);
    api.ready = api.design = api.preview = function() {
        // start by loading the turnstile script (if the user has the feature enabled)
        loadTurnstileScript();
        // Init forms
        init();
        // Wire document events on published and in preview workflow only once
        if ((!inApp || Webflow.env('preview')) && !listening) {
            addListeners();
        }
    };
    function init() {
        siteId = $('html').attr('data-wf-site');
        formUrl = "https://webflow.com" + '/api/v1/form/' + siteId;
        // Work around same-protocol IE XDR limitation - without this IE9 and below forms won't submit
        if (retro && formUrl.indexOf("https://webflow.com") >= 0) {
            formUrl = formUrl.replace("https://webflow.com", "https://formdata.webflow.com");
        }
        signFileUrl = `${formUrl}/signFile`;
        $forms = $(namespace + ' form');
        if (!$forms.length) {
            return;
        }
        $forms.each(build);
    }
    function loadTurnstileScript() {
        if (turnstileSiteKey) {
            // Create script tag for turnstile
            turnstileScript = document.createElement('script');
            turnstileScript.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
            document.head.appendChild(turnstileScript);
            turnstileScript.onload = ()=>{
                // after the script loads, emit an event that we listen to below.
                // this enables us to listen for the event on each form on the page and render the turnstile token for each of them.
                $doc.trigger(TURNSTILE_LOADED_EVENT);
            };
        }
    }
    function build(i, el) {
        // Store form state using namespace
        var $el = $(el);
        var data = $.data(el, namespace);
        if (!data) {
            data = $.data(el, namespace, {
                form: $el
            });
        } // data.form
        reset(data);
        var wrap = $el.closest('div.w-form');
        data.done = wrap.find('> .w-form-done');
        data.fail = wrap.find('> .w-form-fail');
        data.fileUploads = wrap.find('.w-file-upload');
        data.fileUploads.each(function(j) {
            initFileUpload(j, data);
        });
        if (turnstileSiteKey) {
            // Once all custom fonts are loaded, set the button state to indicate Turnstile is loading
            setButtonToTurnstileLoading(data);
            // Add loading state to the form wrapper
            setFormLoadingState($el, true);
            // this is probably overkill, but if the turnstile script has already loaded and we reached this point then
            // we'll fire the callback below immediately. Otherwise we'll wait for the TURNSTILE_LOADED_EVENT to fire.
            $doc.on(typeof turnstile !== 'undefined' ? 'ready' : TURNSTILE_LOADED_EVENT, function() {
                // render the hidden input with the turnstile token for each form on the page
                renderTurnstileCaptcha(turnstileSiteKey, el, (token)=>{
                    // The turnstile token gets automatically attached to the form as a hidden input field & sent on submission to the server.
                    // Here we are using this `data.turnstileToken` value to decide whether or not the submit button should be enabled.
                    data.turnstileToken = token;
                    // enable the submit button and restore text once turnstile is done rendering
                    reset(data);
                    setFormLoadingState($el, false);
                }, ()=>{
                    // If Turnstile fails, keep the button disabled but restore original state (tooltip, etc.)
                    reset(data);
                    // Ensure button is definitely disabled if reset didn't handle it (e.g., if turnstileSiteKey logic changes)
                    if (data.btn) {
                        data.btn.prop('disabled', true);
                    }
                    setFormLoadingState($el, false);
                });
            });
        }
        // Accessibility fixes
        var formName = data.form.attr('aria-label') || data.form.attr('data-name') || 'Form';
        if (!data.done.attr('aria-label')) {
            data.form.attr('aria-label', formName);
        }
        data.done.attr('tabindex', '-1');
        data.done.attr('role', 'region');
        if (!data.done.attr('aria-label')) {
            data.done.attr('aria-label', formName + ' success');
        }
        data.fail.attr('tabindex', '-1');
        data.fail.attr('role', 'region');
        if (!data.fail.attr('aria-label')) {
            data.fail.attr('aria-label', formName + ' failure');
        }
        var action = data.action = $el.attr('action');
        data.handler = null;
        data.redirect = $el.attr('data-redirect');
        // MailChimp form
        if (chimpRegex.test(action)) {
            data.handler = submitMailChimp;
            return;
        }
        // Custom form action
        if (action) {
            return;
        }
        // Webflow forms for hosting accounts
        if (siteId) {
            data.handler =  true ? exportedSubmitWebflow : 0;
            return;
        }
        // Alert for disconnected Webflow forms
        disconnected();
    }
    function addListeners() {
        listening = true;
        $doc.on('submit', namespace + ' form', function(evt) {
            var data = $.data(this, namespace);
            if (data.handler) {
                data.evt = evt;
                data.handler(data);
            }
        });
        // handle checked ui for custom checkbox and radio button
        const CHECKBOX_CLASS_NAME = '.w-checkbox-input';
        const RADIO_INPUT_CLASS_NAME = '.w-radio-input';
        const CHECKED_CLASS = 'w--redirected-checked';
        const FOCUSED_CLASS = 'w--redirected-focus';
        const FOCUSED_VISIBLE_CLASS = 'w--redirected-focus-visible';
        const focusVisibleSelectors = ':focus-visible, [data-wf-focus-visible]';
        const CUSTOM_CONTROLS = [
            [
                'checkbox',
                CHECKBOX_CLASS_NAME
            ],
            [
                'radio',
                RADIO_INPUT_CLASS_NAME
            ]
        ];
        $doc.on('change', namespace + ` form input[type="checkbox"]:not(` + CHECKBOX_CLASS_NAME + ')', (evt)=>{
            $(evt.target).siblings(CHECKBOX_CLASS_NAME).toggleClass(CHECKED_CLASS);
        });
        $doc.on('change', namespace + ` form input[type="radio"]`, (evt)=>{
            $(`input[name="${evt.target.name}"]:not(${CHECKBOX_CLASS_NAME})`).map((i, el)=>$(el).siblings(RADIO_INPUT_CLASS_NAME).removeClass(CHECKED_CLASS));
            const $target = $(evt.target);
            if (!$target.hasClass('w-radio-input')) {
                $target.siblings(RADIO_INPUT_CLASS_NAME).addClass(CHECKED_CLASS);
            }
        });
        CUSTOM_CONTROLS.forEach(([controlType, customControlClassName])=>{
            $doc.on('focus', namespace + ` form input[type="${controlType}"]:not(` + customControlClassName + ')', (evt)=>{
                $(evt.target).siblings(customControlClassName).addClass(FOCUSED_CLASS);
                $(evt.target).filter(focusVisibleSelectors).siblings(customControlClassName).addClass(FOCUSED_VISIBLE_CLASS);
            });
            $doc.on('blur', namespace + ` form input[type="${controlType}"]:not(` + customControlClassName + ')', (evt)=>{
                $(evt.target).siblings(customControlClassName).removeClass(`${FOCUSED_CLASS} ${FOCUSED_VISIBLE_CLASS}`);
            });
        });
    }
    // Reset data common to all submit handlers
    function reset(data) {
        var btn = data.btn = data.form.find(':input[type="submit"]');
        data.wait = data.btn.attr('data-wait') || null;
        data.success = false;
        // Determine if the button should be disabled
        const isDisabled = Boolean(turnstileSiteKey && !data.turnstileToken);
        btn.prop('disabled', isDisabled);
        btn.removeClass('w-form-loading');
        data.label && btn.val(data.label);
    }
    // Disable submit button during actual submission
    function disableBtn(data) {
        var btn = data.btn;
        var wait = data.wait; // Use the value from data-wait attribute
        btn.prop('disabled', true);
        // Show wait text and store previous label
        if (wait) {
            data.label = btn.val(); // Store the current label before overwriting
            btn.val(wait);
        }
    }
    // Set button state while Turnstile script is loading
    function setButtonToTurnstileLoading(data) {
        const btn = data.btn || data.form.find(':input[type="submit"]');
        if (!data.btn) data.btn = btn;
        btn.prop('disabled', true);
        btn.addClass('w-form-loading');
    }
    // Add/remove loading class from the form wrapper
    function setFormLoadingState($formEl, isLoading) {
        const $wrapper = $formEl.closest('.w-form');
        if (isLoading) {
            $wrapper.addClass('w-form-loading');
        } else {
            $wrapper.removeClass('w-form-loading');
        }
    }
    // Find form fields, validate, and set value pairs
    function findFields(form, result) {
        var status = null;
        result = result || {};
        // The ":input" selector is a jQuery shortcut to select all inputs, selects, textareas
        form.find(':input:not([type="submit"]):not([type="file"]):not([type="button"])').each(function(i, el) {
            var field = $(el);
            var type = field.attr('type');
            var name = field.attr('data-name') || field.attr('name') || 'Field ' + (i + 1);
            // Encoding the field name will prevent fields that have brackets
            // in their name from being parsed by `bodyParser.urlencoded` as
            // objects which would have unintended consequences like not saving
            // the content of the field.
            // https://webflow.atlassian.net/browse/CMSAUTH-2495
            name = encodeURIComponent(name);
            var value = field.val();
            if (type === 'checkbox') {
                value = field.is(':checked');
            } else if (type === 'radio') {
                // Radio group value already processed
                if (result[name] === null || typeof result[name] === 'string') {
                    return;
                }
                value = form.find('input[name="' + field.attr('name') + '"]:checked').val() || null;
            }
            if (typeof value === 'string') {
                value = $.trim(value);
            }
            result[name] = value;
            status = status || getStatus(field, type, name, value);
        });
        return status;
    }
    function findFileUploads(form) {
        var result = {};
        form.find(':input[type="file"]').each(function(i, el) {
            var field = $(el);
            var name = field.attr('data-name') || field.attr('name') || 'File ' + (i + 1);
            var value = field.attr('data-value');
            if (typeof value === 'string') {
                value = $.trim(value);
            }
            result[name] = value;
        });
        return result;
    }
    const trackingCookieNameMap = {
        _mkto_trk: 'marketo'
    };
    function collectEnterpriseTrackingCookies() {
        const cookies = document.cookie.split('; ').reduce(function(acc, cookie) {
            const splitCookie = cookie.split('=');
            const name = splitCookie[0];
            if (name in trackingCookieNameMap) {
                const mappedName = trackingCookieNameMap[name];
                const value = splitCookie.slice(1).join('=');
                acc[mappedName] = value;
            }
            return acc;
        }, {});
        return cookies;
    }
    function getStatus(field, type, name, value) {
        var status = null;
        if (type === 'password') {
            status = 'Passwords cannot be submitted.';
        } else if (field.attr('required')) {
            if (!value) {
                status = 'Please fill out the required field: ' + name;
            } else if (emailField.test(field.attr('type'))) {
                if (!emailValue.test(value)) {
                    status = 'Please enter a valid email address for: ' + name;
                }
            }
        } else if (name === 'g-recaptcha-response' && !value) {
            status = "Please confirm you're not a robot.";
        }
        return status;
    }
    function exportedSubmitWebflow(data) {
        preventDefault(data);
        afterSubmit(data);
    }
    // Submit form to MailChimp
    function submitMailChimp(data) {
        reset(data);
        var form = data.form;
        var payload = {};
        // Skip Ajax submission if http/s mismatch, fallback to POST instead
        if (/^https/.test(loc.href) && !/^https/.test(data.action)) {
            form.attr('method', 'post');
            return;
        }
        preventDefault(data);
        // Find & populate all fields
        var status = findFields(form, payload);
        if (status) {
            return alert(status);
        }
        // Disable submit button
        disableBtn(data);
        // Use special format for MailChimp params
        var fullName;
        _.each(payload, function(value, key) {
            if (emailField.test(key)) {
                payload.EMAIL = value;
            }
            if (/^((full[ _-]?)?name)$/i.test(key)) {
                fullName = value;
            }
            if (/^(first[ _-]?name)$/i.test(key)) {
                payload.FNAME = value;
            }
            if (/^(last[ _-]?name)$/i.test(key)) {
                payload.LNAME = value;
            }
        });
        if (fullName && !payload.FNAME) {
            fullName = fullName.split(' ');
            payload.FNAME = fullName[0];
            payload.LNAME = payload.LNAME || fullName[1];
        }
        // Use the (undocumented) MailChimp jsonp api
        var url = data.action.replace('/post?', '/post-json?') + '&c=?';
        // Add special param to prevent bot signups
        var userId = url.indexOf('u=') + 2;
        userId = url.substring(userId, url.indexOf('&', userId));
        var listId = url.indexOf('id=') + 3;
        listId = url.substring(listId, url.indexOf('&', listId));
        payload['b_' + userId + '_' + listId] = '';
        $.ajax({
            url,
            data: payload,
            dataType: 'jsonp'
        }).done(function(resp) {
            data.success = resp.result === 'success' || /already/.test(resp.msg);
            if (!data.success) {
                console.info('MailChimp error: ' + resp.msg);
            }
            afterSubmit(data);
        }).fail(function() {
            afterSubmit(data);
        });
    }
    // Common callback which runs after all Ajax submissions
    function afterSubmit(data) {
        var form = data.form;
        var redirect = data.redirect;
        var success = data.success;
        // Redirect to a success url if defined
        if (success && redirect) {
            Webflow.location(redirect);
            return;
        }
        // Show or hide status divs
        data.done.toggle(success);
        data.fail.toggle(!success);
        if (success) {
            data.done.focus();
        } else {
            data.fail.focus();
        }
        // Hide form on success
        form.toggle(!success);
        // Reset data and enable submit button
        reset(data);
    }
    function preventDefault(data) {
        data.evt && data.evt.preventDefault();
        data.evt = null;
    }
    function initFileUpload(i, form) {
        if (!form.fileUploads || !form.fileUploads[i]) {
            return;
        }
        var file;
        var $el = $(form.fileUploads[i]);
        var $defaultWrap = $el.find('> .w-file-upload-default');
        var $uploadingWrap = $el.find('> .w-file-upload-uploading');
        var $successWrap = $el.find('> .w-file-upload-success');
        var $errorWrap = $el.find('> .w-file-upload-error');
        var $input = $defaultWrap.find('.w-file-upload-input');
        var $label = $defaultWrap.find('.w-file-upload-label');
        var $labelChildren = $label.children();
        var $errorMsgEl = $errorWrap.find('.w-file-upload-error-msg');
        var $fileEl = $successWrap.find('.w-file-upload-file');
        var $removeEl = $successWrap.find('.w-file-remove-link');
        var $fileNameEl = $fileEl.find('.w-file-upload-file-name');
        var sizeErrMsg = $errorMsgEl.attr('data-w-size-error');
        var typeErrMsg = $errorMsgEl.attr('data-w-type-error');
        var genericErrMsg = $errorMsgEl.attr('data-w-generic-error');
        // Accessibility fixes
        // The file upload Input is not stylable by the designer, so we are
        // going to pretend the Label is the input. ¯\_(ツ)_/¯
        if (!inApp) {
            $label.on('click keydown', function(e) {
                if (e.type === 'keydown' && e.which !== 13 && e.which !== 32) {
                    return;
                }
                e.preventDefault();
                $input.click();
            });
        }
        // Both of these are added through CSS
        $label.find('.w-icon-file-upload-icon').attr('aria-hidden', 'true');
        $removeEl.find('.w-icon-file-upload-remove').attr('aria-hidden', 'true');
        if (!inApp) {
            $removeEl.on('click keydown', function(e) {
                if (e.type === 'keydown') {
                    if (e.which !== 13 && e.which !== 32) {
                        return;
                    }
                    e.preventDefault();
                }
                $input.removeAttr('data-value');
                $input.val('');
                $fileNameEl.html('');
                $defaultWrap.toggle(true);
                $successWrap.toggle(false);
                $label.focus();
            });
            $input.on('change', function(e) {
                file = e.target && e.target.files && e.target.files[0];
                if (!file) {
                    return;
                }
                // Show uploading
                $defaultWrap.toggle(false);
                $errorWrap.toggle(false);
                $uploadingWrap.toggle(true);
                $uploadingWrap.focus();
                // Set filename
                $fileNameEl.text(file.name);
                // Disable submit button
                if (!isUploading()) {
                    disableBtn(form);
                }
                form.fileUploads[i].uploading = true;
                signFile(file, afterSign);
            });
            // Setting input width 1px and height equal label
            // This is so the browser required error will show up
            var height = $label.outerHeight();
            $input.height(height);
            $input.width(1);
        } else {
            $input.on('click', function(e) {
                e.preventDefault();
            });
            $label.on('click', function(e) {
                e.preventDefault();
            });
            $labelChildren.on('click', function(e) {
                e.preventDefault();
            });
        }
        function parseError(err) {
            var errorMsg = err.responseJSON && err.responseJSON.msg;
            var userError = genericErrMsg;
            if (typeof errorMsg === 'string' && errorMsg.indexOf('InvalidFileTypeError') === 0) {
                userError = typeErrMsg;
            } else if (typeof errorMsg === 'string' && errorMsg.indexOf('MaxFileSizeError') === 0) {
                userError = sizeErrMsg;
            }
            $errorMsgEl.text(userError);
            $input.removeAttr('data-value');
            $input.val('');
            $uploadingWrap.toggle(false);
            $defaultWrap.toggle(true);
            $errorWrap.toggle(true);
            $errorWrap.focus();
            form.fileUploads[i].uploading = false;
            if (!isUploading()) {
                reset(form);
            }
        }
        function afterSign(err, data) {
            if (err) {
                return parseError(err);
            }
            var fileName = data.fileName;
            var postData = data.postData;
            var fileId = data.fileId;
            var s3Url = data.s3Url;
            $input.attr('data-value', fileId);
            uploadS3(s3Url, postData, file, fileName, afterUpload);
        }
        function afterUpload(err) {
            if (err) {
                return parseError(err);
            }
            // Show success
            $uploadingWrap.toggle(false);
            $successWrap.css('display', 'inline-block');
            $successWrap.focus();
            form.fileUploads[i].uploading = false;
            if (!isUploading()) {
                reset(form);
            }
        }
        function isUploading() {
            var uploads = form.fileUploads && form.fileUploads.toArray() || [];
            return uploads.some(function(value) {
                return value.uploading;
            });
        }
    }
    function signFile(file, cb) {
        var payload = new URLSearchParams({
            name: file.name,
            size: file.size
        });
        $.ajax({
            type: 'GET',
            url: `${signFileUrl}?${payload}`,
            crossDomain: true
        }).done(function(data) {
            cb(null, data);
        }).fail(function(err) {
            cb(err);
        });
    }
    function uploadS3(url, data, file, fileName, cb) {
        var formData = new FormData();
        for(var k in data){
            formData.append(k, data[k]);
        }
        formData.append('file', file, fileName);
        $.ajax({
            type: 'POST',
            url,
            data: formData,
            processData: false,
            contentType: false
        }).done(function() {
            cb(null);
        }).fail(function(err) {
            cb(err);
        });
    }
    // Export module
    return api;
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYmZsb3ctZm9ybXMuanMiXSwic291cmNlc0NvbnRlbnQiOlsiLyogZ2xvYmFsc1xuICB3aW5kb3csXG4gIGRvY3VtZW50LFxuICBXRUJGTE9XX0ZPUk1fQVBJX0hPU1QsXG4gIFdFQkZMT1dfRk9STV9PTERJRV9IT1NULFxuICBXRUJGTE9XX0VYUE9SVF9NT0RFLFxuICB0dXJuc3RpbGVcbiovXG5cbi8qKlxuICogV2ViZmxvdzogRm9ybXNcbiAqL1xuXG52YXIgV2ViZmxvdyA9IHJlcXVpcmUoJy4uL0Jhc2VTaXRlTW9kdWxlcy93ZWJmbG93LWxpYicpO1xuXG5jb25zdCByZW5kZXJUdXJuc3RpbGVDYXB0Y2hhID0gKFxuICBzaXRlS2V5LCAvLyBzdHJpbmdcbiAgZm9ybUVsZW1lbnQsIC8vIEhUTUxGb3JtRWxlbWVudFxuICBjYiwgLy8gKHRva2VuOiBzdHJpbmcpID0+IHZvaWRcbiAgZXJyb3JDYWxsYmFjayAvLyAoKSA9PiB2b2lkIHwgYm9vbGVhblxuKSA9PiB7XG4gIGNvbnN0IGNhcHRjaGFDb250YWluZXIgPSBkb2N1bWVudC5jcmVhdGVFbGVtZW50KCdkaXYnKTtcbiAgZm9ybUVsZW1lbnQuYXBwZW5kQ2hpbGQoY2FwdGNoYUNvbnRhaW5lcik7XG5cbiAgLy8gUmVuZGVyIHRoZSBjYXB0Y2hhXG4gIHR1cm5zdGlsZS5yZW5kZXIoY2FwdGNoYUNvbnRhaW5lciwge1xuICAgIHNpdGVrZXk6IHNpdGVLZXksXG4gICAgY2FsbGJhY2s6IGZ1bmN0aW9uICh0b2tlbikge1xuICAgICAgY2IodG9rZW4pO1xuICAgIH0sXG4gICAgJ2Vycm9yLWNhbGxiYWNrJzogZnVuY3Rpb24gKCkge1xuICAgICAgZXJyb3JDYWxsYmFjaygpO1xuICAgIH0sXG4gIH0pO1xufTtcblxuV2ViZmxvdy5kZWZpbmUoXG4gICdmb3JtcycsXG4gIChtb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uICgkLCBfKSB7XG4gICAgY29uc3QgVFVSTlNUSUxFX0xPQURFRF9FVkVOVCA9ICdUVVJOU1RJTEVfTE9BREVEJztcbiAgICB2YXIgYXBpID0ge307XG5cbiAgICB2YXIgJGRvYyA9ICQoZG9jdW1lbnQpO1xuICAgIHZhciAkZm9ybXM7XG4gICAgdmFyIGxvYyA9IHdpbmRvdy5sb2NhdGlvbjtcbiAgICB2YXIgcmV0cm8gPSB3aW5kb3cuWERvbWFpblJlcXVlc3QgJiYgIXdpbmRvdy5hdG9iO1xuICAgIHZhciBuYW1lc3BhY2UgPSAnLnctZm9ybSc7XG4gICAgdmFyIHNpdGVJZDtcbiAgICB2YXIgZW1haWxGaWVsZCA9IC9lKC0pP21haWwvaTtcbiAgICB2YXIgZW1haWxWYWx1ZSA9IC9eXFxTK0BcXFMrJC87XG4gICAgdmFyIGFsZXJ0ID0gd2luZG93LmFsZXJ0O1xuICAgIHZhciBpbkFwcCA9IFdlYmZsb3cuZW52KCk7XG4gICAgdmFyIGxpc3RlbmluZztcblxuICAgIHZhciBmb3JtVXJsO1xuICAgIHZhciBzaWduRmlsZVVybDtcblxuICAgIGNvbnN0IHR1cm5zdGlsZVNpdGVLZXkgPSAkZG9jXG4gICAgICAuZmluZCgnW2RhdGEtdHVybnN0aWxlLXNpdGVrZXldJylcbiAgICAgIC5kYXRhKCd0dXJuc3RpbGUtc2l0ZWtleScpO1xuICAgIGxldCB0dXJuc3RpbGVTY3JpcHQ7XG5cbiAgICAvLyBNYWlsQ2hpbXAgZG9tYWluczogbGlzdC1tYW5hZ2UuY29tICsgbWlycm9yc1xuICAgIHZhciBjaGltcFJlZ2V4ID0gL2xpc3QtbWFuYWdlWzEtOV0/LmNvbS9pO1xuXG4gICAgdmFyIGRpc2Nvbm5lY3RlZCA9IF8uZGVib3VuY2UoZnVuY3Rpb24gKCkge1xuICAgICAgY29uc29sZS53YXJuKFxuICAgICAgICAnT29wcyEgVGhpcyBwYWdlIGhhcyBpbXByb3Blcmx5IGNvbmZpZ3VyZWQgZm9ybXMuIFBsZWFzZSBjb250YWN0IHlvdXIgd2Vic2l0ZSBhZG1pbmlzdHJhdG9yIHRvIGZpeCB0aGlzIGlzc3VlLidcbiAgICAgICk7XG4gICAgfSwgMTAwKTtcblxuICAgIGFwaS5yZWFkeSA9XG4gICAgICBhcGkuZGVzaWduID1cbiAgICAgIGFwaS5wcmV2aWV3ID1cbiAgICAgICAgZnVuY3Rpb24gKCkge1xuICAgICAgICAgIC8vIHN0YXJ0IGJ5IGxvYWRpbmcgdGhlIHR1cm5zdGlsZSBzY3JpcHQgKGlmIHRoZSB1c2VyIGhhcyB0aGUgZmVhdHVyZSBlbmFibGVkKVxuICAgICAgICAgIGxvYWRUdXJuc3RpbGVTY3JpcHQoKTtcblxuICAgICAgICAgIC8vIEluaXQgZm9ybXNcbiAgICAgICAgICBpbml0KCk7XG5cbiAgICAgICAgICAvLyBXaXJlIGRvY3VtZW50IGV2ZW50cyBvbiBwdWJsaXNoZWQgYW5kIGluIHByZXZpZXcgd29ya2Zsb3cgb25seSBvbmNlXG4gICAgICAgICAgaWYgKCghaW5BcHAgfHwgV2ViZmxvdy5lbnYoJ3ByZXZpZXcnKSkgJiYgIWxpc3RlbmluZykge1xuICAgICAgICAgICAgYWRkTGlzdGVuZXJzKCk7XG4gICAgICAgICAgfVxuICAgICAgICB9O1xuXG4gICAgZnVuY3Rpb24gaW5pdCgpIHtcbiAgICAgIHNpdGVJZCA9ICQoJ2h0bWwnKS5hdHRyKCdkYXRhLXdmLXNpdGUnKTtcblxuICAgICAgZm9ybVVybCA9IFdFQkZMT1dfRk9STV9BUElfSE9TVCArICcvYXBpL3YxL2Zvcm0vJyArIHNpdGVJZDtcblxuICAgICAgLy8gV29yayBhcm91bmQgc2FtZS1wcm90b2NvbCBJRSBYRFIgbGltaXRhdGlvbiAtIHdpdGhvdXQgdGhpcyBJRTkgYW5kIGJlbG93IGZvcm1zIHdvbid0IHN1Ym1pdFxuICAgICAgaWYgKHJldHJvICYmIGZvcm1VcmwuaW5kZXhPZihXRUJGTE9XX0ZPUk1fQVBJX0hPU1QpID49IDApIHtcbiAgICAgICAgZm9ybVVybCA9IGZvcm1VcmwucmVwbGFjZShcbiAgICAgICAgICBXRUJGTE9XX0ZPUk1fQVBJX0hPU1QsXG4gICAgICAgICAgV0VCRkxPV19GT1JNX09MRElFX0hPU1RcbiAgICAgICAgKTtcbiAgICAgIH1cblxuICAgICAgc2lnbkZpbGVVcmwgPSBgJHtmb3JtVXJsfS9zaWduRmlsZWA7XG5cbiAgICAgICRmb3JtcyA9ICQobmFtZXNwYWNlICsgJyBmb3JtJyk7XG4gICAgICBpZiAoISRmb3Jtcy5sZW5ndGgpIHtcbiAgICAgICAgcmV0dXJuO1xuICAgICAgfVxuICAgICAgJGZvcm1zLmVhY2goYnVpbGQpO1xuICAgIH1cblxuICAgIGZ1bmN0aW9uIGxvYWRUdXJuc3RpbGVTY3JpcHQoKSB7XG4gICAgICBpZiAodHVybnN0aWxlU2l0ZUtleSkge1xuICAgICAgICAvLyBDcmVhdGUgc2NyaXB0IHRhZyBmb3IgdHVybnN0aWxlXG4gICAgICAgIHR1cm5zdGlsZVNjcmlwdCA9IGRvY3VtZW50LmNyZWF0ZUVsZW1lbnQoJ3NjcmlwdCcpO1xuICAgICAgICB0dXJuc3RpbGVTY3JpcHQuc3JjID1cbiAgICAgICAgICAnaHR0cHM6Ly9jaGFsbGVuZ2VzLmNsb3VkZmxhcmUuY29tL3R1cm5zdGlsZS92MC9hcGkuanMnO1xuICAgICAgICBkb2N1bWVudC5oZWFkLmFwcGVuZENoaWxkKHR1cm5zdGlsZVNjcmlwdCk7XG4gICAgICAgIHR1cm5zdGlsZVNjcmlwdC5vbmxvYWQgPSAoKSA9PiB7XG4gICAgICAgICAgLy8gYWZ0ZXIgdGhlIHNjcmlwdCBsb2FkcywgZW1pdCBhbiBldmVudCB0aGF0IHdlIGxpc3RlbiB0byBiZWxvdy5cbiAgICAgICAgICAvLyB0aGlzIGVuYWJsZXMgdXMgdG8gbGlzdGVuIGZvciB0aGUgZXZlbnQgb24gZWFjaCBmb3JtIG9uIHRoZSBwYWdlIGFuZCByZW5kZXIgdGhlIHR1cm5zdGlsZSB0b2tlbiBmb3IgZWFjaCBvZiB0aGVtLlxuICAgICAgICAgICRkb2MudHJpZ2dlcihUVVJOU1RJTEVfTE9BREVEX0VWRU5UKTtcbiAgICAgICAgfTtcbiAgICAgIH1cbiAgICB9XG5cbiAgICBmdW5jdGlvbiBidWlsZChpLCBlbCkge1xuICAgICAgLy8gU3RvcmUgZm9ybSBzdGF0ZSB1c2luZyBuYW1lc3BhY2VcbiAgICAgIHZhciAkZWwgPSAkKGVsKTtcbiAgICAgIHZhciBkYXRhID0gJC5kYXRhKGVsLCBuYW1lc3BhY2UpO1xuICAgICAgaWYgKCFkYXRhKSB7XG4gICAgICAgIGRhdGEgPSAkLmRhdGEoZWwsIG5hbWVzcGFjZSwge2Zvcm06ICRlbH0pO1xuICAgICAgfSAvLyBkYXRhLmZvcm1cblxuICAgICAgcmVzZXQoZGF0YSk7XG4gICAgICB2YXIgd3JhcCA9ICRlbC5jbG9zZXN0KCdkaXYudy1mb3JtJyk7XG4gICAgICBkYXRhLmRvbmUgPSB3cmFwLmZpbmQoJz4gLnctZm9ybS1kb25lJyk7XG4gICAgICBkYXRhLmZhaWwgPSB3cmFwLmZpbmQoJz4gLnctZm9ybS1mYWlsJyk7XG4gICAgICBkYXRhLmZpbGVVcGxvYWRzID0gd3JhcC5maW5kKCcudy1maWxlLXVwbG9hZCcpO1xuXG4gICAgICBkYXRhLmZpbGVVcGxvYWRzLmVhY2goZnVuY3Rpb24gKGopIHtcbiAgICAgICAgaW5pdEZpbGVVcGxvYWQoaiwgZGF0YSk7XG4gICAgICB9KTtcblxuICAgICAgaWYgKHR1cm5zdGlsZVNpdGVLZXkpIHtcbiAgICAgICAgLy8gT25jZSBhbGwgY3VzdG9tIGZvbnRzIGFyZSBsb2FkZWQsIHNldCB0aGUgYnV0dG9uIHN0YXRlIHRvIGluZGljYXRlIFR1cm5zdGlsZSBpcyBsb2FkaW5nXG4gICAgICAgIHNldEJ1dHRvblRvVHVybnN0aWxlTG9hZGluZyhkYXRhKTtcblxuICAgICAgICAvLyBBZGQgbG9hZGluZyBzdGF0ZSB0byB0aGUgZm9ybSB3cmFwcGVyXG4gICAgICAgIHNldEZvcm1Mb2FkaW5nU3RhdGUoJGVsLCB0cnVlKTtcblxuICAgICAgICAvLyB0aGlzIGlzIHByb2JhYmx5IG92ZXJraWxsLCBidXQgaWYgdGhlIHR1cm5zdGlsZSBzY3JpcHQgaGFzIGFscmVhZHkgbG9hZGVkIGFuZCB3ZSByZWFjaGVkIHRoaXMgcG9pbnQgdGhlblxuICAgICAgICAvLyB3ZSdsbCBmaXJlIHRoZSBjYWxsYmFjayBiZWxvdyBpbW1lZGlhdGVseS4gT3RoZXJ3aXNlIHdlJ2xsIHdhaXQgZm9yIHRoZSBUVVJOU1RJTEVfTE9BREVEX0VWRU5UIHRvIGZpcmUuXG4gICAgICAgICRkb2Mub24oXG4gICAgICAgICAgdHlwZW9mIHR1cm5zdGlsZSAhPT0gJ3VuZGVmaW5lZCcgPyAncmVhZHknIDogVFVSTlNUSUxFX0xPQURFRF9FVkVOVCxcbiAgICAgICAgICBmdW5jdGlvbiAoKSB7XG4gICAgICAgICAgICAvLyByZW5kZXIgdGhlIGhpZGRlbiBpbnB1dCB3aXRoIHRoZSB0dXJuc3RpbGUgdG9rZW4gZm9yIGVhY2ggZm9ybSBvbiB0aGUgcGFnZVxuICAgICAgICAgICAgcmVuZGVyVHVybnN0aWxlQ2FwdGNoYShcbiAgICAgICAgICAgICAgdHVybnN0aWxlU2l0ZUtleSxcbiAgICAgICAgICAgICAgZWwsXG4gICAgICAgICAgICAgICh0b2tlbikgPT4ge1xuICAgICAgICAgICAgICAgIC8vIFRoZSB0dXJuc3RpbGUgdG9rZW4gZ2V0cyBhdXRvbWF0aWNhbGx5IGF0dGFjaGVkIHRvIHRoZSBmb3JtIGFzIGEgaGlkZGVuIGlucHV0IGZpZWxkICYgc2VudCBvbiBzdWJtaXNzaW9uIHRvIHRoZSBzZXJ2ZXIuXG4gICAgICAgICAgICAgICAgLy8gSGVyZSB3ZSBhcmUgdXNpbmcgdGhpcyBgZGF0YS50dXJuc3RpbGVUb2tlbmAgdmFsdWUgdG8gZGVjaWRlIHdoZXRoZXIgb3Igbm90IHRoZSBzdWJtaXQgYnV0dG9uIHNob3VsZCBiZSBlbmFibGVkLlxuICAgICAgICAgICAgICAgIGRhdGEudHVybnN0aWxlVG9rZW4gPSB0b2tlbjtcbiAgICAgICAgICAgICAgICAvLyBlbmFibGUgdGhlIHN1Ym1pdCBidXR0b24gYW5kIHJlc3RvcmUgdGV4dCBvbmNlIHR1cm5zdGlsZSBpcyBkb25lIHJlbmRlcmluZ1xuICAgICAgICAgICAgICAgIHJlc2V0KGRhdGEpO1xuICAgICAgICAgICAgICAgIHNldEZvcm1Mb2FkaW5nU3RhdGUoJGVsLCBmYWxzZSk7XG4gICAgICAgICAgICAgIH0sXG4gICAgICAgICAgICAgICgpID0+IHtcbiAgICAgICAgICAgICAgICAvLyBJZiBUdXJuc3RpbGUgZmFpbHMsIGtlZXAgdGhlIGJ1dHRvbiBkaXNhYmxlZCBidXQgcmVzdG9yZSBvcmlnaW5hbCBzdGF0ZSAodG9vbHRpcCwgZXRjLilcbiAgICAgICAgICAgICAgICByZXNldChkYXRhKTtcbiAgICAgICAgICAgICAgICAvLyBFbnN1cmUgYnV0dG9uIGlzIGRlZmluaXRlbHkgZGlzYWJsZWQgaWYgcmVzZXQgZGlkbid0IGhhbmRsZSBpdCAoZS5nLiwgaWYgdHVybnN0aWxlU2l0ZUtleSBsb2dpYyBjaGFuZ2VzKVxuICAgICAgICAgICAgICAgIGlmIChkYXRhLmJ0bikge1xuICAgICAgICAgICAgICAgICAgZGF0YS5idG4ucHJvcCgnZGlzYWJsZWQnLCB0cnVlKTtcbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgc2V0Rm9ybUxvYWRpbmdTdGF0ZSgkZWwsIGZhbHNlKTtcbiAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgKTtcbiAgICAgICAgICB9XG4gICAgICAgICk7XG4gICAgICB9XG5cbiAgICAgIC8vIEFjY2Vzc2liaWxpdHkgZml4ZXNcbiAgICAgIHZhciBmb3JtTmFtZSA9XG4gICAgICAgIGRhdGEuZm9ybS5hdHRyKCdhcmlhLWxhYmVsJykgfHwgZGF0YS5mb3JtLmF0dHIoJ2RhdGEtbmFtZScpIHx8ICdGb3JtJztcbiAgICAgIGlmICghZGF0YS5kb25lLmF0dHIoJ2FyaWEtbGFiZWwnKSkge1xuICAgICAgICBkYXRhLmZvcm0uYXR0cignYXJpYS1sYWJlbCcsIGZvcm1OYW1lKTtcbiAgICAgIH1cblxuICAgICAgZGF0YS5kb25lLmF0dHIoJ3RhYmluZGV4JywgJy0xJyk7XG4gICAgICBkYXRhLmRvbmUuYXR0cigncm9sZScsICdyZWdpb24nKTtcbiAgICAgIGlmICghZGF0YS5kb25lLmF0dHIoJ2FyaWEtbGFiZWwnKSkge1xuICAgICAgICBkYXRhLmRvbmUuYXR0cignYXJpYS1sYWJlbCcsIGZvcm1OYW1lICsgJyBzdWNjZXNzJyk7XG4gICAgICB9XG4gICAgICBkYXRhLmZhaWwuYXR0cigndGFiaW5kZXgnLCAnLTEnKTtcbiAgICAgIGRhdGEuZmFpbC5hdHRyKCdyb2xlJywgJ3JlZ2lvbicpO1xuICAgICAgaWYgKCFkYXRhLmZhaWwuYXR0cignYXJpYS1sYWJlbCcpKSB7XG4gICAgICAgIGRhdGEuZmFpbC5hdHRyKCdhcmlhLWxhYmVsJywgZm9ybU5hbWUgKyAnIGZhaWx1cmUnKTtcbiAgICAgIH1cblxuICAgICAgdmFyIGFjdGlvbiA9IChkYXRhLmFjdGlvbiA9ICRlbC5hdHRyKCdhY3Rpb24nKSk7XG4gICAgICBkYXRhLmhhbmRsZXIgPSBudWxsO1xuICAgICAgZGF0YS5yZWRpcmVjdCA9ICRlbC5hdHRyKCdkYXRhLXJlZGlyZWN0Jyk7XG5cbiAgICAgIC8vIE1haWxDaGltcCBmb3JtXG4gICAgICBpZiAoY2hpbXBSZWdleC50ZXN0KGFjdGlvbikpIHtcbiAgICAgICAgZGF0YS5oYW5kbGVyID0gc3VibWl0TWFpbENoaW1wO1xuICAgICAgICByZXR1cm47XG4gICAgICB9XG5cbiAgICAgIC8vIEN1c3RvbSBmb3JtIGFjdGlvblxuICAgICAgaWYgKGFjdGlvbikge1xuICAgICAgICByZXR1cm47XG4gICAgICB9XG5cbiAgICAgIC8vIFdlYmZsb3cgZm9ybXMgZm9yIGhvc3RpbmcgYWNjb3VudHNcbiAgICAgIGlmIChzaXRlSWQpIHtcbiAgICAgICAgZGF0YS5oYW5kbGVyID0gV0VCRkxPV19FWFBPUlRfTU9ERVxuICAgICAgICAgID8gZXhwb3J0ZWRTdWJtaXRXZWJmbG93XG4gICAgICAgICAgOiAoKCkgPT4ge1xuICAgICAgICAgICAgICBjb25zdCBob3N0ZWRTdWJtaXRIYW5kbGVyID1cbiAgICAgICAgICAgICAgICByZXF1aXJlKCcuL3dlYmZsb3ctZm9ybXMtaG9zdGVkJykuZGVmYXVsdDtcbiAgICAgICAgICAgICAgcmV0dXJuIGhvc3RlZFN1Ym1pdEhhbmRsZXIoXG4gICAgICAgICAgICAgICAgcmVzZXQsXG4gICAgICAgICAgICAgICAgbG9jLFxuICAgICAgICAgICAgICAgIFdlYmZsb3csXG4gICAgICAgICAgICAgICAgY29sbGVjdEVudGVycHJpc2VUcmFja2luZ0Nvb2tpZXMsXG4gICAgICAgICAgICAgICAgcHJldmVudERlZmF1bHQsXG4gICAgICAgICAgICAgICAgZmluZEZpZWxkcyxcbiAgICAgICAgICAgICAgICBhbGVydCxcbiAgICAgICAgICAgICAgICBmaW5kRmlsZVVwbG9hZHMsXG4gICAgICAgICAgICAgICAgZGlzYWJsZUJ0bixcbiAgICAgICAgICAgICAgICBzaXRlSWQsXG4gICAgICAgICAgICAgICAgYWZ0ZXJTdWJtaXQsXG4gICAgICAgICAgICAgICAgJCxcbiAgICAgICAgICAgICAgICBmb3JtVXJsXG4gICAgICAgICAgICAgICk7XG4gICAgICAgICAgICB9KSgpO1xuICAgICAgICByZXR1cm47XG4gICAgICB9XG5cbiAgICAgIC8vIEFsZXJ0IGZvciBkaXNjb25uZWN0ZWQgV2ViZmxvdyBmb3Jtc1xuICAgICAgZGlzY29ubmVjdGVkKCk7XG4gICAgfVxuXG4gICAgZnVuY3Rpb24gYWRkTGlzdGVuZXJzKCkge1xuICAgICAgbGlzdGVuaW5nID0gdHJ1ZTtcblxuICAgICAgJGRvYy5vbignc3VibWl0JywgbmFtZXNwYWNlICsgJyBmb3JtJywgZnVuY3Rpb24gKGV2dCkge1xuICAgICAgICB2YXIgZGF0YSA9ICQuZGF0YSh0aGlzLCBuYW1lc3BhY2UpO1xuICAgICAgICBpZiAoZGF0YS5oYW5kbGVyKSB7XG4gICAgICAgICAgZGF0YS5ldnQgPSBldnQ7XG4gICAgICAgICAgZGF0YS5oYW5kbGVyKGRhdGEpO1xuICAgICAgICB9XG4gICAgICB9KTtcblxuICAgICAgLy8gaGFuZGxlIGNoZWNrZWQgdWkgZm9yIGN1c3RvbSBjaGVja2JveCBhbmQgcmFkaW8gYnV0dG9uXG4gICAgICBjb25zdCBDSEVDS0JPWF9DTEFTU19OQU1FID0gJy53LWNoZWNrYm94LWlucHV0JztcbiAgICAgIGNvbnN0IFJBRElPX0lOUFVUX0NMQVNTX05BTUUgPSAnLnctcmFkaW8taW5wdXQnO1xuICAgICAgY29uc3QgQ0hFQ0tFRF9DTEFTUyA9ICd3LS1yZWRpcmVjdGVkLWNoZWNrZWQnO1xuICAgICAgY29uc3QgRk9DVVNFRF9DTEFTUyA9ICd3LS1yZWRpcmVjdGVkLWZvY3VzJztcbiAgICAgIGNvbnN0IEZPQ1VTRURfVklTSUJMRV9DTEFTUyA9ICd3LS1yZWRpcmVjdGVkLWZvY3VzLXZpc2libGUnO1xuICAgICAgY29uc3QgZm9jdXNWaXNpYmxlU2VsZWN0b3JzID0gJzpmb2N1cy12aXNpYmxlLCBbZGF0YS13Zi1mb2N1cy12aXNpYmxlXSc7XG5cbiAgICAgIGNvbnN0IENVU1RPTV9DT05UUk9MUyA9IFtcbiAgICAgICAgWydjaGVja2JveCcsIENIRUNLQk9YX0NMQVNTX05BTUVdLFxuICAgICAgICBbJ3JhZGlvJywgUkFESU9fSU5QVVRfQ0xBU1NfTkFNRV0sXG4gICAgICBdO1xuXG4gICAgICAkZG9jLm9uKFxuICAgICAgICAnY2hhbmdlJyxcbiAgICAgICAgbmFtZXNwYWNlICtcbiAgICAgICAgICBgIGZvcm0gaW5wdXRbdHlwZT1cImNoZWNrYm94XCJdOm5vdChgICtcbiAgICAgICAgICBDSEVDS0JPWF9DTEFTU19OQU1FICtcbiAgICAgICAgICAnKScsXG4gICAgICAgIChldnQpID0+IHtcbiAgICAgICAgICAkKGV2dC50YXJnZXQpXG4gICAgICAgICAgICAuc2libGluZ3MoQ0hFQ0tCT1hfQ0xBU1NfTkFNRSlcbiAgICAgICAgICAgIC50b2dnbGVDbGFzcyhDSEVDS0VEX0NMQVNTKTtcbiAgICAgICAgfVxuICAgICAgKTtcblxuICAgICAgJGRvYy5vbignY2hhbmdlJywgbmFtZXNwYWNlICsgYCBmb3JtIGlucHV0W3R5cGU9XCJyYWRpb1wiXWAsIChldnQpID0+IHtcbiAgICAgICAgJChgaW5wdXRbbmFtZT1cIiR7ZXZ0LnRhcmdldC5uYW1lfVwiXTpub3QoJHtDSEVDS0JPWF9DTEFTU19OQU1FfSlgKS5tYXAoXG4gICAgICAgICAgKGksIGVsKSA9PlxuICAgICAgICAgICAgJChlbCkuc2libGluZ3MoUkFESU9fSU5QVVRfQ0xBU1NfTkFNRSkucmVtb3ZlQ2xhc3MoQ0hFQ0tFRF9DTEFTUylcbiAgICAgICAgKTtcblxuICAgICAgICBjb25zdCAkdGFyZ2V0ID0gJChldnQudGFyZ2V0KTtcblxuICAgICAgICBpZiAoISR0YXJnZXQuaGFzQ2xhc3MoJ3ctcmFkaW8taW5wdXQnKSkge1xuICAgICAgICAgICR0YXJnZXQuc2libGluZ3MoUkFESU9fSU5QVVRfQ0xBU1NfTkFNRSkuYWRkQ2xhc3MoQ0hFQ0tFRF9DTEFTUyk7XG4gICAgICAgIH1cbiAgICAgIH0pO1xuXG4gICAgICBDVVNUT01fQ09OVFJPTFMuZm9yRWFjaCgoW2NvbnRyb2xUeXBlLCBjdXN0b21Db250cm9sQ2xhc3NOYW1lXSkgPT4ge1xuICAgICAgICAkZG9jLm9uKFxuICAgICAgICAgICdmb2N1cycsXG4gICAgICAgICAgbmFtZXNwYWNlICtcbiAgICAgICAgICAgIGAgZm9ybSBpbnB1dFt0eXBlPVwiJHtjb250cm9sVHlwZX1cIl06bm90KGAgK1xuICAgICAgICAgICAgY3VzdG9tQ29udHJvbENsYXNzTmFtZSArXG4gICAgICAgICAgICAnKScsXG4gICAgICAgICAgKGV2dCkgPT4ge1xuICAgICAgICAgICAgJChldnQudGFyZ2V0KVxuICAgICAgICAgICAgICAuc2libGluZ3MoY3VzdG9tQ29udHJvbENsYXNzTmFtZSlcbiAgICAgICAgICAgICAgLmFkZENsYXNzKEZPQ1VTRURfQ0xBU1MpO1xuICAgICAgICAgICAgJChldnQudGFyZ2V0KVxuICAgICAgICAgICAgICAuZmlsdGVyKGZvY3VzVmlzaWJsZVNlbGVjdG9ycylcbiAgICAgICAgICAgICAgLnNpYmxpbmdzKGN1c3RvbUNvbnRyb2xDbGFzc05hbWUpXG4gICAgICAgICAgICAgIC5hZGRDbGFzcyhGT0NVU0VEX1ZJU0lCTEVfQ0xBU1MpO1xuICAgICAgICAgIH1cbiAgICAgICAgKTtcbiAgICAgICAgJGRvYy5vbihcbiAgICAgICAgICAnYmx1cicsXG4gICAgICAgICAgbmFtZXNwYWNlICtcbiAgICAgICAgICAgIGAgZm9ybSBpbnB1dFt0eXBlPVwiJHtjb250cm9sVHlwZX1cIl06bm90KGAgK1xuICAgICAgICAgICAgY3VzdG9tQ29udHJvbENsYXNzTmFtZSArXG4gICAgICAgICAgICAnKScsXG4gICAgICAgICAgKGV2dCkgPT4ge1xuICAgICAgICAgICAgJChldnQudGFyZ2V0KVxuICAgICAgICAgICAgICAuc2libGluZ3MoY3VzdG9tQ29udHJvbENsYXNzTmFtZSlcbiAgICAgICAgICAgICAgLnJlbW92ZUNsYXNzKGAke0ZPQ1VTRURfQ0xBU1N9ICR7Rk9DVVNFRF9WSVNJQkxFX0NMQVNTfWApO1xuICAgICAgICAgIH1cbiAgICAgICAgKTtcbiAgICAgIH0pO1xuICAgIH1cblxuICAgIC8vIFJlc2V0IGRhdGEgY29tbW9uIHRvIGFsbCBzdWJtaXQgaGFuZGxlcnNcbiAgICBmdW5jdGlvbiByZXNldChkYXRhKSB7XG4gICAgICB2YXIgYnRuID0gKGRhdGEuYnRuID0gZGF0YS5mb3JtLmZpbmQoJzppbnB1dFt0eXBlPVwic3VibWl0XCJdJykpO1xuICAgICAgZGF0YS53YWl0ID0gZGF0YS5idG4uYXR0cignZGF0YS13YWl0JykgfHwgbnVsbDtcbiAgICAgIGRhdGEuc3VjY2VzcyA9IGZhbHNlO1xuXG4gICAgICAvLyBEZXRlcm1pbmUgaWYgdGhlIGJ1dHRvbiBzaG91bGQgYmUgZGlzYWJsZWRcbiAgICAgIGNvbnN0IGlzRGlzYWJsZWQgPSBCb29sZWFuKHR1cm5zdGlsZVNpdGVLZXkgJiYgIWRhdGEudHVybnN0aWxlVG9rZW4pO1xuICAgICAgYnRuLnByb3AoJ2Rpc2FibGVkJywgaXNEaXNhYmxlZCk7XG4gICAgICBidG4ucmVtb3ZlQ2xhc3MoJ3ctZm9ybS1sb2FkaW5nJyk7XG4gICAgICBkYXRhLmxhYmVsICYmIGJ0bi52YWwoZGF0YS5sYWJlbCk7XG4gICAgfVxuXG4gICAgLy8gRGlzYWJsZSBzdWJtaXQgYnV0dG9uIGR1cmluZyBhY3R1YWwgc3VibWlzc2lvblxuICAgIGZ1bmN0aW9uIGRpc2FibGVCdG4oZGF0YSkge1xuICAgICAgdmFyIGJ0biA9IGRhdGEuYnRuO1xuICAgICAgdmFyIHdhaXQgPSBkYXRhLndhaXQ7IC8vIFVzZSB0aGUgdmFsdWUgZnJvbSBkYXRhLXdhaXQgYXR0cmlidXRlXG5cbiAgICAgIGJ0bi5wcm9wKCdkaXNhYmxlZCcsIHRydWUpO1xuXG4gICAgICAvLyBTaG93IHdhaXQgdGV4dCBhbmQgc3RvcmUgcHJldmlvdXMgbGFiZWxcbiAgICAgIGlmICh3YWl0KSB7XG4gICAgICAgIGRhdGEubGFiZWwgPSBidG4udmFsKCk7IC8vIFN0b3JlIHRoZSBjdXJyZW50IGxhYmVsIGJlZm9yZSBvdmVyd3JpdGluZ1xuICAgICAgICBidG4udmFsKHdhaXQpO1xuICAgICAgfVxuICAgIH1cblxuICAgIC8vIFNldCBidXR0b24gc3RhdGUgd2hpbGUgVHVybnN0aWxlIHNjcmlwdCBpcyBsb2FkaW5nXG4gICAgZnVuY3Rpb24gc2V0QnV0dG9uVG9UdXJuc3RpbGVMb2FkaW5nKGRhdGEpIHtcbiAgICAgIGNvbnN0IGJ0biA9IGRhdGEuYnRuIHx8IGRhdGEuZm9ybS5maW5kKCc6aW5wdXRbdHlwZT1cInN1Ym1pdFwiXScpO1xuICAgICAgaWYgKCFkYXRhLmJ0bikgZGF0YS5idG4gPSBidG47XG5cbiAgICAgIGJ0bi5wcm9wKCdkaXNhYmxlZCcsIHRydWUpO1xuICAgICAgYnRuLmFkZENsYXNzKCd3LWZvcm0tbG9hZGluZycpO1xuICAgIH1cblxuICAgIC8vIEFkZC9yZW1vdmUgbG9hZGluZyBjbGFzcyBmcm9tIHRoZSBmb3JtIHdyYXBwZXJcbiAgICBmdW5jdGlvbiBzZXRGb3JtTG9hZGluZ1N0YXRlKCRmb3JtRWwsIGlzTG9hZGluZykge1xuICAgICAgY29uc3QgJHdyYXBwZXIgPSAkZm9ybUVsLmNsb3Nlc3QoJy53LWZvcm0nKTtcbiAgICAgIGlmIChpc0xvYWRpbmcpIHtcbiAgICAgICAgJHdyYXBwZXIuYWRkQ2xhc3MoJ3ctZm9ybS1sb2FkaW5nJyk7XG4gICAgICB9IGVsc2Uge1xuICAgICAgICAkd3JhcHBlci5yZW1vdmVDbGFzcygndy1mb3JtLWxvYWRpbmcnKTtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAvLyBGaW5kIGZvcm0gZmllbGRzLCB2YWxpZGF0ZSwgYW5kIHNldCB2YWx1ZSBwYWlyc1xuICAgIGZ1bmN0aW9uIGZpbmRGaWVsZHMoZm9ybSwgcmVzdWx0KSB7XG4gICAgICB2YXIgc3RhdHVzID0gbnVsbDtcbiAgICAgIHJlc3VsdCA9IHJlc3VsdCB8fCB7fTtcblxuICAgICAgLy8gVGhlIFwiOmlucHV0XCIgc2VsZWN0b3IgaXMgYSBqUXVlcnkgc2hvcnRjdXQgdG8gc2VsZWN0IGFsbCBpbnB1dHMsIHNlbGVjdHMsIHRleHRhcmVhc1xuICAgICAgZm9ybVxuICAgICAgICAuZmluZChcbiAgICAgICAgICAnOmlucHV0Om5vdChbdHlwZT1cInN1Ym1pdFwiXSk6bm90KFt0eXBlPVwiZmlsZVwiXSk6bm90KFt0eXBlPVwiYnV0dG9uXCJdKSdcbiAgICAgICAgKVxuICAgICAgICAuZWFjaChmdW5jdGlvbiAoaSwgZWwpIHtcbiAgICAgICAgICB2YXIgZmllbGQgPSAkKGVsKTtcbiAgICAgICAgICB2YXIgdHlwZSA9IGZpZWxkLmF0dHIoJ3R5cGUnKTtcbiAgICAgICAgICB2YXIgbmFtZSA9XG4gICAgICAgICAgICBmaWVsZC5hdHRyKCdkYXRhLW5hbWUnKSB8fCBmaWVsZC5hdHRyKCduYW1lJykgfHwgJ0ZpZWxkICcgKyAoaSArIDEpO1xuICAgICAgICAgIC8vIEVuY29kaW5nIHRoZSBmaWVsZCBuYW1lIHdpbGwgcHJldmVudCBmaWVsZHMgdGhhdCBoYXZlIGJyYWNrZXRzXG4gICAgICAgICAgLy8gaW4gdGhlaXIgbmFtZSBmcm9tIGJlaW5nIHBhcnNlZCBieSBgYm9keVBhcnNlci51cmxlbmNvZGVkYCBhc1xuICAgICAgICAgIC8vIG9iamVjdHMgd2hpY2ggd291bGQgaGF2ZSB1bmludGVuZGVkIGNvbnNlcXVlbmNlcyBsaWtlIG5vdCBzYXZpbmdcbiAgICAgICAgICAvLyB0aGUgY29udGVudCBvZiB0aGUgZmllbGQuXG4gICAgICAgICAgLy8gaHR0cHM6Ly93ZWJmbG93LmF0bGFzc2lhbi5uZXQvYnJvd3NlL0NNU0FVVEgtMjQ5NVxuICAgICAgICAgIG5hbWUgPSBlbmNvZGVVUklDb21wb25lbnQobmFtZSk7XG4gICAgICAgICAgdmFyIHZhbHVlID0gZmllbGQudmFsKCk7XG5cbiAgICAgICAgICBpZiAodHlwZSA9PT0gJ2NoZWNrYm94Jykge1xuICAgICAgICAgICAgdmFsdWUgPSBmaWVsZC5pcygnOmNoZWNrZWQnKTtcbiAgICAgICAgICB9IGVsc2UgaWYgKHR5cGUgPT09ICdyYWRpbycpIHtcbiAgICAgICAgICAgIC8vIFJhZGlvIGdyb3VwIHZhbHVlIGFscmVhZHkgcHJvY2Vzc2VkXG4gICAgICAgICAgICBpZiAocmVzdWx0W25hbWVdID09PSBudWxsIHx8IHR5cGVvZiByZXN1bHRbbmFtZV0gPT09ICdzdHJpbmcnKSB7XG4gICAgICAgICAgICAgIHJldHVybjtcbiAgICAgICAgICAgIH1cblxuICAgICAgICAgICAgdmFsdWUgPVxuICAgICAgICAgICAgICBmb3JtXG4gICAgICAgICAgICAgICAgLmZpbmQoJ2lucHV0W25hbWU9XCInICsgZmllbGQuYXR0cignbmFtZScpICsgJ1wiXTpjaGVja2VkJylcbiAgICAgICAgICAgICAgICAudmFsKCkgfHwgbnVsbDtcbiAgICAgICAgICB9XG5cbiAgICAgICAgICBpZiAodHlwZW9mIHZhbHVlID09PSAnc3RyaW5nJykge1xuICAgICAgICAgICAgdmFsdWUgPSAkLnRyaW0odmFsdWUpO1xuICAgICAgICAgIH1cbiAgICAgICAgICByZXN1bHRbbmFtZV0gPSB2YWx1ZTtcbiAgICAgICAgICBzdGF0dXMgPSBzdGF0dXMgfHwgZ2V0U3RhdHVzKGZpZWxkLCB0eXBlLCBuYW1lLCB2YWx1ZSk7XG4gICAgICAgIH0pO1xuXG4gICAgICByZXR1cm4gc3RhdHVzO1xuICAgIH1cblxuICAgIGZ1bmN0aW9uIGZpbmRGaWxlVXBsb2Fkcyhmb3JtKSB7XG4gICAgICB2YXIgcmVzdWx0ID0ge307XG5cbiAgICAgIGZvcm0uZmluZCgnOmlucHV0W3R5cGU9XCJmaWxlXCJdJykuZWFjaChmdW5jdGlvbiAoaSwgZWwpIHtcbiAgICAgICAgdmFyIGZpZWxkID0gJChlbCk7XG4gICAgICAgIHZhciBuYW1lID1cbiAgICAgICAgICBmaWVsZC5hdHRyKCdkYXRhLW5hbWUnKSB8fCBmaWVsZC5hdHRyKCduYW1lJykgfHwgJ0ZpbGUgJyArIChpICsgMSk7XG4gICAgICAgIHZhciB2YWx1ZSA9IGZpZWxkLmF0dHIoJ2RhdGEtdmFsdWUnKTtcbiAgICAgICAgaWYgKHR5cGVvZiB2YWx1ZSA9PT0gJ3N0cmluZycpIHtcbiAgICAgICAgICB2YWx1ZSA9ICQudHJpbSh2YWx1ZSk7XG4gICAgICAgIH1cbiAgICAgICAgcmVzdWx0W25hbWVdID0gdmFsdWU7XG4gICAgICB9KTtcblxuICAgICAgcmV0dXJuIHJlc3VsdDtcbiAgICB9XG5cbiAgICBjb25zdCB0cmFja2luZ0Nvb2tpZU5hbWVNYXAgPSB7XG4gICAgICBfbWt0b190cms6ICdtYXJrZXRvJyxcbiAgICAgIC8vIF9faHN0YzogJ2h1YnNwb3QnLFxuICAgIH07XG5cbiAgICBmdW5jdGlvbiBjb2xsZWN0RW50ZXJwcmlzZVRyYWNraW5nQ29va2llcygpIHtcbiAgICAgIGNvbnN0IGNvb2tpZXMgPSBkb2N1bWVudC5jb29raWUuc3BsaXQoJzsgJykucmVkdWNlKGZ1bmN0aW9uIChcbiAgICAgICAgYWNjLFxuICAgICAgICBjb29raWVcbiAgICAgICkge1xuICAgICAgICBjb25zdCBzcGxpdENvb2tpZSA9IGNvb2tpZS5zcGxpdCgnPScpO1xuICAgICAgICBjb25zdCBuYW1lID0gc3BsaXRDb29raWVbMF07XG4gICAgICAgIGlmIChuYW1lIGluIHRyYWNraW5nQ29va2llTmFtZU1hcCkge1xuICAgICAgICAgIGNvbnN0IG1hcHBlZE5hbWUgPSB0cmFja2luZ0Nvb2tpZU5hbWVNYXBbbmFtZV07XG4gICAgICAgICAgY29uc3QgdmFsdWUgPSBzcGxpdENvb2tpZS5zbGljZSgxKS5qb2luKCc9Jyk7XG4gICAgICAgICAgYWNjW21hcHBlZE5hbWVdID0gdmFsdWU7XG4gICAgICAgIH1cbiAgICAgICAgcmV0dXJuIGFjYztcbiAgICAgIH0sIHt9KTtcblxuICAgICAgcmV0dXJuIGNvb2tpZXM7XG4gICAgfVxuXG4gICAgZnVuY3Rpb24gZ2V0U3RhdHVzKGZpZWxkLCB0eXBlLCBuYW1lLCB2YWx1ZSkge1xuICAgICAgdmFyIHN0YXR1cyA9IG51bGw7XG5cbiAgICAgIGlmICh0eXBlID09PSAncGFzc3dvcmQnKSB7XG4gICAgICAgIHN0YXR1cyA9ICdQYXNzd29yZHMgY2Fubm90IGJlIHN1Ym1pdHRlZC4nO1xuICAgICAgfSBlbHNlIGlmIChmaWVsZC5hdHRyKCdyZXF1aXJlZCcpKSB7XG4gICAgICAgIGlmICghdmFsdWUpIHtcbiAgICAgICAgICBzdGF0dXMgPSAnUGxlYXNlIGZpbGwgb3V0IHRoZSByZXF1aXJlZCBmaWVsZDogJyArIG5hbWU7XG4gICAgICAgIH0gZWxzZSBpZiAoZW1haWxGaWVsZC50ZXN0KGZpZWxkLmF0dHIoJ3R5cGUnKSkpIHtcbiAgICAgICAgICBpZiAoIWVtYWlsVmFsdWUudGVzdCh2YWx1ZSkpIHtcbiAgICAgICAgICAgIHN0YXR1cyA9ICdQbGVhc2UgZW50ZXIgYSB2YWxpZCBlbWFpbCBhZGRyZXNzIGZvcjogJyArIG5hbWU7XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICB9IGVsc2UgaWYgKG5hbWUgPT09ICdnLXJlY2FwdGNoYS1yZXNwb25zZScgJiYgIXZhbHVlKSB7XG4gICAgICAgIHN0YXR1cyA9IFwiUGxlYXNlIGNvbmZpcm0geW91J3JlIG5vdCBhIHJvYm90LlwiO1xuICAgICAgfVxuXG4gICAgICByZXR1cm4gc3RhdHVzO1xuICAgIH1cblxuICAgIGZ1bmN0aW9uIGV4cG9ydGVkU3VibWl0V2ViZmxvdyhkYXRhKSB7XG4gICAgICBwcmV2ZW50RGVmYXVsdChkYXRhKTtcbiAgICAgIGFmdGVyU3VibWl0KGRhdGEpO1xuICAgIH1cblxuICAgIC8vIFN1Ym1pdCBmb3JtIHRvIE1haWxDaGltcFxuICAgIGZ1bmN0aW9uIHN1Ym1pdE1haWxDaGltcChkYXRhKSB7XG4gICAgICByZXNldChkYXRhKTtcblxuICAgICAgdmFyIGZvcm0gPSBkYXRhLmZvcm07XG4gICAgICB2YXIgcGF5bG9hZCA9IHt9O1xuXG4gICAgICAvLyBTa2lwIEFqYXggc3VibWlzc2lvbiBpZiBodHRwL3MgbWlzbWF0Y2gsIGZhbGxiYWNrIHRvIFBPU1QgaW5zdGVhZFxuICAgICAgaWYgKC9eaHR0cHMvLnRlc3QobG9jLmhyZWYpICYmICEvXmh0dHBzLy50ZXN0KGRhdGEuYWN0aW9uKSkge1xuICAgICAgICBmb3JtLmF0dHIoJ21ldGhvZCcsICdwb3N0Jyk7XG4gICAgICAgIHJldHVybjtcbiAgICAgIH1cblxuICAgICAgcHJldmVudERlZmF1bHQoZGF0YSk7XG5cbiAgICAgIC8vIEZpbmQgJiBwb3B1bGF0ZSBhbGwgZmllbGRzXG4gICAgICB2YXIgc3RhdHVzID0gZmluZEZpZWxkcyhmb3JtLCBwYXlsb2FkKTtcbiAgICAgIGlmIChzdGF0dXMpIHtcbiAgICAgICAgcmV0dXJuIGFsZXJ0KHN0YXR1cyk7XG4gICAgICB9XG5cbiAgICAgIC8vIERpc2FibGUgc3VibWl0IGJ1dHRvblxuICAgICAgZGlzYWJsZUJ0bihkYXRhKTtcblxuICAgICAgLy8gVXNlIHNwZWNpYWwgZm9ybWF0IGZvciBNYWlsQ2hpbXAgcGFyYW1zXG4gICAgICB2YXIgZnVsbE5hbWU7XG4gICAgICBfLmVhY2gocGF5bG9hZCwgZnVuY3Rpb24gKHZhbHVlLCBrZXkpIHtcbiAgICAgICAgaWYgKGVtYWlsRmllbGQudGVzdChrZXkpKSB7XG4gICAgICAgICAgcGF5bG9hZC5FTUFJTCA9IHZhbHVlO1xuICAgICAgICB9XG4gICAgICAgIGlmICgvXigoZnVsbFsgXy1dPyk/bmFtZSkkL2kudGVzdChrZXkpKSB7XG4gICAgICAgICAgZnVsbE5hbWUgPSB2YWx1ZTtcbiAgICAgICAgfVxuICAgICAgICBpZiAoL14oZmlyc3RbIF8tXT9uYW1lKSQvaS50ZXN0KGtleSkpIHtcbiAgICAgICAgICBwYXlsb2FkLkZOQU1FID0gdmFsdWU7XG4gICAgICAgIH1cbiAgICAgICAgaWYgKC9eKGxhc3RbIF8tXT9uYW1lKSQvaS50ZXN0KGtleSkpIHtcbiAgICAgICAgICBwYXlsb2FkLkxOQU1FID0gdmFsdWU7XG4gICAgICAgIH1cbiAgICAgIH0pO1xuXG4gICAgICBpZiAoZnVsbE5hbWUgJiYgIXBheWxvYWQuRk5BTUUpIHtcbiAgICAgICAgZnVsbE5hbWUgPSBmdWxsTmFtZS5zcGxpdCgnICcpO1xuICAgICAgICBwYXlsb2FkLkZOQU1FID0gZnVsbE5hbWVbMF07XG4gICAgICAgIHBheWxvYWQuTE5BTUUgPSBwYXlsb2FkLkxOQU1FIHx8IGZ1bGxOYW1lWzFdO1xuICAgICAgfVxuXG4gICAgICAvLyBVc2UgdGhlICh1bmRvY3VtZW50ZWQpIE1haWxDaGltcCBqc29ucCBhcGlcbiAgICAgIHZhciB1cmwgPSBkYXRhLmFjdGlvbi5yZXBsYWNlKCcvcG9zdD8nLCAnL3Bvc3QtanNvbj8nKSArICcmYz0/JztcbiAgICAgIC8vIEFkZCBzcGVjaWFsIHBhcmFtIHRvIHByZXZlbnQgYm90IHNpZ251cHNcbiAgICAgIHZhciB1c2VySWQgPSB1cmwuaW5kZXhPZigndT0nKSArIDI7XG4gICAgICB1c2VySWQgPSB1cmwuc3Vic3RyaW5nKHVzZXJJZCwgdXJsLmluZGV4T2YoJyYnLCB1c2VySWQpKTtcbiAgICAgIHZhciBsaXN0SWQgPSB1cmwuaW5kZXhPZignaWQ9JykgKyAzO1xuICAgICAgbGlzdElkID0gdXJsLnN1YnN0cmluZyhsaXN0SWQsIHVybC5pbmRleE9mKCcmJywgbGlzdElkKSk7XG4gICAgICBwYXlsb2FkWydiXycgKyB1c2VySWQgKyAnXycgKyBsaXN0SWRdID0gJyc7XG5cbiAgICAgICQuYWpheCh7XG4gICAgICAgIHVybCxcbiAgICAgICAgZGF0YTogcGF5bG9hZCxcbiAgICAgICAgZGF0YVR5cGU6ICdqc29ucCcsXG4gICAgICB9KVxuICAgICAgICAuZG9uZShmdW5jdGlvbiAocmVzcCkge1xuICAgICAgICAgIGRhdGEuc3VjY2VzcyA9IHJlc3AucmVzdWx0ID09PSAnc3VjY2VzcycgfHwgL2FscmVhZHkvLnRlc3QocmVzcC5tc2cpO1xuICAgICAgICAgIGlmICghZGF0YS5zdWNjZXNzKSB7XG4gICAgICAgICAgICBjb25zb2xlLmluZm8oJ01haWxDaGltcCBlcnJvcjogJyArIHJlc3AubXNnKTtcbiAgICAgICAgICB9XG4gICAgICAgICAgYWZ0ZXJTdWJtaXQoZGF0YSk7XG4gICAgICAgIH0pXG4gICAgICAgIC5mYWlsKGZ1bmN0aW9uICgpIHtcbiAgICAgICAgICBhZnRlclN1Ym1pdChkYXRhKTtcbiAgICAgICAgfSk7XG4gICAgfVxuXG4gICAgLy8gQ29tbW9uIGNhbGxiYWNrIHdoaWNoIHJ1bnMgYWZ0ZXIgYWxsIEFqYXggc3VibWlzc2lvbnNcbiAgICBmdW5jdGlvbiBhZnRlclN1Ym1pdChkYXRhKSB7XG4gICAgICB2YXIgZm9ybSA9IGRhdGEuZm9ybTtcbiAgICAgIHZhciByZWRpcmVjdCA9IGRhdGEucmVkaXJlY3Q7XG4gICAgICB2YXIgc3VjY2VzcyA9IGRhdGEuc3VjY2VzcztcblxuICAgICAgLy8gUmVkaXJlY3QgdG8gYSBzdWNjZXNzIHVybCBpZiBkZWZpbmVkXG4gICAgICBpZiAoc3VjY2VzcyAmJiByZWRpcmVjdCkge1xuICAgICAgICBXZWJmbG93LmxvY2F0aW9uKHJlZGlyZWN0KTtcbiAgICAgICAgcmV0dXJuO1xuICAgICAgfVxuXG4gICAgICAvLyBTaG93IG9yIGhpZGUgc3RhdHVzIGRpdnNcbiAgICAgIGRhdGEuZG9uZS50b2dnbGUoc3VjY2Vzcyk7XG4gICAgICBkYXRhLmZhaWwudG9nZ2xlKCFzdWNjZXNzKTtcblxuICAgICAgaWYgKHN1Y2Nlc3MpIHtcbiAgICAgICAgZGF0YS5kb25lLmZvY3VzKCk7XG4gICAgICB9IGVsc2Uge1xuICAgICAgICBkYXRhLmZhaWwuZm9jdXMoKTtcbiAgICAgIH1cblxuICAgICAgLy8gSGlkZSBmb3JtIG9uIHN1Y2Nlc3NcbiAgICAgIGZvcm0udG9nZ2xlKCFzdWNjZXNzKTtcblxuICAgICAgLy8gUmVzZXQgZGF0YSBhbmQgZW5hYmxlIHN1Ym1pdCBidXR0b25cbiAgICAgIHJlc2V0KGRhdGEpO1xuICAgIH1cblxuICAgIGZ1bmN0aW9uIHByZXZlbnREZWZhdWx0KGRhdGEpIHtcbiAgICAgIGRhdGEuZXZ0ICYmIGRhdGEuZXZ0LnByZXZlbnREZWZhdWx0KCk7XG4gICAgICBkYXRhLmV2dCA9IG51bGw7XG4gICAgfVxuXG4gICAgZnVuY3Rpb24gaW5pdEZpbGVVcGxvYWQoaSwgZm9ybSkge1xuICAgICAgaWYgKCFmb3JtLmZpbGVVcGxvYWRzIHx8ICFmb3JtLmZpbGVVcGxvYWRzW2ldKSB7XG4gICAgICAgIHJldHVybjtcbiAgICAgIH1cblxuICAgICAgdmFyIGZpbGU7XG4gICAgICB2YXIgJGVsID0gJChmb3JtLmZpbGVVcGxvYWRzW2ldKTtcbiAgICAgIHZhciAkZGVmYXVsdFdyYXAgPSAkZWwuZmluZCgnPiAudy1maWxlLXVwbG9hZC1kZWZhdWx0Jyk7XG4gICAgICB2YXIgJHVwbG9hZGluZ1dyYXAgPSAkZWwuZmluZCgnPiAudy1maWxlLXVwbG9hZC11cGxvYWRpbmcnKTtcbiAgICAgIHZhciAkc3VjY2Vzc1dyYXAgPSAkZWwuZmluZCgnPiAudy1maWxlLXVwbG9hZC1zdWNjZXNzJyk7XG4gICAgICB2YXIgJGVycm9yV3JhcCA9ICRlbC5maW5kKCc+IC53LWZpbGUtdXBsb2FkLWVycm9yJyk7XG4gICAgICB2YXIgJGlucHV0ID0gJGRlZmF1bHRXcmFwLmZpbmQoJy53LWZpbGUtdXBsb2FkLWlucHV0Jyk7XG4gICAgICB2YXIgJGxhYmVsID0gJGRlZmF1bHRXcmFwLmZpbmQoJy53LWZpbGUtdXBsb2FkLWxhYmVsJyk7XG4gICAgICB2YXIgJGxhYmVsQ2hpbGRyZW4gPSAkbGFiZWwuY2hpbGRyZW4oKTtcbiAgICAgIHZhciAkZXJyb3JNc2dFbCA9ICRlcnJvcldyYXAuZmluZCgnLnctZmlsZS11cGxvYWQtZXJyb3ItbXNnJyk7XG4gICAgICB2YXIgJGZpbGVFbCA9ICRzdWNjZXNzV3JhcC5maW5kKCcudy1maWxlLXVwbG9hZC1maWxlJyk7XG4gICAgICB2YXIgJHJlbW92ZUVsID0gJHN1Y2Nlc3NXcmFwLmZpbmQoJy53LWZpbGUtcmVtb3ZlLWxpbmsnKTtcbiAgICAgIHZhciAkZmlsZU5hbWVFbCA9ICRmaWxlRWwuZmluZCgnLnctZmlsZS11cGxvYWQtZmlsZS1uYW1lJyk7XG5cbiAgICAgIHZhciBzaXplRXJyTXNnID0gJGVycm9yTXNnRWwuYXR0cignZGF0YS13LXNpemUtZXJyb3InKTtcbiAgICAgIHZhciB0eXBlRXJyTXNnID0gJGVycm9yTXNnRWwuYXR0cignZGF0YS13LXR5cGUtZXJyb3InKTtcbiAgICAgIHZhciBnZW5lcmljRXJyTXNnID0gJGVycm9yTXNnRWwuYXR0cignZGF0YS13LWdlbmVyaWMtZXJyb3InKTtcblxuICAgICAgLy8gQWNjZXNzaWJpbGl0eSBmaXhlc1xuICAgICAgLy8gVGhlIGZpbGUgdXBsb2FkIElucHV0IGlzIG5vdCBzdHlsYWJsZSBieSB0aGUgZGVzaWduZXIsIHNvIHdlIGFyZVxuICAgICAgLy8gZ29pbmcgdG8gcHJldGVuZCB0aGUgTGFiZWwgaXMgdGhlIGlucHV0LiDCr1xcXyjjg4QpXy/Cr1xuICAgICAgaWYgKCFpbkFwcCkge1xuICAgICAgICAkbGFiZWwub24oJ2NsaWNrIGtleWRvd24nLCBmdW5jdGlvbiAoZSkge1xuICAgICAgICAgIGlmIChlLnR5cGUgPT09ICdrZXlkb3duJyAmJiBlLndoaWNoICE9PSAxMyAmJiBlLndoaWNoICE9PSAzMikge1xuICAgICAgICAgICAgcmV0dXJuO1xuICAgICAgICAgIH1cblxuICAgICAgICAgIGUucHJldmVudERlZmF1bHQoKTtcbiAgICAgICAgICAkaW5wdXQuY2xpY2soKTtcbiAgICAgICAgfSk7XG4gICAgICB9XG5cbiAgICAgIC8vIEJvdGggb2YgdGhlc2UgYXJlIGFkZGVkIHRocm91Z2ggQ1NTXG4gICAgICAkbGFiZWwuZmluZCgnLnctaWNvbi1maWxlLXVwbG9hZC1pY29uJykuYXR0cignYXJpYS1oaWRkZW4nLCAndHJ1ZScpO1xuICAgICAgJHJlbW92ZUVsLmZpbmQoJy53LWljb24tZmlsZS11cGxvYWQtcmVtb3ZlJykuYXR0cignYXJpYS1oaWRkZW4nLCAndHJ1ZScpO1xuXG4gICAgICBpZiAoIWluQXBwKSB7XG4gICAgICAgICRyZW1vdmVFbC5vbignY2xpY2sga2V5ZG93bicsIGZ1bmN0aW9uIChlKSB7XG4gICAgICAgICAgaWYgKGUudHlwZSA9PT0gJ2tleWRvd24nKSB7XG4gICAgICAgICAgICBpZiAoZS53aGljaCAhPT0gMTMgJiYgZS53aGljaCAhPT0gMzIpIHtcbiAgICAgICAgICAgICAgcmV0dXJuO1xuICAgICAgICAgICAgfVxuXG4gICAgICAgICAgICBlLnByZXZlbnREZWZhdWx0KCk7XG4gICAgICAgICAgfVxuXG4gICAgICAgICAgJGlucHV0LnJlbW92ZUF0dHIoJ2RhdGEtdmFsdWUnKTtcbiAgICAgICAgICAkaW5wdXQudmFsKCcnKTtcbiAgICAgICAgICAkZmlsZU5hbWVFbC5odG1sKCcnKTtcbiAgICAgICAgICAkZGVmYXVsdFdyYXAudG9nZ2xlKHRydWUpO1xuICAgICAgICAgICRzdWNjZXNzV3JhcC50b2dnbGUoZmFsc2UpO1xuICAgICAgICAgICRsYWJlbC5mb2N1cygpO1xuICAgICAgICB9KTtcblxuICAgICAgICAkaW5wdXQub24oJ2NoYW5nZScsIGZ1bmN0aW9uIChlKSB7XG4gICAgICAgICAgZmlsZSA9IGUudGFyZ2V0ICYmIGUudGFyZ2V0LmZpbGVzICYmIGUudGFyZ2V0LmZpbGVzWzBdO1xuICAgICAgICAgIGlmICghZmlsZSkge1xuICAgICAgICAgICAgcmV0dXJuO1xuICAgICAgICAgIH1cblxuICAgICAgICAgIC8vIFNob3cgdXBsb2FkaW5nXG4gICAgICAgICAgJGRlZmF1bHRXcmFwLnRvZ2dsZShmYWxzZSk7XG4gICAgICAgICAgJGVycm9yV3JhcC50b2dnbGUoZmFsc2UpO1xuICAgICAgICAgICR1cGxvYWRpbmdXcmFwLnRvZ2dsZSh0cnVlKTtcbiAgICAgICAgICAkdXBsb2FkaW5nV3JhcC5mb2N1cygpO1xuXG4gICAgICAgICAgLy8gU2V0IGZpbGVuYW1lXG4gICAgICAgICAgJGZpbGVOYW1lRWwudGV4dChmaWxlLm5hbWUpO1xuXG4gICAgICAgICAgLy8gRGlzYWJsZSBzdWJtaXQgYnV0dG9uXG4gICAgICAgICAgaWYgKCFpc1VwbG9hZGluZygpKSB7XG4gICAgICAgICAgICBkaXNhYmxlQnRuKGZvcm0pO1xuICAgICAgICAgIH1cbiAgICAgICAgICBmb3JtLmZpbGVVcGxvYWRzW2ldLnVwbG9hZGluZyA9IHRydWU7XG5cbiAgICAgICAgICBzaWduRmlsZShmaWxlLCBhZnRlclNpZ24pO1xuICAgICAgICB9KTtcblxuICAgICAgICAvLyBTZXR0aW5nIGlucHV0IHdpZHRoIDFweCBhbmQgaGVpZ2h0IGVxdWFsIGxhYmVsXG4gICAgICAgIC8vIFRoaXMgaXMgc28gdGhlIGJyb3dzZXIgcmVxdWlyZWQgZXJyb3Igd2lsbCBzaG93IHVwXG4gICAgICAgIHZhciBoZWlnaHQgPSAkbGFiZWwub3V0ZXJIZWlnaHQoKTtcbiAgICAgICAgJGlucHV0LmhlaWdodChoZWlnaHQpO1xuICAgICAgICAkaW5wdXQud2lkdGgoMSk7XG4gICAgICB9IGVsc2Uge1xuICAgICAgICAkaW5wdXQub24oJ2NsaWNrJywgZnVuY3Rpb24gKGUpIHtcbiAgICAgICAgICBlLnByZXZlbnREZWZhdWx0KCk7XG4gICAgICAgIH0pO1xuICAgICAgICAkbGFiZWwub24oJ2NsaWNrJywgZnVuY3Rpb24gKGUpIHtcbiAgICAgICAgICBlLnByZXZlbnREZWZhdWx0KCk7XG4gICAgICAgIH0pO1xuICAgICAgICAkbGFiZWxDaGlsZHJlbi5vbignY2xpY2snLCBmdW5jdGlvbiAoZSkge1xuICAgICAgICAgIGUucHJldmVudERlZmF1bHQoKTtcbiAgICAgICAgfSk7XG4gICAgICB9XG5cbiAgICAgIGZ1bmN0aW9uIHBhcnNlRXJyb3IoZXJyKSB7XG4gICAgICAgIHZhciBlcnJvck1zZyA9IGVyci5yZXNwb25zZUpTT04gJiYgZXJyLnJlc3BvbnNlSlNPTi5tc2c7XG4gICAgICAgIHZhciB1c2VyRXJyb3IgPSBnZW5lcmljRXJyTXNnO1xuICAgICAgICBpZiAoXG4gICAgICAgICAgdHlwZW9mIGVycm9yTXNnID09PSAnc3RyaW5nJyAmJlxuICAgICAgICAgIGVycm9yTXNnLmluZGV4T2YoJ0ludmFsaWRGaWxlVHlwZUVycm9yJykgPT09IDBcbiAgICAgICAgKSB7XG4gICAgICAgICAgdXNlckVycm9yID0gdHlwZUVyck1zZztcbiAgICAgICAgfSBlbHNlIGlmIChcbiAgICAgICAgICB0eXBlb2YgZXJyb3JNc2cgPT09ICdzdHJpbmcnICYmXG4gICAgICAgICAgZXJyb3JNc2cuaW5kZXhPZignTWF4RmlsZVNpemVFcnJvcicpID09PSAwXG4gICAgICAgICkge1xuICAgICAgICAgIHVzZXJFcnJvciA9IHNpemVFcnJNc2c7XG4gICAgICAgIH1cblxuICAgICAgICAkZXJyb3JNc2dFbC50ZXh0KHVzZXJFcnJvcik7XG5cbiAgICAgICAgJGlucHV0LnJlbW92ZUF0dHIoJ2RhdGEtdmFsdWUnKTtcbiAgICAgICAgJGlucHV0LnZhbCgnJyk7XG4gICAgICAgICR1cGxvYWRpbmdXcmFwLnRvZ2dsZShmYWxzZSk7XG4gICAgICAgICRkZWZhdWx0V3JhcC50b2dnbGUodHJ1ZSk7XG4gICAgICAgICRlcnJvcldyYXAudG9nZ2xlKHRydWUpO1xuICAgICAgICAkZXJyb3JXcmFwLmZvY3VzKCk7XG5cbiAgICAgICAgZm9ybS5maWxlVXBsb2Fkc1tpXS51cGxvYWRpbmcgPSBmYWxzZTtcbiAgICAgICAgaWYgKCFpc1VwbG9hZGluZygpKSB7XG4gICAgICAgICAgcmVzZXQoZm9ybSk7XG4gICAgICAgIH1cbiAgICAgIH1cblxuICAgICAgZnVuY3Rpb24gYWZ0ZXJTaWduKGVyciwgZGF0YSkge1xuICAgICAgICBpZiAoZXJyKSB7XG4gICAgICAgICAgcmV0dXJuIHBhcnNlRXJyb3IoZXJyKTtcbiAgICAgICAgfVxuXG4gICAgICAgIHZhciBmaWxlTmFtZSA9IGRhdGEuZmlsZU5hbWU7XG4gICAgICAgIHZhciBwb3N0RGF0YSA9IGRhdGEucG9zdERhdGE7XG4gICAgICAgIHZhciBmaWxlSWQgPSBkYXRhLmZpbGVJZDtcbiAgICAgICAgdmFyIHMzVXJsID0gZGF0YS5zM1VybDtcbiAgICAgICAgJGlucHV0LmF0dHIoJ2RhdGEtdmFsdWUnLCBmaWxlSWQpO1xuXG4gICAgICAgIHVwbG9hZFMzKHMzVXJsLCBwb3N0RGF0YSwgZmlsZSwgZmlsZU5hbWUsIGFmdGVyVXBsb2FkKTtcbiAgICAgIH1cblxuICAgICAgZnVuY3Rpb24gYWZ0ZXJVcGxvYWQoZXJyKSB7XG4gICAgICAgIGlmIChlcnIpIHtcbiAgICAgICAgICByZXR1cm4gcGFyc2VFcnJvcihlcnIpO1xuICAgICAgICB9XG5cbiAgICAgICAgLy8gU2hvdyBzdWNjZXNzXG4gICAgICAgICR1cGxvYWRpbmdXcmFwLnRvZ2dsZShmYWxzZSk7XG4gICAgICAgICRzdWNjZXNzV3JhcC5jc3MoJ2Rpc3BsYXknLCAnaW5saW5lLWJsb2NrJyk7XG4gICAgICAgICRzdWNjZXNzV3JhcC5mb2N1cygpO1xuXG4gICAgICAgIGZvcm0uZmlsZVVwbG9hZHNbaV0udXBsb2FkaW5nID0gZmFsc2U7XG4gICAgICAgIGlmICghaXNVcGxvYWRpbmcoKSkge1xuICAgICAgICAgIHJlc2V0KGZvcm0pO1xuICAgICAgICB9XG4gICAgICB9XG5cbiAgICAgIGZ1bmN0aW9uIGlzVXBsb2FkaW5nKCkge1xuICAgICAgICB2YXIgdXBsb2FkcyA9IChmb3JtLmZpbGVVcGxvYWRzICYmIGZvcm0uZmlsZVVwbG9hZHMudG9BcnJheSgpKSB8fCBbXTtcbiAgICAgICAgcmV0dXJuIHVwbG9hZHMuc29tZShmdW5jdGlvbiAodmFsdWUpIHtcbiAgICAgICAgICByZXR1cm4gdmFsdWUudXBsb2FkaW5nO1xuICAgICAgICB9KTtcbiAgICAgIH1cbiAgICB9XG5cbiAgICBmdW5jdGlvbiBzaWduRmlsZShmaWxlLCBjYikge1xuICAgICAgdmFyIHBheWxvYWQgPSBuZXcgVVJMU2VhcmNoUGFyYW1zKHtcbiAgICAgICAgbmFtZTogZmlsZS5uYW1lLFxuICAgICAgICBzaXplOiBmaWxlLnNpemUsXG4gICAgICB9KTtcblxuICAgICAgJC5hamF4KHt0eXBlOiAnR0VUJywgdXJsOiBgJHtzaWduRmlsZVVybH0/JHtwYXlsb2FkfWAsIGNyb3NzRG9tYWluOiB0cnVlfSlcbiAgICAgICAgLmRvbmUoZnVuY3Rpb24gKGRhdGEpIHtcbiAgICAgICAgICBjYihudWxsLCBkYXRhKTtcbiAgICAgICAgfSlcbiAgICAgICAgLmZhaWwoZnVuY3Rpb24gKGVycikge1xuICAgICAgICAgIGNiKGVycik7XG4gICAgICAgIH0pO1xuICAgIH1cblxuICAgIGZ1bmN0aW9uIHVwbG9hZFMzKHVybCwgZGF0YSwgZmlsZSwgZmlsZU5hbWUsIGNiKSB7XG4gICAgICB2YXIgZm9ybURhdGEgPSBuZXcgRm9ybURhdGEoKTtcbiAgICAgIGZvciAodmFyIGsgaW4gZGF0YSkge1xuICAgICAgICBmb3JtRGF0YS5hcHBlbmQoaywgZGF0YVtrXSk7XG4gICAgICB9XG4gICAgICBmb3JtRGF0YS5hcHBlbmQoJ2ZpbGUnLCBmaWxlLCBmaWxlTmFtZSk7XG5cbiAgICAgICQuYWpheCh7XG4gICAgICAgIHR5cGU6ICdQT1NUJyxcbiAgICAgICAgdXJsLFxuICAgICAgICBkYXRhOiBmb3JtRGF0YSxcbiAgICAgICAgcHJvY2Vzc0RhdGE6IGZhbHNlLFxuICAgICAgICBjb250ZW50VHlwZTogZmFsc2UsXG4gICAgICB9KVxuICAgICAgICAuZG9uZShmdW5jdGlvbiAoKSB7XG4gICAgICAgICAgY2IobnVsbCk7XG4gICAgICAgIH0pXG4gICAgICAgIC5mYWlsKGZ1bmN0aW9uIChlcnIpIHtcbiAgICAgICAgICBjYihlcnIpO1xuICAgICAgICB9KTtcbiAgICB9XG5cbiAgICAvLyBFeHBvcnQgbW9kdWxlXG4gICAgcmV0dXJuIGFwaTtcbiAgfSlcbik7XG4iXSwibmFtZXMiOlsiV2ViZmxvdyIsInJlcXVpcmUiLCJyZW5kZXJUdXJuc3RpbGVDYXB0Y2hhIiwic2l0ZUtleSIsImZvcm1FbGVtZW50IiwiY2IiLCJlcnJvckNhbGxiYWNrIiwiY2FwdGNoYUNvbnRhaW5lciIsImRvY3VtZW50IiwiY3JlYXRlRWxlbWVudCIsImFwcGVuZENoaWxkIiwidHVybnN0aWxlIiwicmVuZGVyIiwic2l0ZWtleSIsImNhbGxiYWNrIiwidG9rZW4iLCJkZWZpbmUiLCJtb2R1bGUiLCJleHBvcnRzIiwiJCIsIl8iLCJUVVJOU1RJTEVfTE9BREVEX0VWRU5UIiwiYXBpIiwiJGRvYyIsIiRmb3JtcyIsImxvYyIsIndpbmRvdyIsImxvY2F0aW9uIiwicmV0cm8iLCJYRG9tYWluUmVxdWVzdCIsImF0b2IiLCJuYW1lc3BhY2UiLCJzaXRlSWQiLCJlbWFpbEZpZWxkIiwiZW1haWxWYWx1ZSIsImFsZXJ0IiwiaW5BcHAiLCJlbnYiLCJsaXN0ZW5pbmciLCJmb3JtVXJsIiwic2lnbkZpbGVVcmwiLCJ0dXJuc3RpbGVTaXRlS2V5IiwiZmluZCIsImRhdGEiLCJ0dXJuc3RpbGVTY3JpcHQiLCJjaGltcFJlZ2V4IiwiZGlzY29ubmVjdGVkIiwiZGVib3VuY2UiLCJjb25zb2xlIiwid2FybiIsInJlYWR5IiwiZGVzaWduIiwicHJldmlldyIsImxvYWRUdXJuc3RpbGVTY3JpcHQiLCJpbml0IiwiYWRkTGlzdGVuZXJzIiwiYXR0ciIsIldFQkZMT1dfRk9STV9BUElfSE9TVCIsImluZGV4T2YiLCJyZXBsYWNlIiwiV0VCRkxPV19GT1JNX09MRElFX0hPU1QiLCJsZW5ndGgiLCJlYWNoIiwiYnVpbGQiLCJzcmMiLCJoZWFkIiwib25sb2FkIiwidHJpZ2dlciIsImkiLCJlbCIsIiRlbCIsImZvcm0iLCJyZXNldCIsIndyYXAiLCJjbG9zZXN0IiwiZG9uZSIsImZhaWwiLCJmaWxlVXBsb2FkcyIsImoiLCJpbml0RmlsZVVwbG9hZCIsInNldEJ1dHRvblRvVHVybnN0aWxlTG9hZGluZyIsInNldEZvcm1Mb2FkaW5nU3RhdGUiLCJvbiIsInR1cm5zdGlsZVRva2VuIiwiYnRuIiwicHJvcCIsImZvcm1OYW1lIiwiYWN0aW9uIiwiaGFuZGxlciIsInJlZGlyZWN0IiwidGVzdCIsInN1Ym1pdE1haWxDaGltcCIsIldFQkZMT1dfRVhQT1JUX01PREUiLCJleHBvcnRlZFN1Ym1pdFdlYmZsb3ciLCJob3N0ZWRTdWJtaXRIYW5kbGVyIiwiZGVmYXVsdCIsImNvbGxlY3RFbnRlcnByaXNlVHJhY2tpbmdDb29raWVzIiwicHJldmVudERlZmF1bHQiLCJmaW5kRmllbGRzIiwiZmluZEZpbGVVcGxvYWRzIiwiZGlzYWJsZUJ0biIsImFmdGVyU3VibWl0IiwiZXZ0IiwiQ0hFQ0tCT1hfQ0xBU1NfTkFNRSIsIlJBRElPX0lOUFVUX0NMQVNTX05BTUUiLCJDSEVDS0VEX0NMQVNTIiwiRk9DVVNFRF9DTEFTUyIsIkZPQ1VTRURfVklTSUJMRV9DTEFTUyIsImZvY3VzVmlzaWJsZVNlbGVjdG9ycyIsIkNVU1RPTV9DT05UUk9MUyIsInRhcmdldCIsInNpYmxpbmdzIiwidG9nZ2xlQ2xhc3MiLCJuYW1lIiwibWFwIiwicmVtb3ZlQ2xhc3MiLCIkdGFyZ2V0IiwiaGFzQ2xhc3MiLCJhZGRDbGFzcyIsImZvckVhY2giLCJjb250cm9sVHlwZSIsImN1c3RvbUNvbnRyb2xDbGFzc05hbWUiLCJmaWx0ZXIiLCJ3YWl0Iiwic3VjY2VzcyIsImlzRGlzYWJsZWQiLCJCb29sZWFuIiwibGFiZWwiLCJ2YWwiLCIkZm9ybUVsIiwiaXNMb2FkaW5nIiwiJHdyYXBwZXIiLCJyZXN1bHQiLCJzdGF0dXMiLCJmaWVsZCIsInR5cGUiLCJlbmNvZGVVUklDb21wb25lbnQiLCJ2YWx1ZSIsImlzIiwidHJpbSIsImdldFN0YXR1cyIsInRyYWNraW5nQ29va2llTmFtZU1hcCIsIl9ta3RvX3RyayIsImNvb2tpZXMiLCJjb29raWUiLCJzcGxpdCIsInJlZHVjZSIsImFjYyIsInNwbGl0Q29va2llIiwibWFwcGVkTmFtZSIsInNsaWNlIiwiam9pbiIsInBheWxvYWQiLCJocmVmIiwiZnVsbE5hbWUiLCJrZXkiLCJFTUFJTCIsIkZOQU1FIiwiTE5BTUUiLCJ1cmwiLCJ1c2VySWQiLCJzdWJzdHJpbmciLCJsaXN0SWQiLCJhamF4IiwiZGF0YVR5cGUiLCJyZXNwIiwibXNnIiwiaW5mbyIsInRvZ2dsZSIsImZvY3VzIiwiZmlsZSIsIiRkZWZhdWx0V3JhcCIsIiR1cGxvYWRpbmdXcmFwIiwiJHN1Y2Nlc3NXcmFwIiwiJGVycm9yV3JhcCIsIiRpbnB1dCIsIiRsYWJlbCIsIiRsYWJlbENoaWxkcmVuIiwiY2hpbGRyZW4iLCIkZXJyb3JNc2dFbCIsIiRmaWxlRWwiLCIkcmVtb3ZlRWwiLCIkZmlsZU5hbWVFbCIsInNpemVFcnJNc2ciLCJ0eXBlRXJyTXNnIiwiZ2VuZXJpY0Vyck1zZyIsImUiLCJ3aGljaCIsImNsaWNrIiwicmVtb3ZlQXR0ciIsImh0bWwiLCJmaWxlcyIsInRleHQiLCJpc1VwbG9hZGluZyIsInVwbG9hZGluZyIsInNpZ25GaWxlIiwiYWZ0ZXJTaWduIiwiaGVpZ2h0Iiwib3V0ZXJIZWlnaHQiLCJ3aWR0aCIsInBhcnNlRXJyb3IiLCJlcnIiLCJlcnJvck1zZyIsInJlc3BvbnNlSlNPTiIsInVzZXJFcnJvciIsImZpbGVOYW1lIiwicG9zdERhdGEiLCJmaWxlSWQiLCJzM1VybCIsInVwbG9hZFMzIiwiYWZ0ZXJVcGxvYWQiLCJjc3MiLCJ1cGxvYWRzIiwidG9BcnJheSIsInNvbWUiLCJVUkxTZWFyY2hQYXJhbXMiLCJzaXplIiwiY3Jvc3NEb21haW4iLCJmb3JtRGF0YSIsIkZvcm1EYXRhIiwiayIsImFwcGVuZCIsInByb2Nlc3NEYXRhIiwiY29udGVudFR5cGUiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7O0FBT0EsR0FFQTs7Q0FFQztBQUVELElBQUlBLFVBQVVDLFFBQVE7QUFFdEIsTUFBTUMseUJBQXlCLENBQzdCQyxTQUNBQyxhQUNBQyxJQUNBQyxjQUFjLHVCQUF1Qjs7SUFFckMsTUFBTUMsbUJBQW1CQyxTQUFTQyxhQUFhLENBQUM7SUFDaERMLFlBQVlNLFdBQVcsQ0FBQ0g7SUFFeEIscUJBQXFCO0lBQ3JCSSxVQUFVQyxNQUFNLENBQUNMLGtCQUFrQjtRQUNqQ00sU0FBU1Y7UUFDVFcsVUFBVSxTQUFVQyxLQUFLO1lBQ3ZCVixHQUFHVTtRQUNMO1FBQ0Esa0JBQWtCO1lBQ2hCVDtRQUNGO0lBQ0Y7QUFDRjtBQUVBTixRQUFRZ0IsTUFBTSxDQUNaLFNBQ0NDLE9BQU9DLE9BQU8sR0FBRyxTQUFVQyxDQUFDLEVBQUVDLENBQUM7SUFDOUIsTUFBTUMseUJBQXlCO0lBQy9CLElBQUlDLE1BQU0sQ0FBQztJQUVYLElBQUlDLE9BQU9KLEVBQUVYO0lBQ2IsSUFBSWdCO0lBQ0osSUFBSUMsTUFBTUMsT0FBT0MsUUFBUTtJQUN6QixJQUFJQyxRQUFRRixPQUFPRyxjQUFjLElBQUksQ0FBQ0gsT0FBT0ksSUFBSTtJQUNqRCxJQUFJQyxZQUFZO0lBQ2hCLElBQUlDO0lBQ0osSUFBSUMsYUFBYTtJQUNqQixJQUFJQyxhQUFhO0lBQ2pCLElBQUlDLFFBQVFULE9BQU9TLEtBQUs7SUFDeEIsSUFBSUMsUUFBUXBDLFFBQVFxQyxHQUFHO0lBQ3ZCLElBQUlDO0lBRUosSUFBSUM7SUFDSixJQUFJQztJQUVKLE1BQU1DLG1CQUFtQmxCLEtBQ3RCbUIsSUFBSSxDQUFDLDRCQUNMQyxJQUFJLENBQUM7SUFDUixJQUFJQztJQUVKLCtDQUErQztJQUMvQyxJQUFJQyxhQUFhO0lBRWpCLElBQUlDLGVBQWUxQixFQUFFMkIsUUFBUSxDQUFDO1FBQzVCQyxRQUFRQyxJQUFJLENBQ1Y7SUFFSixHQUFHO0lBRUgzQixJQUFJNEIsS0FBSyxHQUNQNUIsSUFBSTZCLE1BQU0sR0FDVjdCLElBQUk4QixPQUFPLEdBQ1Q7UUFDRSw4RUFBOEU7UUFDOUVDO1FBRUEsYUFBYTtRQUNiQztRQUVBLHNFQUFzRTtRQUN0RSxJQUFJLEFBQUMsQ0FBQSxDQUFDbEIsU0FBU3BDLFFBQVFxQyxHQUFHLENBQUMsVUFBUyxLQUFNLENBQUNDLFdBQVc7WUFDcERpQjtRQUNGO0lBQ0Y7SUFFSixTQUFTRDtRQUNQdEIsU0FBU2IsRUFBRSxRQUFRcUMsSUFBSSxDQUFDO1FBRXhCakIsVUFBVWtCLHdCQUF3QixrQkFBa0J6QjtRQUVwRCw4RkFBOEY7UUFDOUYsSUFBSUosU0FBU1csUUFBUW1CLE9BQU8sQ0FBQ0QsMEJBQTBCLEdBQUc7WUFDeERsQixVQUFVQSxRQUFRb0IsT0FBTyxDQUN2QkYsdUJBQ0FHO1FBRUo7UUFFQXBCLGNBQWMsQ0FBQyxFQUFFRCxRQUFRLFNBQVMsQ0FBQztRQUVuQ2YsU0FBU0wsRUFBRVksWUFBWTtRQUN2QixJQUFJLENBQUNQLE9BQU9xQyxNQUFNLEVBQUU7WUFDbEI7UUFDRjtRQUNBckMsT0FBT3NDLElBQUksQ0FBQ0M7SUFDZDtJQUVBLFNBQVNWO1FBQ1AsSUFBSVosa0JBQWtCO1lBQ3BCLGtDQUFrQztZQUNsQ0csa0JBQWtCcEMsU0FBU0MsYUFBYSxDQUFDO1lBQ3pDbUMsZ0JBQWdCb0IsR0FBRyxHQUNqQjtZQUNGeEQsU0FBU3lELElBQUksQ0FBQ3ZELFdBQVcsQ0FBQ2tDO1lBQzFCQSxnQkFBZ0JzQixNQUFNLEdBQUc7Z0JBQ3ZCLGlFQUFpRTtnQkFDakUsb0hBQW9IO2dCQUNwSDNDLEtBQUs0QyxPQUFPLENBQUM5QztZQUNmO1FBQ0Y7SUFDRjtJQUVBLFNBQVMwQyxNQUFNSyxDQUFDLEVBQUVDLEVBQUU7UUFDbEIsbUNBQW1DO1FBQ25DLElBQUlDLE1BQU1uRCxFQUFFa0Q7UUFDWixJQUFJMUIsT0FBT3hCLEVBQUV3QixJQUFJLENBQUMwQixJQUFJdEM7UUFDdEIsSUFBSSxDQUFDWSxNQUFNO1lBQ1RBLE9BQU94QixFQUFFd0IsSUFBSSxDQUFDMEIsSUFBSXRDLFdBQVc7Z0JBQUN3QyxNQUFNRDtZQUFHO1FBQ3pDLEVBQUUsWUFBWTtRQUVkRSxNQUFNN0I7UUFDTixJQUFJOEIsT0FBT0gsSUFBSUksT0FBTyxDQUFDO1FBQ3ZCL0IsS0FBS2dDLElBQUksR0FBR0YsS0FBSy9CLElBQUksQ0FBQztRQUN0QkMsS0FBS2lDLElBQUksR0FBR0gsS0FBSy9CLElBQUksQ0FBQztRQUN0QkMsS0FBS2tDLFdBQVcsR0FBR0osS0FBSy9CLElBQUksQ0FBQztRQUU3QkMsS0FBS2tDLFdBQVcsQ0FBQ2YsSUFBSSxDQUFDLFNBQVVnQixDQUFDO1lBQy9CQyxlQUFlRCxHQUFHbkM7UUFDcEI7UUFFQSxJQUFJRixrQkFBa0I7WUFDcEIsMEZBQTBGO1lBQzFGdUMsNEJBQTRCckM7WUFFNUIsd0NBQXdDO1lBQ3hDc0Msb0JBQW9CWCxLQUFLO1lBRXpCLDJHQUEyRztZQUMzRywwR0FBMEc7WUFDMUcvQyxLQUFLMkQsRUFBRSxDQUNMLE9BQU92RSxjQUFjLGNBQWMsVUFBVVUsd0JBQzdDO2dCQUNFLDZFQUE2RTtnQkFDN0VuQix1QkFDRXVDLGtCQUNBNEIsSUFDQSxDQUFDdEQ7b0JBQ0MsMEhBQTBIO29CQUMxSCxtSEFBbUg7b0JBQ25INEIsS0FBS3dDLGNBQWMsR0FBR3BFO29CQUN0Qiw2RUFBNkU7b0JBQzdFeUQsTUFBTTdCO29CQUNOc0Msb0JBQW9CWCxLQUFLO2dCQUMzQixHQUNBO29CQUNFLDBGQUEwRjtvQkFDMUZFLE1BQU03QjtvQkFDTiwyR0FBMkc7b0JBQzNHLElBQUlBLEtBQUt5QyxHQUFHLEVBQUU7d0JBQ1p6QyxLQUFLeUMsR0FBRyxDQUFDQyxJQUFJLENBQUMsWUFBWTtvQkFDNUI7b0JBQ0FKLG9CQUFvQlgsS0FBSztnQkFDM0I7WUFFSjtRQUVKO1FBRUEsc0JBQXNCO1FBQ3RCLElBQUlnQixXQUNGM0MsS0FBSzRCLElBQUksQ0FBQ2YsSUFBSSxDQUFDLGlCQUFpQmIsS0FBSzRCLElBQUksQ0FBQ2YsSUFBSSxDQUFDLGdCQUFnQjtRQUNqRSxJQUFJLENBQUNiLEtBQUtnQyxJQUFJLENBQUNuQixJQUFJLENBQUMsZUFBZTtZQUNqQ2IsS0FBSzRCLElBQUksQ0FBQ2YsSUFBSSxDQUFDLGNBQWM4QjtRQUMvQjtRQUVBM0MsS0FBS2dDLElBQUksQ0FBQ25CLElBQUksQ0FBQyxZQUFZO1FBQzNCYixLQUFLZ0MsSUFBSSxDQUFDbkIsSUFBSSxDQUFDLFFBQVE7UUFDdkIsSUFBSSxDQUFDYixLQUFLZ0MsSUFBSSxDQUFDbkIsSUFBSSxDQUFDLGVBQWU7WUFDakNiLEtBQUtnQyxJQUFJLENBQUNuQixJQUFJLENBQUMsY0FBYzhCLFdBQVc7UUFDMUM7UUFDQTNDLEtBQUtpQyxJQUFJLENBQUNwQixJQUFJLENBQUMsWUFBWTtRQUMzQmIsS0FBS2lDLElBQUksQ0FBQ3BCLElBQUksQ0FBQyxRQUFRO1FBQ3ZCLElBQUksQ0FBQ2IsS0FBS2lDLElBQUksQ0FBQ3BCLElBQUksQ0FBQyxlQUFlO1lBQ2pDYixLQUFLaUMsSUFBSSxDQUFDcEIsSUFBSSxDQUFDLGNBQWM4QixXQUFXO1FBQzFDO1FBRUEsSUFBSUMsU0FBVTVDLEtBQUs0QyxNQUFNLEdBQUdqQixJQUFJZCxJQUFJLENBQUM7UUFDckNiLEtBQUs2QyxPQUFPLEdBQUc7UUFDZjdDLEtBQUs4QyxRQUFRLEdBQUduQixJQUFJZCxJQUFJLENBQUM7UUFFekIsaUJBQWlCO1FBQ2pCLElBQUlYLFdBQVc2QyxJQUFJLENBQUNILFNBQVM7WUFDM0I1QyxLQUFLNkMsT0FBTyxHQUFHRztZQUNmO1FBQ0Y7UUFFQSxxQkFBcUI7UUFDckIsSUFBSUosUUFBUTtZQUNWO1FBQ0Y7UUFFQSxxQ0FBcUM7UUFDckMsSUFBSXZELFFBQVE7WUFDVlcsS0FBSzZDLE9BQU8sR0FBR0ksc0JBQ1hDLHdCQUNBLEFBQUMsQ0FBQTtnQkFDQyxNQUFNQyxzQkFDSjdGLFFBQVEsMEJBQTBCOEYsT0FBTztnQkFDM0MsT0FBT0Qsb0JBQ0x0QixPQUNBL0MsS0FDQXpCLFNBQ0FnRyxrQ0FDQUMsZ0JBQ0FDLFlBQ0EvRCxPQUNBZ0UsaUJBQ0FDLFlBQ0FwRSxRQUNBcUUsYUFDQWxGLEdBQ0FvQjtZQUVKLENBQUE7WUFDSjtRQUNGO1FBRUEsdUNBQXVDO1FBQ3ZDTztJQUNGO0lBRUEsU0FBU1M7UUFDUGpCLFlBQVk7UUFFWmYsS0FBSzJELEVBQUUsQ0FBQyxVQUFVbkQsWUFBWSxTQUFTLFNBQVV1RSxHQUFHO1lBQ2xELElBQUkzRCxPQUFPeEIsRUFBRXdCLElBQUksQ0FBQyxJQUFJLEVBQUVaO1lBQ3hCLElBQUlZLEtBQUs2QyxPQUFPLEVBQUU7Z0JBQ2hCN0MsS0FBSzJELEdBQUcsR0FBR0E7Z0JBQ1gzRCxLQUFLNkMsT0FBTyxDQUFDN0M7WUFDZjtRQUNGO1FBRUEseURBQXlEO1FBQ3pELE1BQU00RCxzQkFBc0I7UUFDNUIsTUFBTUMseUJBQXlCO1FBQy9CLE1BQU1DLGdCQUFnQjtRQUN0QixNQUFNQyxnQkFBZ0I7UUFDdEIsTUFBTUMsd0JBQXdCO1FBQzlCLE1BQU1DLHdCQUF3QjtRQUU5QixNQUFNQyxrQkFBa0I7WUFDdEI7Z0JBQUM7Z0JBQVlOO2FBQW9CO1lBQ2pDO2dCQUFDO2dCQUFTQzthQUF1QjtTQUNsQztRQUVEakYsS0FBSzJELEVBQUUsQ0FDTCxVQUNBbkQsWUFDRSxDQUFDLGlDQUFpQyxDQUFDLEdBQ25Dd0Usc0JBQ0EsS0FDRixDQUFDRDtZQUNDbkYsRUFBRW1GLElBQUlRLE1BQU0sRUFDVEMsUUFBUSxDQUFDUixxQkFDVFMsV0FBVyxDQUFDUDtRQUNqQjtRQUdGbEYsS0FBSzJELEVBQUUsQ0FBQyxVQUFVbkQsWUFBWSxDQUFDLHlCQUF5QixDQUFDLEVBQUUsQ0FBQ3VFO1lBQzFEbkYsRUFBRSxDQUFDLFlBQVksRUFBRW1GLElBQUlRLE1BQU0sQ0FBQ0csSUFBSSxDQUFDLE9BQU8sRUFBRVYsb0JBQW9CLENBQUMsQ0FBQyxFQUFFVyxHQUFHLENBQ25FLENBQUM5QyxHQUFHQyxLQUNGbEQsRUFBRWtELElBQUkwQyxRQUFRLENBQUNQLHdCQUF3QlcsV0FBVyxDQUFDVjtZQUd2RCxNQUFNVyxVQUFVakcsRUFBRW1GLElBQUlRLE1BQU07WUFFNUIsSUFBSSxDQUFDTSxRQUFRQyxRQUFRLENBQUMsa0JBQWtCO2dCQUN0Q0QsUUFBUUwsUUFBUSxDQUFDUCx3QkFBd0JjLFFBQVEsQ0FBQ2I7WUFDcEQ7UUFDRjtRQUVBSSxnQkFBZ0JVLE9BQU8sQ0FBQyxDQUFDLENBQUNDLGFBQWFDLHVCQUF1QjtZQUM1RGxHLEtBQUsyRCxFQUFFLENBQ0wsU0FDQW5ELFlBQ0UsQ0FBQyxrQkFBa0IsRUFBRXlGLFlBQVksT0FBTyxDQUFDLEdBQ3pDQyx5QkFDQSxLQUNGLENBQUNuQjtnQkFDQ25GLEVBQUVtRixJQUFJUSxNQUFNLEVBQ1RDLFFBQVEsQ0FBQ1Usd0JBQ1RILFFBQVEsQ0FBQ1o7Z0JBQ1p2RixFQUFFbUYsSUFBSVEsTUFBTSxFQUNUWSxNQUFNLENBQUNkLHVCQUNQRyxRQUFRLENBQUNVLHdCQUNUSCxRQUFRLENBQUNYO1lBQ2Q7WUFFRnBGLEtBQUsyRCxFQUFFLENBQ0wsUUFDQW5ELFlBQ0UsQ0FBQyxrQkFBa0IsRUFBRXlGLFlBQVksT0FBTyxDQUFDLEdBQ3pDQyx5QkFDQSxLQUNGLENBQUNuQjtnQkFDQ25GLEVBQUVtRixJQUFJUSxNQUFNLEVBQ1RDLFFBQVEsQ0FBQ1Usd0JBQ1ROLFdBQVcsQ0FBQyxDQUFDLEVBQUVULGNBQWMsQ0FBQyxFQUFFQyxzQkFBc0IsQ0FBQztZQUM1RDtRQUVKO0lBQ0Y7SUFFQSwyQ0FBMkM7SUFDM0MsU0FBU25DLE1BQU03QixJQUFJO1FBQ2pCLElBQUl5QyxNQUFPekMsS0FBS3lDLEdBQUcsR0FBR3pDLEtBQUs0QixJQUFJLENBQUM3QixJQUFJLENBQUM7UUFDckNDLEtBQUtnRixJQUFJLEdBQUdoRixLQUFLeUMsR0FBRyxDQUFDNUIsSUFBSSxDQUFDLGdCQUFnQjtRQUMxQ2IsS0FBS2lGLE9BQU8sR0FBRztRQUVmLDZDQUE2QztRQUM3QyxNQUFNQyxhQUFhQyxRQUFRckYsb0JBQW9CLENBQUNFLEtBQUt3QyxjQUFjO1FBQ25FQyxJQUFJQyxJQUFJLENBQUMsWUFBWXdDO1FBQ3JCekMsSUFBSStCLFdBQVcsQ0FBQztRQUNoQnhFLEtBQUtvRixLQUFLLElBQUkzQyxJQUFJNEMsR0FBRyxDQUFDckYsS0FBS29GLEtBQUs7SUFDbEM7SUFFQSxpREFBaUQ7SUFDakQsU0FBUzNCLFdBQVd6RCxJQUFJO1FBQ3RCLElBQUl5QyxNQUFNekMsS0FBS3lDLEdBQUc7UUFDbEIsSUFBSXVDLE9BQU9oRixLQUFLZ0YsSUFBSSxFQUFFLHlDQUF5QztRQUUvRHZDLElBQUlDLElBQUksQ0FBQyxZQUFZO1FBRXJCLDBDQUEwQztRQUMxQyxJQUFJc0MsTUFBTTtZQUNSaEYsS0FBS29GLEtBQUssR0FBRzNDLElBQUk0QyxHQUFHLElBQUksNkNBQTZDO1lBQ3JFNUMsSUFBSTRDLEdBQUcsQ0FBQ0w7UUFDVjtJQUNGO0lBRUEscURBQXFEO0lBQ3JELFNBQVMzQyw0QkFBNEJyQyxJQUFJO1FBQ3ZDLE1BQU15QyxNQUFNekMsS0FBS3lDLEdBQUcsSUFBSXpDLEtBQUs0QixJQUFJLENBQUM3QixJQUFJLENBQUM7UUFDdkMsSUFBSSxDQUFDQyxLQUFLeUMsR0FBRyxFQUFFekMsS0FBS3lDLEdBQUcsR0FBR0E7UUFFMUJBLElBQUlDLElBQUksQ0FBQyxZQUFZO1FBQ3JCRCxJQUFJa0MsUUFBUSxDQUFDO0lBQ2Y7SUFFQSxpREFBaUQ7SUFDakQsU0FBU3JDLG9CQUFvQmdELE9BQU8sRUFBRUMsU0FBUztRQUM3QyxNQUFNQyxXQUFXRixRQUFRdkQsT0FBTyxDQUFDO1FBQ2pDLElBQUl3RCxXQUFXO1lBQ2JDLFNBQVNiLFFBQVEsQ0FBQztRQUNwQixPQUFPO1lBQ0xhLFNBQVNoQixXQUFXLENBQUM7UUFDdkI7SUFDRjtJQUVBLGtEQUFrRDtJQUNsRCxTQUFTakIsV0FBVzNCLElBQUksRUFBRTZELE1BQU07UUFDOUIsSUFBSUMsU0FBUztRQUNiRCxTQUFTQSxVQUFVLENBQUM7UUFFcEIsc0ZBQXNGO1FBQ3RGN0QsS0FDRzdCLElBQUksQ0FDSCx1RUFFRG9CLElBQUksQ0FBQyxTQUFVTSxDQUFDLEVBQUVDLEVBQUU7WUFDbkIsSUFBSWlFLFFBQVFuSCxFQUFFa0Q7WUFDZCxJQUFJa0UsT0FBT0QsTUFBTTlFLElBQUksQ0FBQztZQUN0QixJQUFJeUQsT0FDRnFCLE1BQU05RSxJQUFJLENBQUMsZ0JBQWdCOEUsTUFBTTlFLElBQUksQ0FBQyxXQUFXLFdBQVlZLENBQUFBLElBQUksQ0FBQTtZQUNuRSxpRUFBaUU7WUFDakUsZ0VBQWdFO1lBQ2hFLG1FQUFtRTtZQUNuRSw0QkFBNEI7WUFDNUIsb0RBQW9EO1lBQ3BENkMsT0FBT3VCLG1CQUFtQnZCO1lBQzFCLElBQUl3QixRQUFRSCxNQUFNTixHQUFHO1lBRXJCLElBQUlPLFNBQVMsWUFBWTtnQkFDdkJFLFFBQVFILE1BQU1JLEVBQUUsQ0FBQztZQUNuQixPQUFPLElBQUlILFNBQVMsU0FBUztnQkFDM0Isc0NBQXNDO2dCQUN0QyxJQUFJSCxNQUFNLENBQUNuQixLQUFLLEtBQUssUUFBUSxPQUFPbUIsTUFBTSxDQUFDbkIsS0FBSyxLQUFLLFVBQVU7b0JBQzdEO2dCQUNGO2dCQUVBd0IsUUFDRWxFLEtBQ0c3QixJQUFJLENBQUMsaUJBQWlCNEYsTUFBTTlFLElBQUksQ0FBQyxVQUFVLGNBQzNDd0UsR0FBRyxNQUFNO1lBQ2hCO1lBRUEsSUFBSSxPQUFPUyxVQUFVLFVBQVU7Z0JBQzdCQSxRQUFRdEgsRUFBRXdILElBQUksQ0FBQ0Y7WUFDakI7WUFDQUwsTUFBTSxDQUFDbkIsS0FBSyxHQUFHd0I7WUFDZkosU0FBU0EsVUFBVU8sVUFBVU4sT0FBT0MsTUFBTXRCLE1BQU13QjtRQUNsRDtRQUVGLE9BQU9KO0lBQ1Q7SUFFQSxTQUFTbEMsZ0JBQWdCNUIsSUFBSTtRQUMzQixJQUFJNkQsU0FBUyxDQUFDO1FBRWQ3RCxLQUFLN0IsSUFBSSxDQUFDLHVCQUF1Qm9CLElBQUksQ0FBQyxTQUFVTSxDQUFDLEVBQUVDLEVBQUU7WUFDbkQsSUFBSWlFLFFBQVFuSCxFQUFFa0Q7WUFDZCxJQUFJNEMsT0FDRnFCLE1BQU05RSxJQUFJLENBQUMsZ0JBQWdCOEUsTUFBTTlFLElBQUksQ0FBQyxXQUFXLFVBQVdZLENBQUFBLElBQUksQ0FBQTtZQUNsRSxJQUFJcUUsUUFBUUgsTUFBTTlFLElBQUksQ0FBQztZQUN2QixJQUFJLE9BQU9pRixVQUFVLFVBQVU7Z0JBQzdCQSxRQUFRdEgsRUFBRXdILElBQUksQ0FBQ0Y7WUFDakI7WUFDQUwsTUFBTSxDQUFDbkIsS0FBSyxHQUFHd0I7UUFDakI7UUFFQSxPQUFPTDtJQUNUO0lBRUEsTUFBTVMsd0JBQXdCO1FBQzVCQyxXQUFXO0lBRWI7SUFFQSxTQUFTOUM7UUFDUCxNQUFNK0MsVUFBVXZJLFNBQVN3SSxNQUFNLENBQUNDLEtBQUssQ0FBQyxNQUFNQyxNQUFNLENBQUMsU0FDakRDLEdBQUcsRUFDSEgsTUFBTTtZQUVOLE1BQU1JLGNBQWNKLE9BQU9DLEtBQUssQ0FBQztZQUNqQyxNQUFNaEMsT0FBT21DLFdBQVcsQ0FBQyxFQUFFO1lBQzNCLElBQUluQyxRQUFRNEIsdUJBQXVCO2dCQUNqQyxNQUFNUSxhQUFhUixxQkFBcUIsQ0FBQzVCLEtBQUs7Z0JBQzlDLE1BQU13QixRQUFRVyxZQUFZRSxLQUFLLENBQUMsR0FBR0MsSUFBSSxDQUFDO2dCQUN4Q0osR0FBRyxDQUFDRSxXQUFXLEdBQUdaO1lBQ3BCO1lBQ0EsT0FBT1U7UUFDVCxHQUFHLENBQUM7UUFFSixPQUFPSjtJQUNUO0lBRUEsU0FBU0gsVUFBVU4sS0FBSyxFQUFFQyxJQUFJLEVBQUV0QixJQUFJLEVBQUV3QixLQUFLO1FBQ3pDLElBQUlKLFNBQVM7UUFFYixJQUFJRSxTQUFTLFlBQVk7WUFDdkJGLFNBQVM7UUFDWCxPQUFPLElBQUlDLE1BQU05RSxJQUFJLENBQUMsYUFBYTtZQUNqQyxJQUFJLENBQUNpRixPQUFPO2dCQUNWSixTQUFTLHlDQUF5Q3BCO1lBQ3BELE9BQU8sSUFBSWhGLFdBQVd5RCxJQUFJLENBQUM0QyxNQUFNOUUsSUFBSSxDQUFDLFVBQVU7Z0JBQzlDLElBQUksQ0FBQ3RCLFdBQVd3RCxJQUFJLENBQUMrQyxRQUFRO29CQUMzQkosU0FBUyw2Q0FBNkNwQjtnQkFDeEQ7WUFDRjtRQUNGLE9BQU8sSUFBSUEsU0FBUywwQkFBMEIsQ0FBQ3dCLE9BQU87WUFDcERKLFNBQVM7UUFDWDtRQUVBLE9BQU9BO0lBQ1Q7SUFFQSxTQUFTeEMsc0JBQXNCbEQsSUFBSTtRQUNqQ3NELGVBQWV0RDtRQUNmMEQsWUFBWTFEO0lBQ2Q7SUFFQSwyQkFBMkI7SUFDM0IsU0FBU2dELGdCQUFnQmhELElBQUk7UUFDM0I2QixNQUFNN0I7UUFFTixJQUFJNEIsT0FBTzVCLEtBQUs0QixJQUFJO1FBQ3BCLElBQUlpRixVQUFVLENBQUM7UUFFZixvRUFBb0U7UUFDcEUsSUFBSSxTQUFTOUQsSUFBSSxDQUFDakUsSUFBSWdJLElBQUksS0FBSyxDQUFDLFNBQVMvRCxJQUFJLENBQUMvQyxLQUFLNEMsTUFBTSxHQUFHO1lBQzFEaEIsS0FBS2YsSUFBSSxDQUFDLFVBQVU7WUFDcEI7UUFDRjtRQUVBeUMsZUFBZXREO1FBRWYsNkJBQTZCO1FBQzdCLElBQUkwRixTQUFTbkMsV0FBVzNCLE1BQU1pRjtRQUM5QixJQUFJbkIsUUFBUTtZQUNWLE9BQU9sRyxNQUFNa0c7UUFDZjtRQUVBLHdCQUF3QjtRQUN4QmpDLFdBQVd6RDtRQUVYLDBDQUEwQztRQUMxQyxJQUFJK0c7UUFDSnRJLEVBQUUwQyxJQUFJLENBQUMwRixTQUFTLFNBQVVmLEtBQUssRUFBRWtCLEdBQUc7WUFDbEMsSUFBSTFILFdBQVd5RCxJQUFJLENBQUNpRSxNQUFNO2dCQUN4QkgsUUFBUUksS0FBSyxHQUFHbkI7WUFDbEI7WUFDQSxJQUFJLHlCQUF5Qi9DLElBQUksQ0FBQ2lFLE1BQU07Z0JBQ3RDRCxXQUFXakI7WUFDYjtZQUNBLElBQUksdUJBQXVCL0MsSUFBSSxDQUFDaUUsTUFBTTtnQkFDcENILFFBQVFLLEtBQUssR0FBR3BCO1lBQ2xCO1lBQ0EsSUFBSSxzQkFBc0IvQyxJQUFJLENBQUNpRSxNQUFNO2dCQUNuQ0gsUUFBUU0sS0FBSyxHQUFHckI7WUFDbEI7UUFDRjtRQUVBLElBQUlpQixZQUFZLENBQUNGLFFBQVFLLEtBQUssRUFBRTtZQUM5QkgsV0FBV0EsU0FBU1QsS0FBSyxDQUFDO1lBQzFCTyxRQUFRSyxLQUFLLEdBQUdILFFBQVEsQ0FBQyxFQUFFO1lBQzNCRixRQUFRTSxLQUFLLEdBQUdOLFFBQVFNLEtBQUssSUFBSUosUUFBUSxDQUFDLEVBQUU7UUFDOUM7UUFFQSw2Q0FBNkM7UUFDN0MsSUFBSUssTUFBTXBILEtBQUs0QyxNQUFNLENBQUM1QixPQUFPLENBQUMsVUFBVSxpQkFBaUI7UUFDekQsMkNBQTJDO1FBQzNDLElBQUlxRyxTQUFTRCxJQUFJckcsT0FBTyxDQUFDLFFBQVE7UUFDakNzRyxTQUFTRCxJQUFJRSxTQUFTLENBQUNELFFBQVFELElBQUlyRyxPQUFPLENBQUMsS0FBS3NHO1FBQ2hELElBQUlFLFNBQVNILElBQUlyRyxPQUFPLENBQUMsU0FBUztRQUNsQ3dHLFNBQVNILElBQUlFLFNBQVMsQ0FBQ0MsUUFBUUgsSUFBSXJHLE9BQU8sQ0FBQyxLQUFLd0c7UUFDaERWLE9BQU8sQ0FBQyxPQUFPUSxTQUFTLE1BQU1FLE9BQU8sR0FBRztRQUV4Qy9JLEVBQUVnSixJQUFJLENBQUM7WUFDTEo7WUFDQXBILE1BQU02RztZQUNOWSxVQUFVO1FBQ1osR0FDR3pGLElBQUksQ0FBQyxTQUFVMEYsSUFBSTtZQUNsQjFILEtBQUtpRixPQUFPLEdBQUd5QyxLQUFLakMsTUFBTSxLQUFLLGFBQWEsVUFBVTFDLElBQUksQ0FBQzJFLEtBQUtDLEdBQUc7WUFDbkUsSUFBSSxDQUFDM0gsS0FBS2lGLE9BQU8sRUFBRTtnQkFDakI1RSxRQUFRdUgsSUFBSSxDQUFDLHNCQUFzQkYsS0FBS0MsR0FBRztZQUM3QztZQUNBakUsWUFBWTFEO1FBQ2QsR0FDQ2lDLElBQUksQ0FBQztZQUNKeUIsWUFBWTFEO1FBQ2Q7SUFDSjtJQUVBLHdEQUF3RDtJQUN4RCxTQUFTMEQsWUFBWTFELElBQUk7UUFDdkIsSUFBSTRCLE9BQU81QixLQUFLNEIsSUFBSTtRQUNwQixJQUFJa0IsV0FBVzlDLEtBQUs4QyxRQUFRO1FBQzVCLElBQUltQyxVQUFVakYsS0FBS2lGLE9BQU87UUFFMUIsdUNBQXVDO1FBQ3ZDLElBQUlBLFdBQVduQyxVQUFVO1lBQ3ZCekYsUUFBUTJCLFFBQVEsQ0FBQzhEO1lBQ2pCO1FBQ0Y7UUFFQSwyQkFBMkI7UUFDM0I5QyxLQUFLZ0MsSUFBSSxDQUFDNkYsTUFBTSxDQUFDNUM7UUFDakJqRixLQUFLaUMsSUFBSSxDQUFDNEYsTUFBTSxDQUFDLENBQUM1QztRQUVsQixJQUFJQSxTQUFTO1lBQ1hqRixLQUFLZ0MsSUFBSSxDQUFDOEYsS0FBSztRQUNqQixPQUFPO1lBQ0w5SCxLQUFLaUMsSUFBSSxDQUFDNkYsS0FBSztRQUNqQjtRQUVBLHVCQUF1QjtRQUN2QmxHLEtBQUtpRyxNQUFNLENBQUMsQ0FBQzVDO1FBRWIsc0NBQXNDO1FBQ3RDcEQsTUFBTTdCO0lBQ1I7SUFFQSxTQUFTc0QsZUFBZXRELElBQUk7UUFDMUJBLEtBQUsyRCxHQUFHLElBQUkzRCxLQUFLMkQsR0FBRyxDQUFDTCxjQUFjO1FBQ25DdEQsS0FBSzJELEdBQUcsR0FBRztJQUNiO0lBRUEsU0FBU3ZCLGVBQWVYLENBQUMsRUFBRUcsSUFBSTtRQUM3QixJQUFJLENBQUNBLEtBQUtNLFdBQVcsSUFBSSxDQUFDTixLQUFLTSxXQUFXLENBQUNULEVBQUUsRUFBRTtZQUM3QztRQUNGO1FBRUEsSUFBSXNHO1FBQ0osSUFBSXBHLE1BQU1uRCxFQUFFb0QsS0FBS00sV0FBVyxDQUFDVCxFQUFFO1FBQy9CLElBQUl1RyxlQUFlckcsSUFBSTVCLElBQUksQ0FBQztRQUM1QixJQUFJa0ksaUJBQWlCdEcsSUFBSTVCLElBQUksQ0FBQztRQUM5QixJQUFJbUksZUFBZXZHLElBQUk1QixJQUFJLENBQUM7UUFDNUIsSUFBSW9JLGFBQWF4RyxJQUFJNUIsSUFBSSxDQUFDO1FBQzFCLElBQUlxSSxTQUFTSixhQUFhakksSUFBSSxDQUFDO1FBQy9CLElBQUlzSSxTQUFTTCxhQUFhakksSUFBSSxDQUFDO1FBQy9CLElBQUl1SSxpQkFBaUJELE9BQU9FLFFBQVE7UUFDcEMsSUFBSUMsY0FBY0wsV0FBV3BJLElBQUksQ0FBQztRQUNsQyxJQUFJMEksVUFBVVAsYUFBYW5JLElBQUksQ0FBQztRQUNoQyxJQUFJMkksWUFBWVIsYUFBYW5JLElBQUksQ0FBQztRQUNsQyxJQUFJNEksY0FBY0YsUUFBUTFJLElBQUksQ0FBQztRQUUvQixJQUFJNkksYUFBYUosWUFBWTNILElBQUksQ0FBQztRQUNsQyxJQUFJZ0ksYUFBYUwsWUFBWTNILElBQUksQ0FBQztRQUNsQyxJQUFJaUksZ0JBQWdCTixZQUFZM0gsSUFBSSxDQUFDO1FBRXJDLHNCQUFzQjtRQUN0QixtRUFBbUU7UUFDbkUscURBQXFEO1FBQ3JELElBQUksQ0FBQ3BCLE9BQU87WUFDVjRJLE9BQU85RixFQUFFLENBQUMsaUJBQWlCLFNBQVV3RyxDQUFDO2dCQUNwQyxJQUFJQSxFQUFFbkQsSUFBSSxLQUFLLGFBQWFtRCxFQUFFQyxLQUFLLEtBQUssTUFBTUQsRUFBRUMsS0FBSyxLQUFLLElBQUk7b0JBQzVEO2dCQUNGO2dCQUVBRCxFQUFFekYsY0FBYztnQkFDaEI4RSxPQUFPYSxLQUFLO1lBQ2Q7UUFDRjtRQUVBLHNDQUFzQztRQUN0Q1osT0FBT3RJLElBQUksQ0FBQyw0QkFBNEJjLElBQUksQ0FBQyxlQUFlO1FBQzVENkgsVUFBVTNJLElBQUksQ0FBQyw4QkFBOEJjLElBQUksQ0FBQyxlQUFlO1FBRWpFLElBQUksQ0FBQ3BCLE9BQU87WUFDVmlKLFVBQVVuRyxFQUFFLENBQUMsaUJBQWlCLFNBQVV3RyxDQUFDO2dCQUN2QyxJQUFJQSxFQUFFbkQsSUFBSSxLQUFLLFdBQVc7b0JBQ3hCLElBQUltRCxFQUFFQyxLQUFLLEtBQUssTUFBTUQsRUFBRUMsS0FBSyxLQUFLLElBQUk7d0JBQ3BDO29CQUNGO29CQUVBRCxFQUFFekYsY0FBYztnQkFDbEI7Z0JBRUE4RSxPQUFPYyxVQUFVLENBQUM7Z0JBQ2xCZCxPQUFPL0MsR0FBRyxDQUFDO2dCQUNYc0QsWUFBWVEsSUFBSSxDQUFDO2dCQUNqQm5CLGFBQWFILE1BQU0sQ0FBQztnQkFDcEJLLGFBQWFMLE1BQU0sQ0FBQztnQkFDcEJRLE9BQU9QLEtBQUs7WUFDZDtZQUVBTSxPQUFPN0YsRUFBRSxDQUFDLFVBQVUsU0FBVXdHLENBQUM7Z0JBQzdCaEIsT0FBT2dCLEVBQUU1RSxNQUFNLElBQUk0RSxFQUFFNUUsTUFBTSxDQUFDaUYsS0FBSyxJQUFJTCxFQUFFNUUsTUFBTSxDQUFDaUYsS0FBSyxDQUFDLEVBQUU7Z0JBQ3RELElBQUksQ0FBQ3JCLE1BQU07b0JBQ1Q7Z0JBQ0Y7Z0JBRUEsaUJBQWlCO2dCQUNqQkMsYUFBYUgsTUFBTSxDQUFDO2dCQUNwQk0sV0FBV04sTUFBTSxDQUFDO2dCQUNsQkksZUFBZUosTUFBTSxDQUFDO2dCQUN0QkksZUFBZUgsS0FBSztnQkFFcEIsZUFBZTtnQkFDZmEsWUFBWVUsSUFBSSxDQUFDdEIsS0FBS3pELElBQUk7Z0JBRTFCLHdCQUF3QjtnQkFDeEIsSUFBSSxDQUFDZ0YsZUFBZTtvQkFDbEI3RixXQUFXN0I7Z0JBQ2I7Z0JBQ0FBLEtBQUtNLFdBQVcsQ0FBQ1QsRUFBRSxDQUFDOEgsU0FBUyxHQUFHO2dCQUVoQ0MsU0FBU3pCLE1BQU0wQjtZQUNqQjtZQUVBLGlEQUFpRDtZQUNqRCxxREFBcUQ7WUFDckQsSUFBSUMsU0FBU3JCLE9BQU9zQixXQUFXO1lBQy9CdkIsT0FBT3NCLE1BQU0sQ0FBQ0E7WUFDZHRCLE9BQU93QixLQUFLLENBQUM7UUFDZixPQUFPO1lBQ0x4QixPQUFPN0YsRUFBRSxDQUFDLFNBQVMsU0FBVXdHLENBQUM7Z0JBQzVCQSxFQUFFekYsY0FBYztZQUNsQjtZQUNBK0UsT0FBTzlGLEVBQUUsQ0FBQyxTQUFTLFNBQVV3RyxDQUFDO2dCQUM1QkEsRUFBRXpGLGNBQWM7WUFDbEI7WUFDQWdGLGVBQWUvRixFQUFFLENBQUMsU0FBUyxTQUFVd0csQ0FBQztnQkFDcENBLEVBQUV6RixjQUFjO1lBQ2xCO1FBQ0Y7UUFFQSxTQUFTdUcsV0FBV0MsR0FBRztZQUNyQixJQUFJQyxXQUFXRCxJQUFJRSxZQUFZLElBQUlGLElBQUlFLFlBQVksQ0FBQ3JDLEdBQUc7WUFDdkQsSUFBSXNDLFlBQVluQjtZQUNoQixJQUNFLE9BQU9pQixhQUFhLFlBQ3BCQSxTQUFTaEosT0FBTyxDQUFDLDRCQUE0QixHQUM3QztnQkFDQWtKLFlBQVlwQjtZQUNkLE9BQU8sSUFDTCxPQUFPa0IsYUFBYSxZQUNwQkEsU0FBU2hKLE9BQU8sQ0FBQyx3QkFBd0IsR0FDekM7Z0JBQ0FrSixZQUFZckI7WUFDZDtZQUVBSixZQUFZYSxJQUFJLENBQUNZO1lBRWpCN0IsT0FBT2MsVUFBVSxDQUFDO1lBQ2xCZCxPQUFPL0MsR0FBRyxDQUFDO1lBQ1g0QyxlQUFlSixNQUFNLENBQUM7WUFDdEJHLGFBQWFILE1BQU0sQ0FBQztZQUNwQk0sV0FBV04sTUFBTSxDQUFDO1lBQ2xCTSxXQUFXTCxLQUFLO1lBRWhCbEcsS0FBS00sV0FBVyxDQUFDVCxFQUFFLENBQUM4SCxTQUFTLEdBQUc7WUFDaEMsSUFBSSxDQUFDRCxlQUFlO2dCQUNsQnpILE1BQU1EO1lBQ1I7UUFDRjtRQUVBLFNBQVM2SCxVQUFVSyxHQUFHLEVBQUU5SixJQUFJO1lBQzFCLElBQUk4SixLQUFLO2dCQUNQLE9BQU9ELFdBQVdDO1lBQ3BCO1lBRUEsSUFBSUksV0FBV2xLLEtBQUtrSyxRQUFRO1lBQzVCLElBQUlDLFdBQVduSyxLQUFLbUssUUFBUTtZQUM1QixJQUFJQyxTQUFTcEssS0FBS29LLE1BQU07WUFDeEIsSUFBSUMsUUFBUXJLLEtBQUtxSyxLQUFLO1lBQ3RCakMsT0FBT3ZILElBQUksQ0FBQyxjQUFjdUo7WUFFMUJFLFNBQVNELE9BQU9GLFVBQVVwQyxNQUFNbUMsVUFBVUs7UUFDNUM7UUFFQSxTQUFTQSxZQUFZVCxHQUFHO1lBQ3RCLElBQUlBLEtBQUs7Z0JBQ1AsT0FBT0QsV0FBV0M7WUFDcEI7WUFFQSxlQUFlO1lBQ2Y3QixlQUFlSixNQUFNLENBQUM7WUFDdEJLLGFBQWFzQyxHQUFHLENBQUMsV0FBVztZQUM1QnRDLGFBQWFKLEtBQUs7WUFFbEJsRyxLQUFLTSxXQUFXLENBQUNULEVBQUUsQ0FBQzhILFNBQVMsR0FBRztZQUNoQyxJQUFJLENBQUNELGVBQWU7Z0JBQ2xCekgsTUFBTUQ7WUFDUjtRQUNGO1FBRUEsU0FBUzBIO1lBQ1AsSUFBSW1CLFVBQVUsQUFBQzdJLEtBQUtNLFdBQVcsSUFBSU4sS0FBS00sV0FBVyxDQUFDd0ksT0FBTyxNQUFPLEVBQUU7WUFDcEUsT0FBT0QsUUFBUUUsSUFBSSxDQUFDLFNBQVU3RSxLQUFLO2dCQUNqQyxPQUFPQSxNQUFNeUQsU0FBUztZQUN4QjtRQUNGO0lBQ0Y7SUFFQSxTQUFTQyxTQUFTekIsSUFBSSxFQUFFckssRUFBRTtRQUN4QixJQUFJbUosVUFBVSxJQUFJK0QsZ0JBQWdCO1lBQ2hDdEcsTUFBTXlELEtBQUt6RCxJQUFJO1lBQ2Z1RyxNQUFNOUMsS0FBSzhDLElBQUk7UUFDakI7UUFFQXJNLEVBQUVnSixJQUFJLENBQUM7WUFBQzVCLE1BQU07WUFBT3dCLEtBQUssQ0FBQyxFQUFFdkgsWUFBWSxDQUFDLEVBQUVnSCxRQUFRLENBQUM7WUFBRWlFLGFBQWE7UUFBSSxHQUNyRTlJLElBQUksQ0FBQyxTQUFVaEMsSUFBSTtZQUNsQnRDLEdBQUcsTUFBTXNDO1FBQ1gsR0FDQ2lDLElBQUksQ0FBQyxTQUFVNkgsR0FBRztZQUNqQnBNLEdBQUdvTTtRQUNMO0lBQ0o7SUFFQSxTQUFTUSxTQUFTbEQsR0FBRyxFQUFFcEgsSUFBSSxFQUFFK0gsSUFBSSxFQUFFbUMsUUFBUSxFQUFFeE0sRUFBRTtRQUM3QyxJQUFJcU4sV0FBVyxJQUFJQztRQUNuQixJQUFLLElBQUlDLEtBQUtqTCxLQUFNO1lBQ2xCK0ssU0FBU0csTUFBTSxDQUFDRCxHQUFHakwsSUFBSSxDQUFDaUwsRUFBRTtRQUM1QjtRQUNBRixTQUFTRyxNQUFNLENBQUMsUUFBUW5ELE1BQU1tQztRQUU5QjFMLEVBQUVnSixJQUFJLENBQUM7WUFDTDVCLE1BQU07WUFDTndCO1lBQ0FwSCxNQUFNK0s7WUFDTkksYUFBYTtZQUNiQyxhQUFhO1FBQ2YsR0FDR3BKLElBQUksQ0FBQztZQUNKdEUsR0FBRztRQUNMLEdBQ0N1RSxJQUFJLENBQUMsU0FBVTZILEdBQUc7WUFDakJwTSxHQUFHb007UUFDTDtJQUNKO0lBRUEsZ0JBQWdCO0lBQ2hCLE9BQU9uTDtBQUNUIn0=

}),
73392: (function (__unused_webpack_module, exports) {
"use strict";
/*
 * WARNING
 *
 * This file is included in the `webflow.js` bundle, so
 * please refrain from adding dependencies that might
 * have an outsized impact on bundle size.
 *
 * Thank you!
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "createJsonFromBoundMedia", ({
    enumerable: true,
    get: function() {
        return createJsonFromBoundMedia;
    }
}));
const createJsonItemFromBoundMedia = (binding)=>{
    if (binding) {
        if (binding.metadata) {
            const { html, height, width, thumbnail_url: thumbnailUrl } = binding.metadata;
            return {
                url: binding.url,
                html,
                height,
                width,
                thumbnailUrl,
                type: 'video'
            };
        } else {
            return {
                url: binding.url,
                type: 'image'
            };
        }
    }
    return null;
};
const createJsonFromBoundMedia = (binding, nodeJsonData)=>{
    const group = nodeJsonData ? nodeJsonData.group : undefined;
    if (Array.isArray(binding)) {
        const items = binding.reduce((memo, subBinding)=>{
            const jsonItem = createJsonItemFromBoundMedia(subBinding);
            if (jsonItem) {
                memo.push(jsonItem);
            }
            return memo;
        }, []);
        return items.length > 0 ? {
            items,
            group
        } : null;
    }
    const jsonItem = createJsonItemFromBoundMedia(binding);
    return jsonItem !== null ? {
        items: [
            jsonItem
        ],
        group
    } : null;
};

//# sourceMappingURL=data:application/json;base64,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

}),
41655: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";
/* globals window, document */ /**
 * Webflow: Navbar component
 */ 
var Webflow = __webpack_require__(43949);
var IXEvents = __webpack_require__(65134);
const KEY_CODES = {
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40,
    ESCAPE: 27,
    SPACE: 32,
    ENTER: 13,
    HOME: 36,
    END: 35
};
Webflow.define('navbar', module.exports = function($, _) {
    var api = {};
    var tram = $.tram;
    var $win = $(window);
    var $doc = $(document);
    var debounce = _.debounce;
    var $body;
    var $navbars;
    var designer;
    var inEditor;
    var inApp = Webflow.env();
    var overlay = '<div class="w-nav-overlay" data-wf-ignore />';
    var namespace = '.w-nav';
    var navbarOpenedButton = 'w--open';
    var navbarOpenedDropdown = 'w--nav-dropdown-open';
    var navbarOpenedDropdownToggle = 'w--nav-dropdown-toggle-open';
    var navbarOpenedDropdownList = 'w--nav-dropdown-list-open';
    var navbarOpenedLink = 'w--nav-link-open';
    var ix = IXEvents.triggers;
    var menuSibling = $();
    // -----------------------------------
    // Module methods
    api.ready = api.design = api.preview = init;
    api.destroy = function() {
        menuSibling = $();
        removeListeners();
        if ($navbars && $navbars.length) {
            $navbars.each(teardown);
        }
    };
    // -----------------------------------
    // Private methods
    function init() {
        designer = inApp && Webflow.env('design');
        inEditor = Webflow.env('editor');
        $body = $(document.body);
        // Find all instances on the page
        $navbars = $doc.find(namespace);
        if (!$navbars.length) {
            return;
        }
        $navbars.each(build);
        // Wire events
        removeListeners();
        addListeners();
    }
    function removeListeners() {
        Webflow.resize.off(resizeAll);
    }
    function addListeners() {
        Webflow.resize.on(resizeAll);
    }
    function resizeAll() {
        $navbars.each(resize);
    }
    function build(i, el) {
        var $el = $(el);
        // Store state in data
        var data = $.data(el, namespace);
        if (!data) {
            data = $.data(el, namespace, {
                open: false,
                el: $el,
                config: {},
                selectedIdx: -1
            });
        }
        data.menu = $el.find('.w-nav-menu');
        data.links = data.menu.find('.w-nav-link');
        data.dropdowns = data.menu.find('.w-dropdown');
        data.dropdownToggle = data.menu.find('.w-dropdown-toggle');
        data.dropdownList = data.menu.find('.w-dropdown-list');
        data.button = $el.find('.w-nav-button');
        data.container = $el.find('.w-container');
        data.overlayContainerId = 'w-nav-overlay-' + i;
        data.outside = outside(data);
        //   If the brand links exists and is set to link to the homepage, the
        // default setting, then add an aria-label
        var navBrandLink = $el.find('.w-nav-brand');
        if (navBrandLink && navBrandLink.attr('href') === '/' && navBrandLink.attr('aria-label') == null) {
            navBrandLink.attr('aria-label', 'home');
        }
        //   VoiceOver bug, when items that disallow user selection are focused
        // VoiceOver gets confused and scrolls to the end of the page. ¯\_(ツ)_/¯
        data.button.attr('style', '-webkit-user-select: text;');
        // Add attributes to toggle element
        if (data.button.attr('aria-label') == null) {
            data.button.attr('aria-label', 'menu');
        }
        data.button.attr('role', 'button');
        data.button.attr('tabindex', '0');
        data.button.attr('aria-controls', data.overlayContainerId);
        data.button.attr('aria-haspopup', 'menu');
        data.button.attr('aria-expanded', 'false');
        // Remove old events
        data.el.off(namespace);
        data.button.off(namespace);
        data.menu.off(namespace);
        // Set config from data attributes
        configure(data);
        // Add events based on mode
        if (designer) {
            removeOverlay(data);
            data.el.on('setting' + namespace, handler(data));
        } else {
            addOverlay(data);
            data.button.on('click' + namespace, toggle(data));
            data.menu.on('click' + namespace, 'a', navigate(data));
            data.button.on('keydown' + namespace, makeToggleButtonKeyboardHandler(data));
            data.el.on('keydown' + namespace, makeLinksKeyboardHandler(data));
        }
        // Trigger initial resize
        resize(i, el);
    }
    function teardown(i, el) {
        var data = $.data(el, namespace);
        if (data) {
            removeOverlay(data);
            $.removeData(el, namespace);
        }
    }
    function removeOverlay(data) {
        if (!data.overlay) {
            return;
        }
        close(data, true);
        data.overlay.remove();
        data.overlay = null;
    }
    function addOverlay(data) {
        if (data.overlay) {
            return;
        }
        data.overlay = $(overlay).appendTo(data.el);
        data.overlay.attr('id', data.overlayContainerId);
        data.parent = data.menu.parent();
        close(data, true);
    }
    function configure(data) {
        var config = {};
        var old = data.config || {};
        // Set config options from data attributes
        var animation = config.animation = data.el.attr('data-animation') || 'default';
        config.animOver = /^over/.test(animation);
        config.animDirect = /left$/.test(animation) ? -1 : 1;
        // Re-open menu if the animation type changed
        if (old.animation !== animation) {
            data.open && _.defer(reopen, data);
        }
        config.easing = data.el.attr('data-easing') || 'ease';
        config.easing2 = data.el.attr('data-easing2') || 'ease';
        var duration = data.el.attr('data-duration');
        config.duration = duration != null ? Number(duration) : 400;
        config.docHeight = data.el.attr('data-doc-height');
        // Store config in data
        data.config = config;
    }
    function handler(data) {
        return function(evt, options) {
            options = options || {};
            var winWidth = $win.width();
            configure(data);
            options.open === true && open(data, true);
            options.open === false && close(data, true);
            // Reopen if media query changed after setting
            data.open && _.defer(function() {
                if (winWidth !== $win.width()) {
                    reopen(data);
                }
            });
        };
    }
    function makeToggleButtonKeyboardHandler(data) {
        return function(evt) {
            switch(evt.keyCode){
                case KEY_CODES.SPACE:
                case KEY_CODES.ENTER:
                    {
                        // Toggle returns a function
                        toggle(data)();
                        evt.preventDefault();
                        return evt.stopPropagation();
                    }
                case KEY_CODES.ESCAPE:
                    {
                        close(data);
                        evt.preventDefault();
                        return evt.stopPropagation();
                    }
                case KEY_CODES.ARROW_RIGHT:
                case KEY_CODES.ARROW_DOWN:
                case KEY_CODES.HOME:
                case KEY_CODES.END:
                    {
                        if (!data.open) {
                            evt.preventDefault();
                            return evt.stopPropagation();
                        }
                        if (evt.keyCode === KEY_CODES.END) {
                            data.selectedIdx = data.links.length - 1;
                        } else {
                            data.selectedIdx = 0;
                        }
                        focusSelectedLink(data);
                        evt.preventDefault();
                        return evt.stopPropagation();
                    }
            }
        };
    }
    function makeLinksKeyboardHandler(data) {
        return function(evt) {
            if (!data.open) {
                return;
            }
            // Realign selectedIdx with the menu item that is currently in focus.
            // We need this because we do not track the `Tab` key activity!
            data.selectedIdx = data.links.index(document.activeElement);
            switch(evt.keyCode){
                case KEY_CODES.HOME:
                case KEY_CODES.END:
                    {
                        if (evt.keyCode === KEY_CODES.END) {
                            data.selectedIdx = data.links.length - 1;
                        } else {
                            data.selectedIdx = 0;
                        }
                        focusSelectedLink(data);
                        evt.preventDefault();
                        return evt.stopPropagation();
                    }
                case KEY_CODES.ESCAPE:
                    {
                        close(data);
                        // Focus toggle button
                        data.button.focus();
                        evt.preventDefault();
                        return evt.stopPropagation();
                    }
                case KEY_CODES.ARROW_LEFT:
                case KEY_CODES.ARROW_UP:
                    {
                        data.selectedIdx = Math.max(-1, data.selectedIdx - 1);
                        focusSelectedLink(data);
                        evt.preventDefault();
                        return evt.stopPropagation();
                    }
                case KEY_CODES.ARROW_RIGHT:
                case KEY_CODES.ARROW_DOWN:
                    {
                        data.selectedIdx = Math.min(data.links.length - 1, data.selectedIdx + 1);
                        focusSelectedLink(data);
                        evt.preventDefault();
                        return evt.stopPropagation();
                    }
            }
        };
    }
    function focusSelectedLink(data) {
        if (data.links[data.selectedIdx]) {
            var selectedElement = data.links[data.selectedIdx];
            selectedElement.focus();
            navigate(selectedElement);
        }
    }
    function reopen(data) {
        if (!data.open) {
            return;
        }
        close(data, true);
        open(data, true);
    }
    function toggle(data) {
        // Debounce toggle to wait for accurate open state
        return debounce(function() {
            data.open ? close(data) : open(data);
        });
    }
    function navigate(data) {
        return function(evt) {
            var link = $(this);
            var href = link.attr('href');
            // Avoid late clicks on touch devices
            if (!Webflow.validClick(evt.currentTarget)) {
                evt.preventDefault();
                return;
            }
            // Close when navigating to an in-page anchor
            if (href && href.indexOf('#') === 0 && data.open) {
                close(data);
            }
        };
    }
    function outside(data) {
        // Unbind previous click handler if it exists
        if (data.outside) {
            $doc.off('click' + namespace, data.outside);
        }
        return function(evt) {
            var $target = $(evt.target);
            // Ignore clicks on Editor overlay UI
            if (inEditor && $target.closest('.w-editor-bem-EditorOverlay').length) {
                return;
            }
            // Close menu when clicked outside, debounced to wait for state
            outsideDebounced(data, $target);
        };
    }
    var outsideDebounced = debounce(function(data, $target) {
        if (!data.open) {
            return;
        }
        var menu = $target.closest('.w-nav-menu');
        if (!data.menu.is(menu)) {
            close(data);
        }
    });
    function resize(i, el) {
        var data = $.data(el, namespace);
        // Check for collapsed state based on button display
        var collapsed = data.collapsed = data.button.css('display') !== 'none';
        // Close menu if button is no longer visible (and not in designer)
        if (data.open && !collapsed && !designer) {
            close(data, true);
        }
        // Set max-width of links + dropdowns to match container
        if (data.container.length) {
            var updateEachMax = updateMax(data);
            data.links.each(updateEachMax);
            data.dropdowns.each(updateEachMax);
        }
        // If currently open, update height to match body
        if (data.open) {
            setOverlayHeight(data);
        }
    }
    var maxWidth = 'max-width';
    function updateMax(data) {
        // Set max-width of each element to match container
        var containMax = data.container.css(maxWidth);
        if (containMax === 'none') {
            containMax = '';
        }
        return function(i, link) {
            link = $(link);
            link.css(maxWidth, '');
            // Don't set the max-width if an upstream value exists
            if (link.css(maxWidth) === 'none') {
                link.css(maxWidth, containMax);
            }
        };
    }
    function addMenuOpen(i, el) {
        el.setAttribute('data-nav-menu-open', '');
    }
    function removeMenuOpen(i, el) {
        el.removeAttribute('data-nav-menu-open');
    }
    function open(data, immediate) {
        if (data.open) {
            return;
        }
        data.open = true;
        data.menu.each(addMenuOpen);
        data.links.addClass(navbarOpenedLink);
        data.dropdowns.addClass(navbarOpenedDropdown);
        data.dropdownToggle.addClass(navbarOpenedDropdownToggle);
        data.dropdownList.addClass(navbarOpenedDropdownList);
        data.button.addClass(navbarOpenedButton);
        var config = data.config;
        var animation = config.animation;
        if (animation === 'none' || !tram.support.transform || config.duration <= 0) {
            immediate = true;
        }
        var bodyHeight = setOverlayHeight(data);
        var menuHeight = data.menu.outerHeight(true);
        var menuWidth = data.menu.outerWidth(true);
        var navHeight = data.el.height();
        var navbarEl = data.el[0];
        resize(0, navbarEl);
        ix.intro(0, navbarEl);
        Webflow.redraw.up();
        // Listen for click outside events
        if (!designer) {
            $doc.on('click' + namespace, data.outside);
        }
        // No transition for immediate
        if (immediate) {
            complete();
            return;
        }
        var transConfig = 'transform ' + config.duration + 'ms ' + config.easing;
        // Add menu to overlay
        if (data.overlay) {
            menuSibling = data.menu.prev();
            data.overlay.show().append(data.menu);
        }
        // Over left/right
        if (config.animOver) {
            tram(data.menu).add(transConfig).set({
                x: config.animDirect * menuWidth,
                height: bodyHeight
            }).start({
                x: 0
            }).then(complete);
            data.overlay && data.overlay.width(menuWidth);
            return;
        }
        // Drop Down
        var offsetY = navHeight + menuHeight;
        tram(data.menu).add(transConfig).set({
            y: -offsetY
        }).start({
            y: 0
        }).then(complete);
        function complete() {
            data.button.attr('aria-expanded', 'true');
        }
    }
    function setOverlayHeight(data) {
        var config = data.config;
        var bodyHeight = config.docHeight ? $doc.height() : $body.height();
        if (config.animOver) {
            data.menu.height(bodyHeight);
        } else if (data.el.css('position') !== 'fixed') {
            bodyHeight -= data.el.outerHeight(true);
        }
        data.overlay && data.overlay.height(bodyHeight);
        return bodyHeight;
    }
    function close(data, immediate) {
        if (!data.open) {
            return;
        }
        data.open = false;
        data.button.removeClass(navbarOpenedButton);
        var config = data.config;
        if (config.animation === 'none' || !tram.support.transform || config.duration <= 0) {
            immediate = true;
        }
        ix.outro(0, data.el[0]);
        // Stop listening for click outside events
        $doc.off('click' + namespace, data.outside);
        if (immediate) {
            tram(data.menu).stop();
            complete();
            return;
        }
        var transConfig = 'transform ' + config.duration + 'ms ' + config.easing2;
        var menuHeight = data.menu.outerHeight(true);
        var menuWidth = data.menu.outerWidth(true);
        var navHeight = data.el.height();
        // Over left/right
        if (config.animOver) {
            tram(data.menu).add(transConfig).start({
                x: menuWidth * config.animDirect
            }).then(complete);
            return;
        }
        // Drop Down
        var offsetY = navHeight + menuHeight;
        tram(data.menu).add(transConfig).start({
            y: -offsetY
        }).then(complete);
        function complete() {
            data.menu.height('');
            tram(data.menu).set({
                x: 0,
                y: 0
            });
            data.menu.each(removeMenuOpen);
            data.links.removeClass(navbarOpenedLink);
            data.dropdowns.removeClass(navbarOpenedDropdown);
            data.dropdownToggle.removeClass(navbarOpenedDropdownToggle);
            data.dropdownList.removeClass(navbarOpenedDropdownList);
            if (data.overlay && data.overlay.children().length) {
                // Move menu back to parent at the original location
                menuSibling.length ? data.menu.insertAfter(menuSibling) : data.menu.prependTo(data.parent);
                data.overlay.attr('style', '').hide();
            }
            // Trigger event so other components can hook in (dropdown)
            data.el.triggerHandler('w-close');
            data.button.attr('aria-expanded', 'false');
        }
    }
    // Export module
    return api;
});

//# sourceMappingURL=data:application/json;base64,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

}),
84345: (function (module, __unused_webpack_exports, __webpack_require__) {
"use strict";
/* global window, document */ /**
 * Webflow: Slider component
 */ 
var Webflow = __webpack_require__(43949);
var IXEvents = __webpack_require__(65134);
const KEY_CODES = {
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40,
    SPACE: 32,
    ENTER: 13,
    HOME: 36,
    END: 35
};
const FOCUSABLE_SELECTOR = 'a[href], area[href], [role="button"], input, select, textarea, button, iframe, object, embed, *[tabindex], *[contenteditable]';
Webflow.define('slider', module.exports = function($, _) {
    var api = {};
    var tram = $.tram;
    var $doc = $(document);
    var $sliders;
    var designer;
    var inApp = Webflow.env();
    var namespace = '.w-slider';
    var dot = '<div class="w-slider-dot" data-wf-ignore />';
    var ariaLiveLabelHtml = '<div aria-live="off" aria-atomic="true" class="w-slider-aria-label" data-wf-ignore />';
    var forceShow = 'w-slider-force-show';
    var ix = IXEvents.triggers;
    var fallback;
    var inRedraw = false;
    // -----------------------------------
    // Module methods
    api.ready = function() {
        designer = Webflow.env('design');
        init();
    };
    api.design = function() {
        designer = true;
        // Helps slider init on Designer load.
        setTimeout(init, 1000);
    };
    api.preview = function() {
        designer = false;
        init();
    };
    api.redraw = function() {
        inRedraw = true;
        init();
        inRedraw = false;
    };
    api.destroy = removeListeners;
    // -----------------------------------
    // Private methods
    function init() {
        // Find all sliders on the page
        $sliders = $doc.find(namespace);
        if (!$sliders.length) {
            return;
        }
        $sliders.each(build);
        if (fallback) {
            return;
        }
        removeListeners();
        addListeners();
    }
    function removeListeners() {
        Webflow.resize.off(renderAll);
        Webflow.redraw.off(api.redraw);
    }
    function addListeners() {
        Webflow.resize.on(renderAll);
        Webflow.redraw.on(api.redraw);
    }
    function renderAll() {
        $sliders.filter(':visible').each(render);
    }
    function build(i, el) {
        var $el = $(el);
        // Store slider state in data
        var data = $.data(el, namespace);
        if (!data) {
            data = $.data(el, namespace, {
                index: 0,
                depth: 1,
                hasFocus: {
                    keyboard: false,
                    mouse: false
                },
                el: $el,
                config: {}
            });
        }
        data.mask = $el.children('.w-slider-mask');
        data.left = $el.children('.w-slider-arrow-left');
        data.right = $el.children('.w-slider-arrow-right');
        data.nav = $el.children('.w-slider-nav');
        data.slides = data.mask.children('.w-slide');
        data.slides.each(ix.reset);
        if (inRedraw) {
            data.maskWidth = 0;
        }
        if ($el.attr('role') === undefined) {
            $el.attr('role', 'region');
        }
        if ($el.attr('aria-label') === undefined) {
            $el.attr('aria-label', 'carousel');
        }
        // Store the ID of the slider slide view mask
        var slideViewId = data.mask.attr('id');
        // If user did not provide an ID, set it
        if (!slideViewId) {
            slideViewId = 'w-slider-mask-' + i;
            data.mask.attr('id', slideViewId);
        }
        // Create aria live label
        if (!designer && !data.ariaLiveLabel) {
            data.ariaLiveLabel = $(ariaLiveLabelHtml).appendTo(data.mask);
        }
        // Add attributes to left/right buttons
        data.left.attr('role', 'button');
        data.left.attr('tabindex', '0');
        data.left.attr('aria-controls', slideViewId);
        if (data.left.attr('aria-label') === undefined) {
            data.left.attr('aria-label', 'previous slide');
        }
        data.right.attr('role', 'button');
        data.right.attr('tabindex', '0');
        data.right.attr('aria-controls', slideViewId);
        if (data.right.attr('aria-label') === undefined) {
            data.right.attr('aria-label', 'next slide');
        }
        // Disable in old browsers
        if (!tram.support.transform) {
            data.left.hide();
            data.right.hide();
            data.nav.hide();
            fallback = true;
            return;
        }
        // Remove old events
        data.el.off(namespace);
        data.left.off(namespace);
        data.right.off(namespace);
        data.nav.off(namespace);
        // Set config from data attributes
        configure(data);
        // Add events based on mode
        if (designer) {
            data.el.on('setting' + namespace, handler(data));
            stopTimer(data);
            data.hasTimer = false;
        } else {
            data.el.on('swipe' + namespace, handler(data));
            data.left.on('click' + namespace, previousFunction(data));
            data.right.on('click' + namespace, next(data));
            data.left.on('keydown' + namespace, keyboardSlideButtonsFunction(data, previousFunction));
            data.right.on('keydown' + namespace, keyboardSlideButtonsFunction(data, next));
            // Listen to nav keyboard events
            data.nav.on('keydown' + namespace, '> div', handler(data));
            // Start timer if autoplay is true, only once
            if (data.config.autoplay && !data.hasTimer) {
                data.hasTimer = true;
                data.timerCount = 1;
                startTimer(data);
            }
            data.el.on('mouseenter' + namespace, hasFocus(data, true, 'mouse'));
            data.el.on('focusin' + namespace, hasFocus(data, true, 'keyboard'));
            data.el.on('mouseleave' + namespace, hasFocus(data, false, 'mouse'));
            data.el.on('focusout' + namespace, hasFocus(data, false, 'keyboard'));
        }
        // Listen to nav click events
        data.nav.on('click' + namespace, '> div', handler(data));
        // Remove gaps from formatted html (for inline-blocks)
        if (!inApp) {
            data.mask.contents().filter(function() {
                return this.nodeType === 3;
            }).remove();
        }
        // If slider or any parent is hidden, temporarily show for measurements (https://github.com/webflow/webflow/issues/24921)
        var $elHidden = $el.filter(':hidden');
        $elHidden.addClass(forceShow);
        var $elHiddenParents = $el.parents(':hidden');
        $elHiddenParents.addClass(forceShow);
        // Run first render
        if (!inRedraw) {
            render(i, el);
        }
        // If slider or any parent is hidden, reset after temporarily showing for measurements
        $elHidden.removeClass(forceShow);
        $elHiddenParents.removeClass(forceShow);
    }
    function configure(data) {
        var config = {};
        config.crossOver = 0;
        // Set config options from data attributes
        config.animation = data.el.attr('data-animation') || 'slide';
        if (config.animation === 'outin') {
            config.animation = 'cross';
            config.crossOver = 0.5;
        }
        config.easing = data.el.attr('data-easing') || 'ease';
        var duration = data.el.attr('data-duration');
        config.duration = duration != null ? parseInt(duration, 10) : 500;
        if (isAttrTrue(data.el.attr('data-infinite'))) {
            config.infinite = true;
        }
        if (isAttrTrue(data.el.attr('data-disable-swipe'))) {
            config.disableSwipe = true;
        }
        if (isAttrTrue(data.el.attr('data-hide-arrows'))) {
            config.hideArrows = true;
        } else if (data.config.hideArrows) {
            data.left.show();
            data.right.show();
        }
        if (isAttrTrue(data.el.attr('data-autoplay'))) {
            config.autoplay = true;
            config.delay = parseInt(data.el.attr('data-delay'), 10) || 2000;
            config.timerMax = parseInt(data.el.attr('data-autoplay-limit'), 10);
            // Disable timer on first touch or mouse down
            var touchEvents = 'mousedown' + namespace + ' touchstart' + namespace;
            if (!designer) {
                data.el.off(touchEvents).one(touchEvents, function() {
                    stopTimer(data);
                });
            }
        }
        // Use edge buffer to help calculate page count
        var arrowWidth = data.right.width();
        config.edge = arrowWidth ? arrowWidth + 40 : 100;
        // Store config in data
        data.config = config;
    }
    function isAttrTrue(value) {
        return value === '1' || value === 'true';
    }
    function hasFocus(data, focusIn, eventType) {
        return function(evt) {
            if (!focusIn) {
                // Prevent Focus Out if moving to another element in the slider
                if ($.contains(data.el.get(0), evt.relatedTarget)) {
                    return;
                }
                data.hasFocus[eventType] = focusIn;
                // Prevent Aria live change if focused by other input
                if (data.hasFocus.mouse && eventType === 'keyboard' || data.hasFocus.keyboard && eventType === 'mouse') {
                    return;
                }
            } else {
                data.hasFocus[eventType] = focusIn;
            }
            if (focusIn) {
                data.ariaLiveLabel.attr('aria-live', 'polite');
                if (data.hasTimer) {
                    stopTimer(data);
                }
            } else {
                data.ariaLiveLabel.attr('aria-live', 'off');
                if (data.hasTimer) {
                    startTimer(data);
                }
            }
            return;
        };
    }
    function keyboardSlideButtonsFunction(data, directionFunction) {
        return function(evt) {
            switch(evt.keyCode){
                case KEY_CODES.SPACE:
                case KEY_CODES.ENTER:
                    {
                        // DirectionFunction returns a function
                        directionFunction(data)();
                        evt.preventDefault();
                        return evt.stopPropagation();
                    }
            }
        };
    }
    function previousFunction(data) {
        return function() {
            change(data, {
                index: data.index - 1,
                vector: -1
            });
        };
    }
    function next(data) {
        return function() {
            change(data, {
                index: data.index + 1,
                vector: 1
            });
        };
    }
    function select(data, value) {
        // Select page based on slide element index
        var found = null;
        if (value === data.slides.length) {
            init();
            layout(data); // Rebuild and find new slides
        }
        _.each(data.anchors, function(anchor, index) {
            $(anchor.els).each(function(i, el) {
                if ($(el).index() === value) {
                    found = index;
                }
            });
        });
        if (found != null) {
            change(data, {
                index: found,
                immediate: true
            });
        }
    }
    function startTimer(data) {
        stopTimer(data);
        var config = data.config;
        var timerMax = config.timerMax;
        if (timerMax && data.timerCount++ > timerMax) {
            return;
        }
        data.timerId = window.setTimeout(function() {
            if (data.timerId == null || designer) {
                return;
            }
            next(data)();
            startTimer(data);
        }, config.delay);
    }
    function stopTimer(data) {
        window.clearTimeout(data.timerId);
        data.timerId = null;
    }
    function handler(data) {
        return function(evt, options) {
            options = options || {};
            var config = data.config;
            // Designer settings
            if (designer && evt.type === 'setting') {
                if (options.select === 'prev') {
                    return previousFunction(data)();
                }
                if (options.select === 'next') {
                    return next(data)();
                }
                configure(data);
                layout(data);
                if (options.select == null) {
                    return;
                }
                select(data, options.select);
                return;
            }
            // Swipe event
            if (evt.type === 'swipe') {
                if (config.disableSwipe) {
                    return;
                }
                if (Webflow.env('editor')) {
                    return;
                }
                if (options.direction === 'left') {
                    return next(data)();
                }
                if (options.direction === 'right') {
                    return previousFunction(data)();
                }
                return;
            }
            // Page buttons
            if (data.nav.has(evt.target).length) {
                var index = $(evt.target).index();
                if (evt.type === 'click') {
                    change(data, {
                        index
                    });
                }
                if (evt.type === 'keydown') {
                    switch(evt.keyCode){
                        case KEY_CODES.ENTER:
                        case KEY_CODES.SPACE:
                            {
                                change(data, {
                                    index
                                });
                                evt.preventDefault();
                                break;
                            }
                        case KEY_CODES.ARROW_LEFT:
                        case KEY_CODES.ARROW_UP:
                            {
                                focusDot(data.nav, Math.max(index - 1, 0));
                                evt.preventDefault();
                                break;
                            }
                        case KEY_CODES.ARROW_RIGHT:
                        case KEY_CODES.ARROW_DOWN:
                            {
                                focusDot(data.nav, Math.min(index + 1, data.pages));
                                evt.preventDefault();
                                break;
                            }
                        case KEY_CODES.HOME:
                            {
                                focusDot(data.nav, 0);
                                evt.preventDefault();
                                break;
                            }
                        case KEY_CODES.END:
                            {
                                focusDot(data.nav, data.pages);
                                evt.preventDefault();
                                break;
                            }
                        default:
                            {
                                return;
                            }
                    }
                }
            }
        };
    }
    function focusDot($nav, index) {
        // Focus nav dot; don't change class to active
        var $active = $nav.children().eq(index).focus();
        $nav.children().not($active);
    }
    function change(data, options) {
        options = options || {};
        var config = data.config;
        var anchors = data.anchors;
        // Set new index
        data.previous = data.index;
        var index = options.index;
        var shift = {};
        if (index < 0) {
            index = anchors.length - 1;
            if (config.infinite) {
                // Shift first slide to the end
                shift.x = -data.endX;
                shift.from = 0;
                shift.to = anchors[0].width;
            }
        } else if (index >= anchors.length) {
            index = 0;
            if (config.infinite) {
                // Shift last slide to the start
                shift.x = anchors[anchors.length - 1].width;
                shift.from = -anchors[anchors.length - 1].x;
                shift.to = shift.from - shift.x;
            }
        }
        data.index = index;
        // Select nav dot; set class active
        var $active = data.nav.children().eq(index).addClass('w-active').attr('aria-pressed', 'true').attr('tabindex', '0');
        data.nav.children().not($active).removeClass('w-active').attr('aria-pressed', 'false').attr('tabindex', '-1');
        // Hide arrows
        if (config.hideArrows) {
            data.index === anchors.length - 1 ? data.right.hide() : data.right.show();
            data.index === 0 ? data.left.hide() : data.left.show();
        }
        // Get page offset from anchors
        var lastOffsetX = data.offsetX || 0;
        var offsetX = data.offsetX = -anchors[data.index].x;
        var resetConfig = {
            x: offsetX,
            opacity: 1,
            visibility: ''
        };
        // Transition slides
        var targets = $(anchors[data.index].els);
        var prevTargs = $(anchors[data.previous] && anchors[data.previous].els);
        var others = data.slides.not(targets);
        var animation = config.animation;
        var easing = config.easing;
        var duration = Math.round(config.duration);
        var vector = options.vector || (data.index > data.previous ? 1 : -1);
        var fadeRule = 'opacity ' + duration + 'ms ' + easing;
        var slideRule = 'transform ' + duration + 'ms ' + easing;
        // Make active slides' content focusable
        targets.find(FOCUSABLE_SELECTOR).removeAttr('tabindex');
        targets.removeAttr('aria-hidden');
        // Voiceover bug: Sometimes descendants are still visible, so hide everything...
        targets.find('*').removeAttr('aria-hidden');
        // Prevent focus on inactive slides' content
        others.find(FOCUSABLE_SELECTOR).attr('tabindex', '-1');
        others.attr('aria-hidden', 'true');
        // Voiceover bug: Sometimes descendants are still visible, so hide everything...
        others.find('*').attr('aria-hidden', 'true');
        // Trigger IX events
        if (!designer) {
            targets.each(ix.intro);
            others.each(ix.outro);
        }
        // Set immediately after layout changes (but not during redraw)
        if (options.immediate && !inRedraw) {
            tram(targets).set(resetConfig);
            resetOthers();
            return;
        }
        // Exit early if index is unchanged
        if (data.index === data.previous) {
            return;
        }
        // Announce slide change to screen reader
        if (!designer) {
            data.ariaLiveLabel.text(`Slide ${index + 1} of ${anchors.length}.`);
        }
        // Cross Fade / Out-In
        if (animation === 'cross') {
            var reduced = Math.round(duration - duration * config.crossOver);
            var wait = Math.round(duration - reduced);
            fadeRule = 'opacity ' + reduced + 'ms ' + easing;
            tram(prevTargs).set({
                visibility: ''
            }).add(fadeRule).start({
                opacity: 0
            });
            tram(targets).set({
                visibility: '',
                x: offsetX,
                opacity: 0,
                zIndex: data.depth++
            }).add(fadeRule).wait(wait).then({
                opacity: 1
            }).then(resetOthers);
            return;
        }
        // Fade Over
        if (animation === 'fade') {
            tram(prevTargs).set({
                visibility: ''
            }).stop();
            tram(targets).set({
                visibility: '',
                x: offsetX,
                opacity: 0,
                zIndex: data.depth++
            }).add(fadeRule).start({
                opacity: 1
            }).then(resetOthers);
            return;
        }
        // Slide Over
        if (animation === 'over') {
            resetConfig = {
                x: data.endX
            };
            tram(prevTargs).set({
                visibility: ''
            }).stop();
            tram(targets).set({
                visibility: '',
                zIndex: data.depth++,
                x: offsetX + anchors[data.index].width * vector
            }).add(slideRule).start({
                x: offsetX
            }).then(resetOthers);
            return;
        }
        // Slide - infinite scroll
        if (config.infinite && shift.x) {
            tram(data.slides.not(prevTargs)).set({
                visibility: '',
                x: shift.x
            }).add(slideRule).start({
                x: offsetX
            });
            tram(prevTargs).set({
                visibility: '',
                x: shift.from
            }).add(slideRule).start({
                x: shift.to
            });
            data.shifted = prevTargs;
        } else {
            if (config.infinite && data.shifted) {
                tram(data.shifted).set({
                    visibility: '',
                    x: lastOffsetX
                });
                data.shifted = null;
            }
            // Slide - basic scroll
            tram(data.slides).set({
                visibility: ''
            }).add(slideRule).start({
                x: offsetX
            });
        }
        // Helper to move others out of view
        function resetOthers() {
            targets = $(anchors[data.index].els);
            others = data.slides.not(targets);
            if (animation !== 'slide') {
                resetConfig.visibility = 'hidden';
            }
            tram(others).set(resetConfig);
        }
    }
    function render(i, el) {
        var data = $.data(el, namespace);
        if (!data) {
            return;
        }
        if (maskChanged(data)) {
            return layout(data);
        }
        if (designer && slidesChanged(data)) {
            layout(data);
        }
    }
    function layout(data) {
        // Determine page count from width of slides
        var pages = 1;
        var offset = 0;
        var anchor = 0;
        var width = 0;
        var maskWidth = data.maskWidth;
        var threshold = maskWidth - data.config.edge;
        if (threshold < 0) {
            threshold = 0;
        }
        data.anchors = [
            {
                els: [],
                x: 0,
                width: 0
            }
        ];
        data.slides.each(function(i, el) {
            if (anchor - offset > threshold) {
                pages++;
                offset += maskWidth;
                // Store page anchor for transition
                data.anchors[pages - 1] = {
                    els: [],
                    x: anchor,
                    width: 0
                };
            }
            // Set next anchor using current width + margin
            width = $(el).outerWidth(true);
            anchor += width;
            data.anchors[pages - 1].width += width;
            data.anchors[pages - 1].els.push(el);
            var ariaLabel = i + 1 + ' of ' + data.slides.length;
            $(el).attr('aria-label', ariaLabel);
            $(el).attr('role', 'group');
        });
        data.endX = anchor;
        // Build dots if nav exists and needs updating
        if (designer) {
            data.pages = null;
        }
        if (data.nav.length && data.pages !== pages) {
            data.pages = pages;
            buildNav(data);
        }
        // Make sure index is still within range and call change handler
        var index = data.index;
        if (index >= pages) {
            index = pages - 1;
        }
        change(data, {
            immediate: true,
            index
        });
    }
    function buildNav(data) {
        var dots = [];
        var $dot;
        var spacing = data.el.attr('data-nav-spacing');
        if (spacing) {
            spacing = parseFloat(spacing) + 'px';
        }
        for(var i = 0, len = data.pages; i < len; i++){
            $dot = $(dot);
            $dot.attr('aria-label', 'Show slide ' + (i + 1) + ' of ' + len).attr('aria-pressed', 'false').attr('role', 'button').attr('tabindex', '-1');
            if (data.nav.hasClass('w-num')) {
                $dot.text(i + 1);
            }
            if (spacing != null) {
                $dot.css({
                    'margin-left': spacing,
                    'margin-right': spacing
                });
            }
            dots.push($dot);
        }
        data.nav.empty().append(dots);
    }
    function maskChanged(data) {
        var maskWidth = data.mask.width();
        if (data.maskWidth !== maskWidth) {
            data.maskWidth = maskWidth;
            return true;
        }
        return false;
    }
    function slidesChanged(data) {
        var slidesWidth = 0;
        data.slides.each(function(i, el) {
            slidesWidth += $(el).outerWidth(true);
        });
        if (data.slidesWidth !== slidesWidth) {
            data.slidesWidth = slidesWidth;
            return true;
        }
        return false;
    }
    // Export module
    return api;
});

//# sourceMappingURL=data:application/json;base64,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

}),
32949: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
_export_star(__webpack_require__(31350), exports);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gJy4vdXRpbHMvQ29tbWVyY2UnO1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWMifQ==

}),
31350: (function (__unused_webpack_module, exports) {
"use strict";
// keep this file as simple as possible and avoid any additional imports, as this can increase published site bundle size a location

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getProductOptionValueName: function() {
        return getProductOptionValueName;
    },
    simplifySkuValues: function() {
        return simplifySkuValues;
    }
});
const simplifySkuValues = (skuValues)=>skuValues.reduce((acc, pair)=>{
        acc[pair.property.id] = pair.value.id;
        return acc;
    }, {});
const getProductOptionValueName = (property, simplifiedSkuValues)=>{
    if (property.id && property.enum) {
        const propValueId = simplifiedSkuValues[property.id];
        const propValue = property.enum.find((value)=>value.id === propValueId);
        if (propValue && typeof propValue.name === 'string') {
            return propValue.name;
        }
    }
    return '';
};

//# sourceMappingURL=data:application/json;base64,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

}),
34206: (function (__unused_webpack_module, exports) {
"use strict";
// Ecommerce data source definition uses this as the externalKey of the Products
// binding context type, while CommerceAddToCartWrapper uses this in its
// BindingContext Atom constraint.

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ORDER_ITEMS_BINDING_CONTEXT_EXTERNAL_KEY: function() {
        return ORDER_ITEMS_BINDING_CONTEXT_EXTERNAL_KEY;
    },
    PRODUCTS_BINDING_CONTEXT_EXTERNAL_KEY: function() {
        return PRODUCTS_BINDING_CONTEXT_EXTERNAL_KEY;
    }
});
const PRODUCTS_BINDING_CONTEXT_EXTERNAL_KEY = 'commerce-products-type';
const ORDER_ITEMS_BINDING_CONTEXT_EXTERNAL_KEY = 'commerce-order-items-type';

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImJpbmRpbmdDb250ZXh0Q29uc3RhbnRzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbIi8vIEVjb21tZXJjZSBkYXRhIHNvdXJjZSBkZWZpbml0aW9uIHVzZXMgdGhpcyBhcyB0aGUgZXh0ZXJuYWxLZXkgb2YgdGhlIFByb2R1Y3RzXG4vLyBiaW5kaW5nIGNvbnRleHQgdHlwZSwgd2hpbGUgQ29tbWVyY2VBZGRUb0NhcnRXcmFwcGVyIHVzZXMgdGhpcyBpbiBpdHNcbi8vIEJpbmRpbmdDb250ZXh0IEF0b20gY29uc3RyYWludC5cbmV4cG9ydCBjb25zdCBQUk9EVUNUU19CSU5ESU5HX0NPTlRFWFRfRVhURVJOQUxfS0VZID0gJ2NvbW1lcmNlLXByb2R1Y3RzLXR5cGUnO1xuXG4vLyBFY29tbWVyY2UgZGF0YSBzb3VyY2UgZGVmaW5pdGlvbiB1c2VzIHRoaXMgYXMgdGhlIGV4dGVybmFsS2V5IG9mIHRoZSBPcmRlciBJdGVtc1xuLy8gYmluZGluZyBjb250ZXh0IHR5cGUuXG5leHBvcnQgY29uc3QgT1JERVJfSVRFTVNfQklORElOR19DT05URVhUX0VYVEVSTkFMX0tFWSA9XG4gICdjb21tZXJjZS1vcmRlci1pdGVtcy10eXBlJztcbiJdLCJuYW1lcyI6WyJPUkRFUl9JVEVNU19CSU5ESU5HX0NPTlRFWFRfRVhURVJOQUxfS0VZIiwiUFJPRFVDVFNfQklORElOR19DT05URVhUX0VYVEVSTkFMX0tFWSJdLCJtYXBwaW5ncyI6IkFBQUEsZ0ZBQWdGO0FBQ2hGLHdFQUF3RTtBQUN4RSxrQ0FBa0M7Ozs7Ozs7Ozs7OztJQUtyQkEsd0NBQXdDO2VBQXhDQTs7SUFKQUMscUNBQXFDO2VBQXJDQTs7O0FBQU4sTUFBTUEsd0NBQXdDO0FBSTlDLE1BQU1ELDJDQUNYIn0=

}),
10873: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ACTIVE_STRIPE_SUBSCRIPTION_STATUSES: function() {
        return ACTIVE_STRIPE_SUBSCRIPTION_STATUSES;
    },
    ADVANCED_PRODUCT_TYPE: function() {
        return ADVANCED_PRODUCT_TYPE;
    },
    BILLING_METHOD_TYPES: function() {
        return BILLING_METHOD_TYPES;
    },
    CSV_CURRENCY_TEMPLATE: function() {
        return CSV_CURRENCY_TEMPLATE;
    },
    CSV_INTEGRATION_CURRENCY_TEMPLATE: function() {
        return CSV_INTEGRATION_CURRENCY_TEMPLATE;
    },
    DEFAULT_PRICE_TEMPLATE_VALUE: function() {
        return DEFAULT_PRICE_TEMPLATE_VALUE;
    },
    DEFAULT_PRODUCT_TYPE_ID: function() {
        return DEFAULT_PRODUCT_TYPE_ID;
    },
    DEFAULT_TAX_CATEGORY: function() {
        return DEFAULT_TAX_CATEGORY;
    },
    DIGITAL_PRODUCT_TYPE: function() {
        return DIGITAL_PRODUCT_TYPE;
    },
    DISCOUNTS_CSV_IMPORT_EXPORT_COLUMNS: function() {
        return DISCOUNTS_CSV_IMPORT_EXPORT_COLUMNS;
    },
    DISCOUNT_CODE_MAX_LENGTH: function() {
        return DISCOUNT_CODE_MAX_LENGTH;
    },
    DOWNLOAD_FILES_EDITABLE_FIELDS: function() {
        return DOWNLOAD_FILES_EDITABLE_FIELDS;
    },
    DOWNLOAD_FILES_FAKE_DATA: function() {
        return DOWNLOAD_FILES_FAKE_DATA;
    },
    DOWNLOAD_FILES_KEY_PATH: function() {
        return DOWNLOAD_FILES_KEY_PATH;
    },
    ECOMMERCE_PROVIDER_NAME_ENUM: function() {
        return ECOMMERCE_PROVIDER_NAME_ENUM;
    },
    INFINITE_INVENTORY: function() {
        return INFINITE_INVENTORY;
    },
    INVENTORY_TYPE_FINITE: function() {
        return INVENTORY_TYPE_FINITE;
    },
    INVENTORY_TYPE_INFINITE: function() {
        return INVENTORY_TYPE_INFINITE;
    },
    MAX_MEMBERSHIP_PRODUCTS: function() {
        return MAX_MEMBERSHIP_PRODUCTS;
    },
    MAX_PRODUCT_DIMENSION: function() {
        return MAX_PRODUCT_DIMENSION;
    },
    MAX_SEARCH_LIMIT: function() {
        return MAX_SEARCH_LIMIT;
    },
    MAX_TOTAL_ORDER_PRICE: function() {
        return MAX_TOTAL_ORDER_PRICE;
    },
    MEMBERSHIP_PRODUCT_TYPE: function() {
        return MEMBERSHIP_PRODUCT_TYPE;
    },
    ORDER_ID_RE: function() {
        return ORDER_ID_RE;
    },
    ORDER_ITEMS_BINDING_CONTEXT_EXTERNAL_KEY: function() {
        return _bindingContextConstants.ORDER_ITEMS_BINDING_CONTEXT_EXTERNAL_KEY;
    },
    ORDER_SORT_MODES: function() {
        return ORDER_SORT_MODES;
    },
    PHYSICAL_PRODUCT_TYPE: function() {
        return PHYSICAL_PRODUCT_TYPE;
    },
    PRICE_TEMPLATE_AMOUNT: function() {
        return PRICE_TEMPLATE_AMOUNT;
    },
    PRICE_TEMPLATE_CURRENCY_CODE: function() {
        return PRICE_TEMPLATE_CURRENCY_CODE;
    },
    PRICE_TEMPLATE_CURRENCY_SYMBOL: function() {
        return PRICE_TEMPLATE_CURRENCY_SYMBOL;
    },
    PRICE_TEMPLATE_OPTIONS: function() {
        return PRICE_TEMPLATE_OPTIONS;
    },
    PRODUCTS_BINDING_CONTEXT_EXTERNAL_KEY: function() {
        return _bindingContextConstants.PRODUCTS_BINDING_CONTEXT_EXTERNAL_KEY;
    },
    PRODUCT_TYPE_HELP_TEXT: function() {
        return PRODUCT_TYPE_HELP_TEXT;
    },
    PRODUCT_TYPE_ID: function() {
        return PRODUCT_TYPE_ID;
    },
    REQUIRED_DISCOUNT_IMPORT_FIELDS: function() {
        return REQUIRED_DISCOUNT_IMPORT_FIELDS;
    },
    SERVICE_PRODUCT_TYPE: function() {
        return SERVICE_PRODUCT_TYPE;
    },
    SHIPPING_METHODS: function() {
        return SHIPPING_METHODS;
    },
    STRIPE_DISCONNECT_SUBSCRIPTIONS_ERROR_MESSAGE: function() {
        return STRIPE_DISCONNECT_SUBSCRIPTIONS_ERROR_MESSAGE;
    },
    STRIPE_SUBSCRIPTION_STATUS_ENUM: function() {
        return STRIPE_SUBSCRIPTION_STATUS_ENUM;
    },
    SUBSCRIPTION_INTERVAL_ENUM: function() {
        return SUBSCRIPTION_INTERVAL_ENUM;
    },
    SUBSCRIPTION_SORT_MODES: function() {
        return SUBSCRIPTION_SORT_MODES;
    },
    SUBSCRIPTION_STATUS_ENUM: function() {
        return SUBSCRIPTION_STATUS_ENUM;
    },
    SUBSCRIPTION_STATUS_PRETTY_ENUM: function() {
        return SUBSCRIPTION_STATUS_PRETTY_ENUM;
    },
    TEMPLATE_PRODUCT_TYPES: function() {
        return TEMPLATE_PRODUCT_TYPES;
    },
    TEMPLATE_PRODUCT_TYPES_BY_ID: function() {
        return TEMPLATE_PRODUCT_TYPES_BY_ID;
    },
    paypalCurrencyList: function() {
        return _paypalCurrencyList.paypalCurrencyList;
    },
    stripeCurrencyList: function() {
        return _stripeCurrencyList.stripeCurrencyList;
    }
});
const _camelCase = /*#__PURE__*/ _interop_require_default(__webpack_require__(56034));
_export_star(__webpack_require__(41158), exports);
const _bindingContextConstants = __webpack_require__(34206);
const _paypalCurrencyList = __webpack_require__(25766);
const _stripeCurrencyList = __webpack_require__(37693);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const ORDER_ID_RE = /^[0-9a-f]{5,}$/;
const SHIPPING_METHOD_FLAT = 'flat-rate';
const SHIPPING_METHOD_PERCENTAGE = 'percentage';
const SHIPPING_METHOD_PRICE = 'price';
const SHIPPING_METHOD_QUANTITY = 'quantity';
const SHIPPING_METHOD_WEIGHT = 'weight';
const SHIPPING_METHODS = Object.freeze({
    FLAT: SHIPPING_METHOD_FLAT,
    PERCENTAGE: SHIPPING_METHOD_PERCENTAGE,
    PRICE: SHIPPING_METHOD_PRICE,
    QUANTITY: SHIPPING_METHOD_QUANTITY,
    WEIGHT: SHIPPING_METHOD_WEIGHT
});
const DEFAULT_TAX_CATEGORY = 'standard-taxable';
const INVENTORY_TYPE_FINITE = 'finite';
const INVENTORY_TYPE_INFINITE = 'infinite';
const INFINITE_INVENTORY = {
    inventoryType: INVENTORY_TYPE_INFINITE,
    quantity: 0
};
const MAX_TOTAL_ORDER_PRICE = 99999999;
const MAX_PRODUCT_DIMENSION = 9000000000000000;
const MAX_MEMBERSHIP_PRODUCTS = 20;
const MAX_SEARCH_LIMIT = 100;
function _withDerivedValue({ label, type = 'PlainText', path = (0, _camelCase.default)(label), options = {
    readOnly: false,
    isNotAddable: false
} }) {
    return {
        label,
        type,
        ...options,
        value: JSON.stringify({
            path,
            type
        })
    };
}
const PRICE_TEMPLATE_CURRENCY_SYMBOL = _withDerivedValue({
    label: 'Currency symbol',
    path: 'symbol'
});
const PRICE_TEMPLATE_AMOUNT = _withDerivedValue({
    label: 'Amount',
    type: 'CommercePrice',
    options: {
        readOnly: true,
        isNotAddable: true
    }
});
const PRICE_TEMPLATE_CURRENCY_CODE = _withDerivedValue({
    label: 'Currency code'
});
const PRICE_TEMPLATE_OPTIONS = [
    PRICE_TEMPLATE_CURRENCY_SYMBOL,
    PRICE_TEMPLATE_AMOUNT,
    PRICE_TEMPLATE_CURRENCY_CODE
];
const _intoToken = (option)=>`{{wf ${option.value} }}`;
const DEFAULT_PRICE_TEMPLATE_VALUE = [
    _intoToken(PRICE_TEMPLATE_CURRENCY_SYMBOL),
    ' ',
    _intoToken(PRICE_TEMPLATE_AMOUNT),
    ' ',
    _intoToken(PRICE_TEMPLATE_CURRENCY_CODE)
].join('');
const CSV_CURRENCY_TEMPLATE = [
    _intoToken(PRICE_TEMPLATE_CURRENCY_SYMBOL),
    _intoToken(PRICE_TEMPLATE_AMOUNT)
].join('');
const CSV_INTEGRATION_CURRENCY_TEMPLATE = [
    _intoToken(PRICE_TEMPLATE_AMOUNT),
    ' ',
    _intoToken(PRICE_TEMPLATE_CURRENCY_CODE)
].join('');
const DOWNLOAD_FILES_FAKE_DATA = [
    {
        id: '5d8fcb6d94dd1853060fb3b3',
        name: 'The modern web design process - Webflow Ebook.pdf',
        url: 'https://assets-global.website-files.com/5cf6b7202bf8199f50d43e6c/5e9dd8a680b972888929747b_The%20modern%20web%20design%20process%20-%20Webflow%20Ebook.pdf'
    },
    {
        id: '5d8fcb6d94dd1853060fb3b4',
        name: 'The freelance web designers guide - Webflow Ebook.pdf',
        url: 'https://assets-global.website-files.com/5cf6b7202bf8199f50d43e6c/5e9dd8e6abe52b33243a22cf_The%20freelance%20web%20designer%E2%80%99s%20guide%20-%20Webflow%20Ebook.pdf'
    }
];
const DOWNLOAD_FILES_KEY_PATH = 'download-files';
const DOWNLOAD_FILES_EDITABLE_FIELDS = {
    name: true,
    url: true
};
const SUBSCRIPTION_INTERVAL_ENUM = [
    'day',
    'week',
    'month',
    'year'
];
const SUBSCRIPTION_STATUS_ENUM = {
    active: 'active',
    pastdue: 'pastdue',
    unpaid: 'unpaid',
    canceled: 'canceled',
    cancelPending: 'cancelPending',
    incomplete: 'incomplete',
    incompleteExpired: 'incompleteExpired',
    trialing: 'trialing',
    unknown: `unknown`
};
const SUBSCRIPTION_STATUS_PRETTY_ENUM = {
    active: 'active',
    pastdue: 'pastdue',
    unpaid: 'unpaid',
    canceled: 'canceled',
    cancelPending: 'cancelPending',
    incomplete: 'incomplete',
    incompleteExpired: 'incompleteExpired',
    trialing: 'in trial',
    unknown: `unknown`
};
const STRIPE_SUBSCRIPTION_STATUS_ENUM = {
    active: 'active',
    past_due: 'past_due',
    unpaid: 'unpaid',
    canceled: 'canceled',
    incomplete: 'incomplete',
    incomplete_expired: 'incomplete_expired',
    trialing: 'trialing'
};
const ACTIVE_STRIPE_SUBSCRIPTION_STATUSES = [
    STRIPE_SUBSCRIPTION_STATUS_ENUM.active,
    STRIPE_SUBSCRIPTION_STATUS_ENUM.past_due,
    STRIPE_SUBSCRIPTION_STATUS_ENUM.trialing
];
const ECOMMERCE_PROVIDER_NAME_ENUM = {
    stripe: 'stripe'
};
const BILLING_METHOD_TYPES = {
    subscription: 'subscription',
    oneTime: 'one-time'
};
const PRODUCT_TYPE_ID = {
    PHYSICAL: 'ff42fee0113744f693a764e3431a9cc2',
    DIGITAL: 'f22027db68002190aef89a4a2b7ac8a1',
    SERVICE: 'c599e43b1a1c34d5a323aedf75d3adf6',
    MEMBERSHIP: 'e348fd487d0102946c9179d2a94bb613',
    ADVANCED: 'b6ccc1830db4b1babeb06a9ac5f6dd76'
};
const DEFAULT_PRODUCT_TYPE_PRODUCT_FIELDS = [
    {
        fieldSlug: 'name',
        required: true
    },
    {
        fieldSlug: 'slug',
        required: true
    },
    {
        fieldSlug: 'sku-properties',
        required: false
    },
    {
        fieldSlug: 'category',
        required: false
    },
    {
        fieldSlug: 'description',
        required: false
    },
    {
        fieldSlug: 'tax-category',
        required: false
    },
    {
        fieldSlug: 'default-sku',
        required: false
    },
    {
        fieldSlug: 'ec-product-type',
        required: false
    },
    {
        fieldSlug: 'options',
        required: false
    }
];
const DEFAULT_PRODUCT_TYPE_SKU_FIELDS = [
    {
        fieldSlug: 'sku-values',
        required: false
    },
    {
        fieldSlug: 'product',
        required: false
    },
    {
        fieldSlug: 'main-image',
        required: false
    },
    {
        fieldSlug: 'more-images',
        required: false
    },
    {
        fieldSlug: 'price',
        required: true
    },
    {
        fieldSlug: 'compare-at-price',
        required: false
    },
    {
        fieldSlug: 'ec-sku-subscription-plan',
        required: false
    },
    {
        fieldSlug: 'sku',
        required: false
    },
    {
        fieldSlug: 'ec-sku-billing-method',
        required: false
    },
    {
        fieldSlug: 'track-inventory',
        required: false
    },
    {
        fieldSlug: 'quantity',
        required: false
    }
];
const PHYSICAL_PRODUCT_TYPE = {
    name: 'Physical',
    id: PRODUCT_TYPE_ID.PHYSICAL,
    fields: {
        product: [
            ...DEFAULT_PRODUCT_TYPE_PRODUCT_FIELDS,
            {
                fieldSlug: 'shippable',
                required: false
            }
        ],
        sku: [
            ...DEFAULT_PRODUCT_TYPE_SKU_FIELDS,
            {
                fieldSlug: 'weight',
                required: false
            },
            {
                fieldSlug: 'width',
                required: false
            },
            {
                fieldSlug: 'height',
                required: false
            },
            {
                fieldSlug: 'length',
                required: false
            }
        ]
    }
};
const DIGITAL_PRODUCT_TYPE = {
    name: 'Digital',
    id: PRODUCT_TYPE_ID.DIGITAL,
    fields: {
        product: [
            ...DEFAULT_PRODUCT_TYPE_PRODUCT_FIELDS
        ],
        sku: [
            ...DEFAULT_PRODUCT_TYPE_SKU_FIELDS,
            {
                fieldSlug: 'download-files',
                required: true
            }
        ]
    }
};
const SERVICE_PRODUCT_TYPE = {
    name: 'Service',
    id: PRODUCT_TYPE_ID.SERVICE,
    fields: {
        product: [
            ...DEFAULT_PRODUCT_TYPE_PRODUCT_FIELDS
        ],
        sku: [
            ...DEFAULT_PRODUCT_TYPE_SKU_FIELDS
        ]
    }
};
const MEMBERSHIP_PRODUCT_TYPE = {
    name: 'Membership',
    id: PRODUCT_TYPE_ID.MEMBERSHIP,
    fields: {
        product: [
            ...DEFAULT_PRODUCT_TYPE_PRODUCT_FIELDS,
            {
                fieldSlug: 'shippable',
                required: false
            }
        ],
        sku: [
            ...DEFAULT_PRODUCT_TYPE_SKU_FIELDS,
            {
                fieldSlug: 'weight',
                required: false
            },
            {
                fieldSlug: 'width',
                required: false
            },
            {
                fieldSlug: 'height',
                required: false
            },
            {
                fieldSlug: 'length',
                required: false
            },
            {
                fieldSlug: 'download-files',
                required: false
            },
            {
                fieldSlug: 'include-downloads',
                required: false
            }
        ]
    }
};
const ADVANCED_PRODUCT_TYPE = {
    name: 'Advanced',
    id: PRODUCT_TYPE_ID.ADVANCED
};
const TEMPLATE_PRODUCT_TYPES = [
    PHYSICAL_PRODUCT_TYPE,
    DIGITAL_PRODUCT_TYPE,
    SERVICE_PRODUCT_TYPE,
    MEMBERSHIP_PRODUCT_TYPE,
    ADVANCED_PRODUCT_TYPE
];
const DEFAULT_PRODUCT_TYPE_ID = PRODUCT_TYPE_ID.PHYSICAL;
const TEMPLATE_PRODUCT_TYPES_BY_ID = Object.fromEntries(TEMPLATE_PRODUCT_TYPES.map((t)=>[
        t.id,
        t
    ]));
const PRODUCT_TYPE_HELP_TEXT = {
    [PHYSICAL_PRODUCT_TYPE.id]: 'Physical products are shipped to the customer (e.g., merchandise, apparel).',
    [DIGITAL_PRODUCT_TYPE.id]: 'Digital products are immediately downloadable by the customer after checkout (e.g., audio files, ebooks).',
    [SERVICE_PRODUCT_TYPE.id]: 'Service products do not require a shipping address during checkout (e.g., classes, consultations).',
    [MEMBERSHIP_PRODUCT_TYPE.id]: 'Membership products give users access to gated content through recurring or one-time payment (e.g., subscriptions, one-time membership fee). Membership products require a user login and can only be purchased once.',
    [ADVANCED_PRODUCT_TYPE.id]: 'Advanced products provide all available customizable options.'
};
const DISCOUNT_CODE_MAX_LENGTH = 255;
const DISCOUNTS_CSV_IMPORT_EXPORT_COLUMNS = [
    'name',
    'code',
    'notes',
    'type',
    'percentOff',
    'amountOff',
    'validOn',
    'expiresOn',
    'enabled',
    'orderMinimum',
    // archived is disabled until we have UI for it
    // 'archived',
    'totalUsage',
    'maxAmountOff',
    // NOTE: for dot-notation fields to be properly expanded
    // during import, you need to add the camel-case flattened property to
    // the 'KEYS_TO_EXPAND' variable in `entrypoints/server/lib/ecommerce/csvImport/discountCsvImport.js`
    // Example: 'usage.limit.total' -> 'usageLimitTotal'
    'usage.limit.total',
    'usage.limit.customer',
    'appliesTo.scope',
    'appliesTo.filter',
    'appliesTo.applyOnce'
];
const REQUIRED_DISCOUNT_IMPORT_FIELDS = [
    'name',
    'code',
    'type',
    [
        'percentOff',
        'amountOff'
    ]
];
const STRIPE_DISCONNECT_SUBSCRIPTIONS_ERROR_MESSAGE = 'Stripe disconnect attempted with non-canceled subscriptions';
const ORDER_SORT_MODES = Object.freeze({
    '-count': '-purchasedItemsCount -_id',
    count: 'purchasedItemsCount _id',
    '-name': '-customerInfo.fullName -_id',
    name: 'customerInfo.fullName _id',
    '-orderid': '-orderId',
    orderid: 'orderId',
    '-paid': '-customerPaid.unit -customerPaid.value -_id',
    paid: 'customerPaid.unit customerPaid.value _id',
    '-status': '-statusCode -_id',
    status: 'statusCode _id',
    '-time': '-acceptedOn -_id',
    time: 'acceptedOn _id'
});
const SUBSCRIPTION_SORT_MODES = Object.freeze({
    '-lastBilled': '-lastInvoiced -_id',
    lastBilled: 'lastInvoiced _id',
    '-nextBilling': '-paidUntil -_id',
    nextBilling: 'paidUntil _id',
    '-orderid': '-orderId',
    orderid: 'orderId',
    '-purchased': '-subCreatedOn -_id',
    purchased: 'subCreatedOn _id',
    '-status': '-status -_id',
    status: 'status _id',
    '-trialing': '-trialing -_id',
    trialing: 'trialing _id'
});

//# sourceMappingURL=data:application/json;base64,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

}),
25766: (function (__unused_webpack_module, exports) {
"use strict";
// Note: These currencies are extracted by getting PayPal compatible currencies from:
//
// curl https://developer.paypal.com/docs/api/reference/currency-codes
//
// And then populating in the names from ISO 4217:

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "paypalCurrencyList", ({
    enumerable: true,
    get: function() {
        return paypalCurrencyList;
    }
}));
const paypalCurrencyList = [
    /*
   * ----------------------------------------------------------------------------
   * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
   * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
   * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
   * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
   *
   * This const is duplicated to @packages/systems/core/constants/SharedConfig.js
   * to avoid bundling this entire SharedConfig file in the webflow.js published
   * site bundle. Once we have support for bundling for the Dashboard (this
   * config is injected in to window.SharedConfig for angular), we should
   * be able to delete the const in SharedConfig and use the commerce/consts
   * package whenever `paypalCurrencyList` const is needed.
   *
   * In the meantime, if you make changes to this const, please make sure to
   * update in the other location as well.
   *
   * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
   * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
   * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
   * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
   * ----------------------------------------------------------------------------
   */ {
        code: 'AUD',
        digits: 2,
        minCharge: 1,
        name: 'Australian Dollar'
    },
    {
        code: 'BRL',
        digits: 2,
        minCharge: 1,
        name: 'Brazilian Real'
    },
    {
        code: 'CAD',
        digits: 2,
        minCharge: 1,
        name: 'Canadian Dollar'
    },
    {
        code: 'CNY',
        digits: 2,
        minCharge: 1,
        name: 'Chinese Renmenbi'
    },
    {
        code: 'CZK',
        digits: 2,
        minCharge: 1,
        name: 'Czech Koruna'
    },
    {
        code: 'DKK',
        digits: 2,
        minCharge: 1,
        name: 'Danish Krone'
    },
    {
        code: 'EUR',
        digits: 2,
        minCharge: 1,
        name: 'Euro'
    },
    {
        code: 'HKD',
        digits: 2,
        minCharge: 1,
        name: 'Hong Kong Dollar'
    },
    // HUF is currently disabled, due to issues with PayPal's 0-decimal implementation
    // See: https://github.com/webflow/webflow/issues/32865
    // {code: 'HUF', digits: 0, minCharge: 1, name: 'Hungarian Forint'},
    {
        code: 'INR',
        digits: 2,
        minCharge: 1,
        name: 'Indian Rupee'
    },
    {
        code: 'ILS',
        digits: 2,
        minCharge: 1,
        name: 'Israeli New Sheqel'
    },
    {
        code: 'JPY',
        digits: 0,
        minCharge: 1,
        name: 'Japanese Yen'
    },
    {
        code: 'MYR',
        digits: 2,
        minCharge: 1,
        name: 'Malaysian Ringgit'
    },
    {
        code: 'MXN',
        digits: 2,
        minCharge: 1,
        name: 'Mexican Peso'
    },
    {
        code: 'TWD',
        digits: 0,
        minCharge: 1,
        name: 'New Taiwan Dollar'
    },
    {
        code: 'NZD',
        digits: 2,
        minCharge: 1,
        name: 'New Zealand Dollar'
    },
    {
        code: 'NOK',
        digits: 2,
        minCharge: 1,
        name: 'Norwegian Krone'
    },
    {
        code: 'PHP',
        digits: 2,
        minCharge: 1,
        name: 'Philippine Peso'
    },
    {
        code: 'PLN',
        digits: 2,
        minCharge: 1,
        name: 'Polish Złoty'
    },
    {
        code: 'GBP',
        digits: 2,
        minCharge: 1,
        name: 'British Pound'
    },
    {
        code: 'RUB',
        digits: 2,
        minCharge: 1,
        name: 'Russian Ruble'
    },
    {
        code: 'SGD',
        digits: 2,
        minCharge: 1,
        name: 'Singapore Dollar'
    },
    {
        code: 'SEK',
        digits: 2,
        minCharge: 1,
        name: 'Swedish Krona'
    },
    {
        code: 'CHF',
        digits: 2,
        minCharge: 1,
        name: 'Swiss Franc'
    },
    {
        code: 'THB',
        digits: 2,
        minCharge: 1,
        name: 'Thai Baht'
    },
    {
        code: 'USD',
        digits: 2,
        minCharge: 1,
        name: 'United States Dollar'
    }
];

//# sourceMappingURL=data:application/json;base64,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

}),
41158: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ADD_TO_CART_ERRORS: function() {
        return ADD_TO_CART_ERRORS;
    },
    ADD_TO_CART_ERROR_MESSAGE: function() {
        return ADD_TO_CART_ERROR_MESSAGE;
    },
    ADD_TO_CART_LOADING: function() {
        return ADD_TO_CART_LOADING;
    },
    ADD_TO_CART_STATES: function() {
        return ADD_TO_CART_STATES;
    },
    ALIGN_DEFAULT: function() {
        return ALIGN_DEFAULT;
    },
    ALIGN_KEY: function() {
        return ALIGN_KEY;
    },
    ANIMATION_DURATION_DEFAULT: function() {
        return ANIMATION_DURATION_DEFAULT;
    },
    ANIMATION_DURATION_KEY: function() {
        return ANIMATION_DURATION_KEY;
    },
    ANIMATION_DURATION_KEYPATH: function() {
        return ANIMATION_DURATION_KEYPATH;
    },
    ANIMATION_EASING_DEFAULT: function() {
        return ANIMATION_EASING_DEFAULT;
    },
    ANIMATION_EASING_KEY: function() {
        return ANIMATION_EASING_KEY;
    },
    ANIMATION_EASING_KEYPATH: function() {
        return ANIMATION_EASING_KEYPATH;
    },
    BILLING_ADDRESS_TOGGLE_DEFAULT: function() {
        return BILLING_ADDRESS_TOGGLE_DEFAULT;
    },
    BILLING_ADDRESS_TOGGLE_KEY: function() {
        return BILLING_ADDRESS_TOGGLE_KEY;
    },
    BILLING_ADDRESS_TOGGLE_KEYPATH: function() {
        return BILLING_ADDRESS_TOGGLE_KEYPATH;
    },
    CART_CHECKOUT_BUTTON_TEXT_DEFAULT: function() {
        return CART_CHECKOUT_BUTTON_TEXT_DEFAULT;
    },
    CART_CHECKOUT_ERROR_MESSAGE: function() {
        return CART_CHECKOUT_ERROR_MESSAGE;
    },
    CART_CHECKOUT_ERROR_MESSAGE_SELECTOR: function() {
        return CART_CHECKOUT_ERROR_MESSAGE_SELECTOR;
    },
    CART_CHECKOUT_LOADING_TEXT_DEFAULT: function() {
        return CART_CHECKOUT_LOADING_TEXT_DEFAULT;
    },
    CART_COUNT_HIDE_RULES: function() {
        return CART_COUNT_HIDE_RULES;
    },
    CART_ERRORS: function() {
        return CART_ERRORS;
    },
    CART_ERROR_MESSAGE: function() {
        return CART_ERROR_MESSAGE;
    },
    CART_ERROR_MESSAGE_SELECTOR: function() {
        return CART_ERROR_MESSAGE_SELECTOR;
    },
    CART_GENERAL_ERROR_MESSAGE: function() {
        return CART_GENERAL_ERROR_MESSAGE;
    },
    CART_OPEN: function() {
        return CART_OPEN;
    },
    CART_PRODUCT_ADDED_DEFAULT: function() {
        return CART_PRODUCT_ADDED_DEFAULT;
    },
    CART_PRODUCT_ADDED_KEY: function() {
        return CART_PRODUCT_ADDED_KEY;
    },
    CART_PRODUCT_ADDED_KEYPATH: function() {
        return CART_PRODUCT_ADDED_KEYPATH;
    },
    CART_QUERY: function() {
        return CART_QUERY;
    },
    CART_STATE: function() {
        return CART_STATE;
    },
    CART_STATES: function() {
        return CART_STATES;
    },
    CART_STATES_AUTOMATION: function() {
        return CART_STATES_AUTOMATION;
    },
    CART_TYPE: function() {
        return CART_TYPE;
    },
    CART_TYPES: function() {
        return CART_TYPES;
    },
    CART_TYPE_DROPDOWN_ON_OPEN: function() {
        return CART_TYPE_DROPDOWN_ON_OPEN;
    },
    CART_TYPE_DROPDOWN_ON_OPEN_KEY: function() {
        return CART_TYPE_DROPDOWN_ON_OPEN_KEY;
    },
    CART_TYPE_KEY: function() {
        return CART_TYPE_KEY;
    },
    CHANGE_CART_EVENT: function() {
        return CHANGE_CART_EVENT;
    },
    CHECKOUT_BINDING_ROOT_QUERY_PATH: function() {
        return CHECKOUT_BINDING_ROOT_QUERY_PATH;
    },
    CHECKOUT_DISABLED_ERROR_MESSAGE: function() {
        return CHECKOUT_DISABLED_ERROR_MESSAGE;
    },
    CHECKOUT_ERRORS: function() {
        return CHECKOUT_ERRORS;
    },
    CHECKOUT_PLACE_ORDER_BUTTON_TEXT_DEFAULT: function() {
        return CHECKOUT_PLACE_ORDER_BUTTON_TEXT_DEFAULT;
    },
    CHECKOUT_PLACE_ORDER_LOADING_TEXT_DEFAULT: function() {
        return CHECKOUT_PLACE_ORDER_LOADING_TEXT_DEFAULT;
    },
    CHECKOUT_QUERY: function() {
        return CHECKOUT_QUERY;
    },
    CHECKOUT_STATE: function() {
        return CHECKOUT_STATE;
    },
    CHECKOUT_STATES: function() {
        return CHECKOUT_STATES;
    },
    COMMERCE_CART_ITEM_ID_ATTR: function() {
        return COMMERCE_CART_ITEM_ID_ATTR;
    },
    COMMERCE_CART_PUBLISHED_SITE_ACTIONS: function() {
        return COMMERCE_CART_PUBLISHED_SITE_ACTIONS;
    },
    COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR: function() {
        return COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR;
    },
    COMMERCE_CATEGORY_COLLECTION_SLUG: function() {
        return COMMERCE_CATEGORY_COLLECTION_SLUG;
    },
    COMMERCE_DEFAULT_COPY: function() {
        return COMMERCE_DEFAULT_COPY;
    },
    COMMERCE_ERROR_CATEGORY: function() {
        return COMMERCE_ERROR_CATEGORY;
    },
    COMMERCE_PLUGIN_KEY: function() {
        return COMMERCE_PLUGIN_KEY;
    },
    COMMERCE_PRODUCT_COLLECTION_SLUG: function() {
        return COMMERCE_PRODUCT_COLLECTION_SLUG;
    },
    COMMERCE_PRODUCT_FIELD_SLUG: function() {
        return COMMERCE_PRODUCT_FIELD_SLUG;
    },
    COMMERCE_PRODUCT_TYPE_FIELD_SLUG: function() {
        return COMMERCE_PRODUCT_TYPE_FIELD_SLUG;
    },
    COMMERCE_SKU_BILLING_METHOD_FIELD_SLUG: function() {
        return COMMERCE_SKU_BILLING_METHOD_FIELD_SLUG;
    },
    COMMERCE_SKU_COLLECTION_SLUG: function() {
        return COMMERCE_SKU_COLLECTION_SLUG;
    },
    COMMERCE_SKU_FIELD_SLUG: function() {
        return COMMERCE_SKU_FIELD_SLUG;
    },
    DATA_ATTR_ANIMATION_DURATION: function() {
        return DATA_ATTR_ANIMATION_DURATION;
    },
    DATA_ATTR_ANIMATION_EASING: function() {
        return DATA_ATTR_ANIMATION_EASING;
    },
    DATA_ATTR_COMMERCE_OPTION_SET_ID: function() {
        return DATA_ATTR_COMMERCE_OPTION_SET_ID;
    },
    DATA_ATTR_COMMERCE_PRODUCT_CURRENT_SKU_VALUES: function() {
        return DATA_ATTR_COMMERCE_PRODUCT_CURRENT_SKU_VALUES;
    },
    DATA_ATTR_COMMERCE_PRODUCT_ID: function() {
        return DATA_ATTR_COMMERCE_PRODUCT_ID;
    },
    DATA_ATTR_COMMERCE_SKU_ID: function() {
        return DATA_ATTR_COMMERCE_SKU_ID;
    },
    DATA_ATTR_COUNT_HIDE_RULE: function() {
        return DATA_ATTR_COUNT_HIDE_RULE;
    },
    DATA_ATTR_DEFAULT_TEXT: function() {
        return DATA_ATTR_DEFAULT_TEXT;
    },
    DATA_ATTR_LOADING_TEXT: function() {
        return DATA_ATTR_LOADING_TEXT;
    },
    DATA_ATTR_NODE_TYPE: function() {
        return DATA_ATTR_NODE_TYPE;
    },
    DATA_ATTR_OPEN_ON_HOVER: function() {
        return DATA_ATTR_OPEN_ON_HOVER;
    },
    DATA_ATTR_OPEN_PRODUCT: function() {
        return DATA_ATTR_OPEN_PRODUCT;
    },
    DATA_ATTR_PRESELECT_DEFAULT_VARIANT: function() {
        return DATA_ATTR_PRESELECT_DEFAULT_VARIANT;
    },
    DATA_ATTR_PUBLISHABLE_KEY: function() {
        return DATA_ATTR_PUBLISHABLE_KEY;
    },
    DATA_ATTR_SUBSCRIPTION_TEXT: function() {
        return DATA_ATTR_SUBSCRIPTION_TEXT;
    },
    DEFAULT_SKU_SLUG: function() {
        return DEFAULT_SKU_SLUG;
    },
    EASE_DEFAULT: function() {
        return EASE_DEFAULT;
    },
    EASINGS: function() {
        return EASINGS;
    },
    EDITABLE_STYLE_NAMES: function() {
        return EDITABLE_STYLE_NAMES;
    },
    HIDE_CART_COUNT_DEFAULT: function() {
        return HIDE_CART_COUNT_DEFAULT;
    },
    HIDE_CART_COUNT_KEY: function() {
        return HIDE_CART_COUNT_KEY;
    },
    HIDE_CART_WHEN_EMPTY_DEFAULT: function() {
        return HIDE_CART_WHEN_EMPTY_DEFAULT;
    },
    HIDE_CART_WHEN_EMPTY_KEY: function() {
        return HIDE_CART_WHEN_EMPTY_KEY;
    },
    HIDE_CART_WHEN_EMPTY_KEYPATH: function() {
        return HIDE_CART_WHEN_EMPTY_KEYPATH;
    },
    LOADING_TEXT: function() {
        return LOADING_TEXT;
    },
    LOADING_TEXT_DEFAULT: function() {
        return LOADING_TEXT_DEFAULT;
    },
    NEEDS_REFRESH: function() {
        return NEEDS_REFRESH;
    },
    NODE_NAME_COMMERCE_ADD_TO_CART_QUANTITY_INPUT: function() {
        return NODE_NAME_COMMERCE_ADD_TO_CART_QUANTITY_INPUT;
    },
    NODE_TYPE_ADD_TO_CART_ERROR: function() {
        return NODE_TYPE_ADD_TO_CART_ERROR;
    },
    NODE_TYPE_COMMERCE_ADD_TO_CART_BUTTON: function() {
        return NODE_TYPE_COMMERCE_ADD_TO_CART_BUTTON;
    },
    NODE_TYPE_COMMERCE_ADD_TO_CART_ERROR: function() {
        return NODE_TYPE_COMMERCE_ADD_TO_CART_ERROR;
    },
    NODE_TYPE_COMMERCE_ADD_TO_CART_FORM: function() {
        return NODE_TYPE_COMMERCE_ADD_TO_CART_FORM;
    },
    NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_LIST: function() {
        return NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_LIST;
    },
    NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_SELECT: function() {
        return NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_SELECT;
    },
    NODE_TYPE_COMMERCE_ADD_TO_CART_PILL: function() {
        return NODE_TYPE_COMMERCE_ADD_TO_CART_PILL;
    },
    NODE_TYPE_COMMERCE_ADD_TO_CART_PILL_GROUP: function() {
        return NODE_TYPE_COMMERCE_ADD_TO_CART_PILL_GROUP;
    },
    NODE_TYPE_COMMERCE_BUY_NOW_BUTTON: function() {
        return NODE_TYPE_COMMERCE_BUY_NOW_BUTTON;
    },
    NODE_TYPE_COMMERCE_CART_APPLE_PAY_BUTTON: function() {
        return NODE_TYPE_COMMERCE_CART_APPLE_PAY_BUTTON;
    },
    NODE_TYPE_COMMERCE_CART_CHECKOUT_BUTTON: function() {
        return NODE_TYPE_COMMERCE_CART_CHECKOUT_BUTTON;
    },
    NODE_TYPE_COMMERCE_CART_CLOSE_LINK: function() {
        return NODE_TYPE_COMMERCE_CART_CLOSE_LINK;
    },
    NODE_TYPE_COMMERCE_CART_CONTAINER: function() {
        return NODE_TYPE_COMMERCE_CART_CONTAINER;
    },
    NODE_TYPE_COMMERCE_CART_CONTAINER_WRAPPER: function() {
        return NODE_TYPE_COMMERCE_CART_CONTAINER_WRAPPER;
    },
    NODE_TYPE_COMMERCE_CART_ERROR: function() {
        return NODE_TYPE_COMMERCE_CART_ERROR;
    },
    NODE_TYPE_COMMERCE_CART_FORM: function() {
        return NODE_TYPE_COMMERCE_CART_FORM;
    },
    NODE_TYPE_COMMERCE_CART_OPEN_LINK: function() {
        return NODE_TYPE_COMMERCE_CART_OPEN_LINK;
    },
    NODE_TYPE_COMMERCE_CART_QUICK_CHECKOUT_ACTIONS: function() {
        return NODE_TYPE_COMMERCE_CART_QUICK_CHECKOUT_ACTIONS;
    },
    NODE_TYPE_COMMERCE_CART_QUICK_CHECKOUT_BUTTON: function() {
        return NODE_TYPE_COMMERCE_CART_QUICK_CHECKOUT_BUTTON;
    },
    NODE_TYPE_COMMERCE_CART_WRAPPER: function() {
        return NODE_TYPE_COMMERCE_CART_WRAPPER;
    },
    NODE_TYPE_COMMERCE_CHECKOUT_ADDITIONAL_INFO: function() {
        return NODE_TYPE_COMMERCE_CHECKOUT_ADDITIONAL_INFO;
    },
    NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_TOGGLE_CHECKBOX: function() {
        return NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_TOGGLE_CHECKBOX;
    },
    NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_WRAPPER: function() {
        return NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_WRAPPER;
    },
    NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_ZIP_FIELD: function() {
        return NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_ZIP_FIELD;
    },
    NODE_TYPE_COMMERCE_CHECKOUT_CUSTOMER_INFO_WRAPPER: function() {
        return NODE_TYPE_COMMERCE_CHECKOUT_CUSTOMER_INFO_WRAPPER;
    },
    NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_FORM: function() {
        return NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_FORM;
    },
    NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_INPUT: function() {
        return NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_INPUT;
    },
    NODE_TYPE_COMMERCE_CHECKOUT_ERROR_STATE: function() {
        return NODE_TYPE_COMMERCE_CHECKOUT_ERROR_STATE;
    },
    NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER: function() {
        return NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER;
    },
    NODE_TYPE_COMMERCE_CHECKOUT_PLACE_ORDER_BUTTON: function() {
        return NODE_TYPE_COMMERCE_CHECKOUT_PLACE_ORDER_BUTTON;
    },
    NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_WRAPPER: function() {
        return NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_WRAPPER;
    },
    NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_ZIP_FIELD: function() {
        return NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_ZIP_FIELD;
    },
    NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_EMPTY_STATE: function() {
        return NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_EMPTY_STATE;
    },
    NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_LIST: function() {
        return NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_LIST;
    },
    NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_WRAPPER: function() {
        return NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_WRAPPER;
    },
    NODE_TYPE_COMMERCE_DOWNLOADS_BUTTON: function() {
        return NODE_TYPE_COMMERCE_DOWNLOADS_BUTTON;
    },
    NODE_TYPE_COMMERCE_ORDER_CONFIRMATION_WRAPPER: function() {
        return NODE_TYPE_COMMERCE_ORDER_CONFIRMATION_WRAPPER;
    },
    NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_ERROR_STATE: function() {
        return NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_ERROR_STATE;
    },
    NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_FORM_CONTAINER: function() {
        return NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_FORM_CONTAINER;
    },
    OPEN_STATE_DEFAULT: function() {
        return OPEN_STATE_DEFAULT;
    },
    OPEN_STATE_KEY: function() {
        return OPEN_STATE_KEY;
    },
    OPEN_STATE_KEYPATH: function() {
        return OPEN_STATE_KEYPATH;
    },
    ORDER_QUERY: function() {
        return ORDER_QUERY;
    },
    ORDER_TYPE: function() {
        return ORDER_TYPE;
    },
    PAYPAL_BUTTON_ELEMENT_INSTANCE: function() {
        return PAYPAL_BUTTON_ELEMENT_INSTANCE;
    },
    PAYPAL_ELEMENT_INSTANCE: function() {
        return PAYPAL_ELEMENT_INSTANCE;
    },
    PREVIEW_ITEMS_DEFAULT: function() {
        return PREVIEW_ITEMS_DEFAULT;
    },
    PREVIEW_ITEMS_KEY: function() {
        return PREVIEW_ITEMS_KEY;
    },
    PREVIEW_ITEMS_KEYPATH: function() {
        return PREVIEW_ITEMS_KEYPATH;
    },
    QUANTITY_ENABLED: function() {
        return QUANTITY_ENABLED;
    },
    QUICK_CHECKOUT_AUTOMATION: function() {
        return QUICK_CHECKOUT_AUTOMATION;
    },
    QUICK_CHECKOUT_STATE: function() {
        return QUICK_CHECKOUT_STATE;
    },
    QUICK_CHECKOUT_STATES: function() {
        return QUICK_CHECKOUT_STATES;
    },
    QUICK_CHECKOUT_STATE_KEYPATH: function() {
        return QUICK_CHECKOUT_STATE_KEYPATH;
    },
    RENDER_TREE_EVENT: function() {
        return RENDER_TREE_EVENT;
    },
    REQUIRES_ACTION: function() {
        return REQUIRES_ACTION;
    },
    REQUIRES_SHIPPING: function() {
        return REQUIRES_SHIPPING;
    },
    SECTION_NAMES: function() {
        return SECTION_NAMES;
    },
    SHIPPING_METHODS_STATE: function() {
        return SHIPPING_METHODS_STATE;
    },
    SHIPPING_METHODS_STATES: function() {
        return SHIPPING_METHODS_STATES;
    },
    STATE: function() {
        return STATE;
    },
    STRIPE_ECOMMERCE_ACCOUNT_ID: function() {
        return STRIPE_ECOMMERCE_ACCOUNT_ID;
    },
    STRIPE_ECOMMERCE_KEY: function() {
        return STRIPE_ECOMMERCE_KEY;
    },
    STRIPE_ELEMENT_INSTANCE: function() {
        return STRIPE_ELEMENT_INSTANCE;
    },
    STRIPE_ELEMENT_STYLE: function() {
        return STRIPE_ELEMENT_STYLE;
    },
    STRIPE_ELEMENT_TYPE: function() {
        return STRIPE_ELEMENT_TYPE;
    },
    WF_BINDING_DATA_KEY: function() {
        return WF_BINDING_DATA_KEY;
    },
    WF_COLLECTION_DATA_KEY: function() {
        return WF_COLLECTION_DATA_KEY;
    },
    WF_CONDITION_DATA_KEY: function() {
        return WF_CONDITION_DATA_KEY;
    },
    WF_SKU_BINDING_DATA_KEY: function() {
        return WF_SKU_BINDING_DATA_KEY;
    },
    WF_SKU_CONDITION_DATA_KEY: function() {
        return WF_SKU_CONDITION_DATA_KEY;
    },
    WF_TEMPLATE_ID_DATA_KEY: function() {
        return WF_TEMPLATE_ID_DATA_KEY;
    },
    WF_TEMPLATE_TYPE: function() {
        return WF_TEMPLATE_TYPE;
    },
    getATCErrorMessageForType: function() {
        return getATCErrorMessageForType;
    },
    getCartErrorMessageForType: function() {
        return getCartErrorMessageForType;
    },
    getCheckoutErrorMessageForType: function() {
        return getCheckoutErrorMessageForType;
    },
    symbolMap: function() {
        return symbolMap;
    }
});
const DATA_ATTR_COMMERCE_SKU_ID = 'data-commerce-sku-id';
const DATA_ATTR_COMMERCE_PRODUCT_CURRENT_SKU_VALUES = 'data-commerce-product-sku-values';
const DATA_ATTR_COMMERCE_OPTION_SET_ID = 'data-commerce-option-set-id';
const DATA_ATTR_COMMERCE_PRODUCT_ID = 'data-commerce-product-id';
const DATA_ATTR_NODE_TYPE = 'data-node-type';
const DATA_ATTR_LOADING_TEXT = 'data-loading-text';
const DATA_ATTR_OPEN_PRODUCT = 'data-open-product';
const DATA_ATTR_OPEN_ON_HOVER = 'data-open-on-hover';
const DATA_ATTR_COUNT_HIDE_RULE = 'data-count-hide-rule';
const DATA_ATTR_PRESELECT_DEFAULT_VARIANT = 'data-preselect-default-variant';
const DATA_ATTR_DEFAULT_TEXT = 'data-default-text';
const DATA_ATTR_SUBSCRIPTION_TEXT = 'data-subscription-text';
const NODE_TYPE_COMMERCE_ADD_TO_CART_FORM = 'commerce-add-to-cart-form';
const NODE_TYPE_COMMERCE_ADD_TO_CART_ERROR = 'commerce-add-to-cart-error';
const NODE_TYPE_COMMERCE_CART_ERROR = 'commerce-cart-error';
const NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_SELECT = 'commerce-add-to-cart-option-select';
const NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_LIST = 'commerce-add-to-cart-option-list';
const NODE_TYPE_COMMERCE_ADD_TO_CART_PILL_GROUP = 'commerce-add-to-cart-pill-group';
const NODE_TYPE_COMMERCE_ADD_TO_CART_PILL = 'commerce-add-to-cart-pill';
const NODE_TYPE_COMMERCE_CART_WRAPPER = 'commerce-cart-wrapper';
const NODE_TYPE_COMMERCE_CART_OPEN_LINK = 'commerce-cart-open-link';
const NODE_TYPE_COMMERCE_CART_CLOSE_LINK = 'commerce-cart-close-link';
const NODE_TYPE_COMMERCE_CART_CONTAINER_WRAPPER = 'commerce-cart-container-wrapper';
const NODE_TYPE_COMMERCE_CART_CONTAINER = 'commerce-cart-container';
const NODE_TYPE_COMMERCE_CART_CHECKOUT_BUTTON = 'cart-checkout-button';
const NODE_TYPE_COMMERCE_CART_FORM = 'commerce-cart-form';
const NODE_NAME_COMMERCE_ADD_TO_CART_QUANTITY_INPUT = 'commerce-add-to-cart-quantity-input';
const NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER = 'commerce-checkout-form-container';
const NODE_TYPE_COMMERCE_CHECKOUT_CUSTOMER_INFO_WRAPPER = 'commerce-checkout-customer-info-wrapper';
const NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_WRAPPER = 'commerce-checkout-shipping-address-wrapper';
const NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_ZIP_FIELD = 'commerce-checkout-shipping-zip-field';
const NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_ZIP_FIELD = 'commerce-checkout-billing-zip-field';
const NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_WRAPPER = 'commerce-checkout-billing-address-wrapper';
const NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_WRAPPER = 'commerce-checkout-shipping-methods-wrapper';
const NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_LIST = 'commerce-checkout-shipping-methods-list';
const NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_EMPTY_STATE = 'commerce-checkout-shipping-methods-empty-state';
const NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_TOGGLE_CHECKBOX = 'commerce-checkout-billing-address-toggle-checkbox';
const NODE_TYPE_COMMERCE_CHECKOUT_PLACE_ORDER_BUTTON = 'commerce-checkout-place-order-button';
const NODE_TYPE_COMMERCE_CHECKOUT_ERROR_STATE = 'commerce-checkout-error-state';
const NODE_TYPE_COMMERCE_ORDER_CONFIRMATION_WRAPPER = 'commerce-order-confirmation-wrapper';
const NODE_TYPE_COMMERCE_CART_QUICK_CHECKOUT_ACTIONS = 'commerce-cart-quick-checkout-actions';
const NODE_TYPE_COMMERCE_CART_QUICK_CHECKOUT_BUTTON = 'commerce-cart-quick-checkout-button';
const NODE_TYPE_COMMERCE_CART_APPLE_PAY_BUTTON = 'commerce-cart-apple-pay-button';
const NODE_TYPE_COMMERCE_CHECKOUT_ADDITIONAL_INFO = 'commerce-checkout-additional-info';
const NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_FORM_CONTAINER = 'commerce-paypal-checkout-form-container';
const NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_ERROR_STATE = 'commerce-checkout-error-state';
const NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_FORM = 'commerce-checkout-discount-form';
const NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_INPUT = 'commerce-checkout-discount-input';
const NODE_TYPE_COMMERCE_BUY_NOW_BUTTON = 'commerce-buy-now-button';
const NODE_TYPE_COMMERCE_DOWNLOADS_BUTTON = 'commerce-downloads-button';
const NODE_TYPE_COMMERCE_ADD_TO_CART_BUTTON = 'commerce-add-to-cart-button';
const NODE_TYPE_ADD_TO_CART_ERROR = 'commerce-add-to-cart-error';
const ADD_TO_CART_STATES = {
    DEFAULT: 'DEFAULT',
    OUT_OF_STOCK: 'OUT_OF_STOCK',
    ERROR: 'ERROR'
};
const CART_STATES = {
    DEFAULT: 'DEFAULT',
    EMPTY: 'EMPTY',
    ERROR: 'ERROR'
};
const CART_STATES_AUTOMATION = {
    DEFAULT: 'cart-default-button',
    EMPTY: 'cart-empty-button',
    ERROR: 'cart-error-button'
};
const CHECKOUT_STATES = {
    DEFAULT: 'DEFAULT',
    ERROR: 'ERROR'
};
const SHIPPING_METHODS_STATES = {
    DEFAULT: 'DEFAULT',
    EMPTY: 'EMPTY'
};
const CART_TYPE_DROPDOWN_ON_OPEN = {
    CLICK: 'CLICK',
    HOVER: 'HOVER'
};
const CART_TYPES = {
    MODAL: 'modal',
    LEFT_SIDEBAR: 'leftSidebar',
    RIGHT_SIDEBAR: 'rightSidebar',
    LEFT_DROPDOWN: 'leftDropdown',
    RIGHT_DROPDOWN: 'rightDropdown',
    DROPDOWN: 'dropdown'
};
const CART_COUNT_HIDE_RULES = {
    ALWAYS: 'always',
    EMPTY: 'empty'
};
const QUICK_CHECKOUT_STATES = {
    NONE: 'NONE',
    PAY_NOW: 'PAY_NOW',
    APPLE_PAY: 'APPLE_PAY'
};
const QUICK_CHECKOUT_AUTOMATION = {
    PAY_NOW: 'quick-checkout-default-button',
    APPLE_PAY: 'quick-checkout-apple-pay-button'
};
const PREVIEW_ITEMS_DEFAULT = 3;
const PREVIEW_ITEMS_KEY = 'previewItems';
const PREVIEW_ITEMS_KEYPATH = [
    'data',
    'temp',
    PREVIEW_ITEMS_KEY
];
const QUANTITY_ENABLED = 'quantityEnabled';
const STATE = 'state';
const CART_STATE = 'state';
const QUICK_CHECKOUT_STATE = 'state';
const QUICK_CHECKOUT_STATE_KEYPATH = [
    'data',
    'temp',
    QUICK_CHECKOUT_STATE
];
const CHECKOUT_STATE = 'state';
const SHIPPING_METHODS_STATE = 'shippingMethodsState';
const OPEN_STATE_KEY = 'isOpen';
const OPEN_STATE_KEYPATH = [
    'data',
    'temp',
    OPEN_STATE_KEY
];
const OPEN_STATE_DEFAULT = false;
const BILLING_ADDRESS_TOGGLE_KEY = 'isBillingAddressOpen';
const BILLING_ADDRESS_TOGGLE_KEYPATH = [
    'data',
    'temp',
    BILLING_ADDRESS_TOGGLE_KEY
];
const BILLING_ADDRESS_TOGGLE_DEFAULT = true;
const HIDE_CART_WHEN_EMPTY_KEY = 'hideCartWhenEmpty';
const HIDE_CART_WHEN_EMPTY_KEYPATH = [
    'data',
    'commerce',
    HIDE_CART_WHEN_EMPTY_KEY
];
const HIDE_CART_WHEN_EMPTY_DEFAULT = false;
const HIDE_CART_COUNT_KEY = 'hideCartCount';
const HIDE_CART_COUNT_DEFAULT = false;
const LOADING_TEXT = 'loadingText';
const LOADING_TEXT_DEFAULT = 'Adding to cart...';
const CART_CHECKOUT_BUTTON_TEXT_DEFAULT = 'Continue to Checkout';
const CART_CHECKOUT_LOADING_TEXT_DEFAULT = 'Hang Tight...';
const CHECKOUT_PLACE_ORDER_BUTTON_TEXT_DEFAULT = 'Place Order';
const CHECKOUT_PLACE_ORDER_LOADING_TEXT_DEFAULT = 'Placing Order...';
const CART_TYPE_KEY = 'cartType';
const ALIGN_KEY = 'align';
const ALIGN_DEFAULT = 'rightDropdown';
const CART_TYPE_DROPDOWN_ON_OPEN_KEY = 'openOn';
const CART_PRODUCT_ADDED_KEY = 'openWhenProductAdded';
const CART_PRODUCT_ADDED_KEYPATH = [
    'data',
    'commerce',
    CART_PRODUCT_ADDED_KEY
];
const CART_PRODUCT_ADDED_DEFAULT = true;
const COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR = 'data-wf-cart-action';
const COMMERCE_CART_PUBLISHED_SITE_ACTIONS = {
    UPDATE_ITEM_QUANTITY: 'update-item-quantity',
    REMOVE_ITEM: 'remove-item'
};
const COMMERCE_CART_ITEM_ID_ATTR = 'data-wf-item-id';
const COMMERCE_SKU_COLLECTION_SLUG = 'sku';
const COMMERCE_SKU_FIELD_SLUG = 'sku';
const COMMERCE_PRODUCT_COLLECTION_SLUG = 'product';
const COMMERCE_PRODUCT_FIELD_SLUG = 'product';
const COMMERCE_PRODUCT_TYPE_FIELD_SLUG = 'ec-product-type';
const COMMERCE_SKU_BILLING_METHOD_FIELD_SLUG = 'ec-sku-billing-method';
const COMMERCE_CATEGORY_COLLECTION_SLUG = 'category';
const COMMERCE_PLUGIN_KEY = 'ecommerce';
const DEFAULT_SKU_SLUG = 'default-sku';
const WF_BINDING_DATA_KEY = 'data-wf-bindings';
const WF_CONDITION_DATA_KEY = 'data-wf-conditions';
const WF_COLLECTION_DATA_KEY = 'data-wf-collection';
const WF_TEMPLATE_ID_DATA_KEY = 'data-wf-template-id';
const WF_SKU_BINDING_DATA_KEY = 'data-wf-sku-bindings';
const WF_SKU_CONDITION_DATA_KEY = 'data-wf-sku-conditions';
const WF_TEMPLATE_TYPE = 'text/x-wf-template';
const INFO_ERR = 'INFO_ERROR';
const SHIPPING_ERR = 'SHIPPING_ERROR';
const BILLING_ERR = 'BILLING_ERROR';
const PAYMENT_ERR = 'PAYMENT_ERROR';
const PRICING_ERR = 'PRICING_ERROR';
const ORDER_MIN_ERR = 'ORDER_MINIMUM_ERROR';
const ORDER_EXTRAS_ERR = 'ORDER_EXTRAS_ERROR';
const PRODUCT_ERR = 'PRODUCT_ERROR';
const INVALID_DISCOUNT_ERR = 'INVALID_DISCOUNT_ERROR';
const EXPIRED_DISCOUNT_ERR = 'EXPIRED_DISCOUNT_ERROR';
const USAGE_REACHED_DISCOUNT_ERR = 'USAGE_REACHED_DISCOUNT_ERROR';
const REQUIREMENTS_NOT_MET_DISCOUNT_ERR = 'REQUIREMENTS_NOT_MET_DISCOUNT_ERROR';
const COMMERCE_ERROR_CATEGORY = {
    GENERAL: {
        id: 'GENERAL',
        label: 'General Errors'
    },
    PRODUCT: {
        id: 'PRODUCT',
        label: 'Product Errors'
    },
    BILLING: {
        id: 'BILLING',
        label: 'Billing Errors'
    },
    DISCOUNT: {
        id: 'DISCOUNT',
        label: 'Discount Errors'
    },
    SUBSCRIPTION: {
        id: 'SUBSCRIPTION',
        label: 'Subscription Errors'
    }
};
const CHECKOUT_ERRORS = {
    INFO: {
        id: INFO_ERR,
        name: 'General customer info error',
        category: COMMERCE_ERROR_CATEGORY.GENERAL,
        copy: 'There was an error processing your customer info. Please try again, or contact us if you continue to have problems.',
        path: [
            'data',
            'commerce',
            INFO_ERR
        ]
    },
    SHIPPING: {
        id: SHIPPING_ERR,
        category: COMMERCE_ERROR_CATEGORY.GENERAL,
        name: 'Shipping not available',
        copy: 'Sorry. We can’t ship your order to the address provided.',
        path: [
            'data',
            'commerce',
            SHIPPING_ERR
        ]
    },
    EXTRAS: {
        id: ORDER_EXTRAS_ERR,
        category: COMMERCE_ERROR_CATEGORY.GENERAL,
        name: 'Merchant setting changed',
        copy: 'A merchant setting has changed that impacts your cart. Please refresh and try again.',
        path: [
            'data',
            'commerce',
            ORDER_EXTRAS_ERR
        ],
        requiresRefresh: true
    },
    PRICING: {
        id: PRICING_ERR,
        category: COMMERCE_ERROR_CATEGORY.PRODUCT,
        name: 'Product price changed',
        copy: 'The prices of one or more items in your cart have changed. Please refresh this page and try again.',
        path: [
            'data',
            'commerce',
            PRICING_ERR
        ],
        requiresRefresh: true
    },
    PRODUCT: {
        id: PRODUCT_ERR,
        category: COMMERCE_ERROR_CATEGORY.PRODUCT,
        name: 'Product removed',
        copy: 'One or more of the products in your cart have been removed. Please refresh the page and try again.',
        path: [
            'data',
            'commerce',
            PRODUCT_ERR
        ],
        requiresRefresh: true
    },
    PAYMENT: {
        id: PAYMENT_ERR,
        category: COMMERCE_ERROR_CATEGORY.BILLING,
        name: 'General payment error',
        copy: 'There was an error processing your payment. Please try again, or contact us if you continue to have problems.',
        path: [
            'data',
            'commerce',
            PAYMENT_ERR
        ]
    },
    BILLING: {
        id: BILLING_ERR,
        category: COMMERCE_ERROR_CATEGORY.BILLING,
        name: 'Card declined',
        copy: 'Your payment could not be completed with the payment information provided. Please make sure that your card and billing address information is correct, or try a different payment card, to complete this order. Contact us if you continue to have problems.',
        path: [
            'data',
            'commerce',
            BILLING_ERR
        ]
    },
    MINIMUM: {
        id: ORDER_MIN_ERR,
        category: COMMERCE_ERROR_CATEGORY.BILLING,
        name: 'Order minimum not met',
        copy: 'The order minimum was not met. Add more items to your cart to continue.',
        path: [
            'data',
            'commerce',
            ORDER_MIN_ERR
        ],
        note: {
            copy: "You can customize this message with the exact minimum based on your Stripe account's settlement currency.",
            cta: {
                copy: 'Go to Stripe docs',
                link: 'https://stripe.com/docs/currencies#minimum-and-maximum-charge-amounts'
            }
        }
    },
    INVALID_DISCOUNT: {
        id: INVALID_DISCOUNT_ERR,
        category: COMMERCE_ERROR_CATEGORY.DISCOUNT,
        name: 'Invalid discount error',
        copy: 'This discount is invalid.',
        path: [
            'data',
            'commerce',
            INVALID_DISCOUNT_ERR
        ]
    },
    EXPIRED_DISCOUNT: {
        id: EXPIRED_DISCOUNT_ERR,
        category: COMMERCE_ERROR_CATEGORY.DISCOUNT,
        name: 'Discount expired',
        copy: 'This discount is no longer available.',
        path: [
            'data',
            'commerce',
            EXPIRED_DISCOUNT_ERR
        ]
    },
    USAGE_REACHED_DISCOUNT: {
        id: USAGE_REACHED_DISCOUNT_ERR,
        category: COMMERCE_ERROR_CATEGORY.DISCOUNT,
        name: 'Discount usage limit reached',
        copy: 'This discount is no longer available.',
        path: [
            'data',
            'commerce',
            USAGE_REACHED_DISCOUNT_ERR
        ]
    },
    REQUIREMENTS_NOT_MET_DISCOUNT: {
        id: REQUIREMENTS_NOT_MET_DISCOUNT_ERR,
        category: COMMERCE_ERROR_CATEGORY.DISCOUNT,
        name: 'Discount requirements not met',
        copy: 'Your order does not meet the requirements for this discount.',
        path: [
            'data',
            'commerce',
            REQUIREMENTS_NOT_MET_DISCOUNT_ERR
        ]
    }
};
const QUANTITY_ERR = 'QUANTITY_ERROR';
const CHECKOUT_ERR = 'CHECKOUT_ERROR';
const GENERAL_ERR = 'GENERAL_ERROR';
const CART_ORDER_MIN_ERR = 'CART_ORDER_MIN_ERROR';
const SUBSCRIPTION_ERR = 'SUBSCRIPTION_ERR';
const CART_ERRORS = {
    QUANTITY: {
        id: QUANTITY_ERR,
        name: 'Quantity not available',
        category: COMMERCE_ERROR_CATEGORY.GENERAL,
        copy: 'Product is not available in this quantity.',
        path: [
            'data',
            'commerce',
            QUANTITY_ERR
        ]
    },
    GENERAL: {
        id: GENERAL_ERR,
        category: COMMERCE_ERROR_CATEGORY.GENERAL,
        name: 'General error',
        copy: 'Something went wrong when adding this item to the cart.',
        path: [
            'data',
            'commerce',
            GENERAL_ERR
        ]
    },
    CHECKOUT: {
        id: CHECKOUT_ERR,
        category: COMMERCE_ERROR_CATEGORY.GENERAL,
        name: 'Checkout disabled',
        copy: 'Checkout is disabled on this site.',
        path: [
            'data',
            'commerce',
            CHECKOUT_ERR
        ]
    },
    CART_ORDER_MIN: {
        id: CART_ORDER_MIN_ERR,
        category: COMMERCE_ERROR_CATEGORY.BILLING,
        name: 'Order minimum not met',
        copy: 'The order minimum was not met. Add more items to your cart to continue.',
        path: [
            'data',
            'commerce',
            CART_ORDER_MIN_ERR
        ]
    },
    SUBSCRIPTION_ERROR: {
        id: SUBSCRIPTION_ERR,
        category: COMMERCE_ERROR_CATEGORY.SUBSCRIPTION,
        name: 'Subscription not verified',
        copy: 'Before you purchase, please use your email invite to verify your address so we can send order updates.',
        path: [
            'data',
            'commerce',
            SUBSCRIPTION_ERR
        ]
    }
};
const ADD_TO_CART_QUANTITY_ERR = 'ADD_TO_CART_QUANTITY_ERROR';
const ADD_TO_CART_GENERAL_ERR = 'ADD_TO_CART_GENERAL_ERROR';
const ADD_TO_CART_MIXED_ERR = 'ADD_TO_CART_MIXED_ERROR';
const ADD_TO_CART_ERRORS = {
    QUANTITY: {
        id: ADD_TO_CART_QUANTITY_ERR,
        category: COMMERCE_ERROR_CATEGORY.GENERAL,
        name: 'Quantity not available',
        copy: 'Product is not available in this quantity.',
        path: [
            'data',
            'commerce',
            ADD_TO_CART_QUANTITY_ERR
        ]
    },
    GENERAL: {
        id: ADD_TO_CART_GENERAL_ERR,
        category: COMMERCE_ERROR_CATEGORY.GENERAL,
        name: 'Add to Cart error',
        copy: 'Something went wrong when adding this item to the cart.',
        path: [
            'data',
            'commerce',
            ADD_TO_CART_GENERAL_ERR
        ]
    },
    MIXED_CART: {
        id: ADD_TO_CART_MIXED_ERR,
        category: COMMERCE_ERROR_CATEGORY.GENERAL,
        name: 'Add to mixed Cart error',
        copy: 'You can’t purchase another product with a subscription.'
    },
    BUY_NOW: {
        id: 'BUY_NOW_ERROR',
        category: COMMERCE_ERROR_CATEGORY.GENERAL,
        name: 'Buy now error',
        copy: 'Something went wrong when trying to purchase this item.'
    },
    CHECKOUT_DISABLED: {
        id: 'CHECKOUT_DISABLED_ERROR',
        category: COMMERCE_ERROR_CATEGORY.GENERAL,
        name: 'Checkout disabled',
        copy: 'Checkout is disabled on this site.'
    },
    SELECT_ALL_OPTIONS: {
        id: 'SELECT_ALL_OPTIONS',
        category: COMMERCE_ERROR_CATEGORY.GENERAL,
        name: 'Option selection required',
        copy: 'Please select an option in each set.',
        path: [
            'data',
            'commerce',
            'SELECT_ALL_OPTIONS'
        ]
    }
};
const DATA_ATTR_ANIMATION_EASING = 'data-wf-cart-easing';
const ANIMATION_EASING_DEFAULT = 'ease-out-quad';
const ANIMATION_EASING_KEY = 'easingType';
const ANIMATION_EASING_KEYPATH = [
    'data',
    'commerce',
    ANIMATION_EASING_KEY
];
const DATA_ATTR_ANIMATION_DURATION = 'data-wf-cart-duration';
const ANIMATION_DURATION_DEFAULT = 300;
const ANIMATION_DURATION_KEY = 'duration';
const ANIMATION_DURATION_KEYPATH = [
    'data',
    'commerce',
    ANIMATION_DURATION_KEY
];
const DATA_ATTR_PUBLISHABLE_KEY = 'data-publishable-key';
const EDITABLE_STYLE_NAMES = [
    'backgroundColor',
    'backgroundSize',
    'backgroundPosition',
    'backgroundImage',
    'backgroundRepeat',
    'border',
    'borderRadius',
    'boxShadow',
    'clear',
    'color',
    'cursor',
    'direction',
    'display',
    'filter',
    'float',
    'fontFamily',
    'fontSize',
    'fontStyle',
    'fontWeight',
    'height',
    'lineHeight',
    'letterSpacing',
    'listStyleType',
    'marginBottom',
    'marginLeft',
    'marginRight',
    'marginTop',
    'maxHeight',
    'minHeight',
    'maxWidth',
    'minWidth',
    'mixBlendMode',
    'opacity',
    'overflow',
    'outlineColor',
    'outlineOffset',
    'outlineStyle',
    'outlineWidth',
    'paddingBottom',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'position',
    'textAlign',
    'textColumns',
    'textDecoration',
    'textIndent',
    'textTransform',
    'textShadow',
    'transform',
    'transition',
    'whiteSpace',
    'width'
];
const symbolMap = {
    aed: 'د.إ',
    afn: '؋',
    all: 'L',
    amd: '֏',
    ang: 'ƒ',
    aoa: 'Kz',
    ars: '$',
    aud: '$',
    awg: 'ƒ',
    azn: '₼',
    bam: 'KM',
    bbd: '$',
    bdt: '৳',
    bgn: 'лв',
    bhd: '.د.ب',
    bif: 'FBu',
    bmd: '$',
    bnd: '$',
    bob: '$b',
    brl: 'R$',
    bsd: '$',
    btc: '฿',
    btn: 'Nu.',
    bwp: 'P',
    byr: 'Br',
    byn: 'Br',
    bzd: 'BZ$',
    cad: '$',
    cdf: 'FC',
    chf: 'CHF',
    clp: '$',
    cny: '¥',
    cop: '$',
    crc: '₡',
    cuc: '$',
    cup: '₱',
    cve: '$',
    czk: 'Kč',
    djf: 'Fdj',
    dkk: 'kr',
    dop: 'RD$',
    dzd: 'دج',
    eek: 'kr',
    egp: '£',
    ern: 'Nfk',
    etb: 'Br',
    eth: 'Ξ',
    eur: '€',
    fjd: '$',
    fkp: '£',
    gbp: '£',
    gel: '₾',
    ggp: '£',
    ghc: '₵',
    ghs: 'GH₵',
    gip: '£',
    gmd: 'D',
    gnf: 'FG',
    gtq: 'Q',
    gyd: '$',
    hkd: '$',
    hnl: 'L',
    hrk: 'kn',
    htg: 'G',
    huf: 'Ft',
    idr: 'Rp',
    ils: '₪',
    imp: '£',
    inr: '₹',
    iqd: 'ع.د',
    irr: '﷼',
    isk: 'kr',
    jep: '£',
    jmd: 'J$',
    jod: 'JD',
    jpy: '¥',
    kes: 'KSh',
    kgs: 'лв',
    khr: '៛',
    kmf: 'CF',
    kpw: '₩',
    krw: '₩',
    kwd: 'KD',
    kyd: '$',
    kzt: 'лв',
    lak: '₭',
    lbp: '£',
    lkr: '₨',
    lrd: '$',
    lsl: 'M',
    ltc: 'Ł',
    ltl: 'Lt',
    lvl: 'Ls',
    lyd: 'LD',
    mad: 'MAD',
    mdl: 'lei',
    mga: 'Ar',
    mkd: 'ден',
    mmk: 'K',
    mnt: '₮',
    mop: 'MOP$',
    mro: 'UM',
    mru: 'UM',
    mur: '₨',
    mvr: 'Rf',
    mwk: 'MK',
    mxn: '$',
    myr: 'RM',
    mzn: 'MT',
    nad: '$',
    ngn: '₦',
    nio: 'C$',
    nok: 'kr',
    npr: '₨',
    nzd: '$',
    omr: '﷼',
    pab: 'B/.',
    pen: 'S/.',
    pgk: 'K',
    php: '₱',
    pkr: '₨',
    pln: 'zł',
    pyg: 'Gs',
    qar: '﷼',
    rmb: '￥',
    ron: 'lei',
    rsd: 'Дин.',
    rub: '₽',
    rwf: 'R₣',
    sar: '﷼',
    sbd: '$',
    scr: '₨',
    sdg: 'ج.س.',
    sek: 'kr',
    sgd: '$',
    shp: '£',
    sll: 'Le',
    sos: 'S',
    srd: '$',
    ssp: '£',
    std: 'Db',
    stn: 'Db',
    svc: '$',
    syp: '£',
    szl: 'E',
    thb: '฿',
    tjs: 'SM',
    tmt: 'T',
    tnd: 'د.ت',
    top: 'T$',
    trl: '₤',
    try: '₺',
    ttd: 'TT$',
    tvd: '$',
    twd: 'NT$',
    tzs: 'TSh',
    uah: '₴',
    ugx: 'USh',
    usd: '$',
    uyu: '$U',
    uzs: 'лв',
    vef: 'Bs',
    vnd: '₫',
    vuv: 'VT',
    wst: 'WS$',
    xaf: 'FCFA',
    xbt: 'Ƀ',
    xcd: '$',
    xof: 'CFA',
    xpf: '₣',
    yer: '﷼',
    zar: 'R',
    zwd: 'Z$'
};
const CHECKOUT_BINDING_ROOT_QUERY_PATH = [
    'database',
    'commerceOrder'
];
const ORDER_TYPE = {
    REQUIRE_SHIPPING: 'shipping',
    NO_SHIPPING: 'noShipping'
};
const RENDER_TREE_EVENT = 'wf-render-tree';
const NEEDS_REFRESH = 'data-wf-needs-refresh';
const REQUIRES_SHIPPING = 'data-wf-order-requires-shipping';
const STRIPE_ELEMENT_INSTANCE = 'data-wf-stripe-element-instance';
const STRIPE_ELEMENT_TYPE = 'data-wf-stripe-element-type';
const STRIPE_ELEMENT_STYLE = 'data-wf-stripe-style';
const ADD_TO_CART_LOADING = 'data-wf-atc-loading';
const CHANGE_CART_EVENT = 'wf-change-cart-state';
const ADD_TO_CART_ERROR_MESSAGE = '.w-add-to-cart-error-msg';
const getATCErrorMessageForType = (errorType)=>`data-w-add-to-cart-${errorType}-error`;
const CHECKOUT_DISABLED_ERROR_MESSAGE = 'data-w-add-to-cart-checkout-disabled-error';
const CHECKOUT_QUERY = 'data-wf-checkout-query';
const getCheckoutErrorMessageForType = (errorType)=>`data-w-${errorType}-error`;
const REQUIRES_ACTION = 'requires_action';
const CART_GENERAL_ERROR_MESSAGE = 'data-w-cart-general-error';
const CART_CHECKOUT_ERROR_MESSAGE = 'data-w-cart-checkout-error';
const CART_CHECKOUT_ERROR_MESSAGE_SELECTOR = '.w-checkout-error-msg';
const CART_ERROR_MESSAGE = 'cart-error-msg';
const CART_ERROR_MESSAGE_SELECTOR = `.w-${CART_ERROR_MESSAGE}`;
const CART_OPEN = 'data-cart-open';
const CART_TYPE = 'data-wf-cart-type';
const CART_QUERY = 'data-wf-cart-query';
const PAYPAL_ELEMENT_INSTANCE = 'data-wf-paypal-element';
const PAYPAL_BUTTON_ELEMENT_INSTANCE = 'data-wf-paypal-button';
const getCartErrorMessageForType = (errorType)=>`data-w-cart-${errorType}-error`;
const ORDER_QUERY = 'data-wf-order-query';
const STRIPE_ECOMMERCE_KEY = 'data-wf-ecomm-key';
const STRIPE_ECOMMERCE_ACCOUNT_ID = 'data-wf-ecomm-acct-id';
const EASINGS = {
    ease: 'Ease',
    'ease-in': 'Ease In',
    'ease-out': 'Ease Out',
    'ease-in-out': 'Ease In Out',
    linear: 'Linear',
    'ease-in-quad': 'Ease In Quad',
    'ease-in-cubic': 'Ease In Cubic',
    'ease-in-quart': 'Ease In Quart',
    'ease-in-quint': 'Ease In Quint',
    'ease-in-sine': 'Ease In Sine',
    'ease-in-expo': 'Ease In Expo',
    'ease-in-circ': 'Ease In Circ',
    'ease-in-back': 'Ease In Back',
    'ease-out-quad': 'Ease Out Quad',
    'ease-out-cubic': 'Ease Out Cubic',
    'ease-out-quart': 'Ease Out Quart',
    'ease-out-quint': 'Ease Out Quint',
    'ease-out-sine': 'Ease Out Sine',
    'ease-out-expo': 'Ease Out Expo',
    'ease-out-circ': 'Ease Out Circ',
    'ease-out-back': 'Ease Out Back',
    'ease-in-out-quad': 'Ease In Out Quad',
    'ease-in-out-cubic': 'Ease In Out Cubic',
    'ease-in-out-quart': 'Ease In Out Quart',
    'ease-in-out-quint': 'Ease In Out Quint',
    'ease-in-out-sine': 'Ease In Out Sine',
    'ease-in-out-expo': 'Ease In Out Expo',
    'ease-in-out-circ': 'Ease In Out Circ',
    'ease-in-out-back': 'Ease In Out Back'
};
const EASE_DEFAULT = 'ease-out-quad';
const SECTION_NAMES = {
    ECOMMERCE: 'Ecommerce',
    CHECKOUT_PAGE: 'Checkout Page',
    ORDER_CONFIRMATION_PAGE: 'Order Confirmation Page',
    PAYPAL_CHECKOUT_PAGE: 'Checkout (PayPal) Page'
};
const COMMERCE_DEFAULT_COPY = {
    INFO_ERROR: CHECKOUT_ERRORS.INFO.copy,
    SHIPPING_ERROR: CHECKOUT_ERRORS.SHIPPING.copy,
    ORDER_EXTRAS_ERROR: CHECKOUT_ERRORS.EXTRAS.copy,
    PRICING_ERROR: CHECKOUT_ERRORS.PRICING.copy,
    PRODUCT_ERROR: CHECKOUT_ERRORS.PRODUCT.copy,
    PAYMENT_ERROR: CHECKOUT_ERRORS.PAYMENT.copy,
    BILLING_ERROR: CHECKOUT_ERRORS.BILLING.copy,
    ORDER_MINIMUM_ERROR: CHECKOUT_ERRORS.MINIMUM.copy,
    INVALID_DISCOUNT_ERROR: CHECKOUT_ERRORS.INVALID_DISCOUNT.copy,
    EXPIRED_DISCOUNT_ERROR: CHECKOUT_ERRORS.EXPIRED_DISCOUNT.copy,
    USAGE_REACHED_DISCOUNT_ERROR: CHECKOUT_ERRORS.USAGE_REACHED_DISCOUNT.copy,
    REQUIREMENTS_NOT_MET_DISCOUNT_ERROR: CHECKOUT_ERRORS.REQUIREMENTS_NOT_MET_DISCOUNT.copy,
    COMMERCE_ADD_TO_CART_BUTTON_DEFAULT: 'Add to Cart',
    COMMERCE_ADD_TO_CART_BUTTON_WAITING: 'Adding to cart...',
    COMMERCE_BUY_NOW_BUTTON_DEFAULT: 'Buy now',
    SUBSCRIPTION_BUTTON_DEFAULT: 'Subscribe now',
    QUANTITY_ERROR: 'Product is not available in this quantity.',
    GENERAL_ERROR: 'Something went wrong when adding this item to the cart.',
    CHECKOUT_ERROR: 'Checkout is disabled on this site.',
    CART_ORDER_MIN_ERROR: 'The order minimum was not met. Add more items to your cart to continue.',
    SUBSCRIPTION_ERR: 'Before you purchase, please use your email invite to verify your address so we can send order updates.',
    ADD_TO_CART_QUANTITY_ERROR: 'Product is not available in this quantity.',
    ADD_TO_CART_GENERAL_ERROR: 'Something went wrong when adding this item to the cart.',
    ADD_TO_CART_MIXED_ERROR: 'You can’t purchase another product with a subscription.',
    BUY_NOW_ERROR: 'Something went wrong when trying to purchase this item.',
    CHECKOUT_DISABLED_ERROR: 'Checkout is disabled on this site.',
    SELECT_ALL_OPTIONS: 'Please select an option in each set.'
};

//# sourceMappingURL=data:application/json;base64,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

}),
37693: (function (__unused_webpack_module, exports) {
"use strict";
// Note: These currencies are extracted by getting Stripe compatible currencies with:
//
// curl https://api.stripe.com/v1/country_specs\?limit\=100 -u $STRIPE_TEST_KEY: -G \
//   | jq '.data|.[]|.supported_payment_currencies|.[]' \
//   | sort \
//   | uniq
//
// And then populating in the names from ISO 4217:
//
// Digit counts are also added. Stripe is treated as the source-of-truth for that number, even though their
// numbers are often at odds with ISO 4217. Notes:
//
//  - CVE had a subunit (centavo), that has been discontinued. The ISO reflects this, but stripe sticks
//    with 2 digits, since the currency is still commonly formatted as "1$00". ¯\_(ツ)_/¯
//  - ISK had a subunit (eyrir) that was obsoleted in 2003, but Stripe sticks with 2 digits instead of
//    the ISO's 0.
//  - MGA is strange, since its smallest denomination is a 1/5th piece (the Iraimbilanja), but is
//    represented as a decimal, so the currency goes "1.3, 1.4, 2.0, ...". Stripe dodges this strangeness
//    by ignoring that minimum unit, and so do we, since it has so little value.
//  - UGX had a subunit (cent) that was discontinued in 2013. Stripe still counts it, tho, even though
//    that cent is work 1/350000th of a penny.

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "stripeCurrencyList", ({
    enumerable: true,
    get: function() {
        return stripeCurrencyList;
    }
}));
const stripeCurrencyList = [
    /*
   * ----------------------------------------------------------------------------
   * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
   * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
   * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
   * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
   *
   * This const is duplicated to @packages/systems/core/constants/SharedConfig.js
   * to avoid bundling this entire SharedConfig file in the webflow.js published
   * site bundle. Once we have support for bundling for the Dashboard (this
   * config is injected in to window.SharedConfig for angular), we should
   * be able to delete the const in SharedConfig and use the commerce/consts
   * package whenever `stripeCurrencyList` const is needed.
   *
   * In the meantime, if you make changes to this const, please make sure to
   * update in the other location as well.
   *
   * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
   * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
   * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
   * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
   * ----------------------------------------------------------------------------
   */ {
        code: 'AED',
        digits: 2,
        minCharge: 0,
        name: 'United Arab Emirates Dirham'
    },
    {
        code: 'AFN',
        digits: 2,
        minCharge: 0,
        name: 'Afghanistan Afghani'
    },
    {
        code: 'ALL',
        digits: 2,
        minCharge: 0,
        name: 'Albanian Lek'
    },
    {
        code: 'AMD',
        digits: 2,
        minCharge: 0,
        name: 'Armenia Dram'
    },
    {
        code: 'ANG',
        digits: 2,
        minCharge: 0,
        name: 'Netherlands Antillean Gulden'
    },
    {
        code: 'AOA',
        digits: 2,
        minCharge: 0,
        name: 'Angola Kwanza'
    },
    {
        code: 'ARS',
        digits: 2,
        minCharge: 0,
        name: 'Argentine Peso'
    },
    {
        code: 'AUD',
        digits: 2,
        minCharge: 50,
        name: 'Australian Dollar'
    },
    {
        code: 'AWG',
        digits: 2,
        minCharge: 0,
        name: 'Aruban Florin'
    },
    {
        code: 'AZN',
        digits: 2,
        minCharge: 0,
        name: 'Azerbaijan Manat'
    },
    {
        code: 'BAM',
        digits: 2,
        minCharge: 0,
        name: 'Bosnia and Herzegovina Convertible Marka'
    },
    {
        code: 'BBD',
        digits: 2,
        minCharge: 0,
        name: 'Barbadian Dollar'
    },
    {
        code: 'BDT',
        digits: 2,
        minCharge: 0,
        name: 'Bangladeshi Taka'
    },
    {
        code: 'BGN',
        digits: 2,
        minCharge: 0,
        name: 'Bulgaria Lev'
    },
    {
        code: 'BIF',
        digits: 0,
        minCharge: 0,
        name: 'Burundian Franc'
    },
    {
        code: 'BMD',
        digits: 2,
        minCharge: 0,
        name: 'Bermudian Dollar'
    },
    {
        code: 'BND',
        digits: 2,
        minCharge: 0,
        name: 'Brunei Dollar'
    },
    {
        code: 'BOB',
        digits: 2,
        minCharge: 0,
        name: 'Bolivian Boliviano'
    },
    {
        code: 'BRL',
        digits: 2,
        minCharge: 50,
        name: 'Brazilian Real'
    },
    {
        code: 'BSD',
        digits: 2,
        minCharge: 0,
        name: 'Bahamian Dollar'
    },
    {
        code: 'BWP',
        digits: 2,
        minCharge: 0,
        name: 'Botswana Pula'
    },
    {
        code: 'BZD',
        digits: 2,
        minCharge: 0,
        name: 'Belize Dollar'
    },
    {
        code: 'CAD',
        digits: 2,
        minCharge: 50,
        name: 'Canadian Dollar'
    },
    {
        code: 'CDF',
        digits: 2,
        minCharge: 0,
        name: 'Congo/Kinshasa Franc'
    },
    {
        code: 'CHF',
        digits: 2,
        minCharge: 50,
        name: 'Swiss Franc'
    },
    {
        code: 'CLP',
        digits: 0,
        minCharge: 0,
        name: 'Chilean Peso'
    },
    {
        code: 'CNY',
        digits: 2,
        minCharge: 0,
        name: 'Chinese Renminbi Yuan'
    },
    {
        code: 'COP',
        digits: 2,
        minCharge: 0,
        name: 'Colombian Peso'
    },
    {
        code: 'CRC',
        digits: 2,
        minCharge: 0,
        name: 'Costa Rican Colón'
    },
    {
        code: 'CVE',
        digits: 2,
        minCharge: 0,
        name: 'Cape Verdean Escudo'
    },
    {
        code: 'CZK',
        digits: 2,
        minCharge: 0,
        name: 'Czech Koruna'
    },
    {
        code: 'DJF',
        digits: 0,
        minCharge: 0,
        name: 'Djiboutian Franc'
    },
    {
        code: 'DKK',
        digits: 2,
        minCharge: 250,
        name: 'Danish Krone'
    },
    {
        code: 'DOP',
        digits: 2,
        minCharge: 0,
        name: 'Dominican Peso'
    },
    {
        code: 'DZD',
        digits: 2,
        minCharge: 0,
        name: 'Algerian Dinar'
    },
    {
        code: 'EGP',
        digits: 2,
        minCharge: 0,
        name: 'Egyptian Pound'
    },
    {
        code: 'ETB',
        digits: 2,
        minCharge: 0,
        name: 'Ethiopian Birr'
    },
    {
        code: 'EUR',
        digits: 2,
        minCharge: 50,
        name: 'Euro'
    },
    {
        code: 'FJD',
        digits: 2,
        minCharge: 0,
        name: 'Fijian Dollar'
    },
    {
        code: 'FKP',
        digits: 2,
        minCharge: 0,
        name: 'Falkland Islands Pound'
    },
    {
        code: 'GBP',
        digits: 2,
        minCharge: 30,
        name: 'British Pound'
    },
    {
        code: 'GEL',
        digits: 2,
        minCharge: 0,
        name: 'Georgia Lari'
    },
    {
        code: 'GIP',
        digits: 2,
        minCharge: 0,
        name: 'Gibraltar Pound'
    },
    {
        code: 'GMD',
        digits: 2,
        minCharge: 0,
        name: 'Gambian Dalasi'
    },
    {
        code: 'GNF',
        digits: 0,
        minCharge: 0,
        name: 'Guinean Franc'
    },
    {
        code: 'GTQ',
        digits: 2,
        minCharge: 0,
        name: 'Guatemalan Quetzal'
    },
    {
        code: 'GYD',
        digits: 2,
        minCharge: 0,
        name: 'Guyanese Dollar'
    },
    {
        code: 'HKD',
        digits: 2,
        minCharge: 400,
        name: 'Hong Kong Dollar'
    },
    {
        code: 'HNL',
        digits: 2,
        minCharge: 0,
        name: 'Honduran Lempira'
    },
    {
        code: 'HRK',
        digits: 2,
        minCharge: 0,
        name: 'Croatian Kuna'
    },
    {
        code: 'HTG',
        digits: 2,
        minCharge: 0,
        name: 'Haitian Gourde'
    },
    {
        code: 'HUF',
        digits: 2,
        minCharge: 0,
        name: 'Hungarian Forint'
    },
    {
        code: 'IDR',
        digits: 2,
        minCharge: 0,
        name: 'Indonesian Rupiah'
    },
    {
        code: 'ILS',
        digits: 2,
        minCharge: 0,
        name: 'Israeli New Sheqel'
    },
    {
        code: 'INR',
        digits: 2,
        minCharge: 50,
        name: 'Indian Rupee'
    },
    {
        code: 'ISK',
        digits: 2,
        minCharge: 0,
        name: 'Icelandic Króna'
    },
    {
        code: 'JMD',
        digits: 2,
        minCharge: 0,
        name: 'Jamaican Dollar'
    },
    {
        code: 'JPY',
        digits: 0,
        minCharge: 50,
        name: 'Japanese Yen'
    },
    {
        code: 'KES',
        digits: 2,
        minCharge: 0,
        name: 'Kenyan Shilling'
    },
    {
        code: 'KGS',
        digits: 2,
        minCharge: 0,
        name: 'Kyrgyzstan Som'
    },
    {
        code: 'KHR',
        digits: 2,
        minCharge: 0,
        name: 'Cambodian Riel'
    },
    {
        code: 'KMF',
        digits: 0,
        minCharge: 0,
        name: 'Comorian Franc'
    },
    {
        code: 'KRW',
        digits: 0,
        minCharge: 0,
        name: 'South Korean Won'
    },
    {
        code: 'KYD',
        digits: 2,
        minCharge: 0,
        name: 'Cayman Islands Dollar'
    },
    {
        code: 'KZT',
        digits: 2,
        minCharge: 0,
        name: 'Kazakhstani Tenge'
    },
    {
        code: 'LAK',
        digits: 2,
        minCharge: 0,
        name: 'Lao Kip'
    },
    {
        code: 'LBP',
        digits: 2,
        minCharge: 0,
        name: 'Lebanese Pound'
    },
    {
        code: 'LKR',
        digits: 2,
        minCharge: 0,
        name: 'Sri Lankan Rupee'
    },
    {
        code: 'LRD',
        digits: 2,
        minCharge: 0,
        name: 'Liberian Dollar'
    },
    {
        code: 'LSL',
        digits: 2,
        minCharge: 0,
        name: 'Lesotho Loti'
    },
    {
        code: 'MAD',
        digits: 2,
        minCharge: 0,
        name: 'Moroccan Dirham'
    },
    {
        code: 'MDL',
        digits: 2,
        minCharge: 0,
        name: 'Moldovan Leu'
    },
    {
        code: 'MGA',
        digits: 0,
        minCharge: 0,
        name: 'Madagascar Ariary'
    },
    {
        code: 'MKD',
        digits: 2,
        minCharge: 0,
        name: 'Macedonia Denar'
    },
    {
        code: 'MMK',
        digits: 2,
        minCharge: 0,
        name: 'Myanmar (Burma) Kyat'
    },
    {
        code: 'MNT',
        digits: 2,
        minCharge: 0,
        name: 'Mongolian Tögrög'
    },
    {
        code: 'MOP',
        digits: 2,
        minCharge: 0,
        name: 'Macanese Pataca'
    },
    {
        code: 'MRO',
        digits: 2,
        minCharge: 0,
        name: 'Mauritanian Ouguiya'
    },
    {
        code: 'MUR',
        digits: 2,
        minCharge: 0,
        name: 'Mauritian Rupee'
    },
    {
        code: 'MVR',
        digits: 2,
        minCharge: 0,
        name: 'Maldivian Rufiyaa'
    },
    {
        code: 'MWK',
        digits: 2,
        minCharge: 0,
        name: 'Malawian Kwacha'
    },
    {
        code: 'MXN',
        digits: 2,
        minCharge: 1000,
        name: 'Mexican Peso'
    },
    {
        code: 'MYR',
        digits: 2,
        minCharge: 200,
        name: 'Malaysian Ringgit'
    },
    {
        code: 'MZN',
        digits: 2,
        minCharge: 0,
        name: 'Mozambique Metical'
    },
    {
        code: 'NAD',
        digits: 2,
        minCharge: 0,
        name: 'Namibian Dollar'
    },
    {
        code: 'NGN',
        digits: 2,
        minCharge: 0,
        name: 'Nigerian Naira'
    },
    {
        code: 'NIO',
        digits: 2,
        minCharge: 0,
        name: 'Nicaraguan Córdoba'
    },
    {
        code: 'NOK',
        digits: 2,
        minCharge: 300,
        name: 'Norwegian Krone'
    },
    {
        code: 'NPR',
        digits: 2,
        minCharge: 0,
        name: 'Nepalese Rupee'
    },
    {
        code: 'NZD',
        digits: 2,
        minCharge: 50,
        name: 'New Zealand Dollar'
    },
    {
        code: 'PAB',
        digits: 2,
        minCharge: 0,
        name: 'Panamanian Balboa'
    },
    {
        code: 'PEN',
        digits: 2,
        minCharge: 0,
        name: 'Peruvian Nuevo Sol'
    },
    {
        code: 'PGK',
        digits: 2,
        minCharge: 0,
        name: 'Papua New Guinean Kina'
    },
    {
        code: 'PHP',
        digits: 2,
        minCharge: 0,
        name: 'Philippine Peso'
    },
    {
        code: 'PKR',
        digits: 2,
        minCharge: 0,
        name: 'Pakistani Rupee'
    },
    {
        code: 'PLN',
        digits: 2,
        minCharge: 200,
        name: 'Polish Złoty'
    },
    {
        code: 'PYG',
        digits: 0,
        minCharge: 0,
        name: 'Paraguayan Guaraní'
    },
    {
        code: 'QAR',
        digits: 2,
        minCharge: 0,
        name: 'Qatari Riyal'
    },
    {
        code: 'RON',
        digits: 2,
        minCharge: 0,
        name: 'Romania Leu'
    },
    {
        code: 'RSD',
        digits: 2,
        minCharge: 0,
        name: 'Serbia Dinar'
    },
    {
        code: 'RUB',
        digits: 2,
        minCharge: 0,
        name: 'Russian Ruble'
    },
    {
        code: 'RWF',
        digits: 0,
        minCharge: 0,
        name: 'Rwanda Franc'
    },
    {
        code: 'SAR',
        digits: 2,
        minCharge: 0,
        name: 'Saudi Riyal'
    },
    {
        code: 'SBD',
        digits: 2,
        minCharge: 0,
        name: 'Solomon Islands Dollar'
    },
    {
        code: 'SCR',
        digits: 2,
        minCharge: 0,
        name: 'Seychellois Rupee'
    },
    {
        code: 'SEK',
        digits: 2,
        minCharge: 300,
        name: 'Swedish Krona'
    },
    {
        code: 'SGD',
        digits: 2,
        minCharge: 50,
        name: 'Singapore Dollar'
    },
    {
        code: 'SHP',
        digits: 2,
        minCharge: 0,
        name: 'Saint Helenian Pound'
    },
    {
        code: 'SLL',
        digits: 2,
        minCharge: 0,
        name: 'Sierra Leonean Leone'
    },
    {
        code: 'SOS',
        digits: 2,
        minCharge: 0,
        name: 'Somali Shilling'
    },
    {
        code: 'SRD',
        digits: 2,
        minCharge: 0,
        name: 'Suriname Dollar'
    },
    {
        code: 'STD',
        digits: 2,
        minCharge: 0,
        name: 'São Tomé and Príncipe Dobra'
    },
    {
        code: 'SZL',
        digits: 2,
        minCharge: 0,
        name: 'Swazi Lilangeni'
    },
    {
        code: 'THB',
        digits: 2,
        minCharge: 0,
        name: 'Thai Baht'
    },
    {
        code: 'TJS',
        digits: 2,
        minCharge: 0,
        name: 'Tajikistan Somoni'
    },
    {
        code: 'TOP',
        digits: 2,
        minCharge: 0,
        name: 'Tongan Paʻanga'
    },
    {
        code: 'TRY',
        digits: 2,
        minCharge: 0,
        name: 'Turkey Lira'
    },
    {
        code: 'TTD',
        digits: 2,
        minCharge: 0,
        name: 'Trinidad and Tobago Dollar'
    },
    {
        code: 'TWD',
        digits: 2,
        minCharge: 0,
        name: 'New Taiwan Dollar'
    },
    {
        code: 'TZS',
        digits: 2,
        minCharge: 0,
        name: 'Tanzanian Shilling'
    },
    {
        code: 'UAH',
        digits: 2,
        minCharge: 0,
        name: 'Ukrainian Hryvnia'
    },
    {
        code: 'UGX',
        digits: 0,
        minCharge: 0,
        name: 'Ugandan Shilling'
    },
    {
        code: 'USD',
        digits: 2,
        minCharge: 50,
        name: 'United States Dollar'
    },
    {
        code: 'UYU',
        digits: 2,
        minCharge: 0,
        name: 'Uruguayan Peso'
    },
    {
        code: 'UZS',
        digits: 2,
        minCharge: 0,
        name: 'Uzbekistani Som'
    },
    {
        code: 'VND',
        digits: 0,
        minCharge: 0,
        name: 'Vietnamese Đồng'
    },
    {
        code: 'VUV',
        digits: 0,
        minCharge: 0,
        name: 'Vanuatu Vatu'
    },
    {
        code: 'WST',
        digits: 2,
        minCharge: 0,
        name: 'Samoan Tala'
    },
    {
        code: 'XAF',
        digits: 0,
        minCharge: 0,
        name: 'Central African Cfa Franc'
    },
    {
        code: 'XCD',
        digits: 2,
        minCharge: 0,
        name: 'East Caribbean Dollar'
    },
    {
        code: 'XOF',
        digits: 0,
        minCharge: 0,
        name: 'West African Cfa Franc'
    },
    {
        code: 'XPF',
        digits: 0,
        minCharge: 0,
        name: 'Cfp Franc'
    },
    {
        code: 'YER',
        digits: 2,
        minCharge: 0,
        name: 'Yemeni Rial'
    },
    {
        code: 'ZAR',
        digits: 2,
        minCharge: 0,
        name: 'South African Rand'
    },
    {
        code: 'ZMW',
        digits: 2,
        minCharge: 0,
        name: 'Zambia Kwacha'
    }
];

//# sourceMappingURL=data:application/json;base64,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

}),
82988: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    _invalid: function() {
        return _invalid;
    },
    convertPaypalAmountToWFPrice: function() {
        return convertPaypalAmountToWFPrice;
    },
    convertWFPriceToPaypalAmount: function() {
        return convertWFPriceToPaypalAmount;
    },
    convertWFPriceToPaypalAmountWithBreakdown: function() {
        return convertWFPriceToPaypalAmountWithBreakdown;
    },
    currencyInfoByCode: function() {
        return currencyInfoByCode;
    },
    currencyInfoByCodePaypal: function() {
        return currencyInfoByCodePaypal;
    },
    equalPrice: function() {
        return equalPrice;
    },
    formatPrice: function() {
        return formatPrice;
    },
    getCurrencyInfo: function() {
        return getCurrencyInfo;
    },
    getCurrencyInfoPaypal: function() {
        return getCurrencyInfoPaypal;
    },
    getCurrencySymbol: function() {
        return getCurrencySymbol;
    },
    intToUnsafeFloat: function() {
        return intToUnsafeFloat;
    },
    parsePrice: function() {
        return parsePrice;
    },
    renderPrice: function() {
        return renderPrice;
    },
    scalePrice: function() {
        return scalePrice;
    },
    subtractPrice: function() {
        return subtractPrice;
    },
    sumPrice: function() {
        return sumPrice;
    },
    unsafeFloatToInt: function() {
        return unsafeFloatToInt;
    },
    validatePrice: function() {
        return validatePrice;
    },
    zeroUnitPaypal: function() {
        return zeroUnitPaypal;
    },
    zeroUnitWF: function() {
        return zeroUnitWF;
    }
});
const _keyBy = /*#__PURE__*/ _interop_require_default(__webpack_require__(3350));
const _memoize = /*#__PURE__*/ _interop_require_default(__webpack_require__(84984));
const _isString = /*#__PURE__*/ _interop_require_default(__webpack_require__(81098));
const _isNumber = /*#__PURE__*/ _interop_require_default(__webpack_require__(91464));
const _constants = __webpack_require__(10873);
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const currencyInfoByCode = (0, _keyBy.default)(_constants.stripeCurrencyList, 'code');
const currencyInfoByCodePaypal = (0, _keyBy.default)(_constants.paypalCurrencyList, 'code');
function getCurrencyInfo(code, platform = 'stripe') {
    if (isValidCurrency(code)) {
        return platform === 'stripe' ? // @ts-expect-error
        currencyInfoByCode[code.toUpperCase()] : // @ts-expect-error
        currencyInfoByCodePaypal[code.toUpperCase()];
    }
    return {
        code: '???',
        digits: 2,
        minCharge: 0,
        name: `Unknown currency`
    };
}
function getCurrencyInfoPaypal(code) {
    return getCurrencyInfo(code, 'paypal');
}
const isValidCurrency = (currencyCode)=>typeof currencyCode === 'string' && currencyInfoByCode.hasOwnProperty(currencyCode.toUpperCase());
class NullNumberFormat {
    format(_value) {
        return 'NaN';
    }
}
// @ts-expect-error - TS2322 - Type '((unit?: string | null | undefined, currencyDisplay?: CurrencyDisplayType) => NullNumberFormat) & MemoizedFunction' is not assignable to type '(unit?: string | null | undefined, arg2?: CurrencyDisplayType | null | undefined) => NullNumberFormat | NumberFormat'.
const getNumberFormat = (0, _memoize.default)((unit, currencyDisplay = 'symbol')=>// HACK: for some reason, GraphQL is returning a currency of '???' for null
    // prices; we're temporarily glossing over this fact, and will address the
    // backend at a later time..
    unit != null && isValidCurrency(unit) ? new Intl.NumberFormat('en-US', {
        currency: unit,
        style: 'currency',
        currencyDisplay
    }) : new NullNumberFormat(), /* cache key function **/ (unit, currencyDisplay = 'symbol')=>{
    return [
        String(unit),
        currencyDisplay
    ].join('::');
});
const getCurrencySymbol = (unit)=>{
    // As Intl.Numberformat.prototype.formatToParts is still experimental
    const symbol = String(getNumberFormat(unit).format(0)).match(/^([^0-9\s]*)/);
    return symbol ? symbol[0] : unit;
};
const unsafeFloatToInt = (floatValue, currency, round = Math.round)=>{
    const currencyInfo = typeof currency === 'object' ? currency : getCurrencyInfo(currency);
    return round(floatValue * Math.pow(10, currencyInfo.digits));
};
const intToUnsafeFloat = (intValue, currency)=>{
    const currencyInfo = typeof currency === 'object' ? currency : getCurrencyInfo(currency);
    return intValue / Math.pow(10, currencyInfo.digits);
};
function renderPrice(price, opts = {}) {
    const { isoFormat = false, noCurrency = false } = opts;
    price = validatePrice(price) ? price : _invalid();
    const normal_value = Number(price.value);
    const currencyInfo = getCurrencyInfo(price.unit);
    const float_value = intToUnsafeFloat(normal_value, currencyInfo);
    if (Number.isNaN(float_value)) {
        return 'NaN';
    }
    if (noCurrency) {
        return String(float_value);
    }
    const fmt = getNumberFormat(price.unit, isoFormat ? 'code' : 'symbol');
    return fmt.format(float_value);
}
function formatPrice(price) {
    price = validatePrice(price) ? price : _invalid();
    const string = renderPrice(price);
    return {
        unit: price.unit,
        value: price.value,
        string
    };
}
function validatePrice(a) {
    if (!a || typeof a !== 'object') {
        return false;
    }
    // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'object'.
    if (!(0, _isNumber.default)(a.value)) {
        return false;
    }
    // @ts-expect-error - TS2339 - Property 'unit' does not exist on type 'object'.
    if (!(0, _isString.default)(a.unit)) {
        return false;
    }
    // @ts-expect-error - TS2339 - Property 'unit' does not exist on type 'object'.
    if (!isValidCurrency(a.unit)) {
        return false;
    }
    return true;
}
function sumPrice(a, b) {
    if (!validatePrice(a) || !validatePrice(b)) {
        return _invalid();
    }
    // No defined behavior, if the Prices don't have a common currency...
    if (a.unit !== b.unit) {
        return _invalid();
    }
    return {
        value: a.value + b.value,
        unit: a.unit
    };
}
function subtractPrice(a, b) {
    if (!validatePrice(a) || !validatePrice(b)) {
        return _invalid();
    }
    // No defined behavior, if the Prices don't have a common currency...
    if (a.unit !== b.unit) {
        return _invalid();
    }
    return {
        value: a.value - b.value,
        unit: a.unit
    };
}
function scalePrice(a, scalar) {
    if (!validatePrice(a) || !(0, _isNumber.default)(scalar)) {
        return _invalid();
    }
    const value = Math.round(a.value * scalar);
    const unit = a.unit;
    return {
        value,
        unit
    };
}
function equalPrice(a, b) {
    return Boolean(a && b && a.value === b.value && a.unit === b.unit);
}
function parsePrice(priceString, unit, fallback) {
    if (typeof priceString !== 'string') {
        throw new Error('parsePrice must be called with a string');
    }
    if (!isValidCurrency(unit)) {
        throw new Error(`parsePrice called with invalid currency ${unit}`);
    }
    if (!priceString) {
        return fallback;
    }
    // TODO: Fails on
    // 1,000.00 -> NaN
    // 0,99 -> NaN
    // Also it passes numbers we shouldn't allow:
    // 0x11 -> 17
    // 0b11 -> 3
    const rawNumber = Number(priceString);
    if (Number.isNaN(rawNumber)) {
        return fallback;
    }
    return {
        value: unsafeFloatToInt(rawNumber, unit),
        unit
    };
}
function _invalid() {
    return {
        value: NaN,
        unit: '???'
    };
}
function zeroUnitWF(unit) {
    return {
        unit,
        value: 0
    };
}
function zeroUnitPaypal(unit) {
    return convertWFPriceToPaypalAmount(zeroUnitWF(unit));
}
function convertWFPriceToPaypalAmountWithBreakdown(orderPrices) {
    const { total, subtotal, shipping, tax, discount, discountShipping } = orderPrices;
    const convertOrZero = (price, scalar)=>price ? convertWFPriceToPaypalAmount(price, scalar) : zeroUnitPaypal(total.unit);
    return {
        ...convertWFPriceToPaypalAmount(total),
        breakdown: {
            item_total: convertOrZero(subtotal),
            shipping: convertOrZero(shipping),
            tax_total: convertOrZero(tax),
            discount: convertOrZero(discount, -1),
            shipping_discount: convertOrZero(discountShipping, -1)
        }
    };
}
function convertWFPriceToPaypalAmount(a, scalar) {
    // TODO:
    // - May have to account for in-country PayPal accounts only support for some currencies
    const unitInfo = getCurrencyInfoPaypal(a.unit);
    const wfValue = scalar ? scalePrice(a, scalar).value : a.value;
    const value = intToUnsafeFloat(wfValue, unitInfo).toFixed(unitInfo.digits);
    return {
        currency_code: a.unit,
        value
    };
}
function convertPaypalAmountToWFPrice(a) {
    // TODO:
    // - May have to account for in-country PayPal accounts only support for some currencies
    const unitInfo = getCurrencyInfoPaypal(a.currency_code);
    const value = unsafeFloatToInt(parseFloat(a.value), unitInfo);
    return {
        unit: a.currency_code,
        value
    };
}

//# sourceMappingURL=data:application/json;base64,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

}),
60937: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
_export_star(__webpack_require__(82988), exports);
_export_star(__webpack_require__(9807), exports);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gJy4vQ3VycmVuY3lVdGlscyc7XG5leHBvcnQgKiBmcm9tICcuL3JlbmRlclByaWNlJztcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O3FCQUFjO3FCQUNBIn0=

}),
9807: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    formatPriceFromSettings: function() {
        return formatPriceFromSettings;
    },
    getCurrencySettingsFromCommerceSettings: function() {
        return getCurrencySettingsFromCommerceSettings;
    },
    renderAmountFromSettings: function() {
        return renderAmountFromSettings;
    },
    renderPriceFromSettings: function() {
        return renderPriceFromSettings;
    }
});
const _get = /*#__PURE__*/ _interop_require_default(__webpack_require__(24738));
const _isInteger = /*#__PURE__*/ _interop_require_default(__webpack_require__(80023));
const _accounting = __webpack_require__(41471);
const _simpleReplaceTokens = __webpack_require__(30805);
const _CurrencyUtils = __webpack_require__(82988);
const _memo = __webpack_require__(23056);
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function formatPriceFromSettings(price, currencySettings) {
    price = (0, _CurrencyUtils.validatePrice)(price) ? price : (0, _CurrencyUtils._invalid)();
    const string = renderPriceFromSettings(price, currencySettings);
    return {
        unit: price.unit,
        value: price.value,
        string
    };
}
const getCurrencySettingsFromCommerceSettings = (0, _memo.weakMemo)((commerceSettings)=>{
    const getTheStuff = typeof commerceSettings.getIn === 'function' ? (keyPath, defaultValue)=>// @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
        commerceSettings.getIn(keyPath, defaultValue) : (keyPath, defaultValue)=>(0, _get.default)(commerceSettings, keyPath, defaultValue);
    return {
        hideDecimalForWholeNumbers: getTheStuff([
            'defaultCurrencyFormat',
            'hideDecimalForWholeNumbers'
        ], false),
        fractionDigits: getTheStuff([
            'defaultCurrencyFormat',
            'fractionDigits'
        ], 2),
        template: getTheStuff([
            'defaultCurrencyFormat',
            'template'
        ], ''),
        decimal: getTheStuff([
            'defaultCurrencyFormat',
            'decimal'
        ], '.'),
        group: getTheStuff([
            'defaultCurrencyFormat',
            'group'
        ], ','),
        symbol: getTheStuff([
            'defaultCurrencyFormat',
            'symbol'
        ], '$'),
        currencyCode: getTheStuff([
            'defaultCurrency'
        ], 'USD')
    };
});
const _nonBreakingSpace = String.fromCharCode(160);
const _replaceAllSpaceWithNBSP = (str)=>str.replace(/\s/g, _nonBreakingSpace);
function renderAmountFromSettings(amount, // @ts-expect-error - TS2739 - Type '{}' is missing the following properties from type '{ fractionDigits: number; hideDecimalForWholeNumbers: boolean; decimal: string; group: string; }': fractionDigits, hideDecimalForWholeNumbers, decimal, group
amountSettings = {}) {
    if (typeof amount === 'undefined') {
        return '';
    }
    if (typeof amount === 'string') {
        if (amount === '∞') {
            return amount;
        }
        // This should most likely never happen, but it's a flow guard for the rest of the function
        throw new Error(`amount has type string: got ${amount}, expected ∞`);
    }
    // Price.value is always whole number. For example, USD is represented in cents
    // this is because fractionDigits = 2. To convert to a jsNumber we need to move
    // the decimal to the left fractionDigits number of times. (we can do this
    // with division)
    const jsValue = amount / parseFloat(`1${'0'.repeat(amountSettings.fractionDigits || 0)}`);
    const precision = (0, _isInteger.default)(jsValue) && amountSettings.hideDecimalForWholeNumbers ? 0 : amountSettings.fractionDigits;
    return (0, _accounting.formatMoney)(jsValue, {
        symbol: '',
        decimal: amountSettings.decimal,
        precision,
        thousand: amountSettings.group
    });
}
function renderPriceFromSettings(price, // @ts-expect-error - TS2740 - Type '{}' is missing the following properties from type 'CurrencySettings': hideDecimalForWholeNumbers, fractionDigits, template, decimal, and 3 more.
currencySettings = {}, renderOpts = {}) {
    const { template, currencyCode } = currencySettings;
    // fall back to old renderPrice if some currency settings don't exist
    // snapshots > ecommerce > ecommerceIsOn for Cypress tests currently doesn't have currency settings
    // we also want to fallback to the old renderPrice in the event that a price's unit
    // does not match the currencyCode for the currency settings
    if (!template || price.unit !== currencyCode) {
        return (0, _CurrencyUtils.renderPrice)(price);
    }
    return (price.value < 0 ? '−' : '') + // negative sign to appear before currency symbol e.g., -$ 5.00 USD
    (0, _simpleReplaceTokens.simpleReplaceTokens)((renderOpts.breakingWhitespace ? currencySettings.template : _replaceAllSpaceWithNBSP(currencySettings.template)) || '', {
        amount: renderAmountFromSettings(Math.abs(price.value), currencySettings),
        symbol: currencySettings.symbol,
        currencyCode: currencySettings.currencyCode
    });
}

//# sourceMappingURL=data:application/json;base64,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

}),
71847: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    extractToken: function() {
        return extractToken;
    },
    getAmountTokenPattern: function() {
        return getAmountTokenPattern;
    },
    getCatchAllTokenPattern: function() {
        return getCatchAllTokenPattern;
    },
    getExternalTokenPattern: function() {
        return getExternalTokenPattern;
    },
    getWfTokenPattern: function() {
        return getWfTokenPattern;
    },
    parseTokenJson: function() {
        return parseTokenJson;
    },
    parseTokenJsonFromMatch: function() {
        return parseTokenJsonFromMatch;
    },
    stripLegacyShorthandSuffix: function() {
        return stripLegacyShorthandSuffix;
    }
});
const _unescape = /*#__PURE__*/ _interop_require_default(__webpack_require__(94891));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const getWfTokenPattern = function() {
    return /{{\s*wf\s*({.*?})\s*}}/g;
};
const getCatchAllTokenPattern = function() {
    return /{{\s*(.*?)\s*}}/g;
};
const getExternalTokenPattern = function() {
    return /{\\{(\s*.*?\s*)}}/g;
};
const getAmountTokenPattern = ()=>{
    return /{{\s*wf\s*({&quot;path&quot;:&quot;amount&quot;,&quot;type&quot;:&quot;CommercePrice&quot;\\})\s*}}/;
};
function parseTokenJsonFromMatch(match) {
    let token;
    let isEscaped = false;
    try {
        const replacedTrailing = match.replace(/\\}/g, '}');
        const unescaped = (0, _unescape.default)(replacedTrailing);
        // If the trailing backslash is not present in the original match, or if unescaping the match causes it to be
        // different, then the original match is not escaped
        if (match !== replacedTrailing && unescaped !== replacedTrailing) {
            isEscaped = true;
        }
        token = JSON.parse(unescaped);
    } catch (err) {
        return;
    }
    if (!token?.path || !token.type) {
        return; // If path doesn't exist, this JSON string is not a token
    }
    token.isEscaped = isEscaped;
    return token;
}
function parseTokenJson(string) {
    if (string.match(getWfTokenPattern())) {
        let token;
        try {
            token = JSON.parse((0, _unescape.default)(extractToken(string).replace(/\\}/g, '}')));
        } catch (err) {
            return null;
        }
        if (!token || !token.path || !token.type) {
            // If path doesn't exist, this JSON string is not a token
            return null;
        } else {
            return token;
        }
    } else {
        return null;
    }
}
function extractToken(string, { shortHand } = {}) {
    return shortHand ? string.replace(getCatchAllTokenPattern(), (match, subMatch)=>{
        return stripLegacyShorthandSuffix(subMatch);
    }) : string.replace(getWfTokenPattern(), '$1');
}
function stripLegacyShorthandSuffix(tokenPath) {
    return tokenPath.split(':').map((part)=>part.split('.')[0]).join(':');
}

//# sourceMappingURL=data:application/json;base64,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

}),
30805: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "simpleReplaceTokens", ({
    enumerable: true,
    get: function() {
        return simpleReplaceTokens;
    }
}));
const _isFunction = /*#__PURE__*/ _interop_require_default(__webpack_require__(56644));
const _get = /*#__PURE__*/ _interop_require_default(__webpack_require__(24738));
const _shared = __webpack_require__(71847);
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function simpleReplaceTokens(replaceable, item) {
    return replaceable.replace((0, _shared.getWfTokenPattern)(), function(match) {
        const token = (0, _shared.parseTokenJson)(match) || {};
        // @ts-expect-error - TS2339 - Property 'path' does not exist on type '{}'.
        const path = token.path.split('.');
        return (0, _isFunction.default)(item.getIn) ? item.getIn(path, '') : (0, _get.default)(item, path, '');
    });
}

//# sourceMappingURL=data:application/json;base64,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

}),
29197: (function (__unused_webpack_module, exports) {
"use strict";
// Internal useful constants.

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CLASS_NAME_W_DYN_BIND_EMPTY: function() {
        return CLASS_NAME_W_DYN_BIND_EMPTY;
    },
    COLLECTION_LIST_QUERY_MODES: function() {
        return COLLECTION_LIST_QUERY_MODES;
    },
    COLLECTION_TYPES: function() {
        return COLLECTION_TYPES;
    },
    CONDITION_INVISIBLE_CLASS: function() {
        return CONDITION_INVISIBLE_CLASS;
    },
    DATETIME_FORMAT_OPTIONS: function() {
        return DATETIME_FORMAT_OPTIONS;
    },
    DATE_FORMAT_OPTIONS: function() {
        return DATE_FORMAT_OPTIONS;
    },
    DEFAULT_NESTED_COLLECTION_LIST_LIMIT: function() {
        return DEFAULT_NESTED_COLLECTION_LIST_LIMIT;
    },
    FUTURE: function() {
        return FUTURE;
    },
    MIN_COLLECTION_LIST_OFFSET: function() {
        return MIN_COLLECTION_LIST_OFFSET;
    },
    NON_EXISTING_ITEM_ID: function() {
        return NON_EXISTING_ITEM_ID;
    },
    PAST: function() {
        return PAST;
    },
    QUERY_FILTER_FOR_STATES: function() {
        return QUERY_FILTER_FOR_STATES;
    },
    SCHEDULED_PUBLISH_GRACE_PERIOD_IN_MS: function() {
        return SCHEDULED_PUBLISH_GRACE_PERIOD_IN_MS;
    },
    SCHEDULED_PUBLISH_GRANULARITY_IN_MIN: function() {
        return SCHEDULED_PUBLISH_GRANULARITY_IN_MIN;
    },
    SCHEDULED_PUBLISH_LIMIT_IN_MS: function() {
        return SCHEDULED_PUBLISH_LIMIT_IN_MS;
    },
    SET_FIELD_MAX_ITEMS: function() {
        return SET_FIELD_MAX_ITEMS;
    },
    SHARED_ALLOWED_FIELD_TYPES: function() {
        return SHARED_ALLOWED_FIELD_TYPES;
    },
    TENSES_ENUM: function() {
        return TENSES_ENUM;
    },
    TENSES_TO_HUMAN_PHRASES_MAP: function() {
        return TENSES_TO_HUMAN_PHRASES_MAP;
    },
    TIME_INTERVALS_ENUM: function() {
        return TIME_INTERVALS_ENUM;
    }
});
const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const YEAR = 365 * DAY;
const TIME_INTERVALS_ENUM = {
    days: 'days',
    weeks: 'weeks',
    months: 'months',
    years: 'years'
};
const FUTURE = 'FUTURE';
const PAST = 'PAST';
const TENSES_ENUM = {
    FUTURE,
    PAST
};
const TENSES_TO_HUMAN_PHRASES_MAP = {
    FUTURE: 'in the future',
    PAST: 'in the past'
};
const CLASS_NAME_W_DYN_BIND_EMPTY = 'w-dyn-bind-empty';
const CONDITION_INVISIBLE_CLASS = 'w-condition-invisible';
const NON_EXISTING_ITEM_ID = '000000000000000000000000';
const QUERY_FILTER_FOR_STATES = {
    ALL: 'ALL',
    ANY: 'ANY'
};
const SET_FIELD_MAX_ITEMS = 25;
const DEFAULT_NESTED_COLLECTION_LIST_LIMIT = 5;
const COLLECTION_LIST_QUERY_MODES = {
    CURATED: 'curated',
    DYNAMIC: 'dynamic'
};
const SCHEDULED_PUBLISH_GRANULARITY_IN_MIN = 5;
const SCHEDULED_PUBLISH_LIMIT_IN_MS = 5 * YEAR;
const SCHEDULED_PUBLISH_GRACE_PERIOD_IN_MS = 30 * MINUTE;
const COLLECTION_TYPES = {
    CATEGORIES: 'CATEGORIES',
    CMS_COLLECTIONS: 'CMS_COLLECTIONS',
    PRODUCTS: 'PRODUCTS',
    SKUS: 'SKUS'
};
const MIN_COLLECTION_LIST_OFFSET = 0;
const SHARED_ALLOWED_FIELD_TYPES = {
    innerHTML: {
        PlainText: 'innerText',
        HighlightedText: 'innerText',
        RichText: 'innerHTML',
        Number: 'innerText',
        Video: 'innerHTML',
        Option: 'innerText',
        Date: 'innerText',
        Phone: 'innerText',
        Email: 'innerText',
        CommercePrice: 'innerHTML',
        Link: 'innerText',
        ImageRef: false,
        FileRef: false,
        ItemRef: false,
        CommercePropValues: 'innerText'
    },
    'style.color': {
        Color: true
    },
    'style.background-color': {
        Color: true
    },
    'style.border-color': {
        Color: true
    },
    'style.background-image': {
        ImageRef: true
    },
    src: [
        'ImageRef'
    ],
    alt: [
        'PlainText',
        'Option',
        'Number',
        'Date',
        'Phone',
        'Email',
        'Video',
        'Link'
    ],
    href: [
        'Phone',
        'Email',
        'Video',
        'Link',
        'FileRef'
    ],
    id: [
        'PlainText'
    ],
    for: [
        'PlainText'
    ],
    value: [
        'Number',
        'PlainText'
    ],
    checked: [
        'Bool'
    ],
    dataWHref: [
        'PlainText',
        'FullSlug'
    ]
};
const DATETIME_FORMAT_OPTIONS = [
    'MMMM D, YYYY',
    'MMMM D, YYYY h:mm A',
    'MMMM D, YYYY H:mm',
    'MMM D, YYYY',
    'MMM D, YYYY h:mm A',
    'MMM D, YYYY H:mm',
    'dddd, MMMM D, YYYY',
    'DD MMMM YYYY',
    'DD MMM YYYY',
    'DD MMM YY',
    'D MMMM YYYY',
    'MMM Do, YYYY',
    'MMMM Do, YYYY',
    'DD.MM.YYYY',
    'M/D/YYYY',
    'M.D.YYYY',
    'D/M/YYYY',
    'D.M.YYYY',
    'M/D/YYYY h:mm A',
    'M/D/YYYY H:mm',
    'M.D.YYYY h:mm A',
    'M.D.YYYY H:mm',
    'D/M/YYYY h:mm A',
    'D/M/YYYY H:mm',
    'D.M.YYYY h:mm A',
    'D.M.YYYY H:mm',
    'M/D/YY',
    'M.D.YY',
    'D/M/YY',
    'D.M.YY',
    'M/D/YY h:mm a',
    'M/D/YY H:mm',
    'M.D.YY h:mm a',
    'M.D.YY H:mm',
    'D/M/YY h:mm a',
    'D/M/YY H:mm',
    'D.M.YY h:mm a',
    'D.M.YY H:mm',
    'YYYY-MM-DD',
    'YYYY-MM-DD h:mm a',
    'YYYY-MM-DD H:mm',
    'MMM D',
    'D MMM',
    'MMMM YYYY',
    'MMM YYYY',
    'MM/YYYY',
    'h:mm a',
    'H:mm',
    'D',
    'DD',
    'ddd',
    'dddd',
    'M',
    'MM',
    'MMM',
    'MMMM',
    'YY',
    'YYYY'
];
const DATE_FORMAT_OPTIONS = DATETIME_FORMAT_OPTIONS.filter((format)=>!/[hHmaA]/.test(format));

//# sourceMappingURL=data:application/json;base64,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

}),
99369: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
// Avoid adding unnecessary code or imports to this file,
// because it will directly affect the webflow.js bundle size.

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "testCondition", ({
    enumerable: true,
    get: function() {
        return testCondition;
    }
}));
const _DynamoConditionUtils = __webpack_require__(95253);
const _momenttimezone = /*#__PURE__*/ _interop_require_default(__webpack_require__(47636));
const _SlugUtils = __webpack_require__(82985);
const _memo = __webpack_require__(23056);
const _ParamFieldPathUtils = __webpack_require__(68490);
const _constants = __webpack_require__(29197);
const _FilterUtils = __webpack_require__(20574);
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// inlined from `@packages/systems/core/utils/RecordUtils` to keep bundle size minimal
const getId = (record)=>{
    return record._id || record.id || (record.get ? record.get('_id', record.get('id')) : null);
};
const isDateStringWithoutTime = (dateString)=>/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(dateString);
const toGraphQLSlug = (originalSlug)=>{
    const slug = handleId(originalSlug);
    return slug === 'id' || (0, _SlugUtils.isDynamoGraphQLFieldSlug)(slug) || // Don't want to namespace field slug when retrieving product inventory data
    slug === 'ecSkuInventoryQuantity' ? slug : (0, _SlugUtils.fieldSlug)(slug);
};
const handleId = (slug)=>slug === '_id' ? 'id' : slug;
const isObj = (x)=>x !== null && typeof x === 'object' && !Array.isArray(x);
// A simple, non-comprehensive way of detecting Maps and Lists
const isMap = (x)=>x && Boolean(x['@@__IMMUTABLE_MAP__@@']);
const isList = (x)=>x && Boolean(x['@@__IMMUTABLE_LIST__@@']);
const isRecord = (x)=>x && Boolean(x['@@__IMMUTABLE_RECORD__@@']);
const memoizedToJS = (0, _memo.weakMemo)((imm)=>imm.toJS());
// This is purposefully an `any`. It avoids about 9 Flow errors below
// that derive from 1) the impossibility of inferring that many different
// data types and 2) the challenge of enumerating all the possible ones.
// `mixed` is not very well suited for this, because it still requires enumeration
// for types before operating on those values.
const convertImmutableDataStructure = (value)=>{
    if (isMap(value) || isList(value) || isRecord(value)) {
        return memoizedToJS(value);
    }
    return value;
};
const getFieldsFromConditions = (conditions)=>isMap(conditions) ? conditions.get('fields') : conditions.fields;
const testCondition = ({ item, contextItem, timezone, condition, graphQLSlugs })=>{
    const cleanSlug = graphQLSlugs ? toGraphQLSlug : handleId;
    const plainCondition = convertImmutableDataStructure(condition);
    const plainItem = withCleanedSlugs(convertImmutableDataStructure(item), cleanSlug);
    const conditionData = reifyConditions(plainCondition, contextItem, cleanSlug);
    const conditionFields = (0, _FilterUtils.normalizeConditionFields)(conditionData.fields);
    const itemData = conditionFields.reduce((acc, field)=>{
        const { fieldPath, type } = field;
        const itemFieldValue = (0, _DynamoConditionUtils.getItemFieldValue)(plainItem, fieldPath);
        if (itemFieldValue == null) {
            return acc;
        }
        acc[fieldPath] = castFieldValue(itemFieldValue, type, timezone);
        return acc;
    }, {});
    return (0, _DynamoConditionUtils.test)(itemData, conditionData, timezone);
};
const fieldConditionsUpdater = (contextItem, cleanSlug)=>(fields)=>{
        const plainFields = convertImmutableDataStructure(fields);
        // Handles the new data shape of `data.dyn.query.filter.fields`
        if (Array.isArray(fields)) {
            return plainFields.map(reifyQueryField(contextItem, cleanSlug));
        }
        return Object.entries(plainFields).reduce((acc, plainField)=>{
            const [path, item] = reifyCondition(contextItem, cleanSlug)(plainField);
            // @ts-expect-error - TS2538 - Type 'Record<string, any>' cannot be used as an index type.
            acc[path] = item;
            return acc;
        }, {});
    };
const withCleanedSlugs = (obj, cleanSlug)=>{
    return Object.keys(obj).reduce((objWithCleanSlugs, slug)=>{
        objWithCleanSlugs[cleanSlug(slug)] = obj[slug];
        return objWithCleanSlugs;
    }, {});
};
const reifyConditions = (conditions, contextItem, cleanSlug)=>({
        ...conditions,
        fields: fieldConditionsUpdater(contextItem, cleanSlug)(getFieldsFromConditions(conditions))
    });
const createNewFieldPath = (fieldPath, cleanSlug)=>{
    const itemRefFieldSlug = (0, _ParamFieldPathUtils.getItemRefSlug)(fieldPath);
    const valueFieldSlug = (0, _ParamFieldPathUtils.getValueFieldSlug)(fieldPath);
    return itemRefFieldSlug ? (0, _ParamFieldPathUtils.createFieldPath)(cleanSlug(itemRefFieldSlug), cleanSlug(valueFieldSlug)) : (0, _ParamFieldPathUtils.createFieldPath)(cleanSlug(valueFieldSlug));
};
const reifyCondition = (contextItem, cleanSlug)=>(fieldEntry)=>{
        const [fieldPath, operation] = fieldEntry;
        const newFieldPath = createNewFieldPath(fieldPath, cleanSlug);
        const pageItemDataReducer = replacePageItemData(contextItem, cleanSlug);
        return [
            newFieldPath,
            Object.entries(operation).reduce((acc, entry)=>{
                const [key, value] = entry;
                return pageItemDataReducer(acc, value, key);
            }, {})
        ];
    };
const reifyQueryField = (contextItem, cleanSlug)=>(field)=>{
        const { fieldPath, value } = field;
        const newFieldPath = createNewFieldPath(fieldPath, cleanSlug);
        return {
            ...field,
            fieldPath: newFieldPath,
            value: replaceValueBasedOnPageItemData(contextItem, cleanSlug, value)
        };
    };
const replacePageItemData = (contextItem, cleanSlug)=>(acc, value, key)=>{
        acc[key] = replaceValueBasedOnPageItemData(contextItem, cleanSlug, value);
        return acc;
    };
const replaceValueBasedOnPageItemData = (contextItem, cleanSlug, value)=>{
    const plainPageItem = convertImmutableDataStructure(contextItem);
    const pageItemId = plainPageItem ? getId(plainPageItem) : null;
    if (typeof value === 'string') {
        if (value === 'DYN_CONTEXT') {
            if (pageItemId) {
                return pageItemId;
            }
        }
        if (/^DYN_CONTEXT/.test(value)) {
            const dynContextFieldSlug = value.replace(/^DYN_CONTEXT\./, '');
            const dynContextFieldValue = plainPageItem && plainPageItem[cleanSlug(dynContextFieldSlug)];
            const conditionValue = Array.isArray(dynContextFieldValue) ? dynContextFieldValue.map(dynContextFieldValueId) : dynContextFieldValueId(dynContextFieldValue);
            if (plainPageItem) {
                return conditionValue || _constants.NON_EXISTING_ITEM_ID;
            }
        }
    }
    return value;
};
const dynContextFieldValueId = (dynContextFieldValue)=>{
    return isObj(dynContextFieldValue) ? getId(dynContextFieldValue) : dynContextFieldValue;
};
const castFieldValue = (fieldValue, fieldType, timezone)=>{
    switch(fieldType){
        case 'Date':
            {
                // GraphQL api returns date-times as ISO strings and simple dates as YYYY-MM-DD format
                // We know that fieldValue is a string if the itemType is date
                const dateString = fieldValue;
                const dateStringWithoutTime = isDateStringWithoutTime(dateString);
                return dateStringWithoutTime ? _momenttimezone.default.tz(fieldValue, timezone).toDate() : _momenttimezone.default.utc(dateString).toDate();
            }
        case 'Option':
        case 'ItemRef':
            {
                return isObj(fieldValue) ? getId(fieldValue) : fieldValue;
            }
        case 'ItemRefSet':
            {
                return Array.isArray(fieldValue) && fieldValue.length ? Object.values(fieldValue).map((ref)=>{
                    if (typeof ref === 'string') {
                        return {
                            _id: ref
                        };
                    }
                    // @ts-expect-error Unknown type
                    const { id: _, ...restOfRef } = ref;
                    return {
                        ...restOfRef,
                        _id: getId(ref)
                    };
                }) : null;
            }
        default:
            {
                return fieldValue;
            }
    }
};

//# sourceMappingURL=data:application/json;base64,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

}),
44557: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
_export_star(__webpack_require__(99369), exports);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gJy4vQ29uZGl0aW9uVXRpbHMnO1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWMifQ==

}),
95253: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    EXAMPLE_IMG_URL: function() {
        return EXAMPLE_IMG_URL;
    },
    castConditionValue: function() {
        return castConditionValue;
    },
    castItemValue: function() {
        return castItemValue;
    },
    getItemFieldValue: function() {
        return getItemFieldValue;
    },
    parseDate: function() {
        return parseDate;
    },
    test: function() {
        return test;
    }
});
const _momenttimezone = /*#__PURE__*/ _interop_require_default(__webpack_require__(47636));
const _ParamFieldPathUtils = __webpack_require__(68490);
const _FilterUtils = __webpack_require__(20574);
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const EXAMPLE_IMG_URL = 'https://d3e54v103j8qbb.cloudfront.net/img/image-placeholder.svg';
const OPERATOR_FNS = {
    eq: function(a, b) {
        return a == b; // eslint-disable-line eqeqeq
    },
    ne: function(a, b) {
        return a != b; // eslint-disable-line eqeqeq
    },
    gt: function(a, b) {
        return a > b;
    },
    lt: function(a, b) {
        return a < b;
    },
    gte: function(a, b) {
        return a >= b;
    },
    lte: function(a, b) {
        return a <= b;
    },
    exists: function(a, b) {
        function getATruthiness() {
            if (a != null) {
                if (Array.isArray(a)) {
                    return a.length > 0;
                } else if (typeof a === 'object') {
                    return !('url' in a) || a.url !== EXAMPLE_IMG_URL;
                } else if (typeof a === 'number') {
                    return !Number.isNaN(a);
                } else {
                    return true;
                }
            } else {
                return false;
            }
        }
        function getBTruthiness() {
            return b === 'yes';
        }
        const aIsTruthy = getATruthiness();
        const bIsTruthy = getBTruthiness();
        return aIsTruthy === bIsTruthy;
    },
    idin: function(a, b) {
        return containsResolver(a, b);
    },
    idnin: function(a, b) {
        return !containsResolver(a, b);
    },
    type: false
};
const containsResolver = (a, b)=>{
    if (Array.isArray(a) && typeof b === 'string') {
        // A contains B
        return a.includes(b);
    }
    if (Array.isArray(a) && Array.isArray(b)) {
        // A contains any of B
        return b.some((id)=>a.includes(id));
    }
    if (typeof a === 'string' && Array.isArray(b)) {
        // A equals any of B
        return b.includes(a);
    }
    return false;
};
function test(itemData, conditionData, timezone) {
    const conditionFields = (0, _FilterUtils.normalizeConditionFields)(conditionData.fields);
    // We use for..of to exit as early as possible
    for (const conditionField of conditionFields){
        const result = testSingleCondition({
            conditionField,
            itemData,
            timezone
        });
        // if a condition does not pass, we return false as quickly as possible
        if (!result) {
            return false;
        }
    }
    return true;
}
function testSingleCondition({ conditionField, itemData, timezone }) {
    const { fieldPath, operatorName, value, type } = conditionField;
    const opFn = OPERATOR_FNS[operatorName];
    if (!opFn) {
        console.warn(`Ignoring unsupported condition operator: ${operatorName}`);
        // The condition "passes" because there is no operation to test
        return true;
    }
    /*
    The renderer send out item data in different forms.
    Here, we first try to retrive the item field value in the current format,
    if that fails, we fall back to the legacy format.

    The main difference is in how item references are treated in itemData
    Current: { 'author:name': 'Author Name' }
    Legacy: { author: { name: 'Author Name } }
  */ const itemFieldValue = itemData.hasOwnProperty(fieldPath) ? itemData[fieldPath] : getItemFieldValue(itemData, fieldPath);
    // if field type is available in the condition, we use it to determine the item field type
    // otherwise we use the field value to determine item field type
    const itemFieldType = type ? convertFieldTypeToLegacyItemType(type) : _getLegacyItemType(fieldPath, itemFieldValue);
    const resolvedFieldValue = castItemFieldValue(itemFieldValue, itemFieldType);
    const resolvedConditionValue = castConditionValue(value, operatorName, itemFieldType, timezone);
    return opFn(resolvedFieldValue, resolvedConditionValue);
}
function castItemValue({ operator, value, type, timezone }) {
    if (value !== undefined) {
        switch(type){
            case 'Bool':
                return function() {
                    if (typeof value === 'boolean') {
                        return value;
                    } else if (typeof value === 'string') {
                        // Yes. Some sites have "True"
                        return value.toLowerCase() === 'true';
                    } else {
                        return Boolean(value);
                    }
                }();
            case 'Number':
                return parseFloat(value);
            case 'Date':
                return parseDate({
                    operator,
                    value,
                    timezone
                });
            default:
                return value;
        }
    } else {
        return value;
    }
}
function castConditionValue(value, op, type, timezone) {
    if (op === 'exists') {
        return value;
    } else {
        return castItemValue({
            operator: op,
            timezone,
            type,
            value
        });
    }
}
// TODO: swap with imported constant once OperatorTypes is lifted to dynamo package
// tech debt tracked in: https://github.com/webflow/webflow/issues/29496
const OPERATOR_LTE_NAME = 'lte';
// RegEx Patterns required for `parseDate`
///////////////////////////////////////////////
const NOW_REGEX = /^now$/i;
// The END_OF_TODAY_REGEX pattern collects up to two groups of matches
// Group 1: if the string begins with "end of "
// Group 2: if the string contains "today"
const END_OF_TODAY_REGEX = /^(end of )?(today)$/i;
// The DEPRECATED_END_OF_TOMORROW_YESTERDAY_REGEX pattern is to handle parsing older date filters
// that depended up on an "excluding today" boolean. It collects two groups
// Group 1: if the string begins with "end of "
// Group 2: if the string contains "tomorrow" or "yesterday"
const DEPRECATED_END_OF_TOMORROW_YESTERDAY_REGEX = /^(end of )?(tomorrow|yesterday)$/i;
// The DEPRECATED_RELATIVE_TIME_COMPLEX_REGEX pattern is designed to handle parsing older complex date filters
// It captures 4 groups
// Group 1: A string combining time lengths and time intervals
//   Example: 2 days 17 hours 4 minutes
// Group 2: A string containing either "ago" or "from now"
// Group 3: A string containing "starting" with either "now" or "end of"
// Group 4: A string of either "today", "yesterday" or "tomorrow"
const DEPRECATED_RELATIVE_TIME_COMPLEX_REGEX = /^((?:\d+ (?:year|quarter|month|week|day|hour|minute|second)s? )+)(ago|from now)(?: (?:starting (?:now|(?:(end of )?(today|yesterday|tomorrow)))))?$/i;
// The RELATIVE_TIME_COMPLEX_REGEX pattern collects two groups of matches
// Group 1: A string combining time lengths and time intervals.
//   Example: 2 days 17 hours 4 minutes
// Group 2: a string of either 'future' or 'past'
const RELATIVE_TIME_COMPLEX_REGEX = /^((?:\d+ (?:year|quarter|month|week|day|hour|minute|second)s? )+)in the (future|past)$/i;
// The FULL_TIME_LENGTH_INTERVAL_STRING_REGEX pattern collects all the matches found in
// Group 1 of RELATIVE_TIME_COMPLEX_REGEX and returns them as an array
//   Example: '2 days 17 hours 4 minutes' returns a matches array
//   of ['2 days', '17 hours', '4 minutes']
const FULL_TIME_LENGTH_INTERVAL_STRING_REGEX = /\d+ (?:year|quarter|month|week|day|hour|minute|second)s?/gi;
const isDeprecatedDatePattern = (str)=>DEPRECATED_END_OF_TOMORROW_YESTERDAY_REGEX.test(str) || DEPRECATED_RELATIVE_TIME_COMPLEX_REGEX.test(str);
function handleDeprecatedParseDate({ value, timezone, momentNowUtc }) {
    function getToday() {
        return momentNowUtc.tz(timezone).startOf('day');
    }
    function getEndOfToday() {
        return momentNowUtc.tz(timezone).endOf('day');
    }
    function getNow() {
        return momentNowUtc.tz(timezone);
    }
    const simpleResults = value.match(DEPRECATED_END_OF_TOMORROW_YESTERDAY_REGEX);
    if (simpleResults) {
        // handle deprecated end of tomorrow/yesterday scenarios
        const [, endOf, relativeDate] = simpleResults;
        const getStart = endOf ? getEndOfToday : getToday;
        if (relativeDate === 'tomorrow') {
            return getStart().add(1, 'day').toDate();
        }
        if (relativeDate === 'yesterday') {
            return getStart().subtract(1, 'day').toDate();
        }
    }
    const complexResults = value.match(DEPRECATED_RELATIVE_TIME_COMPLEX_REGEX);
    if (complexResults) {
        // handle deprecated complex results
        const [, values, mode, endOf, relativeDate] = complexResults;
        const getStart = endOf ? getEndOfToday : getToday;
        let time;
        switch(relativeDate){
            case 'today':
                time = getStart();
                break;
            case 'tomorrow':
                time = getStart().add(1, 'day');
                break;
            case 'yesterday':
                time = getStart().subtract(1, 'day');
                break;
            default:
                time = getNow();
                break;
        }
        // @ts-expect-error - TS18048 - 'values' is possibly 'undefined'.
        const timeLengthIntervalItems = values.match(FULL_TIME_LENGTH_INTERVAL_STRING_REGEX);
        if (!timeLengthIntervalItems) {
            return null;
        }
        const method = mode === 'from now' ? 'add' : 'subtract';
        // Loop through each length-interval item, ex '14 days', and mutate `time` with each one
        timeLengthIntervalItems.forEach((item)=>{
            const [length, interval] = item.split(' ');
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            time[method](parseInt(length, 10), interval);
        });
        return time.toDate();
    }
}
function parseDate({ operator, value, timezone = 'UTC', nowUtcString }) {
    const momentNowUtc = nowUtcString ? _momenttimezone.default.utc(nowUtcString) : _momenttimezone.default.utc();
    function getToday() {
        return momentNowUtc.tz(timezone).startOf('day');
    }
    function getEndOfToday() {
        return momentNowUtc.tz(timezone).endOf('day');
    }
    function getNow() {
        return momentNowUtc.tz(timezone);
    }
    const stringValue = String(value).toLowerCase();
    if (NOW_REGEX.test(stringValue)) {
        return getNow().toDate();
    }
    // Capture and handle deprecated date patterns, this code will/should eventually be removed
    if (isDeprecatedDatePattern(stringValue)) {
        return handleDeprecatedParseDate({
            value: stringValue,
            timezone,
            momentNowUtc
        });
    }
    const simpleResults = stringValue.match(END_OF_TODAY_REGEX);
    if (simpleResults) {
        const [, endOf] = simpleResults;
        return endOf ? getEndOfToday().toDate() : getToday().toDate();
    }
    const complexResults = stringValue.match(RELATIVE_TIME_COMPLEX_REGEX);
    if (complexResults) {
        const [, fullTimeLengthIntervalString, tense] = complexResults;
        // @ts-expect-error - TS18048 - 'fullTimeLengthIntervalString' is possibly 'undefined'.
        const timeLengthIntervalItems = fullTimeLengthIntervalString.match(FULL_TIME_LENGTH_INTERVAL_STRING_REGEX);
        if (!timeLengthIntervalItems) {
            return null;
        }
        // We want LTE operators to include everything up to the end of the day
        const getStart = operator && operator === OPERATOR_LTE_NAME ? getEndOfToday : getToday;
        const TENSE_METHODS_MAP = {
            future: 'add',
            past: 'subtract'
        };
        const tenseMethod = TENSE_METHODS_MAP[tense];
        // This loops through each item and accumulatively adds or subtracts
        // the length and intervals from today's date
        const reducedDateTime = timeLengthIntervalItems.reduce((accumulatedMoment, item)=>{
            // `item` is a string in the shape of "2 days" or "14 years"
            const [length, interval] = item.split(' ');
            return accumulatedMoment[tenseMethod](// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            parseInt(length, 10), interval);
        }, getStart());
        return reducedDateTime.toDate();
    }
    // Else, fall back on standard ISO 8601 parsing:
    const isoMoment = _momenttimezone.default.utc(value, _momenttimezone.default.ISO_8601).tz(timezone);
    if (!isoMoment || !isoMoment.isValid()) {
        return null;
    }
    // Ok!
    return isoMoment.toDate();
}
function castItemFieldValue(fieldValue, fieldType) {
    switch(fieldType){
        case 'CommercePrice':
            {
                // typeof null equals 'object' so we need to guard against that
                return fieldValue !== null && typeof fieldValue === 'object' && typeof fieldValue.value === 'number' ? fieldValue.value / 100 : NaN;
            }
        case 'ItemRef':
            {
                return fieldValue !== null && typeof fieldValue === 'object' ? fieldValue._id : fieldValue;
            }
        case 'ItemRefSet':
            {
                return Array.isArray(fieldValue) ? fieldValue.map(function(itemRef) {
                    return itemRef._id;
                }) : [];
            }
        case 'Option':
            {
                return fieldValue !== null && typeof fieldValue === 'object' ? fieldValue.id : fieldValue;
            }
        case 'Number':
            {
                return fieldValue === null ? NaN : fieldValue;
            }
        default:
            {
                return fieldValue;
            }
    }
}
function getItemFieldValue(itemData, fieldPath) {
    const itemRefSlug = (0, _ParamFieldPathUtils.getItemRefSlug)(fieldPath);
    const valueFieldSlug = (0, _ParamFieldPathUtils.getValueFieldSlug)(fieldPath);
    return itemRefSlug ? itemData[itemRefSlug] && itemData[itemRefSlug][valueFieldSlug] : itemData[valueFieldSlug];
}
/*
 * Converts CMS Field Type into legacy item types used in this file
 *
 * This function maps Field types to the appropriate legacy field type.
 *
 * The legacy field types are `Bool`, `CommercePrice`, `Date`, `Id`,
 * `ImageRef`, `ItemRef`, `ItemRefSet`, `Number`, `Option` and `String`.
 *
 * Of these, only `Bool`, `CommercePrice`, `Date`, `ItemRef`,
 * `ItemRefSet`, `Number` and `Option` are consequential,
 * because condition and item field values are cast based on them
 * in `castConditionValue` and `castItemValue`.
 */ function convertFieldTypeToLegacyItemType(fieldType) {
    switch(fieldType){
        case 'Bool':
        case 'CommercePrice':
        case 'Date':
        case 'ImageRef':
        case 'ItemRef':
        case 'ItemRefSet':
        case 'Number':
        case 'Option':
        case 'Set':
            {
                return fieldType;
            }
        case 'FileRef':
        case 'Video':
            {
                return 'ImageRef';
            }
        case 'Email':
        case 'Phone':
        case 'PlainText':
        case 'RichText':
        case 'Link':
            {
                return 'String';
            }
        default:
            {
                return 'String';
            }
    }
}
/*
 * LEGACY function that derives the field type from field name and value.
 *
 * This way of deriving field type is only used with the Legacy Renderer,
 * where the field type is not added to the associated condition data.
 */ function _getLegacyItemType(name, value) {
    if (name === '_id') {
        return 'Id';
    } else {
        switch(typeof value){
            case 'number':
                return 'Number';
            case 'boolean':
                return 'Bool';
            case 'object':
                return function() {
                    if (value) {
                        if (value instanceof Date) {
                            return 'Date';
                        } else if ('_id' in value && '_cid' in value) {
                            return 'ItemRef';
                        } else if (Array.isArray(value)) {
                            // Do not need to worry about `Set` fields here,
                            // because this function is used only for legacy conditions.
                            return 'ItemRefSet';
                        } else if ('url' in value) {
                            // technically this could be a video as well; we use 'ImageRef' as a stand-in for 'Asset'-type
                            return 'ImageRef';
                        } else if ('value' in value && 'unit' in value) {
                            return 'CommercePrice';
                        } else {
                            return 'Option';
                        }
                    } else {
                        return 'Option';
                    }
                }();
            default:
                return 'String';
        }
    }
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBtb21lbnQgZnJvbSAnbW9tZW50LXRpbWV6b25lJztcblxuaW1wb3J0IHtcbiAgZ2V0SXRlbVJlZlNsdWcsXG4gIGdldFZhbHVlRmllbGRTbHVnLFxufSBmcm9tICdAcGFja2FnZXMvc3lzdGVtcy9keW5hbW8vdXRpbHMvUGFyYW1GaWVsZFBhdGhVdGlscyc7XG5pbXBvcnQgdHlwZSB7XG4gIENvbmRpdGlvbldpdGhUeXBlVCxcbiAgQ29uZGl0aW9uc1dpdGhUeXBlVCxcbn0gZnJvbSAnQHBhY2thZ2VzL3N5c3RlbXMvZHluYW1vL3R5cGVzJztcbmltcG9ydCB7bm9ybWFsaXplQ29uZGl0aW9uRmllbGRzfSBmcm9tICdAcGFja2FnZXMvc3lzdGVtcy9keW5hbW8vdXRpbHMvRmlsdGVyVXRpbHMnO1xuXG4vKipcbiAqIENvbnRhaW5zIHN0YXRpYyB1dGlsaXRpZXMgdG8gZGVhbCB3aXRoIER5bmFtbyBjb25kaXRpb25hbCB2aXNpYmlsaXR5IGZvciBET00gbm9kZXMuXG4gKi9cblxuZXhwb3J0IGNvbnN0IEVYQU1QTEVfSU1HX1VSTCA9XG4gICdodHRwczovL2QzZTU0djEwM2o4cWJiLmNsb3VkZnJvbnQubmV0L2ltZy9pbWFnZS1wbGFjZWhvbGRlci5zdmcnO1xuXG5jb25zdCBPUEVSQVRPUl9GTlMgPSB7XG4gIGVxOiBmdW5jdGlvbiAoYTogdW5rbm93biwgYjogdW5rbm93bikge1xuICAgIHJldHVybiBhID09IGI7IC8vIGVzbGludC1kaXNhYmxlLWxpbmUgZXFlcWVxXG4gIH0sXG4gIG5lOiBmdW5jdGlvbiAoYTogdW5rbm93biwgYjogdW5rbm93bikge1xuICAgIHJldHVybiBhICE9IGI7IC8vIGVzbGludC1kaXNhYmxlLWxpbmUgZXFlcWVxXG4gIH0sXG4gIGd0OiBmdW5jdGlvbiAoYTogYW55LCBiOiBhbnkpIHtcbiAgICByZXR1cm4gYSA+IGI7XG4gIH0sXG4gIGx0OiBmdW5jdGlvbiAoYTogYW55LCBiOiBhbnkpOiBib29sZWFuIHtcbiAgICByZXR1cm4gYSA8IGI7XG4gIH0sXG4gIGd0ZTogZnVuY3Rpb24gKGE6IGFueSwgYjogYW55KSB7XG4gICAgcmV0dXJuIGEgPj0gYjtcbiAgfSxcbiAgbHRlOiBmdW5jdGlvbiAoYTogYW55LCBiOiBhbnkpIHtcbiAgICByZXR1cm4gYSA8PSBiO1xuICB9LFxuICBleGlzdHM6IGZ1bmN0aW9uIChhOiB1bmtub3duLCBiOiB1bmtub3duKSB7XG4gICAgZnVuY3Rpb24gZ2V0QVRydXRoaW5lc3MoKSB7XG4gICAgICBpZiAoYSAhPSBudWxsKSB7XG4gICAgICAgIGlmIChBcnJheS5pc0FycmF5KGEpKSB7XG4gICAgICAgICAgcmV0dXJuIGEubGVuZ3RoID4gMDtcbiAgICAgICAgfSBlbHNlIGlmICh0eXBlb2YgYSA9PT0gJ29iamVjdCcpIHtcbiAgICAgICAgICByZXR1cm4gISgndXJsJyBpbiBhKSB8fCBhLnVybCAhPT0gRVhBTVBMRV9JTUdfVVJMO1xuICAgICAgICB9IGVsc2UgaWYgKHR5cGVvZiBhID09PSAnbnVtYmVyJykge1xuICAgICAgICAgIHJldHVybiAhTnVtYmVyLmlzTmFOKGEpO1xuICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgIHJldHVybiB0cnVlO1xuICAgICAgICB9XG4gICAgICB9IGVsc2Uge1xuICAgICAgICByZXR1cm4gZmFsc2U7XG4gICAgICB9XG4gICAgfVxuXG4gICAgZnVuY3Rpb24gZ2V0QlRydXRoaW5lc3MoKSB7XG4gICAgICByZXR1cm4gYiA9PT0gJ3llcyc7XG4gICAgfVxuXG4gICAgY29uc3QgYUlzVHJ1dGh5ID0gZ2V0QVRydXRoaW5lc3MoKTtcbiAgICBjb25zdCBiSXNUcnV0aHkgPSBnZXRCVHJ1dGhpbmVzcygpO1xuXG4gICAgcmV0dXJuIGFJc1RydXRoeSA9PT0gYklzVHJ1dGh5O1xuICB9LFxuICBpZGluOiBmdW5jdGlvbiAoYTogdW5rbm93biwgYjogdW5rbm93bikge1xuICAgIHJldHVybiBjb250YWluc1Jlc29sdmVyKGEsIGIpO1xuICB9LFxuICBpZG5pbjogZnVuY3Rpb24gKGE6IHVua25vd24sIGI6IHVua25vd24pIHtcbiAgICByZXR1cm4gIWNvbnRhaW5zUmVzb2x2ZXIoYSwgYik7XG4gIH0sXG4gIHR5cGU6IGZhbHNlLCAvLyBlbnN1cmUgdGhlIGB0eXBlYCBwcm9wZXJ0eSB3aWxsIG5ldmVyIHJlc29sdmUgdG8gYSBmdW5jdGlvblxufSBhcyBjb25zdDtcblxuY29uc3QgY29udGFpbnNSZXNvbHZlciA9IChhOiB1bmtub3duLCBiOiB1bmtub3duKSA9PiB7XG4gIGlmIChBcnJheS5pc0FycmF5KGEpICYmIHR5cGVvZiBiID09PSAnc3RyaW5nJykge1xuICAgIC8vIEEgY29udGFpbnMgQlxuICAgIHJldHVybiBhLmluY2x1ZGVzKGIpO1xuICB9XG4gIGlmIChBcnJheS5pc0FycmF5KGEpICYmIEFycmF5LmlzQXJyYXkoYikpIHtcbiAgICAvLyBBIGNvbnRhaW5zIGFueSBvZiBCXG4gICAgcmV0dXJuIGIuc29tZSgoaWQpID0+IGEuaW5jbHVkZXMoaWQpKTtcbiAgfVxuICBpZiAodHlwZW9mIGEgPT09ICdzdHJpbmcnICYmIEFycmF5LmlzQXJyYXkoYikpIHtcbiAgICAvLyBBIGVxdWFscyBhbnkgb2YgQlxuICAgIHJldHVybiBiLmluY2x1ZGVzKGEpO1xuICB9XG4gIHJldHVybiBmYWxzZTtcbn07XG5cbnR5cGUgSXRlbURhdGFUID0ge1xuICBba2V5OiBzdHJpbmddOiBhbnk7XG59O1xuXG5leHBvcnQgZnVuY3Rpb24gdGVzdChcbiAgaXRlbURhdGE6IEl0ZW1EYXRhVCxcbiAgY29uZGl0aW9uRGF0YToge1xuICAgIGZpZWxkcz86IEl0ZW1EYXRhVCB8IENvbmRpdGlvbnNXaXRoVHlwZVQ7XG4gIH0sXG4gIHRpbWV6b25lPzogc3RyaW5nXG4pIHtcbiAgY29uc3QgY29uZGl0aW9uRmllbGRzID0gbm9ybWFsaXplQ29uZGl0aW9uRmllbGRzKGNvbmRpdGlvbkRhdGEuZmllbGRzKTtcblxuICAvLyBXZSB1c2UgZm9yLi5vZiB0byBleGl0IGFzIGVhcmx5IGFzIHBvc3NpYmxlXG4gIGZvciAoY29uc3QgY29uZGl0aW9uRmllbGQgb2YgY29uZGl0aW9uRmllbGRzKSB7XG4gICAgY29uc3QgcmVzdWx0ID0gdGVzdFNpbmdsZUNvbmRpdGlvbih7XG4gICAgICBjb25kaXRpb25GaWVsZCxcbiAgICAgIGl0ZW1EYXRhLFxuICAgICAgdGltZXpvbmUsXG4gICAgfSk7XG5cbiAgICAvLyBpZiBhIGNvbmRpdGlvbiBkb2VzIG5vdCBwYXNzLCB3ZSByZXR1cm4gZmFsc2UgYXMgcXVpY2tseSBhcyBwb3NzaWJsZVxuICAgIGlmICghcmVzdWx0KSB7XG4gICAgICByZXR1cm4gZmFsc2U7XG4gICAgfVxuICB9XG5cbiAgcmV0dXJuIHRydWU7XG59XG5cbmZ1bmN0aW9uIHRlc3RTaW5nbGVDb25kaXRpb24oe1xuICBjb25kaXRpb25GaWVsZCxcbiAgaXRlbURhdGEsXG4gIHRpbWV6b25lLFxufToge1xuICBjb25kaXRpb25GaWVsZDogQ29uZGl0aW9uV2l0aFR5cGVUO1xuICBpdGVtRGF0YTogSXRlbURhdGFUO1xuICB0aW1lem9uZT86IHN0cmluZztcbn0pIHtcbiAgY29uc3Qge2ZpZWxkUGF0aCwgb3BlcmF0b3JOYW1lLCB2YWx1ZSwgdHlwZX0gPSBjb25kaXRpb25GaWVsZDtcbiAgY29uc3Qgb3BGbiA9IE9QRVJBVE9SX0ZOU1tvcGVyYXRvck5hbWUgYXMga2V5b2YgdHlwZW9mIE9QRVJBVE9SX0ZOU107XG5cbiAgaWYgKCFvcEZuKSB7XG4gICAgY29uc29sZS53YXJuKGBJZ25vcmluZyB1bnN1cHBvcnRlZCBjb25kaXRpb24gb3BlcmF0b3I6ICR7b3BlcmF0b3JOYW1lfWApO1xuICAgIC8vIFRoZSBjb25kaXRpb24gXCJwYXNzZXNcIiBiZWNhdXNlIHRoZXJlIGlzIG5vIG9wZXJhdGlvbiB0byB0ZXN0XG4gICAgcmV0dXJuIHRydWU7XG4gIH1cblxuICAvKlxuICAgIFRoZSByZW5kZXJlciBzZW5kIG91dCBpdGVtIGRhdGEgaW4gZGlmZmVyZW50IGZvcm1zLlxuICAgIEhlcmUsIHdlIGZpcnN0IHRyeSB0byByZXRyaXZlIHRoZSBpdGVtIGZpZWxkIHZhbHVlIGluIHRoZSBjdXJyZW50IGZvcm1hdCxcbiAgICBpZiB0aGF0IGZhaWxzLCB3ZSBmYWxsIGJhY2sgdG8gdGhlIGxlZ2FjeSBmb3JtYXQuXG5cbiAgICBUaGUgbWFpbiBkaWZmZXJlbmNlIGlzIGluIGhvdyBpdGVtIHJlZmVyZW5jZXMgYXJlIHRyZWF0ZWQgaW4gaXRlbURhdGFcbiAgICBDdXJyZW50OiB7ICdhdXRob3I6bmFtZSc6ICdBdXRob3IgTmFtZScgfVxuICAgIExlZ2FjeTogeyBhdXRob3I6IHsgbmFtZTogJ0F1dGhvciBOYW1lIH0gfVxuICAqL1xuICBjb25zdCBpdGVtRmllbGRWYWx1ZSA9IGl0ZW1EYXRhLmhhc093blByb3BlcnR5KGZpZWxkUGF0aClcbiAgICA/IGl0ZW1EYXRhW2ZpZWxkUGF0aF1cbiAgICA6IGdldEl0ZW1GaWVsZFZhbHVlKGl0ZW1EYXRhLCBmaWVsZFBhdGgpO1xuXG4gIC8vIGlmIGZpZWxkIHR5cGUgaXMgYXZhaWxhYmxlIGluIHRoZSBjb25kaXRpb24sIHdlIHVzZSBpdCB0byBkZXRlcm1pbmUgdGhlIGl0ZW0gZmllbGQgdHlwZVxuICAvLyBvdGhlcndpc2Ugd2UgdXNlIHRoZSBmaWVsZCB2YWx1ZSB0byBkZXRlcm1pbmUgaXRlbSBmaWVsZCB0eXBlXG4gIGNvbnN0IGl0ZW1GaWVsZFR5cGUgPSB0eXBlXG4gICAgPyBjb252ZXJ0RmllbGRUeXBlVG9MZWdhY3lJdGVtVHlwZSh0eXBlKVxuICAgIDogX2dldExlZ2FjeUl0ZW1UeXBlKGZpZWxkUGF0aCwgaXRlbUZpZWxkVmFsdWUpO1xuXG4gIGNvbnN0IHJlc29sdmVkRmllbGRWYWx1ZSA9IGNhc3RJdGVtRmllbGRWYWx1ZShpdGVtRmllbGRWYWx1ZSwgaXRlbUZpZWxkVHlwZSk7XG4gIGNvbnN0IHJlc29sdmVkQ29uZGl0aW9uVmFsdWUgPSBjYXN0Q29uZGl0aW9uVmFsdWUoXG4gICAgdmFsdWUsXG4gICAgb3BlcmF0b3JOYW1lLFxuICAgIGl0ZW1GaWVsZFR5cGUsXG4gICAgdGltZXpvbmVcbiAgKTtcblxuICByZXR1cm4gb3BGbihyZXNvbHZlZEZpZWxkVmFsdWUsIHJlc29sdmVkQ29uZGl0aW9uVmFsdWUpO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gY2FzdEl0ZW1WYWx1ZSh7XG4gIG9wZXJhdG9yLFxuICB2YWx1ZSxcbiAgdHlwZSxcbiAgdGltZXpvbmUsXG59OiB7XG4gIG9wZXJhdG9yPzogc3RyaW5nO1xuICB2YWx1ZTogYW55O1xuICB0aW1lem9uZT86IHN0cmluZztcbiAgdHlwZTogc3RyaW5nO1xufSkge1xuICBpZiAodmFsdWUgIT09IHVuZGVmaW5lZCkge1xuICAgIHN3aXRjaCAodHlwZSkge1xuICAgICAgY2FzZSAnQm9vbCc6XG4gICAgICAgIHJldHVybiAoZnVuY3Rpb24gKCkge1xuICAgICAgICAgIGlmICh0eXBlb2YgdmFsdWUgPT09ICdib29sZWFuJykge1xuICAgICAgICAgICAgcmV0dXJuIHZhbHVlO1xuICAgICAgICAgIH0gZWxzZSBpZiAodHlwZW9mIHZhbHVlID09PSAnc3RyaW5nJykge1xuICAgICAgICAgICAgLy8gWWVzLiBTb21lIHNpdGVzIGhhdmUgXCJUcnVlXCJcbiAgICAgICAgICAgIHJldHVybiB2YWx1ZS50b0xvd2VyQ2FzZSgpID09PSAndHJ1ZSc7XG4gICAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICAgIHJldHVybiBCb29sZWFuKHZhbHVlKTtcbiAgICAgICAgICB9XG4gICAgICAgIH0pKCk7XG4gICAgICBjYXNlICdOdW1iZXInOlxuICAgICAgICByZXR1cm4gcGFyc2VGbG9hdCh2YWx1ZSk7XG4gICAgICBjYXNlICdEYXRlJzpcbiAgICAgICAgcmV0dXJuIHBhcnNlRGF0ZSh7b3BlcmF0b3IsIHZhbHVlLCB0aW1lem9uZX0pO1xuICAgICAgZGVmYXVsdDpcbiAgICAgICAgcmV0dXJuIHZhbHVlO1xuICAgIH1cbiAgfSBlbHNlIHtcbiAgICByZXR1cm4gdmFsdWU7XG4gIH1cbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGNhc3RDb25kaXRpb25WYWx1ZShcbiAgdmFsdWU6IGFueSxcbiAgb3A6IHN0cmluZyxcbiAgdHlwZTogc3RyaW5nLFxuICB0aW1lem9uZT86IHN0cmluZ1xuKSB7XG4gIGlmIChvcCA9PT0gJ2V4aXN0cycpIHtcbiAgICByZXR1cm4gdmFsdWU7XG4gIH0gZWxzZSB7XG4gICAgcmV0dXJuIGNhc3RJdGVtVmFsdWUoe29wZXJhdG9yOiBvcCwgdGltZXpvbmUsIHR5cGUsIHZhbHVlfSk7XG4gIH1cbn1cblxuLy8gVE9ETzogc3dhcCB3aXRoIGltcG9ydGVkIGNvbnN0YW50IG9uY2UgT3BlcmF0b3JUeXBlcyBpcyBsaWZ0ZWQgdG8gZHluYW1vIHBhY2thZ2Vcbi8vIHRlY2ggZGVidCB0cmFja2VkIGluOiBodHRwczovL2dpdGh1Yi5jb20vd2ViZmxvdy93ZWJmbG93L2lzc3Vlcy8yOTQ5NlxuY29uc3QgT1BFUkFUT1JfTFRFX05BTUUgPSAnbHRlJztcblxuLy8gUmVnRXggUGF0dGVybnMgcmVxdWlyZWQgZm9yIGBwYXJzZURhdGVgXG4vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vL1xuXG5jb25zdCBOT1dfUkVHRVggPSAvXm5vdyQvaTtcblxuLy8gVGhlIEVORF9PRl9UT0RBWV9SRUdFWCBwYXR0ZXJuIGNvbGxlY3RzIHVwIHRvIHR3byBncm91cHMgb2YgbWF0Y2hlc1xuLy8gR3JvdXAgMTogaWYgdGhlIHN0cmluZyBiZWdpbnMgd2l0aCBcImVuZCBvZiBcIlxuLy8gR3JvdXAgMjogaWYgdGhlIHN0cmluZyBjb250YWlucyBcInRvZGF5XCJcbmNvbnN0IEVORF9PRl9UT0RBWV9SRUdFWCA9IC9eKGVuZCBvZiApPyh0b2RheSkkL2k7XG5cbi8vIFRoZSBERVBSRUNBVEVEX0VORF9PRl9UT01PUlJPV19ZRVNURVJEQVlfUkVHRVggcGF0dGVybiBpcyB0byBoYW5kbGUgcGFyc2luZyBvbGRlciBkYXRlIGZpbHRlcnNcbi8vIHRoYXQgZGVwZW5kZWQgdXAgb24gYW4gXCJleGNsdWRpbmcgdG9kYXlcIiBib29sZWFuLiBJdCBjb2xsZWN0cyB0d28gZ3JvdXBzXG4vLyBHcm91cCAxOiBpZiB0aGUgc3RyaW5nIGJlZ2lucyB3aXRoIFwiZW5kIG9mIFwiXG4vLyBHcm91cCAyOiBpZiB0aGUgc3RyaW5nIGNvbnRhaW5zIFwidG9tb3Jyb3dcIiBvciBcInllc3RlcmRheVwiXG5jb25zdCBERVBSRUNBVEVEX0VORF9PRl9UT01PUlJPV19ZRVNURVJEQVlfUkVHRVggPVxuICAvXihlbmQgb2YgKT8odG9tb3Jyb3d8eWVzdGVyZGF5KSQvaTtcblxuLy8gVGhlIERFUFJFQ0FURURfUkVMQVRJVkVfVElNRV9DT01QTEVYX1JFR0VYIHBhdHRlcm4gaXMgZGVzaWduZWQgdG8gaGFuZGxlIHBhcnNpbmcgb2xkZXIgY29tcGxleCBkYXRlIGZpbHRlcnNcbi8vIEl0IGNhcHR1cmVzIDQgZ3JvdXBzXG4vLyBHcm91cCAxOiBBIHN0cmluZyBjb21iaW5pbmcgdGltZSBsZW5ndGhzIGFuZCB0aW1lIGludGVydmFsc1xuLy8gICBFeGFtcGxlOiAyIGRheXMgMTcgaG91cnMgNCBtaW51dGVzXG4vLyBHcm91cCAyOiBBIHN0cmluZyBjb250YWluaW5nIGVpdGhlciBcImFnb1wiIG9yIFwiZnJvbSBub3dcIlxuLy8gR3JvdXAgMzogQSBzdHJpbmcgY29udGFpbmluZyBcInN0YXJ0aW5nXCIgd2l0aCBlaXRoZXIgXCJub3dcIiBvciBcImVuZCBvZlwiXG4vLyBHcm91cCA0OiBBIHN0cmluZyBvZiBlaXRoZXIgXCJ0b2RheVwiLCBcInllc3RlcmRheVwiIG9yIFwidG9tb3Jyb3dcIlxuY29uc3QgREVQUkVDQVRFRF9SRUxBVElWRV9USU1FX0NPTVBMRVhfUkVHRVggPVxuICAvXigoPzpcXGQrICg/OnllYXJ8cXVhcnRlcnxtb250aHx3ZWVrfGRheXxob3VyfG1pbnV0ZXxzZWNvbmQpcz8gKSspKGFnb3xmcm9tIG5vdykoPzogKD86c3RhcnRpbmcgKD86bm93fCg/OihlbmQgb2YgKT8odG9kYXl8eWVzdGVyZGF5fHRvbW9ycm93KSkpKSk/JC9pO1xuXG4vLyBUaGUgUkVMQVRJVkVfVElNRV9DT01QTEVYX1JFR0VYIHBhdHRlcm4gY29sbGVjdHMgdHdvIGdyb3VwcyBvZiBtYXRjaGVzXG4vLyBHcm91cCAxOiBBIHN0cmluZyBjb21iaW5pbmcgdGltZSBsZW5ndGhzIGFuZCB0aW1lIGludGVydmFscy5cbi8vICAgRXhhbXBsZTogMiBkYXlzIDE3IGhvdXJzIDQgbWludXRlc1xuLy8gR3JvdXAgMjogYSBzdHJpbmcgb2YgZWl0aGVyICdmdXR1cmUnIG9yICdwYXN0J1xuY29uc3QgUkVMQVRJVkVfVElNRV9DT01QTEVYX1JFR0VYID1cbiAgL14oKD86XFxkKyAoPzp5ZWFyfHF1YXJ0ZXJ8bW9udGh8d2Vla3xkYXl8aG91cnxtaW51dGV8c2Vjb25kKXM/ICkrKWluIHRoZSAoZnV0dXJlfHBhc3QpJC9pO1xuXG4vLyBUaGUgRlVMTF9USU1FX0xFTkdUSF9JTlRFUlZBTF9TVFJJTkdfUkVHRVggcGF0dGVybiBjb2xsZWN0cyBhbGwgdGhlIG1hdGNoZXMgZm91bmQgaW5cbi8vIEdyb3VwIDEgb2YgUkVMQVRJVkVfVElNRV9DT01QTEVYX1JFR0VYIGFuZCByZXR1cm5zIHRoZW0gYXMgYW4gYXJyYXlcbi8vICAgRXhhbXBsZTogJzIgZGF5cyAxNyBob3VycyA0IG1pbnV0ZXMnIHJldHVybnMgYSBtYXRjaGVzIGFycmF5XG4vLyAgIG9mIFsnMiBkYXlzJywgJzE3IGhvdXJzJywgJzQgbWludXRlcyddXG5jb25zdCBGVUxMX1RJTUVfTEVOR1RIX0lOVEVSVkFMX1NUUklOR19SRUdFWCA9XG4gIC9cXGQrICg/OnllYXJ8cXVhcnRlcnxtb250aHx3ZWVrfGRheXxob3VyfG1pbnV0ZXxzZWNvbmQpcz8vZ2k7XG5cbmNvbnN0IGlzRGVwcmVjYXRlZERhdGVQYXR0ZXJuID0gKHN0cjogc3RyaW5nKTogYm9vbGVhbiA9PlxuICBERVBSRUNBVEVEX0VORF9PRl9UT01PUlJPV19ZRVNURVJEQVlfUkVHRVgudGVzdChzdHIpIHx8XG4gIERFUFJFQ0FURURfUkVMQVRJVkVfVElNRV9DT01QTEVYX1JFR0VYLnRlc3Qoc3RyKTtcblxuZnVuY3Rpb24gaGFuZGxlRGVwcmVjYXRlZFBhcnNlRGF0ZSh7XG4gIHZhbHVlLFxuICB0aW1lem9uZSxcbiAgbW9tZW50Tm93VXRjLFxufToge1xuICB2YWx1ZTogc3RyaW5nO1xuICB0aW1lem9uZTogc3RyaW5nO1xuICBtb21lbnROb3dVdGM6IGFueTsgLy8gYSBtb21lbnQgaW5zdGFuY2U7XG59KTogRGF0ZSB8IG51bGwgfCB1bmRlZmluZWQge1xuICBmdW5jdGlvbiBnZXRUb2RheSgpIHtcbiAgICByZXR1cm4gbW9tZW50Tm93VXRjLnR6KHRpbWV6b25lKS5zdGFydE9mKCdkYXknKTtcbiAgfVxuXG4gIGZ1bmN0aW9uIGdldEVuZE9mVG9kYXkoKSB7XG4gICAgcmV0dXJuIG1vbWVudE5vd1V0Yy50eih0aW1lem9uZSkuZW5kT2YoJ2RheScpO1xuICB9XG5cbiAgZnVuY3Rpb24gZ2V0Tm93KCkge1xuICAgIHJldHVybiBtb21lbnROb3dVdGMudHoodGltZXpvbmUpO1xuICB9XG5cbiAgY29uc3Qgc2ltcGxlUmVzdWx0cyA9IHZhbHVlLm1hdGNoKERFUFJFQ0FURURfRU5EX09GX1RPTU9SUk9XX1lFU1RFUkRBWV9SRUdFWCk7XG5cbiAgaWYgKHNpbXBsZVJlc3VsdHMpIHtcbiAgICAvLyBoYW5kbGUgZGVwcmVjYXRlZCBlbmQgb2YgdG9tb3Jyb3cveWVzdGVyZGF5IHNjZW5hcmlvc1xuICAgIGNvbnN0IFssIGVuZE9mLCByZWxhdGl2ZURhdGVdID0gc2ltcGxlUmVzdWx0cztcbiAgICBjb25zdCBnZXRTdGFydCA9IGVuZE9mID8gZ2V0RW5kT2ZUb2RheSA6IGdldFRvZGF5O1xuXG4gICAgaWYgKHJlbGF0aXZlRGF0ZSA9PT0gJ3RvbW9ycm93Jykge1xuICAgICAgcmV0dXJuIGdldFN0YXJ0KCkuYWRkKDEsICdkYXknKS50b0RhdGUoKTtcbiAgICB9XG5cbiAgICBpZiAocmVsYXRpdmVEYXRlID09PSAneWVzdGVyZGF5Jykge1xuICAgICAgcmV0dXJuIGdldFN0YXJ0KCkuc3VidHJhY3QoMSwgJ2RheScpLnRvRGF0ZSgpO1xuICAgIH1cbiAgfVxuXG4gIGNvbnN0IGNvbXBsZXhSZXN1bHRzID0gdmFsdWUubWF0Y2goREVQUkVDQVRFRF9SRUxBVElWRV9USU1FX0NPTVBMRVhfUkVHRVgpO1xuXG4gIGlmIChjb21wbGV4UmVzdWx0cykge1xuICAgIC8vIGhhbmRsZSBkZXByZWNhdGVkIGNvbXBsZXggcmVzdWx0c1xuICAgIGNvbnN0IFssIHZhbHVlcywgbW9kZSwgZW5kT2YsIHJlbGF0aXZlRGF0ZV0gPSBjb21wbGV4UmVzdWx0cztcbiAgICBjb25zdCBnZXRTdGFydCA9IGVuZE9mID8gZ2V0RW5kT2ZUb2RheSA6IGdldFRvZGF5O1xuXG4gICAgbGV0IHRpbWU6IG1vbWVudC5Nb21lbnQ7XG4gICAgc3dpdGNoIChyZWxhdGl2ZURhdGUpIHtcbiAgICAgIGNhc2UgJ3RvZGF5JzpcbiAgICAgICAgdGltZSA9IGdldFN0YXJ0KCk7XG4gICAgICAgIGJyZWFrO1xuXG4gICAgICBjYXNlICd0b21vcnJvdyc6XG4gICAgICAgIHRpbWUgPSBnZXRTdGFydCgpLmFkZCgxLCAnZGF5Jyk7XG4gICAgICAgIGJyZWFrO1xuXG4gICAgICBjYXNlICd5ZXN0ZXJkYXknOlxuICAgICAgICB0aW1lID0gZ2V0U3RhcnQoKS5zdWJ0cmFjdCgxLCAnZGF5Jyk7XG4gICAgICAgIGJyZWFrO1xuXG4gICAgICBkZWZhdWx0OlxuICAgICAgICB0aW1lID0gZ2V0Tm93KCk7XG4gICAgICAgIGJyZWFrO1xuICAgIH1cblxuICAgIC8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzE4MDQ4IC0gJ3ZhbHVlcycgaXMgcG9zc2libHkgJ3VuZGVmaW5lZCcuXG4gICAgY29uc3QgdGltZUxlbmd0aEludGVydmFsSXRlbXMgPSB2YWx1ZXMubWF0Y2goXG4gICAgICBGVUxMX1RJTUVfTEVOR1RIX0lOVEVSVkFMX1NUUklOR19SRUdFWFxuICAgICk7XG5cbiAgICBpZiAoIXRpbWVMZW5ndGhJbnRlcnZhbEl0ZW1zKSB7XG4gICAgICByZXR1cm4gbnVsbDtcbiAgICB9XG5cbiAgICBjb25zdCBtZXRob2QgPSBtb2RlID09PSAnZnJvbSBub3cnID8gJ2FkZCcgOiAnc3VidHJhY3QnO1xuXG4gICAgLy8gTG9vcCB0aHJvdWdoIGVhY2ggbGVuZ3RoLWludGVydmFsIGl0ZW0sIGV4ICcxNCBkYXlzJywgYW5kIG11dGF0ZSBgdGltZWAgd2l0aCBlYWNoIG9uZVxuICAgIHRpbWVMZW5ndGhJbnRlcnZhbEl0ZW1zLmZvckVhY2goKGl0ZW0pID0+IHtcbiAgICAgIGNvbnN0IFtsZW5ndGgsIGludGVydmFsXSA9IGl0ZW0uc3BsaXQoJyAnKTtcblxuICAgICAgLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTMjM0NSAtIEFyZ3VtZW50IG9mIHR5cGUgJ3N0cmluZyB8IHVuZGVmaW5lZCcgaXMgbm90IGFzc2lnbmFibGUgdG8gcGFyYW1ldGVyIG9mIHR5cGUgJ3N0cmluZycuXG4gICAgICB0aW1lW21ldGhvZF0ocGFyc2VJbnQobGVuZ3RoLCAxMCksIGludGVydmFsIGFzIG1vbWVudC5EdXJhdGlvbklucHV0QXJnMik7XG4gICAgfSk7XG5cbiAgICByZXR1cm4gdGltZS50b0RhdGUoKTtcbiAgfVxufVxuXG5leHBvcnQgZnVuY3Rpb24gcGFyc2VEYXRlKHtcbiAgb3BlcmF0b3IsXG4gIHZhbHVlLFxuICB0aW1lem9uZSA9ICdVVEMnLFxuICBub3dVdGNTdHJpbmcsXG59OiB7XG4gIG9wZXJhdG9yPzogc3RyaW5nO1xuICB2YWx1ZTogYW55O1xuICB0aW1lem9uZT86IHN0cmluZztcbiAgbm93VXRjU3RyaW5nPzogc3RyaW5nO1xufSk6IERhdGUgfCBudWxsIHwgdW5kZWZpbmVkIHtcbiAgY29uc3QgbW9tZW50Tm93VXRjID0gbm93VXRjU3RyaW5nID8gbW9tZW50LnV0Yyhub3dVdGNTdHJpbmcpIDogbW9tZW50LnV0YygpO1xuXG4gIGZ1bmN0aW9uIGdldFRvZGF5KCkge1xuICAgIHJldHVybiBtb21lbnROb3dVdGMudHoodGltZXpvbmUpLnN0YXJ0T2YoJ2RheScpO1xuICB9XG5cbiAgZnVuY3Rpb24gZ2V0RW5kT2ZUb2RheSgpIHtcbiAgICByZXR1cm4gbW9tZW50Tm93VXRjLnR6KHRpbWV6b25lKS5lbmRPZignZGF5Jyk7XG4gIH1cblxuICBmdW5jdGlvbiBnZXROb3coKSB7XG4gICAgcmV0dXJuIG1vbWVudE5vd1V0Yy50eih0aW1lem9uZSk7XG4gIH1cblxuICBjb25zdCBzdHJpbmdWYWx1ZSA9IFN0cmluZyh2YWx1ZSkudG9Mb3dlckNhc2UoKTtcblxuICBpZiAoTk9XX1JFR0VYLnRlc3Qoc3RyaW5nVmFsdWUpKSB7XG4gICAgcmV0dXJuIGdldE5vdygpLnRvRGF0ZSgpO1xuICB9XG5cbiAgLy8gQ2FwdHVyZSBhbmQgaGFuZGxlIGRlcHJlY2F0ZWQgZGF0ZSBwYXR0ZXJucywgdGhpcyBjb2RlIHdpbGwvc2hvdWxkIGV2ZW50dWFsbHkgYmUgcmVtb3ZlZFxuICBpZiAoaXNEZXByZWNhdGVkRGF0ZVBhdHRlcm4oc3RyaW5nVmFsdWUpKSB7XG4gICAgcmV0dXJuIGhhbmRsZURlcHJlY2F0ZWRQYXJzZURhdGUoe1xuICAgICAgdmFsdWU6IHN0cmluZ1ZhbHVlLFxuICAgICAgdGltZXpvbmUsXG4gICAgICBtb21lbnROb3dVdGMsXG4gICAgfSk7XG4gIH1cblxuICBjb25zdCBzaW1wbGVSZXN1bHRzID0gc3RyaW5nVmFsdWUubWF0Y2goRU5EX09GX1RPREFZX1JFR0VYKTtcbiAgaWYgKHNpbXBsZVJlc3VsdHMpIHtcbiAgICBjb25zdCBbLCBlbmRPZl0gPSBzaW1wbGVSZXN1bHRzO1xuICAgIHJldHVybiBlbmRPZiA/IGdldEVuZE9mVG9kYXkoKS50b0RhdGUoKSA6IGdldFRvZGF5KCkudG9EYXRlKCk7XG4gIH1cblxuICBjb25zdCBjb21wbGV4UmVzdWx0cyA9IHN0cmluZ1ZhbHVlLm1hdGNoKFJFTEFUSVZFX1RJTUVfQ09NUExFWF9SRUdFWCk7XG4gIGlmIChjb21wbGV4UmVzdWx0cykge1xuICAgIGNvbnN0IFssIGZ1bGxUaW1lTGVuZ3RoSW50ZXJ2YWxTdHJpbmcsIHRlbnNlXSA9IGNvbXBsZXhSZXN1bHRzO1xuICAgIC8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzE4MDQ4IC0gJ2Z1bGxUaW1lTGVuZ3RoSW50ZXJ2YWxTdHJpbmcnIGlzIHBvc3NpYmx5ICd1bmRlZmluZWQnLlxuICAgIGNvbnN0IHRpbWVMZW5ndGhJbnRlcnZhbEl0ZW1zID0gZnVsbFRpbWVMZW5ndGhJbnRlcnZhbFN0cmluZy5tYXRjaChcbiAgICAgIEZVTExfVElNRV9MRU5HVEhfSU5URVJWQUxfU1RSSU5HX1JFR0VYXG4gICAgKTtcblxuICAgIGlmICghdGltZUxlbmd0aEludGVydmFsSXRlbXMpIHtcbiAgICAgIHJldHVybiBudWxsO1xuICAgIH1cblxuICAgIC8vIFdlIHdhbnQgTFRFIG9wZXJhdG9ycyB0byBpbmNsdWRlIGV2ZXJ5dGhpbmcgdXAgdG8gdGhlIGVuZCBvZiB0aGUgZGF5XG4gICAgY29uc3QgZ2V0U3RhcnQgPVxuICAgICAgb3BlcmF0b3IgJiYgb3BlcmF0b3IgPT09IE9QRVJBVE9SX0xURV9OQU1FID8gZ2V0RW5kT2ZUb2RheSA6IGdldFRvZGF5O1xuXG4gICAgY29uc3QgVEVOU0VfTUVUSE9EU19NQVAgPSB7XG4gICAgICBmdXR1cmU6ICdhZGQnLFxuICAgICAgcGFzdDogJ3N1YnRyYWN0JyxcbiAgICB9IGFzIGNvbnN0O1xuICAgIGNvbnN0IHRlbnNlTWV0aG9kID1cbiAgICAgIFRFTlNFX01FVEhPRFNfTUFQW3RlbnNlIGFzIGtleW9mIHR5cGVvZiBURU5TRV9NRVRIT0RTX01BUF07XG5cbiAgICAvLyBUaGlzIGxvb3BzIHRocm91Z2ggZWFjaCBpdGVtIGFuZCBhY2N1bXVsYXRpdmVseSBhZGRzIG9yIHN1YnRyYWN0c1xuICAgIC8vIHRoZSBsZW5ndGggYW5kIGludGVydmFscyBmcm9tIHRvZGF5J3MgZGF0ZVxuICAgIGNvbnN0IHJlZHVjZWREYXRlVGltZSA9IHRpbWVMZW5ndGhJbnRlcnZhbEl0ZW1zLnJlZHVjZShcbiAgICAgIChhY2N1bXVsYXRlZE1vbWVudCwgaXRlbSkgPT4ge1xuICAgICAgICAvLyBgaXRlbWAgaXMgYSBzdHJpbmcgaW4gdGhlIHNoYXBlIG9mIFwiMiBkYXlzXCIgb3IgXCIxNCB5ZWFyc1wiXG4gICAgICAgIGNvbnN0IFtsZW5ndGgsIGludGVydmFsXSA9IGl0ZW0uc3BsaXQoJyAnKTtcbiAgICAgICAgcmV0dXJuIGFjY3VtdWxhdGVkTW9tZW50W3RlbnNlTWV0aG9kXShcbiAgICAgICAgICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFMyMzQ1IC0gQXJndW1lbnQgb2YgdHlwZSAnc3RyaW5nIHwgdW5kZWZpbmVkJyBpcyBub3QgYXNzaWduYWJsZSB0byBwYXJhbWV0ZXIgb2YgdHlwZSAnc3RyaW5nJy5cbiAgICAgICAgICBwYXJzZUludChsZW5ndGgsIDEwKSxcbiAgICAgICAgICBpbnRlcnZhbCBhcyBtb21lbnQuRHVyYXRpb25JbnB1dEFyZzJcbiAgICAgICAgKTtcbiAgICAgIH0sXG4gICAgICBnZXRTdGFydCgpXG4gICAgKTtcblxuICAgIHJldHVybiByZWR1Y2VkRGF0ZVRpbWUudG9EYXRlKCk7XG4gIH1cblxuICAvLyBFbHNlLCBmYWxsIGJhY2sgb24gc3RhbmRhcmQgSVNPIDg2MDEgcGFyc2luZzpcbiAgY29uc3QgaXNvTW9tZW50ID0gbW9tZW50LnV0Yyh2YWx1ZSwgbW9tZW50LklTT184NjAxKS50eih0aW1lem9uZSk7XG5cbiAgaWYgKCFpc29Nb21lbnQgfHwgIWlzb01vbWVudC5pc1ZhbGlkKCkpIHtcbiAgICByZXR1cm4gbnVsbDtcbiAgfVxuXG4gIC8vIE9rIVxuICByZXR1cm4gaXNvTW9tZW50LnRvRGF0ZSgpO1xufVxuXG5mdW5jdGlvbiBjYXN0SXRlbUZpZWxkVmFsdWUoZmllbGRWYWx1ZTogYW55LCBmaWVsZFR5cGU6IHN0cmluZyk6IGFueSB7XG4gIHN3aXRjaCAoZmllbGRUeXBlKSB7XG4gICAgY2FzZSAnQ29tbWVyY2VQcmljZSc6IHtcbiAgICAgIC8vIHR5cGVvZiBudWxsIGVxdWFscyAnb2JqZWN0JyBzbyB3ZSBuZWVkIHRvIGd1YXJkIGFnYWluc3QgdGhhdFxuICAgICAgcmV0dXJuIGZpZWxkVmFsdWUgIT09IG51bGwgJiZcbiAgICAgICAgdHlwZW9mIGZpZWxkVmFsdWUgPT09ICdvYmplY3QnICYmXG4gICAgICAgIHR5cGVvZiBmaWVsZFZhbHVlLnZhbHVlID09PSAnbnVtYmVyJ1xuICAgICAgICA/IGZpZWxkVmFsdWUudmFsdWUgLyAxMDBcbiAgICAgICAgOiBOYU47XG4gICAgfVxuICAgIGNhc2UgJ0l0ZW1SZWYnOiB7XG4gICAgICByZXR1cm4gZmllbGRWYWx1ZSAhPT0gbnVsbCAmJiB0eXBlb2YgZmllbGRWYWx1ZSA9PT0gJ29iamVjdCdcbiAgICAgICAgPyBmaWVsZFZhbHVlLl9pZFxuICAgICAgICA6IGZpZWxkVmFsdWU7XG4gICAgfVxuICAgIGNhc2UgJ0l0ZW1SZWZTZXQnOiB7XG4gICAgICByZXR1cm4gQXJyYXkuaXNBcnJheShmaWVsZFZhbHVlKVxuICAgICAgICA/IGZpZWxkVmFsdWUubWFwKGZ1bmN0aW9uIChpdGVtUmVmKSB7XG4gICAgICAgICAgICByZXR1cm4gaXRlbVJlZi5faWQ7XG4gICAgICAgICAgfSlcbiAgICAgICAgOiBbXTtcbiAgICB9XG4gICAgY2FzZSAnT3B0aW9uJzoge1xuICAgICAgcmV0dXJuIGZpZWxkVmFsdWUgIT09IG51bGwgJiYgdHlwZW9mIGZpZWxkVmFsdWUgPT09ICdvYmplY3QnXG4gICAgICAgID8gZmllbGRWYWx1ZS5pZFxuICAgICAgICA6IGZpZWxkVmFsdWU7XG4gICAgfVxuICAgIGNhc2UgJ051bWJlcic6IHtcbiAgICAgIHJldHVybiBmaWVsZFZhbHVlID09PSBudWxsID8gTmFOIDogZmllbGRWYWx1ZTtcbiAgICB9XG4gICAgZGVmYXVsdDoge1xuICAgICAgcmV0dXJuIGZpZWxkVmFsdWU7XG4gICAgfVxuICB9XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBnZXRJdGVtRmllbGRWYWx1ZShpdGVtRGF0YTogYW55LCBmaWVsZFBhdGg6IHN0cmluZyk6IGFueSB7XG4gIGNvbnN0IGl0ZW1SZWZTbHVnID0gZ2V0SXRlbVJlZlNsdWcoZmllbGRQYXRoKTtcbiAgY29uc3QgdmFsdWVGaWVsZFNsdWcgPSBnZXRWYWx1ZUZpZWxkU2x1ZyhmaWVsZFBhdGgpO1xuICByZXR1cm4gaXRlbVJlZlNsdWdcbiAgICA/IGl0ZW1EYXRhW2l0ZW1SZWZTbHVnXSAmJiBpdGVtRGF0YVtpdGVtUmVmU2x1Z11bdmFsdWVGaWVsZFNsdWddXG4gICAgOiBpdGVtRGF0YVt2YWx1ZUZpZWxkU2x1Z107XG59XG5cbi8qXG4gKiBDb252ZXJ0cyBDTVMgRmllbGQgVHlwZSBpbnRvIGxlZ2FjeSBpdGVtIHR5cGVzIHVzZWQgaW4gdGhpcyBmaWxlXG4gKlxuICogVGhpcyBmdW5jdGlvbiBtYXBzIEZpZWxkIHR5cGVzIHRvIHRoZSBhcHByb3ByaWF0ZSBsZWdhY3kgZmllbGQgdHlwZS5cbiAqXG4gKiBUaGUgbGVnYWN5IGZpZWxkIHR5cGVzIGFyZSBgQm9vbGAsIGBDb21tZXJjZVByaWNlYCwgYERhdGVgLCBgSWRgLFxuICogYEltYWdlUmVmYCwgYEl0ZW1SZWZgLCBgSXRlbVJlZlNldGAsIGBOdW1iZXJgLCBgT3B0aW9uYCBhbmQgYFN0cmluZ2AuXG4gKlxuICogT2YgdGhlc2UsIG9ubHkgYEJvb2xgLCBgQ29tbWVyY2VQcmljZWAsIGBEYXRlYCwgYEl0ZW1SZWZgLFxuICogYEl0ZW1SZWZTZXRgLCBgTnVtYmVyYCBhbmQgYE9wdGlvbmAgYXJlIGNvbnNlcXVlbnRpYWwsXG4gKiBiZWNhdXNlIGNvbmRpdGlvbiBhbmQgaXRlbSBmaWVsZCB2YWx1ZXMgYXJlIGNhc3QgYmFzZWQgb24gdGhlbVxuICogaW4gYGNhc3RDb25kaXRpb25WYWx1ZWAgYW5kIGBjYXN0SXRlbVZhbHVlYC5cbiAqL1xuZnVuY3Rpb24gY29udmVydEZpZWxkVHlwZVRvTGVnYWN5SXRlbVR5cGUoZmllbGRUeXBlOiBzdHJpbmcpOiBzdHJpbmcge1xuICBzd2l0Y2ggKGZpZWxkVHlwZSkge1xuICAgIGNhc2UgJ0Jvb2wnOlxuICAgIGNhc2UgJ0NvbW1lcmNlUHJpY2UnOlxuICAgIGNhc2UgJ0RhdGUnOlxuICAgIGNhc2UgJ0ltYWdlUmVmJzpcbiAgICBjYXNlICdJdGVtUmVmJzpcbiAgICBjYXNlICdJdGVtUmVmU2V0JzpcbiAgICBjYXNlICdOdW1iZXInOlxuICAgIGNhc2UgJ09wdGlvbic6XG4gICAgY2FzZSAnU2V0Jzoge1xuICAgICAgcmV0dXJuIGZpZWxkVHlwZTtcbiAgICB9XG4gICAgY2FzZSAnRmlsZVJlZic6XG4gICAgY2FzZSAnVmlkZW8nOiB7XG4gICAgICByZXR1cm4gJ0ltYWdlUmVmJztcbiAgICB9XG4gICAgY2FzZSAnRW1haWwnOlxuICAgIGNhc2UgJ1Bob25lJzpcbiAgICBjYXNlICdQbGFpblRleHQnOlxuICAgIGNhc2UgJ1JpY2hUZXh0JzpcbiAgICBjYXNlICdMaW5rJzoge1xuICAgICAgcmV0dXJuICdTdHJpbmcnO1xuICAgIH1cbiAgICBkZWZhdWx0OiB7XG4gICAgICByZXR1cm4gJ1N0cmluZyc7XG4gICAgfVxuICB9XG59XG5cbi8qXG4gKiBMRUdBQ1kgZnVuY3Rpb24gdGhhdCBkZXJpdmVzIHRoZSBmaWVsZCB0eXBlIGZyb20gZmllbGQgbmFtZSBhbmQgdmFsdWUuXG4gKlxuICogVGhpcyB3YXkgb2YgZGVyaXZpbmcgZmllbGQgdHlwZSBpcyBvbmx5IHVzZWQgd2l0aCB0aGUgTGVnYWN5IFJlbmRlcmVyLFxuICogd2hlcmUgdGhlIGZpZWxkIHR5cGUgaXMgbm90IGFkZGVkIHRvIHRoZSBhc3NvY2lhdGVkIGNvbmRpdGlvbiBkYXRhLlxuICovXG5mdW5jdGlvbiBfZ2V0TGVnYWN5SXRlbVR5cGUobmFtZTogc3RyaW5nLCB2YWx1ZTogdW5rbm93bikge1xuICBpZiAobmFtZSA9PT0gJ19pZCcpIHtcbiAgICByZXR1cm4gJ0lkJztcbiAgfSBlbHNlIHtcbiAgICBzd2l0Y2ggKHR5cGVvZiB2YWx1ZSkge1xuICAgICAgY2FzZSAnbnVtYmVyJzpcbiAgICAgICAgcmV0dXJuICdOdW1iZXInO1xuICAgICAgY2FzZSAnYm9vbGVhbic6XG4gICAgICAgIHJldHVybiAnQm9vbCc7XG4gICAgICBjYXNlICdvYmplY3QnOlxuICAgICAgICByZXR1cm4gKGZ1bmN0aW9uICgpIHtcbiAgICAgICAgICBpZiAodmFsdWUpIHtcbiAgICAgICAgICAgIGlmICh2YWx1ZSBpbnN0YW5jZW9mIERhdGUpIHtcbiAgICAgICAgICAgICAgcmV0dXJuICdEYXRlJztcbiAgICAgICAgICAgIH0gZWxzZSBpZiAoJ19pZCcgaW4gdmFsdWUgJiYgJ19jaWQnIGluIHZhbHVlKSB7XG4gICAgICAgICAgICAgIHJldHVybiAnSXRlbVJlZic7XG4gICAgICAgICAgICB9IGVsc2UgaWYgKEFycmF5LmlzQXJyYXkodmFsdWUpKSB7XG4gICAgICAgICAgICAgIC8vIERvIG5vdCBuZWVkIHRvIHdvcnJ5IGFib3V0IGBTZXRgIGZpZWxkcyBoZXJlLFxuICAgICAgICAgICAgICAvLyBiZWNhdXNlIHRoaXMgZnVuY3Rpb24gaXMgdXNlZCBvbmx5IGZvciBsZWdhY3kgY29uZGl0aW9ucy5cbiAgICAgICAgICAgICAgcmV0dXJuICdJdGVtUmVmU2V0JztcbiAgICAgICAgICAgIH0gZWxzZSBpZiAoJ3VybCcgaW4gdmFsdWUpIHtcbiAgICAgICAgICAgICAgLy8gdGVjaG5pY2FsbHkgdGhpcyBjb3VsZCBiZSBhIHZpZGVvIGFzIHdlbGw7IHdlIHVzZSAnSW1hZ2VSZWYnIGFzIGEgc3RhbmQtaW4gZm9yICdBc3NldCctdHlwZVxuICAgICAgICAgICAgICByZXR1cm4gJ0ltYWdlUmVmJztcbiAgICAgICAgICAgIH0gZWxzZSBpZiAoJ3ZhbHVlJyBpbiB2YWx1ZSAmJiAndW5pdCcgaW4gdmFsdWUpIHtcbiAgICAgICAgICAgICAgcmV0dXJuICdDb21tZXJjZVByaWNlJztcbiAgICAgICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgICAgIHJldHVybiAnT3B0aW9uJztcbiAgICAgICAgICAgIH1cbiAgICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgICAgcmV0dXJuICdPcHRpb24nO1xuICAgICAgICAgIH1cbiAgICAgICAgfSkoKTtcbiAgICAgIGRlZmF1bHQ6XG4gICAgICAgIHJldHVybiAnU3RyaW5nJztcbiAgICB9XG4gIH1cbn1cbiJdLCJuYW1lcyI6WyJFWEFNUExFX0lNR19VUkwiLCJjYXN0Q29uZGl0aW9uVmFsdWUiLCJjYXN0SXRlbVZhbHVlIiwiZ2V0SXRlbUZpZWxkVmFsdWUiLCJwYXJzZURhdGUiLCJ0ZXN0IiwiT1BFUkFUT1JfRk5TIiwiZXEiLCJhIiwiYiIsIm5lIiwiZ3QiLCJsdCIsImd0ZSIsImx0ZSIsImV4aXN0cyIsImdldEFUcnV0aGluZXNzIiwiQXJyYXkiLCJpc0FycmF5IiwibGVuZ3RoIiwidXJsIiwiTnVtYmVyIiwiaXNOYU4iLCJnZXRCVHJ1dGhpbmVzcyIsImFJc1RydXRoeSIsImJJc1RydXRoeSIsImlkaW4iLCJjb250YWluc1Jlc29sdmVyIiwiaWRuaW4iLCJ0eXBlIiwiaW5jbHVkZXMiLCJzb21lIiwiaWQiLCJpdGVtRGF0YSIsImNvbmRpdGlvbkRhdGEiLCJ0aW1lem9uZSIsImNvbmRpdGlvbkZpZWxkcyIsIm5vcm1hbGl6ZUNvbmRpdGlvbkZpZWxkcyIsImZpZWxkcyIsImNvbmRpdGlvbkZpZWxkIiwicmVzdWx0IiwidGVzdFNpbmdsZUNvbmRpdGlvbiIsImZpZWxkUGF0aCIsIm9wZXJhdG9yTmFtZSIsInZhbHVlIiwib3BGbiIsImNvbnNvbGUiLCJ3YXJuIiwiaXRlbUZpZWxkVmFsdWUiLCJoYXNPd25Qcm9wZXJ0eSIsIml0ZW1GaWVsZFR5cGUiLCJjb252ZXJ0RmllbGRUeXBlVG9MZWdhY3lJdGVtVHlwZSIsIl9nZXRMZWdhY3lJdGVtVHlwZSIsInJlc29sdmVkRmllbGRWYWx1ZSIsImNhc3RJdGVtRmllbGRWYWx1ZSIsInJlc29sdmVkQ29uZGl0aW9uVmFsdWUiLCJvcGVyYXRvciIsInVuZGVmaW5lZCIsInRvTG93ZXJDYXNlIiwiQm9vbGVhbiIsInBhcnNlRmxvYXQiLCJvcCIsIk9QRVJBVE9SX0xURV9OQU1FIiwiTk9XX1JFR0VYIiwiRU5EX09GX1RPREFZX1JFR0VYIiwiREVQUkVDQVRFRF9FTkRfT0ZfVE9NT1JST1dfWUVTVEVSREFZX1JFR0VYIiwiREVQUkVDQVRFRF9SRUxBVElWRV9USU1FX0NPTVBMRVhfUkVHRVgiLCJSRUxBVElWRV9USU1FX0NPTVBMRVhfUkVHRVgiLCJGVUxMX1RJTUVfTEVOR1RIX0lOVEVSVkFMX1NUUklOR19SRUdFWCIsImlzRGVwcmVjYXRlZERhdGVQYXR0ZXJuIiwic3RyIiwiaGFuZGxlRGVwcmVjYXRlZFBhcnNlRGF0ZSIsIm1vbWVudE5vd1V0YyIsImdldFRvZGF5IiwidHoiLCJzdGFydE9mIiwiZ2V0RW5kT2ZUb2RheSIsImVuZE9mIiwiZ2V0Tm93Iiwic2ltcGxlUmVzdWx0cyIsIm1hdGNoIiwicmVsYXRpdmVEYXRlIiwiZ2V0U3RhcnQiLCJhZGQiLCJ0b0RhdGUiLCJzdWJ0cmFjdCIsImNvbXBsZXhSZXN1bHRzIiwidmFsdWVzIiwibW9kZSIsInRpbWUiLCJ0aW1lTGVuZ3RoSW50ZXJ2YWxJdGVtcyIsIm1ldGhvZCIsImZvckVhY2giLCJpdGVtIiwiaW50ZXJ2YWwiLCJzcGxpdCIsInBhcnNlSW50Iiwibm93VXRjU3RyaW5nIiwibW9tZW50IiwidXRjIiwic3RyaW5nVmFsdWUiLCJTdHJpbmciLCJmdWxsVGltZUxlbmd0aEludGVydmFsU3RyaW5nIiwidGVuc2UiLCJURU5TRV9NRVRIT0RTX01BUCIsImZ1dHVyZSIsInBhc3QiLCJ0ZW5zZU1ldGhvZCIsInJlZHVjZWREYXRlVGltZSIsInJlZHVjZSIsImFjY3VtdWxhdGVkTW9tZW50IiwiaXNvTW9tZW50IiwiSVNPXzg2MDEiLCJpc1ZhbGlkIiwiZmllbGRWYWx1ZSIsImZpZWxkVHlwZSIsIk5hTiIsIl9pZCIsIm1hcCIsIml0ZW1SZWYiLCJpdGVtUmVmU2x1ZyIsImdldEl0ZW1SZWZTbHVnIiwidmFsdWVGaWVsZFNsdWciLCJnZXRWYWx1ZUZpZWxkU2x1ZyIsIm5hbWUiLCJEYXRlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztJQWdCYUEsZUFBZTtlQUFmQTs7SUEyTEdDLGtCQUFrQjtlQUFsQkE7O0lBcENBQyxhQUFhO2VBQWJBOztJQThUQUMsaUJBQWlCO2VBQWpCQTs7SUF0SUFDLFNBQVM7ZUFBVEE7O0lBbFFBQyxJQUFJO2VBQUpBOzs7dUVBN0ZHO3FDQUtaOzZCQUtnQzs7Ozs7O0FBTWhDLE1BQU1MLGtCQUNYO0FBRUYsTUFBTU0sZUFBZTtJQUNuQkMsSUFBSSxTQUFVQyxDQUFVLEVBQUVDLENBQVU7UUFDbEMsT0FBT0QsS0FBS0MsR0FBRyw2QkFBNkI7SUFDOUM7SUFDQUMsSUFBSSxTQUFVRixDQUFVLEVBQUVDLENBQVU7UUFDbEMsT0FBT0QsS0FBS0MsR0FBRyw2QkFBNkI7SUFDOUM7SUFDQUUsSUFBSSxTQUFVSCxDQUFNLEVBQUVDLENBQU07UUFDMUIsT0FBT0QsSUFBSUM7SUFDYjtJQUNBRyxJQUFJLFNBQVVKLENBQU0sRUFBRUMsQ0FBTTtRQUMxQixPQUFPRCxJQUFJQztJQUNiO0lBQ0FJLEtBQUssU0FBVUwsQ0FBTSxFQUFFQyxDQUFNO1FBQzNCLE9BQU9ELEtBQUtDO0lBQ2Q7SUFDQUssS0FBSyxTQUFVTixDQUFNLEVBQUVDLENBQU07UUFDM0IsT0FBT0QsS0FBS0M7SUFDZDtJQUNBTSxRQUFRLFNBQVVQLENBQVUsRUFBRUMsQ0FBVTtRQUN0QyxTQUFTTztZQUNQLElBQUlSLEtBQUssTUFBTTtnQkFDYixJQUFJUyxNQUFNQyxPQUFPLENBQUNWLElBQUk7b0JBQ3BCLE9BQU9BLEVBQUVXLE1BQU0sR0FBRztnQkFDcEIsT0FBTyxJQUFJLE9BQU9YLE1BQU0sVUFBVTtvQkFDaEMsT0FBTyxDQUFFLENBQUEsU0FBU0EsQ0FBQUEsS0FBTUEsRUFBRVksR0FBRyxLQUFLcEI7Z0JBQ3BDLE9BQU8sSUFBSSxPQUFPUSxNQUFNLFVBQVU7b0JBQ2hDLE9BQU8sQ0FBQ2EsT0FBT0MsS0FBSyxDQUFDZDtnQkFDdkIsT0FBTztvQkFDTCxPQUFPO2dCQUNUO1lBQ0YsT0FBTztnQkFDTCxPQUFPO1lBQ1Q7UUFDRjtRQUVBLFNBQVNlO1lBQ1AsT0FBT2QsTUFBTTtRQUNmO1FBRUEsTUFBTWUsWUFBWVI7UUFDbEIsTUFBTVMsWUFBWUY7UUFFbEIsT0FBT0MsY0FBY0M7SUFDdkI7SUFDQUMsTUFBTSxTQUFVbEIsQ0FBVSxFQUFFQyxDQUFVO1FBQ3BDLE9BQU9rQixpQkFBaUJuQixHQUFHQztJQUM3QjtJQUNBbUIsT0FBTyxTQUFVcEIsQ0FBVSxFQUFFQyxDQUFVO1FBQ3JDLE9BQU8sQ0FBQ2tCLGlCQUFpQm5CLEdBQUdDO0lBQzlCO0lBQ0FvQixNQUFNO0FBQ1I7QUFFQSxNQUFNRixtQkFBbUIsQ0FBQ25CLEdBQVlDO0lBQ3BDLElBQUlRLE1BQU1DLE9BQU8sQ0FBQ1YsTUFBTSxPQUFPQyxNQUFNLFVBQVU7UUFDN0MsZUFBZTtRQUNmLE9BQU9ELEVBQUVzQixRQUFRLENBQUNyQjtJQUNwQjtJQUNBLElBQUlRLE1BQU1DLE9BQU8sQ0FBQ1YsTUFBTVMsTUFBTUMsT0FBTyxDQUFDVCxJQUFJO1FBQ3hDLHNCQUFzQjtRQUN0QixPQUFPQSxFQUFFc0IsSUFBSSxDQUFDLENBQUNDLEtBQU94QixFQUFFc0IsUUFBUSxDQUFDRTtJQUNuQztJQUNBLElBQUksT0FBT3hCLE1BQU0sWUFBWVMsTUFBTUMsT0FBTyxDQUFDVCxJQUFJO1FBQzdDLG9CQUFvQjtRQUNwQixPQUFPQSxFQUFFcUIsUUFBUSxDQUFDdEI7SUFDcEI7SUFDQSxPQUFPO0FBQ1Q7QUFNTyxTQUFTSCxLQUNkNEIsUUFBbUIsRUFDbkJDLGFBRUMsRUFDREMsUUFBaUI7SUFFakIsTUFBTUMsa0JBQWtCQyxJQUFBQSxxQ0FBd0IsRUFBQ0gsY0FBY0ksTUFBTTtJQUVyRSw4Q0FBOEM7SUFDOUMsS0FBSyxNQUFNQyxrQkFBa0JILGdCQUFpQjtRQUM1QyxNQUFNSSxTQUFTQyxvQkFBb0I7WUFDakNGO1lBQ0FOO1lBQ0FFO1FBQ0Y7UUFFQSx1RUFBdUU7UUFDdkUsSUFBSSxDQUFDSyxRQUFRO1lBQ1gsT0FBTztRQUNUO0lBQ0Y7SUFFQSxPQUFPO0FBQ1Q7QUFFQSxTQUFTQyxvQkFBb0IsRUFDM0JGLGNBQWMsRUFDZE4sUUFBUSxFQUNSRSxRQUFRLEVBS1Q7SUFDQyxNQUFNLEVBQUNPLFNBQVMsRUFBRUMsWUFBWSxFQUFFQyxLQUFLLEVBQUVmLElBQUksRUFBQyxHQUFHVTtJQUMvQyxNQUFNTSxPQUFPdkMsWUFBWSxDQUFDcUMsYUFBMEM7SUFFcEUsSUFBSSxDQUFDRSxNQUFNO1FBQ1RDLFFBQVFDLElBQUksQ0FBQyxDQUFDLHlDQUF5QyxFQUFFSixhQUFhLENBQUM7UUFDdkUsK0RBQStEO1FBQy9ELE9BQU87SUFDVDtJQUVBOzs7Ozs7OztFQVFBLEdBQ0EsTUFBTUssaUJBQWlCZixTQUFTZ0IsY0FBYyxDQUFDUCxhQUMzQ1QsUUFBUSxDQUFDUyxVQUFVLEdBQ25CdkMsa0JBQWtCOEIsVUFBVVM7SUFFaEMsMEZBQTBGO0lBQzFGLGdFQUFnRTtJQUNoRSxNQUFNUSxnQkFBZ0JyQixPQUNsQnNCLGlDQUFpQ3RCLFFBQ2pDdUIsbUJBQW1CVixXQUFXTTtJQUVsQyxNQUFNSyxxQkFBcUJDLG1CQUFtQk4sZ0JBQWdCRTtJQUM5RCxNQUFNSyx5QkFBeUJ0RCxtQkFDN0IyQyxPQUNBRCxjQUNBTyxlQUNBZjtJQUdGLE9BQU9VLEtBQUtRLG9CQUFvQkU7QUFDbEM7QUFFTyxTQUFTckQsY0FBYyxFQUM1QnNELFFBQVEsRUFDUlosS0FBSyxFQUNMZixJQUFJLEVBQ0pNLFFBQVEsRUFNVDtJQUNDLElBQUlTLFVBQVVhLFdBQVc7UUFDdkIsT0FBUTVCO1lBQ04sS0FBSztnQkFDSCxPQUFPLEFBQUM7b0JBQ04sSUFBSSxPQUFPZSxVQUFVLFdBQVc7d0JBQzlCLE9BQU9BO29CQUNULE9BQU8sSUFBSSxPQUFPQSxVQUFVLFVBQVU7d0JBQ3BDLDhCQUE4Qjt3QkFDOUIsT0FBT0EsTUFBTWMsV0FBVyxPQUFPO29CQUNqQyxPQUFPO3dCQUNMLE9BQU9DLFFBQVFmO29CQUNqQjtnQkFDRjtZQUNGLEtBQUs7Z0JBQ0gsT0FBT2dCLFdBQVdoQjtZQUNwQixLQUFLO2dCQUNILE9BQU94QyxVQUFVO29CQUFDb0Q7b0JBQVVaO29CQUFPVDtnQkFBUTtZQUM3QztnQkFDRSxPQUFPUztRQUNYO0lBQ0YsT0FBTztRQUNMLE9BQU9BO0lBQ1Q7QUFDRjtBQUVPLFNBQVMzQyxtQkFDZDJDLEtBQVUsRUFDVmlCLEVBQVUsRUFDVmhDLElBQVksRUFDWk0sUUFBaUI7SUFFakIsSUFBSTBCLE9BQU8sVUFBVTtRQUNuQixPQUFPakI7SUFDVCxPQUFPO1FBQ0wsT0FBTzFDLGNBQWM7WUFBQ3NELFVBQVVLO1lBQUkxQjtZQUFVTjtZQUFNZTtRQUFLO0lBQzNEO0FBQ0Y7QUFFQSxtRkFBbUY7QUFDbkYsd0VBQXdFO0FBQ3hFLE1BQU1rQixvQkFBb0I7QUFFMUIsMENBQTBDO0FBQzFDLCtDQUErQztBQUUvQyxNQUFNQyxZQUFZO0FBRWxCLHNFQUFzRTtBQUN0RSwrQ0FBK0M7QUFDL0MsMENBQTBDO0FBQzFDLE1BQU1DLHFCQUFxQjtBQUUzQixpR0FBaUc7QUFDakcsMkVBQTJFO0FBQzNFLCtDQUErQztBQUMvQyw0REFBNEQ7QUFDNUQsTUFBTUMsNkNBQ0o7QUFFRiw4R0FBOEc7QUFDOUcsdUJBQXVCO0FBQ3ZCLDhEQUE4RDtBQUM5RCx1Q0FBdUM7QUFDdkMsMERBQTBEO0FBQzFELHdFQUF3RTtBQUN4RSxpRUFBaUU7QUFDakUsTUFBTUMseUNBQ0o7QUFFRix5RUFBeUU7QUFDekUsK0RBQStEO0FBQy9ELHVDQUF1QztBQUN2QyxpREFBaUQ7QUFDakQsTUFBTUMsOEJBQ0o7QUFFRix1RkFBdUY7QUFDdkYsc0VBQXNFO0FBQ3RFLGlFQUFpRTtBQUNqRSwyQ0FBMkM7QUFDM0MsTUFBTUMseUNBQ0o7QUFFRixNQUFNQywwQkFBMEIsQ0FBQ0MsTUFDL0JMLDJDQUEyQzVELElBQUksQ0FBQ2lFLFFBQ2hESix1Q0FBdUM3RCxJQUFJLENBQUNpRTtBQUU5QyxTQUFTQywwQkFBMEIsRUFDakMzQixLQUFLLEVBQ0xULFFBQVEsRUFDUnFDLFlBQVksRUFLYjtJQUNDLFNBQVNDO1FBQ1AsT0FBT0QsYUFBYUUsRUFBRSxDQUFDdkMsVUFBVXdDLE9BQU8sQ0FBQztJQUMzQztJQUVBLFNBQVNDO1FBQ1AsT0FBT0osYUFBYUUsRUFBRSxDQUFDdkMsVUFBVTBDLEtBQUssQ0FBQztJQUN6QztJQUVBLFNBQVNDO1FBQ1AsT0FBT04sYUFBYUUsRUFBRSxDQUFDdkM7SUFDekI7SUFFQSxNQUFNNEMsZ0JBQWdCbkMsTUFBTW9DLEtBQUssQ0FBQ2Y7SUFFbEMsSUFBSWMsZUFBZTtRQUNqQix3REFBd0Q7UUFDeEQsTUFBTSxHQUFHRixPQUFPSSxhQUFhLEdBQUdGO1FBQ2hDLE1BQU1HLFdBQVdMLFFBQVFELGdCQUFnQkg7UUFFekMsSUFBSVEsaUJBQWlCLFlBQVk7WUFDL0IsT0FBT0MsV0FBV0MsR0FBRyxDQUFDLEdBQUcsT0FBT0MsTUFBTTtRQUN4QztRQUVBLElBQUlILGlCQUFpQixhQUFhO1lBQ2hDLE9BQU9DLFdBQVdHLFFBQVEsQ0FBQyxHQUFHLE9BQU9ELE1BQU07UUFDN0M7SUFDRjtJQUVBLE1BQU1FLGlCQUFpQjFDLE1BQU1vQyxLQUFLLENBQUNkO0lBRW5DLElBQUlvQixnQkFBZ0I7UUFDbEIsb0NBQW9DO1FBQ3BDLE1BQU0sR0FBR0MsUUFBUUMsTUFBTVgsT0FBT0ksYUFBYSxHQUFHSztRQUM5QyxNQUFNSixXQUFXTCxRQUFRRCxnQkFBZ0JIO1FBRXpDLElBQUlnQjtRQUNKLE9BQVFSO1lBQ04sS0FBSztnQkFDSFEsT0FBT1A7Z0JBQ1A7WUFFRixLQUFLO2dCQUNITyxPQUFPUCxXQUFXQyxHQUFHLENBQUMsR0FBRztnQkFDekI7WUFFRixLQUFLO2dCQUNITSxPQUFPUCxXQUFXRyxRQUFRLENBQUMsR0FBRztnQkFDOUI7WUFFRjtnQkFDRUksT0FBT1g7Z0JBQ1A7UUFDSjtRQUVBLGlFQUFpRTtRQUNqRSxNQUFNWSwwQkFBMEJILE9BQU9QLEtBQUssQ0FDMUNaO1FBR0YsSUFBSSxDQUFDc0IseUJBQXlCO1lBQzVCLE9BQU87UUFDVDtRQUVBLE1BQU1DLFNBQVNILFNBQVMsYUFBYSxRQUFRO1FBRTdDLHdGQUF3RjtRQUN4RkUsd0JBQXdCRSxPQUFPLENBQUMsQ0FBQ0M7WUFDL0IsTUFBTSxDQUFDMUUsUUFBUTJFLFNBQVMsR0FBR0QsS0FBS0UsS0FBSyxDQUFDO1lBRXRDLHFIQUFxSDtZQUNySE4sSUFBSSxDQUFDRSxPQUFPLENBQUNLLFNBQVM3RSxRQUFRLEtBQUsyRTtRQUNyQztRQUVBLE9BQU9MLEtBQUtMLE1BQU07SUFDcEI7QUFDRjtBQUVPLFNBQVNoRixVQUFVLEVBQ3hCb0QsUUFBUSxFQUNSWixLQUFLLEVBQ0xULFdBQVcsS0FBSyxFQUNoQjhELFlBQVksRUFNYjtJQUNDLE1BQU16QixlQUFleUIsZUFBZUMsdUJBQU0sQ0FBQ0MsR0FBRyxDQUFDRixnQkFBZ0JDLHVCQUFNLENBQUNDLEdBQUc7SUFFekUsU0FBUzFCO1FBQ1AsT0FBT0QsYUFBYUUsRUFBRSxDQUFDdkMsVUFBVXdDLE9BQU8sQ0FBQztJQUMzQztJQUVBLFNBQVNDO1FBQ1AsT0FBT0osYUFBYUUsRUFBRSxDQUFDdkMsVUFBVTBDLEtBQUssQ0FBQztJQUN6QztJQUVBLFNBQVNDO1FBQ1AsT0FBT04sYUFBYUUsRUFBRSxDQUFDdkM7SUFDekI7SUFFQSxNQUFNaUUsY0FBY0MsT0FBT3pELE9BQU9jLFdBQVc7SUFFN0MsSUFBSUssVUFBVTFELElBQUksQ0FBQytGLGNBQWM7UUFDL0IsT0FBT3RCLFNBQVNNLE1BQU07SUFDeEI7SUFFQSwyRkFBMkY7SUFDM0YsSUFBSWYsd0JBQXdCK0IsY0FBYztRQUN4QyxPQUFPN0IsMEJBQTBCO1lBQy9CM0IsT0FBT3dEO1lBQ1BqRTtZQUNBcUM7UUFDRjtJQUNGO0lBRUEsTUFBTU8sZ0JBQWdCcUIsWUFBWXBCLEtBQUssQ0FBQ2hCO0lBQ3hDLElBQUllLGVBQWU7UUFDakIsTUFBTSxHQUFHRixNQUFNLEdBQUdFO1FBQ2xCLE9BQU9GLFFBQVFELGdCQUFnQlEsTUFBTSxLQUFLWCxXQUFXVyxNQUFNO0lBQzdEO0lBRUEsTUFBTUUsaUJBQWlCYyxZQUFZcEIsS0FBSyxDQUFDYjtJQUN6QyxJQUFJbUIsZ0JBQWdCO1FBQ2xCLE1BQU0sR0FBR2dCLDhCQUE4QkMsTUFBTSxHQUFHakI7UUFDaEQsdUZBQXVGO1FBQ3ZGLE1BQU1JLDBCQUEwQlksNkJBQTZCdEIsS0FBSyxDQUNoRVo7UUFHRixJQUFJLENBQUNzQix5QkFBeUI7WUFDNUIsT0FBTztRQUNUO1FBRUEsdUVBQXVFO1FBQ3ZFLE1BQU1SLFdBQ0oxQixZQUFZQSxhQUFhTSxvQkFBb0JjLGdCQUFnQkg7UUFFL0QsTUFBTStCLG9CQUFvQjtZQUN4QkMsUUFBUTtZQUNSQyxNQUFNO1FBQ1I7UUFDQSxNQUFNQyxjQUNKSCxpQkFBaUIsQ0FBQ0QsTUFBd0M7UUFFNUQsb0VBQW9FO1FBQ3BFLDZDQUE2QztRQUM3QyxNQUFNSyxrQkFBa0JsQix3QkFBd0JtQixNQUFNLENBQ3BELENBQUNDLG1CQUFtQmpCO1lBQ2xCLDREQUE0RDtZQUM1RCxNQUFNLENBQUMxRSxRQUFRMkUsU0FBUyxHQUFHRCxLQUFLRSxLQUFLLENBQUM7WUFDdEMsT0FBT2UsaUJBQWlCLENBQUNILFlBQVksQ0FDbkMscUhBQXFIO1lBQ3JIWCxTQUFTN0UsUUFBUSxLQUNqQjJFO1FBRUosR0FDQVo7UUFHRixPQUFPMEIsZ0JBQWdCeEIsTUFBTTtJQUMvQjtJQUVBLGdEQUFnRDtJQUNoRCxNQUFNMkIsWUFBWWIsdUJBQU0sQ0FBQ0MsR0FBRyxDQUFDdkQsT0FBT3NELHVCQUFNLENBQUNjLFFBQVEsRUFBRXRDLEVBQUUsQ0FBQ3ZDO0lBRXhELElBQUksQ0FBQzRFLGFBQWEsQ0FBQ0EsVUFBVUUsT0FBTyxJQUFJO1FBQ3RDLE9BQU87SUFDVDtJQUVBLE1BQU07SUFDTixPQUFPRixVQUFVM0IsTUFBTTtBQUN6QjtBQUVBLFNBQVM5QixtQkFBbUI0RCxVQUFlLEVBQUVDLFNBQWlCO0lBQzVELE9BQVFBO1FBQ04sS0FBSztZQUFpQjtnQkFDcEIsK0RBQStEO2dCQUMvRCxPQUFPRCxlQUFlLFFBQ3BCLE9BQU9BLGVBQWUsWUFDdEIsT0FBT0EsV0FBV3RFLEtBQUssS0FBSyxXQUMxQnNFLFdBQVd0RSxLQUFLLEdBQUcsTUFDbkJ3RTtZQUNOO1FBQ0EsS0FBSztZQUFXO2dCQUNkLE9BQU9GLGVBQWUsUUFBUSxPQUFPQSxlQUFlLFdBQ2hEQSxXQUFXRyxHQUFHLEdBQ2RIO1lBQ047UUFDQSxLQUFLO1lBQWM7Z0JBQ2pCLE9BQU9qRyxNQUFNQyxPQUFPLENBQUNnRyxjQUNqQkEsV0FBV0ksR0FBRyxDQUFDLFNBQVVDLE9BQU87b0JBQzlCLE9BQU9BLFFBQVFGLEdBQUc7Z0JBQ3BCLEtBQ0EsRUFBRTtZQUNSO1FBQ0EsS0FBSztZQUFVO2dCQUNiLE9BQU9ILGVBQWUsUUFBUSxPQUFPQSxlQUFlLFdBQ2hEQSxXQUFXbEYsRUFBRSxHQUNia0Y7WUFDTjtRQUNBLEtBQUs7WUFBVTtnQkFDYixPQUFPQSxlQUFlLE9BQU9FLE1BQU1GO1lBQ3JDO1FBQ0E7WUFBUztnQkFDUCxPQUFPQTtZQUNUO0lBQ0Y7QUFDRjtBQUVPLFNBQVMvRyxrQkFBa0I4QixRQUFhLEVBQUVTLFNBQWlCO0lBQ2hFLE1BQU04RSxjQUFjQyxJQUFBQSxtQ0FBYyxFQUFDL0U7SUFDbkMsTUFBTWdGLGlCQUFpQkMsSUFBQUEsc0NBQWlCLEVBQUNqRjtJQUN6QyxPQUFPOEUsY0FDSHZGLFFBQVEsQ0FBQ3VGLFlBQVksSUFBSXZGLFFBQVEsQ0FBQ3VGLFlBQVksQ0FBQ0UsZUFBZSxHQUM5RHpGLFFBQVEsQ0FBQ3lGLGVBQWU7QUFDOUI7QUFFQTs7Ozs7Ozs7Ozs7O0NBWUMsR0FDRCxTQUFTdkUsaUNBQWlDZ0UsU0FBaUI7SUFDekQsT0FBUUE7UUFDTixLQUFLO1FBQ0wsS0FBSztRQUNMLEtBQUs7UUFDTCxLQUFLO1FBQ0wsS0FBSztRQUNMLEtBQUs7UUFDTCxLQUFLO1FBQ0wsS0FBSztRQUNMLEtBQUs7WUFBTztnQkFDVixPQUFPQTtZQUNUO1FBQ0EsS0FBSztRQUNMLEtBQUs7WUFBUztnQkFDWixPQUFPO1lBQ1Q7UUFDQSxLQUFLO1FBQ0wsS0FBSztRQUNMLEtBQUs7UUFDTCxLQUFLO1FBQ0wsS0FBSztZQUFRO2dCQUNYLE9BQU87WUFDVDtRQUNBO1lBQVM7Z0JBQ1AsT0FBTztZQUNUO0lBQ0Y7QUFDRjtBQUVBOzs7OztDQUtDLEdBQ0QsU0FBUy9ELG1CQUFtQndFLElBQVksRUFBRWhGLEtBQWM7SUFDdEQsSUFBSWdGLFNBQVMsT0FBTztRQUNsQixPQUFPO0lBQ1QsT0FBTztRQUNMLE9BQVEsT0FBT2hGO1lBQ2IsS0FBSztnQkFDSCxPQUFPO1lBQ1QsS0FBSztnQkFDSCxPQUFPO1lBQ1QsS0FBSztnQkFDSCxPQUFPLEFBQUM7b0JBQ04sSUFBSUEsT0FBTzt3QkFDVCxJQUFJQSxpQkFBaUJpRixNQUFNOzRCQUN6QixPQUFPO3dCQUNULE9BQU8sSUFBSSxTQUFTakYsU0FBUyxVQUFVQSxPQUFPOzRCQUM1QyxPQUFPO3dCQUNULE9BQU8sSUFBSTNCLE1BQU1DLE9BQU8sQ0FBQzBCLFFBQVE7NEJBQy9CLGdEQUFnRDs0QkFDaEQsNERBQTREOzRCQUM1RCxPQUFPO3dCQUNULE9BQU8sSUFBSSxTQUFTQSxPQUFPOzRCQUN6Qiw4RkFBOEY7NEJBQzlGLE9BQU87d0JBQ1QsT0FBTyxJQUFJLFdBQVdBLFNBQVMsVUFBVUEsT0FBTzs0QkFDOUMsT0FBTzt3QkFDVCxPQUFPOzRCQUNMLE9BQU87d0JBQ1Q7b0JBQ0YsT0FBTzt3QkFDTCxPQUFPO29CQUNUO2dCQUNGO1lBQ0Y7Z0JBQ0UsT0FBTztRQUNYO0lBQ0Y7QUFDRiJ9

}),
82688: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    formatEmail: function() {
        return formatEmail;
    },
    formatNumber: function() {
        return formatNumber;
    },
    formatPhone: function() {
        return formatPhone;
    }
});
function formatNumber(n, formatType) {
    if (typeof n === 'number') {
        const precision = formatType === '' || formatType === 'none' ? NaN : Number(formatType);
        if (!isNaN(precision)) {
            return n.toFixed(precision);
        } else {
            return String(n);
        }
    } else {
        return '';
    }
}
function formatEmail(email, subject, property) {
    const prefix = property === 'href' ? 'mailto:' : '';
    if (email && subject) {
        return prefix + email + '?subject=' + subject;
    } else if (email) {
        return prefix + email;
    } else {
        return null;
    }
}
function formatPhone(phone, property) {
    if (property === 'href') {
        let tel = phone ? phone.replace(/\s/g, '') : '';
        if (/\d/.test(tel)) {
            // Create a map to replace phonewords with the proper numbers
            const keypadMap = [
                [
                    /a|b|c/gi,
                    2
                ],
                [
                    /d|e|f/gi,
                    3
                ],
                [
                    /g|h|i/gi,
                    4
                ],
                [
                    /j|k|l/gi,
                    5
                ],
                [
                    /m|n|o/gi,
                    6
                ],
                [
                    /p|q|r|s/gi,
                    7
                ],
                [
                    /t|u|v/gi,
                    8
                ],
                [
                    /w|x|y|z/gi,
                    9
                ]
            ];
            keypadMap.forEach(([key, value])=>{
                tel = tel.replace(key, value.toString());
            });
        } else {
            phone = '#';
        }
        phone = /\d/.test(tel) ? 'tel:' + tel : '#';
    }
    return phone;
}

//# sourceMappingURL=data:application/json;base64,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

}),
4880: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    convertConditionFieldsFromObjectToArray: function() {
        return convertConditionFieldsFromObjectToArray;
    },
    normalizeConditionFields: function() {
        return normalizeConditionFields;
    }
});
const _utils = __webpack_require__(1242);
const convertConditionFieldsFromObjectToArray = (fields)=>{
    const mapper = (fieldPath)=>{
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        const type = fields[fieldPath].type;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return Object.entries(fields[fieldPath]).reduce((conditionFields, [operatorName, value])=>{
            if (operatorName === 'type') {
                return conditionFields;
            }
            conditionFields.push({
                fieldPath,
                operatorName,
                value,
                type
            });
            return conditionFields;
        }, []);
    };
    return (0, _utils.flatMap)(mapper)(Object.keys(fields));
};
const normalizeConditionFields = (fields = [])=>{
    if (Array.isArray(fields)) {
        return fields;
    }
    return convertConditionFieldsFromObjectToArray(fields);
};

//# sourceMappingURL=data:application/json;base64,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

}),
20574: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
_export_star(__webpack_require__(4880), exports);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gJy4vRmlsdGVyVXRpbHMnO1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWMifQ==

}),
68490: (function (__unused_webpack_module, exports) {
"use strict";
/**
 * These utils are for handling field paths in node params (DynList filters and CondVis).
 * For basic fields the fieldPath is currently just the field slug. For fields of an
 * item-reference the fieldPaths are for example `author:post` (separated with SEPARATOR).
 *
 * Encapsulating the internals of fieldPath inside these utils it is easier to refactor the
 * structure of a fieldPath if needed.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    createFieldPath: function() {
        return createFieldPath;
    },
    fieldPathsEqual: function() {
        return fieldPathsEqual;
    },
    getItemRefSlug: function() {
        return getItemRefSlug;
    },
    getValueFieldSlug: function() {
        return getValueFieldSlug;
    },
    isEmptyFieldPath: function() {
        return isEmptyFieldPath;
    },
    isFauxDynContextField: function() {
        return isFauxDynContextField;
    },
    isFieldOfItemRef: function() {
        return isFieldOfItemRef;
    }
});
const SEPARATOR = ':';
const EMPTY_STRING = '';
const isFieldOfItemRef = (fieldPath)=>fieldPath.indexOf(SEPARATOR) !== -1;
const getValueFieldSlug = (fieldPath)=>{
    const splitPath = fieldPath.split(SEPARATOR);
    // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return splitPath[splitPath.length - 1];
};
const getItemRefSlug = (fieldPath)=>{
    if (isFieldOfItemRef(fieldPath)) {
        const splitPath = fieldPath.split(SEPARATOR);
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string | null'.
        return splitPath[0];
    }
    return null;
};
const createFieldPath = (...fieldSlugs)=>fieldSlugs.join(SEPARATOR);
const isEmptyFieldPath = (a)=>a === EMPTY_STRING;
const fieldPathsEqual = (a, b)=>a === b;
const isFauxDynContextField = (fieldPath)=>!isFieldOfItemRef(fieldPath) && getValueFieldSlug(fieldPath) === '_id';

//# sourceMappingURL=data:application/json;base64,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

}),
19336: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    applyConditionToNode: function() {
        return applyConditionToNode;
    },
    removeWDynBindEmptyClass: function() {
        return removeWDynBindEmptyClass;
    },
    walkDOM: function() {
        return walkDOM;
    }
});
const _constants = __webpack_require__(29197);
const _ConditionUtils = __webpack_require__(44557);
const removeClass = (node, className)=>{
    if (node.classList.contains(className)) {
        node.classList.remove(className);
        if (node.classList.length === 0) {
            node.removeAttribute('class');
        }
    }
};
const removeWDynBindEmptyClass = (node)=>removeClass(node, _constants.CLASS_NAME_W_DYN_BIND_EMPTY);
const addConditionalVisibilityClass = (node)=>{
    node.classList.add(_constants.CONDITION_INVISIBLE_CLASS);
};
const removeConditionalVisibilityClass = (node)=>removeClass(node, _constants.CONDITION_INVISIBLE_CLASS);
const applyConditionToNode = (node, item, conditionData, graphQLSlugs = false)=>{
    if (!conditionData) {
        return;
    }
    const { condition, timezone } = conditionData;
    if (item) {
        const isVisible = (0, _ConditionUtils.testCondition)({
            item,
            contextItem: null,
            timezone,
            condition,
            graphQLSlugs
        });
        if (isVisible) {
            removeConditionalVisibilityClass(node);
        } else {
            addConditionalVisibilityClass(node);
        }
    }
};
function walkDOM(el, fn) {
    fn(el);
    if (!el || !el.children) {
        return el;
    }
    const children = Array.from(el.children);
    if (!children.length) {
        return el;
    }
    children.forEach((child)=>walkDOM(child, fn));
    return el;
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlbmRlcmluZ1V0aWxzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7XG4gIENMQVNTX05BTUVfV19EWU5fQklORF9FTVBUWSxcbiAgQ09ORElUSU9OX0lOVklTSUJMRV9DTEFTUyxcbn0gZnJvbSAnQHBhY2thZ2VzL3N5c3RlbXMvZHluYW1vL2NvbnN0YW50cyc7XG5pbXBvcnQge3Rlc3RDb25kaXRpb259IGZyb20gJ0BwYWNrYWdlcy9zeXN0ZW1zL2R5bmFtby91dGlscy9Db25kaXRpb25VdGlscyc7XG5cbmNvbnN0IHJlbW92ZUNsYXNzID0gKG5vZGU6IEVsZW1lbnQsIGNsYXNzTmFtZTogc3RyaW5nKTogdm9pZCA9PiB7XG4gIGlmIChub2RlLmNsYXNzTGlzdC5jb250YWlucyhjbGFzc05hbWUpKSB7XG4gICAgbm9kZS5jbGFzc0xpc3QucmVtb3ZlKGNsYXNzTmFtZSk7XG4gICAgaWYgKG5vZGUuY2xhc3NMaXN0Lmxlbmd0aCA9PT0gMCkge1xuICAgICAgbm9kZS5yZW1vdmVBdHRyaWJ1dGUoJ2NsYXNzJyk7XG4gICAgfVxuICB9XG59O1xuXG5leHBvcnQgY29uc3QgcmVtb3ZlV0R5bkJpbmRFbXB0eUNsYXNzID0gKG5vZGU6IEVsZW1lbnQpOiB2b2lkID0+XG4gIHJlbW92ZUNsYXNzKG5vZGUsIENMQVNTX05BTUVfV19EWU5fQklORF9FTVBUWSk7XG5cbmNvbnN0IGFkZENvbmRpdGlvbmFsVmlzaWJpbGl0eUNsYXNzID0gKG5vZGU6IEVsZW1lbnQpOiB2b2lkID0+IHtcbiAgbm9kZS5jbGFzc0xpc3QuYWRkKENPTkRJVElPTl9JTlZJU0lCTEVfQ0xBU1MpO1xufTtcblxuY29uc3QgcmVtb3ZlQ29uZGl0aW9uYWxWaXNpYmlsaXR5Q2xhc3MgPSAobm9kZTogRWxlbWVudCk6IHZvaWQgPT5cbiAgcmVtb3ZlQ2xhc3Mobm9kZSwgQ09ORElUSU9OX0lOVklTSUJMRV9DTEFTUyk7XG5cbmV4cG9ydCBjb25zdCBhcHBseUNvbmRpdGlvblRvTm9kZSA9IChcbiAgbm9kZTogRWxlbWVudCxcbiAgaXRlbTogUmVjb3JkPGFueSwgYW55PiB8IG51bGwsXG4gIGNvbmRpdGlvbkRhdGE6IGFueSxcbiAgZ3JhcGhRTFNsdWdzOiBib29sZWFuID0gZmFsc2Vcbik6IHZvaWQgPT4ge1xuICBpZiAoIWNvbmRpdGlvbkRhdGEpIHtcbiAgICByZXR1cm47XG4gIH1cblxuICBjb25zdCB7Y29uZGl0aW9uLCB0aW1lem9uZX0gPSBjb25kaXRpb25EYXRhO1xuXG4gIGlmIChpdGVtKSB7XG4gICAgY29uc3QgaXNWaXNpYmxlID0gdGVzdENvbmRpdGlvbih7XG4gICAgICBpdGVtLFxuICAgICAgY29udGV4dEl0ZW06IG51bGwsXG4gICAgICB0aW1lem9uZSxcbiAgICAgIGNvbmRpdGlvbixcbiAgICAgIGdyYXBoUUxTbHVncyxcbiAgICB9KTtcbiAgICBpZiAoaXNWaXNpYmxlKSB7XG4gICAgICByZW1vdmVDb25kaXRpb25hbFZpc2liaWxpdHlDbGFzcyhub2RlKTtcbiAgICB9IGVsc2Uge1xuICAgICAgYWRkQ29uZGl0aW9uYWxWaXNpYmlsaXR5Q2xhc3Mobm9kZSk7XG4gICAgfVxuICB9XG59O1xuXG4vKipcbiAqIEJyZWFkdGgtZmlyc3QgdHJhdmVyc2FsIG9mIERPTSBub2Rlc1xuICogQHBhcmFtIHtFbGVtZW50fSBlbCAtIFJvb3QgZWxlbWVudCB0byBzdGFydCB3aXRoXG4gKiBAcGFyYW0geyhub2RlOiBFbGVtZW50KSA9PiB2b2lkfSBmbiAtIEZ1bmN0aW9uIHRvIHJ1biBmb3IgZXZlcnkgbm9kZSBlbmNvdW50ZXJlZFxuICovXG5leHBvcnQgZnVuY3Rpb24gd2Fsa0RPTShlbDogRWxlbWVudCwgZm46IChub2RlOiBFbGVtZW50KSA9PiB2b2lkKTogYW55IHtcbiAgZm4oZWwpO1xuXG4gIGlmICghZWwgfHwgIWVsLmNoaWxkcmVuKSB7XG4gICAgcmV0dXJuIGVsO1xuICB9XG5cbiAgY29uc3QgY2hpbGRyZW4gPSBBcnJheS5mcm9tKGVsLmNoaWxkcmVuKTtcblxuICBpZiAoIWNoaWxkcmVuLmxlbmd0aCkge1xuICAgIHJldHVybiBlbDtcbiAgfVxuXG4gIGNoaWxkcmVuLmZvckVhY2goKGNoaWxkKSA9PiB3YWxrRE9NKGNoaWxkLCBmbikpO1xuXG4gIHJldHVybiBlbDtcbn1cbiJdLCJuYW1lcyI6WyJhcHBseUNvbmRpdGlvblRvTm9kZSIsInJlbW92ZVdEeW5CaW5kRW1wdHlDbGFzcyIsIndhbGtET00iLCJyZW1vdmVDbGFzcyIsIm5vZGUiLCJjbGFzc05hbWUiLCJjbGFzc0xpc3QiLCJjb250YWlucyIsInJlbW92ZSIsImxlbmd0aCIsInJlbW92ZUF0dHJpYnV0ZSIsIkNMQVNTX05BTUVfV19EWU5fQklORF9FTVBUWSIsImFkZENvbmRpdGlvbmFsVmlzaWJpbGl0eUNsYXNzIiwiYWRkIiwiQ09ORElUSU9OX0lOVklTSUJMRV9DTEFTUyIsInJlbW92ZUNvbmRpdGlvbmFsVmlzaWJpbGl0eUNsYXNzIiwiaXRlbSIsImNvbmRpdGlvbkRhdGEiLCJncmFwaFFMU2x1Z3MiLCJjb25kaXRpb24iLCJ0aW1lem9uZSIsImlzVmlzaWJsZSIsInRlc3RDb25kaXRpb24iLCJjb250ZXh0SXRlbSIsImVsIiwiZm4iLCJjaGlsZHJlbiIsIkFycmF5IiwiZnJvbSIsImZvckVhY2giLCJjaGlsZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7SUF5QmFBLG9CQUFvQjtlQUFwQkE7O0lBVkFDLHdCQUF3QjtlQUF4QkE7O0lBMkNHQyxPQUFPO2VBQVBBOzs7MkJBdkRUO2dDQUNxQjtBQUU1QixNQUFNQyxjQUFjLENBQUNDLE1BQWVDO0lBQ2xDLElBQUlELEtBQUtFLFNBQVMsQ0FBQ0MsUUFBUSxDQUFDRixZQUFZO1FBQ3RDRCxLQUFLRSxTQUFTLENBQUNFLE1BQU0sQ0FBQ0g7UUFDdEIsSUFBSUQsS0FBS0UsU0FBUyxDQUFDRyxNQUFNLEtBQUssR0FBRztZQUMvQkwsS0FBS00sZUFBZSxDQUFDO1FBQ3ZCO0lBQ0Y7QUFDRjtBQUVPLE1BQU1ULDJCQUEyQixDQUFDRyxPQUN2Q0QsWUFBWUMsTUFBTU8sc0NBQTJCO0FBRS9DLE1BQU1DLGdDQUFnQyxDQUFDUjtJQUNyQ0EsS0FBS0UsU0FBUyxDQUFDTyxHQUFHLENBQUNDLG9DQUF5QjtBQUM5QztBQUVBLE1BQU1DLG1DQUFtQyxDQUFDWCxPQUN4Q0QsWUFBWUMsTUFBTVUsb0NBQXlCO0FBRXRDLE1BQU1kLHVCQUF1QixDQUNsQ0ksTUFDQVksTUFDQUMsZUFDQUMsZUFBd0IsS0FBSztJQUU3QixJQUFJLENBQUNELGVBQWU7UUFDbEI7SUFDRjtJQUVBLE1BQU0sRUFBQ0UsU0FBUyxFQUFFQyxRQUFRLEVBQUMsR0FBR0g7SUFFOUIsSUFBSUQsTUFBTTtRQUNSLE1BQU1LLFlBQVlDLElBQUFBLDZCQUFhLEVBQUM7WUFDOUJOO1lBQ0FPLGFBQWE7WUFDYkg7WUFDQUQ7WUFDQUQ7UUFDRjtRQUNBLElBQUlHLFdBQVc7WUFDYk4saUNBQWlDWDtRQUNuQyxPQUFPO1lBQ0xRLDhCQUE4QlI7UUFDaEM7SUFDRjtBQUNGO0FBT08sU0FBU0YsUUFBUXNCLEVBQVcsRUFBRUMsRUFBMkI7SUFDOURBLEdBQUdEO0lBRUgsSUFBSSxDQUFDQSxNQUFNLENBQUNBLEdBQUdFLFFBQVEsRUFBRTtRQUN2QixPQUFPRjtJQUNUO0lBRUEsTUFBTUUsV0FBV0MsTUFBTUMsSUFBSSxDQUFDSixHQUFHRSxRQUFRO0lBRXZDLElBQUksQ0FBQ0EsU0FBU2pCLE1BQU0sRUFBRTtRQUNwQixPQUFPZTtJQUNUO0lBRUFFLFNBQVNHLE9BQU8sQ0FBQyxDQUFDQyxRQUFVNUIsUUFBUTRCLE9BQU9MO0lBRTNDLE9BQU9EO0FBQ1QifQ==

}),
86078: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
_export_star(__webpack_require__(19336), exports);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gJy4vUmVuZGVyaW5nVXRpbHMnO1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWMifQ==

}),
53083: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    _crapCode: function() {
        return _crapCode;
    },
    _test: function() {
        return _test;
    },
    collSlug: function() {
        return collSlug;
    },
    fieldSlug: function() {
        return fieldSlug;
    },
    restoreSlug: function() {
        return restoreSlug;
    }
});
const _invert = /*#__PURE__*/ _interop_require_default(__webpack_require__(61576));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * This file exists because GraphQL only allows /^[a-z_][a-z_0-9]$/i identifiers, but we allow things to be slugs,
 * like: "foo-bar". Since we allow characters that are not allowed by GraphQL, we need to convert these slugs into an
 * accepted format.
 *
 * Unfortunately, simple conversions (like what the prototype did: slug.replace(/\W/g, '_')) don't work, because this
 * would encode the slugs "foo-bar" and "foo_bar" to the same value. Both are valid slugs according to our system, and
 * can totally co-exist in a collection schema. So if a site existed that accidentally did something like that, schema
 * generation would fail for that user, which is a big "No bueno".
 */ // Consonants are used instead of the traditional hex characters, since there's
// a lower likelihood of it accidentally spelling something...
const hex_lookup = {
    '0': 'b',
    '1': 'c',
    '2': 'd',
    '3': 'f',
    '4': 'g',
    '5': 'h',
    '6': 'j',
    '7': 'k',
    '8': 'l',
    '9': 'm',
    a: 'n',
    b: 'p',
    c: 'q',
    d: 'r',
    e: 's',
    f: 't'
};
const reverse_hex_lookup = (0, _invert.default)(hex_lookup);
function _crapCode(str) {
    str = String(str);
    // Right is all rejected chars, in a {idx}{letterhex} format. Letter hex is just hex,
    // but all values are shifted into consonants to avoid ambiguities with idx / the hex
    // data. Left is the original string, with all rejected characters replaced with '_'.
    // This stragegy should have a good 1:1 mapping from source to encoded values. It
    // will produce keys that can be used as identifiers in GraphQL. And it also leaves
    // many of the readable characters in the source string alone, so that the slug is
    // still kinda readable:
    const right = [];
    // Left is all acceptable chars, for "readability".
    const left = str.replace(/[^a-z0-9]/gi, (substr, idx)=>{
        // Get hex of invalid character:
        const hex = substr.charCodeAt(0).toString(16);
        // Map to letters, so there's no ambiguity between indexes and char data.
        // @ts-expect-error - TS2769 - No overload matches this call.
        const letters = hex.replace(/./g, (ch)=>hex_lookup[ch]);
        // Push this {idx}{kinda-hex} combo for later concat:
        right.push(String(idx) + letters);
        // ... and replace the invalid char with '_':
        return '_';
    });
    return left + '_' + right.join('');
}
const collSlug = (coll)=>'c_' + _crapCode(coll.slug);
const fieldSlug = (field)=>'f_' + _crapCode(field.slug);
const _test = {
    _crapCode
};
const restoreSlug = (slugWithPrefixAndCrapCode)=>{
    const results = slugWithPrefixAndCrapCode.match(/^[fc]_([_A-Za-z0-9]+)_([0-9bcdfghjklmnpqrst]*)$/);
    if (!results || results.length < 3) {
        // slug is not a valid Dynamo collection or field GraphQL slug,
        // so it does not need to be restored
        return slugWithPrefixAndCrapCode;
    }
    const left = results[1];
    const right = results[2];
    if (!right) {
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        return left;
    }
    // we use a while loop and mutable variables,
    // because node 10 does not support `matchAll`
    // @ts-expect-error - TS18048 - 'left' is possibly 'undefined'.
    const decrapified = left.split('');
    const re = /(\d+)([bcdfghjklmnpqrst]+)/g;
    let matches = re.exec(right);
    while(matches !== null && matches.length > 2){
        const idx = Number(matches[1]);
        const letters = matches[2];
        // @ts-expect-error - TS18048 - 'letters' is possibly 'undefined'. | TS2769 - No overload matches this call.
        const hex = letters.replace(/./g, (ch)=>reverse_hex_lookup[ch]);
        const char = String.fromCharCode(parseInt(hex, 16));
        decrapified[idx] = char;
        matches = re.exec(right);
    }
    return decrapified.join('');
};

//# sourceMappingURL=data:application/json;base64,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

}),
24915: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
_export_star(__webpack_require__(53083), exports);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gJy4vU2NoZW1hRW5jb2Rlcic7XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztxQkFBYyJ9

}),
67526: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    collectionSlug: function() {
        return collectionSlug;
    },
    fieldSlug: function() {
        return fieldSlug;
    },
    isDynamoGraphQLFieldSlug: function() {
        return isDynamoGraphQLFieldSlug;
    },
    restoreSlug: function() {
        return _SchemaEncoder.restoreSlug;
    }
});
const _SchemaEncoder = __webpack_require__(24915);
const fieldSlug = (slug)=>{
    if (slug === 'fullSlug') {
        return slug;
    }
    return (0, _SchemaEncoder.fieldSlug)({
        slug
    });
};
const DYNAMO_GQL_FIELD_SLUG = 'f_';
const isDynamoGraphQLFieldSlug = (str)=>str.startsWith(DYNAMO_GQL_FIELD_SLUG);
const collectionSlug = (slug)=>(0, _SchemaEncoder.collSlug)({
        slug
    });

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNsdWdVdGlscy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge1xuICBjb2xsU2x1ZyxcbiAgZmllbGRTbHVnIGFzIF9maWVsZFNsdWcsXG59IGZyb20gJ0BwYWNrYWdlcy9zeXN0ZW1zL2R5bmFtby91dGlscy9TY2hlbWFFbmNvZGVyJztcblxuZXhwb3J0IHtyZXN0b3JlU2x1Z30gZnJvbSAnQHBhY2thZ2VzL3N5c3RlbXMvZHluYW1vL3V0aWxzL1NjaGVtYUVuY29kZXInO1xuXG5leHBvcnQgY29uc3QgZmllbGRTbHVnID0gKHNsdWc6IHN0cmluZyk6IHN0cmluZyA9PiB7XG4gIGlmIChzbHVnID09PSAnZnVsbFNsdWcnKSB7XG4gICAgcmV0dXJuIHNsdWc7XG4gIH1cblxuICByZXR1cm4gX2ZpZWxkU2x1Zyh7c2x1Z30pO1xufTtcblxuY29uc3QgRFlOQU1PX0dRTF9GSUVMRF9TTFVHID0gJ2ZfJztcbmV4cG9ydCBjb25zdCBpc0R5bmFtb0dyYXBoUUxGaWVsZFNsdWc6IChhcmcxOiBzdHJpbmcpID0+IGJvb2xlYW4gPSAoc3RyKSA9PlxuICBzdHIuc3RhcnRzV2l0aChEWU5BTU9fR1FMX0ZJRUxEX1NMVUcpO1xuXG5leHBvcnQgY29uc3QgY29sbGVjdGlvblNsdWcgPSAoc2x1Zzogc3RyaW5nKTogc3RyaW5nID0+IGNvbGxTbHVnKHtzbHVnfSk7XG4iXSwibmFtZXMiOlsiY29sbGVjdGlvblNsdWciLCJmaWVsZFNsdWciLCJpc0R5bmFtb0dyYXBoUUxGaWVsZFNsdWciLCJyZXN0b3JlU2x1ZyIsInNsdWciLCJfZmllbGRTbHVnIiwiRFlOQU1PX0dRTF9GSUVMRF9TTFVHIiwic3RyIiwic3RhcnRzV2l0aCIsImNvbGxTbHVnIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztJQW1CYUEsY0FBYztlQUFkQTs7SUFaQUMsU0FBUztlQUFUQTs7SUFTQUMsd0JBQXdCO2VBQXhCQTs7SUFYTEMsV0FBVztlQUFYQSwwQkFBVzs7OytCQUZaO0FBSUEsTUFBTUYsWUFBWSxDQUFDRztJQUN4QixJQUFJQSxTQUFTLFlBQVk7UUFDdkIsT0FBT0E7SUFDVDtJQUVBLE9BQU9DLElBQUFBLHdCQUFVLEVBQUM7UUFBQ0Q7SUFBSTtBQUN6QjtBQUVBLE1BQU1FLHdCQUF3QjtBQUN2QixNQUFNSiwyQkFBc0QsQ0FBQ0ssTUFDbEVBLElBQUlDLFVBQVUsQ0FBQ0Y7QUFFVixNQUFNTixpQkFBaUIsQ0FBQ0ksT0FBeUJLLElBQUFBLHVCQUFRLEVBQUM7UUFBQ0w7SUFBSSJ9

}),
82985: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
_export_star(__webpack_require__(67526), exports);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gJy4vU2x1Z1V0aWxzJztcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O3FCQUFjIn0=

}),
73141: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "transformers", ({
    enumerable: true,
    get: function() {
        return transformers;
    }
}));
const _escape = /*#__PURE__*/ _interop_require_default(__webpack_require__(28929));
const _momenttimezone = /*#__PURE__*/ _interop_require_default(__webpack_require__(47636));
const _CurrencyUtils = __webpack_require__(60937);
const _DynamoFormattingUtils = __webpack_require__(82688);
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// GraphQL api returns date-times as ISO strings and simple dates as YYYY-MM-DD format
const isSimpleDateFormat = (value)=>/^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.test(value);
const date = (value, [format], { timezone = 'UTC' })=>{
    if (isSimpleDateFormat(value)) {
        timezone = 'UTC';
    }
    const momentDate = _momenttimezone.default.utc(value, _momenttimezone.default.ISO_8601);
    if (momentDate.isValid()) {
        return momentDate.tz(timezone).format(format);
    } else {
        return '';
    }
};
const detailPage = (value, [collectionIdOrLegacySlug], { collectionSlugMap })=>{
    // Falling back to collectionIdOrLegacySlug because in the legacy filters, it's
    // actually the collection slug. If there's a legacy filter, the collection slug
    // rename is not enabled yet for the site so the href is still accurate.
    const collectionSlug = collectionSlugMap[collectionIdOrLegacySlug] || collectionIdOrLegacySlug;
    return value ? `/${collectionSlug}/${value}` : null;
};
const style = (value, [styleProp])=>{
    if (styleProp === 'background-image') {
        return value ? `url("${value}")` : 'none';
    }
    return value;
};
const numberPrecision = (value, [precision])=>{
    return (0, _DynamoFormattingUtils.formatNumber)(value, precision);
};
const rich = (value, params, { pageLinkHrefPrefix, collectionSlugMap })=>{
    if (!value) {
        return null;
    }
    if (typeof value !== 'string') {
        return value;
    }
    return value.replace(/<a\s+[^>]+/g, (linkString)=>{
        const isPageLink = /\sdata-rt-link-type="page"/.test(linkString);
        const needsPrefix = pageLinkHrefPrefix && isPageLink;
        const collectionIdMatch = isPageLink && /\sdata-rt-link-collectionid="([a-z0-9]{24})"/.exec(linkString);
        if (needsPrefix || collectionIdMatch) {
            return linkString.replace(/(\shref=")([^"]+)/, (match, begin, href)=>{
                const end = collectionIdMatch ? replaceDetailPageHrefCollectionSlug(href, // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                collectionIdMatch[1], collectionSlugMap) : href;
                // Need to escape the prefix here as dynamic RTE is added with dangerouslySetInnerHTML in RichText atom.
                const prefix = pageLinkHrefPrefix ? (0, _escape.default)(pageLinkHrefPrefix) : '';
                return `${begin}${prefix}${end}`;
            });
        } else {
            return linkString;
        }
    });
};
// Collection slug may have been renamed so we need to make sure detail
// page links in CMS RichText fields still point to the correct page.
const replaceDetailPageHrefCollectionSlug = (href, collectionId, collectionSlugMap)=>{
    const [emptyString, originalCollectionSlug, ...rest] = href.split('/');
    const collectionSlug = collectionSlugMap[collectionId] || originalCollectionSlug;
    return [
        emptyString,
        collectionSlug,
        ...rest
    ].join('/');
};
const get = (obj, key)=>{
    if (obj != null && typeof obj.get === 'function') {
        return obj.get(key);
    }
    return obj[key];
};
const price = (obj, params, context)=>{
    if (!obj) return null;
    return (0, _CurrencyUtils.renderPriceFromSettings)({
        unit: get(obj, 'unit'),
        value: get(obj, 'value')
    }, context.currencySettings);
};
function getTransformerFn(fnKey) {
    switch(fnKey){
        case 'date':
            {
                return date;
            }
        case 'detailPage':
            {
                return detailPage;
            }
        case 'style':
            {
                return style;
            }
        case 'numberPrecision':
            {
                return numberPrecision;
            }
        case 'rich':
            {
                return rich;
            }
        case 'price':
            {
                return price;
            }
        default:
            {
                return null;
            }
    }
}
const transformers = (value, filter, context)=>{
    const { type: key, params } = filter;
    const fn = getTransformerFn(key);
    return fn ? fn(value, params, context) : value;
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRyYW5zZm9ybWVycy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgZXNjYXBlIGZyb20gJ2xvZGFzaC9lc2NhcGUnO1xuaW1wb3J0IG1vbWVudCBmcm9tICdtb21lbnQtdGltZXpvbmUnO1xuaW1wb3J0IHtcbiAgdHlwZSBDdXJyZW5jeVNldHRpbmdzLFxuICByZW5kZXJQcmljZUZyb21TZXR0aW5ncyxcbn0gZnJvbSAnQHBhY2thZ2VzL3N5c3RlbXMvY29yZS91dGlscy9DdXJyZW5jeVV0aWxzJztcbmltcG9ydCB7Zm9ybWF0TnVtYmVyfSBmcm9tICdAcGFja2FnZXMvc3lzdGVtcy9keW5hbW8vdXRpbHMvRHluYW1vRm9ybWF0dGluZ1V0aWxzJztcbmltcG9ydCB0eXBlIHtCaW5kaW5nVHJhbnNmb3JtZXJ9IGZyb20gJ0BwYWNrYWdlcy9zeXN0ZW1zL2R5bmFtby9iaW5kaW5nLXR5cGVzJztcblxuLy8gR3JhcGhRTCBhcGkgcmV0dXJucyBkYXRlLXRpbWVzIGFzIElTTyBzdHJpbmdzIGFuZCBzaW1wbGUgZGF0ZXMgYXMgWVlZWS1NTS1ERCBmb3JtYXRcbmNvbnN0IGlzU2ltcGxlRGF0ZUZvcm1hdCA9ICh2YWx1ZTogYW55KSA9PlxuICAvXihbMC05XXs0fSktKFswLTldezJ9KS0oWzAtOV17Mn0pJC8udGVzdCh2YWx1ZSk7XG5cbmNvbnN0IGRhdGUgPSAoXG4gIHZhbHVlOiBhbnksXG4gIFtmb3JtYXRdOiBbYW55XSxcbiAge3RpbWV6b25lID0gJ1VUQyd9OiBUcmFuc2Zvcm1lcnNDb250ZXh0XG4pID0+IHtcbiAgaWYgKGlzU2ltcGxlRGF0ZUZvcm1hdCh2YWx1ZSkpIHtcbiAgICB0aW1lem9uZSA9ICdVVEMnO1xuICB9XG5cbiAgY29uc3QgbW9tZW50RGF0ZSA9IG1vbWVudC51dGModmFsdWUsIG1vbWVudC5JU09fODYwMSk7XG5cbiAgaWYgKG1vbWVudERhdGUuaXNWYWxpZCgpKSB7XG4gICAgcmV0dXJuIG1vbWVudERhdGUudHoodGltZXpvbmUpLmZvcm1hdChmb3JtYXQpO1xuICB9IGVsc2Uge1xuICAgIHJldHVybiAnJztcbiAgfVxufTtcblxuY29uc3QgZGV0YWlsUGFnZSA9IChcbiAgdmFsdWU6IGFueSxcbiAgW2NvbGxlY3Rpb25JZE9yTGVnYWN5U2x1Z106IFthbnldLFxuICB7Y29sbGVjdGlvblNsdWdNYXB9OiBUcmFuc2Zvcm1lcnNDb250ZXh0XG4pID0+IHtcbiAgLy8gRmFsbGluZyBiYWNrIHRvIGNvbGxlY3Rpb25JZE9yTGVnYWN5U2x1ZyBiZWNhdXNlIGluIHRoZSBsZWdhY3kgZmlsdGVycywgaXQnc1xuICAvLyBhY3R1YWxseSB0aGUgY29sbGVjdGlvbiBzbHVnLiBJZiB0aGVyZSdzIGEgbGVnYWN5IGZpbHRlciwgdGhlIGNvbGxlY3Rpb24gc2x1Z1xuICAvLyByZW5hbWUgaXMgbm90IGVuYWJsZWQgeWV0IGZvciB0aGUgc2l0ZSBzbyB0aGUgaHJlZiBpcyBzdGlsbCBhY2N1cmF0ZS5cbiAgY29uc3QgY29sbGVjdGlvblNsdWcgPVxuICAgIGNvbGxlY3Rpb25TbHVnTWFwW2NvbGxlY3Rpb25JZE9yTGVnYWN5U2x1Z10gfHwgY29sbGVjdGlvbklkT3JMZWdhY3lTbHVnO1xuICByZXR1cm4gdmFsdWUgPyBgLyR7Y29sbGVjdGlvblNsdWd9LyR7dmFsdWV9YCA6IG51bGw7XG59O1xuXG5jb25zdCBzdHlsZSA9ICh2YWx1ZTogYW55LCBbc3R5bGVQcm9wXTogW2FueV0pID0+IHtcbiAgaWYgKHN0eWxlUHJvcCA9PT0gJ2JhY2tncm91bmQtaW1hZ2UnKSB7XG4gICAgcmV0dXJuIHZhbHVlID8gYHVybChcIiR7dmFsdWV9XCIpYCA6ICdub25lJztcbiAgfVxuICByZXR1cm4gdmFsdWU7XG59O1xuXG5jb25zdCBudW1iZXJQcmVjaXNpb24gPSAodmFsdWU6IGFueSwgW3ByZWNpc2lvbl06IFthbnldKSA9PiB7XG4gIHJldHVybiBmb3JtYXROdW1iZXIodmFsdWUsIHByZWNpc2lvbik7XG59O1xuXG5jb25zdCByaWNoID0gKFxuICB2YWx1ZTogYW55LFxuICBwYXJhbXM6IGFueSxcbiAge3BhZ2VMaW5rSHJlZlByZWZpeCwgY29sbGVjdGlvblNsdWdNYXB9OiBUcmFuc2Zvcm1lcnNDb250ZXh0XG4pID0+IHtcbiAgaWYgKCF2YWx1ZSkge1xuICAgIHJldHVybiBudWxsO1xuICB9XG5cbiAgaWYgKHR5cGVvZiB2YWx1ZSAhPT0gJ3N0cmluZycpIHtcbiAgICByZXR1cm4gdmFsdWU7XG4gIH1cblxuICByZXR1cm4gdmFsdWUucmVwbGFjZSgvPGFcXHMrW14+XSsvZywgKGxpbmtTdHJpbmcpID0+IHtcbiAgICBjb25zdCBpc1BhZ2VMaW5rID0gL1xcc2RhdGEtcnQtbGluay10eXBlPVwicGFnZVwiLy50ZXN0KGxpbmtTdHJpbmcpO1xuICAgIGNvbnN0IG5lZWRzUHJlZml4ID0gcGFnZUxpbmtIcmVmUHJlZml4ICYmIGlzUGFnZUxpbms7XG4gICAgY29uc3QgY29sbGVjdGlvbklkTWF0Y2ggPVxuICAgICAgaXNQYWdlTGluayAmJlxuICAgICAgL1xcc2RhdGEtcnQtbGluay1jb2xsZWN0aW9uaWQ9XCIoW2EtejAtOV17MjR9KVwiLy5leGVjKGxpbmtTdHJpbmcpO1xuXG4gICAgaWYgKG5lZWRzUHJlZml4IHx8IGNvbGxlY3Rpb25JZE1hdGNoKSB7XG4gICAgICByZXR1cm4gbGlua1N0cmluZy5yZXBsYWNlKC8oXFxzaHJlZj1cIikoW15cIl0rKS8sIChtYXRjaCwgYmVnaW4sIGhyZWYpID0+IHtcbiAgICAgICAgY29uc3QgZW5kID0gY29sbGVjdGlvbklkTWF0Y2hcbiAgICAgICAgICA/IHJlcGxhY2VEZXRhaWxQYWdlSHJlZkNvbGxlY3Rpb25TbHVnKFxuICAgICAgICAgICAgICBocmVmLFxuICAgICAgICAgICAgICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFMyMzQ1IC0gQXJndW1lbnQgb2YgdHlwZSAnc3RyaW5nIHwgdW5kZWZpbmVkJyBpcyBub3QgYXNzaWduYWJsZSB0byBwYXJhbWV0ZXIgb2YgdHlwZSAnc3RyaW5nJy5cbiAgICAgICAgICAgICAgY29sbGVjdGlvbklkTWF0Y2hbMV0sXG4gICAgICAgICAgICAgIGNvbGxlY3Rpb25TbHVnTWFwXG4gICAgICAgICAgICApXG4gICAgICAgICAgOiBocmVmO1xuICAgICAgICAvLyBOZWVkIHRvIGVzY2FwZSB0aGUgcHJlZml4IGhlcmUgYXMgZHluYW1pYyBSVEUgaXMgYWRkZWQgd2l0aCBkYW5nZXJvdXNseVNldElubmVySFRNTCBpbiBSaWNoVGV4dCBhdG9tLlxuICAgICAgICBjb25zdCBwcmVmaXggPSBwYWdlTGlua0hyZWZQcmVmaXggPyBlc2NhcGUocGFnZUxpbmtIcmVmUHJlZml4KSA6ICcnO1xuICAgICAgICByZXR1cm4gYCR7YmVnaW59JHtwcmVmaXh9JHtlbmR9YDtcbiAgICAgIH0pO1xuICAgIH0gZWxzZSB7XG4gICAgICByZXR1cm4gbGlua1N0cmluZztcbiAgICB9XG4gIH0pO1xufTtcblxuLy8gQ29sbGVjdGlvbiBzbHVnIG1heSBoYXZlIGJlZW4gcmVuYW1lZCBzbyB3ZSBuZWVkIHRvIG1ha2Ugc3VyZSBkZXRhaWxcbi8vIHBhZ2UgbGlua3MgaW4gQ01TIFJpY2hUZXh0IGZpZWxkcyBzdGlsbCBwb2ludCB0byB0aGUgY29ycmVjdCBwYWdlLlxuY29uc3QgcmVwbGFjZURldGFpbFBhZ2VIcmVmQ29sbGVjdGlvblNsdWcgPSAoXG4gIGhyZWY6IGFueSxcbiAgY29sbGVjdGlvbklkOiBzdHJpbmcsXG4gIGNvbGxlY3Rpb25TbHVnTWFwOiB7XG4gICAgW2tleTogc3RyaW5nXTogc3RyaW5nO1xuICB9XG4pID0+IHtcbiAgY29uc3QgW2VtcHR5U3RyaW5nLCBvcmlnaW5hbENvbGxlY3Rpb25TbHVnLCAuLi5yZXN0XSA9IGhyZWYuc3BsaXQoJy8nKTtcbiAgY29uc3QgY29sbGVjdGlvblNsdWcgPVxuICAgIGNvbGxlY3Rpb25TbHVnTWFwW2NvbGxlY3Rpb25JZF0gfHwgb3JpZ2luYWxDb2xsZWN0aW9uU2x1ZztcbiAgcmV0dXJuIFtlbXB0eVN0cmluZywgY29sbGVjdGlvblNsdWcsIC4uLnJlc3RdLmpvaW4oJy8nKTtcbn07XG5cbmNvbnN0IGdldCA9IChvYmo6IFJlY29yZDxhbnksIGFueT4sIGtleToga2V5b2YgQ29tbWVyY2VQcmljZVBvam8pID0+IHtcbiAgaWYgKG9iaiAhPSBudWxsICYmIHR5cGVvZiBvYmouZ2V0ID09PSAnZnVuY3Rpb24nKSB7XG4gICAgcmV0dXJuIG9iai5nZXQoa2V5KTtcbiAgfVxuICByZXR1cm4gb2JqW2tleV07XG59O1xuXG50eXBlIENvbW1lcmNlUHJpY2VQb2pvID0ge1xuICB2YWx1ZTogbnVtYmVyO1xuICB1bml0OiBzdHJpbmc7XG4gIHN0cmluZzogc3RyaW5nO1xufTtcbnR5cGUgQ29tbWVyY2VQcmljZUltbSA9IHtcbiAgZ2V0OiAodmFsdWU6IGtleW9mIENvbW1lcmNlUHJpY2VQb2pvKSA9PiBhbnk7XG59O1xudHlwZSBDb21tZXJjZVByaWNlQXNJbW1PclBvam8gPSBDb21tZXJjZVByaWNlUG9qbyAmIENvbW1lcmNlUHJpY2VJbW07XG5cbmNvbnN0IHByaWNlID0gKFxuICBvYmo6IENvbW1lcmNlUHJpY2VBc0ltbU9yUG9qbyB8IHVuZGVmaW5lZCxcbiAgcGFyYW1zOiBhbnksXG4gIGNvbnRleHQ6IFRyYW5zZm9ybWVyc0NvbnRleHRcbikgPT4ge1xuICBpZiAoIW9iaikgcmV0dXJuIG51bGw7XG5cbiAgcmV0dXJuIHJlbmRlclByaWNlRnJvbVNldHRpbmdzKFxuICAgIHt1bml0OiBnZXQob2JqLCAndW5pdCcpLCB2YWx1ZTogZ2V0KG9iaiwgJ3ZhbHVlJyl9LFxuICAgIGNvbnRleHQuY3VycmVuY3lTZXR0aW5nc1xuICApO1xufTtcblxudHlwZSBUcmFuc2Zvcm1lckZuID1cbiAgfCB0eXBlb2YgZGF0ZVxuICB8IHR5cGVvZiBkZXRhaWxQYWdlXG4gIHwgdHlwZW9mIHN0eWxlXG4gIHwgdHlwZW9mIG51bWJlclByZWNpc2lvblxuICB8IHR5cGVvZiByaWNoXG4gIHwgdHlwZW9mIHByaWNlO1xuXG5mdW5jdGlvbiBnZXRUcmFuc2Zvcm1lckZuKGZuS2V5OiBzdHJpbmcpOiBUcmFuc2Zvcm1lckZuIHwgbnVsbCB7XG4gIHN3aXRjaCAoZm5LZXkpIHtcbiAgICBjYXNlICdkYXRlJzoge1xuICAgICAgcmV0dXJuIGRhdGU7XG4gICAgfVxuICAgIGNhc2UgJ2RldGFpbFBhZ2UnOiB7XG4gICAgICByZXR1cm4gZGV0YWlsUGFnZTtcbiAgICB9XG4gICAgY2FzZSAnc3R5bGUnOiB7XG4gICAgICByZXR1cm4gc3R5bGU7XG4gICAgfVxuICAgIGNhc2UgJ251bWJlclByZWNpc2lvbic6IHtcbiAgICAgIHJldHVybiBudW1iZXJQcmVjaXNpb247XG4gICAgfVxuICAgIGNhc2UgJ3JpY2gnOiB7XG4gICAgICByZXR1cm4gcmljaDtcbiAgICB9XG4gICAgY2FzZSAncHJpY2UnOiB7XG4gICAgICByZXR1cm4gcHJpY2U7XG4gICAgfVxuICAgIGRlZmF1bHQ6IHtcbiAgICAgIHJldHVybiBudWxsO1xuICAgIH1cbiAgfVxufVxuXG50eXBlIFRyYW5zZm9ybWVyc0NvbnRleHQgPSB7XG4gIHRpbWV6b25lPzogc3RyaW5nO1xuICBwYWdlTGlua0hyZWZQcmVmaXg/OiBzdHJpbmcgfCBudWxsO1xuICBjb2xsZWN0aW9uU2x1Z01hcDoge1xuICAgIFtrZXk6IHN0cmluZ106IHN0cmluZztcbiAgfTtcbiAgY3VycmVuY3lTZXR0aW5ncz86IEN1cnJlbmN5U2V0dGluZ3M7XG59O1xuXG5leHBvcnQgY29uc3QgdHJhbnNmb3JtZXJzID0gKFxuICB2YWx1ZTogdW5rbm93bixcbiAgZmlsdGVyOiBCaW5kaW5nVHJhbnNmb3JtZXIsXG4gIGNvbnRleHQ6IFRyYW5zZm9ybWVyc0NvbnRleHRcbikgPT4ge1xuICBjb25zdCB7dHlwZToga2V5LCBwYXJhbXN9ID0gZmlsdGVyO1xuICBjb25zdCBmbiA9IGdldFRyYW5zZm9ybWVyRm4oa2V5KTtcbiAgcmV0dXJuIGZuID8gZm4odmFsdWUsIHBhcmFtcywgY29udGV4dCkgOiB2YWx1ZTtcbn07XG4iXSwibmFtZXMiOlsidHJhbnNmb3JtZXJzIiwiaXNTaW1wbGVEYXRlRm9ybWF0IiwidmFsdWUiLCJ0ZXN0IiwiZGF0ZSIsImZvcm1hdCIsInRpbWV6b25lIiwibW9tZW50RGF0ZSIsIm1vbWVudCIsInV0YyIsIklTT184NjAxIiwiaXNWYWxpZCIsInR6IiwiZGV0YWlsUGFnZSIsImNvbGxlY3Rpb25JZE9yTGVnYWN5U2x1ZyIsImNvbGxlY3Rpb25TbHVnTWFwIiwiY29sbGVjdGlvblNsdWciLCJzdHlsZSIsInN0eWxlUHJvcCIsIm51bWJlclByZWNpc2lvbiIsInByZWNpc2lvbiIsImZvcm1hdE51bWJlciIsInJpY2giLCJwYXJhbXMiLCJwYWdlTGlua0hyZWZQcmVmaXgiLCJyZXBsYWNlIiwibGlua1N0cmluZyIsImlzUGFnZUxpbmsiLCJuZWVkc1ByZWZpeCIsImNvbGxlY3Rpb25JZE1hdGNoIiwiZXhlYyIsIm1hdGNoIiwiYmVnaW4iLCJocmVmIiwiZW5kIiwicmVwbGFjZURldGFpbFBhZ2VIcmVmQ29sbGVjdGlvblNsdWciLCJwcmVmaXgiLCJlc2NhcGUiLCJjb2xsZWN0aW9uSWQiLCJlbXB0eVN0cmluZyIsIm9yaWdpbmFsQ29sbGVjdGlvblNsdWciLCJyZXN0Iiwic3BsaXQiLCJqb2luIiwiZ2V0Iiwib2JqIiwia2V5IiwicHJpY2UiLCJjb250ZXh0IiwicmVuZGVyUHJpY2VGcm9tU2V0dGluZ3MiLCJ1bml0IiwiY3VycmVuY3lTZXR0aW5ncyIsImdldFRyYW5zZm9ybWVyRm4iLCJmbktleSIsImZpbHRlciIsInR5cGUiLCJmbiJdLCJtYXBwaW5ncyI6Ijs7OzsrQkF1TGFBOzs7ZUFBQUE7OzsrREF2TE07dUVBQ0E7K0JBSVo7dUNBQ29COzs7Ozs7QUFHM0Isc0ZBQXNGO0FBQ3RGLE1BQU1DLHFCQUFxQixDQUFDQyxRQUMxQixxQ0FBcUNDLElBQUksQ0FBQ0Q7QUFFNUMsTUFBTUUsT0FBTyxDQUNYRixPQUNBLENBQUNHLE9BQWMsRUFDZixFQUFDQyxXQUFXLEtBQUssRUFBc0I7SUFFdkMsSUFBSUwsbUJBQW1CQyxRQUFRO1FBQzdCSSxXQUFXO0lBQ2I7SUFFQSxNQUFNQyxhQUFhQyx1QkFBTSxDQUFDQyxHQUFHLENBQUNQLE9BQU9NLHVCQUFNLENBQUNFLFFBQVE7SUFFcEQsSUFBSUgsV0FBV0ksT0FBTyxJQUFJO1FBQ3hCLE9BQU9KLFdBQVdLLEVBQUUsQ0FBQ04sVUFBVUQsTUFBTSxDQUFDQTtJQUN4QyxPQUFPO1FBQ0wsT0FBTztJQUNUO0FBQ0Y7QUFFQSxNQUFNUSxhQUFhLENBQ2pCWCxPQUNBLENBQUNZLHlCQUFnQyxFQUNqQyxFQUFDQyxpQkFBaUIsRUFBc0I7SUFFeEMsK0VBQStFO0lBQy9FLGdGQUFnRjtJQUNoRix3RUFBd0U7SUFDeEUsTUFBTUMsaUJBQ0pELGlCQUFpQixDQUFDRCx5QkFBeUIsSUFBSUE7SUFDakQsT0FBT1osUUFBUSxDQUFDLENBQUMsRUFBRWMsZUFBZSxDQUFDLEVBQUVkLE1BQU0sQ0FBQyxHQUFHO0FBQ2pEO0FBRUEsTUFBTWUsUUFBUSxDQUFDZixPQUFZLENBQUNnQixVQUFpQjtJQUMzQyxJQUFJQSxjQUFjLG9CQUFvQjtRQUNwQyxPQUFPaEIsUUFBUSxDQUFDLEtBQUssRUFBRUEsTUFBTSxFQUFFLENBQUMsR0FBRztJQUNyQztJQUNBLE9BQU9BO0FBQ1Q7QUFFQSxNQUFNaUIsa0JBQWtCLENBQUNqQixPQUFZLENBQUNrQixVQUFpQjtJQUNyRCxPQUFPQyxJQUFBQSxtQ0FBWSxFQUFDbkIsT0FBT2tCO0FBQzdCO0FBRUEsTUFBTUUsT0FBTyxDQUNYcEIsT0FDQXFCLFFBQ0EsRUFBQ0Msa0JBQWtCLEVBQUVULGlCQUFpQixFQUFzQjtJQUU1RCxJQUFJLENBQUNiLE9BQU87UUFDVixPQUFPO0lBQ1Q7SUFFQSxJQUFJLE9BQU9BLFVBQVUsVUFBVTtRQUM3QixPQUFPQTtJQUNUO0lBRUEsT0FBT0EsTUFBTXVCLE9BQU8sQ0FBQyxlQUFlLENBQUNDO1FBQ25DLE1BQU1DLGFBQWEsNkJBQTZCeEIsSUFBSSxDQUFDdUI7UUFDckQsTUFBTUUsY0FBY0osc0JBQXNCRztRQUMxQyxNQUFNRSxvQkFDSkYsY0FDQSwrQ0FBK0NHLElBQUksQ0FBQ0o7UUFFdEQsSUFBSUUsZUFBZUMsbUJBQW1CO1lBQ3BDLE9BQU9ILFdBQVdELE9BQU8sQ0FBQyxxQkFBcUIsQ0FBQ00sT0FBT0MsT0FBT0M7Z0JBQzVELE1BQU1DLE1BQU1MLG9CQUNSTSxvQ0FDRUYsTUFDQSxxSEFBcUg7Z0JBQ3JISixpQkFBaUIsQ0FBQyxFQUFFLEVBQ3BCZCxxQkFFRmtCO2dCQUNKLHdHQUF3RztnQkFDeEcsTUFBTUcsU0FBU1oscUJBQXFCYSxJQUFBQSxlQUFNLEVBQUNiLHNCQUFzQjtnQkFDakUsT0FBTyxDQUFDLEVBQUVRLE1BQU0sRUFBRUksT0FBTyxFQUFFRixJQUFJLENBQUM7WUFDbEM7UUFDRixPQUFPO1lBQ0wsT0FBT1I7UUFDVDtJQUNGO0FBQ0Y7QUFFQSx1RUFBdUU7QUFDdkUscUVBQXFFO0FBQ3JFLE1BQU1TLHNDQUFzQyxDQUMxQ0YsTUFDQUssY0FDQXZCO0lBSUEsTUFBTSxDQUFDd0IsYUFBYUMsd0JBQXdCLEdBQUdDLEtBQUssR0FBR1IsS0FBS1MsS0FBSyxDQUFDO0lBQ2xFLE1BQU0xQixpQkFDSkQsaUJBQWlCLENBQUN1QixhQUFhLElBQUlFO0lBQ3JDLE9BQU87UUFBQ0Q7UUFBYXZCO1dBQW1CeUI7S0FBSyxDQUFDRSxJQUFJLENBQUM7QUFDckQ7QUFFQSxNQUFNQyxNQUFNLENBQUNDLEtBQXVCQztJQUNsQyxJQUFJRCxPQUFPLFFBQVEsT0FBT0EsSUFBSUQsR0FBRyxLQUFLLFlBQVk7UUFDaEQsT0FBT0MsSUFBSUQsR0FBRyxDQUFDRTtJQUNqQjtJQUNBLE9BQU9ELEdBQUcsQ0FBQ0MsSUFBSTtBQUNqQjtBQVlBLE1BQU1DLFFBQVEsQ0FDWkYsS0FDQXRCLFFBQ0F5QjtJQUVBLElBQUksQ0FBQ0gsS0FBSyxPQUFPO0lBRWpCLE9BQU9JLElBQUFBLHNDQUF1QixFQUM1QjtRQUFDQyxNQUFNTixJQUFJQyxLQUFLO1FBQVMzQyxPQUFPMEMsSUFBSUMsS0FBSztJQUFRLEdBQ2pERyxRQUFRRyxnQkFBZ0I7QUFFNUI7QUFVQSxTQUFTQyxpQkFBaUJDLEtBQWE7SUFDckMsT0FBUUE7UUFDTixLQUFLO1lBQVE7Z0JBQ1gsT0FBT2pEO1lBQ1Q7UUFDQSxLQUFLO1lBQWM7Z0JBQ2pCLE9BQU9TO1lBQ1Q7UUFDQSxLQUFLO1lBQVM7Z0JBQ1osT0FBT0k7WUFDVDtRQUNBLEtBQUs7WUFBbUI7Z0JBQ3RCLE9BQU9FO1lBQ1Q7UUFDQSxLQUFLO1lBQVE7Z0JBQ1gsT0FBT0c7WUFDVDtRQUNBLEtBQUs7WUFBUztnQkFDWixPQUFPeUI7WUFDVDtRQUNBO1lBQVM7Z0JBQ1AsT0FBTztZQUNUO0lBQ0Y7QUFDRjtBQVdPLE1BQU0vQyxlQUFlLENBQzFCRSxPQUNBb0QsUUFDQU47SUFFQSxNQUFNLEVBQUNPLE1BQU1ULEdBQUcsRUFBRXZCLE1BQU0sRUFBQyxHQUFHK0I7SUFDNUIsTUFBTUUsS0FBS0osaUJBQWlCTjtJQUM1QixPQUFPVSxLQUFLQSxHQUFHdEQsT0FBT3FCLFFBQVF5QixXQUFXOUM7QUFDM0MifQ==

}),
61649: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
_export_star(__webpack_require__(73141), exports);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gJy4vVHJhbnNmb3JtZXJzJztcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O3FCQUFjIn0=

}),
13946: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    actionListPlaybackChanged: function() {
        return actionListPlaybackChanged;
    },
    animationFrameChanged: function() {
        return animationFrameChanged;
    },
    clearRequested: function() {
        return clearRequested;
    },
    elementStateChanged: function() {
        return elementStateChanged;
    },
    eventListenerAdded: function() {
        return eventListenerAdded;
    },
    eventStateChanged: function() {
        return eventStateChanged;
    },
    instanceAdded: function() {
        return instanceAdded;
    },
    instanceRemoved: function() {
        return instanceRemoved;
    },
    instanceStarted: function() {
        return instanceStarted;
    },
    mediaQueriesDefined: function() {
        return mediaQueriesDefined;
    },
    parameterChanged: function() {
        return parameterChanged;
    },
    playbackRequested: function() {
        return playbackRequested;
    },
    previewRequested: function() {
        return previewRequested;
    },
    rawDataImported: function() {
        return rawDataImported;
    },
    sessionInitialized: function() {
        return sessionInitialized;
    },
    sessionStarted: function() {
        return sessionStarted;
    },
    sessionStopped: function() {
        return sessionStopped;
    },
    stopRequested: function() {
        return stopRequested;
    },
    testFrameRendered: function() {
        return testFrameRendered;
    },
    viewportWidthChanged: function() {
        return viewportWidthChanged;
    }
});
const _sharedconstants = __webpack_require__(7087);
const _shared = __webpack_require__(9468);
const { IX2_RAW_DATA_IMPORTED, IX2_SESSION_INITIALIZED, IX2_SESSION_STARTED, IX2_SESSION_STOPPED, IX2_PREVIEW_REQUESTED, IX2_PLAYBACK_REQUESTED, IX2_STOP_REQUESTED, IX2_CLEAR_REQUESTED, IX2_EVENT_LISTENER_ADDED, IX2_TEST_FRAME_RENDERED, IX2_EVENT_STATE_CHANGED, IX2_ANIMATION_FRAME_CHANGED, IX2_PARAMETER_CHANGED, IX2_INSTANCE_ADDED, IX2_INSTANCE_STARTED, IX2_INSTANCE_REMOVED, IX2_ELEMENT_STATE_CHANGED, IX2_ACTION_LIST_PLAYBACK_CHANGED, IX2_VIEWPORT_WIDTH_CHANGED, IX2_MEDIA_QUERIES_DEFINED } = _sharedconstants.IX2EngineActionTypes;
const { reifyState } = _shared.IX2VanillaUtils;
const rawDataImported = (rawData)=>({
        type: IX2_RAW_DATA_IMPORTED,
        payload: {
            ...reifyState(rawData)
        }
    });
const sessionInitialized = ({ hasBoundaryNodes, reducedMotion })=>({
        type: IX2_SESSION_INITIALIZED,
        payload: {
            hasBoundaryNodes,
            reducedMotion
        }
    });
const sessionStarted = ()=>({
        type: IX2_SESSION_STARTED
    });
const sessionStopped = ()=>({
        type: IX2_SESSION_STOPPED
    });
const previewRequested = ({ rawData, defer })=>({
        type: IX2_PREVIEW_REQUESTED,
        payload: {
            defer,
            rawData
        }
    });
const playbackRequested = ({ actionTypeId = _sharedconstants.ActionTypeConsts.GENERAL_START_ACTION, actionListId, actionItemId, eventId, allowEvents, immediate, testManual, verbose, rawData })=>({
        type: IX2_PLAYBACK_REQUESTED,
        payload: {
            actionTypeId,
            actionListId,
            actionItemId,
            testManual,
            eventId,
            allowEvents,
            immediate,
            verbose,
            rawData
        }
    });
const stopRequested = (actionListId)=>({
        type: IX2_STOP_REQUESTED,
        payload: {
            actionListId
        }
    });
const clearRequested = ()=>({
        type: IX2_CLEAR_REQUESTED
    });
const eventListenerAdded = (target, listenerParams)=>({
        type: IX2_EVENT_LISTENER_ADDED,
        payload: {
            target,
            listenerParams
        }
    });
const testFrameRendered = (step = 1)=>({
        type: IX2_TEST_FRAME_RENDERED,
        payload: {
            step
        }
    });
const eventStateChanged = (stateKey, newState)=>({
        type: IX2_EVENT_STATE_CHANGED,
        payload: {
            stateKey,
            newState
        }
    });
const animationFrameChanged = (now, parameters)=>({
        type: IX2_ANIMATION_FRAME_CHANGED,
        payload: {
            now,
            parameters
        }
    });
const parameterChanged = (key, value)=>({
        type: IX2_PARAMETER_CHANGED,
        payload: {
            key,
            value
        }
    });
const instanceAdded = (options)=>({
        type: IX2_INSTANCE_ADDED,
        payload: {
            ...options
        }
    });
const instanceStarted = (instanceId, time)=>({
        type: IX2_INSTANCE_STARTED,
        payload: {
            instanceId,
            time
        }
    });
const instanceRemoved = (instanceId)=>({
        type: IX2_INSTANCE_REMOVED,
        payload: {
            instanceId
        }
    });
const elementStateChanged = (elementId, actionTypeId, current, actionItem)=>({
        type: IX2_ELEMENT_STATE_CHANGED,
        payload: {
            elementId,
            actionTypeId,
            current,
            actionItem
        }
    });
const actionListPlaybackChanged = ({ actionListId, isPlaying })=>({
        type: IX2_ACTION_LIST_PLAYBACK_CHANGED,
        payload: {
            actionListId,
            isPlaying
        }
    });
const viewportWidthChanged = ({ width, mediaQueries })=>({
        type: IX2_VIEWPORT_WIDTH_CHANGED,
        payload: {
            width,
            mediaQueries
        }
    });
const mediaQueriesDefined = ()=>({
        type: IX2_MEDIA_QUERIES_DEFINED
    });

//# sourceMappingURL=data:application/json;base64,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

}),
46011: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
// Array.includes needed for IE11 @packages/systems/ix2/shared-utils/quick-effects

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    actions: function() {
        return _IX2EngineActions;
    },
    destroy: function() {
        return destroy;
    },
    init: function() {
        return init;
    },
    setEnv: function() {
        return setEnv;
    },
    store: function() {
        return store;
    }
});
const _redux = __webpack_require__(19516);
const _IX2Reducer = /*#__PURE__*/ _interop_require_default(__webpack_require__(17243));
const _IX2VanillaEngine = __webpack_require__(51970);
const _IX2EngineActions = /*#__PURE__*/ _interop_require_wildcard(__webpack_require__(13946));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const store = (0, _redux.createStore)(_IX2Reducer.default);
function setEnv(env) {
    if (env()) {
        (0, _IX2VanillaEngine.observeRequests)(store);
    }
}
function init(rawData) {
    destroy();
    (0, _IX2VanillaEngine.startEngine)({
        store,
        rawData,
        allowEvents: true
    });
}
function destroy() {
    (0, _IX2VanillaEngine.stopEngine)(store);
}

//# sourceMappingURL=data:application/json;base64,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

}),
15012: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/* eslint-env browser */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    elementContains: function() {
        return elementContains;
    },
    getChildElements: function() {
        return getChildElements;
    },
    getClosestElement: function() {
        return getClosestElement;
    },
    getProperty: function() {
        return getProperty;
    },
    getQuerySelector: function() {
        return getQuerySelector;
    },
    getRefType: function() {
        return getRefType;
    },
    getSiblingElements: function() {
        return getSiblingElements;
    },
    getStyle: function() {
        return getStyle;
    },
    getValidDocument: function() {
        return getValidDocument;
    },
    isSiblingNode: function() {
        return isSiblingNode;
    },
    matchSelector: function() {
        return matchSelector;
    },
    queryDocument: function() {
        return queryDocument;
    },
    setStyle: function() {
        return setStyle;
    }
});
const _shared = __webpack_require__(9468);
const _sharedconstants = __webpack_require__(7087);
const { ELEMENT_MATCHES } = _shared.IX2BrowserSupport;
const { IX2_ID_DELIMITER, HTML_ELEMENT, PLAIN_OBJECT, WF_PAGE } = _sharedconstants.IX2EngineConstants;
function setStyle(element, prop, value) {
    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
    element.style[prop] = value;
}
function getStyle(element, prop) {
    if (prop.startsWith('--')) {
        return window.getComputedStyle(document.documentElement).getPropertyValue(prop);
    }
    if (element.style instanceof CSSStyleDeclaration) {
        // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
        return element.style[prop];
    }
}
function getProperty(element, prop) {
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'HTMLElement'.
    return element[prop];
}
function matchSelector(selector) {
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'HTMLElement'.
    return (element)=>element[ELEMENT_MATCHES](selector);
}
function getQuerySelector({ id, selector }) {
    if (id) {
        let nodeId = id;
        if (id.indexOf(IX2_ID_DELIMITER) !== -1) {
            const pair = id.split(IX2_ID_DELIMITER);
            const pageId = pair[0];
            // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
            nodeId = pair[1];
            // Short circuit query if we're on the wrong page
            if (pageId !== document.documentElement.getAttribute(WF_PAGE)) {
                return null;
            }
        }
        return `[data-w-id="${nodeId}"], [data-w-id^="${nodeId}_instance"]`;
    }
    return selector;
}
function getValidDocument(pageId) {
    if (pageId == null || pageId === document.documentElement.getAttribute(WF_PAGE)) {
        return document;
    }
    return null;
}
function queryDocument(baseSelector, descendantSelector) {
    return Array.prototype.slice.call(document.querySelectorAll(descendantSelector ? baseSelector + ' ' + descendantSelector : baseSelector));
}
function elementContains(parent, child) {
    return parent.contains(child);
}
function isSiblingNode(a, b) {
    return a !== b && a.parentNode === b.parentNode;
}
function getChildElements(// @ts-expect-error - TS2315 - Type 'NodeList' is not generic.
sourceElements) {
    const childElements = [];
    for(let i = 0, { length } = sourceElements || []; i < length; i++){
        const { children } = sourceElements[i];
        const { length: childCount } = children;
        if (!childCount) {
            continue;
        }
        for(let j = 0; j < childCount; j++){
            childElements.push(children[j]);
        }
    }
    return childElements;
}
function getSiblingElements(sourceElements = []) {
    const elements = [];
    const parentCache = [];
    for(let i = 0, { length } = sourceElements; i < length; i++){
        // @ts-expect-error - TS2339 - Property 'parentNode' does not exist on type 'undefined'.
        const { parentNode } = sourceElements[i];
        if (!parentNode || !parentNode.children || !parentNode.children.length) {
            continue;
        }
        if (parentCache.indexOf(parentNode) !== -1) {
            continue;
        }
        parentCache.push(parentNode);
        let el = parentNode.firstElementChild;
        while(el != null){
            // @ts-expect-error - TS2345 - Argument of type 'any' is not assignable to parameter of type 'never'.
            if (sourceElements.indexOf(el) === -1) {
                elements.push(el);
            }
            el = el.nextElementSibling;
        }
    }
    return elements;
}
const getClosestElement = Element.prototype.closest ? (element, selector)=>{
    if (!document.documentElement.contains(element)) {
        return null;
    }
    return element.closest(selector);
} : (element, selector)=>{
    if (!document.documentElement.contains(element)) {
        return null;
    }
    let el = element;
    do {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'HTMLElement'. | TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'HTMLElement'.
        if (el[ELEMENT_MATCHES] && el[ELEMENT_MATCHES](selector)) {
            return el;
        }
        // @ts-expect-error - TS2322 - Type 'ParentNode | null' is not assignable to type 'HTMLElement'.
        el = el.parentNode;
    }while (el != null);
    return null;
};
function getRefType(ref) {
    if (ref != null && typeof ref == 'object') {
        return ref instanceof Element ? HTML_ELEMENT : PLAIN_OBJECT;
    }
    return null;
}

//# sourceMappingURL=data:application/json;base64,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

}),
51970: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/* eslint-env browser */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    observeRequests: function() {
        return observeRequests;
    },
    startActionGroup: function() {
        return startActionGroup;
    },
    startEngine: function() {
        return startEngine;
    },
    stopActionGroup: function() {
        return stopActionGroup;
    },
    stopAllActionGroups: function() {
        return stopAllActionGroups;
    },
    stopEngine: function() {
        return stopEngine;
    }
});
const _find = /*#__PURE__*/ _interop_require_default(__webpack_require__(19777));
const _get = /*#__PURE__*/ _interop_require_default(__webpack_require__(24738));
const _size = /*#__PURE__*/ _interop_require_default(__webpack_require__(64659));
const _omitBy = /*#__PURE__*/ _interop_require_default(__webpack_require__(13452));
const _isEmpty = /*#__PURE__*/ _interop_require_default(__webpack_require__(86633));
const _mapValues = /*#__PURE__*/ _interop_require_default(__webpack_require__(53729));
const _forEach = /*#__PURE__*/ _interop_require_default(__webpack_require__(32397));
const _throttle = /*#__PURE__*/ _interop_require_default(__webpack_require__(35082));
const _sharedconstants = __webpack_require__(7087);
const _shared = __webpack_require__(9468);
const _IX2EngineActions = __webpack_require__(13946);
const _IX2BrowserApi = /*#__PURE__*/ _interop_require_wildcard(__webpack_require__(15012));
const _IX2VanillaEvents = /*#__PURE__*/ _interop_require_default(__webpack_require__(58955));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const QuickEffectsIdList = Object.keys(_sharedconstants.QuickEffectIds);
const isQuickEffect = (actionTypeId)=>QuickEffectsIdList.includes(actionTypeId);
const { COLON_DELIMITER, BOUNDARY_SELECTOR, HTML_ELEMENT, RENDER_GENERAL, W_MOD_IX } = _sharedconstants.IX2EngineConstants;
const { getAffectedElements, getElementId, getDestinationValues, observeStore, getInstanceId, renderHTMLElement, clearAllStyles, getMaxDurationItemIndex, getComputedStyle, getInstanceOrigin, reduceListToGroup, shouldNamespaceEventParameter, getNamespacedParameterId, shouldAllowMediaQuery, cleanupHTMLElement, clearObjectCache, stringifyTarget, mediaQueriesEqual, shallowEqual } = _shared.IX2VanillaUtils;
const { isPluginType, createPluginInstance, getPluginDuration } = _shared.IX2VanillaPlugins;
const ua = navigator.userAgent;
const IS_MOBILE_SAFARI = ua.match(/iPad/i) || ua.match(/iPhone/);
// Keep throttled events at ~80fps to reduce reflows while maintaining render accuracy
const THROTTLED_EVENT_WAIT = 12;
function observeRequests(store) {
    observeStore({
        store,
        select: ({ ixRequest })=>ixRequest.preview,
        onChange: handlePreviewRequest
    });
    observeStore({
        store,
        select: ({ ixRequest })=>ixRequest.playback,
        onChange: handlePlaybackRequest
    });
    observeStore({
        store,
        select: ({ ixRequest })=>ixRequest.stop,
        onChange: handleStopRequest
    });
    observeStore({
        store,
        select: ({ ixRequest })=>ixRequest.clear,
        onChange: handleClearRequest
    });
}
function observeMediaQueryChange(store) {
    observeStore({
        store,
        select: ({ ixSession })=>ixSession.mediaQueryKey,
        onChange: ()=>{
            stopEngine(store);
            clearAllStyles({
                store,
                elementApi: _IX2BrowserApi
            });
            startEngine({
                store,
                allowEvents: true
            });
            dispatchPageUpdateEvent();
        }
    });
}
function observeOneRenderTick(store, onTick) {
    const unsubscribe = observeStore({
        store,
        select: ({ ixSession })=>ixSession.tick,
        // @ts-expect-error - TS7006 - Parameter 'tick' implicitly has an 'any' type.
        onChange: (tick)=>{
            onTick(tick);
            unsubscribe();
        }
    });
}
function handlePreviewRequest({ rawData, defer }, store) {
    const start = ()=>{
        startEngine({
            store,
            rawData,
            allowEvents: true
        });
        dispatchPageUpdateEvent();
    };
    defer ? setTimeout(start, 0) : start();
}
function dispatchPageUpdateEvent() {
    document.dispatchEvent(new CustomEvent('IX2_PAGE_UPDATE'));
}
function handlePlaybackRequest(playback, store) {
    const { actionTypeId, actionListId, actionItemId, eventId, allowEvents, immediate, testManual, verbose = true } = playback;
    let { rawData } = playback;
    if (actionListId && actionItemId && rawData && immediate) {
        const actionList = rawData.actionLists[actionListId];
        if (actionList) {
            rawData = reduceListToGroup({
                actionList,
                actionItemId,
                rawData
            });
        }
    }
    startEngine({
        store,
        rawData,
        allowEvents,
        testManual
    });
    if (actionListId && actionTypeId === _sharedconstants.ActionTypeConsts.GENERAL_START_ACTION || isQuickEffect(actionTypeId)) {
        // @ts-expect-error - TS2345 - Argument of type '{ store: any; actionListId: any; }' is not assignable to parameter of type '{ store: any; eventId: any; eventTarget: any; eventStateKey: any; actionListId: any; }'.
        stopActionGroup({
            store,
            actionListId
        });
        renderInitialGroup({
            store,
            actionListId,
            eventId
        });
        // @ts-expect-error - TS2345 - Argument of type '{ store: any; eventId: any; actionListId: any; immediate: any; verbose: any; }' is not assignable to parameter of type '{ store: any; eventId: any; eventTarget: any; eventStateKey: any; actionListId: any; groupIndex?: number | undefined; immediate: any; verbose: any; }'.
        const started = startActionGroup({
            store,
            eventId,
            actionListId,
            immediate,
            verbose
        });
        if (verbose && started) {
            store.dispatch((0, _IX2EngineActions.actionListPlaybackChanged)({
                actionListId,
                isPlaying: !immediate
            }));
        }
    }
}
function handleStopRequest({ actionListId }, store) {
    if (actionListId) {
        // @ts-expect-error - TS2345 - Argument of type '{ store: any; actionListId: any; }' is not assignable to parameter of type '{ store: any; eventId: any; eventTarget: any; eventStateKey: any; actionListId: any; }'.
        stopActionGroup({
            store,
            actionListId
        });
    } else {
        stopAllActionGroups({
            store
        });
    }
    stopEngine(store);
}
function handleClearRequest(state, store) {
    stopEngine(store);
    clearAllStyles({
        store,
        elementApi: _IX2BrowserApi
    });
}
function startEngine({ store, rawData, allowEvents, testManual }) {
    const { ixSession } = store.getState();
    if (rawData) {
        store.dispatch((0, _IX2EngineActions.rawDataImported)(rawData));
    }
    if (!ixSession.active) {
        store.dispatch((0, _IX2EngineActions.sessionInitialized)({
            hasBoundaryNodes: Boolean(document.querySelector(BOUNDARY_SELECTOR)),
            reducedMotion: document.body.hasAttribute('data-wf-ix-vacation') && window.matchMedia('(prefers-reduced-motion)').matches
        }));
        if (allowEvents) {
            bindEvents(store);
            addDocumentClass();
            if (store.getState().ixSession.hasDefinedMediaQueries) {
                observeMediaQueryChange(store);
            }
        }
        store.dispatch((0, _IX2EngineActions.sessionStarted)());
        startRenderLoop(store, testManual);
    }
}
function addDocumentClass() {
    const { documentElement } = document;
    if (documentElement.className.indexOf(W_MOD_IX) === -1) {
        documentElement.className += ` ${W_MOD_IX}`;
    }
}
function startRenderLoop(store, testManual) {
    const handleFrame = (now)=>{
        const { ixSession, ixParameters } = store.getState();
        if (ixSession.active) {
            store.dispatch((0, _IX2EngineActions.animationFrameChanged)(now, ixParameters));
            if (testManual) {
                observeOneRenderTick(store, handleFrame);
            } else {
                requestAnimationFrame(handleFrame);
            }
        }
    };
    handleFrame(window.performance.now());
}
function stopEngine(store) {
    const { ixSession } = store.getState();
    if (ixSession.active) {
        const { eventListeners } = ixSession;
        eventListeners.forEach(clearEventListener);
        clearObjectCache();
        store.dispatch((0, _IX2EngineActions.sessionStopped)());
    }
}
// @ts-expect-error - TS7031 - Binding element 'target' implicitly has an 'any' type. | TS7031 - Binding element 'listenerParams' implicitly has an 'any' type.
function clearEventListener({ target, listenerParams }) {
    // eslint-disable-next-line prefer-spread
    target.removeEventListener.apply(target, listenerParams);
}
function createGroupInstances({ // @ts-expect-error - TS7031 - Binding element 'store' implicitly has an 'any' type.
store, // @ts-expect-error - TS7031 - Binding element 'eventStateKey' implicitly has an 'any' type.
eventStateKey, // @ts-expect-error - TS7031 - Binding element 'eventTarget' implicitly has an 'any' type.
eventTarget, // @ts-expect-error - TS7031 - Binding element 'eventId' implicitly has an 'any' type.
eventId, // @ts-expect-error - TS7031 - Binding element 'eventConfig' implicitly has an 'any' type.
eventConfig, // @ts-expect-error - TS7031 - Binding element 'actionListId' implicitly has an 'any' type.
actionListId, // @ts-expect-error - TS7031 - Binding element 'parameterGroup' implicitly has an 'any' type.
parameterGroup, // @ts-expect-error - TS7031 - Binding element 'smoothing' implicitly has an 'any' type.
smoothing, // @ts-expect-error - TS7031 - Binding element 'restingValue' implicitly has an 'any' type.
restingValue }) {
    const { ixData, ixSession } = store.getState();
    const { events } = ixData;
    const event = events[eventId];
    const { eventTypeId } = event;
    const targetCache = {};
    const instanceActionGroups = {};
    const instanceConfigs = [];
    const { continuousActionGroups } = parameterGroup;
    let { id: parameterId } = parameterGroup;
    if (shouldNamespaceEventParameter(eventTypeId, eventConfig)) {
        parameterId = getNamespacedParameterId(eventStateKey, parameterId);
    }
    // Limit affected elements when event target is within a boundary node
    const eventElementRoot = ixSession.hasBoundaryNodes && eventTarget ? _IX2BrowserApi.getClosestElement(eventTarget, BOUNDARY_SELECTOR) : null;
    // @ts-expect-error - TS7006 - Parameter 'actionGroup' implicitly has an 'any' type.
    continuousActionGroups.forEach((actionGroup)=>{
        const { keyframe, actionItems } = actionGroup;
        // @ts-expect-error - TS7006 - Parameter 'actionItem' implicitly has an 'any' type.
        actionItems.forEach((actionItem)=>{
            const { actionTypeId } = actionItem;
            const { target } = actionItem.config;
            if (!target) {
                return;
            }
            const elementRoot = target.boundaryMode ? eventElementRoot : null;
            const key = stringifyTarget(target) + COLON_DELIMITER + actionTypeId;
            instanceActionGroups[key] = appendActionItem(instanceActionGroups[key], keyframe, actionItem);
            if (!targetCache[key]) {
                targetCache[key] = true;
                const { config } = actionItem;
                getAffectedElements({
                    config,
                    event,
                    eventTarget,
                    elementRoot,
                    elementApi: _IX2BrowserApi
                }).forEach((element)=>{
                    instanceConfigs.push({
                        element,
                        key
                    });
                });
            }
        });
    });
    instanceConfigs.forEach(({ element, key })=>{
        const actionGroups = instanceActionGroups[key];
        const actionItem = (0, _get.default)(actionGroups, `[0].actionItems[0]`, {});
        const { actionTypeId } = actionItem;
        const shouldUsePlugin = // If it's targeted by class, don't query the element by pluginElementId
        actionTypeId === _sharedconstants.ActionTypeConsts.PLUGIN_RIVE ? (actionItem.config?.target?.selectorGuids || []).length === 0 : isPluginType(actionTypeId);
        const pluginInstance = shouldUsePlugin ? createPluginInstance(actionTypeId)?.(element, actionItem) : null;
        const destination = getDestinationValues({
            element,
            actionItem,
            elementApi: _IX2BrowserApi
        }, // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        pluginInstance);
        createInstance({
            store,
            element,
            eventId,
            actionListId,
            actionItem,
            destination,
            continuous: true,
            parameterId,
            actionGroups,
            smoothing,
            restingValue,
            pluginInstance
        });
    });
}
function appendActionItem(actionGroups = [], keyframe, actionItem) {
    const newActionGroups = [
        ...actionGroups
    ];
    let groupIndex;
    newActionGroups.some((group, index)=>{
        // @ts-expect-error - TS2339 - Property 'keyframe' does not exist on type 'never'.
        if (group.keyframe === keyframe) {
            groupIndex = index;
            return true;
        }
        return false;
    });
    if (groupIndex == null) {
        groupIndex = newActionGroups.length;
        // @ts-expect-error - TS2345 - Argument of type '{ keyframe: any; actionItems: never[]; }' is not assignable to parameter of type 'never'.
        newActionGroups.push({
            keyframe,
            actionItems: []
        });
    }
    // @ts-expect-error - TS2339 - Property 'actionItems' does not exist on type 'never'.
    newActionGroups[groupIndex].actionItems.push(actionItem);
    return newActionGroups;
}
function bindEvents(store) {
    const { ixData } = store.getState();
    const { eventTypeMap } = ixData;
    updateViewportWidth(store);
    (0, _forEach.default)(eventTypeMap, (events, key)=>{
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ SLIDER_ACTIVE: { handler: (options: any, state: any) => any; types: string; }; SLIDER_INACTIVE: { handler: (options: any, state: any) => any; types: string; }; DROPDOWN_OPEN: { handler: (options: any, state: any) => any; types: string; }; ... 21 more ...; PAGE_START: { ...; }; }'.
        const logic = _IX2VanillaEvents.default[key];
        if (!logic) {
            console.warn(`IX2 event type not configured: ${key}`);
            return;
        }
        bindEventType({
            // @ts-expect-error - TS7031 - Binding element 'logic' implicitly has an 'any' type.
            logic,
            store,
            events
        });
    });
    const { ixSession } = store.getState();
    if (ixSession.eventListeners.length) {
        bindResizeEvents(store);
    }
}
const WINDOW_RESIZE_EVENTS = [
    'resize',
    'orientationchange'
];
function bindResizeEvents(store) {
    const handleResize = ()=>{
        updateViewportWidth(store);
    };
    WINDOW_RESIZE_EVENTS.forEach((type)=>{
        window.addEventListener(type, handleResize);
        store.dispatch((0, _IX2EngineActions.eventListenerAdded)(window, [
            type,
            handleResize
        ]));
    });
    handleResize();
}
function updateViewportWidth(store) {
    const { ixSession, ixData } = store.getState();
    const width = window.innerWidth;
    if (width !== ixSession.viewportWidth) {
        const { mediaQueries } = ixData;
        store.dispatch((0, _IX2EngineActions.viewportWidthChanged)({
            width,
            mediaQueries
        }));
    }
}
const mapFoundValues = (object, iteratee)=>(0, _omitBy.default)((0, _mapValues.default)(object, iteratee), _isEmpty.default);
const forEachEventTarget = (eventTargets, eventCallback)=>{
    (0, _forEach.default)(eventTargets, (elements, eventId)=>{
        // @ts-expect-error - TS7006 - Parameter 'element' implicitly has an 'any' type. | TS7006 - Parameter 'index' implicitly has an 'any' type.
        elements.forEach((element, index)=>{
            const eventStateKey = eventId + COLON_DELIMITER + index;
            eventCallback(element, eventId, eventStateKey);
        });
    });
};
const getAffectedForEvent = (event)=>{
    const config = {
        target: event.target,
        targets: event.targets
    };
    return getAffectedElements({
        config,
        elementApi: _IX2BrowserApi
    });
};
// @ts-expect-error - TS7031 - Binding element 'logic' implicitly has an 'any' type. | TS7031 - Binding element 'store' implicitly has an 'any' type. | TS7031 - Binding element 'events' implicitly has an 'any' type.
function bindEventType({ logic, store, events }) {
    injectBehaviorCSSFixes(events);
    const { types: eventTypes, handler: eventHandler } = logic;
    const { ixData } = store.getState();
    const { actionLists } = ixData;
    const eventTargets = mapFoundValues(events, getAffectedForEvent);
    if (!(0, _size.default)(eventTargets)) {
        return;
    }
    (0, _forEach.default)(eventTargets, (elements, key)=>{
        const event = events[key];
        const { action: eventAction, id: eventId, mediaQueries = ixData.mediaQueryKeys } = event;
        const { actionListId } = eventAction.config;
        if (!mediaQueriesEqual(mediaQueries, ixData.mediaQueryKeys)) {
            store.dispatch((0, _IX2EngineActions.mediaQueriesDefined)());
        }
        if (eventAction.actionTypeId === _sharedconstants.ActionTypeConsts.GENERAL_CONTINUOUS_ACTION) {
            const configs = Array.isArray(event.config) ? event.config : [
                event.config
            ];
            // @ts-expect-error - TS7006 - Parameter 'eventConfig' implicitly has an 'any' type.
            configs.forEach((eventConfig)=>{
                const { continuousParameterGroupId } = eventConfig;
                const paramGroups = (0, _get.default)(actionLists, `${actionListId}.continuousParameterGroups`, []);
                const parameterGroup = (0, _find.default)(paramGroups, ({ id })=>id === continuousParameterGroupId);
                const smoothing = (eventConfig.smoothing || 0) / 100;
                const restingValue = (eventConfig.restingState || 0) / 100;
                if (!parameterGroup) {
                    return;
                }
                elements.forEach((eventTarget, index)=>{
                    const eventStateKey = eventId + COLON_DELIMITER + index;
                    createGroupInstances({
                        store,
                        eventStateKey,
                        eventTarget,
                        eventId,
                        eventConfig,
                        actionListId,
                        parameterGroup,
                        smoothing,
                        restingValue
                    });
                });
            });
        }
        if (eventAction.actionTypeId === _sharedconstants.ActionTypeConsts.GENERAL_START_ACTION || isQuickEffect(eventAction.actionTypeId)) {
            renderInitialGroup({
                store,
                actionListId,
                eventId
            });
        }
    });
    const handleEvent = (nativeEvent)=>{
        const { ixSession } = store.getState();
        forEachEventTarget(eventTargets, (element, eventId, eventStateKey)=>{
            const event = events[eventId];
            const oldState = ixSession.eventState[eventStateKey];
            const { action: eventAction, mediaQueries = ixData.mediaQueryKeys } = event;
            // Bypass event handler if current media query is not listed in event config
            if (!shouldAllowMediaQuery(mediaQueries, ixSession.mediaQueryKey)) {
                return;
            }
            const handleEventWithConfig = (eventConfig = {})=>{
                const newState = eventHandler({
                    store,
                    element,
                    event,
                    eventConfig,
                    nativeEvent,
                    eventStateKey
                }, oldState);
                if (!shallowEqual(newState, oldState)) {
                    store.dispatch((0, _IX2EngineActions.eventStateChanged)(eventStateKey, newState));
                }
            };
            if (eventAction.actionTypeId === _sharedconstants.ActionTypeConsts.GENERAL_CONTINUOUS_ACTION) {
                const configs = Array.isArray(event.config) ? event.config : [
                    event.config
                ];
                configs.forEach(handleEventWithConfig);
            } else {
                handleEventWithConfig();
            }
        });
    };
    const handleEventThrottled = (0, _throttle.default)(handleEvent, THROTTLED_EVENT_WAIT);
    const addListeners = ({ target = document, // @ts-expect-error - TS7031 - Binding element 'types' implicitly has an 'any' type.
    types, // @ts-expect-error - TS7031 - Binding element 'shouldThrottle' implicitly has an 'any' type.
    throttle: shouldThrottle })=>{
        types.split(' ').filter(Boolean)// @ts-expect-error - TS7006 - Parameter 'type' implicitly has an 'any' type.
        .forEach((type)=>{
            const handlerFunc = shouldThrottle ? handleEventThrottled : handleEvent;
            target.addEventListener(type, handlerFunc);
            store.dispatch((0, _IX2EngineActions.eventListenerAdded)(target, [
                type,
                handlerFunc
            ]));
        });
    };
    if (Array.isArray(eventTypes)) {
        eventTypes.forEach(addListeners);
    } else if (typeof eventTypes === 'string') {
        addListeners(logic);
    }
}
/**
 * Injects CSS into the document to fix behavior issues across
 * different devices.
 */ function injectBehaviorCSSFixes(events) {
    if (!IS_MOBILE_SAFARI) {
        return;
    }
    const injectedSelectors = {};
    let cssText = '';
    for(const eventId in events){
        const { eventTypeId, target } = events[eventId];
        const selector = _IX2BrowserApi.getQuerySelector(target);
        // @ts-expect-error - TS2538 - Type 'null' cannot be used as an index type.
        if (injectedSelectors[selector]) {
            continue;
        }
        // add a "cursor: pointer" style rule to ensure that CLICK events get fired for IOS devices
        if (eventTypeId === _sharedconstants.EventTypeConsts.MOUSE_CLICK || eventTypeId === _sharedconstants.EventTypeConsts.MOUSE_SECOND_CLICK) {
            // @ts-expect-error - TS2538 - Type 'null' cannot be used as an index type.
            injectedSelectors[selector] = true;
            cssText += selector + '{' + 'cursor: pointer;' + 'touch-action: manipulation;' + '}';
        }
    }
    if (cssText) {
        const style = document.createElement('style');
        style.textContent = cssText;
        document.body.appendChild(style);
    }
}
function renderInitialGroup({ store, actionListId, eventId }) {
    const { ixData, ixSession } = store.getState();
    const { actionLists, events } = ixData;
    // @ts-expect-error - TS18048 - 'events' is possibly 'undefined'.
    const event = events[eventId];
    // @ts-expect-error - TS18048 - 'actionLists' is possibly 'undefined'.
    const actionList = actionLists[actionListId];
    // @ts-expect-error - Property 'useFirstGroupAsInitialState' does not exist on type 'ActionListType'.
    if (actionList && actionList.useFirstGroupAsInitialState) {
        const initialStateItems = (0, _get.default)(actionList, 'actionItemGroups[0].actionItems', []);
        // Bypass initial state render if current media query is not listed in event config
        const mediaQueries = (0, _get.default)(event, 'mediaQueries', ixData.mediaQueryKeys);
        if (!shouldAllowMediaQuery(mediaQueries, ixSession.mediaQueryKey)) {
            return;
        }
        initialStateItems.forEach((actionItem)=>{
            const { config: itemConfig, actionTypeId } = actionItem;
            const config = // When useEventTarget is explicitly true, use event target/targets to query elements
            // However, skip this condition when objectId is defined
            // @ts-expect-error - Property 'target' does not exist on type 'never'.
            itemConfig?.target?.useEventTarget === true && // @ts-expect-error - Property 'target' does not exist on type 'never'.
            itemConfig?.target?.objectId == null ? {
                target: event.target,
                targets: event.targets
            } : itemConfig;
            const itemElements = getAffectedElements({
                config,
                event,
                elementApi: _IX2BrowserApi
            });
            const shouldUsePlugin = isPluginType(actionTypeId);
            itemElements.forEach((element)=>{
                const pluginInstance = shouldUsePlugin ? createPluginInstance(actionTypeId)?.(element, actionItem) : null;
                createInstance({
                    destination: getDestinationValues({
                        element,
                        actionItem,
                        elementApi: _IX2BrowserApi
                    }, // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-expect-error
                    pluginInstance),
                    immediate: true,
                    store,
                    element,
                    eventId,
                    actionItem,
                    actionListId,
                    pluginInstance
                });
            });
        });
    }
}
function stopAllActionGroups({ store }) {
    const { ixInstances } = store.getState();
    (0, _forEach.default)(ixInstances, (instance)=>{
        if (!instance.continuous) {
            const { actionListId, verbose } = instance;
            removeInstance(instance, store);
            if (verbose) {
                store.dispatch((0, _IX2EngineActions.actionListPlaybackChanged)({
                    actionListId,
                    isPlaying: false
                }));
            }
        }
    });
}
function stopActionGroup({ // @ts-expect-error - TS7031 - Binding element 'store' implicitly has an 'any' type.
store, // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
eventId, // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
eventTarget, // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
eventStateKey, // @ts-expect-error - TS7031 - Binding element 'actionListId' implicitly has an 'any' type.
actionListId }) {
    const { ixInstances, ixSession } = store.getState();
    // Check for element boundary before stopping engine instances
    const eventElementRoot = ixSession.hasBoundaryNodes && eventTarget ? _IX2BrowserApi.getClosestElement(eventTarget, BOUNDARY_SELECTOR) : null;
    (0, _forEach.default)(ixInstances, (instance)=>{
        const boundaryMode = (0, _get.default)(instance, 'actionItem.config.target.boundaryMode');
        // Validate event key if eventStateKey was provided, otherwise default to true
        const validEventKey = eventStateKey ? instance.eventStateKey === eventStateKey : true;
        // Remove engine instances that match the required ids
        if (instance.actionListId === actionListId && instance.eventId === eventId && validEventKey) {
            // Avoid removal when root boundary does not contain instance element
            if (eventElementRoot && boundaryMode && !_IX2BrowserApi.elementContains(eventElementRoot, instance.element)) {
                return;
            }
            removeInstance(instance, store);
            if (instance.verbose) {
                store.dispatch((0, _IX2EngineActions.actionListPlaybackChanged)({
                    actionListId,
                    isPlaying: false
                }));
            }
        }
    });
}
function startActionGroup({ // @ts-expect-error - TS7031 - Binding element 'store' implicitly has an 'any' type.
store, // @ts-expect-error - TS7031 - Binding element 'eventId' implicitly has an 'any' type.
eventId, // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
eventTarget, // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
eventStateKey, // @ts-expect-error - TS7031 - Binding element 'actionListId' implicitly has an 'any' type.
actionListId, groupIndex = 0, // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
immediate, // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
verbose }) {
    const { ixData, ixSession } = store.getState();
    const { events } = ixData;
    const event = events[eventId] || {};
    const { mediaQueries = ixData.mediaQueryKeys } = event;
    const actionList = (0, _get.default)(ixData, `actionLists.${actionListId}`, {});
    const { actionItemGroups, useFirstGroupAsInitialState } = actionList;
    // Abort playback if no action groups
    if (!actionItemGroups || !actionItemGroups.length) {
        return false;
    }
    // Reset to first group when event loop is configured
    if (groupIndex >= actionItemGroups.length && (0, _get.default)(event, 'config.loop')) {
        groupIndex = 0;
    }
    // Skip initial state group during action list playback, as it should already be applied
    if (groupIndex === 0 && useFirstGroupAsInitialState) {
        groupIndex++;
    }
    // Identify first animated group and apply the initial QuickEffect delay
    const isFirstGroup = groupIndex === 0 || groupIndex === 1 && useFirstGroupAsInitialState;
    const instanceDelay = isFirstGroup && isQuickEffect(event.action?.actionTypeId) ? event.config.delay : undefined;
    // Abort playback if no action items exist at group index
    const actionItems = (0, _get.default)(actionItemGroups, [
        groupIndex,
        'actionItems'
    ], []);
    if (!actionItems.length) {
        return false;
    }
    // Abort playback if current media query is not listed in event config
    if (!shouldAllowMediaQuery(mediaQueries, ixSession.mediaQueryKey)) {
        return false;
    }
    // Limit affected elements when event target is within a boundary node
    const eventElementRoot = ixSession.hasBoundaryNodes && eventTarget ? _IX2BrowserApi.getClosestElement(eventTarget, BOUNDARY_SELECTOR) : null;
    const carrierIndex = getMaxDurationItemIndex(actionItems);
    let groupStartResult = false;
    // @ts-expect-error - TS7006 - Parameter 'actionItem' implicitly has an 'any' type. | TS7006 - Parameter 'actionIndex' implicitly has an 'any' type.
    actionItems.forEach((actionItem, actionIndex)=>{
        const { config, actionTypeId } = actionItem;
        const shouldUsePlugin = isPluginType(actionTypeId);
        const { target } = config;
        if (!target) {
            return;
        }
        const elementRoot = target.boundaryMode ? eventElementRoot : null;
        const elements = getAffectedElements({
            config,
            event,
            eventTarget,
            elementRoot,
            elementApi: _IX2BrowserApi
        });
        elements.forEach((element, elementIndex)=>{
            const pluginInstance = shouldUsePlugin ? createPluginInstance(actionTypeId)?.(element, actionItem) : null;
            const pluginDuration = shouldUsePlugin ? getPluginDuration(actionTypeId)(element, actionItem) : null;
            groupStartResult = true;
            const isCarrier = carrierIndex === actionIndex && elementIndex === 0;
            const computedStyle = getComputedStyle({
                element,
                actionItem
            });
            const destination = getDestinationValues({
                element,
                actionItem,
                elementApi: _IX2BrowserApi
            }, // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            pluginInstance);
            createInstance({
                store,
                element,
                actionItem,
                eventId,
                eventTarget,
                eventStateKey,
                actionListId,
                groupIndex,
                isCarrier,
                computedStyle,
                destination,
                immediate,
                verbose,
                pluginInstance,
                pluginDuration,
                instanceDelay
            });
        });
    });
    return groupStartResult;
}
// @ts-expect-error - TS7006 - Parameter 'options' implicitly has an 'any' type.
function createInstance(options) {
    const { store, computedStyle, ...rest } = options;
    const { element, actionItem, immediate, pluginInstance, continuous, restingValue, eventId } = rest;
    const autoStart = !continuous;
    const instanceId = getInstanceId();
    const { ixElements, ixSession, ixData } = store.getState();
    const elementId = getElementId(ixElements, element);
    const { refState } = ixElements[elementId] || {};
    const refType = _IX2BrowserApi.getRefType(element);
    const skipMotion = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly TRANSFORM_MOVE: true; readonly TRANSFORM_SCALE: true; readonly TRANSFORM_ROTATE: true; readonly TRANSFORM_SKEW: true; readonly STYLE_SIZE: true; readonly STYLE_FILTER: true; readonly STYLE_FONT_VARIATION: true; }'.
    ixSession.reducedMotion && _sharedconstants.ReducedMotionTypes[actionItem.actionTypeId];
    let skipToValue;
    if (skipMotion && continuous) {
        switch(ixData.events[eventId]?.eventTypeId){
            case _sharedconstants.EventTypeConsts.MOUSE_MOVE:
            case _sharedconstants.EventTypeConsts.MOUSE_MOVE_IN_VIEWPORT:
                skipToValue = restingValue;
                break;
            default:
                skipToValue = 0.5;
                break;
        }
    }
    const origin = getInstanceOrigin(element, refState, computedStyle, actionItem, _IX2BrowserApi, // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    pluginInstance);
    store.dispatch((0, _IX2EngineActions.instanceAdded)({
        instanceId,
        elementId,
        origin,
        refType,
        skipMotion,
        skipToValue,
        ...rest
    }));
    dispatchCustomEvent(document.body, 'ix2-animation-started', instanceId);
    if (immediate) {
        renderImmediateInstance(store, instanceId);
        return;
    }
    observeStore({
        store,
        // @ts-expect-error - TS7031 - Binding element 'ixInstances' implicitly has an 'any' type.
        select: ({ ixInstances })=>ixInstances[instanceId],
        onChange: handleInstanceChange
    });
    if (autoStart) {
        store.dispatch((0, _IX2EngineActions.instanceStarted)(instanceId, ixSession.tick));
    }
}
function removeInstance(instance, store) {
    dispatchCustomEvent(document.body, 'ix2-animation-stopping', {
        instanceId: instance.id,
        state: store.getState()
    });
    const { elementId, actionItem } = instance;
    const { ixElements } = store.getState();
    const { ref, refType } = ixElements[elementId] || {};
    if (refType === HTML_ELEMENT) {
        cleanupHTMLElement(ref, actionItem, _IX2BrowserApi);
    }
    store.dispatch((0, _IX2EngineActions.instanceRemoved)(instance.id));
}
function dispatchCustomEvent(element, eventName, detail) {
    const event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventName, true, true, detail);
    // @ts-expect-error - TS18047 - 'element' is possibly 'null'.
    element.dispatchEvent(event);
}
function renderImmediateInstance(store, instanceId) {
    const { ixParameters } = store.getState();
    store.dispatch((0, _IX2EngineActions.instanceStarted)(instanceId, 0));
    store.dispatch((0, _IX2EngineActions.animationFrameChanged)(performance.now(), ixParameters));
    const { ixInstances } = store.getState();
    handleInstanceChange(ixInstances[instanceId], store);
}
function handleInstanceChange(instance, store) {
    const { active, continuous, complete, elementId, actionItem, actionTypeId, renderType, current, groupIndex, eventId, eventTarget, eventStateKey, actionListId, isCarrier, styleProp, verbose, pluginInstance } = instance;
    // Bypass render if current media query is not listed in event config
    const { ixData, ixSession } = store.getState();
    const { events } = ixData;
    const event = events && events[eventId] ? events[eventId] : {};
    // @ts-expect-error - TS2339 -  Property 'mediaQueries' does not exist on type '{} | undefined'.
    const { mediaQueries = ixData.mediaQueryKeys } = event;
    if (!shouldAllowMediaQuery(mediaQueries, ixSession.mediaQueryKey)) {
        return;
    }
    if (continuous || active || complete) {
        if (current || renderType === RENDER_GENERAL && complete) {
            // Render current values to ref state and grab latest
            store.dispatch((0, _IX2EngineActions.elementStateChanged)(elementId, actionTypeId, current, actionItem));
            const { ixElements } = store.getState();
            const { ref, refType, refState } = ixElements[elementId] || {};
            const actionState = refState && refState[actionTypeId];
            // Render HTML and plugin elements
            if (refType === HTML_ELEMENT || isPluginType(actionTypeId)) {
                renderHTMLElement(ref, refState, actionState, eventId, actionItem, styleProp, _IX2BrowserApi, renderType, pluginInstance);
            }
        }
        if (complete) {
            if (isCarrier) {
                // @ts-expect-error - TS2345 - Argument of type '{ store: any; eventId: any; eventTarget: any; eventStateKey: any; actionListId: any; groupIndex: any; verbose: any; }' is not assignable to parameter of type '{ store: any; eventId: any; eventTarget: any; eventStateKey: any; actionListId: any; groupIndex?: number | undefined; immediate: any; verbose: any; }'.
                const started = startActionGroup({
                    store,
                    eventId,
                    eventTarget,
                    eventStateKey,
                    actionListId,
                    groupIndex: groupIndex + 1,
                    verbose
                });
                if (verbose && !started) {
                    store.dispatch((0, _IX2EngineActions.actionListPlaybackChanged)({
                        actionListId,
                        isPlaying: false
                    }));
                }
            }
            removeInstance(instance, store);
        }
    }
}

//# sourceMappingURL=data:application/json;base64,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

}),
58955: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/* eslint-env browser */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
const _flow = /*#__PURE__*/ _interop_require_default(__webpack_require__(85801));
const _get = /*#__PURE__*/ _interop_require_default(__webpack_require__(24738));
const _clamp = /*#__PURE__*/ _interop_require_default(__webpack_require__(43789));
const _sharedconstants = __webpack_require__(7087);
const _IX2VanillaEngine = __webpack_require__(51970);
const _IX2EngineActions = __webpack_require__(13946);
const _shared = __webpack_require__(9468);
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const { MOUSE_CLICK, MOUSE_SECOND_CLICK, MOUSE_DOWN, MOUSE_UP, MOUSE_OVER, MOUSE_OUT, DROPDOWN_CLOSE, DROPDOWN_OPEN, SLIDER_ACTIVE, SLIDER_INACTIVE, TAB_ACTIVE, TAB_INACTIVE, NAVBAR_CLOSE, NAVBAR_OPEN, MOUSE_MOVE, PAGE_SCROLL_DOWN, SCROLL_INTO_VIEW, SCROLL_OUT_OF_VIEW, PAGE_SCROLL_UP, SCROLLING_IN_VIEW, PAGE_FINISH, ECOMMERCE_CART_CLOSE, ECOMMERCE_CART_OPEN, PAGE_START, PAGE_SCROLL } = _sharedconstants.EventTypeConsts;
const COMPONENT_ACTIVE = 'COMPONENT_ACTIVE';
const COMPONENT_INACTIVE = 'COMPONENT_INACTIVE';
const { COLON_DELIMITER } = _sharedconstants.IX2EngineConstants;
const { getNamespacedParameterId } = _shared.IX2VanillaUtils;
const composableFilter = (predicate)=>(options)=>{
        if (typeof options === 'object' && predicate(options)) {
            return true;
        }
        return options;
    };
const isElement = composableFilter(({ element, nativeEvent })=>{
    return element === nativeEvent.target;
});
const containsElement = composableFilter(({ element, nativeEvent })=>{
    return element.contains(nativeEvent.target);
});
const isOrContainsElement = (0, _flow.default)([
    isElement,
    containsElement
]);
const getAutoStopEvent = (store, autoStopEventId)=>{
    if (autoStopEventId) {
        const { ixData } = store.getState();
        const { events } = ixData;
        const eventToStop = events[autoStopEventId];
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly PAGE_START: "PAGE_START"; readonly PAGE_FINISH: "PAGE_FINISH"; }'.
        if (eventToStop && !AUTO_STOP_DISABLED_EVENTS[eventToStop.eventTypeId]) {
            return eventToStop;
        }
    }
    return null;
};
// @ts-expect-error - TS7031 - Binding element 'store' implicitly has an 'any' type. | TS7031 - Binding element 'event' implicitly has an 'any' type.
const hasAutoStopEvent = ({ store, event })=>{
    const { action: eventAction } = event;
    const { autoStopEventId } = eventAction.config;
    return Boolean(getAutoStopEvent(store, autoStopEventId));
};
// @ts-expect-error - TS7031 - Binding element 'store' implicitly has an 'any' type. | TS7031 - Binding element 'event' implicitly has an 'any' type. | TS7031 - Binding element 'element' implicitly has an 'any' type. | TS7031 - Binding element 'eventStateKey' implicitly has an 'any' type. | TS7006 - Parameter 'state' implicitly has an 'any' type.
const actionGroupCreator = ({ store, event, element, eventStateKey }, state)=>{
    const { action: eventAction, id: eventId } = event;
    const { actionListId, autoStopEventId } = eventAction.config;
    const eventToStop = getAutoStopEvent(store, autoStopEventId);
    if (eventToStop) {
        (0, _IX2VanillaEngine.stopActionGroup)({
            store,
            eventId: autoStopEventId,
            eventTarget: element,
            eventStateKey: autoStopEventId + COLON_DELIMITER + eventStateKey.split(COLON_DELIMITER)[1],
            actionListId: (0, _get.default)(eventToStop, 'action.config.actionListId')
        });
    }
    (0, _IX2VanillaEngine.stopActionGroup)({
        store,
        eventId,
        eventTarget: element,
        eventStateKey,
        actionListId
    });
    // @ts-expect-error - TS2345 - Argument of type '{ store: any; eventId: any; eventTarget: any; eventStateKey: any; actionListId: any; }' is not assignable to parameter of type '{ store: any; eventId: any; eventTarget: any; eventStateKey: any; actionListId: any; groupIndex?: number | undefined; immediate: any; verbose: any; }'.
    (0, _IX2VanillaEngine.startActionGroup)({
        store,
        eventId,
        eventTarget: element,
        eventStateKey,
        actionListId
    });
    return state;
};
// @ts-expect-error - TS7006 - Parameter 'filter' implicitly has an 'any' type. | TS7006 - Parameter 'handler' implicitly has an 'any' type.
const withFilter = (filter, handler)=>(options, state)=>filter(options, state) === true ? handler(options, state) : state;
const baseActionGroupOptions = {
    handler: withFilter(isOrContainsElement, actionGroupCreator)
};
const baseActivityActionGroupOptions = {
    ...baseActionGroupOptions,
    types: [
        COMPONENT_ACTIVE,
        COMPONENT_INACTIVE
    ].join(' ')
};
const SCROLL_EVENT_TYPES = [
    {
        target: window,
        types: 'resize orientationchange',
        throttle: true
    },
    {
        target: document,
        types: 'scroll wheel readystatechange IX2_PAGE_UPDATE',
        throttle: true
    }
];
const MOUSE_OVER_OUT_TYPES = 'mouseover mouseout';
const baseScrollActionGroupOptions = {
    types: SCROLL_EVENT_TYPES
};
const AUTO_STOP_DISABLED_EVENTS = {
    PAGE_START,
    PAGE_FINISH
};
const getDocumentState = (()=>{
    const supportOffset = window.pageXOffset !== undefined;
    const isCSS1Compat = document.compatMode === 'CSS1Compat';
    const rootElement = isCSS1Compat ? document.documentElement : document.body;
    return ()=>({
            scrollLeft: supportOffset ? window.pageXOffset : rootElement.scrollLeft,
            scrollTop: supportOffset ? window.pageYOffset : rootElement.scrollTop,
            // required to remove elasticity in Safari scrolling.
            stiffScrollTop: (0, _clamp.default)(supportOffset ? window.pageYOffset : rootElement.scrollTop, 0, rootElement.scrollHeight - window.innerHeight),
            scrollWidth: rootElement.scrollWidth,
            scrollHeight: rootElement.scrollHeight,
            clientWidth: rootElement.clientWidth,
            clientHeight: rootElement.clientHeight,
            innerWidth: window.innerWidth,
            innerHeight: window.innerHeight
        });
})();
const areBoxesIntersecting = (a, b)=>!(a.left > b.right || a.right < b.left || a.top > b.bottom || a.bottom < b.top);
// @ts-expect-error - TS7031 - Binding element 'element' implicitly has an 'any' type. | TS7031 - Binding element 'nativeEvent' implicitly has an 'any' type.
const isElementHovered = ({ element, nativeEvent })=>{
    const { type, target, relatedTarget } = nativeEvent;
    const containsTarget = element.contains(target);
    if (type === 'mouseover' && containsTarget) {
        return true;
    }
    const containsRelated = element.contains(relatedTarget);
    if (type === 'mouseout' && containsTarget && containsRelated) {
        return true;
    }
    return false;
};
const isElementVisible = (options)=>{
    const { element, event: { config } } = options;
    const { clientWidth, clientHeight } = getDocumentState();
    const scrollOffsetValue = config.scrollOffsetValue;
    const scrollOffsetUnit = config.scrollOffsetUnit;
    const isPX = scrollOffsetUnit === 'PX';
    const offsetPadding = isPX ? scrollOffsetValue : clientHeight * (scrollOffsetValue || 0) / 100;
    return areBoxesIntersecting(element.getBoundingClientRect(), {
        left: 0,
        top: offsetPadding,
        right: clientWidth,
        bottom: clientHeight - offsetPadding
    });
};
const whenComponentActiveChange = // @ts-expect-error - TS7006 - Parameter 'handler' implicitly has an 'any' type.
(handler)=>(options, oldState)=>{
        const { type } = options.nativeEvent;
        // prettier-ignore
        const isActive = [
            COMPONENT_ACTIVE,
            COMPONENT_INACTIVE
        ].indexOf(type) !== -1 ? type === COMPONENT_ACTIVE : oldState.isActive;
        const newState = {
            ...oldState,
            isActive
        };
        if (!oldState || newState.isActive !== oldState.isActive) {
            return handler(options, newState) || newState;
        }
        return newState;
    };
const whenElementHoverChange = (handler)=>(options, oldState)=>{
        const newState = {
            elementHovered: isElementHovered(options)
        };
        if (oldState ? newState.elementHovered !== oldState.elementHovered : newState.elementHovered) {
            // @ts-expect-error - TS1345 - An expression of type 'void' cannot be tested for truthiness.
            return handler(options, newState) || newState;
        }
        return newState;
    };
const whenElementVisibiltyChange = (handler)=>(options, oldState)=>{
        const newState = {
            ...oldState,
            elementVisible: isElementVisible(options)
        };
        if (oldState ? newState.elementVisible !== oldState.elementVisible : newState.elementVisible) {
            return handler(options, newState) || newState;
        }
        return newState;
    };
const whenScrollDirectionChange = // @ts-expect-error - TS7006 - Parameter 'handler' implicitly has an 'any' type.
(handler)=>(options, oldState = {})=>{
        const { stiffScrollTop: scrollTop, scrollHeight, innerHeight } = getDocumentState();
        const { event: { config, eventTypeId } } = options;
        const { scrollOffsetValue, scrollOffsetUnit } = config;
        const isPX = scrollOffsetUnit === 'PX';
        const scrollHeightBounds = scrollHeight - innerHeight;
        // percent top since innerHeight may change for mobile devices which also changes the scrollTop value.
        const percentTop = Number((scrollTop / scrollHeightBounds).toFixed(2));
        // no state change
        // @ts-expect-error - TS2339 - Property 'percentTop' does not exist on type '{}'.
        if (oldState && oldState.percentTop === percentTop) {
            return oldState;
        }
        const scrollTopPadding = (isPX ? scrollOffsetValue : innerHeight * (scrollOffsetValue || 0) / 100) / scrollHeightBounds;
        let scrollingDown;
        let scrollDirectionChanged;
        let anchorTop = 0;
        if (oldState) {
            // @ts-expect-error - TS2339 - Property 'percentTop' does not exist on type '{}'.
            scrollingDown = percentTop > oldState.percentTop;
            // @ts-expect-error - TS2339 - Property 'scrollingDown' does not exist on type '{}'.
            scrollDirectionChanged = oldState.scrollingDown !== scrollingDown;
            // @ts-expect-error - TS2339 - Property 'anchorTop' does not exist on type '{}'.
            anchorTop = scrollDirectionChanged ? percentTop : oldState.anchorTop;
        }
        const inBounds = eventTypeId === PAGE_SCROLL_DOWN ? percentTop >= anchorTop + scrollTopPadding : percentTop <= anchorTop - scrollTopPadding;
        const newState = {
            ...oldState,
            percentTop,
            inBounds,
            anchorTop,
            scrollingDown
        };
        if (oldState && inBounds && // @ts-expect-error - TS2339 - Property 'inBounds' does not exist on type '{}'.
        (scrollDirectionChanged || newState.inBounds !== oldState.inBounds)) {
            return handler(options, newState) || newState;
        }
        return newState;
    };
const pointIntersects = (point, rect)=>point.left > rect.left && point.left < rect.right && point.top > rect.top && point.top < rect.bottom;
const whenPageLoadFinish = (handler)=>(options, oldState)=>{
        const newState = {
            finished: document.readyState === 'complete'
        };
        if (newState.finished && !(oldState && oldState.finshed)) {
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            handler(options);
        }
        return newState;
    };
const whenPageLoadStart = (handler)=>(options, oldState)=>{
        const newState = {
            started: true
        };
        if (!oldState) {
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            handler(options);
        }
        return newState;
    };
const whenClickCountChange = (handler)=>(options, oldState = {
        clickCount: 0
    })=>{
        const newState = {
            clickCount: oldState.clickCount % 2 + 1
        };
        if (newState.clickCount !== oldState.clickCount) {
            // @ts-expect-error - TS1345 - An expression of type 'void' cannot be tested for truthiness.
            return handler(options, newState) || newState;
        }
        return newState;
    };
const getComponentActiveOptions = (allowNestedChildrenEvents = true)=>({
        ...baseActivityActionGroupOptions,
        handler: withFilter(allowNestedChildrenEvents ? isOrContainsElement : isElement, // @ts-expect-error - TS7006 - Parameter 'options' implicitly has an 'any' type. | TS7006 - Parameter 'state' implicitly has an 'any' type.
        whenComponentActiveChange((options, state)=>{
            return state.isActive ? baseActionGroupOptions.handler(options, state) : state;
        }))
    });
const getComponentInactiveOptions = (allowNestedChildrenEvents = true)=>({
        ...baseActivityActionGroupOptions,
        handler: withFilter(allowNestedChildrenEvents ? isOrContainsElement : isElement, // @ts-expect-error - TS7006 - Parameter 'options' implicitly has an 'any' type. | TS7006 - Parameter 'state' implicitly has an 'any' type.
        whenComponentActiveChange((options, state)=>{
            return !state.isActive ? baseActionGroupOptions.handler(options, state) : state;
        }))
    });
const scrollIntoOutOfViewOptions = {
    ...baseScrollActionGroupOptions,
    handler: whenElementVisibiltyChange((options, state)=>{
        const { elementVisible } = state;
        const { event, store } = options;
        const { ixData } = store.getState();
        const { events } = ixData;
        // trigger the handler only once if only one of SCROLL_INTO or SCROLL_OUT_OF event types
        // are registered.
        if (!events[event.action.config.autoStopEventId] && state.triggered) {
            return state;
        }
        if (event.eventTypeId === SCROLL_INTO_VIEW === elementVisible) {
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            actionGroupCreator(options);
            return {
                ...state,
                triggered: true
            };
        } else {
            return state;
        }
    })
};
const MOUSE_OUT_ROUND_THRESHOLD = 0.05;
const _default = {
    [SLIDER_ACTIVE]: getComponentActiveOptions(),
    [SLIDER_INACTIVE]: getComponentInactiveOptions(),
    [DROPDOWN_OPEN]: getComponentActiveOptions(),
    [DROPDOWN_CLOSE]: getComponentInactiveOptions(),
    // navbar elements may contain nested components in the menu. To prevent activity misfires, only listed for activity
    // events where the target is the navbar element, and ignore children that dispatch activitiy events.
    [NAVBAR_OPEN]: getComponentActiveOptions(false),
    [NAVBAR_CLOSE]: getComponentInactiveOptions(false),
    [TAB_ACTIVE]: getComponentActiveOptions(),
    [TAB_INACTIVE]: getComponentInactiveOptions(),
    [ECOMMERCE_CART_OPEN]: {
        types: 'ecommerce-cart-open',
        handler: withFilter(isOrContainsElement, actionGroupCreator)
    },
    [ECOMMERCE_CART_CLOSE]: {
        types: 'ecommerce-cart-close',
        handler: withFilter(isOrContainsElement, actionGroupCreator)
    },
    [MOUSE_CLICK]: {
        types: 'click',
        handler: withFilter(isOrContainsElement, whenClickCountChange((options, { clickCount })=>{
            if (hasAutoStopEvent(options)) {
                // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
                clickCount === 1 && actionGroupCreator(options);
            } else {
                // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
                actionGroupCreator(options);
            }
        }))
    },
    [MOUSE_SECOND_CLICK]: {
        types: 'click',
        handler: withFilter(isOrContainsElement, whenClickCountChange((options, { clickCount })=>{
            if (clickCount === 2) {
                // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
                actionGroupCreator(options);
            }
        }))
    },
    [MOUSE_DOWN]: {
        ...baseActionGroupOptions,
        types: 'mousedown'
    },
    [MOUSE_UP]: {
        ...baseActionGroupOptions,
        types: 'mouseup'
    },
    [MOUSE_OVER]: {
        types: MOUSE_OVER_OUT_TYPES,
        handler: withFilter(isOrContainsElement, whenElementHoverChange((options, state)=>{
            if (state.elementHovered) {
                // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
                actionGroupCreator(options);
            }
        }))
    },
    [MOUSE_OUT]: {
        types: MOUSE_OVER_OUT_TYPES,
        handler: withFilter(isOrContainsElement, whenElementHoverChange((options, state)=>{
            if (!state.elementHovered) {
                // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
                actionGroupCreator(options);
            }
        }))
    },
    [MOUSE_MOVE]: {
        types: 'mousemove mouseout scroll',
        handler: (// eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        { store, element, eventConfig, nativeEvent, eventStateKey }, state = {
            clientX: 0,
            clientY: 0,
            pageX: 0,
            pageY: 0
        })=>{
            const { basedOn, selectedAxis, continuousParameterGroupId, reverse, restingState = 0 } = eventConfig;
            const { clientX = state.clientX, clientY = state.clientY, pageX = state.pageX, pageY = state.pageY } = nativeEvent;
            const isXAxis = selectedAxis === 'X_AXIS';
            const isMouseOut = nativeEvent.type === 'mouseout';
            let value = restingState / 100;
            let namespacedParameterId = continuousParameterGroupId;
            let elementHovered = false;
            switch(basedOn){
                case _sharedconstants.EventBasedOn.VIEWPORT:
                    {
                        value = isXAxis ? Math.min(clientX, window.innerWidth) / window.innerWidth : Math.min(clientY, window.innerHeight) / window.innerHeight;
                        break;
                    }
                // @ts-expect-error - TS2339 - Property 'PAGE' does not exist on type '{ readonly ELEMENT: "ELEMENT"; readonly VIEWPORT: "VIEWPORT"; }'.
                case _sharedconstants.EventBasedOn.PAGE:
                    {
                        const { scrollLeft, scrollTop, scrollWidth, scrollHeight } = getDocumentState();
                        value = isXAxis ? Math.min(scrollLeft + pageX, scrollWidth) / scrollWidth : Math.min(scrollTop + pageY, scrollHeight) / scrollHeight;
                        break;
                    }
                case _sharedconstants.EventBasedOn.ELEMENT:
                default:
                    {
                        namespacedParameterId = getNamespacedParameterId(eventStateKey, continuousParameterGroupId);
                        const isMouseEvent = nativeEvent.type.indexOf('mouse') === 0;
                        // Use isOrContainsElement for mouse events since they are fired from the target
                        if (isMouseEvent && isOrContainsElement({
                            element,
                            nativeEvent
                        }) !== true) {
                            break;
                        }
                        const rect = element.getBoundingClientRect();
                        const { left, top, width, height } = rect;
                        // Otherwise we'll need to calculate the mouse position from the previous handler state
                        // against the target element's rect
                        if (!isMouseEvent && !pointIntersects({
                            left: clientX,
                            top: clientY
                        }, rect)) {
                            break;
                        }
                        elementHovered = true;
                        value = isXAxis ? (clientX - left) / width : (clientY - top) / height;
                        break;
                    }
            }
            // cover case where the event is a mouse out, but the value is not quite at 100%
            if (isMouseOut && (value > 1 - MOUSE_OUT_ROUND_THRESHOLD || value < MOUSE_OUT_ROUND_THRESHOLD)) {
                value = Math.round(value);
            }
            // Only update based on element if the mouse is moving over or has just left the element
            if (basedOn !== _sharedconstants.EventBasedOn.ELEMENT || elementHovered || // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            elementHovered !== state.elementHovered) {
                value = reverse ? 1 - value : value;
                store.dispatch((0, _IX2EngineActions.parameterChanged)(namespacedParameterId, value));
            }
            return {
                elementHovered,
                clientX,
                clientY,
                pageX,
                pageY
            };
        }
    },
    [PAGE_SCROLL]: {
        types: SCROLL_EVENT_TYPES,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        handler: ({ store, eventConfig })=>{
            const { continuousParameterGroupId, reverse } = eventConfig;
            const { scrollTop, scrollHeight, clientHeight } = getDocumentState();
            let value = scrollTop / (scrollHeight - clientHeight);
            value = reverse ? 1 - value : value;
            store.dispatch((0, _IX2EngineActions.parameterChanged)(continuousParameterGroupId, value));
        }
    },
    [SCROLLING_IN_VIEW]: {
        types: SCROLL_EVENT_TYPES,
        handler: (// eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        { element, store, eventConfig, eventStateKey }, state = {
            scrollPercent: 0
        })=>{
            const { scrollLeft, scrollTop, scrollWidth, scrollHeight, clientHeight: visibleHeight } = getDocumentState();
            const { basedOn, selectedAxis, continuousParameterGroupId, startsEntering, startsExiting, addEndOffset, addStartOffset, addOffsetValue = 0, endOffsetValue = 0 } = eventConfig;
            const isXAxis = selectedAxis === 'X_AXIS';
            if (basedOn === _sharedconstants.EventBasedOn.VIEWPORT) {
                const value = isXAxis ? scrollLeft / scrollWidth : scrollTop / scrollHeight;
                if (value !== state.scrollPercent) {
                    store.dispatch((0, _IX2EngineActions.parameterChanged)(continuousParameterGroupId, value));
                }
                return {
                    scrollPercent: value
                };
            } else {
                const namespacedParameterId = getNamespacedParameterId(eventStateKey, continuousParameterGroupId);
                const elementRect = element.getBoundingClientRect();
                let offsetStartPerc = (addStartOffset ? addOffsetValue : 0) / 100;
                let offsetEndPerc = (addEndOffset ? endOffsetValue : 0) / 100;
                // flip the offset percentages depending on start / exit type
                offsetStartPerc = startsEntering ? offsetStartPerc : 1 - offsetStartPerc;
                offsetEndPerc = startsExiting ? offsetEndPerc : 1 - offsetEndPerc;
                const offsetElementTop = elementRect.top + Math.min(elementRect.height * offsetStartPerc, visibleHeight);
                const offsetElementBottom = elementRect.top + elementRect.height * offsetEndPerc;
                const offsetHeight = offsetElementBottom - offsetElementTop;
                const fixedScrollHeight = Math.min(visibleHeight + offsetHeight, scrollHeight);
                const fixedScrollTop = Math.min(Math.max(0, visibleHeight - offsetElementTop), fixedScrollHeight);
                const fixedScrollPerc = fixedScrollTop / fixedScrollHeight;
                if (fixedScrollPerc !== state.scrollPercent) {
                    store.dispatch((0, _IX2EngineActions.parameterChanged)(namespacedParameterId, fixedScrollPerc));
                }
                return {
                    scrollPercent: fixedScrollPerc
                };
            }
        }
    },
    [SCROLL_INTO_VIEW]: scrollIntoOutOfViewOptions,
    [SCROLL_OUT_OF_VIEW]: scrollIntoOutOfViewOptions,
    [PAGE_SCROLL_DOWN]: {
        ...baseScrollActionGroupOptions,
        // @ts-expect-error - TS7006 - Parameter 'options' implicitly has an 'any' type. | TS7006 - Parameter 'state' implicitly has an 'any' type.
        handler: whenScrollDirectionChange((options, state)=>{
            if (state.scrollingDown) {
                // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
                actionGroupCreator(options);
            }
        })
    },
    [PAGE_SCROLL_UP]: {
        ...baseScrollActionGroupOptions,
        // @ts-expect-error - TS7006 - Parameter 'options' implicitly has an 'any' type. | TS7006 - Parameter 'state' implicitly has an 'any' type.
        handler: whenScrollDirectionChange((options, state)=>{
            if (!state.scrollingDown) {
                // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
                actionGroupCreator(options);
            }
        })
    },
    [PAGE_FINISH]: {
        types: 'readystatechange IX2_PAGE_UPDATE',
        handler: withFilter(isElement, whenPageLoadFinish(actionGroupCreator))
    },
    [PAGE_START]: {
        types: 'readystatechange IX2_PAGE_UPDATE',
        handler: withFilter(isElement, whenPageLoadStart(actionGroupCreator))
    }
};

//# sourceMappingURL=data:application/json;base64,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

}),
34609: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ixData", ({
    enumerable: true,
    get: function() {
        return ixData;
    }
}));
const _sharedconstants = __webpack_require__(7087);
const { IX2_RAW_DATA_IMPORTED } = _sharedconstants.IX2EngineActionTypes;
const ixData = (state = Object.freeze({}), action)=>{
    switch(action.type){
        case IX2_RAW_DATA_IMPORTED:
            {
                return action.payload.ixData || Object.freeze({});
            }
        default:
            {
                return state;
            }
    }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIklYMkRhdGFSZWR1Y2VyLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7SVgyRW5naW5lQWN0aW9uVHlwZXN9IGZyb20gJ0BwYWNrYWdlcy9zeXN0ZW1zL2l4Mi9zaGFyZWQtY29uc3RhbnRzJztcbmltcG9ydCB7cmF3RGF0YUltcG9ydGVkUGF5bG9hZH0gZnJvbSAnLi4vYWN0aW9ucy9JWDJFbmdpbmVBY3Rpb25zJztcbmNvbnN0IHtJWDJfUkFXX0RBVEFfSU1QT1JURUR9ID0gSVgyRW5naW5lQWN0aW9uVHlwZXM7XG5cbnR5cGUgaXhEYXRhUmVkdWNlckFjdGlvbiA9IHtcbiAgdHlwZTogdHlwZW9mIElYMl9SQVdfREFUQV9JTVBPUlRFRDtcbiAgcGF5bG9hZDogcmF3RGF0YUltcG9ydGVkUGF5bG9hZDtcbn07XG5cbmV4cG9ydCB0eXBlIGl4RGF0YVJlZHVjZXJTdGF0ZSA9IHJhd0RhdGFJbXBvcnRlZFBheWxvYWRbJ2l4RGF0YSddO1xuXG5leHBvcnQgY29uc3QgaXhEYXRhID0gKFxuICBzdGF0ZTogaXhEYXRhUmVkdWNlclN0YXRlID0gT2JqZWN0LmZyZWV6ZShcbiAgICB7fVxuICApIGFzIHJhd0RhdGFJbXBvcnRlZFBheWxvYWRbJ2l4RGF0YSddLFxuICBhY3Rpb246IGl4RGF0YVJlZHVjZXJBY3Rpb25cbikgPT4ge1xuICBzd2l0Y2ggKGFjdGlvbi50eXBlKSB7XG4gICAgY2FzZSBJWDJfUkFXX0RBVEFfSU1QT1JURUQ6IHtcbiAgICAgIHJldHVybiBhY3Rpb24ucGF5bG9hZC5peERhdGEgfHwgT2JqZWN0LmZyZWV6ZSh7fSk7XG4gICAgfVxuICAgIGRlZmF1bHQ6IHtcbiAgICAgIHJldHVybiBzdGF0ZTtcbiAgICB9XG4gIH1cbn07XG4iXSwibmFtZXMiOlsiaXhEYXRhIiwiSVgyX1JBV19EQVRBX0lNUE9SVEVEIiwiSVgyRW5naW5lQWN0aW9uVHlwZXMiLCJzdGF0ZSIsIk9iamVjdCIsImZyZWV6ZSIsImFjdGlvbiIsInR5cGUiLCJwYXlsb2FkIl0sIm1hcHBpbmdzIjoiOzs7OytCQVdhQTs7O2VBQUFBOzs7aUNBWHNCO0FBRW5DLE1BQU0sRUFBQ0MscUJBQXFCLEVBQUMsR0FBR0MscUNBQW9CO0FBUzdDLE1BQU1GLFNBQVMsQ0FDcEJHLFFBQTRCQyxPQUFPQyxNQUFNLENBQ3ZDLENBQUMsRUFDa0MsRUFDckNDO0lBRUEsT0FBUUEsT0FBT0MsSUFBSTtRQUNqQixLQUFLTjtZQUF1QjtnQkFDMUIsT0FBT0ssT0FBT0UsT0FBTyxDQUFDUixNQUFNLElBQUlJLE9BQU9DLE1BQU0sQ0FBQyxDQUFDO1lBQ2pEO1FBQ0E7WUFBUztnQkFDUCxPQUFPRjtZQUNUO0lBQ0Y7QUFDRiJ9

}),
7718: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/* eslint-env browser */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ixInstances", ({
    enumerable: true,
    get: function() {
        return ixInstances;
    }
}));
const _sharedconstants = __webpack_require__(7087);
const _shared = __webpack_require__(9468);
const _timm = __webpack_require__(81185);
const { IX2_RAW_DATA_IMPORTED, IX2_SESSION_STOPPED, IX2_INSTANCE_ADDED, IX2_INSTANCE_STARTED, IX2_INSTANCE_REMOVED, IX2_ANIMATION_FRAME_CHANGED } = _sharedconstants.IX2EngineActionTypes;
const { optimizeFloat, applyEasing, createBezierEasing } = _shared.IX2EasingUtils;
const { RENDER_GENERAL } = _sharedconstants.IX2EngineConstants;
const { getItemConfigByKey, getRenderType, getStyleProp } = _shared.IX2VanillaUtils;
const continuousInstance = (state, action)=>{
    const { position: lastPosition, parameterId, actionGroups, destinationKeys, smoothing, restingValue, actionTypeId, customEasingFn, skipMotion, skipToValue } = state;
    const { parameters } = action.payload;
    let velocity = Math.max(1 - smoothing, 0.01);
    let paramValue = parameters[parameterId];
    if (paramValue == null) {
        velocity = 1;
        paramValue = restingValue;
    }
    const nextPosition = Math.max(paramValue, 0) || 0;
    const positionDiff = optimizeFloat(nextPosition - lastPosition);
    const position = skipMotion ? skipToValue : optimizeFloat(lastPosition + positionDiff * velocity);
    const keyframePosition = position * 100;
    if (position === lastPosition && state.current) {
        return state;
    }
    let fromActionItem;
    let toActionItem;
    let positionOffset;
    let positionRange;
    for(let i = 0, { length } = actionGroups; i < length; i++){
        const { keyframe, actionItems } = actionGroups[i];
        if (i === 0) {
            fromActionItem = actionItems[0];
        }
        if (keyframePosition >= keyframe) {
            fromActionItem = actionItems[0];
            const nextGroup = actionGroups[i + 1];
            const hasNextItem = nextGroup && keyframePosition !== keyframe;
            toActionItem = hasNextItem ? nextGroup.actionItems[0] : null;
            if (hasNextItem) {
                positionOffset = keyframe / 100;
                positionRange = (nextGroup.keyframe - keyframe) / 100;
            }
        }
    }
    const current = {};
    if (fromActionItem && !toActionItem) {
        for(let i = 0, { length } = destinationKeys; i < length; i++){
            const key = destinationKeys[i];
            current[key] = getItemConfigByKey(actionTypeId, key, fromActionItem.config);
        }
    } else if (fromActionItem && toActionItem && positionOffset !== undefined && positionRange !== undefined) {
        const localPosition = (position - positionOffset) / positionRange;
        const easing = fromActionItem.config.easing;
        const eased = applyEasing(easing, localPosition, customEasingFn);
        for(let i = 0, { length } = destinationKeys; i < length; i++){
            const key = destinationKeys[i];
            const fromVal = getItemConfigByKey(actionTypeId, key, fromActionItem.config);
            const toVal = getItemConfigByKey(actionTypeId, key, toActionItem.config);
            const diff = toVal - fromVal;
            const value = diff * eased + fromVal;
            current[key] = value;
        }
    }
    return (0, _timm.merge)(state, {
        position,
        current
    });
};
const timedInstance = (state, action)=>{
    const { active, origin, start, immediate, renderType, verbose, actionItem, destination, destinationKeys, pluginDuration, instanceDelay, customEasingFn, skipMotion } = state;
    const easing = actionItem.config.easing;
    let { duration, delay } = actionItem.config;
    if (pluginDuration != null) {
        duration = pluginDuration;
    }
    delay = instanceDelay != null ? instanceDelay : delay;
    if (renderType === RENDER_GENERAL) {
        duration = 0;
    } else if (immediate || skipMotion) {
        duration = delay = 0;
    }
    const { now } = action.payload;
    if (active && origin) {
        const delta = now - (start + delay);
        if (verbose) {
            const verboseDelta = now - start;
            const verboseDuration = duration + delay;
            const verbosePosition = optimizeFloat(Math.min(Math.max(0, verboseDelta / verboseDuration), 1));
            state = (0, _timm.set)(state, 'verboseTimeElapsed', verboseDuration * verbosePosition);
        }
        if (delta < 0) {
            return state;
        }
        const position = optimizeFloat(Math.min(Math.max(0, delta / duration), 1));
        const eased = applyEasing(easing, position, customEasingFn);
        const newProps = {};
        let current = null;
        if (destinationKeys.length) {
            // @ts-expect-error - TS2347 - Untyped function calls may not accept type arguments. | TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'key' implicitly has an 'any' type.
            current = destinationKeys.reduce((result, key)=>{
                const destValue = destination[key];
                const originVal = parseFloat(origin[key]) || 0;
                const diff = parseFloat(destValue) - originVal;
                const value = diff * eased + originVal;
                result[key] = value;
                return result;
            }, {});
        }
        newProps.current = current;
        newProps.position = position;
        if (position === 1) {
            newProps.active = false;
            newProps.complete = true;
        }
        return (0, _timm.merge)(state, newProps);
    }
    return state;
};
const ixInstances = (state = Object.freeze({}), action)=>{
    switch(action.type){
        case IX2_RAW_DATA_IMPORTED:
            {
                return action.payload.ixInstances || Object.freeze({});
            }
        case IX2_SESSION_STOPPED:
            {
                return Object.freeze({});
            }
        case IX2_INSTANCE_ADDED:
            {
                const { instanceId, elementId, actionItem, eventId, eventTarget, eventStateKey, actionListId, groupIndex, isCarrier, origin, destination, immediate, verbose, continuous, parameterId, actionGroups, smoothing, restingValue, pluginInstance, pluginDuration, instanceDelay, skipMotion, skipToValue } = action.payload;
                const { actionTypeId } = actionItem;
                const renderType = getRenderType(actionTypeId);
                const styleProp = getStyleProp(renderType, actionTypeId);
                const destinationKeys = Object.keys(destination).filter((key)=>// Skip null destination values
                    destination[key] != null && // Skip string destination values
                    typeof destination[key] !== 'string');
                const { easing } = actionItem.config;
                return (0, _timm.set)(state, instanceId, {
                    id: instanceId,
                    elementId,
                    active: false,
                    position: 0,
                    start: 0,
                    origin,
                    destination,
                    destinationKeys,
                    immediate,
                    verbose,
                    current: null,
                    actionItem,
                    actionTypeId,
                    eventId,
                    eventTarget,
                    eventStateKey,
                    actionListId,
                    groupIndex,
                    renderType,
                    isCarrier,
                    styleProp,
                    continuous,
                    parameterId,
                    actionGroups,
                    smoothing,
                    restingValue,
                    pluginInstance,
                    pluginDuration,
                    instanceDelay,
                    skipMotion,
                    skipToValue,
                    customEasingFn: Array.isArray(easing) && easing.length === 4 ? createBezierEasing(easing) : undefined
                });
            }
        case IX2_INSTANCE_STARTED:
            {
                const { instanceId, time } = action.payload;
                return (0, _timm.mergeIn)(state, [
                    instanceId
                ], {
                    active: true,
                    complete: false,
                    start: time
                });
            }
        case IX2_INSTANCE_REMOVED:
            {
                const { instanceId } = action.payload;
                if (!state[instanceId]) {
                    return state;
                }
                const newState = {};
                const keys = Object.keys(state);
                const { length } = keys;
                for(let i = 0; i < length; i++){
                    const key = keys[i];
                    if (key !== instanceId) {
                        // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type. | TS2538 - Type 'undefined' cannot be used as an index type.
                        newState[key] = state[key];
                    }
                }
                return newState;
            }
        case IX2_ANIMATION_FRAME_CHANGED:
            {
                let newState = state;
                const keys = Object.keys(state);
                const { length } = keys;
                for(let i = 0; i < length; i++){
                    const key = keys[i];
                    // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
                    const instance = state[key];
                    const reducer = instance.continuous ? continuousInstance : timedInstance;
                    // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'Key'.
                    newState = (0, _timm.set)(newState, key, reducer(instance, action));
                }
                return newState;
            }
        default:
            {
                return state;
            }
    }
};

//# sourceMappingURL=data:application/json;base64,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

}),
71540: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ixParameters", ({
    enumerable: true,
    get: function() {
        return ixParameters;
    }
}));
const _sharedconstants = __webpack_require__(7087);
const { IX2_RAW_DATA_IMPORTED, IX2_SESSION_STOPPED, IX2_PARAMETER_CHANGED } = _sharedconstants.IX2EngineActionTypes;
const ixParameters = (state = {}, action)=>{
    switch(action.type){
        case IX2_RAW_DATA_IMPORTED:
            {
                return(// @ts-expect-error - Further investigation is needed as looks like IX2_RAW_DATA_IMPORTED is never triggered with ixParameters
                action.payload.ixParameters || {});
            }
        case IX2_SESSION_STOPPED:
            {
                return {};
            }
        case IX2_PARAMETER_CHANGED:
            {
                const { key, value } = action.payload;
                state[key] = value;
                return state;
            }
        default:
            {
                return state;
            }
    }
};

//# sourceMappingURL=data:application/json;base64,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

}),
17243: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
const _redux = __webpack_require__(19516);
const _IX2DataReducer = __webpack_require__(34609);
const _IX2RequestReducer = __webpack_require__(30628);
const _IX2SessionReducer = __webpack_require__(25862);
const _shared = __webpack_require__(9468);
const _IX2InstancesReducer = __webpack_require__(7718);
const _IX2ParametersReducer = __webpack_require__(71540);
const { ixElements } = _shared.IX2ElementsReducer;
const _default = (0, _redux.combineReducers)({
    ixData: _IX2DataReducer.ixData,
    ixRequest: _IX2RequestReducer.ixRequest,
    ixSession: _IX2SessionReducer.ixSession,
    ixElements,
    ixInstances: _IX2InstancesReducer.ixInstances,
    ixParameters: _IX2ParametersReducer.ixParameters
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIklYMlJlZHVjZXIudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtTdG9yZSwgY29tYmluZVJlZHVjZXJzLCB0eXBlIFJlZHVjZXJ9IGZyb20gJ3JlZHV4JztcblxuaW1wb3J0IHtpeERhdGEsIHR5cGUgaXhEYXRhUmVkdWNlclN0YXRlfSBmcm9tICcuL0lYMkRhdGFSZWR1Y2VyJztcbmltcG9ydCB7aXhSZXF1ZXN0fSBmcm9tICcuL0lYMlJlcXVlc3RSZWR1Y2VyJztcbmltcG9ydCB7aXhTZXNzaW9ufSBmcm9tICcuL0lYMlNlc3Npb25SZWR1Y2VyJztcbmltcG9ydCB7SVgyRWxlbWVudHNSZWR1Y2VyfSBmcm9tICdAcGFja2FnZXMvc3lzdGVtcy9peDIvc2hhcmVkJztcbmNvbnN0IHtpeEVsZW1lbnRzfSA9IElYMkVsZW1lbnRzUmVkdWNlcjtcbmltcG9ydCB7aXhJbnN0YW5jZXN9IGZyb20gJy4vSVgySW5zdGFuY2VzUmVkdWNlcic7XG5pbXBvcnQge2l4UGFyYW1ldGVyc30gZnJvbSAnLi9JWDJQYXJhbWV0ZXJzUmVkdWNlcic7XG5cbmV4cG9ydCB0eXBlIElYMkVuZ2luZVJlZHVjZXJTdGF0ZVNoYXBlID0ge1xuICBpeERhdGE6IFJldHVyblR5cGU8dHlwZW9mIGl4RGF0YT47XG4gIGl4UGFyYW1ldGVyczogUmV0dXJuVHlwZTx0eXBlb2YgaXhQYXJhbWV0ZXJzPjtcbiAgaXhTZXNzaW9uOiBSZXR1cm5UeXBlPHR5cGVvZiBpeFNlc3Npb24+O1xuICBpeEVsZW1lbnRzOiBSZXR1cm5UeXBlPHR5cGVvZiBpeEVsZW1lbnRzPjtcbiAgaXhJbnN0YW5jZXM6IFJldHVyblR5cGU8dHlwZW9mIGl4SW5zdGFuY2VzPjtcbiAgaXhSZXF1ZXN0OiBSZXR1cm5UeXBlPHR5cGVvZiBpeFJlcXVlc3Q+O1xufTtcblxuZXhwb3J0IGRlZmF1bHQgY29tYmluZVJlZHVjZXJzPElYMkVuZ2luZVJlZHVjZXJTdGF0ZVNoYXBlPih7XG4gIGl4RGF0YTogaXhEYXRhIGFzIFJlZHVjZXI8aXhEYXRhUmVkdWNlclN0YXRlPixcbiAgaXhSZXF1ZXN0LFxuICBpeFNlc3Npb24sXG4gIGl4RWxlbWVudHMsXG4gIGl4SW5zdGFuY2VzLFxuICBpeFBhcmFtZXRlcnMsXG59KTtcblxuZXhwb3J0IHR5cGUgSVgyRW5naW5lUmVkdWNlclN0b3JlID0gU3RvcmU8SVgyRW5naW5lUmVkdWNlclN0YXRlU2hhcGU+O1xuIl0sIm5hbWVzIjpbIml4RWxlbWVudHMiLCJJWDJFbGVtZW50c1JlZHVjZXIiLCJjb21iaW5lUmVkdWNlcnMiLCJpeERhdGEiLCJpeFJlcXVlc3QiLCJpeFNlc3Npb24iLCJpeEluc3RhbmNlcyIsIml4UGFyYW1ldGVycyJdLCJtYXBwaW5ncyI6Ijs7OzsrQkFtQkE7OztlQUFBOzs7dUJBbkJtRDtnQ0FFTDttQ0FDdEI7bUNBQ0E7d0JBQ1M7cUNBRVA7c0NBQ0M7QUFGM0IsTUFBTSxFQUFDQSxVQUFVLEVBQUMsR0FBR0MsMEJBQWtCO01BYXZDLFdBQWVDLElBQUFBLHNCQUFlLEVBQTZCO0lBQ3pEQyxRQUFRQSxzQkFBTTtJQUNkQyxXQUFBQSw0QkFBUztJQUNUQyxXQUFBQSw0QkFBUztJQUNUTDtJQUNBTSxhQUFBQSxnQ0FBVztJQUNYQyxjQUFBQSxrQ0FBWTtBQUNkIn0=

}),
30628: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ixRequest", ({
    enumerable: true,
    get: function() {
        return ixRequest;
    }
}));
const _sharedconstants = __webpack_require__(7087);
const _timm = __webpack_require__(81185);
const { IX2_PREVIEW_REQUESTED, IX2_PLAYBACK_REQUESTED, IX2_STOP_REQUESTED, IX2_CLEAR_REQUESTED } = _sharedconstants.IX2EngineActionTypes;
const initialState = {
    preview: {},
    playback: {},
    stop: {},
    clear: {}
};
const stateKeys = Object.create(null, {
    [IX2_PREVIEW_REQUESTED]: {
        value: 'preview'
    },
    [IX2_PLAYBACK_REQUESTED]: {
        value: 'playback'
    },
    [IX2_STOP_REQUESTED]: {
        value: 'stop'
    },
    [IX2_CLEAR_REQUESTED]: {
        value: 'clear'
    }
});
const ixRequest = (state = initialState, action)=>{
    if (action.type in stateKeys) {
        const key = [
            stateKeys[action.type]
        ];
        return (0, _timm.setIn)(state, [
            key
        ], {
            ...action.payload
        });
    }
    return state;
};

//# sourceMappingURL=data:application/json;base64,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

}),
25862: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ixSession", ({
    enumerable: true,
    get: function() {
        return ixSession;
    }
}));
const _sharedconstants = __webpack_require__(7087);
const _timm = __webpack_require__(81185);
const { IX2_SESSION_INITIALIZED, IX2_SESSION_STARTED, IX2_TEST_FRAME_RENDERED, IX2_SESSION_STOPPED, IX2_EVENT_LISTENER_ADDED, IX2_EVENT_STATE_CHANGED, IX2_ANIMATION_FRAME_CHANGED, IX2_ACTION_LIST_PLAYBACK_CHANGED, IX2_VIEWPORT_WIDTH_CHANGED, IX2_MEDIA_QUERIES_DEFINED } = _sharedconstants.IX2EngineActionTypes;
const initialState = {
    active: false,
    tick: 0,
    eventListeners: [],
    eventState: {},
    playbackState: {},
    viewportWidth: 0,
    mediaQueryKey: null,
    hasBoundaryNodes: false,
    hasDefinedMediaQueries: false,
    reducedMotion: false
};
const TEST_FRAME_STEPS_SIZE = 20;
const ixSession = (state = initialState, action)=>{
    switch(action.type){
        case IX2_SESSION_INITIALIZED:
            {
                const { hasBoundaryNodes, reducedMotion } = action.payload;
                return (0, _timm.merge)(state, {
                    hasBoundaryNodes,
                    reducedMotion
                });
            }
        case IX2_SESSION_STARTED:
            {
                return (0, _timm.set)(state, 'active', true);
            }
        case IX2_TEST_FRAME_RENDERED:
            {
                const { payload: { step = TEST_FRAME_STEPS_SIZE } } = action;
                return (0, _timm.set)(state, 'tick', state.tick + step);
            }
        case IX2_SESSION_STOPPED:
            {
                return initialState;
            }
        case IX2_ANIMATION_FRAME_CHANGED:
            {
                const { payload: { now } } = action;
                return (0, _timm.set)(state, 'tick', now);
            }
        case IX2_EVENT_LISTENER_ADDED:
            {
                const eventListeners = (0, _timm.addLast)(state.eventListeners, action.payload);
                return (0, _timm.set)(state, 'eventListeners', eventListeners);
            }
        case IX2_EVENT_STATE_CHANGED:
            {
                const { stateKey, newState } = action.payload;
                return (0, _timm.setIn)(state, [
                    'eventState',
                    stateKey
                ], newState);
            }
        case IX2_ACTION_LIST_PLAYBACK_CHANGED:
            {
                const { actionListId, isPlaying } = action.payload;
                return (0, _timm.setIn)(state, [
                    'playbackState',
                    actionListId
                ], isPlaying);
            }
        case IX2_VIEWPORT_WIDTH_CHANGED:
            {
                const { width, mediaQueries } = action.payload;
                const mediaQueryCount = mediaQueries.length;
                let mediaQueryKey = null;
                for(let i = 0; i < mediaQueryCount; i++){
                    const { key, min, max } = mediaQueries[i];
                    if (width >= min && width <= max) {
                        mediaQueryKey = key;
                        break;
                    }
                }
                return (0, _timm.merge)(state, {
                    viewportWidth: width,
                    mediaQueryKey
                });
            }
        case IX2_MEDIA_QUERIES_DEFINED:
            {
                return (0, _timm.set)(state, 'hasDefinedMediaQueries', true);
            }
        default:
            {
                return state;
            }
    }
};

//# sourceMappingURL=data:application/json;base64,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

}),
97377: (function (__unused_webpack_module, exports) {
"use strict";
/* eslint-env browser */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    clearPlugin: function() {
        return clearPlugin;
    },
    createPluginInstance: function() {
        return createPluginInstance;
    },
    getPluginConfig: function() {
        return getPluginConfig;
    },
    getPluginDestination: function() {
        return getPluginDestination;
    },
    getPluginDuration: function() {
        return getPluginDuration;
    },
    getPluginOrigin: function() {
        return getPluginOrigin;
    },
    renderPlugin: function() {
        return renderPlugin;
    }
});
const getPluginConfig = (actionItemConfig)=>{
    return actionItemConfig.value;
};
const getPluginDuration = (element, actionItem)=>{
    if (actionItem.config.duration !== 'auto') {
        return null;
    }
    const duration = parseFloat(element.getAttribute('data-duration'));
    if (duration > 0) {
        return duration * 1000;
    }
    return parseFloat(element.getAttribute('data-default-duration')) * 1000;
};
const getPluginOrigin = (refState)=>{
    return refState || {
        value: 0
    };
};
const getPluginDestination = (actionItemConfig)=>{
    return {
        value: actionItemConfig.value
    };
};
const createPluginInstance = (element)=>{
    const lottie = window.Webflow.require('lottie');
    if (!lottie) return null;
    const instance = lottie.createInstance(element);
    instance.stop();
    instance.setSubframe(true);
    return instance;
};
const renderPlugin = (pluginInstance, refState, actionItem)=>{
    if (!pluginInstance) {
        return;
    }
    const percent = refState[actionItem.actionTypeId].value / 100;
    pluginInstance.goToFrame(pluginInstance.frames * percent);
};
const clearPlugin = (element)=>{
    const lottie = window.Webflow.require('lottie');
    if (lottie) {
        lottie.createInstance(element).stop();
    }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIklYMkxvdHRpZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyIvKiBlc2xpbnQtZW52IGJyb3dzZXIgKi9cblxuZXhwb3J0IGNvbnN0IGdldFBsdWdpbkNvbmZpZyA9IChhY3Rpb25JdGVtQ29uZmlnKSA9PiB7XG4gIHJldHVybiBhY3Rpb25JdGVtQ29uZmlnLnZhbHVlO1xufTtcblxuZXhwb3J0IGNvbnN0IGdldFBsdWdpbkR1cmF0aW9uID0gKGVsZW1lbnQsIGFjdGlvbkl0ZW0pID0+IHtcbiAgaWYgKGFjdGlvbkl0ZW0uY29uZmlnLmR1cmF0aW9uICE9PSAnYXV0bycpIHtcbiAgICByZXR1cm4gbnVsbDtcbiAgfVxuXG4gIGNvbnN0IGR1cmF0aW9uID0gcGFyc2VGbG9hdChlbGVtZW50LmdldEF0dHJpYnV0ZSgnZGF0YS1kdXJhdGlvbicpKTtcblxuICBpZiAoZHVyYXRpb24gPiAwKSB7XG4gICAgcmV0dXJuIGR1cmF0aW9uICogMTAwMDtcbiAgfVxuXG4gIHJldHVybiBwYXJzZUZsb2F0KGVsZW1lbnQuZ2V0QXR0cmlidXRlKCdkYXRhLWRlZmF1bHQtZHVyYXRpb24nKSkgKiAxMDAwO1xufTtcblxuZXhwb3J0IGNvbnN0IGdldFBsdWdpbk9yaWdpbiA9IChyZWZTdGF0ZSkgPT4ge1xuICByZXR1cm4gcmVmU3RhdGUgfHwge3ZhbHVlOiAwfTtcbn07XG5cbmV4cG9ydCBjb25zdCBnZXRQbHVnaW5EZXN0aW5hdGlvbiA9IChhY3Rpb25JdGVtQ29uZmlnKSA9PiB7XG4gIHJldHVybiB7dmFsdWU6IGFjdGlvbkl0ZW1Db25maWcudmFsdWV9O1xufTtcblxuZXhwb3J0IGNvbnN0IGNyZWF0ZVBsdWdpbkluc3RhbmNlID0gKGVsZW1lbnQpID0+IHtcbiAgY29uc3QgbG90dGllID0gd2luZG93LldlYmZsb3cucmVxdWlyZSgnbG90dGllJyk7XG4gIGlmICghbG90dGllKSByZXR1cm4gbnVsbDtcbiAgY29uc3QgaW5zdGFuY2UgPSBsb3R0aWUuY3JlYXRlSW5zdGFuY2UoZWxlbWVudCk7XG4gIGluc3RhbmNlLnN0b3AoKTtcbiAgaW5zdGFuY2Uuc2V0U3ViZnJhbWUodHJ1ZSk7XG4gIHJldHVybiBpbnN0YW5jZTtcbn07XG5cbmV4cG9ydCBjb25zdCByZW5kZXJQbHVnaW4gPSAocGx1Z2luSW5zdGFuY2UsIHJlZlN0YXRlLCBhY3Rpb25JdGVtKSA9PiB7XG4gIGlmICghcGx1Z2luSW5zdGFuY2UpIHtcbiAgICByZXR1cm47XG4gIH1cbiAgY29uc3QgcGVyY2VudCA9IHJlZlN0YXRlW2FjdGlvbkl0ZW0uYWN0aW9uVHlwZUlkXS52YWx1ZSAvIDEwMDtcbiAgcGx1Z2luSW5zdGFuY2UuZ29Ub0ZyYW1lKHBsdWdpbkluc3RhbmNlLmZyYW1lcyAqIHBlcmNlbnQpO1xufTtcblxuZXhwb3J0IGNvbnN0IGNsZWFyUGx1Z2luID0gKGVsZW1lbnQpID0+IHtcbiAgY29uc3QgbG90dGllID0gd2luZG93LldlYmZsb3cucmVxdWlyZSgnbG90dGllJyk7XG4gIGlmIChsb3R0aWUpIHtcbiAgICBsb3R0aWUuY3JlYXRlSW5zdGFuY2UoZWxlbWVudCkuc3RvcCgpO1xuICB9XG59O1xuIl0sIm5hbWVzIjpbImNsZWFyUGx1Z2luIiwiY3JlYXRlUGx1Z2luSW5zdGFuY2UiLCJnZXRQbHVnaW5Db25maWciLCJnZXRQbHVnaW5EZXN0aW5hdGlvbiIsImdldFBsdWdpbkR1cmF0aW9uIiwiZ2V0UGx1Z2luT3JpZ2luIiwicmVuZGVyUGx1Z2luIiwiYWN0aW9uSXRlbUNvbmZpZyIsInZhbHVlIiwiZWxlbWVudCIsImFjdGlvbkl0ZW0iLCJjb25maWciLCJkdXJhdGlvbiIsInBhcnNlRmxvYXQiLCJnZXRBdHRyaWJ1dGUiLCJyZWZTdGF0ZSIsImxvdHRpZSIsIndpbmRvdyIsIldlYmZsb3ciLCJyZXF1aXJlIiwiaW5zdGFuY2UiLCJjcmVhdGVJbnN0YW5jZSIsInN0b3AiLCJzZXRTdWJmcmFtZSIsInBsdWdpbkluc3RhbmNlIiwicGVyY2VudCIsImFjdGlvblR5cGVJZCIsImdvVG9GcmFtZSIsImZyYW1lcyJdLCJtYXBwaW5ncyI6IkFBQUEsc0JBQXNCOzs7Ozs7Ozs7OztJQTZDVEEsV0FBVztlQUFYQTs7SUFqQkFDLG9CQUFvQjtlQUFwQkE7O0lBMUJBQyxlQUFlO2VBQWZBOztJQXNCQUMsb0JBQW9CO2VBQXBCQTs7SUFsQkFDLGlCQUFpQjtlQUFqQkE7O0lBY0FDLGVBQWU7ZUFBZkE7O0lBaUJBQyxZQUFZO2VBQVpBOzs7QUFuQ04sTUFBTUosa0JBQWtCLENBQUNLO0lBQzlCLE9BQU9BLGlCQUFpQkMsS0FBSztBQUMvQjtBQUVPLE1BQU1KLG9CQUFvQixDQUFDSyxTQUFTQztJQUN6QyxJQUFJQSxXQUFXQyxNQUFNLENBQUNDLFFBQVEsS0FBSyxRQUFRO1FBQ3pDLE9BQU87SUFDVDtJQUVBLE1BQU1BLFdBQVdDLFdBQVdKLFFBQVFLLFlBQVksQ0FBQztJQUVqRCxJQUFJRixXQUFXLEdBQUc7UUFDaEIsT0FBT0EsV0FBVztJQUNwQjtJQUVBLE9BQU9DLFdBQVdKLFFBQVFLLFlBQVksQ0FBQyw0QkFBNEI7QUFDckU7QUFFTyxNQUFNVCxrQkFBa0IsQ0FBQ1U7SUFDOUIsT0FBT0EsWUFBWTtRQUFDUCxPQUFPO0lBQUM7QUFDOUI7QUFFTyxNQUFNTCx1QkFBdUIsQ0FBQ0k7SUFDbkMsT0FBTztRQUFDQyxPQUFPRCxpQkFBaUJDLEtBQUs7SUFBQTtBQUN2QztBQUVPLE1BQU1QLHVCQUF1QixDQUFDUTtJQUNuQyxNQUFNTyxTQUFTQyxPQUFPQyxPQUFPLENBQUNDLE9BQU8sQ0FBQztJQUN0QyxJQUFJLENBQUNILFFBQVEsT0FBTztJQUNwQixNQUFNSSxXQUFXSixPQUFPSyxjQUFjLENBQUNaO0lBQ3ZDVyxTQUFTRSxJQUFJO0lBQ2JGLFNBQVNHLFdBQVcsQ0FBQztJQUNyQixPQUFPSDtBQUNUO0FBRU8sTUFBTWQsZUFBZSxDQUFDa0IsZ0JBQWdCVCxVQUFVTDtJQUNyRCxJQUFJLENBQUNjLGdCQUFnQjtRQUNuQjtJQUNGO0lBQ0EsTUFBTUMsVUFBVVYsUUFBUSxDQUFDTCxXQUFXZ0IsWUFBWSxDQUFDLENBQUNsQixLQUFLLEdBQUc7SUFDMURnQixlQUFlRyxTQUFTLENBQUNILGVBQWVJLE1BQU0sR0FBR0g7QUFDbkQ7QUFFTyxNQUFNekIsY0FBYyxDQUFDUztJQUMxQixNQUFNTyxTQUFTQyxPQUFPQyxPQUFPLENBQUNDLE9BQU8sQ0FBQztJQUN0QyxJQUFJSCxRQUFRO1FBQ1ZBLE9BQU9LLGNBQWMsQ0FBQ1osU0FBU2EsSUFBSTtJQUNyQztBQUNGIn0=

}),
92570: (function (__unused_webpack_module, exports) {
"use strict";
/* eslint-env browser */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    clearPlugin: function() {
        return clearPlugin;
    },
    createPluginInstance: function() {
        return createPluginInstance;
    },
    getPluginConfig: function() {
        return getPluginConfig;
    },
    getPluginDestination: function() {
        return getPluginDestination;
    },
    getPluginDuration: function() {
        return getPluginDuration;
    },
    getPluginOrigin: function() {
        return getPluginOrigin;
    },
    renderPlugin: function() {
        return renderPlugin;
    }
});
const FIT_KEY = '--wf-rive-fit';
const ALIGNMENT_KEY = '--wf-rive-alignment';
const queryContainerElement = (elementId)=>document.querySelector(`[data-w-id="${elementId}"]`);
const getFrontendModule = ()=>window.Webflow.require('rive');
const getPluginConfig = (actionItemConfig, key)=>actionItemConfig.value.inputs[key];
const getPluginDuration = ()=>null; // Not used by this plugin
const getPluginOrigin = (refState, actionItem)=>{
    if (refState) return refState;
    const result = {};
    const { inputs = {} } = actionItem.config.value;
    for(const input in inputs)if (inputs[input] == null) result[input] = 0;
    return result;
};
const getPluginDestination = (actionItemConfig)=>actionItemConfig.value.inputs ?? {};
const createPluginInstance = (element, actionItem)=>{
    const selectorGuids = actionItem.config?.target?.selectorGuids || [];
    if (selectorGuids.length > 0) return element;
    // In this case, we define pluginInstance as a reference to the container element
    const pluginElementId = actionItem?.config?.target?.pluginElement;
    return pluginElementId ? queryContainerElement(pluginElementId) : null;
};
const renderPlugin = (containerElement, { PLUGIN_RIVE: props }, actionItem)=>{
    const frontendModule = getFrontendModule();
    if (!frontendModule) return;
    const instance = frontendModule.getInstance(containerElement);
    const StateMachineInputType = frontendModule.rive.StateMachineInputType;
    const { name, inputs = {} } = actionItem.config.value || {};
    function renderRive(riveInstance) {
        if (riveInstance.loaded) {
            render();
        } else {
            // Render instance immediately on load and then clean up handler
            const onLoad = ()=>{
                render();
                riveInstance?.off('load', onLoad);
            };
            riveInstance?.on('load', onLoad);
        }
        function render() {
            const stateMachineInputs = riveInstance.stateMachineInputs(name);
            if (stateMachineInputs == null) return; // exit early since no inputs found
            if (!riveInstance.isPlaying) riveInstance.play(name, false); // set autoplay: false because IX engine is controlling playback.
            if (FIT_KEY in inputs || ALIGNMENT_KEY in inputs) {
                const currentLayout = riveInstance.layout;
                const nextFit = inputs[FIT_KEY] ?? currentLayout.fit;
                const nextAlignment = inputs[ALIGNMENT_KEY] ?? currentLayout.alignment;
                if (nextFit !== currentLayout.fit || nextAlignment !== currentLayout.alignment) {
                    riveInstance.layout = currentLayout.copyWith({
                        fit: nextFit,
                        alignment: nextAlignment
                    });
                }
            }
            for(const inputName in inputs){
                if (inputName === FIT_KEY || inputName === ALIGNMENT_KEY) continue;
                const machineInput = stateMachineInputs.find((m)=>m.name === inputName);
                if (machineInput == null) continue;
                switch(machineInput.type){
                    case StateMachineInputType.Boolean:
                        {
                            if (inputs[inputName] != null) {
                                const booleanValue = Boolean(inputs[inputName]);
                                machineInput.value = booleanValue;
                            }
                            break;
                        }
                    case StateMachineInputType.Number:
                        {
                            const numberValue = props[inputName];
                            if (numberValue != null) machineInput.value = numberValue;
                            break;
                        }
                    case StateMachineInputType.Trigger:
                        {
                            if (inputs[inputName]) machineInput.fire();
                            break;
                        }
                }
            }
        }
    }
    // Render rive if the instance is available
    if (instance?.rive) renderRive(instance.rive);
    else frontendModule.setLoadHandler(containerElement, renderRive);
};
const clearPlugin = (_containerElement, _actionItem)=>null; // Not used by this plugin

//# sourceMappingURL=data:application/json;base64,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

}),
22866: (function (__unused_webpack_module, exports) {
"use strict";
/* eslint-env browser */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    clearPlugin: function() {
        return clearPlugin;
    },
    createPluginInstance: function() {
        return createPluginInstance;
    },
    getPluginConfig: function() {
        return getPluginConfig;
    },
    getPluginDestination: function() {
        return getPluginDestination;
    },
    getPluginDuration: function() {
        return getPluginDuration;
    },
    getPluginOrigin: function() {
        return getPluginOrigin;
    },
    renderPlugin: function() {
        return renderPlugin;
    }
});
const queryContainerElement = (elementId)=>document.querySelector(`[data-w-id="${elementId}"]`);
const getFrontendModule = ()=>window.Webflow.require('spline');
const difference = (arr1, arr2)=>arr1.filter((x)=>!arr2.includes(x));
const getPluginConfig = (actionItemConfig, key)=>{
    return actionItemConfig.value[key];
};
const getPluginDuration = ()=>{
    // Not used by this plugin
    return null;
};
const DEFAULT_VALUES = Object.freeze({
    positionX: 0,
    positionY: 0,
    positionZ: 0,
    rotationX: 0,
    rotationY: 0,
    rotationZ: 0,
    scaleX: 1,
    scaleY: 1,
    scaleZ: 1
});
const getPluginOrigin = (refState, actionItem)=>{
    // Determine which props we care about in the destination
    const destination = actionItem.config.value;
    const destinationKeys = Object.keys(destination);
    // Check the current state for any missing origin props
    if (refState) {
        const stateKeys = Object.keys(refState);
        const diffKeys = difference(destinationKeys, stateKeys);
        // If new props are needed, merge new origin values with current state
        if (diffKeys.length) {
            const origin = diffKeys.reduce((result, key)=>{
                result[key] = DEFAULT_VALUES[key];
                return result;
            }, refState);
            return origin;
        }
        // No difference, return current state
        return refState;
    }
    // State doesn't exist so define new origin based on destination
    const origin = destinationKeys.reduce((result, key)=>{
        result[key] = DEFAULT_VALUES[key];
        return result;
    }, {});
    return origin;
};
const getPluginDestination = (actionItemConfig)=>{
    return actionItemConfig.value;
};
const createPluginInstance = (element, actionItem)=>{
    // In this case, we define pluginInstance as a reference to the container element
    const pluginElementId = actionItem?.config?.target?.pluginElement;
    return pluginElementId ? queryContainerElement(pluginElementId) : null;
};
const renderPlugin = (containerElement, refState, actionItem)=>{
    const frontendModule = getFrontendModule();
    if (!frontendModule) return;
    const instance = frontendModule.getInstance(containerElement);
    const objectId = actionItem.config.target.objectId;
    const renderSpline = (spline)=>{
        if (!spline) {
            throw new Error('Invalid spline app passed to renderSpline');
        }
        const obj = objectId && spline.findObjectById(objectId);
        if (!obj) {
            return;
        }
        const { PLUGIN_SPLINE: props } = refState;
        if (props.positionX != null) {
            obj.position.x = props.positionX;
        }
        if (props.positionY != null) {
            obj.position.y = props.positionY;
        }
        if (props.positionZ != null) {
            obj.position.z = props.positionZ;
        }
        if (props.rotationX != null) {
            obj.rotation.x = props.rotationX;
        }
        if (props.rotationY != null) {
            obj.rotation.y = props.rotationY;
        }
        if (props.rotationZ != null) {
            obj.rotation.z = props.rotationZ;
        }
        if (props.scaleX != null) {
            obj.scale.x = props.scaleX;
        }
        if (props.scaleY != null) {
            obj.scale.y = props.scaleY;
        }
        if (props.scaleZ != null) {
            obj.scale.z = props.scaleZ;
        }
    };
    if (instance) {
        // Render spline if the app instance is already loaded
        renderSpline(instance.spline);
    } else {
        // Otherwise, store latest render as a callback to fire when loaded
        frontendModule.setLoadHandler(containerElement, renderSpline);
    }
};
const clearPlugin = ()=>{
    // Not used by this plugin
    return null;
};

//# sourceMappingURL=data:application/json;base64,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

}),
11407: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/* eslint-env browser */ // Importing directly to avoid importing the entire shared-utils package.
// eslint-disable-next-line webflow/package-boundaries

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    clearPlugin: function() {
        return clearPlugin;
    },
    createPluginInstance: function() {
        return createPluginInstance;
    },
    getPluginConfig: function() {
        return getPluginConfig;
    },
    getPluginDestination: function() {
        return getPluginDestination;
    },
    getPluginDuration: function() {
        return getPluginDuration;
    },
    getPluginOrigin: function() {
        return getPluginOrigin;
    },
    renderPlugin: function() {
        return renderPlugin;
    }
});
const _normalizeColor = __webpack_require__(40380);
const getPluginConfig = (actionItemConfig, key)=>{
    return actionItemConfig.value[key];
};
const getPluginDuration = ()=>{
    // Not used by this plugin
    return null;
};
const getPluginOrigin = (refState, actionItem)=>{
    if (refState) {
        return refState;
    }
    // Determine which props we care about in the destination
    const destination = actionItem.config.value;
    // Look up root variable to parse origin values
    const objectId = actionItem.config.target.objectId;
    const computedValue = getComputedStyle(document.documentElement).getPropertyValue(objectId);
    if (destination.size != null) {
        return {
            size: parseInt(computedValue, 10)
        };
    }
    if (destination.unit === '%' || destination.unit === '-') {
        return {
            size: parseFloat(computedValue)
        };
    }
    if (destination.red != null && destination.green != null && destination.blue != null) {
        return (0, _normalizeColor.normalizeColor)(computedValue);
    }
};
const getPluginDestination = (actionItemConfig)=>{
    return actionItemConfig.value;
};
const createPluginInstance = ()=>{
    // Not used by this plugin
    return null;
};
const variableHandlers = {
    color: {
        match: ({ red, green, blue, alpha })=>[
                red,
                green,
                blue,
                alpha
            ].every((x)=>x != null),
        getValue: ({ red, green, blue, alpha })=>`rgba(${red}, ${green}, ${blue}, ${alpha})`
    },
    // Size, Percentage, and Unitless variables.
    size: {
        match: ({ size })=>size != null,
        getValue: ({ size }, unit)=>{
            switch(unit){
                case '-':
                    return size;
                default:
                    return `${size}${unit}`;
            }
        }
    }
};
const renderPlugin = (_, refState, actionItem)=>{
    const { target: { objectId }, value: { unit } } = actionItem.config;
    const props = refState.PLUGIN_VARIABLE;
    const handler = Object.values(variableHandlers).find((h)=>h.match(props, unit));
    if (handler) {
        document.documentElement.style.setProperty(objectId, handler.getValue(props, unit));
    }
};
const clearPlugin = (ref, actionItem)=>{
    const objectId = actionItem.config.target.objectId;
    document.documentElement.style.removeProperty(objectId);
};

//# sourceMappingURL=data:application/json;base64,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

}),
63690: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "pluginMethodMap", ({
    enumerable: true,
    get: function() {
        return pluginMethodMap;
    }
}));
const _sharedconstants = __webpack_require__(7087);
const _IX2Lottie = /*#__PURE__*/ _interop_require_wildcard(__webpack_require__(97377));
const _IX2Spline = /*#__PURE__*/ _interop_require_wildcard(__webpack_require__(22866));
const _IX2Rive = /*#__PURE__*/ _interop_require_wildcard(__webpack_require__(92570));
const _IX2Variable = /*#__PURE__*/ _interop_require_wildcard(__webpack_require__(11407));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const pluginMethodMap = new Map([
    [
        _sharedconstants.ActionTypeConsts.PLUGIN_LOTTIE,
        {
            ..._IX2Lottie
        }
    ],
    [
        _sharedconstants.ActionTypeConsts.PLUGIN_SPLINE,
        {
            ..._IX2Spline
        }
    ],
    [
        _sharedconstants.ActionTypeConsts.PLUGIN_RIVE,
        {
            ..._IX2Rive
        }
    ],
    [
        _sharedconstants.ActionTypeConsts.PLUGIN_VARIABLE,
        {
            ..._IX2Variable
        }
    ]
]);

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7QWN0aW9uVHlwZUNvbnN0c30gZnJvbSAnQHBhY2thZ2VzL3N5c3RlbXMvaXgyL3NoYXJlZC1jb25zdGFudHMnO1xuXG5pbXBvcnQgKiBhcyBsb3R0aWUgZnJvbSAnLi9JWDJMb3R0aWUnO1xuaW1wb3J0ICogYXMgc3BsaW5lIGZyb20gJy4vSVgyU3BsaW5lJztcbmltcG9ydCAqIGFzIHJpdmUgZnJvbSAnLi9JWDJSaXZlJztcbmltcG9ydCAqIGFzIHZhcmlhYmxlIGZyb20gJy4vSVgyVmFyaWFibGUnO1xuXG5leHBvcnQgdHlwZSBQbHVnaW5UeXBlID1cbiAgfCB0eXBlb2YgQWN0aW9uVHlwZUNvbnN0cy5QTFVHSU5fTE9UVElFXG4gIHwgdHlwZW9mIEFjdGlvblR5cGVDb25zdHMuUExVR0lOX1NQTElORVxuICB8IHR5cGVvZiBBY3Rpb25UeXBlQ29uc3RzLlBMVUdJTl9WQVJJQUJMRVxuICB8IHR5cGVvZiBBY3Rpb25UeXBlQ29uc3RzLlBMVUdJTl9SSVZFO1xuXG5leHBvcnQgY29uc3QgcGx1Z2luTWV0aG9kTWFwID0gbmV3IE1hcChbXG4gIFtBY3Rpb25UeXBlQ29uc3RzLlBMVUdJTl9MT1RUSUUsIHsuLi5sb3R0aWV9XSxcbiAgW0FjdGlvblR5cGVDb25zdHMuUExVR0lOX1NQTElORSwgey4uLnNwbGluZX1dLFxuICBbQWN0aW9uVHlwZUNvbnN0cy5QTFVHSU5fUklWRSwgey4uLnJpdmV9XSxcbiAgW0FjdGlvblR5cGVDb25zdHMuUExVR0lOX1ZBUklBQkxFLCB7Li4udmFyaWFibGV9XSxcbl0pO1xuIl0sIm5hbWVzIjpbInBsdWdpbk1ldGhvZE1hcCIsIk1hcCIsIkFjdGlvblR5cGVDb25zdHMiLCJQTFVHSU5fTE9UVElFIiwibG90dGllIiwiUExVR0lOX1NQTElORSIsInNwbGluZSIsIlBMVUdJTl9SSVZFIiwicml2ZSIsIlBMVUdJTl9WQVJJQUJMRSIsInZhcmlhYmxlIl0sIm1hcHBpbmdzIjoiOzs7OytCQWFhQTs7O2VBQUFBOzs7aUNBYmtCO21FQUVQO21FQUNBO2lFQUNGO3FFQUNJOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFRbkIsTUFBTUEsa0JBQWtCLElBQUlDLElBQUk7SUFDckM7UUFBQ0MsaUNBQWdCLENBQUNDLGFBQWE7UUFBRTtZQUFDLEdBQUdDLFVBQU07UUFBQTtLQUFFO0lBQzdDO1FBQUNGLGlDQUFnQixDQUFDRyxhQUFhO1FBQUU7WUFBQyxHQUFHQyxVQUFNO1FBQUE7S0FBRTtJQUM3QztRQUFDSixpQ0FBZ0IsQ0FBQ0ssV0FBVztRQUFFO1lBQUMsR0FBR0MsUUFBSTtRQUFBO0tBQUU7SUFDekM7UUFBQ04saUNBQWdCLENBQUNPLGVBQWU7UUFBRTtZQUFDLEdBQUdDLFlBQVE7UUFBQTtLQUFFO0NBQ2xEIn0=

}),
48023: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    IX2_ACTION_LIST_PLAYBACK_CHANGED: function() {
        return IX2_ACTION_LIST_PLAYBACK_CHANGED;
    },
    IX2_ANIMATION_FRAME_CHANGED: function() {
        return IX2_ANIMATION_FRAME_CHANGED;
    },
    IX2_CLEAR_REQUESTED: function() {
        return IX2_CLEAR_REQUESTED;
    },
    IX2_ELEMENT_STATE_CHANGED: function() {
        return IX2_ELEMENT_STATE_CHANGED;
    },
    IX2_EVENT_LISTENER_ADDED: function() {
        return IX2_EVENT_LISTENER_ADDED;
    },
    IX2_EVENT_STATE_CHANGED: function() {
        return IX2_EVENT_STATE_CHANGED;
    },
    IX2_INSTANCE_ADDED: function() {
        return IX2_INSTANCE_ADDED;
    },
    IX2_INSTANCE_REMOVED: function() {
        return IX2_INSTANCE_REMOVED;
    },
    IX2_INSTANCE_STARTED: function() {
        return IX2_INSTANCE_STARTED;
    },
    IX2_MEDIA_QUERIES_DEFINED: function() {
        return IX2_MEDIA_QUERIES_DEFINED;
    },
    IX2_PARAMETER_CHANGED: function() {
        return IX2_PARAMETER_CHANGED;
    },
    IX2_PLAYBACK_REQUESTED: function() {
        return IX2_PLAYBACK_REQUESTED;
    },
    IX2_PREVIEW_REQUESTED: function() {
        return IX2_PREVIEW_REQUESTED;
    },
    IX2_RAW_DATA_IMPORTED: function() {
        return IX2_RAW_DATA_IMPORTED;
    },
    IX2_SESSION_INITIALIZED: function() {
        return IX2_SESSION_INITIALIZED;
    },
    IX2_SESSION_STARTED: function() {
        return IX2_SESSION_STARTED;
    },
    IX2_SESSION_STOPPED: function() {
        return IX2_SESSION_STOPPED;
    },
    IX2_STOP_REQUESTED: function() {
        return IX2_STOP_REQUESTED;
    },
    IX2_TEST_FRAME_RENDERED: function() {
        return IX2_TEST_FRAME_RENDERED;
    },
    IX2_VIEWPORT_WIDTH_CHANGED: function() {
        return IX2_VIEWPORT_WIDTH_CHANGED;
    }
});
const IX2_RAW_DATA_IMPORTED = 'IX2_RAW_DATA_IMPORTED';
const IX2_SESSION_INITIALIZED = 'IX2_SESSION_INITIALIZED';
const IX2_SESSION_STARTED = 'IX2_SESSION_STARTED';
const IX2_SESSION_STOPPED = 'IX2_SESSION_STOPPED';
const IX2_PREVIEW_REQUESTED = 'IX2_PREVIEW_REQUESTED';
const IX2_PLAYBACK_REQUESTED = 'IX2_PLAYBACK_REQUESTED';
const IX2_STOP_REQUESTED = 'IX2_STOP_REQUESTED';
const IX2_CLEAR_REQUESTED = 'IX2_CLEAR_REQUESTED';
const IX2_EVENT_LISTENER_ADDED = 'IX2_EVENT_LISTENER_ADDED';
const IX2_EVENT_STATE_CHANGED = 'IX2_EVENT_STATE_CHANGED';
const IX2_ANIMATION_FRAME_CHANGED = 'IX2_ANIMATION_FRAME_CHANGED';
const IX2_PARAMETER_CHANGED = 'IX2_PARAMETER_CHANGED';
const IX2_INSTANCE_ADDED = 'IX2_INSTANCE_ADDED';
const IX2_INSTANCE_STARTED = 'IX2_INSTANCE_STARTED';
const IX2_INSTANCE_REMOVED = 'IX2_INSTANCE_REMOVED';
const IX2_ELEMENT_STATE_CHANGED = 'IX2_ELEMENT_STATE_CHANGED';
const IX2_ACTION_LIST_PLAYBACK_CHANGED = 'IX2_ACTION_LIST_PLAYBACK_CHANGED';
const IX2_VIEWPORT_WIDTH_CHANGED = 'IX2_VIEWPORT_WIDTH_CHANGED';
const IX2_MEDIA_QUERIES_DEFINED = 'IX2_MEDIA_QUERIES_DEFINED';
const IX2_TEST_FRAME_RENDERED = 'IX2_TEST_FRAME_RENDERED';

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIklYMkVuZ2luZUFjdGlvblR5cGVzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBJWDJfUkFXX0RBVEFfSU1QT1JURUQgPSAnSVgyX1JBV19EQVRBX0lNUE9SVEVEJztcbmV4cG9ydCBjb25zdCBJWDJfU0VTU0lPTl9JTklUSUFMSVpFRCA9ICdJWDJfU0VTU0lPTl9JTklUSUFMSVpFRCc7XG5leHBvcnQgY29uc3QgSVgyX1NFU1NJT05fU1RBUlRFRCA9ICdJWDJfU0VTU0lPTl9TVEFSVEVEJztcbmV4cG9ydCBjb25zdCBJWDJfU0VTU0lPTl9TVE9QUEVEID0gJ0lYMl9TRVNTSU9OX1NUT1BQRUQnO1xuZXhwb3J0IGNvbnN0IElYMl9QUkVWSUVXX1JFUVVFU1RFRCA9ICdJWDJfUFJFVklFV19SRVFVRVNURUQnO1xuZXhwb3J0IGNvbnN0IElYMl9QTEFZQkFDS19SRVFVRVNURUQgPSAnSVgyX1BMQVlCQUNLX1JFUVVFU1RFRCc7XG5leHBvcnQgY29uc3QgSVgyX1NUT1BfUkVRVUVTVEVEID0gJ0lYMl9TVE9QX1JFUVVFU1RFRCc7XG5leHBvcnQgY29uc3QgSVgyX0NMRUFSX1JFUVVFU1RFRCA9ICdJWDJfQ0xFQVJfUkVRVUVTVEVEJztcbmV4cG9ydCBjb25zdCBJWDJfRVZFTlRfTElTVEVORVJfQURERUQgPSAnSVgyX0VWRU5UX0xJU1RFTkVSX0FEREVEJztcbmV4cG9ydCBjb25zdCBJWDJfRVZFTlRfU1RBVEVfQ0hBTkdFRCA9ICdJWDJfRVZFTlRfU1RBVEVfQ0hBTkdFRCc7XG5leHBvcnQgY29uc3QgSVgyX0FOSU1BVElPTl9GUkFNRV9DSEFOR0VEID0gJ0lYMl9BTklNQVRJT05fRlJBTUVfQ0hBTkdFRCc7XG5leHBvcnQgY29uc3QgSVgyX1BBUkFNRVRFUl9DSEFOR0VEID0gJ0lYMl9QQVJBTUVURVJfQ0hBTkdFRCc7XG5leHBvcnQgY29uc3QgSVgyX0lOU1RBTkNFX0FEREVEID0gJ0lYMl9JTlNUQU5DRV9BRERFRCc7XG5leHBvcnQgY29uc3QgSVgyX0lOU1RBTkNFX1NUQVJURUQgPSAnSVgyX0lOU1RBTkNFX1NUQVJURUQnO1xuZXhwb3J0IGNvbnN0IElYMl9JTlNUQU5DRV9SRU1PVkVEID0gJ0lYMl9JTlNUQU5DRV9SRU1PVkVEJztcbmV4cG9ydCBjb25zdCBJWDJfRUxFTUVOVF9TVEFURV9DSEFOR0VEID0gJ0lYMl9FTEVNRU5UX1NUQVRFX0NIQU5HRUQnO1xuZXhwb3J0IGNvbnN0IElYMl9BQ1RJT05fTElTVF9QTEFZQkFDS19DSEFOR0VEID1cbiAgJ0lYMl9BQ1RJT05fTElTVF9QTEFZQkFDS19DSEFOR0VEJztcbmV4cG9ydCBjb25zdCBJWDJfVklFV1BPUlRfV0lEVEhfQ0hBTkdFRCA9ICdJWDJfVklFV1BPUlRfV0lEVEhfQ0hBTkdFRCc7XG5leHBvcnQgY29uc3QgSVgyX01FRElBX1FVRVJJRVNfREVGSU5FRCA9ICdJWDJfTUVESUFfUVVFUklFU19ERUZJTkVEJztcbmV4cG9ydCBjb25zdCBJWDJfVEVTVF9GUkFNRV9SRU5ERVJFRCA9ICdJWDJfVEVTVF9GUkFNRV9SRU5ERVJFRCc7XG4iXSwibmFtZXMiOlsiSVgyX0FDVElPTl9MSVNUX1BMQVlCQUNLX0NIQU5HRUQiLCJJWDJfQU5JTUFUSU9OX0ZSQU1FX0NIQU5HRUQiLCJJWDJfQ0xFQVJfUkVRVUVTVEVEIiwiSVgyX0VMRU1FTlRfU1RBVEVfQ0hBTkdFRCIsIklYMl9FVkVOVF9MSVNURU5FUl9BRERFRCIsIklYMl9FVkVOVF9TVEFURV9DSEFOR0VEIiwiSVgyX0lOU1RBTkNFX0FEREVEIiwiSVgyX0lOU1RBTkNFX1JFTU9WRUQiLCJJWDJfSU5TVEFOQ0VfU1RBUlRFRCIsIklYMl9NRURJQV9RVUVSSUVTX0RFRklORUQiLCJJWDJfUEFSQU1FVEVSX0NIQU5HRUQiLCJJWDJfUExBWUJBQ0tfUkVRVUVTVEVEIiwiSVgyX1BSRVZJRVdfUkVRVUVTVEVEIiwiSVgyX1JBV19EQVRBX0lNUE9SVEVEIiwiSVgyX1NFU1NJT05fSU5JVElBTElaRUQiLCJJWDJfU0VTU0lPTl9TVEFSVEVEIiwiSVgyX1NFU1NJT05fU1RPUFBFRCIsIklYMl9TVE9QX1JFUVVFU1RFRCIsIklYMl9URVNUX0ZSQU1FX1JFTkRFUkVEIiwiSVgyX1ZJRVdQT1JUX1dJRFRIX0NIQU5HRUQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0lBZ0JhQSxnQ0FBZ0M7ZUFBaENBOztJQU5BQywyQkFBMkI7ZUFBM0JBOztJQUhBQyxtQkFBbUI7ZUFBbkJBOztJQVFBQyx5QkFBeUI7ZUFBekJBOztJQVBBQyx3QkFBd0I7ZUFBeEJBOztJQUNBQyx1QkFBdUI7ZUFBdkJBOztJQUdBQyxrQkFBa0I7ZUFBbEJBOztJQUVBQyxvQkFBb0I7ZUFBcEJBOztJQURBQyxvQkFBb0I7ZUFBcEJBOztJQU1BQyx5QkFBeUI7ZUFBekJBOztJQVJBQyxxQkFBcUI7ZUFBckJBOztJQU5BQyxzQkFBc0I7ZUFBdEJBOztJQURBQyxxQkFBcUI7ZUFBckJBOztJQUpBQyxxQkFBcUI7ZUFBckJBOztJQUNBQyx1QkFBdUI7ZUFBdkJBOztJQUNBQyxtQkFBbUI7ZUFBbkJBOztJQUNBQyxtQkFBbUI7ZUFBbkJBOztJQUdBQyxrQkFBa0I7ZUFBbEJBOztJQWNBQyx1QkFBdUI7ZUFBdkJBOztJQUZBQywwQkFBMEI7ZUFBMUJBOzs7QUFsQk4sTUFBTU4sd0JBQXdCO0FBQzlCLE1BQU1DLDBCQUEwQjtBQUNoQyxNQUFNQyxzQkFBc0I7QUFDNUIsTUFBTUMsc0JBQXNCO0FBQzVCLE1BQU1KLHdCQUF3QjtBQUM5QixNQUFNRCx5QkFBeUI7QUFDL0IsTUFBTU0scUJBQXFCO0FBQzNCLE1BQU1mLHNCQUFzQjtBQUM1QixNQUFNRSwyQkFBMkI7QUFDakMsTUFBTUMsMEJBQTBCO0FBQ2hDLE1BQU1KLDhCQUE4QjtBQUNwQyxNQUFNUyx3QkFBd0I7QUFDOUIsTUFBTUoscUJBQXFCO0FBQzNCLE1BQU1FLHVCQUF1QjtBQUM3QixNQUFNRCx1QkFBdUI7QUFDN0IsTUFBTUosNEJBQTRCO0FBQ2xDLE1BQU1ILG1DQUNYO0FBQ0ssTUFBTW1CLDZCQUE2QjtBQUNuQyxNQUFNViw0QkFBNEI7QUFDbEMsTUFBTVMsMEJBQTBCIn0=

}),
52686: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ABSTRACT_NODE: function() {
        return ABSTRACT_NODE;
    },
    AUTO: function() {
        return AUTO;
    },
    BACKGROUND: function() {
        return BACKGROUND;
    },
    BACKGROUND_COLOR: function() {
        return BACKGROUND_COLOR;
    },
    BAR_DELIMITER: function() {
        return BAR_DELIMITER;
    },
    BORDER_COLOR: function() {
        return BORDER_COLOR;
    },
    BOUNDARY_SELECTOR: function() {
        return BOUNDARY_SELECTOR;
    },
    CHILDREN: function() {
        return CHILDREN;
    },
    COLON_DELIMITER: function() {
        return COLON_DELIMITER;
    },
    COLOR: function() {
        return COLOR;
    },
    COMMA_DELIMITER: function() {
        return COMMA_DELIMITER;
    },
    CONFIG_UNIT: function() {
        return CONFIG_UNIT;
    },
    CONFIG_VALUE: function() {
        return CONFIG_VALUE;
    },
    CONFIG_X_UNIT: function() {
        return CONFIG_X_UNIT;
    },
    CONFIG_X_VALUE: function() {
        return CONFIG_X_VALUE;
    },
    CONFIG_Y_UNIT: function() {
        return CONFIG_Y_UNIT;
    },
    CONFIG_Y_VALUE: function() {
        return CONFIG_Y_VALUE;
    },
    CONFIG_Z_UNIT: function() {
        return CONFIG_Z_UNIT;
    },
    CONFIG_Z_VALUE: function() {
        return CONFIG_Z_VALUE;
    },
    DISPLAY: function() {
        return DISPLAY;
    },
    FILTER: function() {
        return FILTER;
    },
    FLEX: function() {
        return FLEX;
    },
    FONT_VARIATION_SETTINGS: function() {
        return FONT_VARIATION_SETTINGS;
    },
    HEIGHT: function() {
        return HEIGHT;
    },
    HTML_ELEMENT: function() {
        return HTML_ELEMENT;
    },
    IMMEDIATE_CHILDREN: function() {
        return IMMEDIATE_CHILDREN;
    },
    IX2_ID_DELIMITER: function() {
        return IX2_ID_DELIMITER;
    },
    OPACITY: function() {
        return OPACITY;
    },
    PARENT: function() {
        return PARENT;
    },
    PLAIN_OBJECT: function() {
        return PLAIN_OBJECT;
    },
    PRESERVE_3D: function() {
        return PRESERVE_3D;
    },
    RENDER_GENERAL: function() {
        return RENDER_GENERAL;
    },
    RENDER_PLUGIN: function() {
        return RENDER_PLUGIN;
    },
    RENDER_STYLE: function() {
        return RENDER_STYLE;
    },
    RENDER_TRANSFORM: function() {
        return RENDER_TRANSFORM;
    },
    ROTATE_X: function() {
        return ROTATE_X;
    },
    ROTATE_Y: function() {
        return ROTATE_Y;
    },
    ROTATE_Z: function() {
        return ROTATE_Z;
    },
    SCALE_3D: function() {
        return SCALE_3D;
    },
    SCALE_X: function() {
        return SCALE_X;
    },
    SCALE_Y: function() {
        return SCALE_Y;
    },
    SCALE_Z: function() {
        return SCALE_Z;
    },
    SIBLINGS: function() {
        return SIBLINGS;
    },
    SKEW: function() {
        return SKEW;
    },
    SKEW_X: function() {
        return SKEW_X;
    },
    SKEW_Y: function() {
        return SKEW_Y;
    },
    TRANSFORM: function() {
        return TRANSFORM;
    },
    TRANSLATE_3D: function() {
        return TRANSLATE_3D;
    },
    TRANSLATE_X: function() {
        return TRANSLATE_X;
    },
    TRANSLATE_Y: function() {
        return TRANSLATE_Y;
    },
    TRANSLATE_Z: function() {
        return TRANSLATE_Z;
    },
    WF_PAGE: function() {
        return WF_PAGE;
    },
    WIDTH: function() {
        return WIDTH;
    },
    WILL_CHANGE: function() {
        return WILL_CHANGE;
    },
    W_MOD_IX: function() {
        return W_MOD_IX;
    },
    W_MOD_JS: function() {
        return W_MOD_JS;
    }
});
const IX2_ID_DELIMITER = '|';
const WF_PAGE = 'data-wf-page';
const W_MOD_JS = 'w-mod-js';
const W_MOD_IX = 'w-mod-ix';
const BOUNDARY_SELECTOR = '.w-dyn-item';
const CONFIG_X_VALUE = 'xValue';
const CONFIG_Y_VALUE = 'yValue';
const CONFIG_Z_VALUE = 'zValue';
const CONFIG_VALUE = 'value';
const CONFIG_X_UNIT = 'xUnit';
const CONFIG_Y_UNIT = 'yUnit';
const CONFIG_Z_UNIT = 'zUnit';
const CONFIG_UNIT = 'unit';
const TRANSFORM = 'transform';
const TRANSLATE_X = 'translateX';
const TRANSLATE_Y = 'translateY';
const TRANSLATE_Z = 'translateZ';
const TRANSLATE_3D = 'translate3d';
const SCALE_X = 'scaleX';
const SCALE_Y = 'scaleY';
const SCALE_Z = 'scaleZ';
const SCALE_3D = 'scale3d';
const ROTATE_X = 'rotateX';
const ROTATE_Y = 'rotateY';
const ROTATE_Z = 'rotateZ';
const SKEW = 'skew';
const SKEW_X = 'skewX';
const SKEW_Y = 'skewY';
const OPACITY = 'opacity';
const FILTER = 'filter';
const FONT_VARIATION_SETTINGS = 'font-variation-settings';
const WIDTH = 'width';
const HEIGHT = 'height';
const BACKGROUND_COLOR = 'backgroundColor';
const BACKGROUND = 'background';
const BORDER_COLOR = 'borderColor';
const COLOR = 'color';
const DISPLAY = 'display';
const FLEX = 'flex';
const WILL_CHANGE = 'willChange';
const AUTO = 'AUTO';
const COMMA_DELIMITER = ',';
const COLON_DELIMITER = ':';
const BAR_DELIMITER = '|';
const CHILDREN = 'CHILDREN';
const IMMEDIATE_CHILDREN = 'IMMEDIATE_CHILDREN';
const SIBLINGS = 'SIBLINGS';
const PARENT = 'PARENT';
const PRESERVE_3D = 'preserve-3d';
const HTML_ELEMENT = 'HTML_ELEMENT';
const PLAIN_OBJECT = 'PLAIN_OBJECT';
const ABSTRACT_NODE = 'ABSTRACT_NODE';
const RENDER_TRANSFORM = 'RENDER_TRANSFORM';
const RENDER_GENERAL = 'RENDER_GENERAL';
const RENDER_STYLE = 'RENDER_STYLE';
const RENDER_PLUGIN = 'RENDER_PLUGIN';

//# sourceMappingURL=data:application/json;base64,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

}),
70262: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ActionAppliesTo: function() {
        return ActionAppliesTo;
    },
    ActionTypeConsts: function() {
        return ActionTypeConsts;
    }
});
const ActionTypeConsts = {
    TRANSFORM_MOVE: 'TRANSFORM_MOVE',
    TRANSFORM_SCALE: 'TRANSFORM_SCALE',
    TRANSFORM_ROTATE: 'TRANSFORM_ROTATE',
    TRANSFORM_SKEW: 'TRANSFORM_SKEW',
    STYLE_OPACITY: 'STYLE_OPACITY',
    STYLE_SIZE: 'STYLE_SIZE',
    STYLE_FILTER: 'STYLE_FILTER',
    STYLE_FONT_VARIATION: 'STYLE_FONT_VARIATION',
    STYLE_BACKGROUND_COLOR: 'STYLE_BACKGROUND_COLOR',
    STYLE_BORDER: 'STYLE_BORDER',
    STYLE_TEXT_COLOR: 'STYLE_TEXT_COLOR',
    OBJECT_VALUE: 'OBJECT_VALUE',
    PLUGIN_LOTTIE: 'PLUGIN_LOTTIE',
    PLUGIN_SPLINE: 'PLUGIN_SPLINE',
    PLUGIN_RIVE: 'PLUGIN_RIVE',
    PLUGIN_VARIABLE: 'PLUGIN_VARIABLE',
    GENERAL_DISPLAY: 'GENERAL_DISPLAY',
    GENERAL_START_ACTION: 'GENERAL_START_ACTION',
    GENERAL_CONTINUOUS_ACTION: 'GENERAL_CONTINUOUS_ACTION',
    // TODO: Clean these up below because they're not used at this time
    GENERAL_COMBO_CLASS: 'GENERAL_COMBO_CLASS',
    GENERAL_STOP_ACTION: 'GENERAL_STOP_ACTION',
    GENERAL_LOOP: 'GENERAL_LOOP',
    STYLE_BOX_SHADOW: 'STYLE_BOX_SHADOW'
};
const ActionAppliesTo = {
    ELEMENT: 'ELEMENT',
    ELEMENT_CLASS: 'ELEMENT_CLASS',
    TRIGGER_ELEMENT: 'TRIGGER_ELEMENT'
};

//# sourceMappingURL=data:application/json;base64,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

}),
7087: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ActionTypeConsts: function() {
        return _animationactions.ActionTypeConsts;
    },
    IX2EngineActionTypes: function() {
        return _IX2EngineActionTypes;
    },
    IX2EngineConstants: function() {
        return _IX2EngineConstants;
    },
    QuickEffectIds: function() {
        return _triggerevents.QuickEffectIds;
    }
});
const _triggerevents = _export_star(__webpack_require__(61833), exports);
const _animationactions = _export_star(__webpack_require__(70262), exports);
_export_star(__webpack_require__(28704), exports);
_export_star(__webpack_require__(83213), exports);
const _IX2EngineActionTypes = /*#__PURE__*/ _interop_require_wildcard(__webpack_require__(48023));
const _IX2EngineConstants = /*#__PURE__*/ _interop_require_wildcard(__webpack_require__(52686));
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gJy4vdHJpZ2dlci1ldmVudHMnO1xuZXhwb3J0ICogZnJvbSAnLi9hbmltYXRpb24tYWN0aW9ucyc7XG5leHBvcnQgKiBmcm9tICcuL3RyaWdnZXItaW50ZXJhY3Rpb25zJztcbmV4cG9ydCAqIGZyb20gJy4vcmVkdWNlZC1tb3Rpb24nO1xuXG5pbXBvcnQgKiBhcyBJWDJFbmdpbmVBY3Rpb25UeXBlcyBmcm9tICcuL0lYMkVuZ2luZUFjdGlvblR5cGVzJztcbmltcG9ydCAqIGFzIElYMkVuZ2luZUNvbnN0YW50cyBmcm9tICcuL0lYMkVuZ2luZUNvbnN0YW50cyc7XG5leHBvcnQge0lYMkVuZ2luZUFjdGlvblR5cGVzLCBJWDJFbmdpbmVDb25zdGFudHN9O1xuXG5leHBvcnQge0FjdGlvblR5cGVDb25zdHN9IGZyb20gJy4vYW5pbWF0aW9uLWFjdGlvbnMnO1xuZXhwb3J0IHtRdWlja0VmZmVjdElkc30gZnJvbSAnLi90cmlnZ2VyLWV2ZW50cyc7XG4iXSwibmFtZXMiOlsiQWN0aW9uVHlwZUNvbnN0cyIsIklYMkVuZ2luZUFjdGlvblR5cGVzIiwiSVgyRW5naW5lQ29uc3RhbnRzIiwiUXVpY2tFZmZlY3RJZHMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0lBU1FBLGdCQUFnQjtlQUFoQkEsa0NBQWdCOztJQUZoQkMsb0JBQW9CO2VBQXBCQTs7SUFBc0JDLGtCQUFrQjtlQUFsQkE7O0lBR3RCQyxjQUFjO2VBQWRBLDZCQUFjOzs7NENBVlI7K0NBQ0E7cUJBQ0E7cUJBQ0E7OEVBRXdCOzRFQUNGIn0=

}),
83213: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ReducedMotionTypes", ({
    enumerable: true,
    get: function() {
        return ReducedMotionTypes;
    }
}));
const _animationactions = __webpack_require__(70262);
const { TRANSFORM_MOVE, TRANSFORM_SCALE, TRANSFORM_ROTATE, TRANSFORM_SKEW, STYLE_SIZE, STYLE_FILTER, STYLE_FONT_VARIATION } = _animationactions.ActionTypeConsts;
const ReducedMotionTypes = {
    [TRANSFORM_MOVE]: true,
    [TRANSFORM_SCALE]: true,
    [TRANSFORM_ROTATE]: true,
    [TRANSFORM_SKEW]: true,
    [STYLE_SIZE]: true,
    [STYLE_FILTER]: true,
    [STYLE_FONT_VARIATION]: true
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInJlZHVjZWQtbW90aW9uLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7QWN0aW9uVHlwZUNvbnN0c30gZnJvbSAnLi9hbmltYXRpb24tYWN0aW9ucyc7XG5cbmNvbnN0IHtcbiAgVFJBTlNGT1JNX01PVkUsXG4gIFRSQU5TRk9STV9TQ0FMRSxcbiAgVFJBTlNGT1JNX1JPVEFURSxcbiAgVFJBTlNGT1JNX1NLRVcsXG4gIFNUWUxFX1NJWkUsXG4gIFNUWUxFX0ZJTFRFUixcbiAgU1RZTEVfRk9OVF9WQVJJQVRJT04sXG59ID0gQWN0aW9uVHlwZUNvbnN0cztcblxuLyoqXG4gKiBSZWR1Y2VkIE1vdGlvbjogQWN0aW9uIHR5cGVzIHRvIGJ5cGFzcyBkdXJpbmcgYHByZWZlcnMtcmVkdWNlZC1tb3Rpb25gXG4gKi9cblxuZXhwb3J0IGNvbnN0IFJlZHVjZWRNb3Rpb25UeXBlcyA9IHtcbiAgW1RSQU5TRk9STV9NT1ZFXTogdHJ1ZSxcbiAgW1RSQU5TRk9STV9TQ0FMRV06IHRydWUsXG4gIFtUUkFOU0ZPUk1fUk9UQVRFXTogdHJ1ZSxcbiAgW1RSQU5TRk9STV9TS0VXXTogdHJ1ZSxcbiAgW1NUWUxFX1NJWkVdOiB0cnVlLFxuICBbU1RZTEVfRklMVEVSXTogdHJ1ZSxcbiAgW1NUWUxFX0ZPTlRfVkFSSUFUSU9OXTogdHJ1ZSxcbn0gYXMgY29uc3Q7XG4iXSwibmFtZXMiOlsiUmVkdWNlZE1vdGlvblR5cGVzIiwiVFJBTlNGT1JNX01PVkUiLCJUUkFOU0ZPUk1fU0NBTEUiLCJUUkFOU0ZPUk1fUk9UQVRFIiwiVFJBTlNGT1JNX1NLRVciLCJTVFlMRV9TSVpFIiwiU1RZTEVfRklMVEVSIiwiU1RZTEVfRk9OVF9WQVJJQVRJT04iLCJBY3Rpb25UeXBlQ29uc3RzIl0sIm1hcHBpbmdzIjoiOzs7OytCQWdCYUE7OztlQUFBQTs7O2tDQWhCa0I7QUFFL0IsTUFBTSxFQUNKQyxjQUFjLEVBQ2RDLGVBQWUsRUFDZkMsZ0JBQWdCLEVBQ2hCQyxjQUFjLEVBQ2RDLFVBQVUsRUFDVkMsWUFBWSxFQUNaQyxvQkFBb0IsRUFDckIsR0FBR0Msa0NBQWdCO0FBTWIsTUFBTVIscUJBQXFCO0lBQ2hDLENBQUNDLGVBQWUsRUFBRTtJQUNsQixDQUFDQyxnQkFBZ0IsRUFBRTtJQUNuQixDQUFDQyxpQkFBaUIsRUFBRTtJQUNwQixDQUFDQyxlQUFlLEVBQUU7SUFDbEIsQ0FBQ0MsV0FBVyxFQUFFO0lBQ2QsQ0FBQ0MsYUFBYSxFQUFFO0lBQ2hCLENBQUNDLHFCQUFxQixFQUFFO0FBQzFCIn0=

}),
61833: (function (__unused_webpack_module, exports) {
"use strict";
/**
 * Event Type IDs
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    EventAppliesTo: function() {
        return EventAppliesTo;
    },
    EventBasedOn: function() {
        return EventBasedOn;
    },
    EventContinuousMouseAxes: function() {
        return EventContinuousMouseAxes;
    },
    EventLimitAffectedElements: function() {
        return EventLimitAffectedElements;
    },
    EventTypeConsts: function() {
        return EventTypeConsts;
    },
    QuickEffectDirectionConsts: function() {
        return QuickEffectDirectionConsts;
    },
    QuickEffectIds: function() {
        return QuickEffectIds;
    }
});
const EventTypeConsts = {
    NAVBAR_OPEN: 'NAVBAR_OPEN',
    NAVBAR_CLOSE: 'NAVBAR_CLOSE',
    TAB_ACTIVE: 'TAB_ACTIVE',
    TAB_INACTIVE: 'TAB_INACTIVE',
    SLIDER_ACTIVE: 'SLIDER_ACTIVE',
    SLIDER_INACTIVE: 'SLIDER_INACTIVE',
    DROPDOWN_OPEN: 'DROPDOWN_OPEN',
    DROPDOWN_CLOSE: 'DROPDOWN_CLOSE',
    MOUSE_CLICK: 'MOUSE_CLICK',
    MOUSE_SECOND_CLICK: 'MOUSE_SECOND_CLICK',
    MOUSE_DOWN: 'MOUSE_DOWN',
    MOUSE_UP: 'MOUSE_UP',
    MOUSE_OVER: 'MOUSE_OVER',
    MOUSE_OUT: 'MOUSE_OUT',
    MOUSE_MOVE: 'MOUSE_MOVE',
    MOUSE_MOVE_IN_VIEWPORT: 'MOUSE_MOVE_IN_VIEWPORT',
    SCROLL_INTO_VIEW: 'SCROLL_INTO_VIEW',
    SCROLL_OUT_OF_VIEW: 'SCROLL_OUT_OF_VIEW',
    SCROLLING_IN_VIEW: 'SCROLLING_IN_VIEW',
    ECOMMERCE_CART_OPEN: 'ECOMMERCE_CART_OPEN',
    ECOMMERCE_CART_CLOSE: 'ECOMMERCE_CART_CLOSE',
    PAGE_START: 'PAGE_START',
    PAGE_FINISH: 'PAGE_FINISH',
    PAGE_SCROLL_UP: 'PAGE_SCROLL_UP',
    PAGE_SCROLL_DOWN: 'PAGE_SCROLL_DOWN',
    PAGE_SCROLL: 'PAGE_SCROLL'
};
const EventAppliesTo = {
    ELEMENT: 'ELEMENT',
    CLASS: 'CLASS',
    PAGE: 'PAGE'
};
const EventBasedOn = {
    ELEMENT: 'ELEMENT',
    VIEWPORT: 'VIEWPORT'
};
const EventContinuousMouseAxes = {
    X_AXIS: 'X_AXIS',
    Y_AXIS: 'Y_AXIS'
};
const EventLimitAffectedElements = {
    CHILDREN: 'CHILDREN',
    SIBLINGS: 'SIBLINGS',
    IMMEDIATE_CHILDREN: 'IMMEDIATE_CHILDREN'
};
const QuickEffectIds = {
    FADE_EFFECT: 'FADE_EFFECT',
    SLIDE_EFFECT: 'SLIDE_EFFECT',
    GROW_EFFECT: 'GROW_EFFECT',
    SHRINK_EFFECT: 'SHRINK_EFFECT',
    SPIN_EFFECT: 'SPIN_EFFECT',
    FLY_EFFECT: 'FLY_EFFECT',
    POP_EFFECT: 'POP_EFFECT',
    FLIP_EFFECT: 'FLIP_EFFECT',
    JIGGLE_EFFECT: 'JIGGLE_EFFECT',
    PULSE_EFFECT: 'PULSE_EFFECT',
    DROP_EFFECT: 'DROP_EFFECT',
    BLINK_EFFECT: 'BLINK_EFFECT',
    BOUNCE_EFFECT: 'BOUNCE_EFFECT',
    FLIP_LEFT_TO_RIGHT_EFFECT: 'FLIP_LEFT_TO_RIGHT_EFFECT',
    FLIP_RIGHT_TO_LEFT_EFFECT: 'FLIP_RIGHT_TO_LEFT_EFFECT',
    RUBBER_BAND_EFFECT: 'RUBBER_BAND_EFFECT',
    JELLO_EFFECT: 'JELLO_EFFECT',
    GROW_BIG_EFFECT: 'GROW_BIG_EFFECT',
    SHRINK_BIG_EFFECT: 'SHRINK_BIG_EFFECT',
    PLUGIN_LOTTIE_EFFECT: 'PLUGIN_LOTTIE_EFFECT'
};
const QuickEffectDirectionConsts = {
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    BOTTOM: 'BOTTOM',
    TOP: 'TOP',
    BOTTOM_LEFT: 'BOTTOM_LEFT',
    BOTTOM_RIGHT: 'BOTTOM_RIGHT',
    TOP_RIGHT: 'TOP_RIGHT',
    TOP_LEFT: 'TOP_LEFT',
    CLOCKWISE: 'CLOCKWISE',
    COUNTER_CLOCKWISE: 'COUNTER_CLOCKWISE'
};

//# sourceMappingURL=data:application/json;base64,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

}),
28704: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "InteractionTypeConsts", ({
    enumerable: true,
    get: function() {
        return InteractionTypeConsts;
    }
}));
const InteractionTypeConsts = {
    MOUSE_CLICK_INTERACTION: 'MOUSE_CLICK_INTERACTION',
    MOUSE_HOVER_INTERACTION: 'MOUSE_HOVER_INTERACTION',
    MOUSE_MOVE_INTERACTION: 'MOUSE_MOVE_INTERACTION',
    SCROLL_INTO_VIEW_INTERACTION: 'SCROLL_INTO_VIEW_INTERACTION',
    SCROLLING_IN_VIEW_INTERACTION: 'SCROLLING_IN_VIEW_INTERACTION',
    MOUSE_MOVE_IN_VIEWPORT_INTERACTION: 'MOUSE_MOVE_IN_VIEWPORT_INTERACTION',
    PAGE_IS_SCROLLING_INTERACTION: 'PAGE_IS_SCROLLING_INTERACTION',
    PAGE_LOAD_INTERACTION: 'PAGE_LOAD_INTERACTION',
    PAGE_SCROLLED_INTERACTION: 'PAGE_SCROLLED_INTERACTION',
    NAVBAR_INTERACTION: 'NAVBAR_INTERACTION',
    DROPDOWN_INTERACTION: 'DROPDOWN_INTERACTION',
    ECOMMERCE_CART_INTERACTION: 'ECOMMERCE_CART_INTERACTION',
    TAB_INTERACTION: 'TAB_INTERACTION',
    SLIDER_INTERACTION: 'SLIDER_INTERACTION'
};

//# sourceMappingURL=data:application/json;base64,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

}),
40380: (function (__unused_webpack_module, exports) {
"use strict";
// Big List of Colors
// ------------------
// <https://www.w3.org/TR/css-color-4/#named-colors>

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "normalizeColor", ({
    enumerable: true,
    get: function() {
        return normalizeColor;
    }
}));
const colorNamesObj = {
    aliceblue: '#F0F8FF',
    antiquewhite: '#FAEBD7',
    aqua: '#00FFFF',
    aquamarine: '#7FFFD4',
    azure: '#F0FFFF',
    beige: '#F5F5DC',
    bisque: '#FFE4C4',
    black: '#000000',
    blanchedalmond: '#FFEBCD',
    blue: '#0000FF',
    blueviolet: '#8A2BE2',
    brown: '#A52A2A',
    burlywood: '#DEB887',
    cadetblue: '#5F9EA0',
    chartreuse: '#7FFF00',
    chocolate: '#D2691E',
    coral: '#FF7F50',
    cornflowerblue: '#6495ED',
    cornsilk: '#FFF8DC',
    crimson: '#DC143C',
    cyan: '#00FFFF',
    darkblue: '#00008B',
    darkcyan: '#008B8B',
    darkgoldenrod: '#B8860B',
    darkgray: '#A9A9A9',
    darkgreen: '#006400',
    darkgrey: '#A9A9A9',
    darkkhaki: '#BDB76B',
    darkmagenta: '#8B008B',
    darkolivegreen: '#556B2F',
    darkorange: '#FF8C00',
    darkorchid: '#9932CC',
    darkred: '#8B0000',
    darksalmon: '#E9967A',
    darkseagreen: '#8FBC8F',
    darkslateblue: '#483D8B',
    darkslategray: '#2F4F4F',
    darkslategrey: '#2F4F4F',
    darkturquoise: '#00CED1',
    darkviolet: '#9400D3',
    deeppink: '#FF1493',
    deepskyblue: '#00BFFF',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1E90FF',
    firebrick: '#B22222',
    floralwhite: '#FFFAF0',
    forestgreen: '#228B22',
    fuchsia: '#FF00FF',
    gainsboro: '#DCDCDC',
    ghostwhite: '#F8F8FF',
    gold: '#FFD700',
    goldenrod: '#DAA520',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#ADFF2F',
    grey: '#808080',
    honeydew: '#F0FFF0',
    hotpink: '#FF69B4',
    indianred: '#CD5C5C',
    indigo: '#4B0082',
    ivory: '#FFFFF0',
    khaki: '#F0E68C',
    lavender: '#E6E6FA',
    lavenderblush: '#FFF0F5',
    lawngreen: '#7CFC00',
    lemonchiffon: '#FFFACD',
    lightblue: '#ADD8E6',
    lightcoral: '#F08080',
    lightcyan: '#E0FFFF',
    lightgoldenrodyellow: '#FAFAD2',
    lightgray: '#D3D3D3',
    lightgreen: '#90EE90',
    lightgrey: '#D3D3D3',
    lightpink: '#FFB6C1',
    lightsalmon: '#FFA07A',
    lightseagreen: '#20B2AA',
    lightskyblue: '#87CEFA',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#B0C4DE',
    lightyellow: '#FFFFE0',
    lime: '#00FF00',
    limegreen: '#32CD32',
    linen: '#FAF0E6',
    magenta: '#FF00FF',
    maroon: '#800000',
    mediumaquamarine: '#66CDAA',
    mediumblue: '#0000CD',
    mediumorchid: '#BA55D3',
    mediumpurple: '#9370DB',
    mediumseagreen: '#3CB371',
    mediumslateblue: '#7B68EE',
    mediumspringgreen: '#00FA9A',
    mediumturquoise: '#48D1CC',
    mediumvioletred: '#C71585',
    midnightblue: '#191970',
    mintcream: '#F5FFFA',
    mistyrose: '#FFE4E1',
    moccasin: '#FFE4B5',
    navajowhite: '#FFDEAD',
    navy: '#000080',
    oldlace: '#FDF5E6',
    olive: '#808000',
    olivedrab: '#6B8E23',
    orange: '#FFA500',
    orangered: '#FF4500',
    orchid: '#DA70D6',
    palegoldenrod: '#EEE8AA',
    palegreen: '#98FB98',
    paleturquoise: '#AFEEEE',
    palevioletred: '#DB7093',
    papayawhip: '#FFEFD5',
    peachpuff: '#FFDAB9',
    peru: '#CD853F',
    pink: '#FFC0CB',
    plum: '#DDA0DD',
    powderblue: '#B0E0E6',
    purple: '#800080',
    rebeccapurple: '#663399',
    red: '#FF0000',
    rosybrown: '#BC8F8F',
    royalblue: '#4169E1',
    saddlebrown: '#8B4513',
    salmon: '#FA8072',
    sandybrown: '#F4A460',
    seagreen: '#2E8B57',
    seashell: '#FFF5EE',
    sienna: '#A0522D',
    silver: '#C0C0C0',
    skyblue: '#87CEEB',
    slateblue: '#6A5ACD',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#FFFAFA',
    springgreen: '#00FF7F',
    steelblue: '#4682B4',
    tan: '#D2B48C',
    teal: '#008080',
    thistle: '#D8BFD8',
    tomato: '#FF6347',
    turquoise: '#40E0D0',
    violet: '#EE82EE',
    wheat: '#F5DEB3',
    white: '#FFFFFF',
    whitesmoke: '#F5F5F5',
    yellow: '#FFFF00',
    yellowgreen: '#9ACD32'
};
function normalizeColor(inputColor) {
    let red;
    let green;
    let blue;
    let alpha = 1; // Default alpha to 1
    const rawColor = inputColor.replace(/\s/g, '').toLowerCase();
    const namedColor = typeof colorNamesObj[rawColor] === 'string' ? colorNamesObj[rawColor].toLowerCase() : null;
    const cleanColor = namedColor || rawColor;
    if (cleanColor.startsWith('#')) {
        const hex = cleanColor.substring(1);
        if (hex.length === 3 || hex.length === 4) {
            red = parseInt(hex[0] + hex[0], 16);
            green = parseInt(hex[1] + hex[1], 16);
            blue = parseInt(hex[2] + hex[2], 16);
            if (hex.length === 4) {
                alpha = parseInt(hex[3] + hex[3], 16) / 255;
            }
        } else if (hex.length === 6 || hex.length === 8) {
            red = parseInt(hex.substring(0, 2), 16);
            green = parseInt(hex.substring(2, 4), 16);
            blue = parseInt(hex.substring(4, 6), 16);
            if (hex.length === 8) {
                alpha = parseInt(hex.substring(6, 8), 16) / 255;
            }
        }
    } else if (cleanColor.startsWith('rgba')) {
        const rgbaValues = cleanColor.match(/rgba\(([^)]+)\)/)[1].split(',');
        red = parseInt(rgbaValues[0], 10);
        green = parseInt(rgbaValues[1], 10);
        blue = parseInt(rgbaValues[2], 10);
        alpha = parseFloat(rgbaValues[3]);
    } else if (cleanColor.startsWith('rgb')) {
        const rgbValues = cleanColor.match(/rgb\(([^)]+)\)/)[1].split(',');
        red = parseInt(rgbValues[0], 10);
        green = parseInt(rgbValues[1], 10);
        blue = parseInt(rgbValues[2], 10);
    } else if (cleanColor.startsWith('hsla')) {
        const hslaValues = cleanColor.match(/hsla\(([^)]+)\)/)[1].split(',');
        const h = parseFloat(hslaValues[0]);
        const s = parseFloat(hslaValues[1].replace('%', '')) / 100;
        const l = parseFloat(hslaValues[2].replace('%', '')) / 100;
        alpha = parseFloat(hslaValues[3]);
        // Convert HSL to RGB
        const C = (1 - Math.abs(2 * l - 1)) * s;
        const X = C * (1 - Math.abs(h / 60 % 2 - 1));
        const m = l - C / 2;
        let R;
        let G;
        let B;
        if (h >= 0 && h < 60) {
            R = C;
            G = X;
            B = 0;
        } else if (h >= 60 && h < 120) {
            R = X;
            G = C;
            B = 0;
        } else if (h >= 120 && h < 180) {
            R = 0;
            G = C;
            B = X;
        } else if (h >= 180 && h < 240) {
            R = 0;
            G = X;
            B = C;
        } else if (h >= 240 && h < 300) {
            R = X;
            G = 0;
            B = C;
        } else {
            R = C;
            G = 0;
            B = X;
        }
        red = Math.round((R + m) * 255);
        green = Math.round((G + m) * 255);
        blue = Math.round((B + m) * 255);
    } else if (cleanColor.startsWith('hsl')) {
        const hslValues = cleanColor.match(/hsl\(([^)]+)\)/)[1].split(',');
        const h = parseFloat(hslValues[0]);
        const s = parseFloat(hslValues[1].replace('%', '')) / 100;
        const l = parseFloat(hslValues[2].replace('%', '')) / 100;
        // Convert HSL to RGB (without alpha)
        const C = (1 - Math.abs(2 * l - 1)) * s;
        const X = C * (1 - Math.abs(h / 60 % 2 - 1));
        const m = l - C / 2;
        let R;
        let G;
        let B;
        if (h >= 0 && h < 60) {
            R = C;
            G = X;
            B = 0;
        } else if (h >= 60 && h < 120) {
            R = X;
            G = C;
            B = 0;
        } else if (h >= 120 && h < 180) {
            R = 0;
            G = C;
            B = X;
        } else if (h >= 180 && h < 240) {
            R = 0;
            G = X;
            B = C;
        } else if (h >= 240 && h < 300) {
            R = X;
            G = 0;
            B = C;
        } else {
            R = C;
            G = 0;
            B = X;
        }
        red = Math.round((R + m) * 255);
        green = Math.round((G + m) * 255);
        blue = Math.round((B + m) * 255);
    }
    if (Number.isNaN(red) || Number.isNaN(green) || Number.isNaN(blue)) {
        throw new Error(`Invalid color in [ix2/shared/utils/normalizeColor.js] '${inputColor}'`);
    }
    return {
        red,
        green,
        blue,
        alpha
    };
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm5vcm1hbGl6ZUNvbG9yLmpzIl0sInNvdXJjZXNDb250ZW50IjpbIi8vIEJpZyBMaXN0IG9mIENvbG9yc1xuLy8gLS0tLS0tLS0tLS0tLS0tLS0tXG4vLyA8aHR0cHM6Ly93d3cudzMub3JnL1RSL2Nzcy1jb2xvci00LyNuYW1lZC1jb2xvcnM+XG5jb25zdCBjb2xvck5hbWVzT2JqID0ge1xuICBhbGljZWJsdWU6ICcjRjBGOEZGJyxcbiAgYW50aXF1ZXdoaXRlOiAnI0ZBRUJENycsXG4gIGFxdWE6ICcjMDBGRkZGJyxcbiAgYXF1YW1hcmluZTogJyM3RkZGRDQnLFxuICBhenVyZTogJyNGMEZGRkYnLFxuICBiZWlnZTogJyNGNUY1REMnLFxuICBiaXNxdWU6ICcjRkZFNEM0JyxcbiAgYmxhY2s6ICcjMDAwMDAwJyxcbiAgYmxhbmNoZWRhbG1vbmQ6ICcjRkZFQkNEJyxcbiAgYmx1ZTogJyMwMDAwRkYnLFxuICBibHVldmlvbGV0OiAnIzhBMkJFMicsXG4gIGJyb3duOiAnI0E1MkEyQScsXG4gIGJ1cmx5d29vZDogJyNERUI4ODcnLFxuICBjYWRldGJsdWU6ICcjNUY5RUEwJyxcbiAgY2hhcnRyZXVzZTogJyM3RkZGMDAnLFxuICBjaG9jb2xhdGU6ICcjRDI2OTFFJyxcbiAgY29yYWw6ICcjRkY3RjUwJyxcbiAgY29ybmZsb3dlcmJsdWU6ICcjNjQ5NUVEJyxcbiAgY29ybnNpbGs6ICcjRkZGOERDJyxcbiAgY3JpbXNvbjogJyNEQzE0M0MnLFxuICBjeWFuOiAnIzAwRkZGRicsXG4gIGRhcmtibHVlOiAnIzAwMDA4QicsXG4gIGRhcmtjeWFuOiAnIzAwOEI4QicsXG4gIGRhcmtnb2xkZW5yb2Q6ICcjQjg4NjBCJyxcbiAgZGFya2dyYXk6ICcjQTlBOUE5JyxcbiAgZGFya2dyZWVuOiAnIzAwNjQwMCcsXG4gIGRhcmtncmV5OiAnI0E5QTlBOScsXG4gIGRhcmtraGFraTogJyNCREI3NkInLFxuICBkYXJrbWFnZW50YTogJyM4QjAwOEInLFxuICBkYXJrb2xpdmVncmVlbjogJyM1NTZCMkYnLFxuICBkYXJrb3JhbmdlOiAnI0ZGOEMwMCcsXG4gIGRhcmtvcmNoaWQ6ICcjOTkzMkNDJyxcbiAgZGFya3JlZDogJyM4QjAwMDAnLFxuICBkYXJrc2FsbW9uOiAnI0U5OTY3QScsXG4gIGRhcmtzZWFncmVlbjogJyM4RkJDOEYnLFxuICBkYXJrc2xhdGVibHVlOiAnIzQ4M0Q4QicsXG4gIGRhcmtzbGF0ZWdyYXk6ICcjMkY0RjRGJyxcbiAgZGFya3NsYXRlZ3JleTogJyMyRjRGNEYnLFxuICBkYXJrdHVycXVvaXNlOiAnIzAwQ0VEMScsXG4gIGRhcmt2aW9sZXQ6ICcjOTQwMEQzJyxcbiAgZGVlcHBpbms6ICcjRkYxNDkzJyxcbiAgZGVlcHNreWJsdWU6ICcjMDBCRkZGJyxcbiAgZGltZ3JheTogJyM2OTY5NjknLFxuICBkaW1ncmV5OiAnIzY5Njk2OScsXG4gIGRvZGdlcmJsdWU6ICcjMUU5MEZGJyxcbiAgZmlyZWJyaWNrOiAnI0IyMjIyMicsXG4gIGZsb3JhbHdoaXRlOiAnI0ZGRkFGMCcsXG4gIGZvcmVzdGdyZWVuOiAnIzIyOEIyMicsXG4gIGZ1Y2hzaWE6ICcjRkYwMEZGJyxcbiAgZ2FpbnNib3JvOiAnI0RDRENEQycsXG4gIGdob3N0d2hpdGU6ICcjRjhGOEZGJyxcbiAgZ29sZDogJyNGRkQ3MDAnLFxuICBnb2xkZW5yb2Q6ICcjREFBNTIwJyxcbiAgZ3JheTogJyM4MDgwODAnLFxuICBncmVlbjogJyMwMDgwMDAnLFxuICBncmVlbnllbGxvdzogJyNBREZGMkYnLFxuICBncmV5OiAnIzgwODA4MCcsXG4gIGhvbmV5ZGV3OiAnI0YwRkZGMCcsXG4gIGhvdHBpbms6ICcjRkY2OUI0JyxcbiAgaW5kaWFucmVkOiAnI0NENUM1QycsXG4gIGluZGlnbzogJyM0QjAwODInLFxuICBpdm9yeTogJyNGRkZGRjAnLFxuICBraGFraTogJyNGMEU2OEMnLFxuICBsYXZlbmRlcjogJyNFNkU2RkEnLFxuICBsYXZlbmRlcmJsdXNoOiAnI0ZGRjBGNScsXG4gIGxhd25ncmVlbjogJyM3Q0ZDMDAnLFxuICBsZW1vbmNoaWZmb246ICcjRkZGQUNEJyxcbiAgbGlnaHRibHVlOiAnI0FERDhFNicsXG4gIGxpZ2h0Y29yYWw6ICcjRjA4MDgwJyxcbiAgbGlnaHRjeWFuOiAnI0UwRkZGRicsXG4gIGxpZ2h0Z29sZGVucm9keWVsbG93OiAnI0ZBRkFEMicsXG4gIGxpZ2h0Z3JheTogJyNEM0QzRDMnLFxuICBsaWdodGdyZWVuOiAnIzkwRUU5MCcsXG4gIGxpZ2h0Z3JleTogJyNEM0QzRDMnLFxuICBsaWdodHBpbms6ICcjRkZCNkMxJyxcbiAgbGlnaHRzYWxtb246ICcjRkZBMDdBJyxcbiAgbGlnaHRzZWFncmVlbjogJyMyMEIyQUEnLFxuICBsaWdodHNreWJsdWU6ICcjODdDRUZBJyxcbiAgbGlnaHRzbGF0ZWdyYXk6ICcjNzc4ODk5JyxcbiAgbGlnaHRzbGF0ZWdyZXk6ICcjNzc4ODk5JyxcbiAgbGlnaHRzdGVlbGJsdWU6ICcjQjBDNERFJyxcbiAgbGlnaHR5ZWxsb3c6ICcjRkZGRkUwJyxcbiAgbGltZTogJyMwMEZGMDAnLFxuICBsaW1lZ3JlZW46ICcjMzJDRDMyJyxcbiAgbGluZW46ICcjRkFGMEU2JyxcbiAgbWFnZW50YTogJyNGRjAwRkYnLFxuICBtYXJvb246ICcjODAwMDAwJyxcbiAgbWVkaXVtYXF1YW1hcmluZTogJyM2NkNEQUEnLFxuICBtZWRpdW1ibHVlOiAnIzAwMDBDRCcsXG4gIG1lZGl1bW9yY2hpZDogJyNCQTU1RDMnLFxuICBtZWRpdW1wdXJwbGU6ICcjOTM3MERCJyxcbiAgbWVkaXVtc2VhZ3JlZW46ICcjM0NCMzcxJyxcbiAgbWVkaXVtc2xhdGVibHVlOiAnIzdCNjhFRScsXG4gIG1lZGl1bXNwcmluZ2dyZWVuOiAnIzAwRkE5QScsXG4gIG1lZGl1bXR1cnF1b2lzZTogJyM0OEQxQ0MnLFxuICBtZWRpdW12aW9sZXRyZWQ6ICcjQzcxNTg1JyxcbiAgbWlkbmlnaHRibHVlOiAnIzE5MTk3MCcsXG4gIG1pbnRjcmVhbTogJyNGNUZGRkEnLFxuICBtaXN0eXJvc2U6ICcjRkZFNEUxJyxcbiAgbW9jY2FzaW46ICcjRkZFNEI1JyxcbiAgbmF2YWpvd2hpdGU6ICcjRkZERUFEJyxcbiAgbmF2eTogJyMwMDAwODAnLFxuICBvbGRsYWNlOiAnI0ZERjVFNicsXG4gIG9saXZlOiAnIzgwODAwMCcsXG4gIG9saXZlZHJhYjogJyM2QjhFMjMnLFxuICBvcmFuZ2U6ICcjRkZBNTAwJyxcbiAgb3JhbmdlcmVkOiAnI0ZGNDUwMCcsXG4gIG9yY2hpZDogJyNEQTcwRDYnLFxuICBwYWxlZ29sZGVucm9kOiAnI0VFRThBQScsXG4gIHBhbGVncmVlbjogJyM5OEZCOTgnLFxuICBwYWxldHVycXVvaXNlOiAnI0FGRUVFRScsXG4gIHBhbGV2aW9sZXRyZWQ6ICcjREI3MDkzJyxcbiAgcGFwYXlhd2hpcDogJyNGRkVGRDUnLFxuICBwZWFjaHB1ZmY6ICcjRkZEQUI5JyxcbiAgcGVydTogJyNDRDg1M0YnLFxuICBwaW5rOiAnI0ZGQzBDQicsXG4gIHBsdW06ICcjRERBMEREJyxcbiAgcG93ZGVyYmx1ZTogJyNCMEUwRTYnLFxuICBwdXJwbGU6ICcjODAwMDgwJyxcbiAgcmViZWNjYXB1cnBsZTogJyM2NjMzOTknLFxuICByZWQ6ICcjRkYwMDAwJyxcbiAgcm9zeWJyb3duOiAnI0JDOEY4RicsXG4gIHJveWFsYmx1ZTogJyM0MTY5RTEnLFxuICBzYWRkbGVicm93bjogJyM4QjQ1MTMnLFxuICBzYWxtb246ICcjRkE4MDcyJyxcbiAgc2FuZHlicm93bjogJyNGNEE0NjAnLFxuICBzZWFncmVlbjogJyMyRThCNTcnLFxuICBzZWFzaGVsbDogJyNGRkY1RUUnLFxuICBzaWVubmE6ICcjQTA1MjJEJyxcbiAgc2lsdmVyOiAnI0MwQzBDMCcsXG4gIHNreWJsdWU6ICcjODdDRUVCJyxcbiAgc2xhdGVibHVlOiAnIzZBNUFDRCcsXG4gIHNsYXRlZ3JheTogJyM3MDgwOTAnLFxuICBzbGF0ZWdyZXk6ICcjNzA4MDkwJyxcbiAgc25vdzogJyNGRkZBRkEnLFxuICBzcHJpbmdncmVlbjogJyMwMEZGN0YnLFxuICBzdGVlbGJsdWU6ICcjNDY4MkI0JyxcbiAgdGFuOiAnI0QyQjQ4QycsXG4gIHRlYWw6ICcjMDA4MDgwJyxcbiAgdGhpc3RsZTogJyNEOEJGRDgnLFxuICB0b21hdG86ICcjRkY2MzQ3JyxcbiAgdHVycXVvaXNlOiAnIzQwRTBEMCcsXG4gIHZpb2xldDogJyNFRTgyRUUnLFxuICB3aGVhdDogJyNGNURFQjMnLFxuICB3aGl0ZTogJyNGRkZGRkYnLFxuICB3aGl0ZXNtb2tlOiAnI0Y1RjVGNScsXG4gIHllbGxvdzogJyNGRkZGMDAnLFxuICB5ZWxsb3dncmVlbjogJyM5QUNEMzInLFxufTtcblxuZXhwb3J0IGZ1bmN0aW9uIG5vcm1hbGl6ZUNvbG9yKGlucHV0Q29sb3IpIHtcbiAgbGV0IHJlZDtcbiAgbGV0IGdyZWVuO1xuICBsZXQgYmx1ZTtcbiAgbGV0IGFscGhhID0gMTsgLy8gRGVmYXVsdCBhbHBoYSB0byAxXG4gIGNvbnN0IHJhd0NvbG9yID0gaW5wdXRDb2xvci5yZXBsYWNlKC9cXHMvZywgJycpLnRvTG93ZXJDYXNlKCk7XG4gIGNvbnN0IG5hbWVkQ29sb3IgPVxuICAgIHR5cGVvZiBjb2xvck5hbWVzT2JqW3Jhd0NvbG9yXSA9PT0gJ3N0cmluZydcbiAgICAgID8gY29sb3JOYW1lc09ialtyYXdDb2xvcl0udG9Mb3dlckNhc2UoKVxuICAgICAgOiBudWxsO1xuICBjb25zdCBjbGVhbkNvbG9yID0gbmFtZWRDb2xvciB8fCByYXdDb2xvcjtcblxuICBpZiAoY2xlYW5Db2xvci5zdGFydHNXaXRoKCcjJykpIHtcbiAgICBjb25zdCBoZXggPSBjbGVhbkNvbG9yLnN1YnN0cmluZygxKTtcblxuICAgIGlmIChoZXgubGVuZ3RoID09PSAzIHx8IGhleC5sZW5ndGggPT09IDQpIHtcbiAgICAgIHJlZCA9IHBhcnNlSW50KGhleFswXSArIGhleFswXSwgMTYpO1xuICAgICAgZ3JlZW4gPSBwYXJzZUludChoZXhbMV0gKyBoZXhbMV0sIDE2KTtcbiAgICAgIGJsdWUgPSBwYXJzZUludChoZXhbMl0gKyBoZXhbMl0sIDE2KTtcbiAgICAgIGlmIChoZXgubGVuZ3RoID09PSA0KSB7XG4gICAgICAgIGFscGhhID0gcGFyc2VJbnQoaGV4WzNdICsgaGV4WzNdLCAxNikgLyAyNTU7XG4gICAgICB9XG4gICAgfSBlbHNlIGlmIChoZXgubGVuZ3RoID09PSA2IHx8IGhleC5sZW5ndGggPT09IDgpIHtcbiAgICAgIHJlZCA9IHBhcnNlSW50KGhleC5zdWJzdHJpbmcoMCwgMiksIDE2KTtcbiAgICAgIGdyZWVuID0gcGFyc2VJbnQoaGV4LnN1YnN0cmluZygyLCA0KSwgMTYpO1xuICAgICAgYmx1ZSA9IHBhcnNlSW50KGhleC5zdWJzdHJpbmcoNCwgNiksIDE2KTtcbiAgICAgIGlmIChoZXgubGVuZ3RoID09PSA4KSB7XG4gICAgICAgIGFscGhhID0gcGFyc2VJbnQoaGV4LnN1YnN0cmluZyg2LCA4KSwgMTYpIC8gMjU1O1xuICAgICAgfVxuICAgIH1cbiAgfSBlbHNlIGlmIChjbGVhbkNvbG9yLnN0YXJ0c1dpdGgoJ3JnYmEnKSkge1xuICAgIGNvbnN0IHJnYmFWYWx1ZXMgPSBjbGVhbkNvbG9yLm1hdGNoKC9yZ2JhXFwoKFteKV0rKVxcKS8pWzFdLnNwbGl0KCcsJyk7XG4gICAgcmVkID0gcGFyc2VJbnQocmdiYVZhbHVlc1swXSwgMTApO1xuICAgIGdyZWVuID0gcGFyc2VJbnQocmdiYVZhbHVlc1sxXSwgMTApO1xuICAgIGJsdWUgPSBwYXJzZUludChyZ2JhVmFsdWVzWzJdLCAxMCk7XG4gICAgYWxwaGEgPSBwYXJzZUZsb2F0KHJnYmFWYWx1ZXNbM10pO1xuICB9IGVsc2UgaWYgKGNsZWFuQ29sb3Iuc3RhcnRzV2l0aCgncmdiJykpIHtcbiAgICBjb25zdCByZ2JWYWx1ZXMgPSBjbGVhbkNvbG9yLm1hdGNoKC9yZ2JcXCgoW14pXSspXFwpLylbMV0uc3BsaXQoJywnKTtcbiAgICByZWQgPSBwYXJzZUludChyZ2JWYWx1ZXNbMF0sIDEwKTtcbiAgICBncmVlbiA9IHBhcnNlSW50KHJnYlZhbHVlc1sxXSwgMTApO1xuICAgIGJsdWUgPSBwYXJzZUludChyZ2JWYWx1ZXNbMl0sIDEwKTtcbiAgfSBlbHNlIGlmIChjbGVhbkNvbG9yLnN0YXJ0c1dpdGgoJ2hzbGEnKSkge1xuICAgIGNvbnN0IGhzbGFWYWx1ZXMgPSBjbGVhbkNvbG9yLm1hdGNoKC9oc2xhXFwoKFteKV0rKVxcKS8pWzFdLnNwbGl0KCcsJyk7XG4gICAgY29uc3QgaCA9IHBhcnNlRmxvYXQoaHNsYVZhbHVlc1swXSk7XG4gICAgY29uc3QgcyA9IHBhcnNlRmxvYXQoaHNsYVZhbHVlc1sxXS5yZXBsYWNlKCclJywgJycpKSAvIDEwMDtcbiAgICBjb25zdCBsID0gcGFyc2VGbG9hdChoc2xhVmFsdWVzWzJdLnJlcGxhY2UoJyUnLCAnJykpIC8gMTAwO1xuICAgIGFscGhhID0gcGFyc2VGbG9hdChoc2xhVmFsdWVzWzNdKTtcblxuICAgIC8vIENvbnZlcnQgSFNMIHRvIFJHQlxuICAgIGNvbnN0IEMgPSAoMSAtIE1hdGguYWJzKDIgKiBsIC0gMSkpICogcztcbiAgICBjb25zdCBYID0gQyAqICgxIC0gTWF0aC5hYnMoKChoIC8gNjApICUgMikgLSAxKSk7XG4gICAgY29uc3QgbSA9IGwgLSBDIC8gMjtcbiAgICBsZXQgUjtcbiAgICBsZXQgRztcbiAgICBsZXQgQjtcblxuICAgIGlmIChoID49IDAgJiYgaCA8IDYwKSB7XG4gICAgICBSID0gQztcbiAgICAgIEcgPSBYO1xuICAgICAgQiA9IDA7XG4gICAgfSBlbHNlIGlmIChoID49IDYwICYmIGggPCAxMjApIHtcbiAgICAgIFIgPSBYO1xuICAgICAgRyA9IEM7XG4gICAgICBCID0gMDtcbiAgICB9IGVsc2UgaWYgKGggPj0gMTIwICYmIGggPCAxODApIHtcbiAgICAgIFIgPSAwO1xuICAgICAgRyA9IEM7XG4gICAgICBCID0gWDtcbiAgICB9IGVsc2UgaWYgKGggPj0gMTgwICYmIGggPCAyNDApIHtcbiAgICAgIFIgPSAwO1xuICAgICAgRyA9IFg7XG4gICAgICBCID0gQztcbiAgICB9IGVsc2UgaWYgKGggPj0gMjQwICYmIGggPCAzMDApIHtcbiAgICAgIFIgPSBYO1xuICAgICAgRyA9IDA7XG4gICAgICBCID0gQztcbiAgICB9IGVsc2Uge1xuICAgICAgUiA9IEM7XG4gICAgICBHID0gMDtcbiAgICAgIEIgPSBYO1xuICAgIH1cblxuICAgIHJlZCA9IE1hdGgucm91bmQoKFIgKyBtKSAqIDI1NSk7XG4gICAgZ3JlZW4gPSBNYXRoLnJvdW5kKChHICsgbSkgKiAyNTUpO1xuICAgIGJsdWUgPSBNYXRoLnJvdW5kKChCICsgbSkgKiAyNTUpO1xuICB9IGVsc2UgaWYgKGNsZWFuQ29sb3Iuc3RhcnRzV2l0aCgnaHNsJykpIHtcbiAgICBjb25zdCBoc2xWYWx1ZXMgPSBjbGVhbkNvbG9yLm1hdGNoKC9oc2xcXCgoW14pXSspXFwpLylbMV0uc3BsaXQoJywnKTtcbiAgICBjb25zdCBoID0gcGFyc2VGbG9hdChoc2xWYWx1ZXNbMF0pO1xuICAgIGNvbnN0IHMgPSBwYXJzZUZsb2F0KGhzbFZhbHVlc1sxXS5yZXBsYWNlKCclJywgJycpKSAvIDEwMDtcbiAgICBjb25zdCBsID0gcGFyc2VGbG9hdChoc2xWYWx1ZXNbMl0ucmVwbGFjZSgnJScsICcnKSkgLyAxMDA7XG5cbiAgICAvLyBDb252ZXJ0IEhTTCB0byBSR0IgKHdpdGhvdXQgYWxwaGEpXG4gICAgY29uc3QgQyA9ICgxIC0gTWF0aC5hYnMoMiAqIGwgLSAxKSkgKiBzO1xuICAgIGNvbnN0IFggPSBDICogKDEgLSBNYXRoLmFicygoKGggLyA2MCkgJSAyKSAtIDEpKTtcbiAgICBjb25zdCBtID0gbCAtIEMgLyAyO1xuICAgIGxldCBSO1xuICAgIGxldCBHO1xuICAgIGxldCBCO1xuXG4gICAgaWYgKGggPj0gMCAmJiBoIDwgNjApIHtcbiAgICAgIFIgPSBDO1xuICAgICAgRyA9IFg7XG4gICAgICBCID0gMDtcbiAgICB9IGVsc2UgaWYgKGggPj0gNjAgJiYgaCA8IDEyMCkge1xuICAgICAgUiA9IFg7XG4gICAgICBHID0gQztcbiAgICAgIEIgPSAwO1xuICAgIH0gZWxzZSBpZiAoaCA+PSAxMjAgJiYgaCA8IDE4MCkge1xuICAgICAgUiA9IDA7XG4gICAgICBHID0gQztcbiAgICAgIEIgPSBYO1xuICAgIH0gZWxzZSBpZiAoaCA+PSAxODAgJiYgaCA8IDI0MCkge1xuICAgICAgUiA9IDA7XG4gICAgICBHID0gWDtcbiAgICAgIEIgPSBDO1xuICAgIH0gZWxzZSBpZiAoaCA+PSAyNDAgJiYgaCA8IDMwMCkge1xuICAgICAgUiA9IFg7XG4gICAgICBHID0gMDtcbiAgICAgIEIgPSBDO1xuICAgIH0gZWxzZSB7XG4gICAgICBSID0gQztcbiAgICAgIEcgPSAwO1xuICAgICAgQiA9IFg7XG4gICAgfVxuXG4gICAgcmVkID0gTWF0aC5yb3VuZCgoUiArIG0pICogMjU1KTtcbiAgICBncmVlbiA9IE1hdGgucm91bmQoKEcgKyBtKSAqIDI1NSk7XG4gICAgYmx1ZSA9IE1hdGgucm91bmQoKEIgKyBtKSAqIDI1NSk7XG4gIH1cblxuICBpZiAoTnVtYmVyLmlzTmFOKHJlZCkgfHwgTnVtYmVyLmlzTmFOKGdyZWVuKSB8fCBOdW1iZXIuaXNOYU4oYmx1ZSkpIHtcbiAgICB0aHJvdyBuZXcgRXJyb3IoXG4gICAgICBgSW52YWxpZCBjb2xvciBpbiBbaXgyL3NoYXJlZC91dGlscy9ub3JtYWxpemVDb2xvci5qc10gJyR7aW5wdXRDb2xvcn0nYFxuICAgICk7XG4gIH1cblxuICByZXR1cm4ge3JlZCwgZ3JlZW4sIGJsdWUsIGFscGhhfTtcbn1cbiJdLCJuYW1lcyI6WyJub3JtYWxpemVDb2xvciIsImNvbG9yTmFtZXNPYmoiLCJhbGljZWJsdWUiLCJhbnRpcXVld2hpdGUiLCJhcXVhIiwiYXF1YW1hcmluZSIsImF6dXJlIiwiYmVpZ2UiLCJiaXNxdWUiLCJibGFjayIsImJsYW5jaGVkYWxtb25kIiwiYmx1ZSIsImJsdWV2aW9sZXQiLCJicm93biIsImJ1cmx5d29vZCIsImNhZGV0Ymx1ZSIsImNoYXJ0cmV1c2UiLCJjaG9jb2xhdGUiLCJjb3JhbCIsImNvcm5mbG93ZXJibHVlIiwiY29ybnNpbGsiLCJjcmltc29uIiwiY3lhbiIsImRhcmtibHVlIiwiZGFya2N5YW4iLCJkYXJrZ29sZGVucm9kIiwiZGFya2dyYXkiLCJkYXJrZ3JlZW4iLCJkYXJrZ3JleSIsImRhcmtraGFraSIsImRhcmttYWdlbnRhIiwiZGFya29saXZlZ3JlZW4iLCJkYXJrb3JhbmdlIiwiZGFya29yY2hpZCIsImRhcmtyZWQiLCJkYXJrc2FsbW9uIiwiZGFya3NlYWdyZWVuIiwiZGFya3NsYXRlYmx1ZSIsImRhcmtzbGF0ZWdyYXkiLCJkYXJrc2xhdGVncmV5IiwiZGFya3R1cnF1b2lzZSIsImRhcmt2aW9sZXQiLCJkZWVwcGluayIsImRlZXBza3libHVlIiwiZGltZ3JheSIsImRpbWdyZXkiLCJkb2RnZXJibHVlIiwiZmlyZWJyaWNrIiwiZmxvcmFsd2hpdGUiLCJmb3Jlc3RncmVlbiIsImZ1Y2hzaWEiLCJnYWluc2Jvcm8iLCJnaG9zdHdoaXRlIiwiZ29sZCIsImdvbGRlbnJvZCIsImdyYXkiLCJncmVlbiIsImdyZWVueWVsbG93IiwiZ3JleSIsImhvbmV5ZGV3IiwiaG90cGluayIsImluZGlhbnJlZCIsImluZGlnbyIsIml2b3J5Iiwia2hha2kiLCJsYXZlbmRlciIsImxhdmVuZGVyYmx1c2giLCJsYXduZ3JlZW4iLCJsZW1vbmNoaWZmb24iLCJsaWdodGJsdWUiLCJsaWdodGNvcmFsIiwibGlnaHRjeWFuIiwibGlnaHRnb2xkZW5yb2R5ZWxsb3ciLCJsaWdodGdyYXkiLCJsaWdodGdyZWVuIiwibGlnaHRncmV5IiwibGlnaHRwaW5rIiwibGlnaHRzYWxtb24iLCJsaWdodHNlYWdyZWVuIiwibGlnaHRza3libHVlIiwibGlnaHRzbGF0ZWdyYXkiLCJsaWdodHNsYXRlZ3JleSIsImxpZ2h0c3RlZWxibHVlIiwibGlnaHR5ZWxsb3ciLCJsaW1lIiwibGltZWdyZWVuIiwibGluZW4iLCJtYWdlbnRhIiwibWFyb29uIiwibWVkaXVtYXF1YW1hcmluZSIsIm1lZGl1bWJsdWUiLCJtZWRpdW1vcmNoaWQiLCJtZWRpdW1wdXJwbGUiLCJtZWRpdW1zZWFncmVlbiIsIm1lZGl1bXNsYXRlYmx1ZSIsIm1lZGl1bXNwcmluZ2dyZWVuIiwibWVkaXVtdHVycXVvaXNlIiwibWVkaXVtdmlvbGV0cmVkIiwibWlkbmlnaHRibHVlIiwibWludGNyZWFtIiwibWlzdHlyb3NlIiwibW9jY2FzaW4iLCJuYXZham93aGl0ZSIsIm5hdnkiLCJvbGRsYWNlIiwib2xpdmUiLCJvbGl2ZWRyYWIiLCJvcmFuZ2UiLCJvcmFuZ2VyZWQiLCJvcmNoaWQiLCJwYWxlZ29sZGVucm9kIiwicGFsZWdyZWVuIiwicGFsZXR1cnF1b2lzZSIsInBhbGV2aW9sZXRyZWQiLCJwYXBheWF3aGlwIiwicGVhY2hwdWZmIiwicGVydSIsInBpbmsiLCJwbHVtIiwicG93ZGVyYmx1ZSIsInB1cnBsZSIsInJlYmVjY2FwdXJwbGUiLCJyZWQiLCJyb3N5YnJvd24iLCJyb3lhbGJsdWUiLCJzYWRkbGVicm93biIsInNhbG1vbiIsInNhbmR5YnJvd24iLCJzZWFncmVlbiIsInNlYXNoZWxsIiwic2llbm5hIiwic2lsdmVyIiwic2t5Ymx1ZSIsInNsYXRlYmx1ZSIsInNsYXRlZ3JheSIsInNsYXRlZ3JleSIsInNub3ciLCJzcHJpbmdncmVlbiIsInN0ZWVsYmx1ZSIsInRhbiIsInRlYWwiLCJ0aGlzdGxlIiwidG9tYXRvIiwidHVycXVvaXNlIiwidmlvbGV0Iiwid2hlYXQiLCJ3aGl0ZSIsIndoaXRlc21va2UiLCJ5ZWxsb3ciLCJ5ZWxsb3dncmVlbiIsImlucHV0Q29sb3IiLCJhbHBoYSIsInJhd0NvbG9yIiwicmVwbGFjZSIsInRvTG93ZXJDYXNlIiwibmFtZWRDb2xvciIsImNsZWFuQ29sb3IiLCJzdGFydHNXaXRoIiwiaGV4Iiwic3Vic3RyaW5nIiwibGVuZ3RoIiwicGFyc2VJbnQiLCJyZ2JhVmFsdWVzIiwibWF0Y2giLCJzcGxpdCIsInBhcnNlRmxvYXQiLCJyZ2JWYWx1ZXMiLCJoc2xhVmFsdWVzIiwiaCIsInMiLCJsIiwiQyIsIk1hdGgiLCJhYnMiLCJYIiwibSIsIlIiLCJHIiwiQiIsInJvdW5kIiwiaHNsVmFsdWVzIiwiTnVtYmVyIiwiaXNOYU4iLCJFcnJvciJdLCJtYXBwaW5ncyI6IkFBQUEscUJBQXFCO0FBQ3JCLHFCQUFxQjtBQUNyQixvREFBb0Q7Ozs7OytCQXdKcENBOzs7ZUFBQUE7OztBQXZKaEIsTUFBTUMsZ0JBQWdCO0lBQ3BCQyxXQUFXO0lBQ1hDLGNBQWM7SUFDZEMsTUFBTTtJQUNOQyxZQUFZO0lBQ1pDLE9BQU87SUFDUEMsT0FBTztJQUNQQyxRQUFRO0lBQ1JDLE9BQU87SUFDUEMsZ0JBQWdCO0lBQ2hCQyxNQUFNO0lBQ05DLFlBQVk7SUFDWkMsT0FBTztJQUNQQyxXQUFXO0lBQ1hDLFdBQVc7SUFDWEMsWUFBWTtJQUNaQyxXQUFXO0lBQ1hDLE9BQU87SUFDUEMsZ0JBQWdCO0lBQ2hCQyxVQUFVO0lBQ1ZDLFNBQVM7SUFDVEMsTUFBTTtJQUNOQyxVQUFVO0lBQ1ZDLFVBQVU7SUFDVkMsZUFBZTtJQUNmQyxVQUFVO0lBQ1ZDLFdBQVc7SUFDWEMsVUFBVTtJQUNWQyxXQUFXO0lBQ1hDLGFBQWE7SUFDYkMsZ0JBQWdCO0lBQ2hCQyxZQUFZO0lBQ1pDLFlBQVk7SUFDWkMsU0FBUztJQUNUQyxZQUFZO0lBQ1pDLGNBQWM7SUFDZEMsZUFBZTtJQUNmQyxlQUFlO0lBQ2ZDLGVBQWU7SUFDZkMsZUFBZTtJQUNmQyxZQUFZO0lBQ1pDLFVBQVU7SUFDVkMsYUFBYTtJQUNiQyxTQUFTO0lBQ1RDLFNBQVM7SUFDVEMsWUFBWTtJQUNaQyxXQUFXO0lBQ1hDLGFBQWE7SUFDYkMsYUFBYTtJQUNiQyxTQUFTO0lBQ1RDLFdBQVc7SUFDWEMsWUFBWTtJQUNaQyxNQUFNO0lBQ05DLFdBQVc7SUFDWEMsTUFBTTtJQUNOQyxPQUFPO0lBQ1BDLGFBQWE7SUFDYkMsTUFBTTtJQUNOQyxVQUFVO0lBQ1ZDLFNBQVM7SUFDVEMsV0FBVztJQUNYQyxRQUFRO0lBQ1JDLE9BQU87SUFDUEMsT0FBTztJQUNQQyxVQUFVO0lBQ1ZDLGVBQWU7SUFDZkMsV0FBVztJQUNYQyxjQUFjO0lBQ2RDLFdBQVc7SUFDWEMsWUFBWTtJQUNaQyxXQUFXO0lBQ1hDLHNCQUFzQjtJQUN0QkMsV0FBVztJQUNYQyxZQUFZO0lBQ1pDLFdBQVc7SUFDWEMsV0FBVztJQUNYQyxhQUFhO0lBQ2JDLGVBQWU7SUFDZkMsY0FBYztJQUNkQyxnQkFBZ0I7SUFDaEJDLGdCQUFnQjtJQUNoQkMsZ0JBQWdCO0lBQ2hCQyxhQUFhO0lBQ2JDLE1BQU07SUFDTkMsV0FBVztJQUNYQyxPQUFPO0lBQ1BDLFNBQVM7SUFDVEMsUUFBUTtJQUNSQyxrQkFBa0I7SUFDbEJDLFlBQVk7SUFDWkMsY0FBYztJQUNkQyxjQUFjO0lBQ2RDLGdCQUFnQjtJQUNoQkMsaUJBQWlCO0lBQ2pCQyxtQkFBbUI7SUFDbkJDLGlCQUFpQjtJQUNqQkMsaUJBQWlCO0lBQ2pCQyxjQUFjO0lBQ2RDLFdBQVc7SUFDWEMsV0FBVztJQUNYQyxVQUFVO0lBQ1ZDLGFBQWE7SUFDYkMsTUFBTTtJQUNOQyxTQUFTO0lBQ1RDLE9BQU87SUFDUEMsV0FBVztJQUNYQyxRQUFRO0lBQ1JDLFdBQVc7SUFDWEMsUUFBUTtJQUNSQyxlQUFlO0lBQ2ZDLFdBQVc7SUFDWEMsZUFBZTtJQUNmQyxlQUFlO0lBQ2ZDLFlBQVk7SUFDWkMsV0FBVztJQUNYQyxNQUFNO0lBQ05DLE1BQU07SUFDTkMsTUFBTTtJQUNOQyxZQUFZO0lBQ1pDLFFBQVE7SUFDUkMsZUFBZTtJQUNmQyxLQUFLO0lBQ0xDLFdBQVc7SUFDWEMsV0FBVztJQUNYQyxhQUFhO0lBQ2JDLFFBQVE7SUFDUkMsWUFBWTtJQUNaQyxVQUFVO0lBQ1ZDLFVBQVU7SUFDVkMsUUFBUTtJQUNSQyxRQUFRO0lBQ1JDLFNBQVM7SUFDVEMsV0FBVztJQUNYQyxXQUFXO0lBQ1hDLFdBQVc7SUFDWEMsTUFBTTtJQUNOQyxhQUFhO0lBQ2JDLFdBQVc7SUFDWEMsS0FBSztJQUNMQyxNQUFNO0lBQ05DLFNBQVM7SUFDVEMsUUFBUTtJQUNSQyxXQUFXO0lBQ1hDLFFBQVE7SUFDUkMsT0FBTztJQUNQQyxPQUFPO0lBQ1BDLFlBQVk7SUFDWkMsUUFBUTtJQUNSQyxhQUFhO0FBQ2Y7QUFFTyxTQUFTckosZUFBZXNKLFVBQVU7SUFDdkMsSUFBSTVCO0lBQ0osSUFBSWxFO0lBQ0osSUFBSTdDO0lBQ0osSUFBSTRJLFFBQVEsR0FBRyxxQkFBcUI7SUFDcEMsTUFBTUMsV0FBV0YsV0FBV0csT0FBTyxDQUFDLE9BQU8sSUFBSUMsV0FBVztJQUMxRCxNQUFNQyxhQUNKLE9BQU8xSixhQUFhLENBQUN1SixTQUFTLEtBQUssV0FDL0J2SixhQUFhLENBQUN1SixTQUFTLENBQUNFLFdBQVcsS0FDbkM7SUFDTixNQUFNRSxhQUFhRCxjQUFjSDtJQUVqQyxJQUFJSSxXQUFXQyxVQUFVLENBQUMsTUFBTTtRQUM5QixNQUFNQyxNQUFNRixXQUFXRyxTQUFTLENBQUM7UUFFakMsSUFBSUQsSUFBSUUsTUFBTSxLQUFLLEtBQUtGLElBQUlFLE1BQU0sS0FBSyxHQUFHO1lBQ3hDdEMsTUFBTXVDLFNBQVNILEdBQUcsQ0FBQyxFQUFFLEdBQUdBLEdBQUcsQ0FBQyxFQUFFLEVBQUU7WUFDaEN0RyxRQUFReUcsU0FBU0gsR0FBRyxDQUFDLEVBQUUsR0FBR0EsR0FBRyxDQUFDLEVBQUUsRUFBRTtZQUNsQ25KLE9BQU9zSixTQUFTSCxHQUFHLENBQUMsRUFBRSxHQUFHQSxHQUFHLENBQUMsRUFBRSxFQUFFO1lBQ2pDLElBQUlBLElBQUlFLE1BQU0sS0FBSyxHQUFHO2dCQUNwQlQsUUFBUVUsU0FBU0gsR0FBRyxDQUFDLEVBQUUsR0FBR0EsR0FBRyxDQUFDLEVBQUUsRUFBRSxNQUFNO1lBQzFDO1FBQ0YsT0FBTyxJQUFJQSxJQUFJRSxNQUFNLEtBQUssS0FBS0YsSUFBSUUsTUFBTSxLQUFLLEdBQUc7WUFDL0N0QyxNQUFNdUMsU0FBU0gsSUFBSUMsU0FBUyxDQUFDLEdBQUcsSUFBSTtZQUNwQ3ZHLFFBQVF5RyxTQUFTSCxJQUFJQyxTQUFTLENBQUMsR0FBRyxJQUFJO1lBQ3RDcEosT0FBT3NKLFNBQVNILElBQUlDLFNBQVMsQ0FBQyxHQUFHLElBQUk7WUFDckMsSUFBSUQsSUFBSUUsTUFBTSxLQUFLLEdBQUc7Z0JBQ3BCVCxRQUFRVSxTQUFTSCxJQUFJQyxTQUFTLENBQUMsR0FBRyxJQUFJLE1BQU07WUFDOUM7UUFDRjtJQUNGLE9BQU8sSUFBSUgsV0FBV0MsVUFBVSxDQUFDLFNBQVM7UUFDeEMsTUFBTUssYUFBYU4sV0FBV08sS0FBSyxDQUFDLGtCQUFrQixDQUFDLEVBQUUsQ0FBQ0MsS0FBSyxDQUFDO1FBQ2hFMUMsTUFBTXVDLFNBQVNDLFVBQVUsQ0FBQyxFQUFFLEVBQUU7UUFDOUIxRyxRQUFReUcsU0FBU0MsVUFBVSxDQUFDLEVBQUUsRUFBRTtRQUNoQ3ZKLE9BQU9zSixTQUFTQyxVQUFVLENBQUMsRUFBRSxFQUFFO1FBQy9CWCxRQUFRYyxXQUFXSCxVQUFVLENBQUMsRUFBRTtJQUNsQyxPQUFPLElBQUlOLFdBQVdDLFVBQVUsQ0FBQyxRQUFRO1FBQ3ZDLE1BQU1TLFlBQVlWLFdBQVdPLEtBQUssQ0FBQyxpQkFBaUIsQ0FBQyxFQUFFLENBQUNDLEtBQUssQ0FBQztRQUM5RDFDLE1BQU11QyxTQUFTSyxTQUFTLENBQUMsRUFBRSxFQUFFO1FBQzdCOUcsUUFBUXlHLFNBQVNLLFNBQVMsQ0FBQyxFQUFFLEVBQUU7UUFDL0IzSixPQUFPc0osU0FBU0ssU0FBUyxDQUFDLEVBQUUsRUFBRTtJQUNoQyxPQUFPLElBQUlWLFdBQVdDLFVBQVUsQ0FBQyxTQUFTO1FBQ3hDLE1BQU1VLGFBQWFYLFdBQVdPLEtBQUssQ0FBQyxrQkFBa0IsQ0FBQyxFQUFFLENBQUNDLEtBQUssQ0FBQztRQUNoRSxNQUFNSSxJQUFJSCxXQUFXRSxVQUFVLENBQUMsRUFBRTtRQUNsQyxNQUFNRSxJQUFJSixXQUFXRSxVQUFVLENBQUMsRUFBRSxDQUFDZCxPQUFPLENBQUMsS0FBSyxPQUFPO1FBQ3ZELE1BQU1pQixJQUFJTCxXQUFXRSxVQUFVLENBQUMsRUFBRSxDQUFDZCxPQUFPLENBQUMsS0FBSyxPQUFPO1FBQ3ZERixRQUFRYyxXQUFXRSxVQUFVLENBQUMsRUFBRTtRQUVoQyxxQkFBcUI7UUFDckIsTUFBTUksSUFBSSxBQUFDLENBQUEsSUFBSUMsS0FBS0MsR0FBRyxDQUFDLElBQUlILElBQUksRUFBQyxJQUFLRDtRQUN0QyxNQUFNSyxJQUFJSCxJQUFLLENBQUEsSUFBSUMsS0FBS0MsR0FBRyxDQUFDLEFBQUVMLElBQUksS0FBTSxJQUFLLEVBQUM7UUFDOUMsTUFBTU8sSUFBSUwsSUFBSUMsSUFBSTtRQUNsQixJQUFJSztRQUNKLElBQUlDO1FBQ0osSUFBSUM7UUFFSixJQUFJVixLQUFLLEtBQUtBLElBQUksSUFBSTtZQUNwQlEsSUFBSUw7WUFDSk0sSUFBSUg7WUFDSkksSUFBSTtRQUNOLE9BQU8sSUFBSVYsS0FBSyxNQUFNQSxJQUFJLEtBQUs7WUFDN0JRLElBQUlGO1lBQ0pHLElBQUlOO1lBQ0pPLElBQUk7UUFDTixPQUFPLElBQUlWLEtBQUssT0FBT0EsSUFBSSxLQUFLO1lBQzlCUSxJQUFJO1lBQ0pDLElBQUlOO1lBQ0pPLElBQUlKO1FBQ04sT0FBTyxJQUFJTixLQUFLLE9BQU9BLElBQUksS0FBSztZQUM5QlEsSUFBSTtZQUNKQyxJQUFJSDtZQUNKSSxJQUFJUDtRQUNOLE9BQU8sSUFBSUgsS0FBSyxPQUFPQSxJQUFJLEtBQUs7WUFDOUJRLElBQUlGO1lBQ0pHLElBQUk7WUFDSkMsSUFBSVA7UUFDTixPQUFPO1lBQ0xLLElBQUlMO1lBQ0pNLElBQUk7WUFDSkMsSUFBSUo7UUFDTjtRQUVBcEQsTUFBTWtELEtBQUtPLEtBQUssQ0FBQyxBQUFDSCxDQUFBQSxJQUFJRCxDQUFBQSxJQUFLO1FBQzNCdkgsUUFBUW9ILEtBQUtPLEtBQUssQ0FBQyxBQUFDRixDQUFBQSxJQUFJRixDQUFBQSxJQUFLO1FBQzdCcEssT0FBT2lLLEtBQUtPLEtBQUssQ0FBQyxBQUFDRCxDQUFBQSxJQUFJSCxDQUFBQSxJQUFLO0lBQzlCLE9BQU8sSUFBSW5CLFdBQVdDLFVBQVUsQ0FBQyxRQUFRO1FBQ3ZDLE1BQU11QixZQUFZeEIsV0FBV08sS0FBSyxDQUFDLGlCQUFpQixDQUFDLEVBQUUsQ0FBQ0MsS0FBSyxDQUFDO1FBQzlELE1BQU1JLElBQUlILFdBQVdlLFNBQVMsQ0FBQyxFQUFFO1FBQ2pDLE1BQU1YLElBQUlKLFdBQVdlLFNBQVMsQ0FBQyxFQUFFLENBQUMzQixPQUFPLENBQUMsS0FBSyxPQUFPO1FBQ3RELE1BQU1pQixJQUFJTCxXQUFXZSxTQUFTLENBQUMsRUFBRSxDQUFDM0IsT0FBTyxDQUFDLEtBQUssT0FBTztRQUV0RCxxQ0FBcUM7UUFDckMsTUFBTWtCLElBQUksQUFBQyxDQUFBLElBQUlDLEtBQUtDLEdBQUcsQ0FBQyxJQUFJSCxJQUFJLEVBQUMsSUFBS0Q7UUFDdEMsTUFBTUssSUFBSUgsSUFBSyxDQUFBLElBQUlDLEtBQUtDLEdBQUcsQ0FBQyxBQUFFTCxJQUFJLEtBQU0sSUFBSyxFQUFDO1FBQzlDLE1BQU1PLElBQUlMLElBQUlDLElBQUk7UUFDbEIsSUFBSUs7UUFDSixJQUFJQztRQUNKLElBQUlDO1FBRUosSUFBSVYsS0FBSyxLQUFLQSxJQUFJLElBQUk7WUFDcEJRLElBQUlMO1lBQ0pNLElBQUlIO1lBQ0pJLElBQUk7UUFDTixPQUFPLElBQUlWLEtBQUssTUFBTUEsSUFBSSxLQUFLO1lBQzdCUSxJQUFJRjtZQUNKRyxJQUFJTjtZQUNKTyxJQUFJO1FBQ04sT0FBTyxJQUFJVixLQUFLLE9BQU9BLElBQUksS0FBSztZQUM5QlEsSUFBSTtZQUNKQyxJQUFJTjtZQUNKTyxJQUFJSjtRQUNOLE9BQU8sSUFBSU4sS0FBSyxPQUFPQSxJQUFJLEtBQUs7WUFDOUJRLElBQUk7WUFDSkMsSUFBSUg7WUFDSkksSUFBSVA7UUFDTixPQUFPLElBQUlILEtBQUssT0FBT0EsSUFBSSxLQUFLO1lBQzlCUSxJQUFJRjtZQUNKRyxJQUFJO1lBQ0pDLElBQUlQO1FBQ04sT0FBTztZQUNMSyxJQUFJTDtZQUNKTSxJQUFJO1lBQ0pDLElBQUlKO1FBQ047UUFFQXBELE1BQU1rRCxLQUFLTyxLQUFLLENBQUMsQUFBQ0gsQ0FBQUEsSUFBSUQsQ0FBQUEsSUFBSztRQUMzQnZILFFBQVFvSCxLQUFLTyxLQUFLLENBQUMsQUFBQ0YsQ0FBQUEsSUFBSUYsQ0FBQUEsSUFBSztRQUM3QnBLLE9BQU9pSyxLQUFLTyxLQUFLLENBQUMsQUFBQ0QsQ0FBQUEsSUFBSUgsQ0FBQUEsSUFBSztJQUM5QjtJQUVBLElBQUlNLE9BQU9DLEtBQUssQ0FBQzVELFFBQVEyRCxPQUFPQyxLQUFLLENBQUM5SCxVQUFVNkgsT0FBT0MsS0FBSyxDQUFDM0ssT0FBTztRQUNsRSxNQUFNLElBQUk0SyxNQUNSLENBQUMsdURBQXVELEVBQUVqQyxXQUFXLENBQUMsQ0FBQztJQUUzRTtJQUVBLE9BQU87UUFBQzVCO1FBQUtsRTtRQUFPN0M7UUFBTTRJO0lBQUs7QUFDakMifQ==

}),
9468: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    // IX2Actions,
    IX2BrowserSupport: function() {
        return _IX2BrowserSupport;
    },
    IX2EasingUtils: function() {
        return _IX2EasingUtils;
    },
    IX2Easings: function() {
        return _IX2Easings;
    },
    IX2ElementsReducer: function() {
        return _IX2ElementsReducer;
    },
    IX2VanillaPlugins: function() {
        return _IX2VanillaPlugins;
    },
    IX2VanillaUtils: function() {
        return _IX2VanillaUtils;
    }
});
const _IX2BrowserSupport = /*#__PURE__*/ _interop_require_wildcard(__webpack_require__(12662));
const _IX2Easings = /*#__PURE__*/ _interop_require_wildcard(__webpack_require__(78686));
const _IX2EasingUtils = /*#__PURE__*/ _interop_require_wildcard(__webpack_require__(73767));
const _IX2ElementsReducer = /*#__PURE__*/ _interop_require_wildcard(__webpack_require__(85861));
const _IX2VanillaPlugins = /*#__PURE__*/ _interop_require_wildcard(__webpack_require__(31799));
const _IX2VanillaUtils = /*#__PURE__*/ _interop_require_wildcard(__webpack_require__(4124));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCAqIGFzIElYMkJyb3dzZXJTdXBwb3J0IGZyb20gJy4vbG9naWMvSVgyQnJvd3NlclN1cHBvcnQnO1xuaW1wb3J0ICogYXMgSVgyRWFzaW5ncyBmcm9tICcuL2xvZ2ljL0lYMkVhc2luZ3MnO1xuaW1wb3J0ICogYXMgSVgyRWFzaW5nVXRpbHMgZnJvbSAnLi9sb2dpYy9JWDJFYXNpbmdVdGlscyc7XG5pbXBvcnQgKiBhcyBJWDJFbGVtZW50c1JlZHVjZXIgZnJvbSAnLi9yZWR1Y2Vycy9JWDJFbGVtZW50c1JlZHVjZXInO1xuaW1wb3J0ICogYXMgSVgyVmFuaWxsYVBsdWdpbnMgZnJvbSAnLi9sb2dpYy9JWDJWYW5pbGxhUGx1Z2lucyc7XG5pbXBvcnQgKiBhcyBJWDJWYW5pbGxhVXRpbHMgZnJvbSAnLi9sb2dpYy9JWDJWYW5pbGxhVXRpbHMnO1xuZXhwb3J0IHtcbiAgLy8gSVgyQWN0aW9ucyxcbiAgSVgyQnJvd3NlclN1cHBvcnQsXG4gIElYMkVhc2luZ3MsXG4gIElYMkVhc2luZ1V0aWxzLFxuICBJWDJFbGVtZW50c1JlZHVjZXIsXG4gIElYMlZhbmlsbGFQbHVnaW5zLFxuICBJWDJWYW5pbGxhVXRpbHMsXG59O1xuIl0sIm5hbWVzIjpbIklYMkJyb3dzZXJTdXBwb3J0IiwiSVgyRWFzaW5nVXRpbHMiLCJJWDJFYXNpbmdzIiwiSVgyRWxlbWVudHNSZWR1Y2VyIiwiSVgyVmFuaWxsYVBsdWdpbnMiLCJJWDJWYW5pbGxhVXRpbHMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0lBT0UsY0FBYztJQUNkQSxpQkFBaUI7ZUFBakJBOztJQUVBQyxjQUFjO2VBQWRBOztJQURBQyxVQUFVO2VBQVZBOztJQUVBQyxrQkFBa0I7ZUFBbEJBOztJQUNBQyxpQkFBaUI7ZUFBakJBOztJQUNBQyxlQUFlO2VBQWZBOzs7MkVBYmlDO29FQUNQO3dFQUNJOzRFQUNJOzJFQUNEO3lFQUNGIn0=

}),
12662: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/* eslint-env browser */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ELEMENT_MATCHES: function() {
        return ELEMENT_MATCHES;
    },
    FLEX_PREFIXED: function() {
        return FLEX_PREFIXED;
    },
    IS_BROWSER_ENV: function() {
        return IS_BROWSER_ENV;
    },
    TRANSFORM_PREFIXED: function() {
        return TRANSFORM_PREFIXED;
    },
    TRANSFORM_STYLE_PREFIXED: function() {
        return TRANSFORM_STYLE_PREFIXED;
    },
    withBrowser: function() {
        return withBrowser;
    }
});
const _find = /*#__PURE__*/ _interop_require_default(__webpack_require__(19777));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const IS_BROWSER_ENV = typeof window !== 'undefined';
const withBrowser = (fn, fallback)=>{
    if (IS_BROWSER_ENV) {
        return fn();
    }
    return fallback;
};
const ELEMENT_MATCHES = withBrowser(()=>{
    return (0, _find.default)([
        'matches',
        'matchesSelector',
        'mozMatchesSelector',
        'msMatchesSelector',
        'oMatchesSelector',
        'webkitMatchesSelector'
    ], (key)=>key in Element.prototype);
});
const FLEX_PREFIXED = withBrowser(()=>{
    const el = document.createElement('i');
    const values = [
        'flex',
        '-webkit-flex',
        '-ms-flexbox',
        '-moz-box',
        '-webkit-box'
    ];
    const none = '';
    try {
        const { length } = values;
        for(let i = 0; i < length; i++){
            const value = values[i];
            // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
            el.style.display = value;
            if (el.style.display === value) {
                return value;
            }
        }
        return none;
    } catch (err) {
        return none;
    }
}, 'flex');
const TRANSFORM_PREFIXED = withBrowser(()=>{
    const el = document.createElement('i');
    if (el.style.transform == null) {
        const prefixes = [
            'Webkit',
            'Moz',
            'ms'
        ];
        const suffix = 'Transform';
        const { length } = prefixes;
        for(let i = 0; i < length; i++){
            const prop = prefixes[i] + suffix;
            // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
            if (el.style[prop] !== undefined) {
                return prop;
            }
        }
    }
    return 'transform';
}, 'transform');
const TRANSFORM_PREFIX = TRANSFORM_PREFIXED.split('transform')[0];
const TRANSFORM_STYLE_PREFIXED = TRANSFORM_PREFIX ? TRANSFORM_PREFIX + 'TransformStyle' : 'transformStyle';

//# sourceMappingURL=data:application/json;base64,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

}),
73767: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    applyEasing: function() {
        return applyEasing;
    },
    createBezierEasing: function() {
        return createBezierEasing;
    },
    optimizeFloat: function() {
        return optimizeFloat;
    }
});
const _IX2Easings = /*#__PURE__*/ _interop_require_wildcard(__webpack_require__(78686));
const _beziereasing = /*#__PURE__*/ _interop_require_default(__webpack_require__(1361));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function optimizeFloat(value, digits = 5, base = 10) {
    const pow = Math.pow(base, digits);
    const float = Number(Math.round(value * pow) / pow);
    return Math.abs(float) > 0.0001 ? float : 0;
}
function createBezierEasing(easing) {
    return (0, _beziereasing.default)(...easing);
}
function applyEasing(easing, position, customEasingFn) {
    if (position === 0) {
        return 0;
    }
    if (position === 1) {
        return 1;
    }
    if (customEasingFn) {
        return optimizeFloat(position > 0 ? customEasingFn(position) : position);
    }
    return optimizeFloat(position > 0 && easing && _IX2Easings[easing] ? _IX2Easings[easing](position) : position);
}

//# sourceMappingURL=data:application/json;base64,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

}),
78686: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'bezier-easing'. '/home/runner/work/flow-to-typescript-codemod/flow-to-typescript-codemod/webflow/node_modules/bezier-easing/src/index.js' implicitly has an 'any' type.

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    bounce: function() {
        return bounce;
    },
    bouncePast: function() {
        return bouncePast;
    },
    ease: function() {
        return ease;
    },
    easeIn: function() {
        return easeIn;
    },
    easeInOut: function() {
        return easeInOut;
    },
    easeOut: function() {
        return easeOut;
    },
    inBack: function() {
        return inBack;
    },
    inCirc: function() {
        return inCirc;
    },
    inCubic: function() {
        return inCubic;
    },
    inElastic: function() {
        return inElastic;
    },
    inExpo: function() {
        return inExpo;
    },
    inOutBack: function() {
        return inOutBack;
    },
    inOutCirc: function() {
        return inOutCirc;
    },
    inOutCubic: function() {
        return inOutCubic;
    },
    inOutElastic: function() {
        return inOutElastic;
    },
    inOutExpo: function() {
        return inOutExpo;
    },
    inOutQuad: function() {
        return inOutQuad;
    },
    inOutQuart: function() {
        return inOutQuart;
    },
    inOutQuint: function() {
        return inOutQuint;
    },
    inOutSine: function() {
        return inOutSine;
    },
    inQuad: function() {
        return inQuad;
    },
    inQuart: function() {
        return inQuart;
    },
    inQuint: function() {
        return inQuint;
    },
    inSine: function() {
        return inSine;
    },
    outBack: function() {
        return outBack;
    },
    outBounce: function() {
        return outBounce;
    },
    outCirc: function() {
        return outCirc;
    },
    outCubic: function() {
        return outCubic;
    },
    outElastic: function() {
        return outElastic;
    },
    outExpo: function() {
        return outExpo;
    },
    outQuad: function() {
        return outQuad;
    },
    outQuart: function() {
        return outQuart;
    },
    outQuint: function() {
        return outQuint;
    },
    outSine: function() {
        return outSine;
    },
    swingFrom: function() {
        return swingFrom;
    },
    swingFromTo: function() {
        return swingFromTo;
    },
    swingTo: function() {
        return swingTo;
    }
});
const _beziereasing = /*#__PURE__*/ _interop_require_default(__webpack_require__(1361));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Easing functions adapted from Thomas Fuchs & Jeremy Kahn
// Easing Equations (c) 2003 Robert Penner, BSD license
// https://raw.github.com/danro/easing-js/master/LICENSE
const magicSwing = 1.70158;
const ease = (0, _beziereasing.default)(0.25, 0.1, 0.25, 1.0);
const easeIn = (0, _beziereasing.default)(0.42, 0.0, 1.0, 1.0);
const easeOut = (0, _beziereasing.default)(0.0, 0.0, 0.58, 1.0);
const easeInOut = (0, _beziereasing.default)(0.42, 0.0, 0.58, 1.0);
function inQuad(pos) {
    return Math.pow(pos, 2);
}
function outQuad(pos) {
    return -(Math.pow(pos - 1, 2) - 1);
}
function inOutQuad(pos) {
    if ((pos /= 0.5) < 1) {
        return 0.5 * Math.pow(pos, 2);
    }
    return -0.5 * ((pos -= 2) * pos - 2);
}
function inCubic(pos) {
    return Math.pow(pos, 3);
}
function outCubic(pos) {
    return Math.pow(pos - 1, 3) + 1;
}
function inOutCubic(pos) {
    if ((pos /= 0.5) < 1) {
        return 0.5 * Math.pow(pos, 3);
    }
    return 0.5 * (Math.pow(pos - 2, 3) + 2);
}
function inQuart(pos) {
    return Math.pow(pos, 4);
}
function outQuart(pos) {
    return -(Math.pow(pos - 1, 4) - 1);
}
function inOutQuart(pos) {
    if ((pos /= 0.5) < 1) {
        return 0.5 * Math.pow(pos, 4);
    }
    return -0.5 * ((pos -= 2) * Math.pow(pos, 3) - 2);
}
function inQuint(pos) {
    return Math.pow(pos, 5);
}
function outQuint(pos) {
    return Math.pow(pos - 1, 5) + 1;
}
function inOutQuint(pos) {
    if ((pos /= 0.5) < 1) {
        return 0.5 * Math.pow(pos, 5);
    }
    return 0.5 * (Math.pow(pos - 2, 5) + 2);
}
function inSine(pos) {
    return -Math.cos(pos * (Math.PI / 2)) + 1;
}
function outSine(pos) {
    return Math.sin(pos * (Math.PI / 2));
}
function inOutSine(pos) {
    return -0.5 * (Math.cos(Math.PI * pos) - 1);
}
function inExpo(pos) {
    return pos === 0 ? 0 : Math.pow(2, 10 * (pos - 1));
}
function outExpo(pos) {
    return pos === 1 ? 1 : -Math.pow(2, -10 * pos) + 1;
}
function inOutExpo(pos) {
    if (pos === 0) {
        return 0;
    }
    if (pos === 1) {
        return 1;
    }
    if ((pos /= 0.5) < 1) {
        return 0.5 * Math.pow(2, 10 * (pos - 1));
    }
    return 0.5 * (-Math.pow(2, -10 * --pos) + 2);
}
function inCirc(pos) {
    return -(Math.sqrt(1 - pos * pos) - 1);
}
function outCirc(pos) {
    return Math.sqrt(1 - Math.pow(pos - 1, 2));
}
function inOutCirc(pos) {
    if ((pos /= 0.5) < 1) {
        return -0.5 * (Math.sqrt(1 - pos * pos) - 1);
    }
    return 0.5 * (Math.sqrt(1 - (pos -= 2) * pos) + 1);
}
function outBounce(pos) {
    if (pos < 1 / 2.75) {
        return 7.5625 * pos * pos;
    } else if (pos < 2 / 2.75) {
        return 7.5625 * (pos -= 1.5 / 2.75) * pos + 0.75;
    } else if (pos < 2.5 / 2.75) {
        return 7.5625 * (pos -= 2.25 / 2.75) * pos + 0.9375;
    } else {
        return 7.5625 * (pos -= 2.625 / 2.75) * pos + 0.984375;
    }
}
function inBack(pos) {
    const s = magicSwing;
    return pos * pos * ((s + 1) * pos - s);
}
function outBack(pos) {
    const s = magicSwing;
    return (pos -= 1) * pos * ((s + 1) * pos + s) + 1;
}
function inOutBack(pos) {
    let s = magicSwing;
    if ((pos /= 0.5) < 1) {
        return 0.5 * (pos * pos * (((s *= 1.525) + 1) * pos - s));
    }
    return 0.5 * ((pos -= 2) * pos * (((s *= 1.525) + 1) * pos + s) + 2);
}
function inElastic(pos) {
    let s = magicSwing;
    let p = 0;
    let a = 1;
    if (pos === 0) {
        return 0;
    }
    if (pos === 1) {
        return 1;
    }
    if (!p) {
        p = 0.3;
    }
    if (a < 1) {
        a = 1;
        s = p / 4;
    } else {
        s = p / (2 * Math.PI) * Math.asin(1 / a);
    }
    return -(a * Math.pow(2, 10 * (pos -= 1)) * Math.sin((pos - s) * (2 * Math.PI) / p));
}
function outElastic(pos) {
    let s = magicSwing;
    let p = 0;
    let a = 1;
    if (pos === 0) {
        return 0;
    }
    if (pos === 1) {
        return 1;
    }
    if (!p) {
        p = 0.3;
    }
    if (a < 1) {
        a = 1;
        s = p / 4;
    } else {
        s = p / (2 * Math.PI) * Math.asin(1 / a);
    }
    return a * Math.pow(2, -10 * pos) * Math.sin((pos - s) * (2 * Math.PI) / p) + 1;
}
function inOutElastic(pos) {
    let s = magicSwing;
    let p = 0;
    let a = 1;
    if (pos === 0) {
        return 0;
    }
    if ((pos /= 1 / 2) === 2) {
        return 1;
    }
    if (!p) {
        p = 0.3 * 1.5;
    }
    if (a < 1) {
        a = 1;
        s = p / 4;
    } else {
        s = p / (2 * Math.PI) * Math.asin(1 / a);
    }
    if (pos < 1) {
        return -0.5 * (a * Math.pow(2, 10 * (pos -= 1)) * Math.sin((pos - s) * (2 * Math.PI) / p));
    }
    return a * Math.pow(2, -10 * (pos -= 1)) * Math.sin((pos - s) * (2 * Math.PI) / p) * 0.5 + 1;
}
function swingFromTo(pos) {
    let s = magicSwing;
    return (pos /= 0.5) < 1 ? 0.5 * (pos * pos * (((s *= 1.525) + 1) * pos - s)) : 0.5 * ((pos -= 2) * pos * (((s *= 1.525) + 1) * pos + s) + 2);
}
function swingFrom(pos) {
    const s = magicSwing;
    return pos * pos * ((s + 1) * pos - s);
}
function swingTo(pos) {
    const s = magicSwing;
    return (pos -= 1) * pos * ((s + 1) * pos + s) + 1;
}
function bounce(pos) {
    if (pos < 1 / 2.75) {
        return 7.5625 * pos * pos;
    } else if (pos < 2 / 2.75) {
        return 7.5625 * (pos -= 1.5 / 2.75) * pos + 0.75;
    } else if (pos < 2.5 / 2.75) {
        return 7.5625 * (pos -= 2.25 / 2.75) * pos + 0.9375;
    } else {
        return 7.5625 * (pos -= 2.625 / 2.75) * pos + 0.984375;
    }
}
function bouncePast(pos) {
    if (pos < 1 / 2.75) {
        return 7.5625 * pos * pos;
    } else if (pos < 2 / 2.75) {
        return 2 - (7.5625 * (pos -= 1.5 / 2.75) * pos + 0.75);
    } else if (pos < 2.5 / 2.75) {
        return 2 - (7.5625 * (pos -= 2.25 / 2.75) * pos + 0.9375);
    } else {
        return 2 - (7.5625 * (pos -= 2.625 / 2.75) * pos + 0.984375);
    }
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIklYMkVhc2luZ3MudHMiXSwic291cmNlc0NvbnRlbnQiOlsiLy8gQHRzLWV4cGVjdC1lcnJvciAtIFRTNzAxNiAtIENvdWxkIG5vdCBmaW5kIGEgZGVjbGFyYXRpb24gZmlsZSBmb3IgbW9kdWxlICdiZXppZXItZWFzaW5nJy4gJy9ob21lL3J1bm5lci93b3JrL2Zsb3ctdG8tdHlwZXNjcmlwdC1jb2RlbW9kL2Zsb3ctdG8tdHlwZXNjcmlwdC1jb2RlbW9kL3dlYmZsb3cvbm9kZV9tb2R1bGVzL2Jlemllci1lYXNpbmcvc3JjL2luZGV4LmpzJyBpbXBsaWNpdGx5IGhhcyBhbiAnYW55JyB0eXBlLlxuaW1wb3J0IEJlemllckVhc2luZyBmcm9tICdiZXppZXItZWFzaW5nJztcblxuLy8gRWFzaW5nIGZ1bmN0aW9ucyBhZGFwdGVkIGZyb20gVGhvbWFzIEZ1Y2hzICYgSmVyZW15IEthaG5cbi8vIEVhc2luZyBFcXVhdGlvbnMgKGMpIDIwMDMgUm9iZXJ0IFBlbm5lciwgQlNEIGxpY2Vuc2Vcbi8vIGh0dHBzOi8vcmF3LmdpdGh1Yi5jb20vZGFucm8vZWFzaW5nLWpzL21hc3Rlci9MSUNFTlNFXG5cbmNvbnN0IG1hZ2ljU3dpbmcgPSAxLjcwMTU4O1xuXG50eXBlIEVhc2luZ0Z1bmN0aW9uID0gKGFyZzE6IG51bWJlcikgPT4gbnVtYmVyO1xuXG5leHBvcnQgY29uc3QgZWFzZTogRWFzaW5nRnVuY3Rpb24gPSBCZXppZXJFYXNpbmcoMC4yNSwgMC4xLCAwLjI1LCAxLjApO1xuZXhwb3J0IGNvbnN0IGVhc2VJbjogRWFzaW5nRnVuY3Rpb24gPSBCZXppZXJFYXNpbmcoMC40MiwgMC4wLCAxLjAsIDEuMCk7XG5leHBvcnQgY29uc3QgZWFzZU91dDogRWFzaW5nRnVuY3Rpb24gPSBCZXppZXJFYXNpbmcoMC4wLCAwLjAsIDAuNTgsIDEuMCk7XG5leHBvcnQgY29uc3QgZWFzZUluT3V0OiBFYXNpbmdGdW5jdGlvbiA9IEJlemllckVhc2luZygwLjQyLCAwLjAsIDAuNTgsIDEuMCk7XG5cbmV4cG9ydCBmdW5jdGlvbiBpblF1YWQocG9zOiBudW1iZXIpOiBudW1iZXIge1xuICByZXR1cm4gTWF0aC5wb3cocG9zLCAyKTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIG91dFF1YWQocG9zOiBudW1iZXIpOiBudW1iZXIge1xuICByZXR1cm4gLShNYXRoLnBvdyhwb3MgLSAxLCAyKSAtIDEpO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gaW5PdXRRdWFkKHBvczogbnVtYmVyKTogbnVtYmVyIHtcbiAgaWYgKChwb3MgLz0gMC41KSA8IDEpIHtcbiAgICByZXR1cm4gMC41ICogTWF0aC5wb3cocG9zLCAyKTtcbiAgfVxuICByZXR1cm4gLTAuNSAqICgocG9zIC09IDIpICogcG9zIC0gMik7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBpbkN1YmljKHBvczogbnVtYmVyKTogbnVtYmVyIHtcbiAgcmV0dXJuIE1hdGgucG93KHBvcywgMyk7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBvdXRDdWJpYyhwb3M6IG51bWJlcik6IG51bWJlciB7XG4gIHJldHVybiBNYXRoLnBvdyhwb3MgLSAxLCAzKSArIDE7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBpbk91dEN1YmljKHBvczogbnVtYmVyKTogbnVtYmVyIHtcbiAgaWYgKChwb3MgLz0gMC41KSA8IDEpIHtcbiAgICByZXR1cm4gMC41ICogTWF0aC5wb3cocG9zLCAzKTtcbiAgfVxuICByZXR1cm4gMC41ICogKE1hdGgucG93KHBvcyAtIDIsIDMpICsgMik7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBpblF1YXJ0KHBvczogbnVtYmVyKTogbnVtYmVyIHtcbiAgcmV0dXJuIE1hdGgucG93KHBvcywgNCk7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBvdXRRdWFydChwb3M6IG51bWJlcik6IG51bWJlciB7XG4gIHJldHVybiAtKE1hdGgucG93KHBvcyAtIDEsIDQpIC0gMSk7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBpbk91dFF1YXJ0KHBvczogbnVtYmVyKTogbnVtYmVyIHtcbiAgaWYgKChwb3MgLz0gMC41KSA8IDEpIHtcbiAgICByZXR1cm4gMC41ICogTWF0aC5wb3cocG9zLCA0KTtcbiAgfVxuICByZXR1cm4gLTAuNSAqICgocG9zIC09IDIpICogTWF0aC5wb3cocG9zLCAzKSAtIDIpO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gaW5RdWludChwb3M6IG51bWJlcik6IG51bWJlciB7XG4gIHJldHVybiBNYXRoLnBvdyhwb3MsIDUpO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gb3V0UXVpbnQocG9zOiBudW1iZXIpOiBudW1iZXIge1xuICByZXR1cm4gTWF0aC5wb3cocG9zIC0gMSwgNSkgKyAxO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gaW5PdXRRdWludChwb3M6IG51bWJlcik6IG51bWJlciB7XG4gIGlmICgocG9zIC89IDAuNSkgPCAxKSB7XG4gICAgcmV0dXJuIDAuNSAqIE1hdGgucG93KHBvcywgNSk7XG4gIH1cbiAgcmV0dXJuIDAuNSAqIChNYXRoLnBvdyhwb3MgLSAyLCA1KSArIDIpO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gaW5TaW5lKHBvczogbnVtYmVyKTogbnVtYmVyIHtcbiAgcmV0dXJuIC1NYXRoLmNvcyhwb3MgKiAoTWF0aC5QSSAvIDIpKSArIDE7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBvdXRTaW5lKHBvczogbnVtYmVyKTogbnVtYmVyIHtcbiAgcmV0dXJuIE1hdGguc2luKHBvcyAqIChNYXRoLlBJIC8gMikpO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gaW5PdXRTaW5lKHBvczogbnVtYmVyKTogbnVtYmVyIHtcbiAgcmV0dXJuIC0wLjUgKiAoTWF0aC5jb3MoTWF0aC5QSSAqIHBvcykgLSAxKTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGluRXhwbyhwb3M6IG51bWJlcik6IG51bWJlciB7XG4gIHJldHVybiBwb3MgPT09IDAgPyAwIDogTWF0aC5wb3coMiwgMTAgKiAocG9zIC0gMSkpO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gb3V0RXhwbyhwb3M6IG51bWJlcik6IG51bWJlciB7XG4gIHJldHVybiBwb3MgPT09IDEgPyAxIDogLU1hdGgucG93KDIsIC0xMCAqIHBvcykgKyAxO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gaW5PdXRFeHBvKHBvczogbnVtYmVyKTogbnVtYmVyIHtcbiAgaWYgKHBvcyA9PT0gMCkge1xuICAgIHJldHVybiAwO1xuICB9XG4gIGlmIChwb3MgPT09IDEpIHtcbiAgICByZXR1cm4gMTtcbiAgfVxuICBpZiAoKHBvcyAvPSAwLjUpIDwgMSkge1xuICAgIHJldHVybiAwLjUgKiBNYXRoLnBvdygyLCAxMCAqIChwb3MgLSAxKSk7XG4gIH1cbiAgcmV0dXJuIDAuNSAqICgtTWF0aC5wb3coMiwgLTEwICogLS1wb3MpICsgMik7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBpbkNpcmMocG9zOiBudW1iZXIpOiBudW1iZXIge1xuICByZXR1cm4gLShNYXRoLnNxcnQoMSAtIHBvcyAqIHBvcykgLSAxKTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIG91dENpcmMocG9zOiBudW1iZXIpOiBudW1iZXIge1xuICByZXR1cm4gTWF0aC5zcXJ0KDEgLSBNYXRoLnBvdyhwb3MgLSAxLCAyKSk7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBpbk91dENpcmMocG9zOiBudW1iZXIpOiBudW1iZXIge1xuICBpZiAoKHBvcyAvPSAwLjUpIDwgMSkge1xuICAgIHJldHVybiAtMC41ICogKE1hdGguc3FydCgxIC0gcG9zICogcG9zKSAtIDEpO1xuICB9XG4gIHJldHVybiAwLjUgKiAoTWF0aC5zcXJ0KDEgLSAocG9zIC09IDIpICogcG9zKSArIDEpO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gb3V0Qm91bmNlKHBvczogbnVtYmVyKTogbnVtYmVyIHtcbiAgaWYgKHBvcyA8IDEgLyAyLjc1KSB7XG4gICAgcmV0dXJuIDcuNTYyNSAqIHBvcyAqIHBvcztcbiAgfSBlbHNlIGlmIChwb3MgPCAyIC8gMi43NSkge1xuICAgIHJldHVybiA3LjU2MjUgKiAocG9zIC09IDEuNSAvIDIuNzUpICogcG9zICsgMC43NTtcbiAgfSBlbHNlIGlmIChwb3MgPCAyLjUgLyAyLjc1KSB7XG4gICAgcmV0dXJuIDcuNTYyNSAqIChwb3MgLT0gMi4yNSAvIDIuNzUpICogcG9zICsgMC45Mzc1O1xuICB9IGVsc2Uge1xuICAgIHJldHVybiA3LjU2MjUgKiAocG9zIC09IDIuNjI1IC8gMi43NSkgKiBwb3MgKyAwLjk4NDM3NTtcbiAgfVxufVxuXG5leHBvcnQgZnVuY3Rpb24gaW5CYWNrKHBvczogbnVtYmVyKTogbnVtYmVyIHtcbiAgY29uc3QgcyA9IG1hZ2ljU3dpbmc7XG4gIHJldHVybiBwb3MgKiBwb3MgKiAoKHMgKyAxKSAqIHBvcyAtIHMpO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gb3V0QmFjayhwb3M6IG51bWJlcik6IG51bWJlciB7XG4gIGNvbnN0IHMgPSBtYWdpY1N3aW5nO1xuICByZXR1cm4gKHBvcyAtPSAxKSAqIHBvcyAqICgocyArIDEpICogcG9zICsgcykgKyAxO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gaW5PdXRCYWNrKHBvczogbnVtYmVyKTogbnVtYmVyIHtcbiAgbGV0IHMgPSBtYWdpY1N3aW5nO1xuICBpZiAoKHBvcyAvPSAwLjUpIDwgMSkge1xuICAgIHJldHVybiAwLjUgKiAocG9zICogcG9zICogKCgocyAqPSAxLjUyNSkgKyAxKSAqIHBvcyAtIHMpKTtcbiAgfVxuICByZXR1cm4gMC41ICogKChwb3MgLT0gMikgKiBwb3MgKiAoKChzICo9IDEuNTI1KSArIDEpICogcG9zICsgcykgKyAyKTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGluRWxhc3RpYyhwb3M6IG51bWJlcik6IG51bWJlciB7XG4gIGxldCBzID0gbWFnaWNTd2luZztcbiAgbGV0IHAgPSAwO1xuICBsZXQgYSA9IDE7XG4gIGlmIChwb3MgPT09IDApIHtcbiAgICByZXR1cm4gMDtcbiAgfVxuICBpZiAocG9zID09PSAxKSB7XG4gICAgcmV0dXJuIDE7XG4gIH1cbiAgaWYgKCFwKSB7XG4gICAgcCA9IDAuMztcbiAgfVxuICBpZiAoYSA8IDEpIHtcbiAgICBhID0gMTtcbiAgICBzID0gcCAvIDQ7XG4gIH0gZWxzZSB7XG4gICAgcyA9IChwIC8gKDIgKiBNYXRoLlBJKSkgKiBNYXRoLmFzaW4oMSAvIGEpO1xuICB9XG4gIHJldHVybiAtKFxuICAgIGEgKlxuICAgIE1hdGgucG93KDIsIDEwICogKHBvcyAtPSAxKSkgKlxuICAgIE1hdGguc2luKCgocG9zIC0gcykgKiAoMiAqIE1hdGguUEkpKSAvIHApXG4gICk7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBvdXRFbGFzdGljKHBvczogbnVtYmVyKTogbnVtYmVyIHtcbiAgbGV0IHMgPSBtYWdpY1N3aW5nO1xuICBsZXQgcCA9IDA7XG4gIGxldCBhID0gMTtcbiAgaWYgKHBvcyA9PT0gMCkge1xuICAgIHJldHVybiAwO1xuICB9XG4gIGlmIChwb3MgPT09IDEpIHtcbiAgICByZXR1cm4gMTtcbiAgfVxuICBpZiAoIXApIHtcbiAgICBwID0gMC4zO1xuICB9XG4gIGlmIChhIDwgMSkge1xuICAgIGEgPSAxO1xuICAgIHMgPSBwIC8gNDtcbiAgfSBlbHNlIHtcbiAgICBzID0gKHAgLyAoMiAqIE1hdGguUEkpKSAqIE1hdGguYXNpbigxIC8gYSk7XG4gIH1cbiAgcmV0dXJuIChcbiAgICBhICogTWF0aC5wb3coMiwgLTEwICogcG9zKSAqIE1hdGguc2luKCgocG9zIC0gcykgKiAoMiAqIE1hdGguUEkpKSAvIHApICsgMVxuICApO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gaW5PdXRFbGFzdGljKHBvczogbnVtYmVyKTogbnVtYmVyIHtcbiAgbGV0IHMgPSBtYWdpY1N3aW5nO1xuICBsZXQgcCA9IDA7XG4gIGxldCBhID0gMTtcbiAgaWYgKHBvcyA9PT0gMCkge1xuICAgIHJldHVybiAwO1xuICB9XG4gIGlmICgocG9zIC89IDEgLyAyKSA9PT0gMikge1xuICAgIHJldHVybiAxO1xuICB9XG4gIGlmICghcCkge1xuICAgIHAgPSAwLjMgKiAxLjU7XG4gIH1cbiAgaWYgKGEgPCAxKSB7XG4gICAgYSA9IDE7XG4gICAgcyA9IHAgLyA0O1xuICB9IGVsc2Uge1xuICAgIHMgPSAocCAvICgyICogTWF0aC5QSSkpICogTWF0aC5hc2luKDEgLyBhKTtcbiAgfVxuICBpZiAocG9zIDwgMSkge1xuICAgIHJldHVybiAoXG4gICAgICAtMC41ICpcbiAgICAgIChhICpcbiAgICAgICAgTWF0aC5wb3coMiwgMTAgKiAocG9zIC09IDEpKSAqXG4gICAgICAgIE1hdGguc2luKCgocG9zIC0gcykgKiAoMiAqIE1hdGguUEkpKSAvIHApKVxuICAgICk7XG4gIH1cbiAgcmV0dXJuIChcbiAgICBhICpcbiAgICAgIE1hdGgucG93KDIsIC0xMCAqIChwb3MgLT0gMSkpICpcbiAgICAgIE1hdGguc2luKCgocG9zIC0gcykgKiAoMiAqIE1hdGguUEkpKSAvIHApICpcbiAgICAgIDAuNSArXG4gICAgMVxuICApO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gc3dpbmdGcm9tVG8ocG9zOiBudW1iZXIpOiBudW1iZXIge1xuICBsZXQgcyA9IG1hZ2ljU3dpbmc7XG4gIHJldHVybiAocG9zIC89IDAuNSkgPCAxXG4gICAgPyAwLjUgKiAocG9zICogcG9zICogKCgocyAqPSAxLjUyNSkgKyAxKSAqIHBvcyAtIHMpKVxuICAgIDogMC41ICogKChwb3MgLT0gMikgKiBwb3MgKiAoKChzICo9IDEuNTI1KSArIDEpICogcG9zICsgcykgKyAyKTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIHN3aW5nRnJvbShwb3M6IG51bWJlcik6IG51bWJlciB7XG4gIGNvbnN0IHMgPSBtYWdpY1N3aW5nO1xuICByZXR1cm4gcG9zICogcG9zICogKChzICsgMSkgKiBwb3MgLSBzKTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIHN3aW5nVG8ocG9zOiBudW1iZXIpOiBudW1iZXIge1xuICBjb25zdCBzID0gbWFnaWNTd2luZztcbiAgcmV0dXJuIChwb3MgLT0gMSkgKiBwb3MgKiAoKHMgKyAxKSAqIHBvcyArIHMpICsgMTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGJvdW5jZShwb3M6IG51bWJlcik6IG51bWJlciB7XG4gIGlmIChwb3MgPCAxIC8gMi43NSkge1xuICAgIHJldHVybiA3LjU2MjUgKiBwb3MgKiBwb3M7XG4gIH0gZWxzZSBpZiAocG9zIDwgMiAvIDIuNzUpIHtcbiAgICByZXR1cm4gNy41NjI1ICogKHBvcyAtPSAxLjUgLyAyLjc1KSAqIHBvcyArIDAuNzU7XG4gIH0gZWxzZSBpZiAocG9zIDwgMi41IC8gMi43NSkge1xuICAgIHJldHVybiA3LjU2MjUgKiAocG9zIC09IDIuMjUgLyAyLjc1KSAqIHBvcyArIDAuOTM3NTtcbiAgfSBlbHNlIHtcbiAgICByZXR1cm4gNy41NjI1ICogKHBvcyAtPSAyLjYyNSAvIDIuNzUpICogcG9zICsgMC45ODQzNzU7XG4gIH1cbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGJvdW5jZVBhc3QocG9zOiBudW1iZXIpOiBudW1iZXIge1xuICBpZiAocG9zIDwgMSAvIDIuNzUpIHtcbiAgICByZXR1cm4gNy41NjI1ICogcG9zICogcG9zO1xuICB9IGVsc2UgaWYgKHBvcyA8IDIgLyAyLjc1KSB7XG4gICAgcmV0dXJuIDIgLSAoNy41NjI1ICogKHBvcyAtPSAxLjUgLyAyLjc1KSAqIHBvcyArIDAuNzUpO1xuICB9IGVsc2UgaWYgKHBvcyA8IDIuNSAvIDIuNzUpIHtcbiAgICByZXR1cm4gMiAtICg3LjU2MjUgKiAocG9zIC09IDIuMjUgLyAyLjc1KSAqIHBvcyArIDAuOTM3NSk7XG4gIH0gZWxzZSB7XG4gICAgcmV0dXJuIDIgLSAoNy41NjI1ICogKHBvcyAtPSAyLjYyNSAvIDIuNzUpICogcG9zICsgMC45ODQzNzUpO1xuICB9XG59XG4iXSwibmFtZXMiOlsiYm91bmNlIiwiYm91bmNlUGFzdCIsImVhc2UiLCJlYXNlSW4iLCJlYXNlSW5PdXQiLCJlYXNlT3V0IiwiaW5CYWNrIiwiaW5DaXJjIiwiaW5DdWJpYyIsImluRWxhc3RpYyIsImluRXhwbyIsImluT3V0QmFjayIsImluT3V0Q2lyYyIsImluT3V0Q3ViaWMiLCJpbk91dEVsYXN0aWMiLCJpbk91dEV4cG8iLCJpbk91dFF1YWQiLCJpbk91dFF1YXJ0IiwiaW5PdXRRdWludCIsImluT3V0U2luZSIsImluUXVhZCIsImluUXVhcnQiLCJpblF1aW50IiwiaW5TaW5lIiwib3V0QmFjayIsIm91dEJvdW5jZSIsIm91dENpcmMiLCJvdXRDdWJpYyIsIm91dEVsYXN0aWMiLCJvdXRFeHBvIiwib3V0UXVhZCIsIm91dFF1YXJ0Iiwib3V0UXVpbnQiLCJvdXRTaW5lIiwic3dpbmdGcm9tIiwic3dpbmdGcm9tVG8iLCJzd2luZ1RvIiwibWFnaWNTd2luZyIsIkJlemllckVhc2luZyIsInBvcyIsIk1hdGgiLCJwb3ciLCJjb3MiLCJQSSIsInNpbiIsInNxcnQiLCJzIiwicCIsImEiLCJhc2luIl0sIm1hcHBpbmdzIjoiQUFBQSxvUEFBb1A7Ozs7Ozs7Ozs7OztJQWlRcE9BLE1BQU07ZUFBTkE7O0lBWUFDLFVBQVU7ZUFBVkE7O0lBbFFIQyxJQUFJO2VBQUpBOztJQUNBQyxNQUFNO2VBQU5BOztJQUVBQyxTQUFTO2VBQVRBOztJQURBQyxPQUFPO2VBQVBBOztJQTJIR0MsTUFBTTtlQUFOQTs7SUEzQkFDLE1BQU07ZUFBTkE7O0lBOUVBQyxPQUFPO2VBQVBBOztJQTJIQUMsU0FBUztlQUFUQTs7SUFsRUFDLE1BQU07ZUFBTkE7O0lBMERBQyxTQUFTO2VBQVRBOztJQTdCQUMsU0FBUztlQUFUQTs7SUE5RUFDLFVBQVU7ZUFBVkE7O0lBcUtBQyxZQUFZO2VBQVpBOztJQTVHQUMsU0FBUztlQUFUQTs7SUF4RUFDLFNBQVM7ZUFBVEE7O0lBOEJBQyxVQUFVO2VBQVZBOztJQWVBQyxVQUFVO2VBQVZBOztJQWVBQyxTQUFTO2VBQVRBOztJQXBFQUMsTUFBTTtlQUFOQTs7SUE4QkFDLE9BQU87ZUFBUEE7O0lBZUFDLE9BQU87ZUFBUEE7O0lBZUFDLE1BQU07ZUFBTkE7O0lBaUVBQyxPQUFPO2VBQVBBOztJQWpCQUMsU0FBUztlQUFUQTs7SUFYQUMsT0FBTztlQUFQQTs7SUE5RUFDLFFBQVE7ZUFBUkE7O0lBaUpBQyxVQUFVO2VBQVZBOztJQXhGQUMsT0FBTztlQUFQQTs7SUF4RUFDLE9BQU87ZUFBUEE7O0lBOEJBQyxRQUFRO2VBQVJBOztJQWVBQyxRQUFRO2VBQVJBOztJQWVBQyxPQUFPO2VBQVBBOztJQXVLQUMsU0FBUztlQUFUQTs7SUFQQUMsV0FBVztlQUFYQTs7SUFZQUMsT0FBTztlQUFQQTs7O3FFQTNQUzs7Ozs7O0FBRXpCLDJEQUEyRDtBQUMzRCx1REFBdUQ7QUFDdkQsd0RBQXdEO0FBRXhELE1BQU1DLGFBQWE7QUFJWixNQUFNbkMsT0FBdUJvQyxJQUFBQSxxQkFBWSxFQUFDLE1BQU0sS0FBSyxNQUFNO0FBQzNELE1BQU1uQyxTQUF5Qm1DLElBQUFBLHFCQUFZLEVBQUMsTUFBTSxLQUFLLEtBQUs7QUFDNUQsTUFBTWpDLFVBQTBCaUMsSUFBQUEscUJBQVksRUFBQyxLQUFLLEtBQUssTUFBTTtBQUM3RCxNQUFNbEMsWUFBNEJrQyxJQUFBQSxxQkFBWSxFQUFDLE1BQU0sS0FBSyxNQUFNO0FBRWhFLFNBQVNsQixPQUFPbUIsR0FBVztJQUNoQyxPQUFPQyxLQUFLQyxHQUFHLENBQUNGLEtBQUs7QUFDdkI7QUFFTyxTQUFTVCxRQUFRUyxHQUFXO0lBQ2pDLE9BQU8sQ0FBRUMsQ0FBQUEsS0FBS0MsR0FBRyxDQUFDRixNQUFNLEdBQUcsS0FBSyxDQUFBO0FBQ2xDO0FBRU8sU0FBU3ZCLFVBQVV1QixHQUFXO0lBQ25DLElBQUksQUFBQ0EsQ0FBQUEsT0FBTyxHQUFFLElBQUssR0FBRztRQUNwQixPQUFPLE1BQU1DLEtBQUtDLEdBQUcsQ0FBQ0YsS0FBSztJQUM3QjtJQUNBLE9BQU8sQ0FBQyxNQUFPLENBQUEsQUFBQ0EsQ0FBQUEsT0FBTyxDQUFBLElBQUtBLE1BQU0sQ0FBQTtBQUNwQztBQUVPLFNBQVMvQixRQUFRK0IsR0FBVztJQUNqQyxPQUFPQyxLQUFLQyxHQUFHLENBQUNGLEtBQUs7QUFDdkI7QUFFTyxTQUFTWixTQUFTWSxHQUFXO0lBQ2xDLE9BQU9DLEtBQUtDLEdBQUcsQ0FBQ0YsTUFBTSxHQUFHLEtBQUs7QUFDaEM7QUFFTyxTQUFTMUIsV0FBVzBCLEdBQVc7SUFDcEMsSUFBSSxBQUFDQSxDQUFBQSxPQUFPLEdBQUUsSUFBSyxHQUFHO1FBQ3BCLE9BQU8sTUFBTUMsS0FBS0MsR0FBRyxDQUFDRixLQUFLO0lBQzdCO0lBQ0EsT0FBTyxNQUFPQyxDQUFBQSxLQUFLQyxHQUFHLENBQUNGLE1BQU0sR0FBRyxLQUFLLENBQUE7QUFDdkM7QUFFTyxTQUFTbEIsUUFBUWtCLEdBQVc7SUFDakMsT0FBT0MsS0FBS0MsR0FBRyxDQUFDRixLQUFLO0FBQ3ZCO0FBRU8sU0FBU1IsU0FBU1EsR0FBVztJQUNsQyxPQUFPLENBQUVDLENBQUFBLEtBQUtDLEdBQUcsQ0FBQ0YsTUFBTSxHQUFHLEtBQUssQ0FBQTtBQUNsQztBQUVPLFNBQVN0QixXQUFXc0IsR0FBVztJQUNwQyxJQUFJLEFBQUNBLENBQUFBLE9BQU8sR0FBRSxJQUFLLEdBQUc7UUFDcEIsT0FBTyxNQUFNQyxLQUFLQyxHQUFHLENBQUNGLEtBQUs7SUFDN0I7SUFDQSxPQUFPLENBQUMsTUFBTyxDQUFBLEFBQUNBLENBQUFBLE9BQU8sQ0FBQSxJQUFLQyxLQUFLQyxHQUFHLENBQUNGLEtBQUssS0FBSyxDQUFBO0FBQ2pEO0FBRU8sU0FBU2pCLFFBQVFpQixHQUFXO0lBQ2pDLE9BQU9DLEtBQUtDLEdBQUcsQ0FBQ0YsS0FBSztBQUN2QjtBQUVPLFNBQVNQLFNBQVNPLEdBQVc7SUFDbEMsT0FBT0MsS0FBS0MsR0FBRyxDQUFDRixNQUFNLEdBQUcsS0FBSztBQUNoQztBQUVPLFNBQVNyQixXQUFXcUIsR0FBVztJQUNwQyxJQUFJLEFBQUNBLENBQUFBLE9BQU8sR0FBRSxJQUFLLEdBQUc7UUFDcEIsT0FBTyxNQUFNQyxLQUFLQyxHQUFHLENBQUNGLEtBQUs7SUFDN0I7SUFDQSxPQUFPLE1BQU9DLENBQUFBLEtBQUtDLEdBQUcsQ0FBQ0YsTUFBTSxHQUFHLEtBQUssQ0FBQTtBQUN2QztBQUVPLFNBQVNoQixPQUFPZ0IsR0FBVztJQUNoQyxPQUFPLENBQUNDLEtBQUtFLEdBQUcsQ0FBQ0gsTUFBT0MsQ0FBQUEsS0FBS0csRUFBRSxHQUFHLENBQUEsS0FBTTtBQUMxQztBQUVPLFNBQVNWLFFBQVFNLEdBQVc7SUFDakMsT0FBT0MsS0FBS0ksR0FBRyxDQUFDTCxNQUFPQyxDQUFBQSxLQUFLRyxFQUFFLEdBQUcsQ0FBQTtBQUNuQztBQUVPLFNBQVN4QixVQUFVb0IsR0FBVztJQUNuQyxPQUFPLENBQUMsTUFBT0MsQ0FBQUEsS0FBS0UsR0FBRyxDQUFDRixLQUFLRyxFQUFFLEdBQUdKLE9BQU8sQ0FBQTtBQUMzQztBQUVPLFNBQVM3QixPQUFPNkIsR0FBVztJQUNoQyxPQUFPQSxRQUFRLElBQUksSUFBSUMsS0FBS0MsR0FBRyxDQUFDLEdBQUcsS0FBTUYsQ0FBQUEsTUFBTSxDQUFBO0FBQ2pEO0FBRU8sU0FBU1YsUUFBUVUsR0FBVztJQUNqQyxPQUFPQSxRQUFRLElBQUksSUFBSSxDQUFDQyxLQUFLQyxHQUFHLENBQUMsR0FBRyxDQUFDLEtBQUtGLE9BQU87QUFDbkQ7QUFFTyxTQUFTeEIsVUFBVXdCLEdBQVc7SUFDbkMsSUFBSUEsUUFBUSxHQUFHO1FBQ2IsT0FBTztJQUNUO0lBQ0EsSUFBSUEsUUFBUSxHQUFHO1FBQ2IsT0FBTztJQUNUO0lBQ0EsSUFBSSxBQUFDQSxDQUFBQSxPQUFPLEdBQUUsSUFBSyxHQUFHO1FBQ3BCLE9BQU8sTUFBTUMsS0FBS0MsR0FBRyxDQUFDLEdBQUcsS0FBTUYsQ0FBQUEsTUFBTSxDQUFBO0lBQ3ZDO0lBQ0EsT0FBTyxNQUFPLENBQUEsQ0FBQ0MsS0FBS0MsR0FBRyxDQUFDLEdBQUcsQ0FBQyxLQUFLLEVBQUVGLE9BQU8sQ0FBQTtBQUM1QztBQUVPLFNBQVNoQyxPQUFPZ0MsR0FBVztJQUNoQyxPQUFPLENBQUVDLENBQUFBLEtBQUtLLElBQUksQ0FBQyxJQUFJTixNQUFNQSxPQUFPLENBQUE7QUFDdEM7QUFFTyxTQUFTYixRQUFRYSxHQUFXO0lBQ2pDLE9BQU9DLEtBQUtLLElBQUksQ0FBQyxJQUFJTCxLQUFLQyxHQUFHLENBQUNGLE1BQU0sR0FBRztBQUN6QztBQUVPLFNBQVMzQixVQUFVMkIsR0FBVztJQUNuQyxJQUFJLEFBQUNBLENBQUFBLE9BQU8sR0FBRSxJQUFLLEdBQUc7UUFDcEIsT0FBTyxDQUFDLE1BQU9DLENBQUFBLEtBQUtLLElBQUksQ0FBQyxJQUFJTixNQUFNQSxPQUFPLENBQUE7SUFDNUM7SUFDQSxPQUFPLE1BQU9DLENBQUFBLEtBQUtLLElBQUksQ0FBQyxJQUFJLEFBQUNOLENBQUFBLE9BQU8sQ0FBQSxJQUFLQSxPQUFPLENBQUE7QUFDbEQ7QUFFTyxTQUFTZCxVQUFVYyxHQUFXO0lBQ25DLElBQUlBLE1BQU0sSUFBSSxNQUFNO1FBQ2xCLE9BQU8sU0FBU0EsTUFBTUE7SUFDeEIsT0FBTyxJQUFJQSxNQUFNLElBQUksTUFBTTtRQUN6QixPQUFPLFNBQVVBLENBQUFBLE9BQU8sTUFBTSxJQUFHLElBQUtBLE1BQU07SUFDOUMsT0FBTyxJQUFJQSxNQUFNLE1BQU0sTUFBTTtRQUMzQixPQUFPLFNBQVVBLENBQUFBLE9BQU8sT0FBTyxJQUFHLElBQUtBLE1BQU07SUFDL0MsT0FBTztRQUNMLE9BQU8sU0FBVUEsQ0FBQUEsT0FBTyxRQUFRLElBQUcsSUFBS0EsTUFBTTtJQUNoRDtBQUNGO0FBRU8sU0FBU2pDLE9BQU9pQyxHQUFXO0lBQ2hDLE1BQU1PLElBQUlUO0lBQ1YsT0FBT0UsTUFBTUEsTUFBTyxDQUFBLEFBQUNPLENBQUFBLElBQUksQ0FBQSxJQUFLUCxNQUFNTyxDQUFBQTtBQUN0QztBQUVPLFNBQVN0QixRQUFRZSxHQUFXO0lBQ2pDLE1BQU1PLElBQUlUO0lBQ1YsT0FBTyxBQUFDRSxDQUFBQSxPQUFPLENBQUEsSUFBS0EsTUFBTyxDQUFBLEFBQUNPLENBQUFBLElBQUksQ0FBQSxJQUFLUCxNQUFNTyxDQUFBQSxJQUFLO0FBQ2xEO0FBRU8sU0FBU25DLFVBQVU0QixHQUFXO0lBQ25DLElBQUlPLElBQUlUO0lBQ1IsSUFBSSxBQUFDRSxDQUFBQSxPQUFPLEdBQUUsSUFBSyxHQUFHO1FBQ3BCLE9BQU8sTUFBT0EsQ0FBQUEsTUFBTUEsTUFBTyxDQUFBLEFBQUMsQ0FBQSxBQUFDTyxDQUFBQSxLQUFLLEtBQUksSUFBSyxDQUFBLElBQUtQLE1BQU1PLENBQUFBLENBQUM7SUFDekQ7SUFDQSxPQUFPLE1BQU8sQ0FBQSxBQUFDUCxDQUFBQSxPQUFPLENBQUEsSUFBS0EsTUFBTyxDQUFBLEFBQUMsQ0FBQSxBQUFDTyxDQUFBQSxLQUFLLEtBQUksSUFBSyxDQUFBLElBQUtQLE1BQU1PLENBQUFBLElBQUssQ0FBQTtBQUNwRTtBQUVPLFNBQVNyQyxVQUFVOEIsR0FBVztJQUNuQyxJQUFJTyxJQUFJVDtJQUNSLElBQUlVLElBQUk7SUFDUixJQUFJQyxJQUFJO0lBQ1IsSUFBSVQsUUFBUSxHQUFHO1FBQ2IsT0FBTztJQUNUO0lBQ0EsSUFBSUEsUUFBUSxHQUFHO1FBQ2IsT0FBTztJQUNUO0lBQ0EsSUFBSSxDQUFDUSxHQUFHO1FBQ05BLElBQUk7SUFDTjtJQUNBLElBQUlDLElBQUksR0FBRztRQUNUQSxJQUFJO1FBQ0pGLElBQUlDLElBQUk7SUFDVixPQUFPO1FBQ0xELElBQUksQUFBQ0MsSUFBSyxDQUFBLElBQUlQLEtBQUtHLEVBQUUsQUFBRCxJQUFNSCxLQUFLUyxJQUFJLENBQUMsSUFBSUQ7SUFDMUM7SUFDQSxPQUFPLENBQ0xBLENBQUFBLElBQ0FSLEtBQUtDLEdBQUcsQ0FBQyxHQUFHLEtBQU1GLENBQUFBLE9BQU8sQ0FBQSxLQUN6QkMsS0FBS0ksR0FBRyxDQUFDLEFBQUVMLENBQUFBLE1BQU1PLENBQUFBLElBQU0sQ0FBQSxJQUFJTixLQUFLRyxFQUFFLEFBQUQsSUFBTUksRUFBQztBQUU1QztBQUVPLFNBQVNuQixXQUFXVyxHQUFXO0lBQ3BDLElBQUlPLElBQUlUO0lBQ1IsSUFBSVUsSUFBSTtJQUNSLElBQUlDLElBQUk7SUFDUixJQUFJVCxRQUFRLEdBQUc7UUFDYixPQUFPO0lBQ1Q7SUFDQSxJQUFJQSxRQUFRLEdBQUc7UUFDYixPQUFPO0lBQ1Q7SUFDQSxJQUFJLENBQUNRLEdBQUc7UUFDTkEsSUFBSTtJQUNOO0lBQ0EsSUFBSUMsSUFBSSxHQUFHO1FBQ1RBLElBQUk7UUFDSkYsSUFBSUMsSUFBSTtJQUNWLE9BQU87UUFDTEQsSUFBSSxBQUFDQyxJQUFLLENBQUEsSUFBSVAsS0FBS0csRUFBRSxBQUFELElBQU1ILEtBQUtTLElBQUksQ0FBQyxJQUFJRDtJQUMxQztJQUNBLE9BQ0VBLElBQUlSLEtBQUtDLEdBQUcsQ0FBQyxHQUFHLENBQUMsS0FBS0YsT0FBT0MsS0FBS0ksR0FBRyxDQUFDLEFBQUVMLENBQUFBLE1BQU1PLENBQUFBLElBQU0sQ0FBQSxJQUFJTixLQUFLRyxFQUFFLEFBQUQsSUFBTUksS0FBSztBQUU3RTtBQUVPLFNBQVNqQyxhQUFheUIsR0FBVztJQUN0QyxJQUFJTyxJQUFJVDtJQUNSLElBQUlVLElBQUk7SUFDUixJQUFJQyxJQUFJO0lBQ1IsSUFBSVQsUUFBUSxHQUFHO1FBQ2IsT0FBTztJQUNUO0lBQ0EsSUFBSSxBQUFDQSxDQUFBQSxPQUFPLElBQUksQ0FBQSxNQUFPLEdBQUc7UUFDeEIsT0FBTztJQUNUO0lBQ0EsSUFBSSxDQUFDUSxHQUFHO1FBQ05BLElBQUksTUFBTTtJQUNaO0lBQ0EsSUFBSUMsSUFBSSxHQUFHO1FBQ1RBLElBQUk7UUFDSkYsSUFBSUMsSUFBSTtJQUNWLE9BQU87UUFDTEQsSUFBSSxBQUFDQyxJQUFLLENBQUEsSUFBSVAsS0FBS0csRUFBRSxBQUFELElBQU1ILEtBQUtTLElBQUksQ0FBQyxJQUFJRDtJQUMxQztJQUNBLElBQUlULE1BQU0sR0FBRztRQUNYLE9BQ0UsQ0FBQyxNQUNBUyxDQUFBQSxJQUNDUixLQUFLQyxHQUFHLENBQUMsR0FBRyxLQUFNRixDQUFBQSxPQUFPLENBQUEsS0FDekJDLEtBQUtJLEdBQUcsQ0FBQyxBQUFFTCxDQUFBQSxNQUFNTyxDQUFBQSxJQUFNLENBQUEsSUFBSU4sS0FBS0csRUFBRSxBQUFELElBQU1JLEVBQUM7SUFFOUM7SUFDQSxPQUNFQyxJQUNFUixLQUFLQyxHQUFHLENBQUMsR0FBRyxDQUFDLEtBQU1GLENBQUFBLE9BQU8sQ0FBQSxLQUMxQkMsS0FBS0ksR0FBRyxDQUFDLEFBQUVMLENBQUFBLE1BQU1PLENBQUFBLElBQU0sQ0FBQSxJQUFJTixLQUFLRyxFQUFFLEFBQUQsSUFBTUksS0FDdkMsTUFDRjtBQUVKO0FBRU8sU0FBU1osWUFBWUksR0FBVztJQUNyQyxJQUFJTyxJQUFJVDtJQUNSLE9BQU8sQUFBQ0UsQ0FBQUEsT0FBTyxHQUFFLElBQUssSUFDbEIsTUFBT0EsQ0FBQUEsTUFBTUEsTUFBTyxDQUFBLEFBQUMsQ0FBQSxBQUFDTyxDQUFBQSxLQUFLLEtBQUksSUFBSyxDQUFBLElBQUtQLE1BQU1PLENBQUFBLENBQUMsSUFDaEQsTUFBTyxDQUFBLEFBQUNQLENBQUFBLE9BQU8sQ0FBQSxJQUFLQSxNQUFPLENBQUEsQUFBQyxDQUFBLEFBQUNPLENBQUFBLEtBQUssS0FBSSxJQUFLLENBQUEsSUFBS1AsTUFBTU8sQ0FBQUEsSUFBSyxDQUFBO0FBQ2pFO0FBRU8sU0FBU1osVUFBVUssR0FBVztJQUNuQyxNQUFNTyxJQUFJVDtJQUNWLE9BQU9FLE1BQU1BLE1BQU8sQ0FBQSxBQUFDTyxDQUFBQSxJQUFJLENBQUEsSUFBS1AsTUFBTU8sQ0FBQUE7QUFDdEM7QUFFTyxTQUFTVixRQUFRRyxHQUFXO0lBQ2pDLE1BQU1PLElBQUlUO0lBQ1YsT0FBTyxBQUFDRSxDQUFBQSxPQUFPLENBQUEsSUFBS0EsTUFBTyxDQUFBLEFBQUNPLENBQUFBLElBQUksQ0FBQSxJQUFLUCxNQUFNTyxDQUFBQSxJQUFLO0FBQ2xEO0FBRU8sU0FBUzlDLE9BQU91QyxHQUFXO0lBQ2hDLElBQUlBLE1BQU0sSUFBSSxNQUFNO1FBQ2xCLE9BQU8sU0FBU0EsTUFBTUE7SUFDeEIsT0FBTyxJQUFJQSxNQUFNLElBQUksTUFBTTtRQUN6QixPQUFPLFNBQVVBLENBQUFBLE9BQU8sTUFBTSxJQUFHLElBQUtBLE1BQU07SUFDOUMsT0FBTyxJQUFJQSxNQUFNLE1BQU0sTUFBTTtRQUMzQixPQUFPLFNBQVVBLENBQUFBLE9BQU8sT0FBTyxJQUFHLElBQUtBLE1BQU07SUFDL0MsT0FBTztRQUNMLE9BQU8sU0FBVUEsQ0FBQUEsT0FBTyxRQUFRLElBQUcsSUFBS0EsTUFBTTtJQUNoRDtBQUNGO0FBRU8sU0FBU3RDLFdBQVdzQyxHQUFXO0lBQ3BDLElBQUlBLE1BQU0sSUFBSSxNQUFNO1FBQ2xCLE9BQU8sU0FBU0EsTUFBTUE7SUFDeEIsT0FBTyxJQUFJQSxNQUFNLElBQUksTUFBTTtRQUN6QixPQUFPLElBQUssQ0FBQSxTQUFVQSxDQUFBQSxPQUFPLE1BQU0sSUFBRyxJQUFLQSxNQUFNLElBQUc7SUFDdEQsT0FBTyxJQUFJQSxNQUFNLE1BQU0sTUFBTTtRQUMzQixPQUFPLElBQUssQ0FBQSxTQUFVQSxDQUFBQSxPQUFPLE9BQU8sSUFBRyxJQUFLQSxNQUFNLE1BQUs7SUFDekQsT0FBTztRQUNMLE9BQU8sSUFBSyxDQUFBLFNBQVVBLENBQUFBLE9BQU8sUUFBUSxJQUFHLElBQUtBLE1BQU0sUUFBTztJQUM1RDtBQUNGIn0=

}),
31799: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    clearPlugin: function() {
        return clearPlugin;
    },
    createPluginInstance: function() {
        return createPluginInstance;
    },
    getPluginConfig: function() {
        return getPluginConfig;
    },
    getPluginDestination: function() {
        return getPluginDestination;
    },
    getPluginDuration: function() {
        return getPluginDuration;
    },
    getPluginOrigin: function() {
        return getPluginOrigin;
    },
    isPluginType: function() {
        return isPluginType;
    },
    renderPlugin: function() {
        return renderPlugin;
    }
});
const _IX2BrowserSupport = __webpack_require__(12662);
const _plugins = __webpack_require__(63690);
function isPluginType(actionTypeId) {
    // @ts-expect-error - TS2345 - Argument of type '"TRANSFORM_MOVE" | "TRANSFORM_SCALE" | "TRANSFORM_ROTATE" | "TRANSFORM_SKEW" | "STYLE_OPACITY" | "STYLE_SIZE" | "STYLE_FILTER" | "STYLE_FONT_VARIATION" | "STYLE_BACKGROUND_COLOR" | ... 12 more ... | "STYLE_BOX_SHADOW"' is not assignable to parameter of type '"PLUGIN_LOTTIE" | "PLUGIN_SPLINE" | "PLUGIN_VARIABLE"'.
    return _plugins.pluginMethodMap.has(actionTypeId);
}
const pluginMethod = (methodName)=>(actionTypeId)=>{
        if (!_IX2BrowserSupport.IS_BROWSER_ENV) {
            // IX2 plugins require browser libs for now
            return ()=>null;
        }
        const plugin = _plugins.pluginMethodMap.get(actionTypeId);
        if (!plugin) {
            throw new Error(`IX2 no plugin configured for: ${actionTypeId}`);
        }
        const method = plugin[methodName];
        if (!method) {
            throw new Error(`IX2 invalid plugin method: ${methodName}`);
        }
        return method;
    };
const getPluginConfig = pluginMethod('getPluginConfig');
const getPluginOrigin = pluginMethod('getPluginOrigin');
const getPluginDuration = pluginMethod('getPluginDuration');
const getPluginDestination = pluginMethod('getPluginDestination');
const createPluginInstance = pluginMethod('createPluginInstance');
const renderPlugin = pluginMethod('renderPlugin');
const clearPlugin = pluginMethod('clearPlugin');

//# sourceMappingURL=data:application/json;base64,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

}),
4124: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/* eslint-env browser */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    cleanupHTMLElement: function() {
        return cleanupHTMLElement;
    },
    clearAllStyles: function() {
        return clearAllStyles;
    },
    clearObjectCache: function() {
        return clearObjectCache;
    },
    getActionListProgress: function() {
        return getActionListProgress;
    },
    getAffectedElements: function() {
        return getAffectedElements;
    },
    getComputedStyle: function() {
        return getComputedStyle;
    },
    getDestinationValues: function() {
        return getDestinationValues;
    },
    getElementId: function() {
        return getElementId;
    },
    getInstanceId: function() {
        return getInstanceId;
    },
    getInstanceOrigin: function() {
        return getInstanceOrigin;
    },
    getItemConfigByKey: function() {
        return getItemConfigByKey;
    },
    getMaxDurationItemIndex: function() {
        return getMaxDurationItemIndex;
    },
    getNamespacedParameterId: function() {
        return getNamespacedParameterId;
    },
    getRenderType: function() {
        return getRenderType;
    },
    getStyleProp: function() {
        return getStyleProp;
    },
    mediaQueriesEqual: function() {
        return mediaQueriesEqual;
    },
    observeStore: function() {
        return observeStore;
    },
    reduceListToGroup: function() {
        return reduceListToGroup;
    },
    reifyState: function() {
        return reifyState;
    },
    renderHTMLElement: function() {
        return renderHTMLElement;
    },
    shallowEqual: function() {
        return _shallowEqual.default;
    },
    shouldAllowMediaQuery: function() {
        return shouldAllowMediaQuery;
    },
    shouldNamespaceEventParameter: function() {
        return shouldNamespaceEventParameter;
    },
    stringifyTarget: function() {
        return stringifyTarget;
    }
});
const _defaultTo = /*#__PURE__*/ _interop_require_default(__webpack_require__(34075));
const _reduce = /*#__PURE__*/ _interop_require_default(__webpack_require__(51455));
const _findLast = /*#__PURE__*/ _interop_require_default(__webpack_require__(45720));
const _timm = __webpack_require__(81185);
const _sharedconstants = __webpack_require__(7087);
const _shallowEqual = /*#__PURE__*/ _interop_require_default(__webpack_require__(57164));
const _IX2EasingUtils = __webpack_require__(73767);
const _normalizeColor = __webpack_require__(40380);
const _IX2VanillaPlugins = __webpack_require__(31799);
const _IX2BrowserSupport = __webpack_require__(12662);
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const { BACKGROUND, TRANSFORM, TRANSLATE_3D, SCALE_3D, ROTATE_X, ROTATE_Y, ROTATE_Z, SKEW, PRESERVE_3D, FLEX, OPACITY, FILTER, FONT_VARIATION_SETTINGS, WIDTH, HEIGHT, BACKGROUND_COLOR, BORDER_COLOR, COLOR, CHILDREN, IMMEDIATE_CHILDREN, SIBLINGS, PARENT, DISPLAY, WILL_CHANGE, AUTO, COMMA_DELIMITER, COLON_DELIMITER, BAR_DELIMITER, RENDER_TRANSFORM, RENDER_GENERAL, RENDER_STYLE, RENDER_PLUGIN } = _sharedconstants.IX2EngineConstants;
const { TRANSFORM_MOVE, TRANSFORM_SCALE, TRANSFORM_ROTATE, TRANSFORM_SKEW, STYLE_OPACITY, STYLE_FILTER, STYLE_FONT_VARIATION, STYLE_SIZE, STYLE_BACKGROUND_COLOR, STYLE_BORDER, STYLE_TEXT_COLOR, GENERAL_DISPLAY, OBJECT_VALUE } = _sharedconstants.ActionTypeConsts;
// @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type.
const trim = (v)=>v.trim();
const colorStyleProps = Object.freeze({
    [STYLE_BACKGROUND_COLOR]: BACKGROUND_COLOR,
    [STYLE_BORDER]: BORDER_COLOR,
    [STYLE_TEXT_COLOR]: COLOR
});
const willChangeProps = Object.freeze({
    [_IX2BrowserSupport.TRANSFORM_PREFIXED]: TRANSFORM,
    [BACKGROUND_COLOR]: BACKGROUND,
    [OPACITY]: OPACITY,
    [FILTER]: FILTER,
    [WIDTH]: WIDTH,
    [HEIGHT]: HEIGHT,
    [FONT_VARIATION_SETTINGS]: FONT_VARIATION_SETTINGS
});
const objectCache = new Map();
function clearObjectCache() {
    objectCache.clear();
}
let instanceCount = 1;
function getInstanceId() {
    return 'i' + instanceCount++;
}
let elementCount = 1;
function getElementId(ixElements, ref) {
    // TODO: optimize element lookup
    for(const key in ixElements){
        const ixEl = ixElements[key];
        if (ixEl && ixEl.ref === ref) {
            return ixEl.id;
        }
    }
    return 'e' + elementCount++;
}
function reifyState({ events, actionLists, site } = {}) {
    const eventTypeMap = (0, _reduce.default)(events, (result, event)=>{
        const { eventTypeId } = event;
        if (!result[eventTypeId]) {
            result[eventTypeId] = {};
        }
        result[eventTypeId][event.id] = event;
        return result;
    }, {});
    let mediaQueries = site && site.mediaQueries;
    let mediaQueryKeys = [];
    if (mediaQueries) {
        mediaQueryKeys = mediaQueries.map((mq)=>mq.key);
    } else {
        mediaQueries = [];
        console.warn(`IX2 missing mediaQueries in site data`);
    }
    return {
        ixData: {
            events,
            actionLists,
            eventTypeMap,
            mediaQueries,
            mediaQueryKeys
        }
    };
}
const strictEqual = (a, b)=>a === b;
function observeStore({ // @ts-expect-error - TS7031 - Binding element 'store' implicitly has an 'any' type.
store, // @ts-expect-error - TS7031 - Binding element 'select' implicitly has an 'any' type.
select, // @ts-expect-error - TS7031 - Binding element 'onChange' implicitly has an 'any' type.
onChange, comparator = strictEqual }) {
    const { getState, subscribe } = store;
    const unsubscribe = subscribe(handleChange);
    let currentState = select(getState());
    function handleChange() {
        const nextState = select(getState());
        if (nextState == null) {
            unsubscribe();
            return;
        }
        if (!comparator(nextState, currentState)) {
            currentState = nextState;
            onChange(currentState, store);
        }
    }
    return unsubscribe;
}
// @ts-expect-error - TS7006 - Parameter 'target' implicitly has an 'any' type.
function normalizeTarget(target) {
    const type = typeof target;
    if (type === 'string') {
        return {
            id: target
        };
    } else if (target != null && type === 'object') {
        const { id, objectId, selector, selectorGuids, appliesTo, useEventTarget } = target;
        return {
            id,
            objectId,
            selector,
            selectorGuids,
            appliesTo,
            useEventTarget
        };
    }
    return {};
}
function getAffectedElements({ config, event, eventTarget, elementRoot, elementApi }) {
    if (!elementApi) {
        throw new Error('IX2 missing elementApi');
    }
    const { targets } = config;
    if (Array.isArray(targets) && targets.length > 0) {
        return targets.reduce((accumulator, target)=>accumulator.concat(getAffectedElements({
                config: {
                    target
                },
                event,
                eventTarget,
                elementRoot,
                elementApi
            })), []);
    }
    const { getValidDocument, getQuerySelector, queryDocument, getChildElements, getSiblingElements, matchSelector, elementContains, isSiblingNode } = elementApi;
    const { target } = config;
    if (!target) {
        return [];
    }
    const { id, objectId, selector, selectorGuids, appliesTo, useEventTarget } = normalizeTarget(target);
    if (objectId) {
        const ref = objectCache.has(objectId) ? objectCache.get(objectId) : objectCache.set(objectId, {}).get(objectId);
        return [
            ref
        ];
    }
    if (appliesTo === _sharedconstants.EventAppliesTo.PAGE) {
        const doc = getValidDocument(id);
        return doc ? [
            doc
        ] : [];
    }
    const overrides = event?.action?.config?.affectedElements ?? {};
    const override = overrides[id || selector] || {};
    const validOverride = Boolean(override.id || override.selector);
    let limitAffectedElements;
    let baseSelector;
    let finalSelector;
    const eventTargetSelector = event && getQuerySelector(normalizeTarget(event.target));
    if (validOverride) {
        limitAffectedElements = override.limitAffectedElements;
        baseSelector = eventTargetSelector;
        finalSelector = getQuerySelector(override);
    } else {
        // pass in selectorGuids as well for server-side rendering.
        baseSelector = finalSelector = getQuerySelector({
            id,
            selector,
            selectorGuids
        });
    }
    if (event && useEventTarget) {
        // eventTarget is not defined when this function is called in a clear request, so find
        // all target elements associated with the event data, and return affected elements.
        const eventTargets = eventTarget && (finalSelector || useEventTarget === true) ? [
            eventTarget
        ] : queryDocument(eventTargetSelector);
        if (finalSelector) {
            if (useEventTarget === PARENT) {
                return queryDocument(finalSelector).filter((parentElement)=>eventTargets.some((targetElement)=>elementContains(parentElement, targetElement)));
            }
            if (useEventTarget === CHILDREN) {
                return queryDocument(finalSelector).filter((childElement)=>eventTargets.some((targetElement)=>elementContains(targetElement, childElement)));
            }
            if (useEventTarget === SIBLINGS) {
                return queryDocument(finalSelector).filter((siblingElement)=>eventTargets.some((targetElement)=>isSiblingNode(targetElement, siblingElement)));
            }
        }
        return eventTargets;
    }
    if (baseSelector == null || finalSelector == null) {
        return [];
    }
    if (_IX2BrowserSupport.IS_BROWSER_ENV && elementRoot) {
        return queryDocument(finalSelector).filter((element)=>elementRoot.contains(element));
    }
    if (limitAffectedElements === CHILDREN) {
        return queryDocument(baseSelector, finalSelector);
    } else if (limitAffectedElements === IMMEDIATE_CHILDREN) {
        return getChildElements(queryDocument(baseSelector)).filter(matchSelector(finalSelector));
    } else if (limitAffectedElements === SIBLINGS) {
        return getSiblingElements(queryDocument(baseSelector)).filter(matchSelector(finalSelector));
    } else {
        return queryDocument(finalSelector);
    }
}
function getComputedStyle({ element, actionItem }) {
    if (!_IX2BrowserSupport.IS_BROWSER_ENV) {
        return {};
    }
    const { actionTypeId } = actionItem;
    switch(actionTypeId){
        case STYLE_SIZE:
        case STYLE_BACKGROUND_COLOR:
        case STYLE_BORDER:
        case STYLE_TEXT_COLOR:
        case GENERAL_DISPLAY:
            return window.getComputedStyle(element);
        default:
            return {};
    }
}
const pxValueRegex = /px/;
// @ts-expect-error - TS7006 - Parameter 'filters' implicitly has an 'any' type.
const getFilterDefaults = (actionState, filters)=>// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'filter' implicitly has an 'any' type.
    filters.reduce((result, filter)=>{
        if (result[filter.type] == null) {
            result[filter.type] = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Readonly<{ blur: 0; 'hue-rotate': 0; invert: 0; grayscale: 0; saturate: 100; sepia: 0; contrast: 100; brightness: 100; }>'.
            filterDefaults[filter.type];
        }
        return result;
    }, actionState || {});
const getFontVariationDefaults = (actionState, fontVariations)=>fontVariations.reduce((result, fontVariation)=>{
        if (result[fontVariation.type] == null) {
            result[fontVariation.type] = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<{ wght: 0; opsz: 0; wdth: 0; slnt: 0; }>'.
            fontVariationDefaults[fontVariation.type] || // @ts-expect-error - TS2339 - Property 'defaultValue' does not exist on type 'FontVariationItemConfigType'.
            fontVariation.defaultValue || 0;
        }
        return result;
    }, actionState || {});
function getInstanceOrigin(element, refState = {}, computedStyle = {}, actionItem, elementApi) {
    const { getStyle } = elementApi;
    // Flow Hack: Passing actionTypeId to isPluginType and then trying
    // to do type refinement using the same variable via a switch statement
    // breaks down. This is is a workaround to ensure we can use type refinement.
    const { actionTypeId } = actionItem;
    if ((0, _IX2VanillaPlugins.isPluginType)(actionTypeId)) {
        // @ts-expect-error - TS2345 - Argument of type '"TRANSFORM_MOVE" | "TRANSFORM_SCALE" | "TRANSFORM_ROTATE" | "TRANSFORM_SKEW" | "STYLE_OPACITY" | "STYLE_SIZE" | "STYLE_FILTER" | "STYLE_FONT_VARIATION" | "STYLE_BACKGROUND_COLOR" | "STYLE_BORDER" | "STYLE_TEXT_COLOR" | "PLUGIN_LOTTIE" | "GENERAL_DISPLAY"' is not assignable to parameter of type 'PluginType'. | TS7053 - Element implicitly has an 'any' type because expression of type '"TRANSFORM_MOVE" | "TRANSFORM_SCALE" | "TRANSFORM_ROTATE" | "TRANSFORM_SKEW" | "STYLE_OPACITY" | "STYLE_SIZE" | "STYLE_FILTER" | "STYLE_FONT_VARIATION" | "STYLE_BACKGROUND_COLOR" | "STYLE_BORDER" | "STYLE_TEXT_COLOR" | "PLUGIN_LOTTIE" | "GENERAL_DISPLAY"' can't be used to index type '{}'.
        return (0, _IX2VanillaPlugins.getPluginOrigin)(actionTypeId)(refState[actionTypeId], actionItem);
    }
    switch(actionItem.actionTypeId){
        case TRANSFORM_MOVE:
        case TRANSFORM_SCALE:
        case TRANSFORM_ROTATE:
        case TRANSFORM_SKEW:
            {
                return(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type '"TRANSFORM_MOVE" | "TRANSFORM_SCALE" | "TRANSFORM_ROTATE" | "TRANSFORM_SKEW"' can't be used to index type '{}'.
                refState[actionItem.actionTypeId] || transformDefaults[actionItem.actionTypeId]);
            }
        case STYLE_FILTER:
            return getFilterDefaults(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type '"STYLE_FILTER"' can't be used to index type '{}'.
            refState[actionItem.actionTypeId], actionItem.config.filters);
        case STYLE_FONT_VARIATION:
            return getFontVariationDefaults(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type '"STYLE_FONT_VARIATION"' can't be used to index type '{}'.
            refState[actionItem.actionTypeId], actionItem.config.fontVariations);
        case STYLE_OPACITY:
            return {
                value: (0, _defaultTo.default)(parseFloat(getStyle(element, OPACITY)), 1.0)
            };
        case STYLE_SIZE:
            {
                const inlineWidth = getStyle(element, WIDTH);
                const inlineHeight = getStyle(element, HEIGHT);
                let widthValue;
                let heightValue;
                // When destination unit is 'AUTO', ensure origin values are in px
                if (actionItem.config.widthUnit === AUTO) {
                    widthValue = pxValueRegex.test(inlineWidth) ? parseFloat(inlineWidth) : parseFloat(computedStyle.width);
                } else {
                    widthValue = (0, _defaultTo.default)(parseFloat(inlineWidth), // @ts-expect-error - TS18047 - 'computedStyle' is possibly 'null'.
                    parseFloat(computedStyle.width));
                }
                if (actionItem.config.heightUnit === AUTO) {
                    heightValue = pxValueRegex.test(inlineHeight) ? parseFloat(inlineHeight) : parseFloat(computedStyle.height);
                } else {
                    heightValue = (0, _defaultTo.default)(parseFloat(inlineHeight), // @ts-expect-error - TS18047 - 'computedStyle' is possibly 'null'.
                    parseFloat(computedStyle.height));
                }
                return {
                    widthValue,
                    heightValue
                };
            }
        case STYLE_BACKGROUND_COLOR:
        case STYLE_BORDER:
        case STYLE_TEXT_COLOR:
            return parseColor({
                element,
                actionTypeId: actionItem.actionTypeId,
                computedStyle,
                getStyle
            });
        case GENERAL_DISPLAY:
            return {
                // @ts-expect-error - TS18047 - 'computedStyle' is possibly 'null'.
                value: (0, _defaultTo.default)(getStyle(element, DISPLAY), computedStyle.display)
            };
        // @ts-expect-error - `OBJECT_VALUE` is not an expected `actionTypeId`
        case OBJECT_VALUE:
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{}'. | TS2339 - Property 'actionTypeId' does not exist on type 'never'.
            return refState[actionItem.actionTypeId] || {
                value: 0
            };
        default:
            {
                // As far as the type system can tell, we're missing a handler for
                // PLUGIN_LOTTIE.
                //
                // This is actually handled by `isPluginType` above.
                //
                /*:: (actionItem: empty); */ return;
            }
    }
}
// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'filter' implicitly has an 'any' type.
const reduceFilters = (result, filter)=>{
    if (filter) {
        result[filter.type] = filter.value || 0;
    }
    return result;
};
const reduceFontVariations = (result, fontVariation)=>{
    if (fontVariation) {
        result[fontVariation.type] = fontVariation.value || 0;
    }
    return result;
};
const getItemConfigByKey = (actionTypeId, key, config)=>{
    if ((0, _IX2VanillaPlugins.isPluginType)(actionTypeId)) {
        return (0, _IX2VanillaPlugins.getPluginConfig)(actionTypeId)(config, key);
    }
    switch(actionTypeId){
        case STYLE_FILTER:
            {
                const filter = (0, _findLast.default)(config.filters, ({ type })=>type === key);
                return filter ? filter.value : 0;
            }
        case STYLE_FONT_VARIATION:
            {
                const fontVariation = (0, _findLast.default)(config.fontVariations, ({ type })=>type === key);
                return fontVariation ? fontVariation.value : 0;
            }
        default:
            return config[key];
    }
};
function getDestinationValues({ element, actionItem, elementApi }) {
    if ((0, _IX2VanillaPlugins.isPluginType)(actionItem.actionTypeId)) {
        // @ts-expect-error - TS2345 - Argument of type '"TRANSFORM_MOVE" | "TRANSFORM_SCALE" | "TRANSFORM_ROTATE" | "TRANSFORM_SKEW" | "STYLE_OPACITY" | "STYLE_SIZE" | "STYLE_FILTER" | "STYLE_FONT_VARIATION" | "STYLE_BACKGROUND_COLOR" | "STYLE_BORDER" | "STYLE_TEXT_COLOR" | "PLUGIN_LOTTIE" | "GENERAL_DISPLAY"' is not assignable to parameter of type 'PluginType'.
        return (0, _IX2VanillaPlugins.getPluginDestination)(actionItem.actionTypeId)(actionItem.config);
    }
    switch(actionItem.actionTypeId){
        case TRANSFORM_MOVE:
        case TRANSFORM_SCALE:
        case TRANSFORM_ROTATE:
        case TRANSFORM_SKEW:
            {
                const { xValue, yValue, zValue } = actionItem.config;
                return {
                    xValue,
                    yValue,
                    zValue
                };
            }
        case STYLE_SIZE:
            {
                const { getStyle, setStyle, getProperty } = elementApi;
                const { widthUnit, heightUnit } = actionItem.config;
                let { widthValue, heightValue } = actionItem.config;
                if (!_IX2BrowserSupport.IS_BROWSER_ENV) {
                    return {
                        widthValue,
                        heightValue
                    };
                }
                if (widthUnit === AUTO) {
                    const temp = getStyle(element, WIDTH);
                    setStyle(element, WIDTH, '');
                    // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'number | undefined'.
                    widthValue = getProperty(element, 'offsetWidth');
                    setStyle(element, WIDTH, temp);
                }
                if (heightUnit === AUTO) {
                    const temp = getStyle(element, HEIGHT);
                    setStyle(element, HEIGHT, '');
                    // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'number | undefined'.
                    heightValue = getProperty(element, 'offsetHeight');
                    setStyle(element, HEIGHT, temp);
                }
                return {
                    widthValue,
                    heightValue
                };
            }
        case STYLE_BACKGROUND_COLOR:
        case STYLE_BORDER:
        case STYLE_TEXT_COLOR:
            {
                const { rValue, gValue, bValue, aValue, globalSwatchId } = actionItem.config;
                if (globalSwatchId && globalSwatchId.startsWith('--')) {
                    const { getStyle } = elementApi;
                    const value = getStyle(element, globalSwatchId);
                    const normalizedValue = (0, _normalizeColor.normalizeColor)(value);
                    return {
                        rValue: normalizedValue.red,
                        gValue: normalizedValue.green,
                        bValue: normalizedValue.blue,
                        aValue: normalizedValue.alpha
                    };
                }
                return {
                    rValue,
                    gValue,
                    bValue,
                    aValue
                };
            }
        case STYLE_FILTER:
            {
                return actionItem.config.filters.reduce(reduceFilters, {});
            }
        case STYLE_FONT_VARIATION:
            {
                return actionItem.config.fontVariations.reduce(reduceFontVariations, {});
            }
        default:
            {
                const { value } = actionItem.config;
                return {
                    value
                };
            }
    }
}
function getRenderType(actionTypeId) {
    if (/^TRANSFORM_/.test(actionTypeId)) {
        return RENDER_TRANSFORM;
    }
    if (/^STYLE_/.test(actionTypeId)) {
        return RENDER_STYLE;
    }
    if (/^GENERAL_/.test(actionTypeId)) {
        return RENDER_GENERAL;
    }
    if (/^PLUGIN_/.test(actionTypeId)) {
        return RENDER_PLUGIN;
    }
}
function getStyleProp(renderType, actionTypeId) {
    return renderType === RENDER_STYLE ? actionTypeId.replace('STYLE_', '').toLowerCase() : null;
}
function renderHTMLElement(element, refState, actionState, eventId, actionItem, styleProp, elementApi, renderType, pluginInstance) {
    switch(renderType){
        case RENDER_TRANSFORM:
            {
                return renderTransform(element, refState, actionState, actionItem, elementApi);
            }
        case RENDER_STYLE:
            {
                return renderStyle(element, refState, actionState, actionItem, styleProp, elementApi);
            }
        case RENDER_GENERAL:
            {
                return renderGeneral(element, actionItem, elementApi);
            }
        case RENDER_PLUGIN:
            {
                const { actionTypeId } = actionItem;
                if ((0, _IX2VanillaPlugins.isPluginType)(actionTypeId)) {
                    return (0, _IX2VanillaPlugins.renderPlugin)(actionTypeId)(pluginInstance, refState, actionItem);
                }
            }
    }
}
const transformDefaults = {
    [TRANSFORM_MOVE]: Object.freeze({
        xValue: 0,
        yValue: 0,
        zValue: 0
    }),
    [TRANSFORM_SCALE]: Object.freeze({
        xValue: 1,
        yValue: 1,
        zValue: 1
    }),
    [TRANSFORM_ROTATE]: Object.freeze({
        xValue: 0,
        yValue: 0,
        zValue: 0
    }),
    [TRANSFORM_SKEW]: Object.freeze({
        xValue: 0,
        yValue: 0
    })
};
const filterDefaults = Object.freeze({
    blur: 0,
    'hue-rotate': 0,
    invert: 0,
    grayscale: 0,
    saturate: 100,
    sepia: 0,
    contrast: 100,
    brightness: 100
});
const fontVariationDefaults = Object.freeze({
    wght: 0,
    opsz: 0,
    wdth: 0,
    slnt: 0
});
// @ts-expect-error - TS7006 - Parameter 'filterType' implicitly has an 'any' type. | TS7006 - Parameter 'actionItemConfig' implicitly has an 'any' type.
const getFilterUnit = (filterType, actionItemConfig)=>{
    const filter = (0, _findLast.default)(actionItemConfig.filters, ({ type })=>type === filterType);
    if (filter && filter.unit) {
        return filter.unit;
    }
    switch(filterType){
        case 'blur':
            return 'px';
        case 'hue-rotate':
            return 'deg';
        default:
            return '%';
    }
};
const transformKeys = Object.keys(transformDefaults);
function renderTransform(element, refState, actionState, actionItem, elementApi) {
    const newTransform = transformKeys.map((actionTypeId)=>{
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly TRANSFORM_MOVE: Readonly<{ xValue: 0; yValue: 0; zValue: 0; }>; readonly TRANSFORM_SCALE: Readonly<{ xValue: 1; yValue: 1; zValue: 1; }>; readonly TRANSFORM_ROTATE: Readonly<{ xValue: 0; yValue: 0; zValue: 0; }>; readonly TRANSFORM_SKEW: Readonly<...>; }'.
        const defaults = transformDefaults[actionTypeId];
        const { xValue = defaults.xValue, yValue = defaults.yValue, zValue = defaults.zValue, xUnit = '', yUnit = '', zUnit = '' } = refState[actionTypeId] || {};
        switch(actionTypeId){
            case TRANSFORM_MOVE:
                return `${TRANSLATE_3D}(${xValue}${xUnit}, ${yValue}${yUnit}, ${zValue}${zUnit})`;
            case TRANSFORM_SCALE:
                return `${SCALE_3D}(${xValue}${xUnit}, ${yValue}${yUnit}, ${zValue}${zUnit})`;
            case TRANSFORM_ROTATE:
                return `${ROTATE_X}(${xValue}${xUnit}) ${ROTATE_Y}(${yValue}${yUnit}) ${ROTATE_Z}(${zValue}${zUnit})`;
            case TRANSFORM_SKEW:
                return `${SKEW}(${xValue}${xUnit}, ${yValue}${yUnit})`;
            default:
                return '';
        }
    }).join(' ');
    const { setStyle } = elementApi;
    addWillChange(element, _IX2BrowserSupport.TRANSFORM_PREFIXED, elementApi);
    setStyle(element, _IX2BrowserSupport.TRANSFORM_PREFIXED, newTransform);
    // Set transform-style: preserve-3d
    if (hasDefined3dTransform(actionItem, actionState)) {
        setStyle(element, _IX2BrowserSupport.TRANSFORM_STYLE_PREFIXED, PRESERVE_3D);
    }
}
function renderFilter(element, actionState, // @ts-expect-error - TS7006 - Parameter 'actionItemConfig' implicitly has an 'any' type.
actionItemConfig, elementApi) {
    const filterValue = (0, _reduce.default)(actionState, (result, value, type)=>`${result} ${type}(${value}${getFilterUnit(type, actionItemConfig)})`, '');
    const { setStyle } = elementApi;
    addWillChange(element, FILTER, elementApi);
    setStyle(element, FILTER, filterValue);
}
function renderFontVariation(element, actionState, actionItemConfig, elementApi) {
    const fontVariationValue = (0, _reduce.default)(actionState, (result, value, type)=>{
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        result.push(`"${type}" ${value}`);
        return result;
    }, []).join(', ');
    const { setStyle } = elementApi;
    addWillChange(element, FONT_VARIATION_SETTINGS, elementApi);
    setStyle(element, FONT_VARIATION_SETTINGS, fontVariationValue);
}
// @ts-expect-error - TS7031 - Binding element 'actionTypeId' implicitly has an 'any' type. | TS7031 - Binding element 'xValue' implicitly has an 'any' type. | TS7031 - Binding element 'yValue' implicitly has an 'any' type. | TS7031 - Binding element 'zValue' implicitly has an 'any' type.
function hasDefined3dTransform({ actionTypeId }, { xValue, yValue, zValue }) {
    // TRANSLATE_Z
    return actionTypeId === TRANSFORM_MOVE && zValue !== undefined || // SCALE_Z
    actionTypeId === TRANSFORM_SCALE && zValue !== undefined || // ROTATE_X or ROTATE_Y
    actionTypeId === TRANSFORM_ROTATE && (xValue !== undefined || yValue !== undefined);
}
const paramCapture = '\\(([^)]+)\\)';
const rgbValidRegex = /^rgb/;
const rgbMatchRegex = RegExp(`rgba?${paramCapture}`);
function getFirstMatch(regex, value) {
    const match = regex.exec(value);
    return match ? match[1] : '';
}
// @ts-expect-error - TS7031 - Binding element 'element' implicitly has an 'any' type. | TS7031 - Binding element 'actionTypeId' implicitly has an 'any' type. | TS7031 - Binding element 'computedStyle' implicitly has an 'any' type. | TS7031 - Binding element 'getStyle' implicitly has an 'any' type.
function parseColor({ element, actionTypeId, computedStyle, getStyle }) {
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Readonly<{ STYLE_BACKGROUND_COLOR: "backgroundColor"; STYLE_BORDER: "borderColor"; STYLE_TEXT_COLOR: "color"; }>'.
    const prop = colorStyleProps[actionTypeId];
    const inlineValue = getStyle(element, prop);
    const value = rgbValidRegex.test(inlineValue) ? inlineValue : computedStyle[prop];
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    const matches = getFirstMatch(rgbMatchRegex, value).split(COMMA_DELIMITER);
    return {
        // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        rValue: (0, _defaultTo.default)(parseInt(matches[0], 10), 255),
        // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        gValue: (0, _defaultTo.default)(parseInt(matches[1], 10), 255),
        // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        bValue: (0, _defaultTo.default)(parseInt(matches[2], 10), 255),
        // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        aValue: (0, _defaultTo.default)(parseFloat(matches[3]), 1)
    };
}
function renderStyle(element, refState, actionState, actionItem, styleProp, elementApi) {
    const { setStyle } = elementApi;
    switch(actionItem.actionTypeId){
        case STYLE_SIZE:
            {
                let { widthUnit = '', heightUnit = '' } = actionItem.config;
                const { widthValue, heightValue } = actionState;
                if (widthValue !== undefined) {
                    if (widthUnit === AUTO) {
                        widthUnit = 'px';
                    }
                    addWillChange(element, WIDTH, elementApi);
                    setStyle(element, WIDTH, widthValue + widthUnit);
                }
                if (heightValue !== undefined) {
                    if (heightUnit === AUTO) {
                        heightUnit = 'px';
                    }
                    addWillChange(element, HEIGHT, elementApi);
                    setStyle(element, HEIGHT, heightValue + heightUnit);
                }
                break;
            }
        case STYLE_FILTER:
            {
                renderFilter(element, actionState, actionItem.config, elementApi);
                break;
            }
        case STYLE_FONT_VARIATION:
            {
                renderFontVariation(element, actionState, actionItem.config, elementApi);
                break;
            }
        case STYLE_BACKGROUND_COLOR:
        case STYLE_BORDER:
        case STYLE_TEXT_COLOR:
            {
                const prop = colorStyleProps[actionItem.actionTypeId];
                const rValue = Math.round(actionState.rValue);
                const gValue = Math.round(actionState.gValue);
                const bValue = Math.round(actionState.bValue);
                const aValue = actionState.aValue;
                addWillChange(element, prop, elementApi);
                setStyle(element, prop, aValue >= 1 ? `rgb(${rValue},${gValue},${bValue})` : `rgba(${rValue},${gValue},${bValue},${aValue})`);
                break;
            }
        default:
            {
                // @ts-expect-error - TS2339 - Property 'unit' does not exist on type '{ delay: number; easing: IX2EasingType; duration: number; target: ActionItemTargetType; xValue: number | undefined; yValue: number | undefined; zValue: number | undefined; xUnit: "%" | ... 4 more ... | "VW"; yUnit: "%" | ... 4 more ... | "VW"; zUnit: "%" | ... 4 more ... | "VW"; } | ... 5 more ... | { ...; }'.
                const { unit = '' } = actionItem.config;
                addWillChange(element, styleProp, elementApi);
                setStyle(element, styleProp, actionState.value + unit);
                break;
            }
    }
}
function renderGeneral(element, actionItem, elementApi) {
    const { setStyle } = elementApi;
    switch(actionItem.actionTypeId){
        case GENERAL_DISPLAY:
            {
                const { value } = actionItem.config;
                if (value === FLEX && _IX2BrowserSupport.IS_BROWSER_ENV) {
                    setStyle(element, DISPLAY, _IX2BrowserSupport.FLEX_PREFIXED);
                } else {
                    setStyle(element, DISPLAY, value);
                }
                return;
            }
    }
}
// @ts-expect-error - TS7006 - Parameter 'element' implicitly has an 'any' type. | TS7006 - Parameter 'prop' implicitly has an 'any' type.
function addWillChange(element, prop, elementApi) {
    if (!_IX2BrowserSupport.IS_BROWSER_ENV) {
        return;
    }
    const validProp = willChangeProps[prop];
    if (!validProp) {
        return;
    }
    const { getStyle, setStyle } = elementApi;
    const value = getStyle(element, WILL_CHANGE);
    if (!value) {
        setStyle(element, WILL_CHANGE, validProp);
        return;
    }
    const values = value.split(COMMA_DELIMITER).map(trim);
    if (values.indexOf(validProp) === -1) {
        setStyle(element, WILL_CHANGE, values.concat(validProp).join(COMMA_DELIMITER));
    }
}
// @ts-expect-error - TS7006 - Parameter 'prop' implicitly has an 'any' type.
function removeWillChange(element, prop, elementApi) {
    if (!_IX2BrowserSupport.IS_BROWSER_ENV) {
        return;
    }
    const validProp = willChangeProps[prop];
    if (!validProp) {
        return;
    }
    const { getStyle, setStyle } = elementApi;
    const value = getStyle(element, WILL_CHANGE);
    if (!value || value.indexOf(validProp) === -1) {
        return;
    }
    setStyle(element, WILL_CHANGE, value.split(COMMA_DELIMITER).map(trim)// @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type.
    .filter((v)=>v !== validProp).join(COMMA_DELIMITER));
}
function clearAllStyles({ store, elementApi }) {
    const { ixData } = store.getState();
    const { events = {}, actionLists = {} } = ixData;
    Object.keys(events).forEach((eventId)=>{
        const event = events[eventId];
        const { config } = event.action;
        const { actionListId } = config;
        const actionList = actionLists[actionListId];
        if (actionList) {
            clearActionListStyles({
                actionList,
                event,
                elementApi
            });
        }
    });
    Object.keys(actionLists).forEach((actionListId)=>{
        // @ts-expect-error - TS2345 - Argument of type '{ actionList: any; elementApi: any; }' is not assignable to parameter of type '{ actionList?: {} | undefined; event: any; elementApi: any; }'.
        clearActionListStyles({
            actionList: actionLists[actionListId],
            elementApi
        });
    });
}
// @ts-expect-error - TS7031 - Binding element 'event' implicitly has an 'any' type. | TS7031 - Binding element 'elementApi' implicitly has an 'any' type.
function clearActionListStyles({ actionList = {}, event, elementApi }) {
    // @ts-expect-error - TS2339 - Property 'actionItemGroups' does not exist on type '{}'. | TS2339 - Property 'continuousParameterGroups' does not exist on type '{}'.
    const { actionItemGroups, continuousParameterGroups } = actionList;
    actionItemGroups && // @ts-expect-error - TS7006 - Parameter 'actionGroup' implicitly has an 'any' type.
    actionItemGroups.forEach((actionGroup)=>{
        clearActionGroupStyles({
            actionGroup,
            event,
            elementApi
        });
    });
    continuousParameterGroups && // @ts-expect-error - TS7006 - Parameter 'paramGroup' implicitly has an 'any' type.
    continuousParameterGroups.forEach((paramGroup)=>{
        const { continuousActionGroups } = paramGroup;
        // @ts-expect-error - TS7006 - Parameter 'actionGroup' implicitly has an 'any' type.
        continuousActionGroups.forEach((actionGroup)=>{
            clearActionGroupStyles({
                actionGroup,
                event,
                elementApi
            });
        });
    });
}
// @ts-expect-error - TS7031 - Binding element 'actionGroup' implicitly has an 'any' type. | TS7031 - Binding element 'event' implicitly has an 'any' type. | TS7031 - Binding element 'elementApi' implicitly has an 'any' type.
function clearActionGroupStyles({ actionGroup, event, elementApi }) {
    const { actionItems } = actionGroup;
    // @ts-expect-error - TS7006 - Parameter 'actionItem' implicitly has an 'any' type.
    actionItems.forEach((actionItem)=>{
        const { actionTypeId, config } = actionItem;
        let clearElement;
        if ((0, _IX2VanillaPlugins.isPluginType)(actionTypeId)) {
            // @ts-expect-error - TS7006 - Parameter 'ref' implicitly has an 'any' type.
            clearElement = (ref)=>(0, _IX2VanillaPlugins.clearPlugin)(actionTypeId)(ref, actionItem);
        } else {
            clearElement = processElementByType({
                effect: clearStyleProp,
                actionTypeId,
                elementApi
            });
        }
        getAffectedElements({
            config,
            event,
            elementApi
        }).forEach(clearElement);
    });
}
function cleanupHTMLElement(element, actionItem, elementApi) {
    const { setStyle, getStyle } = elementApi;
    const { actionTypeId } = actionItem;
    if (actionTypeId === STYLE_SIZE) {
        const { config } = actionItem;
        if (config.widthUnit === AUTO) {
            setStyle(element, WIDTH, '');
        }
        if (config.heightUnit === AUTO) {
            setStyle(element, HEIGHT, '');
        }
    }
    if (getStyle(element, WILL_CHANGE)) {
        processElementByType({
            effect: removeWillChange,
            actionTypeId,
            elementApi
        })(element);
    }
}
const processElementByType = ({ effect, actionTypeId, elementApi })=>// @ts-expect-error - TS7006 - Parameter 'element' implicitly has an 'any' type.
    (element)=>{
        switch(actionTypeId){
            case TRANSFORM_MOVE:
            case TRANSFORM_SCALE:
            case TRANSFORM_ROTATE:
            case TRANSFORM_SKEW:
                effect(element, _IX2BrowserSupport.TRANSFORM_PREFIXED, elementApi);
                break;
            case STYLE_FILTER:
                effect(element, FILTER, elementApi);
                break;
            case STYLE_FONT_VARIATION:
                effect(element, FONT_VARIATION_SETTINGS, elementApi);
                break;
            case STYLE_OPACITY:
                effect(element, OPACITY, elementApi);
                break;
            case STYLE_SIZE:
                effect(element, WIDTH, elementApi);
                effect(element, HEIGHT, elementApi);
                break;
            case STYLE_BACKGROUND_COLOR:
            case STYLE_BORDER:
            case STYLE_TEXT_COLOR:
                effect(element, colorStyleProps[actionTypeId], elementApi);
                break;
            case GENERAL_DISPLAY:
                effect(element, DISPLAY, elementApi);
                break;
        }
    };
// @ts-expect-error - TS7006 - Parameter 'prop' implicitly has an 'any' type.
function clearStyleProp(element, prop, elementApi) {
    const { setStyle } = elementApi;
    removeWillChange(element, prop, elementApi);
    setStyle(element, prop, '');
    // Clear transform-style: preserve-3d
    if (prop === _IX2BrowserSupport.TRANSFORM_PREFIXED) {
        setStyle(element, _IX2BrowserSupport.TRANSFORM_STYLE_PREFIXED, '');
    }
}
function getMaxDurationItemIndex(actionItems) {
    let maxDuration = 0;
    let resultIndex = 0;
    // @ts-expect-error - TS7006 - Parameter 'actionItem' implicitly has an 'any' type. | TS7006 - Parameter 'index' implicitly has an 'any' type.
    actionItems.forEach((actionItem, index)=>{
        const { config } = actionItem;
        const total = config.delay + config.duration;
        if (total >= maxDuration) {
            maxDuration = total;
            resultIndex = index;
        }
    });
    return resultIndex;
}
function getActionListProgress(actionList, instance) {
    const { actionItemGroups, useFirstGroupAsInitialState } = actionList;
    const { actionItem: instanceItem, verboseTimeElapsed = 0 } = instance;
    let totalDuration = 0;
    let elapsedDuration = 0;
    // @ts-expect-error - TS7006 - Parameter 'group' implicitly has an 'any' type. | TS7006 - Parameter 'index' implicitly has an 'any' type.
    actionItemGroups.forEach((group, index)=>{
        if (useFirstGroupAsInitialState && index === 0) {
            return;
        }
        const { actionItems } = group;
        const carrierItem = actionItems[getMaxDurationItemIndex(actionItems)];
        const { config, actionTypeId } = carrierItem;
        if (instanceItem.id === carrierItem.id) {
            elapsedDuration = totalDuration + verboseTimeElapsed;
        }
        const duration = getRenderType(actionTypeId) === RENDER_GENERAL ? 0 : config.duration;
        totalDuration += config.delay + duration;
    });
    return totalDuration > 0 ? (0, _IX2EasingUtils.optimizeFloat)(elapsedDuration / totalDuration) : 0;
}
function reduceListToGroup({ actionList, actionItemId, rawData }) {
    // @ts-expect-error - FIXME - TS2339 - Property 'actionItemGroups' does not exist on type 'ActionListType'.
    const { actionItemGroups, continuousParameterGroups } = actionList;
    const newActionItems = [];
    const takeItemUntilMatch = (actionItem)=>{
        newActionItems.push((0, _timm.mergeIn)(actionItem, [
            'config'
        ], {
            delay: 0,
            duration: 0
        }));
        return actionItem.id === actionItemId;
    };
    actionItemGroups && actionItemGroups.some(({ actionItems })=>{
        return actionItems.some(takeItemUntilMatch);
    });
    continuousParameterGroups && continuousParameterGroups.some((paramGroup)=>{
        const { continuousActionGroups } = paramGroup;
        return continuousActionGroups.some(({ actionItems })=>{
            return actionItems.some(takeItemUntilMatch);
        });
    });
    return (0, _timm.setIn)(rawData, [
        'actionLists'
    ], {
        [actionList.id]: {
            id: actionList.id,
            actionItemGroups: [
                {
                    actionItems: newActionItems
                }
            ]
        }
    });
}
function shouldNamespaceEventParameter(eventTypeId, { basedOn }) {
    return eventTypeId === _sharedconstants.EventTypeConsts.SCROLLING_IN_VIEW && (basedOn === _sharedconstants.EventBasedOn.ELEMENT || basedOn == null) || eventTypeId === _sharedconstants.EventTypeConsts.MOUSE_MOVE && basedOn === _sharedconstants.EventBasedOn.ELEMENT;
}
function getNamespacedParameterId(eventStateKey, continuousParameterGroupId) {
    const namespacedParameterId = eventStateKey + COLON_DELIMITER + continuousParameterGroupId;
    return namespacedParameterId;
}
function shouldAllowMediaQuery(mediaQueries, mediaQueryKey) {
    // During design mode, current media query key does not exist
    if (mediaQueryKey == null) {
        return true;
    }
    return mediaQueries.indexOf(mediaQueryKey) !== -1;
}
function mediaQueriesEqual(listA, listB) {
    return (0, _shallowEqual.default)(listA && listA.sort(), listB && listB.sort());
}
function stringifyTarget(target) {
    if (typeof target === 'string') {
        return target;
    }
    if (target.pluginElement && target.objectId) {
        return target.pluginElement + BAR_DELIMITER + target.objectId;
    }
    if (target.objectId) {
        return target.objectId;
    }
    const { id = '', selector = '', useEventTarget = '' } = target;
    return id + BAR_DELIMITER + selector + BAR_DELIMITER + useEventTarget;
}

//# sourceMappingURL=data:application/json;base64,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

}),
57164: (function (__unused_webpack_module, exports) {
"use strict";
// from https://github.com/acdlite/recompose/blob/master/src/packages/recompose/shallowEqual.js
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule shallowEqual
 * @typechecks
 */ /* eslint-disable no-self-compare */ /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
function is(x, y) {
    // SameValue algorithm
    if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        // Added the nonzero y check to make Flow happy, but it is redundant
        return x !== 0 || y !== 0 || 1 / x === 1 / y;
    }
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
}
/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
    if (is(objA, objB)) {
        return true;
    }
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
        return false;
    }
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!Object.hasOwn(objB, // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'PropertyKey'.
        keysA[i]) || // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type. | TS2538 - Type 'undefined' cannot be used as an index type.
        !is(objA[keysA[i]], objB[keysA[i]])) {
            return false;
        }
    }
    return true;
}
const _default = shallowEqual;

//# sourceMappingURL=data:application/json;base64,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

}),
85861: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    createElementState: function() {
        return createElementState;
    },
    ixElements: function() {
        return ixElements;
    },
    mergeActionState: function() {
        return mergeActionState;
    }
});
const _timm = __webpack_require__(81185);
const _sharedconstants = __webpack_require__(7087);
const { HTML_ELEMENT, PLAIN_OBJECT, ABSTRACT_NODE, CONFIG_X_VALUE, CONFIG_Y_VALUE, CONFIG_Z_VALUE, CONFIG_VALUE, CONFIG_X_UNIT, CONFIG_Y_UNIT, CONFIG_Z_UNIT, CONFIG_UNIT } = _sharedconstants.IX2EngineConstants;
const { IX2_SESSION_STOPPED, IX2_INSTANCE_ADDED, IX2_ELEMENT_STATE_CHANGED } = _sharedconstants.IX2EngineActionTypes;
const initialState = {};
const refState = 'refState';
const ixElements = (state = initialState, action = {})=>{
    switch(action.type){
        case IX2_SESSION_STOPPED:
            {
                return initialState;
            }
        case IX2_INSTANCE_ADDED:
            {
                const { elementId, element: ref, origin, actionItem, refType } = action.payload;
                const { actionTypeId } = actionItem;
                let newState = state;
                // Create new ref entry if it doesn't exist
                if ((0, _timm.getIn)(newState, [
                    elementId,
                    ref
                ]) !== ref) {
                    newState = createElementState(newState, ref, refType, elementId, actionItem);
                }
                // Merge origin values into ref state
                return mergeActionState(newState, elementId, actionTypeId, origin, actionItem);
            }
        case IX2_ELEMENT_STATE_CHANGED:
            {
                const { elementId, actionTypeId, current, actionItem } = action.payload;
                return mergeActionState(state, elementId, actionTypeId, current, actionItem);
            }
        default:
            {
                return state;
            }
    }
};
function createElementState(state, ref, refType, elementId, actionItem) {
    const refId = refType === PLAIN_OBJECT ? (0, _timm.getIn)(actionItem, [
        'config',
        'target',
        'objectId'
    ]) : null;
    return (0, _timm.mergeIn)(state, [
        elementId
    ], {
        id: elementId,
        ref,
        refId,
        refType
    });
}
function mergeActionState(state, elementId, actionTypeId, actionState, actionItem) {
    const units = pickUnits(actionItem);
    const mergePath = [
        elementId,
        refState,
        actionTypeId
    ];
    return (0, _timm.mergeIn)(state, mergePath, actionState, units);
}
const valueUnitPairs = [
    [
        CONFIG_X_VALUE,
        CONFIG_X_UNIT
    ],
    [
        CONFIG_Y_VALUE,
        CONFIG_Y_UNIT
    ],
    [
        CONFIG_Z_VALUE,
        CONFIG_Z_UNIT
    ],
    [
        CONFIG_VALUE,
        CONFIG_UNIT
    ]
];
function pickUnits(actionItem) {
    const { config } = actionItem;
    return valueUnitPairs.reduce((result, pair)=>{
        const valueKey = pair[0];
        const unitKey = pair[1];
        // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
        const configValue = config[valueKey];
        // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
        const configUnit = config[unitKey];
        if (configValue != null && configUnit != null) {
            // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
            result[unitKey] = configUnit;
        }
        return result;
    }, {});
}

//# sourceMappingURL=data:application/json;base64,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

}),
82216: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BREAKPOINT_ID_LARGE: function() {
        return BREAKPOINT_ID_LARGE;
    },
    BREAKPOINT_ID_MAIN: function() {
        return BREAKPOINT_ID_MAIN;
    },
    BREAKPOINT_ID_MEDIUM: function() {
        return BREAKPOINT_ID_MEDIUM;
    },
    BREAKPOINT_ID_SMALL: function() {
        return BREAKPOINT_ID_SMALL;
    },
    BREAKPOINT_ID_TINY: function() {
        return BREAKPOINT_ID_TINY;
    },
    BREAKPOINT_ID_XL: function() {
        return BREAKPOINT_ID_XL;
    },
    BREAKPOINT_ID_XXL: function() {
        return BREAKPOINT_ID_XXL;
    },
    DEFAULT_BREAKPOINT_IDS: function() {
        return DEFAULT_BREAKPOINT_IDS;
    },
    LARGER_BREAKPOINT_IDS: function() {
        return LARGER_BREAKPOINT_IDS;
    }
});
const BREAKPOINT_ID_XXL = 'xxl';
const BREAKPOINT_ID_XL = 'xl';
const BREAKPOINT_ID_LARGE = 'large';
const BREAKPOINT_ID_MAIN = 'main';
const BREAKPOINT_ID_MEDIUM = 'medium';
const BREAKPOINT_ID_SMALL = 'small';
const BREAKPOINT_ID_TINY = 'tiny';
const DEFAULT_BREAKPOINT_IDS = [
    BREAKPOINT_ID_MAIN,
    BREAKPOINT_ID_MEDIUM,
    BREAKPOINT_ID_SMALL,
    BREAKPOINT_ID_TINY
];
const LARGER_BREAKPOINT_IDS = [
    BREAKPOINT_ID_LARGE,
    BREAKPOINT_ID_XL,
    BREAKPOINT_ID_XXL
];

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0eXBlIHtCcmVha3BvaW50SUR9IGZyb20gJ0BwYWNrYWdlcy9zeXN0ZW1zL3N0eWxlL3R5cGVzJztcblxuZXhwb3J0IGNvbnN0IEJSRUFLUE9JTlRfSURfWFhMID0gJ3h4bCcgYXMgY29uc3Q7XG5leHBvcnQgY29uc3QgQlJFQUtQT0lOVF9JRF9YTCA9ICd4bCcgYXMgY29uc3Q7XG5leHBvcnQgY29uc3QgQlJFQUtQT0lOVF9JRF9MQVJHRSA9ICdsYXJnZScgYXMgY29uc3Q7XG5leHBvcnQgY29uc3QgQlJFQUtQT0lOVF9JRF9NQUlOID0gJ21haW4nIGFzIGNvbnN0O1xuZXhwb3J0IGNvbnN0IEJSRUFLUE9JTlRfSURfTUVESVVNID0gJ21lZGl1bScgYXMgY29uc3Q7XG5leHBvcnQgY29uc3QgQlJFQUtQT0lOVF9JRF9TTUFMTCA9ICdzbWFsbCcgYXMgY29uc3Q7XG5leHBvcnQgY29uc3QgQlJFQUtQT0lOVF9JRF9USU5ZID0gJ3RpbnknIGFzIGNvbnN0O1xuXG5leHBvcnQgY29uc3QgREVGQVVMVF9CUkVBS1BPSU5UX0lEUyA9IFtcbiAgQlJFQUtQT0lOVF9JRF9NQUlOLFxuICBCUkVBS1BPSU5UX0lEX01FRElVTSxcbiAgQlJFQUtQT0lOVF9JRF9TTUFMTCxcbiAgQlJFQUtQT0lOVF9JRF9USU5ZLFxuXSBhcyBjb25zdDtcblxuZXhwb3J0IGNvbnN0IExBUkdFUl9CUkVBS1BPSU5UX0lEUzogQnJlYWtwb2ludElEW10gPSBbXG4gIEJSRUFLUE9JTlRfSURfTEFSR0UsXG4gIEJSRUFLUE9JTlRfSURfWEwsXG4gIEJSRUFLUE9JTlRfSURfWFhMLFxuXTtcbiJdLCJuYW1lcyI6WyJCUkVBS1BPSU5UX0lEX0xBUkdFIiwiQlJFQUtQT0lOVF9JRF9NQUlOIiwiQlJFQUtQT0lOVF9JRF9NRURJVU0iLCJCUkVBS1BPSU5UX0lEX1NNQUxMIiwiQlJFQUtQT0lOVF9JRF9USU5ZIiwiQlJFQUtQT0lOVF9JRF9YTCIsIkJSRUFLUE9JTlRfSURfWFhMIiwiREVGQVVMVF9CUkVBS1BPSU5UX0lEUyIsIkxBUkdFUl9CUkVBS1BPSU5UX0lEUyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7SUFJYUEsbUJBQW1CO2VBQW5CQTs7SUFDQUMsa0JBQWtCO2VBQWxCQTs7SUFDQUMsb0JBQW9CO2VBQXBCQTs7SUFDQUMsbUJBQW1CO2VBQW5CQTs7SUFDQUMsa0JBQWtCO2VBQWxCQTs7SUFMQUMsZ0JBQWdCO2VBQWhCQTs7SUFEQUMsaUJBQWlCO2VBQWpCQTs7SUFRQUMsc0JBQXNCO2VBQXRCQTs7SUFPQUMscUJBQXFCO2VBQXJCQTs7O0FBZk4sTUFBTUYsb0JBQW9CO0FBQzFCLE1BQU1ELG1CQUFtQjtBQUN6QixNQUFNTCxzQkFBc0I7QUFDNUIsTUFBTUMscUJBQXFCO0FBQzNCLE1BQU1DLHVCQUF1QjtBQUM3QixNQUFNQyxzQkFBc0I7QUFDNUIsTUFBTUMscUJBQXFCO0FBRTNCLE1BQU1HLHlCQUF5QjtJQUNwQ047SUFDQUM7SUFDQUM7SUFDQUM7Q0FDRDtBQUVNLE1BQU1JLHdCQUF3QztJQUNuRFI7SUFDQUs7SUFDQUM7Q0FDRCJ9

}),
66725: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DEFAULT_BREAKPOINTS_CONFIG: function() {
        return DEFAULT_BREAKPOINTS_CONFIG;
    },
    LARGER_BREAKPOINTS_CONFIG: function() {
        return LARGER_BREAKPOINTS_CONFIG;
    }
});
const _breakpointids = __webpack_require__(82216);
const DEFAULT_BREAKPOINTS_CONFIG = {
    [_breakpointids.BREAKPOINT_ID_MAIN]: {
        maxWidth: 10000
    },
    [_breakpointids.BREAKPOINT_ID_MEDIUM]: {
        maxWidth: 991
    },
    [_breakpointids.BREAKPOINT_ID_SMALL]: {
        maxWidth: 767
    },
    [_breakpointids.BREAKPOINT_ID_TINY]: {
        maxWidth: 479
    }
};
const LARGER_BREAKPOINTS_CONFIG = {
    [_breakpointids.BREAKPOINT_ID_MAIN]: {
        maxWidth: 10000
    },
    [_breakpointids.BREAKPOINT_ID_XXL]: {
        minWidth: 1920
    },
    [_breakpointids.BREAKPOINT_ID_XL]: {
        minWidth: 1440
    },
    [_breakpointids.BREAKPOINT_ID_LARGE]: {
        minWidth: 1280
    },
    [_breakpointids.BREAKPOINT_ID_MEDIUM]: {
        maxWidth: 991
    },
    [_breakpointids.BREAKPOINT_ID_SMALL]: {
        maxWidth: 767
    },
    [_breakpointids.BREAKPOINT_ID_TINY]: {
        maxWidth: 479
    }
};

//# sourceMappingURL=data:application/json;base64,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

}),
33001: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ERROR_ATTRIBUTE_PREFIX: function() {
        return ERROR_ATTRIBUTE_PREFIX;
    },
    ERROR_MSG_CLASS: function() {
        return ERROR_MSG_CLASS;
    },
    ERROR_STATE: function() {
        return ERROR_STATE;
    },
    ErrorStateToCopy: function() {
        return ErrorStateToCopy;
    },
    FORM_GENERIC_ERROR_PATH: function() {
        return FORM_GENERIC_ERROR_PATH;
    },
    FORM_REQUIRED_ERROR_PATH: function() {
        return FORM_REQUIRED_ERROR_PATH;
    },
    FORM_TOO_LARGE_ERROR_PATH: function() {
        return FORM_TOO_LARGE_ERROR_PATH;
    },
    FORM_TOO_SMALL_ERROR_PATH: function() {
        return FORM_TOO_SMALL_ERROR_PATH;
    },
    FORM_TYPE_ERROR_PATH: function() {
        return FORM_TYPE_ERROR_PATH;
    },
    LOGIN_UI_ERROR_CODES: function() {
        return LOGIN_UI_ERROR_CODES;
    },
    RESET_PASSWORD_UI_ERROR_CODES: function() {
        return RESET_PASSWORD_UI_ERROR_CODES;
    },
    SERVER_DATA_VALIDATION_ERRORS: function() {
        return SERVER_DATA_VALIDATION_ERRORS;
    },
    SIGNUP_ERROR_CATEGORY: function() {
        return SIGNUP_ERROR_CATEGORY;
    },
    SIGNUP_UI_ERROR_CODES: function() {
        return SIGNUP_UI_ERROR_CODES;
    },
    UPDATE_ACCOUNT_ERROR_CODES: function() {
        return UPDATE_ACCOUNT_ERROR_CODES;
    },
    UPDATE_PASSWORD_UI_ERROR_CODES: function() {
        return UPDATE_PASSWORD_UI_ERROR_CODES;
    },
    USER_FILE_UPLOAD_ERRORS: function() {
        return USER_FILE_UPLOAD_ERRORS;
    },
    __DEPRECATED__logInErrorStates: function() {
        return __DEPRECATED__logInErrorStates;
    },
    logInErrorStates: function() {
        return logInErrorStates;
    },
    resetPasswordErrorStates: function() {
        return resetPasswordErrorStates;
    },
    signUpErrorStates: function() {
        return signUpErrorStates;
    },
    updateAccountErrorStates: function() {
        return updateAccountErrorStates;
    },
    updatePasswordErrorStates: function() {
        return updatePasswordErrorStates;
    }
});
const ERROR_MSG_CLASS = 'user-form-error-msg';
const ERROR_STATE = {
    SIGNUP: 'signup-error-state',
    LOGIN: 'login-error-state',
    UPDATE_PASSWORD: 'update-password-error-state',
    RESET_PASSWORD: 'reset-password-error-state',
    ACCOUNT_UPDATE: 'account-update-error-state'
};
const ErrorStateToCopy = (errorStateType, id)=>{
    if (errorStateType === 'signup-error-state') {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"GENERAL_ERROR" | "NOT_ALLOWED" | "NOT_VERIFIED" | "EMAIL_ALREADY_EXIST" | "USE_INVITE_EMAIL" | "INVALID_EMAIL" | "INVALID_PASSWORD" | "EXPIRED_TOKEN" | "VALIDATION_FAILED" | "REQUIRED", ErrorStateType>>'.
        return signUpErrorStates[id]?.copy ?? null;
    }
    if (errorStateType === 'login-error-state') {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"GENERAL_ERROR" | "INVALID_EMAIL_OR_PASSWORD", ErrorStateType>>'.
        return logInErrorStates[id]?.copy ?? null;
    }
    if (errorStateType === 'update-password-error-state') {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"GENERAL_ERROR" | "WEAK_PASSWORD", ErrorStateType>>'.
        return updatePasswordErrorStates[id]?.copy ?? null;
    }
    if (errorStateType === 'reset-password-error-state') {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"GENERAL_ERROR", ErrorStateType>>'.
        return resetPasswordErrorStates[id]?.copy ?? null;
    }
    if (errorStateType === 'account-update-error-state') {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"GENERAL_ERROR", ErrorStateType>>'.
        return updateAccountErrorStates[id]?.copy ?? null;
    }
    console.error(`copy for ${errorStateType} not found`);
    return null;
};
const SERVER_DATA_VALIDATION_ERRORS = {
    RequiredError: 'EmptyValue',
    MinSizeError: 'MinSizeError',
    MaxSizeError: 'MaxSizeError',
    ExtensionsError: 'ExtensionsError',
    DefaultError: 'DefaultError'
};
const LOGIN_UI_ERROR_CODES = {
    GENERAL_ERROR: 'GENERAL_ERROR',
    INVALID_EMAIL_OR_PASSWORD: 'INVALID_EMAIL_OR_PASSWORD'
};
const SIGNUP_UI_ERROR_CODES = {
    GENERAL_ERROR: 'GENERAL_ERROR',
    NOT_ALLOWED: 'NOT_ALLOWED',
    NOT_VERIFIED: 'NOT_VERIFIED',
    EMAIL_ALREADY_EXIST: 'EMAIL_ALREADY_EXIST',
    USE_INVITE_EMAIL: 'USE_INVITE_EMAIL',
    INVALID_EMAIL: 'INVALID_EMAIL',
    INVALID_PASSWORD: 'INVALID_PASSWORD',
    EXPIRED_TOKEN: 'EXPIRED_TOKEN',
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    REQUIRED: 'REQUIRED'
};
const ERROR_ATTRIBUTE_PREFIX = {
    SIGNUP: 'wf-signup-form',
    LOGIN: 'wf-login-form',
    RESET_PASSWORD: 'wf-reset-pw-form',
    UPDATE_PASSWORD: 'wf-update-pw-form',
    ACCOUNT_UPDATE: 'wf-account-update-form'
};
const UPDATE_PASSWORD_UI_ERROR_CODES = {
    GENERAL_ERROR: 'GENERAL_ERROR',
    WEAK_PASSWORD: 'WEAK_PASSWORD'
};
const RESET_PASSWORD_UI_ERROR_CODES = {
    GENERAL_ERROR: 'GENERAL_ERROR'
};
const TOO_LARGE_ERR = 'TOO_LARGE_ERROR';
const TOO_SMALL_ERR = 'TOO_SMALL_ERROR';
const TYPE_ERR = 'TYPE_ERROR';
const GENERIC_ERR = 'GENERIC_ERROR';
const REQUIRED_ERR = 'REQUIRED_ERROR';
const USER_FILE_UPLOAD_ERRORS = {
    GENERIC: {
        id: GENERIC_ERR,
        msg: 'Upload failed. Something went wrong. Please retry.',
        path: [
            'data',
            'form',
            GENERIC_ERR
        ]
    },
    TOO_LARGE: {
        id: TOO_LARGE_ERR,
        msg: 'Upload failed. File too large.',
        path: [
            'data',
            'form',
            TOO_LARGE_ERR
        ]
    },
    TOO_SMALL: {
        id: TOO_SMALL_ERR,
        msg: 'Upload failed. File too small.',
        path: [
            'data',
            'form',
            TOO_SMALL_ERR
        ]
    },
    TYPE: {
        id: TYPE_ERR,
        msg: 'Upload failed. Invalid file type.',
        path: [
            'data',
            'form',
            TYPE_ERR
        ]
    },
    REQUIRED: {
        id: REQUIRED_ERR,
        msg: 'Please upload a file.',
        path: [
            'data',
            'form',
            REQUIRED_ERR
        ]
    }
};
const FORM_PATH = [
    {
        in: 'Record',
        at: 'form'
    }
];
const FORM_TOO_LARGE_ERROR_PATH = [
    ...FORM_PATH,
    {
        in: 'Record',
        at: TOO_LARGE_ERR
    }
];
const FORM_TOO_SMALL_ERROR_PATH = [
    ...FORM_PATH,
    {
        in: 'Record',
        at: TOO_SMALL_ERR
    }
];
const FORM_TYPE_ERROR_PATH = [
    ...FORM_PATH,
    {
        in: 'Record',
        at: TYPE_ERR
    }
];
const FORM_GENERIC_ERROR_PATH = [
    ...FORM_PATH,
    {
        in: 'Record',
        at: GENERIC_ERR
    }
];
const FORM_REQUIRED_ERROR_PATH = [
    ...FORM_PATH,
    {
        in: 'Record',
        at: REQUIRED_ERR
    }
];
const __DEPRECATED__logInErrorStates = {
    [LOGIN_UI_ERROR_CODES.GENERAL_ERROR]: {
        id: LOGIN_UI_ERROR_CODES.GENERAL_ERROR,
        name: 'General error',
        copy: "We're having trouble logging you in. Please try again, or contact us if you continue to have problems.",
        path: [
            'data',
            'users',
            LOGIN_UI_ERROR_CODES.GENERAL_ERROR
        ]
    }
};
const logInErrorStates = {
    [LOGIN_UI_ERROR_CODES.GENERAL_ERROR]: {
        id: LOGIN_UI_ERROR_CODES.GENERAL_ERROR,
        name: 'General error',
        copy: "We're having trouble logging you in. Please try again, or contact us if you continue to have problems.",
        path: [
            'data',
            'users',
            LOGIN_UI_ERROR_CODES.GENERAL_ERROR
        ]
    },
    [LOGIN_UI_ERROR_CODES.INVALID_EMAIL_OR_PASSWORD]: {
        id: LOGIN_UI_ERROR_CODES.INVALID_EMAIL_OR_PASSWORD,
        name: 'Wrong email or password',
        copy: 'Invalid email or password. Please try again.',
        path: [
            'data',
            'users',
            LOGIN_UI_ERROR_CODES.INVALID_EMAIL_OR_PASSWORD
        ]
    }
};
const SIGNUP_ERROR_CATEGORY = {
    GENERAL: {
        id: 'GENERAL',
        label: 'General Errors'
    },
    EMAIL: {
        id: 'EMAIL',
        label: 'Email Errors'
    },
    PASSWORD: {
        id: 'PASSWORD',
        label: 'Password Errors'
    },
    INVITE: {
        id: 'INVITE',
        label: 'Invitation Errors'
    },
    VERFIICATION: {
        id: 'VERIFCATION',
        label: 'Verification Errors'
    },
    VALIDATION: {
        id: 'VALIDATION',
        label: 'Validation Errors'
    }
};
const signUpErrorStates = {
    [SIGNUP_UI_ERROR_CODES.GENERAL_ERROR]: {
        id: SIGNUP_UI_ERROR_CODES.GENERAL_ERROR,
        // @ts-expect-error - TS2418 - Type of computed property's value is '{ id: "GENERAL_ERROR"; category: { readonly id: "GENERAL"; readonly label: "General Errors"; }; name: string; copy: string; path: string[]; }', which is not assignable to type 'ErrorStateType'.
        category: SIGNUP_ERROR_CATEGORY.GENERAL,
        name: 'General error',
        copy: 'There was an error signing you up. Please try again, or contact us if you continue to have problems.',
        path: [
            'data',
            'users',
            SIGNUP_UI_ERROR_CODES.GENERAL_ERROR
        ]
    },
    [SIGNUP_UI_ERROR_CODES.NOT_ALLOWED]: {
        id: SIGNUP_UI_ERROR_CODES.NOT_ALLOWED,
        // @ts-expect-error - TS2418 - Type of computed property's value is '{ id: "NOT_ALLOWED"; category: { readonly id: "EMAIL"; readonly label: "Email Errors"; }; name: string; copy: string; path: string[]; }', which is not assignable to type 'ErrorStateType'.
        category: SIGNUP_ERROR_CATEGORY.EMAIL,
        name: 'Email not allowed',
        copy: "You're not allowed to access this site, please contact the admin for support.",
        path: [
            'data',
            'users',
            SIGNUP_UI_ERROR_CODES.NOT_ALLOWED
        ]
    },
    // email errors
    [SIGNUP_UI_ERROR_CODES.INVALID_EMAIL]: {
        id: SIGNUP_UI_ERROR_CODES.INVALID_EMAIL,
        // @ts-expect-error - TS2418 - Type of computed property's value is '{ id: "INVALID_EMAIL"; category: { readonly id: "EMAIL"; readonly label: "Email Errors"; }; name: string; copy: string; path: string[]; }', which is not assignable to type 'ErrorStateType'.
        category: SIGNUP_ERROR_CATEGORY.EMAIL,
        name: 'Invalid email',
        copy: 'Make sure your email exists and is properly formatted (e.g., user@domain.com).',
        path: [
            'data',
            'users',
            SIGNUP_UI_ERROR_CODES.INVALID_EMAIL
        ]
    },
    [SIGNUP_UI_ERROR_CODES.EMAIL_ALREADY_EXIST]: {
        id: SIGNUP_UI_ERROR_CODES.EMAIL_ALREADY_EXIST,
        // @ts-expect-error - TS2418 - Type of computed property's value is '{ id: "EMAIL_ALREADY_EXIST"; category: { readonly id: "EMAIL"; readonly label: "Email Errors"; }; name: string; copy: string; path: string[]; }', which is not assignable to type 'ErrorStateType'.
        category: SIGNUP_ERROR_CATEGORY.EMAIL,
        name: 'Email already exists',
        copy: 'An account with this email address already exists. Log in or reset your password.',
        path: [
            'data',
            'users',
            SIGNUP_UI_ERROR_CODES.EMAIL_ALREADY_EXIST
        ]
    },
    // invitation errors
    [SIGNUP_UI_ERROR_CODES.USE_INVITE_EMAIL]: {
        id: SIGNUP_UI_ERROR_CODES.USE_INVITE_EMAIL,
        // @ts-expect-error - TS2418 - Type of computed property's value is '{ id: "USE_INVITE_EMAIL"; category: { readonly id: "INVITE"; readonly label: "Invitation Errors"; }; name: string; copy: string; path: string[]; }', which is not assignable to type 'ErrorStateType'.
        category: SIGNUP_ERROR_CATEGORY.INVITE,
        name: 'Must use invite email',
        copy: 'Use the same email address your invitation was sent to.',
        path: [
            'data',
            'users',
            SIGNUP_UI_ERROR_CODES.USE_INVITE_EMAIL
        ]
    },
    // password errors
    [SIGNUP_UI_ERROR_CODES.INVALID_PASSWORD]: {
        id: SIGNUP_UI_ERROR_CODES.INVALID_PASSWORD,
        // @ts-expect-error - TS2418 - Type of computed property's value is '{ id: "INVALID_PASSWORD"; category: { readonly id: "PASSWORD"; readonly label: "Password Errors"; }; name: string; copy: string; path: string[]; }', which is not assignable to type 'ErrorStateType'.
        category: SIGNUP_ERROR_CATEGORY.PASSWORD,
        name: 'Invalid password',
        copy: 'Your password must be at least 8 characters.',
        path: [
            'data',
            'users',
            SIGNUP_UI_ERROR_CODES.INVALID_PASSWORD
        ]
    },
    // verification errors
    [SIGNUP_UI_ERROR_CODES.NOT_VERIFIED]: {
        id: SIGNUP_UI_ERROR_CODES.NOT_VERIFIED,
        // @ts-expect-error - TS2418 - Type of computed property's value is '{ id: "NOT_VERIFIED"; category: { readonly id: "VERIFCATION"; readonly label: "Verification Errors"; }; name: string; copy: string; path: string[]; }', which is not assignable to type 'ErrorStateType'.
        category: SIGNUP_ERROR_CATEGORY.VERFIICATION,
        name: 'Verification failed',
        copy: "We couldn't verify your account. Please try again, or contact us if you continue to have problems.",
        path: [
            'data',
            'users',
            SIGNUP_UI_ERROR_CODES.NOT_VERIFIED
        ]
    },
    [SIGNUP_UI_ERROR_CODES.EXPIRED_TOKEN]: {
        id: SIGNUP_UI_ERROR_CODES.EXPIRED_TOKEN,
        // @ts-expect-error - TS2418 - Type of computed property's value is '{ id: "EXPIRED_TOKEN"; category: { readonly id: "VERIFCATION"; readonly label: "Verification Errors"; }; name: string; copy: string; path: string[]; }', which is not assignable to type 'ErrorStateType'.
        category: SIGNUP_ERROR_CATEGORY.VERFIICATION,
        name: 'Verification expired',
        copy: 'This link has expired. A new link has been sent to your email. Please try again, or contact us if you continue to have problems.',
        path: [
            'data',
            'users',
            SIGNUP_UI_ERROR_CODES.EXPIRED_TOKEN
        ]
    },
    [SIGNUP_UI_ERROR_CODES.VALIDATION_FAILED]: {
        id: SIGNUP_UI_ERROR_CODES.VALIDATION_FAILED,
        // @ts-expect-error - TS2418 - Type of computed property's value is '{ id: "VALIDATION_FAILED"; category: { readonly id: "VALIDATION"; readonly label: "Validation Errors"; }; name: string; copy: string; path: string[]; }', which is not assignable to type 'ErrorStateType'.
        category: SIGNUP_ERROR_CATEGORY.VALIDATION,
        name: 'Validation error',
        copy: 'There was an error in some of the information provided.',
        path: [
            'data',
            'users',
            SIGNUP_UI_ERROR_CODES.VALIDATION_FAILED
        ]
    },
    [SIGNUP_UI_ERROR_CODES.REQUIRED]: {
        id: SIGNUP_UI_ERROR_CODES.REQUIRED,
        // @ts-expect-error - TS2418 - Type of computed property's value is '{ id: "REQUIRED"; category: { readonly id: "VALIDATION"; readonly label: "Validation Errors"; }; name: string; copy: string; path: string[]; }', which is not assignable to type 'ErrorStateType'.
        category: SIGNUP_ERROR_CATEGORY.VALIDATION,
        name: 'Missing information',
        copy: 'Fill out all required fields',
        path: [
            'data',
            'users',
            SIGNUP_UI_ERROR_CODES.REQUIRED
        ]
    }
};
const updatePasswordErrorStates = {
    [UPDATE_PASSWORD_UI_ERROR_CODES.GENERAL_ERROR]: {
        id: UPDATE_PASSWORD_UI_ERROR_CODES.GENERAL_ERROR,
        name: 'General error',
        copy: 'There was an error updating your password. Please try again, or contact us if you continue to have problems.',
        path: [
            'data',
            'users',
            UPDATE_PASSWORD_UI_ERROR_CODES.GENERAL_ERROR
        ]
    },
    [UPDATE_PASSWORD_UI_ERROR_CODES.WEAK_PASSWORD]: {
        id: UPDATE_PASSWORD_UI_ERROR_CODES.WEAK_PASSWORD,
        name: 'Weak password',
        copy: 'Your password must be at least 8 characters.',
        path: [
            'data',
            'users',
            UPDATE_PASSWORD_UI_ERROR_CODES.WEAK_PASSWORD
        ]
    }
};
const resetPasswordErrorStates = {
    [RESET_PASSWORD_UI_ERROR_CODES.GENERAL_ERROR]: {
        id: RESET_PASSWORD_UI_ERROR_CODES.GENERAL_ERROR,
        name: 'General error',
        copy: 'There was an error resetting your password. Please try again, or contact us if you continue to have problems.',
        path: [
            'data',
            'users',
            RESET_PASSWORD_UI_ERROR_CODES.GENERAL_ERROR
        ]
    }
};
const UPDATE_ACCOUNT_ERROR_CODES = {
    GENERAL_ERROR: 'GENERAL_ERROR'
};
const updateAccountErrorStates = {
    [UPDATE_ACCOUNT_ERROR_CODES.GENERAL_ERROR]: {
        id: UPDATE_ACCOUNT_ERROR_CODES.GENERAL_ERROR,
        name: 'General error',
        copy: 'There was an error updating your account. Please try again, or contact us if you continue to have problems.',
        path: [
            'data',
            'users',
            UPDATE_ACCOUNT_ERROR_CODES.GENERAL_ERROR
        ]
    }
};

//# sourceMappingURL=data:application/json;base64,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

}),
7462: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ACCESS_GROUP_ADMISSION_TYPE: function() {
        return ACCESS_GROUP_ADMISSION_TYPE;
    },
    ACCESS_GROUP_FREE_TYPE: function() {
        return ACCESS_GROUP_FREE_TYPE;
    },
    ACCESS_GROUP_INLINE_PRODUCT_FIELD_SLUG: function() {
        return ACCESS_GROUP_INLINE_PRODUCT_FIELD_SLUG;
    },
    BASIC_MAX_NUM_USERS: function() {
        return BASIC_MAX_NUM_USERS;
    },
    BUSINESS_MAX_NUM_USERS: function() {
        return BUSINESS_MAX_NUM_USERS;
    },
    CONFIRM_UNSAVED_CHANGES_COPY: function() {
        return CONFIRM_UNSAVED_CHANGES_COPY;
    },
    DEFAULT_SESSION_DURATION_IN_MS: function() {
        return DEFAULT_SESSION_DURATION_IN_MS;
    },
    DEFAULT_SESSION_TOKEN_DURATION_IN_MS: function() {
        return DEFAULT_SESSION_TOKEN_DURATION_IN_MS;
    },
    DEFAULT_STYLES: function() {
        return DEFAULT_STYLES;
    },
    DEFAULT_TOKEN_AGE_MS: function() {
        return DEFAULT_TOKEN_AGE_MS;
    },
    DEFAULT_USER_FIELDS: function() {
        return DEFAULT_USER_FIELDS;
    },
    ECOMM_PLUS_MAX_NUM_USERS: function() {
        return ECOMM_PLUS_MAX_NUM_USERS;
    },
    ECOMM_STANDARD_MAX_NUM_USERS: function() {
        return ECOMM_STANDARD_MAX_NUM_USERS;
    },
    EMAIL_TEMPLATE_TYPES: function() {
        return EMAIL_TEMPLATE_TYPES;
    },
    EXCEEDS_MAX_FILE_SIZE_ERROR: function() {
        return EXCEEDS_MAX_FILE_SIZE_ERROR;
    },
    EXCEEDS_MAX_IMAGE_SIZE_ERROR: function() {
        return EXCEEDS_MAX_IMAGE_SIZE_ERROR;
    },
    HARD_LIMIT_MAX_NUM_USERS: function() {
        return HARD_LIMIT_MAX_NUM_USERS;
    },
    KEY_FROM_RESERVED_USER_FIELD: function() {
        return KEY_FROM_RESERVED_USER_FIELD;
    },
    LOGGEDIN_COOKIE_NAME: function() {
        return LOGGEDIN_COOKIE_NAME;
    },
    MAX_GROUP_ID_LENGTH: function() {
        return MAX_GROUP_ID_LENGTH;
    },
    MAX_NUM_GROUPS: function() {
        return MAX_NUM_GROUPS;
    },
    MAX_UPDATE_USER_DATA_FIELDS: function() {
        return MAX_UPDATE_USER_DATA_FIELDS;
    },
    MAX_USER_DATA_FIELDS: function() {
        return MAX_USER_DATA_FIELDS;
    },
    MEMBERSHIPS_EMAIL_KEYS: function() {
        return MEMBERSHIPS_EMAIL_KEYS;
    },
    MIN_GROUP_ID_LENGTH: function() {
        return MIN_GROUP_ID_LENGTH;
    },
    NAMES_FROM_USER_FIELDS: function() {
        return NAMES_FROM_USER_FIELDS;
    },
    NEW_USER_FIELD_ID: function() {
        return NEW_USER_FIELD_ID;
    },
    NO_REQUIRED_ATTRIBUTE: function() {
        return NO_REQUIRED_ATTRIBUTE;
    },
    PASSWORD_MAX_LENGTH: function() {
        return PASSWORD_MAX_LENGTH;
    },
    PASSWORD_MIN_LENGTH: function() {
        return PASSWORD_MIN_LENGTH;
    },
    RESERVED_USER_FIELDS: function() {
        return RESERVED_USER_FIELDS;
    },
    RESERVED_USER_PREFIX: function() {
        return RESERVED_USER_PREFIX;
    },
    SESSION_COOKIE_NAME: function() {
        return SESSION_COOKIE_NAME;
    },
    SETUP_GUIDE_ALL_KEYS: function() {
        return SETUP_GUIDE_ALL_KEYS;
    },
    SETUP_GUIDE_KEYS: function() {
        return SETUP_GUIDE_KEYS;
    },
    STARTER_MAX_NUM_USERS: function() {
        return STARTER_MAX_NUM_USERS;
    },
    SUBSCRIPTION_EMAIL_TYPES: function() {
        return SUBSCRIPTION_EMAIL_TYPES;
    },
    SUBSCRIPTION_USER_LIMITS: function() {
        return SUBSCRIPTION_USER_LIMITS;
    },
    TEXT_INPUT_TYPE_TO_FIELD_TYPE: function() {
        return TEXT_INPUT_TYPE_TO_FIELD_TYPE;
    },
    USER_ACCESS_META_OPTIONS: function() {
        return USER_ACCESS_META_OPTIONS;
    },
    USER_CSV_IMPORT_STATUS_MAX_TRIES: function() {
        return USER_CSV_IMPORT_STATUS_MAX_TRIES;
    },
    USER_CSV_IMPORT_STATUS_POLLING_INTERVAL: function() {
        return USER_CSV_IMPORT_STATUS_POLLING_INTERVAL;
    },
    USER_FIELD_DEFAULTS: function() {
        return USER_FIELD_DEFAULTS;
    },
    USER_FIELD_FORM_ID: function() {
        return USER_FIELD_FORM_ID;
    },
    USER_PAGE_SIZE: function() {
        return USER_PAGE_SIZE;
    },
    USER_STATUSES: function() {
        return USER_STATUSES;
    },
    USYS_DATA_ATTRS: function() {
        return USYS_DATA_ATTRS;
    },
    USYS_DOM_CLASS_NAMES: function() {
        return USYS_DOM_CLASS_NAMES;
    },
    USYS_FORM_TYPES: function() {
        return USYS_FORM_TYPES;
    },
    USYS_INPUT_SIGN_UP_IDS: function() {
        return USYS_INPUT_SIGN_UP_IDS;
    },
    USYS_INPUT_TYPES: function() {
        return USYS_INPUT_TYPES;
    },
    USYS_PAGE_SETTINGS: function() {
        return USYS_PAGE_SETTINGS;
    },
    USYS_PAGE_UTIL_KEYS: function() {
        return USYS_PAGE_UTIL_KEYS;
    },
    USYS_RESERVED_SLUGS: function() {
        return USYS_RESERVED_SLUGS;
    },
    USYS_TOKEN_TYPES: function() {
        return USYS_TOKEN_TYPES;
    },
    USYS_USER_STATES: function() {
        return USYS_USER_STATES;
    },
    USYS_UTILITY_KEYS: function() {
        return USYS_UTILITY_KEYS;
    }
});
const _utils = __webpack_require__(1242);
const _types = _export_star(__webpack_require__(29089), exports);
_export_star(__webpack_require__(33001), exports);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}
const RESERVED_USER_PREFIX = 'wf-user-field-';
const RESERVED_USER_FIELDS = {
    name: RESERVED_USER_PREFIX + 'name',
    acceptPrivacy: RESERVED_USER_PREFIX + 'accept-privacy',
    acceptCommunications: RESERVED_USER_PREFIX + 'accept-communications'
};
const KEY_FROM_RESERVED_USER_FIELD = {
    [RESERVED_USER_PREFIX + 'name']: 'name',
    [RESERVED_USER_PREFIX + 'accept-privacy']: 'acceptPrivacy',
    [RESERVED_USER_PREFIX + 'accept-communications']: 'acceptCommunications'
};
const NAMES_FROM_USER_FIELDS = {
    [RESERVED_USER_PREFIX + 'name']: 'Name',
    [RESERVED_USER_PREFIX + 'accept-privacy']: 'Accept privacy policy',
    [RESERVED_USER_PREFIX + 'accept-communications']: 'Accept communications',
    PRIVACY_POLICY: 'Accept privacy policy',
    PASSWORD: 'Password',
    EMAIL: 'Email'
};
const TEXT_INPUT_TYPE_TO_FIELD_TYPE = {
    text: 'PlainText',
    password: 'Password',
    email: 'Email',
    number: 'PlainText',
    tel: 'PlainText'
};
const USYS_UTILITY_KEYS = {
    'usys-log-in': 'usys-log-in',
    'usys-sign-up': 'usys-sign-up',
    'usys-reset-password': 'usys-reset-password',
    'usys-update-password': 'usys-update-password',
    'usys-access-denied': 'usys-access-denied',
    'usys-user-account': 'usys-user-account'
};
const USYS_DATA_ATTRS = {
    formType: 'data-wf-user-form-type',
    inputType: 'data-wf-user-form-input-type',
    logout: 'data-wf-user-logout',
    login: 'data-wf-user-login',
    formError: 'data-wf-user-form-error',
    redirectUrl: 'data-wf-user-form-redirect',
    formVerification: 'data-wf-user-form-verification',
    userSubscriptions: 'data-wf-user-subscriptions-list',
    userSubscriptionsEmptyState: 'data-wf-user-subscriptions-empty',
    userAccount: 'data-wf-user-account',
    subscriptionCancel: 'data-wf-user-subscription-cancel',
    userId: 'data-wf-user-id',
    field: 'data-wf-user-field',
    fieldType: 'data-wf-user-field-type',
    fileUploadKey: 'data-wf-user-file-upload-key',
    unsavedFileUploadKey: 'data-wf-unsaved-user-file-upload-key'
};
const USYS_DOM_CLASS_NAMES = {
    formSuccess: 'w-form-success',
    formVerfication: 'w-form-verification',
    formError: 'w-form-fail'
};
const USYS_FORM_TYPES = {
    login: 'login',
    signup: 'signup',
    updatePassword: 'updatePassword',
    resetPassword: 'resetPassword',
    account: 'userAccount'
};
const USYS_INPUT_TYPES = {
    email: 'email',
    name: 'name',
    password: 'password',
    acceptPrivacy: 'accept-privacy'
};
const USYS_INPUT_SIGN_UP_IDS = {
    email: 'wf-sign-up-email',
    name: 'wf-sign-up-name',
    password: 'wf-sign-up-password',
    acceptPrivacy: 'wf-sign-up-accept-privacy',
    acceptCommunications: 'wf-sign-up-accept-communications'
};
const USYS_USER_STATES = {
    loggedIn: 'loggedIn',
    loggedOut: 'loggedOut'
};
const USYS_PAGE_SETTINGS = {
    login: {
        parent: null,
        sortPos: 0,
        utilKey: 'usys-log-in',
        slug: 'log-in',
        title: 'Log In'
    },
    signup: {
        parent: null,
        sortPos: 1,
        utilKey: 'usys-sign-up',
        slug: 'sign-up',
        title: 'Sign Up'
    },
    resetPassword: {
        parent: null,
        sortPos: 2,
        utilKey: 'usys-reset-password',
        slug: 'reset-password',
        title: 'Reset Password'
    },
    updatePassword: {
        parent: null,
        sortPos: 3,
        utilKey: 'usys-update-password',
        slug: 'update-password',
        title: 'Update Password'
    },
    accessDenied: {
        parent: null,
        sortPos: 4,
        utilKey: 'usys-access-denied',
        slug: 'access-denied',
        title: 'Access Denied'
    },
    userAccount: {
        parent: null,
        sortPos: 5,
        utilKey: 'usys-user-account',
        slug: 'user-account',
        title: 'User Account'
    }
};
const USYS_RESERVED_SLUGS = (0, _utils.values)(USYS_PAGE_SETTINGS).map((pageSettings)=>pageSettings.slug);
const USYS_PAGE_UTIL_KEYS = (0, _utils.values)(USYS_PAGE_SETTINGS).map((pageSettings)=>pageSettings.utilKey);
const DEFAULT_STYLES = {
    accentColor: '#468EE5',
    bgColor: '#F5F6F7',
    includeWfBrand: true
};
const PASSWORD_MIN_LENGTH = 8;
const PASSWORD_MAX_LENGTH = 72;
// Helper constants.
const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const SESSION_COOKIE_NAME = 'wf_sid';
const LOGGEDIN_COOKIE_NAME = 'wf_loggedin';
const DEFAULT_SESSION_DURATION_IN_MS = 7 * DAY;
const DEFAULT_SESSION_TOKEN_DURATION_IN_MS = 4 * HOUR;
const DEFAULT_TOKEN_AGE_MS = HOUR;
const STARTER_MAX_NUM_USERS = 100;
const BASIC_MAX_NUM_USERS = 20000;
const BUSINESS_MAX_NUM_USERS = 20000;
const ECOMM_STANDARD_MAX_NUM_USERS = 20000;
const ECOMM_PLUS_MAX_NUM_USERS = 20000;
const HARD_LIMIT_MAX_NUM_USERS = 100 * 1000;
const SUBSCRIPTION_USER_LIMITS = {
    free: STARTER_MAX_NUM_USERS,
    static: BASIC_MAX_NUM_USERS,
    cms: BUSINESS_MAX_NUM_USERS,
    business: BUSINESS_MAX_NUM_USERS,
    ecommerce_standard: ECOMM_STANDARD_MAX_NUM_USERS,
    ecommerce_plus: ECOMM_PLUS_MAX_NUM_USERS,
    ecommerce_advanced: BUSINESS_MAX_NUM_USERS,
    enterprise: BUSINESS_MAX_NUM_USERS,
    enterprise_lite: BUSINESS_MAX_NUM_USERS
};
const MAX_NUM_GROUPS = 20;
const MIN_GROUP_ID_LENGTH = 2;
const MAX_GROUP_ID_LENGTH = 2;
const USYS_TOKEN_TYPES = {
    inviteUser: 'inviteUser',
    resetPassword: 'resetPassword',
    verifyEmail: 'verifyEmail'
};
const ACCESS_GROUP_INLINE_PRODUCT_FIELD_SLUG = 'access-group-membership-product';
const ACCESS_GROUP_ADMISSION_TYPE = {
    free: 'free',
    paid: 'paid'
};
const ACCESS_GROUP_FREE_TYPE = {
    all: 'all',
    admin: 'admin'
};
const SUBSCRIPTION_EMAIL_TYPES = {
    PAYMENT_FAILED: 'paymentFailed',
    PAYMENT_SUCCESSFUL: 'paymentSuccessful',
    SUBSCRIPTION_CANCELED: 'subscriptionCanceled',
    VERIFY_PAYMENT: 'verifyPayment'
};
const MEMBERSHIPS_EMAIL_KEYS = {
    invite: 'invite',
    resetPassword: 'resetPassword',
    updatedPassword: 'updatedPassword',
    welcome: 'welcome',
    verify: 'verify'
};
const EMAIL_TEMPLATE_TYPES = {
    invite: 'MEMBERSHIPS_INVITE',
    resetPassword: 'MEMBERSHIPS_RESET_PASSWORD',
    updatedPassword: 'MEMBERSHIPS_UPDATED_PASSWORD',
    verify: 'MEMBERSHIPS_VERIFY',
    welcome: 'MEMBERSHIPS_WELCOME'
};
const CONFIRM_UNSAVED_CHANGES_COPY = {
    title: 'Continue without saving?',
    content: 'Your changes will be lost.',
    iconType: 'warning',
    submit: {
        label: 'Continue',
        intent: 'danger'
    },
    cancel: {
        label: 'Cancel',
        intent: 'default'
    }
};
const USER_FIELD_FORM_ID = 'UserFieldForm';
const NEW_USER_FIELD_ID = 'mint-user-field';
const USER_FIELD_DEFAULTS = {
    PlainText: {
        id: NEW_USER_FIELD_ID,
        name: '',
        slug: '',
        required: false,
        type: 'PlainText',
        validations: {}
    },
    Email: {
        id: NEW_USER_FIELD_ID,
        name: '',
        slug: '',
        required: false,
        type: 'Email',
        validations: {}
    },
    Bool: {
        id: NEW_USER_FIELD_ID,
        name: '',
        slug: '',
        required: false,
        type: 'Bool',
        validations: {}
    },
    FileRef: {
        id: NEW_USER_FIELD_ID,
        name: '',
        slug: '',
        required: false,
        type: 'FileRef',
        validations: {}
    },
    Option: {
        id: NEW_USER_FIELD_ID,
        name: '',
        slug: '',
        required: false,
        type: 'Option',
        validations: {
            options: []
        }
    },
    Password: {
        id: NEW_USER_FIELD_ID,
        name: 'Password',
        slug: '',
        required: true,
        type: 'Password',
        validations: {}
    },
    Number: {
        id: NEW_USER_FIELD_ID,
        name: '',
        slug: '',
        required: false,
        type: 'Number',
        validations: {
            min: 0,
            step: 1
        }
    },
    Link: {
        id: NEW_USER_FIELD_ID,
        name: '',
        slug: '',
        required: false,
        type: 'Link',
        validations: {}
    }
};
const DEFAULT_USER_FIELDS = [
    {
        id: 'name',
        name: 'Name',
        required: false,
        slug: 'name',
        type: 'PlainText',
        validations: {}
    },
    {
        id: 'email',
        name: 'Email',
        required: true,
        slug: 'email',
        type: 'Email',
        validations: {}
    },
    {
        id: 'password',
        name: 'Password',
        required: true,
        slug: 'password',
        type: 'Password',
        validations: {}
    },
    {
        id: 'acceptPrivacy',
        name: 'Accept privacy',
        required: false,
        slug: 'accept-privacy',
        type: 'Bool',
        validations: {}
    },
    {
        id: 'acceptCommunications',
        name: 'Accept communications',
        required: false,
        slug: 'accept-communications',
        type: 'Bool',
        validations: {}
    }
];
const SETUP_GUIDE_KEYS = {
    hasVisitedAccessDeniedPage: 'hasVisitedAccessDeniedPage',
    hasVisitedLoginPage: 'hasVisitedLoginPage',
    hasVisitedSignUpPage: 'hasVisitedSignUpPage',
    hasVisitedUserAccountSettings: 'hasVisitedUserAccountSettings',
    hasVisitedUserAccountPage: 'hasVisitedUserAccountPage'
};
const SETUP_GUIDE_ALL_KEYS = {
    ...SETUP_GUIDE_KEYS,
    hasHostingPlan: 'hasHostingPlan',
    hasEcommerce: 'hasEcommerce',
    hasEnabledSSL: 'hasEnabledSSL',
    hasUsers: 'hasUsers',
    hasAccessGroups: 'hasAccessGroups',
    hasRestrictedContent: 'hasRestrictedContent',
    hasRestrictedProducts: 'hasRestrictedProducts'
};
const MAX_USER_DATA_FIELDS = 20;
const MAX_UPDATE_USER_DATA_FIELDS = MAX_USER_DATA_FIELDS + 2;
const USER_ACCESS_META_OPTIONS = [
    _types.USYS_ACCESS_TYPES.LOGGED_IN
];
const EXCEEDS_MAX_FILE_SIZE_ERROR = 'Maximum size allowed for a file upload is 10000kb / 10mb.';
const EXCEEDS_MAX_IMAGE_SIZE_ERROR = 'Maximum size allowed for a image upload is 4000kb / 4mb.';
const NO_REQUIRED_ATTRIBUTE = [
    'FileRef',
    'Bool'
];
const USER_STATUSES = {
    invited: 'Invited',
    verified: 'Verified',
    unverified: 'Unverified'
};
const USER_PAGE_SIZE = 100;
// User CSV Import constants
const USER_CSV_IMPORT_STATUS_POLLING_TIMEOUT = 20 * 60 * 1000;
const USER_CSV_IMPORT_STATUS_POLLING_INTERVAL = 5000;
const USER_CSV_IMPORT_STATUS_MAX_TRIES = Math.floor(USER_CSV_IMPORT_STATUS_POLLING_TIMEOUT / USER_CSV_IMPORT_STATUS_POLLING_INTERVAL);

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7Rmxvd0xhbmd9IGZyb20gJ2Zsb3ctdG8tdHlwZXNjcmlwdC1jb2RlbW9kJztcbmltcG9ydCB7dmFsdWVzfSBmcm9tICdAcGFja2FnZXMvdXRpbGl0aWVzL2ZwL3V0aWxzJztcbmltcG9ydCB7dHlwZSBVc2VyQWNjZXNzTWV0YSwgVVNZU19BQ0NFU1NfVFlQRVN9IGZyb20gJy4vdHlwZXMnO1xuZXhwb3J0ICogZnJvbSAnLi9lcnJvclN0YXRlcyc7XG5leHBvcnQgKiBmcm9tICcuL3R5cGVzJztcblxuZXhwb3J0IHR5cGUgVXN5c1V0aWxLZXlUeXBlID0ga2V5b2YgdHlwZW9mIFVTWVNfVVRJTElUWV9LRVlTO1xuZXhwb3J0IHR5cGUgVXN5c0Zvcm1UeXBlID0ga2V5b2YgdHlwZW9mIFVTWVNfRk9STV9UWVBFUztcbmV4cG9ydCB0eXBlIE1lbWJlcnNoaXBzRW1haWxUeXBlID0ga2V5b2YgdHlwZW9mIE1FTUJFUlNISVBTX0VNQUlMX0tFWVM7XG5leHBvcnQgdHlwZSBVc2Vyc1NldHVwR3VpZGVUeXBlID0gRmxvd0xhbmcuT2JqTWFwPFxuICB0eXBlb2YgU0VUVVBfR1VJREVfS0VZUyxcbiAgKCkgPT4gYm9vbGVhblxuPjtcbmV4cG9ydCB0eXBlIFVzZXJTZXR1cEd1aWRlS2V5cyA9IGtleW9mIHR5cGVvZiBTRVRVUF9HVUlERV9LRVlTO1xuZXhwb3J0IHR5cGUgVXN5c1V0aWxLZXlNYXA8Vj4gPSBGbG93TGFuZy5PYmpNYXA8XG4gIHR5cGVvZiBVU1lTX1VUSUxJVFlfS0VZUyxcbiAgPFQ+KGFyZzE6IFQpID0+IFZcbj47XG5leHBvcnQgdHlwZSBVc2VyU3RhdHVzZXMgPSBrZXlvZiB0eXBlb2YgVVNFUl9TVEFUVVNFUztcblxuZXhwb3J0IGNvbnN0IFJFU0VSVkVEX1VTRVJfUFJFRklYID0gJ3dmLXVzZXItZmllbGQtJztcblxuZXhwb3J0IGNvbnN0IFJFU0VSVkVEX1VTRVJfRklFTERTID0ge1xuICBuYW1lOiBSRVNFUlZFRF9VU0VSX1BSRUZJWCArICduYW1lJyxcbiAgYWNjZXB0UHJpdmFjeTogUkVTRVJWRURfVVNFUl9QUkVGSVggKyAnYWNjZXB0LXByaXZhY3knLFxuICBhY2NlcHRDb21tdW5pY2F0aW9uczogUkVTRVJWRURfVVNFUl9QUkVGSVggKyAnYWNjZXB0LWNvbW11bmljYXRpb25zJyxcbn0gYXMgY29uc3Q7XG5cbmV4cG9ydCBjb25zdCBLRVlfRlJPTV9SRVNFUlZFRF9VU0VSX0ZJRUxEID0ge1xuICBbUkVTRVJWRURfVVNFUl9QUkVGSVggKyAnbmFtZSddOiAnbmFtZScsXG4gIFtSRVNFUlZFRF9VU0VSX1BSRUZJWCArICdhY2NlcHQtcHJpdmFjeSddOiAnYWNjZXB0UHJpdmFjeScsXG4gIFtSRVNFUlZFRF9VU0VSX1BSRUZJWCArICdhY2NlcHQtY29tbXVuaWNhdGlvbnMnXTogJ2FjY2VwdENvbW11bmljYXRpb25zJyxcbn0gYXMgY29uc3Q7XG5cbmV4cG9ydCBjb25zdCBOQU1FU19GUk9NX1VTRVJfRklFTERTID0ge1xuICBbUkVTRVJWRURfVVNFUl9QUkVGSVggKyAnbmFtZSddOiAnTmFtZScsXG4gIFtSRVNFUlZFRF9VU0VSX1BSRUZJWCArICdhY2NlcHQtcHJpdmFjeSddOiAnQWNjZXB0IHByaXZhY3kgcG9saWN5JyxcbiAgW1JFU0VSVkVEX1VTRVJfUFJFRklYICsgJ2FjY2VwdC1jb21tdW5pY2F0aW9ucyddOiAnQWNjZXB0IGNvbW11bmljYXRpb25zJyxcbiAgUFJJVkFDWV9QT0xJQ1k6ICdBY2NlcHQgcHJpdmFjeSBwb2xpY3knLFxuICBQQVNTV09SRDogJ1Bhc3N3b3JkJyxcbiAgRU1BSUw6ICdFbWFpbCcsXG59IGFzIGNvbnN0O1xuXG5leHBvcnQgY29uc3QgVEVYVF9JTlBVVF9UWVBFX1RPX0ZJRUxEX1RZUEUgPSB7XG4gIHRleHQ6ICdQbGFpblRleHQnLFxuICBwYXNzd29yZDogJ1Bhc3N3b3JkJyxcbiAgZW1haWw6ICdFbWFpbCcsXG4gIG51bWJlcjogJ1BsYWluVGV4dCcsXG4gIHRlbDogJ1BsYWluVGV4dCcsXG59IGFzIGNvbnN0O1xuXG5leHBvcnQgY29uc3QgVVNZU19VVElMSVRZX0tFWVMgPSB7XG4gICd1c3lzLWxvZy1pbic6ICd1c3lzLWxvZy1pbicsXG4gICd1c3lzLXNpZ24tdXAnOiAndXN5cy1zaWduLXVwJyxcbiAgJ3VzeXMtcmVzZXQtcGFzc3dvcmQnOiAndXN5cy1yZXNldC1wYXNzd29yZCcsXG4gICd1c3lzLXVwZGF0ZS1wYXNzd29yZCc6ICd1c3lzLXVwZGF0ZS1wYXNzd29yZCcsXG4gICd1c3lzLWFjY2Vzcy1kZW5pZWQnOiAndXN5cy1hY2Nlc3MtZGVuaWVkJyxcbiAgJ3VzeXMtdXNlci1hY2NvdW50JzogJ3VzeXMtdXNlci1hY2NvdW50Jyxcbn0gYXMgY29uc3Q7XG5cbmV4cG9ydCBjb25zdCBVU1lTX0RBVEFfQVRUUlMgPSB7XG4gIGZvcm1UeXBlOiAnZGF0YS13Zi11c2VyLWZvcm0tdHlwZScsXG4gIGlucHV0VHlwZTogJ2RhdGEtd2YtdXNlci1mb3JtLWlucHV0LXR5cGUnLFxuICBsb2dvdXQ6ICdkYXRhLXdmLXVzZXItbG9nb3V0JyxcbiAgbG9naW46ICdkYXRhLXdmLXVzZXItbG9naW4nLFxuICBmb3JtRXJyb3I6ICdkYXRhLXdmLXVzZXItZm9ybS1lcnJvcicsXG4gIHJlZGlyZWN0VXJsOiAnZGF0YS13Zi11c2VyLWZvcm0tcmVkaXJlY3QnLFxuICBmb3JtVmVyaWZpY2F0aW9uOiAnZGF0YS13Zi11c2VyLWZvcm0tdmVyaWZpY2F0aW9uJyxcbiAgdXNlclN1YnNjcmlwdGlvbnM6ICdkYXRhLXdmLXVzZXItc3Vic2NyaXB0aW9ucy1saXN0JyxcbiAgdXNlclN1YnNjcmlwdGlvbnNFbXB0eVN0YXRlOiAnZGF0YS13Zi11c2VyLXN1YnNjcmlwdGlvbnMtZW1wdHknLFxuICB1c2VyQWNjb3VudDogJ2RhdGEtd2YtdXNlci1hY2NvdW50JyxcbiAgc3Vic2NyaXB0aW9uQ2FuY2VsOiAnZGF0YS13Zi11c2VyLXN1YnNjcmlwdGlvbi1jYW5jZWwnLFxuICB1c2VySWQ6ICdkYXRhLXdmLXVzZXItaWQnLFxuICBmaWVsZDogJ2RhdGEtd2YtdXNlci1maWVsZCcsXG4gIGZpZWxkVHlwZTogJ2RhdGEtd2YtdXNlci1maWVsZC10eXBlJyxcbiAgZmlsZVVwbG9hZEtleTogJ2RhdGEtd2YtdXNlci1maWxlLXVwbG9hZC1rZXknLFxuICB1bnNhdmVkRmlsZVVwbG9hZEtleTogJ2RhdGEtd2YtdW5zYXZlZC11c2VyLWZpbGUtdXBsb2FkLWtleScsXG59IGFzIGNvbnN0O1xuXG5leHBvcnQgY29uc3QgVVNZU19ET01fQ0xBU1NfTkFNRVMgPSB7XG4gIGZvcm1TdWNjZXNzOiAndy1mb3JtLXN1Y2Nlc3MnLFxuICBmb3JtVmVyZmljYXRpb246ICd3LWZvcm0tdmVyaWZpY2F0aW9uJyxcbiAgZm9ybUVycm9yOiAndy1mb3JtLWZhaWwnLFxufSBhcyBjb25zdDtcblxuZXhwb3J0IGNvbnN0IFVTWVNfRk9STV9UWVBFUyA9IHtcbiAgbG9naW46ICdsb2dpbicsXG4gIHNpZ251cDogJ3NpZ251cCcsXG4gIHVwZGF0ZVBhc3N3b3JkOiAndXBkYXRlUGFzc3dvcmQnLFxuICByZXNldFBhc3N3b3JkOiAncmVzZXRQYXNzd29yZCcsXG4gIGFjY291bnQ6ICd1c2VyQWNjb3VudCcsXG59IGFzIGNvbnN0O1xuXG5leHBvcnQgY29uc3QgVVNZU19JTlBVVF9UWVBFUyA9IHtcbiAgZW1haWw6ICdlbWFpbCcsXG4gIG5hbWU6ICduYW1lJyxcbiAgcGFzc3dvcmQ6ICdwYXNzd29yZCcsXG4gIGFjY2VwdFByaXZhY3k6ICdhY2NlcHQtcHJpdmFjeScsXG59IGFzIGNvbnN0O1xuXG5leHBvcnQgY29uc3QgVVNZU19JTlBVVF9TSUdOX1VQX0lEUyA9IHtcbiAgZW1haWw6ICd3Zi1zaWduLXVwLWVtYWlsJyxcbiAgbmFtZTogJ3dmLXNpZ24tdXAtbmFtZScsXG4gIHBhc3N3b3JkOiAnd2Ytc2lnbi11cC1wYXNzd29yZCcsXG4gIGFjY2VwdFByaXZhY3k6ICd3Zi1zaWduLXVwLWFjY2VwdC1wcml2YWN5JyxcbiAgYWNjZXB0Q29tbXVuaWNhdGlvbnM6ICd3Zi1zaWduLXVwLWFjY2VwdC1jb21tdW5pY2F0aW9ucycsXG59IGFzIGNvbnN0O1xuXG5leHBvcnQgY29uc3QgVVNZU19VU0VSX1NUQVRFUyA9IHtcbiAgbG9nZ2VkSW46ICdsb2dnZWRJbicsXG4gIGxvZ2dlZE91dDogJ2xvZ2dlZE91dCcsXG59IGFzIGNvbnN0O1xuXG4vLyBTb3VyY2Ugb2YgdHJ1dGggZm9yIGFsbCB1c2VyIHN5c3RlbXMgdGVtcGxhdGUgcGFnZSBzZXR0aW5nc1xuZXhwb3J0IGNvbnN0IFVTWVNfUEFHRV9TRVRUSU5HUyA9IHtcbiAgbG9naW46IHtcbiAgICBwYXJlbnQ6IG51bGwsXG4gICAgc29ydFBvczogMCxcbiAgICB1dGlsS2V5OiAndXN5cy1sb2ctaW4nLFxuICAgIHNsdWc6ICdsb2ctaW4nLFxuICAgIHRpdGxlOiAnTG9nIEluJyxcbiAgfSxcbiAgc2lnbnVwOiB7XG4gICAgcGFyZW50OiBudWxsLFxuICAgIHNvcnRQb3M6IDEsXG4gICAgdXRpbEtleTogJ3VzeXMtc2lnbi11cCcsXG4gICAgc2x1ZzogJ3NpZ24tdXAnLFxuICAgIHRpdGxlOiAnU2lnbiBVcCcsXG4gIH0sXG4gIHJlc2V0UGFzc3dvcmQ6IHtcbiAgICBwYXJlbnQ6IG51bGwsXG4gICAgc29ydFBvczogMixcbiAgICB1dGlsS2V5OiAndXN5cy1yZXNldC1wYXNzd29yZCcsXG4gICAgc2x1ZzogJ3Jlc2V0LXBhc3N3b3JkJyxcbiAgICB0aXRsZTogJ1Jlc2V0IFBhc3N3b3JkJyxcbiAgfSxcbiAgdXBkYXRlUGFzc3dvcmQ6IHtcbiAgICBwYXJlbnQ6IG51bGwsXG4gICAgc29ydFBvczogMyxcbiAgICB1dGlsS2V5OiAndXN5cy11cGRhdGUtcGFzc3dvcmQnLFxuICAgIHNsdWc6ICd1cGRhdGUtcGFzc3dvcmQnLFxuICAgIHRpdGxlOiAnVXBkYXRlIFBhc3N3b3JkJyxcbiAgfSxcbiAgYWNjZXNzRGVuaWVkOiB7XG4gICAgcGFyZW50OiBudWxsLFxuICAgIHNvcnRQb3M6IDQsXG4gICAgdXRpbEtleTogJ3VzeXMtYWNjZXNzLWRlbmllZCcsXG4gICAgc2x1ZzogJ2FjY2Vzcy1kZW5pZWQnLFxuICAgIHRpdGxlOiAnQWNjZXNzIERlbmllZCcsXG4gIH0sXG4gIHVzZXJBY2NvdW50OiB7XG4gICAgcGFyZW50OiBudWxsLFxuICAgIHNvcnRQb3M6IDUsXG4gICAgdXRpbEtleTogJ3VzeXMtdXNlci1hY2NvdW50JyxcbiAgICBzbHVnOiAndXNlci1hY2NvdW50JyxcbiAgICB0aXRsZTogJ1VzZXIgQWNjb3VudCcsXG4gIH0sXG59IGFzIGNvbnN0O1xuXG5leHBvcnQgY29uc3QgVVNZU19SRVNFUlZFRF9TTFVHUyA9IHZhbHVlcyhVU1lTX1BBR0VfU0VUVElOR1MpLm1hcDxzdHJpbmc+KFxuICAocGFnZVNldHRpbmdzKSA9PiBwYWdlU2V0dGluZ3Muc2x1Z1xuKTtcblxuZXhwb3J0IGNvbnN0IFVTWVNfUEFHRV9VVElMX0tFWVMgPSB2YWx1ZXMoVVNZU19QQUdFX1NFVFRJTkdTKS5tYXA8c3RyaW5nPihcbiAgKHBhZ2VTZXR0aW5ncykgPT4gcGFnZVNldHRpbmdzLnV0aWxLZXlcbik7XG5cbi8vIGZvciBicmFuZCBzdHlsaW5nIGluIGVtYWlsc1xuZXhwb3J0IGNvbnN0IERFRkFVTFRfU1RZTEVTID0ge1xuICBhY2NlbnRDb2xvcjogJyM0NjhFRTUnLFxuICBiZ0NvbG9yOiAnI0Y1RjZGNycsXG4gIGluY2x1ZGVXZkJyYW5kOiB0cnVlLFxufSBhcyBjb25zdDtcblxuLy8gVGhlIGxlbmd0aCBleHByZXNzZWQgaGVyZSBpcyBpbiBieXRlcywgdGhhdCBtZWFucyB0aGF0IHNvbWUgY2hhcmFjdGVycyB3aWxsXG4vLyBjb3VudCBhcyBtb3JlIHRoYW4gMSBieXRlLCBsaWtlOiDDoSwgw6ksIMOtLCDDsywgw7osIGV0Yy5cbmV4cG9ydCBjb25zdCBQQVNTV09SRF9NSU5fTEVOR1RIID0gODtcbmV4cG9ydCBjb25zdCBQQVNTV09SRF9NQVhfTEVOR1RIID0gNzI7XG5cbi8vIEhlbHBlciBjb25zdGFudHMuXG5jb25zdCBTRUNPTkQgPSAxMDAwO1xuY29uc3QgTUlOVVRFID0gNjAgKiBTRUNPTkQ7XG5jb25zdCBIT1VSID0gNjAgKiBNSU5VVEU7XG5jb25zdCBEQVkgPSAyNCAqIEhPVVI7XG5cbmV4cG9ydCBjb25zdCBTRVNTSU9OX0NPT0tJRV9OQU1FID0gJ3dmX3NpZCc7XG5leHBvcnQgY29uc3QgTE9HR0VESU5fQ09PS0lFX05BTUUgPSAnd2ZfbG9nZ2VkaW4nO1xuZXhwb3J0IGNvbnN0IERFRkFVTFRfU0VTU0lPTl9EVVJBVElPTl9JTl9NUyA9IDcgKiBEQVk7XG5leHBvcnQgY29uc3QgREVGQVVMVF9TRVNTSU9OX1RPS0VOX0RVUkFUSU9OX0lOX01TID0gNCAqIEhPVVI7XG5leHBvcnQgY29uc3QgREVGQVVMVF9UT0tFTl9BR0VfTVMgPSBIT1VSO1xuXG4vLyBUaGUgbWF4aW11bSBudW1iZXIgb2YgdXNlcnMgdGhhdCBhIGZyZWUgc2l0ZSBjYW4gaGF2ZS4gQSBmcmVlIHNpdGUgaW4gdGhpc1xuLy8gY2FzZSBtZWFucyBhIHNpdGUgdGhhdCBkb2Vzbid0IGhhdmUgYSBzaXRlIHBsYW4uXG5leHBvcnQgY29uc3QgU1RBUlRFUl9NQVhfTlVNX1VTRVJTID0gMTAwO1xuZXhwb3J0IGNvbnN0IEJBU0lDX01BWF9OVU1fVVNFUlMgPSAyMDAwMDtcbmV4cG9ydCBjb25zdCBCVVNJTkVTU19NQVhfTlVNX1VTRVJTID0gMjAwMDA7XG5leHBvcnQgY29uc3QgRUNPTU1fU1RBTkRBUkRfTUFYX05VTV9VU0VSUyA9IDIwMDAwO1xuZXhwb3J0IGNvbnN0IEVDT01NX1BMVVNfTUFYX05VTV9VU0VSUyA9IDIwMDAwO1xuLy8gSW4gc29tZSBjYXNlcywgd2UgbWlnaHQgd2FudCB0byBoYXZlIHNvbWUgc2l0ZXMgZ28gb3ZlciB0aGVpciBwbGFuIGxpbWl0LlxuLy8gSG93ZXZlciwgZm9yIHNhZmV0eSB3ZSBzaG91bGQgYWx3YXlzIGhhdmUgYSBoYXJkIGxpbWl0IGZvciBvdXIgc3lzdGVtLiBUaGlzXG4vLyBsaW1pdCBjYW4gYmUgaW5jcmVhc2VkIGJ1dCBzaG91bGQgYmUgZG9uZSBncmFkdWFsbHkgYXMgd2UgbGVhcm4gYWJvdXQgb3VyXG4vLyBjdXN0b21lcnMgbmVlZHMuXG5leHBvcnQgY29uc3QgSEFSRF9MSU1JVF9NQVhfTlVNX1VTRVJTID0gMTAwICogMTAwMDtcblxudHlwZSBTdWJzY3JpcHRpb25Vc2VyTGltaXRzID0ge1xuICBmcmVlOiBudW1iZXI7XG4gIHN0YXRpYzogbnVtYmVyO1xuICBjbXM6IG51bWJlcjtcbiAgYnVzaW5lc3M6IG51bWJlcjtcbiAgZWNvbW1lcmNlX3N0YW5kYXJkOiBudW1iZXI7XG4gIGVjb21tZXJjZV9wbHVzOiBudW1iZXI7XG4gIGVjb21tZXJjZV9hZHZhbmNlZDogbnVtYmVyO1xuICBlbnRlcnByaXNlOiBudW1iZXI7XG4gIGVudGVycHJpc2VfbGl0ZTogbnVtYmVyO1xufTtcblxuLy8gTWFwIHVzZXIgbGltaXRzIHRvIHNpdGVTdWJzY3JpcHRpb24gdHlwZXMgZGVmaW5lZCBpblxuLy8gcGFja2FnZXMvc3lzdGVtcy9kZXNpZ25lci9zaXRlLWRhdGEvU2l0ZURhdGFTdGF0ZVR5cGUuanNcbmV4cG9ydCBjb25zdCBTVUJTQ1JJUFRJT05fVVNFUl9MSU1JVFM6IFN1YnNjcmlwdGlvblVzZXJMaW1pdHMgPSB7XG4gIGZyZWU6IFNUQVJURVJfTUFYX05VTV9VU0VSUyxcbiAgc3RhdGljOiBCQVNJQ19NQVhfTlVNX1VTRVJTLFxuICBjbXM6IEJVU0lORVNTX01BWF9OVU1fVVNFUlMsXG4gIGJ1c2luZXNzOiBCVVNJTkVTU19NQVhfTlVNX1VTRVJTLFxuICBlY29tbWVyY2Vfc3RhbmRhcmQ6IEVDT01NX1NUQU5EQVJEX01BWF9OVU1fVVNFUlMsXG4gIGVjb21tZXJjZV9wbHVzOiBFQ09NTV9QTFVTX01BWF9OVU1fVVNFUlMsXG4gIGVjb21tZXJjZV9hZHZhbmNlZDogQlVTSU5FU1NfTUFYX05VTV9VU0VSUyxcbiAgZW50ZXJwcmlzZTogQlVTSU5FU1NfTUFYX05VTV9VU0VSUyxcbiAgZW50ZXJwcmlzZV9saXRlOiBCVVNJTkVTU19NQVhfTlVNX1VTRVJTLFxufTtcblxuZXhwb3J0IGNvbnN0IE1BWF9OVU1fR1JPVVBTID0gMjA7XG5leHBvcnQgY29uc3QgTUlOX0dST1VQX0lEX0xFTkdUSCA9IDI7XG5leHBvcnQgY29uc3QgTUFYX0dST1VQX0lEX0xFTkdUSCA9IDI7XG5cbmV4cG9ydCBjb25zdCBVU1lTX1RPS0VOX1RZUEVTID0ge1xuICBpbnZpdGVVc2VyOiAnaW52aXRlVXNlcicsXG4gIHJlc2V0UGFzc3dvcmQ6ICdyZXNldFBhc3N3b3JkJyxcbiAgdmVyaWZ5RW1haWw6ICd2ZXJpZnlFbWFpbCcsXG59IGFzIGNvbnN0O1xuXG5leHBvcnQgY29uc3QgQUNDRVNTX0dST1VQX0lOTElORV9QUk9EVUNUX0ZJRUxEX1NMVUcgPVxuICAnYWNjZXNzLWdyb3VwLW1lbWJlcnNoaXAtcHJvZHVjdCc7XG5cbmV4cG9ydCBjb25zdCBBQ0NFU1NfR1JPVVBfQURNSVNTSU9OX1RZUEUgPSB7XG4gIGZyZWU6ICdmcmVlJyxcbiAgcGFpZDogJ3BhaWQnLFxufSBhcyBjb25zdDtcblxuZXhwb3J0IGNvbnN0IEFDQ0VTU19HUk9VUF9GUkVFX1RZUEUgPSB7XG4gIGFsbDogJ2FsbCcsXG4gIGFkbWluOiAnYWRtaW4nLFxufSBhcyBjb25zdDtcblxuLy8gKioqKiBFbWFpbHMgKioqKiAvL1xuXG5leHBvcnQgY29uc3QgU1VCU0NSSVBUSU9OX0VNQUlMX1RZUEVTID0ge1xuICBQQVlNRU5UX0ZBSUxFRDogJ3BheW1lbnRGYWlsZWQnLFxuICBQQVlNRU5UX1NVQ0NFU1NGVUw6ICdwYXltZW50U3VjY2Vzc2Z1bCcsXG4gIFNVQlNDUklQVElPTl9DQU5DRUxFRDogJ3N1YnNjcmlwdGlvbkNhbmNlbGVkJyxcbiAgVkVSSUZZX1BBWU1FTlQ6ICd2ZXJpZnlQYXltZW50Jyxcbn0gYXMgY29uc3Q7XG5cbmV4cG9ydCBjb25zdCBNRU1CRVJTSElQU19FTUFJTF9LRVlTID0ge1xuICBpbnZpdGU6ICdpbnZpdGUnLFxuICByZXNldFBhc3N3b3JkOiAncmVzZXRQYXNzd29yZCcsXG4gIHVwZGF0ZWRQYXNzd29yZDogJ3VwZGF0ZWRQYXNzd29yZCcsXG4gIHdlbGNvbWU6ICd3ZWxjb21lJyxcbiAgdmVyaWZ5OiAndmVyaWZ5Jyxcbn0gYXMgY29uc3Q7XG5cbmV4cG9ydCBjb25zdCBFTUFJTF9URU1QTEFURV9UWVBFUyA9IHtcbiAgaW52aXRlOiAnTUVNQkVSU0hJUFNfSU5WSVRFJyxcbiAgcmVzZXRQYXNzd29yZDogJ01FTUJFUlNISVBTX1JFU0VUX1BBU1NXT1JEJyxcbiAgdXBkYXRlZFBhc3N3b3JkOiAnTUVNQkVSU0hJUFNfVVBEQVRFRF9QQVNTV09SRCcsXG4gIHZlcmlmeTogJ01FTUJFUlNISVBTX1ZFUklGWScsXG4gIHdlbGNvbWU6ICdNRU1CRVJTSElQU19XRUxDT01FJyxcbn0gYXMgY29uc3Q7XG5cbmV4cG9ydCBjb25zdCBDT05GSVJNX1VOU0FWRURfQ0hBTkdFU19DT1BZID0ge1xuICB0aXRsZTogJ0NvbnRpbnVlIHdpdGhvdXQgc2F2aW5nPycsXG4gIGNvbnRlbnQ6ICdZb3VyIGNoYW5nZXMgd2lsbCBiZSBsb3N0LicsXG4gIGljb25UeXBlOiAnd2FybmluZycsXG4gIHN1Ym1pdDoge2xhYmVsOiAnQ29udGludWUnLCBpbnRlbnQ6ICdkYW5nZXInfSxcbiAgY2FuY2VsOiB7bGFiZWw6ICdDYW5jZWwnLCBpbnRlbnQ6ICdkZWZhdWx0J30sXG59IGFzIGNvbnN0O1xuXG4vLyAqKioqIFVzZXIgYWNjb3VudCBzZXR0aW5ncyAqKioqIC8vXG5cbmV4cG9ydCBjb25zdCBVU0VSX0ZJRUxEX0ZPUk1fSUQgPSAnVXNlckZpZWxkRm9ybSc7XG5cbmV4cG9ydCBjb25zdCBORVdfVVNFUl9GSUVMRF9JRCA9ICdtaW50LXVzZXItZmllbGQnO1xuXG5leHBvcnQgY29uc3QgVVNFUl9GSUVMRF9ERUZBVUxUUyA9IHtcbiAgUGxhaW5UZXh0OiB7XG4gICAgaWQ6IE5FV19VU0VSX0ZJRUxEX0lELFxuICAgIG5hbWU6ICcnLFxuICAgIHNsdWc6ICcnLFxuICAgIHJlcXVpcmVkOiBmYWxzZSxcbiAgICB0eXBlOiAnUGxhaW5UZXh0JyxcbiAgICB2YWxpZGF0aW9uczoge30sXG4gIH0sXG4gIEVtYWlsOiB7XG4gICAgaWQ6IE5FV19VU0VSX0ZJRUxEX0lELFxuICAgIG5hbWU6ICcnLFxuICAgIHNsdWc6ICcnLFxuICAgIHJlcXVpcmVkOiBmYWxzZSxcbiAgICB0eXBlOiAnRW1haWwnLFxuICAgIHZhbGlkYXRpb25zOiB7fSxcbiAgfSxcbiAgQm9vbDoge1xuICAgIGlkOiBORVdfVVNFUl9GSUVMRF9JRCxcbiAgICBuYW1lOiAnJyxcbiAgICBzbHVnOiAnJyxcbiAgICByZXF1aXJlZDogZmFsc2UsXG4gICAgdHlwZTogJ0Jvb2wnLFxuICAgIHZhbGlkYXRpb25zOiB7fSxcbiAgfSxcbiAgRmlsZVJlZjoge1xuICAgIGlkOiBORVdfVVNFUl9GSUVMRF9JRCxcbiAgICBuYW1lOiAnJyxcbiAgICBzbHVnOiAnJyxcbiAgICByZXF1aXJlZDogZmFsc2UsXG4gICAgdHlwZTogJ0ZpbGVSZWYnLFxuICAgIHZhbGlkYXRpb25zOiB7fSxcbiAgfSxcbiAgT3B0aW9uOiB7XG4gICAgaWQ6IE5FV19VU0VSX0ZJRUxEX0lELFxuICAgIG5hbWU6ICcnLFxuICAgIHNsdWc6ICcnLFxuICAgIHJlcXVpcmVkOiBmYWxzZSxcbiAgICB0eXBlOiAnT3B0aW9uJyxcbiAgICB2YWxpZGF0aW9uczoge1xuICAgICAgb3B0aW9uczogW10sXG4gICAgfSxcbiAgfSxcbiAgUGFzc3dvcmQ6IHtcbiAgICBpZDogTkVXX1VTRVJfRklFTERfSUQsXG4gICAgbmFtZTogJ1Bhc3N3b3JkJyxcbiAgICBzbHVnOiAnJyxcbiAgICByZXF1aXJlZDogdHJ1ZSxcbiAgICB0eXBlOiAnUGFzc3dvcmQnLFxuICAgIHZhbGlkYXRpb25zOiB7fSxcbiAgfSxcbiAgTnVtYmVyOiB7XG4gICAgaWQ6IE5FV19VU0VSX0ZJRUxEX0lELFxuICAgIG5hbWU6ICcnLFxuICAgIHNsdWc6ICcnLFxuICAgIHJlcXVpcmVkOiBmYWxzZSxcbiAgICB0eXBlOiAnTnVtYmVyJyxcbiAgICB2YWxpZGF0aW9uczoge1xuICAgICAgbWluOiAwLFxuICAgICAgc3RlcDogMSxcbiAgICB9LFxuICB9LFxuICBMaW5rOiB7XG4gICAgaWQ6IE5FV19VU0VSX0ZJRUxEX0lELFxuICAgIG5hbWU6ICcnLFxuICAgIHNsdWc6ICcnLFxuICAgIHJlcXVpcmVkOiBmYWxzZSxcbiAgICB0eXBlOiAnTGluaycsXG4gICAgdmFsaWRhdGlvbnM6IHt9LFxuICB9LFxufSBhcyBjb25zdDtcblxuZXhwb3J0IGNvbnN0IERFRkFVTFRfVVNFUl9GSUVMRFMgPSBbXG4gIHtcbiAgICBpZDogJ25hbWUnLFxuICAgIG5hbWU6ICdOYW1lJyxcbiAgICByZXF1aXJlZDogZmFsc2UsXG4gICAgc2x1ZzogJ25hbWUnLFxuICAgIHR5cGU6ICdQbGFpblRleHQnLFxuICAgIHZhbGlkYXRpb25zOiB7fSxcbiAgfSxcbiAge1xuICAgIGlkOiAnZW1haWwnLFxuICAgIG5hbWU6ICdFbWFpbCcsXG4gICAgcmVxdWlyZWQ6IHRydWUsXG4gICAgc2x1ZzogJ2VtYWlsJyxcbiAgICB0eXBlOiAnRW1haWwnLFxuICAgIHZhbGlkYXRpb25zOiB7fSxcbiAgfSxcbiAge1xuICAgIGlkOiAncGFzc3dvcmQnLFxuICAgIG5hbWU6ICdQYXNzd29yZCcsXG4gICAgcmVxdWlyZWQ6IHRydWUsXG4gICAgc2x1ZzogJ3Bhc3N3b3JkJyxcbiAgICB0eXBlOiAnUGFzc3dvcmQnLFxuICAgIHZhbGlkYXRpb25zOiB7fSxcbiAgfSxcbiAge1xuICAgIGlkOiAnYWNjZXB0UHJpdmFjeScsXG4gICAgbmFtZTogJ0FjY2VwdCBwcml2YWN5JyxcbiAgICByZXF1aXJlZDogZmFsc2UsXG4gICAgc2x1ZzogJ2FjY2VwdC1wcml2YWN5JyxcbiAgICB0eXBlOiAnQm9vbCcsXG4gICAgdmFsaWRhdGlvbnM6IHt9LFxuICB9LFxuICB7XG4gICAgaWQ6ICdhY2NlcHRDb21tdW5pY2F0aW9ucycsXG4gICAgbmFtZTogJ0FjY2VwdCBjb21tdW5pY2F0aW9ucycsXG4gICAgcmVxdWlyZWQ6IGZhbHNlLFxuICAgIHNsdWc6ICdhY2NlcHQtY29tbXVuaWNhdGlvbnMnLFxuICAgIHR5cGU6ICdCb29sJyxcbiAgICB2YWxpZGF0aW9uczoge30sXG4gIH0sXG5dIGFzIGNvbnN0O1xuXG4vLyBDb250YWlucyB0aGUga2V5cyB0aGF0IHVzeXNTZXR0aW5ncyBzdG9yZXNcbmV4cG9ydCBjb25zdCBTRVRVUF9HVUlERV9LRVlTID0ge1xuICBoYXNWaXNpdGVkQWNjZXNzRGVuaWVkUGFnZTogJ2hhc1Zpc2l0ZWRBY2Nlc3NEZW5pZWRQYWdlJyxcbiAgaGFzVmlzaXRlZExvZ2luUGFnZTogJ2hhc1Zpc2l0ZWRMb2dpblBhZ2UnLFxuICBoYXNWaXNpdGVkU2lnblVwUGFnZTogJ2hhc1Zpc2l0ZWRTaWduVXBQYWdlJyxcbiAgaGFzVmlzaXRlZFVzZXJBY2NvdW50U2V0dGluZ3M6ICdoYXNWaXNpdGVkVXNlckFjY291bnRTZXR0aW5ncycsXG4gIGhhc1Zpc2l0ZWRVc2VyQWNjb3VudFBhZ2U6ICdoYXNWaXNpdGVkVXNlckFjY291bnRQYWdlJyxcbn0gYXMgY29uc3Q7XG5cbi8vIENvbnRhaW5zIGFsbCB0aGUgc2V0dXAgZ3VpZGUga2V5cywgc2VydmVyIGFuZCBmcm9udGVuZC1vbmx5XG5leHBvcnQgY29uc3QgU0VUVVBfR1VJREVfQUxMX0tFWVMgPSB7XG4gIC4uLlNFVFVQX0dVSURFX0tFWVMsXG4gIGhhc0hvc3RpbmdQbGFuOiAnaGFzSG9zdGluZ1BsYW4nLFxuICBoYXNFY29tbWVyY2U6ICdoYXNFY29tbWVyY2UnLFxuICBoYXNFbmFibGVkU1NMOiAnaGFzRW5hYmxlZFNTTCcsXG4gIGhhc1VzZXJzOiAnaGFzVXNlcnMnLFxuICBoYXNBY2Nlc3NHcm91cHM6ICdoYXNBY2Nlc3NHcm91cHMnLFxuICBoYXNSZXN0cmljdGVkQ29udGVudDogJ2hhc1Jlc3RyaWN0ZWRDb250ZW50JyxcbiAgaGFzUmVzdHJpY3RlZFByb2R1Y3RzOiAnaGFzUmVzdHJpY3RlZFByb2R1Y3RzJyxcbn0gYXMgY29uc3Q7XG5cbmV4cG9ydCBjb25zdCBNQVhfVVNFUl9EQVRBX0ZJRUxEUyA9IDIwO1xuXG4vLyBgbmFtZWAgYW5kIGBhY2NlcHQtY29tbXVuaWNhdGlvbnNgIGNvbW1vbiBmaWVsZHMgY2FuIGFsc28gYmUgdXBkYXRlZFxuLy8gYWxvbmcgd2l0aCBjdXN0b20gZmllbGRzIGN1cnJlbnRseVxuZXhwb3J0IGNvbnN0IE1BWF9VUERBVEVfVVNFUl9EQVRBX0ZJRUxEUyA9IE1BWF9VU0VSX0RBVEFfRklFTERTICsgMjtcblxuZXhwb3J0IGNvbnN0IFVTRVJfQUNDRVNTX01FVEFfT1BUSU9OUzogVXNlckFjY2Vzc01ldGEgPSBbXG4gIFVTWVNfQUNDRVNTX1RZUEVTLkxPR0dFRF9JTixcbl07XG5cbmV4cG9ydCBjb25zdCBFWENFRURTX01BWF9GSUxFX1NJWkVfRVJST1IgPVxuICAnTWF4aW11bSBzaXplIGFsbG93ZWQgZm9yIGEgZmlsZSB1cGxvYWQgaXMgMTAwMDBrYiAvIDEwbWIuJztcbmV4cG9ydCBjb25zdCBFWENFRURTX01BWF9JTUFHRV9TSVpFX0VSUk9SID1cbiAgJ01heGltdW0gc2l6ZSBhbGxvd2VkIGZvciBhIGltYWdlIHVwbG9hZCBpcyA0MDAwa2IgLyA0bWIuJztcbmV4cG9ydCBjb25zdCBOT19SRVFVSVJFRF9BVFRSSUJVVEUgPSBbJ0ZpbGVSZWYnLCAnQm9vbCddIGFzIGNvbnN0O1xuXG5leHBvcnQgY29uc3QgVVNFUl9TVEFUVVNFUyA9IHtcbiAgaW52aXRlZDogJ0ludml0ZWQnLFxuICB2ZXJpZmllZDogJ1ZlcmlmaWVkJyxcbiAgdW52ZXJpZmllZDogJ1VudmVyaWZpZWQnLFxufSBhcyBjb25zdDtcblxuZXhwb3J0IGNvbnN0IFVTRVJfUEFHRV9TSVpFID0gMTAwO1xuXG4vLyBVc2VyIENTViBJbXBvcnQgY29uc3RhbnRzXG5jb25zdCBVU0VSX0NTVl9JTVBPUlRfU1RBVFVTX1BPTExJTkdfVElNRU9VVCA9IDIwICogNjAgKiAxMDAwO1xuZXhwb3J0IGNvbnN0IFVTRVJfQ1NWX0lNUE9SVF9TVEFUVVNfUE9MTElOR19JTlRFUlZBTCA9IDUwMDA7XG5leHBvcnQgY29uc3QgVVNFUl9DU1ZfSU1QT1JUX1NUQVRVU19NQVhfVFJJRVMgPSBNYXRoLmZsb29yKFxuICBVU0VSX0NTVl9JTVBPUlRfU1RBVFVTX1BPTExJTkdfVElNRU9VVCAvXG4gICAgVVNFUl9DU1ZfSU1QT1JUX1NUQVRVU19QT0xMSU5HX0lOVEVSVkFMXG4pO1xuIl0sIm5hbWVzIjpbIkFDQ0VTU19HUk9VUF9BRE1JU1NJT05fVFlQRSIsIkFDQ0VTU19HUk9VUF9GUkVFX1RZUEUiLCJBQ0NFU1NfR1JPVVBfSU5MSU5FX1BST0RVQ1RfRklFTERfU0xVRyIsIkJBU0lDX01BWF9OVU1fVVNFUlMiLCJCVVNJTkVTU19NQVhfTlVNX1VTRVJTIiwiQ09ORklSTV9VTlNBVkVEX0NIQU5HRVNfQ09QWSIsIkRFRkFVTFRfU0VTU0lPTl9EVVJBVElPTl9JTl9NUyIsIkRFRkFVTFRfU0VTU0lPTl9UT0tFTl9EVVJBVElPTl9JTl9NUyIsIkRFRkFVTFRfU1RZTEVTIiwiREVGQVVMVF9UT0tFTl9BR0VfTVMiLCJERUZBVUxUX1VTRVJfRklFTERTIiwiRUNPTU1fUExVU19NQVhfTlVNX1VTRVJTIiwiRUNPTU1fU1RBTkRBUkRfTUFYX05VTV9VU0VSUyIsIkVNQUlMX1RFTVBMQVRFX1RZUEVTIiwiRVhDRUVEU19NQVhfRklMRV9TSVpFX0VSUk9SIiwiRVhDRUVEU19NQVhfSU1BR0VfU0laRV9FUlJPUiIsIkhBUkRfTElNSVRfTUFYX05VTV9VU0VSUyIsIktFWV9GUk9NX1JFU0VSVkVEX1VTRVJfRklFTEQiLCJMT0dHRURJTl9DT09LSUVfTkFNRSIsIk1BWF9HUk9VUF9JRF9MRU5HVEgiLCJNQVhfTlVNX0dST1VQUyIsIk1BWF9VUERBVEVfVVNFUl9EQVRBX0ZJRUxEUyIsIk1BWF9VU0VSX0RBVEFfRklFTERTIiwiTUVNQkVSU0hJUFNfRU1BSUxfS0VZUyIsIk1JTl9HUk9VUF9JRF9MRU5HVEgiLCJOQU1FU19GUk9NX1VTRVJfRklFTERTIiwiTkVXX1VTRVJfRklFTERfSUQiLCJOT19SRVFVSVJFRF9BVFRSSUJVVEUiLCJQQVNTV09SRF9NQVhfTEVOR1RIIiwiUEFTU1dPUkRfTUlOX0xFTkdUSCIsIlJFU0VSVkVEX1VTRVJfRklFTERTIiwiUkVTRVJWRURfVVNFUl9QUkVGSVgiLCJTRVNTSU9OX0NPT0tJRV9OQU1FIiwiU0VUVVBfR1VJREVfQUxMX0tFWVMiLCJTRVRVUF9HVUlERV9LRVlTIiwiU1RBUlRFUl9NQVhfTlVNX1VTRVJTIiwiU1VCU0NSSVBUSU9OX0VNQUlMX1RZUEVTIiwiU1VCU0NSSVBUSU9OX1VTRVJfTElNSVRTIiwiVEVYVF9JTlBVVF9UWVBFX1RPX0ZJRUxEX1RZUEUiLCJVU0VSX0FDQ0VTU19NRVRBX09QVElPTlMiLCJVU0VSX0NTVl9JTVBPUlRfU1RBVFVTX01BWF9UUklFUyIsIlVTRVJfQ1NWX0lNUE9SVF9TVEFUVVNfUE9MTElOR19JTlRFUlZBTCIsIlVTRVJfRklFTERfREVGQVVMVFMiLCJVU0VSX0ZJRUxEX0ZPUk1fSUQiLCJVU0VSX1BBR0VfU0laRSIsIlVTRVJfU1RBVFVTRVMiLCJVU1lTX0RBVEFfQVRUUlMiLCJVU1lTX0RPTV9DTEFTU19OQU1FUyIsIlVTWVNfRk9STV9UWVBFUyIsIlVTWVNfSU5QVVRfU0lHTl9VUF9JRFMiLCJVU1lTX0lOUFVUX1RZUEVTIiwiVVNZU19QQUdFX1NFVFRJTkdTIiwiVVNZU19QQUdFX1VUSUxfS0VZUyIsIlVTWVNfUkVTRVJWRURfU0xVR1MiLCJVU1lTX1RPS0VOX1RZUEVTIiwiVVNZU19VU0VSX1NUQVRFUyIsIlVTWVNfVVRJTElUWV9LRVlTIiwibmFtZSIsImFjY2VwdFByaXZhY3kiLCJhY2NlcHRDb21tdW5pY2F0aW9ucyIsIlBSSVZBQ1lfUE9MSUNZIiwiUEFTU1dPUkQiLCJFTUFJTCIsInRleHQiLCJwYXNzd29yZCIsImVtYWlsIiwibnVtYmVyIiwidGVsIiwiZm9ybVR5cGUiLCJpbnB1dFR5cGUiLCJsb2dvdXQiLCJsb2dpbiIsImZvcm1FcnJvciIsInJlZGlyZWN0VXJsIiwiZm9ybVZlcmlmaWNhdGlvbiIsInVzZXJTdWJzY3JpcHRpb25zIiwidXNlclN1YnNjcmlwdGlvbnNFbXB0eVN0YXRlIiwidXNlckFjY291bnQiLCJzdWJzY3JpcHRpb25DYW5jZWwiLCJ1c2VySWQiLCJmaWVsZCIsImZpZWxkVHlwZSIsImZpbGVVcGxvYWRLZXkiLCJ1bnNhdmVkRmlsZVVwbG9hZEtleSIsImZvcm1TdWNjZXNzIiwiZm9ybVZlcmZpY2F0aW9uIiwic2lnbnVwIiwidXBkYXRlUGFzc3dvcmQiLCJyZXNldFBhc3N3b3JkIiwiYWNjb3VudCIsImxvZ2dlZEluIiwibG9nZ2VkT3V0IiwicGFyZW50Iiwic29ydFBvcyIsInV0aWxLZXkiLCJzbHVnIiwidGl0bGUiLCJhY2Nlc3NEZW5pZWQiLCJ2YWx1ZXMiLCJtYXAiLCJwYWdlU2V0dGluZ3MiLCJhY2NlbnRDb2xvciIsImJnQ29sb3IiLCJpbmNsdWRlV2ZCcmFuZCIsIlNFQ09ORCIsIk1JTlVURSIsIkhPVVIiLCJEQVkiLCJmcmVlIiwic3RhdGljIiwiY21zIiwiYnVzaW5lc3MiLCJlY29tbWVyY2Vfc3RhbmRhcmQiLCJlY29tbWVyY2VfcGx1cyIsImVjb21tZXJjZV9hZHZhbmNlZCIsImVudGVycHJpc2UiLCJlbnRlcnByaXNlX2xpdGUiLCJpbnZpdGVVc2VyIiwidmVyaWZ5RW1haWwiLCJwYWlkIiwiYWxsIiwiYWRtaW4iLCJQQVlNRU5UX0ZBSUxFRCIsIlBBWU1FTlRfU1VDQ0VTU0ZVTCIsIlNVQlNDUklQVElPTl9DQU5DRUxFRCIsIlZFUklGWV9QQVlNRU5UIiwiaW52aXRlIiwidXBkYXRlZFBhc3N3b3JkIiwid2VsY29tZSIsInZlcmlmeSIsImNvbnRlbnQiLCJpY29uVHlwZSIsInN1Ym1pdCIsImxhYmVsIiwiaW50ZW50IiwiY2FuY2VsIiwiUGxhaW5UZXh0IiwiaWQiLCJyZXF1aXJlZCIsInR5cGUiLCJ2YWxpZGF0aW9ucyIsIkVtYWlsIiwiQm9vbCIsIkZpbGVSZWYiLCJPcHRpb24iLCJvcHRpb25zIiwiUGFzc3dvcmQiLCJOdW1iZXIiLCJtaW4iLCJzdGVwIiwiTGluayIsImhhc1Zpc2l0ZWRBY2Nlc3NEZW5pZWRQYWdlIiwiaGFzVmlzaXRlZExvZ2luUGFnZSIsImhhc1Zpc2l0ZWRTaWduVXBQYWdlIiwiaGFzVmlzaXRlZFVzZXJBY2NvdW50U2V0dGluZ3MiLCJoYXNWaXNpdGVkVXNlckFjY291bnRQYWdlIiwiaGFzSG9zdGluZ1BsYW4iLCJoYXNFY29tbWVyY2UiLCJoYXNFbmFibGVkU1NMIiwiaGFzVXNlcnMiLCJoYXNBY2Nlc3NHcm91cHMiLCJoYXNSZXN0cmljdGVkQ29udGVudCIsImhhc1Jlc3RyaWN0ZWRQcm9kdWN0cyIsIlVTWVNfQUNDRVNTX1RZUEVTIiwiTE9HR0VEX0lOIiwiaW52aXRlZCIsInZlcmlmaWVkIiwidW52ZXJpZmllZCIsIlVTRVJfQ1NWX0lNUE9SVF9TVEFUVVNfUE9MTElOR19USU1FT1VUIiwiTWF0aCIsImZsb29yIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztJQW1QYUEsMkJBQTJCO2VBQTNCQTs7SUFLQUMsc0JBQXNCO2VBQXRCQTs7SUFSQUMsc0NBQXNDO2VBQXRDQTs7SUE5Q0FDLG1CQUFtQjtlQUFuQkE7O0lBQ0FDLHNCQUFzQjtlQUF0QkE7O0lBbUZBQyw0QkFBNEI7ZUFBNUJBOztJQTNGQUMsOEJBQThCO2VBQTlCQTs7SUFDQUMsb0NBQW9DO2VBQXBDQTs7SUFwQkFDLGNBQWM7ZUFBZEE7O0lBcUJBQyxvQkFBb0I7ZUFBcEJBOztJQStLQUMsbUJBQW1CO2VBQW5CQTs7SUF2S0FDLHdCQUF3QjtlQUF4QkE7O0lBREFDLDRCQUE0QjtlQUE1QkE7O0lBMEVBQyxvQkFBb0I7ZUFBcEJBOztJQXdLQUMsMkJBQTJCO2VBQTNCQTs7SUFFQUMsNEJBQTRCO2VBQTVCQTs7SUE5T0FDLHdCQUF3QjtlQUF4QkE7O0lBOUtBQyw0QkFBNEI7ZUFBNUJBOztJQThKQUMsb0JBQW9CO2VBQXBCQTs7SUE4Q0FDLG1CQUFtQjtlQUFuQkE7O0lBRkFDLGNBQWM7ZUFBZEE7O0lBME1BQywyQkFBMkI7ZUFBM0JBOztJQUpBQyxvQkFBb0I7ZUFBcEJBOztJQXRLQUMsc0JBQXNCO2VBQXRCQTs7SUEvQkFDLG1CQUFtQjtlQUFuQkE7O0lBck1BQyxzQkFBc0I7ZUFBdEJBOztJQWdRQUMsaUJBQWlCO2VBQWpCQTs7SUF3SkFDLHFCQUFxQjtlQUFyQkE7O0lBelFBQyxtQkFBbUI7ZUFBbkJBOztJQURBQyxtQkFBbUI7ZUFBbkJBOztJQTFKQUMsb0JBQW9CO2VBQXBCQTs7SUFGQUMsb0JBQW9CO2VBQXBCQTs7SUFxS0FDLG1CQUFtQjtlQUFuQkE7O0lBd09BQyxvQkFBb0I7ZUFBcEJBOztJQVRBQyxnQkFBZ0I7ZUFBaEJBOztJQXZOQUMscUJBQXFCO2VBQXJCQTs7SUE4REFDLHdCQUF3QjtlQUF4QkE7O0lBckNBQyx3QkFBd0I7ZUFBeEJBOztJQS9LQUMsNkJBQTZCO2VBQTdCQTs7SUF1WUFDLHdCQUF3QjtlQUF4QkE7O0lBcUJBQyxnQ0FBZ0M7ZUFBaENBOztJQURBQyx1Q0FBdUM7ZUFBdkNBOztJQWxLQUMsbUJBQW1CO2VBQW5CQTs7SUFKQUMsa0JBQWtCO2VBQWxCQTs7SUFrS0FDLGNBQWM7ZUFBZEE7O0lBTkFDLGFBQWE7ZUFBYkE7O0lBaFlBQyxlQUFlO2VBQWZBOztJQW1CQUMsb0JBQW9CO2VBQXBCQTs7SUFNQUMsZUFBZTtlQUFmQTs7SUFlQUMsc0JBQXNCO2VBQXRCQTs7SUFQQUMsZ0JBQWdCO2VBQWhCQTs7SUFxQkFDLGtCQUFrQjtlQUFsQkE7O0lBaURBQyxtQkFBbUI7ZUFBbkJBOztJQUpBQyxtQkFBbUI7ZUFBbkJBOztJQTJFQUMsZ0JBQWdCO2VBQWhCQTs7SUE5SEFDLGdCQUFnQjtlQUFoQkE7O0lBekRBQyxpQkFBaUI7ZUFBakJBOzs7dUJBbERRO29DQUNnQztxQkFDdkM7Ozs7Ozs7Ozs7Ozs7O0FBaUJQLE1BQU16Qix1QkFBdUI7QUFFN0IsTUFBTUQsdUJBQXVCO0lBQ2xDMkIsTUFBTTFCLHVCQUF1QjtJQUM3QjJCLGVBQWUzQix1QkFBdUI7SUFDdEM0QixzQkFBc0I1Qix1QkFBdUI7QUFDL0M7QUFFTyxNQUFNZCwrQkFBK0I7SUFDMUMsQ0FBQ2MsdUJBQXVCLE9BQU8sRUFBRTtJQUNqQyxDQUFDQSx1QkFBdUIsaUJBQWlCLEVBQUU7SUFDM0MsQ0FBQ0EsdUJBQXVCLHdCQUF3QixFQUFFO0FBQ3BEO0FBRU8sTUFBTU4seUJBQXlCO0lBQ3BDLENBQUNNLHVCQUF1QixPQUFPLEVBQUU7SUFDakMsQ0FBQ0EsdUJBQXVCLGlCQUFpQixFQUFFO0lBQzNDLENBQUNBLHVCQUF1Qix3QkFBd0IsRUFBRTtJQUNsRDZCLGdCQUFnQjtJQUNoQkMsVUFBVTtJQUNWQyxPQUFPO0FBQ1Q7QUFFTyxNQUFNeEIsZ0NBQWdDO0lBQzNDeUIsTUFBTTtJQUNOQyxVQUFVO0lBQ1ZDLE9BQU87SUFDUEMsUUFBUTtJQUNSQyxLQUFLO0FBQ1A7QUFFTyxNQUFNWCxvQkFBb0I7SUFDL0IsZUFBZTtJQUNmLGdCQUFnQjtJQUNoQix1QkFBdUI7SUFDdkIsd0JBQXdCO0lBQ3hCLHNCQUFzQjtJQUN0QixxQkFBcUI7QUFDdkI7QUFFTyxNQUFNVixrQkFBa0I7SUFDN0JzQixVQUFVO0lBQ1ZDLFdBQVc7SUFDWEMsUUFBUTtJQUNSQyxPQUFPO0lBQ1BDLFdBQVc7SUFDWEMsYUFBYTtJQUNiQyxrQkFBa0I7SUFDbEJDLG1CQUFtQjtJQUNuQkMsNkJBQTZCO0lBQzdCQyxhQUFhO0lBQ2JDLG9CQUFvQjtJQUNwQkMsUUFBUTtJQUNSQyxPQUFPO0lBQ1BDLFdBQVc7SUFDWEMsZUFBZTtJQUNmQyxzQkFBc0I7QUFDeEI7QUFFTyxNQUFNcEMsdUJBQXVCO0lBQ2xDcUMsYUFBYTtJQUNiQyxpQkFBaUI7SUFDakJiLFdBQVc7QUFDYjtBQUVPLE1BQU14QixrQkFBa0I7SUFDN0J1QixPQUFPO0lBQ1BlLFFBQVE7SUFDUkMsZ0JBQWdCO0lBQ2hCQyxlQUFlO0lBQ2ZDLFNBQVM7QUFDWDtBQUVPLE1BQU12QyxtQkFBbUI7SUFDOUJlLE9BQU87SUFDUFIsTUFBTTtJQUNOTyxVQUFVO0lBQ1ZOLGVBQWU7QUFDakI7QUFFTyxNQUFNVCx5QkFBeUI7SUFDcENnQixPQUFPO0lBQ1BSLE1BQU07SUFDTk8sVUFBVTtJQUNWTixlQUFlO0lBQ2ZDLHNCQUFzQjtBQUN4QjtBQUVPLE1BQU1KLG1CQUFtQjtJQUM5Qm1DLFVBQVU7SUFDVkMsV0FBVztBQUNiO0FBR08sTUFBTXhDLHFCQUFxQjtJQUNoQ29CLE9BQU87UUFDTHFCLFFBQVE7UUFDUkMsU0FBUztRQUNUQyxTQUFTO1FBQ1RDLE1BQU07UUFDTkMsT0FBTztJQUNUO0lBQ0FWLFFBQVE7UUFDTk0sUUFBUTtRQUNSQyxTQUFTO1FBQ1RDLFNBQVM7UUFDVEMsTUFBTTtRQUNOQyxPQUFPO0lBQ1Q7SUFDQVIsZUFBZTtRQUNiSSxRQUFRO1FBQ1JDLFNBQVM7UUFDVEMsU0FBUztRQUNUQyxNQUFNO1FBQ05DLE9BQU87SUFDVDtJQUNBVCxnQkFBZ0I7UUFDZEssUUFBUTtRQUNSQyxTQUFTO1FBQ1RDLFNBQVM7UUFDVEMsTUFBTTtRQUNOQyxPQUFPO0lBQ1Q7SUFDQUMsY0FBYztRQUNaTCxRQUFRO1FBQ1JDLFNBQVM7UUFDVEMsU0FBUztRQUNUQyxNQUFNO1FBQ05DLE9BQU87SUFDVDtJQUNBbkIsYUFBYTtRQUNYZSxRQUFRO1FBQ1JDLFNBQVM7UUFDVEMsU0FBUztRQUNUQyxNQUFNO1FBQ05DLE9BQU87SUFDVDtBQUNGO0FBRU8sTUFBTTNDLHNCQUFzQjZDLElBQUFBLGFBQU0sRUFBQy9DLG9CQUFvQmdELEdBQUcsQ0FDL0QsQ0FBQ0MsZUFBaUJBLGFBQWFMLElBQUk7QUFHOUIsTUFBTTNDLHNCQUFzQjhDLElBQUFBLGFBQU0sRUFBQy9DLG9CQUFvQmdELEdBQUcsQ0FDL0QsQ0FBQ0MsZUFBaUJBLGFBQWFOLE9BQU87QUFJakMsTUFBTXRGLGlCQUFpQjtJQUM1QjZGLGFBQWE7SUFDYkMsU0FBUztJQUNUQyxnQkFBZ0I7QUFDbEI7QUFJTyxNQUFNMUUsc0JBQXNCO0FBQzVCLE1BQU1ELHNCQUFzQjtBQUVuQyxvQkFBb0I7QUFDcEIsTUFBTTRFLFNBQVM7QUFDZixNQUFNQyxTQUFTLEtBQUtEO0FBQ3BCLE1BQU1FLE9BQU8sS0FBS0Q7QUFDbEIsTUFBTUUsTUFBTSxLQUFLRDtBQUVWLE1BQU0xRSxzQkFBc0I7QUFDNUIsTUFBTWQsdUJBQXVCO0FBQzdCLE1BQU1aLGlDQUFpQyxJQUFJcUc7QUFDM0MsTUFBTXBHLHVDQUF1QyxJQUFJbUc7QUFDakQsTUFBTWpHLHVCQUF1QmlHO0FBSTdCLE1BQU12RSx3QkFBd0I7QUFDOUIsTUFBTWhDLHNCQUFzQjtBQUM1QixNQUFNQyx5QkFBeUI7QUFDL0IsTUFBTVEsK0JBQStCO0FBQ3JDLE1BQU1ELDJCQUEyQjtBQUtqQyxNQUFNSywyQkFBMkIsTUFBTTtBQWdCdkMsTUFBTXFCLDJCQUFtRDtJQUM5RHVFLE1BQU16RTtJQUNOMEUsUUFBUTFHO0lBQ1IyRyxLQUFLMUc7SUFDTDJHLFVBQVUzRztJQUNWNEcsb0JBQW9CcEc7SUFDcEJxRyxnQkFBZ0J0RztJQUNoQnVHLG9CQUFvQjlHO0lBQ3BCK0csWUFBWS9HO0lBQ1pnSCxpQkFBaUJoSDtBQUNuQjtBQUVPLE1BQU1nQixpQkFBaUI7QUFDdkIsTUFBTUksc0JBQXNCO0FBQzVCLE1BQU1MLHNCQUFzQjtBQUU1QixNQUFNbUMsbUJBQW1CO0lBQzlCK0QsWUFBWTtJQUNaN0IsZUFBZTtJQUNmOEIsYUFBYTtBQUNmO0FBRU8sTUFBTXBILHlDQUNYO0FBRUssTUFBTUYsOEJBQThCO0lBQ3pDNEcsTUFBTTtJQUNOVyxNQUFNO0FBQ1I7QUFFTyxNQUFNdEgseUJBQXlCO0lBQ3BDdUgsS0FBSztJQUNMQyxPQUFPO0FBQ1Q7QUFJTyxNQUFNckYsMkJBQTJCO0lBQ3RDc0YsZ0JBQWdCO0lBQ2hCQyxvQkFBb0I7SUFDcEJDLHVCQUF1QjtJQUN2QkMsZ0JBQWdCO0FBQ2xCO0FBRU8sTUFBTXRHLHlCQUF5QjtJQUNwQ3VHLFFBQVE7SUFDUnRDLGVBQWU7SUFDZnVDLGlCQUFpQjtJQUNqQkMsU0FBUztJQUNUQyxRQUFRO0FBQ1Y7QUFFTyxNQUFNcEgsdUJBQXVCO0lBQ2xDaUgsUUFBUTtJQUNSdEMsZUFBZTtJQUNmdUMsaUJBQWlCO0lBQ2pCRSxRQUFRO0lBQ1JELFNBQVM7QUFDWDtBQUVPLE1BQU0zSCwrQkFBK0I7SUFDMUMyRixPQUFPO0lBQ1BrQyxTQUFTO0lBQ1RDLFVBQVU7SUFDVkMsUUFBUTtRQUFDQyxPQUFPO1FBQVlDLFFBQVE7SUFBUTtJQUM1Q0MsUUFBUTtRQUFDRixPQUFPO1FBQVVDLFFBQVE7SUFBUztBQUM3QztBQUlPLE1BQU0zRixxQkFBcUI7QUFFM0IsTUFBTWpCLG9CQUFvQjtBQUUxQixNQUFNZ0Isc0JBQXNCO0lBQ2pDOEYsV0FBVztRQUNUQyxJQUFJL0c7UUFDSitCLE1BQU07UUFDTnNDLE1BQU07UUFDTjJDLFVBQVU7UUFDVkMsTUFBTTtRQUNOQyxhQUFhLENBQUM7SUFDaEI7SUFDQUMsT0FBTztRQUNMSixJQUFJL0c7UUFDSitCLE1BQU07UUFDTnNDLE1BQU07UUFDTjJDLFVBQVU7UUFDVkMsTUFBTTtRQUNOQyxhQUFhLENBQUM7SUFDaEI7SUFDQUUsTUFBTTtRQUNKTCxJQUFJL0c7UUFDSitCLE1BQU07UUFDTnNDLE1BQU07UUFDTjJDLFVBQVU7UUFDVkMsTUFBTTtRQUNOQyxhQUFhLENBQUM7SUFDaEI7SUFDQUcsU0FBUztRQUNQTixJQUFJL0c7UUFDSitCLE1BQU07UUFDTnNDLE1BQU07UUFDTjJDLFVBQVU7UUFDVkMsTUFBTTtRQUNOQyxhQUFhLENBQUM7SUFDaEI7SUFDQUksUUFBUTtRQUNOUCxJQUFJL0c7UUFDSitCLE1BQU07UUFDTnNDLE1BQU07UUFDTjJDLFVBQVU7UUFDVkMsTUFBTTtRQUNOQyxhQUFhO1lBQ1hLLFNBQVMsRUFBRTtRQUNiO0lBQ0Y7SUFDQUMsVUFBVTtRQUNSVCxJQUFJL0c7UUFDSitCLE1BQU07UUFDTnNDLE1BQU07UUFDTjJDLFVBQVU7UUFDVkMsTUFBTTtRQUNOQyxhQUFhLENBQUM7SUFDaEI7SUFDQU8sUUFBUTtRQUNOVixJQUFJL0c7UUFDSitCLE1BQU07UUFDTnNDLE1BQU07UUFDTjJDLFVBQVU7UUFDVkMsTUFBTTtRQUNOQyxhQUFhO1lBQ1hRLEtBQUs7WUFDTEMsTUFBTTtRQUNSO0lBQ0Y7SUFDQUMsTUFBTTtRQUNKYixJQUFJL0c7UUFDSitCLE1BQU07UUFDTnNDLE1BQU07UUFDTjJDLFVBQVU7UUFDVkMsTUFBTTtRQUNOQyxhQUFhLENBQUM7SUFDaEI7QUFDRjtBQUVPLE1BQU1sSSxzQkFBc0I7SUFDakM7UUFDRStILElBQUk7UUFDSmhGLE1BQU07UUFDTmlGLFVBQVU7UUFDVjNDLE1BQU07UUFDTjRDLE1BQU07UUFDTkMsYUFBYSxDQUFDO0lBQ2hCO0lBQ0E7UUFDRUgsSUFBSTtRQUNKaEYsTUFBTTtRQUNOaUYsVUFBVTtRQUNWM0MsTUFBTTtRQUNONEMsTUFBTTtRQUNOQyxhQUFhLENBQUM7SUFDaEI7SUFDQTtRQUNFSCxJQUFJO1FBQ0poRixNQUFNO1FBQ05pRixVQUFVO1FBQ1YzQyxNQUFNO1FBQ040QyxNQUFNO1FBQ05DLGFBQWEsQ0FBQztJQUNoQjtJQUNBO1FBQ0VILElBQUk7UUFDSmhGLE1BQU07UUFDTmlGLFVBQVU7UUFDVjNDLE1BQU07UUFDTjRDLE1BQU07UUFDTkMsYUFBYSxDQUFDO0lBQ2hCO0lBQ0E7UUFDRUgsSUFBSTtRQUNKaEYsTUFBTTtRQUNOaUYsVUFBVTtRQUNWM0MsTUFBTTtRQUNONEMsTUFBTTtRQUNOQyxhQUFhLENBQUM7SUFDaEI7Q0FDRDtBQUdNLE1BQU0xRyxtQkFBbUI7SUFDOUJxSCw0QkFBNEI7SUFDNUJDLHFCQUFxQjtJQUNyQkMsc0JBQXNCO0lBQ3RCQywrQkFBK0I7SUFDL0JDLDJCQUEyQjtBQUM3QjtBQUdPLE1BQU0xSCx1QkFBdUI7SUFDbEMsR0FBR0MsZ0JBQWdCO0lBQ25CMEgsZ0JBQWdCO0lBQ2hCQyxjQUFjO0lBQ2RDLGVBQWU7SUFDZkMsVUFBVTtJQUNWQyxpQkFBaUI7SUFDakJDLHNCQUFzQjtJQUN0QkMsdUJBQXVCO0FBQ3pCO0FBRU8sTUFBTTVJLHVCQUF1QjtBQUk3QixNQUFNRCw4QkFBOEJDLHVCQUF1QjtBQUUzRCxNQUFNaUIsMkJBQTJDO0lBQ3RENEgsd0JBQWlCLENBQUNDLFNBQVM7Q0FDNUI7QUFFTSxNQUFNdEosOEJBQ1g7QUFDSyxNQUFNQywrQkFDWDtBQUNLLE1BQU1ZLHdCQUF3QjtJQUFDO0lBQVc7Q0FBTztBQUVqRCxNQUFNa0IsZ0JBQWdCO0lBQzNCd0gsU0FBUztJQUNUQyxVQUFVO0lBQ1ZDLFlBQVk7QUFDZDtBQUVPLE1BQU0zSCxpQkFBaUI7QUFFOUIsNEJBQTRCO0FBQzVCLE1BQU00SCx5Q0FBeUMsS0FBSyxLQUFLO0FBQ2xELE1BQU0vSCwwQ0FBMEM7QUFDaEQsTUFBTUQsbUNBQW1DaUksS0FBS0MsS0FBSyxDQUN4REYseUNBQ0UvSCJ9

}),
29089: (function (__unused_webpack_module, exports) {
"use strict";
// Server email configuration

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "USYS_ACCESS_TYPES", ({
    enumerable: true,
    get: function() {
        return USYS_ACCESS_TYPES;
    }
}));
const USYS_ACCESS_TYPES = {
    LOGGED_IN: 'LOGGED_IN',
    ADMIN_ALWAYS_VISIBLE: 'ADMIN_ALWAYS_VISIBLE'
};

//# sourceMappingURL=data:application/json;base64,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

}),
30916: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/*
  globals
  document
  window
  HTMLFormElement
*/ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    handleUserAccount: function() {
        return handleUserAccount;
    },
    handleUserSubscriptionLists: function() {
        return handleUserSubscriptionLists;
    }
});
const _constants = __webpack_require__(7462);
const _constants1 = __webpack_require__(10873);
const _RenderingUtils = __webpack_require__(86078);
const _utils = __webpack_require__(56897);
const _queries = __webpack_require__(3671);
const _mutations = __webpack_require__(13197);
const _rendering = __webpack_require__(85513);
const _fields = __webpack_require__(18457);
const _client = __webpack_require__(22805);
function asyncGetUserSubscriptions() {
    return _utils.userSystemsRequestClient.query({
        query: _queries.getUserSubscriptions
    });
}
function asyncGetUser(dataFields) {
    return _utils.userSystemsRequestClient.query({
        query: (0, _queries.buildGetLoggedInUserQuery)(dataFields)
    });
}
function asyncSubmitUserData(dataFields) {
    // get variables in correct shape
    const data = (0, _fields.getFieldsAsTypeKeys)(dataFields);
    return _utils.userSystemsRequestClient.mutate({
        mutation: (0, _mutations.buildUpdateUsysUserDataMutation)(dataFields),
        variables: {
            data
        }
    });
}
const subscriptionListSelector = `[${_constants.USYS_DATA_ATTRS.userSubscriptions}]`;
const EmptyStateSelector = `[${_constants.USYS_DATA_ATTRS.userSubscriptionsEmptyState}]`;
const templateSelector = `script[type='${_constants1.WF_TEMPLATE_TYPE}']`;
function getUserSubscriptionLists() {
    const subscriptionLists = document.querySelectorAll(subscriptionListSelector);
    return Array.from(subscriptionLists);
}
const userAccountFormQuerySelector = `form[${_constants.USYS_DATA_ATTRS.formType}="${_constants.USYS_FORM_TYPES.account}"]`;
function getUserAccountForms() {
    const accountForms = document.querySelectorAll(userAccountFormQuerySelector);
    return Array.prototype.slice.call(accountForms).filter((accountForm)=>accountForm instanceof HTMLFormElement);
}
function handleUserSubscriptionLists(domParser) {
    if (window.Webflow.env('design') || window.Webflow.env('preview')) {
        // The usys Apollo client does not work in the Designer and will error out.
        // We are using mocked data in the Designer and Preview mode instead.
        return;
    }
    const subscriptionLists = getUserSubscriptionLists();
    // If we have a list to render, query for the data
    if (subscriptionLists.length > 0) {
        asyncGetUserSubscriptions().then((response)=>{
            // @ts-expect-error - TS2339: Property database does not exist on type {}
            const userSubscriptions = response?.data?.database?.userSubscriptions;
            const noUserSubscriptions = userSubscriptions.length === 0;
            if (noUserSubscriptions) return renderEmptySubscriptionList(subscriptionLists);
            renderUserSubscriptionLists(subscriptionLists, domParser, userSubscriptions);
        }).catch((error)=>{
            const graphQLErrors = _client.CombinedGraphQLErrors.is(error) ? error.errors : [];
            const errorsHandled = graphQLErrors.reduce((hasUnhandledError, graphQLError)=>{
                if ('code' in graphQLError && graphQLError.code === 'NoCommerceCustomerFound') {
                    renderEmptySubscriptionList(subscriptionLists);
                    return hasUnhandledError;
                }
                return false;
            }, graphQLErrors.length > 0);
            if (!errorsHandled) throw error;
        });
    }
}
function renderEmptySubscriptionList(subscriptionListElements) {
    subscriptionListElements.forEach((subscriptionListElement)=>{
        const EmptyStateElement = subscriptionListElement.querySelector(EmptyStateSelector);
        (0, _utils.showElement)(EmptyStateElement);
    });
}
function renderUserSubscriptionLists(subscriptionListElements, domParser, userSubscriptions = []) {
    subscriptionListElements.forEach((subscriptionListElement)=>{
        const EmptyStateElement = subscriptionListElement.querySelector(EmptyStateSelector);
        (0, _utils.hideElement)(EmptyStateElement);
        const templateScript = subscriptionListElement.querySelector(templateSelector);
        if (!templateScript) {
            return;
        }
        const templateId = templateScript.getAttribute('id');
        if (!templateId) {
            return;
        }
        const listWrapperElement = document.querySelector(`[${_constants1.WF_TEMPLATE_ID_DATA_KEY}='${templateId}']`);
        if (!(listWrapperElement instanceof Element)) {
            // If we don't have a wrapper to append items to, return
            return;
        }
        const templateElement = domParser.getHtmlFromString(templateScript.innerHTML);
        if (!(templateElement instanceof Element)) {
            // If there is no template content present, return
            return;
        }
        userSubscriptions.forEach((subscription)=>{
            const templateClone = templateElement.cloneNode(true);
            listWrapperElement.appendChild(templateClone);
            // @ts-expect-error - TS2345 - Argument of type 'Node' is not assignable to parameter of type 'Element'.
            (0, _RenderingUtils.walkDOM)(templateClone, (node)=>{
                (0, _rendering.applyBindingsAndConditionalVisibility)(node, subscription);
                // Add handler for cancel subscription button. Done here since we have access to subscription id.
                if (node.hasAttribute(_constants.USYS_DATA_ATTRS.subscriptionCancel)) {
                    // @ts-expect-error - TS2339 - Property '_id' does not exist on type 'never'.
                    addCancelButtonEventListener(node, subscription._id);
                }
            });
        });
    });
}
function addCancelButtonEventListener(node, subscriptionId) {
    node.addEventListener('click', function() {
        _utils.userSystemsRequestClient.mutate({
            mutation: _mutations.cancelSubscriptionMutation,
            variables: {
                subscriptionId
            }
        }).then(()=>{
            // Refresh so can refetch and rerender with updated status of subscription after cancelation
            // Ultimately we should probably do a re fetch adn re render render, but will require replacing existing nodes
            window.location.reload();
        });
    });
}
function handleUserAccount() {
    // UserAccountWrapper
    const userAccount = document.querySelector(`[${_constants.USYS_DATA_ATTRS.userAccount}]`);
    if (!userAccount || window.Webflow.env('design') || window.Webflow.env('preview')) {
        return;
    }
    const successMessage = userAccount.querySelector('.' + _constants.USYS_DOM_CLASS_NAMES.formSuccess);
    const errorMessage = userAccount.querySelector('.' + _constants.USYS_DOM_CLASS_NAMES.formError);
    const userAccountForms = getUserAccountForms();
    if (userAccountForms.length > 0) {
        const fields = (0, _fields.getFieldsForFetch)(userAccountForms);
        asyncGetUser(fields).then((response)=>{
            // @ts-expect-error - TS2339: Property site does not exist on type {}
            const siteUser = response?.data?.site?.siteUser;
            if (!siteUser) return;
            const userData = siteUser.data;
            userAccountForms.forEach((accountForm)=>{
                (0, _RenderingUtils.walkDOM)(userAccount, (node)=>{
                    (0, _rendering.applyUserAccountData)(node, userData);
                });
                if (!(accountForm instanceof HTMLFormElement)) return;
                const submit = accountForm.querySelector('input[type="submit"]');
                accountForm.addEventListener('submit', (event)=>{
                    event.preventDefault();
                    const form = event.currentTarget;
                    if (!(form instanceof HTMLFormElement)) {
                        return;
                    }
                    // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null | undefined'.
                    (0, _utils.hideElement)(successMessage);
                    // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null | undefined'.
                    (0, _utils.hideElement)(errorMessage);
                    const submitText = (0, _utils.disableSubmit)(submit);
                    const commonFields = (0, _fields.getCommonFields)(form, [
                        'name',
                        'accept-communications'
                    ]);
                    const customFields = (0, _fields.getCustomFields)(form);
                    asyncSubmitUserData([
                        ...commonFields,
                        ...customFields
                    ]).then((res)=>{
                        const newUserData = res && res.data && // @ts-expect-error - TS2339: Property usysUpdateUserData does not exist on type {}
                        res.data.usysUpdateUserData && // @ts-expect-error - TS2339: Property usysUpdateUserData does not exist on type {}
                        res.data.usysUpdateUserData.data;
                        if (newUserData) {
                            // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
                            addResetEventListener(accountForm, userAccount, newUserData);
                        }
                        // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
                        successMessage && (0, _utils.showAndFocusElement)(successMessage);
                    })// @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null'.
                    .catch((0, _utils.userFormError)(form, errorMessage, 'ACCOUNT_UPDATE')).finally(()=>{
                        (0, _utils.resetSubmit)(submit, submitText);
                    });
                });
                accountForm.querySelectorAll('input').forEach((input)=>input.addEventListener('input', ()=>{
                        // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null | undefined'.
                        (0, _utils.hideElement)(successMessage);
                        // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null | undefined'.
                        (0, _utils.hideElement)(errorMessage);
                    }));
                // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
                addResetEventListener(accountForm, userAccount, userData);
            });
        });
    }
}
const addResetEventListener = (accountForm, userAccount, userData)=>{
    accountForm.addEventListener('reset', (event)=>{
        event.preventDefault();
        const form = event.currentTarget;
        if (!(form instanceof HTMLFormElement)) return;
        if (userData) {
            // apply saved user account data
            (0, _RenderingUtils.walkDOM)(userAccount, (node)=>{
                (0, _rendering.applyUserAccountData)(node, userData);
            });
        }
    });
};

//# sourceMappingURL=data:application/json;base64,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

}),
18457: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/*
  globals
  HTMLInputElement
  HTMLSelectElement
*/ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    commonFields: function() {
        return commonFields;
    },
    getCommonFields: function() {
        return getCommonFields;
    },
    getCustomFields: function() {
        return getCustomFields;
    },
    getFieldValueById: function() {
        return getFieldValueById;
    },
    getFieldsAsTypeKeys: function() {
        return getFieldsAsTypeKeys;
    },
    getFieldsForFetch: function() {
        return getFieldsForFetch;
    }
});
const _constants = __webpack_require__(7462);
const _universalUtils = __webpack_require__(62467);
const getTextInput = (element)=>element instanceof HTMLInputElement ? element.value : '';
const typeGetter = {
    PlainText: getTextInput,
    Email: getTextInput,
    Bool: (element)=>element instanceof HTMLInputElement ? element.checked : false,
    Number: getTextInput,
    Option: (element)=>element instanceof HTMLSelectElement ? element.value : '',
    Link: getTextInput,
    FileRef: (element)=>{
        const fileKey = (0, _universalUtils.getUserFileKey)(element);
        const tempFileKey = (0, _universalUtils.getTempUserFileKey)(element);
        if (tempFileKey) {
            // change file
            return {
                key: tempFileKey
            };
        }
        if (fileKey === 'DELETE') {
            // delete file
            return null;
        }
        if (fileKey) {
            // preserve existing file
            return {
                _id: fileKey
            };
        }
    }
};
const customFieldTypes = [
    'PlainText',
    'Bool',
    'Email',
    'Number',
    'Option',
    'Link',
    'FileRef'
];
const commonFields = [
    {
        type: 'Email',
        slug: 'email',
        selector: (container)=>container.querySelector(`input[${_constants.USYS_DATA_ATTRS.inputType}="${_constants.USYS_INPUT_TYPES.email}"]`)
    },
    {
        type: 'PlainText',
        slug: 'name',
        selector: (container)=>container.querySelector(`input[${_constants.USYS_DATA_ATTRS.field}="${_constants.RESERVED_USER_FIELDS.name}"]`) || container.querySelector(`input[${_constants.USYS_DATA_ATTRS.inputType}="${_constants.USYS_INPUT_TYPES.name}"]`)
    },
    {
        type: 'PlainText',
        slug: 'password',
        selector: (container)=>container.querySelector(`input[${_constants.USYS_DATA_ATTRS.inputType}="${_constants.USYS_INPUT_TYPES.password}"]`)
    },
    {
        type: 'Bool',
        slug: 'accept-privacy',
        selector: (container)=>container.querySelector(`input[${_constants.USYS_DATA_ATTRS.field}="${_constants.RESERVED_USER_FIELDS.acceptPrivacy}"]`) || container.querySelector(`input[${_constants.USYS_DATA_ATTRS.inputType}="${_constants.USYS_INPUT_TYPES.acceptPrivacy}"]`)
    },
    {
        type: 'Bool',
        slug: 'accept-communications',
        selector: (container)=>container.querySelector(`input[${_constants.USYS_DATA_ATTRS.field}="${_constants.RESERVED_USER_FIELDS.acceptCommunications}"]`)
    }
];
const toCamelCase = (str)=>{
    // Handle kebab-case to PascalCase
    const pascalCase = str.split('-').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join('');
    // return camelCase
    return pascalCase.charAt(0).toLowerCase() + pascalCase.slice(1);
};
const getCommonFields = (form, requestedFields)=>{
    const payload = [];
    commonFields.forEach((field)=>{
        if (requestedFields && !requestedFields.includes(field.slug)) return;
        const ele = field.selector(form);
        if (!ele || !typeGetter[field.type]) return;
        payload.push({
            key: toCamelCase(field.slug),
            type: toCamelCase(field.type),
            id: field.slug,
            value: typeGetter[field.type](ele, field.id)
        });
    });
    return payload;
};
const getCustomFields = (form, includeValue = true)=>{
    const payload = [];
    customFieldTypes.forEach((fieldType)=>{
        const camelFieldType = toCamelCase(fieldType);
        const inputEles = form.querySelectorAll(`input[${_constants.USYS_DATA_ATTRS.fieldType}="${fieldType}"], select[${_constants.USYS_DATA_ATTRS.fieldType}="${fieldType}"]`);
        if (inputEles.length === 0 || !typeGetter[fieldType]) return;
        inputEles.forEach((ele)=>{
            const id = ele.getAttribute(_constants.USYS_DATA_ATTRS.field);
            if (!id) return;
            const elementData = {
                key: `f_${id}`,
                type: camelFieldType,
                id
            };
            if (includeValue) {
                const value = typeGetter[fieldType](ele, id);
                if (value === '') {
                    elementData.value = null;
                } else {
                    elementData.value = value;
                }
            }
            payload.push(elementData);
        });
    });
    return payload;
};
const getFieldsForFetch = (forms)=>{
    const custom = [];
    const nested = [];
    const alreadyFound = (customField)=>{
        return custom.find((item)=>item.id === customField.id);
    };
    forms.forEach((form)=>{
        nested.push([
            ...getCommonFields(form),
            ...getCustomFields(form, false)
        ]);
    });
    nested.forEach((getCustomFieldRes)=>{
        getCustomFieldRes.forEach((customField)=>{
            if (!alreadyFound(customField)) {
                custom.push(customField);
            }
        });
    });
    return custom;
};
function getFieldValueById(id, fieldsArray) {
    const match = fieldsArray.find((field)=>field.id === id);
    if (!match) return null;
    return match.value;
}
function getFieldsAsTypeKeys(fieldsArray) {
    const memo = {};
    fieldsArray.forEach((field)=>{
        const { key, type, value } = field;
        if (!memo[type]) memo[type] = [];
        memo[type].push({
            id: key.replace('f_', ''),
            value
        });
    });
    return memo;
}

//# sourceMappingURL=data:application/json;base64,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

}),
66551: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    usysFormBundle: function() {
        return usysFormBundle;
    },
    usysSiteBundle: function() {
        return usysSiteBundle;
    }
});
__webpack_require__(52897);
__webpack_require__(233);
__webpack_require__(49754);
__webpack_require__(30971);
__webpack_require__(62374);
__webpack_require__(55152);
__webpack_require__(35273);
__webpack_require__(30172);
__webpack_require__(67304);
__webpack_require__(14362);
const _login = __webpack_require__(69263);
const _signup = __webpack_require__(54284);
const _logout = __webpack_require__(87021);
const _resetPassword = __webpack_require__(63245);
const _updatePassword = __webpack_require__(10104);
const _account = __webpack_require__(30916);
const _utils = _export_star(__webpack_require__(56897), exports);
const _usysForm = __webpack_require__(65438);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}
const usysSiteBundle = ()=>{
    function init() {
        const domParser = (0, _utils.getDomParser)();
        (0, _login.handleLogInForms)();
        (0, _login.handleLoginRedirects)();
        (0, _signup.handleSignUpForms)();
        (0, _logout.handleLogInLogOutButton)();
        (0, _resetPassword.handleResetPasswordForms)();
        (0, _updatePassword.handleUpdatePasswordForms)();
        (0, _account.handleUserAccount)();
        (0, _account.handleUserSubscriptionLists)(domParser);
    }
    const ready = init;
    const design = init;
    const preview = init;
    return {
        init,
        ready,
        design,
        preview
    };
};
const usysFormBundle = function(env) {
    function init() {
        if (env('design')) return;
        (0, _usysForm.handleFields)();
    }
    return {
        init,
        ready: init,
        preview: init
    };
};

//# sourceMappingURL=data:application/json;base64,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

}),
69263: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/*
  globals
  document,
  window,
  HTMLFormElement,
  HTMLInputElement
*/ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    asyncLogInUser: function() {
        return asyncLogInUser;
    },
    handleLogInForms: function() {
        return handleLogInForms;
    },
    handleLoginRedirects: function() {
        return handleLoginRedirects;
    }
});
const _utils = __webpack_require__(56897);
const _constants = __webpack_require__(7462);
const _mutations = __webpack_require__(13197);
const _client = __webpack_require__(22805);
function getLoginLinks() {
    return Array.prototype.slice.call(document.links).filter((link)=>link.getAttribute('href') === '/log-in');
}
function handleLoginRedirects() {
    getLoginLinks().forEach((link)=>{
        const queryString = window.location.search;
        const redirectParam = queryString.match(/\?usredir=([^&]+)/g);
        if (redirectParam) {
            link.href = link.href.concat(redirectParam[0]);
        }
    });
}
const loginFormQuerySelector = `form[${_constants.USYS_DATA_ATTRS.formType}="${_constants.USYS_FORM_TYPES.login}"]`;
// error handling
const errorState = document.querySelector(`[${_constants.USYS_DATA_ATTRS.formError}]`);
const defaultErrorCopy = // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
_constants.logInErrorStates[_constants.LOGIN_UI_ERROR_CODES.GENERAL_ERROR].copy;
const errorMsgNode = document.querySelector(`.${_constants.ERROR_MSG_CLASS}`);
const getLogInErrorCode = (error)=>{
    let errorCode;
    switch(error){
        case 'UsysInvalidCredentials':
            errorCode = _constants.LOGIN_UI_ERROR_CODES.INVALID_EMAIL_OR_PASSWORD;
            break;
        default:
            errorCode = _constants.LOGIN_UI_ERROR_CODES.GENERAL_ERROR;
    }
    return errorCode;
};
function getLoginForms() {
    const loginForms = document.querySelectorAll(loginFormQuerySelector);
    return Array.prototype.slice.call(loginForms).filter((loginForm)=>loginForm instanceof HTMLFormElement);
}
function handleLogInForms() {
    getLoginForms().forEach((loginForm)=>{
        loginForm.addEventListener('submit', (event)=>{
            event.preventDefault();
            const form = event.currentTarget;
            if (!(form instanceof HTMLFormElement)) {
                return;
            }
            const submit = form.querySelector('input[type="submit"]');
            const submitText = (0, _utils.disableSubmit)(submit);
            // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null | undefined'.
            (0, _utils.hideElement)(errorState);
            const emailInput = form.querySelector(`input[${_constants.USYS_DATA_ATTRS.inputType}="${_constants.USYS_INPUT_TYPES.email}"]`);
            const passwordInput = form.querySelector(`input[${_constants.USYS_DATA_ATTRS.inputType}="${_constants.USYS_INPUT_TYPES.password}"]`);
            if (!(emailInput instanceof HTMLInputElement) || !(passwordInput instanceof HTMLInputElement)) {
                return;
            }
            const onSuccessRedirectUrl = form.getAttribute(_constants.USYS_DATA_ATTRS.redirectUrl);
            asyncLogInUser(emailInput.value, passwordInput.value).then(()=>{
                // If there is a redirect param, redirect to that href after log-in.
                (0, _utils.handleRedirect)(onSuccessRedirectUrl);
            }).catch((error)=>{
                // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null'.
                (0, _utils.resetSubmit)(submit, submitText);
                if (errorState) {
                    // if there isn't an error code, send an empty string so a generic error message appears
                    const gqlError = _client.CombinedGraphQLErrors.is(error) ? error.errors[0] : null;
                    const elementErrorCode = gqlError && 'code' in gqlError && typeof gqlError.code === 'string' ? gqlError.code : '';
                    const errorCode = getLogInErrorCode(elementErrorCode);
                    (0, _utils.handleErrorNode)(errorMsgNode, // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
                    errorState, errorCode, _constants.ERROR_ATTRIBUTE_PREFIX.LOGIN, defaultErrorCopy);
                }
            });
        });
    });
}
function asyncLogInUser(email, password) {
    return _utils.userSystemsRequestClient.mutate({
        mutation: _mutations.loginMutation,
        variables: {
            email,
            authPassword: password
        }
    });
}

//# sourceMappingURL=data:application/json;base64,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

}),
87021: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/*
  globals
  window,
  document,
  HTMLButtonElement
*/ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    asyncLogOutUser: function() {
        return asyncLogOutUser;
    },
    handleLogInLogOutButton: function() {
        return handleLogInLogOutButton;
    }
});
const _utils = __webpack_require__(56897);
const _constants = __webpack_require__(7462);
const _mutations = __webpack_require__(13197);
const logoutButtonQuerySelector = `[${_constants.USYS_DATA_ATTRS.logout}]`;
function getLogoutButtons() {
    const logoutButtons = document.querySelectorAll(logoutButtonQuerySelector);
    return Array.prototype.slice.call(logoutButtons).filter((logoutButton)=>logoutButton instanceof HTMLButtonElement);
}
function handleGoToLoginClick() {
    if (window.Webflow.env('preview')) {
        return;
    }
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Location | (string & Location)'.
    window.location = '/log-in';
}
function handleLogOutButtonClick(event) {
    event.preventDefault();
    asyncLogOutUser().then(()=>{
        // @ts-expect-error - TS2339 - Property 'Webflow' does not exist on type 'Window & typeof globalThis'.
        window.Webflow.location('/');
    });
}
function handleLogInLogOutButton() {
    getLogoutButtons().forEach((logoutButton)=>{
        if (document.cookie.split(';').some((cookie)=>cookie.indexOf(_constants.LOGGEDIN_COOKIE_NAME) > -1)) {
            logoutButton.innerHTML = logoutButton.getAttribute(_constants.USYS_DATA_ATTRS.logout) || 'Log out';
            logoutButton.removeEventListener('click', handleGoToLoginClick);
            logoutButton.addEventListener('click', handleLogOutButtonClick);
        } else if (!window.Webflow.env('design')) {
            logoutButton.innerHTML = logoutButton.getAttribute(_constants.USYS_DATA_ATTRS.login) || 'Log in';
            logoutButton.removeEventListener('click', handleLogOutButtonClick);
            logoutButton.addEventListener('click', handleGoToLoginClick);
        }
    });
}
function asyncLogOutUser() {
    return _utils.userSystemsRequestClient.mutate({
        mutation: _mutations.logoutMutation
    });
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImxvZ291dC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIvKlxuICBnbG9iYWxzXG4gIHdpbmRvdyxcbiAgZG9jdW1lbnQsXG4gIEhUTUxCdXR0b25FbGVtZW50XG4qL1xuXG5pbXBvcnQge3VzZXJTeXN0ZW1zUmVxdWVzdENsaWVudH0gZnJvbSAnLi91dGlscyc7XG5pbXBvcnQge1xuICBVU1lTX0RBVEFfQVRUUlMsXG4gIExPR0dFRElOX0NPT0tJRV9OQU1FLFxufSBmcm9tICdAcGFja2FnZXMvc3lzdGVtcy91c2Vycy9jb25zdGFudHMnO1xuaW1wb3J0IHtsb2dvdXRNdXRhdGlvbn0gZnJvbSAnLi9tdXRhdGlvbnMnO1xuXG5jb25zdCBsb2dvdXRCdXR0b25RdWVyeVNlbGVjdG9yID0gYFske1VTWVNfREFUQV9BVFRSUy5sb2dvdXR9XWA7XG5cbmZ1bmN0aW9uIGdldExvZ291dEJ1dHRvbnMoKSB7XG4gIGNvbnN0IGxvZ291dEJ1dHRvbnMgPSBkb2N1bWVudC5xdWVyeVNlbGVjdG9yQWxsKGxvZ291dEJ1dHRvblF1ZXJ5U2VsZWN0b3IpO1xuICByZXR1cm4gQXJyYXkucHJvdG90eXBlLnNsaWNlXG4gICAgLmNhbGwobG9nb3V0QnV0dG9ucylcbiAgICAuZmlsdGVyKChsb2dvdXRCdXR0b24pID0+IGxvZ291dEJ1dHRvbiBpbnN0YW5jZW9mIEhUTUxCdXR0b25FbGVtZW50KTtcbn1cblxuZnVuY3Rpb24gaGFuZGxlR29Ub0xvZ2luQ2xpY2soKSB7XG4gIGlmICh3aW5kb3cuV2ViZmxvdy5lbnYoJ3ByZXZpZXcnKSkge1xuICAgIHJldHVybjtcbiAgfVxuICAvLyBAdHMtZXhwZWN0LWVycm9yIC0gVFMyMzIyIC0gVHlwZSAnc3RyaW5nJyBpcyBub3QgYXNzaWduYWJsZSB0byB0eXBlICdMb2NhdGlvbiB8IChzdHJpbmcgJiBMb2NhdGlvbiknLlxuICB3aW5kb3cubG9jYXRpb24gPSAnL2xvZy1pbic7XG59XG5cbmZ1bmN0aW9uIGhhbmRsZUxvZ091dEJ1dHRvbkNsaWNrKGV2ZW50OiBFdmVudCkge1xuICBldmVudC5wcmV2ZW50RGVmYXVsdCgpO1xuXG4gIGFzeW5jTG9nT3V0VXNlcigpLnRoZW4oKCkgPT4ge1xuICAgIC8vIEB0cy1leHBlY3QtZXJyb3IgLSBUUzIzMzkgLSBQcm9wZXJ0eSAnV2ViZmxvdycgZG9lcyBub3QgZXhpc3Qgb24gdHlwZSAnV2luZG93ICYgdHlwZW9mIGdsb2JhbFRoaXMnLlxuICAgIHdpbmRvdy5XZWJmbG93LmxvY2F0aW9uKCcvJyk7XG4gIH0pO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gaGFuZGxlTG9nSW5Mb2dPdXRCdXR0b24oKSB7XG4gIGdldExvZ291dEJ1dHRvbnMoKS5mb3JFYWNoKChsb2dvdXRCdXR0b24pID0+IHtcbiAgICBpZiAoXG4gICAgICBkb2N1bWVudC5jb29raWVcbiAgICAgICAgLnNwbGl0KCc7JylcbiAgICAgICAgLnNvbWUoKGNvb2tpZSkgPT4gY29va2llLmluZGV4T2YoTE9HR0VESU5fQ09PS0lFX05BTUUpID4gLTEpXG4gICAgKSB7XG4gICAgICBsb2dvdXRCdXR0b24uaW5uZXJIVE1MID1cbiAgICAgICAgbG9nb3V0QnV0dG9uLmdldEF0dHJpYnV0ZShVU1lTX0RBVEFfQVRUUlMubG9nb3V0KSB8fCAnTG9nIG91dCc7XG4gICAgICBsb2dvdXRCdXR0b24ucmVtb3ZlRXZlbnRMaXN0ZW5lcignY2xpY2snLCBoYW5kbGVHb1RvTG9naW5DbGljayk7XG4gICAgICBsb2dvdXRCdXR0b24uYWRkRXZlbnRMaXN0ZW5lcignY2xpY2snLCBoYW5kbGVMb2dPdXRCdXR0b25DbGljayk7XG4gICAgfSBlbHNlIGlmICghd2luZG93LldlYmZsb3cuZW52KCdkZXNpZ24nKSkge1xuICAgICAgbG9nb3V0QnV0dG9uLmlubmVySFRNTCA9XG4gICAgICAgIGxvZ291dEJ1dHRvbi5nZXRBdHRyaWJ1dGUoVVNZU19EQVRBX0FUVFJTLmxvZ2luKSB8fCAnTG9nIGluJztcbiAgICAgIGxvZ291dEJ1dHRvbi5yZW1vdmVFdmVudExpc3RlbmVyKCdjbGljaycsIGhhbmRsZUxvZ091dEJ1dHRvbkNsaWNrKTtcbiAgICAgIGxvZ291dEJ1dHRvbi5hZGRFdmVudExpc3RlbmVyKCdjbGljaycsIGhhbmRsZUdvVG9Mb2dpbkNsaWNrKTtcbiAgICB9XG4gIH0pO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gYXN5bmNMb2dPdXRVc2VyKCkge1xuICByZXR1cm4gdXNlclN5c3RlbXNSZXF1ZXN0Q2xpZW50Lm11dGF0ZSh7XG4gICAgbXV0YXRpb246IGxvZ291dE11dGF0aW9uLFxuICB9KTtcbn1cbiJdLCJuYW1lcyI6WyJhc3luY0xvZ091dFVzZXIiLCJoYW5kbGVMb2dJbkxvZ091dEJ1dHRvbiIsImxvZ291dEJ1dHRvblF1ZXJ5U2VsZWN0b3IiLCJVU1lTX0RBVEFfQVRUUlMiLCJsb2dvdXQiLCJnZXRMb2dvdXRCdXR0b25zIiwibG9nb3V0QnV0dG9ucyIsImRvY3VtZW50IiwicXVlcnlTZWxlY3RvckFsbCIsIkFycmF5IiwicHJvdG90eXBlIiwic2xpY2UiLCJjYWxsIiwiZmlsdGVyIiwibG9nb3V0QnV0dG9uIiwiSFRNTEJ1dHRvbkVsZW1lbnQiLCJoYW5kbGVHb1RvTG9naW5DbGljayIsIndpbmRvdyIsIldlYmZsb3ciLCJlbnYiLCJsb2NhdGlvbiIsImhhbmRsZUxvZ091dEJ1dHRvbkNsaWNrIiwiZXZlbnQiLCJwcmV2ZW50RGVmYXVsdCIsInRoZW4iLCJmb3JFYWNoIiwiY29va2llIiwic3BsaXQiLCJzb21lIiwiaW5kZXhPZiIsIkxPR0dFRElOX0NPT0tJRV9OQU1FIiwiaW5uZXJIVE1MIiwiZ2V0QXR0cmlidXRlIiwicmVtb3ZlRXZlbnRMaXN0ZW5lciIsImFkZEV2ZW50TGlzdGVuZXIiLCJsb2dpbiIsInVzZXJTeXN0ZW1zUmVxdWVzdENsaWVudCIsIm11dGF0ZSIsIm11dGF0aW9uIiwibG9nb3V0TXV0YXRpb24iXSwibWFwcGluZ3MiOiJBQUFBOzs7OztBQUtBOzs7Ozs7Ozs7OztJQXVEZ0JBLGVBQWU7ZUFBZkE7O0lBcEJBQyx1QkFBdUI7ZUFBdkJBOzs7dUJBakN1QjsyQkFJaEM7MkJBQ3NCO0FBRTdCLE1BQU1DLDRCQUE0QixDQUFDLENBQUMsRUFBRUMsMEJBQWUsQ0FBQ0MsTUFBTSxDQUFDLENBQUMsQ0FBQztBQUUvRCxTQUFTQztJQUNQLE1BQU1DLGdCQUFnQkMsU0FBU0MsZ0JBQWdCLENBQUNOO0lBQ2hELE9BQU9PLE1BQU1DLFNBQVMsQ0FBQ0MsS0FBSyxDQUN6QkMsSUFBSSxDQUFDTixlQUNMTyxNQUFNLENBQUMsQ0FBQ0MsZUFBaUJBLHdCQUF3QkM7QUFDdEQ7QUFFQSxTQUFTQztJQUNQLElBQUlDLE9BQU9DLE9BQU8sQ0FBQ0MsR0FBRyxDQUFDLFlBQVk7UUFDakM7SUFDRjtJQUNBLHdHQUF3RztJQUN4R0YsT0FBT0csUUFBUSxHQUFHO0FBQ3BCO0FBRUEsU0FBU0Msd0JBQXdCQyxLQUFZO0lBQzNDQSxNQUFNQyxjQUFjO0lBRXBCdkIsa0JBQWtCd0IsSUFBSSxDQUFDO1FBQ3JCLHNHQUFzRztRQUN0R1AsT0FBT0MsT0FBTyxDQUFDRSxRQUFRLENBQUM7SUFDMUI7QUFDRjtBQUVPLFNBQVNuQjtJQUNkSSxtQkFBbUJvQixPQUFPLENBQUMsQ0FBQ1g7UUFDMUIsSUFDRVAsU0FBU21CLE1BQU0sQ0FDWkMsS0FBSyxDQUFDLEtBQ05DLElBQUksQ0FBQyxDQUFDRixTQUFXQSxPQUFPRyxPQUFPLENBQUNDLCtCQUFvQixJQUFJLENBQUMsSUFDNUQ7WUFDQWhCLGFBQWFpQixTQUFTLEdBQ3BCakIsYUFBYWtCLFlBQVksQ0FBQzdCLDBCQUFlLENBQUNDLE1BQU0sS0FBSztZQUN2RFUsYUFBYW1CLG1CQUFtQixDQUFDLFNBQVNqQjtZQUMxQ0YsYUFBYW9CLGdCQUFnQixDQUFDLFNBQVNiO1FBQ3pDLE9BQU8sSUFBSSxDQUFDSixPQUFPQyxPQUFPLENBQUNDLEdBQUcsQ0FBQyxXQUFXO1lBQ3hDTCxhQUFhaUIsU0FBUyxHQUNwQmpCLGFBQWFrQixZQUFZLENBQUM3QiwwQkFBZSxDQUFDZ0MsS0FBSyxLQUFLO1lBQ3REckIsYUFBYW1CLG1CQUFtQixDQUFDLFNBQVNaO1lBQzFDUCxhQUFhb0IsZ0JBQWdCLENBQUMsU0FBU2xCO1FBQ3pDO0lBQ0Y7QUFDRjtBQUVPLFNBQVNoQjtJQUNkLE9BQU9vQywrQkFBd0IsQ0FBQ0MsTUFBTSxDQUFDO1FBQ3JDQyxVQUFVQyx5QkFBYztJQUMxQjtBQUNGIn0=

}),
13197: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    buildUpdateUsysUserDataMutation: function() {
        return buildUpdateUsysUserDataMutation;
    },
    cancelSubscriptionMutation: function() {
        return cancelSubscriptionMutation;
    },
    getUploadURLMutation: function() {
        return getUploadURLMutation;
    },
    loginMutation: function() {
        return loginMutation;
    },
    logoutMutation: function() {
        return logoutMutation;
    },
    resetPasswordMutation: function() {
        return resetPasswordMutation;
    },
    signupMutation: function() {
        return signupMutation;
    },
    updatePasswordMutation: function() {
        return updatePasswordMutation;
    },
    verifyEmailMutation: function() {
        return verifyEmailMutation;
    }
});
const _graphqltag = /*#__PURE__*/ _interop_require_default(__webpack_require__(28160));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const loginMutation = (0, _graphqltag.default)`
  mutation UserLoginRequest($email: String!, $authPassword: String!) {
    usysCreateSession(email: $email, authPassword: $authPassword) {
      user {
        id
        email
        createdOn
        emailVerified
      }
    }
  }
`;
function buildUpdateUsysUserDataMutation(dataFields) {
    return (0, _graphqltag.default)`
    mutation UpdateUsysUserData(
      $data: usys_update_user_data!
    ) {
      usysUpdateUserData(
        data: $data
    ) {
      data {
      ${dataFields.map((field)=>{
        const base = `${field.key}: ${field.type}(id: "${field.id}")`;
        if (field.type === 'option') {
            return base + '{\n slug \n}';
        }
        if (field.type === 'fileRef') {
            return base + '{\n id \n}';
        }
        return base;
    }).join('\n')}
        }
      }
    }
  `;
}
const signupMutation = (0, _graphqltag.default)`
  mutation UserSignupRequest(
    $email: String!
    $name: String!
    $acceptPrivacy: Boolean
    $acceptCommunications: Boolean
    $authPassword: String!
    $inviteToken: String
    $captchaToken: String
    $redirectPath: String
    $data: usys_update_user_data
  ) {
    usysCreateUser(
      email: $email
      name: $name
      acceptPrivacy: $acceptPrivacy
      acceptCommunications: $acceptCommunications
      authPassword: $authPassword
      inviteToken: $inviteToken
      captchaToken: $captchaToken
      redirectPath: $redirectPath
      data: $data
    ) {
      user {
        id
        email
        name
        createdOn
        emailVerified
      }
    }
  }
`;
const logoutMutation = (0, _graphqltag.default)`
  mutation UserLogoutRequest {
    usysDestroySession {
      ok
    }
  }
`;
const resetPasswordMutation = (0, _graphqltag.default)`
  mutation UserResetPasswordRequest($email: String!) {
    usysResetPassword(email: $email) {
      ok
    }
  }
`;
const updatePasswordMutation = (0, _graphqltag.default)`
  mutation UserUpdatePasswordRequest($authPassword: String!, $token: String!) {
    usysUpdatePassword(authPassword: $authPassword, token: $token) {
      ok
    }
  }
`;
const verifyEmailMutation = (0, _graphqltag.default)`
  mutation UserVerifyEmail($verifyToken: String!, $redirectPath: String) {
    usysVerifyEmail(verifyToken: $verifyToken, redirectPath: $redirectPath) {
      ok
    }
  }
`;
const cancelSubscriptionMutation = (0, _graphqltag.default)`
  mutation CancelSiteUserSubscription($subscriptionId: String!) {
    ecommerceCancelSubscriptionForSiteUser(subscriptionId: $subscriptionId) {
      ok
    }
  }
`;
const getUploadURLMutation = (0, _graphqltag.default)`
  mutation getUploadURL($fieldId: String!, $filename: String!) {
    usysGetUploadURL(fieldId: $fieldId, filename: $filename) {
      presignedPOST {
        url
        fields {
          key
          value
        }
      }
      key
    }
  }
`;

//# sourceMappingURL=data:application/json;base64,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

}),
3671: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    buildGetLoggedInUserQuery: function() {
        return buildGetLoggedInUserQuery;
    },
    getFieldValidations: function() {
        return getFieldValidations;
    },
    getUserSubscriptions: function() {
        return getUserSubscriptions;
    }
});
const _graphqltag = /*#__PURE__*/ _interop_require_default(__webpack_require__(28160));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const getUserSubscriptions = (0, _graphqltag.default)`
  query FetchSubscriptions {
    database {
      id
      userSubscriptions {
        _id
        productName
        variantPrice {
          string
          unit
          value
        }
        variantImage {
          url
          alt
        }
        status
        lastInvoiced
        periodEnd
        subCreatedOn
        canceledOn
        billingAddressAddressee
        billingAddressLine1
        billingAddressLine2
        billingAddressCity
        billingAddressState
        billingAddressPostalCode
        billingAddressCountry
        cardLast4
        cardExpiresMonth
        cardExpiresYear
      }
    }
  }
`;
function buildGetLoggedInUserQuery(dataFields = []) {
    return (0, _graphqltag.default)`
    query FetchUser {
        site {
          id
          siteUser {
            id
            createdOn
            ${dataFields.length > 0 ? `
            data {
              ${dataFields.map((field)=>{
        const base = `${field.key}: ${field.type}(id: "${field.id}")`;
        if (field.type === 'option') {
            return base + '{\n slug \n}';
        }
        if (field.type === 'fileRef') {
            return base + '{\n url \n \n id \n}';
        }
        return base;
    }).join('\n')}
            }` : ''}
        }
      }
    }
  `;
}
const getFieldValidations = (0, _graphqltag.default)`
  query GetFieldValidations {
    site {
      id
      usysFieldSchema {
        id
        required
        validations {
          minLength
          maxLength
          min
          max
          step
          extensions
          options {
            slug
            name
          }
        }
      }
    }
  }
`;

//# sourceMappingURL=data:application/json;base64,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

}),
85513: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/* globals
 window
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    applyBindingsAndConditionalVisibility: function() {
        return applyBindingsAndConditionalVisibility;
    },
    applyUserAccountData: function() {
        return applyUserAccountData;
    }
});
const _escape = /*#__PURE__*/ _interop_require_default(__webpack_require__(28929));
const _get = /*#__PURE__*/ _interop_require_default(__webpack_require__(24738));
const _Transformers = __webpack_require__(61649);
const _RenderingUtils = __webpack_require__(86078);
const _constants = __webpack_require__(29197);
const _constants1 = __webpack_require__(10873);
const _constants2 = __webpack_require__(7462);
const _universalUtils = __webpack_require__(62467);
const _utils = __webpack_require__(56897);
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const getPropertyMutator = (bindingProperty)=>{
    if (typeof mutators[bindingProperty] === 'function') {
        return mutators[bindingProperty];
    }
    return null;
};
const mutators = {
    innerHTML: (node, type, value)=>{
        const valueString = value != null ? String(value) : '';
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ PlainText: string; HighlightedText: string; RichText: string; Number: string; Video: string; Option: string; Date: string; Phone: string; Email: string; CommercePrice: string; Link: string; ImageRef: boolean; FileRef: boolean; ItemRef: boolean; CommercePropValues: string; }'.
        if (_constants.SHARED_ALLOWED_FIELD_TYPES.innerHTML[type] === 'innerHTML') {
            node.innerHTML = valueString;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ PlainText: string; HighlightedText: string; RichText: string; Number: string; Video: string; Option: string; Date: string; Phone: string; Email: string; CommercePrice: string; Link: string; ImageRef: boolean; FileRef: boolean; ItemRef: boolean; CommercePropValues: string; }'.
        } else if (_constants.SHARED_ALLOWED_FIELD_TYPES.innerHTML[type] === 'innerText') {
            node.innerHTML = (0, _escape.default)(valueString);
        }
        if (node.innerHTML) {
            node.classList.remove('w-dyn-bind-empty');
        }
    },
    src: (node, type, value)=>{
        if (value && value.url) {
            node.setAttribute('src', value.url);
        }
        node.classList.remove('w-dyn-bind-empty');
    }
};
const bindDataToNode = (node, data, bindings)=>{
    bindings.forEach((binding)=>{
        Object.keys(binding).forEach((bindingProperty)=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"innerHTML" | "src", Binding>>'.
            const bindingValue = binding[bindingProperty];
            const { dataPath, filter, timezone, type } = bindingValue;
            const rawValue = (0, _get.default)(data, dataPath);
            const transformedValue = (0, _Transformers.transformers)(rawValue, filter, {
                timezone,
                collectionSlugMap: {},
                // @ts-expect-error - TS2339 - Property '__WEBFLOW_CURRENCY_SETTINGS' does not exist on type 'Window & typeof globalThis'.
                currencySettings: window.__WEBFLOW_CURRENCY_SETTINGS
            });
            // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"innerHTML" | "src"'.
            const propertyMutator = getPropertyMutator(bindingProperty);
            if (propertyMutator) {
                propertyMutator(node, type, transformedValue);
            }
        });
    });
};
function applyBindingsAndConditionalVisibility(node, data) {
    // Apply bindings
    if (node.hasAttribute(_constants1.WF_BINDING_DATA_KEY)) {
        const bindingsStr = node.getAttribute(_constants1.WF_BINDING_DATA_KEY) || '';
        const bindings = JSON.parse(decodeURIComponent(bindingsStr));
        if (bindings) {
            bindDataToNode(node, data, bindings);
        }
    }
    // Apply conditional visibility
    if (node.hasAttribute(_constants1.WF_CONDITION_DATA_KEY)) {
        const conditionsStr = node.getAttribute(_constants1.WF_CONDITION_DATA_KEY) || '';
        const conditionData = JSON.parse(decodeURIComponent(conditionsStr));
        if (conditionData) {
            (0, _RenderingUtils.applyConditionToNode)(node, data, conditionData);
        }
    }
}
function getFirstAncestor(element, pred) {
    if (element.parentNode === null) {
        return null;
    }
    // @ts-expect-error - TS2345 - Argument of type 'ElementWithInputProperties' is not assignable to parameter of type 'never'.
    if (pred(element)) {
        return element;
    }
    // @ts-expect-error - TS2345 - Argument of type 'ParentNode' is not assignable to parameter of type 'ElementWithInputProperties'.
    return getFirstAncestor(element.parentNode, pred);
}
function hasFormFileUploadWrapperClass(element) {
    return element.classList.contains('w-file-upload');
}
function setFileUploadValue(node, fileId) {
    if (!fileId) return;
    (0, _universalUtils.setUserFileKey)(node, fileId);
    const formFileUploadWrapper = getFirstAncestor(node, // @ts-expect-error - TS2345 - Argument of type '(element: any) => any' is not assignable to parameter of type '(element: never) => never'.
    hasFormFileUploadWrapperClass);
    if (formFileUploadWrapper === null) return;
    const formFileDefault = formFileUploadWrapper.querySelector('.w-file-upload-default');
    const formFileSuccess = formFileUploadWrapper.querySelector('.w-file-upload-success');
    const formFileError = formFileUploadWrapper.querySelector('.w-file-upload-error');
    const formFileUploading = formFileUploadWrapper.querySelector('.w-file-upload-uploading');
    // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null'.
    (0, _utils.addHiddenClass)(formFileDefault);
    // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null'.
    (0, _utils.addHiddenClass)(formFileError);
    // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null'.
    (0, _utils.addHiddenClass)(formFileUploading);
    // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null'.
    (0, _utils.removeHiddenClass)(formFileSuccess);
}
function applyUserAccountData(node, userData) {
    // Apply user name, checkbox, and custom fields
    if (node.hasAttribute(_constants2.USYS_DATA_ATTRS.field)) {
        const field = node.getAttribute(_constants2.USYS_DATA_ATTRS.field) || '';
        const fieldType = node.getAttribute(_constants2.USYS_DATA_ATTRS.fieldType) || '';
        if (fieldType === 'Option') {
            node.value = (0, _get.default)(userData, [
                `f_${field}`,
                'slug'
            ], '');
            return;
        }
        if (fieldType === 'FileRef') {
            setFileUploadValue(node, (0, _get.default)(userData, [
                `f_${field}`,
                'id'
            ], ''));
            return;
        }
        const dataPath = field && field.includes(_constants2.RESERVED_USER_PREFIX) ? _constants2.KEY_FROM_RESERVED_USER_FIELD[field] : `f_${field}`;
        // @ts-expect-error - TS2769 - No overload matches this call.
        const value = (0, _get.default)(userData, [
            dataPath
        ], '');
        if (node.type === 'checkbox' && node.checked !== Boolean(value) && node.click) {
            // Set the checkbox to the right `checked` value, but also trigger the onChange event
            node.click();
            return;
        }
        node.value = value;
    }
    // Apply user email, if not empty
    if (node.hasAttribute(_constants2.USYS_DATA_ATTRS.inputType)) {
        const dataPath = node.getAttribute(_constants2.USYS_DATA_ATTRS.inputType) || '';
        const value = (0, _get.default)(userData, [
            dataPath
        ], '');
        if (value) {
            node.value = value;
        }
    }
}

//# sourceMappingURL=data:application/json;base64,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

}),
63245: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/*
  globals
  document,
  HTMLFormElement,
  HTMLInputElement
*/ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    asyncRequestResetPassword: function() {
        return asyncRequestResetPassword;
    },
    handleResetPasswordForms: function() {
        return handleResetPasswordForms;
    }
});
const _utils = __webpack_require__(56897);
const _constants = __webpack_require__(7462);
const _mutations = __webpack_require__(13197);
const _client = __webpack_require__(22805);
const resetPasswordFormQuerySelector = `form[${_constants.USYS_DATA_ATTRS.formType}="${_constants.USYS_FORM_TYPES.resetPassword}"]`;
// error handling
const errorState = document.querySelector(`[${_constants.USYS_DATA_ATTRS.formError}]`);
const defaultErrorCopy = // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
_constants.resetPasswordErrorStates[_constants.RESET_PASSWORD_UI_ERROR_CODES.GENERAL_ERROR].copy;
const errorMsgNode = document.querySelector(`.${_constants.ERROR_MSG_CLASS}`);
const getResetPasswordErrorCode = (error)=>{
    // right now we only have one error, this is for when add more
    let errorCode;
    switch(error){
        default:
            errorCode = _constants.RESET_PASSWORD_UI_ERROR_CODES.GENERAL_ERROR;
    }
    return errorCode;
};
function getResetPasswordForms() {
    const resetPasswordForms = document.querySelectorAll(resetPasswordFormQuerySelector);
    return Array.prototype.slice.call(resetPasswordForms).filter((resetPasswordForm)=>resetPasswordForm instanceof HTMLFormElement);
}
function handleResetPasswordForms() {
    getResetPasswordForms().forEach((resetPasswordForm)=>{
        resetPasswordForm.addEventListener('submit', (event)=>{
            event.preventDefault();
            const form = event.currentTarget;
            const successMessage = document.querySelector(`.${_constants.USYS_DOM_CLASS_NAMES.formSuccess}`);
            if (!(form instanceof HTMLFormElement)) {
                return;
            }
            // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null | undefined'.
            (0, _utils.hideElement)(errorState);
            const emailInput = form.querySelector(`input[${_constants.USYS_DATA_ATTRS.inputType}="${_constants.USYS_INPUT_TYPES.email}"]`);
            if (!(emailInput instanceof HTMLInputElement)) {
                return;
            }
            asyncRequestResetPassword(emailInput.value).then(()=>{
                (0, _utils.hideElement)(form);
                // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null | undefined'.
                (0, _utils.showAndFocusElement)(successMessage);
            }).catch((error)=>{
                if (errorState) {
                    // if there isn't an error code, send an empty string so a generic error message appears
                    const gqlError = _client.CombinedGraphQLErrors.is(error) ? error.errors[0] : null;
                    const elementErrorCode = gqlError && 'code' in gqlError && typeof gqlError.code === 'string' ? gqlError.code : '';
                    const errorCode = getResetPasswordErrorCode(elementErrorCode);
                    (0, _utils.handleErrorNode)(errorMsgNode, // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
                    errorState, errorCode, _constants.ERROR_ATTRIBUTE_PREFIX.RESET_PASSWORD, defaultErrorCopy);
                }
            });
        });
    });
}
function asyncRequestResetPassword(email) {
    return _utils.userSystemsRequestClient.mutate({
        mutation: _mutations.resetPasswordMutation,
        variables: {
            email
        }
    });
}

//# sourceMappingURL=data:application/json;base64,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

}),
54284: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/*
  globals
  document,
  HTMLFormElement,
  HTMLInputElement,
  window
*/ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    asyncSignUpUser: function() {
        return asyncSignUpUser;
    },
    handleSignUpForms: function() {
        return handleSignUpForms;
    }
});
const _utils = __webpack_require__(56897);
const _constants = __webpack_require__(7462);
const _mutations = __webpack_require__(13197);
const _fields = __webpack_require__(18457);
const _turnstileCaptcha = __webpack_require__(88432);
const signupFormQuerySelector = `form[${_constants.USYS_DATA_ATTRS.formType}="${_constants.USYS_FORM_TYPES.signup}"]`;
const verificationMessage = document.querySelector(`.${_constants.USYS_DOM_CLASS_NAMES.formVerfication}`);
function getSignupForms() {
    const signupForms = document.querySelectorAll(signupFormQuerySelector);
    return Array.prototype.slice.call(signupForms).filter((signupForm)=>signupForm instanceof HTMLFormElement);
}
function handleUserInvite(email) {
    // email is for DISPLAY use ONLY for security reasons
    const form = document.querySelector(signupFormQuerySelector);
    if (!(form instanceof HTMLFormElement)) {
        return;
    }
    const emailInput = form.querySelector(`input[${_constants.USYS_DATA_ATTRS.inputType}="${_constants.USYS_INPUT_TYPES.email}"]`);
    if (!(emailInput instanceof HTMLInputElement)) {
        return;
    }
    // disable email input
    emailInput.disabled = true;
    emailInput.classList.add('w-input-disabled');
    // and set the value to the user's email
    emailInput.value = email;
}
// users are sent to the sign up page to complete verification
function handleEmailVerification(token, errorState) {
    const form = document.querySelector(signupFormQuerySelector);
    // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null | undefined'.
    (0, _utils.hideElement)(form);
    asyncVerifyEmailToken(token).then(()=>{
        const successMessage = document.querySelector(`.${_constants.USYS_DOM_CLASS_NAMES.formSuccess}`);
        const redirectAnchor = document.querySelector(`[${_constants.USYS_DATA_ATTRS.redirectUrl}] a`);
        const redirectPath = (0, _utils.getRedirectPath)();
        // If redirect param exists, use that path for the redirect anchor href
        if (redirectPath && redirectAnchor) {
            redirectAnchor.setAttribute('href', encodeURIComponent(redirectPath));
        }
        // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null | undefined'.
        (0, _utils.showElement)(successMessage);
        // If redirect anchor exists, use that as default redirect path
        (0, _utils.handleRedirect)(redirectAnchor?.getAttribute('href') ?? '/', true);
    }).catch((error)=>{
        // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null | undefined'.
        (0, _utils.showElement)(verificationMessage);
        // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null'.
        (0, _utils.userFormError)(form, errorState, 'SIGNUP')(error);
    });
}
function handleSignUpForms() {
    // we will check to see if there is a token in the link to initiate the verification flow
    // otherwise, the regular sign-up form will be shown
    const params = new URLSearchParams(window.location.search);
    const inviteToken = params.get('inviteToken') || '';
    const verifyToken = params.get('verifyToken') || '';
    const errorState = document.querySelector(`[${_constants.USYS_DATA_ATTRS.formError}]`);
    let turnstileScript = null;
    getSignupForms().forEach((signupForm)=>{
        const submitButton = signupForm.querySelector('input[type="submit"]');
        const sendSubmitData = (captchaToken)=>{
            const submitText = (0, _utils.disableSubmit)(submitButton);
            const commonFields = (0, _fields.getCommonFields)(signupForm);
            const customFields = (0, _fields.getCustomFields)(signupForm);
            // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null | undefined'.
            (0, _utils.hideElement)(errorState);
            asyncSignUpUser((0, _fields.getFieldValueById)('email', commonFields) || '', (0, _fields.getFieldValueById)('name', commonFields) || '', (0, _fields.getFieldValueById)('password', commonFields) || '', (0, _fields.getFieldValueById)('accept-privacy', commonFields) || false, (0, _fields.getFieldValueById)('accept-communications', commonFields) || false, customFields, inviteToken, captchaToken).then(()=>{
                if (inviteToken) {
                    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Location | (string & Location)'.
                    window.location = '/log-in';
                } else {
                    (0, _utils.hideElement)(signupForm);
                    // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null | undefined'.
                    (0, _utils.showAndFocusElement)(verificationMessage);
                }
            })// @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null'.
            .catch((0, _utils.userFormError)(signupForm, errorState, 'SIGNUP')).finally(()=>{
                // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null'.
                (0, _utils.resetSubmit)(submitButton, submitText);
            });
        };
        const captchaSiteKey = signupForm.getAttribute('wf-captcha-site-key');
        const captchaMode = signupForm.getAttribute('wf-captcha-mode');
        if (captchaSiteKey && captchaMode && !turnstileScript) {
            // @ts-expect-error - TS18047 - 'submitButton' is possibly 'null'.
            submitButton.setAttribute('disabled', 'true');
            turnstileScript = document.createElement('script');
            turnstileScript.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
            document.head.appendChild(turnstileScript);
            turnstileScript.onload = ()=>{
                signupForm.addEventListener('submit', (e)=>{
                    e.preventDefault();
                    (0, _turnstileCaptcha.renderTurnstileCaptcha)(captchaSiteKey, captchaMode, sendSubmitData);
                });
                // @ts-expect-error - TS18047 - 'submitButton' is possibly 'null'.
                submitButton.removeAttribute('disabled');
            };
        } else {
            signupForm.addEventListener('submit', (e)=>{
                e.preventDefault();
                sendSubmitData(null);
            });
        }
        if (inviteToken) {
            const email = params.get('email') || '';
            handleUserInvite(email);
        }
        if (verifyToken) {
            // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null'.
            handleEmailVerification(verifyToken, errorState);
        }
    });
}
function asyncSignUpUser(email, name = '', password, acceptPrivacy, acceptCommunications, customFields, inviteToken, captchaToken) {
    const variables = {
        email,
        name,
        acceptPrivacy,
        acceptCommunications,
        authPassword: password,
        data: (0, _fields.getFieldsAsTypeKeys)(customFields),
        inviteToken: inviteToken || undefined,
        captchaToken: captchaToken || undefined,
        redirectPath: (0, _utils.getRedirectPath)()
    };
    return _utils.userSystemsRequestClient.mutate({
        mutation: _mutations.signupMutation,
        variables
    });
}
function asyncVerifyEmailToken(verifyToken) {
    return _utils.userSystemsRequestClient.mutate({
        mutation: _mutations.verifyEmailMutation,
        variables: {
            verifyToken,
            redirectPath: (0, _utils.getRedirectPath)()
        }
    });
}

//# sourceMappingURL=data:application/json;base64,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

}),
88432: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "renderTurnstileCaptcha", ({
    enumerable: true,
    get: function() {
        return renderTurnstileCaptcha;
    }
}));
function setSplashScreenStyles(element) {
    element.style.display = 'flex';
    element.style.position = 'fixed';
    element.style.top = '0';
    element.style.left = '0';
    element.style.width = '100%';
    element.style.height = '100%';
    element.style.background = 'rgba(255, 255, 255, 0.8)';
    element.style.justifyContent = 'center';
    element.style.alignItems = 'center';
    element.style.textAlign = 'center';
    element.style.zIndex = '1000';
    element.style.opacity = '0';
    element.style.transition = 'opacity 1s ease-in-out';
}
const addSplashScreen = ()=>{
    const splashScreen = document.createElement('div');
    setSplashScreenStyles(splashScreen);
    const captchaContainer = document.createElement('div');
    splashScreen.appendChild(captchaContainer);
    document.body.appendChild(splashScreen);
    setTimeout(()=>{
        splashScreen.style.opacity = '1';
    }, 10);
    return splashScreen;
};
const renderTurnstileCaptcha = (captchaSiteKey, captchaMode, cb)=>{
    let splashScreen;
    if (captchaMode !== 'invisible') {
        splashScreen = addSplashScreen();
    }
    const captchaContainer = document.createElement('div');
    if (splashScreen) {
        splashScreen.appendChild(captchaContainer);
    } else {
        document.body.appendChild(captchaContainer);
    }
    // Render the captcha
    // @ts-expect-error - TS2304: Cannot find name 'turnstile'.
    turnstile.render(captchaContainer, {
        sitekey: captchaSiteKey,
        callback: function(token) {
            setTimeout(function() {
                if (splashScreen) {
                    splashScreen.remove();
                }
            }, 1000);
            return cb(token);
        }
    });
};

//# sourceMappingURL=data:application/json;base64,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

}),
10104: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/*
  globals
  document,
  HTMLFormElement,
  HTMLInputElement,
  window
*/ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    asyncRequestUpdatePassword: function() {
        return asyncRequestUpdatePassword;
    },
    handleUpdatePasswordForms: function() {
        return handleUpdatePasswordForms;
    }
});
const _utils = __webpack_require__(56897);
const _constants = __webpack_require__(7462);
const _mutations = __webpack_require__(13197);
const _client = __webpack_require__(22805);
const updatePasswordFormQuerySelector = `form[${_constants.USYS_DATA_ATTRS.formType}="${_constants.USYS_FORM_TYPES.updatePassword}"]`;
// error handling
const errorState = document.querySelector(`[${_constants.USYS_DATA_ATTRS.formError}]`);
const defaultErrorCopy = // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
_constants.updatePasswordErrorStates[_constants.UPDATE_PASSWORD_UI_ERROR_CODES.GENERAL_ERROR].copy;
const errorMsgNode = document.querySelector(`.${_constants.ERROR_MSG_CLASS}`);
const getUpdatePasswordErrorCode = (error)=>{
    let errorCode;
    switch(error){
        case 'UsysInvalidPassword':
            errorCode = _constants.UPDATE_PASSWORD_UI_ERROR_CODES.WEAK_PASSWORD;
            break;
        default:
            errorCode = _constants.UPDATE_PASSWORD_UI_ERROR_CODES.GENERAL_ERROR;
    }
    return errorCode;
};
function getUpdatePasswordForms() {
    const updatePasswordForms = document.querySelectorAll(updatePasswordFormQuerySelector);
    return Array.prototype.slice.call(updatePasswordForms).filter((updatePasswordForm)=>updatePasswordForm instanceof HTMLFormElement);
}
function handleUpdatePasswordForms() {
    getUpdatePasswordForms().forEach((updatePasswordForm)=>{
        updatePasswordForm.addEventListener('submit', (event)=>{
            event.preventDefault();
            const form = event.currentTarget;
            const successMessage = document.querySelector(`.${_constants.USYS_DOM_CLASS_NAMES.formSuccess}`);
            if (!(form instanceof HTMLFormElement)) {
                return;
            }
            const errorElement = document.querySelector(`[${_constants.USYS_DATA_ATTRS.formError}]`);
            // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null | undefined'.
            (0, _utils.hideElement)(errorElement);
            const passwordInput = form.querySelector(`input[${_constants.USYS_DATA_ATTRS.inputType}="${_constants.USYS_INPUT_TYPES.password}"]`);
            if (!(passwordInput instanceof HTMLInputElement)) {
                return;
            }
            const params = new URLSearchParams(window.location.search);
            const token = params.get('token') || '';
            asyncRequestUpdatePassword(passwordInput.value, token).then(()=>{
                (0, _utils.hideElement)(form);
                // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'HTMLElement | null | undefined'.
                (0, _utils.showAndFocusElement)(successMessage);
            }).catch((error)=>{
                if (errorState) {
                    // if there isn't an error code, send an empty string so a generic error message appears
                    const gqlError = _client.CombinedGraphQLErrors.is(error) ? error.errors[0] : null;
                    const elementErrorCode = gqlError && 'code' in gqlError && typeof gqlError.code === 'string' ? gqlError.code : '';
                    const errorCode = getUpdatePasswordErrorCode(elementErrorCode);
                    (0, _utils.handleErrorNode)(errorMsgNode, // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
                    errorState, errorCode, _constants.ERROR_ATTRIBUTE_PREFIX.UPDATE_PASSWORD, defaultErrorCopy);
                }
            });
        });
    });
}
function asyncRequestUpdatePassword(authPassword, token) {
    return _utils.userSystemsRequestClient.mutate({
        mutation: _mutations.updatePasswordMutation,
        variables: {
            authPassword,
            token
        }
    });
}

//# sourceMappingURL=data:application/json;base64,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

}),
65438: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "handleFields", ({
    enumerable: true,
    get: function() {
        return handleFields;
    }
}));
const _utils = __webpack_require__(56897);
const _queries = __webpack_require__(3671);
const _constants = __webpack_require__(7462);
const _universalUtils = __webpack_require__(62467);
const _mutations = __webpack_require__(13197);
const _client = __webpack_require__(22805);
/* global window, HTMLInputElement, HTMLSelectElement, document */ function asyncGetFieldValidations() {
    return _utils.userSystemsRequestClient.query({
        query: _queries.getFieldValidations
    });
}
function signFile(file, { fieldId }) {
    return _utils.userSystemsRequestClient.mutate({
        mutation: _mutations.getUploadURLMutation,
        variables: {
            fieldId,
            filename: file.name
        }
    });
}
function setRequired(input, userField) {
    if (userField.required == null) return;
    input.required = userField.required;
}
const inputAttributeMap = {
    minLength: 'minlength',
    maxLength: 'maxlength',
    min: 'min',
    max: 'max',
    step: 'step',
    extensions: 'accept'
};
const formatValueMap = {
    extensions: function accept(value) {
        return value.join(',');
    }
};
function convertToStr(value) {
    return String(value);
}
function setValidations(input, userField) {
    if (userField.validations == null) return;
    Object.keys(userField.validations).map((attr)=>{
        const val = userField.validations[attr];
        if (attr === 'options' && Array.isArray(val) && input instanceof HTMLSelectElement) {
            val.forEach((option)=>{
                if (option.slug && option.name) {
                    const opt = document.createElement('option');
                    opt.value = option.slug;
                    opt.innerHTML = option.name;
                    input.appendChild(opt);
                }
            });
        }
        if (val !== null && inputAttributeMap[attr]) {
            let formatValue;
            if (formatValueMap[attr]) {
                formatValue = formatValueMap[attr];
            } else {
                formatValue = convertToStr;
            }
            input.setAttribute(inputAttributeMap[attr], formatValue(val));
        }
        if (attr === 'maxLength' && val === null) {
            input.removeAttribute('maxlength');
        }
    });
}
function setUserFieldValidationAttr(input, userField) {
    const fieldType = input.getAttribute(_constants.USYS_DATA_ATTRS.fieldType);
    if (!_constants.NO_REQUIRED_ATTRIBUTE.includes(fieldType)) {
        setRequired(input, userField);
    }
    setValidations(input, userField);
}
function matchInputToData(input, userFieldData) {
    const fieldId = input.getAttribute(_constants.USYS_DATA_ATTRS.field);
    if (!fieldId) {
        return null;
    }
    for(let i = 0; i < userFieldData.length; i++){
        if (userFieldData[i].id === fieldId) {
            return userFieldData[i];
        }
    }
    return null;
}
function setFieldValidation(customFieldInputs) {
    asyncGetFieldValidations().then((response)=>{
        const userFieldData = response.data.site.usysFieldSchema;
        if (!userFieldData) return;
        for(let i = 0; i < customFieldInputs.length; i++){
            const input = customFieldInputs[i];
            if (!input || !(input instanceof HTMLInputElement || input instanceof HTMLSelectElement) || input.getAttribute(_constants.USYS_DATA_ATTRS.fieldType) === 'Bool') {
                continue;
            }
            const userField = matchInputToData(input, userFieldData);
            if (!userField) continue;
            setUserFieldValidationAttr(input, userField);
        }
    }).catch((err)=>{
        console.error(err);
    });
}
function getMatchingSiblings(e, pred) {
    const siblings = [];
    if (e.target.parentNode === null) {
        return siblings;
    }
    [].slice.call(e.target.parentNode.children).forEach((element)=>{
        if (pred(element)) {
            siblings.push(element);
        }
    });
    return siblings;
}
function isFormFileUploadWrapper(element) {
    return element.classList.contains('w-file-upload');
}
function getFirstAncestor(element, pred) {
    if (element.parentNode === null) {
        return null;
    }
    if (pred(element)) {
        return element;
    }
    return getFirstAncestor(element.parentNode, pred);
}
function handleFileRemoveLink(cancelRemoveLinkElement, inputElement, props) {
    const { deleteFile, cancelFile } = props;
    cancelRemoveLinkElement.addEventListener('click', function(e) {
        if (e.type === 'keydown') {
            if (e.which !== 13 && e.which !== 32) {
                return;
            }
            e.preventDefault();
        }
        if ((0, _universalUtils.getUserFileKey)(inputElement)) {
            deleteFile();
            return;
        }
        cancelFile();
    });
}
function handleFileUploadInput(element, props) {
    const { showUploading, successUpload, errorUpload, changeFileNameText, disableSubmitButton, filesState } = props;
    const fieldId = element.getAttribute(_constants.USYS_DATA_ATTRS.field);
    element.addEventListener('change', function(e) {
        if (filesState.isUploading) return;
        const file = e.target && e.target.files && e.target.files[0];
        if (!file) {
            return;
        }
        showUploading();
        changeFileNameText(file.name);
        filesState.isUploading = true;
        if (!filesState.isUploading) {
            disableSubmitButton();
        }
        let key = '';
        signFile(file, {
            fieldId
        }).then((res)=>{
            if (!res.data || !res.data.usysGetUploadURL || !res.data.usysGetUploadURL.presignedPOST) {
                throw Error(res);
            }
            const presignedPOST = res.data.usysGetUploadURL.presignedPOST;
            key = res.data.usysGetUploadURL.key;
            const AWSFields = {};
            presignedPOST.fields.forEach((field)=>{
                const _key = field.key;
                const value = field.value;
                AWSFields[_key] = value;
            });
            return (0, _universalUtils.uploadFileToS3)(presignedPOST.url, AWSFields, file);
        }).then(()=>{
            successUpload(key);
        }).catch((err)=>{
            let code = _constants.SERVER_DATA_VALIDATION_ERRORS.DefaultError;
            if (typeof err === 'string') {
                const content = new window.DOMParser().parseFromString(err, 'text/xml');
                const codeElements = content.getElementsByTagName('Code');
                if (codeElements) {
                    code = codeElements[0].innerHTML;
                }
            }
            if (_client.CombinedGraphQLErrors.is(err) && err.errors[0]?.code === 'UsysForbiddenFileExtension') {
                code = _constants.SERVER_DATA_VALIDATION_ERRORS.ExtensionsError;
            }
            errorUpload(code);
        }).finally(()=>{
            filesState.isUploading = false;
        });
    });
}
const WF_SUBMIT_BUTTON_VALUE = 'wf-submit-button-value';
const adaptAWSErrors = (code)=>{
    if (code === 'EntityTooLarge') return _constants.SERVER_DATA_VALIDATION_ERRORS.MinSizeError;
    if (code === 'EntityTooSmall') return _constants.SERVER_DATA_VALIDATION_ERRORS.MaxSizeError;
    return code;
};
function handleFileUploadInputs(customFieldInputs, props) {
    const { disableSubmitButton, enableSubmitButton } = props;
    const filesState = {
        isUploading: false
    };
    customFieldInputs.forEach((el)=>{
        if (el.getAttribute('type') === 'file') {
            const formFileUploadWrapper = getFirstAncestor(el, isFormFileUploadWrapper);
            const formFileDefault = formFileUploadWrapper.querySelector('.w-file-upload-default');
            const formFileSuccess = formFileUploadWrapper.querySelector('.w-file-upload-success');
            const formFileError = formFileUploadWrapper.querySelector('.w-file-upload-error');
            const formFileErrorMsg = formFileError.querySelector('.w-file-upload-error-msg');
            const formFileUploading = formFileUploadWrapper.querySelector('.w-file-upload-uploading');
            const fileUploadFileName = formFileUploadWrapper.querySelector('.w-file-upload-file-name');
            const fileRemoveLink = formFileUploadWrapper.querySelector('.w-file-remove-link');
            const fileUploadLabel = formFileUploadWrapper.querySelector('.w-file-upload-label');
            // eslint-disable-next-line no-inner-declarations
            function showUploading() {
                (0, _utils.addHiddenClass)(formFileDefault);
                (0, _utils.addHiddenClass)(formFileError);
                (0, _utils.addHiddenClass)(formFileSuccess);
                (0, _utils.removeHiddenClass)(formFileUploading);
                formFileUploading.focus();
                disableSubmitButton();
            }
            // eslint-disable-next-line no-inner-declarations
            function successUpload(fileUrl) {
                (0, _utils.addHiddenClass)(formFileDefault);
                (0, _utils.addHiddenClass)(formFileError);
                (0, _utils.addHiddenClass)(formFileUploading);
                (0, _utils.removeHiddenClass)(formFileSuccess);
                formFileSuccess.focus();
                enableSubmitButton();
                (0, _universalUtils.setTempUserFileKey)(el, fileUrl);
            }
            // eslint-disable-next-line no-inner-declarations
            function errorUpload(code = _constants.SERVER_DATA_VALIDATION_ERRORS.DefaultError) {
                const errorText = formFileErrorMsg.getAttribute(adaptAWSErrors(code).toLowerCase());
                (0, _utils.addHiddenClass)(formFileSuccess);
                (0, _utils.addHiddenClass)(formFileUploading);
                (0, _utils.removeHiddenClass)(formFileDefault);
                (0, _utils.removeHiddenClass)(formFileError);
                if (errorText) {
                    formFileErrorMsg.innerHTML = errorText;
                }
                formFileError.focus();
                enableSubmitButton();
            }
            // eslint-disable-next-line no-inner-declarations
            function showDefault() {
                (0, _utils.addHiddenClass)(formFileSuccess);
                (0, _utils.addHiddenClass)(formFileUploading);
                (0, _utils.addHiddenClass)(formFileError);
                (0, _utils.removeHiddenClass)(formFileDefault);
                fileUploadLabel.focus();
            }
            // eslint-disable-next-line no-inner-declarations
            function changeFileNameText(filename) {
                fileUploadFileName.innerHTML = filename;
            }
            // eslint-disable-next-line no-inner-declarations
            function cancelFile() {
                changeFileNameText('');
                (0, _universalUtils.removeTempUserFileKey)(el);
                showDefault();
            }
            // eslint-disable-next-line no-inner-declarations
            function deleteFile() {
                (0, _universalUtils.setUserFileKey)(el, 'DELETE');
                cancelFile();
            }
            handleFileRemoveLink(fileRemoveLink, el, {
                deleteFile,
                cancelFile
            });
            handleFileUploadInput(el, {
                showUploading,
                successUpload,
                errorUpload,
                changeFileNameText,
                fileRemoveLink,
                filesState
            });
        }
    });
}
function handleFields() {
    const userForms = document.querySelectorAll(`form[${_constants.USYS_DATA_ATTRS.formType}]`);
    userForms.forEach((userForm)=>{
        const customFieldInputs = userForm.querySelectorAll(`input[${_constants.USYS_DATA_ATTRS.field}], select[${_constants.USYS_DATA_ATTRS.field}]`);
        const submitButton = userForm.querySelector('input[type="submit"]');
        submitButton.setAttribute(WF_SUBMIT_BUTTON_VALUE, submitButton.value);
        function disableSubmitButton() {
            if (submitButton) {
                (0, _utils.disableSubmit)(submitButton);
            }
        }
        function enableSubmitButton() {
            if (submitButton) {
                submitButton.removeAttribute('disabled');
                submitButton.setAttribute('value', submitButton.getAttribute(WF_SUBMIT_BUTTON_VALUE) || 'Submit');
            }
        }
        if (customFieldInputs.length > 0) {
            setFieldValidation(customFieldInputs);
            handleFileUploadInputs(customFieldInputs, {
                disableSubmitButton,
                enableSubmitButton
            });
        }
        const CHECKBOX_CLASS_NAME = 'w-checkbox-input';
        const CHECKED_CLASS = 'w--redirected-checked';
        const customCheckboxes = document.querySelectorAll(`form[${_constants.USYS_DATA_ATTRS.formType}] input[type="checkbox"]:not(` + CHECKBOX_CLASS_NAME + ')');
        customCheckboxes.forEach((checkbox)=>{
            checkbox.addEventListener('change', function(e) {
                getMatchingSiblings(e, (element)=>{
                    return element.classList.contains(CHECKBOX_CLASS_NAME);
                }).forEach((sibling)=>{
                    sibling.classList.toggle(CHECKED_CLASS);
                });
            });
        });
    });
}

//# sourceMappingURL=data:application/json;base64,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

}),
56897: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/* globals
 window,
 HTMLElement,
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    addHiddenClass: function() {
        return addHiddenClass;
    },
    disableSubmit: function() {
        return disableSubmit;
    },
    getDomParser: function() {
        return getDomParser;
    },
    getErrorAttrName: function() {
        return getErrorAttrName;
    },
    getRedirectPath: function() {
        return getRedirectPath;
    },
    getSignupErrorCode: function() {
        return getSignupErrorCode;
    },
    handleErrorNode: function() {
        return handleErrorNode;
    },
    handleRedirect: function() {
        return handleRedirect;
    },
    hideElement: function() {
        return hideElement;
    },
    redirectWithUsrdir: function() {
        return redirectWithUsrdir;
    },
    removeHiddenClass: function() {
        return removeHiddenClass;
    },
    resetSubmit: function() {
        return resetSubmit;
    },
    showAndFocusElement: function() {
        return showAndFocusElement;
    },
    showElement: function() {
        return showElement;
    },
    userFormError: function() {
        return userFormError;
    },
    userSystemsRequestClient: function() {
        return userSystemsRequestClient;
    }
});
const _apolloClient = __webpack_require__(25195);
const _constants = __webpack_require__(7462);
const _client = __webpack_require__(22805);
/**
 * SECURITY NOTE:
 * This route is under anti-bot protection via rate limiting and/or PerimeterX. If you deprecate or
 * migrate this route, or modify the path name for this route, notify the #security channel. Also update
 * the file https://github.com/webflow/webflow-proxy/blob/dev/etc/perimeterx-enabled-routes.txt
 * Failing to do the above can result in a security incident
 */ const GQL_QUERY_PATH = '/.wf_graphql/usys/apollo';
const userSystemsRequestClient = (0, _apolloClient.createApolloClient)({
    path: GQL_QUERY_PATH,
    useCsrf: true,
    retryConfig: {
        maxAttempts: 5
    }
});
function addHiddenClass(el) {
    if (el) {
        el.classList.add('w-hidden');
    }
}
function removeHiddenClass(el) {
    if (el) {
        el.classList.remove('w-hidden');
    }
}
function showElement(el) {
    if (el) {
        el.style.display = 'block';
    }
}
function showAndFocusElement(el) {
    if (el) {
        el.style.display = 'block';
        el.focus();
    }
}
function hideElement(el) {
    if (el) {
        el.style.display = 'none';
    }
}
function getDomParser() {
    const domParser = new window.DOMParser();
    return {
        /**
     * Returns an html node for an encoded string
     * @param {string} str - Encoded string to parse
     */ getHtmlFromString (str) {
            const decodedString = decodeURIComponent(str);
            const parsedHtml = domParser.parseFromString(decodedString, 'text/html');
            if (!parsedHtml || !parsedHtml.body || !parsedHtml.body.firstChild) return null;
            return parsedHtml.body.firstChild;
        }
    };
}
const getErrorAttrName = (errorAttr, errorCode)=>{
    const formattedErrorCode = errorCode.replace('_', '-').toLowerCase();
    return `${errorAttr}-${formattedErrorCode}-error`;
};
const handleErrorNode = (errorMsgNode, errorStateNode, errorCode, errorAttrPrefix, defaultErrorCopy)=>{
    // get the error copy from the data attribute
    const errorAttr = getErrorAttrName(errorAttrPrefix, errorCode);
    const errorCopy = errorMsgNode && errorMsgNode.getAttribute(errorAttr);
    // announce the contents of the div to ATs
    errorMsgNode.setAttribute('aria-live', 'assertive');
    // set the message text to the error message or default copy if it is null
    errorMsgNode.textContent = errorCopy ? errorCopy : defaultErrorCopy;
    // show the error state Element
    showElement(errorStateNode);
};
function disableSubmit(submit) {
    if (!submit) return '';
    // Disable submit
    submit.setAttribute('disabled', 'true');
    // Store previous value
    const value = submit.getAttribute('value');
    // Show wait text
    const waitText = submit.getAttribute('data-wait');
    if (waitText) submit.setAttribute('value', waitText);
    return value ?? '';
}
function resetSubmit(submit, text) {
    if (!submit) return;
    // Reenable submit
    submit.removeAttribute('disabled');
    // Reset text
    submit.setAttribute('value', text);
}
function getRedirectPath() {
    const queryString = window.location.search;
    const redirectParam = queryString.match(/[?|&]usredir=([^@&?=]+)/g);
    if (!redirectParam) return undefined;
    const encodedPath = redirectParam[0].substring('?usredir='.length);
    return decodeURIComponent(encodedPath);
}
function redirectWithUsrdir(location) {
    const redirectParam = getRedirectPath();
    let encodedPath;
    if (redirectParam) {
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        encodedPath = redirectParam[0].substring('?usredir='.length);
    } else {
        encodedPath = encodeURIComponent(window.location.pathname);
    }
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Location | (string & Location)'.
    window.location = location + `?usredir=${encodedPath}`;
}
// Test if path has a /, ., or @ at the beginning. If so, remove it.
function normalizedRedirectPath(path) {
    // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    const hasLeadingSymbol = /\/|\.|\@/g.test(path[0]);
    return hasLeadingSymbol ? path.substring(1) : path;
}
function handleRedirect(defaultRedirectPath, includeDelay = false) {
    const redirectPath = getRedirectPath();
    const redirectUrl = (()=>{
        if (redirectPath) {
            return `${window.location.origin}/${normalizedRedirectPath(redirectPath)}`;
        }
        if (defaultRedirectPath) {
            return `${window.location.origin}/${normalizedRedirectPath(defaultRedirectPath)}`;
        }
        return;
    })();
    if (!redirectUrl) return;
    return includeDelay ? setTimeout(()=>window.Webflow.location(redirectUrl), 3000) : window.Webflow.location(redirectUrl);
}
const wrapperSelectors = [
    '.w-file-upload-error'
];
const setErrorMsg = (// @ts-expect-error - TS7006 - Parameter 'wrapper' implicitly has an 'any' type.
wrapper, // @ts-expect-error - TS7006 - Parameter 'fieldElements' implicitly has an 'any' type.
fieldElements, name)=>{
    for(let i = 0; i < fieldElements.length; ++i){
        const errorText = fieldElements[i].getAttribute(name);
        if (errorText) {
            fieldElements[i].innerHTML = errorText;
            removeHiddenClass(wrapper);
            return true;
        }
    }
};
const handleValidationErrors = (form, failedValidations)=>{
    const wrappers = [];
    wrapperSelectors.forEach((wrapperSelector)=>{
        const _wrappers = form.querySelectorAll(wrapperSelector);
        for(let i = 0; i < _wrappers.length; ++i){
            wrappers.push(_wrappers[i]);
        }
    });
    wrappers.forEach((wrapper)=>{
        for(let i = 0; i < failedValidations.length; ++i){
            const failedValidation = failedValidations[i];
            // @ts-expect-error - TS18048 - 'failedValidation' is possibly 'undefined'.
            const name = failedValidation.name;
            // @ts-expect-error - TS18048 - 'failedValidation' is possibly 'undefined'.
            const fieldId = failedValidation.fieldId;
            const fieldElements = wrapper.querySelectorAll('[' + _constants.USYS_DATA_ATTRS.field + '="' + fieldId + '"]');
            if (fieldElements && setErrorMsg(wrapper, fieldElements, name)) {
                break;
            }
        }
    });
};
// error handling
const defaultErrorCopy = // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
_constants.signUpErrorStates[_constants.SIGNUP_UI_ERROR_CODES.GENERAL_ERROR].copy;
const userFormError = (form, errorState, formType)=>(error)=>{
        if (errorState === null || form === null) return;
        const errorMsgNode = errorState.querySelector(`.${_constants.ERROR_MSG_CLASS}`);
        const gqlError = _client.CombinedGraphQLErrors.is(error) ? error.errors[0] : null;
        const failedValidations = gqlError && 'failedValidations' in gqlError ? gqlError.failedValidations : null;
        if (failedValidations) {
            // @ts-expect-error - TS2345: Argument of type {} is not assignable to parameter of type FailedValidations
            handleValidationErrors(form, failedValidations);
        }
        // if there isn't an error code, send an empty string so a generic error message appears
        const elementErrorCode = gqlError && 'code' in gqlError && typeof gqlError.code === 'string' ? gqlError.code : '';
        const errorCode = getSignupErrorCode(elementErrorCode);
        handleErrorNode(errorMsgNode, errorState, errorCode, _constants.ERROR_ATTRIBUTE_PREFIX[formType], defaultErrorCopy);
    };
const getSignupErrorCode = (error)=>{
    let errorCode;
    switch(error){
        case 'UsysInvalidUserData':
            errorCode = _constants.SIGNUP_UI_ERROR_CODES.VALIDATION_FAILED;
            break;
        case 'UsysUnauthorizedEmail':
            errorCode = _constants.SIGNUP_UI_ERROR_CODES.NOT_ALLOWED;
            break;
        case 'UsysMustUseInvitation':
            errorCode = _constants.SIGNUP_UI_ERROR_CODES.USE_INVITE_EMAIL;
            break;
        case 'UsysDuplicateEmail':
            errorCode = _constants.SIGNUP_UI_ERROR_CODES.EMAIL_ALREADY_EXIST;
            break;
        case 'UsysInvalidEmail':
            errorCode = _constants.SIGNUP_UI_ERROR_CODES.INVALID_EMAIL;
            break;
        case 'UsysInvalidPassword':
            errorCode = _constants.SIGNUP_UI_ERROR_CODES.INVALID_PASSWORD;
            break;
        case 'UsysInvalidToken':
            errorCode = _constants.SIGNUP_UI_ERROR_CODES.NOT_VERIFIED;
            break;
        case 'UsysExpiredToken':
            errorCode = _constants.SIGNUP_UI_ERROR_CODES.EXPIRED_TOKEN;
            break;
        default:
            errorCode = _constants.SIGNUP_UI_ERROR_CODES.GENERAL_ERROR;
    }
    return errorCode;
};

//# sourceMappingURL=data:application/json;base64,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

}),
62467: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    appendUserInputClasses: function() {
        return appendUserInputClasses;
    },
    getTempUserFileKey: function() {
        return getTempUserFileKey;
    },
    getUserFileKey: function() {
        return getUserFileKey;
    },
    parseWfUsysVariant: function() {
        return parseWfUsysVariant;
    },
    removeTempUserFileKey: function() {
        return removeTempUserFileKey;
    },
    setTempUserFileKey: function() {
        return setTempUserFileKey;
    },
    setUserFileKey: function() {
        return setUserFileKey;
    },
    uploadFileToS3: function() {
        return uploadFileToS3;
    }
});
const _constants = __webpack_require__(7462);
const appendUserInputClasses = (node, classes)=>{
    const updatedClasses = classes.push('w-input');
    if (node.getIn([
        'data',
        'attr',
        'disabled'
    ])) {
        return updatedClasses.push('w-input-disabled');
    }
    return updatedClasses;
};
const parseWfUsysVariant = (wfUsysVariant)=>{
    if (!wfUsysVariant) return [];
    let results = [];
    for (const wfUsysVariantKey of wfUsysVariant.split(',')){
        if (// @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"LOGGED_IN" | "ADMIN_ALWAYS_VISIBLE"'.
        _constants.USER_ACCESS_META_OPTIONS.includes(wfUsysVariantKey) && // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"LOGGED_IN" | "ADMIN_ALWAYS_VISIBLE"'.
        !results.includes(wfUsysVariantKey)) {
            results.push(wfUsysVariantKey);
        } else {
            // This is the error case
            console.error(`UnexpectedWfUsysVariant: Renderer received unexpected wf-usys-variant`);
            results = [];
            break;
        }
    }
    return results;
};
function uploadFileToS3(url, fields, file) {
    return new Promise((resolve, reject)=>{
        const formData = new FormData();
        Object.entries(fields).forEach(([key, value])=>{
            formData.append(key, value);
        });
        formData.append('file', file);
        fetch(url, {
            method: 'POST',
            body: formData
        }).then((response)=>{
            if (response.ok) {
                // @ts-expect-error - TS2794 - Expected 1 arguments, but got 0. Did you forget to include 'void' in your type argument to 'Promise'?
                resolve();
            } else {
                return response.text();
            }
        }).then((text)=>{
            reject(text);
        });
    });
}
const getUserFileKey = (element)=>{
    return element.getAttribute(_constants.USYS_DATA_ATTRS.fileUploadKey);
};
const setUserFileKey = (element, value)=>{
    element.setAttribute(_constants.USYS_DATA_ATTRS.fileUploadKey, value);
};
const getTempUserFileKey = (element)=>{
    return element.getAttribute(_constants.USYS_DATA_ATTRS.unsavedFileUploadKey);
};
const setTempUserFileKey = (element, value)=>{
    element.setAttribute(_constants.USYS_DATA_ATTRS.unsavedFileUploadKey, value);
};
const removeTempUserFileKey = (element)=>{
    element.removeAttribute(_constants.USYS_DATA_ATTRS.unsavedFileUploadKey);
};

//# sourceMappingURL=data:application/json;base64,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

}),
43742: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    apolloNetworkIdleEmitter: function() {
        return apolloNetworkIdleEmitter;
    },
    apolloNetworkIdleTrackingLink: function() {
        return apolloNetworkIdleTrackingLink;
    }
});
const _client = __webpack_require__(22805);
const _rxjs = __webpack_require__(34043);
let inflightApolloQueryCount = 0;
const apolloNetworkIdleListeners = new Set();
const apolloNetworkIdleEmitter = {
    subscribe (cb) {
        apolloNetworkIdleListeners.add(cb);
        return ()=>{
            apolloNetworkIdleListeners.delete(cb);
        };
    }
};
function emitApolloNetworkIdle() {
    for (const listener of apolloNetworkIdleListeners){
        listener();
    }
}
const apolloNetworkIdleTrackingLink = new _client.ApolloLink((operation, forward)=>{
    inflightApolloQueryCount++;
    return forward(operation).pipe((0, _rxjs.finalize)(()=>{
        inflightApolloQueryCount = Math.max(0, inflightApolloQueryCount - 1);
        if (inflightApolloQueryCount === 0) {
            emitApolloNetworkIdle();
        }
    }));
});

//# sourceMappingURL=data:application/json;base64,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

}),
99866: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    buildApolloClientUri: function() {
        return buildApolloClientUri;
    },
    createApolloClient: function() {
        return createApolloClient;
    }
});
const _client = __webpack_require__(22805);
const _localstate = __webpack_require__(48234);
const _batchhttp = __webpack_require__(16882);
const _rxjs = __webpack_require__(34043);
const _fetchWithCsrf = __webpack_require__(22393);
const _helpers = __webpack_require__(21650);
const createApolloClient = ({ origin = '', path, publicationId, previewKey, projectKey, ssrMode = false, credentials = 'same-origin', headers = {}, useCsrf = false, retryConfig, onError, disableBatching = false, customLinks = [] })=>{
    const uri = buildApolloClientUri({
        origin,
        path,
        publicationId,
        previewKey,
        projectKey
    });
    const requestHeaders = {
        Accept: 'application/json',
        ...headers
    };
    const batchLinkArgs = {
        uri,
        headers: requestHeaders,
        credentials
    };
    // Disable batching
    if (disableBatching) {
        batchLinkArgs.batchMax = 1;
        batchLinkArgs.batchInterval = 0;
    }
    // Fetch using a CSRF token if toggled
    if (useCsrf) {
        batchLinkArgs.fetch = _fetchWithCsrf.fetchWithCsrf;
    }
    const batchLink = new _batchhttp.BatchHttpLink(batchLinkArgs);
    const links = [];
    if (retryConfig) {
        links.push((0, _helpers.createRetryLink)(retryConfig));
    }
    if (onError) {
        const errorMapperLink = new _client.ApolloLink((operation, forward)=>{
            return forward(operation).pipe((0, _rxjs.map)((response)=>{
                if (response.errors) {
                    onError(response);
                }
                return response;
            }));
        });
        links.push(errorMapperLink);
    }
    const apolloClient = new _client.ApolloClient({
        link: _client.ApolloLink.from([
            ...customLinks,
            ...links,
            batchLink
        ]),
        cache: new _client.InMemoryCache({
            dataIdFromObject: (object)=>{
                switch(object.__typename){
                    case 'sku_props':
                        return undefined;
                    case 'commerce_subscription':
                        {
                            return object._id;
                        }
                    case 'collections':
                        // `collections` does not have an ID, so we must
                        // use a hard-coded string so that Apollo cache
                        // can merge the `collections` objects together.
                        return object.__typename;
                    case 'CMSNamespace':
                        // `CMSNamespace` does not have an ID, so we must
                        // use a hard-coded string so that Apollo cache
                        // can merge the `CMSNamespace` objects together.
                        return object.__typename;
                    default:
                        {
                            if (object.cmsLocaleId) {
                                return `${object.id}_${object.cmsLocaleId}`;
                            }
                            return object.id;
                        }
                }
            }
        }),
        localState: new _localstate.LocalState(),
        ssrMode
    });
    return apolloClient;
};
const buildApolloClientUri = ({ origin = '', path, publicationId, previewKey, projectKey })=>{
    const params = [];
    if (publicationId) {
        params.push(`pub=${publicationId}`);
    }
    if (previewKey) {
        params.push(`preview=${previewKey}`);
    }
    if (projectKey) {
        params.push(`project=${projectKey}`);
    }
    // Replace multiple slashes with single slashes
    const cleanPath = `${origin}${path}`.replace(/([^:])\/\/+/g, '$1/');
    return `${cleanPath}${params.length ? `?${params.join('&')}` : ''}`;
};

//# sourceMappingURL=data:application/json;base64,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

}),
22393: (function (__unused_webpack_module, exports) {
"use strict";
/* globals
  window,
  document,
  */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    fetchWithCsrf: function() {
        return fetchWithCsrf;
    },
    getLocalCsrfCookie: function() {
        return getLocalCsrfCookie;
    }
});
const WF_CSRF_COOKIE_REGEX = '(^|;)\\s*wf-csrf\\s*=\\s*([^;]+)';
const WF_CSRF_URI = '/.wf_graphql/csrf';
let hasFetchedCsrfCookie = false;
function fetchWithCsrf(uri, options) {
    if (window.Webflow.env('design') || window.Webflow.env('preview')) {
        return fetch(uri, options);
    }
    const localCsrvCookie = getLocalCsrfCookie();
    const requestHeaders = new Headers(options?.headers);
    return new Promise((resolve, reject)=>{
        if (hasFetchedCsrfCookie && localCsrvCookie) {
            requestHeaders.set('X-Wf-Csrf', localCsrvCookie);
            resolve(fetch(uri, {
                ...options,
                headers: requestHeaders
            }));
        } else {
            fetch(WF_CSRF_URI, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }).then(()=>{
                const newWfCsrfCookie = getLocalCsrfCookie();
                if (newWfCsrfCookie) {
                    hasFetchedCsrfCookie = true;
                    requestHeaders.set('X-Wf-Csrf', newWfCsrfCookie);
                    resolve(fetch(uri, {
                        ...options,
                        headers: requestHeaders
                    }));
                } else {
                    reject(new Error('Did not receive CSRF token'));
                }
            }).catch((err)=>reject(err));
        }
    });
}
function getLocalCsrfCookie() {
    const wfCsrfCookieArray = document.cookie.match(WF_CSRF_COOKIE_REGEX);
    return wfCsrfCookieArray ? wfCsrfCookieArray.pop() : null;
}

//# sourceMappingURL=data:application/json;base64,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

}),
21650: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "createRetryLink", ({
    enumerable: true,
    get: function() {
        return createRetryLink;
    }
}));
const _retry = __webpack_require__(65822);
const _client = __webpack_require__(22805);
const ERROR_METRIC_NAME = 'webflow.renderer.apollo.request.error';
const createRetryLink = ({ maxAttempts = 1, retryOnCorsErrors = true, retriedServerErrors = 'all', metricsLogger })=>{
    return new _retry.RetryLink({
        attempts: (count, operation, error)=>{
            const tags = [];
            let ret = false;
            if (count >= maxAttempts) {
                tags.push('max_attempts:true');
            } else {
                tags.push('max_attempts:false');
                if (error && (_client.ServerError.is(error) || _client.ServerParseError.is(error)) && (retriedServerErrors === 'all' && error.statusCode >= 500 || retriedServerErrors === 'bad-gateway' && error.statusCode === 502)) {
                    // if the request fails, let's try it again because it was probably
                    // a temporary issue.
                    tags.push('reason:server_error');
                    tags.push(`status_code:${error.statusCode}`);
                    ret = true;
                } else if (retryOnCorsErrors && error && (_client.ServerError.is(error) || _client.ServerParseError.is(error)) && error.bodyText) {
                    let parsedResult;
                    try {
                        parsedResult = JSON.parse(error.bodyText);
                    } catch (e) {
                        parsedResult = null;
                    }
                    if (parsedResult && typeof parsedResult === 'object' && 'code' in parsedResult && parsedResult.code === 'BadCrossOriginRequest') {
                        // if CORS fails, it means we used a stale token so we can try it again
                        // with the correct one
                        tags.push('reason:cors_error');
                        ret = true;
                    }
                }
            }
            tags.push(`attempt:${count}`, `retry:${ret}`);
            metricsLogger?.logDistributionMetric(ERROR_METRIC_NAME, 1, ...tags);
            return ret;
        },
        delay: (count)=>{
            // delay in ms
            return count * 500 + Math.random() * 500;
        }
    });
};

//# sourceMappingURL=data:application/json;base64,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

}),
25195: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    apolloNetworkIdleEmitter: function() {
        return _apolloNetworkIdleTrackingLink.apolloNetworkIdleEmitter;
    },
    apolloNetworkIdleTrackingLink: function() {
        return _apolloNetworkIdleTrackingLink.apolloNetworkIdleTrackingLink;
    },
    createApolloClient: function() {
        return _createApolloClient.createApolloClient;
    }
});
const _createApolloClient = __webpack_require__(99866);
const _apolloNetworkIdleTrackingLink = __webpack_require__(43742);

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7Y3JlYXRlQXBvbGxvQ2xpZW50fSBmcm9tICcuL2NyZWF0ZUFwb2xsb0NsaWVudCc7XG5leHBvcnQge3R5cGUgQXBvbGxvTWV0cmljc0xvZ2dlcn0gZnJvbSAnLi9hcG9sbG9NZXRyaWNzTG9nZ2VyJztcbmV4cG9ydCB7XG4gIGFwb2xsb05ldHdvcmtJZGxlRW1pdHRlcixcbiAgYXBvbGxvTmV0d29ya0lkbGVUcmFja2luZ0xpbmssXG59IGZyb20gJy4vYXBvbGxvTmV0d29ya0lkbGVUcmFja2luZ0xpbmsnO1xuIl0sIm5hbWVzIjpbImFwb2xsb05ldHdvcmtJZGxlRW1pdHRlciIsImFwb2xsb05ldHdvcmtJZGxlVHJhY2tpbmdMaW5rIiwiY3JlYXRlQXBvbGxvQ2xpZW50Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztJQUdFQSx3QkFBd0I7ZUFBeEJBLHVEQUF3Qjs7SUFDeEJDLDZCQUE2QjtlQUE3QkEsNERBQTZCOztJQUp2QkMsa0JBQWtCO2VBQWxCQSxzQ0FBa0I7OztvQ0FBTzsrQ0FLMUIifQ==

}),
51522: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    None: function() {
        return None;
    },
    Some: function() {
        return Some;
    },
    fromNullable: function() {
        return fromNullable;
    },
    maybe: function() {
        return maybe;
    },
    of: function() {
        return of;
    }
});
const { create } = Object;
const returnThis = function() {
    return this;
};
const VALUE = Symbol();
const FOLD = Symbol();
const None = create({
    map: returnThis,
    chain: returnThis,
    alt: (alternativeOption)=>alternativeOption,
    ap: returnThis,
    concat: (other)=>other,
    /**
   * Returns a default fallback value if the `Option` is a `None`.
   */ [FOLD]: (fallback)=>fallback
});
const Some = (value)=>{
    const object = create(SomePrototype);
    object[VALUE] = value;
    return object;
};
const SomePrototype = {
    /**
   * Transform the value inside of a `Option` by applying a unary function to it.
   */ map (f) {
        return Some(f(this[VALUE]));
    },
    /**
   * Sequence computations by applying a function to the value
   * contained in the `Option`. The function must return an `Option`.
   */ chain (f) {
        return f(this[VALUE]);
    },
    /**
   * Provide an alternative option that will be returned if this option is None.
   */ alt: returnThis,
    /**
   * Allows you to apply the Option's value with another Option's value,
   * returning another Option.
   */ ap (m) {
        return m.map(this[VALUE]);
    },
    concat (other) {
        return other[FOLD](this, (otherValue)=>Some(this[VALUE].concat(otherValue)));
    },
    /**
   * Applies a function to the value contained in an `Option`
   * if the `Option` is a `Some`.
   */ [FOLD] (fallback, mapValue) {
        return mapValue(this[VALUE]);
    }
};
const fromNullable = (value)=>value == null ? None : Some(value);
const maybe = (fallback)=>(mapValue)=>(option)=>option[FOLD](fallback, mapValue);
const of = Some;

//# sourceMappingURL=data:application/json;base64,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

}),
16387: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Err: function() {
        return Err;
    },
    Ok: function() {
        return Ok;
    },
    either: function() {
        return either;
    },
    of: function() {
        return of;
    }
});
const { create } = Object;
const returnThis = function() {
    return this;
};
const VALUE = Symbol();
const ERROR = Symbol();
const FOLD = Symbol();
const Err = (error)=>{
    const object = create(ErrPrototype);
    object[ERROR] = error;
    return object;
};
const Ok = (value)=>{
    const object = create(OkPrototype);
    object[VALUE] = value;
    return object;
};
const ErrPrototype = {
    map: returnThis,
    chain: returnThis,
    ap: returnThis,
    [FOLD]: function(errorHandler, _) {
        return errorHandler(this[ERROR]);
    }
};
const OkPrototype = {
    map (f) {
        return Ok(f(this[VALUE]));
    },
    chain (f) {
        return f(this[VALUE]);
    },
    ap (m) {
        return m.map(this[VALUE]);
    },
    [FOLD]: function(errorHandler, valueHandler) {
        return valueHandler(this[VALUE]);
    }
};
const either = (mapErr)=>(mapVal)=>(result)=>result[FOLD](mapErr, mapVal);
const of = Ok;

//# sourceMappingURL=data:application/json;base64,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

}),
56574: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Const: function() {
        return Const;
    },
    getConst: function() {
        return getConst;
    },
    of: function() {
        return of;
    }
});
const { create } = Object;
const VALUE = Symbol();
const prototype = {
    map () {
        return this;
    }
};
const Const = (value)=>{
    const object = create(prototype);
    object[VALUE] = value;
    return object;
};
const of = Const;
const getConst = (con)=>con[VALUE];

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnN0LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IHtjcmVhdGV9ID0gT2JqZWN0O1xuXG5jb25zdCBWQUxVRTogdW5pcXVlIHN5bWJvbCA9IFN5bWJvbCgpO1xuXG5leHBvcnQgaW50ZXJmYWNlIENvbnN0VHlwZTxDLCBBPiB7XG4gIFtWQUxVRV06IEM7XG4gIG1hcDogPEI+KGY6ICh4OiBBKSA9PiBCKSA9PiBDb25zdFR5cGU8QywgQj47XG59XG5cbmNvbnN0IHByb3RvdHlwZSA9IHtcbiAgbWFwKCkge1xuICAgIHJldHVybiB0aGlzO1xuICB9LFxufSBhcyBjb25zdDtcblxuZXhwb3J0IGNvbnN0IENvbnN0ID0gPEMsIEE+KHZhbHVlOiBDKTogQ29uc3RUeXBlPEMsIEE+ID0+IHtcbiAgY29uc3Qgb2JqZWN0ID0gY3JlYXRlKHByb3RvdHlwZSk7XG4gIG9iamVjdFtWQUxVRV0gPSB2YWx1ZTtcbiAgcmV0dXJuIG9iamVjdDtcbn07XG5cbmV4cG9ydCBjb25zdCBvZiA9IENvbnN0O1xuZXhwb3J0IGNvbnN0IGdldENvbnN0ID0gPEEsIEM+KGNvbjogQ29uc3RUeXBlPEMsIEE+KTogQyA9PiBjb25bVkFMVUVdO1xuIl0sIm5hbWVzIjpbIkNvbnN0IiwiZ2V0Q29uc3QiLCJvZiIsImNyZWF0ZSIsIk9iamVjdCIsIlZBTFVFIiwiU3ltYm9sIiwicHJvdG90eXBlIiwibWFwIiwidmFsdWUiLCJvYmplY3QiLCJjb24iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0lBZWFBLEtBQUs7ZUFBTEE7O0lBT0FDLFFBQVE7ZUFBUkE7O0lBREFDLEVBQUU7ZUFBRkE7OztBQXJCYixNQUFNLEVBQUNDLE1BQU0sRUFBQyxHQUFHQztBQUVqQixNQUFNQyxRQUF1QkM7QUFPN0IsTUFBTUMsWUFBWTtJQUNoQkM7UUFDRSxPQUFPLElBQUk7SUFDYjtBQUNGO0FBRU8sTUFBTVIsUUFBUSxDQUFPUztJQUMxQixNQUFNQyxTQUFTUCxPQUFPSTtJQUN0QkcsTUFBTSxDQUFDTCxNQUFNLEdBQUdJO0lBQ2hCLE9BQU9DO0FBQ1Q7QUFFTyxNQUFNUixLQUFLRjtBQUNYLE1BQU1DLFdBQVcsQ0FBT1UsTUFBNEJBLEdBQUcsQ0FBQ04sTUFBTSJ9

}),
64552: (function (__unused_webpack_module, exports) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Identity: function() {
        return Identity;
    },
    of: function() {
        return of;
    },
    runIdentity: function() {
        return runIdentity;
    }
});
const { create } = Object;
const VALUE = Symbol();
const prototype = {
    map (f) {
        return Identity(f(this[VALUE]));
    }
};
const Identity = (value)=>{
    const object = create(prototype);
    object[VALUE] = value;
    return object;
};
const of = Identity;
const runIdentity = (object)=>object[VALUE];

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIklkZW50aXR5LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IHtjcmVhdGV9ID0gT2JqZWN0O1xuXG5jb25zdCBWQUxVRTogdW5pcXVlIHN5bWJvbCA9IFN5bWJvbCgpO1xuXG5leHBvcnQgaW50ZXJmYWNlIElkZW50aXR5VHlwZTxBPiB7XG4gIFtWQUxVRV06IEE7XG4gIG1hcDogPEI+KGY6ICh4OiBBKSA9PiBCKSA9PiBJZGVudGl0eVR5cGU8Qj47XG59XG5cbmNvbnN0IHByb3RvdHlwZSA9IHtcbiAgbWFwPEEsIEI+KHRoaXM6IElkZW50aXR5VHlwZTxBPiwgZjogKHg6IEEpID0+IEIpIHtcbiAgICByZXR1cm4gSWRlbnRpdHkoZih0aGlzW1ZBTFVFXSkpO1xuICB9LFxufSBhcyBjb25zdDtcblxuZXhwb3J0IGNvbnN0IElkZW50aXR5ID0gPEE+KHZhbHVlOiBBKTogSWRlbnRpdHlUeXBlPEE+ID0+IHtcbiAgY29uc3Qgb2JqZWN0ID0gY3JlYXRlKHByb3RvdHlwZSk7XG4gIG9iamVjdFtWQUxVRV0gPSB2YWx1ZTtcbiAgcmV0dXJuIG9iamVjdDtcbn07XG5cbmV4cG9ydCBjb25zdCBvZiA9IElkZW50aXR5O1xuZXhwb3J0IGNvbnN0IHJ1bklkZW50aXR5ID0gPEE+KG9iamVjdDogSWRlbnRpdHlUeXBlPEE+KTogQSA9PiBvYmplY3RbVkFMVUVdO1xuIl0sIm5hbWVzIjpbIklkZW50aXR5Iiwib2YiLCJydW5JZGVudGl0eSIsImNyZWF0ZSIsIk9iamVjdCIsIlZBTFVFIiwiU3ltYm9sIiwicHJvdG90eXBlIiwibWFwIiwiZiIsInZhbHVlIiwib2JqZWN0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztJQWVhQSxRQUFRO2VBQVJBOztJQU1BQyxFQUFFO2VBQUZBOztJQUNBQyxXQUFXO2VBQVhBOzs7QUF0QmIsTUFBTSxFQUFDQyxNQUFNLEVBQUMsR0FBR0M7QUFFakIsTUFBTUMsUUFBdUJDO0FBTzdCLE1BQU1DLFlBQVk7SUFDaEJDLEtBQWlDQyxDQUFjO1FBQzdDLE9BQU9ULFNBQVNTLEVBQUUsSUFBSSxDQUFDSixNQUFNO0lBQy9CO0FBQ0Y7QUFFTyxNQUFNTCxXQUFXLENBQUlVO0lBQzFCLE1BQU1DLFNBQVNSLE9BQU9JO0lBQ3RCSSxNQUFNLENBQUNOLE1BQU0sR0FBR0s7SUFDaEIsT0FBT0M7QUFDVDtBQUVPLE1BQU1WLEtBQUtEO0FBQ1gsTUFBTUUsY0FBYyxDQUFJUyxTQUErQkEsTUFBTSxDQUFDTixNQUFNIn0=

}),
1242: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    add: function() {
        return add;
    },
    adjust: function() {
        return adjust;
    },
    allPass: function() {
        return allPass;
    },
    anyPass: function() {
        return anyPass;
    },
    append: function() {
        return append;
    },
    assoc: function() {
        return assoc;
    },
    blackbird: function() {
        return blackbird;
    },
    both: function() {
        return both;
    },
    complement: function() {
        return complement;
    },
    compose: function() {
        return compose;
    },
    concat: function() {
        return concat;
    },
    concatTo: function() {
        return concatTo;
    },
    constant: function() {
        return constant;
    },
    constantFalse: function() {
        return constantFalse;
    },
    constantIdentity: function() {
        return constantIdentity;
    },
    constantNone: function() {
        return constantNone;
    },
    constantTrue: function() {
        return constantTrue;
    },
    dissoc: function() {
        return dissoc;
    },
    either: function() {
        return either;
    },
    emptyArray: function() {
        return emptyArray;
    },
    emptyObject: function() {
        return emptyObject;
    },
    entries: function() {
        return entries;
    },
    equals: function() {
        return equals;
    },
    errToOption: function() {
        return errToOption;
    },
    extractArray: function() {
        return extractArray;
    },
    extractBool: function() {
        return extractBool;
    },
    extractFunctionFromOption: function() {
        return extractFunctionFromOption;
    },
    extractFunctionFromResult: function() {
        return extractFunctionFromResult;
    },
    filter: function() {
        return filter;
    },
    find: function() {
        return find;
    },
    flat: function() {
        return flat;
    },
    flatMap: function() {
        return flatMap;
    },
    flip: function() {
        return flip;
    },
    getDeepestValues: function() {
        return getDeepestValues;
    },
    has: function() {
        return has;
    },
    head: function() {
        return head;
    },
    identity: function() {
        return identity;
    },
    inc: function() {
        return inc;
    },
    isNil: function() {
        return isNil;
    },
    last: function() {
        return last;
    },
    length: function() {
        return length;
    },
    lens: function() {
        return lens;
    },
    lensProp: function() {
        return lensProp;
    },
    lookup: function() {
        return lookup;
    },
    lookupWithDefault: function() {
        return lookupWithDefault;
    },
    map: function() {
        return map;
    },
    mapArray: function() {
        return mapArray;
    },
    mapValues: function() {
        return mapValues;
    },
    match: function() {
        return match;
    },
    max: function() {
        return max;
    },
    noneToErr: function() {
        return noneToErr;
    },
    not: function() {
        return not;
    },
    notEqual: function() {
        return notEqual;
    },
    notNil: function() {
        return notNil;
    },
    nth: function() {
        return nth;
    },
    objOf: function() {
        return objOf;
    },
    objectKeys: function() {
        return objectKeys;
    },
    okToOption: function() {
        return okToOption;
    },
    omit: function() {
        return omit;
    },
    optionToArray: function() {
        return optionToArray;
    },
    optionToBool: function() {
        return optionToBool;
    },
    over: function() {
        return over;
    },
    parseIntWithRadix: function() {
        return parseIntWithRadix;
    },
    pick: function() {
        return pick;
    },
    pickBy: function() {
        return pickBy;
    },
    pipe: function() {
        return pipe;
    },
    prop: function() {
        return prop;
    },
    reduce: function() {
        return reduce;
    },
    reduceObject: function() {
        return reduceObject;
    },
    replace: function() {
        return replace;
    },
    resultToBool: function() {
        return resultToBool;
    },
    safeParseInt: function() {
        return safeParseInt;
    },
    set: function() {
        return set;
    },
    split: function() {
        return split;
    },
    substitution: function() {
        return substitution;
    },
    tail: function() {
        return tail;
    },
    tap: function() {
        return tap;
    },
    test: function() {
        return test;
    },
    thrush: function() {
        return thrush;
    },
    traverseObjectResults: function() {
        return traverseObjectResults;
    },
    traverseOptions: function() {
        return traverseOptions;
    },
    traverseResults: function() {
        return traverseResults;
    },
    union: function() {
        return union;
    },
    unionTo: function() {
        return unionTo;
    },
    unionWith: function() {
        return unionWith;
    },
    values: function() {
        return values;
    },
    view: function() {
        return view;
    },
    when: function() {
        return when;
    },
    zip: function() {
        return zip;
    },
    zipCat: function() {
        return zipCat;
    },
    zipWith: function() {
        return zipWith;
    }
});
const _Const = __webpack_require__(56574);
const _Identity = __webpack_require__(64552);
const _option = __webpack_require__(51522);
const _result = __webpack_require__(16387);
const objectKeys = Object.keys;
let emptyArray = [];
let emptyObject = {};
if (false) {}
const identity = (x)=>x;
const constant = (x)=>(_)=>x;
const compose = (f)=>(g)=>(x)=>f(g(x));
const blackbird = (f)=>(g)=>(x)=>(y)=>f(g(x)(y));
const flip = (f)=>(x)=>(y)=>f(y)(x);
const thrush = (x)=>(f)=>f(x);
const substitution = (f)=>(g)=>(x)=>f(x)(g(x));
const constantFalse = constant(false);
const constantTrue = constant(true);
const not = (x)=>!x;
const complement = compose(not);
const anyPass = (preds)=>(value)=>preds.some(thrush(value));
const allPass = (preds)=>(value)=>preds.every(thrush(value));
const optionToBool = (0, _option.maybe)(false)(constantTrue);
const resultToBool = (0, _result.either)(constantFalse)(constantTrue);
const equals = (x)=>(y)=>x === y;
const notEqual = (x)=>(y)=>x !== y;
const isNil = (value)=>value == null;
const notNil = complement(isNil);
const either = (predicateA, predicateB)=>(...args)=>predicateA(...args) || predicateB(...args);
const both = (predicateA, predicateB)=>(...args)=>predicateA(...args) && predicateB(...args);
const when = (predicate)=>(whenTrueFn)=>(value)=>predicate(value) ? whenTrueFn(value) : value;
const has = (key)=>(object)=>Object.hasOwn(object, key);
const prop = (key)=>(object)=>object[key];
const assocReducer = (acc, key)=>{
    acc.result[key] = acc.source[key];
    return acc;
};
const assoc = (key)=>{
    const hasKey = has(key);
    return (value)=>(object)=>{
            if (hasKey(object) && object[key] === value) {
                return object;
            }
            const result = objectKeys(object).reduce(assocReducer, {
                source: object,
                result: {}
            }).result;
            result[key] = value;
            return result;
        };
};
const dissocReducer = (acc, key)=>{
    if (acc.exclude !== key) {
        acc.result[key] = acc.source[key];
    }
    return acc;
};
const dissoc = (key)=>{
    const hasKey = has(key);
    return (object)=>hasKey(object) ? objectKeys(object).reduce(dissocReducer, {
            source: object,
            result: {},
            exclude: key
        }).result : object;
};
const adjust = (f)=>(key)=>{
        const hasKey = has(key);
        return (obj)=>hasKey(obj) ? assoc(key)(f(obj[key]))(obj) : obj;
    };
const unionWith = (combine)=>(first)=>first === emptyObject ? identity : (second)=>{
            if (second === emptyObject) return first;
            let changedFromFirst = false;
            let changedFromSecond = false;
            const result = {};
            for(const key in second){
                const secondVal = second[key];
                if (key in first) {
                    const firstVal = first[key];
                    const finalVal = combine(firstVal)(secondVal);
                    if (finalVal !== secondVal) {
                        changedFromSecond = true;
                    }
                    if (finalVal !== firstVal) {
                        changedFromFirst = true;
                    }
                    result[key] = finalVal;
                } else {
                    changedFromFirst = true;
                    result[key] = secondVal;
                }
            }
            for(const key in first){
                if (key in result) continue;
                changedFromSecond = true;
                result[key] = first[key];
            }
            if (!changedFromFirst) return first;
            if (!changedFromSecond) return second;
            return result;
        };
const union = unionWith(constant);
const unionTo = flip(union);
const omitReducer = (acc, key)=>{
    if (acc.exclude.includes(key)) {
        acc.changed = true;
    } else {
        // @ts-expect-error - TS2322 - Type 'a | undefined' is not assignable to type 'a'.
        acc.result[key] = acc.source[key];
    }
    return acc;
};
const omit = (keys)=>{
    const len = keys.length;
    if (len === 0) {
        return identity;
    }
    if (len === 1) {
        // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        return dissoc(keys[0]);
    }
    return (object)=>{
        const { result, changed } = objectKeys(object).reduce(omitReducer, {
            source: object,
            exclude: keys,
            changed: false,
            result: {}
        });
        return changed ? result : object;
    };
};
const pickReducer = (acc, key)=>{
    if (Object.hasOwn(acc.source, key)) {
        acc.result[key] = acc.source[key];
    }
    return acc;
};
const pick = (keys)=>(source)=>keys.reduce(pickReducer, {
            source,
            result: {}
        }).result;
const pickByReducer = (acc, key)=>{
    const value = acc.source[key];
    // @ts-expect-error - TS2345 - Argument of type 'undefined' is not assignable to parameter of type 'never'.
    if (acc.predicate(value)) {
        acc.result[key] = value;
    } else {
        acc.changed = true;
    }
    return acc;
};
const pickBy = (predicate)=>(object)=>{
        const { result, changed } = objectKeys(object).reduce(pickByReducer, {
            source: object,
            predicate,
            changed: false,
            result: {}
        });
        return changed ? result : object;
    };
const lookup = (key)=>{
    const hasKey = has(key);
    return (object)=>hasKey(object) ? (0, _option.Some)(object[key]) : _option.None;
};
const lookupWithDefault = (defaultValue)=>(key)=>{
        const hasKey = has(key);
        return (object)=>hasKey(object) ? object[key] : defaultValue;
    };
const find = (pred)=>// @ts-expect-error - TS2322 - Type '(array: a[]) => Option<a> | Option<a | undefined>' is not assignable to type '(arg1: a[]) => Option<a>'.
    (array)=>{
        const index = array.findIndex(pred);
        return index === -1 ? _option.None : (0, _option.Some)(array[index]);
    };
const pipe = (fns)=>(initialValue)=>fns.reduce((value, fn)=>fn(value), initialValue);
const zipWith = (f)=>(xs)=>(ys)=>{
            const rv = [];
            let idx = 0;
            const len = Math.min(xs.length, ys.length);
            while(idx < len){
                // @ts-expect-error - TS2345 - Argument of type 'a | undefined' is not assignable to parameter of type 'a'. | TS2345 - Argument of type 'b | undefined' is not assignable to parameter of type 'b'.
                rv[idx] = f(xs[idx])(ys[idx]);
                idx += 1;
            }
            return rv;
        };
const zip = zipWith((x)=>(y)=>[
            x,
            y
        ]);
function getMinLength(arrays) {
    if (arrays.length === 0) return 0;
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    if (arrays.length === 1) return arrays[0].length;
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    let min = arrays[0].length;
    for(let i = 1, len = arrays.length; i < len; i++){
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        const arr_len = arrays[i].length;
        if (arr_len < min) min = arr_len;
    }
    return min;
}
function zipCat(fn) {
    return function zipCat_inner(arrays) {
        // Find the length of the shortest array to know the max number of zip items.
        const zipLength = getMinLength(arrays);
        // Create a single array reference to store our items into.
        const rv = [];
        // For each array
        for(let i = 0, len = arrays.length; i < len; i++){
            const array = arrays[i];
            // For each index in the current array
            // @ts-expect-error - TS18048 - 'array' is possibly 'undefined'.
            for(let j = 0, array_len = array.length; j < array_len; j++){
                // @ts-expect-error - TS18048 - 'array' is possibly 'undefined'.
                const item = array[j];
                // For each index that falls in the zip range
                if (j < zipLength) {
                    const existing = rv[j];
                    // Check if we have a previously calculated value for this zip index.
                    // If we do then we call the zip fn on the existing result and the current item,
                    // then save it back at the zip index.
                    if (typeof existing !== 'undefined') {
                        // @ts-expect-error - TS2345 - Argument of type 'T | undefined' is not assignable to parameter of type 'T'.
                        rv[j] = fn(existing)(item);
                    } else {
                        // @ts-expect-error - TS2322 - Type 'T | undefined' is not assignable to type 'T'.
                        rv[j] = item;
                    }
                } else {
                    // @ts-expect-error - TS2345 - Argument of type 'T | undefined' is not assignable to parameter of type 'T'.
                    rv.push(item);
                }
            }
        }
        return rv;
    };
}
const map = (f)=>(xs)=>xs.map(f);
const mapArray = (f)=>(xs)=>{
        let changed = false;
        const ys = xs.reduce((res, x)=>{
            const newX = f(x);
            // @ts-expect-error - TS2367 - This comparison appears to be unintentional because the types 'b' and 'a' have no overlap.
            if (newX !== x) {
                changed = true;
            }
            res.push(newX);
            return res;
        }, []);
        // @ts-expect-error - TS2352 - Conversion of type 'a[]' to type 'b[]' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
        return changed ? ys : xs;
    };
const filter = (f)=>(xs)=>xs.filter(f);
const reduce = (reducer)=>(init)=>(xs)=>xs.reduce(reducer, init);
const reduceObject = (reducer)=>(init)=>(obj)=>// @ts-expect-error - TS2345 - Argument of type 'a | undefined' is not assignable to parameter of type 'a'.
            objectKeys(obj).reduce((result, key)=>reducer(result)(obj[key]), init);
const objOf = (key)=>(value)=>({
            [key]: value
        });
const concat = (ys)=>ys.length ? (xs)=>xs.length ? xs.concat(ys) : ys : identity;
const concatTo = flip(concat);
const append = (value)=>concat([
        value
    ]);
const constantIdentity = constant(identity);
const add = (x)=>(y)=>x + y;
const inc = (x)=>x + 1;
const max = (x)=>(y)=>x > y ? x : y;
const parseIntWithRadix = (radix)=>(num)=>{
        const parsed = parseInt(num, radix);
        return isNaN(parsed) ? _option.None : (0, _option.Some)(parsed);
    };
const safeParseInt = parseIntWithRadix(10);
const head = (xs)=>// @ts-expect-error - TS2322 - Type 'Option<any> | Option<a | undefined>' is not assignable to type 'Option<a>'.
    xs.length ? (0, _option.Some)(xs[0]) : _option.None;
const last = (xs)=>// @ts-expect-error - TS2322 - Type 'Option<any> | Option<a | undefined>' is not assignable to type 'Option<a>'.
    xs.length ? (0, _option.Some)(xs[xs.length - 1]) : _option.None;
const tail = (xs)=>xs.slice(1);
const length = (xs)=>xs.length;
const flatMap = (f)=>reduce((result, item)=>{
        const ys = f(item);
        if (!ys.length) {
            return result;
        }
        const nextResult = result.length ? result : [];
        nextResult.push.apply(nextResult, ys); // eslint-disable-line prefer-spread
        return nextResult;
    })(emptyArray);
const flat = flatMap(identity);
const test = (regex)=>(string)=>{
        regex.lastIndex = 0;
        const result = regex.test(string);
        regex.lastIndex = 0;
        return result;
    };
const match = (regex)=>(string)=>{
        const result = string.match(regex);
        return result ? (0, _option.Some)(result[0]) : _option.None;
    };
const replace = (pattern)=>(replacement)=>(string)=>string.replace(pattern, replacement);
const split = (pattern)=>(string)=>string.split(pattern);
const lens = (getter)=>(setter)=>(toFunctor)=>(target)=>toFunctor(getter(target)).map((focus)=>setter(focus)(target));
const lensProp = (key)=>lens(prop(key))(assoc(key));
const view = // @ts-expect-error Argument of type '<A>(arg1: (arg2: A) => unknown) => (arg3: A) => unknown' is not assignable to parameter of type '(arg1: unknown) => (arg3: unknown) => unknown'.  Types of parameters 'arg1' and 'arg1' are incompatible.  Type 'unknown' is not assignable to type '(arg2: unknown) => unknown'.
compose(compose(_Const.getConst))(thrush(_Const.Const));
const over = (l)=>(f)=>{
        const toFunctor = compose(_Identity.Identity)(f);
        // @ts-expect-error - TS2322 - Type '(arg1: s) => unknown' is not assignable to type '(arg1: s) => t'. | TS2345 - Argument of type '<a>(object: IdentityType<a>) => a' is not assignable to parameter of type '(arg1: unknown) => unknown'. | TS2345 - Argument of type '(arg1: a) => IdentityType<unknown>' is not assignable to parameter of type '(arg1: a) => Functor<b>'.
        return compose(_Identity.runIdentity)(l(toFunctor));
    };
const set = (l)=>compose(over(l))(constant);
const constantNone = constant(_option.None);
const noneToErr = (error)=>(0, _option.maybe)((0, _result.Err)(error))(_result.Ok);
const okToOption = // eslint-disable-next-line @typescript-eslint/no-explicit-any
(0, _result.either)(constantNone)(_option.Some);
const errToOption = // eslint-disable-next-line @typescript-eslint/no-explicit-any
(0, _result.either)(_option.Some)(constantNone);
const tap = (unsafeFn)=>(value)=>{
        unsafeFn(value);
        return value;
    };
const extractBool = (0, _option.maybe)(false)(identity);
const extractArray = (0, _option.maybe)(emptyArray)(identity);
const extractFunctionFromOption = (0, _option.maybe)(identity)(identity);
const extractFunctionFromResult = (0, _result.either)(constantIdentity)(identity);
const optionToArray = (0, _option.maybe)(emptyArray)(Array.of);
const optionOfEmptyArray = (0, _option.Some)(emptyArray);
const traverseOptions = (f)=>(xs)=>xs.reduce((option, x)=>f(x).map(append).ap(option), optionOfEmptyArray);
const resultOfEmptyArray = (0, _result.Ok)(emptyArray);
const traverseResults = (f)=>(xs)=>xs.reduce((result, x)=>f(x).map(append).ap(result), resultOfEmptyArray);
const resultOfEmptyObject = (0, _result.Ok)(emptyObject);
const traverseObjectResults = (f)=>(obj)=>objectKeys(obj).reduce((result, key)=>f(obj[key]).map(assoc(key)).ap(result), resultOfEmptyObject);
const mapValues = (f)=>(obj)=>{
        let changed = false;
        const newObj = objectKeys(obj).reduce((result, key)=>{
            const oldVal = obj[key];
            // @ts-expect-error - TS2345 - Argument of type 'a | undefined' is not assignable to parameter of type 'a'.
            const newVal = f(oldVal);
            if (oldVal !== newVal) {
                changed = true;
            }
            result[key] = newVal;
            return result;
        }, {});
        return changed ? newObj : obj;
    };
const values = (obj)=>// @ts-expect-error - TS2322 - Type '(T | undefined)[]' is not assignable to type 'T[]'.
    Object.keys(obj).map((k)=>obj[k]);
const entries = (obj)=>{
    const keys = Object.keys(obj);
    // @ts-expect-error - TS2322 - Type '[string, any][]' is not assignable to type '[V, T][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<V, T>>'.
    return keys.map((key)=>[
            key,
            obj[key]
        ]);
};
const getDeepestValues = (obj)=>{
    // @ts-expect-error - TS2322 - Type '(T | undefined)[]' is not assignable to type 'T[]'.
    return Object.keys(obj).flatMap((k)=>obj[k] && typeof obj[k] === 'object' ? getDeepestValues(obj[k]) : [
            obj[k]
        ]);
};
const nth = (index)=>(a)=>index < 0 || index >= a.length ? _option.None : (0, _option.Some)(a[index]);

//# sourceMappingURL=data:application/json;base64,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

}),
23056: (function (__unused_webpack_module, exports, __webpack_require__) {
"use strict";
/* eslint-disable @typescript-eslint/ban-types */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    cacheMemo: function() {
        return cacheMemo;
    },
    isEqual: function() {
        return isEqual;
    },
    memoize: function() {
        return memoize;
    },
    once: function() {
        return once;
    },
    singleMemo: function() {
        return singleMemo;
    },
    singleMemoMulti: function() {
        return singleMemoMulti;
    },
    weakMemo: function() {
        return weakMemo;
    },
    weakMemoMulti: function() {
        return weakMemoMulti;
    }
});
const _reselect = __webpack_require__(14445);
const _lrucache = __webpack_require__(77825);
const _isBoolean = /*#__PURE__*/ _interop_require_default(__webpack_require__(81247));
const _isFunction = /*#__PURE__*/ _interop_require_default(__webpack_require__(56644));
const _isObject = /*#__PURE__*/ _interop_require_default(__webpack_require__(28532));
const _utils = __webpack_require__(1242);
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const True = {
    '@webflow/Boolean': true
};
const False = {
    '@webflow/Boolean': false
};
/*
 * Inlined Immutable v3.8.1 `is` to reduce webflow.js bundle size
 * Source: https://github.com/immutable-js/immutable-js/blob/v3.8.1/src/is.js
 */ const is = (valueA, valueB)=>{
    // eslint-disable-next-line no-self-compare
    if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
        return true;
    }
    if (!valueA || !valueB) {
        return false;
    }
    if (typeof valueA.valueOf === 'function' && typeof valueB.valueOf === 'function') {
        valueA = valueA.valueOf();
        valueB = valueB.valueOf();
        // eslint-disable-next-line no-self-compare
        if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
            return true;
        }
        if (!valueA || !valueB) {
            return false;
        }
    }
    if (typeof valueA.equals === 'function' && typeof valueB.equals === 'function' && valueA.equals(valueB)) {
        return true;
    }
    return false;
};
const isEqual = (a, b)=>{
    if (is(a, b)) {
        return true;
    }
    if (typeof a !== 'object' || a === null || typeof b !== 'object' || b === null) {
        return false;
    }
    for(const k in a){
        if (!is(a[k], b[k])) {
            return false;
        }
    }
    return Object.keys(a).length === Object.keys(b).length;
};
function memoize(fn) {
    // We need to cast `fn` to some ungodly type because `lruMemoize` expects
    // (...args: any[]) => any, but we want to be more strict about the type of `fn`.
    // In other words, if we accept the same type than `lruMemoize` does, we
    // stop requesting fn to be properly typed (as it infers that both arguments
    // and return type are already `any`). For further discussion about this:
    // https://github.com/webflow/webflow/pull/85516/files#r2128406623
    return (0, _reselect.lruMemoize)(fn, isEqual);
}
function weakMemo(fn) {
    if (false) {}
    const map = new WeakMap();
    // @ts-expect-error - TS2322 - Type '{ (arg: any): any; displayName: string; }' is not assignable to type 'F'. | TS7006 - Parameter 'arg' implicitly has an 'any' type.
    const memFn = (arg)=>{
        if (!(0, _isObject.default)(arg) && !(0, _isBoolean.default)(arg)) {
            const errorMessage = `Expected an object or boolean as an argument to "${// @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'F'.
            fn.displayName || fn.name}()", but received ${String(arg)}.`;
            if (false) {}
            throw new WeakMemoError({
                message: errorMessage,
                memFn
            });
        }
        const key = typeof arg === 'boolean' ? arg && True || False : arg;
        // Flow doesn't seem to like True/False since they don't always
        // fit the expected type of `arg`
        if (!map.has(key)) {
            map.set(key, fn(arg));
        }
        const result = map.get(key);
        return result;
    };
    if (false) {}
    return memFn;
}
function getFnName(fn) {
    // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'Function'.
    return fn.displayName || fn.name || 'unknown';
}
function weakMemoMulti(// the arguments can only be objects. this can't be expressed easily
// in the `extends` type above, so instead we constrain the type
// of the function passed in here
// since weakMemoMulti is only performant when used to memoise functions
// with at least four arguments, we use the type system to enforce that
// the function to be memoised does have at least four arguments
fn) {
    if (false) {}
    const argsLength = fn.length;
    // if the function takes less than four arguments, we should use a different approach.
    // this will also catch any functions which use rest parameters.
    if (argsLength <= 3) {
        throw new Error(`weakMemoMulti: cannot be used to memoize a function which has less than four arguments, or which uses rest parameters.`);
    }
    // for functions with arity of 4 or higher, we use a tree-based algorithm to
    // memoize the function. it starts with a single WeakMap at the root, and
    // dynamically creates a new WeakMap for each level of the tree when an
    // argument is not found in the current level. this allows it to work
    // for any arbitrary number of arguments!
    const rootLevel = new WeakMap();
    const memFn = (...args)=>{
        if (args.length !== argsLength) {
            throw new Error(`weakMemoMulti: Expected ${argsLength} arguments to ${getFnName(memFn)}, but received ${args.length}.`);
        }
        let currentLevel = rootLevel;
        for(let i = 0; i < argsLength; i++){
            const key = args[i];
            if (!(0, _isObject.default)(key)) {
                throw new TypeError(`weakMemoMulti: Expected an object as an argument to ${getFnName(memFn)} but got ${key === null ? 'null' : typeof key} at index ${i}.`);
            }
            if (!currentLevel.has(key)) {
                currentLevel.set(key, i < argsLength - 1 ? new WeakMap() : fn(...args));
            }
            currentLevel = currentLevel.get(key);
        }
        return currentLevel;
    };
    if (false) {}
    return memFn;
}
const cacheMemo = (depth)=>{
    /**
   * Returns a memoized version of a "trivially hashable" function passed as parameter, with a fixed cache size.
   *
   * A "trivially hashable" function takes a single string as an argument and therefore does not need to be hashed.
   *
   * This is a pretty significant optimization if your function needs to be called very frequently.
   *
   * @param  {Function} fn          The function to memoize.
   * @return {Function}             The memoized function.
   */ const memoizeFn = (fn)=>{
        const cache = new _lrucache.LRUCache({
            max: depth || 1
        });
        // @ts-expect-error - TS2322 - Type '(arg: F) => unknown' is not assignable to type 'F'.
        return function(arg) {
            if (!cache.has(arg)) {
                cache.set(arg, fn(arg));
            }
            return cache.get(arg);
        };
    };
    return memoizeFn;
};
/**
 * A simple memoization function for usage with primitives or single argument
 * arguments of identity equality.
 */ const defaultLastArg = Symbol();
const singleMemo = (fn)=>{
    let lastArg = defaultLastArg;
    // @ts-expect-error - TS7034 - Variable 'lastResult' implicitly has type 'any' in some locations where its type cannot be determined.
    let lastResult;
    // @ts-expect-error - TS2322 - Type '(arg: F) => any' is not assignable to type 'F'.
    return (arg)=>{
        // @ts-expect-error - TS2367 - This condition will always return 'true' since the types 'F' and 'symbol' have no overlap.
        if (arg !== lastArg) {
            lastResult = fn(arg);
            // @ts-expect-error - TS2322 - Type 'F' is not assignable to type 'symbol'.
            lastArg = arg;
        }
        // @ts-expect-error - TS7005 - Variable 'lastResult' implicitly has an 'any' type.
        return lastResult;
    };
};
const singleMemoMulti = (fn)=>{
    let lastArgs = _utils.emptyArray;
    let lastResult;
    if (fn.length <= 3) {
        throw new Error(`singleMemoMulti: cannot be used to memoize a function which has less than four arguments, manually nest singleMemo instead`);
    }
    // Using rest and spread rather than arguments.apply after running this benchmark: https://jsperf.app/lalevi
    return (...args)=>{
        if (lastArgs === _utils.emptyArray) {
            lastArgs = args;
            lastResult = fn(...args);
            return lastResult;
        }
        for(let i = 0; i < args.length; i++){
            if (lastArgs[i] !== args[i]) {
                lastResult = fn(...args);
                lastArgs = args;
                return lastResult;
            }
        }
        return lastResult;
    };
};
const once = (fn)=>{
    let result;
    return ()=>{
        if (fn) {
            result = fn();
            // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type '(arg1: undefined) => a'.
            fn = undefined;
        }
        return result;
    };
};
class WeakMemoError extends TypeError {
    constructor(opts){
        super();
        if (TypeError.captureStackTrace) {
            TypeError.captureStackTrace(this, opts.memFn);
        }
        this.name = 'WeakMemoError';
        this.message = opts.message;
    }
}
function syntaxHighlight(fnSource) {
    const keywords = /\b(function|return|const|let|if|else|throw|for|while|switch|case|break|continue|default|new|delete|typeof|instanceof|void|this|class)\b/g;
    const literals = /\b(true|false|null|undefined)\b/g;
    const strings = /(['"`][^'"`]*['"`])/g; // Matches single, double, or backticks (template literals)
    const numbers = /\b(\d+(\.\d+)?(e[+-]?\d+)?|NaN|Infinity)\b/gi; // Matches integers, floats, and scientific notation
    const operators = /[=+\-*\/%<>!&|^~?]/g;
    const comments = /(\/\/[^\n]*|\/\*[\s\S]*?\*\/)/g;
    const parentheses = /[\(\)\[\]\{\}]/g; // Matches (), [], {}
    // Apply syntax highlighting via ANSI escape codes
    return fnSource.replace(parentheses, (match)=>`\x1b[37m${match}\x1b[0m`) // white for parentheses and brackets
    .replace(comments, (match)=>`\x1b[90m${match}\x1b[0m`) // gray for comments
    .replace(strings, (match)=>`\x1b[32m${match}\x1b[0m`) // green for strings and template literals
    .replace(literals, (match)=>`\x1b[33m${match}\x1b[0m`) // yellow for literals (true, false, null, undefined)
    .replace(keywords, (match)=>`\x1b[35m${match}\x1b[0m`) // magenta for keywords
    .replace(numbers, (match)=>`\x1b[36m${match}\x1b[0m`) // cyan for numbers
    .replace(operators, (match)=>`\x1b[31m${match}\x1b[0m`); // red for operators
}

//# sourceMappingURL=data:application/json;base64,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

}),
80334: (function () {
/**
 * ----------------------------------------------------------------------
 * Webflow: Interactions 2.0: Init
 */
Webflow.require('ix2').init(
{"events":{"e-3":{"id":"e-3","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-4","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-4"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|8f50044c-073b-a9f2-d740-61c4632114d9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|8f50044c-073b-a9f2-d740-61c4632114d9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692105708163},"e-4":{"id":"e-4","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-3"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|8f50044c-073b-a9f2-d740-61c4632114d9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|8f50044c-073b-a9f2-d740-61c4632114d9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692105708164},"e-7":{"id":"e-7","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-7","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-8"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|c125be24-66fd-f745-d77a-0799f907e442","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|c125be24-66fd-f745-d77a-0799f907e442","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":true,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692229619538},"e-8":{"id":"e-8","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-9","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-7"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|c125be24-66fd-f745-d77a-0799f907e442","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|c125be24-66fd-f745-d77a-0799f907e442","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692229619539},"e-9":{"id":"e-9","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-7","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-10"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|c2ca08db-83e8-6fb7-b099-adb1753f0e4f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|c2ca08db-83e8-6fb7-b099-adb1753f0e4f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692230439997},"e-10":{"id":"e-10","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-9","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-9"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|c2ca08db-83e8-6fb7-b099-adb1753f0e4f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|c2ca08db-83e8-6fb7-b099-adb1753f0e4f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692230439998},"e-11":{"id":"e-11","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-7","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-12"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|53ff4e6a-d53d-e70e-ae20-39fafe103e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|53ff4e6a-d53d-e70e-ae20-39fafe103e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692231096786},"e-12":{"id":"e-12","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-9","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-11"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|53ff4e6a-d53d-e70e-ae20-39fafe103e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|53ff4e6a-d53d-e70e-ae20-39fafe103e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692231096786},"e-13":{"id":"e-13","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-7","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-14"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|a8715ab1-d41a-c06d-c645-dfb1bc537b6c","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|a8715ab1-d41a-c06d-c645-dfb1bc537b6c","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692231124685},"e-14":{"id":"e-14","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-9","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-13"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|a8715ab1-d41a-c06d-c645-dfb1bc537b6c","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|a8715ab1-d41a-c06d-c645-dfb1bc537b6c","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692231124685},"e-15":{"id":"e-15","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-7","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-16"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|5fce32a6-fd82-bb97-aff7-4ef24707e6e9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|5fce32a6-fd82-bb97-aff7-4ef24707e6e9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692231139884},"e-16":{"id":"e-16","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-9","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-15"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|5fce32a6-fd82-bb97-aff7-4ef24707e6e9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|5fce32a6-fd82-bb97-aff7-4ef24707e6e9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692231139938},"e-17":{"id":"e-17","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-7","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-18"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|a3b881f2-190c-9e48-1baa-7acb3630da13","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|a3b881f2-190c-9e48-1baa-7acb3630da13","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692231163785},"e-18":{"id":"e-18","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-9","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-17"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|a3b881f2-190c-9e48-1baa-7acb3630da13","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|a3b881f2-190c-9e48-1baa-7acb3630da13","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692231163840},"e-19":{"id":"e-19","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-7","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-20"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|d27b9edd-a818-512b-227a-e16d28030a24","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|d27b9edd-a818-512b-227a-e16d28030a24","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692231184618},"e-20":{"id":"e-20","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-9","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-19"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|d27b9edd-a818-512b-227a-e16d28030a24","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|d27b9edd-a818-512b-227a-e16d28030a24","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692231184619},"e-21":{"id":"e-21","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-7","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-22"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|e1b91768-0365-779b-a044-5257f9a5a4f5","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|e1b91768-0365-779b-a044-5257f9a5a4f5","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692231250802},"e-22":{"id":"e-22","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-9","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-21"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|e1b91768-0365-779b-a044-5257f9a5a4f5","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|e1b91768-0365-779b-a044-5257f9a5a4f5","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692231250857},"e-24":{"id":"e-24","name":"","animationType":"custom","eventTypeId":"PAGE_FINISH","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-44","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-23"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6","appliesTo":"PAGE","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6","appliesTo":"PAGE","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692232027874},"e-25":{"id":"e-25","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-11","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-26"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|121450cc-d090-3c8a-1056-f36b2cde2441","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|121450cc-d090-3c8a-1056-f36b2cde2441","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1692233153603},"e-27":{"id":"e-27","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-13","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-28"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|10ac6af2-ee88-c584-4506-00742a0a7d7f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|10ac6af2-ee88-c584-4506-00742a0a7d7f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":20,"scrollOffsetUnit":"%","delay":0.2,"direction":null,"effectIn":true},"createdOn":1692266715401},"e-29":{"id":"e-29","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-12","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-30"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|8a817069-40a9-6845-3b50-6af711e453ee","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|8a817069-40a9-6845-3b50-6af711e453ee","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1692267410486},"e-31":{"id":"e-31","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-14","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-32"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|666c11bc-9320-2c59-1dd2-91bc02ac3de0","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|666c11bc-9320-2c59-1dd2-91bc02ac3de0","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1692267609358},"e-33":{"id":"e-33","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-34"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|a73df31d-2086-8af2-3a1f-073899ec84c7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|a73df31d-2086-8af2-3a1f-073899ec84c7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":5,"scrollOffsetUnit":"%","delay":0.1,"direction":"BOTTOM","effectIn":true},"createdOn":1692285743136},"e-35":{"id":"e-35","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-36"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|1fa0d02f-1e94-3967-28d2-60b1cae5a9d2","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|1fa0d02f-1e94-3967-28d2-60b1cae5a9d2","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":15,"scrollOffsetUnit":"%","delay":0.3,"direction":"BOTTOM","effectIn":true},"createdOn":1692285998728},"e-37":{"id":"e-37","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInRight","autoStopEventId":"e-38"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|f6eb8337-f50d-a3a6-8859-5c2b3e5ce9f9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|f6eb8337-f50d-a3a6-8859-5c2b3e5ce9f9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":"RIGHT","effectIn":true},"createdOn":1692354999386},"e-39":{"id":"e-39","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-40"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|3b13c8cd-f2d7-9107-9750-eddb4318ecd2","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|3b13c8cd-f2d7-9107-9750-eddb4318ecd2","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":15,"scrollOffsetUnit":"%","delay":0,"direction":"LEFT","effectIn":true},"createdOn":1692355041821},"e-41":{"id":"e-41","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-16","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-42"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|f6eb8337-f50d-a3a6-8859-5c2b3e5ce9f9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|f6eb8337-f50d-a3a6-8859-5c2b3e5ce9f9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1692355103905},"e-43":{"id":"e-43","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-44"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|884938c9-1e7a-54b0-bd72-738e39a56ea0","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|884938c9-1e7a-54b0-bd72-738e39a56ea0","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":"LEFT","effectIn":true},"createdOn":1692355584577},"e-45":{"id":"e-45","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-17","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-46"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".banner","originalId":"64c51800c1cab5bb07d46fe6|2930310a-8bfc-bbb6-bdfa-e0a42d3181e2","appliesTo":"CLASS"},"targets":[{"selector":".banner","originalId":"64c51800c1cab5bb07d46fe6|2930310a-8bfc-bbb6-bdfa-e0a42d3181e2","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1692356042727},"e-47":{"id":"e-47","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-18","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-48"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".footer","originalId":"afc5aff8-6b21-1019-f898-3d21a53ff0e0","appliesTo":"CLASS"},"targets":[{"selector":".footer","originalId":"afc5aff8-6b21-1019-f898-3d21a53ff0e0","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1692356613367},"e-49":{"id":"e-49","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-19","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-50"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|617aa621-57ef-4101-5fcb-03d3845a84c5","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|617aa621-57ef-4101-5fcb-03d3845a84c5","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":30,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1692361012098},"e-51":{"id":"e-51","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-52"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|c411a6a4-001c-8212-16b5-161cadca565d","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|c411a6a4-001c-8212-16b5-161cadca565d","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":5,"scrollOffsetUnit":"%","delay":0,"direction":"BOTTOM","effectIn":true},"createdOn":1692361414188},"e-53":{"id":"e-53","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-54"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|d5ffaf76-83cf-129e-a2af-3733c4b764e2","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|d5ffaf76-83cf-129e-a2af-3733c4b764e2","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":5,"scrollOffsetUnit":"%","delay":0,"direction":"BOTTOM","effectIn":true},"createdOn":1692361432204},"e-59":{"id":"e-59","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-60"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|a0171fd4-109e-88a2-2aae-f6975d55db79","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|a0171fd4-109e-88a2-2aae-f6975d55db79","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":0,"direction":"LEFT","effectIn":true},"createdOn":1692477121754},"e-61":{"id":"e-61","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-62"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|04f2b1b9-cfce-043c-478f-8b0d75af9ec6","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|04f2b1b9-cfce-043c-478f-8b0d75af9ec6","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":0,"direction":"LEFT","effectIn":true},"createdOn":1692477154622},"e-63":{"id":"e-63","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-64"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|57a7ec36-4a27-2b40-1e5e-29d89d1b3833","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|57a7ec36-4a27-2b40-1e5e-29d89d1b3833","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":20,"scrollOffsetUnit":"%","delay":0.5,"direction":"BOTTOM","effectIn":true},"createdOn":1692477256458},"e-65":{"id":"e-65","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-66"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|0cd6145f-993c-9da7-6eae-0b688a9b22d4","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|0cd6145f-993c-9da7-6eae-0b688a9b22d4","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":0,"direction":"LEFT","effectIn":true},"createdOn":1692477314958},"e-67":{"id":"e-67","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-68"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|09609d00-24fc-5993-39d6-f073f3b3058f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|09609d00-24fc-5993-39d6-f073f3b3058f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":0,"direction":"BOTTOM","effectIn":true},"createdOn":1692477527514},"e-69":{"id":"e-69","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-70"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|4ec48047-654e-be1f-e43c-30006e41be25","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|4ec48047-654e-be1f-e43c-30006e41be25","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":0,"direction":"BOTTOM","effectIn":true},"createdOn":1692477588681},"e-73":{"id":"e-73","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInRight","autoStopEventId":"e-74"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64ce424f90468059ede47e3a|e8cbbc58-a88f-0aec-5a89-474a7c126b06","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64ce424f90468059ede47e3a|e8cbbc58-a88f-0aec-5a89-474a7c126b06","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":0,"direction":"RIGHT","effectIn":true},"createdOn":1692486482510},"e-75":{"id":"e-75","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-76"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64ce424f90468059ede47e3a|3dab4cb7-f0a0-f75c-eb5c-b80647b108d7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64ce424f90468059ede47e3a|3dab4cb7-f0a0-f75c-eb5c-b80647b108d7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":0,"direction":"LEFT","effectIn":true},"createdOn":1692486493645},"e-77":{"id":"e-77","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-78"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64ce424f90468059ede47e3a|347ed535-dc1c-f357-7769-25f0804bccea","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64ce424f90468059ede47e3a|347ed535-dc1c-f357-7769-25f0804bccea","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":"LEFT","effectIn":true},"createdOn":1692486517085},"e-79":{"id":"e-79","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInRight","autoStopEventId":"e-80"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64ce424f90468059ede47e3a|325104cd-b899-9cc5-8c8a-fb31e5dd9012","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64ce424f90468059ede47e3a|325104cd-b899-9cc5-8c8a-fb31e5dd9012","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":"RIGHT","effectIn":true},"createdOn":1692486538196},"e-81":{"id":"e-81","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-82"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64ce424f90468059ede47e3a|f3ec6011-01bc-9066-cd62-ba4c7d26cba7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64ce424f90468059ede47e3a|f3ec6011-01bc-9066-cd62-ba4c7d26cba7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":"LEFT","effectIn":true},"createdOn":1692486576788},"e-83":{"id":"e-83","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInRight","autoStopEventId":"e-84"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64ce424f90468059ede47e3a|5ccb59a3-8e46-3e58-aaae-5c19b62cdcbd","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64ce424f90468059ede47e3a|5ccb59a3-8e46-3e58-aaae-5c19b62cdcbd","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":"RIGHT","effectIn":true},"createdOn":1692486589446},"e-85":{"id":"e-85","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-86"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64ce424f90468059ede47e3a|d9680cc7-ad70-6c13-5828-75d9d29520f9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64ce424f90468059ede47e3a|d9680cc7-ad70-6c13-5828-75d9d29520f9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":"LEFT","effectIn":true},"createdOn":1692486601725},"e-87":{"id":"e-87","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInRight","autoStopEventId":"e-88"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64ce424f90468059ede47e3a|d9680cc7-ad70-6c13-5828-75d9d29520fa","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64ce424f90468059ede47e3a|d9680cc7-ad70-6c13-5828-75d9d29520fa","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":"RIGHT","effectIn":true},"createdOn":1692486617309},"e-89":{"id":"e-89","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"FADE_EFFECT","instant":false,"config":{"actionListId":"fadeIn","autoStopEventId":"e-90"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64ce424f90468059ede47e3a|311f6d4e-75a6-7de7-198d-de9a1fd34d27","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64ce424f90468059ede47e3a|311f6d4e-75a6-7de7-198d-de9a1fd34d27","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":20,"scrollOffsetUnit":"%","delay":0.5,"direction":null,"effectIn":true},"createdOn":1692486683389},"e-91":{"id":"e-91","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"FADE_EFFECT","instant":false,"config":{"actionListId":"fadeIn","autoStopEventId":"e-92"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64ce424f90468059ede47e3a|5ccb59a3-8e46-3e58-aaae-5c19b62cdcbe","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64ce424f90468059ede47e3a|5ccb59a3-8e46-3e58-aaae-5c19b62cdcbe","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":20,"scrollOffsetUnit":"%","delay":0.5,"direction":null,"effectIn":true},"createdOn":1692486701220},"e-93":{"id":"e-93","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"FADE_EFFECT","instant":false,"config":{"actionListId":"fadeIn","autoStopEventId":"e-94"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64ce424f90468059ede47e3a|6c6035b5-2a44-c1f5-aecb-f3b4e9bd7455","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64ce424f90468059ede47e3a|6c6035b5-2a44-c1f5-aecb-f3b4e9bd7455","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":20,"scrollOffsetUnit":"%","delay":0.5,"direction":null,"effectIn":true},"createdOn":1692486941053},"e-95":{"id":"e-95","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-96"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf741eed7270f23d514a3e|f07f7340-fa9b-590f-bd22-64abdf7ebf7e","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf741eed7270f23d514a3e|f07f7340-fa9b-590f-bd22-64abdf7ebf7e","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":15,"scrollOffsetUnit":"%","delay":0,"direction":"LEFT","effectIn":true},"createdOn":1692487042547},"e-97":{"id":"e-97","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInRight","autoStopEventId":"e-98"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf741eed7270f23d514a3e|f07f7340-fa9b-590f-bd22-64abdf7ebf8c","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf741eed7270f23d514a3e|f07f7340-fa9b-590f-bd22-64abdf7ebf8c","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":15,"scrollOffsetUnit":"%","delay":0,"direction":"RIGHT","effectIn":true},"createdOn":1692487055195},"e-99":{"id":"e-99","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GROW_EFFECT","instant":false,"config":{"actionListId":"growIn","autoStopEventId":"e-100"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf741eed7270f23d514a3e|f07f7340-fa9b-590f-bd22-64abdf7ebf85","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf741eed7270f23d514a3e|f07f7340-fa9b-590f-bd22-64abdf7ebf85","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":15,"scrollOffsetUnit":"%","delay":0,"direction":null,"effectIn":true},"createdOn":1692487066028},"e-101":{"id":"e-101","name":"","animationType":"custom","eventTypeId":"PAGE_START","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-21","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-102"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf741eed7270f23d514a3e","appliesTo":"PAGE","styleBlockIds":[]},"targets":[{"id":"64cf741eed7270f23d514a3e","appliesTo":"PAGE","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692487206064},"e-103":{"id":"e-103","name":"","animationType":"custom","eventTypeId":"PAGE_START","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-22","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-104"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64db860de15445b6611e99f6","appliesTo":"PAGE","styleBlockIds":[]},"targets":[{"id":"64db860de15445b6611e99f6","appliesTo":"PAGE","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692487747243},"e-105":{"id":"e-105","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-23","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-106"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64db860de15445b6611e99f6|a9bacd4c-8cf9-0e39-6cbe-795fb28172db","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64db860de15445b6611e99f6|a9bacd4c-8cf9-0e39-6cbe-795fb28172db","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1692487943995},"e-107":{"id":"e-107","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-24","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-108"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64db860de15445b6611e99f6|d63b27ae-4c03-0759-6b98-b1c52d235eda","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64db860de15445b6611e99f6|d63b27ae-4c03-0759-6b98-b1c52d235eda","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":15,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1692488543698},"e-109":{"id":"e-109","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-25","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-110"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64db860de15445b6611e99f6|1b3b82c1-09d1-0369-6c1d-66f7ce49214a","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64db860de15445b6611e99f6|1b3b82c1-09d1-0369-6c1d-66f7ce49214a","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":20,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1692488732949},"e-111":{"id":"e-111","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-26","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-112"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64db860de15445b6611e99f6|3c65fbdd-a48f-256b-93e8-806bbc9c315c","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64db860de15445b6611e99f6|3c65fbdd-a48f-256b-93e8-806bbc9c315c","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":15,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1692488781467},"e-113":{"id":"e-113","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-27","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-114"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64db860de15445b6611e99f6|3a2a93fb-5725-bb2c-fb1c-aa5fcd9af6c9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64db860de15445b6611e99f6|3a2a93fb-5725-bb2c-fb1c-aa5fcd9af6c9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":15,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1692488857587},"e-115":{"id":"e-115","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-28","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-116"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64db860de15445b6611e99f6|fc53a6f3-b6a7-8465-bf4d-12fea350fca6","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64db860de15445b6611e99f6|fc53a6f3-b6a7-8465-bf4d-12fea350fca6","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":15,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1692488885884},"e-117":{"id":"e-117","name":"","animationType":"custom","eventTypeId":"PAGE_START","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-29","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-118"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec","appliesTo":"PAGE","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec","appliesTo":"PAGE","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692489129305},"e-125":{"id":"e-125","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-126"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|53ff4e6a-d53d-e70e-ae20-39fafe103e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|53ff4e6a-d53d-e70e-ae20-39fafe103e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":20,"scrollOffsetUnit":"%","delay":0,"direction":"LEFT","effectIn":true},"createdOn":1692490089730},"e-127":{"id":"e-127","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInRight","autoStopEventId":"e-128"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|a8715ab1-d41a-c06d-c645-dfb1bc537b6c","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|a8715ab1-d41a-c06d-c645-dfb1bc537b6c","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":20,"scrollOffsetUnit":"%","delay":0,"direction":"RIGHT","effectIn":true},"createdOn":1692490101248},"e-129":{"id":"e-129","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-130"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|5fce32a6-fd82-bb97-aff7-4ef24707e6e9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|5fce32a6-fd82-bb97-aff7-4ef24707e6e9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":20,"scrollOffsetUnit":"%","delay":0,"direction":"LEFT","effectIn":true},"createdOn":1692490112714},"e-131":{"id":"e-131","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInRight","autoStopEventId":"e-132"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|a3b881f2-190c-9e48-1baa-7acb3630da13","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|a3b881f2-190c-9e48-1baa-7acb3630da13","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":20,"scrollOffsetUnit":"%","delay":0,"direction":"RIGHT","effectIn":true},"createdOn":1692490126271},"e-133":{"id":"e-133","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-134"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|d27b9edd-a818-512b-227a-e16d28030a24","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|d27b9edd-a818-512b-227a-e16d28030a24","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":20,"scrollOffsetUnit":"%","delay":0,"direction":"LEFT","effectIn":true},"createdOn":1692490140313},"e-135":{"id":"e-135","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInRight","autoStopEventId":"e-136"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|e1b91768-0365-779b-a044-5257f9a5a4f5","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|e1b91768-0365-779b-a044-5257f9a5a4f5","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":20,"scrollOffsetUnit":"%","delay":0,"direction":"RIGHT","effectIn":true},"createdOn":1692490149504},"e-137":{"id":"e-137","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"FADE_EFFECT","instant":false,"config":{"actionListId":"fadeIn","autoStopEventId":"e-138"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|c2ca08db-83e8-6fb7-b099-adb1753f0e56","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|c2ca08db-83e8-6fb7-b099-adb1753f0e56","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":20,"scrollOffsetUnit":"%","delay":0,"direction":null,"effectIn":true},"createdOn":1692490178090},"e-139":{"id":"e-139","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"FADE_EFFECT","instant":false,"config":{"actionListId":"fadeIn","autoStopEventId":"e-140"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|d27b9edd-a818-512b-227a-e16d28030a2b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|d27b9edd-a818-512b-227a-e16d28030a2b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":20,"scrollOffsetUnit":"%","delay":0,"direction":null,"effectIn":true},"createdOn":1692490273979},"e-141":{"id":"e-141","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"FADE_EFFECT","instant":false,"config":{"actionListId":"fadeIn","autoStopEventId":"e-142"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|a3b881f2-190c-9e48-1baa-7acb3630da1a","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|a3b881f2-190c-9e48-1baa-7acb3630da1a","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":20,"scrollOffsetUnit":"%","delay":0,"direction":null,"effectIn":true},"createdOn":1692490289545},"e-143":{"id":"e-143","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"FADE_EFFECT","instant":false,"config":{"actionListId":"fadeIn","autoStopEventId":"e-144"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|5fce32a6-fd82-bb97-aff7-4ef24707e6f0","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|5fce32a6-fd82-bb97-aff7-4ef24707e6f0","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":20,"scrollOffsetUnit":"%","delay":0,"direction":null,"effectIn":true},"createdOn":1692490298234},"e-145":{"id":"e-145","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"FADE_EFFECT","instant":false,"config":{"actionListId":"fadeIn","autoStopEventId":"e-146"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|a8715ab1-d41a-c06d-c645-dfb1bc537b73","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|a8715ab1-d41a-c06d-c645-dfb1bc537b73","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":20,"scrollOffsetUnit":"%","delay":0,"direction":null,"effectIn":true},"createdOn":1692490310209},"e-147":{"id":"e-147","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"FADE_EFFECT","instant":false,"config":{"actionListId":"fadeIn","autoStopEventId":"e-148"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|53ff4e6a-d53d-e70e-ae20-39fafe103e9c","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|53ff4e6a-d53d-e70e-ae20-39fafe103e9c","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":20,"scrollOffsetUnit":"%","delay":0,"direction":null,"effectIn":true},"createdOn":1692490323915},"e-149":{"id":"e-149","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-150"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cf86cf347c14534ee2b4ec|6310a98e-9ab9-e217-0ecb-52b1d79414ee","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cf86cf347c14534ee2b4ec|6310a98e-9ab9-e217-0ecb-52b1d79414ee","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1692490919714},"e-151":{"id":"e-151","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-152"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73240|78508e08-6851-5ed3-f343-cb0a16d20fe8","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73240|78508e08-6851-5ed3-f343-cb0a16d20fe8","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":"BOTTOM","effectIn":true},"createdOn":1692548178731},"e-153":{"id":"e-153","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-154"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73240|06a8b2bb-6dda-88d8-9164-c2d989d0fe4b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73240|06a8b2bb-6dda-88d8-9164-c2d989d0fe4b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":"LEFT","effectIn":true},"createdOn":1692548216813},"e-155":{"id":"e-155","name":"","animationType":"custom","eventTypeId":"PAGE_START","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-47","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-156"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73240","appliesTo":"PAGE","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73240","appliesTo":"PAGE","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692548271840},"e-157":{"id":"e-157","name":"","animationType":"custom","eventTypeId":"PAGE_START","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-32","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-158"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242","appliesTo":"PAGE","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242","appliesTo":"PAGE","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692549983033},"e-161":{"id":"e-161","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInRight","autoStopEventId":"e-162"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|45a97878-e681-6725-53a3-160b81c1ea04","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|45a97878-e681-6725-53a3-160b81c1ea04","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":"RIGHT","effectIn":true},"createdOn":1692550389266},"e-163":{"id":"e-163","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInRight","autoStopEventId":"e-164"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|4b7822c9-997b-bca6-b655-150c10da4b5d","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|4b7822c9-997b-bca6-b655-150c10da4b5d","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":"RIGHT","effectIn":true},"createdOn":1692550403538},"e-165":{"id":"e-165","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInRight","autoStopEventId":"e-166"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|f343e1ee-c890-d077-7e29-b46943d63818","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|f343e1ee-c890-d077-7e29-b46943d63818","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":"RIGHT","effectIn":true},"createdOn":1692550414105},"e-167":{"id":"e-167","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInRight","autoStopEventId":"e-168"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|e21cd2f6-f250-8b08-21a9-d51c630f8936","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|e21cd2f6-f250-8b08-21a9-d51c630f8936","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":"RIGHT","effectIn":true},"createdOn":1692550427515},"e-169":{"id":"e-169","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInRight","autoStopEventId":"e-170"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|e21cd2f6-f250-8b08-21a9-d51c630f893f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|e21cd2f6-f250-8b08-21a9-d51c630f893f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":0,"direction":"RIGHT","effectIn":true},"createdOn":1692550439649},"e-171":{"id":"e-171","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInRight","autoStopEventId":"e-172"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|e21cd2f6-f250-8b08-21a9-d51c630f8940","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|e21cd2f6-f250-8b08-21a9-d51c630f8940","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":"RIGHT","effectIn":true},"createdOn":1692550451666},"e-173":{"id":"e-173","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInRight","autoStopEventId":"e-174"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|276e5ccf-823a-9b32-8ccd-c006d725eb7c","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|276e5ccf-823a-9b32-8ccd-c006d725eb7c","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":"RIGHT","effectIn":true},"createdOn":1692550465780},"e-177":{"id":"e-177","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"FADE_EFFECT","instant":false,"config":{"actionListId":"fadeIn","autoStopEventId":"e-178"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|6741d7eb-2be4-778a-1bc3-d7e54713e5c5","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|6741d7eb-2be4-778a-1bc3-d7e54713e5c5","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":null,"effectIn":true},"createdOn":1692550515361},"e-179":{"id":"e-179","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"FADE_EFFECT","instant":false,"config":{"actionListId":"fadeIn","autoStopEventId":"e-180"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|831528b8-6d23-e6bb-c8c4-8870ec04c7ea","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|831528b8-6d23-e6bb-c8c4-8870ec04c7ea","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":null,"effectIn":true},"createdOn":1692550524939},"e-181":{"id":"e-181","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"FADE_EFFECT","instant":false,"config":{"actionListId":"fadeIn","autoStopEventId":"e-236"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|05163c2d-02c1-8b50-26fc-95322fcdd153","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|05163c2d-02c1-8b50-26fc-95322fcdd153","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":null,"effectIn":true},"createdOn":1692550540123},"e-183":{"id":"e-183","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-238"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|44d9b506-a7ce-d9aa-53c8-47a877efea28","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|44d9b506-a7ce-d9aa-53c8-47a877efea28","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":"LEFT","effectIn":true},"createdOn":1692550555826},"e-185":{"id":"e-185","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-186"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|9735fa0a-98cf-82ee-ec71-76fa119a64c5","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|9735fa0a-98cf-82ee-ec71-76fa119a64c5","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":"LEFT","effectIn":true},"createdOn":1692550581898},"e-187":{"id":"e-187","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GROW_BIG_EFFECT","instant":false,"config":{"actionListId":"growBigIn","autoStopEventId":"e-188"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|9735fa0a-98cf-82ee-ec71-76fa119a64cc","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|9735fa0a-98cf-82ee-ec71-76fa119a64cc","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":null,"effectIn":true},"createdOn":1692550591816},"e-189":{"id":"e-189","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInRight","autoStopEventId":"e-190"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|9735fa0a-98cf-82ee-ec71-76fa119a64d3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|9735fa0a-98cf-82ee-ec71-76fa119a64d3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":"RIGHT","effectIn":true},"createdOn":1692550601081},"e-191":{"id":"e-191","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-192"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|24d3f0ba-346c-d784-0237-ad83fb5742bd","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|24d3f0ba-346c-d784-0237-ad83fb5742bd","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":"LEFT","effectIn":true},"createdOn":1692551009659},"e-193":{"id":"e-193","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GROW_BIG_EFFECT","instant":false,"config":{"actionListId":"growBigIn","autoStopEventId":"e-194"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|aa8912eb-dff0-a1b9-500e-aba28b18cd43","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|aa8912eb-dff0-a1b9-500e-aba28b18cd43","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":null,"effectIn":true},"createdOn":1692551081793},"e-201":{"id":"e-201","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-37","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-202"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|05110fd0-7d6a-291e-8f24-6e7abd2485f0","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|05110fd0-7d6a-291e-8f24-6e7abd2485f0","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692552584836},"e-203":{"id":"e-203","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-35","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-204"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|84480547-1ddd-e97e-3260-62c4d4451e56","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|84480547-1ddd-e97e-3260-62c4d4451e56","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692557493188},"e-209":{"id":"e-209","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-38","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-210"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|aa8912eb-dff0-a1b9-500e-aba28b18cd43","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|aa8912eb-dff0-a1b9-500e-aba28b18cd43","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1692561521443},"e-211":{"id":"e-211","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-36","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-212"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|d8afce73-542e-d529-ade6-fdddc1ecb531","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|d8afce73-542e-d529-ade6-fdddc1ecb531","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1698298801007},"e-213":{"id":"e-213","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-34","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-214"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|5f62eeee-0a4f-ae6b-bb93-0a8564a44969","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|5f62eeee-0a4f-ae6b-bb93-0a8564a44969","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1698302284551},"e-215":{"id":"e-215","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"FADE_EFFECT","instant":false,"config":{"actionListId":"fadeIn","autoStopEventId":"e-216"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|5f62eeee-0a4f-ae6b-bb93-0a8564a4496a","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|5f62eeee-0a4f-ae6b-bb93-0a8564a4496a","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":10,"scrollOffsetUnit":"%","delay":0,"direction":null,"effectIn":true},"createdOn":1698302284551},"e-217":{"id":"e-217","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GROW_EFFECT","instant":false,"config":{"actionListId":"growIn","autoStopEventId":"e-218"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|77991944-1d0c-0aa7-1993-a96ec02c24e4","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|77991944-1d0c-0aa7-1993-a96ec02c24e4","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":324,"direction":null,"effectIn":true},"createdOn":1708441135139},"e-219":{"id":"e-219","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GROW_EFFECT","instant":false,"config":{"actionListId":"growIn","autoStopEventId":"e-220"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c80ce05979ef41d6b73242|ef370ee6-de57-e101-6330-7bb378ae9c5f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c80ce05979ef41d6b73242|ef370ee6-de57-e101-6330-7bb378ae9c5f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":229,"direction":null,"effectIn":true},"createdOn":1708441172053},"e-225":{"id":"e-225","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-44","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-226"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|c142ca4f-95a7-137d-6ca8-8808fe83599a","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|c142ca4f-95a7-137d-6ca8-8808fe83599a","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1680161983410},"e-227":{"id":"e-227","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-46","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-228"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64ce424f90468059ede47e3a|69ea88ae-6516-ba87-37be-70c9c1a97fb7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64ce424f90468059ede47e3a|69ea88ae-6516-ba87-37be-70c9c1a97fb7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1731172885116},"e-229":{"id":"e-229","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInTop","autoStopEventId":"e-230"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64ce424f90468059ede47e3a|30090b2c-8be0-eec4-5c41-593128299434","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64ce424f90468059ede47e3a|30090b2c-8be0-eec4-5c41-593128299434","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":0,"direction":"TOP","effectIn":true},"createdOn":1731175025586},"e-235":{"id":"e-235","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-52","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-236"}},"mediaQueries":["main","medium"],"target":{"id":"64c51800c1cab5bb07d46fe6|32b85450-c737-4224-64f0-8c478319db9a","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|32b85450-c737-4224-64f0-8c478319db9a","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":true,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1651458326539},"e-237":{"id":"e-237","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-53","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-238"}},"mediaQueries":["small","tiny"],"target":{"id":"64c51800c1cab5bb07d46fe6|32b85450-c737-4224-64f0-8c478319db9a","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64c51800c1cab5bb07d46fe6|32b85450-c737-4224-64f0-8c478319db9a","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":true,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1651458326539},"e-245":{"id":"e-245","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-246"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"67be27dd5618715c5fe23749|1bec7bb2-ba31-bebc-bd90-e1472b1d661e","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"67be27dd5618715c5fe23749|1bec7bb2-ba31-bebc-bd90-e1472b1d661e","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":0,"direction":"LEFT","effectIn":true},"createdOn":1740515872483}},"actionLists":{"a-4":{"id":"a-4","title":"Collection Hoover In","actionItemGroups":[{"actionItems":[{"id":"a-4-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".text-block-38","selectorGuids":["0208af5a-a82a-81af-133a-9e713e5f01ad"]},"yValue":450,"xUnit":"PX","yUnit":"%","zUnit":"PX"}},{"id":"a-4-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".heading-21","selectorGuids":["f39957b4-2576-85d5-ba91-33e7115c8f01"]},"yValue":100,"xUnit":"PX","yUnit":"%","zUnit":"PX"}},{"id":"a-4-n","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"inQuad","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".div-block-11","selectorGuids":["3871556a-bd32-bd13-4a8a-5babec8d560c"]},"globalSwatchId":"","rValue":0,"bValue":0,"gValue":0,"aValue":0}}]},{"actionItems":[{"id":"a-4-n-7","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"inQuad","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".div-block-11","selectorGuids":["3871556a-bd32-bd13-4a8a-5babec8d560c"]},"globalSwatchId":"","rValue":0,"bValue":0,"gValue":0,"aValue":0.45}}]},{"actionItems":[{"id":"a-4-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inCubic","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".heading-21","selectorGuids":["f39957b4-2576-85d5-ba91-33e7115c8f01"]},"yValue":0,"xUnit":"PX","yUnit":"%","zUnit":"PX"}},{"id":"a-4-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inCubic","duration":400,"target":{"useEventTarget":"CHILDREN","selector":".text-block-38","selectorGuids":["0208af5a-a82a-81af-133a-9e713e5f01ad"]},"yValue":9,"xUnit":"PX","yUnit":"%","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1692105725269},"a-15":{"id":"a-15","title":"Collection Hover Out","actionItemGroups":[{"actionItems":[{"id":"a-15-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":200,"easing":"outQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".heading-21","selectorGuids":["f39957b4-2576-85d5-ba91-33e7115c8f01"]},"yValue":100,"xUnit":"PX","yUnit":"%","zUnit":"PX"}},{"id":"a-15-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":200,"easing":"outQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".text-block-38","selectorGuids":["0208af5a-a82a-81af-133a-9e713e5f01ad"]},"yValue":450,"xUnit":"PX","yUnit":"%","zUnit":"PX"}}]},{"actionItems":[{"id":"a-15-n-3","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"outQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".div-block-11","selectorGuids":["3871556a-bd32-bd13-4a8a-5babec8d560c"]},"globalSwatchId":"","rValue":0,"bValue":0,"gValue":0,"aValue":0}}]}],"useFirstGroupAsInitialState":false,"createdOn":1692286361292},"a-7":{"id":"a-7","title":"FAQ Down","actionItemGroups":[{"actionItems":[{"id":"a-7-n","actionTypeId":"STYLE_SIZE","config":{"delay":0,"easing":"inOutCubic","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".faq-row-two","selectorGuids":["592937d9-0fce-2420-2792-3dd202d3bfe6"]},"heightValue":0,"widthUnit":"PX","heightUnit":"px","locked":false}}]},{"actionItems":[{"id":"a-7-n-2","actionTypeId":"STYLE_SIZE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".faq-row-two","selectorGuids":["592937d9-0fce-2420-2792-3dd202d3bfe6"]},"widthUnit":"PX","heightUnit":"AUTO","locked":false}},{"id":"a-7-n-3","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"ease","duration":400,"target":{"useEventTarget":"CHILDREN","selector":".down-arrow","selectorGuids":["4a1963b8-0f03-cf07-0c92-9396dc3c3c15"]},"zValue":180,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1692229646523},"a-9":{"id":"a-9","title":"FAQ up","actionItemGroups":[{"actionItems":[{"id":"a-9-n","actionTypeId":"STYLE_SIZE","config":{"delay":0,"easing":"inOutCubic","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".faq-row-two","selectorGuids":["592937d9-0fce-2420-2792-3dd202d3bfe6"]},"heightValue":0,"widthUnit":"PX","heightUnit":"px","locked":false}},{"id":"a-9-n-2","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"ease","duration":400,"target":{"useEventTarget":"CHILDREN","selector":".down-arrow","selectorGuids":["4a1963b8-0f03-cf07-0c92-9396dc3c3c15"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1692230167064},"a-44":{"id":"a-44","title":"Loader 3 [Hide]","actionItemGroups":[{"actionItems":[{"id":"a-44-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".loader3_component","selectorGuids":["30bb1f27-b575-90ef-384a-8b3d80c4d46d"]},"value":"flex"}},{"id":"a-44-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".loader3_background","selectorGuids":["30bb1f27-b575-90ef-384a-8b3d80c4d469"]},"yValue":0,"xUnit":"PX","yUnit":"%","zUnit":"PX"}},{"id":"a-44-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".loader3_image-overlay","selectorGuids":["30bb1f27-b575-90ef-384a-8b3d80c4d465"]},"yValue":0,"xUnit":"PX","yUnit":"%","zUnit":"PX"}},{"id":"a-44-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".loader3_content-wrapper","selectorGuids":["30bb1f27-b575-90ef-384a-8b3d80c4d468"]},"value":1,"unit":""}},{"id":"a-44-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".loader3_image","selectorGuids":["30bb1f27-b575-90ef-384a-8b3d80c4d473"]},"yValue":100,"xUnit":"PX","yUnit":"%","zUnit":"PX"}}]},{"actionItems":[{"id":"a-44-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"selector":".loader3_image","selectorGuids":["30bb1f27-b575-90ef-384a-8b3d80c4d473"]},"yValue":0,"xUnit":"PX","yUnit":"%","zUnit":"PX"}}]},{"actionItems":[{"id":"a-44-n-7","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":300,"target":{"selector":".loader3_content-wrapper","selectorGuids":["30bb1f27-b575-90ef-384a-8b3d80c4d468"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-44-n-8","actionTypeId":"TRANSFORM_MOVE","config":{"delay":200,"easing":"outQuart","duration":600,"target":{"selector":".loader3_background","selectorGuids":["30bb1f27-b575-90ef-384a-8b3d80c4d469"]},"yValue":-100,"xUnit":"PX","yUnit":"%","zUnit":"PX"}}]},{"actionItems":[{"id":"a-44-n-9","actionTypeId":"GENERAL_DISPLAY","config":{"delay":1000,"easing":"","duration":0,"target":{"selector":".loader3_component","selectorGuids":["30bb1f27-b575-90ef-384a-8b3d80c4d46d"]},"value":"none"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1680078417278},"a-11":{"id":"a-11","title":"Specialise Wrapper","actionItemGroups":[{"actionItems":[{"id":"a-11-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"64c51800c1cab5bb07d46fe6|121450cc-d090-3c8a-1056-f36b2cde2441"},"yValue":50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-11-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"64c51800c1cab5bb07d46fe6|121450cc-d090-3c8a-1056-f36b2cde2441"},"value":0,"unit":""}},{"id":"a-11-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".heading-6","selectorGuids":["62a44ff4-d6e9-3e06-2534-7918bbbf76c9"]},"yValue":-50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-11-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".heading-6","selectorGuids":["62a44ff4-d6e9-3e06-2534-7918bbbf76c9"]},"value":0,"unit":""}},{"id":"a-11-n-10","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".specialise-card","selectorGuids":["c77d9142-7e5b-7044-3e1b-9e22016b5bef"]},"value":0,"unit":""}},{"id":"a-11-n-9","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".specialise-card","selectorGuids":["c77d9142-7e5b-7044-3e1b-9e22016b5bef"]},"xValue":0,"yValue":50,"xUnit":"px","yUnit":"px","zUnit":"PX"}}]},{"actionItems":[{"id":"a-11-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeIn","duration":400,"target":{"useEventTarget":true,"id":"64c51800c1cab5bb07d46fe6|121450cc-d090-3c8a-1056-f36b2cde2441"},"yValue":0,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-11-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":300,"target":{"useEventTarget":true,"id":"64c51800c1cab5bb07d46fe6|121450cc-d090-3c8a-1056-f36b2cde2441"},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-11-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".heading-6","selectorGuids":["62a44ff4-d6e9-3e06-2534-7918bbbf76c9"]},"yValue":0,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-11-n-8","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"inQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".heading-6","selectorGuids":["62a44ff4-d6e9-3e06-2534-7918bbbf76c9"]},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-11-n-11","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".specialise-card","selectorGuids":["c77d9142-7e5b-7044-3e1b-9e22016b5bef"]},"yValue":0,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-11-n-12","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":1000,"target":{"useEventTarget":"CHILDREN","selector":".specialise-card","selectorGuids":["c77d9142-7e5b-7044-3e1b-9e22016b5bef"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1692233188204},"a-13":{"id":"a-13","title":"About Section 2","actionItemGroups":[{"actionItems":[{"id":"a-13-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".about-tag-border","selectorGuids":["c7b66824-54f2-6b4a-d623-b68ec810ed65"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-13-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":200,"easing":"easeOut","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".about-tag-border","selectorGuids":["c7b66824-54f2-6b4a-d623-b68ec810ed65"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1692266810588},"a-12":{"id":"a-12","title":"About Section","actionItemGroups":[{"actionItems":[{"id":"a-12-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".image-6","selectorGuids":["6ff2c0cd-441d-9e40-f241-320dd9337e8c"]},"xValue":-500,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-12-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".image-6","selectorGuids":["6ff2c0cd-441d-9e40-f241-320dd9337e8c"]},"value":0,"unit":""}},{"id":"a-12-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".about-text-wrapper","selectorGuids":["19f7ddf6-73d8-4e86-acc7-041c1750d20b"]},"xValue":200,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-12-n-5","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".about-text-wrapper","selectorGuids":["19f7ddf6-73d8-4e86-acc7-041c1750d20b"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-12-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeOut","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".image-6","selectorGuids":["6ff2c0cd-441d-9e40-f241-320dd9337e8c"]},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-12-n-8","actionTypeId":"STYLE_OPACITY","config":{"delay":200,"easing":"easeOut","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".image-6","selectorGuids":["6ff2c0cd-441d-9e40-f241-320dd9337e8c"]},"value":1,"unit":""}},{"id":"a-12-n-10","actionTypeId":"STYLE_OPACITY","config":{"delay":200,"easing":"easeOut","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".about-text-wrapper","selectorGuids":["19f7ddf6-73d8-4e86-acc7-041c1750d20b"]},"value":1,"unit":""}},{"id":"a-12-n-9","actionTypeId":"TRANSFORM_MOVE","config":{"delay":200,"easing":"easeOut","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".about-text-wrapper","selectorGuids":["19f7ddf6-73d8-4e86-acc7-041c1750d20b"]},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1692266810588},"a-14":{"id":"a-14","title":"About Section 3","actionItemGroups":[{"actionItems":[{"id":"a-14-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".about-icon-grid","selectorGuids":["6ffbdb41-95d8-adf7-d24c-f4d04df0dd8a"]},"yValue":50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-14-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".about-icon-grid","selectorGuids":["6ffbdb41-95d8-adf7-d24c-f4d04df0dd8a"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-14-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".about-icon-grid","selectorGuids":["6ffbdb41-95d8-adf7-d24c-f4d04df0dd8a"]},"yValue":0,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-14-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".about-icon-grid","selectorGuids":["6ffbdb41-95d8-adf7-d24c-f4d04df0dd8a"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1692267618323},"a-16":{"id":"a-16","title":"Best Seller Section","actionItemGroups":[{"actionItems":[{"id":"a-16-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".best-seller-payment","selectorGuids":["29903153-989d-a65f-cc43-ff06ac081e7f"]},"yValue":100,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-16-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".best-seller-payment","selectorGuids":["29903153-989d-a65f-cc43-ff06ac081e7f"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-16-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":500,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".best-seller-payment","selectorGuids":["29903153-989d-a65f-cc43-ff06ac081e7f"]},"yValue":0,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-16-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":500,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".best-seller-payment","selectorGuids":["29903153-989d-a65f-cc43-ff06ac081e7f"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1692355117372},"a-17":{"id":"a-17","title":"Banner Animation","actionItemGroups":[{"actionItems":[{"id":"a-17-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"64c51800c1cab5bb07d46fe6|2930310a-8bfc-bbb6-bdfa-e0a42d3181e2"},"value":0,"unit":""}},{"id":"a-17-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".heading-16","selectorGuids":["9d25c1ea-90af-a47e-f961-4bcd34f8a729"]},"xValue":-100,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-17-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".text-block-15","selectorGuids":["72062494-d0bd-cd8a-fad6-856548db4d07"]},"xValue":-100,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-17-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64c51800c1cab5bb07d46fe6|7ea95902-84ba-ff59-1ad1-db7c0a81a4ea"},"yValue":100,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-17-n-8","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64c51800c1cab5bb07d46fe6|7ea95902-84ba-ff59-1ad1-db7c0a81a4ea"},"value":0,"unit":""}},{"id":"a-17-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".text-block-15","selectorGuids":["72062494-d0bd-cd8a-fad6-856548db4d07"]},"value":0,"unit":""}},{"id":"a-17-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".heading-16","selectorGuids":["9d25c1ea-90af-a47e-f961-4bcd34f8a729"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-17-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"useEventTarget":true,"id":"64c51800c1cab5bb07d46fe6|2930310a-8bfc-bbb6-bdfa-e0a42d3181e2"},"value":1,"unit":""}},{"id":"a-17-n-9","actionTypeId":"TRANSFORM_MOVE","config":{"delay":100,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".heading-16","selectorGuids":["9d25c1ea-90af-a47e-f961-4bcd34f8a729"]},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-17-n-14","actionTypeId":"STYLE_OPACITY","config":{"delay":100,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".heading-16","selectorGuids":["9d25c1ea-90af-a47e-f961-4bcd34f8a729"]},"value":1,"unit":""}},{"id":"a-17-n-10","actionTypeId":"TRANSFORM_MOVE","config":{"delay":200,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".text-block-15","selectorGuids":["72062494-d0bd-cd8a-fad6-856548db4d07"]},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-17-n-13","actionTypeId":"STYLE_OPACITY","config":{"delay":200,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".text-block-15","selectorGuids":["72062494-d0bd-cd8a-fad6-856548db4d07"]},"value":1,"unit":""}},{"id":"a-17-n-11","actionTypeId":"TRANSFORM_MOVE","config":{"delay":300,"easing":"inOutQuad","duration":500,"target":{"id":"64c51800c1cab5bb07d46fe6|7ea95902-84ba-ff59-1ad1-db7c0a81a4ea"},"xValue":0,"yValue":0,"xUnit":"px","yUnit":"px","zUnit":"PX"}},{"id":"a-17-n-12","actionTypeId":"STYLE_OPACITY","config":{"delay":300,"easing":"inOutQuad","duration":500,"target":{"id":"64c51800c1cab5bb07d46fe6|7ea95902-84ba-ff59-1ad1-db7c0a81a4ea"},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1692356056079},"a-18":{"id":"a-18","title":"Footer Animation","actionItemGroups":[{"actionItems":[{"id":"a-18-n-46","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","id":"afc5aff8-6b21-1019-f898-3d21a53ff101"},"xValue":150,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-18-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".logo-footer","selectorGuids":["daf9ce54-abcb-3922-0122-6cdc39fd2b07"]},"xValue":-150,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-18-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".logo-footer","selectorGuids":["daf9ce54-abcb-3922-0122-6cdc39fd2b07"]},"value":0,"unit":""}},{"id":"a-18-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","id":"afc5aff8-6b21-1019-f898-3d21a53ff0ef"},"xValue":150,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-18-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","id":"afc5aff8-6b21-1019-f898-3d21a53ff113"},"xValue":150,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-18-n-8","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","id":"afc5aff8-6b21-1019-f898-3d21a53ff11f"},"xValue":150,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-18-n-12","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","id":"afc5aff8-6b21-1019-f898-3d21a53ff0ef"},"value":0,"unit":""}},{"id":"a-18-n-11","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","id":"afc5aff8-6b21-1019-f898-3d21a53ff101"},"value":0,"unit":""}},{"id":"a-18-n-10","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","id":"afc5aff8-6b21-1019-f898-3d21a53ff113"},"value":0,"unit":""}},{"id":"a-18-n-9","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","id":"afc5aff8-6b21-1019-f898-3d21a53ff11f"},"value":0,"unit":""}},{"id":"a-18-n-13","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".payment-cards-wrapper","selectorGuids":["ec4c0c7e-8ccb-423d-d25b-a6eb54584934"]},"yValue":50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-18-n-14","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".payment-cards-wrapper","selectorGuids":["ec4c0c7e-8ccb-423d-d25b-a6eb54584934"]},"value":0,"unit":""}},{"id":"a-18-n-29","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".links-footer","selectorGuids":["7640687b-6577-75b8-f491-6e12cb531d33"]},"xValue":250,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-18-n-30","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".links-footer","selectorGuids":["7640687b-6577-75b8-f491-6e12cb531d33"]},"value":0,"unit":""}},{"id":"a-18-n-33","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".image-20","selectorGuids":["b8fa6617-02e0-2641-158a-66d7e142be8a"]},"xValue":-100,"yValue":0,"xUnit":"px","yUnit":"px","zUnit":"PX"}},{"id":"a-18-n-34","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".image-20","selectorGuids":["b8fa6617-02e0-2641-158a-66d7e142be8a"]},"value":0,"unit":""}},{"id":"a-18-n-35","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".text-block-18","selectorGuids":["2dc14cc7-6708-d8ed-e2ed-90d95eca7153"]},"xValue":-100,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-18-n-36","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".text-block-18","selectorGuids":["2dc14cc7-6708-d8ed-e2ed-90d95eca7153"]},"value":0,"unit":""}},{"id":"a-18-n-37","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".social-wrapper","selectorGuids":["0c432295-3603-e55d-0ac6-5958f457499e"]},"yValue":100,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-18-n-38","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".social-wrapper","selectorGuids":["0c432295-3603-e55d-0ac6-5958f457499e"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-18-n-31","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".links-footer","selectorGuids":["7640687b-6577-75b8-f491-6e12cb531d33"]},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-18-n-32","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".links-footer","selectorGuids":["7640687b-6577-75b8-f491-6e12cb531d33"]},"value":1,"unit":""}},{"id":"a-18-n-17","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".logo-footer","selectorGuids":["daf9ce54-abcb-3922-0122-6cdc39fd2b07"]},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-18-n-18","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".logo-footer","selectorGuids":["daf9ce54-abcb-3922-0122-6cdc39fd2b07"]},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-18-n-44","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".social-wrapper","selectorGuids":["0c432295-3603-e55d-0ac6-5958f457499e"]},"value":1,"unit":""}},{"id":"a-18-n-43","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".social-wrapper","selectorGuids":["0c432295-3603-e55d-0ac6-5958f457499e"]},"yValue":0,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-18-n-42","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".text-block-18","selectorGuids":["2dc14cc7-6708-d8ed-e2ed-90d95eca7153"]},"value":1,"unit":""}},{"id":"a-18-n-41","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".text-block-18","selectorGuids":["2dc14cc7-6708-d8ed-e2ed-90d95eca7153"]},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-18-n-40","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".image-20","selectorGuids":["b8fa6617-02e0-2641-158a-66d7e142be8a"]},"value":1,"unit":""}},{"id":"a-18-n-39","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".image-20","selectorGuids":["b8fa6617-02e0-2641-158a-66d7e142be8a"]},"xValue":0,"yValue":0,"xUnit":"px","yUnit":"px","zUnit":"PX"}},{"id":"a-18-n-23","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","id":"afc5aff8-6b21-1019-f898-3d21a53ff0ef"},"value":1,"unit":""}},{"id":"a-18-n-45","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","id":"afc5aff8-6b21-1019-f898-3d21a53ff101"},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-18-n-24","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","id":"afc5aff8-6b21-1019-f898-3d21a53ff101"},"value":1,"unit":""}},{"id":"a-18-n-21","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","id":"afc5aff8-6b21-1019-f898-3d21a53ff113"},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-18-n-25","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","id":"afc5aff8-6b21-1019-f898-3d21a53ff113"},"value":1,"unit":""}},{"id":"a-18-n-22","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","id":"afc5aff8-6b21-1019-f898-3d21a53ff11f"},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-18-n-26","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","id":"afc5aff8-6b21-1019-f898-3d21a53ff11f"},"value":1,"unit":""}},{"id":"a-18-n-19","actionTypeId":"TRANSFORM_MOVE","config":{"delay":100,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","id":"afc5aff8-6b21-1019-f898-3d21a53ff0ef"},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-18-n-27","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".payment-cards-wrapper","selectorGuids":["ec4c0c7e-8ccb-423d-d25b-a6eb54584934"]},"yValue":0,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-18-n-28","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"inOutQuad","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".payment-cards-wrapper","selectorGuids":["ec4c0c7e-8ccb-423d-d25b-a6eb54584934"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1692356619717},"a-19":{"id":"a-19","title":"Testimonials","actionItemGroups":[{"actionItems":[{"id":"a-19-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".div-block-5","selectorGuids":["87af2cb1-73c0-4774-ff90-8f65c8f3c2fa"]},"value":0,"unit":""}},{"id":"a-19-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".testimonial-eclipse-2","selectorGuids":["2327db5f-3ae5-1db2-3d5f-d2783ec2896e"]},"value":0,"unit":""}},{"id":"a-19-n-5","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".eclipse-2","selectorGuids":["eb3b2541-ff3f-b63a-121e-f267e870c83b"]},"value":0,"unit":""}},{"id":"a-19-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".testimonial-eclipse-3","selectorGuids":["6747733e-9a5e-16b0-9419-41f30157cbbc"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-19-n-7","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"selector":".div-block-5","selectorGuids":["87af2cb1-73c0-4774-ff90-8f65c8f3c2fa"]},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-19-n-10","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":1000,"target":{"useEventTarget":"CHILDREN","selector":".testimonial-eclipse-3","selectorGuids":["6747733e-9a5e-16b0-9419-41f30157cbbc"]},"value":0.8,"unit":""}},{"id":"a-19-n-8","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":1000,"target":{"useEventTarget":"CHILDREN","selector":".testimonial-eclipse-2","selectorGuids":["2327db5f-3ae5-1db2-3d5f-d2783ec2896e"]},"value":0.5,"unit":""}},{"id":"a-19-n-9","actionTypeId":"STYLE_OPACITY","config":{"delay":400,"easing":"easeIn","duration":1000,"target":{"useEventTarget":"CHILDREN","selector":".eclipse-2","selectorGuids":["eb3b2541-ff3f-b63a-121e-f267e870c83b"]},"value":0.5,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1692361033765},"a-21":{"id":"a-21","title":"Contact Us - Page Load","actionItemGroups":[{"actionItems":[{"id":"a-21-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".navbar","selectorGuids":["02fb2bbe-4108-1bf9-41db-d81cd7f5e02e"]},"yValue":-100,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-21-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".navbar","selectorGuids":["02fb2bbe-4108-1bf9-41db-d81cd7f5e02e"]},"value":0,"unit":""}},{"id":"a-21-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64cf741eed7270f23d514a3e|92b81fdc-0d22-e479-d5f4-a11daa82de8f"},"xValue":-300,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-21-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64cf741eed7270f23d514a3e|92b81fdc-0d22-e479-d5f4-a11daa82de8f"},"value":0,"unit":""}},{"id":"a-21-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64cf741eed7270f23d514a3e|6054ab1d-c183-3c96-662c-995a382765b3"},"xValue":-350,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-21-n-8","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64cf741eed7270f23d514a3e|6054ab1d-c183-3c96-662c-995a382765b3"},"value":0,"unit":""}},{"id":"a-21-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64cf741eed7270f23d514a3e|3017173d-27af-226f-6231-9def0781cecd"},"xValue":700,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-21-n-9","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64cf741eed7270f23d514a3e|3017173d-27af-226f-6231-9def0781cecd"},"value":0,"unit":""}},{"id":"a-21-n-18","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64cf741eed7270f23d514a3e|cdd2fa53-41c2-b0b6-1839-91ec8bc0da2f"},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-21-n-10","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"selector":".navbar","selectorGuids":["02fb2bbe-4108-1bf9-41db-d81cd7f5e02e"]},"yValue":0,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-21-n-11","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"selector":".navbar","selectorGuids":["02fb2bbe-4108-1bf9-41db-d81cd7f5e02e"]},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-21-n-13","actionTypeId":"STYLE_OPACITY","config":{"delay":100,"easing":"easeIn","duration":500,"target":{"id":"64cf741eed7270f23d514a3e|92b81fdc-0d22-e479-d5f4-a11daa82de8f"},"value":1,"unit":""}},{"id":"a-21-n-12","actionTypeId":"TRANSFORM_MOVE","config":{"delay":100,"easing":"easeIn","duration":500,"target":{"id":"64cf741eed7270f23d514a3e|92b81fdc-0d22-e479-d5f4-a11daa82de8f"},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-21-n-16","actionTypeId":"TRANSFORM_MOVE","config":{"delay":200,"easing":"easeIn","duration":500,"target":{"id":"64cf741eed7270f23d514a3e|3017173d-27af-226f-6231-9def0781cecd"},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-21-n-17","actionTypeId":"STYLE_OPACITY","config":{"delay":200,"easing":"easeIn","duration":500,"target":{"id":"64cf741eed7270f23d514a3e|3017173d-27af-226f-6231-9def0781cecd"},"value":1,"unit":""}},{"id":"a-21-n-15","actionTypeId":"STYLE_OPACITY","config":{"delay":200,"easing":"easeIn","duration":500,"target":{"id":"64cf741eed7270f23d514a3e|6054ab1d-c183-3c96-662c-995a382765b3"},"value":1,"unit":""}},{"id":"a-21-n-14","actionTypeId":"TRANSFORM_MOVE","config":{"delay":200,"easing":"easeIn","duration":500,"target":{"id":"64cf741eed7270f23d514a3e|6054ab1d-c183-3c96-662c-995a382765b3"},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-21-n-19","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"id":"64cf741eed7270f23d514a3e|cdd2fa53-41c2-b0b6-1839-91ec8bc0da2f"},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1692487113212},"a-22":{"id":"a-22","title":"Categories - Page Load","actionItemGroups":[{"actionItems":[{"id":"a-22-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"ae23af77-382e-c77c-020f-b332c9a873ef"},"yValue":-100,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-22-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"ae23af77-382e-c77c-020f-b332c9a873ef"},"value":0,"unit":""}},{"id":"a-22-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64db860de15445b6611e99f6|b8c9621c-19f9-cd4e-985a-762d1d0cf8f2"},"xValue":-300,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-22-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64db860de15445b6611e99f6|b8c9621c-19f9-cd4e-985a-762d1d0cf8f2"},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-22-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"id":"ae23af77-382e-c77c-020f-b332c9a873ef"},"yValue":0,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-22-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"id":"ae23af77-382e-c77c-020f-b332c9a873ef"},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-22-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"id":"64db860de15445b6611e99f6|b8c9621c-19f9-cd4e-985a-762d1d0cf8f2"},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-22-n-8","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"id":"64db860de15445b6611e99f6|b8c9621c-19f9-cd4e-985a-762d1d0cf8f2"},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1692487758590},"a-23":{"id":"a-23","title":"Categroies - Card","actionItemGroups":[{"actionItems":[{"id":"a-23-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"64db860de15445b6611e99f6|a9bacd4c-8cf9-0e39-6cbe-795fb28172db"},"value":0,"unit":""}},{"id":"a-23-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".heading-29","selectorGuids":["533e04c9-ba1b-78df-fa34-bd1c4ca98b68"]},"xValue":-300,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-23-n-8","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".heading-29","selectorGuids":["533e04c9-ba1b-78df-fa34-bd1c4ca98b68"]},"value":0,"unit":""}},{"id":"a-23-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".button-5","selectorGuids":["df6b56c8-de30-f14a-3702-8e832f1517db"]},"xValue":-300,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-23-n-7","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".button-5","selectorGuids":["df6b56c8-de30-f14a-3702-8e832f1517db"]},"value":0,"unit":""}},{"id":"a-23-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".text-block-39","selectorGuids":["6d64a211-8fab-49a5-b031-61120b5d133c"]},"xValue":-300,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-23-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".text-block-39","selectorGuids":["6d64a211-8fab-49a5-b031-61120b5d133c"]},"value":0,"unit":""}},{"id":"a-23-n-15","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".image-47","selectorGuids":["e72d6ee4-4520-32d0-39a0-0232cea2a9ce"]},"xValue":350,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-23-n-16","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".image-47","selectorGuids":["e72d6ee4-4520-32d0-39a0-0232cea2a9ce"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-23-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":700,"target":{"useEventTarget":true,"id":"64db860de15445b6611e99f6|a9bacd4c-8cf9-0e39-6cbe-795fb28172db"},"value":1,"unit":""}},{"id":"a-23-n-9","actionTypeId":"TRANSFORM_MOVE","config":{"delay":300,"easing":"easeIn","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".heading-29","selectorGuids":["533e04c9-ba1b-78df-fa34-bd1c4ca98b68"]},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-23-n-14","actionTypeId":"STYLE_OPACITY","config":{"delay":300,"easing":"easeIn","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".text-block-39","selectorGuids":["6d64a211-8fab-49a5-b031-61120b5d133c"]},"value":1,"unit":""}},{"id":"a-23-n-13","actionTypeId":"TRANSFORM_MOVE","config":{"delay":300,"easing":"easeIn","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".text-block-39","selectorGuids":["6d64a211-8fab-49a5-b031-61120b5d133c"]},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-23-n-12","actionTypeId":"STYLE_OPACITY","config":{"delay":300,"easing":"easeIn","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".button-5","selectorGuids":["df6b56c8-de30-f14a-3702-8e832f1517db"]},"value":1,"unit":""}},{"id":"a-23-n-11","actionTypeId":"TRANSFORM_MOVE","config":{"delay":300,"easing":"easeIn","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".button-5","selectorGuids":["df6b56c8-de30-f14a-3702-8e832f1517db"]},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-23-n-10","actionTypeId":"STYLE_OPACITY","config":{"delay":300,"easing":"easeIn","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".heading-29","selectorGuids":["533e04c9-ba1b-78df-fa34-bd1c4ca98b68"]},"value":1,"unit":""}},{"id":"a-23-n-18","actionTypeId":"STYLE_OPACITY","config":{"delay":300,"easing":"easeIn","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".image-47","selectorGuids":["e72d6ee4-4520-32d0-39a0-0232cea2a9ce"]},"value":1,"unit":""}},{"id":"a-23-n-17","actionTypeId":"TRANSFORM_MOVE","config":{"delay":300,"easing":"easeIn","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".image-47","selectorGuids":["e72d6ee4-4520-32d0-39a0-0232cea2a9ce"]},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1692487950747},"a-24":{"id":"a-24","title":"Eclipse Fade","actionItemGroups":[{"actionItems":[{"id":"a-24-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"64db860de15445b6611e99f6|d63b27ae-4c03-0759-6b98-b1c52d235eda"},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-24-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":500,"easing":"easeIn","duration":500,"target":{"useEventTarget":true,"id":"64db860de15445b6611e99f6|d63b27ae-4c03-0759-6b98-b1c52d235eda"},"value":0.8,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1692488562137},"a-25":{"id":"a-25","title":"Eclipse Fade 2","actionItemGroups":[{"actionItems":[{"id":"a-25-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".eclipse1-categories","selectorGuids":["77e3c727-7789-d1d7-82cc-7c1cfd505c68"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-25-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":500,"easing":"easeIn","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".eclipse1-categories","selectorGuids":["77e3c727-7789-d1d7-82cc-7c1cfd505c68"]},"value":0.8,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1692488562137},"a-26":{"id":"a-26","title":"Eclipse Fade 3","actionItemGroups":[{"actionItems":[{"id":"a-26-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"64db860de15445b6611e99f6|3c65fbdd-a48f-256b-93e8-806bbc9c315c"},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-26-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":500,"easing":"easeIn","duration":500,"target":{"useEventTarget":true,"id":"64db860de15445b6611e99f6|3c65fbdd-a48f-256b-93e8-806bbc9c315c"},"value":0.8,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1692488562137},"a-27":{"id":"a-27","title":"Eclipse Fade 4","actionItemGroups":[{"actionItems":[{"id":"a-27-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"64db860de15445b6611e99f6|3c65fbdd-a48f-256b-93e8-806bbc9c315c"},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-27-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":500,"easing":"easeIn","duration":500,"target":{"useEventTarget":true,"id":"64db860de15445b6611e99f6|3c65fbdd-a48f-256b-93e8-806bbc9c315c"},"value":0.8,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1692488562137},"a-28":{"id":"a-28","title":"Eclipse Fade 5","actionItemGroups":[{"actionItems":[{"id":"a-28-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"64db860de15445b6611e99f6|3c65fbdd-a48f-256b-93e8-806bbc9c315c"},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-28-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":500,"easing":"easeIn","duration":500,"target":{"useEventTarget":true,"id":"64db860de15445b6611e99f6|3c65fbdd-a48f-256b-93e8-806bbc9c315c"},"value":0.8,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1692488562137},"a-29":{"id":"a-29","title":"FAQs - Page Load","actionItemGroups":[{"actionItems":[{"id":"a-29-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"ae23af77-382e-c77c-020f-b332c9a873ef"},"yValue":-100,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-29-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"ae23af77-382e-c77c-020f-b332c9a873ef"},"value":0,"unit":""}},{"id":"a-29-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|14229b75-7231-b51a-68c7-4bd8d8971c86"},"xValue":-400,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-29-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|14229b75-7231-b51a-68c7-4bd8d8971c86"},"value":0,"unit":""}},{"id":"a-29-n-9","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|3b275992-c38d-b10b-ae00-ee78bac00276"},"xValue":400,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-29-n-10","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|3b275992-c38d-b10b-ae00-ee78bac00276"},"value":0,"unit":""}},{"id":"a-29-n-13","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|38b8d92b-dacc-7867-afde-aef0d135b6d6"},"value":0,"unit":""}},{"id":"a-29-n-15","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|c125be24-66fd-f745-d77a-0799f907e442"},"xValue":-350,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-29-n-21","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|c125be24-66fd-f745-d77a-0799f907e442"},"value":0,"unit":""}},{"id":"a-29-n-17","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|c2ca08db-83e8-6fb7-b099-adb1753f0e4f"},"xValue":350,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-29-n-22","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|c2ca08db-83e8-6fb7-b099-adb1753f0e4f"},"value":0,"unit":""}},{"id":"a-29-n-19","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|493ba121-c47e-577d-4daa-6204aa72b5f2"},"value":0,"unit":""}},{"id":"a-29-n-25","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|c2ca08db-83e8-6fb7-b099-adb1753f0e56"},"value":0,"unit":""}},{"id":"a-29-n-27","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|53ff4e6a-d53d-e70e-ae20-39fafe103e96"},"xValue":-350,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-29-n-28","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|53ff4e6a-d53d-e70e-ae20-39fafe103e96"},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-29-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"id":"ae23af77-382e-c77c-020f-b332c9a873ef"},"yValue":0,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-29-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"id":"ae23af77-382e-c77c-020f-b332c9a873ef"},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-29-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|14229b75-7231-b51a-68c7-4bd8d8971c86"},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-29-n-8","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|14229b75-7231-b51a-68c7-4bd8d8971c86"},"value":1,"unit":""}},{"id":"a-29-n-12","actionTypeId":"STYLE_OPACITY","config":{"delay":200,"easing":"easeIn","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|3b275992-c38d-b10b-ae00-ee78bac00276"},"value":1,"unit":""}},{"id":"a-29-n-11","actionTypeId":"TRANSFORM_MOVE","config":{"delay":200,"easing":"easeIn","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|3b275992-c38d-b10b-ae00-ee78bac00276"},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-29-n-14","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|38b8d92b-dacc-7867-afde-aef0d135b6d6"},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-29-n-16","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|c125be24-66fd-f745-d77a-0799f907e442"},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-29-n-23","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|c125be24-66fd-f745-d77a-0799f907e442"},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-29-n-20","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|493ba121-c47e-577d-4daa-6204aa72b5f2"},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-29-n-18","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|c2ca08db-83e8-6fb7-b099-adb1753f0e4f"},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-29-n-24","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|c2ca08db-83e8-6fb7-b099-adb1753f0e4f"},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-29-n-26","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|c2ca08db-83e8-6fb7-b099-adb1753f0e56"},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-29-n-29","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|53ff4e6a-d53d-e70e-ae20-39fafe103e96"},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-29-n-30","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{"id":"64cf86cf347c14534ee2b4ec|53ff4e6a-d53d-e70e-ae20-39fafe103e96"},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1692489133043},"a-30":{"id":"a-30","title":"FAQs- Questions Card","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"64cf86cf347c14534ee2b4ec|6310a98e-9ab9-e217-0ecb-52b1d79414ee"},"value":0,"unit":""}},{"id":"a-30-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".image-48","selectorGuids":["c97ed54b-0706-10bc-a625-5280f6928788"]},"xValue":-250,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-30-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".image-48","selectorGuids":["c97ed54b-0706-10bc-a625-5280f6928788"]},"value":0,"unit":""}},{"id":"a-30-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".heading-31","selectorGuids":["e9377949-39b5-9ec8-cbe6-53275ba57a67"]},"xValue":300,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-30-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".heading-31","selectorGuids":["e9377949-39b5-9ec8-cbe6-53275ba57a67"]},"value":0,"unit":""}},{"id":"a-30-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".text-block-41","selectorGuids":["7a75568f-f482-a1f5-e1e5-246c08499808"]},"xValue":300,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-30-n-8","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".text-block-41","selectorGuids":["7a75568f-f482-a1f5-e1e5-246c08499808"]},"value":0,"unit":""}},{"id":"a-30-n-9","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".button-6","selectorGuids":["97462d5f-deb9-4cfd-40bc-2b0cf588746e"]},"xValue":300,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-30-n-10","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".button-6","selectorGuids":["97462d5f-deb9-4cfd-40bc-2b0cf588746e"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-30-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":1000,"target":{"useEventTarget":true,"id":"64cf86cf347c14534ee2b4ec|6310a98e-9ab9-e217-0ecb-52b1d79414ee"},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-30-n-11","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".image-48","selectorGuids":["c97ed54b-0706-10bc-a625-5280f6928788"]},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-30-n-18","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".button-6","selectorGuids":["97462d5f-deb9-4cfd-40bc-2b0cf588746e"]},"value":1,"unit":""}},{"id":"a-30-n-17","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".button-6","selectorGuids":["97462d5f-deb9-4cfd-40bc-2b0cf588746e"]},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-30-n-16","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".text-block-41","selectorGuids":["7a75568f-f482-a1f5-e1e5-246c08499808"]},"value":1,"unit":""}},{"id":"a-30-n-15","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".text-block-41","selectorGuids":["7a75568f-f482-a1f5-e1e5-246c08499808"]},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-30-n-14","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".heading-31","selectorGuids":["e9377949-39b5-9ec8-cbe6-53275ba57a67"]},"value":1,"unit":""}},{"id":"a-30-n-13","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".heading-31","selectorGuids":["e9377949-39b5-9ec8-cbe6-53275ba57a67"]},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-30-n-12","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".image-48","selectorGuids":["c97ed54b-0706-10bc-a625-5280f6928788"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1692490925288},"a-47":{"id":"a-47","title":"Categories Interaction 1","actionItemGroups":[{"actionItems":[{"id":"a-47-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64c80ce05979ef41d6b73240|9652eeb3-b1ad-9faa-0d3f-6efb3e8705f0"},"value":0.1,"unit":""}},{"id":"a-47-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64c80ce05979ef41d6b73240|9652eeb3-b1ad-9faa-0d3f-6efb3e8705f0"},"xValue":0,"yValue":-80,"xUnit":"px","yUnit":"px","zUnit":"PX"}},{"id":"a-47-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64c80ce05979ef41d6b73240|0fcc6406-7db2-18f9-90e7-3ec1f9043be7"},"xValue":271,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-47-n-5","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64c80ce05979ef41d6b73240|0fcc6406-7db2-18f9-90e7-3ec1f9043be7"},"value":0.05,"unit":""}},{"id":"a-47-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64c80ce05979ef41d6b73240|d231b5ed-aee2-abcf-03eb-0ce7b22cce06"},"value":0.05,"unit":""}},{"id":"a-47-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64c80ce05979ef41d6b73240|e8d94811-e7f3-dc09-733d-25e6f944d051"},"xValue":-300,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-47-n-8","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64c80ce05979ef41d6b73240|eb1acbc1-20da-46c4-ec20-fdf2c239f5e5"},"value":0.05,"unit":""}},{"id":"a-47-n-9","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64c80ce05979ef41d6b73240|18983125-e9c3-e7d4-c5f8-2ec513b86124"},"xValue":0,"yValue":200,"xUnit":"px","yUnit":"px","zUnit":"PX"}},{"id":"a-47-n-10","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64c80ce05979ef41d6b73240|18983125-e9c3-e7d4-c5f8-2ec513b86124"},"value":0.05,"unit":""}},{"id":"a-47-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeInOut","duration":500,"target":{"id":"64c80ce05979ef41d6b73240|abf78b8d-2786-7939-c4b9-45050b7bd96a"},"value":0,"unit":""}},{"id":"a-47-n-18","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64c80ce05979ef41d6b73240|e8d94811-e7f3-dc09-733d-25e6f944d051"},"value":0,"unit":""}},{"id":"a-47-n-23","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64c80ce05979ef41d6b73240|13b972c6-6ac8-c231-e32a-0b137debc501"},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-47-n-11","actionTypeId":"TRANSFORM_MOVE","config":{"delay":500,"easing":"easeInOut","duration":500,"target":{"id":"64c80ce05979ef41d6b73240|9652eeb3-b1ad-9faa-0d3f-6efb3e8705f0"},"yValue":0,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-47-n-12","actionTypeId":"STYLE_OPACITY","config":{"delay":500,"easing":"easeInOut","duration":500,"target":{"id":"64c80ce05979ef41d6b73240|9652eeb3-b1ad-9faa-0d3f-6efb3e8705f0"},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-47-n-13","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeInOut","duration":500,"target":{"id":"64c80ce05979ef41d6b73240|abf78b8d-2786-7939-c4b9-45050b7bd96a"},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-47-n-14","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeInOut","duration":500,"target":{"id":"64c80ce05979ef41d6b73240|0fcc6406-7db2-18f9-90e7-3ec1f9043be7"},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-47-n-15","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeInOut","duration":700,"target":{"id":"64c80ce05979ef41d6b73240|0fcc6406-7db2-18f9-90e7-3ec1f9043be7"},"value":1,"unit":""}},{"id":"a-47-n-17","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeInOut","duration":500,"target":{"id":"64c80ce05979ef41d6b73240|e8d94811-e7f3-dc09-733d-25e6f944d051"},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-47-n-19","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeInOut","duration":700,"target":{"id":"64c80ce05979ef41d6b73240|e8d94811-e7f3-dc09-733d-25e6f944d051"},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-47-n-16","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"id":"64c80ce05979ef41d6b73240|d231b5ed-aee2-abcf-03eb-0ce7b22cce06"},"value":1,"unit":""}},{"id":"a-47-n-20","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"id":"64c80ce05979ef41d6b73240|eb1acbc1-20da-46c4-ec20-fdf2c239f5e5"},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-47-n-21","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64c80ce05979ef41d6b73240|18983125-e9c3-e7d4-c5f8-2ec513b86124"},"yValue":0,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-47-n-22","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeInOut","duration":700,"target":{"id":"64c80ce05979ef41d6b73240|18983125-e9c3-e7d4-c5f8-2ec513b86124"},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-47-n-24","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"id":"64c80ce05979ef41d6b73240|13b972c6-6ac8-c231-e32a-0b137debc501"},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1731181618579},"a-32":{"id":"a-32","title":"Product Page - Page Load","actionItemGroups":[{"actionItems":[{"id":"a-32-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"ae23af77-382e-c77c-020f-b332c9a873ef"},"xValue":0,"yValue":-100,"xUnit":"px","yUnit":"px","zUnit":"PX"}},{"id":"a-32-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"ae23af77-382e-c77c-020f-b332c9a873ef"},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-32-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"id":"ae23af77-382e-c77c-020f-b332c9a873ef"},"xValue":0,"yValue":0,"xUnit":"px","yUnit":"px","zUnit":"PX"}},{"id":"a-32-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"id":"ae23af77-382e-c77c-020f-b332c9a873ef"},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1692549987553},"a-37":{"id":"a-37","title":"Thumbnail 1","actionItemGroups":[{"actionItems":[{"id":"a-37-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".image-38-second-copy","selectorGuids":["6d37a597-63ac-98ca-9b79-484095511369"]},"value":"block"}}]},{"actionItems":[{"id":"a-37-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"outQuart","duration":0,"target":{"selector":".image-38-second","selectorGuids":["5a2f2654-b203-a6fb-4049-04d2ae128af2"]},"value":"none"}}]},{"actionItems":[{"id":"a-37-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"outQuart","duration":0,"target":{"selector":".image-38-third","selectorGuids":["8bbc64f1-6811-cc87-b092-e955fb70cbc8"]},"value":"none"}}]},{"actionItems":[{"id":"a-37-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"outQuart","duration":0,"target":{"selector":".image-38-fourth","selectorGuids":["41a4c381-8774-f36d-2814-e5759bfacb6f"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1692552587665},"a-35":{"id":"a-35","title":"Thumbnail 3","actionItemGroups":[{"actionItems":[{"id":"a-35-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".image-38-third","selectorGuids":["8bbc64f1-6811-cc87-b092-e955fb70cbc8"]},"value":"block"}}]},{"actionItems":[{"id":"a-35-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".image-38-second-copy","selectorGuids":["6d37a597-63ac-98ca-9b79-484095511369"]},"value":"none"}}]},{"actionItems":[{"id":"a-35-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".image-38-second","selectorGuids":["5a2f2654-b203-a6fb-4049-04d2ae128af2"]},"value":"none"}}]},{"actionItems":[{"id":"a-35-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".image-38-fourth","selectorGuids":["41a4c381-8774-f36d-2814-e5759bfacb6f"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1692552587665},"a-38":{"id":"a-38","title":"Related Products - Hover","actionItemGroups":[],"useFirstGroupAsInitialState":false,"createdOn":1692561548738},"a-36":{"id":"a-36","title":"Thumbnail 4","actionItemGroups":[{"actionItems":[{"id":"a-36-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"outQuint","duration":0,"target":{"selector":".image-38-fourth","selectorGuids":["41a4c381-8774-f36d-2814-e5759bfacb6f"]},"value":"block"}}]},{"actionItems":[{"id":"a-36-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"outQuint","duration":0,"target":{"selector":".image-38-third","selectorGuids":["8bbc64f1-6811-cc87-b092-e955fb70cbc8"]},"value":"none"}}]},{"actionItems":[{"id":"a-36-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"outQuint","duration":0,"target":{"selector":".image-38-second","selectorGuids":["5a2f2654-b203-a6fb-4049-04d2ae128af2"]},"value":"none"}}]},{"actionItems":[{"id":"a-36-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"outQuint","duration":0,"target":{"selector":".image-38-second-copy","selectorGuids":["6d37a597-63ac-98ca-9b79-484095511369"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1692552587665},"a-34":{"id":"a-34","title":"Thumbnail 2","actionItemGroups":[{"actionItems":[{"id":"a-34-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".image-38-second","selectorGuids":["5a2f2654-b203-a6fb-4049-04d2ae128af2"]},"value":"block"}}]},{"actionItems":[{"id":"a-34-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".image-38-second-copy","selectorGuids":["6d37a597-63ac-98ca-9b79-484095511369"]},"value":"none"}}]},{"actionItems":[{"id":"a-34-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".image-38-third","selectorGuids":["8bbc64f1-6811-cc87-b092-e955fb70cbc8"]},"value":"none"}}]},{"actionItems":[{"id":"a-34-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".image-38-fourth","selectorGuids":["41a4c381-8774-f36d-2814-e5759bfacb6f"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1692552587665},"a-46":{"id":"a-46","title":"New Timed Animation","actionItemGroups":[{"actionItems":[{"id":"a-46-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeInOut","duration":500,"target":{"useEventTarget":true,"id":"64ce424f90468059ede47e3a|69ea88ae-6516-ba87-37be-70c9c1a97fb7"},"value":0.05,"unit":""}},{"id":"a-46-n-2","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"easeInOut","duration":500,"target":{"useEventTarget":true,"id":"64ce424f90468059ede47e3a|69ea88ae-6516-ba87-37be-70c9c1a97fb7"},"xValue":0.7,"yValue":0.7,"locked":true}},{"id":"a-46-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeInOut","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".heading-17","selectorGuids":["b240d63a-eaae-684f-68f8-3c9f4a1f9de3"]},"value":0.05,"unit":""}},{"id":"a-46-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeInOut","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".heading-17","selectorGuids":["b240d63a-eaae-684f-68f8-3c9f4a1f9de3"]},"xValue":-500,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-46-n-5","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeInOut","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".button-wrapper.about-hero","selectorGuids":["704bb94a-4251-dda2-7937-69a56405206b","c326bad5-4a12-fee6-1776-a13ae157eaf1"]},"value":0.05,"unit":""}},{"id":"a-46-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeInOut","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".button-wrapper.about-hero","selectorGuids":["704bb94a-4251-dda2-7937-69a56405206b","c326bad5-4a12-fee6-1776-a13ae157eaf1"]},"xValue":500,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-46-n-9","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeInOut","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".lower-section","selectorGuids":["55659ec1-a2e1-07bd-7e0b-2b1245e6f7a0"]},"yValue":195,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-46-n-10","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeInOut","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".lower-section","selectorGuids":["55659ec1-a2e1-07bd-7e0b-2b1245e6f7a0"]},"value":0.05,"unit":""}}]},{"actionItems":[{"id":"a-46-n-7","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeInOut","duration":1000,"target":{"useEventTarget":true,"id":"64ce424f90468059ede47e3a|69ea88ae-6516-ba87-37be-70c9c1a97fb7"},"value":1,"unit":""}},{"id":"a-46-n-8","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"easeInOut","duration":500,"target":{"useEventTarget":true,"id":"64ce424f90468059ede47e3a|69ea88ae-6516-ba87-37be-70c9c1a97fb7"},"xValue":1,"yValue":1,"locked":true}},{"id":"a-46-n-13","actionTypeId":"STYLE_OPACITY","config":{"delay":200,"easing":"easeInOut","duration":1000,"target":{"useEventTarget":"CHILDREN","selector":".button-wrapper.about-hero","selectorGuids":["704bb94a-4251-dda2-7937-69a56405206b","c326bad5-4a12-fee6-1776-a13ae157eaf1"]},"value":1,"unit":""}},{"id":"a-46-n-11","actionTypeId":"STYLE_OPACITY","config":{"delay":200,"easing":"easeInOut","duration":1000,"target":{"useEventTarget":"CHILDREN","selector":".heading-17","selectorGuids":["b240d63a-eaae-684f-68f8-3c9f4a1f9de3"]},"value":1,"unit":""}},{"id":"a-46-n-12","actionTypeId":"TRANSFORM_MOVE","config":{"delay":200,"easing":"easeInOut","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".heading-17","selectorGuids":["b240d63a-eaae-684f-68f8-3c9f4a1f9de3"]},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-46-n-14","actionTypeId":"TRANSFORM_MOVE","config":{"delay":400,"easing":"easeInOut","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".button-wrapper.about-hero","selectorGuids":["704bb94a-4251-dda2-7937-69a56405206b","c326bad5-4a12-fee6-1776-a13ae157eaf1"]},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}},{"id":"a-46-n-15","actionTypeId":"TRANSFORM_MOVE","config":{"delay":600,"easing":"easeInOut","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".lower-section","selectorGuids":["55659ec1-a2e1-07bd-7e0b-2b1245e6f7a0"]},"xValue":0,"yValue":0,"xUnit":"px","yUnit":"px","zUnit":"PX"}},{"id":"a-46-n-16","actionTypeId":"STYLE_OPACITY","config":{"delay":600,"easing":"easeInOut","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".lower-section","selectorGuids":["55659ec1-a2e1-07bd-7e0b-2b1245e6f7a0"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1731172898613},"a-52":{"id":"a-52","title":"Banner 12 marquee [Loop] [Desktop] 3","actionItemGroups":[{"actionItems":[{"id":"a-52-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":25000,"target":{"selector":".banner12_marquee-3","selectorGuids":["1c802fc2-53ef-fd93-8d4d-eb6ad0624bd0"]},"xValue":100,"xUnit":"%","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-52-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".banner12_marquee-3","selectorGuids":["1c802fc2-53ef-fd93-8d4d-eb6ad0624bd0"]},"xValue":0,"xUnit":"%","yUnit":"PX","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1651457286764},"a-53":{"id":"a-53","title":"Banner 12 marquee [Loop] [Mobile] 3","actionItemGroups":[{"actionItems":[{"id":"a-53-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":10000,"target":{"useEventTarget":"CHILDREN","selector":".banner12_marquee-3","selectorGuids":["1c802fc2-53ef-fd93-8d4d-eb6ad0624bd0"]},"xValue":100,"xUnit":"%","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-53-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".banner12_marquee-3","selectorGuids":["1c802fc2-53ef-fd93-8d4d-eb6ad0624bd0"]},"xValue":0,"xUnit":"%","yUnit":"PX","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1651457286764},"slideInBottom":{"id":"slideInBottom","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":100,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}},{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]},"slideInRight":{"id":"slideInRight","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":100,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}},{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]}]},"slideInLeft":{"id":"slideInLeft","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":-100,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}},{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]}]},"fadeIn":{"id":"fadeIn","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]},"growIn":{"id":"growIn","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0.7500000000000001,"yValue":0.7500000000000001}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":1,"yValue":1}},{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]},"growBigIn":{"id":"growBigIn","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":1,"yValue":1}},{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]},"slideInTop":{"id":"slideInTop","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":-100,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}},{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]}]}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}
);


}),
2292: (function () {
"use strict";
/* (ignored) */

}),
77825: (function (__unused_webpack_module, exports) {
"use strict";

/**
 * @module LRUCache
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LRUCache = void 0;
const perf = typeof performance === 'object' &&
    performance &&
    typeof performance.now === 'function'
    ? performance
    : Date;
const warned = new Set();
/* c8 ignore start */
const PROCESS = (typeof process === 'object' && !!process ? process : {});
/* c8 ignore start */
const emitWarning = (msg, type, code, fn) => {
    typeof PROCESS.emitWarning === 'function'
        ? PROCESS.emitWarning(msg, type, code, fn)
        : console.error(`[${code}] ${type}: ${msg}`);
};
let AC = globalThis.AbortController;
let AS = globalThis.AbortSignal;
/* c8 ignore start */
if (typeof AC === 'undefined') {
    //@ts-ignore
    AS = class AbortSignal {
        onabort;
        _onabort = [];
        reason;
        aborted = false;
        addEventListener(_, fn) {
            this._onabort.push(fn);
        }
    };
    //@ts-ignore
    AC = class AbortController {
        constructor() {
            warnACPolyfill();
        }
        signal = new AS();
        abort(reason) {
            if (this.signal.aborted)
                return;
            //@ts-ignore
            this.signal.reason = reason;
            //@ts-ignore
            this.signal.aborted = true;
            //@ts-ignore
            for (const fn of this.signal._onabort) {
                fn(reason);
            }
            this.signal.onabort?.(reason);
        }
    };
    let printACPolyfillWarning = PROCESS.env?.LRU_CACHE_IGNORE_AC_WARNING !== '1';
    const warnACPolyfill = () => {
        if (!printACPolyfillWarning)
            return;
        printACPolyfillWarning = false;
        emitWarning('AbortController is not defined. If using lru-cache in ' +
            'node 14, load an AbortController polyfill from the ' +
            '`node-abort-controller` package. A minimal polyfill is ' +
            'provided for use by LRUCache.fetch(), but it should not be ' +
            'relied upon in other contexts (eg, passing it to other APIs that ' +
            'use AbortController/AbortSignal might have undesirable effects). ' +
            'You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.', 'NO_ABORT_CONTROLLER', 'ENOTSUP', warnACPolyfill);
    };
}
/* c8 ignore stop */
const shouldWarn = (code) => !warned.has(code);
const TYPE = Symbol('type');
const isPosInt = (n) => n && n === Math.floor(n) && n > 0 && isFinite(n);
/* c8 ignore start */
// This is a little bit ridiculous, tbh.
// The maximum array length is 2^32-1 or thereabouts on most JS impls.
// And well before that point, you're caching the entire world, I mean,
// that's ~32GB of just integers for the next/prev links, plus whatever
// else to hold that many keys and values.  Just filling the memory with
// zeroes at init time is brutal when you get that big.
// But why not be complete?
// Maybe in the future, these limits will have expanded.
const getUintArray = (max) => !isPosInt(max)
    ? null
    : max <= Math.pow(2, 8)
        ? Uint8Array
        : max <= Math.pow(2, 16)
            ? Uint16Array
            : max <= Math.pow(2, 32)
                ? Uint32Array
                : max <= Number.MAX_SAFE_INTEGER
                    ? ZeroArray
                    : null;
/* c8 ignore stop */
class ZeroArray extends Array {
    constructor(size) {
        super(size);
        this.fill(0);
    }
}
class Stack {
    heap;
    length;
    // private constructor
    static #constructing = false;
    static create(max) {
        const HeapCls = getUintArray(max);
        if (!HeapCls)
            return [];
        Stack.#constructing = true;
        const s = new Stack(max, HeapCls);
        Stack.#constructing = false;
        return s;
    }
    constructor(max, HeapCls) {
        /* c8 ignore start */
        if (!Stack.#constructing) {
            throw new TypeError('instantiate Stack using Stack.create(n)');
        }
        /* c8 ignore stop */
        this.heap = new HeapCls(max);
        this.length = 0;
    }
    push(n) {
        this.heap[this.length++] = n;
    }
    pop() {
        return this.heap[--this.length];
    }
}
/**
 * Default export, the thing you're using this module to get.
 *
 * All properties from the options object (with the exception of
 * {@link OptionsBase.max} and {@link OptionsBase.maxSize}) are added as
 * normal public members. (`max` and `maxBase` are read-only getters.)
 * Changing any of these will alter the defaults for subsequent method calls,
 * but is otherwise safe.
 */
class LRUCache {
    // properties coming in from the options of these, only max and maxSize
    // really *need* to be protected. The rest can be modified, as they just
    // set defaults for various methods.
    #max;
    #maxSize;
    #dispose;
    #disposeAfter;
    #fetchMethod;
    /**
     * {@link LRUCache.OptionsBase.ttl}
     */
    ttl;
    /**
     * {@link LRUCache.OptionsBase.ttlResolution}
     */
    ttlResolution;
    /**
     * {@link LRUCache.OptionsBase.ttlAutopurge}
     */
    ttlAutopurge;
    /**
     * {@link LRUCache.OptionsBase.updateAgeOnGet}
     */
    updateAgeOnGet;
    /**
     * {@link LRUCache.OptionsBase.updateAgeOnHas}
     */
    updateAgeOnHas;
    /**
     * {@link LRUCache.OptionsBase.allowStale}
     */
    allowStale;
    /**
     * {@link LRUCache.OptionsBase.noDisposeOnSet}
     */
    noDisposeOnSet;
    /**
     * {@link LRUCache.OptionsBase.noUpdateTTL}
     */
    noUpdateTTL;
    /**
     * {@link LRUCache.OptionsBase.maxEntrySize}
     */
    maxEntrySize;
    /**
     * {@link LRUCache.OptionsBase.sizeCalculation}
     */
    sizeCalculation;
    /**
     * {@link LRUCache.OptionsBase.noDeleteOnFetchRejection}
     */
    noDeleteOnFetchRejection;
    /**
     * {@link LRUCache.OptionsBase.noDeleteOnStaleGet}
     */
    noDeleteOnStaleGet;
    /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchAbort}
     */
    allowStaleOnFetchAbort;
    /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchRejection}
     */
    allowStaleOnFetchRejection;
    /**
     * {@link LRUCache.OptionsBase.ignoreFetchAbort}
     */
    ignoreFetchAbort;
    // computed properties
    #size;
    #calculatedSize;
    #keyMap;
    #keyList;
    #valList;
    #next;
    #prev;
    #head;
    #tail;
    #free;
    #disposed;
    #sizes;
    #starts;
    #ttls;
    #hasDispose;
    #hasFetchMethod;
    #hasDisposeAfter;
    /**
     * Do not call this method unless you need to inspect the
     * inner workings of the cache.  If anything returned by this
     * object is modified in any way, strange breakage may occur.
     *
     * These fields are private for a reason!
     *
     * @internal
     */
    static unsafeExposeInternals(c) {
        return {
            // properties
            starts: c.#starts,
            ttls: c.#ttls,
            sizes: c.#sizes,
            keyMap: c.#keyMap,
            keyList: c.#keyList,
            valList: c.#valList,
            next: c.#next,
            prev: c.#prev,
            get head() {
                return c.#head;
            },
            get tail() {
                return c.#tail;
            },
            free: c.#free,
            // methods
            isBackgroundFetch: (p) => c.#isBackgroundFetch(p),
            backgroundFetch: (k, index, options, context) => c.#backgroundFetch(k, index, options, context),
            moveToTail: (index) => c.#moveToTail(index),
            indexes: (options) => c.#indexes(options),
            rindexes: (options) => c.#rindexes(options),
            isStale: (index) => c.#isStale(index),
        };
    }
    // Protected read-only members
    /**
     * {@link LRUCache.OptionsBase.max} (read-only)
     */
    get max() {
        return this.#max;
    }
    /**
     * {@link LRUCache.OptionsBase.maxSize} (read-only)
     */
    get maxSize() {
        return this.#maxSize;
    }
    /**
     * The total computed size of items in the cache (read-only)
     */
    get calculatedSize() {
        return this.#calculatedSize;
    }
    /**
     * The number of items stored in the cache (read-only)
     */
    get size() {
        return this.#size;
    }
    /**
     * {@link LRUCache.OptionsBase.fetchMethod} (read-only)
     */
    get fetchMethod() {
        return this.#fetchMethod;
    }
    /**
     * {@link LRUCache.OptionsBase.dispose} (read-only)
     */
    get dispose() {
        return this.#dispose;
    }
    /**
     * {@link LRUCache.OptionsBase.disposeAfter} (read-only)
     */
    get disposeAfter() {
        return this.#disposeAfter;
    }
    constructor(options) {
        const { max = 0, ttl, ttlResolution = 1, ttlAutopurge, updateAgeOnGet, updateAgeOnHas, allowStale, dispose, disposeAfter, noDisposeOnSet, noUpdateTTL, maxSize = 0, maxEntrySize = 0, sizeCalculation, fetchMethod, noDeleteOnFetchRejection, noDeleteOnStaleGet, allowStaleOnFetchRejection, allowStaleOnFetchAbort, ignoreFetchAbort, } = options;
        if (max !== 0 && !isPosInt(max)) {
            throw new TypeError('max option must be a nonnegative integer');
        }
        const UintArray = max ? getUintArray(max) : Array;
        if (!UintArray) {
            throw new Error('invalid max value: ' + max);
        }
        this.#max = max;
        this.#maxSize = maxSize;
        this.maxEntrySize = maxEntrySize || this.#maxSize;
        this.sizeCalculation = sizeCalculation;
        if (this.sizeCalculation) {
            if (!this.#maxSize && !this.maxEntrySize) {
                throw new TypeError('cannot set sizeCalculation without setting maxSize or maxEntrySize');
            }
            if (typeof this.sizeCalculation !== 'function') {
                throw new TypeError('sizeCalculation set to non-function');
            }
        }
        if (fetchMethod !== undefined &&
            typeof fetchMethod !== 'function') {
            throw new TypeError('fetchMethod must be a function if specified');
        }
        this.#fetchMethod = fetchMethod;
        this.#hasFetchMethod = !!fetchMethod;
        this.#keyMap = new Map();
        this.#keyList = new Array(max).fill(undefined);
        this.#valList = new Array(max).fill(undefined);
        this.#next = new UintArray(max);
        this.#prev = new UintArray(max);
        this.#head = 0;
        this.#tail = 0;
        this.#free = Stack.create(max);
        this.#size = 0;
        this.#calculatedSize = 0;
        if (typeof dispose === 'function') {
            this.#dispose = dispose;
        }
        if (typeof disposeAfter === 'function') {
            this.#disposeAfter = disposeAfter;
            this.#disposed = [];
        }
        else {
            this.#disposeAfter = undefined;
            this.#disposed = undefined;
        }
        this.#hasDispose = !!this.#dispose;
        this.#hasDisposeAfter = !!this.#disposeAfter;
        this.noDisposeOnSet = !!noDisposeOnSet;
        this.noUpdateTTL = !!noUpdateTTL;
        this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection;
        this.allowStaleOnFetchRejection = !!allowStaleOnFetchRejection;
        this.allowStaleOnFetchAbort = !!allowStaleOnFetchAbort;
        this.ignoreFetchAbort = !!ignoreFetchAbort;
        // NB: maxEntrySize is set to maxSize if it's set
        if (this.maxEntrySize !== 0) {
            if (this.#maxSize !== 0) {
                if (!isPosInt(this.#maxSize)) {
                    throw new TypeError('maxSize must be a positive integer if specified');
                }
            }
            if (!isPosInt(this.maxEntrySize)) {
                throw new TypeError('maxEntrySize must be a positive integer if specified');
            }
            this.#initializeSizeTracking();
        }
        this.allowStale = !!allowStale;
        this.noDeleteOnStaleGet = !!noDeleteOnStaleGet;
        this.updateAgeOnGet = !!updateAgeOnGet;
        this.updateAgeOnHas = !!updateAgeOnHas;
        this.ttlResolution =
            isPosInt(ttlResolution) || ttlResolution === 0
                ? ttlResolution
                : 1;
        this.ttlAutopurge = !!ttlAutopurge;
        this.ttl = ttl || 0;
        if (this.ttl) {
            if (!isPosInt(this.ttl)) {
                throw new TypeError('ttl must be a positive integer if specified');
            }
            this.#initializeTTLTracking();
        }
        // do not allow completely unbounded caches
        if (this.#max === 0 && this.ttl === 0 && this.#maxSize === 0) {
            throw new TypeError('At least one of max, maxSize, or ttl is required');
        }
        if (!this.ttlAutopurge && !this.#max && !this.#maxSize) {
            const code = 'LRU_CACHE_UNBOUNDED';
            if (shouldWarn(code)) {
                warned.add(code);
                const msg = 'TTL caching without ttlAutopurge, max, or maxSize can ' +
                    'result in unbounded memory consumption.';
                emitWarning(msg, 'UnboundedCacheWarning', code, LRUCache);
            }
        }
    }
    /**
     * Return the remaining TTL time for a given entry key
     */
    getRemainingTTL(key) {
        return this.#keyMap.has(key) ? Infinity : 0;
    }
    #initializeTTLTracking() {
        const ttls = new ZeroArray(this.#max);
        const starts = new ZeroArray(this.#max);
        this.#ttls = ttls;
        this.#starts = starts;
        this.#setItemTTL = (index, ttl, start = perf.now()) => {
            starts[index] = ttl !== 0 ? start : 0;
            ttls[index] = ttl;
            if (ttl !== 0 && this.ttlAutopurge) {
                const t = setTimeout(() => {
                    if (this.#isStale(index)) {
                        this.delete(this.#keyList[index]);
                    }
                }, ttl + 1);
                // unref() not supported on all platforms
                /* c8 ignore start */
                if (t.unref) {
                    t.unref();
                }
                /* c8 ignore stop */
            }
        };
        this.#updateItemAge = index => {
            starts[index] = ttls[index] !== 0 ? perf.now() : 0;
        };
        this.#statusTTL = (status, index) => {
            if (ttls[index]) {
                const ttl = ttls[index];
                const start = starts[index];
                /* c8 ignore next */
                if (!ttl || !start)
                    return;
                status.ttl = ttl;
                status.start = start;
                status.now = cachedNow || getNow();
                const age = status.now - start;
                status.remainingTTL = ttl - age;
            }
        };
        // debounce calls to perf.now() to 1s so we're not hitting
        // that costly call repeatedly.
        let cachedNow = 0;
        const getNow = () => {
            const n = perf.now();
            if (this.ttlResolution > 0) {
                cachedNow = n;
                const t = setTimeout(() => (cachedNow = 0), this.ttlResolution);
                // not available on all platforms
                /* c8 ignore start */
                if (t.unref) {
                    t.unref();
                }
                /* c8 ignore stop */
            }
            return n;
        };
        this.getRemainingTTL = key => {
            const index = this.#keyMap.get(key);
            if (index === undefined) {
                return 0;
            }
            const ttl = ttls[index];
            const start = starts[index];
            if (!ttl || !start) {
                return Infinity;
            }
            const age = (cachedNow || getNow()) - start;
            return ttl - age;
        };
        this.#isStale = index => {
            const s = starts[index];
            const t = ttls[index];
            return !!t && !!s && (cachedNow || getNow()) - s > t;
        };
    }
    // conditionally set private methods related to TTL
    #updateItemAge = () => { };
    #statusTTL = () => { };
    #setItemTTL = () => { };
    /* c8 ignore stop */
    #isStale = () => false;
    #initializeSizeTracking() {
        const sizes = new ZeroArray(this.#max);
        this.#calculatedSize = 0;
        this.#sizes = sizes;
        this.#removeItemSize = index => {
            this.#calculatedSize -= sizes[index];
            sizes[index] = 0;
        };
        this.#requireSize = (k, v, size, sizeCalculation) => {
            // provisionally accept background fetches.
            // actual value size will be checked when they return.
            if (this.#isBackgroundFetch(v)) {
                return 0;
            }
            if (!isPosInt(size)) {
                if (sizeCalculation) {
                    if (typeof sizeCalculation !== 'function') {
                        throw new TypeError('sizeCalculation must be a function');
                    }
                    size = sizeCalculation(v, k);
                    if (!isPosInt(size)) {
                        throw new TypeError('sizeCalculation return invalid (expect positive integer)');
                    }
                }
                else {
                    throw new TypeError('invalid size value (must be positive integer). ' +
                        'When maxSize or maxEntrySize is used, sizeCalculation ' +
                        'or size must be set.');
                }
            }
            return size;
        };
        this.#addItemSize = (index, size, status) => {
            sizes[index] = size;
            if (this.#maxSize) {
                const maxSize = this.#maxSize - sizes[index];
                while (this.#calculatedSize > maxSize) {
                    this.#evict(true);
                }
            }
            this.#calculatedSize += sizes[index];
            if (status) {
                status.entrySize = size;
                status.totalCalculatedSize = this.#calculatedSize;
            }
        };
    }
    #removeItemSize = _i => { };
    #addItemSize = (_i, _s, _st) => { };
    #requireSize = (_k, _v, size, sizeCalculation) => {
        if (size || sizeCalculation) {
            throw new TypeError('cannot set size without setting maxSize or maxEntrySize on cache');
        }
        return 0;
    };
    *#indexes({ allowStale = this.allowStale } = {}) {
        if (this.#size) {
            for (let i = this.#tail; true;) {
                if (!this.#isValidIndex(i)) {
                    break;
                }
                if (allowStale || !this.#isStale(i)) {
                    yield i;
                }
                if (i === this.#head) {
                    break;
                }
                else {
                    i = this.#prev[i];
                }
            }
        }
    }
    *#rindexes({ allowStale = this.allowStale } = {}) {
        if (this.#size) {
            for (let i = this.#head; true;) {
                if (!this.#isValidIndex(i)) {
                    break;
                }
                if (allowStale || !this.#isStale(i)) {
                    yield i;
                }
                if (i === this.#tail) {
                    break;
                }
                else {
                    i = this.#next[i];
                }
            }
        }
    }
    #isValidIndex(index) {
        return (index !== undefined &&
            this.#keyMap.get(this.#keyList[index]) === index);
    }
    /**
     * Return a generator yielding `[key, value]` pairs,
     * in order from most recently used to least recently used.
     */
    *entries() {
        for (const i of this.#indexes()) {
            if (this.#valList[i] !== undefined &&
                this.#keyList[i] !== undefined &&
                !this.#isBackgroundFetch(this.#valList[i])) {
                yield [this.#keyList[i], this.#valList[i]];
            }
        }
    }
    /**
     * Inverse order version of {@link LRUCache.entries}
     *
     * Return a generator yielding `[key, value]` pairs,
     * in order from least recently used to most recently used.
     */
    *rentries() {
        for (const i of this.#rindexes()) {
            if (this.#valList[i] !== undefined &&
                this.#keyList[i] !== undefined &&
                !this.#isBackgroundFetch(this.#valList[i])) {
                yield [this.#keyList[i], this.#valList[i]];
            }
        }
    }
    /**
     * Return a generator yielding the keys in the cache,
     * in order from most recently used to least recently used.
     */
    *keys() {
        for (const i of this.#indexes()) {
            const k = this.#keyList[i];
            if (k !== undefined &&
                !this.#isBackgroundFetch(this.#valList[i])) {
                yield k;
            }
        }
    }
    /**
     * Inverse order version of {@link LRUCache.keys}
     *
     * Return a generator yielding the keys in the cache,
     * in order from least recently used to most recently used.
     */
    *rkeys() {
        for (const i of this.#rindexes()) {
            const k = this.#keyList[i];
            if (k !== undefined &&
                !this.#isBackgroundFetch(this.#valList[i])) {
                yield k;
            }
        }
    }
    /**
     * Return a generator yielding the values in the cache,
     * in order from most recently used to least recently used.
     */
    *values() {
        for (const i of this.#indexes()) {
            const v = this.#valList[i];
            if (v !== undefined &&
                !this.#isBackgroundFetch(this.#valList[i])) {
                yield this.#valList[i];
            }
        }
    }
    /**
     * Inverse order version of {@link LRUCache.values}
     *
     * Return a generator yielding the values in the cache,
     * in order from least recently used to most recently used.
     */
    *rvalues() {
        for (const i of this.#rindexes()) {
            const v = this.#valList[i];
            if (v !== undefined &&
                !this.#isBackgroundFetch(this.#valList[i])) {
                yield this.#valList[i];
            }
        }
    }
    /**
     * Iterating over the cache itself yields the same results as
     * {@link LRUCache.entries}
     */
    [Symbol.iterator]() {
        return this.entries();
    }
    /**
     * A String value that is used in the creation of the default string description of an object.
     * Called by the built-in method Object.prototype.toString.
     */
    [Symbol.toStringTag] = 'LRUCache';
    /**
     * Find a value for which the supplied fn method returns a truthy value,
     * similar to Array.find().  fn is called as fn(value, key, cache).
     */
    find(fn, getOptions = {}) {
        for (const i of this.#indexes()) {
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v)
                ? v.__staleWhileFetching
                : v;
            if (value === undefined)
                continue;
            if (fn(value, this.#keyList[i], this)) {
                return this.get(this.#keyList[i], getOptions);
            }
        }
    }
    /**
     * Call the supplied function on each item in the cache, in order from
     * most recently used to least recently used.  fn is called as
     * fn(value, key, cache).  Does not update age or recenty of use.
     * Does not iterate over stale values.
     */
    forEach(fn, thisp = this) {
        for (const i of this.#indexes()) {
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v)
                ? v.__staleWhileFetching
                : v;
            if (value === undefined)
                continue;
            fn.call(thisp, value, this.#keyList[i], this);
        }
    }
    /**
     * The same as {@link LRUCache.forEach} but items are iterated over in
     * reverse order.  (ie, less recently used items are iterated over first.)
     */
    rforEach(fn, thisp = this) {
        for (const i of this.#rindexes()) {
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v)
                ? v.__staleWhileFetching
                : v;
            if (value === undefined)
                continue;
            fn.call(thisp, value, this.#keyList[i], this);
        }
    }
    /**
     * Delete any stale entries. Returns true if anything was removed,
     * false otherwise.
     */
    purgeStale() {
        let deleted = false;
        for (const i of this.#rindexes({ allowStale: true })) {
            if (this.#isStale(i)) {
                this.delete(this.#keyList[i]);
                deleted = true;
            }
        }
        return deleted;
    }
    /**
     * Get the extended info about a given entry, to get its value, size, and
     * TTL info simultaneously. Like {@link LRUCache#dump}, but just for a
     * single key. Always returns stale values, if their info is found in the
     * cache, so be sure to check for expired TTLs if relevant.
     */
    info(key) {
        const i = this.#keyMap.get(key);
        if (i === undefined)
            return undefined;
        const v = this.#valList[i];
        const value = this.#isBackgroundFetch(v)
            ? v.__staleWhileFetching
            : v;
        if (value === undefined)
            return undefined;
        const entry = { value };
        if (this.#ttls && this.#starts) {
            const ttl = this.#ttls[i];
            const start = this.#starts[i];
            if (ttl && start) {
                const remain = ttl - (perf.now() - start);
                entry.ttl = remain;
                entry.start = Date.now();
            }
        }
        if (this.#sizes) {
            entry.size = this.#sizes[i];
        }
        return entry;
    }
    /**
     * Return an array of [key, {@link LRUCache.Entry}] tuples which can be
     * passed to cache.load()
     */
    dump() {
        const arr = [];
        for (const i of this.#indexes({ allowStale: true })) {
            const key = this.#keyList[i];
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v)
                ? v.__staleWhileFetching
                : v;
            if (value === undefined || key === undefined)
                continue;
            const entry = { value };
            if (this.#ttls && this.#starts) {
                entry.ttl = this.#ttls[i];
                // always dump the start relative to a portable timestamp
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = perf.now() - this.#starts[i];
                entry.start = Math.floor(Date.now() - age);
            }
            if (this.#sizes) {
                entry.size = this.#sizes[i];
            }
            arr.unshift([key, entry]);
        }
        return arr;
    }
    /**
     * Reset the cache and load in the items in entries in the order listed.
     * Note that the shape of the resulting cache may be different if the
     * same options are not used in both caches.
     */
    load(arr) {
        this.clear();
        for (const [key, entry] of arr) {
            if (entry.start) {
                // entry.start is a portable timestamp, but we may be using
                // node's performance.now(), so calculate the offset, so that
                // we get the intended remaining TTL, no matter how long it's
                // been on ice.
                //
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = Date.now() - entry.start;
                entry.start = perf.now() - age;
            }
            this.set(key, entry.value, entry);
        }
    }
    /**
     * Add a value to the cache.
     *
     * Note: if `undefined` is specified as a value, this is an alias for
     * {@link LRUCache#delete}
     */
    set(k, v, setOptions = {}) {
        if (v === undefined) {
            this.delete(k);
            return this;
        }
        const { ttl = this.ttl, start, noDisposeOnSet = this.noDisposeOnSet, sizeCalculation = this.sizeCalculation, status, } = setOptions;
        let { noUpdateTTL = this.noUpdateTTL } = setOptions;
        const size = this.#requireSize(k, v, setOptions.size || 0, sizeCalculation);
        // if the item doesn't fit, don't do anything
        // NB: maxEntrySize set to maxSize by default
        if (this.maxEntrySize && size > this.maxEntrySize) {
            if (status) {
                status.set = 'miss';
                status.maxEntrySizeExceeded = true;
            }
            // have to delete, in case something is there already.
            this.delete(k);
            return this;
        }
        let index = this.#size === 0 ? undefined : this.#keyMap.get(k);
        if (index === undefined) {
            // addition
            index = (this.#size === 0
                ? this.#tail
                : this.#free.length !== 0
                    ? this.#free.pop()
                    : this.#size === this.#max
                        ? this.#evict(false)
                        : this.#size);
            this.#keyList[index] = k;
            this.#valList[index] = v;
            this.#keyMap.set(k, index);
            this.#next[this.#tail] = index;
            this.#prev[index] = this.#tail;
            this.#tail = index;
            this.#size++;
            this.#addItemSize(index, size, status);
            if (status)
                status.set = 'add';
            noUpdateTTL = false;
        }
        else {
            // update
            this.#moveToTail(index);
            const oldVal = this.#valList[index];
            if (v !== oldVal) {
                if (this.#hasFetchMethod && this.#isBackgroundFetch(oldVal)) {
                    oldVal.__abortController.abort(new Error('replaced'));
                    const { __staleWhileFetching: s } = oldVal;
                    if (s !== undefined && !noDisposeOnSet) {
                        if (this.#hasDispose) {
                            this.#dispose?.(s, k, 'set');
                        }
                        if (this.#hasDisposeAfter) {
                            this.#disposed?.push([s, k, 'set']);
                        }
                    }
                }
                else if (!noDisposeOnSet) {
                    if (this.#hasDispose) {
                        this.#dispose?.(oldVal, k, 'set');
                    }
                    if (this.#hasDisposeAfter) {
                        this.#disposed?.push([oldVal, k, 'set']);
                    }
                }
                this.#removeItemSize(index);
                this.#addItemSize(index, size, status);
                this.#valList[index] = v;
                if (status) {
                    status.set = 'replace';
                    const oldValue = oldVal && this.#isBackgroundFetch(oldVal)
                        ? oldVal.__staleWhileFetching
                        : oldVal;
                    if (oldValue !== undefined)
                        status.oldValue = oldValue;
                }
            }
            else if (status) {
                status.set = 'update';
            }
        }
        if (ttl !== 0 && !this.#ttls) {
            this.#initializeTTLTracking();
        }
        if (this.#ttls) {
            if (!noUpdateTTL) {
                this.#setItemTTL(index, ttl, start);
            }
            if (status)
                this.#statusTTL(status, index);
        }
        if (!noDisposeOnSet && this.#hasDisposeAfter && this.#disposed) {
            const dt = this.#disposed;
            let task;
            while ((task = dt?.shift())) {
                this.#disposeAfter?.(...task);
            }
        }
        return this;
    }
    /**
     * Evict the least recently used item, returning its value or
     * `undefined` if cache is empty.
     */
    pop() {
        try {
            while (this.#size) {
                const val = this.#valList[this.#head];
                this.#evict(true);
                if (this.#isBackgroundFetch(val)) {
                    if (val.__staleWhileFetching) {
                        return val.__staleWhileFetching;
                    }
                }
                else if (val !== undefined) {
                    return val;
                }
            }
        }
        finally {
            if (this.#hasDisposeAfter && this.#disposed) {
                const dt = this.#disposed;
                let task;
                while ((task = dt?.shift())) {
                    this.#disposeAfter?.(...task);
                }
            }
        }
    }
    #evict(free) {
        const head = this.#head;
        const k = this.#keyList[head];
        const v = this.#valList[head];
        if (this.#hasFetchMethod && this.#isBackgroundFetch(v)) {
            v.__abortController.abort(new Error('evicted'));
        }
        else if (this.#hasDispose || this.#hasDisposeAfter) {
            if (this.#hasDispose) {
                this.#dispose?.(v, k, 'evict');
            }
            if (this.#hasDisposeAfter) {
                this.#disposed?.push([v, k, 'evict']);
            }
        }
        this.#removeItemSize(head);
        // if we aren't about to use the index, then null these out
        if (free) {
            this.#keyList[head] = undefined;
            this.#valList[head] = undefined;
            this.#free.push(head);
        }
        if (this.#size === 1) {
            this.#head = this.#tail = 0;
            this.#free.length = 0;
        }
        else {
            this.#head = this.#next[head];
        }
        this.#keyMap.delete(k);
        this.#size--;
        return head;
    }
    /**
     * Check if a key is in the cache, without updating the recency of use.
     * Will return false if the item is stale, even though it is technically
     * in the cache.
     *
     * Will not update item age unless
     * {@link LRUCache.OptionsBase.updateAgeOnHas} is set.
     */
    has(k, hasOptions = {}) {
        const { updateAgeOnHas = this.updateAgeOnHas, status } = hasOptions;
        const index = this.#keyMap.get(k);
        if (index !== undefined) {
            const v = this.#valList[index];
            if (this.#isBackgroundFetch(v) &&
                v.__staleWhileFetching === undefined) {
                return false;
            }
            if (!this.#isStale(index)) {
                if (updateAgeOnHas) {
                    this.#updateItemAge(index);
                }
                if (status) {
                    status.has = 'hit';
                    this.#statusTTL(status, index);
                }
                return true;
            }
            else if (status) {
                status.has = 'stale';
                this.#statusTTL(status, index);
            }
        }
        else if (status) {
            status.has = 'miss';
        }
        return false;
    }
    /**
     * Like {@link LRUCache#get} but doesn't update recency or delete stale
     * items.
     *
     * Returns `undefined` if the item is stale, unless
     * {@link LRUCache.OptionsBase.allowStale} is set.
     */
    peek(k, peekOptions = {}) {
        const { allowStale = this.allowStale } = peekOptions;
        const index = this.#keyMap.get(k);
        if (index === undefined ||
            (!allowStale && this.#isStale(index))) {
            return;
        }
        const v = this.#valList[index];
        // either stale and allowed, or forcing a refresh of non-stale value
        return this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
    }
    #backgroundFetch(k, index, options, context) {
        const v = index === undefined ? undefined : this.#valList[index];
        if (this.#isBackgroundFetch(v)) {
            return v;
        }
        const ac = new AC();
        const { signal } = options;
        // when/if our AC signals, then stop listening to theirs.
        signal?.addEventListener('abort', () => ac.abort(signal.reason), {
            signal: ac.signal,
        });
        const fetchOpts = {
            signal: ac.signal,
            options,
            context,
        };
        const cb = (v, updateCache = false) => {
            const { aborted } = ac.signal;
            const ignoreAbort = options.ignoreFetchAbort && v !== undefined;
            if (options.status) {
                if (aborted && !updateCache) {
                    options.status.fetchAborted = true;
                    options.status.fetchError = ac.signal.reason;
                    if (ignoreAbort)
                        options.status.fetchAbortIgnored = true;
                }
                else {
                    options.status.fetchResolved = true;
                }
            }
            if (aborted && !ignoreAbort && !updateCache) {
                return fetchFail(ac.signal.reason);
            }
            // either we didn't abort, and are still here, or we did, and ignored
            const bf = p;
            if (this.#valList[index] === p) {
                if (v === undefined) {
                    if (bf.__staleWhileFetching) {
                        this.#valList[index] = bf.__staleWhileFetching;
                    }
                    else {
                        this.delete(k);
                    }
                }
                else {
                    if (options.status)
                        options.status.fetchUpdated = true;
                    this.set(k, v, fetchOpts.options);
                }
            }
            return v;
        };
        const eb = (er) => {
            if (options.status) {
                options.status.fetchRejected = true;
                options.status.fetchError = er;
            }
            return fetchFail(er);
        };
        const fetchFail = (er) => {
            const { aborted } = ac.signal;
            const allowStaleAborted = aborted && options.allowStaleOnFetchAbort;
            const allowStale = allowStaleAborted || options.allowStaleOnFetchRejection;
            const noDelete = allowStale || options.noDeleteOnFetchRejection;
            const bf = p;
            if (this.#valList[index] === p) {
                // if we allow stale on fetch rejections, then we need to ensure that
                // the stale value is not removed from the cache when the fetch fails.
                const del = !noDelete || bf.__staleWhileFetching === undefined;
                if (del) {
                    this.delete(k);
                }
                else if (!allowStaleAborted) {
                    // still replace the *promise* with the stale value,
                    // since we are done with the promise at this point.
                    // leave it untouched if we're still waiting for an
                    // aborted background fetch that hasn't yet returned.
                    this.#valList[index] = bf.__staleWhileFetching;
                }
            }
            if (allowStale) {
                if (options.status && bf.__staleWhileFetching !== undefined) {
                    options.status.returnedStale = true;
                }
                return bf.__staleWhileFetching;
            }
            else if (bf.__returned === bf) {
                throw er;
            }
        };
        const pcall = (res, rej) => {
            const fmp = this.#fetchMethod?.(k, v, fetchOpts);
            if (fmp && fmp instanceof Promise) {
                fmp.then(v => res(v === undefined ? undefined : v), rej);
            }
            // ignored, we go until we finish, regardless.
            // defer check until we are actually aborting,
            // so fetchMethod can override.
            ac.signal.addEventListener('abort', () => {
                if (!options.ignoreFetchAbort ||
                    options.allowStaleOnFetchAbort) {
                    res(undefined);
                    // when it eventually resolves, update the cache.
                    if (options.allowStaleOnFetchAbort) {
                        res = v => cb(v, true);
                    }
                }
            });
        };
        if (options.status)
            options.status.fetchDispatched = true;
        const p = new Promise(pcall).then(cb, eb);
        const bf = Object.assign(p, {
            __abortController: ac,
            __staleWhileFetching: v,
            __returned: undefined,
        });
        if (index === undefined) {
            // internal, don't expose status.
            this.set(k, bf, { ...fetchOpts.options, status: undefined });
            index = this.#keyMap.get(k);
        }
        else {
            this.#valList[index] = bf;
        }
        return bf;
    }
    #isBackgroundFetch(p) {
        if (!this.#hasFetchMethod)
            return false;
        const b = p;
        return (!!b &&
            b instanceof Promise &&
            b.hasOwnProperty('__staleWhileFetching') &&
            b.__abortController instanceof AC);
    }
    async fetch(k, fetchOptions = {}) {
        const { 
        // get options
        allowStale = this.allowStale, updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet = this.noDeleteOnStaleGet, 
        // set options
        ttl = this.ttl, noDisposeOnSet = this.noDisposeOnSet, size = 0, sizeCalculation = this.sizeCalculation, noUpdateTTL = this.noUpdateTTL, 
        // fetch exclusive options
        noDeleteOnFetchRejection = this.noDeleteOnFetchRejection, allowStaleOnFetchRejection = this.allowStaleOnFetchRejection, ignoreFetchAbort = this.ignoreFetchAbort, allowStaleOnFetchAbort = this.allowStaleOnFetchAbort, context, forceRefresh = false, status, signal, } = fetchOptions;
        if (!this.#hasFetchMethod) {
            if (status)
                status.fetch = 'get';
            return this.get(k, {
                allowStale,
                updateAgeOnGet,
                noDeleteOnStaleGet,
                status,
            });
        }
        const options = {
            allowStale,
            updateAgeOnGet,
            noDeleteOnStaleGet,
            ttl,
            noDisposeOnSet,
            size,
            sizeCalculation,
            noUpdateTTL,
            noDeleteOnFetchRejection,
            allowStaleOnFetchRejection,
            allowStaleOnFetchAbort,
            ignoreFetchAbort,
            status,
            signal,
        };
        let index = this.#keyMap.get(k);
        if (index === undefined) {
            if (status)
                status.fetch = 'miss';
            const p = this.#backgroundFetch(k, index, options, context);
            return (p.__returned = p);
        }
        else {
            // in cache, maybe already fetching
            const v = this.#valList[index];
            if (this.#isBackgroundFetch(v)) {
                const stale = allowStale && v.__staleWhileFetching !== undefined;
                if (status) {
                    status.fetch = 'inflight';
                    if (stale)
                        status.returnedStale = true;
                }
                return stale ? v.__staleWhileFetching : (v.__returned = v);
            }
            // if we force a refresh, that means do NOT serve the cached value,
            // unless we are already in the process of refreshing the cache.
            const isStale = this.#isStale(index);
            if (!forceRefresh && !isStale) {
                if (status)
                    status.fetch = 'hit';
                this.#moveToTail(index);
                if (updateAgeOnGet) {
                    this.#updateItemAge(index);
                }
                if (status)
                    this.#statusTTL(status, index);
                return v;
            }
            // ok, it is stale or a forced refresh, and not already fetching.
            // refresh the cache.
            const p = this.#backgroundFetch(k, index, options, context);
            const hasStale = p.__staleWhileFetching !== undefined;
            const staleVal = hasStale && allowStale;
            if (status) {
                status.fetch = isStale ? 'stale' : 'refresh';
                if (staleVal && isStale)
                    status.returnedStale = true;
            }
            return staleVal ? p.__staleWhileFetching : (p.__returned = p);
        }
    }
    /**
     * Return a value from the cache. Will update the recency of the cache
     * entry found.
     *
     * If the key is not found, get() will return `undefined`.
     */
    get(k, getOptions = {}) {
        const { allowStale = this.allowStale, updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet = this.noDeleteOnStaleGet, status, } = getOptions;
        const index = this.#keyMap.get(k);
        if (index !== undefined) {
            const value = this.#valList[index];
            const fetching = this.#isBackgroundFetch(value);
            if (status)
                this.#statusTTL(status, index);
            if (this.#isStale(index)) {
                if (status)
                    status.get = 'stale';
                // delete only if not an in-flight background fetch
                if (!fetching) {
                    if (!noDeleteOnStaleGet) {
                        this.delete(k);
                    }
                    if (status && allowStale)
                        status.returnedStale = true;
                    return allowStale ? value : undefined;
                }
                else {
                    if (status &&
                        allowStale &&
                        value.__staleWhileFetching !== undefined) {
                        status.returnedStale = true;
                    }
                    return allowStale ? value.__staleWhileFetching : undefined;
                }
            }
            else {
                if (status)
                    status.get = 'hit';
                // if we're currently fetching it, we don't actually have it yet
                // it's not stale, which means this isn't a staleWhileRefetching.
                // If it's not stale, and fetching, AND has a __staleWhileFetching
                // value, then that means the user fetched with {forceRefresh:true},
                // so it's safe to return that value.
                if (fetching) {
                    return value.__staleWhileFetching;
                }
                this.#moveToTail(index);
                if (updateAgeOnGet) {
                    this.#updateItemAge(index);
                }
                return value;
            }
        }
        else if (status) {
            status.get = 'miss';
        }
    }
    #connect(p, n) {
        this.#prev[n] = p;
        this.#next[p] = n;
    }
    #moveToTail(index) {
        // if tail already, nothing to do
        // if head, move head to next[index]
        // else
        //   move next[prev[index]] to next[index] (head has no prev)
        //   move prev[next[index]] to prev[index]
        // prev[index] = tail
        // next[tail] = index
        // tail = index
        if (index !== this.#tail) {
            if (index === this.#head) {
                this.#head = this.#next[index];
            }
            else {
                this.#connect(this.#prev[index], this.#next[index]);
            }
            this.#connect(this.#tail, index);
            this.#tail = index;
        }
    }
    /**
     * Deletes a key out of the cache.
     * Returns true if the key was deleted, false otherwise.
     */
    delete(k) {
        let deleted = false;
        if (this.#size !== 0) {
            const index = this.#keyMap.get(k);
            if (index !== undefined) {
                deleted = true;
                if (this.#size === 1) {
                    this.clear();
                }
                else {
                    this.#removeItemSize(index);
                    const v = this.#valList[index];
                    if (this.#isBackgroundFetch(v)) {
                        v.__abortController.abort(new Error('deleted'));
                    }
                    else if (this.#hasDispose || this.#hasDisposeAfter) {
                        if (this.#hasDispose) {
                            this.#dispose?.(v, k, 'delete');
                        }
                        if (this.#hasDisposeAfter) {
                            this.#disposed?.push([v, k, 'delete']);
                        }
                    }
                    this.#keyMap.delete(k);
                    this.#keyList[index] = undefined;
                    this.#valList[index] = undefined;
                    if (index === this.#tail) {
                        this.#tail = this.#prev[index];
                    }
                    else if (index === this.#head) {
                        this.#head = this.#next[index];
                    }
                    else {
                        const pi = this.#prev[index];
                        this.#next[pi] = this.#next[index];
                        const ni = this.#next[index];
                        this.#prev[ni] = this.#prev[index];
                    }
                    this.#size--;
                    this.#free.push(index);
                }
            }
        }
        if (this.#hasDisposeAfter && this.#disposed?.length) {
            const dt = this.#disposed;
            let task;
            while ((task = dt?.shift())) {
                this.#disposeAfter?.(...task);
            }
        }
        return deleted;
    }
    /**
     * Clear the cache entirely, throwing away all values.
     */
    clear() {
        for (const index of this.#rindexes({ allowStale: true })) {
            const v = this.#valList[index];
            if (this.#isBackgroundFetch(v)) {
                v.__abortController.abort(new Error('deleted'));
            }
            else {
                const k = this.#keyList[index];
                if (this.#hasDispose) {
                    this.#dispose?.(v, k, 'delete');
                }
                if (this.#hasDisposeAfter) {
                    this.#disposed?.push([v, k, 'delete']);
                }
            }
        }
        this.#keyMap.clear();
        this.#valList.fill(undefined);
        this.#keyList.fill(undefined);
        if (this.#ttls && this.#starts) {
            this.#ttls.fill(0);
            this.#starts.fill(0);
        }
        if (this.#sizes) {
            this.#sizes.fill(0);
        }
        this.#head = 0;
        this.#tail = 0;
        this.#free.length = 0;
        this.#calculatedSize = 0;
        this.#size = 0;
        if (this.#hasDisposeAfter && this.#disposed) {
            const dt = this.#disposed;
            let task;
            while ((task = dt?.shift())) {
                this.#disposeAfter?.(...task);
            }
        }
    }
}
exports.LRUCache = LRUCache;
//# sourceMappingURL=index.js.map

}),
14445: (function (module) {
"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  createSelector: () => createSelector,
  createSelectorCreator: () => createSelectorCreator,
  createStructuredSelector: () => createStructuredSelector,
  lruMemoize: () => lruMemoize,
  referenceEqualityCheck: () => referenceEqualityCheck,
  setGlobalDevModeChecks: () => setGlobalDevModeChecks,
  unstable_autotrackMemoize: () => autotrackMemoize,
  weakMapMemoize: () => weakMapMemoize
});
module.exports = __toCommonJS(src_exports);

// src/devModeChecks/identityFunctionCheck.ts
var runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult) => {
  if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
    let isInputSameAsOutput = false;
    try {
      const emptyObject = {};
      if (resultFunc(emptyObject) === emptyObject)
        isInputSameAsOutput = true;
    } catch {
    }
    if (isInputSameAsOutput) {
      let stack = void 0;
      try {
        throw new Error();
      } catch (e) {
        ;
        ({ stack } = e);
      }
      console.warn(
        "The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.",
        { stack }
      );
    }
  }
};

// src/devModeChecks/inputStabilityCheck.ts
var runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs) => {
  const { memoize, memoizeOptions } = options;
  const { inputSelectorResults, inputSelectorResultsCopy } = inputSelectorResultsObject;
  const createAnEmptyObject = memoize(() => ({}), ...memoizeOptions);
  const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
  if (!areInputSelectorResultsEqual) {
    let stack = void 0;
    try {
      throw new Error();
    } catch (e) {
      ;
      ({ stack } = e);
    }
    console.warn(
      "An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`",
      {
        arguments: inputSelectorArgs,
        firstInputs: inputSelectorResults,
        secondInputs: inputSelectorResultsCopy,
        stack
      }
    );
  }
};

// src/devModeChecks/setGlobalDevModeChecks.ts
var globalDevModeChecks = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
};
var setGlobalDevModeChecks = (devModeChecks) => {
  Object.assign(globalDevModeChecks, devModeChecks);
};

// src/utils.ts
var NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
  if (typeof func !== "function") {
    throw new TypeError(errorMessage);
  }
}
function assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
  if (typeof object !== "object") {
    throw new TypeError(errorMessage);
  }
}
function assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
  if (!array.every((item) => typeof item === "function")) {
    const itemTypes = array.map(
      (item) => typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item
    ).join(", ");
    throw new TypeError(`${errorMessage}[${itemTypes}]`);
  }
}
var ensureIsArray = (item) => {
  return Array.isArray(item) ? item : [item];
};
function getDependencies(createSelectorArgs) {
  const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
  assertIsArrayOfFunctions(
    dependencies,
    `createSelector expects all input-selectors to be functions, but received the following types: `
  );
  return dependencies;
}
function collectInputSelectorResults(dependencies, inputSelectorArgs) {
  const inputSelectorResults = [];
  const { length } = dependencies;
  for (let i = 0; i < length; i++) {
    inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
  }
  return inputSelectorResults;
}
var getDevModeChecksExecutionInfo = (firstRun, devModeChecks) => {
  const { identityFunctionCheck, inputStabilityCheck } = {
    ...globalDevModeChecks,
    ...devModeChecks
  };
  return {
    identityFunctionCheck: {
      shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
      run: runIdentityFunctionCheck
    },
    inputStabilityCheck: {
      shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
      run: runInputStabilityCheck
    }
  };
};

// src/autotrackMemoize/autotracking.ts
var $REVISION = 0;
var CURRENT_TRACKER = null;
var Cell = class {
  revision = $REVISION;
  _value;
  _lastValue;
  _isEqual = tripleEq;
  constructor(initialValue, isEqual = tripleEq) {
    this._value = this._lastValue = initialValue;
    this._isEqual = isEqual;
  }
  // Whenever a storage value is read, it'll add itself to the current tracker if
  // one exists, entangling its state with that cache.
  get value() {
    CURRENT_TRACKER?.add(this);
    return this._value;
  }
  // Whenever a storage value is updated, we bump the global revision clock,
  // assign the revision for this storage to the new value, _and_ we schedule a
  // rerender. This is important, and it's what makes autotracking  _pull_
  // based. We don't actively tell the caches which depend on the storage that
  // anything has happened. Instead, we recompute the caches when needed.
  set value(newValue) {
    if (this.value === newValue)
      return;
    this._value = newValue;
    this.revision = ++$REVISION;
  }
};
function tripleEq(a, b) {
  return a === b;
}
var TrackingCache = class {
  _cachedValue;
  _cachedRevision = -1;
  _deps = [];
  hits = 0;
  fn;
  constructor(fn) {
    this.fn = fn;
  }
  clear() {
    this._cachedValue = void 0;
    this._cachedRevision = -1;
    this._deps = [];
    this.hits = 0;
  }
  get value() {
    if (this.revision > this._cachedRevision) {
      const { fn } = this;
      const currentTracker = /* @__PURE__ */ new Set();
      const prevTracker = CURRENT_TRACKER;
      CURRENT_TRACKER = currentTracker;
      this._cachedValue = fn();
      CURRENT_TRACKER = prevTracker;
      this.hits++;
      this._deps = Array.from(currentTracker);
      this._cachedRevision = this.revision;
    }
    CURRENT_TRACKER?.add(this);
    return this._cachedValue;
  }
  get revision() {
    return Math.max(...this._deps.map((d) => d.revision), 0);
  }
};
function getValue(cell) {
  if (!(cell instanceof Cell)) {
    console.warn("Not a valid cell! ", cell);
  }
  return cell.value;
}
function setValue(storage, value) {
  if (!(storage instanceof Cell)) {
    throw new TypeError(
      "setValue must be passed a tracked store created with `createStorage`."
    );
  }
  storage.value = storage._lastValue = value;
}
function createCell(initialValue, isEqual = tripleEq) {
  return new Cell(initialValue, isEqual);
}
function createCache(fn) {
  assertIsFunction(
    fn,
    "the first parameter to `createCache` must be a function"
  );
  return new TrackingCache(fn);
}

// src/autotrackMemoize/tracking.ts
var neverEq = (a, b) => false;
function createTag() {
  return createCell(null, neverEq);
}
function dirtyTag(tag, value) {
  setValue(tag, value);
}
var consumeCollection = (node) => {
  let tag = node.collectionTag;
  if (tag === null) {
    tag = node.collectionTag = createTag();
  }
  getValue(tag);
};
var dirtyCollection = (node) => {
  const tag = node.collectionTag;
  if (tag !== null) {
    dirtyTag(tag, null);
  }
};

// src/autotrackMemoize/proxy.ts
var REDUX_PROXY_LABEL = Symbol();
var nextId = 0;
var proto = Object.getPrototypeOf({});
var ObjectTreeNode = class {
  constructor(value) {
    this.value = value;
    this.value = value;
    this.tag.value = value;
  }
  proxy = new Proxy(this, objectProxyHandler);
  tag = createTag();
  tags = {};
  children = {};
  collectionTag = null;
  id = nextId++;
};
var objectProxyHandler = {
  get(node, key) {
    function calculateResult() {
      const { value } = node;
      const childValue = Reflect.get(value, key);
      if (typeof key === "symbol") {
        return childValue;
      }
      if (key in proto) {
        return childValue;
      }
      if (typeof childValue === "object" && childValue !== null) {
        let childNode = node.children[key];
        if (childNode === void 0) {
          childNode = node.children[key] = createNode(childValue);
        }
        if (childNode.tag) {
          getValue(childNode.tag);
        }
        return childNode.proxy;
      } else {
        let tag = node.tags[key];
        if (tag === void 0) {
          tag = node.tags[key] = createTag();
          tag.value = childValue;
        }
        getValue(tag);
        return childValue;
      }
    }
    const res = calculateResult();
    return res;
  },
  ownKeys(node) {
    consumeCollection(node);
    return Reflect.ownKeys(node.value);
  },
  getOwnPropertyDescriptor(node, prop) {
    return Reflect.getOwnPropertyDescriptor(node.value, prop);
  },
  has(node, prop) {
    return Reflect.has(node.value, prop);
  }
};
var ArrayTreeNode = class {
  constructor(value) {
    this.value = value;
    this.value = value;
    this.tag.value = value;
  }
  proxy = new Proxy([this], arrayProxyHandler);
  tag = createTag();
  tags = {};
  children = {};
  collectionTag = null;
  id = nextId++;
};
var arrayProxyHandler = {
  get([node], key) {
    if (key === "length") {
      consumeCollection(node);
    }
    return objectProxyHandler.get(node, key);
  },
  ownKeys([node]) {
    return objectProxyHandler.ownKeys(node);
  },
  getOwnPropertyDescriptor([node], prop) {
    return objectProxyHandler.getOwnPropertyDescriptor(node, prop);
  },
  has([node], prop) {
    return objectProxyHandler.has(node, prop);
  }
};
function createNode(value) {
  if (Array.isArray(value)) {
    return new ArrayTreeNode(value);
  }
  return new ObjectTreeNode(value);
}
function updateNode(node, newValue) {
  const { value, tags, children } = node;
  node.value = newValue;
  if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) {
    dirtyCollection(node);
  } else {
    if (value !== newValue) {
      let oldKeysSize = 0;
      let newKeysSize = 0;
      let anyKeysAdded = false;
      for (const _key in value) {
        oldKeysSize++;
      }
      for (const key in newValue) {
        newKeysSize++;
        if (!(key in value)) {
          anyKeysAdded = true;
          break;
        }
      }
      const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
      if (isDifferent) {
        dirtyCollection(node);
      }
    }
  }
  for (const key in tags) {
    const childValue = value[key];
    const newChildValue = newValue[key];
    if (childValue !== newChildValue) {
      dirtyCollection(node);
      dirtyTag(tags[key], newChildValue);
    }
    if (typeof newChildValue === "object" && newChildValue !== null) {
      delete tags[key];
    }
  }
  for (const key in children) {
    const childNode = children[key];
    const newChildValue = newValue[key];
    const childValue = childNode.value;
    if (childValue === newChildValue) {
      continue;
    } else if (typeof newChildValue === "object" && newChildValue !== null) {
      updateNode(childNode, newChildValue);
    } else {
      deleteNode(childNode);
      delete children[key];
    }
  }
}
function deleteNode(node) {
  if (node.tag) {
    dirtyTag(node.tag, null);
  }
  dirtyCollection(node);
  for (const key in node.tags) {
    dirtyTag(node.tags[key], null);
  }
  for (const key in node.children) {
    deleteNode(node.children[key]);
  }
}

// src/lruMemoize.ts
function createSingletonCache(equals) {
  let entry;
  return {
    get(key) {
      if (entry && equals(entry.key, key)) {
        return entry.value;
      }
      return NOT_FOUND;
    },
    put(key, value) {
      entry = { key, value };
    },
    getEntries() {
      return entry ? [entry] : [];
    },
    clear() {
      entry = void 0;
    }
  };
}
function createLruCache(maxSize, equals) {
  let entries = [];
  function get(key) {
    const cacheIndex = entries.findIndex((entry) => equals(key, entry.key));
    if (cacheIndex > -1) {
      const entry = entries[cacheIndex];
      if (cacheIndex > 0) {
        entries.splice(cacheIndex, 1);
        entries.unshift(entry);
      }
      return entry.value;
    }
    return NOT_FOUND;
  }
  function put(key, value) {
    if (get(key) === NOT_FOUND) {
      entries.unshift({ key, value });
      if (entries.length > maxSize) {
        entries.pop();
      }
    }
  }
  function getEntries() {
    return entries;
  }
  function clear() {
    entries = [];
  }
  return { get, put, getEntries, clear };
}
var referenceEqualityCheck = (a, b) => a === b;
function createCacheKeyComparator(equalityCheck) {
  return function areArgumentsShallowlyEqual(prev, next) {
    if (prev === null || next === null || prev.length !== next.length) {
      return false;
    }
    const { length } = prev;
    for (let i = 0; i < length; i++) {
      if (!equalityCheck(prev[i], next[i])) {
        return false;
      }
    }
    return true;
  };
}
function lruMemoize(func, equalityCheckOrOptions) {
  const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : { equalityCheck: equalityCheckOrOptions };
  const {
    equalityCheck = referenceEqualityCheck,
    maxSize = 1,
    resultEqualityCheck
  } = providedOptions;
  const comparator = createCacheKeyComparator(equalityCheck);
  let resultsCount = 0;
  const cache = maxSize <= 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator);
  function memoized() {
    let value = cache.get(arguments);
    if (value === NOT_FOUND) {
      value = func.apply(null, arguments);
      resultsCount++;
      if (resultEqualityCheck) {
        const entries = cache.getEntries();
        const matchingEntry = entries.find(
          (entry) => resultEqualityCheck(entry.value, value)
        );
        if (matchingEntry) {
          value = matchingEntry.value;
          resultsCount !== 0 && resultsCount--;
        }
      }
      cache.put(arguments, value);
    }
    return value;
  }
  memoized.clearCache = () => {
    cache.clear();
    memoized.resetResultsCount();
  };
  memoized.resultsCount = () => resultsCount;
  memoized.resetResultsCount = () => {
    resultsCount = 0;
  };
  return memoized;
}

// src/autotrackMemoize/autotrackMemoize.ts
function autotrackMemoize(func) {
  const node = createNode(
    []
  );
  let lastArgs = null;
  const shallowEqual = createCacheKeyComparator(referenceEqualityCheck);
  const cache = createCache(() => {
    const res = func.apply(null, node.proxy);
    return res;
  });
  function memoized() {
    if (!shallowEqual(lastArgs, arguments)) {
      updateNode(node, arguments);
      lastArgs = arguments;
    }
    return cache.value;
  }
  memoized.clearCache = () => {
    return cache.clear();
  };
  return memoized;
}

// src/weakMapMemoize.ts
var StrongRef = class {
  constructor(value) {
    this.value = value;
  }
  deref() {
    return this.value;
  }
};
var Ref = typeof WeakRef !== "undefined" ? WeakRef : StrongRef;
var UNTERMINATED = 0;
var TERMINATED = 1;
function createCacheNode() {
  return {
    s: UNTERMINATED,
    v: void 0,
    o: null,
    p: null
  };
}
function weakMapMemoize(func, options = {}) {
  let fnNode = createCacheNode();
  const { resultEqualityCheck } = options;
  let lastResult;
  let resultsCount = 0;
  function memoized() {
    let cacheNode = fnNode;
    const { length } = arguments;
    for (let i = 0, l = length; i < l; i++) {
      const arg = arguments[i];
      if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
        let objectCache = cacheNode.o;
        if (objectCache === null) {
          cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
        }
        const objectNode = objectCache.get(arg);
        if (objectNode === void 0) {
          cacheNode = createCacheNode();
          objectCache.set(arg, cacheNode);
        } else {
          cacheNode = objectNode;
        }
      } else {
        let primitiveCache = cacheNode.p;
        if (primitiveCache === null) {
          cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
        }
        const primitiveNode = primitiveCache.get(arg);
        if (primitiveNode === void 0) {
          cacheNode = createCacheNode();
          primitiveCache.set(arg, cacheNode);
        } else {
          cacheNode = primitiveNode;
        }
      }
    }
    const terminatedNode = cacheNode;
    let result;
    if (cacheNode.s === TERMINATED) {
      result = cacheNode.v;
    } else {
      result = func.apply(null, arguments);
      resultsCount++;
      if (resultEqualityCheck) {
        const lastResultValue = lastResult?.deref?.() ?? lastResult;
        if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
          result = lastResultValue;
          resultsCount !== 0 && resultsCount--;
        }
        const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
        lastResult = needsWeakRef ? new Ref(result) : result;
      }
    }
    terminatedNode.s = TERMINATED;
    terminatedNode.v = result;
    return result;
  }
  memoized.clearCache = () => {
    fnNode = createCacheNode();
    memoized.resetResultsCount();
  };
  memoized.resultsCount = () => resultsCount;
  memoized.resetResultsCount = () => {
    resultsCount = 0;
  };
  return memoized;
}

// src/createSelectorCreator.ts
function createSelectorCreator(memoizeOrOptions, ...memoizeOptionsFromArgs) {
  const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
    memoize: memoizeOrOptions,
    memoizeOptions: memoizeOptionsFromArgs
  } : memoizeOrOptions;
  const createSelector2 = (...createSelectorArgs) => {
    let recomputations = 0;
    let dependencyRecomputations = 0;
    let lastResult;
    let directlyPassedOptions = {};
    let resultFunc = createSelectorArgs.pop();
    if (typeof resultFunc === "object") {
      directlyPassedOptions = resultFunc;
      resultFunc = createSelectorArgs.pop();
    }
    assertIsFunction(
      resultFunc,
      `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`
    );
    const combinedOptions = {
      ...createSelectorCreatorOptions,
      ...directlyPassedOptions
    };
    const {
      memoize,
      memoizeOptions = [],
      argsMemoize = weakMapMemoize,
      argsMemoizeOptions = [],
      devModeChecks = {}
    } = combinedOptions;
    const finalMemoizeOptions = ensureIsArray(memoizeOptions);
    const finalArgsMemoizeOptions = ensureIsArray(argsMemoizeOptions);
    const dependencies = getDependencies(createSelectorArgs);
    const memoizedResultFunc = memoize(function recomputationWrapper() {
      recomputations++;
      return resultFunc.apply(
        null,
        arguments
      );
    }, ...finalMemoizeOptions);
    let firstRun = true;
    const selector = argsMemoize(function dependenciesChecker() {
      dependencyRecomputations++;
      const inputSelectorResults = collectInputSelectorResults(
        dependencies,
        arguments
      );
      lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
      if (false) {}
      return lastResult;
    }, ...finalArgsMemoizeOptions);
    return Object.assign(selector, {
      resultFunc,
      memoizedResultFunc,
      dependencies,
      dependencyRecomputations: () => dependencyRecomputations,
      resetDependencyRecomputations: () => {
        dependencyRecomputations = 0;
      },
      lastResult: () => lastResult,
      recomputations: () => recomputations,
      resetRecomputations: () => {
        recomputations = 0;
      },
      memoize,
      argsMemoize
    });
  };
  Object.assign(createSelector2, {
    withTypes: () => createSelector2
  });
  return createSelector2;
}
var createSelector = /* @__PURE__ */ createSelectorCreator(weakMapMemoize);

// src/createStructuredSelector.ts
var createStructuredSelector = Object.assign(
  (inputSelectorsObject, selectorCreator = createSelector) => {
    assertIsObject(
      inputSelectorsObject,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`
    );
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map(
      (key) => inputSelectorsObject[key]
    );
    const structuredSelector = selectorCreator(
      dependencies,
      (...inputSelectorResults) => {
        return inputSelectorResults.reduce((composition, value, index) => {
          composition[inputSelectorKeys[index]] = value;
          return composition;
        }, {});
      }
    );
    return structuredSelector;
  },
  { withTypes: () => createStructuredSelector }
);
// Annotate the CommonJS export names for ESM import in node:
0 && 0;
//# sourceMappingURL=reselect.cjs.map

}),
52926: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  QS: () => (makeVar),
  _v: () => (recallCache),
  ab: () => (cacheSlot),
  li: () => (forgetCache)
});
/* ESM import */var optimism__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11349);

// Contextual Slot that acquires its value when custom read functions are
// called in Policies#readField.
const cacheSlot = new optimism__WEBPACK_IMPORTED_MODULE_0__/* .Slot */.g7();
const cacheInfoMap = new WeakMap();
function getCacheInfo(cache) {
    let info = cacheInfoMap.get(cache);
    if (!info) {
        cacheInfoMap.set(cache, (info = {
            vars: new Set(),
            dep: (0,optimism__WEBPACK_IMPORTED_MODULE_0__/* .dep */.dP)(),
        }));
    }
    return info;
}
function forgetCache(cache) {
    getCacheInfo(cache).vars.forEach((rv) => rv.forgetCache(cache));
}
// Calling forgetCache(cache) serves to silence broadcasts and allows the
// cache to be garbage collected. However, the varsByCache WeakMap
// preserves the set of reactive variables that were previously associated
// with this cache, which makes it possible to "recall" the cache at a
// later time, by reattaching it to those variables. If the cache has been
// garbage collected in the meantime, because it is no longer reachable,
// you won't be able to call recallCache(cache), and the cache will
// automatically disappear from the varsByCache WeakMap.
function recallCache(cache) {
    getCacheInfo(cache).vars.forEach((rv) => rv.attachCache(cache));
}
function makeVar(value) {
    const caches = new Set();
    const listeners = new Set();
    const rv = function (newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach((cache) => {
                    // Invalidate any fields with custom read functions that
                    // consumed this variable, so query results involving those
                    // fields will be recomputed the next time we read them.
                    getCacheInfo(cache).dep.dirty(rv);
                    // Broadcast changes to any caches that have previously read
                    // from this variable.
                    broadcast(cache);
                });
                // Finally, notify any listeners added via rv.onNextChange.
                const oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach((listener) => listener(value));
            }
        }
        else {
            // When reading from the variable, obtain the current cache from
            // context via cacheSlot. This isn't entirely foolproof, but it's
            // the same system that powers varDep.
            const cache = cacheSlot.getValue();
            if (cache) {
                attach(cache);
                getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = (listener) => {
        listeners.add(listener);
        return () => {
            listeners.delete(listener);
        };
    };
    const attach = (rv.attachCache = (cache) => {
        caches.add(cache);
        getCacheInfo(cache).vars.add(rv);
        return rv;
    });
    rv.forgetCache = (cache) => caches.delete(cache);
    return rv;
}
function broadcast(cache) {
    if (cache.broadcastWatches) {
        cache.broadcastWatches();
    }
}
//# sourceMappingURL=reactiveVars.js.map

}),
22805: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  MissingFieldError: () => (/* reexport */ MissingFieldError),
  resetCaches: () => (/* reexport */ graphql_tag_lib.resetCaches),
  ApolloLink: () => (/* reexport */ ApolloLink/* ApolloLink */.i),
  DocumentTransform: () => (/* reexport */ DocumentTransform),
  selectHttpOptionsAndBody: () => (/* reexport */ selectHttpOptionsAndBody/* selectHttpOptionsAndBody */.E4),
  checkFetcher: () => (/* reexport */ checkFetcher/* checkFetcher */.U),
  disableFragmentWarnings: () => (/* reexport */ graphql_tag_lib.disableFragmentWarnings),
  CombinedProtocolErrors: () => (/* reexport */ CombinedProtocolErrors/* CombinedProtocolErrors */.b),
  isNetworkRequestSettled: () => (/* reexport */ isNetworkRequestSettled),
  version: () => (/* reexport */ version/* version */.i),
  disableExperimentalFragmentVariables: () => (/* reexport */ graphql_tag_lib.disableExperimentalFragmentVariables),
  ServerError: () => (/* reexport */ ServerError/* ServerError */.n),
  ObservableQuery: () => (/* reexport */ ObservableQuery),
  defaultDataIdFromObject: () => (/* reexport */ defaultDataIdFromObject),
  enableExperimentalFragmentVariables: () => (/* reexport */ graphql_tag_lib.enableExperimentalFragmentVariables),
  gql: () => (/* reexport */ graphql_tag_lib.gql),
  from: () => (/* reexport */ core_from_from),
  createSignalIfSupported: () => (/* reexport */ createSignalIfSupported),
  HttpLink: () => (/* reexport */ HttpLink),
  execute: () => (/* reexport */ execute),
  ApolloClient: () => (/* reexport */ ApolloClient),
  LocalStateError: () => (/* reexport */ LocalStateError/* LocalStateError */.x),
  ServerParseError: () => (/* reexport */ ServerParseError/* ServerParseError */.x),
  makeVar: () => (/* reexport */ reactiveVars/* makeVar */.QS),
  parseAndCheckHttpResponse: () => (/* reexport */ parseAndCheckHttpResponse/* parseAndCheckHttpResponse */.d),
  selectHttpOptionsAndBodyInternal: () => (/* reexport */ selectHttpOptionsAndBody/* selectHttpOptionsAndBodyInternal */.ve),
  split: () => (/* reexport */ split),
  NetworkStatus: () => (/* reexport */ networkStatus_NetworkStatus),
  empty: () => (/* reexport */ empty_empty),
  LinkError: () => (/* reexport */ LinkError),
  UnconventionalError: () => (/* reexport */ UnconventionalError/* UnconventionalError */.c),
  CombinedGraphQLErrors: () => (/* reexport */ CombinedGraphQLErrors),
  Observable: () => (/* reexport */ Observable/* Observable */.y),
  selectURI: () => (/* reexport */ selectURI/* selectURI */.r),
  setLogVerbosity: () => (/* reexport */ invariant/* setVerbosity */.U6),
  createHttpLink: () => (/* reexport */ createHttpLink),
  ApolloCache: () => (/* reexport */ ApolloCache),
  isReference: () => (/* reexport */ isReference),
  rewriteURIForGET: () => (/* reexport */ rewriteURIForGET),
  fallbackHttpConfig: () => (/* reexport */ selectHttpOptionsAndBody/* fallbackHttpConfig */.SC),
  defaultPrinter: () => (/* reexport */ selectHttpOptionsAndBody/* defaultPrinter */.sb),
  InMemoryCache: () => (/* reexport */ InMemoryCache),
  build: () => (/* reexport */ version/* build */.J),
  concat: () => (/* reexport */ concat_concat)
});

// EXTERNAL MODULE: ../../app/node_modules/graphql/language/ast.mjs
var ast = __webpack_require__(61432);
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/isFunction.js
var util_isFunction = __webpack_require__(65008);
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/lift.js

function hasLift(source) {
    return (0,util_isFunction/* isFunction */.m)(source === null || source === void 0 ? void 0 : source.lift);
}
function operate(init) {
    return function (source) {
        if (hasLift(source)) {
            return source.lift(function (liftedSource) {
                try {
                    return init(liftedSource, this);
                }
                catch (err) {
                    this.error(err);
                }
            });
        }
        throw new TypeError('Unable to lift unknown Observable type');
    };
}
//# sourceMappingURL=lift.js.map
// EXTERNAL MODULE: ../../app/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(68948);
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/Subscriber.js + 2 modules
var Subscriber = __webpack_require__(75591);
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/operators/OperatorSubscriber.js


function createOperatorSubscriber(destination, onNext, onComplete, onError, onFinalize) {
    return new OperatorSubscriber_OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize);
}
var OperatorSubscriber_OperatorSubscriber = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext
            ? function (value) {
                try {
                    onNext(value);
                }
                catch (err) {
                    destination.error(err);
                }
            }
            : _super.prototype._next;
        _this._error = onError
            ? function (err) {
                try {
                    onError(err);
                }
                catch (err) {
                    destination.error(err);
                }
                finally {
                    this.unsubscribe();
                }
            }
            : _super.prototype._error;
        _this._complete = onComplete
            ? function () {
                try {
                    onComplete();
                }
                catch (err) {
                    destination.error(err);
                }
                finally {
                    this.unsubscribe();
                }
            }
            : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function () {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 ? void 0 : _a.call(this));
        }
    };
    return OperatorSubscriber;
}(Subscriber/* Subscriber */.Lv));

//# sourceMappingURL=OperatorSubscriber.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/operators/map.js


function map_map(project, thisArg) {
    return operate(function (source, subscriber) {
        var index = 0;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}
//# sourceMappingURL=map.js.map
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/hasDirectives.js
var hasDirectives = __webpack_require__(27184);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/invariant/index.js
var invariant = __webpack_require__(85401);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/incremental/handlers/notImplemented.js


class NotImplementedHandler {
    isIncrementalResult(_) {
        return false;
    }
    prepareRequest(request) {
        (0,invariant/* invariant */.kG)(!(0,hasDirectives/* hasDirectives */.F)(["defer"], request.query), 64);
        return request;
    }
    extractErrors() { }
    // This code path can never be reached, so we won't implement it.
    startRequest = undefined;
}
//# sourceMappingURL=notImplemented.js.map

// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/link/core/ApolloLink.js + 1 modules
var ApolloLink = __webpack_require__(44265);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/link/core/execute.js

const execute = ApolloLink/* ApolloLink,execute */.i.execute;
//# sourceMappingURL=execute.js.map
// EXTERNAL MODULE: ../../app/node_modules/@wry/caches/lib/weak.js
var weak = __webpack_require__(53077);
;// CONCATENATED MODULE: ../../app/node_modules/@wry/trie/lib/index.js
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const defaultMakeData = () => Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach, slice } = Array.prototype;
const { hasOwnProperty: lib_hasOwnProperty } = Object.prototype;
class Trie {
    constructor(weakness = true, makeData = defaultMakeData) {
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup() {
        return this.lookupArray(arguments);
    }
    lookupArray(array) {
        let node = this;
        forEach.call(array, key => node = node.getChildTrie(key));
        return lib_hasOwnProperty.call(node, "data")
            ? node.data
            : node.data = this.makeData(slice.call(array));
    }
    peek() {
        return this.peekArray(arguments);
    }
    peekArray(array) {
        let node = this;
        for (let i = 0, len = array.length; node && i < len; ++i) {
            const map = node.mapFor(array[i], false);
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    remove() {
        return this.removeArray(arguments);
    }
    removeArray(array) {
        let data;
        if (array.length) {
            const head = array[0];
            const map = this.mapFor(head, false);
            const child = map && map.get(head);
            if (child) {
                data = child.removeArray(slice.call(array, 1));
                if (!child.data && !child.weak && !(child.strong && child.strong.size)) {
                    map.delete(head);
                }
            }
        }
        else {
            data = this.data;
            delete this.data;
        }
        return data;
    }
    getChildTrie(key) {
        const map = this.mapFor(key, true);
        let child = map.get(key);
        if (!child)
            map.set(key, child = new Trie(this.weakness, this.makeData));
        return child;
    }
    mapFor(key, create) {
        return this.weakness && isObjRef(key)
            ? this.weak || (create ? this.weak = new WeakMap : void 0)
            : this.strong || (create ? this.strong = new Map : void 0);
    }
}
function isObjRef(value) {
    switch (typeof value) {
        case "object":
            if (value === null)
                break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../app/node_modules/optimism/lib/index.js + 7 modules
var lib = __webpack_require__(11349);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/checkDocument.js
var checkDocument = __webpack_require__(48537);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/caching/sizes.js
var sizes = __webpack_require__(15313);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/graphql/DocumentTransform.js






function identity(document) {
    return document;
}
/**
 * A class for transforming GraphQL documents. See the [Document transforms
 * documentation](https://www.apollographql.com/docs/react/data/document-transforms) for more details on using them.
 *
 * @example
 *
 * ```ts
 * import { DocumentTransform } from "@apollo/client/utilities";
 * import { visit } from "graphql";
 *
 * const documentTransform = new DocumentTransform((doc) => {
 *   return visit(doc, {
 *     // ...
 *   });
 * });
 *
 * const transformedDoc = documentTransform.transformDocument(myDocument);
 * ```
 */
class DocumentTransform {
    transform;
    cached;
    resultCache = new WeakSet();
    // This default implementation of getCacheKey can be overridden by providing
    // options.getCacheKey to the DocumentTransform constructor. In general, a
    // getCacheKey function may either return an array of keys (often including
    // the document) to be used as a cache key, or undefined to indicate the
    // transform for this document should not be cached.
    getCacheKey(document) {
        return [document];
    }
    /**
     * Creates a DocumentTransform that returns the input document unchanged.
     *
     * @returns The input document
     */
    static identity() {
        // No need to cache this transform since it just returns the document
        // unchanged. This should save a bit of memory that would otherwise be
        // needed to populate the `documentCache` of this transform.
        return new DocumentTransform(identity, { cache: false });
    }
    /**
     * Creates a DocumentTransform that conditionally applies one of two transforms.
     *
     * @param predicate - Function that determines which transform to apply
     * @param left - Transform to apply when `predicate` returns `true`
     * @param right - Transform to apply when `predicate` returns `false`. If not provided, it defaults to `DocumentTransform.identity()`.
     * @returns A DocumentTransform that conditionally applies a document transform based on the predicate
     *
     * @example
     *
     * ```ts
     * import { isQueryOperation } from "@apollo/client/utilities";
     *
     * const conditionalTransform = DocumentTransform.split(
     *   (document) => isQueryOperation(document),
     *   queryTransform,
     *   mutationTransform
     * );
     * ```
     */
    static split(predicate, left, right = DocumentTransform.identity()) {
        return Object.assign(new DocumentTransform((document) => {
            const documentTransform = predicate(document) ? left : right;
            return documentTransform.transformDocument(document);
        }, 
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: false }), { left, right });
    }
    constructor(transform, options = {}) {
        this.transform = transform;
        if (options.getCacheKey) {
            // Override default `getCacheKey` function, which returns [document].
            this.getCacheKey = options.getCacheKey;
        }
        this.cached = options.cache !== false;
        this.resetCache();
    }
    /**
     * Resets the internal cache of this transform, if it is cached.
     */
    resetCache() {
        if (this.cached) {
            const stableCacheKeys = new Trie();
            this.performWork = (0,lib/* wrap */.re)(DocumentTransform.prototype.performWork.bind(this), {
                makeCacheKey: (document) => {
                    const cacheKeys = this.getCacheKey(document);
                    if (cacheKeys) {
                        (0,invariant/* invariant */.kG)(Array.isArray(cacheKeys), 20);
                        return stableCacheKeys.lookupArray(cacheKeys);
                    }
                },
                max: sizes/* cacheSizes,documentTransform.cache */.Q["documentTransform.cache"],
                cache: (weak/* WeakCache */.k),
            });
        }
    }
    performWork(document) {
        (0,checkDocument/* checkDocument */.A)(document);
        return this.transform(document);
    }
    /**
     * Transforms a GraphQL document using the configured transform function.
     *
     * @remarks
     *
     * Note that `transformDocument` caches the transformed document. Calling
     * `transformDocument` again with the already-transformed document will
     * immediately return it.
     *
     * @param document - The GraphQL document to transform
     * @returns The transformed document
     *
     * @example
     *
     * ```ts
     * const document = gql`
     *   # ...
     * `;
     *
     * const documentTransform = new DocumentTransform(transformFn);
     * const transformedDocument = documentTransform.transformDocument(document);
     * ```
     */
    transformDocument(document) {
        // If a user passes an already transformed result back to this function,
        // immediately return it.
        if (this.resultCache.has(document)) {
            return document;
        }
        const transformedDocument = this.performWork(document);
        this.resultCache.add(transformedDocument);
        return transformedDocument;
    }
    /**
     * Combines this document transform with another document transform. The
     * returned document transform first applies the current document transform,
     * then applies the other document transform.
     *
     * @param otherTransform - The transform to apply after this one
     * @returns A new DocumentTransform that applies both transforms in sequence
     *
     * @example
     *
     * ```ts
     * const combinedTransform = addTypenameTransform.concat(
     *   removeDirectivesTransform
     * );
     * ```
     */
    concat(otherTransform) {
        return Object.assign(new DocumentTransform((document) => {
            return otherTransform.transformDocument(this.transformDocument(document));
        }, 
        // Reasonably assume both transforms handle their own caching
        { cache: false }), {
            left: this,
            right: otherTransform,
        });
    }
    /**
    * @internal
    * Used to iterate through all transforms that are concatenations or `split` links.
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */
    left;
    /**
    * @internal
    * Used to iterate through all transforms that are concatenations or `split` links.
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */
    right;
}
//# sourceMappingURL=DocumentTransform.js.map

// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/environment/index.production.js
var index_production = __webpack_require__(64744);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/compact.js
var compact = __webpack_require__(94169);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/mergeOptions.js

/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function mergeOptions(defaults, options) {
    return (0,compact/* compact */.o)(defaults, options, options.variables && {
        variables: (0,compact/* compact */.o)({
            ...(defaults && defaults.variables),
            ...options.variables,
        }),
    });
}
//# sourceMappingURL=mergeOptions.js.map

// EXTERNAL MODULE: ../../app/node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(51371);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/removeFragmentSpreads.js

function removeMaskedFragmentSpreads(document) {
    return (0,visitor/* visit */.Vn)(document, {
        FragmentSpread(node) {
            if (!node.directives?.some(({ name }) => name.value === "unmask")) {
                return null;
            }
        },
    });
}
//# sourceMappingURL=removeFragmentSpreads.js.map
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/index.production.js
// eslint-disable-next-line no-restricted-syntax

function unsupported() {
    throw new Error("only supported in development mode");
}
const getApolloCacheMemoryInternals = unsupported, getApolloClientMemoryInternals = unsupported, getInMemoryCacheMemoryInternals = unsupported;
//# sourceMappingURL=index.production.js.map
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/version.js
var version = __webpack_require__(81293);
// EXTERNAL MODULE: ../../app/node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(44361);
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/Observable.js + 1 modules
var Observable = __webpack_require__(87252);
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/observable/throwError.js
var throwError = __webpack_require__(82693);
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/isArrayLike.js
var isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });
//# sourceMappingURL=isArrayLike.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/isPromise.js

function isPromise(value) {
    return (0,util_isFunction/* isFunction */.m)(value === null || value === void 0 ? void 0 : value.then);
}
//# sourceMappingURL=isPromise.js.map
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/symbol/observable.js
var symbol_observable = __webpack_require__(55066);
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/isInteropObservable.js


function isInteropObservable(input) {
    return (0,util_isFunction/* isFunction */.m)(input[symbol_observable/* observable */.L]);
}
//# sourceMappingURL=isInteropObservable.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/isAsyncIterable.js

function isAsyncIterable(obj) {
    return Symbol.asyncIterator && (0,util_isFunction/* isFunction */.m)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}
//# sourceMappingURL=isAsyncIterable.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/throwUnobservableError.js
function createInvalidObservableTypeError(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
//# sourceMappingURL=throwUnobservableError.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/symbol/iterator.js
function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) {
        return '@@iterator';
    }
    return Symbol.iterator;
}
var iterator_iterator = getSymbolIterator();
//# sourceMappingURL=iterator.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/isIterable.js


function isIterable(input) {
    return (0,util_isFunction/* isFunction */.m)(input === null || input === void 0 ? void 0 : input[iterator_iterator]);
}
//# sourceMappingURL=isIterable.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/isReadableStreamLike.js


function readableStreamLikeToAsyncGenerator(readableStream) {
    return (0,tslib_es6/* __asyncGenerator */.FC)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0,tslib_es6/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, , 9, 10]);
                    _b.label = 2;
                case 2:
                    if (false) {}
                    return [4, (0,tslib_es6/* __await */.qq)(reader.read())];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [3, 5];
                    return [4, (0,tslib_es6/* __await */.qq)(void 0)];
                case 4: return [2, _b.sent()];
                case 5: return [4, (0,tslib_es6/* __await */.qq)(value)];
                case 6: return [4, _b.sent()];
                case 7:
                    _b.sent();
                    return [3, 2];
                case 8: return [3, 10];
                case 9:
                    reader.releaseLock();
                    return [7];
                case 10: return [2];
            }
        });
    });
}
function isReadableStreamLike(obj) {
    return (0,util_isFunction/* isFunction */.m)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}
//# sourceMappingURL=isReadableStreamLike.js.map
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/reportUnhandledError.js
var reportUnhandledError = __webpack_require__(77220);
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/observable/innerFrom.js












function innerFrom(input) {
    if (input instanceof Observable/* Observable */.y) {
        return input;
    }
    if (input != null) {
        if (isInteropObservable(input)) {
            return fromInteropObservable(input);
        }
        if (isArrayLike(input)) {
            return fromArrayLike(input);
        }
        if (isPromise(input)) {
            return fromPromise(input);
        }
        if (isAsyncIterable(input)) {
            return fromAsyncIterable(input);
        }
        if (isIterable(input)) {
            return fromIterable(input);
        }
        if (isReadableStreamLike(input)) {
            return fromReadableStreamLike(input);
        }
    }
    throw createInvalidObservableTypeError(input);
}
function fromInteropObservable(obj) {
    return new Observable/* Observable */.y(function (subscriber) {
        var obs = obj[symbol_observable/* observable */.L]();
        if ((0,util_isFunction/* isFunction */.m)(obs.subscribe)) {
            return obs.subscribe(subscriber);
        }
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function fromArrayLike(array) {
    return new Observable/* Observable */.y(function (subscriber) {
        for (var i = 0; i < array.length && !subscriber.closed; i++) {
            subscriber.next(array[i]);
        }
        subscriber.complete();
    });
}
function fromPromise(promise) {
    return new Observable/* Observable */.y(function (subscriber) {
        promise
            .then(function (value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function (err) { return subscriber.error(err); })
            .then(null, reportUnhandledError/* reportUnhandledError */.h);
    });
}
function fromIterable(iterable) {
    return new Observable/* Observable */.y(function (subscriber) {
        var e_1, _a;
        try {
            for (var iterable_1 = (0,tslib_es6/* __values */.XA)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()) {
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) {
                    return;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        subscriber.complete();
    });
}
function fromAsyncIterable(asyncIterable) {
    return new Observable/* Observable */.y(function (subscriber) {
        process(asyncIterable, subscriber).catch(function (err) { return subscriber.error(err); });
    });
}
function fromReadableStreamLike(readableStream) {
    return fromAsyncIterable(readableStreamLikeToAsyncGenerator(readableStream));
}
function process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
        var value, e_2_1;
        return (0,tslib_es6/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, 6, 11]);
                    asyncIterable_1 = (0,tslib_es6/* __asyncValues */.KL)(asyncIterable);
                    _b.label = 1;
                case 1: return [4, asyncIterable_1.next()];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [3, 4];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) {
                        return [2];
                    }
                    _b.label = 3;
                case 3: return [3, 1];
                case 4: return [3, 11];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = { error: e_2_1 };
                    return [3, 11];
                case 6:
                    _b.trys.push([6, , 9, 10]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [3, 8];
                    return [4, _a.call(asyncIterable_1)];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8: return [3, 10];
                case 9:
                    if (e_2) throw e_2.error;
                    return [7];
                case 10: return [7];
                case 11:
                    subscriber.complete();
                    return [2];
            }
        });
    });
}
//# sourceMappingURL=innerFrom.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/executeSchedule.js
function executeSchedule(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) { delay = 0; }
    if (repeat === void 0) { repeat = false; }
    var scheduleSubscription = scheduler.schedule(function () {
        work();
        if (repeat) {
            parentSubscription.add(this.schedule(null, delay));
        }
        else {
            this.unsubscribe();
        }
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) {
        return scheduleSubscription;
    }
}
//# sourceMappingURL=executeSchedule.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/operators/mergeInternals.js



function mergeInternals(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function () {
        if (isComplete && !buffer.length && !active) {
            subscriber.complete();
        }
    };
    var outerNext = function (value) { return (active < concurrent ? doInnerSub(value) : buffer.push(value)); };
    var doInnerSub = function (value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        innerFrom(project(value, index++)).subscribe(createOperatorSubscriber(subscriber, function (innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 ? void 0 : onBeforeNext(innerValue);
            if (expand) {
                outerNext(innerValue);
            }
            else {
                subscriber.next(innerValue);
            }
        }, function () {
            innerComplete = true;
        }, undefined, function () {
            if (innerComplete) {
                try {
                    active--;
                    var _loop_1 = function () {
                        var bufferedValue = buffer.shift();
                        if (innerSubScheduler) {
                            executeSchedule(subscriber, innerSubScheduler, function () { return doInnerSub(bufferedValue); });
                        }
                        else {
                            doInnerSub(bufferedValue);
                        }
                    };
                    while (buffer.length && active < concurrent) {
                        _loop_1();
                    }
                    checkComplete();
                }
                catch (err) {
                    subscriber.error(err);
                }
            }
        }));
    };
    source.subscribe(createOperatorSubscriber(subscriber, outerNext, function () {
        isComplete = true;
        checkComplete();
    }));
    return function () {
        additionalFinalizer === null || additionalFinalizer === void 0 ? void 0 : additionalFinalizer();
    };
}
//# sourceMappingURL=mergeInternals.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/operators/mergeMap.js





function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Infinity; }
    if ((0,util_isFunction/* isFunction */.m)(resultSelector)) {
        return mergeMap(function (a, i) { return map_map(function (b, ii) { return resultSelector(a, b, i, ii); })(innerFrom(project(a, i))); }, concurrent);
    }
    else if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return operate(function (source, subscriber) { return mergeInternals(source, subscriber, project, concurrent); });
}
//# sourceMappingURL=mergeMap.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/operators/observeOn.js



function observeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return operate(function (source, subscriber) {
        source.subscribe(createOperatorSubscriber(subscriber, function (value) { return executeSchedule(subscriber, scheduler, function () { return subscriber.next(value); }, delay); }, function () { return executeSchedule(subscriber, scheduler, function () { return subscriber.complete(); }, delay); }, function (err) { return executeSchedule(subscriber, scheduler, function () { return subscriber.error(err); }, delay); }));
    });
}
//# sourceMappingURL=observeOn.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/operators/subscribeOn.js

function subscribeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return operate(function (source, subscriber) {
        subscriber.add(scheduler.schedule(function () { return source.subscribe(subscriber); }, delay));
    });
}
//# sourceMappingURL=subscribeOn.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/scheduled/scheduleObservable.js



function scheduleObservable(input, scheduler) {
    return innerFrom(input).pipe(subscribeOn(scheduler), observeOn(scheduler));
}
//# sourceMappingURL=scheduleObservable.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/scheduled/schedulePromise.js



function schedulePromise(input, scheduler) {
    return innerFrom(input).pipe(subscribeOn(scheduler), observeOn(scheduler));
}
//# sourceMappingURL=schedulePromise.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/scheduled/scheduleArray.js

function scheduleArray(input, scheduler) {
    return new Observable/* Observable */.y(function (subscriber) {
        var i = 0;
        return scheduler.schedule(function () {
            if (i === input.length) {
                subscriber.complete();
            }
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) {
                    this.schedule();
                }
            }
        });
    });
}
//# sourceMappingURL=scheduleArray.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/scheduled/scheduleIterable.js




function scheduleIterable(input, scheduler) {
    return new Observable/* Observable */.y(function (subscriber) {
        var iterator;
        executeSchedule(subscriber, scheduler, function () {
            iterator = input[iterator_iterator]();
            executeSchedule(subscriber, scheduler, function () {
                var _a;
                var value;
                var done;
                try {
                    (_a = iterator.next(), value = _a.value, done = _a.done);
                }
                catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) {
                    subscriber.complete();
                }
                else {
                    subscriber.next(value);
                }
            }, 0, true);
        });
        return function () { return (0,util_isFunction/* isFunction */.m)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return(); };
    });
}
//# sourceMappingURL=scheduleIterable.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/scheduled/scheduleAsyncIterable.js


function scheduleAsyncIterable(input, scheduler) {
    if (!input) {
        throw new Error('Iterable cannot be null');
    }
    return new Observable/* Observable */.y(function (subscriber) {
        executeSchedule(subscriber, scheduler, function () {
            var iterator = input[Symbol.asyncIterator]();
            executeSchedule(subscriber, scheduler, function () {
                iterator.next().then(function (result) {
                    if (result.done) {
                        subscriber.complete();
                    }
                    else {
                        subscriber.next(result.value);
                    }
                });
            }, 0, true);
        });
    });
}
//# sourceMappingURL=scheduleAsyncIterable.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/scheduled/scheduleReadableStreamLike.js


function scheduleReadableStreamLike(input, scheduler) {
    return scheduleAsyncIterable(readableStreamLikeToAsyncGenerator(input), scheduler);
}
//# sourceMappingURL=scheduleReadableStreamLike.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/scheduled/scheduled.js













function scheduled_scheduled(input, scheduler) {
    if (input != null) {
        if (isInteropObservable(input)) {
            return scheduleObservable(input, scheduler);
        }
        if (isArrayLike(input)) {
            return scheduleArray(input, scheduler);
        }
        if (isPromise(input)) {
            return schedulePromise(input, scheduler);
        }
        if (isAsyncIterable(input)) {
            return scheduleAsyncIterable(input, scheduler);
        }
        if (isIterable(input)) {
            return scheduleIterable(input, scheduler);
        }
        if (isReadableStreamLike(input)) {
            return scheduleReadableStreamLike(input, scheduler);
        }
    }
    throw createInvalidObservableTypeError(input);
}
//# sourceMappingURL=scheduled.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/observable/from.js


function from_from(input, scheduler) {
    return scheduler ? scheduled_scheduled(input, scheduler) : innerFrom(input);
}
//# sourceMappingURL=from.js.map
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/createErrorClass.js
var createErrorClass = __webpack_require__(38282);
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/EmptyError.js

var EmptyError = (0,createErrorClass/* createErrorClass */.d)(function (_super) { return function EmptyErrorImpl() {
    _super(this);
    this.name = 'EmptyError';
    this.message = 'no elements in sequence';
}; });
//# sourceMappingURL=EmptyError.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/lastValueFrom.js

function lastValueFrom(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function (resolve, reject) {
        var _hasValue = false;
        var _value;
        source.subscribe({
            next: function (value) {
                _value = value;
                _hasValue = true;
            },
            error: reject,
            complete: function () {
                if (_hasValue) {
                    resolve(_value);
                }
                else if (hasConfig) {
                    resolve(config.defaultValue);
                }
                else {
                    reject(new EmptyError());
                }
            },
        });
    });
}
//# sourceMappingURL=lastValueFrom.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/isScheduler.js

function isScheduler(value) {
    return value && (0,util_isFunction/* isFunction */.m)(value.schedule);
}
//# sourceMappingURL=isScheduler.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/args.js


function args_last(arr) {
    return arr[arr.length - 1];
}
function popResultSelector(args) {
    return isFunction(args_last(args)) ? args.pop() : undefined;
}
function popScheduler(args) {
    return isScheduler(args_last(args)) ? args.pop() : undefined;
}
function popNumber(args, defaultValue) {
    return typeof args_last(args) === 'number' ? args.pop() : defaultValue;
}
//# sourceMappingURL=args.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/observable/of.js


function of() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = popScheduler(args);
    return from_from(args, scheduler);
}
//# sourceMappingURL=of.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/operators/catchError.js



function catchError(selector) {
    return operate(function (source, subscriber) {
        var innerSub = null;
        var syncUnsub = false;
        var handledResult;
        innerSub = source.subscribe(createOperatorSubscriber(subscriber, undefined, undefined, function (err) {
            handledResult = innerFrom(selector(err, catchError(selector)(source)));
            if (innerSub) {
                innerSub.unsubscribe();
                innerSub = null;
                handledResult.subscribe(subscriber);
            }
            else {
                syncUnsub = true;
            }
        }));
        if (syncUnsub) {
            innerSub.unsubscribe();
            innerSub = null;
            handledResult.subscribe(subscriber);
        }
    });
}
//# sourceMappingURL=catchError.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/operators/filter.js


function filter(predicate, thisArg) {
    return operate(function (source, subscriber) {
        var index = 0;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) { return predicate.call(thisArg, value, index++) && subscriber.next(value); }));
    });
}
//# sourceMappingURL=filter.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/operators/finalize.js

function finalize_finalize(callback) {
    return operate(function (source, subscriber) {
        try {
            source.subscribe(subscriber);
        }
        finally {
            subscriber.add(callback);
        }
    });
}
//# sourceMappingURL=finalize.js.map
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/Subscription.js + 1 modules
var Subscription = __webpack_require__(80205);
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/ObjectUnsubscribedError.js

var ObjectUnsubscribedError = (0,createErrorClass/* createErrorClass */.d)(function (_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = 'ObjectUnsubscribedError';
        this.message = 'object unsubscribed';
    };
});
//# sourceMappingURL=ObjectUnsubscribedError.js.map
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/arrRemove.js
var arrRemove = __webpack_require__(69677);
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/errorContext.js
var errorContext = __webpack_require__(18633);
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/Subject.js






var Subject_Subject = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function (operator) {
        var subject = new Subject_AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function () {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
    };
    Subject.prototype.next = function (value) {
        var _this = this;
        (0,errorContext/* errorContext */.x)(function () {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) {
                    _this.currentObservers = Array.from(_this.observers);
                }
                try {
                    for (var _b = (0,tslib_es6/* __values */.XA)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var observer = _c.value;
                        observer.next(value);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        });
    };
    Subject.prototype.error = function (err) {
        var _this = this;
        (0,errorContext/* errorContext */.x)(function () {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while (observers.length) {
                    observers.shift().error(err);
                }
            }
        });
    };
    Subject.prototype.complete = function () {
        var _this = this;
        (0,errorContext/* errorContext */.x)(function () {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while (observers.length) {
                    observers.shift().complete();
                }
            }
        });
    };
    Subject.prototype.unsubscribe = function () {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function () {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function (subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function (subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function (subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) {
            return Subscription/* EMPTY_SUBSCRIPTION */.Lc;
        }
        this.currentObservers = null;
        observers.push(subscriber);
        return new Subscription/* Subscription */.w0(function () {
            _this.currentObservers = null;
            (0,arrRemove/* arrRemove */.P)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function (subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) {
            subscriber.error(thrownError);
        }
        else if (isStopped) {
            subscriber.complete();
        }
    };
    Subject.prototype.asObservable = function () {
        var observable = new Observable/* Observable */.y();
        observable.source = this;
        return observable;
    };
    Subject.create = function (destination, source) {
        return new Subject_AnonymousSubject(destination, source);
    };
    return Subject;
}(Observable/* Observable */.y));

var Subject_AnonymousSubject = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function (value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function (err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function () {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function (subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : Subscription/* EMPTY_SUBSCRIPTION */.Lc;
    };
    return AnonymousSubject;
}(Subject_Subject));

//# sourceMappingURL=Subject.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/operators/share.js





function share(options) {
    if (options === void 0) { options = {}; }
    var _a = options.connector, connector = _a === void 0 ? function () { return new Subject_Subject(); } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function (wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function () {
            resetConnection === null || resetConnection === void 0 ? void 0 : resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function () {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function () {
            var conn = connection;
            reset();
            conn === null || conn === void 0 ? void 0 : conn.unsubscribe();
        };
        return operate(function (source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) {
                cancelReset();
            }
            var dest = (subject = subject !== null && subject !== void 0 ? subject : connector());
            subscriber.add(function () {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) {
                    resetConnection = handleReset(resetAndUnsubscribe, resetOnRefCountZero);
                }
            });
            dest.subscribe(subscriber);
            if (!connection &&
                refCount > 0) {
                connection = new Subscriber/* SafeSubscriber */.Hp({
                    next: function (value) { return dest.next(value); },
                    error: function (err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function () {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = handleReset(reset, resetOnComplete);
                        dest.complete();
                    },
                });
                innerFrom(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function handleReset(reset, on) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (on === true) {
        reset();
        return;
    }
    if (on === false) {
        return;
    }
    var onSubscriber = new Subscriber/* SafeSubscriber */.Hp({
        next: function () {
            onSubscriber.unsubscribe();
            reset();
        },
    });
    return innerFrom(on.apply(void 0, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(args)))).subscribe(onSubscriber);
}
//# sourceMappingURL=share.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/scheduler/dateTimestampProvider.js
var dateTimestampProvider = {
    now: function () {
        return (dateTimestampProvider.delegate || Date).now();
    },
    delegate: undefined,
};
//# sourceMappingURL=dateTimestampProvider.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/ReplaySubject.js



var ReplaySubject_ReplaySubject = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) { _bufferSize = Infinity; }
        if (_windowTime === void 0) { _windowTime = Infinity; }
        if (_timestampProvider === void 0) { _timestampProvider = dateTimestampProvider; }
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
    }
    ReplaySubject.prototype.next = function (value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
            _buffer.push(value);
            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function (subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for (var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2) {
            subscriber.next(copy[i]);
        }
        this._checkFinalizedStatuses(subscriber);
        return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function () {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
            var now = _timestampProvider.now();
            var last = 0;
            for (var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2) {
                last = i;
            }
            last && _buffer.splice(0, last + 1);
        }
    };
    return ReplaySubject;
}(Subject_Subject));

//# sourceMappingURL=ReplaySubject.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/operators/shareReplay.js


function shareReplay(configOrBufferSize, windowTime, scheduler) {
    var _a, _b, _c;
    var bufferSize;
    var refCount = false;
    if (configOrBufferSize && typeof configOrBufferSize === 'object') {
        (_a = configOrBufferSize.bufferSize, bufferSize = _a === void 0 ? Infinity : _a, _b = configOrBufferSize.windowTime, windowTime = _b === void 0 ? Infinity : _b, _c = configOrBufferSize.refCount, refCount = _c === void 0 ? false : _c, scheduler = configOrBufferSize.scheduler);
    }
    else {
        bufferSize = (configOrBufferSize !== null && configOrBufferSize !== void 0 ? configOrBufferSize : Infinity);
    }
    return share({
        connector: function () { return new ReplaySubject_ReplaySubject(bufferSize, windowTime, scheduler); },
        resetOnError: true,
        resetOnComplete: false,
        resetOnRefCountZero: refCount,
    });
}
//# sourceMappingURL=shareReplay.js.map
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/observable/empty.js
var empty = __webpack_require__(21287);
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/Notification.js




var Notification_NotificationKind;
(function (NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})(Notification_NotificationKind || (Notification_NotificationKind = {}));
var Notification_Notification = (function () {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    Notification.prototype.observe = function (observer) {
        return observeNotification(this, observer);
    };
    Notification.prototype.do = function (nextHandler, errorHandler, completeHandler) {
        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
        return kind === 'N' ? nextHandler === null || nextHandler === void 0 ? void 0 : nextHandler(value) : kind === 'E' ? errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(error) : completeHandler === null || completeHandler === void 0 ? void 0 : completeHandler();
    };
    Notification.prototype.accept = function (nextOrObserver, error, complete) {
        var _a;
        return (0,util_isFunction/* isFunction */.m)((_a = nextOrObserver) === null || _a === void 0 ? void 0 : _a.next)
            ? this.observe(nextOrObserver)
            : this.do(nextOrObserver, error, complete);
    };
    Notification.prototype.toObservable = function () {
        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
        var result = kind === 'N'
            ?
                of(value)
            :
                kind === 'E'
                    ?
                        (0,throwError/* throwError */._)(function () { return error; })
                    :
                        kind === 'C'
                            ?
                                empty/* EMPTY */.E
                            :
                                0;
        if (!result) {
            throw new TypeError("Unexpected notification kind " + kind);
        }
        return result;
    };
    Notification.createNext = function (value) {
        return new Notification('N', value);
    };
    Notification.createError = function (err) {
        return new Notification('E', undefined, err);
    };
    Notification.createComplete = function () {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    return Notification;
}());

function observeNotification(notification, observer) {
    var _a, _b, _c;
    var _d = notification, kind = _d.kind, value = _d.value, error = _d.error;
    if (typeof kind !== 'string') {
        throw new TypeError('Invalid notification, missing "kind"');
    }
    kind === 'N' ? (_a = observer.next) === null || _a === void 0 ? void 0 : _a.call(observer, value) : kind === 'E' ? (_b = observer.error) === null || _b === void 0 ? void 0 : _b.call(observer, error) : (_c = observer.complete) === null || _c === void 0 ? void 0 : _c.call(observer);
}
//# sourceMappingURL=Notification.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/operators/materialize.js



function materialize() {
    return operate(function (source, subscriber) {
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            subscriber.next(Notification_Notification.createNext(value));
        }, function () {
            subscriber.next(Notification_Notification.createComplete());
            subscriber.complete();
        }, function (err) {
            subscriber.next(Notification_Notification.createError(err));
            subscriber.complete();
        }));
    });
}
//# sourceMappingURL=materialize.js.map
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/util/identity.js
var util_identity = __webpack_require__(77496);
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/operators/mergeAll.js


function mergeAll(concurrent) {
    if (concurrent === void 0) { concurrent = Infinity; }
    return mergeMap(util_identity/* identity */.y, concurrent);
}
//# sourceMappingURL=mergeAll.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/operators/concatAll.js

function concatAll() {
    return mergeAll(1);
}
//# sourceMappingURL=concatAll.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/observable/concat.js



function concat() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return concatAll()(from_from(args, popScheduler(args)));
}
//# sourceMappingURL=concat.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/operators/tap.js




function tap(observerOrNext, error, complete) {
    var tapObserver = (0,util_isFunction/* isFunction */.m)(observerOrNext) || error || complete
        ?
            { next: observerOrNext, error: error, complete: complete }
        : observerOrNext;
    return tapObserver
        ? operate(function (source, subscriber) {
            var _a;
            (_a = tapObserver.subscribe) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
            var isUnsub = true;
            source.subscribe(createOperatorSubscriber(subscriber, function (value) {
                var _a;
                (_a = tapObserver.next) === null || _a === void 0 ? void 0 : _a.call(tapObserver, value);
                subscriber.next(value);
            }, function () {
                var _a;
                isUnsub = false;
                (_a = tapObserver.complete) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
                subscriber.complete();
            }, function (err) {
                var _a;
                isUnsub = false;
                (_a = tapObserver.error) === null || _a === void 0 ? void 0 : _a.call(tapObserver, err);
                subscriber.error(err);
            }, function () {
                var _a, _b;
                if (isUnsub) {
                    (_a = tapObserver.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
                }
                (_b = tapObserver.finalize) === null || _b === void 0 ? void 0 : _b.call(tapObserver);
            }));
        })
        :
            util_identity/* identity */.y;
}
//# sourceMappingURL=tap.js.map
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/caches.js
var caches = __webpack_require__(88926);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/getMemoryInternals.js
var getMemoryInternals = __webpack_require__(56552);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/canonicalStringify.js




/**
 * Serializes a value to JSON with object keys in a consistent, sorted order.
 *
 * @remarks
 *
 * Unlike `JSON.stringify()`, this function ensures that object keys are always
 * serialized in the same alphabetical order, regardless of their original order.
 * This makes it suitable for creating consistent cache keys from objects,
 * comparing objects by their serialized representation, or generating
 * deterministic hashes of objects.
 *
 * To achieve performant sorting, this function uses a `Map` from JSON-serialized
 * arrays of keys (in any order) to sorted arrays of the same keys, with a
 * single sorted array reference shared by all permutations of the keys.
 *
 * As a drawback, this function will add a little more memory for every object
 * encountered that has different (more, less, a different order of) keys than
 * in the past.
 *
 * In a typical application, this extra memory usage should not play a
 * significant role, as `canonicalStringify` will be called for only a limited
 * number of object shapes, and the cache will not grow beyond a certain point.
 * But in some edge cases, this could be a problem. Use canonicalStringify.reset()
 * as a way to clear the memoization cache.
 *
 * @param value - The value to stringify
 * @returns JSON string with consistently ordered object keys
 *
 * @example
 *
 * ```ts
 * import { canonicalStringify } from "@apollo/client/utilities";
 *
 * const obj1 = { b: 2, a: 1 };
 * const obj2 = { a: 1, b: 2 };
 *
 * console.log(canonicalStringify(obj1)); // '{"a":1,"b":2}'
 * console.log(canonicalStringify(obj2)); // '{"a":1,"b":2}'
 * ```
 */
const canonicalStringify_canonicalStringify = Object.assign(function canonicalStringify(value) {
    return JSON.stringify(value, stableObjectReplacer);
}, {
    reset() {
        // Clearing the sortingMap will reclaim all cached memory, without
        // affecting the logical results of canonicalStringify, but potentially
        // sacrificing performance until the cache is refilled.
        sortingMap = new caches/* AutoCleanedStrongCache */.L(sizes/* cacheSizes,canonicalStringify */.Q.canonicalStringify || 1000 /* defaultCacheSizes.canonicalStringify */);
    },
});
if (index_production/* __DEV__ */.T) {
    (0,getMemoryInternals/* registerGlobalCache */.zP)("canonicalStringify", () => sortingMap.size);
}
// Values are JSON-serialized arrays of object keys (in any order), and values
// are sorted arrays of the same keys.
let sortingMap;
canonicalStringify_canonicalStringify.reset();
// The JSON.stringify function takes an optional second argument called a
// replacer function. This function is called for each key-value pair in the
// object being stringified, and its return value is used instead of the
// original value. If the replacer function returns a new value, that value is
// stringified as JSON instead of the original value of the property.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#the_replacer_parameter
function stableObjectReplacer(key, value) {
    if (value && typeof value === "object") {
        const proto = Object.getPrototypeOf(value);
        // We don't want to mess with objects that are not "plain" objects, which
        // means their prototype is either Object.prototype or null. This check also
        // prevents needlessly rearranging the indices of arrays.
        if (proto === Object.prototype || proto === null) {
            const keys = Object.keys(value);
            // If keys is already sorted, let JSON.stringify serialize the original
            // value instead of creating a new object with keys in the same order.
            if (keys.every(everyKeyInOrder))
                return value;
            const unsortedKey = JSON.stringify(keys);
            let sortedKeys = sortingMap.get(unsortedKey);
            if (!sortedKeys) {
                keys.sort();
                const sortedKey = JSON.stringify(keys);
                // Checking for sortedKey in the sortingMap allows us to share the same
                // sorted array reference for all permutations of the same set of keys.
                sortedKeys = sortingMap.get(sortedKey) || keys;
                sortingMap.set(unsortedKey, sortedKeys);
                sortingMap.set(sortedKey, sortedKeys);
            }
            const sortedObject = Object.create(proto);
            // Reassigning the keys in sorted order will cause JSON.stringify to
            // serialize them in sorted order.
            sortedKeys.forEach((key) => {
                sortedObject[key] = value[key];
            });
            return sortedObject;
        }
    }
    return value;
}
// Since everything that happens in stableObjectReplacer benefits from being as
// efficient as possible, we use a static function as the callback for
// keys.every in order to test if the provided keys are already sorted without
// allocating extra memory for a callback.
function everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}
//# sourceMappingURL=canonicalStringify.js.map
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/errors/utils.js
var utils = __webpack_require__(74730);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/errors/CombinedGraphQLErrors.js

function defaultFormatMessage(errors) {
    return (errors
        // Handle non-spec-compliant servers: See #1185
        .filter((e) => e)
        .map((e) => e.message || "Error message not found.")
        .join("\n"));
}
/**
 * Represents the combined list of GraphQL errors returned from the server in a
 * GraphQL response. This error type is used when your GraphQL operation returns
 * errors in the `errors` field of the response.
 *
 * @remarks
 *
 * When your GraphQL operation encounters errors on the server side (such as
 * resolver errors, validation errors, or syntax errors), the server returns
 * these errors in the `errors` array of the GraphQL response. Apollo Client
 * wraps these errors in a `CombinedGraphQLErrors` object, which provides access
 * to the individual errors while maintaining additional context about the
 * response.
 *
 * @example
 *
 * ```ts
 * import { CombinedGraphQLErrors } from "@apollo/client/errors";
 *
 * // Check if an error is a CombinedGraphQLErrors object
 * if (CombinedGraphQLErrors.is(error)) {
 *   // Access individual GraphQL errors
 *   error.errors.forEach((graphQLError) => {
 *     console.log(graphQLError.message);
 *     console.log(graphQLError.path);
 *     console.log(graphQLError.locations);
 *   });
 *
 *   // Access the original GraphQL result
 *   console.log(error.result);
 * }
 * ```
 */
class CombinedGraphQLErrors extends Error {
    /**
    * A method that determines whether an error is a `CombinedGraphQLErrors`
    * object. This method enables TypeScript to narrow the error type.
    * 
    * @example
    * 
    * ```ts
    * if (CombinedGraphQLErrors.is(error)) {
    *   // TypeScript now knows `error` is a `CombinedGraphQLErrors` object
    *   console.log(error.errors);
    * }
    * ```
    */
    static is(error) {
        return (0,utils/* isBranded */.I)(error, "CombinedGraphQLErrors");
    }
    /**
    * A function that formats the error message used for the error's `message`
    * property. Override this method to provide your own formatting.
    * 
    * @remarks
    * 
    * The `formatMessage` function is called by the `CombinedGraphQLErrors`
    * constructor to provide a formatted message as the `message` property of the
    * `CombinedGraphQLErrors` object. Follow the ["Providing a custom message
    * formatter"](https://www.apollographql.com/docs/react/api/errors/CombinedGraphQLErrors#providing-a-custom-message-formatter) guide to learn how to modify the message format.
    * 
    * @param errors - The array of GraphQL errors returned from the server in
    * the `errors` field of the response.
    * @param options - Additional context that could be useful when formatting
    * the message.
    */
    static formatMessage = defaultFormatMessage;
    /**
    * The raw list of GraphQL errors returned by the `errors` field in the GraphQL response.
    */
    errors;
    /**
    * Partial data returned in the `data` field of the GraphQL response.
    */
    data;
    /**
    * Extensions returned by the `extensions` field in the GraphQL response.
    */
    extensions;
    constructor(result, errors = result.errors || []) {
        super(CombinedGraphQLErrors.formatMessage(errors, {
            result,
            defaultFormatMessage,
        }));
        this.errors = errors;
        this.data = result.data;
        this.extensions = result.extensions;
        this.name = "CombinedGraphQLErrors";
        (0,utils/* brand */.U)(this);
        Object.setPrototypeOf(this, CombinedGraphQLErrors.prototype);
    }
}
//# sourceMappingURL=CombinedGraphQLErrors.js.map

// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/errors/index.js + 1 modules
var client_errors = __webpack_require__(39291);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/errors/LinkError.js
const registry = new WeakSet();
/**
* @internal Please do not use directly.
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function registerLinkError(error) {
    registry.add(error);
}
/**
 * A facade error type that keeps a registry of errors emitted from the link
 * chain. `LinkError` is not an error class itself but rather a utility to
 * detect whether an error originated from the link chain.
 *
 * @remarks
 *
 * Use `LinkError` to distinguish between errors from the link chain and custom
 * errors. This is helpful for retrying an operation at the call site only when
 * the error originates from the link chain.
 *
 * @example
 *
 * The following example creates a custom wrapped query function that detects
 * whether the query includes an operation name and throws if not.
 *
 * ```ts
 * import { LinkError } from "@apollo/client/errors";
 *
 * async function runQuery<TData>(query: TypedDocumentNode<TData>) {
 *   if (!hasOperationName(query)) {
 *     throw new Error("Queries should have operation names.");
 *   }
 *
 *   return client.watchQuery({ query });
 * }
 *
 * try {
 *   const result = await runQuery(query);
 * } catch (error) {
 *   // Only log the error if the error wasn't our own custom thrown error
 *   if (LinkError.is(error)) {
 *     console.log("Got network error:", error.message);
 *   }
 * }
 * ```
 */
const LinkError = {
    /**
     * A method that determines whether an error originated from the link chain.
     * `is` does not provide any type narrowing.
     *
     * @example
     *
     * ```ts
     * if (LinkError.is(error)) {
     *   // The error originated from the link chain
     *   console.log("Got network error:", error.message);
     * }
     * ```
     */
    is: (error) => registry.has(error),
};
//# sourceMappingURL=LinkError.js.map

// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/getOperationDefinition.js
var getOperationDefinition = __webpack_require__(76260);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/createFragmentMap.js
var createFragmentMap = __webpack_require__(21956);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/getFragmentDefinitions.js
var getFragmentDefinitions = __webpack_require__(5087);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/isNonNullObject.js
var isNonNullObject = __webpack_require__(46145);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/deepFreeze.js


/**
* @internal only to be imported in tests
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function deepFreeze(value) {
    const workSet = new Set([value]);
    workSet.forEach((obj) => {
        if ((0,isNonNullObject/* isNonNullObject */.s)(obj) && shallowFreeze(obj) === obj) {
            Object.getOwnPropertyNames(obj).forEach((name) => {
                if ((0,isNonNullObject/* isNonNullObject */.s)(obj[name]))
                    workSet.add(obj[name]);
            });
        }
    });
    return value;
}
function shallowFreeze(obj) {
    if (index_production/* __DEV__ */.T && !Object.isFrozen(obj)) {
        try {
            Object.freeze(obj);
        }
        catch (e) {
            // Some types like Uint8Array and Node.js's Buffer cannot be frozen, but
            // they all throw a TypeError when you try, so we re-throw any exceptions
            // that are not TypeErrors, since that would be unexpected.
            if (e instanceof TypeError)
                return null;
            throw e;
        }
    }
    return obj;
}
//# sourceMappingURL=deepFreeze.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/maybeDeepFreeze.js


/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function maybeDeepFreeze(obj) {
    if (index_production/* __DEV__ */.T) {
        deepFreeze(obj);
    }
    return obj;
}
//# sourceMappingURL=maybeDeepFreeze.js.map

// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/resultKeyNameFromField.js
var resultKeyNameFromField = __webpack_require__(87193);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/masking/utils.js




// Contextual slot that allows us to disable accessor warnings on fields when in
// migrate mode.
/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
const disableWarningsSlot = new lib/* Slot */.g7();
function getFragmentMaskMode(fragment) {
    const directive = fragment.directives?.find(({ name }) => name.value === "unmask");
    if (!directive) {
        return "mask";
    }
    const modeArg = directive.arguments?.find(({ name }) => name.value === "mode");
    if (index_production/* __DEV__ */.T) {
        if (modeArg) {
            if (modeArg.value.kind === kinds/* Kind,VARIABLE */.h.VARIABLE) {
                index_production/* __DEV__ */.T && invariant/* invariant,warn */.kG.warn(44);
            }
            else if (modeArg.value.kind !== kinds/* Kind,STRING */.h.STRING) {
                index_production/* __DEV__ */.T && invariant/* invariant,warn */.kG.warn(45);
            }
            else if (modeArg.value.value !== "migrate") {
                index_production/* __DEV__ */.T && invariant/* invariant,warn */.kG.warn(46, modeArg.value.value);
            }
        }
    }
    if (modeArg &&
        "value" in modeArg.value &&
        modeArg.value.value === "migrate") {
        return "migrate";
    }
    return "unmask";
}
//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/masking/maskDefinition.js





function maskDefinition(data, selectionSet, context) {
    return disableWarningsSlot.withValue(true, () => {
        const masked = maskSelectionSet(data, selectionSet, context, false);
        if (Object.isFrozen(data)) {
            maybeDeepFreeze(masked);
        }
        return masked;
    });
}
function getMutableTarget(data, mutableTargets) {
    if (mutableTargets.has(data)) {
        return mutableTargets.get(data);
    }
    const mutableTarget = Array.isArray(data) ? [] : {};
    mutableTargets.set(data, mutableTarget);
    return mutableTarget;
}
function maskSelectionSet(data, selectionSet, context, migration, path) {
    const { knownChanged } = context;
    const memo = getMutableTarget(data, context.mutableTargets);
    if (Array.isArray(data)) {
        for (const [index, item] of Array.from(data.entries())) {
            if (item === null) {
                memo[index] = null;
                continue;
            }
            const masked = maskSelectionSet(item, selectionSet, context, migration, index_production/* __DEV__ */.T ? `${path || ""}[${index}]` : void 0);
            if (knownChanged.has(masked)) {
                knownChanged.add(memo);
            }
            memo[index] = masked;
        }
        return knownChanged.has(memo) ? memo : data;
    }
    for (const selection of selectionSet.selections) {
        let value;
        // we later want to add accessor warnings to the final result
        // so we need a new object to add the accessor warning to
        if (migration) {
            knownChanged.add(memo);
        }
        if (selection.kind === kinds/* Kind,FIELD */.h.FIELD) {
            const keyName = (0,resultKeyNameFromField/* resultKeyNameFromField */.u)(selection);
            const childSelectionSet = selection.selectionSet;
            value = memo[keyName] || data[keyName];
            if (value === void 0) {
                continue;
            }
            if (childSelectionSet && value !== null) {
                const masked = maskSelectionSet(data[keyName], childSelectionSet, context, migration, index_production/* __DEV__ */.T ? `${path || ""}.${keyName}` : void 0);
                if (knownChanged.has(masked)) {
                    value = masked;
                }
            }
            if (!index_production/* __DEV__ */.T) {
                memo[keyName] = value;
            }
            if (index_production/* __DEV__ */.T) {
                if (migration &&
                    keyName !== "__typename" &&
                    // either the field is not present in the memo object
                    // or it has a `get` descriptor, not a `value` descriptor
                    // => it is a warning accessor and we can overwrite it
                    // with another accessor
                    !Object.getOwnPropertyDescriptor(memo, keyName)?.value) {
                    Object.defineProperty(memo, keyName, getAccessorWarningDescriptor(keyName, value, path || "", context.operationName, context.operationType));
                }
                else {
                    delete memo[keyName];
                    memo[keyName] = value;
                }
            }
        }
        if (selection.kind === kinds/* Kind,INLINE_FRAGMENT */.h.INLINE_FRAGMENT &&
            (!selection.typeCondition ||
                context.cache.fragmentMatches(selection, data.__typename))) {
            value = maskSelectionSet(data, selection.selectionSet, context, migration, path);
        }
        if (selection.kind === kinds/* Kind,FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD) {
            const fragmentName = selection.name.value;
            const fragment = context.fragmentMap[fragmentName] ||
                (context.fragmentMap[fragmentName] =
                    context.cache.lookupFragment(fragmentName));
            (0,invariant/* invariant */.kG)(fragment, 39, fragmentName);
            const mode = getFragmentMaskMode(selection);
            if (mode !== "mask") {
                value = maskSelectionSet(data, fragment.selectionSet, context, mode === "migrate", path);
            }
        }
        if (knownChanged.has(value)) {
            knownChanged.add(memo);
        }
    }
    if ("__typename" in data && !("__typename" in memo)) {
        memo.__typename = data.__typename;
    }
    // This check prevents cases where masked fields may accidentally be
    // returned as part of this object when the fragment also selects
    // additional fields from the same child selection.
    if (Object.keys(memo).length !== Object.keys(data).length) {
        knownChanged.add(memo);
    }
    return knownChanged.has(memo) ? memo : data;
}
function getAccessorWarningDescriptor(fieldName, value, path, operationName, operationType) {
    let getValue = () => {
        if (disableWarningsSlot.getValue()) {
            return value;
        }
        index_production/* __DEV__ */.T && invariant/* invariant,warn */.kG.warn(40, operationName ?
            `${operationType} '${operationName}'`
            : `anonymous ${operationType}`, `${path}.${fieldName}`.replace(/^\./, ""));
        getValue = () => value;
        return value;
    };
    return {
        get() {
            return getValue();
        },
        set(newValue) {
            getValue = () => newValue;
        },
        enumerable: true,
        configurable: true,
    };
}
//# sourceMappingURL=maskDefinition.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/masking/maskOperation.js



/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function maskOperation(data, document, cache) {
    const definition = (0,getOperationDefinition/* getOperationDefinition */.$)(document);
    (0,invariant/* invariant */.kG)(definition, 43);
    if (data == null) {
        // Maintain the original `null` or `undefined` value
        return data;
    }
    return maskDefinition(data, definition.selectionSet, {
        operationType: definition.operation,
        operationName: definition.name?.value,
        fragmentMap: (0,createFragmentMap/* createFragmentMap */.F)((0,getFragmentDefinitions/* getFragmentDefinitions */.k)(document)),
        cache,
        mutableTargets: new WeakMap(),
        knownChanged: new WeakSet(),
    });
}
//# sourceMappingURL=maskOperation.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@wry/equality/lib/index.js
const { toString: lib_toString, hasOwnProperty: equality_lib_hasOwnProperty } = Object.prototype;
const fnToStr = Function.prototype.toString;
const previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */
function equal(a, b) {
    try {
        return check(a, b);
    }
    finally {
        previousComparisons.clear();
    }
}
// Allow default imports as well.
/* ESM default export */ const equality_lib = ((/* unused pure expression or super */ null && (equal)));
function check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) {
        return true;
    }
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    const aTag = lib_toString.call(a);
    const bTag = lib_toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) {
        return false;
    }
    switch (aTag) {
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length)
                return false;
        // Fall through to object case...
        case '[object Object]': {
            if (previouslyCompared(a, b))
                return true;
            const aKeys = definedKeys(a);
            const bKeys = definedKeys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            const keyCount = aKeys.length;
            if (keyCount !== bKeys.length)
                return false;
            // Now make sure they have the same keys.
            for (let k = 0; k < keyCount; ++k) {
                if (!equality_lib_hasOwnProperty.call(b, aKeys[k])) {
                    return false;
                }
            }
            // Finally, check deep equality of all child properties.
            for (let k = 0; k < keyCount; ++k) {
                const key = aKeys[k];
                if (!check(a[key], b[key])) {
                    return false;
                }
            }
            return true;
        }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a)
                return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == `${b}`;
        case '[object Map]':
        case '[object Set]': {
            if (a.size !== b.size)
                return false;
            if (previouslyCompared(a, b))
                return true;
            const aIterator = a.entries();
            const isMap = aTag === '[object Map]';
            while (true) {
                const info = aIterator.next();
                if (info.done)
                    break;
                // If a instanceof Set, aValue === aKey.
                const [aKey, aValue] = info.value;
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) {
                    return false;
                }
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !check(aValue, b.get(aKey))) {
                    return false;
                }
            }
            return true;
        }
        case '[object Uint16Array]':
        case '[object Uint8Array]': // Buffer, in Node.js.
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]': {
            let len = a.byteLength;
            if (len === b.byteLength) {
                while (len-- && a[len] === b[len]) {
                    // Keep looping as long as the bytes are equal.
                }
            }
            return len === -1;
        }
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]': {
            const aCode = fnToStr.call(a);
            if (aCode !== fnToStr.call(b)) {
                return false;
            }
            // We consider non-native functions equal if they have the same code
            // (native functions require === because their code is censored).
            // Note that this behavior is not entirely sound, since !== function
            // objects with the same code can behave differently depending on
            // their closure scope. However, any function can behave differently
            // depending on the values of its input arguments (including this)
            // and its calling context (including its closure scope), even
            // though the function object is === to itself; and it is entirely
            // possible for functions that are not === to behave exactly the
            // same under all conceivable circumstances. Because none of these
            // factors are statically decidable in JavaScript, JS function
            // equality is not well-defined. This ambiguity allows us to
            // consider the best possible heuristic among various imperfect
            // options, and equating non-native functions that have the same
            // code has enormous practical benefits, such as when comparing
            // functions that are repeatedly passed as fresh function
            // expressions within objects that are otherwise deeply equal. Since
            // any function created from the same syntactic expression (in the
            // same code location) will always stringify to the same code
            // according to fnToStr.call, we can reasonably expect these
            // repeatedly passed function expressions to have the same code, and
            // thus behave "the same" (with all the caveats mentioned above),
            // even though the runtime function objects are !== to one another.
            return !endsWith(aCode, nativeCodeSuffix);
        }
    }
    // Otherwise the values are not equal.
    return false;
}
function definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter(isDefinedKey, obj);
}
function isDefinedKey(key) {
    return this[key] !== void 0;
}
const nativeCodeSuffix = "{ [native code] }";
function endsWith(full, suffix) {
    const fromIndex = full.length - suffix.length;
    return fromIndex >= 0 &&
        full.indexOf(suffix, fromIndex) === fromIndex;
}
function previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    let bSet = previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b))
            return true;
    }
    else {
        previousComparisons.set(a, bSet = new Set);
    }
    bSet.add(b);
    return false;
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/masking/maskFragment.js





/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function maskFragment(data, document, cache, fragmentName) {
    const fragments = document.definitions.filter((node) => node.kind === kinds/* Kind,FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION);
    if (typeof fragmentName === "undefined") {
        (0,invariant/* invariant */.kG)(fragments.length === 1, 41, fragments.length);
        fragmentName = fragments[0].name.value;
    }
    const fragment = fragments.find((fragment) => fragment.name.value === fragmentName);
    (0,invariant/* invariant */.kG)(!!fragment, 42, fragmentName);
    if (data == null) {
        // Maintain the original `null` or `undefined` value
        return data;
    }
    if (equal(data, {})) {
        // Return early and skip the masking algorithm if we don't have any data
        // yet. This can happen when cache.diff returns an empty object which is
        // used from watchFragment.
        return data;
    }
    return maskDefinition(data, fragment.selectionSet, {
        operationType: "fragment",
        operationName: fragment.name.value,
        fragmentMap: (0,createFragmentMap/* createFragmentMap */.F)((0,getFragmentDefinitions/* getFragmentDefinitions */.k)(document)),
        cache,
        mutableTargets: new WeakMap(),
        knownChanged: new WeakSet(),
    });
}
//# sourceMappingURL=maskFragment.js.map

// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/graphql/print.js + 2 modules
var graphql_print = __webpack_require__(60827);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/isNetworkRequestSettled.js
/**
 * Returns true if the network request is in ready or error state according to a given network
 * status.
 */
function isNetworkRequestSettled(networkStatus) {
    return networkStatus === 7 || networkStatus === 8;
}
//# sourceMappingURL=isNetworkRequestSettled.js.map
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/isNetworkRequestInFlight.js

/**
 * Returns true if there is currently a network request in flight according to a given network
 * status.
 */
function isNetworkRequestInFlight(networkStatus) {
    return !isNetworkRequestSettled(networkStatus);
}
//# sourceMappingURL=isNetworkRequestInFlight.js.map
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/getOperationName.js
var getOperationName = __webpack_require__(26802);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/graphQLResultHasError.js
/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function graphQLResultHasError(result) {
    return !!result.errors?.length;
}
//# sourceMappingURL=graphQLResultHasError.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/filterMap.js

function filterMap(fn, makeContext = () => undefined) {
    return (source) => new Observable/* Observable */.y((subscriber) => {
        let context = makeContext();
        return source.subscribe({
            next(value) {
                let result;
                try {
                    result = fn(value, context);
                }
                catch (e) {
                    subscriber.error(e);
                }
                if (result === undefined) {
                    return;
                }
                subscriber.next(result);
            },
            error(err) {
                subscriber.error(err);
            },
            complete() {
                subscriber.complete();
            },
        });
    });
}
//# sourceMappingURL=filterMap.js.map
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/toQueryResult.js
/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function toQueryResult(value) {
    const result = {
        data: value.data,
    };
    if (value.error) {
        result.error = value.error;
    }
    return result;
}
//# sourceMappingURL=toQueryResult.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/hasForcedResolvers.js

function hasForcedResolvers(document) {
    let forceResolvers = false;
    (0,visitor/* visit */.Vn)(document, {
        Directive: {
            enter(node) {
                if (node.name.value === "client" && node.arguments) {
                    forceResolvers = node.arguments.some((arg) => arg.name.value === "always" &&
                        arg.value.kind === "BooleanValue" &&
                        arg.value.value === true);
                    if (forceResolvers) {
                        return visitor/* BREAK */.$_;
                    }
                }
            },
        },
    });
    return forceResolvers;
}
//# sourceMappingURL=hasForcedResolvers.js.map
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/getFragmentDefinition.js

/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function getFragmentDefinition(doc) {
    (0,invariant/* invariant */.kG)(doc.kind === "Document", 6);
    (0,invariant/* invariant */.kG)(doc.definitions.length <= 1, 7);
    const fragmentDef = doc.definitions[0];
    (0,invariant/* invariant */.kG)(fragmentDef.kind === "FragmentDefinition", 8);
    return fragmentDef;
}
//# sourceMappingURL=getFragmentDefinition.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/isArray.js
/**
* A version of Array.isArray that works better with readonly arrays.
*
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
const isArray = Array.isArray;
//# sourceMappingURL=isArray.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/isNonEmptyArray.js
/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
//# sourceMappingURL=isNonEmptyArray.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/removeDirectivesFromDocument.js









/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function removeDirectivesFromDocument(directives, doc) {
    (0,checkDocument/* checkDocument */.A)(doc);
    // Passing empty strings to makeInUseGetterFunction means we handle anonymous
    // operations as if their names were "". Anonymous fragment definitions are
    // not supposed to be possible, but the same default naming strategy seems
    // appropriate for that case as well.
    const getInUseByOperationName = makeInUseGetterFunction("");
    const getInUseByFragmentName = makeInUseGetterFunction("");
    const getInUse = (ancestors) => {
        for (let p = 0, ancestor; p < ancestors.length && (ancestor = ancestors[p]); ++p) {
            if (isArray(ancestor))
                continue;
            if (ancestor.kind === kinds/* Kind,OPERATION_DEFINITION */.h.OPERATION_DEFINITION) {
                // If an operation is anonymous, we use the empty string as its key.
                return getInUseByOperationName(ancestor.name && ancestor.name.value);
            }
            if (ancestor.kind === kinds/* Kind,FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION) {
                return getInUseByFragmentName(ancestor.name.value);
            }
        }
        invariant/* invariant,error */.kG.error(14);
        return null;
    };
    let operationCount = 0;
    for (let i = doc.definitions.length - 1; i >= 0; --i) {
        if (doc.definitions[i].kind === kinds/* Kind,OPERATION_DEFINITION */.h.OPERATION_DEFINITION) {
            ++operationCount;
        }
    }
    const directiveMatcher = getDirectiveMatcher(directives);
    const shouldRemoveField = (nodeDirectives) => isNonEmptyArray(nodeDirectives) &&
        nodeDirectives
            .map(directiveMatcher)
            .some((config) => config && config.remove);
    const originalFragmentDefsByPath = new Map();
    // Any time the first traversal of the document below makes a change like
    // removing a fragment (by returning null), this variable should be set to
    // true. Once it becomes true, it should never be set to false again. If this
    // variable remains false throughout the traversal, then we can return the
    // original doc immediately without any modifications.
    let firstVisitMadeChanges = false;
    const fieldOrInlineFragmentVisitor = {
        enter(node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        },
    };
    const docWithoutDirectiveSubtrees = (0,visitor/* visit */.Vn)(doc, {
        // These two AST node types share the same implementation, defined above.
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter() {
                // VariableDefinition nodes do not count as variables in use, though
                // they do contain Variable nodes that might be visited below. To avoid
                // counting variable declarations as usages, we skip visiting the
                // contents of this VariableDefinition node by returning false.
                return false;
            },
        },
        Variable: {
            enter(node, _key, _parent, _path, ancestors) {
                const inUse = getInUse(ancestors);
                if (inUse) {
                    inUse.variables.add(node.name.value);
                }
            },
        },
        FragmentSpread: {
            enter(node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                const inUse = getInUse(ancestors);
                if (inUse) {
                    inUse.fragmentSpreads.add(node.name.value);
                }
                // We might like to remove this FragmentSpread by returning null here if
                // the corresponding FragmentDefinition node is also going to be removed
                // by the logic below, but we can't control the relative order of those
                // events, so we have to postpone the removal of dangling FragmentSpread
                // nodes until after the current visit of the document has finished.
            },
        },
        FragmentDefinition: {
            enter(node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave(node, _key, _parent, path) {
                const originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) {
                    // If the FragmentNode received by this leave function is identical to
                    // the one received by the corresponding enter function (above), then
                    // the visitor must not have made any changes within this
                    // FragmentDefinition node. This fragment definition may still be
                    // removed if there are no ...spread references to it, but it won't be
                    // removed just because it has only a __typename field.
                    return node;
                }
                if (
                // This logic applies only if the document contains one or more
                // operations, since removing all fragments from a document containing
                // only fragments makes the document useless.
                operationCount > 0 &&
                    node.selectionSet.selections.every((selection) => selection.kind === kinds/* Kind,FIELD */.h.FIELD &&
                        selection.name.value === "__typename")) {
                    // This is a somewhat opinionated choice: if a FragmentDefinition ends
                    // up having no fields other than __typename, we remove the whole
                    // fragment definition, and later prune ...spread references to it.
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            },
        },
        Directive: {
            leave(node) {
                // If a matching directive is found, remove the directive itself. Note
                // that this does not remove the target (field, argument, etc) of the
                // directive, but only the directive itself.
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            },
        },
    });
    if (!firstVisitMadeChanges) {
        // If our first pass did not change anything about the document, then there
        // is no cleanup we need to do, and we can return the original doc.
        return doc;
    }
    // Utility for making sure inUse.transitiveVars is recursively populated.
    // Because this logic assumes inUse.fragmentSpreads has been completely
    // populated and inUse.removed has been set if appropriate,
    // populateTransitiveVars must be called after that information has been
    // collected by the first traversal of the document.
    const populateTransitiveVars = (inUse) => {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) {
                inUse.fragmentSpreads.forEach((childFragmentName) => {
                    populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach((varName) => {
                        inUse.transitiveVars.add(varName);
                    });
                });
            }
        }
        return inUse;
    };
    // Since we've been keeping track of fragment spreads used by particular
    // operations and fragment definitions, we now need to compute the set of all
    // spreads used (transitively) by any operations in the document.
    const allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach((def) => {
        if (def.kind === kinds/* Kind,OPERATION_DEFINITION */.h.OPERATION_DEFINITION) {
            populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach((childFragmentName) => {
                allFragmentNamesUsed.add(childFragmentName);
            });
        }
        else if (def.kind === kinds/* Kind,FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION &&
            // If there are no operations in the document, then all fragment
            // definitions count as usages of their own fragment names. This heuristic
            // prevents accidentally removing all fragment definitions from the
            // document just because it contains no operations that use the fragments.
            operationCount === 0 &&
            !getInUseByFragmentName(def.name.value).removed) {
            allFragmentNamesUsed.add(def.name.value);
        }
    });
    // Now that we have added all fragment spreads used by operations to the
    // allFragmentNamesUsed set, we can complete the set by transitively adding
    // all fragment spreads used by those fragments, and so on.
    allFragmentNamesUsed.forEach((fragmentName) => {
        // Once all the childFragmentName strings added here have been seen already,
        // the top-level allFragmentNamesUsed.forEach loop will terminate.
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach((childFragmentName) => {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    const fragmentWillBeRemoved = (fragmentName) => !!(
    // A fragment definition will be removed if there are no spreads that refer
    // to it, or the fragment was explicitly removed because it had no fields
    // other than __typename.
    (!allFragmentNamesUsed.has(fragmentName) ||
        getInUseByFragmentName(fragmentName).removed));
    const enterVisitor = {
        enter(node) {
            if (fragmentWillBeRemoved(node.name.value)) {
                return null;
            }
        },
    };
    return nullIfDocIsEmpty((0,visitor/* visit */.Vn)(docWithoutDirectiveSubtrees, {
        // If the fragment is going to be removed, then leaving any dangling
        // FragmentSpread nodes with the same name would be a mistake.
        FragmentSpread: enterVisitor,
        // This is where the fragment definition is actually removed.
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave(node) {
                // Upon leaving each operation in the depth-first AST traversal, prune
                // any variables that are declared by the operation but unused within.
                if (node.variableDefinitions) {
                    const usedVariableNames = populateTransitiveVars(
                    // If an operation is anonymous, we use the empty string as its key.
                    getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    // According to the GraphQL spec, all variables declared by an
                    // operation must either be used by that operation or used by some
                    // fragment included transitively into that operation:
                    // https://spec.graphql.org/draft/#sec-All-Variables-Used
                    //
                    // To stay on the right side of this validation rule, if/when we
                    // remove the last $var references from an operation or its fragments,
                    // we must also remove the corresponding $var declaration from the
                    // enclosing operation. This pruning applies only to operations and
                    // not fragment definitions, at the moment. Fragments may be able to
                    // declare variables eventually, but today they can only consume them.
                    if (usedVariableNames.size < node.variableDefinitions.length) {
                        return {
                            ...node,
                            variableDefinitions: node.variableDefinitions.filter((varDef) => usedVariableNames.has(varDef.variable.name.value)),
                        };
                    }
                }
            },
        },
    }));
}
function makeInUseGetterFunction(defaultKey) {
    const map = new Map();
    return function inUseGetterFunction(key = defaultKey) {
        let inUse = map.get(key);
        if (!inUse) {
            map.set(key, (inUse = {
                // Variable and fragment spread names used directly within this
                // operation or fragment definition, as identified by key. These sets
                // will be populated during the first traversal of the document in
                // removeDirectivesFromDocument below.
                variables: new Set(),
                fragmentSpreads: new Set(),
            }));
        }
        return inUse;
    };
}
function getDirectiveMatcher(configs) {
    const names = new Map();
    const tests = new Map();
    configs.forEach((directive) => {
        if (directive) {
            if (directive.name) {
                names.set(directive.name, directive);
            }
            else if (directive.test) {
                tests.set(directive.test, directive);
            }
        }
    });
    return (directive) => {
        let config = names.get(directive.name.value);
        if (!config && tests.size) {
            tests.forEach((testConfig, test) => {
                if (test(directive)) {
                    config = testConfig;
                }
            });
        }
        return config;
    };
}
function isEmpty(op, fragmentMap) {
    return (!op ||
        op.selectionSet.selections.every((selection) => selection.kind === kinds/* Kind,FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD &&
            isEmpty(fragmentMap[selection.name.value], fragmentMap)));
}
function nullIfDocIsEmpty(doc) {
    return (isEmpty((0,getOperationDefinition/* getOperationDefinition */.$)(doc) || getFragmentDefinition(doc), (0,createFragmentMap/* createFragmentMap */.F)((0,getFragmentDefinitions/* getFragmentDefinitions */.k)(doc)))) ?
        null
        : doc;
}
//# sourceMappingURL=removeDirectivesFromDocument.js.map

// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/valueToObjectRepresentation.js
var valueToObjectRepresentation = __webpack_require__(21124);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/getDefaultValues.js

/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function getDefaultValues(definition) {
    const defaultValues = {};
    const defs = definition && definition.variableDefinitions;
    if (defs && defs.length) {
        defs.forEach((def) => {
            if (def.defaultValue) {
                (0,valueToObjectRepresentation/* valueToObjectRepresentation */.v)(defaultValues, def.variable.name, def.defaultValue);
            }
        });
    }
    return defaultValues;
}
//# sourceMappingURL=getDefaultValues.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/isDocumentNode.js

/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function isDocumentNode(value) {
    return ((0,isNonNullObject/* isNonNullObject */.s)(value) &&
        value.kind === "Document" &&
        Array.isArray(value.definitions));
}
//# sourceMappingURL=isDocumentNode.js.map

// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/makeUniqueId.js
var makeUniqueId = __webpack_require__(7671);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/core/networkStatus.js
/**
 * The current status of a query’s execution in our system.
 */
var networkStatus_NetworkStatus;
(function (NetworkStatus) {
    /**
     * The query has never been run before and the query is now currently running. A query will still
     * have this network status even if a partial data result was returned from the cache, but a
     * query was dispatched anyway.
     */
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    /**
     * If `setVariables` was called and a query was fired because of that then the network status
     * will be `setVariables` until the result of that query comes back.
     */
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    /**
     * Indicates that `fetchMore` was called on this query and that the query created is currently in
     * flight.
     */
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    /**
     * Similar to the `setVariables` network status. It means that `refetch` was called on a query
     * and the refetch request is currently in flight.
     */
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    /**
     * Indicates that a polling query is currently in flight. So for example if you are polling a
     * query every 10 seconds then the network status will switch to `poll` every 10 seconds whenever
     * a poll request has been sent but not resolved.
     */
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    /**
     * No request is in flight for this query, and no errors happened. Everything is OK.
     */
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    /**
     * No request is in flight for this query, but one or more errors were detected.
     */
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
    /**
     * Indicates that a `@defer` query has received at least the first chunk of
     * the result but the full result has not yet been fully streamed to the
     * client.
     */
    NetworkStatus[NetworkStatus["streaming"] = 9] = "streaming";
})(networkStatus_NetworkStatus || (networkStatus_NetworkStatus = {}));
//# sourceMappingURL=networkStatus.js.map
;// CONCATENATED MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/BehaviorSubject.js


var BehaviorSubject_BehaviorSubject = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function () {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function (subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function () {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) {
            throw thrownError;
        }
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function (value) {
        _super.prototype.next.call(this, (this._value = value));
    };
    return BehaviorSubject;
}(Subject_Subject));

//# sourceMappingURL=BehaviorSubject.js.map
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/getFragmentFromSelection.js

/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function getFragmentFromSelection(selection, fragmentMap) {
    switch (selection.kind) {
        case "InlineFragment":
            return selection;
        case "FragmentSpread": {
            const fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") {
                return fragmentMap(fragmentName);
            }
            const fragment = fragmentMap && fragmentMap[fragmentName];
            (0,invariant/* invariant */.kG)(fragment, 9, fragmentName);
            return fragment || null;
        }
        default:
            return null;
    }
}
//# sourceMappingURL=getFragmentFromSelection.js.map

// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/getMainDefinition.js
var getMainDefinition = __webpack_require__(2918);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/isField.js
/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function isField(selection) {
    return selection.kind === "Field";
}
//# sourceMappingURL=isField.js.map

// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/shouldInclude.js
var shouldInclude = __webpack_require__(32303);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/equalByQuery.js








// Returns true if aResult and bResult are deeply equal according to the fields
// selected by the given query, ignoring any fields marked as @nonreactive.
function equalByQuery(query, { data: aData, ...aRest }, { data: bData, ...bRest }, variables) {
    return (equal(aRest, bRest) &&
        equalBySelectionSet((0,getMainDefinition/* getMainDefinition */.p)(query).selectionSet, aData, bData, {
            fragmentMap: (0,createFragmentMap/* createFragmentMap */.F)((0,getFragmentDefinitions/* getFragmentDefinitions */.k)(query)),
            variables,
        }));
}
function equalBySelectionSet(selectionSet, aResult, bResult, context) {
    if (aResult === bResult) {
        return true;
    }
    const seenSelections = new Set();
    // Returning true from this Array.prototype.every callback function skips the
    // current field/subtree. Returning false aborts the entire traversal
    // immediately, causing equalBySelectionSet to return false.
    return selectionSet.selections.every((selection) => {
        // Avoid re-processing the same selection at the same level of recursion, in
        // case the same field gets included via multiple indirect fragment spreads.
        if (seenSelections.has(selection))
            return true;
        seenSelections.add(selection);
        // Ignore @skip(if: true) and @include(if: false) fields.
        if (!(0,shouldInclude/* shouldInclude */.L)(selection, context.variables))
            return true;
        // If the field or (named) fragment spread has a @nonreactive directive on
        // it, we don't care if it's different, so we pretend it's the same.
        if (selectionHasNonreactiveDirective(selection))
            return true;
        if (isField(selection)) {
            const resultKey = (0,resultKeyNameFromField/* resultKeyNameFromField */.u)(selection);
            const aResultChild = aResult && aResult[resultKey];
            const bResultChild = bResult && bResult[resultKey];
            const childSelectionSet = selection.selectionSet;
            if (!childSelectionSet) {
                // These are scalar values, so we can compare them with deep equal
                // without redoing the main recursive work.
                return equal(aResultChild, bResultChild);
            }
            const aChildIsArray = Array.isArray(aResultChild);
            const bChildIsArray = Array.isArray(bResultChild);
            if (aChildIsArray !== bChildIsArray)
                return false;
            if (aChildIsArray && bChildIsArray) {
                const length = aResultChild.length;
                if (bResultChild.length !== length) {
                    return false;
                }
                for (let i = 0; i < length; ++i) {
                    if (!equalBySelectionSet(childSelectionSet, aResultChild[i], bResultChild[i], context)) {
                        return false;
                    }
                }
                return true;
            }
            return equalBySelectionSet(childSelectionSet, aResultChild, bResultChild, context);
        }
        else {
            const fragment = getFragmentFromSelection(selection, context.fragmentMap);
            if (fragment) {
                // The fragment might === selection if it's an inline fragment, but
                // could be !== if it's a named fragment ...spread.
                if (selectionHasNonreactiveDirective(fragment))
                    return true;
                return equalBySelectionSet(fragment.selectionSet, 
                // Notice that we reuse the same aResult and bResult values here,
                // since the fragment ...spread does not specify a field name, but
                // consists of multiple fields (within the fragment's selection set)
                // that should be applied to the current result value(s).
                aResult, bResult, context);
            }
        }
    });
}
function selectionHasNonreactiveDirective(selection) {
    return (!!selection.directives && selection.directives.some(directiveIsNonreactive));
}
function directiveIsNonreactive(dir) {
    return dir.name.value === "nonreactive";
}
//# sourceMappingURL=equalByQuery.js.map
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/getQueryDefinition.js


/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function getQueryDefinition(doc) {
    const queryDef = (0,getOperationDefinition/* getOperationDefinition */.$)(doc);
    (0,invariant/* invariant */.kG)(queryDef && queryDef.operation === "query", 13);
    return queryDef;
}
//# sourceMappingURL=getQueryDefinition.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/preventUnhandledRejection.js
function preventUnhandledRejection(promise) {
    promise.catch(() => { });
    return promise;
}
//# sourceMappingURL=preventUnhandledRejection.js.map
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/core/ObservableQuery.js







const { assign: ObservableQuery_assign, hasOwnProperty: ObservableQuery_hasOwnProperty } = Object;
const uninitialized = {
    loading: true,
    networkStatus: networkStatus_NetworkStatus.loading,
    data: undefined,
    dataState: "empty",
    partial: true,
};
const ObservableQuery_empty = {
    loading: false,
    networkStatus: networkStatus_NetworkStatus.ready,
    data: undefined,
    dataState: "empty",
    partial: true,
};
class ObservableQuery {
    options;
    queryName;
    /**
    * @internal will be read and written from `QueryInfo`
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */
    _lastWrite;
    // The `query` computed property will always reflect the document transformed
    // by the last run query. `this.options.query` will always reflect the raw
    // untransformed query to ensure document transforms with runtime conditionals
    // are run on the original document.
    get query() {
        return this.lastQuery;
    }
    /**
     * An object containing the variables that were provided for the query.
     */
    get variables() {
        return this.options.variables;
    }
    unsubscribeFromCache;
    input;
    subject;
    isTornDown;
    queryManager;
    subscriptions = new Set();
    /**
     * If an `ObservableQuery` is created with a `network-only` fetch policy,
     * it should actually start receiving cache updates, but not before it has
     * received the first result from the network.
     */
    waitForNetworkResult;
    lastQuery;
    linkSubscription;
    pollingInfo;
    get networkStatus() {
        return this.subject.getValue().result.networkStatus;
    }
    constructor({ queryManager, options, transformedQuery = queryManager.transform(options.query), }) {
        this.queryManager = queryManager;
        // active state
        this.waitForNetworkResult = options.fetchPolicy === "network-only";
        this.isTornDown = false;
        this.subscribeToMore = this.subscribeToMore.bind(this);
        this.maskResult = this.maskResult.bind(this);
        const { watchQuery: { fetchPolicy: defaultFetchPolicy = "cache-first" } = {}, } = queryManager.defaultOptions;
        const { fetchPolicy = defaultFetchPolicy, 
        // Make sure we don't store "standby" as the initialFetchPolicy.
        initialFetchPolicy = fetchPolicy === "standby" ? defaultFetchPolicy : (fetchPolicy), } = options;
        this.lastQuery = transformedQuery;
        this.options = {
            ...options,
            // Remember the initial options.fetchPolicy so we can revert back to this
            // policy when variables change. This information can also be specified
            // (or overridden) by providing options.initialFetchPolicy explicitly.
            initialFetchPolicy,
            // This ensures this.options.fetchPolicy always has a string value, in
            // case options.fetchPolicy was not provided.
            fetchPolicy,
            variables: this.getVariablesWithDefaults(options.variables),
        };
        this.initializeObservablesQueue();
        this["@@observable"] = () => this;
        if (Symbol.observable) {
            this[Symbol.observable] = () => this;
        }
        const opDef = (0,getOperationDefinition/* getOperationDefinition */.$)(this.query);
        this.queryName = opDef && opDef.name && opDef.name.value;
    }
    initializeObservablesQueue() {
        this.subject = new BehaviorSubject_BehaviorSubject({
            query: this.query,
            variables: this.variables,
            result: uninitialized,
            meta: {},
        });
        const observable = this.subject.pipe(tap({
            subscribe: () => {
                if (!this.subject.observed) {
                    this.reobserve();
                    // TODO: See if we can rework updatePolling to better handle this.
                    // reobserve calls updatePolling but this `subscribe` callback is
                    // called before the subject is subscribed to so `updatePolling`
                    // can't accurately detect if there is an active subscription.
                    // Calling it again here ensures that it can detect if it can poll
                    setTimeout(() => this.updatePolling());
                }
            },
            unsubscribe: () => {
                if (!this.subject.observed) {
                    this.tearDownQuery();
                }
            },
        }), filterMap(({ query, variables, result: current, meta }, context) => {
            const { shouldEmit } = meta;
            if (current === uninitialized) {
                // reset internal state after `ObservableQuery.reset()`
                context.previous = undefined;
                context.previousVariables = undefined;
            }
            if (this.options.fetchPolicy === "standby" ||
                shouldEmit === 2 /* EmitBehavior.never */)
                return;
            if (shouldEmit === 1 /* EmitBehavior.force */)
                return emit();
            const { previous, previousVariables } = context;
            if (previous) {
                const documentInfo = this.queryManager.getDocumentInfo(query);
                const dataMasking = this.queryManager.dataMasking;
                const maskedQuery = dataMasking ? documentInfo.nonReactiveQuery : query;
                const resultIsEqual = dataMasking || documentInfo.hasNonreactiveDirective ?
                    equalByQuery(maskedQuery, previous, current, variables)
                    : equal(previous, current);
                if (resultIsEqual && equal(previousVariables, variables)) {
                    return;
                }
            }
            if (shouldEmit === 3 /* EmitBehavior.networkStatusChange */ &&
                (!this.options.notifyOnNetworkStatusChange ||
                    equal(previous, current))) {
                return;
            }
            return emit();
            function emit() {
                context.previous = current;
                context.previousVariables = variables;
                return current;
            }
        }, () => ({})));
        this.pipe = observable.pipe.bind(observable);
        this.subscribe = observable.subscribe.bind(observable);
        this.input = new Subject_Subject();
        // we want to feed many streams into `this.subject`, but none of them should
        // be able to close `this.input`
        this.input.complete = () => { };
        this.input.pipe(this.operator).subscribe(this.subject);
    }
    // We can't use Observable['subscribe'] here as the type as it conflicts with
    // the ability to infer T from Subscribable<T>. This limits the surface area
    // to the non-deprecated signature which works properly with type inference.
    /**
     * Subscribes to the `ObservableQuery`.
     * @param observerOrNext - Either an RxJS `Observer` with some or all callback methods,
     * or the `next` handler that is called for each value emitted from the subscribed Observable.
     * @returns A subscription reference to the registered handlers.
     */
    subscribe;
    /**
     * Used to stitch together functional operators into a chain.
     *
     * @example
     *
     * ```ts
     * import { filter, map } from 'rxjs';
     *
     * observableQuery
     *   .pipe(
     *     filter(...),
     *     map(...),
     *   )
     *   .subscribe(x => console.log(x));
     * ```
     *
     * @returns The Observable result of all the operators having been called
     * in the order they were passed in.
     */
    pipe;
    [Symbol.observable];
    ["@@observable"];
    /**
    * @internal
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */
    getCacheDiff({ optimistic = true } = {}) {
        return this.queryManager.cache.diff({
            query: this.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic,
        });
    }
    getInitialResult(initialFetchPolicy) {
        const fetchPolicy = this.queryManager.prioritizeCacheValues ?
            "cache-first"
            : initialFetchPolicy || this.options.fetchPolicy;
        const cacheResult = () => {
            const diff = this.getCacheDiff();
            // TODO: queryInfo.getDiff should handle this since cache.diff returns a
            // null when returnPartialData is false
            const data = this.options.returnPartialData || diff.complete ?
                diff.result ?? undefined
                : undefined;
            return this.maskResult({
                data,
                dataState: diff.complete ? "complete"
                    : data === undefined ? "empty"
                        : "partial",
                loading: !diff.complete,
                networkStatus: diff.complete ? networkStatus_NetworkStatus.ready : networkStatus_NetworkStatus.loading,
                partial: !diff.complete,
            });
        };
        switch (fetchPolicy) {
            case "cache-only": {
                return {
                    ...cacheResult(),
                    loading: false,
                    networkStatus: networkStatus_NetworkStatus.ready,
                };
            }
            case "cache-first":
                return cacheResult();
            case "cache-and-network":
                return {
                    ...cacheResult(),
                    loading: true,
                    networkStatus: networkStatus_NetworkStatus.loading,
                };
            case "standby":
                return ObservableQuery_empty;
            default:
                return uninitialized;
        }
    }
    resubscribeCache() {
        const { variables, fetchPolicy } = this.options;
        const query = this.query;
        const shouldUnsubscribe = fetchPolicy === "standby" ||
            fetchPolicy === "no-cache" ||
            this.waitForNetworkResult;
        const shouldResubscribe = !isEqualQuery({ query, variables }, this.unsubscribeFromCache) &&
            !this.waitForNetworkResult;
        if (shouldUnsubscribe || shouldResubscribe) {
            this.unsubscribeFromCache?.();
        }
        if (shouldUnsubscribe || !shouldResubscribe) {
            return;
        }
        const watch = {
            query,
            variables,
            optimistic: true,
            watcher: this,
            callback: (diff) => {
                const info = this.queryManager.getDocumentInfo(query);
                if (info.hasClientExports || info.hasForcedResolvers) {
                    // If this is not set to something different than `diff`, we will
                    // not be notified about future cache changes with an equal `diff`.
                    // That would be the case if we are working with client-only fields
                    // that are forced or with `exports` fields that might change, causing
                    // local resolvers to return a new result.
                    // This is based on an implementation detail of `InMemoryCache`, which
                    // is not optimal - but the only alternative to this would be to
                    // resubscribe to the cache asynchonouly, which would bear the risk of
                    // missing further synchronous updates.
                    watch.lastDiff = undefined;
                }
                if (watch.lastOwnDiff === diff) {
                    // skip cache updates that were caused by our own writes
                    return;
                }
                const { result: previousResult } = this.subject.getValue();
                if (!diff.complete &&
                    // If we are trying to deliver an incomplete cache result, we avoid
                    // reporting it if the query has errored, otherwise we let the broadcast try
                    // and repair the partial result by refetching the query. This check avoids
                    // a situation where a query that errors and another succeeds with
                    // overlapping data does not report the partial data result to the errored
                    // query.
                    //
                    // See https://github.com/apollographql/apollo-client/issues/11400 for more
                    // information on this issue.
                    (previousResult.error ||
                        // Prevent to schedule a notify directly after the `ObservableQuery`
                        // has been `reset` (which will set the `previousResult` to `uninitialized` or `empty`)
                        // as in those cases, `resetCache` will manually call `refetch` with more intentional timing.
                        previousResult === uninitialized ||
                        previousResult === ObservableQuery_empty)) {
                    return;
                }
                if (!equal(previousResult.data, diff.result)) {
                    this.scheduleNotify();
                }
            },
        };
        const cancelWatch = this.queryManager.cache.watch(watch);
        this.unsubscribeFromCache = Object.assign(() => {
            this.unsubscribeFromCache = undefined;
            cancelWatch();
        }, { query, variables });
    }
    stableLastResult;
    getCurrentResult() {
        const { result: current } = this.subject.getValue();
        let value = (
        // if the `current` result is in an error state, we will always return that
        // error state, even if we have no observers
        (current.networkStatus === networkStatus_NetworkStatus.error ||
            // if we have observers, we are watching the cache and
            // this.subject.getValue() will always be up to date
            this.hasObservers() || // if we are using a `no-cache` fetch policy in which case this
        // `ObservableQuery` cannot have been updated from the outside - in
        // that case, we prefer to keep the current value
        this.options.fetchPolicy === "no-cache")) ?
            current
            // otherwise, the `current` value might be outdated due to missed
            // external updates - calculate it again
            : this.getInitialResult();
        if (value === uninitialized) {
            value = this.getInitialResult();
        }
        if (!equal(this.stableLastResult, value)) {
            this.stableLastResult = value;
        }
        return this.stableLastResult;
    }
    /**
     * Update the variables of this observable query, and fetch the new results.
     * This method should be preferred over `setVariables` in most use cases.
     *
     * Returns a `ResultPromise` with an additional `.retain()` method. Calling
     * `.retain()` keeps the network operation running even if the `ObservableQuery`
     * no longer requires the result.
     *
     * Note: `refetch()` guarantees that a value will be emitted from the
     * observable, even if the result is deep equal to the previous value.
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */
    refetch(variables) {
        const { fetchPolicy } = this.options;
        const reobserveOptions = {
            // Always disable polling for refetches.
            pollInterval: 0,
        };
        // Unless the provided fetchPolicy always consults the network
        // (no-cache, network-only, or cache-and-network), override it with
        // network-only to force the refetch for this fetchQuery call.
        if (fetchPolicy === "no-cache") {
            reobserveOptions.fetchPolicy = "no-cache";
        }
        else {
            reobserveOptions.fetchPolicy = "network-only";
        }
        if (index_production/* __DEV__ */.T && variables && ObservableQuery_hasOwnProperty.call(variables, "variables")) {
            const queryDef = getQueryDefinition(this.query);
            const vars = queryDef.variableDefinitions;
            if (!vars || !vars.some((v) => v.variable.name.value === "variables")) {
                index_production/* __DEV__ */.T && invariant/* invariant,warn */.kG.warn(77, variables, queryDef.name?.value || queryDef);
            }
        }
        if (variables && !equal(this.variables, variables)) {
            // Update the existing options with new variables
            reobserveOptions.variables = this.options.variables =
                this.getVariablesWithDefaults({ ...this.variables, ...variables });
        }
        this._lastWrite = undefined;
        return this._reobserve(reobserveOptions, {
            newNetworkStatus: networkStatus_NetworkStatus.refetch,
        });
    }
    fetchMore({ query, variables, context, errorPolicy, updateQuery, }) {
        (0,invariant/* invariant */.kG)(
            this.options.fetchPolicy !== "cache-only",
            78,
            (0,getOperationName/* getOperationName */.r)(this.query, "(anonymous)")
        );
        const combinedOptions = {
            ...(0,compact/* compact */.o)(this.options, { errorPolicy: "none" }, {
                query,
                context,
                errorPolicy,
            }),
            variables: (query ? variables : ({
                ...this.variables,
                ...variables,
            })),
            // The fetchMore request goes immediately to the network and does
            // not automatically write its result to the cache (hence no-cache
            // instead of network-only), because we allow the caller of
            // fetchMore to provide an updateQuery callback that determines how
            // the data gets written to the cache.
            fetchPolicy: "no-cache",
            notifyOnNetworkStatusChange: this.options.notifyOnNetworkStatusChange,
        };
        combinedOptions.query = this.transformDocument(combinedOptions.query);
        // If a temporary query is passed to `fetchMore`, we don't want to store
        // it as the last query result since it may be an optimized query for
        // pagination. We will however run the transforms on the original document
        // as well as the document passed in `fetchMoreOptions` to ensure the cache
        // uses the most up-to-date document which may rely on runtime conditionals.
        this.lastQuery =
            query ?
                this.transformDocument(this.options.query)
                : combinedOptions.query;
        let wasUpdated = false;
        const isCached = this.options.fetchPolicy !== "no-cache";
        if (!isCached) {
            (0,invariant/* invariant */.kG)(updateQuery, 79);
        }
        const { finalize, pushNotification } = this.pushOperation(networkStatus_NetworkStatus.fetchMore);
        pushNotification({
            source: "newNetworkStatus",
            kind: "N",
            value: {},
        }, { shouldEmit: 3 /* EmitBehavior.networkStatusChange */ });
        return this.queryManager
            .fetchQuery(combinedOptions, networkStatus_NetworkStatus.fetchMore)
            .then((fetchMoreResult) => {
            // disable the `fetchMore` override that is currently active
            // the next updates caused by this should not be `fetchMore` anymore,
            // but `ready` or whatever other calculated loading state is currently
            // appropriate
            finalize();
            if (isCached) {
                // Separately getting a diff here before the batch - `onWatchUpdated` might be
                // called with an `undefined` `lastDiff` on the watcher if the cache was just subscribed to.
                const lastDiff = this.getCacheDiff();
                // Performing this cache update inside a cache.batch transaction ensures
                // any affected cache.watch watchers are notified at most once about any
                // updates. Most watchers will be using the QueryInfo class, which
                // responds to notifications by calling reobserveCacheFirst to deliver
                // fetchMore cache results back to this ObservableQuery.
                this.queryManager.cache.batch({
                    update: (cache) => {
                        if (updateQuery) {
                            cache.updateQuery({
                                query: this.query,
                                variables: this.variables,
                                returnPartialData: true,
                                optimistic: false,
                            }, (previous) => updateQuery(previous, {
                                fetchMoreResult: fetchMoreResult.data,
                                variables: combinedOptions.variables,
                            }));
                        }
                        else {
                            // If we're using a field policy instead of updateQuery, the only
                            // thing we need to do is write the new data to the cache using
                            // combinedOptions.variables (instead of this.variables, which is
                            // what this.updateQuery uses, because it works by abusing the
                            // original field value, keyed by the original variables).
                            cache.writeQuery({
                                query: combinedOptions.query,
                                variables: combinedOptions.variables,
                                data: fetchMoreResult.data,
                            });
                        }
                    },
                    onWatchUpdated: (watch, diff) => {
                        if (watch.watcher === this &&
                            !equal(diff.result, lastDiff.result)) {
                            wasUpdated = true;
                        }
                    },
                });
            }
            else {
                // There is a possibility `lastResult` may not be set when
                // `fetchMore` is called which would cause this to crash. This should
                // only happen if we haven't previously reported a result. We don't
                // quite know what the right behavior should be here since this block
                // of code runs after the fetch result has executed on the network.
                // We plan to let it crash in the meantime.
                //
                // If we get bug reports due to the `data` property access on
                // undefined, this should give us a real-world scenario that we can
                // use to test against and determine the right behavior. If we do end
                // up changing this behavior, this may require, for example, an
                // adjustment to the types on `updateQuery` since that function
                // expects that the first argument always contains previous result
                // data, but not `undefined`.
                const lastResult = this.getCurrentResult();
                const data = updateQuery(lastResult.data, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables,
                });
                // was reportResult
                pushNotification({
                    kind: "N",
                    value: {
                        ...lastResult,
                        networkStatus: networkStatus_NetworkStatus.ready,
                        // will be overwritten anyways, just here for types sake
                        loading: false,
                        data: data,
                        dataState: lastResult.dataState === "streaming" ? "streaming" : "complete",
                    },
                    source: "network",
                });
            }
            return this.maskResult(fetchMoreResult);
        })
            .finally(() => {
            // call `finalize` a second time in case the `.then` case above was not reached
            finalize();
            // In case the cache writes above did not generate a broadcast
            // notification (which would have been intercepted by onWatchUpdated),
            // likely because the written data were the same as what was already in
            // the cache, we still want fetchMore to deliver its final loading:false
            // result with the unchanged data.
            if (isCached && !wasUpdated) {
                pushNotification({
                    kind: "N",
                    source: "newNetworkStatus",
                    value: {},
                }, { shouldEmit: 1 /* EmitBehavior.force */ });
            }
        });
    }
    // XXX the subscription variables are separate from the query variables.
    // if you want to update subscription variables, right now you have to do that separately,
    // and you can only do it by stopping the subscription and then subscribing again with new variables.
    /**
     * A function that enables you to execute a [subscription](https://www.apollographql.com/docs/react/data/subscriptions/), usually to subscribe to specific fields that were included in the query.
     *
     * This function returns _another_ function that you can call to terminate the subscription.
     */
    subscribeToMore(options) {
        const subscription = this.queryManager
            .startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context,
        })
            .subscribe({
            next: (subscriptionData) => {
                const { updateQuery, onError } = options;
                const { error } = subscriptionData;
                if (error) {
                    if (onError) {
                        onError(error);
                    }
                    else {
                        invariant/* invariant,error */.kG.error(80, error);
                    }
                    return;
                }
                if (updateQuery) {
                    this.updateQuery((previous, updateOptions) => updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        ...updateOptions,
                    }));
                }
            },
        });
        this.subscriptions.add(subscription);
        return () => {
            if (this.subscriptions.delete(subscription)) {
                subscription.unsubscribe();
            }
        };
    }
    /**
    * @internal
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */
    applyOptions(newOptions) {
        const mergedOptions = (0,compact/* compact */.o)(this.options, newOptions || {});
        ObservableQuery_assign(this.options, mergedOptions);
        this.updatePolling();
    }
    /**
     * Update the variables of this observable query, and fetch the new results
     * if they've changed. Most users should prefer `refetch` instead of
     * `setVariables` in order to to be properly notified of results even when
     * they come from the cache.
     *
     * Note: `setVariables()` guarantees that a value will be emitted from the
     * observable, even if the result is deeply equal to the previous value.
     *
     * Note: the promise will resolve with the last emitted result
     * when either the variables match the current variables or there
     * are no subscribers to the query.
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */
    async setVariables(variables) {
        variables = this.getVariablesWithDefaults(variables);
        if (equal(this.variables, variables)) {
            // If we have no observers, then we don't actually want to make a network
            // request. As soon as someone observes the query, the request will kick
            // off. For now, we just store any changes. (See #1077)
            return toQueryResult(this.getCurrentResult());
        }
        this.options.variables = variables;
        // See comment above
        if (!this.hasObservers()) {
            return toQueryResult(this.getCurrentResult());
        }
        return this._reobserve({
            // Reset options.fetchPolicy to its original value.
            fetchPolicy: this.options.initialFetchPolicy,
            variables,
        }, { newNetworkStatus: networkStatus_NetworkStatus.setVariables });
    }
    /**
     * A function that enables you to update the query's cached result without executing a followup GraphQL operation.
     *
     * See [using updateQuery and updateFragment](https://www.apollographql.com/docs/react/caching/cache-interaction/#using-updatequery-and-updatefragment) for additional information.
     */
    updateQuery(mapFn) {
        const { queryManager } = this;
        const { result, complete } = this.getCacheDiff({ optimistic: false });
        const newResult = mapFn(result, {
            variables: this.variables,
            complete: !!complete,
            previousData: result,
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables,
            });
            queryManager.broadcastQueries();
        }
    }
    /**
     * A function that instructs the query to begin re-executing at a specified interval (in milliseconds).
     */
    startPolling(pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    }
    /**
     * A function that instructs the query to stop polling after a previous call to `startPolling`.
     */
    stopPolling() {
        this.options.pollInterval = 0;
        this.updatePolling();
    }
    // Update options.fetchPolicy according to options.nextFetchPolicy.
    applyNextFetchPolicy(reason, 
    // It's possible to use this method to apply options.nextFetchPolicy to
    // options.fetchPolicy even if options !== this.options, though that happens
    // most often when the options are temporary, used for only one request and
    // then thrown away, so nextFetchPolicy may not end up mattering.
    options) {
        if (options.nextFetchPolicy) {
            const { fetchPolicy = "cache-first", initialFetchPolicy = fetchPolicy } = options;
            if (fetchPolicy === "standby") {
                // Do nothing, leaving options.fetchPolicy unchanged.
            }
            else if (typeof options.nextFetchPolicy === "function") {
                // When someone chooses "cache-and-network" or "network-only" as their
                // initial FetchPolicy, they often do not want future cache updates to
                // trigger unconditional network requests, which is what repeatedly
                // applying the "cache-and-network" or "network-only" policies would
                // seem to imply. Instead, when the cache reports an update after the
                // initial network request, it may be desirable for subsequent network
                // requests to be triggered only if the cache result is incomplete. To
                // that end, the options.nextFetchPolicy option provides an easy way to
                // update options.fetchPolicy after the initial network request, without
                // having to call observableQuery.reobserve.
                options.fetchPolicy = options.nextFetchPolicy.call(options, fetchPolicy, { reason, options, observable: this, initialFetchPolicy });
            }
            else if (reason === "variables-changed") {
                options.fetchPolicy = initialFetchPolicy;
            }
            else {
                options.fetchPolicy = options.nextFetchPolicy;
            }
        }
        return options.fetchPolicy;
    }
    fetch(options, networkStatus, fetchQuery, operator) {
        // TODO Make sure we update the networkStatus (and infer fetchVariables)
        // before actually committing to the fetch.
        const initialFetchPolicy = this.options.fetchPolicy;
        options.context ??= {};
        let synchronouslyEmitted = false;
        const onCacheHit = () => {
            synchronouslyEmitted = true;
        };
        const fetchQueryOperator = // we cannot use `tap` here, since it allows only for a "before subscription"
         
        // hook with `subscribe` and we care for "directly before and after subscription"
        (source) => new Observable/* Observable */.y((subscriber) => {
            try {
                return source.subscribe({
                    next(value) {
                        synchronouslyEmitted = true;
                        subscriber.next(value);
                    },
                    error: (error) => subscriber.error(error),
                    complete: () => subscriber.complete(),
                });
            }
            finally {
                if (!synchronouslyEmitted) {
                    operation.override = networkStatus;
                    this.input.next({
                        kind: "N",
                        source: "newNetworkStatus",
                        value: {
                            resetError: true,
                        },
                        query,
                        variables,
                        meta: {
                            shouldEmit: 3 /* EmitBehavior.networkStatusChange */,
                            /*
                             * The moment this notification is emitted, `nextFetchPolicy`
                             * might already have switched from a `network-only` to a
                             * `cache-something` policy, so we want to ensure that the
                             * loading state emit doesn't accidentally read from the cache
                             * in those cases.
                             */
                            fetchPolicy: initialFetchPolicy,
                        },
                    });
                }
            }
        });
        let { observable, fromLink } = this.queryManager.fetchObservableWithInfo(options, {
            networkStatus,
            query: fetchQuery,
            onCacheHit,
            fetchQueryOperator,
            observableQuery: this,
        });
        // track query and variables from the start of the operation
        const { query, variables } = this;
        const operation = {
            abort: () => {
                subscription.unsubscribe();
            },
            query,
            variables,
        };
        this.activeOperations.add(operation);
        let forceFirstValueEmit = networkStatus == networkStatus_NetworkStatus.refetch ||
            networkStatus == networkStatus_NetworkStatus.setVariables;
        observable = observable.pipe(operator, share());
        const subscription = observable
            .pipe(tap({
            next: (notification) => {
                if (notification.source === "newNetworkStatus" ||
                    (notification.kind === "N" && notification.value.loading)) {
                    operation.override = networkStatus;
                }
                else {
                    delete operation.override;
                }
            },
            finalize: () => this.activeOperations.delete(operation),
        }))
            .subscribe({
            next: (value) => {
                const meta = {};
                if (forceFirstValueEmit &&
                    value.kind === "N" &&
                    "loading" in value.value &&
                    !value.value.loading) {
                    forceFirstValueEmit = false;
                    meta.shouldEmit = 1 /* EmitBehavior.force */;
                }
                this.input.next({ ...value, query, variables, meta });
            },
        });
        return { fromLink, subscription, observable };
    }
    // Turns polling on or off based on this.options.pollInterval.
    didWarnCacheOnlyPolling = false;
    updatePolling() {
        // Avoid polling in SSR mode
        if (this.queryManager.ssrMode) {
            return;
        }
        const { pollingInfo, options: { fetchPolicy, pollInterval }, } = this;
        if (!pollInterval || !this.hasObservers() || fetchPolicy === "cache-only") {
            if (index_production/* __DEV__ */.T) {
                if (!this.didWarnCacheOnlyPolling &&
                    pollInterval &&
                    fetchPolicy === "cache-only") {
                    index_production/* __DEV__ */.T && invariant/* invariant,warn */.kG.warn(81, (0,getOperationName/* getOperationName */.r)(this.query, "(anonymous)"));
                    this.didWarnCacheOnlyPolling = true;
                }
            }
            this.cancelPolling();
            return;
        }
        if (pollingInfo?.interval === pollInterval) {
            return;
        }
        const info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        const maybeFetch = () => {
            if (this.pollingInfo) {
                if (!isNetworkRequestInFlight(this.networkStatus) &&
                    !this.options.skipPollAttempt?.()) {
                    this._reobserve({
                        // Most fetchPolicy options don't make sense to use in a polling context, as
                        // users wouldn't want to be polling the cache directly. However, network-only and
                        // no-cache are both useful for when the user wants to control whether or not the
                        // polled results are written to the cache.
                        fetchPolicy: this.options.initialFetchPolicy === "no-cache" ?
                            "no-cache"
                            : "network-only",
                    }, {
                        newNetworkStatus: networkStatus_NetworkStatus.poll,
                    }).then(poll, poll);
                }
                else {
                    poll();
                }
            }
        };
        const poll = () => {
            const info = this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    }
    // This differs from stopPolling in that it does not set pollInterval to 0
    cancelPolling() {
        if (this.pollingInfo) {
            clearTimeout(this.pollingInfo.timeout);
            delete this.pollingInfo;
        }
    }
    /**
     * Reevaluate the query, optionally against new options. New options will be
     * merged with the current options when given.
     *
     * Note: `variables` can be reset back to their defaults (typically empty) by calling `reobserve` with
     * `variables: undefined`.
     */
    reobserve(newOptions) {
        return this._reobserve(newOptions);
    }
    _reobserve(newOptions, internalOptions) {
        this.isTornDown = false;
        let { newNetworkStatus } = internalOptions || {};
        this.queryManager.obsQueries.add(this);
        const useDisposableObservable = 
        // Refetching uses a disposable Observable to allow refetches using different
        // options, without permanently altering the options of the
        // original ObservableQuery.
        newNetworkStatus === networkStatus_NetworkStatus.refetch ||
            // Polling uses a disposable Observable so the polling options (which force
            // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
            newNetworkStatus === networkStatus_NetworkStatus.poll;
        // Save the old variables, since Object.assign may modify them below.
        const oldVariables = this.variables;
        const oldFetchPolicy = this.options.fetchPolicy;
        const mergedOptions = (0,compact/* compact */.o)(this.options, newOptions || {});
        const options = useDisposableObservable ?
            // Disposable Observable fetches receive a shallow copy of this.options
            // (merged with newOptions), leaving this.options unmodified.
            mergedOptions
            : ObservableQuery_assign(this.options, mergedOptions);
        // Don't update options.query with the transformed query to avoid
        // overwriting this.options.query when we aren't using a disposable concast.
        // We want to ensure we can re-run the custom document transforms the next
        // time a request is made against the original query.
        const query = this.transformDocument(options.query);
        this.lastQuery = query;
        // Reevaluate variables to allow resetting variables with variables: undefined,
        // otherwise `compact` will ignore the `variables` key in `newOptions`. We
        // do this after we run the query transform to ensure we get default
        // variables from the transformed query.
        //
        // Note: updating options.variables may mutate this.options.variables
        // in the case of a non-disposable query. This is intentional.
        if (newOptions && "variables" in newOptions) {
            options.variables = this.getVariablesWithDefaults(newOptions.variables);
        }
        if (!useDisposableObservable) {
            // We can skip calling updatePolling if we're not changing this.options.
            this.updatePolling();
            // Reset options.fetchPolicy to its original value when variables change,
            // unless a new fetchPolicy was provided by newOptions.
            if (newOptions &&
                newOptions.variables &&
                !equal(newOptions.variables, oldVariables) &&
                // Don't mess with the fetchPolicy if it's currently "standby".
                options.fetchPolicy !== "standby" &&
                // If we're changing the fetchPolicy anyway, don't try to change it here
                // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
                (options.fetchPolicy === oldFetchPolicy ||
                    // A `nextFetchPolicy` function has even higher priority, though,
                    // so in that case `applyNextFetchPolicy` must be called.
                    typeof options.nextFetchPolicy === "function")) {
                // This might mutate options.fetchPolicy
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) {
                    newNetworkStatus = networkStatus_NetworkStatus.setVariables;
                }
            }
        }
        const oldNetworkStatus = this.networkStatus;
        if (!newNetworkStatus) {
            newNetworkStatus = networkStatus_NetworkStatus.loading;
            if (oldNetworkStatus !== networkStatus_NetworkStatus.loading &&
                newOptions?.variables &&
                !equal(newOptions.variables, oldVariables)) {
                newNetworkStatus = networkStatus_NetworkStatus.setVariables;
            }
            // QueryManager does not emit any values for standby fetch policies so we
            // want ensure that the networkStatus remains ready.
            if (options.fetchPolicy === "standby") {
                newNetworkStatus = networkStatus_NetworkStatus.ready;
            }
        }
        if (options.fetchPolicy === "standby") {
            this.cancelPolling();
        }
        this.resubscribeCache();
        const { promise, operator: promiseOperator } = getTrackingOperatorPromise((value) => {
            switch (value.kind) {
                case "E":
                    throw value.error;
                case "N":
                    if (value.source !== "newNetworkStatus" && !value.value.loading)
                        return value.value;
            }
        }, 
        // This default value should only be used when using a `fetchPolicy` of
        // `standby` since that fetch policy completes without emitting a
        // result. Since we are converting this to a QueryResult type, we
        // omit the extra fields from ApolloQueryResult in the default value.
        options.fetchPolicy === "standby" ?
            { data: undefined }
            : undefined);
        const { subscription, observable, fromLink } = this.fetch(options, newNetworkStatus, query, promiseOperator);
        if (!useDisposableObservable && (fromLink || !this.linkSubscription)) {
            if (this.linkSubscription) {
                this.linkSubscription.unsubscribe();
            }
            this.linkSubscription = subscription;
        }
        const ret = Object.assign(preventUnhandledRejection(promise
            .then((result) => toQueryResult(this.maskResult(result)))
            .finally(() => {
            if (!this.hasObservers() && this.activeOperations.size === 0) {
                // If `reobserve` was called on a query without any observers,
                // the teardown logic would never be called, so we need to
                // call it here to ensure the query is properly torn down.
                this.tearDownQuery();
            }
        })), {
            retain: () => {
                const subscription = observable.subscribe({});
                const unsubscribe = () => subscription.unsubscribe();
                promise.then(unsubscribe, unsubscribe);
                return ret;
            },
        });
        return ret;
    }
    hasObservers() {
        return this.subject.observed;
    }
    /**
     * Tears down the `ObservableQuery` and stops all active operations by sending a `complete` notification.
     */
    stop() {
        this.subject.complete();
        this.initializeObservablesQueue();
        this.tearDownQuery();
    }
    tearDownQuery() {
        if (this.isTornDown)
            return;
        this.resetNotifications();
        this.unsubscribeFromCache?.();
        if (this.linkSubscription) {
            this.linkSubscription.unsubscribe();
            delete this.linkSubscription;
        }
        this.stopPolling();
        // stop all active GraphQL subscriptions
        this.subscriptions.forEach((sub) => sub.unsubscribe());
        this.subscriptions.clear();
        this.queryManager.obsQueries.delete(this);
        this.isTornDown = true;
        this.abortActiveOperations();
        this._lastWrite = undefined;
    }
    transformDocument(document) {
        return this.queryManager.transform(document);
    }
    maskResult(result) {
        const masked = this.queryManager.maskOperation({
            document: this.query,
            data: result.data,
            fetchPolicy: this.options.fetchPolicy,
            cause: this,
        });
        // Maintain object identity as much as possible
        return masked === result.data ? result : { ...result, data: masked };
    }
    dirty = false;
    notifyTimeout;
    /**
    * @internal
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */
    resetNotifications() {
        if (this.notifyTimeout) {
            clearTimeout(this.notifyTimeout);
            this.notifyTimeout = void 0;
        }
        this.dirty = false;
    }
    /**
    * @internal
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */
    scheduleNotify() {
        if (this.dirty)
            return;
        this.dirty = true;
        if (!this.notifyTimeout) {
            this.notifyTimeout = setTimeout(() => this.notify(true), 0);
        }
    }
    /**
    * @internal
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */
    notify(scheduled = false) {
        if (!scheduled) {
            // For queries with client exports or forced resolvers, we don't want to
            // synchronously reobserve the cache on broadcast,
            // but actually wait for the `scheduleNotify` timeout triggered by the
            // `cache.watch` callback from `resubscribeCache`.
            const info = this.queryManager.getDocumentInfo(this.query);
            if (info.hasClientExports || info.hasForcedResolvers) {
                return;
            }
        }
        const { dirty } = this;
        this.resetNotifications();
        if (dirty &&
            (this.options.fetchPolicy == "cache-only" ||
                this.options.fetchPolicy == "cache-and-network" ||
                !this.activeOperations.size)) {
            const diff = this.getCacheDiff();
            if (
            // `fromOptimisticTransaction` is not available through the `cache.diff`
            // code path, so we need to check it this way
            equal(diff.result, this.getCacheDiff({ optimistic: false }).result)) {
                //If this diff did not come from an optimistic transaction
                // make the ObservableQuery "reobserve" the latest data
                // using a temporary fetch policy of "cache-first", so complete cache
                // results have a chance to be delivered without triggering additional
                // network requests, even when options.fetchPolicy is "network-only"
                // or "cache-and-network". All other fetch policies are preserved by
                // this method, and are handled by calling oq.reobserve(). If this
                // reobservation is spurious, distinctUntilChanged still has a
                // chance to catch it before delivery to ObservableQuery subscribers.
                this.reobserveCacheFirst();
            }
            else {
                // If this diff came from an optimistic transaction, deliver the
                // current cache data to the ObservableQuery, but don't perform a
                // reobservation, since oq.reobserveCacheFirst might make a network
                // request, and we never want to trigger network requests in the
                // middle of optimistic updates.
                this.input.next({
                    kind: "N",
                    value: {
                        data: diff.result,
                        dataState: diff.complete ? "complete"
                            : diff.result ? "partial"
                                : "empty",
                        networkStatus: networkStatus_NetworkStatus.ready,
                        loading: false,
                        error: undefined,
                        partial: !diff.complete,
                    },
                    source: "cache",
                    query: this.query,
                    variables: this.variables,
                    meta: {},
                });
            }
        }
    }
    activeOperations = new Set();
    pushOperation(networkStatus) {
        let aborted = false;
        // track query and variables from the start of the operation
        const { query, variables } = this;
        const finalize = () => {
            this.activeOperations.delete(operation);
        };
        const operation = {
            override: networkStatus,
            abort: () => {
                aborted = true;
                finalize();
            },
            query,
            variables,
        };
        this.activeOperations.add(operation);
        return {
            finalize,
            pushNotification: (notification, additionalMeta) => {
                if (!aborted) {
                    this.input.next({
                        ...notification,
                        query,
                        variables,
                        meta: { ...additionalMeta },
                    });
                }
            },
        };
    }
    calculateNetworkStatus(baseNetworkStatus) {
        if (baseNetworkStatus === networkStatus_NetworkStatus.streaming) {
            return baseNetworkStatus;
        }
        // in the future, this could be more complex logic, e.g. "refetch" and
        // "fetchMore" having priority over "polling" or "loading" network statuses
        // as for now we just take the "latest" operation that is still active,
        // as that lines up best with previous behavior[]
        const operation = Array.from(this.activeOperations.values()).findLast((operation) => isEqualQuery(operation, this) && operation.override !== undefined);
        return operation?.override ?? baseNetworkStatus;
    }
    abortActiveOperations() {
        this.activeOperations.forEach((operation) => operation.abort());
    }
    /**
    * @internal
    * Called from `clearStore`.
    *
    * - resets the query to its initial state
    * - cancels all active operations and their subscriptions
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */
    reset() {
        // exception for cache-only queries - we reset them into a "ready" state
        // as we won't trigger a refetch for them
        const resetToEmpty = this.options.fetchPolicy === "cache-only";
        this.setResult(resetToEmpty ? ObservableQuery_empty : uninitialized, {
            shouldEmit: resetToEmpty ? 1 /* EmitBehavior.force */ : 2 /* EmitBehavior.never */,
        });
        this.abortActiveOperations();
    }
    /**
    * @internal
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */
    setResult(result, additionalMeta) {
        this.input.next({
            source: "setResult",
            kind: "N",
            value: result,
            query: this.query,
            variables: this.variables,
            meta: { ...additionalMeta },
        });
    }
    operator = filterMap((notification) => {
        const { query, variables, meta } = notification;
        if (notification.source === "setResult") {
            return { query, variables, result: notification.value, meta };
        }
        if (notification.kind === "C" || !isEqualQuery(notification, this)) {
            return;
        }
        let result;
        const previous = this.subject.getValue();
        if (notification.source === "cache") {
            result = notification.value;
            if (result.networkStatus === networkStatus_NetworkStatus.ready &&
                result.partial &&
                (!this.options.returnPartialData ||
                    previous.result.networkStatus === networkStatus_NetworkStatus.error) &&
                this.options.fetchPolicy !== "cache-only") {
                return;
            }
        }
        else if (notification.source === "network") {
            if (this.waitForNetworkResult) {
                this.waitForNetworkResult = false;
                this.resubscribeCache();
            }
            result =
                notification.kind === "E" ?
                    {
                        ...(isEqualQuery(previous, notification) ?
                            previous.result
                            : { data: undefined, dataState: "empty", partial: true }),
                        error: notification.error,
                        networkStatus: networkStatus_NetworkStatus.error,
                        loading: false,
                    }
                    : notification.value;
            if (notification.kind === "E" && result.dataState === "streaming") {
                result.dataState = "complete";
            }
            if (result.error) {
                meta.shouldEmit = 1 /* EmitBehavior.force */;
            }
        }
        else if (notification.source === "newNetworkStatus") {
            const baseResult = isEqualQuery(previous, notification) ?
                previous.result
                : this.getInitialResult(meta.fetchPolicy);
            const { resetError } = notification.value;
            const error = resetError ? undefined : baseResult.error;
            const networkStatus = error ? networkStatus_NetworkStatus.error : networkStatus_NetworkStatus.ready;
            result = {
                ...baseResult,
                error,
                networkStatus,
            };
        }
        // every code path until here should have either returned or set a result,
        // but typescript needs a little help
        (0,invariant/* invariant */.kG)(result);
        // normalize result shape
        if (!result.error)
            delete result.error;
        result.networkStatus = this.calculateNetworkStatus(result.networkStatus);
        result.loading = isNetworkRequestInFlight(result.networkStatus);
        result = this.maskResult(result);
        return { query, variables, result, meta };
    });
    // Reobserve with fetchPolicy effectively set to "cache-first", triggering
    // delivery of any new data from the cache, possibly falling back to the network
    // if any cache data are missing. This allows _complete_ cache results to be
    // delivered without also kicking off unnecessary network requests when
    // this.options.fetchPolicy is "cache-and-network" or "network-only". When
    // this.options.fetchPolicy is any other policy ("cache-first", "cache-only",
    // "standby", or "no-cache"), we call this.reobserve() as usual.
    reobserveCacheFirst() {
        const { fetchPolicy, nextFetchPolicy } = this.options;
        if (fetchPolicy === "cache-and-network" || fetchPolicy === "network-only") {
            this.reobserve({
                fetchPolicy: "cache-first",
                // Use a temporary nextFetchPolicy function that replaces itself with the
                // previous nextFetchPolicy value and returns the original fetchPolicy.
                nextFetchPolicy(currentFetchPolicy, context) {
                    // Replace this nextFetchPolicy function in the options object with the
                    // original this.options.nextFetchPolicy value.
                    this.nextFetchPolicy = nextFetchPolicy;
                    // If the original nextFetchPolicy value was a function, give it a
                    // chance to decide what happens here.
                    if (typeof this.nextFetchPolicy === "function") {
                        return this.nextFetchPolicy(currentFetchPolicy, context);
                    }
                    // Otherwise go back to the original this.options.fetchPolicy.
                    return fetchPolicy;
                },
            });
        }
        else {
            this.reobserve();
        }
    }
    getVariablesWithDefaults(variables) {
        return this.queryManager.getVariables(this.query, variables);
    }
}
function logMissingFieldErrors(missing) {
    if (index_production/* __DEV__ */.T && missing) {
        index_production/* __DEV__ */.T && invariant/* invariant,debug */.kG.debug(82, missing);
    }
}
function isEqualQuery(a, b) {
    return !!(a && b && a.query === b.query && equal(a.variables, b.variables));
}
function getTrackingOperatorPromise(filterMapCb, defaultValue) {
    let lastValue = defaultValue, resolve, reject;
    const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    });
    const operator = tap({
        next(value) {
            try {
                const newValue = filterMapCb(value);
                if (newValue !== undefined) {
                    lastValue = newValue;
                }
            }
            catch (error) {
                reject(error);
            }
        },
        finalize: () => {
            if (lastValue) {
                resolve(lastValue);
            }
            else {
                const message = "The operation was aborted.";
                const name = "AbortError";
                reject(typeof DOMException !== "undefined" ?
                    new DOMException(message, name)
                    // some environments do not have `DOMException`, e.g. node
                    // uses a normal `Error` with a `name` property instead: https://github.com/phryneas/node/blob/d0579b64f0f6b722f8e49bf8a471dd0d0604a21e/lib/internal/errors.js#L964
                    // error.code is a legacy property that is not used anymore,
                    // and also inconsistent across environments (in supporting
                    // browsers it is `20`, in node `'ABORT_ERR'`) so we omit that.
                    : Object.assign(new Error(message), { name }));
            }
        },
    });
    return { promise, operator };
}
//# sourceMappingURL=ObservableQuery.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/core/QueryInfo.js



const IGNORE = {};
const destructiveMethodCounts = new WeakMap();
function wrapDestructiveCacheMethod(cache, methodName) {
    const original = cache[methodName];
    if (typeof original === "function") {
        // @ts-expect-error this is just too generic to be typed correctly
        cache[methodName] = function () {
            destructiveMethodCounts.set(cache, 
            // The %1e15 allows the count to wrap around to 0 safely every
            // quadrillion evictions, so there's no risk of overflow. To be
            // clear, this is more of a pedantic principle than something
            // that matters in any conceivable practical scenario.
            (destructiveMethodCounts.get(cache) + 1) % 1e15);
            // @ts-expect-error this is just too generic to be typed correctly
            return original.apply(this, arguments);
        };
    }
}
const queryInfoIds = new WeakMap();
// A QueryInfo object represents a single network request, either initiated
// from the QueryManager or from an ObservableQuery.
// It will only ever be used for a single network call.
// It is responsible for reporting results to the cache, merging and in a no-cache
// scenario accumulating the response.
class QueryInfo {
    // TODO remove soon - this should be able to be handled by cancelling old operations before starting new ones
    lastRequestId = 1;
    cache;
    queryManager;
    id;
    observableQuery;
    incremental;
    constructor(queryManager, observableQuery) {
        const cache = (this.cache = queryManager.cache);
        const id = (queryInfoIds.get(queryManager) || 0) + 1;
        queryInfoIds.set(queryManager, id);
        this.id = id + "";
        this.observableQuery = observableQuery;
        this.queryManager = queryManager;
        // Track how often cache.evict is called, since we want eviction to
        // override the feud-stopping logic in the markQueryResult method, by
        // causing shouldWrite to return true. Wrapping the cache.evict method
        // is a bit of a hack, but it saves us from having to make eviction
        // counting an official part of the ApolloCache API.
        if (!destructiveMethodCounts.has(cache)) {
            destructiveMethodCounts.set(cache, 0);
            wrapDestructiveCacheMethod(cache, "evict");
            wrapDestructiveCacheMethod(cache, "modify");
            wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    /**
    * @internal
    * For feud-preventing behaviour, `lastWrite` should be shared by all `QueryInfo` instances of an `ObservableQuery`.
    * In the case of a standalone `QueryInfo`, we will keep a local version.
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */
    _lastWrite;
    get lastWrite() {
        return (this.observableQuery || this)._lastWrite;
    }
    set lastWrite(value) {
        (this.observableQuery || this)._lastWrite = value;
    }
    resetLastWrite() {
        this.lastWrite = void 0;
    }
    shouldWrite(result, variables) {
        const { lastWrite } = this;
        return !(lastWrite &&
            // If cache.evict has been called since the last time we wrote this
            // data into the cache, there's a chance writing this result into
            // the cache will repair what was evicted.
            lastWrite.dmCount === destructiveMethodCounts.get(this.cache) &&
            equal(variables, lastWrite.variables) &&
            equal(result.data, lastWrite.result.data));
    }
    get hasNext() {
        return this.incremental ? this.incremental.hasNext : false;
    }
    maybeHandleIncrementalResult(cacheData, incoming, query) {
        const { incrementalHandler } = this.queryManager;
        if (incrementalHandler.isIncrementalResult(incoming)) {
            this.incremental ||= incrementalHandler.startRequest({
                query,
            });
            return this.incremental.handle(cacheData, incoming);
        }
        return incoming;
    }
    markQueryResult(incoming, { document: query, variables, errorPolicy, cacheWriteBehavior, }) {
        const diffOptions = {
            query,
            variables,
            returnPartialData: true,
            optimistic: true,
        };
        // Cancel the pending notify timeout (if it exists) to prevent extraneous network
        // requests. To allow future notify timeouts, diff and dirty are reset as well.
        this.observableQuery?.["resetNotifications"]();
        const skipCache = cacheWriteBehavior === 0 /* CacheWriteBehavior.FORBID */;
        const lastDiff = skipCache ? undefined : this.cache.diff(diffOptions);
        let result = this.maybeHandleIncrementalResult(lastDiff?.result, incoming, query);
        if (skipCache) {
            return result;
        }
        if (shouldWriteResult(result, errorPolicy)) {
            // Using a transaction here so we have a chance to read the result
            // back from the cache before the watch callback fires as a result
            // of writeQuery, so we can store the new diff quietly and ignore
            // it when we receive it redundantly from the watch callback.
            this.cache.batch({
                onWatchUpdated: (
                // all additional options on ObservableQuery.CacheWatchOptions are
                // optional so we can use the type here
                watch, diff) => {
                    if (watch.watcher === this.observableQuery) {
                        // see comment on `lastOwnDiff` for explanation
                        watch.lastOwnDiff = diff;
                    }
                },
                update: (cache) => {
                    if (this.shouldWrite(result, variables)) {
                        cache.writeQuery({
                            query,
                            data: result.data,
                            variables,
                            overwrite: cacheWriteBehavior === 1 /* CacheWriteBehavior.OVERWRITE */,
                        });
                        this.lastWrite = {
                            result,
                            variables,
                            dmCount: destructiveMethodCounts.get(this.cache),
                        };
                    }
                    else {
                        // If result is the same as the last result we received from
                        // the network (and the variables match too), avoid writing
                        // result into the cache again. The wisdom of skipping this
                        // cache write is far from obvious, since any cache write
                        // could be the one that puts the cache back into a desired
                        // state, fixing corruption or missing data. However, if we
                        // always write every network result into the cache, we enable
                        // feuds between queries competing to update the same data in
                        // incompatible ways, which can lead to an endless cycle of
                        // cache broadcasts and useless network requests. As with any
                        // feud, eventually one side must step back from the brink,
                        // letting the other side(s) have the last word(s). There may
                        // be other points where we could break this cycle, such as
                        // silencing the broadcast for cache.writeQuery (not a good
                        // idea, since it just delays the feud a bit) or somehow
                        // avoiding the network request that just happened (also bad,
                        // because the server could return useful new data). All
                        // options considered, skipping this cache write seems to be
                        // the least damaging place to break the cycle, because it
                        // reflects the intuition that we recently wrote this exact
                        // result into the cache, so the cache *should* already/still
                        // contain this data. If some other query has clobbered that
                        // data in the meantime, that's too bad, but there will be no
                        // winners if every query blindly reverts to its own version
                        // of the data. This approach also gives the network a chance
                        // to return new data, which will be written into the cache as
                        // usual, notifying only those queries that are directly
                        // affected by the cache updates, as usual. In the future, an
                        // even more sophisticated cache could perhaps prevent or
                        // mitigate the clobbering somehow, but that would make this
                        // particular cache write even less important, and thus
                        // skipping it would be even safer than it is today.
                        if (lastDiff && lastDiff.complete) {
                            // Reuse data from the last good (complete) diff that we
                            // received, when possible.
                            result = { ...result, data: lastDiff.result };
                            return;
                        }
                        // If the previous this.diff was incomplete, fall through to
                        // re-reading the latest data with cache.diff, below.
                    }
                    const diff = cache.diff(diffOptions);
                    // If we're allowed to write to the cache, and we can read a
                    // complete result from the cache, update result.data to be the
                    // result from the cache, rather than the raw network result.
                    // Set without setDiff to avoid triggering a notify call, since
                    // we have other ways of notifying for this result.
                    if (diff.complete) {
                        result = { ...result, data: diff.result };
                    }
                },
            });
        }
        else {
            this.lastWrite = void 0;
        }
        return result;
    }
    markMutationResult(incoming, mutation, cache = this.cache) {
        const cacheWrites = [];
        const skipCache = mutation.cacheWriteBehavior === 0 /* CacheWriteBehavior.FORBID */;
        let result = this.maybeHandleIncrementalResult(skipCache ? undefined : (cache.diff({
            id: "ROOT_MUTATION",
            // The cache complains if passed a mutation where it expects a
            // query, so we transform mutations and subscriptions to queries
            // (only once, thanks to this.transformCache).
            query: this.queryManager.getDocumentInfo(mutation.document).asQuery,
            variables: mutation.variables,
            optimistic: false,
            returnPartialData: true,
        }).result), incoming, mutation.document);
        if (mutation.errorPolicy === "ignore") {
            result = { ...result, errors: [] };
        }
        if (graphQLResultHasError(result) && mutation.errorPolicy === "none") {
            return Promise.resolve(result);
        }
        const getResultWithDataState = () => ({
            ...result,
            dataState: this.hasNext ? "streaming" : "complete",
        });
        if (!skipCache && shouldWriteResult(result, mutation.errorPolicy)) {
            cacheWrites.push({
                result: result.data,
                dataId: "ROOT_MUTATION",
                query: mutation.document,
                variables: mutation.variables,
            });
            const { updateQueries } = mutation;
            if (updateQueries) {
                this.queryManager
                    .getObservableQueries("all")
                    .forEach((observableQuery) => {
                    const queryName = observableQuery && observableQuery.queryName;
                    if (!queryName ||
                        !Object.hasOwnProperty.call(updateQueries, queryName)) {
                        return;
                    }
                    const updater = updateQueries[queryName];
                    const { query: document, variables } = observableQuery;
                    // Read the current query result from the store.
                    const { result: currentQueryResult, complete } = observableQuery.getCacheDiff({ optimistic: false });
                    if (complete && currentQueryResult) {
                        // Run our reducer using the current query result and the mutation result.
                        const nextQueryResult = updater(currentQueryResult, {
                            mutationResult: getResultWithDataState(),
                            queryName: (document && (0,getOperationName/* getOperationName */.r)(document)) || void 0,
                            queryVariables: variables,
                        });
                        // Write the modified result back into the store if we got a new result.
                        if (nextQueryResult) {
                            cacheWrites.push({
                                result: nextQueryResult,
                                dataId: "ROOT_QUERY",
                                query: document,
                                variables,
                            });
                        }
                    }
                });
            }
        }
        let refetchQueries = mutation.refetchQueries;
        if (typeof refetchQueries === "function") {
            refetchQueries = refetchQueries(getResultWithDataState());
        }
        if (cacheWrites.length > 0 ||
            (refetchQueries || "").length > 0 ||
            mutation.update ||
            mutation.onQueryUpdated ||
            mutation.removeOptimistic) {
            const results = [];
            this.queryManager
                .refetchQueries({
                updateCache: (cache) => {
                    if (!skipCache) {
                        cacheWrites.forEach((write) => cache.write(write));
                    }
                    // If the mutation has some writes associated with it then we need to
                    // apply those writes to the store by running this reducer again with
                    // a write action.
                    const { update } = mutation;
                    // Determine whether result is a SingleExecutionResult,
                    // or the final ExecutionPatchResult.
                    if (update) {
                        if (!skipCache) {
                            // Re-read the ROOT_MUTATION data we just wrote into the cache
                            // (the first cache.write call in the cacheWrites.forEach loop
                            // above), so field read functions have a chance to run for
                            // fields within mutation result objects.
                            const diff = cache.diff({
                                id: "ROOT_MUTATION",
                                // The cache complains if passed a mutation where it expects a
                                // query, so we transform mutations and subscriptions to queries
                                // (only once, thanks to this.transformCache).
                                query: this.queryManager.getDocumentInfo(mutation.document)
                                    .asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true,
                            });
                            if (diff.complete) {
                                result = {
                                    ...result,
                                    data: diff.result,
                                };
                            }
                        }
                        // If we've received the whole response, call the update function.
                        if (!this.hasNext) {
                            update(cache, result, {
                                context: mutation.context,
                                variables: mutation.variables,
                            });
                        }
                    }
                    // TODO Do this with cache.evict({ id: 'ROOT_MUTATION' }) but make it
                    // shallow to allow rolling back optimistic evictions.
                    if (!skipCache && !mutation.keepRootFields && !this.hasNext) {
                        cache.modify({
                            id: "ROOT_MUTATION",
                            fields(value, { fieldName, DELETE }) {
                                return fieldName === "__typename" ? value : DELETE;
                            },
                        });
                    }
                },
                include: refetchQueries,
                // Write the final mutation.result to the root layer of the cache.
                optimistic: false,
                // Remove the corresponding optimistic layer at the same time as we
                // write the final non-optimistic result.
                removeOptimistic: mutation.removeOptimistic,
                // Let the caller of client.mutate optionally determine the refetching
                // behavior for watched queries after the mutation.update function runs.
                // If no onQueryUpdated function was provided for this mutation, pass
                // null instead of undefined to disable the default refetching behavior.
                onQueryUpdated: mutation.onQueryUpdated || null,
            })
                .forEach((result) => results.push(result));
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) {
                // Returning a promise here makes the mutation await that promise, so we
                // include results in that promise's work if awaitRefetchQueries or an
                // onQueryUpdated function was specified.
                return Promise.all(results).then(() => result);
            }
        }
        return Promise.resolve(result);
    }
    markMutationOptimistic(optimisticResponse, mutation) {
        const data = typeof optimisticResponse === "function" ?
            optimisticResponse(mutation.variables, { IGNORE })
            : optimisticResponse;
        if (data === IGNORE) {
            return false;
        }
        this.cache.recordOptimisticTransaction((cache) => {
            try {
                this.markMutationResult({ data }, mutation, cache);
            }
            catch (error) {
                invariant/* invariant,error */.kG.error(error);
            }
        }, this.id);
        return true;
    }
    markSubscriptionResult(result, { document, variables, errorPolicy, cacheWriteBehavior, }) {
        if (cacheWriteBehavior !== 0 /* CacheWriteBehavior.FORBID */) {
            if (shouldWriteResult(result, errorPolicy)) {
                this.cache.write({
                    query: document,
                    result: result.data,
                    dataId: "ROOT_SUBSCRIPTION",
                    variables: variables,
                });
            }
            this.queryManager.broadcastQueries();
        }
    }
}
function shouldWriteResult(result, errorPolicy = "none") {
    const ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    let writeWithErrors = !graphQLResultHasError(result);
    if (!writeWithErrors && ignoreErrors && result.data) {
        writeWithErrors = true;
    }
    return writeWithErrors;
}
//# sourceMappingURL=QueryInfo.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/core/QueryManager.js
















class QueryManager {
    defaultOptions;
    client;
    /**
     * The options that were passed to the ApolloClient constructor.
     */
    clientOptions;
    assumeImmutableResults;
    documentTransform;
    ssrMode;
    defaultContext;
    dataMasking;
    incrementalHandler;
    localState;
    queryDeduplication;
    /**
     * Whether to prioritize cache values over network results when
     * `fetchObservableWithInfo` is called.
     * This will essentially turn a `"network-only"` or `"cache-and-network"`
     * fetchPolicy into a `"cache-first"` fetchPolicy, but without influencing
     * the `fetchPolicy` of the `ObservableQuery`.
     *
     * This can e.g. be used to prioritize the cache during the first render after
     * SSR.
     */
    prioritizeCacheValues = false;
    onBroadcast;
    mutationStore;
    /**
     * All ObservableQueries that currently have at least one subscriber.
     */
    obsQueries = new Set();
    // Maps from queryInfo.id strings to Promise rejection functions for
    // currently active queries and fetches.
    // Use protected instead of private field so
    // @apollo/experimental-nextjs-app-support can access type info.
    fetchCancelFns = new Map();
    constructor(options) {
        const defaultDocumentTransform = new DocumentTransform((document) => this.cache.transformDocument(document), 
        // Allow the apollo cache to manage its own transform caches
        { cache: false });
        this.client = options.client;
        this.defaultOptions = options.defaultOptions;
        this.queryDeduplication = options.queryDeduplication;
        this.clientOptions = options.clientOptions;
        this.ssrMode = options.ssrMode;
        this.assumeImmutableResults = options.assumeImmutableResults;
        this.dataMasking = options.dataMasking;
        this.localState = options.localState;
        this.incrementalHandler = options.incrementalHandler;
        const documentTransform = options.documentTransform;
        this.documentTransform =
            documentTransform ?
                defaultDocumentTransform
                    .concat(documentTransform)
                    // The custom document transform may add new fragment spreads or new
                    // field selections, so we want to give the cache a chance to run
                    // again. For example, the InMemoryCache adds __typename to field
                    // selections and fragments from the fragment registry.
                    .concat(defaultDocumentTransform)
                : defaultDocumentTransform;
        this.defaultContext = options.defaultContext || {};
        if ((this.onBroadcast = options.onBroadcast)) {
            this.mutationStore = {};
        }
    }
    get link() {
        return this.client.link;
    }
    get cache() {
        return this.client.cache;
    }
    /**
     * Call this method to terminate any active query processes, making it safe
     * to dispose of this QueryManager instance.
     */
    stop() {
        this.obsQueries.forEach((oq) => oq.stop());
        this.cancelPendingFetches((0,invariant/* newInvariantError */._K)(83));
    }
    cancelPendingFetches(error) {
        this.fetchCancelFns.forEach((cancel) => cancel(error));
        this.fetchCancelFns.clear();
    }
    async mutate({ mutation, variables, optimisticResponse, updateQueries, refetchQueries = [], awaitRefetchQueries = false, update: updateWithProxyFn, onQueryUpdated, fetchPolicy, errorPolicy, keepRootFields, context, }) {
        const queryInfo = new QueryInfo(this);
        mutation = this.cache.transformForLink(this.transform(mutation));
        const { hasClientExports } = this.getDocumentInfo(mutation);
        variables = this.getVariables(mutation, variables);
        if (hasClientExports) {
            if (index_production/* __DEV__ */.T) {
                (0,invariant/* invariant */.kG)(this.localState, 84, (0,getOperationName/* getOperationName */.r)(mutation, "(anonymous)"));
            }
            variables = await this.localState.getExportedVariables({
                client: this.client,
                document: mutation,
                variables,
                context,
            });
        }
        const mutationStoreValue = this.mutationStore &&
            (this.mutationStore[queryInfo.id] = {
                mutation,
                variables,
                loading: true,
                error: null,
            });
        const isOptimistic = optimisticResponse &&
            queryInfo.markMutationOptimistic(optimisticResponse, {
                document: mutation,
                variables,
                cacheWriteBehavior: fetchPolicy === "no-cache" ?
                    0 /* CacheWriteBehavior.FORBID */
                    : 2 /* CacheWriteBehavior.MERGE */,
                errorPolicy,
                context,
                updateQueries,
                update: updateWithProxyFn,
                keepRootFields,
            });
        this.broadcastQueries();
        return new Promise((resolve, reject) => {
            const cause = {};
            return this.getObservableFromLink(mutation, {
                ...context,
                optimisticResponse: isOptimistic ? optimisticResponse : void 0,
            }, variables, {}, false)
                .observable.pipe(validateDidEmitValue(), mergeMap((result) => {
                const storeResult = { ...result };
                return from_from(queryInfo.markMutationResult(storeResult, {
                    document: mutation,
                    variables,
                    cacheWriteBehavior: fetchPolicy === "no-cache" ?
                        0 /* CacheWriteBehavior.FORBID */
                        : 2 /* CacheWriteBehavior.MERGE */,
                    errorPolicy,
                    context,
                    update: updateWithProxyFn,
                    updateQueries,
                    awaitRefetchQueries,
                    refetchQueries,
                    removeOptimistic: isOptimistic ? queryInfo.id : void 0,
                    onQueryUpdated,
                    keepRootFields,
                }));
            }))
                .pipe(map_map((storeResult) => {
                const hasErrors = graphQLResultHasError(storeResult);
                if (hasErrors && errorPolicy === "none") {
                    throw new CombinedGraphQLErrors(storeResult);
                }
                if (mutationStoreValue) {
                    mutationStoreValue.loading = false;
                    mutationStoreValue.error = null;
                }
                return storeResult;
            }))
                .subscribe({
                next: (storeResult) => {
                    this.broadcastQueries();
                    // Since mutations might receive multiple payloads from the
                    // ApolloLink chain (e.g. when used with @defer),
                    // we resolve with a SingleExecutionResult or after the final
                    // ExecutionPatchResult has arrived and we have assembled the
                    // multipart response into a single result.
                    if (!queryInfo.hasNext) {
                        const result = {
                            data: this.maskOperation({
                                document: mutation,
                                data: storeResult.data,
                                fetchPolicy,
                                cause,
                            }),
                        };
                        if (graphQLResultHasError(storeResult)) {
                            result.error = new CombinedGraphQLErrors(storeResult);
                        }
                        if (Object.keys(storeResult.extensions || {}).length) {
                            result.extensions = storeResult.extensions;
                        }
                        resolve(result);
                    }
                },
                error: (error) => {
                    if (mutationStoreValue) {
                        mutationStoreValue.loading = false;
                        mutationStoreValue.error = error;
                    }
                    if (isOptimistic) {
                        this.cache.removeOptimistic(queryInfo.id);
                    }
                    this.broadcastQueries();
                    if (errorPolicy === "ignore") {
                        return resolve({ data: undefined });
                    }
                    if (errorPolicy === "all") {
                        return resolve({ data: undefined, error });
                    }
                    reject(error);
                },
            });
        });
    }
    fetchQuery(options, networkStatus) {
        (0,checkDocument/* checkDocument */.A)(options.query, ast/* OperationTypeNode,QUERY */.ku.QUERY);
        // do the rest asynchronously to keep the same rejection timing as
        // checks further in `.mutate`
        return (async () => lastValueFrom(this.fetchObservableWithInfo(options, {
            networkStatus,
        }).observable.pipe(filterMap((value) => {
            switch (value.kind) {
                case "E":
                    throw value.error;
                case "N": {
                    if (value.source !== "newNetworkStatus")
                        return toQueryResult(value.value);
                }
            }
        })), {
            // This default is needed when a `standby` fetch policy is used to avoid
            // an EmptyError from rejecting this promise.
            defaultValue: { data: undefined },
        }))();
    }
    transform(document) {
        return this.documentTransform.transformDocument(document);
    }
    transformCache = new caches/* AutoCleanedWeakCache */.s(sizes/* cacheSizes,queryManager.getDocumentInfo */.Q["queryManager.getDocumentInfo"] ||
        2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */);
    getDocumentInfo(document) {
        const { transformCache } = this;
        if (!transformCache.has(document)) {
            const operationDefinition = (0,getOperationDefinition/* getOperationDefinition */.$)(document);
            const cacheEntry = {
                // TODO These three calls (hasClientExports, shouldForceResolvers, and
                // usesNonreactiveDirective) are performing independent full traversals
                // of the transformed document. We should consider merging these
                // traversals into a single pass in the future, though the work is
                // cached after the first time.
                hasClientExports: (0,hasDirectives/* hasDirectives */.F)(["client", "export"], document, true),
                hasForcedResolvers: hasForcedResolvers(document),
                hasNonreactiveDirective: (0,hasDirectives/* hasDirectives */.F)(["nonreactive"], document),
                hasIncrementalDirective: (0,hasDirectives/* hasDirectives */.F)(["defer"], document),
                nonReactiveQuery: addNonReactiveToNamedFragments(document),
                clientQuery: (0,hasDirectives/* hasDirectives */.F)(["client"], document) ? document : null,
                serverQuery: removeDirectivesFromDocument([
                    { name: "client", remove: true },
                    { name: "connection" },
                    { name: "nonreactive" },
                    { name: "unmask" },
                ], document),
                operationType: operationDefinition?.operation,
                defaultVars: getDefaultValues(operationDefinition),
                // Transform any mutation or subscription operations to query operations
                // so we can read/write them from/to the cache.
                asQuery: {
                    ...document,
                    definitions: document.definitions.map((def) => {
                        if (def.kind === "OperationDefinition" &&
                            def.operation !== "query") {
                            return { ...def, operation: "query" };
                        }
                        return def;
                    }),
                },
            };
            transformCache.set(document, cacheEntry);
        }
        const entry = transformCache.get(document);
        if (entry.violation) {
            throw entry.violation;
        }
        return entry;
    }
    getVariables(document, variables) {
        const defaultVars = this.getDocumentInfo(document).defaultVars;
        const varsWithDefaults = Object.entries(variables ?? {}).map(([key, value]) => [key, value === undefined ? defaultVars[key] : value]);
        return {
            ...defaultVars,
            ...Object.fromEntries(varsWithDefaults),
        };
    }
    watchQuery(options) {
        (0,checkDocument/* checkDocument */.A)(options.query, ast/* OperationTypeNode,QUERY */.ku.QUERY);
        const query = this.transform(options.query);
        // assign variable default values if supplied
        // NOTE: We don't modify options.query here with the transformed query to
        // ensure observable.options.query is set to the raw untransformed query.
        options = {
            ...options,
            variables: this.getVariables(query, options.variables),
        };
        if (typeof options.notifyOnNetworkStatusChange === "undefined") {
            options.notifyOnNetworkStatusChange = true;
        }
        const observable = new ObservableQuery({
            queryManager: this,
            options,
            transformedQuery: query,
        });
        return observable;
    }
    query(options) {
        const query = this.transform(options.query);
        return this.fetchQuery({
            ...options,
            query,
        }).then((value) => ({
            ...value,
            data: this.maskOperation({
                document: query,
                data: value?.data,
                fetchPolicy: options.fetchPolicy,
            }),
        }));
    }
    requestIdCounter = 1;
    generateRequestId() {
        return this.requestIdCounter++;
    }
    clearStore(options = {
        discardWatches: true,
    }) {
        // Before we have sent the reset action to the store, we can no longer
        // rely on the results returned by in-flight requests since these may
        // depend on values that previously existed in the data portion of the
        // store. So, we cancel the promises and observers that we have issued
        // so far and not yet resolved (in the case of queries).
        this.cancelPendingFetches((0,invariant/* newInvariantError */._K)(85));
        this.obsQueries.forEach((observableQuery) => {
            // Set loading to true so listeners don't trigger unless they want
            // results with partial data.
            observableQuery.reset();
        });
        if (this.mutationStore) {
            this.mutationStore = {};
        }
        // begin removing data from the store
        return this.cache.reset(options);
    }
    getObservableQueries(include = "active") {
        const queries = new Set();
        const queryNames = new Map();
        const queryNamesAndQueryStrings = new Map();
        const legacyQueryOptions = new Set();
        if (Array.isArray(include)) {
            include.forEach((desc) => {
                if (typeof desc === "string") {
                    queryNames.set(desc, desc);
                    queryNamesAndQueryStrings.set(desc, false);
                }
                else if (isDocumentNode(desc)) {
                    const queryString = (0,graphql_print/* print */.S)(this.transform(desc));
                    queryNames.set(queryString, (0,getOperationName/* getOperationName */.r)(desc));
                    queryNamesAndQueryStrings.set(queryString, false);
                }
                else if ((0,isNonNullObject/* isNonNullObject */.s)(desc) && desc.query) {
                    legacyQueryOptions.add(desc);
                }
            });
        }
        this.obsQueries.forEach((oq) => {
            const document = (0,graphql_print/* print */.S)(this.transform(oq.options.query));
            if (include === "all") {
                queries.add(oq);
                return;
            }
            const { queryName, options: { fetchPolicy }, } = oq;
            if (include === "active" && fetchPolicy === "standby") {
                return;
            }
            if (include === "active" ||
                (queryName && queryNamesAndQueryStrings.has(queryName)) ||
                (document && queryNamesAndQueryStrings.has(document))) {
                queries.add(oq);
                if (queryName)
                    queryNamesAndQueryStrings.set(queryName, true);
                if (document)
                    queryNamesAndQueryStrings.set(document, true);
            }
        });
        if (legacyQueryOptions.size) {
            legacyQueryOptions.forEach((options) => {
                const oq = new ObservableQuery({
                    queryManager: this,
                    options: {
                        ...options,
                        fetchPolicy: "network-only",
                    },
                });
                queries.add(oq);
            });
        }
        if (index_production/* __DEV__ */.T && queryNamesAndQueryStrings.size) {
            queryNamesAndQueryStrings.forEach((included, nameOrQueryString) => {
                if (!included) {
                    const queryName = queryNames.get(nameOrQueryString);
                    if (queryName) {
                        index_production/* __DEV__ */.T && invariant/* invariant,warn */.kG.warn(86, queryName);
                    }
                    else {
                        index_production/* __DEV__ */.T && invariant/* invariant,warn */.kG.warn(87);
                    }
                }
            });
        }
        return queries;
    }
    refetchObservableQueries(includeStandby = false) {
        const observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach((observableQuery) => {
            const { fetchPolicy } = observableQuery.options;
            if ((includeStandby || fetchPolicy !== "standby") &&
                fetchPolicy !== "cache-only") {
                observableQueryPromises.push(observableQuery.refetch());
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    }
    startGraphQLSubscription(options) {
        let { query, variables } = options;
        const { fetchPolicy, errorPolicy = "none", context = {}, extensions = {}, } = options;
        (0,checkDocument/* checkDocument */.A)(query, ast/* OperationTypeNode,SUBSCRIPTION */.ku.SUBSCRIPTION);
        query = this.transform(query);
        variables = this.getVariables(query, variables);
        let restart;
        if (index_production/* __DEV__ */.T) {
            (0,invariant/* invariant */.kG)(
                !this.getDocumentInfo(query).hasClientExports || this.localState,
                88,
                (0,getOperationName/* getOperationName */.r)(query, "(anonymous)")
            );
        }
        const observable = (this.getDocumentInfo(query).hasClientExports ?
            from_from(this.localState.getExportedVariables({
                client: this.client,
                document: query,
                variables,
                context,
            }))
            : of(variables)).pipe(mergeMap((variables) => {
            const { observable, restart: res } = this.getObservableFromLink(query, context, variables, extensions);
            const queryInfo = new QueryInfo(this);
            restart = res;
            return observable.pipe(map_map((rawResult) => {
                queryInfo.markSubscriptionResult(rawResult, {
                    document: query,
                    variables,
                    errorPolicy,
                    cacheWriteBehavior: fetchPolicy === "no-cache" ?
                        0 /* CacheWriteBehavior.FORBID */
                        : 2 /* CacheWriteBehavior.MERGE */,
                });
                const result = {
                    data: rawResult.data ?? undefined,
                };
                if (graphQLResultHasError(rawResult)) {
                    result.error = new CombinedGraphQLErrors(rawResult);
                }
                else if ((0,client_errors/* graphQLResultHasProtocolErrors */.ls)(rawResult)) {
                    result.error = rawResult.extensions[client_errors/* PROTOCOL_ERRORS_SYMBOL */.YG];
                    // Don't emit protocol errors added by HttpLink
                    delete rawResult.extensions[client_errors/* PROTOCOL_ERRORS_SYMBOL */.YG];
                }
                if (rawResult.extensions &&
                    Object.keys(rawResult.extensions).length) {
                    result.extensions = rawResult.extensions;
                }
                if (result.error && errorPolicy === "none") {
                    result.data = undefined;
                }
                if (errorPolicy === "ignore") {
                    delete result.error;
                }
                return result;
            }), catchError((error) => {
                if (errorPolicy === "ignore") {
                    return of({
                        data: undefined,
                    });
                }
                return of({ data: undefined, error });
            }), filter((result) => !!(result.data || result.error)));
        }));
        return Object.assign(observable, { restart: () => restart?.() });
    }
    broadcastQueries() {
        if (this.onBroadcast)
            this.onBroadcast();
        this.obsQueries.forEach((observableQuery) => observableQuery.notify());
    }
    // Use protected instead of private field so
    // @apollo/experimental-nextjs-app-support can access type info.
    inFlightLinkObservables = new Trie(false);
    getObservableFromLink(query, context, variables, extensions, 
    // Prefer context.queryDeduplication if specified.
    deduplication = context?.queryDeduplication ??
        this.queryDeduplication) {
        let entry = {};
        const { serverQuery, clientQuery, operationType, hasIncrementalDirective } = this.getDocumentInfo(query);
        const operationName = (0,getOperationName/* getOperationName */.r)(query);
        const executeContext = {
            client: this.client,
        };
        if (serverQuery) {
            const { inFlightLinkObservables, link } = this;
            try {
                const operation = this.incrementalHandler.prepareRequest({
                    query: serverQuery,
                    variables,
                    context: {
                        ...this.defaultContext,
                        ...context,
                        queryDeduplication: deduplication,
                    },
                    extensions,
                });
                context = operation.context;
                function withRestart(source) {
                    return new Observable/* Observable */.y((observer) => {
                        function subscribe() {
                            return source.subscribe({
                                next: observer.next.bind(observer),
                                complete: observer.complete.bind(observer),
                                error: observer.error.bind(observer),
                            });
                        }
                        let subscription = subscribe();
                        entry.restart ||= () => {
                            subscription.unsubscribe();
                            subscription = subscribe();
                        };
                        return () => {
                            subscription.unsubscribe();
                            entry.restart = undefined;
                        };
                    });
                }
                if (deduplication) {
                    const printedServerQuery = (0,graphql_print/* print */.S)(serverQuery);
                    const varJson = canonicalStringify_canonicalStringify(variables);
                    entry = inFlightLinkObservables.lookup(printedServerQuery, varJson);
                    if (!entry.observable) {
                        entry.observable = execute(link, operation, executeContext).pipe(withRestart, finalize_finalize(() => {
                            if (inFlightLinkObservables.peek(printedServerQuery, varJson) ===
                                entry) {
                                inFlightLinkObservables.remove(printedServerQuery, varJson);
                            }
                        }), 
                        // We don't want to replay the last emitted value for
                        // subscriptions and instead opt to wait to receive updates until
                        // the subscription emits new values.
                        operationType === ast/* OperationTypeNode,SUBSCRIPTION */.ku.SUBSCRIPTION ?
                            share()
                            : shareReplay({ refCount: true }));
                    }
                }
                else {
                    entry.observable = execute(link, operation, executeContext).pipe(withRestart);
                }
            }
            catch (error) {
                entry.observable = (0,throwError/* throwError */._)(() => error);
            }
        }
        else {
            entry.observable = of({ data: {} });
        }
        if (clientQuery) {
            const { operation } = (0,getOperationDefinition/* getOperationDefinition */.$)(query);
            if (index_production/* __DEV__ */.T) {
                (0,invariant/* invariant */.kG)(
                    this.localState,
                    89,
                    operation[0].toUpperCase() + operation.slice(1),
                    operationName ?? "(anonymous)"
                );
            }
            (0,invariant/* invariant */.kG)(
                !hasIncrementalDirective,
                90,
                operation[0].toUpperCase() + operation.slice(1),
                operationName ?? "(anonymous)"
            );
            entry.observable = entry.observable.pipe(mergeMap((result) => {
                return from_from(this.localState.execute({
                    client: this.client,
                    document: clientQuery,
                    remoteResult: result,
                    context,
                    variables,
                }));
            }));
        }
        return {
            restart: () => entry.restart?.(),
            observable: entry.observable.pipe(catchError((error) => {
                error = (0,client_errors/* toErrorLike */.Nh)(error);
                registerLinkError(error);
                throw error;
            })),
        };
    }
    getResultsFromLink(options, { queryInfo, cacheWriteBehavior, observableQuery, }) {
        const requestId = (queryInfo.lastRequestId = this.generateRequestId());
        const { errorPolicy } = options;
        // Performing transformForLink here gives this.cache a chance to fill in
        // missing fragment definitions (for example) before sending this document
        // through the link chain.
        const linkDocument = this.cache.transformForLink(options.query);
        return this.getObservableFromLink(linkDocument, options.context, options.variables).observable.pipe(map_map((incoming) => {
            // Use linkDocument rather than queryInfo.document so the
            // operation/fragments used to write the result are the same as the
            // ones used to obtain it from the link.
            const result = queryInfo.markQueryResult(incoming, {
                ...options,
                document: linkDocument,
                cacheWriteBehavior,
            });
            const hasErrors = graphQLResultHasError(result);
            if (hasErrors && errorPolicy === "none") {
                queryInfo.resetLastWrite();
                observableQuery?.["resetNotifications"]();
                throw new CombinedGraphQLErrors(result);
            }
            const aqr = {
                data: result.data,
                ...(queryInfo.hasNext ?
                    {
                        loading: true,
                        networkStatus: networkStatus_NetworkStatus.streaming,
                        dataState: "streaming",
                        partial: true,
                    }
                    : {
                        dataState: result.data ? "complete" : "empty",
                        loading: false,
                        networkStatus: networkStatus_NetworkStatus.ready,
                        partial: !result.data,
                    }),
            };
            // In the case we start multiple network requests simultaneously, we
            // want to ensure we properly set `data` if we're reporting on an old
            // result which will not be caught by the conditional above that ends up
            // throwing the markError result.
            if (hasErrors) {
                if (errorPolicy === "none") {
                    aqr.data = void 0;
                    aqr.dataState = "empty";
                }
                if (errorPolicy !== "ignore") {
                    aqr.error = new CombinedGraphQLErrors(result);
                    if (aqr.dataState !== "streaming") {
                        aqr.networkStatus = networkStatus_NetworkStatus.error;
                    }
                }
            }
            return aqr;
        }), catchError((error) => {
            // Avoid storing errors from older interrupted queries.
            if (requestId >= queryInfo.lastRequestId && errorPolicy === "none") {
                queryInfo.resetLastWrite();
                observableQuery?.["resetNotifications"]();
                throw error;
            }
            const aqr = {
                data: undefined,
                dataState: "empty",
                loading: false,
                networkStatus: networkStatus_NetworkStatus.ready,
                partial: true,
            };
            if (errorPolicy !== "ignore") {
                aqr.error = error;
                aqr.networkStatus = networkStatus_NetworkStatus.error;
            }
            return of(aqr);
        }));
    }
    fetchObservableWithInfo(options, { 
    // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus = networkStatus_NetworkStatus.loading, query = options.query, fetchQueryOperator = (x) => x, onCacheHit = () => { }, observableQuery, }) {
        const variables = this.getVariables(query, options.variables);
        const defaults = this.defaultOptions.watchQuery;
        let { fetchPolicy = (defaults && defaults.fetchPolicy) || "cache-first", errorPolicy = (defaults && defaults.errorPolicy) || "none", returnPartialData = false, notifyOnNetworkStatusChange = true, context = {}, } = options;
        if (this.prioritizeCacheValues &&
            (fetchPolicy === "network-only" || fetchPolicy === "cache-and-network")) {
            fetchPolicy = "cache-first";
        }
        const normalized = Object.assign({}, options, {
            query,
            variables,
            fetchPolicy,
            errorPolicy,
            returnPartialData,
            notifyOnNetworkStatusChange,
            context,
        });
        const queryInfo = new QueryInfo(this, observableQuery);
        const fromVariables = (variables) => {
            // Since normalized is always a fresh copy of options, it's safe to
            // modify its properties here, rather than creating yet another new
            // WatchQueryOptions object.
            normalized.variables = variables;
            const cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 /* CacheWriteBehavior.FORBID */
                // Watched queries must opt into overwriting existing data on refetch,
                // by passing refetchWritePolicy: "overwrite" in their WatchQueryOptions.
                : (networkStatus === networkStatus_NetworkStatus.refetch &&
                    normalized.refetchWritePolicy !== "merge") ?
                    1 /* CacheWriteBehavior.OVERWRITE */
                    : 2 /* CacheWriteBehavior.MERGE */;
            const observableWithInfo = this.fetchQueryByPolicy(normalized, { queryInfo, cacheWriteBehavior, onCacheHit, observableQuery });
            observableWithInfo.observable =
                observableWithInfo.observable.pipe(fetchQueryOperator);
            if (
            // If we're in standby, postpone advancing options.fetchPolicy using
            // applyNextFetchPolicy.
            normalized.fetchPolicy !== "standby") {
                observableQuery?.["applyNextFetchPolicy"]("after-fetch", options);
            }
            return observableWithInfo;
        };
        // This cancel function needs to be set before the concast is created,
        // in case concast creation synchronously cancels the request.
        const cleanupCancelFn = () => {
            this.fetchCancelFns.delete(queryInfo.id);
        };
        this.fetchCancelFns.set(queryInfo.id, (error) => {
            fetchCancelSubject.next({
                kind: "E",
                error,
                source: "network",
            });
        });
        const fetchCancelSubject = new Subject_Subject();
        let observable, containsDataFromLink;
        // If the query has @export(as: ...) directives, then we need to
        // process those directives asynchronously. When there are no
        // @export directives (the common case), we deliberately avoid
        // wrapping the result of this.fetchQueryByPolicy in a Promise,
        // since the timing of result delivery is (unfortunately) important
        // for backwards compatibility. TODO This code could be simpler if
        // we deprecated and removed LocalState.
        if (this.getDocumentInfo(normalized.query).hasClientExports) {
            if (index_production/* __DEV__ */.T) {
                (0,invariant/* invariant */.kG)(this.localState, 91, (0,getOperationName/* getOperationName */.r)(normalized.query, "(anonymous)"));
            }
            observable = from_from(this.localState.getExportedVariables({
                client: this.client,
                document: normalized.query,
                variables: normalized.variables,
                context: normalized.context,
            })).pipe(mergeMap((variables) => fromVariables(variables).observable));
            // there is just no way we can synchronously get the *right* value here,
            // so we will assume `true`, which is the behaviour before the bug fix in
            // #10597. This means that bug is not fixed in that case, and is probably
            // un-fixable with reasonable effort for the edge case of @export as
            // directives.
            containsDataFromLink = true;
        }
        else {
            const sourcesWithInfo = fromVariables(normalized.variables);
            containsDataFromLink = sourcesWithInfo.fromLink;
            observable = sourcesWithInfo.observable;
        }
        return {
            // Merge `observable` with `fetchCancelSubject`, in a way that completing or
            // erroring either of them will complete the merged obserable.
            observable: new Observable/* Observable */.y((observer) => {
                observer.add(cleanupCancelFn);
                observable.subscribe(observer);
                fetchCancelSubject.subscribe(observer);
            }).pipe(share()),
            fromLink: containsDataFromLink,
        };
    }
    refetchQueries({ updateCache, include, optimistic = false, removeOptimistic = optimistic ? (0,makeUniqueId/* makeUniqueId */.X)("refetchQueries") : void 0, onQueryUpdated, }) {
        const includedQueriesByOq = new Map();
        if (include) {
            this.getObservableQueries(include).forEach((oq) => {
                if (oq.options.fetchPolicy === "cache-only") {
                    return;
                }
                const current = oq.getCurrentResult();
                includedQueriesByOq.set(oq, {
                    oq,
                    lastDiff: {
                        result: current?.data,
                        complete: !current?.partial,
                    },
                });
            });
        }
        const results = new Map();
        if (updateCache) {
            const handled = new Set();
            this.cache.batch({
                update: updateCache,
                // Since you can perform any combination of cache reads and/or writes in
                // the cache.batch update function, its optimistic option can be either
                // a boolean or a string, representing three distinct modes of
                // operation:
                //
                // * false: read/write only the root layer
                // * true: read/write the topmost layer
                // * string: read/write a fresh optimistic layer with that ID string
                //
                // When typeof optimistic === "string", a new optimistic layer will be
                // temporarily created within cache.batch with that string as its ID. If
                // we then pass that same string as the removeOptimistic option, we can
                // make cache.batch immediately remove the optimistic layer after
                // running the updateCache function, triggering only one broadcast.
                //
                // However, the refetchQueries method accepts only true or false for its
                // optimistic option (not string). We interpret true to mean a temporary
                // optimistic layer should be created, to allow efficiently rolling back
                // the effect of the updateCache function, which involves passing a
                // string instead of true as the optimistic option to cache.batch, when
                // refetchQueries receives optimistic: true.
                //
                // In other words, we are deliberately not supporting the use case of
                // writing to an *existing* optimistic layer (using the refetchQueries
                // updateCache function), since that would potentially interfere with
                // other optimistic updates in progress. Instead, you can read/write
                // only the root layer by passing optimistic: false to refetchQueries,
                // or you can read/write a brand new optimistic layer that will be
                // automatically removed by passing optimistic: true.
                optimistic: (optimistic && removeOptimistic) || false,
                // The removeOptimistic option can also be provided by itself, even if
                // optimistic === false, to remove some previously-added optimistic
                // layer safely and efficiently, like we do in markMutationResult.
                //
                // If an explicit removeOptimistic string is provided with optimistic:
                // true, the removeOptimistic string will determine the ID of the
                // temporary optimistic layer, in case that ever matters.
                removeOptimistic,
                onWatchUpdated(watch, diff, lastDiff) {
                    const oq = watch.watcher;
                    if (oq instanceof ObservableQuery && !handled.has(oq)) {
                        handled.add(oq);
                        if (onQueryUpdated) {
                            // Since we're about to handle this query now, remove it from
                            // includedQueriesById, in case it was added earlier because of
                            // options.include.
                            includedQueriesByOq.delete(oq);
                            let result = onQueryUpdated(oq, diff, lastDiff);
                            if (result === true) {
                                // The onQueryUpdated function requested the default refetching
                                // behavior by returning true.
                                result = oq
                                    .refetch()
                                    .retain( /* create a persistent subscription on the query */);
                            }
                            // Record the result in the results Map, as long as onQueryUpdated
                            // did not return false to skip/ignore this result.
                            if (result !== false) {
                                results.set(oq, result);
                            }
                            // Allow the default cache broadcast to happen, except when
                            // onQueryUpdated returns false.
                            return result;
                        }
                        if (onQueryUpdated !== null &&
                            oq.options.fetchPolicy !== "cache-only") {
                            // If we don't have an onQueryUpdated function, and onQueryUpdated
                            // was not disabled by passing null, make sure this query is
                            // "included" like any other options.include-specified query.
                            includedQueriesByOq.set(oq, { oq, lastDiff, diff });
                        }
                    }
                },
            });
        }
        if (includedQueriesByOq.size) {
            includedQueriesByOq.forEach(({ oq, lastDiff, diff }) => {
                let result;
                // If onQueryUpdated is provided, we want to use it for all included
                // queries, even the QueryOptions ones.
                if (onQueryUpdated) {
                    if (!diff) {
                        diff = oq.getCacheDiff();
                    }
                    result = onQueryUpdated(oq, diff, lastDiff);
                }
                // Otherwise, we fall back to refetching.
                if (!onQueryUpdated || result === true) {
                    result = oq
                        .refetch()
                        .retain( /* create a persistent subscription on the query */);
                }
                if (result !== false) {
                    results.set(oq, result);
                }
            });
        }
        if (removeOptimistic) {
            // In case no updateCache callback was provided (so cache.batch was not
            // called above, and thus did not already remove the optimistic layer),
            // remove it here. Since this is a no-op when the layer has already been
            // removed, we do it even if we called cache.batch above, since it's
            // possible this.cache is an instance of some ApolloCache subclass other
            // than InMemoryCache, and does not fully support the removeOptimistic
            // option for cache.batch.
            this.cache.removeOptimistic(removeOptimistic);
        }
        return results;
    }
    noCacheWarningsByCause = new WeakSet();
    maskOperation(options) {
        const { document, data } = options;
        if (index_production/* __DEV__ */.T) {
            const { fetchPolicy, cause = {} } = options;
            const operationType = (0,getOperationDefinition/* getOperationDefinition */.$)(document)?.operation;
            if (this.dataMasking &&
                fetchPolicy === "no-cache" &&
                !isFullyUnmaskedOperation(document) &&
                !this.noCacheWarningsByCause.has(cause)) {
                this.noCacheWarningsByCause.add(cause);
                index_production/* __DEV__ */.T && invariant/* invariant,warn */.kG.warn(92, (0,getOperationName/* getOperationName */.r)(document, `Unnamed ${operationType ?? "operation"}`));
            }
        }
        return (this.dataMasking ?
            maskOperation(data, document, this.cache)
            : data);
    }
    maskFragment(options) {
        const { data, fragment, fragmentName } = options;
        return this.dataMasking ?
            maskFragment(data, fragment, this.cache, fragmentName)
            : data;
    }
    fetchQueryByPolicy({ query, variables, fetchPolicy, errorPolicy, returnPartialData, context, }, { cacheWriteBehavior, onCacheHit, queryInfo, observableQuery, }) {
        const readCache = () => this.cache.diff({
            query,
            variables,
            returnPartialData: true,
            optimistic: true,
        });
        const resultsFromCache = (diff, networkStatus) => {
            const data = diff.result;
            if (index_production/* __DEV__ */.T && !returnPartialData && data !== null) {
                logMissingFieldErrors(diff.missing);
            }
            const toResult = (data) => {
                // TODO: Eventually we should move this handling into
                // queryInfo.getDiff() directly. Since getDiff is updated to return null
                // on returnPartialData: false, we should take advantage of that instead
                // of having to patch it elsewhere.
                if (!diff.complete && !returnPartialData) {
                    data = undefined;
                }
                return {
                    // TODO: Handle partial data
                    data: data,
                    dataState: diff.complete ? "complete"
                        : data ? "partial"
                            : "empty",
                    loading: isNetworkRequestInFlight(networkStatus),
                    networkStatus,
                    partial: !diff.complete,
                };
            };
            const fromData = (data) => {
                return of({
                    kind: "N",
                    value: toResult(data),
                    source: "cache",
                });
            };
            if (
            // Don't attempt to run forced resolvers if we have incomplete cache
            // data and partial isn't allowed since this result would get set to
            // `undefined` anyways in `toResult`.
            (diff.complete || returnPartialData) &&
                this.getDocumentInfo(query).hasForcedResolvers) {
                if (index_production/* __DEV__ */.T) {
                    (0,invariant/* invariant */.kG)(this.localState, 93, (0,getOperationName/* getOperationName */.r)(query, "(anonymous)"));
                }
                onCacheHit();
                return from_from(this.localState.execute({
                    client: this.client,
                    document: query,
                    remoteResult: data ? { data } : undefined,
                    context,
                    variables,
                    onlyRunForcedResolvers: true,
                    returnPartialData: true,
                }).then((resolved) => ({
                    kind: "N",
                    value: toResult(resolved.data || void 0),
                    source: "cache",
                })));
            }
            // Resolves https://github.com/apollographql/apollo-client/issues/10317.
            // If errorPolicy is 'none' and notifyOnNetworkStatusChange is true,
            // data was incorrectly returned from the cache on refetch:
            // if diff.missing exists, we should not return cache data.
            if (errorPolicy === "none" &&
                networkStatus === networkStatus_NetworkStatus.refetch &&
                diff.missing) {
                return fromData(void 0);
            }
            return fromData(data || undefined);
        };
        const resultsFromLink = () => this.getResultsFromLink({
            query,
            variables,
            context,
            fetchPolicy,
            errorPolicy,
        }, {
            cacheWriteBehavior,
            queryInfo,
            observableQuery,
        }).pipe(validateDidEmitValue(), materialize(), map_map((result) => ({
            ...result,
            source: "network",
        })));
        switch (fetchPolicy) {
            default:
            case "cache-first": {
                const diff = readCache();
                if (diff.complete) {
                    return {
                        fromLink: false,
                        observable: resultsFromCache(diff, networkStatus_NetworkStatus.ready),
                    };
                }
                if (returnPartialData) {
                    return {
                        fromLink: true,
                        observable: concat(resultsFromCache(diff, networkStatus_NetworkStatus.loading), resultsFromLink()),
                    };
                }
                return { fromLink: true, observable: resultsFromLink() };
            }
            case "cache-and-network": {
                const diff = readCache();
                if (diff.complete || returnPartialData) {
                    return {
                        fromLink: true,
                        observable: concat(resultsFromCache(diff, networkStatus_NetworkStatus.loading), resultsFromLink()),
                    };
                }
                return { fromLink: true, observable: resultsFromLink() };
            }
            case "cache-only":
                return {
                    fromLink: false,
                    observable: concat(resultsFromCache(readCache(), networkStatus_NetworkStatus.ready)),
                };
            case "network-only":
                return { fromLink: true, observable: resultsFromLink() };
            case "no-cache":
                return { fromLink: true, observable: resultsFromLink() };
            case "standby":
                return { fromLink: false, observable: empty/* EMPTY */.E };
        }
    }
}
function validateDidEmitValue() {
    let didEmitValue = false;
    return tap({
        next() {
            didEmitValue = true;
        },
        complete() {
            (0,invariant/* invariant */.kG)(didEmitValue, 94);
        },
    });
}
function isFullyUnmaskedOperation(document) {
    let isUnmasked = true;
    (0,visitor/* visit */.Vn)(document, {
        FragmentSpread: (node) => {
            isUnmasked =
                !!node.directives &&
                    node.directives.some((directive) => directive.name.value === "unmask");
            if (!isUnmasked) {
                return visitor/* BREAK */.$_;
            }
        },
    });
    return isUnmasked;
}
function addNonReactiveToNamedFragments(document) {
    return (0,visitor/* visit */.Vn)(document, {
        FragmentSpread: (node) => {
            // Do not add `@nonreactive` if the fragment is marked with `@unmask`
            // since we want to react to changes in this fragment.
            if (node.directives?.some((directive) => directive.name.value === "unmask")) {
                return;
            }
            return {
                ...node,
                directives: [
                    ...(node.directives || []),
                    {
                        kind: kinds/* Kind,DIRECTIVE */.h.DIRECTIVE,
                        name: { kind: kinds/* Kind,NAME */.h.NAME, value: "nonreactive" },
                    },
                ],
            };
        },
    });
}
//# sourceMappingURL=QueryManager.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/core/ApolloClient.js










let hasSuggestedDevtools = false;
/**
 * This is the primary Apollo Client class. It is used to send GraphQL documents (i.e. queries
 * and mutations) to a GraphQL spec-compliant server over an `ApolloLink` instance,
 * receive results from the server and cache the results in a store. It also delivers updates
 * to GraphQL queries through `Observable` instances.
 */
class ApolloClient {
    link;
    cache;
    /**
     * @deprecated `disableNetworkFetches` has been renamed to `prioritizeCacheValues`.
     */
    disableNetworkFetches;
    set prioritizeCacheValues(value) {
        this.queryManager.prioritizeCacheValues = value;
    }
    /**
     * Whether to prioritize cache values over network results when `query` or `watchQuery` is called.
     * This will essentially turn a `"network-only"` or `"cache-and-network"` fetchPolicy into a `"cache-first"` fetchPolicy,
     * but without influencing the `fetchPolicy` of the created `ObservableQuery` long-term.
     *
     * This can e.g. be used to prioritize the cache during the first render after SSR.
     */
    get prioritizeCacheValues() {
        return this.queryManager.prioritizeCacheValues;
    }
    version;
    queryDeduplication;
    defaultOptions;
    devtoolsConfig;
    queryManager;
    devToolsHookCb;
    resetStoreCallbacks = [];
    clearStoreCallbacks = [];
    /**
     * Constructs an instance of `ApolloClient`.
     *
     * @example
     *
     * ```js
     * import { ApolloClient, InMemoryCache } from "@apollo/client";
     *
     * const cache = new InMemoryCache();
     *
     * const client = new ApolloClient({
     *   // Provide required constructor fields
     *   cache: cache,
     *   uri: "http://localhost:4000/",
     *
     *   // Provide some optional constructor fields
     *   name: "react-web-client",
     *   version: "1.3",
     *   queryDeduplication: false,
     *   defaultOptions: {
     *     watchQuery: {
     *       fetchPolicy: "cache-and-network",
     *     },
     *   },
     * });
     * ```
     */
    constructor(options) {
        if (index_production/* __DEV__ */.T) {
            (0,invariant/* invariant */.kG)(options.cache, 65);
            (0,invariant/* invariant */.kG)(options.link, 66);
        }
        const { cache, documentTransform, ssrMode = false, ssrForceFetchDelay = 0, queryDeduplication = true, defaultOptions, defaultContext, assumeImmutableResults = cache.assumeImmutableResults, localState, devtools, dataMasking, link, incrementalHandler = new NotImplementedHandler(), } = options;
        this.link = link;
        this.cache = cache;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.devtoolsConfig = {
            ...devtools,
            enabled: devtools?.enabled ?? index_production/* __DEV__ */.T,
        };
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.watchFragment = this.watchFragment.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.refetchObservableQueries =
            this.refetchObservableQueries.bind(this);
        this.version = version/* version */.i;
        this.queryManager = new QueryManager({
            client: this,
            defaultOptions: this.defaultOptions,
            defaultContext,
            documentTransform,
            queryDeduplication,
            ssrMode,
            dataMasking: !!dataMasking,
            clientOptions: options,
            incrementalHandler,
            assumeImmutableResults,
            onBroadcast: this.devtoolsConfig.enabled ?
                () => {
                    if (this.devToolsHookCb) {
                        this.devToolsHookCb();
                    }
                }
                : void 0,
            localState,
        });
        this.prioritizeCacheValues = ssrMode || ssrForceFetchDelay > 0;
        if (ssrForceFetchDelay) {
            setTimeout(() => {
                this.prioritizeCacheValues = false;
            }, ssrForceFetchDelay);
        }
        if (this.devtoolsConfig.enabled)
            this.connectToDevTools();
    }
    connectToDevTools() {
        if (typeof window === "undefined") {
            return;
        }
        const windowWithDevTools = window;
        const devtoolsSymbol = Symbol.for("apollo.devtools");
        (windowWithDevTools[devtoolsSymbol] =
            windowWithDevTools[devtoolsSymbol] || []).push(this);
        windowWithDevTools.__APOLLO_CLIENT__ = this;
        /**
         * Suggest installing the devtools for developers who don't have them
         */
        if (!hasSuggestedDevtools && index_production/* __DEV__ */.T) {
            hasSuggestedDevtools = true;
            if (window.document &&
                window.top === window.self &&
                /^(https?|file):$/.test(window.location.protocol)) {
                setTimeout(() => {
                    if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                        const nav = window.navigator;
                        const ua = nav && nav.userAgent;
                        let url;
                        if (typeof ua === "string") {
                            if (ua.indexOf("Chrome/") > -1) {
                                url =
                                    "https://chrome.google.com/webstore/detail/" +
                                        "apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                            }
                            else if (ua.indexOf("Firefox/") > -1) {
                                url =
                                    "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                            }
                        }
                        if (url) {
                            index_production/* __DEV__ */.T && invariant/* invariant,log */.kG.log("Download the Apollo DevTools for a better development " +
                                "experience: %s", url);
                        }
                    }
                }, 10000);
            }
        }
    }
    /**
     * The `DocumentTransform` used to modify GraphQL documents before a request
     * is made. If a custom `DocumentTransform` is not provided, this will be the
     * default document transform.
     */
    get documentTransform() {
        return this.queryManager.documentTransform;
    }
    /**
     * The configured `LocalState` instance used to enable the use of `@client`
     * fields.
     */
    get localState() {
        return this.queryManager.localState;
    }
    set localState(localState) {
        this.queryManager.localState = localState;
    }
    /**
     * Call this method to terminate any active client processes, making it safe
     * to dispose of this `ApolloClient` instance.
     *
     * This method performs aggressive cleanup to prevent memory leaks:
     *
     * - Unsubscribes all active `ObservableQuery` instances by emitting a `completed` event
     * - Rejects all currently running queries with "QueryManager stopped while query was in flight"
     * - Removes all queryRefs from the suspense cache
     */
    stop() {
        this.queryManager.stop();
    }
    /**
     * This watches the cache store of the query according to the options specified and
     * returns an `ObservableQuery`. We can subscribe to this `ObservableQuery` and
     * receive updated results through an observer when the cache store changes.
     *
     * Note that this method is not an implementation of GraphQL subscriptions. Rather,
     * it uses Apollo's store in order to reactively deliver updates to your query results.
     *
     * For example, suppose you call watchQuery on a GraphQL query that fetches a person's
     * first and last name and this person has a particular object identifier, provided by
     * `cache.identify`. Later, a different query fetches that same person's
     * first and last name and the first name has now changed. Then, any observers associated
     * with the results of the first query will be updated with a new result object.
     *
     * Note that if the cache does not change, the subscriber will _not_ be notified.
     *
     * See [here](https://medium.com/apollo-stack/the-concepts-of-graphql-bc68bd819be3#.3mb0cbcmc) for
     * a description of store reactivity.
     */
    watchQuery(options) {
        if (this.defaultOptions.watchQuery) {
            options = mergeOptions(this.defaultOptions.watchQuery, options);
        }
        return this.queryManager.watchQuery(options);
    }
    /**
     * This resolves a single query according to the options specified and
     * returns a `Promise` which is either resolved with the resulting data
     * or rejected with an error.
     *
     * @param options - An object of type `QueryOptions` that allows us to
     * describe how this query should be treated e.g. whether it should hit the
     * server at all or just resolve from the cache, etc.
     */
    query(options) {
        if (this.defaultOptions.query) {
            options = mergeOptions(this.defaultOptions.query, options);
        }
        if (index_production/* __DEV__ */.T) {
            (0,invariant/* invariant */.kG)(options.fetchPolicy !== "cache-and-network", 67);
            (0,invariant/* invariant */.kG)(options.fetchPolicy !== "standby", 68);
            (0,invariant/* invariant */.kG)(options.query, 69);
            (0,invariant/* invariant */.kG)(options.query.kind === "Document", 70);
            (0,invariant/* invariant */.kG)(!options.returnPartialData, 71);
            (0,invariant/* invariant */.kG)(!options.pollInterval, 72);
            (0,invariant/* invariant */.kG)(!options.notifyOnNetworkStatusChange, 73);
        }
        return this.queryManager.query(options);
    }
    /**
     * This resolves a single mutation according to the options specified and returns a
     * Promise which is either resolved with the resulting data or rejected with an
     * error. In some cases both `data` and `errors` might be undefined, for example
     * when `errorPolicy` is set to `'ignore'`.
     *
     * It takes options as an object with the following keys and values:
     */
    mutate(options) {
        const optionsWithDefaults = mergeOptions((0,compact/* compact */.o)({
            fetchPolicy: "network-only",
            errorPolicy: "none",
        }, this.defaultOptions.mutate), options);
        if (index_production/* __DEV__ */.T) {
            (0,invariant/* invariant */.kG)(optionsWithDefaults.mutation, 74);
            (0,invariant/* invariant */.kG)(optionsWithDefaults.fetchPolicy === "network-only" ||
                optionsWithDefaults.fetchPolicy === "no-cache", 75);
        }
        (0,checkDocument/* checkDocument */.A)(optionsWithDefaults.mutation, ast/* OperationTypeNode,MUTATION */.ku.MUTATION);
        return this.queryManager.mutate(optionsWithDefaults);
    }
    /**
     * This subscribes to a graphql subscription according to the options specified and returns an
     * `Observable` which either emits received data or an error.
     */
    subscribe(options) {
        const cause = {};
        const observable = this.queryManager.startGraphQLSubscription(options);
        const mapped = observable.pipe(map_map((result) => ({
            ...result,
            data: this.queryManager.maskOperation({
                document: options.query,
                data: result.data,
                fetchPolicy: options.fetchPolicy,
                cause,
            }),
        })));
        return Object.assign(mapped, { restart: observable.restart });
    }
    readQuery(options, optimistic = false) {
        return this.cache.readQuery({ ...options, query: this.transform(options.query) }, optimistic);
    }
    /**
     * Watches the cache store of the fragment according to the options specified
     * and returns an `Observable`. We can subscribe to this
     * `Observable` and receive updated results through an
     * observer when the cache store changes.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     *
     * @since 3.10.0
     * @param options - An object of type `WatchFragmentOptions` that allows
     * the cache to identify the fragment and optionally specify whether to react
     * to optimistic updates.
     */
    watchFragment(options) {
        const dataMasking = this.queryManager.dataMasking;
        return this.cache
            .watchFragment({
            ...options,
            fragment: this.transform(options.fragment, dataMasking),
        })
            .pipe(map_map((result) => {
            // The transform will remove fragment spreads from the fragment
            // document when dataMasking is enabled. The `maskFragment` function
            // remains to apply warnings to fragments marked as
            // `@unmask(mode: "migrate")`. Since these warnings are only applied
            // in dev, we can skip the masking algorithm entirely for production.
            if (index_production/* __DEV__ */.T) {
                if (dataMasking) {
                    const data = this.queryManager.maskFragment({
                        ...options,
                        data: result.data,
                    });
                    return { ...result, data };
                }
            }
            return result;
        }));
    }
    readFragment(options, optimistic = false) {
        return this.cache.readFragment({ ...options, fragment: this.transform(options.fragment) }, optimistic);
    }
    /**
     * Writes some data in the shape of the provided GraphQL query directly to
     * the store. This method will start at the root query. To start at a
     * specific id returned by `cache.identify` then use `writeFragment`.
     */
    writeQuery(options) {
        const ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) {
            this.queryManager.broadcastQueries();
        }
        return ref;
    }
    /**
     * Writes some data in the shape of the provided GraphQL fragment directly to
     * the store. This method will write to a GraphQL fragment from any arbitrary
     * id that is currently cached, unlike `writeQuery` which will only write
     * from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are writing. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     */
    writeFragment(options) {
        const ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) {
            this.queryManager.broadcastQueries();
        }
        return ref;
    }
    __actionHookForDevTools(cb) {
        this.devToolsHookCb = cb;
    }
    __requestRaw(request) {
        return execute(this.link, request, { client: this });
    }
    /**
     * Resets your entire store by clearing out your cache and then re-executing
     * all of your active queries. This makes it so that you may guarantee that
     * there is no data left in your store from a time before you called this
     * method.
     *
     * `resetStore()` is useful when your user just logged out. You’ve removed the
     * user session, and you now want to make sure that any references to data you
     * might have fetched while the user session was active is gone.
     *
     * It is important to remember that `resetStore()` _will_ refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */
    resetStore() {
        return Promise.resolve()
            .then(() => this.queryManager.clearStore({
            discardWatches: false,
        }))
            .then(() => Promise.all(this.resetStoreCallbacks.map((fn) => fn())))
            .then(() => this.refetchObservableQueries());
    }
    /**
     * Remove all data from the store. Unlike `resetStore`, `clearStore` will
     * not refetch any active queries.
     */
    clearStore() {
        return Promise.resolve()
            .then(() => this.queryManager.clearStore({
            discardWatches: true,
        }))
            .then(() => Promise.all(this.clearStoreCallbacks.map((fn) => fn())));
    }
    /**
     * Allows callbacks to be registered that are executed when the store is
     * reset. `onResetStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */
    onResetStore(cb) {
        this.resetStoreCallbacks.push(cb);
        return () => {
            this.resetStoreCallbacks = this.resetStoreCallbacks.filter((c) => c !== cb);
        };
    }
    /**
     * Allows callbacks to be registered that are executed when the store is
     * cleared. `onClearStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */
    onClearStore(cb) {
        this.clearStoreCallbacks.push(cb);
        return () => {
            this.clearStoreCallbacks = this.clearStoreCallbacks.filter((c) => c !== cb);
        };
    }
    /**
     * Refetches all of your active queries.
     *
     * `reFetchObservableQueries()` is useful if you want to bring the client back to proper state in case of a network outage
     *
     * It is important to remember that `reFetchObservableQueries()` _will_ refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     * Takes optional parameter `includeStandby` which will include queries in standby-mode when refetching.
     *
     * Note: `cache-only` queries are not refetched by this function.
     *
     * @deprecated Please use `refetchObservableQueries` instead.
     */
    reFetchObservableQueries;
    /**
     * Refetches all of your active queries.
     *
     * `refetchObservableQueries()` is useful if you want to bring the client back to proper state in case of a network outage
     *
     * It is important to remember that `refetchObservableQueries()` _will_ refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     * Takes optional parameter `includeStandby` which will include queries in standby-mode when refetching.
     *
     * Note: `cache-only` queries are not refetched by this function.
     */
    refetchObservableQueries(includeStandby) {
        return this.queryManager.refetchObservableQueries(includeStandby);
    }
    /**
     * Refetches specified active queries. Similar to "refetchObservableQueries()" but with a specific list of queries.
     *
     * `refetchQueries()` is useful for use cases to imperatively refresh a selection of queries.
     *
     * It is important to remember that `refetchQueries()` _will_ refetch specified active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */
    refetchQueries(options) {
        const map = this.queryManager.refetchQueries(options);
        const queries = [];
        const results = [];
        map.forEach((result, obsQuery) => {
            queries.push(obsQuery);
            results.push(result);
        });
        const result = Promise.all(results);
        // In case you need the raw results immediately, without awaiting
        // Promise.all(results):
        result.queries = queries;
        result.results = results;
        // If you decide to ignore the result Promise because you're using
        // result.queries and result.results instead, you shouldn't have to worry
        // about preventing uncaught rejections for the Promise.all result.
        result.catch((error) => {
            index_production/* __DEV__ */.T && invariant/* invariant,debug */.kG.debug(76, error);
        });
        return result;
    }
    /**
     * Get all currently active `ObservableQuery` objects, in a `Set`.
     *
     * An "active" query is one that has observers and a `fetchPolicy` other than
     * "standby" or "cache-only".
     *
     * You can include all `ObservableQuery` objects (including the inactive ones)
     * by passing "all" instead of "active", or you can include just a subset of
     * active queries by passing an array of query names or DocumentNode objects.
     *
     * Note: This method only returns queries that have active subscribers. Queries
     * without subscribers are not tracked by the client.
     */
    getObservableQueries(include = "active") {
        return this.queryManager.getObservableQueries(include);
    }
    /**
     * Exposes the cache's complete state, in a serializable format for later restoration.
     *
     * @remarks
     *
     * This can be useful for debugging in order to inspect the full state of the
     * cache.
     *
     * @param optimistic - Determines whether the result contains data from the
     * optimistic layer
     */
    extract(optimistic) {
        return this.cache.extract(optimistic);
    }
    /**
     * Replaces existing state in the cache (if any) with the values expressed by
     * `serializedState`.
     *
     * Called when hydrating a cache (server side rendering, or offline storage),
     * and also (potentially) during hot reloads.
     */
    restore(serializedState) {
        return this.cache.restore(serializedState);
    }
    /**
     * Define a new ApolloLink (or link chain) that Apollo Client will use.
     */
    setLink(newLink) {
        this.link = newLink;
    }
    get defaultContext() {
        return this.queryManager.defaultContext;
    }
    maskedFragmentTransform = new DocumentTransform(removeMaskedFragmentSpreads);
    transform(document, dataMasking = false) {
        const transformed = this.queryManager.transform(document);
        return dataMasking ?
            this.maskedFragmentTransform.transformDocument(transformed)
            : transformed;
    }
}
if (index_production/* __DEV__ */.T) {
    ApolloClient.prototype.getMemoryInternals = getApolloClientMemoryInternals;
}
//# sourceMappingURL=ApolloClient.js.map

// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/errors/CombinedProtocolErrors.js
var CombinedProtocolErrors = __webpack_require__(40361);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/errors/LocalStateError.js
var LocalStateError = __webpack_require__(41919);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/errors/ServerError.js
var ServerError = __webpack_require__(77232);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/errors/ServerParseError.js
var ServerParseError = __webpack_require__(47312);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/errors/UnconventionalError.js
var UnconventionalError = __webpack_require__(85355);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/getFragmentQueryDocument.js

/**
* Returns a query document which adds a single query operation that only
* spreads the target fragment inside of it.
*
* So for example a document of:
*
* ```graphql
* fragment foo on Foo {
*   a
*   b
*   c
* }
* ```
*
* Turns into:
*
* ```graphql
* {
*   ...foo
* }
*
* fragment foo on Foo {
*   a
*   b
*   c
* }
* ```
*
* The target fragment will either be the only fragment in the document, or a
* fragment specified by the provided `fragmentName`. If there is more than one
* fragment, but a `fragmentName` was not defined then an error will be thrown.
*
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function getFragmentQueryDocument(document, fragmentName) {
    let actualFragmentName = fragmentName;
    // Build an array of all our fragment definitions that will be used for
    // validations. We also do some validations on the other definitions in the
    // document while building this list.
    const fragments = [];
    document.definitions.forEach((definition) => {
        // Throw an error if we encounter an operation definition because we will
        // define our own operation definition later on.
        if (definition.kind === "OperationDefinition") {
            throw (0,invariant/* newInvariantError */._K)(
                10,
                definition.operation,
                definition.name ? ` named '${definition.name.value}'` : ""
            );
        }
        // Add our definition to the fragments array if it is a fragment
        // definition.
        if (definition.kind === "FragmentDefinition") {
            fragments.push(definition);
        }
    });
    // If the user did not give us a fragment name then let us try to get a
    // name from a single fragment in the definition.
    if (typeof actualFragmentName === "undefined") {
        (0,invariant/* invariant */.kG)(fragments.length === 1, 11, fragments.length);
        actualFragmentName = fragments[0].name.value;
    }
    // Generate a query document with an operation that simply spreads the
    // fragment inside of it.
    const query = {
        ...document,
        definitions: [
            {
                kind: "OperationDefinition",
                // OperationTypeNode is an enum
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            },
            ...document.definitions,
        ],
    };
    return query;
}
//# sourceMappingURL=getFragmentQueryDocument.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/cache/core/cache.js







class ApolloCache {
    assumeImmutableResults = false;
    // Function used to lookup a fragment when a fragment definition is not part
    // of the GraphQL document. This is useful for caches, such as InMemoryCache,
    // that register fragments ahead of time so they can be referenced by name.
    lookupFragment(fragmentName) {
        return null;
    }
    // Transactional API
    // The batch method is intended to replace/subsume both performTransaction
    // and recordOptimisticTransaction, but performTransaction came first, so we
    // provide a default batch implementation that's just another way of calling
    // performTransaction. Subclasses of ApolloCache (such as InMemoryCache) can
    // override the batch method to do more interesting things with its options.
    batch(options) {
        const optimisticId = typeof options.optimistic === "string" ? options.optimistic
            : options.optimistic === false ? null
                : void 0;
        let updateResult;
        this.performTransaction(() => (updateResult = options.update(this)), optimisticId);
        return updateResult;
    }
    recordOptimisticTransaction(transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    }
    // Optional API
    // Called once per input document, allowing the cache to make static changes
    // to the query, such as adding __typename fields.
    transformDocument(document) {
        return document;
    }
    // Called before each ApolloLink request, allowing the cache to make dynamic
    // changes to the query, such as filling in missing fragment definitions.
    transformForLink(document) {
        return document;
    }
    identify(object) {
        return;
    }
    gc() {
        return [];
    }
    modify(options) {
        return false;
    }
    readQuery(options, optimistic = !!options.optimistic) {
        return this.read({
            ...options,
            rootId: options.id || "ROOT_QUERY",
            optimistic,
        });
    }
    /**
    * Watches the cache store of the fragment according to the options specified
    * and returns an `Observable`. We can subscribe to this
    * `Observable` and receive updated results through an
    * observer when the cache store changes.
    * 
    * You must pass in a GraphQL document with a single fragment or a document
    * with multiple fragments that represent what you are reading. If you pass
    * in a document with multiple fragments then you must also specify a
    * `fragmentName`.
    * 
    * @since 3.10.0
    * @param options - An object of type `WatchFragmentOptions` that allows
    * the cache to identify the fragment and optionally specify whether to react
    * to optimistic updates.
    */
    watchFragment(options) {
        const { fragment, fragmentName, from, optimistic = true, ...otherOptions } = options;
        const query = this.getFragmentDoc(fragment, fragmentName);
        // While our TypeScript types do not allow for `undefined` as a valid
        // `from`, its possible `useFragment` gives us an `undefined` since it
        // calls` cache.identify` and provides that value to `from`. We are
        // adding this fix here however to ensure those using plain JavaScript
        // and using `cache.identify` themselves will avoid seeing the obscure
        // warning.
        const id = typeof from === "undefined" || typeof from === "string" ?
            from
            : this.identify(from);
        if (index_production/* __DEV__ */.T) {
            const actualFragmentName = fragmentName || getFragmentDefinition(fragment).name.value;
            if (!id) {
                index_production/* __DEV__ */.T && invariant/* invariant,warn */.kG.warn(109, actualFragmentName);
            }
        }
        const diffOptions = {
            ...otherOptions,
            returnPartialData: true,
            id,
            query,
            optimistic,
        };
        let latestDiff;
        return new Observable/* Observable */.y((observer) => {
            return this.watch({
                ...diffOptions,
                immediate: true,
                callback: (diff) => {
                    let data = diff.result;
                    // TODO: Remove this once `watchFragment` supports `null` as valid
                    // value emitted
                    if (data === null) {
                        data = {};
                    }
                    if (
                    // Always ensure we deliver the first result
                    latestDiff &&
                        equalByQuery(query, { data: latestDiff.result }, { data }, options.variables)) {
                        return;
                    }
                    const result = {
                        data,
                        dataState: diff.complete ? "complete" : "partial",
                        complete: !!diff.complete,
                    };
                    if (diff.missing) {
                        result.missing = diff.missing.missing;
                    }
                    latestDiff = { ...diff, result: data };
                    observer.next(result);
                },
            });
        });
    }
    // Make sure we compute the same (===) fragment query document every
    // time we receive the same fragment in readFragment.
    getFragmentDoc = (0,lib/* wrap */.re)(getFragmentQueryDocument, {
        max: sizes/* cacheSizes,cache.fragmentQueryDocuments */.Q["cache.fragmentQueryDocuments"] ||
            1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */,
        cache: weak/* WeakCache */.k,
    });
    readFragment(options, optimistic = !!options.optimistic) {
        return this.read({
            ...options,
            query: this.getFragmentDoc(options.fragment, options.fragmentName),
            rootId: options.id,
            optimistic,
        });
    }
    writeQuery({ id, data, ...options }) {
        return this.write(Object.assign(options, {
            dataId: id || "ROOT_QUERY",
            result: data,
        }));
    }
    writeFragment({ id, data, fragment, fragmentName, ...options }) {
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data,
        }));
    }
    updateQuery(options, update) {
        return this.batch({
            update(cache) {
                const value = cache.readQuery(options);
                const data = update(value);
                if (data === void 0 || data === null)
                    return value;
                cache.writeQuery({ ...options, data });
                return data;
            },
        });
    }
    updateFragment(options, update) {
        return this.batch({
            update(cache) {
                const value = cache.readFragment(options);
                const data = update(value);
                if (data === void 0 || data === null)
                    return value;
                cache.writeFragment({ ...options, data });
                return data;
            },
        });
    }
}
if (index_production/* __DEV__ */.T) {
    ApolloCache.prototype.getMemoryInternals = getApolloCacheMemoryInternals;
}
//# sourceMappingURL=cache.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/graphql/storeUtils.js
/**
 * Determines if a given object is a reference object.
 *
 * @param obj - The object to check if its a reference object
 *
 * @example
 *
 * ```ts
 * import { isReference } from "@apollo/client/utilities";
 *
 * isReference({ __ref: "User:1" }); // true
 * isReference({ __typename: "User", id: 1 }); // false
 * ```
 */
function isReference(obj) {
    return Boolean(obj && typeof obj === "object" && typeof obj.__ref === "string");
}
//# sourceMappingURL=storeUtils.js.map
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/DeepMerger.js
var DeepMerger = __webpack_require__(19317);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/cache/inmemory/helpers.js


const { hasOwnProperty: hasOwn } = Object.prototype;
function defaultDataIdFromObject({ __typename, id, _id }, context) {
    if (typeof __typename === "string") {
        if (context) {
            context.keyObject =
                id != null ? { id }
                    : _id != null ? { _id }
                        : void 0;
        }
        // If there is no object.id, fall back to object._id.
        if (id == null && _id != null) {
            id = _id;
        }
        if (id != null) {
            return `${__typename}:${typeof id === "number" || typeof id === "string" ?
                id
                : JSON.stringify(id)}`;
        }
    }
}
const defaultConfig = {
    dataIdFromObject: defaultDataIdFromObject,
    resultCaching: true,
};
function normalizeConfig(config) {
    return (0,compact/* compact */.o)(defaultConfig, config);
}
function getTypenameFromStoreObject(store, objectOrReference) {
    return isReference(objectOrReference) ?
        store.get(objectOrReference.__ref, "__typename")
        : objectOrReference && objectOrReference.__typename;
}
const TypeOrFieldNameRegExp = /^[_a-z][_0-9a-z]*/i;
function fieldNameFromStoreName(storeFieldName) {
    const match = storeFieldName.match(TypeOrFieldNameRegExp);
    return match ? match[0] : storeFieldName;
}
function selectionSetMatchesResult(selectionSet, result, variables) {
    if ((0,isNonNullObject/* isNonNullObject */.s)(result)) {
        return isArray(result) ?
            result.every((item) => selectionSetMatchesResult(selectionSet, item, variables))
            : selectionSet.selections.every((field) => {
                if (isField(field) && (0,shouldInclude/* shouldInclude */.L)(field, variables)) {
                    const key = (0,resultKeyNameFromField/* resultKeyNameFromField */.u)(field);
                    return (hasOwn.call(result, key) &&
                        (!field.selectionSet ||
                            selectionSetMatchesResult(field.selectionSet, result[key], variables)));
                }
                // If the selection has been skipped with @skip(true) or
                // @include(false), it should not count against the matching. If
                // the selection is not a field, it must be a fragment (inline or
                // named). We will determine if selectionSetMatchesResult for that
                // fragment when we get to it, so for now we return true.
                return true;
            });
    }
    return false;
}
function storeValueIsStoreObject(value) {
    return (0,isNonNullObject/* isNonNullObject */.s)(value) && !isReference(value) && !isArray(value);
}
function makeProcessedFieldsMerger() {
    return new DeepMerger/* DeepMerger */.w();
}
function extractFragmentContext(document, fragments) {
    // FragmentMap consisting only of fragments defined directly in document, not
    // including other fragments registered in the FragmentRegistry.
    const fragmentMap = (0,createFragmentMap/* createFragmentMap */.F)((0,getFragmentDefinitions/* getFragmentDefinitions */.k)(document));
    return {
        fragmentMap,
        lookupFragment(name) {
            let def = fragmentMap[name];
            if (!def && fragments) {
                def = fragments.lookup(name);
            }
            return def || null;
        },
    };
}
//# sourceMappingURL=helpers.js.map
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/graphql/transform.js

const TYPENAME_FIELD = {
    kind: kinds/* Kind,FIELD */.h.FIELD,
    name: {
        kind: kinds/* Kind,NAME */.h.NAME,
        value: "__typename",
    },
};
/**
 * Adds `__typename` to all selection sets in the document except for the root
 * selection set.
 *
 * @param doc - The `ASTNode` to add `__typename` to
 *
 * @example
 *
 * ```ts
 * const document = gql`
 *   # ...
 * `;
 *
 * const withTypename = addTypenameToDocument(document);
 * ```
 */
const addTypenameToDocument = Object.assign(function (doc) {
    return (0,visitor/* visit */.Vn)(doc, {
        SelectionSet: {
            enter(node, _key, parent) {
                // Don't add __typename to OperationDefinitions.
                if (parent &&
                    parent.kind ===
                        kinds/* Kind,OPERATION_DEFINITION */.h.OPERATION_DEFINITION) {
                    return;
                }
                // No changes if no selections.
                const { selections } = node;
                if (!selections) {
                    return;
                }
                // If selections already have a __typename, or are part of an
                // introspection query, do nothing.
                const skip = selections.some((selection) => {
                    return (selection.kind === kinds/* Kind,FIELD */.h.FIELD &&
                        (selection.name.value === "__typename" ||
                            selection.name.value.lastIndexOf("__", 0) === 0));
                });
                if (skip) {
                    return;
                }
                // If this SelectionSet is @export-ed as an input variable, it should
                // not have a __typename field (see issue #4691).
                const field = parent;
                if (field.kind === kinds/* Kind,FIELD */.h.FIELD &&
                    field.directives &&
                    field.directives.some((d) => d.name.value === "export")) {
                    return;
                }
                // Create and return a new SelectionSet with a __typename Field.
                return {
                    ...node,
                    selections: [...selections, TYPENAME_FIELD],
                };
            },
        },
    });
}, {
    added(field) {
        return field === TYPENAME_FIELD;
    },
});
//# sourceMappingURL=transform.js.map
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/makeReference.js
/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function makeReference(id) {
    return { __ref: String(id) };
}
//# sourceMappingURL=makeReference.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/cache/inmemory/entityStore.js








const entityStore_DELETE = {};
const delModifier = () => entityStore_DELETE;
const INVALIDATE = {};
class EntityStore {
    policies;
    group;
    data = {};
    constructor(policies, group) {
        this.policies = policies;
        this.group = group;
    }
    // Although the EntityStore class is abstract, it contains concrete
    // implementations of the various NormalizedCache interface methods that
    // are inherited by the Root and Layer subclasses.
    toObject() {
        return { ...this.data };
    }
    has(dataId) {
        return this.lookup(dataId, true) !== void 0;
    }
    get(dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if (hasOwn.call(this.data, dataId)) {
            const storeObject = this.data[dataId];
            if (storeObject && hasOwn.call(storeObject, fieldName)) {
                return storeObject[fieldName];
            }
        }
        if (fieldName === "__typename" &&
            hasOwn.call(this.policies.rootTypenamesById, dataId)) {
            return this.policies.rootTypenamesById[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.get(dataId, fieldName);
        }
    }
    lookup(dataId, dependOnExistence) {
        // The has method (above) calls lookup with dependOnExistence = true, so
        // that it can later be invalidated when we add or remove a StoreObject for
        // this dataId. Any consumer who cares about the contents of the StoreObject
        // should not rely on this dependency, since the contents could change
        // without the object being added or removed.
        if (dependOnExistence)
            this.group.depend(dataId, "__exists");
        if (hasOwn.call(this.data, dataId)) {
            return this.data[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.lookup(dataId, dependOnExistence);
        }
        if (this.policies.rootTypenamesById[dataId]) {
            return {};
        }
    }
    merge(older, newer) {
        let dataId;
        // Convert unexpected references to ID strings.
        if (isReference(older))
            older = older.__ref;
        if (isReference(newer))
            newer = newer.__ref;
        const existing = typeof older === "string" ? this.lookup((dataId = older)) : older;
        const incoming = typeof newer === "string" ? this.lookup((dataId = newer)) : newer;
        // If newer was a string ID, but that ID was not defined in this store,
        // then there are no fields to be merged, so we're done.
        if (!incoming)
            return;
        (0,invariant/* invariant */.kG)(typeof dataId === "string", 95);
        const merged = new DeepMerger/* DeepMerger */.w(storeObjectReconciler).merge(existing, incoming);
        // Even if merged === existing, existing may have come from a lower
        // layer, so we always need to set this.data[dataId] on this level.
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                const fieldsToDirty = {};
                // If we added a new StoreObject where there was previously none, dirty
                // anything that depended on the existence of this dataId, such as the
                // EntityStore#has method.
                if (!existing)
                    fieldsToDirty.__exists = 1;
                // Now invalidate dependents who called getFieldValue for any fields
                // that are changing as a result of this merge.
                Object.keys(incoming).forEach((storeFieldName) => {
                    if (!existing ||
                        existing[storeFieldName] !== merged[storeFieldName]) {
                        // Always dirty the full storeFieldName, which may include
                        // serialized arguments following the fieldName prefix.
                        fieldsToDirty[storeFieldName] = 1;
                        // Also dirty fieldNameFromStoreName(storeFieldName) if it's
                        // different from storeFieldName and this field does not have
                        // keyArgs configured, because that means the cache can't make
                        // any assumptions about how field values with the same field
                        // name but different arguments might be interrelated, so it
                        // must err on the side of invalidating all field values that
                        // share the same short fieldName, regardless of arguments.
                        const fieldName = fieldNameFromStoreName(storeFieldName);
                        if (fieldName !== storeFieldName &&
                            !this.policies.hasKeyArgs(merged.__typename, fieldName)) {
                            fieldsToDirty[fieldName] = 1;
                        }
                        // If merged[storeFieldName] has become undefined, and this is the
                        // Root layer, actually delete the property from the merged object,
                        // which is guaranteed to have been created fresh in this method.
                        if (merged[storeFieldName] === void 0 && !(this instanceof Layer)) {
                            delete merged[storeFieldName];
                        }
                    }
                });
                if (fieldsToDirty.__typename &&
                    !(existing && existing.__typename) &&
                    // Since we return default root __typename strings
                    // automatically from store.get, we don't need to dirty the
                    // ROOT_QUERY.__typename field if merged.__typename is equal
                    // to the default string (usually "Query").
                    this.policies.rootTypenamesById[dataId] === merged.__typename) {
                    delete fieldsToDirty.__typename;
                }
                Object.keys(fieldsToDirty).forEach((fieldName) => this.group.dirty(dataId, fieldName));
            }
        }
    }
    modify(dataId, fields, exact) {
        const storeObject = this.lookup(dataId);
        if (storeObject) {
            const changedFields = {};
            let needToMerge = false;
            let allDeleted = true;
            const sharedDetails = {
                DELETE: entityStore_DELETE,
                INVALIDATE,
                isReference: isReference,
                toReference: this.toReference,
                canRead: this.canRead,
                readField: (fieldNameOrOptions, from) => this.policies.readField(typeof fieldNameOrOptions === "string" ?
                    {
                        fieldName: fieldNameOrOptions,
                        from: from || makeReference(dataId),
                    }
                    : fieldNameOrOptions, { store: this }),
            };
            Object.keys(storeObject).forEach((storeFieldName) => {
                const fieldName = fieldNameFromStoreName(storeFieldName);
                let fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0)
                    return;
                const modify = typeof fields === "function" ? fields : (fields[storeFieldName] || (exact ? undefined : fields[fieldName]));
                if (modify) {
                    let newValue = modify === delModifier ? entityStore_DELETE : (modify(maybeDeepFreeze(fieldValue), {
                        ...sharedDetails,
                        fieldName,
                        storeFieldName,
                        storage: this.getStorage(dataId, storeFieldName),
                    }));
                    if (newValue === INVALIDATE) {
                        this.group.dirty(dataId, storeFieldName);
                    }
                    else {
                        if (newValue === entityStore_DELETE)
                            newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields[storeFieldName] = newValue;
                            needToMerge = true;
                            fieldValue = newValue;
                            if (index_production/* __DEV__ */.T) {
                                const checkReference = (ref) => {
                                    if (this.lookup(ref.__ref) === undefined) {
                                        index_production/* __DEV__ */.T && invariant/* invariant,warn */.kG.warn(96, ref);
                                        return true;
                                    }
                                };
                                if (isReference(newValue)) {
                                    checkReference(newValue);
                                }
                                else if (Array.isArray(newValue)) {
                                    // Warn about writing "mixed" arrays of Reference and non-Reference objects
                                    let seenReference = false;
                                    let someNonReference;
                                    for (const value of newValue) {
                                        if (isReference(value)) {
                                            seenReference = true;
                                            if (checkReference(value))
                                                break;
                                        }
                                        else {
                                            // Do not warn on primitive values, since those could never be represented
                                            // by a reference. This is a valid (albeit uncommon) use case.
                                            if (typeof value === "object" && !!value) {
                                                const [id] = this.policies.identify(value);
                                                // check if object could even be referenced, otherwise we are not interested in it for this warning
                                                if (id) {
                                                    someNonReference = value;
                                                }
                                            }
                                        }
                                        if (seenReference && someNonReference !== undefined) {
                                            index_production/* __DEV__ */.T && invariant/* invariant,warn */.kG.warn(97, someNonReference);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (fieldValue !== void 0) {
                    allDeleted = false;
                }
            });
            if (needToMerge) {
                this.merge(dataId, changedFields);
                if (allDeleted) {
                    if (this instanceof Layer) {
                        this.data[dataId] = void 0;
                    }
                    else {
                        delete this.data[dataId];
                    }
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    }
    // If called with only one argument, removes the entire entity
    // identified by dataId. If called with a fieldName as well, removes all
    // fields of that entity whose names match fieldName according to the
    // fieldNameFromStoreName helper function. If called with a fieldName
    // and variables, removes all fields of that entity whose names match fieldName
    // and whose arguments when cached exactly match the variables passed.
    delete(dataId, fieldName, args) {
        const storeObject = this.lookup(dataId);
        if (storeObject) {
            const typename = this.getFieldValue(storeObject, "__typename");
            const storeFieldName = fieldName && args ?
                this.policies.getStoreFieldName({ typename, fieldName, args })
                : fieldName;
            return this.modify(dataId, storeFieldName ?
                {
                    [storeFieldName]: delModifier,
                }
                : delModifier, !!args);
        }
        return false;
    }
    evict(options, limit) {
        let evicted = false;
        if (options.id) {
            if (hasOwn.call(this.data, options.id)) {
                evicted = this.delete(options.id, options.fieldName, options.args);
            }
            if (this instanceof Layer && this !== limit) {
                evicted = this.parent.evict(options, limit) || evicted;
            }
            // Always invalidate the field to trigger rereading of watched
            // queries, even if no cache data was modified by the eviction,
            // because queries may depend on computed fields with custom read
            // functions, whose values are not stored in the EntityStore.
            if (options.fieldName || evicted) {
                this.group.dirty(options.id, options.fieldName || "__exists");
            }
        }
        return evicted;
    }
    clear() {
        this.replace(null);
    }
    extract() {
        const obj = this.toObject();
        const extraRootIds = [];
        this.getRootIdSet().forEach((id) => {
            if (!hasOwn.call(this.policies.rootTypenamesById, id)) {
                extraRootIds.push(id);
            }
        });
        if (extraRootIds.length) {
            obj.__META = { extraRootIds: extraRootIds.sort() };
        }
        return obj;
    }
    replace(newData) {
        Object.keys(this.data).forEach((dataId) => {
            if (!(newData && hasOwn.call(newData, dataId))) {
                this.delete(dataId);
            }
        });
        if (newData) {
            const { __META, ...rest } = newData;
            Object.keys(rest).forEach((dataId) => {
                this.merge(dataId, rest[dataId]);
            });
            if (__META) {
                __META.extraRootIds.forEach(this.retain, this);
            }
        }
    }
    // Maps root entity IDs to the number of times they have been retained, minus
    // the number of times they have been released. Retained entities keep other
    // entities they reference (even indirectly) from being garbage collected.
    rootIds = {};
    retain(rootId) {
        return (this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1);
    }
    release(rootId) {
        if (this.rootIds[rootId] > 0) {
            const count = --this.rootIds[rootId];
            if (!count)
                delete this.rootIds[rootId];
            return count;
        }
        return 0;
    }
    // Return a Set<string> of all the ID strings that have been retained by
    // this layer/root *and* any layers/roots beneath it.
    getRootIdSet(ids = new Set()) {
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof Layer) {
            this.parent.getRootIdSet(ids);
        }
        else {
            // Official singleton IDs like ROOT_QUERY and ROOT_MUTATION are
            // always considered roots for garbage collection, regardless of
            // their retainment counts in this.rootIds.
            Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        }
        return ids;
    }
    // The goal of garbage collection is to remove IDs from the Root layer of the
    // store that are no longer reachable starting from any IDs that have been
    // explicitly retained (see retain and release, above). Returns an array of
    // dataId strings that were removed from the store.
    gc() {
        const ids = this.getRootIdSet();
        const snapshot = this.toObject();
        ids.forEach((id) => {
            if (hasOwn.call(snapshot, id)) {
                // Because we are iterating over an ECMAScript Set, the IDs we add here
                // will be visited in later iterations of the forEach loop only if they
                // were not previously contained by the Set.
                Object.keys(this.findChildRefIds(id)).forEach(ids.add, ids);
                // By removing IDs from the snapshot object here, we protect them from
                // getting removed from the root store layer below.
                delete snapshot[id];
            }
        });
        const idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            let root = this;
            while (root instanceof Layer)
                root = root.parent;
            idsToRemove.forEach((id) => root.delete(id));
        }
        return idsToRemove;
    }
    // Lazily tracks { __ref: <dataId> } strings contained by this.data[dataId].
    refs = {};
    findChildRefIds(dataId) {
        if (!hasOwn.call(this.refs, dataId)) {
            const found = (this.refs[dataId] = {});
            const root = this.data[dataId];
            if (!root)
                return found;
            const workSet = new Set([root]);
            // Within the store, only arrays and objects can contain child entity
            // references, so we can prune the traversal using this predicate:
            workSet.forEach((obj) => {
                if (isReference(obj)) {
                    found[obj.__ref] = true;
                    // In rare cases, a { __ref } Reference object may have other fields.
                    // This often indicates a mismerging of References with StoreObjects,
                    // but garbage collection should not be fooled by a stray __ref
                    // property in a StoreObject (ignoring all the other fields just
                    // because the StoreObject looks like a Reference). To avoid this
                    // premature termination of findChildRefIds recursion, we fall through
                    // to the code below, which will handle any other properties of obj.
                }
                if ((0,isNonNullObject/* isNonNullObject */.s)(obj)) {
                    Object.keys(obj).forEach((key) => {
                        const child = obj[key];
                        // No need to add primitive values to the workSet, since they cannot
                        // contain reference objects.
                        if ((0,isNonNullObject/* isNonNullObject */.s)(child)) {
                            workSet.add(child);
                        }
                    });
                }
            });
        }
        return this.refs[dataId];
    }
    makeCacheKey() {
        return this.group.keyMaker.lookupArray(arguments);
    }
    // Bound function that can be passed around to provide easy access to fields
    // of Reference objects as well as ordinary objects.
    getFieldValue = (objectOrReference, storeFieldName) => maybeDeepFreeze(isReference(objectOrReference) ?
        this.get(objectOrReference.__ref, storeFieldName)
        : objectOrReference && objectOrReference[storeFieldName]);
    // Returns true for non-normalized StoreObjects and non-dangling
    // References, indicating that readField(name, objOrRef) has a chance of
    // working. Useful for filtering out dangling references from lists.
    canRead = (objOrRef) => {
        return isReference(objOrRef) ?
            this.has(objOrRef.__ref)
            : typeof objOrRef === "object";
    };
    // Bound function that converts an id or an object with a __typename and
    // primary key fields to a Reference object. If called with a Reference object,
    // that same Reference object is returned. Pass true for mergeIntoStore to persist
    // an object into the store.
    toReference = (objOrIdOrRef, mergeIntoStore) => {
        if (typeof objOrIdOrRef === "string") {
            return makeReference(objOrIdOrRef);
        }
        if (isReference(objOrIdOrRef)) {
            return objOrIdOrRef;
        }
        const [id] = this.policies.identify(objOrIdOrRef);
        if (id) {
            const ref = makeReference(id);
            if (mergeIntoStore) {
                this.merge(id, objOrIdOrRef);
            }
            return ref;
        }
    };
    get supportsResultCaching() {
        return this.group.caching;
    }
}
// A single CacheGroup represents a set of one or more EntityStore objects,
// typically the Root store in a CacheGroup by itself, and all active Layer
// stores in a group together. A single EntityStore object belongs to only
// one CacheGroup, store.group. The CacheGroup is responsible for tracking
// dependencies, so store.group is helpful for generating unique keys for
// cached results that need to be invalidated when/if those dependencies
// change. If we used the EntityStore objects themselves as cache keys (that
// is, store rather than store.group), the cache would become unnecessarily
// fragmented by all the different Layer objects. Instead, the CacheGroup
// approach allows all optimistic Layer objects in the same linked list to
// belong to one CacheGroup, with the non-optimistic Root object belonging
// to another CacheGroup, allowing resultCaching dependencies to be tracked
// separately for optimistic and non-optimistic entity data.
class CacheGroup {
    caching;
    parent;
    d = null;
    // Used by the EntityStore#makeCacheKey method to compute cache keys
    // specific to this CacheGroup.
    keyMaker;
    constructor(caching, parent = null) {
        this.caching = caching;
        this.parent = parent;
        this.resetCaching();
    }
    resetCaching() {
        this.d = this.caching ? (0,lib/* dep */.dP)() : null;
        this.keyMaker = new Trie();
    }
    depend(dataId, storeFieldName) {
        if (this.d) {
            this.d(makeDepKey(dataId, storeFieldName));
            const fieldName = fieldNameFromStoreName(storeFieldName);
            if (fieldName !== storeFieldName) {
                // Fields with arguments that contribute extra identifying
                // information to the fieldName (thus forming the storeFieldName)
                // depend not only on the full storeFieldName but also on the
                // short fieldName, so the field can be invalidated using either
                // level of specificity.
                this.d(makeDepKey(dataId, fieldName));
            }
            if (this.parent) {
                this.parent.depend(dataId, storeFieldName);
            }
        }
    }
    dirty(dataId, storeFieldName) {
        if (this.d) {
            this.d.dirty(makeDepKey(dataId, storeFieldName), 
            // When storeFieldName === "__exists", that means the entity identified
            // by dataId has either disappeared from the cache or was newly added,
            // so the result caching system would do well to "forget everything it
            // knows" about that object. To achieve that kind of invalidation, we
            // not only dirty the associated result cache entry, but also remove it
            // completely from the dependency graph. For the optimism implementation
            // details, see https://github.com/benjamn/optimism/pull/195.
            storeFieldName === "__exists" ? "forget" : "setDirty");
        }
    }
}
function makeDepKey(dataId, storeFieldName) {
    // Since field names cannot have '#' characters in them, this method
    // of joining the field name and the ID should be unambiguous, and much
    // cheaper than JSON.stringify([dataId, fieldName]).
    return storeFieldName + "#" + dataId;
}
function maybeDependOnExistenceOfEntity(store, entityId) {
    if (supportsResultCaching(store)) {
        // We use this pseudo-field __exists elsewhere in the EntityStore code to
        // represent changes in the existence of the entity object identified by
        // entityId. This dependency gets reliably dirtied whenever an object with
        // this ID is deleted (or newly created) within this group, so any result
        // cache entries (for example, StoreReader#executeSelectionSet results) that
        // depend on __exists for this entityId will get dirtied as well, leading to
        // the eventual recomputation (instead of reuse) of those result objects the
        // next time someone reads them from the cache.
        store.group.depend(entityId, "__exists");
    }
}
class Root extends EntityStore {
    constructor({ policies, resultCaching = true, seed, }) {
        super(policies, new CacheGroup(resultCaching));
        if (seed)
            this.replace(seed);
    }
    stump = new Stump(this);
    addLayer(layerId, replay) {
        // Adding an optimistic Layer on top of the Root actually adds the Layer
        // on top of the Stump, so the Stump always comes between the Root and
        // any Layer objects that we've added.
        return this.stump.addLayer(layerId, replay);
    }
    removeLayer() {
        // Never remove the root layer.
        return this;
    }
    storageTrie = new Trie();
    getStorage() {
        return this.storageTrie.lookupArray(arguments);
    }
}
EntityStore.Root = Root;
// Not exported, since all Layer instances are created by the addLayer method
// of the EntityStore.Root class.
class Layer extends EntityStore {
    id;
    parent;
    replay;
    group;
    constructor(id, parent, replay, group) {
        super(parent.policies, group);
        this.id = id;
        this.parent = parent;
        this.replay = replay;
        this.group = group;
        replay(this);
    }
    addLayer(layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    }
    removeLayer(layerId) {
        // Remove all instances of the given id, not just the first one.
        const parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) {
                // Dirty every ID we're removing. Technically we might be able to avoid
                // dirtying fields that have values in higher layers, but we don't have
                // easy access to higher layers here, and we're about to recreate those
                // layers anyway (see parent.addLayer below).
                Object.keys(this.data).forEach((dataId) => {
                    const ownStoreObject = this.data[dataId];
                    const parentStoreObject = parent["lookup"](dataId);
                    if (!parentStoreObject) {
                        // The StoreObject identified by dataId was defined in this layer
                        // but will be undefined in the parent layer, so we can delete the
                        // whole entity using this.delete(dataId). Since we're about to
                        // throw this layer away, the only goal of this deletion is to dirty
                        // the removed fields.
                        this.delete(dataId);
                    }
                    else if (!ownStoreObject) {
                        // This layer had an entry for dataId but it was undefined, which
                        // means the entity was deleted in this layer, and it's about to
                        // become undeleted when we remove this layer, so we need to dirty
                        // all fields that are about to be reexposed.
                        this.group.dirty(dataId, "__exists");
                        Object.keys(parentStoreObject).forEach((storeFieldName) => {
                            this.group.dirty(dataId, storeFieldName);
                        });
                    }
                    else if (ownStoreObject !== parentStoreObject) {
                        // If ownStoreObject is not exactly the same as parentStoreObject,
                        // dirty any fields whose values will change as a result of this
                        // removal.
                        Object.keys(ownStoreObject).forEach((storeFieldName) => {
                            if (!equal(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) {
                                this.group.dirty(dataId, storeFieldName);
                            }
                        });
                    }
                });
            }
            return parent;
        }
        // No changes are necessary if the parent chain remains identical.
        if (parent === this.parent)
            return this;
        // Recreate this layer on top of the new parent.
        return parent.addLayer(this.id, this.replay);
    }
    toObject() {
        return {
            ...this.parent.toObject(),
            ...this.data,
        };
    }
    findChildRefIds(dataId) {
        const fromParent = this.parent.findChildRefIds(dataId);
        return hasOwn.call(this.data, dataId) ?
            {
                ...fromParent,
                ...super.findChildRefIds(dataId),
            }
            : fromParent;
    }
    getStorage(...args) {
        let p = this.parent;
        while (p.parent)
            p = p.parent;
        return p.getStorage(...args);
    }
}
// Represents a Layer permanently installed just above the Root, which allows
// reading optimistically (and registering optimistic dependencies) even when
// no optimistic layers are currently active. The stump.group CacheGroup object
// is shared by any/all Layer objects added on top of the Stump.
class Stump extends Layer {
    constructor(root) {
        super("EntityStore.Stump", root, () => { }, new CacheGroup(root.group.caching, root.group));
    }
    removeLayer() {
        // Never remove the Stump layer.
        return this;
    }
    merge(older, newer) {
        // We never want to write any data into the Stump, so we forward any merge
        // calls to the Root instead. Another option here would be to throw an
        // exception, but the toReference(object, true) function can sometimes
        // trigger Stump writes (which used to be Root writes, before the Stump
        // concept was introduced).
        return this.parent.merge(older, newer);
    }
}
function storeObjectReconciler(existingObject, incomingObject, property) {
    const existingValue = existingObject[property];
    const incomingValue = incomingObject[property];
    // Wherever there is a key collision, prefer the incoming value, unless
    // it is deeply equal to the existing value. It's worth checking deep
    // equality here (even though blindly returning incoming would be
    // logically correct) because preserving the referential identity of
    // existing data can prevent needless rereading and rerendering.
    return equal(existingValue, incomingValue) ? existingValue : incomingValue;
}
function supportsResultCaching(store) {
    // When result caching is disabled, store.depend will be null.
    return !!(store && store.supportsResultCaching);
}
//# sourceMappingURL=entityStore.js.map

// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/argumentsObjectFromField.js
var argumentsObjectFromField = __webpack_require__(27494);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/getStoreKeyName.js

const KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export",
    "nonreactive",
];
// Default stable JSON.stringify implementation used by getStoreKeyName. Can be
// updated/replaced with something better by calling
// getStoreKeyName.setStringify(newStringifyFunction).
let storeKeyNameStringify = canonicalStringify_canonicalStringify;
/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
const getStoreKeyName = Object.assign(function (fieldName, args, directives) {
    if (args &&
        directives &&
        directives["connection"] &&
        directives["connection"]["key"]) {
        if (directives["connection"]["filter"] &&
            directives["connection"]["filter"].length > 0) {
            const filterKeys = directives["connection"]["filter"] ?
                directives["connection"]["filter"]
                : [];
            filterKeys.sort();
            const filteredArgs = {};
            filterKeys.forEach((key) => {
                filteredArgs[key] = args[key];
            });
            const stringifiedArgs = storeKeyNameStringify(filteredArgs);
            if (stringifiedArgs !== "{}") {
                return `${directives["connection"]["key"]}(${stringifiedArgs})`;
            }
        }
        return directives["connection"]["key"];
    }
    let completeFieldName = fieldName;
    if (args) {
        // We can't use `JSON.stringify` here since it's non-deterministic,
        // and can lead to different store key names being created even though
        // the `args` object used during creation has the same properties/values.
        const stringifiedArgs = storeKeyNameStringify(args);
        if (stringifiedArgs !== "{}") {
            completeFieldName += `(${stringifiedArgs})`;
        }
    }
    if (directives) {
        Object.keys(directives).forEach((key) => {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += `@${key}(${storeKeyNameStringify(directives[key])})`;
            }
            else {
                completeFieldName += `@${key}`;
            }
        });
    }
    return completeFieldName;
}, {
    setStringify(s) {
        const previous = storeKeyNameStringify;
        storeKeyNameStringify = s;
        return previous;
    },
});
//# sourceMappingURL=getStoreKeyName.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/storeKeyNameFromField.js


/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function storeKeyNameFromField(field, variables) {
    let directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach((directive) => {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(({ name, value }) => (0,valueToObjectRepresentation/* valueToObjectRepresentation */.v)(directivesObj[directive.name.value], name, value, variables));
            }
        });
    }
    let argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(({ name, value }) => (0,valueToObjectRepresentation/* valueToObjectRepresentation */.v)(argObj, name, value, variables));
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
//# sourceMappingURL=storeKeyNameFromField.js.map

// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/stringifyForDisplay.js
var stringifyForDisplay = __webpack_require__(81654);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/cache/inmemory/key-extractor.js



// Mapping from JSON-encoded KeySpecifier strings to associated information.
const specifierInfoCache = {};
function lookupSpecifierInfo(spec) {
    // It's safe to encode KeySpecifier arrays with JSON.stringify, since they're
    // just arrays of strings or nested KeySpecifier arrays, and the order of the
    // array elements is important (and suitably preserved by JSON.stringify).
    const cacheKey = JSON.stringify(spec);
    return specifierInfoCache[cacheKey] || (specifierInfoCache[cacheKey] = {});
}
function keyFieldsFnFromSpecifier(specifier) {
    const info = lookupSpecifierInfo(specifier);
    return (info.keyFieldsFn || (info.keyFieldsFn = (object, context) => {
            const extract = (from, key) => context.readField(key, from);
            const keyObject = (context.keyObject = collectSpecifierPaths(specifier, (schemaKeyPath) => {
                let extracted = extractKeyPath(context.storeObject, schemaKeyPath, 
                // Using context.readField to extract paths from context.storeObject
                // allows the extraction to see through Reference objects and respect
                // custom read functions.
                extract);
                if (extracted === void 0 &&
                    object !== context.storeObject &&
                    hasOwn.call(object, schemaKeyPath[0])) {
                    // If context.storeObject fails to provide a value for the requested
                    // path, fall back to the raw result object, if it has a top-level key
                    // matching the first key in the path (schemaKeyPath[0]). This allows
                    // key fields included in the written data to be saved in the cache
                    // even if they are not selected explicitly in context.selectionSet.
                    // Not being mentioned by context.selectionSet is convenient here,
                    // since it means these extra fields cannot be affected by field
                    // aliasing, which is why we can use extractKey instead of
                    // context.readField for this extraction.
                    extracted = extractKeyPath(object, schemaKeyPath, extractKey);
                }
                (0,invariant/* invariant */.kG)(extracted !== void 0, 98, schemaKeyPath.join("."), object);
                return extracted;
            }));
            return `${context.typename}:${JSON.stringify(keyObject)}`;
        }));
}
// The keyArgs extraction process is roughly analogous to keyFields extraction,
// but there are no aliases involved, missing fields are tolerated (by merely
// omitting them from the key), and drawing from field.directives or variables
// is allowed (in addition to drawing from the field's arguments object).
// Concretely, these differences mean passing a different key path extractor
// function to collectSpecifierPaths, reusing the shared extractKeyPath helper
// wherever possible.
function keyArgsFnFromSpecifier(specifier) {
    const info = lookupSpecifierInfo(specifier);
    return (info.keyArgsFn ||
        (info.keyArgsFn = (args, { field, variables, fieldName }) => {
            const collected = collectSpecifierPaths(specifier, (keyPath) => {
                const firstKey = keyPath[0];
                const firstChar = firstKey.charAt(0);
                if (firstChar === "@") {
                    if (field && isNonEmptyArray(field.directives)) {
                        const directiveName = firstKey.slice(1);
                        // If the directive appears multiple times, only the first
                        // occurrence's arguments will be used. TODO Allow repetition?
                        // TODO Cache this work somehow, a la aliasMap?
                        const d = field.directives.find((d) => d.name.value === directiveName);
                        // Fortunately argumentsObjectFromField works for DirectiveNode!
                        const directiveArgs = d && (0,argumentsObjectFromField/* argumentsObjectFromField */.N)(d, variables);
                        // For directives without arguments (d defined, but directiveArgs ===
                        // null), the presence or absence of the directive still counts as
                        // part of the field key, so we return null in those cases. If no
                        // directive with this name was found for this field (d undefined and
                        // thus directiveArgs undefined), we return undefined, which causes
                        // this value to be omitted from the key object returned by
                        // collectSpecifierPaths.
                        return (directiveArgs &&
                            extractKeyPath(directiveArgs, 
                            // If keyPath.length === 1, this code calls extractKeyPath with an
                            // empty path, which works because it uses directiveArgs as the
                            // extracted value.
                            keyPath.slice(1)));
                    }
                    // If the key started with @ but there was no corresponding directive,
                    // we want to omit this value from the key object, not fall through to
                    // treating @whatever as a normal argument name.
                    return;
                }
                if (firstChar === "$") {
                    const variableName = firstKey.slice(1);
                    if (variables && hasOwn.call(variables, variableName)) {
                        const varKeyPath = keyPath.slice(0);
                        varKeyPath[0] = variableName;
                        return extractKeyPath(variables, varKeyPath);
                    }
                    // If the key started with $ but there was no corresponding variable, we
                    // want to omit this value from the key object, not fall through to
                    // treating $whatever as a normal argument name.
                    return;
                }
                if (args) {
                    return extractKeyPath(args, keyPath);
                }
            });
            const suffix = JSON.stringify(collected);
            // If no arguments were passed to this field, and it didn't have any other
            // field key contributions from directives or variables, hide the empty
            // :{} suffix from the field key. However, a field passed no arguments can
            // still end up with a non-empty :{...} suffix if its key configuration
            // refers to directives or variables.
            if (args || suffix !== "{}") {
                fieldName += ":" + suffix;
            }
            return fieldName;
        }));
}
function collectSpecifierPaths(specifier, extractor) {
    // For each path specified by specifier, invoke the extractor, and repeatedly
    // merge the results together, with appropriate ancestor context.
    const merger = new DeepMerger/* DeepMerger */.w();
    return getSpecifierPaths(specifier).reduce((collected, path) => {
        let toMerge = extractor(path);
        if (toMerge !== void 0) {
            // This path is not expected to contain array indexes, so the toMerge
            // reconstruction will not contain arrays. TODO Fix this?
            for (let i = path.length - 1; i >= 0; --i) {
                toMerge = { [path[i]]: toMerge };
            }
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, {});
}
function getSpecifierPaths(spec) {
    const info = lookupSpecifierInfo(spec);
    if (!info.paths) {
        const paths = (info.paths = []);
        const currentPath = [];
        spec.forEach((s, i) => {
            if (isArray(s)) {
                getSpecifierPaths(s).forEach((p) => paths.push(currentPath.concat(p)));
                currentPath.length = 0;
            }
            else {
                currentPath.push(s);
                if (!isArray(spec[i + 1])) {
                    paths.push(currentPath.slice(0));
                    currentPath.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function extractKey(object, key) {
    return object[key];
}
function extractKeyPath(object, path, extract) {
    // For each key in path, extract the corresponding child property from obj,
    // flattening arrays if encountered (uncommon for keyFields and keyArgs, but
    // possible). The final result of path.reduce is normalized so unexpected leaf
    // objects have their keys safely sorted. That final result is difficult to
    // type as anything other than any. You're welcome to try to improve the
    // return type, but keep in mind extractKeyPath is not a public function
    // (exported only for testing), so the effort may not be worthwhile unless the
    // limited set of actual callers (see above) pass arguments that TypeScript
    // can statically type. If we know only that path is some array of strings
    // (and not, say, a specific tuple of statically known strings), any (or
    // possibly unknown) is the honest answer.
    extract = extract || extractKey;
    return normalize(path.reduce(function reducer(obj, key) {
        return isArray(obj) ?
            obj.map((child) => reducer(child, key))
            : obj && extract(obj, key);
    }, object));
}
function normalize(value) {
    // Usually the extracted value will be a scalar value, since most primary
    // key fields are scalar, but just in case we get an object or an array, we
    // need to do some normalization of the order of (nested) keys.
    if ((0,isNonNullObject/* isNonNullObject */.s)(value)) {
        if (isArray(value)) {
            return value.map(normalize);
        }
        return collectSpecifierPaths(Object.keys(value).sort(), (path) => extractKeyPath(value, path));
    }
    return value;
}
//# sourceMappingURL=key-extractor.js.map

// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/cache/inmemory/reactiveVars.js
var reactiveVars = __webpack_require__(52926);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/cache/inmemory/policies.js








function argsFromFieldSpecifier(spec) {
    return (spec.args !== void 0 ? spec.args
        : spec.field ? (0,argumentsObjectFromField/* argumentsObjectFromField */.N)(spec.field, spec.variables)
            : null);
}
const nullKeyFieldsFn = () => void 0;
const simpleKeyArgsFn = (_args, context) => context.fieldName;
// These merge functions can be selected by specifying merge:true or
// merge:false in a field policy.
const mergeTrueFn = (existing, incoming, { mergeObjects }) => mergeObjects(existing, incoming);
const mergeFalseFn = (_, incoming) => incoming;
class Policies {
    config;
    typePolicies = {};
    toBeAdded = {};
    // Map from subtype names to sets of supertype names. Note that this
    // representation inverts the structure of possibleTypes (whose keys are
    // supertypes and whose values are arrays of subtypes) because it tends
    // to be much more efficient to search upwards than downwards.
    supertypeMap = new Map();
    // Any fuzzy subtypes specified by possibleTypes will be converted to
    // RegExp objects and recorded here. Every key of this map can also be
    // found in supertypeMap. In many cases this Map will be empty, which
    // means no fuzzy subtype checking will happen in fragmentMatches.
    fuzzySubtypes = new Map();
    cache;
    rootIdsByTypename = {};
    rootTypenamesById = {};
    usingPossibleTypes = false;
    constructor(config) {
        this.config = config;
        this.config = {
            dataIdFromObject: defaultDataIdFromObject,
            ...config,
        };
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) {
            this.addPossibleTypes(config.possibleTypes);
        }
        if (config.typePolicies) {
            this.addTypePolicies(config.typePolicies);
        }
    }
    identify(object, partialContext) {
        const policies = this;
        const typename = (partialContext &&
            (partialContext.typename || partialContext.storeObject?.__typename)) ||
            object.__typename;
        // It should be possible to write root Query fields with writeFragment,
        // using { __typename: "Query", ... } as the data, but it does not make
        // sense to allow the same identification behavior for the Mutation and
        // Subscription types, since application code should never be writing
        // directly to (or reading directly from) those root objects.
        if (typename === this.rootTypenamesById.ROOT_QUERY) {
            return ["ROOT_QUERY"];
        }
        // Default context.storeObject to object if not otherwise provided.
        const storeObject = (partialContext && partialContext.storeObject) || object;
        const context = {
            ...partialContext,
            typename,
            storeObject,
            readField: (partialContext && partialContext.readField) ||
                ((...args) => {
                    const options = normalizeReadFieldOptions(args, storeObject);
                    return policies.readField(options, {
                        store: policies.cache["data"],
                        variables: options.variables,
                    });
                }),
        };
        let id;
        const policy = typename && this.getTypePolicy(typename);
        let keyFn = (policy && policy.keyFn) || this.config.dataIdFromObject;
        disableWarningsSlot.withValue(true, () => {
            while (keyFn) {
                const specifierOrId = keyFn({ ...object, ...storeObject }, context);
                if (isArray(specifierOrId)) {
                    keyFn = keyFieldsFnFromSpecifier(specifierOrId);
                }
                else {
                    id = specifierOrId;
                    break;
                }
            }
        });
        id = id ? String(id) : void 0;
        return context.keyObject ? [id, context.keyObject] : [id];
    }
    addTypePolicies(typePolicies) {
        Object.keys(typePolicies).forEach((typename) => {
            const { queryType, mutationType, subscriptionType, ...incoming } = typePolicies[typename];
            // Though {query,mutation,subscription}Type configurations are rare,
            // it's important to call setRootTypename as early as possible,
            // since these configurations should apply consistently for the
            // entire lifetime of the cache. Also, since only one __typename can
            // qualify as one of these root types, these three properties cannot
            // be inherited, unlike the rest of the incoming properties. That
            // restriction is convenient, because the purpose of this.toBeAdded
            // is to delay the processing of type/field policies until the first
            // time they're used, allowing policies to be added in any order as
            // long as all relevant policies (including policies for supertypes)
            // have been added by the time a given policy is used for the first
            // time. In other words, since inheritance doesn't matter for these
            // properties, there's also no need to delay their processing using
            // the this.toBeAdded queue.
            if (queryType)
                this.setRootTypename("Query", typename);
            if (mutationType)
                this.setRootTypename("Mutation", typename);
            if (subscriptionType)
                this.setRootTypename("Subscription", typename);
            if (hasOwn.call(this.toBeAdded, typename)) {
                this.toBeAdded[typename].push(incoming);
            }
            else {
                this.toBeAdded[typename] = [incoming];
            }
        });
    }
    updateTypePolicy(typename, incoming, existingFieldPolicies) {
        const existing = this.getTypePolicy(typename);
        const { keyFields, fields } = incoming;
        function setMerge(existing, merge) {
            existing.merge =
                typeof merge === "function" ? merge
                    // Pass merge:true as a shorthand for a merge implementation
                    // that returns options.mergeObjects(existing, incoming).
                    : merge === true ? mergeTrueFn
                        // Pass merge:false to make incoming always replace existing
                        // without any warnings about data clobbering.
                        : merge === false ? mergeFalseFn
                            : existing.merge;
        }
        // Type policies can define merge functions, as an alternative to
        // using field policies to merge child objects.
        setMerge(existing, incoming.merge);
        existing.keyFn =
            // Pass false to disable normalization for this typename.
            keyFields === false ? nullKeyFieldsFn
                // Pass an array of strings to use those fields to compute a
                // composite ID for objects of this typename.
                : isArray(keyFields) ? keyFieldsFnFromSpecifier(keyFields)
                    // Pass a function to take full control over identification.
                    : typeof keyFields === "function" ? keyFields
                        // Leave existing.keyFn unchanged if above cases fail.
                        : existing.keyFn;
        if (fields) {
            Object.keys(fields).forEach((fieldName) => {
                let existing = existingFieldPolicies[fieldName];
                // Field policy inheritance is atomic/shallow: you can't inherit a
                // field policy and then override just its read function, since read
                // and merge functions often need to cooperate, so changing only one
                // of them would be a recipe for inconsistency.
                // So here we avoid merging an inherited field policy with an updated one.
                if (!existing || existing?.typename !== typename) {
                    existing = existingFieldPolicies[fieldName] = { typename };
                }
                const incoming = fields[fieldName];
                if (typeof incoming === "function") {
                    existing.read = incoming;
                }
                else {
                    const { keyArgs, read, merge } = incoming;
                    existing.keyFn =
                        // Pass false to disable argument-based differentiation of
                        // field identities.
                        keyArgs === false ? simpleKeyArgsFn
                            // Pass an array of strings to use named arguments to
                            // compute a composite identity for the field.
                            : isArray(keyArgs) ? keyArgsFnFromSpecifier(keyArgs)
                                // Pass a function to take full control over field identity.
                                : typeof keyArgs === "function" ? keyArgs
                                    // Leave existing.keyFn unchanged if above cases fail.
                                    : existing.keyFn;
                    if (typeof read === "function") {
                        existing.read = read;
                    }
                    setMerge(existing, merge);
                }
                if (existing.read && existing.merge) {
                    // If we have both a read and a merge function, assume
                    // keyArgs:false, because read and merge together can take
                    // responsibility for interpreting arguments in and out. This
                    // default assumption can always be overridden by specifying
                    // keyArgs explicitly in the FieldPolicy.
                    existing.keyFn = existing.keyFn || simpleKeyArgsFn;
                }
            });
        }
    }
    setRootTypename(which, typename = which) {
        const rootId = "ROOT_" + which.toUpperCase();
        const old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            (0,invariant/* invariant */.kG)(!old || old === which, 99, which);
            // First, delete any old __typename associated with this rootId from
            // rootIdsByTypename.
            if (old)
                delete this.rootIdsByTypename[old];
            // Now make this the only __typename that maps to this rootId.
            this.rootIdsByTypename[typename] = rootId;
            // Finally, update the __typename associated with this rootId.
            this.rootTypenamesById[rootId] = typename;
        }
    }
    addPossibleTypes(possibleTypes) {
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach((supertype) => {
            // Make sure all types have an entry in this.supertypeMap, even if
            // their supertype set is empty, so we can return false immediately
            // from policies.fragmentMatches for unknown supertypes.
            this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach((subtype) => {
                this.getSupertypeSet(subtype, true).add(supertype);
                const match = subtype.match(TypeOrFieldNameRegExp);
                if (!match || match[0] !== subtype) {
                    // TODO Don't interpret just any invalid typename as a RegExp.
                    this.fuzzySubtypes.set(subtype, new RegExp(subtype));
                }
            });
        });
    }
    getTypePolicy(typename) {
        if (!hasOwn.call(this.typePolicies, typename)) {
            const policy = (this.typePolicies[typename] = {});
            policy.fields = {};
            // When the TypePolicy for typename is first accessed, instead of
            // starting with an empty policy object, inherit any properties or
            // fields from the type policies of the supertypes of typename.
            //
            // Any properties or fields defined explicitly within the TypePolicy
            // for typename will take precedence, and if there are multiple
            // supertypes, the properties of policies whose types were added
            // later via addPossibleTypes will take precedence over those of
            // earlier supertypes. TODO Perhaps we should warn about these
            // conflicts in development, and recommend defining the property
            // explicitly in the subtype policy?
            //
            // Field policy inheritance is atomic/shallow: you can't inherit a
            // field policy and then override just its read function, since read
            // and merge functions often need to cooperate, so changing only one
            // of them would be a recipe for inconsistency.
            //
            // Once the TypePolicy for typename has been accessed, its properties can
            // still be updated directly using addTypePolicies, but future changes to
            // inherited supertype policies will not be reflected in this subtype
            // policy, because this code runs at most once per typename.
            let supertypes = this.supertypeMap.get(typename);
            if (!supertypes && this.fuzzySubtypes.size) {
                // To make the inheritance logic work for unknown typename strings that
                // may have fuzzy supertypes, we give this typename an empty supertype
                // set and then populate it with any fuzzy supertypes that match.
                supertypes = this.getSupertypeSet(typename, true);
                // This only works for typenames that are directly matched by a fuzzy
                // supertype. What if there is an intermediate chain of supertypes?
                // While possible, that situation can only be solved effectively by
                // specifying the intermediate relationships via possibleTypes, manually
                // and in a non-fuzzy way.
                this.fuzzySubtypes.forEach((regExp, fuzzy) => {
                    if (regExp.test(typename)) {
                        // The fuzzy parameter is just the original string version of regExp
                        // (not a valid __typename string), but we can look up the
                        // associated supertype(s) in this.supertypeMap.
                        const fuzzySupertypes = this.supertypeMap.get(fuzzy);
                        if (fuzzySupertypes) {
                            fuzzySupertypes.forEach((supertype) => supertypes.add(supertype));
                        }
                    }
                });
            }
            if (supertypes && supertypes.size) {
                supertypes.forEach((supertype) => {
                    const { fields, ...rest } = this.getTypePolicy(supertype);
                    Object.assign(policy, rest);
                    Object.assign(policy.fields, fields);
                });
            }
        }
        const inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) {
            // Merge the pending policies into this.typePolicies, in the order they
            // were originally passed to addTypePolicy.
            inbox.splice(0).forEach((policy) => {
                this.updateTypePolicy(typename, policy, this.typePolicies[typename].fields);
            });
        }
        return this.typePolicies[typename];
    }
    getFieldPolicy(typename, fieldName) {
        if (typename) {
            return this.getTypePolicy(typename).fields[fieldName];
        }
    }
    getSupertypeSet(subtype, createIfMissing) {
        let supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) {
            this.supertypeMap.set(subtype, (supertypeSet = new Set()));
        }
        return supertypeSet;
    }
    fragmentMatches(fragment, typename, result, variables) {
        if (!fragment.typeCondition)
            return true;
        // If the fragment has a type condition but the object we're matching
        // against does not have a __typename, the fragment cannot match.
        if (!typename)
            return false;
        const supertype = fragment.typeCondition.name.value;
        // Common case: fragment type condition and __typename are the same.
        if (typename === supertype)
            return true;
        if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
            const typenameSupertypeSet = this.getSupertypeSet(typename, true);
            const workQueue = [typenameSupertypeSet];
            const maybeEnqueue = (subtype) => {
                const supertypeSet = this.getSupertypeSet(subtype, false);
                if (supertypeSet &&
                    supertypeSet.size &&
                    workQueue.indexOf(supertypeSet) < 0) {
                    workQueue.push(supertypeSet);
                }
            };
            // We need to check fuzzy subtypes only if we encountered fuzzy
            // subtype strings in addPossibleTypes, and only while writing to
            // the cache, since that's when selectionSetMatchesResult gives a
            // strong signal of fragment matching. The StoreReader class calls
            // policies.fragmentMatches without passing a result object, so
            // needToCheckFuzzySubtypes is always false while reading.
            let needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            let checkingFuzzySubtypes = false;
            // It's important to keep evaluating workQueue.length each time through
            // the loop, because the queue can grow while we're iterating over it.
            for (let i = 0; i < workQueue.length; ++i) {
                const supertypeSet = workQueue[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) {
                            index_production/* __DEV__ */.T && invariant/* invariant,warn */.kG.warn(100, typename, supertype);
                        }
                        // Record positive results for faster future lookup.
                        // Unfortunately, we cannot safely cache negative results,
                        // because new possibleTypes data could always be added to the
                        // Policies class.
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue);
                if (needToCheckFuzzySubtypes &&
                    // Start checking fuzzy subtypes only after exhausting all
                    // non-fuzzy subtypes (after the final iteration of the loop).
                    i === workQueue.length - 1 &&
                    // We could wait to compare fragment.selectionSet to result
                    // after we verify the supertype, but this check is often less
                    // expensive than that search, and we will have to do the
                    // comparison anyway whenever we find a potential match.
                    selectionSetMatchesResult(fragment.selectionSet, result, variables)) {
                    // We don't always need to check fuzzy subtypes (if no result
                    // was provided, or !this.fuzzySubtypes.size), but, when we do,
                    // we only want to check them once.
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    // If we find any fuzzy subtypes that match typename, extend the
                    // workQueue to search through the supertypes of those fuzzy
                    // subtypes. Otherwise the for-loop will terminate and we'll
                    // return false below.
                    this.fuzzySubtypes.forEach((regExp, fuzzyString) => {
                        const match = typename.match(regExp);
                        if (match && match[0] === typename) {
                            maybeEnqueue(fuzzyString);
                        }
                    });
                }
            }
        }
        return false;
    }
    hasKeyArgs(typename, fieldName) {
        const policy = this.getFieldPolicy(typename, fieldName);
        return !!(policy && policy.keyFn);
    }
    getStoreFieldName(fieldSpec) {
        const { typename, fieldName } = fieldSpec;
        const policy = this.getFieldPolicy(typename, fieldName);
        let storeFieldName;
        let keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            const context = {
                typename,
                fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables,
            };
            const args = argsFromFieldSpecifier(fieldSpec);
            while (keyFn) {
                const specifierOrString = keyFn(args, context);
                if (isArray(specifierOrString)) {
                    keyFn = keyArgsFnFromSpecifier(specifierOrString);
                }
                else {
                    // If the custom keyFn returns a falsy value, fall back to
                    // fieldName instead.
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) {
            storeFieldName =
                fieldSpec.field ?
                    storeKeyNameFromField(fieldSpec.field, fieldSpec.variables)
                    : getStoreKeyName(fieldName, argsFromFieldSpecifier(fieldSpec));
        }
        // Returning false from a keyArgs function is like configuring
        // keyArgs: false, but more dynamic.
        if (storeFieldName === false) {
            return fieldName;
        }
        // Make sure custom field names start with the actual field.name.value
        // of the field, so we can always figure out which properties of a
        // StoreObject correspond to which original field names.
        return fieldName === fieldNameFromStoreName(storeFieldName) ? storeFieldName
            : fieldName + ":" + storeFieldName;
    }
    readField(options, context) {
        const objectOrReference = options.from;
        if (!objectOrReference)
            return;
        const nameOrField = options.field || options.fieldName;
        if (!nameOrField)
            return;
        if (options.typename === void 0) {
            const typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename)
                options.typename = typename;
        }
        const storeFieldName = this.getStoreFieldName(options);
        const fieldName = fieldNameFromStoreName(storeFieldName);
        const existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        const policy = this.getFieldPolicy(options.typename, fieldName);
        const read = policy && policy.read;
        if (read) {
            const readOptions = makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage(isReference(objectOrReference) ?
                objectOrReference.__ref
                : objectOrReference, storeFieldName));
            // Call read(existing, readOptions) with cacheSlot holding this.cache.
            return reactiveVars/* cacheSlot,withValue */.ab.withValue(this.cache, read, [
                existing,
                readOptions,
            ]);
        }
        return existing;
    }
    getReadFunction(typename, fieldName) {
        const policy = this.getFieldPolicy(typename, fieldName);
        return policy && policy.read;
    }
    getMergeFunction(parentTypename, fieldName, childTypename) {
        let policy = this.getFieldPolicy(parentTypename, fieldName);
        let merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    }
    runMergeFunction(existing, incoming, { field, typename, merge }, context, storage) {
        if (merge === mergeTrueFn) {
            // Instead of going to the trouble of creating a full
            // FieldFunctionOptions object and calling mergeTrueFn, we can
            // simply call mergeObjects, as mergeTrueFn would.
            return makeMergeObjectsFunction(context.store)(existing, incoming);
        }
        if (merge === mergeFalseFn) {
            // Likewise for mergeFalseFn, whose implementation is even simpler.
            return incoming;
        }
        // If cache.writeQuery or cache.writeFragment was called with
        // options.overwrite set to true, we still call merge functions, but
        // the existing data is always undefined, so the merge function will
        // not attempt to combine the incoming data with the existing data.
        if (context.overwrite) {
            existing = void 0;
        }
        return merge(existing, incoming, makeFieldFunctionOptions(this, 
        // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0, {
            typename,
            fieldName: field.name.value,
            field,
            variables: context.variables,
        }, context, storage || {}));
    }
}
function makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    const storeFieldName = policies.getStoreFieldName(fieldSpec);
    const fieldName = fieldNameFromStoreName(storeFieldName);
    const variables = fieldSpec.variables || context.variables;
    const { toReference, canRead } = context.store;
    return {
        args: argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName,
        storeFieldName,
        variables,
        isReference: isReference,
        toReference,
        storage,
        cache: policies.cache,
        canRead,
        readField(...args) {
            return policies.readField(normalizeReadFieldOptions(args, objectOrReference, variables), context);
        },
        mergeObjects: makeMergeObjectsFunction(context.store),
    };
}
function normalizeReadFieldOptions(readFieldArgs, objectOrReference, variables) {
    const { 0: fieldNameOrOptions, 1: from, length: argc } = readFieldArgs;
    let options;
    if (typeof fieldNameOrOptions === "string") {
        options = {
            fieldName: fieldNameOrOptions,
            // Default to objectOrReference only when no second argument was
            // passed for the from parameter, not when undefined is explicitly
            // passed as the second argument.
            from: argc > 1 ? from : objectOrReference,
        };
    }
    else {
        options = { ...fieldNameOrOptions };
        // Default to objectOrReference only when fieldNameOrOptions.from is
        // actually omitted, rather than just undefined.
        if (!hasOwn.call(options, "from")) {
            options.from = objectOrReference;
        }
    }
    if (index_production/* __DEV__ */.T && options.from === void 0) {
        index_production/* __DEV__ */.T && invariant/* invariant,warn */.kG.warn(101, (0,stringifyForDisplay/* stringifyForDisplay */.v)(Array.from(readFieldArgs)));
    }
    if (void 0 === options.variables) {
        options.variables = variables;
    }
    return options;
}
function makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if (isArray(existing) || isArray(incoming)) {
            throw (0,invariant/* newInvariantError */._K)(102);
        }
        // These dynamic checks are necessary because the parameters of a
        // custom merge function can easily have the any type, so the type
        // system cannot always enforce the StoreObject | Reference parameter
        // types of options.mergeObjects.
        if ((0,isNonNullObject/* isNonNullObject */.s)(existing) && (0,isNonNullObject/* isNonNullObject */.s)(incoming)) {
            const eType = store.getFieldValue(existing, "__typename");
            const iType = store.getFieldValue(incoming, "__typename");
            const typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) {
                return incoming;
            }
            if (isReference(existing) && storeValueIsStoreObject(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // existing.__ref, preferring/overwriting any fields contributed by the
                // newer incoming StoreObject.
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if (storeValueIsStoreObject(existing) && isReference(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // incoming.__ref, taking fields from the older existing object only if
                // those fields are not already present in the newer StoreObject
                // identified by incoming.__ref.
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if (storeValueIsStoreObject(existing) &&
                storeValueIsStoreObject(incoming)) {
                return { ...existing, ...incoming };
            }
        }
        return incoming;
    };
}
//# sourceMappingURL=policies.js.map

// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/mergeDeepArray.js
var mergeDeepArray = __webpack_require__(89465);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/cache/core/types/common.js
class MissingFieldError extends Error {
    message;
    path;
    query;
    variables;
    constructor(message, path, query, variables) {
        // 'Error' breaks prototype chain here
        super(message);
        this.message = message;
        this.path = path;
        this.query = query;
        this.variables = variables;
        this.name = "MissingFieldError";
        if (Array.isArray(this.path)) {
            this.missing = this.message;
            for (let i = this.path.length - 1; i >= 0; --i) {
                this.missing = { [this.path[i]]: this.missing };
            }
        }
        else {
            this.missing = this.path;
        }
        // We're not using `Object.setPrototypeOf` here as it isn't fully supported
        // on Android (see issue #3236).
        this.__proto__ = MissingFieldError.prototype;
    }
    missing;
}
//# sourceMappingURL=common.js.map
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/cache/inmemory/readFromStore.js









function execSelectionSetKeyArgs(options) {
    return [options.selectionSet, options.objectOrReference, options.context];
}
class StoreReader {
    // cached version of executeSelectionSet
    executeSelectionSet;
    // cached version of executeSubSelectedArray
    executeSubSelectedArray;
    config;
    knownResults = new WeakMap();
    constructor(config) {
        this.config = config;
        // memoized functions in this class will be "garbage-collected"
        // by recreating the whole `StoreReader` in
        // `InMemoryCache.resetResultsCache`
        // (triggered from `InMemoryCache.gc` with `resetResultCache: true`)
        this.executeSelectionSet = (0,lib/* wrap */.re)((options) => {
            const peekArgs = execSelectionSetKeyArgs(options);
            const other = this.executeSelectionSet.peek(...peekArgs);
            if (other) {
                // If we previously read this result with canonization enabled, we can
                // return that canonized result as-is.
                return other;
            }
            maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
            // Finally, if we didn't find any useful previous results, run the real
            // execSelectionSetImpl method with the given options.
            return this.execSelectionSetImpl(options);
        }, {
            max: sizes/* cacheSizes,inMemoryCache.executeSelectionSet */.Q["inMemoryCache.executeSelectionSet"] ||
                50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */,
            keyArgs: execSelectionSetKeyArgs,
            // Note that the parameters of makeCacheKey are determined by the
            // array returned by keyArgs.
            makeCacheKey(selectionSet, parent, context) {
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(selectionSet, isReference(parent) ? parent.__ref : parent, context.varString);
                }
            },
        });
        this.executeSubSelectedArray = (0,lib/* wrap */.re)((options) => {
            maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
            return this.execSubSelectedArrayImpl(options);
        }, {
            max: sizes/* cacheSizes,inMemoryCache.executeSubSelectedArray */.Q["inMemoryCache.executeSubSelectedArray"] ||
                10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */,
            makeCacheKey({ field, array, context }) {
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(field, array, context.varString);
                }
            },
        });
    }
    /**
     * Given a store and a query, return as much of the result as possible and
     * identify if any data was missing from the store.
     */
    diffQueryAgainstStore({ store, query, rootId = "ROOT_QUERY", variables, returnPartialData = true, }) {
        const policies = this.config.cache.policies;
        variables = {
            ...getDefaultValues(getQueryDefinition(query)),
            ...variables,
        };
        const rootRef = makeReference(rootId);
        const execResult = this.executeSelectionSet({
            selectionSet: (0,getMainDefinition/* getMainDefinition */.p)(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: {
                store,
                query,
                policies,
                variables,
                varString: canonicalStringify_canonicalStringify(variables),
                ...extractFragmentContext(query, this.config.fragments),
            },
        });
        let missing;
        if (execResult.missing) {
            missing = new MissingFieldError(firstMissing(execResult.missing), execResult.missing, query, variables);
        }
        const complete = !missing;
        const { result } = execResult;
        return {
            result: complete || returnPartialData ?
                Object.keys(result).length === 0 ?
                    null
                    : result
                : null,
            complete,
            missing,
        };
    }
    isFresh(result, parent, selectionSet, context) {
        if (supportsResultCaching(context.store) &&
            this.knownResults.get(result) === selectionSet) {
            const latest = this.executeSelectionSet.peek(selectionSet, parent, context);
            if (latest && result === latest.result) {
                return true;
            }
        }
        return false;
    }
    // Uncached version of executeSelectionSet.
    execSelectionSetImpl({ selectionSet, objectOrReference, enclosingRef, context, }) {
        if (isReference(objectOrReference) &&
            !context.policies.rootTypenamesById[objectOrReference.__ref] &&
            !context.store.has(objectOrReference.__ref)) {
            return {
                result: {},
                missing: `Dangling reference to missing ${objectOrReference.__ref} object`,
            };
        }
        const { variables, policies, store } = context;
        const typename = store.getFieldValue(objectOrReference, "__typename");
        const objectsToMerge = [];
        let missing;
        const missingMerger = new DeepMerger/* DeepMerger */.w();
        if (typeof typename === "string" && !policies.rootIdsByTypename[typename]) {
            // Ensure we always include a default value for the __typename
            // field, if we have one. Note that this field can be overridden by other
            // merged objects.
            objectsToMerge.push({ __typename: typename });
        }
        function handleMissing(result, resultName) {
            if (result.missing) {
                missing = missingMerger.merge(missing, {
                    [resultName]: result.missing,
                });
            }
            return result.result;
        }
        const workSet = new Set(selectionSet.selections);
        workSet.forEach((selection) => {
            // Omit fields with directives @skip(if: <truthy value>) or
            // @include(if: <falsy value>).
            if (!(0,shouldInclude/* shouldInclude */.L)(selection, variables))
                return;
            if (isField(selection)) {
                let fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference,
                }, context);
                const resultName = (0,resultKeyNameFromField/* resultKeyNameFromField */.u)(selection);
                if (fieldValue === void 0) {
                    if (!addTypenameToDocument.added(selection)) {
                        missing = missingMerger.merge(missing, {
                            [resultName]: `Can't find field '${selection.name.value}' on ${isReference(objectOrReference) ?
                                objectOrReference.__ref + " object"
                                : "object " + JSON.stringify(objectOrReference, null, 2)}`,
                        });
                    }
                }
                else if (isArray(fieldValue)) {
                    if (fieldValue.length > 0) {
                        fieldValue = handleMissing(this.executeSubSelectedArray({
                            field: selection,
                            array: fieldValue,
                            enclosingRef,
                            context,
                        }), resultName);
                    }
                }
                else if (!selection.selectionSet) {
                    // do nothing
                }
                else if (fieldValue != null) {
                    // In this case, because we know the field has a selection set,
                    // it must be trying to query a GraphQLObjectType, which is why
                    // fieldValue must be != null.
                    fieldValue = handleMissing(this.executeSelectionSet({
                        selectionSet: selection.selectionSet,
                        objectOrReference: fieldValue,
                        enclosingRef: isReference(fieldValue) ? fieldValue : enclosingRef,
                        context,
                    }), resultName);
                }
                if (fieldValue !== void 0) {
                    objectsToMerge.push({ [resultName]: fieldValue });
                }
            }
            else {
                const fragment = getFragmentFromSelection(selection, context.lookupFragment);
                if (!fragment && selection.kind === kinds/* Kind,FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD) {
                    throw (0,invariant/* newInvariantError */._K)(103, selection.name.value);
                }
                if (fragment && policies.fragmentMatches(fragment, typename)) {
                    fragment.selectionSet.selections.forEach(workSet.add, workSet);
                }
            }
        });
        const result = (0,mergeDeepArray/* mergeDeepArray */.b)(objectsToMerge);
        const finalResult = { result, missing };
        const frozen = maybeDeepFreeze(finalResult);
        // Store this result with its selection set so that we can quickly
        // recognize it again in the StoreReader#isFresh method.
        if (frozen.result) {
            this.knownResults.set(frozen.result, selectionSet);
        }
        return frozen;
    }
    // Uncached version of executeSubSelectedArray.
    execSubSelectedArrayImpl({ field, array, enclosingRef, context, }) {
        let missing;
        let missingMerger = new DeepMerger/* DeepMerger */.w();
        function handleMissing(childResult, i) {
            if (childResult.missing) {
                missing = missingMerger.merge(missing, { [i]: childResult.missing });
            }
            return childResult.result;
        }
        if (field.selectionSet) {
            array = array.filter(context.store.canRead);
        }
        array = array.map((item, i) => {
            // null value in array
            if (item === null) {
                return null;
            }
            // This is a nested array, recurse
            if (isArray(item)) {
                return handleMissing(this.executeSubSelectedArray({
                    field,
                    array: item,
                    enclosingRef,
                    context,
                }), i);
            }
            // This is an object, run the selection set on it
            if (field.selectionSet) {
                return handleMissing(this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    objectOrReference: item,
                    enclosingRef: isReference(item) ? item : enclosingRef,
                    context,
                }), i);
            }
            if (index_production/* __DEV__ */.T) {
                assertSelectionSetForIdValue(context.store, field, item);
            }
            return item;
        });
        return {
            result: array,
            missing,
        };
    }
}
function firstMissing(tree) {
    try {
        JSON.stringify(tree, (_, value) => {
            if (typeof value === "string")
                throw value;
            return value;
        });
    }
    catch (result) {
        return result;
    }
}
function assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        const workSet = new Set([fieldValue]);
        workSet.forEach((value) => {
            if ((0,isNonNullObject/* isNonNullObject */.s)(value)) {
                (0,invariant/* invariant */.kG)(
                    !isReference(value),
                    104,
                    getTypenameFromStoreObject(store, value),
                    field.name.value
                );
                Object.values(value).forEach(workSet.add, workSet);
            }
        });
    }
}
//# sourceMappingURL=readFromStore.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/cloneDeep.js
const { toString: cloneDeep_toString } = Object.prototype;
/**
* Deeply clones a value to create a new instance.
*
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function cloneDeep(value) {
    return __cloneDeep(value);
}
function __cloneDeep(val, seen) {
    switch (cloneDeep_toString.call(val)) {
        case "[object Array]": {
            seen = seen || new Map();
            if (seen.has(val))
                return seen.get(val);
            const copy = val.slice(0);
            seen.set(val, copy);
            copy.forEach(function (child, i) {
                copy[i] = __cloneDeep(child, seen);
            });
            return copy;
        }
        case "[object Object]": {
            seen = seen || new Map();
            if (seen.has(val))
                return seen.get(val);
            // High fidelity polyfills of Object.create and Object.getPrototypeOf are
            // possible in all JS environments, so we will assume they exist/work.
            const copy = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy);
            Object.keys(val).forEach((key) => {
                copy[key] = __cloneDeep(val[key], seen);
            });
            return copy;
        }
        default:
            return val;
    }
}
//# sourceMappingURL=cloneDeep.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/cache/inmemory/writeToStore.js









// Since there are only four possible combinations of context.clientOnly and
// context.deferred values, we should need at most four "flavors" of any given
// WriteContext. To avoid creating multiple copies of the same context, we cache
// the contexts in the context.flavors Map (shared by all flavors) according to
// their clientOnly and deferred values (always in that order).
function getContextFlavor(context, clientOnly, deferred) {
    const key = `${clientOnly}${deferred}`;
    let flavored = context.flavors.get(key);
    if (!flavored) {
        context.flavors.set(key, (flavored =
            context.clientOnly === clientOnly && context.deferred === deferred ?
                context
                : {
                    ...context,
                    clientOnly,
                    deferred,
                }));
    }
    return flavored;
}
class StoreWriter {
    cache;
    reader;
    fragments;
    constructor(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    writeToStore(store, { query, result, dataId, variables, overwrite, }) {
        const operationDefinition = (0,getOperationDefinition/* getOperationDefinition */.$)(query);
        const merger = makeProcessedFieldsMerger();
        variables = {
            ...getDefaultValues(operationDefinition),
            ...variables,
        };
        const context = {
            store,
            written: {},
            merge(existing, incoming) {
                return merger.merge(existing, incoming);
            },
            variables: variables,
            varString: canonicalStringify_canonicalStringify(variables),
            ...extractFragmentContext(query, this.fragments),
            overwrite: !!overwrite,
            incomingById: new Map(),
            clientOnly: false,
            deferred: false,
            flavors: new Map(),
        };
        const ref = this.processSelectionSet({
            result: result || {},
            dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: { map: new Map() },
            context,
        });
        if (!isReference(ref)) {
            throw (0,invariant/* newInvariantError */._K)(105, result);
        }
        // So far, the store has not been modified, so now it's time to process
        // context.incomingById and merge those incoming fields into context.store.
        context.incomingById.forEach(({ storeObject, mergeTree, fieldNodeSet }, dataId) => {
            const entityRef = makeReference(dataId);
            if (mergeTree && mergeTree.map.size) {
                const applied = this.applyMerges(mergeTree, entityRef, storeObject, context);
                if (isReference(applied)) {
                    // Assume References returned by applyMerges have already been merged
                    // into the store. See makeMergeObjectsFunction in policies.ts for an
                    // example of how this can happen.
                    return;
                }
                // Otherwise, applyMerges returned a StoreObject, whose fields we should
                // merge into the store (see store.merge statement below).
                storeObject = applied;
            }
            if (index_production/* __DEV__ */.T && !context.overwrite) {
                const fieldsWithSelectionSets = {};
                fieldNodeSet.forEach((field) => {
                    if (field.selectionSet) {
                        fieldsWithSelectionSets[field.name.value] = true;
                    }
                });
                const hasSelectionSet = (storeFieldName) => fieldsWithSelectionSets[fieldNameFromStoreName(storeFieldName)] ===
                    true;
                const hasMergeFunction = (storeFieldName) => {
                    const childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach((storeFieldName) => {
                    // If a merge function was defined for this field, trust that it
                    // did the right thing about (not) clobbering data. If the field
                    // has no selection set, it's a scalar field, so it doesn't need
                    // a merge function (even if it's an object, like JSON data).
                    if (hasSelectionSet(storeFieldName) &&
                        !hasMergeFunction(storeFieldName)) {
                        warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                    }
                });
            }
            store.merge(dataId, storeObject);
        });
        // Any IDs written explicitly to the cache will be retained as
        // reachable root IDs for garbage collection purposes. Although this
        // logic includes root IDs like ROOT_QUERY and ROOT_MUTATION, their
        // retainment counts are effectively ignored because cache.gc() always
        // includes them in its root ID set.
        store.retain(ref.__ref);
        return ref;
    }
    processSelectionSet({ dataId, result, selectionSet, context, 
    // This object allows processSelectionSet to report useful information
    // to its callers without explicitly returning that information.
    mergeTree, }) {
        const { policies } = this.cache;
        // This variable will be repeatedly updated using context.merge to
        // accumulate all fields that need to be written into the store.
        let incoming = {};
        // If typename was not passed in, infer it. Note that typename is
        // always passed in for tricky-to-infer cases such as "Query" for
        // ROOT_QUERY.
        const typename = (dataId && policies.rootTypenamesById[dataId]) ||
            getTypenameFromResult(result, selectionSet, context.fragmentMap) ||
            (dataId && context.store.get(dataId, "__typename"));
        if ("string" === typeof typename) {
            incoming.__typename = typename;
        }
        // This readField function will be passed as context.readField in the
        // KeyFieldsContext object created within policies.identify (called below).
        // In addition to reading from the existing context.store (thanks to the
        // policies.readField(options, context) line at the very bottom), this
        // version of readField can read from Reference objects that are currently
        // pending in context.incomingById, which is important whenever keyFields
        // need to be extracted from a child object that processSelectionSet has
        // turned into a Reference.
        const readField = (...args) => {
            const options = normalizeReadFieldOptions(args, incoming, context.variables);
            if (isReference(options.from)) {
                const info = context.incomingById.get(options.from.__ref);
                if (info) {
                    const result = policies.readField({
                        ...options,
                        from: info.storeObject,
                    }, context);
                    if (result !== void 0) {
                        return result;
                    }
                }
            }
            return policies.readField(options, context);
        };
        const fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, 
        // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        context, typename).forEach((context, field) => {
            const resultFieldKey = (0,resultKeyNameFromField/* resultKeyNameFromField */.u)(field);
            const value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                const storeFieldName = policies.getStoreFieldName({
                    typename,
                    fieldName: field.name.value,
                    field,
                    variables: context.variables,
                });
                const childTree = getChildMergeTree(mergeTree, storeFieldName);
                let incomingValue = this.processFieldValue(value, field, 
                // Reset context.clientOnly and context.deferred to their default
                // values before processing nested selection sets.
                field.selectionSet ?
                    getContextFlavor(context, false, false)
                    : context, childTree);
                // To determine if this field holds a child object with a merge function
                // defined in its type policy (see PR #7070), we need to figure out the
                // child object's __typename.
                let childTypename;
                // The field's value can be an object that has a __typename only if the
                // field has a selection set. Otherwise incomingValue is scalar.
                if (field.selectionSet &&
                    (isReference(incomingValue) || storeValueIsStoreObject(incomingValue))) {
                    childTypename = readField("__typename", incomingValue);
                }
                const merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) {
                    childTree.info = {
                        // TODO Check compatibility against any existing childTree.field?
                        field,
                        typename,
                        merge,
                    };
                }
                else {
                    maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                }
                incoming = context.merge(incoming, {
                    [storeFieldName]: incomingValue,
                });
            }
            else if (index_production/* __DEV__ */.T &&
                !context.clientOnly &&
                !context.deferred &&
                !addTypenameToDocument.added(field) &&
                // If the field has a read function, it may be a synthetic field or
                // provide a default value, so its absence from the written data should
                // not be cause for alarm.
                !policies.getReadFunction(typename, field.name.value)) {
                invariant/* invariant,error */.kG.error(106, (0,resultKeyNameFromField/* resultKeyNameFromField */.u)(field), result);
            }
        });
        // Identify the result object, even if dataId was already provided,
        // since we always need keyObject below.
        try {
            const [id, keyObject] = policies.identify(result, {
                typename,
                selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField,
            });
            // If dataId was not provided, fall back to the id just generated by
            // policies.identify.
            dataId = dataId || id;
            // Write any key fields that were used during identification, even if
            // they were not mentioned in the original query.
            if (keyObject) {
                // TODO Reverse the order of the arguments?
                incoming = context.merge(incoming, keyObject);
            }
        }
        catch (e) {
            // If dataId was provided, tolerate failure of policies.identify.
            if (!dataId)
                throw e;
        }
        if ("string" === typeof dataId) {
            const dataRef = makeReference(dataId);
            // Avoid processing the same entity object using the same selection
            // set more than once. We use an array instead of a Set since most
            // entity IDs will be written using only one selection set, so the
            // size of this array is likely to be very small, meaning indexOf is
            // likely to be faster than Set.prototype.has.
            const sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0)
                return dataRef;
            sets.push(selectionSet);
            // If we're about to write a result object into the store, but we
            // happen to know that the exact same (===) result object would be
            // returned if we were to reread the result with the same inputs,
            // then we can skip the rest of the processSelectionSet work for
            // this object, and immediately return a Reference to it.
            if (this.reader &&
                this.reader.isFresh(result, dataRef, selectionSet, context)) {
                return dataRef;
            }
            const previous = context.incomingById.get(dataId);
            if (previous) {
                previous.storeObject = context.merge(previous.storeObject, incoming);
                previous.mergeTree = mergeMergeTrees(previous.mergeTree, mergeTree);
                fieldNodeSet.forEach((field) => previous.fieldNodeSet.add(field));
            }
            else {
                context.incomingById.set(dataId, {
                    storeObject: incoming,
                    // Save a reference to mergeTree only if it is not empty, because
                    // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
                    // reused for entirely different parts of the result tree.
                    mergeTree: mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                    fieldNodeSet,
                });
            }
            return dataRef;
        }
        return incoming;
    }
    processFieldValue(value, field, context, mergeTree) {
        if (!field.selectionSet || value === null) {
            // In development, we need to clone scalar values so that they can be
            // safely frozen with maybeDeepFreeze in readFromStore.ts. In production,
            // it's cheaper to store the scalar values directly in the cache.
            return index_production/* __DEV__ */.T ? cloneDeep(value) : value;
        }
        if (isArray(value)) {
            return value.map((item, i) => {
                const value = this.processFieldValue(item, field, context, getChildMergeTree(mergeTree, i));
                maybeRecycleChildMergeTree(mergeTree, i);
                return value;
            });
        }
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context,
            mergeTree,
        });
    }
    // Implements https://spec.graphql.org/draft/#sec-Field-Collection, but with
    // some additions for tracking @client and @defer directives.
    flattenFields(selectionSet, result, context, typename = getTypenameFromResult(result, selectionSet, context.fragmentMap)) {
        const fieldMap = new Map();
        const { policies } = this.cache;
        const limitingTrie = new Trie(false); // No need for WeakMap, since limitingTrie does not escape.
        (function flatten(selectionSet, inheritedContext) {
            const visitedNode = limitingTrie.lookup(selectionSet, 
            // Because we take inheritedClientOnly and inheritedDeferred into
            // consideration here (in addition to selectionSet), it's possible for
            // the same selection set to be flattened more than once, if it appears
            // in the query with different @client and/or @directive configurations.
            inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited)
                return;
            visitedNode.visited = true;
            selectionSet.selections.forEach((selection) => {
                if (!(0,shouldInclude/* shouldInclude */.L)(selection, context.variables))
                    return;
                let { clientOnly, deferred } = inheritedContext;
                if (
                // Since the presence of @client or @defer on this field can only
                // cause clientOnly or deferred to become true, we can skip the
                // forEach loop if both clientOnly and deferred are already true.
                !(clientOnly && deferred) &&
                    isNonEmptyArray(selection.directives)) {
                    selection.directives.forEach((dir) => {
                        const name = dir.name.value;
                        if (name === "client")
                            clientOnly = true;
                        if (name === "defer") {
                            const args = (0,argumentsObjectFromField/* argumentsObjectFromField */.N)(dir, context.variables);
                            // The @defer directive takes an optional args.if boolean
                            // argument, similar to @include(if: boolean). Note that
                            // @defer(if: false) does not make context.deferred false, but
                            // instead behaves as if there was no @defer directive.
                            if (!args || args.if !== false) {
                                deferred = true;
                            }
                            // TODO In the future, we may want to record args.label using
                            // context.deferred, if a label is specified.
                        }
                    });
                }
                if (isField(selection)) {
                    const existing = fieldMap.get(selection);
                    if (existing) {
                        // If this field has been visited along another recursive path
                        // before, the final context should have clientOnly or deferred set
                        // to true only if *all* paths have the directive (hence the &&).
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, getContextFlavor(context, clientOnly, deferred));
                }
                else {
                    const fragment = getFragmentFromSelection(selection, context.lookupFragment);
                    if (!fragment && selection.kind === kinds/* Kind,FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD) {
                        throw (0,invariant/* newInvariantError */._K)(107, selection.name.value);
                    }
                    if (fragment &&
                        policies.fragmentMatches(fragment, typename, result, context.variables)) {
                        flatten(fragment.selectionSet, getContextFlavor(context, clientOnly, deferred));
                    }
                }
            });
        })(selectionSet, context);
        return fieldMap;
    }
    applyMerges(mergeTree, existing, incoming, context, getStorageArgs) {
        if (mergeTree.map.size && !isReference(incoming)) {
            const e = 
            // Items in the same position in different arrays are not
            // necessarily related to each other, so when incoming is an array
            // we process its elements as if there was no existing data.
            (!isArray(incoming) &&
                // Likewise, existing must be either a Reference or a StoreObject
                // in order for its fields to be safe to merge with the fields of
                // the incoming object.
                (isReference(existing) || storeValueIsStoreObject(existing))) ?
                existing
                : void 0;
            // This narrowing is implied by mergeTree.map.size > 0 and
            // !isReference(incoming), though TypeScript understandably cannot
            // hope to infer this type.
            const i = incoming;
            // The options.storage objects provided to read and merge functions
            // are derived from the identity of the parent object plus a
            // sequence of storeFieldName strings/numbers identifying the nested
            // field name path of each field value to be merged.
            if (e && !getStorageArgs) {
                getStorageArgs = [isReference(e) ? e.__ref : e];
            }
            // It's possible that applying merge functions to this subtree will
            // not change the incoming data, so this variable tracks the fields
            // that did change, so we can create a new incoming object when (and
            // only when) at least one incoming field has changed. We use a Map
            // to preserve the type of numeric keys.
            let changedFields;
            const getValue = (from, name) => {
                return (isArray(from) ?
                    typeof name === "number" ?
                        from[name]
                        : void 0
                    : context.store.getFieldValue(from, String(name)));
            };
            mergeTree.map.forEach((childTree, storeFieldName) => {
                const eVal = getValue(e, storeFieldName);
                const iVal = getValue(i, storeFieldName);
                // If we have no incoming data, leave any existing data untouched.
                if (void 0 === iVal)
                    return;
                if (getStorageArgs) {
                    getStorageArgs.push(storeFieldName);
                }
                const aVal = this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields = changedFields || new Map();
                    changedFields.set(storeFieldName, aVal);
                }
                if (getStorageArgs) {
                    (0,invariant/* invariant */.kG)(getStorageArgs.pop() === storeFieldName);
                }
            });
            if (changedFields) {
                // Shallow clone i so we can add changed fields to it.
                incoming = (isArray(i) ? i.slice(0) : { ...i });
                changedFields.forEach((value, name) => {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) {
            return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && context.store.getStorage(...getStorageArgs));
        }
        return incoming;
    }
}
const emptyMergeTreePool = [];
function getChildMergeTree({ map }, name) {
    if (!map.has(name)) {
        map.set(name, emptyMergeTreePool.pop() || { map: new Map() });
    }
    return map.get(name);
}
function mergeMergeTrees(left, right) {
    if (left === right || !right || mergeTreeIsEmpty(right))
        return left;
    if (!left || mergeTreeIsEmpty(left))
        return right;
    const info = left.info && right.info ?
        {
            ...left.info,
            ...right.info,
        }
        : left.info || right.info;
    const needToMergeMaps = left.map.size && right.map.size;
    const map = needToMergeMaps ? new Map()
        : left.map.size ? left.map
            : right.map;
    const merged = { info, map };
    if (needToMergeMaps) {
        const remainingRightKeys = new Set(right.map.keys());
        left.map.forEach((leftTree, key) => {
            merged.map.set(key, mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys.delete(key);
        });
        remainingRightKeys.forEach((key) => {
            merged.map.set(key, mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function maybeRecycleChildMergeTree({ map }, name) {
    const childTree = map.get(name);
    if (childTree && mergeTreeIsEmpty(childTree)) {
        emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
const warnings = new Set();
// Note that this function is unused in production, and thus should be
// pruned by any well-configured minifier.
function warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    const getChild = (objOrRef) => {
        const child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    const existing = getChild(existingRef);
    if (!existing)
        return;
    const incoming = getChild(incomingObj);
    if (!incoming)
        return;
    // It's always safe to replace a reference, since it refers to data
    // safely stored elsewhere.
    if (isReference(existing))
        return;
    // If the values are structurally equivalent, we do not need to worry
    // about incoming replacing existing.
    if (equal(existing, incoming))
        return;
    // If we're replacing every key of the existing object, then the
    // existing data would be overwritten even if the objects were
    // normalized, so warning would not be helpful here.
    if (Object.keys(existing).every((key) => store.getFieldValue(incoming, key) !== void 0)) {
        return;
    }
    const parentType = store.getFieldValue(existingRef, "__typename") ||
        store.getFieldValue(incomingObj, "__typename");
    const fieldName = fieldNameFromStoreName(storeFieldName);
    const typeDotName = `${parentType}.${fieldName}`;
    // Avoid warning more than once for the same type and field name.
    if (warnings.has(typeDotName))
        return;
    warnings.add(typeDotName);
    const childTypenames = [];
    // Arrays do not have __typename fields, and always need a custom merge
    // function, even if their elements are normalized entities.
    if (!isArray(existing) && !isArray(incoming)) {
        [existing, incoming].forEach((child) => {
            const typename = store.getFieldValue(child, "__typename");
            if (typeof typename === "string" && !childTypenames.includes(typename)) {
                childTypenames.push(typename);
            }
        });
    }
    index_production/* __DEV__ */.T && invariant/* invariant,warn */.kG.warn(108, fieldName, parentType, childTypenames.length ?
        "either ensure all objects of type " +
            childTypenames.join(" and ") +
            " have an ID or a custom merge function, or "
        : "", typeDotName, { ...existing }, { ...incoming });
}
function getTypenameFromResult(result, selectionSet, fragmentMap) {
    let fragments;
    for (const selection of selectionSet.selections) {
        if (isField(selection)) {
            if (selection.name.value === "__typename") {
                return result[(0,resultKeyNameFromField/* resultKeyNameFromField */.u)(selection)];
            }
        }
        else if (fragments) {
            fragments.push(selection);
        }
        else {
            fragments = [selection];
        }
    }
    if (typeof result.__typename === "string") {
        return result.__typename;
    }
    if (fragments) {
        for (const selection of fragments) {
            const typename = getTypenameFromResult(result, getFragmentFromSelection(selection, fragmentMap).selectionSet, fragmentMap);
            if (typeof typename === "string") {
                return typename;
            }
        }
    }
}
//# sourceMappingURL=writeToStore.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/cache/inmemory/inMemoryCache.js













class InMemoryCache extends ApolloCache {
    data;
    optimisticData;
    config;
    watches = new Set();
    storeReader;
    storeWriter;
    addTypenameTransform = new DocumentTransform(addTypenameToDocument);
    maybeBroadcastWatch;
    // Override the default value, since InMemoryCache result objects are frozen
    // in development and expected to remain logically immutable in production.
    assumeImmutableResults = true;
    // Dynamically imported code can augment existing typePolicies or
    // possibleTypes by calling cache.policies.addTypePolicies or
    // cache.policies.addPossibletypes.
    policies;
    makeVar = reactiveVars/* makeVar */.QS;
    constructor(config = {}) {
        super();
        this.config = normalizeConfig(config);
        this.policies = new Policies({
            cache: this,
            dataIdFromObject: this.config.dataIdFromObject,
            possibleTypes: this.config.possibleTypes,
            typePolicies: this.config.typePolicies,
        });
        this.init();
    }
    init() {
        // Passing { resultCaching: false } in the InMemoryCache constructor options
        // will completely disable dependency tracking, which will improve memory
        // usage but worsen the performance of repeated reads.
        const rootStore = (this.data = new EntityStore.Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching,
        }));
        // When no optimistic writes are currently active, cache.optimisticData ===
        // cache.data, so there are no additional layers on top of the actual data.
        // When an optimistic update happens, this.optimisticData will become a
        // linked list of EntityStore Layer objects that terminates with the
        // original this.data cache object.
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    }
    resetResultCache() {
        const { fragments } = this.config;
        this.addTypenameTransform.resetCache();
        fragments?.resetCaches();
        // The StoreWriter is mostly stateless and so doesn't really need to be
        // reset, but it does need to have its writer.storeReader reference updated,
        // so it's simpler to update this.storeWriter as well.
        this.storeWriter = new StoreWriter(this, (this.storeReader = new StoreReader({ cache: this, fragments })), fragments);
        this.maybeBroadcastWatch = (0,lib/* wrap */.re)((c, options) => {
            return this.broadcastWatch(c, options);
        }, {
            max: sizes/* cacheSizes,inMemoryCache.maybeBroadcastWatch */.Q["inMemoryCache.maybeBroadcastWatch"] ||
                5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */,
            makeCacheKey: (c) => {
                // Return a cache key (thus enabling result caching) only if we're
                // currently using a data store that can track cache dependencies.
                const store = c.optimistic ? this.optimisticData : this.data;
                if (supportsResultCaching(store)) {
                    const { optimistic, id, variables } = c;
                    return store.makeCacheKey(c.query, 
                    // Different watches can have the same query, optimistic
                    // status, rootId, and variables, but if their callbacks are
                    // different, the (identical) result needs to be delivered to
                    // each distinct callback. The easiest way to achieve that
                    // separation is to include c.callback in the cache key for
                    // maybeBroadcastWatch calls. See issue #5733.
                    c.callback, canonicalStringify_canonicalStringify({ optimistic, id, variables }));
                }
            },
        });
        // Since we have thrown away all the cached functions that depend on the
        // CacheGroup dependencies maintained by EntityStore, we should also reset
        // all CacheGroup dependency information.
        new Set([this.data.group, this.optimisticData.group]).forEach((group) => group.resetCaching());
    }
    restore(data) {
        this.init();
        // Since calling this.init() discards/replaces the entire StoreReader, along
        // with the result caches it maintains, this.data.replace(data) won't have
        // to bother deleting the old data.
        if (data)
            this.data.replace(data);
        return this;
    }
    extract(optimistic = false) {
        return (optimistic ? this.optimisticData : this.data).extract();
    }
    read(options) {
        const { 
        // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        returnPartialData = false, } = options;
        return this.storeReader.diffQueryAgainstStore({
            ...options,
            store: options.optimistic ? this.optimisticData : this.data,
            config: this.config,
            returnPartialData,
        }).result;
    }
    write(options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    }
    modify(options) {
        if (hasOwn.call(options, "id") && !options.id) {
            // To my knowledge, TypeScript does not currently provide a way to
            // enforce that an optional property?:type must *not* be undefined
            // when present. That ability would be useful here, because we want
            // options.id to default to ROOT_QUERY only when no options.id was
            // provided. If the caller attempts to pass options.id with a
            // falsy/undefined value (perhaps because cache.identify failed), we
            // should not assume the goal was to modify the ROOT_QUERY object.
            // We could throw, but it seems natural to return false to indicate
            // that nothing was modified.
            return false;
        }
        const store = ((options.optimistic) // Defaults to false.
        ) ?
            this.optimisticData
            : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields, false);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    }
    diff(options) {
        return this.storeReader.diffQueryAgainstStore({
            ...options,
            store: options.optimistic ? this.optimisticData : this.data,
            rootId: options.id || "ROOT_QUERY",
            config: this.config,
        });
    }
    watch(watch) {
        if (!this.watches.size) {
            // In case we previously called forgetCache(this) because
            // this.watches became empty (see below), reattach this cache to any
            // reactive variables on which it previously depended. It might seem
            // paradoxical that we're able to recall something we supposedly
            // forgot, but the point of calling forgetCache(this) is to silence
            // useless broadcasts while this.watches is empty, and to allow the
            // cache to be garbage collected. If, however, we manage to call
            // recallCache(this) here, this cache object must not have been
            // garbage collected yet, and should resume receiving updates from
            // reactive variables, now that it has a watcher to notify.
            (0,reactiveVars/* recallCache */._v)(this);
        }
        this.watches.add(watch);
        if (watch.immediate) {
            this.maybeBroadcastWatch(watch);
        }
        return () => {
            // Once we remove the last watch from this.watches, cache.broadcastWatches
            // no longer does anything, so we preemptively tell the reactive variable
            // system to exclude this cache from future broadcasts.
            if (this.watches.delete(watch) && !this.watches.size) {
                (0,reactiveVars/* forgetCache */.li)(this);
            }
            // Remove this watch from the LRU cache managed by the
            // maybeBroadcastWatch OptimisticWrapperFunction, to prevent memory
            // leaks involving the closure of watch.callback.
            this.maybeBroadcastWatch.forget(watch);
        };
    }
    gc(options) {
        canonicalStringify_canonicalStringify.reset();
        graphql_print/* print,reset */.S.reset();
        const ids = this.optimisticData.gc();
        if (options && !this.txCount && options.resetResultCache) {
            this.resetResultCache();
        }
        return ids;
    }
    // Call this method to ensure the given root ID remains in the cache after
    // garbage collection, along with its transitive child entities. Note that
    // the cache automatically retains all directly written entities. By default,
    // the retainment persists after optimistic updates are removed. Pass true
    // for the optimistic argument if you would prefer for the retainment to be
    // discarded when the top-most optimistic layer is removed. Returns the
    // resulting (non-negative) retainment count.
    retain(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    }
    // Call this method to undo the effect of the retain method, above. Once the
    // retainment count falls to zero, the given ID will no longer be preserved
    // during garbage collection, though it may still be preserved by other safe
    // entities that refer to it. Returns the resulting (non-negative) retainment
    // count, in case that's useful.
    release(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    }
    // Returns the canonical ID for a given StoreObject, obeying typePolicies
    // and keyFields (and dataIdFromObject, if you still use that). At minimum,
    // the object must contain a __typename and any primary key fields required
    // to identify entities of that type. If you pass a query result object, be
    // sure that none of the primary key fields have been renamed by aliasing.
    // If you pass a Reference object, its __ref ID string will be returned.
    identify(object) {
        if (isReference(object))
            return object.__ref;
        try {
            return this.policies.identify(object)[0];
        }
        catch (e) {
            index_production/* __DEV__ */.T && invariant/* invariant,warn */.kG.warn(e);
        }
    }
    evict(options) {
        if (!options.id) {
            if (hasOwn.call(options, "id")) {
                // See comment in modify method about why we return false when
                // options.id exists but is falsy/undefined.
                return false;
            }
            options = { ...options, id: "ROOT_QUERY" };
        }
        try {
            // It's unlikely that the eviction will end up invoking any other
            // cache update operations while it's running, but {in,de}crementing
            // this.txCount still seems like a good idea, for uniformity with
            // the other update methods.
            ++this.txCount;
            // Pass this.data as a limit on the depth of the eviction, so evictions
            // during optimistic updates (when this.data is temporarily set equal to
            // this.optimisticData) do not escape their optimistic Layer.
            return this.optimisticData.evict(options, this.data);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    }
    reset(options) {
        this.init();
        canonicalStringify_canonicalStringify.reset();
        if (options && options.discardWatches) {
            // Similar to what happens in the unsubscribe function returned by
            // cache.watch, applied to all current watches.
            this.watches.forEach((watch) => this.maybeBroadcastWatch.forget(watch));
            this.watches.clear();
            (0,reactiveVars/* forgetCache */.li)(this);
        }
        else {
            // Calling this.init() above unblocks all maybeBroadcastWatch caching, so
            // this.broadcastWatches() triggers a broadcast to every current watcher
            // (letting them know their data is now missing). This default behavior is
            // convenient because it means the watches do not have to be manually
            // reestablished after resetting the cache. To prevent this broadcast and
            // cancel all watches, pass true for options.discardWatches.
            this.broadcastWatches();
        }
        return Promise.resolve();
    }
    removeOptimistic(idToRemove) {
        const newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    }
    txCount = 0;
    batch(options) {
        const { update, optimistic = true, removeOptimistic, onWatchUpdated, } = options;
        let updateResult;
        const perform = (layer) => {
            const { data, optimisticData } = this;
            ++this.txCount;
            if (layer) {
                this.data = this.optimisticData = layer;
            }
            try {
                return (updateResult = update(this));
            }
            finally {
                --this.txCount;
                this.data = data;
                this.optimisticData = optimisticData;
            }
        };
        const alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) {
            // If an options.onWatchUpdated callback is provided, we want to call it
            // with only the Cache.WatchOptions objects affected by options.update,
            // but there might be dirty watchers already waiting to be broadcast that
            // have nothing to do with the update. To prevent including those watchers
            // in the post-update broadcast, we perform this initial broadcast to
            // collect the dirty watchers, so we can re-dirty them later, after the
            // post-update broadcast, allowing them to receive their pending
            // broadcasts the next time broadcastWatches is called, just as they would
            // if we never called cache.batch.
            this.broadcastWatches({
                ...options,
                onWatchUpdated(watch) {
                    alreadyDirty.add(watch);
                    return false;
                },
            });
        }
        if (typeof optimistic === "string") {
            // Note that there can be multiple layers with the same optimistic ID.
            // When removeOptimistic(id) is called for that id, all matching layers
            // will be removed, and the remaining layers will be reapplied.
            this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        }
        else if (optimistic === false) {
            // Ensure both this.data and this.optimisticData refer to the root
            // (non-optimistic) layer of the cache during the update. Note that
            // this.data could be a Layer if we are currently executing an optimistic
            // update function, but otherwise will always be an EntityStore.Root
            // instance.
            perform(this.data);
        }
        else {
            // Otherwise, leave this.data and this.optimisticData unchanged and run
            // the update with broadcast batching.
            perform();
        }
        if (typeof removeOptimistic === "string") {
            this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        }
        // Note: if this.txCount > 0, then alreadyDirty.size === 0, so this code
        // takes the else branch and calls this.broadcastWatches(options), which
        // does nothing when this.txCount > 0.
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches({
                ...options,
                onWatchUpdated(watch, diff) {
                    const result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) {
                        // Since onWatchUpdated did not return false, this diff is
                        // about to be broadcast to watch.callback, so we don't need
                        // to re-dirty it with the other alreadyDirty watches below.
                        alreadyDirty.delete(watch);
                    }
                    return result;
                },
            });
            // Silently re-dirty any watches that were already dirty before the update
            // was performed, and were not broadcast just now.
            if (alreadyDirty.size) {
                alreadyDirty.forEach((watch) => this.maybeBroadcastWatch.dirty(watch));
            }
        }
        else {
            // If alreadyDirty is empty or we don't have an onWatchUpdated
            // function, we don't need to go to the trouble of wrapping
            // options.onWatchUpdated.
            this.broadcastWatches(options);
        }
        return updateResult;
    }
    performTransaction(update, optimisticId) {
        return this.batch({
            update,
            optimistic: optimisticId || optimisticId !== null,
        });
    }
    transformDocument(document) {
        return this.addTypenameTransform.transformDocument(this.addFragmentsToDocument(document));
    }
    fragmentMatches(fragment, typename) {
        return this.policies.fragmentMatches(fragment, typename);
    }
    lookupFragment(fragmentName) {
        return this.config.fragments?.lookup(fragmentName) || null;
    }
    broadcastWatches(options) {
        if (!this.txCount) {
            this.watches.forEach((c) => this.maybeBroadcastWatch(c, options));
        }
    }
    addFragmentsToDocument(document) {
        const { fragments } = this.config;
        return fragments ? fragments.transform(document) : document;
    }
    // This method is wrapped by maybeBroadcastWatch, which is called by
    // broadcastWatches, so that we compute and broadcast results only when
    // the data that would be broadcast might have changed. It would be
    // simpler to check for changes after recomputing a result but before
    // broadcasting it, but this wrapping approach allows us to skip both
    // the recomputation and the broadcast, in most cases.
    broadcastWatch(c, options) {
        const { lastDiff } = c;
        // Both WatchOptions and DiffOptions extend ReadOptions, and DiffOptions
        // currently requires no additional properties, so we can use c (a
        // WatchOptions object) as DiffOptions, without having to allocate a new
        // object, and without having to enumerate the relevant properties (query,
        // variables, etc.) explicitly. There will be some additional properties
        // (lastDiff, callback, etc.), but cache.diff ignores them.
        const diff = this.diff(c);
        if (options) {
            if (c.optimistic && typeof options.optimistic === "string") {
                diff.fromOptimisticTransaction = true;
            }
            if (options.onWatchUpdated &&
                options.onWatchUpdated.call(this, c, diff, lastDiff) === false) {
                // Returning false from the onWatchUpdated callback will prevent
                // calling c.callback(diff) for this watcher.
                return;
            }
        }
        if (!lastDiff || !equal(lastDiff.result, diff.result)) {
            c.callback((c.lastDiff = diff), lastDiff);
        }
    }
}
if (index_production/* __DEV__ */.T) {
    InMemoryCache.prototype.getMemoryInternals = getInMemoryCacheMemoryInternals;
}
//# sourceMappingURL=inMemoryCache.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/link/core/concat.js

/**
 * @deprecated Use `ApolloLink.from` instead. `concat` will be removed in a
 * future major version.
 */
const concat_concat = ApolloLink/* ApolloLink,concat */.i.concat;
//# sourceMappingURL=concat.js.map
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/link/core/empty.js

/**
 * @deprecated Use `ApolloLink.empty` instead. `empty` will be removed in a
 * future major version.
 */
const empty_empty = ApolloLink/* ApolloLink,empty */.i.empty;
//# sourceMappingURL=empty.js.map
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/link/core/from.js

/**
 * @deprecated Use `ApolloLink.from` instead. `from` will be removed in a
 * future major version.
 */
const core_from_from = ApolloLink/* ApolloLink,from */.i.from;
//# sourceMappingURL=from.js.map
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/link/core/split.js

/**
 * @deprecated Use `ApolloLink.split` instead. `split` will be removed in a
 * future major version.
 */
const split = ApolloLink/* ApolloLink,split */.i.split;
//# sourceMappingURL=split.js.map
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/link/http/checkFetcher.js
var checkFetcher = __webpack_require__(7037);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/link/client-awareness/ClientAwarenessLink.js
var ClientAwarenessLink = __webpack_require__(78568);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/link/utils/filterOperationVariables.js
var filterOperationVariables = __webpack_require__(64437);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/graphql/operations.js

function isOperation(document, operation) {
    return (0,getOperationDefinition/* getOperationDefinition */.$)(document)?.operation === operation;
}
/**
 * Determine if a document is a mutation document.
 *
 * @remarks
 * If you are authoring an Apollo link, you might not need this utility.
 * Prefer using the `operationType` property the `operation` object instead.
 *
 * @param document - The GraphQL document to check
 * @returns A boolean indicating if the document is a mutation operation
 *
 * @example
 *
 * ```ts
 * import { isMutationOperation } from "@apollo/client/utilities";
 *
 * const mutation = gql`
 *   mutation MyMutation {
 *     # ...
 *   }
 * `;
 *
 * isMutationOperation(mutation); // true
 * ```
 */
function isMutationOperation(document) {
    return isOperation(document, "mutation");
}
/**
 * Determine if a document is a query document.
 *
 * @remarks
 * If you are authoring an Apollo link, you might not need this utility.
 * Prefer using the `operationType` property the `operation` object instead.
 *
 * @param document - The GraphQL document to check
 * @returns A boolean indicating if the document is a query operation
 *
 * @example
 *
 * ```ts
 * import { isQueryOperation } from "@apollo/client/utilities";
 *
 * const query = gql`
 *   query MyQuery {
 *     # ...
 *   }
 * `;
 *
 * isQueryOperation(query); // true
 * ```
 */
function isQueryOperation(document) {
    return isOperation(document, "query");
}
/**
 * Determine if a document is a subscription document.
 *
 * @remarks
 * If you are authoring an Apollo link, you might not need this utility.
 * Prefer using the `operationType` property the `operation` object instead.
 *
 * @param document - The GraphQL document to check
 * @returns A boolean indicating if the document is a subscription operation
 *
 * @example
 *
 * ```ts
 * import { isSubscriptionOperation } from "@apollo/client/utilities";
 *
 * const subscription = gql`
 *   subscription MySubscription {
 *     # ...
 *   }
 * `;
 *
 * isSubscriptionOperation(subscription); // true
 * ```
 */
function isSubscriptionOperation(document) {
    return isOperation(document, "subscription");
}
//# sourceMappingURL=operations.js.map
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/globals/maybe.js
var maybe = __webpack_require__(33089);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/link/http/parseAndCheckHttpResponse.js
var parseAndCheckHttpResponse = __webpack_require__(97819);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/link/http/rewriteURIForGET.js
// For GET operations, returns the given URI rewritten with parameters, or a
// parse error.
function rewriteURIForGET(chosenURI, body) {
    // Implement the standard HTTP GET serialization, plus 'extensions'. Note
    // the extra level of JSON serialization!
    const queryParams = [];
    const addQueryParam = (key, value) => {
        queryParams.push(`${key}=${encodeURIComponent(value)}`);
    };
    if ("query" in body) {
        addQueryParam("query", body.query);
    }
    if (body.operationName) {
        addQueryParam("operationName", body.operationName);
    }
    if (body.variables) {
        let serializedVariables;
        try {
            serializedVariables = JSON.stringify(body.variables);
        }
        catch (parseError) {
            return { parseError };
        }
        addQueryParam("variables", serializedVariables);
    }
    if (body.extensions) {
        let serializedExtensions;
        try {
            serializedExtensions = JSON.stringify(body.extensions);
        }
        catch (parseError) {
            return { parseError };
        }
        addQueryParam("extensions", serializedExtensions);
    }
    // Reconstruct the URI with added query params.
    // XXX This assumes that the URI is well-formed and that it doesn't
    //     already contain any of these query params. We could instead use the
    //     URL API and take a polyfill (whatwg-url@6) for older browsers that
    //     don't support URLSearchParams. Note that some browsers (and
    //     versions of whatwg-url) support URL but not URLSearchParams!
    let fragment = "", preFragment = chosenURI;
    const fragmentStart = chosenURI.indexOf("#");
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    const queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
    const newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
    return { newURI };
}
//# sourceMappingURL=rewriteURIForGET.js.map
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/link/http/selectHttpOptionsAndBody.js
var selectHttpOptionsAndBody = __webpack_require__(28575);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/link/http/selectURI.js
var selectURI = __webpack_require__(1658);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/link/http/BaseHttpLink.js












const backupFetch = (0,maybe/* maybe */.w)(() => fetch);
function noop() { }
/**
 * `BaseHttpLink` is a terminating link that sends a GraphQL operation to a
 * remote endpoint over HTTP. It serves as a base link to `HttpLink`.
 *
 * @remarks
 *
 * `BaseHttpLink` supports both POST and GET requests, and you can configure
 * HTTP options on a per-operation basis. You can use these options for
 * authentication, persisted queries, dynamic URIs, and other granular updates.
 *
 * > [!NOTE]
 * > Prefer using `HttpLink` over `BaseHttpLink`. Use `BaseHttpLink` when you
 * > need to disable client awareness features and would like to tree-shake
 * > the implementation of `ClientAwarenessLink` out of your app bundle.
 *
 * @example
 *
 * ```ts
 * import { BaseHttpLink } from "@apollo/client/link/http";
 *
 * const link = new BaseHttpLink({
 *   uri: "http://localhost:4000/graphql",
 *   headers: {
 *     authorization: `Bearer ${token}`,
 *   },
 * });
 * ```
 */
class BaseHttpLink extends ApolloLink/* ApolloLink */.i {
    constructor(options = {}) {
        let { uri = "/graphql", 
        // use default global fetch if nothing passed in
        fetch: preferredFetch, print = selectHttpOptionsAndBody/* defaultPrinter */.sb, includeExtensions, preserveHeaderCase, useGETForQueries, includeUnusedVariables = false, ...requestOptions } = options;
        if (index_production/* __DEV__ */.T) {
            // Make sure at least one of preferredFetch, window.fetch, or backupFetch is
            // defined, so requests won't fail at runtime.
            (0,checkFetcher/* checkFetcher */.U)(preferredFetch || backupFetch);
        }
        const linkConfig = {
            http: (0,compact/* compact */.o)({ includeExtensions, preserveHeaderCase }),
            options: requestOptions.fetchOptions,
            credentials: requestOptions.credentials,
            headers: requestOptions.headers,
        };
        super((operation) => {
            let chosenURI = (0,selectURI/* selectURI */.r)(operation, uri);
            const context = operation.getContext();
            const http = { ...context.http };
            if (isSubscriptionOperation(operation.query)) {
                http.accept = [
                    "multipart/mixed;boundary=graphql;subscriptionSpec=1.0",
                    ...(http.accept || []),
                ];
            }
            const contextConfig = {
                http,
                options: context.fetchOptions,
                credentials: context.credentials,
                headers: context.headers,
            };
            //uses fallback, link, and then context to build options
            const { options, body } = (0,selectHttpOptionsAndBody/* selectHttpOptionsAndBodyInternal */.ve)(operation, print, selectHttpOptionsAndBody/* fallbackHttpConfig */.SC, linkConfig, contextConfig);
            if (body.variables && !includeUnusedVariables) {
                body.variables = (0,filterOperationVariables/* filterOperationVariables */.e)(body.variables, operation.query);
            }
            let controller = new AbortController();
            let cleanupController = () => {
                controller = undefined;
            };
            if (options.signal) {
                const externalSignal = options.signal;
                // in an ideal world we could use `AbortSignal.any` here, but
                // React Native uses https://github.com/mysticatea/abort-controller as
                // a polyfill for `AbortController`, and it does not support `AbortSignal.any`.
                const listener = () => {
                    controller?.abort(externalSignal.reason);
                };
                externalSignal.addEventListener("abort", listener, { once: true });
                cleanupController = () => {
                    controller?.signal.removeEventListener("abort", cleanupController);
                    controller = undefined;
                    // on cleanup, we need to stop listening to `options.signal` to avoid memory leaks
                    externalSignal.removeEventListener("abort", listener);
                    cleanupController = noop;
                };
                // react native also does not support the addEventListener `signal` option
                // so we have to simulate that ourself
                controller.signal.addEventListener("abort", cleanupController, {
                    once: true,
                });
            }
            options.signal = controller.signal;
            if (useGETForQueries && !isMutationOperation(operation.query)) {
                options.method = "GET";
            }
            return new Observable/* Observable */.y((observer) => {
                if (options.method === "GET") {
                    const { newURI, parseError } = rewriteURIForGET(chosenURI, body);
                    if (parseError) {
                        throw parseError;
                    }
                    chosenURI = newURI;
                }
                else {
                    options.body = JSON.stringify(body);
                }
                // Prefer linkOptions.fetch (preferredFetch) if provided, and otherwise
                // fall back to the *current* global window.fetch function (see issue
                // #7832), or (if all else fails) the backupFetch function we saved when
                // this module was first evaluated. This last option protects against the
                // removal of window.fetch, which is unlikely but not impossible.
                const currentFetch = preferredFetch || (0,maybe/* maybe */.w)(() => fetch) || backupFetch;
                const observerNext = observer.next.bind(observer);
                currentFetch(chosenURI, options)
                    .then((response) => {
                    operation.setContext({ response });
                    const ctype = response.headers?.get("content-type");
                    if (ctype !== null && /^multipart\/mixed/i.test(ctype)) {
                        return (0,parseAndCheckHttpResponse/* readMultipartBody */.T)(response, observerNext);
                    }
                    else {
                        return (0,parseAndCheckHttpResponse/* parseAndCheckHttpResponse */.d)(operation)(response).then(observerNext);
                    }
                })
                    .then(() => {
                    cleanupController();
                    observer.complete();
                })
                    .catch((err) => {
                    cleanupController();
                    observer.error(err);
                });
                return () => {
                    // XXX support canceling this request
                    // https://developers.google.com/web/updates/2017/09/abortable-fetch
                    if (controller)
                        controller.abort();
                };
            });
        });
    }
}
//# sourceMappingURL=BaseHttpLink.js.map
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/link/http/HttpLink.js



/**
 * `HttpLink` is a terminating link that sends a GraphQL operation to a remote
 * endpoint over HTTP. It combines the functionality of `BaseHttpLink` and
 * `ClientAwarenessLink` into a single link.
 *
 * @remarks
 *
 * `HttpLink` supports both POST and GET requests, and you can configure HTTP
 * options on a per-operation basis. You can use these options for
 * authentication, persisted queries, dynamic URIs, and other granular updates.
 *
 * @example
 *
 * ```ts
 * import { HttpLink } from "@apollo/client";
 *
 * const link = new HttpLink({
 *   uri: "http://localhost:4000/graphql",
 *   // Additional options
 * });
 * ```
 */
class HttpLink extends ApolloLink/* ApolloLink */.i {
    constructor(options = {}) {
        const { left, right, request } = ApolloLink/* ApolloLink,from */.i.from([
            new ClientAwarenessLink/* ClientAwarenessLink */.I(options),
            new BaseHttpLink(options),
        ]);
        super(request);
        Object.assign(this, { left, right });
    }
}
/**
 * @deprecated
 * Use `HttpLink` from `@apollo/client/link/http` instead.
 */
const createHttpLink = (options = {}) => new HttpLink(options);
//# sourceMappingURL=HttpLink.js.map
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/link/http/createSignalIfSupported.js
/**
 * @deprecated
 * This is not used internally any more and will be removed in
 * the next major version of Apollo Client.
 */
const createSignalIfSupported = () => {
    if (typeof AbortController === "undefined")
        return { controller: false, signal: false };
    const controller = new AbortController();
    const signal = controller.signal;
    return { controller, signal };
};
//# sourceMappingURL=createSignalIfSupported.js.map
// EXTERNAL MODULE: ../../app/node_modules/graphql-tag/lib/index.js + 12 modules
var graphql_tag_lib = __webpack_require__(28160);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/core/index.js
/* Core */





/* Link */



/* Supporting */
// The verbosity of invariant.{log,warn,error} can be controlled globally
// by passing "log", "warn", "error", or "silent" to setVerbosity ("log" is the default).
// Note that all invariant.* logging is hidden in production.

// Note that importing `gql` by itself, then destructuring
// additional properties separately before exporting, is intentional.
// Due to the way the `graphql-tag` library is setup, certain bundlers
// can't find the properties added to the exported `gql` function without
// additional guidance (e.g. Rollup - see
// https://rollupjs.org/guide/en/#error-name-is-not-exported-by-module).
// Instead of having people that are using bundlers with `@apollo/client` add
// extra bundler config to help `graphql-tag` exports be found (which would be
// awkward since they aren't importing `graphql-tag` themselves), this
// workaround of pulling the extra properties off the `gql` function,
// then re-exporting them separately, helps keeps bundlers happy without any
// additional config changes.


//# sourceMappingURL=index.js.map

}),
40361: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  b: () => (CombinedProtocolErrors)
});
/* ESM import */var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74730);

function defaultFormatMessage(errors) {
    return errors.map((e) => e.message || "Error message not found.").join("\n");
}
/**
 * Fatal transport-level errors returned when executing a subscription using the
 * multipart HTTP subscription protocol. See the documentation on the
 * [multipart HTTP protocol for GraphQL Subscriptions](https://www.apollographql.com/docs/graphos/routing/operations/subscriptions/multipart-protocol) for more information on these errors.
 *
 * @remarks
 *
 * These errors indicate issues with the subscription transport itself, rather
 * than GraphQL-level errors. They typically occur when there are problems
 * communicating with subgraphs from the Apollo Router.
 *
 * @example
 *
 * ```ts
 * import { CombinedProtocolErrors } from "@apollo/client/errors";
 *
 * // Check if an error is a CombinedProtocolErrors instance
 * if (CombinedProtocolErrors.is(error)) {
 *   // Access individual protocol errors
 *   error.errors.forEach((protocolError) => {
 *     console.log(protocolError.message);
 *     console.log(protocolError.extensions);
 *   });
 * }
 * ```
 */
class CombinedProtocolErrors extends Error {
    /**
     * A method that determines whether an error is a `CombinedProtocolErrors`
     * object. This method enables TypeScript to narrow the error type.
     *
     * @example
     *
     * ```ts
     * if (CombinedProtocolErrors.is(error)) {
     *   // TypeScript now knows `error` is a CombinedProtocolErrors object
     *   console.log(error.errors);
     * }
     * ```
     */
    static is(error) {
        return (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .isBranded */.I)(error, "CombinedProtocolErrors");
    }
    /**
    * A function that formats the error message used for the error's `message`
    * property. Override this method to provide your own formatting.
    * 
    * @remarks
    * 
    * The `formatMessage` function is called by the `CombinedProtocolErrors`
    * constructor to provide a formatted message as the `message` property of the
    * `CombinedProtocolErrors` object. Follow the ["Providing a custom message
    * formatter"](https://www.apollographql.com/docs/react/api/errors/CombinedProtocolErrors#providing-a-custom-message-formatter) guide to learn how to modify the message format.
    * 
    * @param errors - The array of GraphQL errors returned from the server in the
    * `errors` field of the response.
    * @param options - Additional context that could be useful when formatting
    * the message.
    */
    static formatMessage = defaultFormatMessage;
    /**
    * The raw list of errors returned by the top-level `errors` field in the
    * multipart HTTP subscription response.
    */
    errors;
    constructor(protocolErrors) {
        super(CombinedProtocolErrors.formatMessage(protocolErrors, {
            defaultFormatMessage,
        }));
        this.name = "CombinedProtocolErrors";
        this.errors = protocolErrors;
        (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .brand */.U)(this);
        Object.setPrototypeOf(this, CombinedProtocolErrors.prototype);
    }
}
//# sourceMappingURL=CombinedProtocolErrors.js.map


}),
41919: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  x: () => (LocalStateError)
});
/* ESM import */var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74730);

/**
 * Represents a fatal error when executing `@client` fields from `LocalState`,
 * typically to indicate a problem with the `LocalState` configuration or
 * incorrect usage of a resolver function. This error does not represent user
 * errors thrown in a local resolver when resolving `@client` fields.
 *
 * @example
 *
 * ```ts
 * import { LocalStateError } from "@apollo/client/errors";
 *
 * // Check if an error is a LocalStateError instance
 * if (LocalStateError.is(error)) {
 *   console.log("Original error:", error.cause);
 *
 *   // Determine which field caused the error
 *   if (error.path) {
 *     console.log("Error occurred at field path:", error.path.join("."));
 *   }
 * }
 * ```
 */
class LocalStateError extends Error {
    /**
     * A method that determines whether an error is a `LocalStateError`
     * object. This method enables TypeScript to narrow the error type.
     *
     * @example
     *
     * ```ts
     * if (LocalStateError.is(error)) {
     *   // TypeScript now knows `error` is a LocalStateError object
     *   console.log(error.path);
     * }
     * ```
     */
    static is(error) {
        return (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .isBranded */.I)(error, "LocalStateError");
    }
    /**
    * The path to the field that caused the error.
    */
    path;
    constructor(message, options = {}) {
        super(message, { cause: options.sourceError });
        this.name = "LocalStateError";
        this.path = options.path;
        (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .brand */.U)(this);
        Object.setPrototypeOf(this, LocalStateError.prototype);
    }
}
//# sourceMappingURL=LocalStateError.js.map


}),
77232: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  n: () => (ServerError)
});
/* ESM import */var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74730);

/**
 * Represents an error when a non-200 HTTP status code is returned from the
 * server according to the [GraphQL Over HTTP specification](https://graphql.github.io/graphql-over-http/draft/). This error
 * contains the full server response, including status code and body text.
 *
 * @remarks
 *
 * This error occurs when your GraphQL server responds with an HTTP status code
 * other than 200 (such as 4xx or 5xx status codes) with any media type other
 * than [`application/graphql-response+json`](https://graphql.github.io/graphql-over-http/draft/#sec-application-graphql-response-json).
 *
 * Servers that return non-200 status codes with other media types are not
 * guaranteed to contain a well-formed GraphQL response and may indicate issues
 * at the HTTP level, such as authentication failures, server unavailability,
 * or other HTTP-level problems.
 *
 * @example
 *
 * ```ts
 * import { ServerError } from "@apollo/client/errors";
 *
 * // Check if an error is a ServerError instance
 * if (ServerError.is(error)) {
 *   console.log(`Server returned status: ${error.statusCode}`);
 *   console.log(`Response body: ${error.bodyText}`);
 *
 *   // Handle specific status codes
 *   if (error.statusCode === 401) {
 *     // Handle unauthorized access
 *   }
 * }
 * ```
 */
class ServerError extends Error {
    /**
     * A method that determines whether an error is a `ServerError` object. This
     * method enables TypeScript to narrow the error type.
     *
     * @example
     *
     * ```ts
     * if (ServerError.is(error)) {
     *   // TypeScript now knows `error` is a ServerError object
     *   console.log(error.errors);
     * }
     * ```
     */
    static is(error) {
        return (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .isBranded */.I)(error, "ServerError");
    }
    /**
    * The raw [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response) object provided by the [Fetch API](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
    */
    response;
    /**
    * The status code returned by the server in the response. This is provided as
    * a shortcut for `response.status`.
    */
    statusCode;
    /**
    * The raw response body text.
    */
    bodyText;
    constructor(message, options) {
        super(message);
        this.name = "ServerError";
        this.response = options.response;
        this.statusCode = options.response.status;
        this.bodyText = options.bodyText;
        (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .brand */.U)(this);
        Object.setPrototypeOf(this, ServerError.prototype);
    }
}
//# sourceMappingURL=ServerError.js.map


}),
47312: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  x: () => (ServerParseError)
});
/* ESM import */var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74730);

/**
 * Represents a failure to parse the response as JSON from the server. This
 * error helps debug issues where the server returns malformed JSON or non-JSON
 * content.
 *
 * @remarks
 *
 * This error occurs when Apollo Client receives a response from the server but
 * cannot parse it as valid JSON. This typically happens when the server returns
 * HTML error pages, plain text responses, or malformed JSON instead of the
 * expected GraphQL JSON response format.
 *
 * @example
 *
 * ```ts
 * import { ServerParseError } from "@apollo/client/errors";
 *
 * // Check if an error is a ServerParseError instance
 * if (ServerParseError.is(error)) {
 *   console.log(`Failed to parse response from ${error.response.url}`);
 *   console.log(`Raw response: ${error.bodyText}`);
 *   console.log(`Status code: ${error.statusCode}`);
 *
 *   // Access the original parse error
 *   console.log(`Parse error: ${error.cause}`);
 * }
 * ```
 */
class ServerParseError extends Error {
    /**
     * A method that determines whether an error is a `ServerParseError`
     * object. This method enables TypeScript to narrow the error type.
     *
     * @example
     *
     * ```ts
     * if (ServerParseError.is(error)) {
     *   // TypeScript now knows `error` is a ServerParseError object
     *   console.log(error.statusCode);
     * }
     * ```
     */
    static is(error) {
        return (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .isBranded */.I)(error, "ServerParseError");
    }
    /**
    * The raw [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response) object provided by the [Fetch API](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
    */
    response;
    /**
    * The status code returned by the server in the response. This is provided
    * as a shortcut for `response.status`.
    */
    statusCode;
    /**
    * The raw response body text.
    */
    bodyText;
    constructor(originalParseError, options) {
        super(originalParseError instanceof Error ?
            originalParseError.message
            : "Could not parse server response", { cause: originalParseError });
        this.name = "ServerParseError";
        this.response = options.response;
        this.statusCode = options.response.status;
        this.bodyText = options.bodyText;
        (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .brand */.U)(this);
        Object.setPrototypeOf(this, ServerParseError.prototype);
    }
}
//# sourceMappingURL=ServerParseError.js.map


}),
85355: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  c: () => (UnconventionalError)
});
/* ESM import */var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74730);

/**
 * A wrapper error type that represents a non-standard error thrown from a
 * A wrapper error type that represents a non-error value thrown from the
 * link chain, such as a symbol, primitive or plain object. Read the `cause` property to
 * determine the source of the error.
 *
 * @remarks
 *
 * This error is used to standardize error handling when non-Error values are
 * thrown in the Apollo Client link chain or other parts of the system.
 * JavaScript allows throwing any value (not just Error instances), and this
 * wrapper ensures that all thrown values can be handled consistently as
 * Error-like objects while preserving the original thrown value.
 *
 * > [!NOTE]
 * > Plain strings thrown as errors are wrapped in regular [`Error`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error) objects instead of `UnconventionalError` objects since strings can be safely used as the error's `message`.
 *
 * @example
 *
 * ```ts
 * import { UnconventionalError } from "@apollo/client/errors";
 *
 * // Check if an error is an UnconventionalError instance
 * if (UnconventionalError.is(error)) {
 *   console.log("Non-standard error thrown:", error.cause);
 *
 *   // Check the type of the original thrown value
 *   if (typeof error.cause === "symbol") {
 *     console.log("A symbol was thrown:", error.cause.toString());
 *   } else if (typeof error.cause === "object") {
 *     console.log("An object was thrown:", error.cause);
 *   } else {
 *     console.log("Unexpected value thrown:", error.cause);
 *   }
 * }
 * ```
 */
class UnconventionalError extends Error {
    /**
     * A method that determines whether an error is an `UnconventionalError`
     * object. This method enables TypeScript to narrow the error type.
     *
     * @example
     *
     * ```ts
     * if (UnconventionalError.is(error)) {
     *   // TypeScript now knows `error` is a UnconventionalError object
     *   console.log("What caused this?", error.cause);
     * }
     * ```
     */
    static is(error) {
        return (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .isBranded */.I)(error, "UnconventionalError");
    }
    constructor(errorType) {
        super("An error of unexpected shape occurred.", { cause: errorType });
        this.name = "UnconventionalError";
        (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .brand */.U)(this);
        Object.setPrototypeOf(this, UnconventionalError.prototype);
    }
}
//# sourceMappingURL=UnconventionalError.js.map

}),
39291: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Nh: () => (/* binding */ toErrorLike),
  YG: () => (/* binding */ PROTOCOL_ERRORS_SYMBOL),
  ls: () => (/* binding */ graphQLResultHasProtocolErrors)
});

// UNUSED EXPORTS: registerLinkError, UnconventionalError, LinkError, CombinedGraphQLErrors, CombinedProtocolErrors, isErrorLike, LocalStateError, ServerError, ServerParseError

// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/errors/CombinedProtocolErrors.js
var CombinedProtocolErrors = __webpack_require__(40361);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/errors/isErrorLike.js
function isErrorLike(error) {
    return (error !== null &&
        typeof error === "object" &&
        typeof error.message === "string" &&
        typeof error.name === "string" &&
        (typeof error.stack === "string" ||
            typeof error.stack === "undefined"));
}
//# sourceMappingURL=isErrorLike.js.map
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/errors/UnconventionalError.js
var UnconventionalError = __webpack_require__(85355);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/errors/index.js



// This Symbol allows us to pass transport-specific errors from the link chain
// into QueryManager/client internals without risking a naming collision within
// extensions (which implementers can use as they see fit).
const PROTOCOL_ERRORS_SYMBOL = Symbol();
function graphQLResultHasProtocolErrors(result) {
    if ("extensions" in result) {
        return CombinedProtocolErrors/* CombinedProtocolErrors,is */.b.is(result.extensions[PROTOCOL_ERRORS_SYMBOL]);
    }
    return false;
}
function toErrorLike(error) {
    if (isErrorLike(error)) {
        return error;
    }
    if (typeof error === "string") {
        return new Error(error, { cause: error });
    }
    return new UnconventionalError/* UnconventionalError */.c(error);
}








//# sourceMappingURL=index.js.map

}),
74730: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  I: () => (isBranded),
  U: () => (brand)
});
function isBranded(error, name) {
    return (typeof error === "object" &&
        error !== null &&
        error[Symbol.for("apollo.error")] === name);
}
function brand(error) {
    Object.defineProperty(error, Symbol.for("apollo.error"), {
        value: error.name,
        enumerable: false,
        writable: false,
        configurable: false,
    });
}
//# sourceMappingURL=utils.js.map

}),
16882: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  BaseBatchHttpLink: () => (/* reexport */ BaseBatchHttpLink),
  BatchHttpLink: () => (/* reexport */ BatchHttpLink)
});

// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/observable/throwError.js
var throwError = __webpack_require__(82693);
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/Observable.js + 1 modules
var Observable = __webpack_require__(87252);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/link/core/ApolloLink.js + 1 modules
var ApolloLink = __webpack_require__(44265);
// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/observable/empty.js
var empty = __webpack_require__(21287);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/link/batch/batching.js

// QueryBatcher doesn't fire requests immediately. Requests that were enqueued within
// a certain amount of time (configurable through `batchInterval`) will be batched together
// into one query.
class OperationBatcher {
    // Queue on which the QueryBatcher will operate on a per-tick basis.
    batchesByKey = new Map();
    scheduledBatchTimerByKey = new Map();
    batchDebounce;
    batchInterval;
    batchMax;
    //This function is called to the queries in the queue to the server.
    batchHandler;
    batchKey;
    constructor({ batchDebounce, batchInterval, batchMax, batchHandler, batchKey, }) {
        this.batchDebounce = batchDebounce;
        this.batchInterval = batchInterval;
        this.batchMax = batchMax || 0;
        this.batchHandler = batchHandler;
        this.batchKey = batchKey || (() => "");
    }
    enqueueRequest(request) {
        const requestCopy = {
            ...request,
            next: [],
            error: [],
            complete: [],
            subscribers: new Set(),
        };
        const key = this.batchKey(request.operation);
        if (!requestCopy.observable) {
            requestCopy.observable = new Observable/* Observable */.y((observer) => {
                let batch = this.batchesByKey.get(key);
                if (!batch)
                    this.batchesByKey.set(key, (batch = new Set()));
                // These booleans seem to me (@benjamn) like they might always be the
                // same (and thus we could do with only one of them), but I'm not 100%
                // sure about that.
                const isFirstEnqueuedRequest = batch.size === 0;
                const isFirstSubscriber = requestCopy.subscribers.size === 0;
                requestCopy.subscribers.add(observer);
                if (isFirstSubscriber) {
                    batch.add(requestCopy);
                }
                // called for each subscriber, so need to save all listeners (next, error, complete)
                if (observer.next) {
                    requestCopy.next.push(observer.next.bind(observer));
                }
                if (observer.error) {
                    requestCopy.error.push(observer.error.bind(observer));
                }
                if (observer.complete) {
                    requestCopy.complete.push(observer.complete.bind(observer));
                }
                // The first enqueued request triggers the queue consumption after `batchInterval` milliseconds.
                if (isFirstEnqueuedRequest || this.batchDebounce) {
                    this.scheduleQueueConsumption(key);
                }
                // When amount of requests reaches `batchMax`, trigger the queue consumption without waiting on the `batchInterval`.
                if (batch.size === this.batchMax) {
                    this.consumeQueue(key);
                }
                return () => {
                    // If this is last subscriber for this request, remove request from queue
                    if (requestCopy.subscribers.delete(observer) &&
                        requestCopy.subscribers.size < 1) {
                        // If this is last request from queue, remove queue entirely
                        if (batch.delete(requestCopy) && batch.size < 1) {
                            this.consumeQueue(key);
                            // If queue was in flight, cancel it
                            batch.subscription?.unsubscribe();
                        }
                    }
                };
            });
        }
        return requestCopy.observable;
    }
    // Consumes the queue.
    // Returns a list of promises (one for each query).
    consumeQueue(key = "") {
        const batch = this.batchesByKey.get(key);
        // Delete this batch and process it below.
        this.batchesByKey.delete(key);
        if (!batch || !batch.size) {
            // No requests to be processed.
            return;
        }
        const operations = [];
        const forwards = [];
        const observables = [];
        const nexts = [];
        const errors = [];
        const completes = [];
        // Even though batch is a Set, it preserves the order of first insertion
        // when iterating (per ECMAScript specification), so these requests will be
        // handled in the order they were enqueued (minus any deleted ones).
        batch.forEach((request) => {
            operations.push(request.operation);
            forwards.push(request.forward);
            observables.push(request.observable);
            nexts.push(request.next);
            errors.push(request.error);
            completes.push(request.complete);
        });
        const batchedObservable = this.batchHandler(operations, forwards);
        const onError = (error) => {
            //each callback list in batch
            errors.forEach((rejecters) => {
                if (rejecters) {
                    //each subscriber to request
                    rejecters.forEach((e) => e(error));
                }
            });
        };
        batch.subscription = batchedObservable.subscribe({
            next: (results) => {
                if (!Array.isArray(results)) {
                    results = [results];
                }
                if (nexts.length !== results.length) {
                    const error = new Error(`server returned results with length ${results.length}, expected length of ${nexts.length}`);
                    error.result = results;
                    return onError(error);
                }
                results.forEach((result, index) => {
                    if (nexts[index]) {
                        nexts[index].forEach((next) => next(result));
                    }
                });
            },
            error: onError,
            complete: () => {
                completes.forEach((complete) => {
                    if (complete) {
                        //each subscriber to request
                        complete.forEach((c) => c());
                    }
                });
            },
        });
        return observables;
    }
    scheduleQueueConsumption(key) {
        clearTimeout(this.scheduledBatchTimerByKey.get(key));
        this.scheduledBatchTimerByKey.set(key, setTimeout(() => {
            this.consumeQueue(key);
            this.scheduledBatchTimerByKey.delete(key);
        }, this.batchInterval));
    }
}
//# sourceMappingURL=batching.js.map
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/link/batch/batchLink.js



/**
 * `BatchLink` is a non-terminating link that provides the core batching
 * functionality for grouping multiple GraphQL operations into batches based
 * on configurable timing and key-based grouping strategies. It serves as a base
 * link to `BatchHttpLink`.
 *
 * @remarks
 *
 * > [!NOTE]
 * > You will not generally use `BatchLink` on your own unless you need to
 * > provide batching capabilities to third-party terminating links. Prefer
 * > using `BatchHttpLink` to batch GraphQL operations over HTTP.
 *
 * @example
 *
 * ```ts
 * import { BatchLink } from "@apollo/client/link/batch";
 *
 * const link = new BatchLink({
 *   batchInterval: 20,
 *   batchMax: 5,
 *   batchHandler: (operations, forwards) => {
 *     // Custom logic to process batch of operations
 *     return handleBatch(operations, forwards);
 *   },
 * });
 * ```
 */
class BatchLink extends ApolloLink/* ApolloLink */.i {
    batcher;
    constructor(options) {
        super();
        const { batchDebounce, batchInterval = 10, batchMax = 0, batchHandler = () => empty/* EMPTY */.E, batchKey = () => "", } = options || {};
        this.batcher = new OperationBatcher({
            batchDebounce,
            batchInterval,
            batchMax,
            batchHandler,
            batchKey,
        });
    }
    request(operation, forward) {
        return this.batcher.enqueueRequest({ operation, forward });
    }
}
//# sourceMappingURL=batchLink.js.map
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/link/http/selectHttpOptionsAndBody.js
var selectHttpOptionsAndBody = __webpack_require__(28575);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/link/http/checkFetcher.js
var checkFetcher = __webpack_require__(7037);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/link/http/selectURI.js
var selectURI = __webpack_require__(1658);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/link/http/parseAndCheckHttpResponse.js
var parseAndCheckHttpResponse = __webpack_require__(97819);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/link/utils/filterOperationVariables.js
var filterOperationVariables = __webpack_require__(64437);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/environment/index.production.js
var index_production = __webpack_require__(64744);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/compact.js
var compact = __webpack_require__(94169);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/globals/maybe.js
var maybe = __webpack_require__(33089);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/link/batch-http/BaseBatchHttpLink.js








const backupFetch = (0,maybe/* maybe */.w)(() => fetch);
/**
 * `BaseBatchHttpLink` is a terminating link that batches array of individual
 * GraphQL operations into a single HTTP request that's sent to a single GraphQL
 * endpoint. It serves as a base link to `BatchHttpLink`.
 *
 * @remarks
 *
 * > [!NOTE]
 * > Prefer using `BatchHttpLink` over `BaseBatchHttpLink`. Use
 * > `BaseBatchHttpLink` when you need to disable client awareness features and
 * > would like to tree-shake the implementation of `ClientAwarenessLink` out
 * > of your app bundle.
 *
 * @example
 *
 * ```ts
 * import { BaseBatchHttpLink } from "@apollo/client/link/batch-http";
 *
 * const link = new BaseBatchHttpLink({
 *   uri: "http://localhost:4000/graphql",
 *   batchMax: 5, // No more than 5 operations per batch
 *   batchInterval: 20, // Wait no more than 20ms after first batched operation
 * });
 * ```
 */
class BaseBatchHttpLink extends ApolloLink/* ApolloLink */.i {
    batchDebounce;
    batchInterval;
    batchMax;
    batcher;
    constructor(options = {}) {
        super();
        let { uri = "/graphql", 
        // use default global fetch if nothing is passed in
        fetch: preferredFetch, print = selectHttpOptionsAndBody/* defaultPrinter */.sb, includeExtensions, preserveHeaderCase, batchInterval, batchDebounce, batchMax, batchKey, includeUnusedVariables = false, ...requestOptions } = options;
        if (index_production/* __DEV__ */.T) {
            // Make sure at least one of preferredFetch, window.fetch, or backupFetch
            // is defined, so requests won't fail at runtime.
            (0,checkFetcher/* checkFetcher */.U)(preferredFetch || backupFetch);
        }
        const linkConfig = {
            http: (0,compact/* compact */.o)({ includeExtensions, preserveHeaderCase }),
            options: requestOptions.fetchOptions,
            credentials: requestOptions.credentials,
            headers: requestOptions.headers,
        };
        this.batchDebounce = batchDebounce;
        this.batchInterval = batchInterval || 10;
        this.batchMax = batchMax || 10;
        const batchHandler = (operations) => {
            const chosenURI = (0,selectURI/* selectURI */.r)(operations[0], uri);
            const context = operations[0].getContext();
            const contextConfig = {
                http: context.http,
                options: context.fetchOptions,
                credentials: context.credentials,
                headers: context.headers,
            };
            //uses fallback, link, and then context to build options
            const optsAndBody = operations.map((operation) => {
                const result = (0,selectHttpOptionsAndBody/* selectHttpOptionsAndBodyInternal */.ve)(operation, print, selectHttpOptionsAndBody/* fallbackHttpConfig */.SC, linkConfig, contextConfig);
                if (result.body.variables && !includeUnusedVariables) {
                    result.body.variables = (0,filterOperationVariables/* filterOperationVariables */.e)(result.body.variables, operation.query);
                }
                return result;
            });
            const loadedBody = optsAndBody.map(({ body }) => body);
            const options = optsAndBody[0].options;
            // There's no spec for using GET with batches.
            if (options.method === "GET") {
                return (0,throwError/* throwError */._)(() => new Error("apollo-link-batch-http does not support GET requests"));
            }
            try {
                options.body = JSON.stringify(loadedBody);
            }
            catch (parseError) {
                return (0,throwError/* throwError */._)(() => parseError);
            }
            let controller;
            if (!options.signal && typeof AbortController !== "undefined") {
                controller = new AbortController();
                options.signal = controller.signal;
            }
            return new Observable/* Observable */.y((observer) => {
                // Prefer BatchHttpLink.Options.fetch (preferredFetch) if provided, and
                // otherwise fall back to the *current* global window.fetch function
                // (see issue #7832), or (if all else fails) the backupFetch function we
                // saved when this module was first evaluated. This last option protects
                // against the removal of window.fetch, which is unlikely but not
                // impossible.
                const currentFetch = preferredFetch || (0,maybe/* maybe */.w)(() => fetch) || backupFetch;
                currentFetch(chosenURI, options)
                    .then((response) => {
                    // Make the raw response available in the context.
                    operations.forEach((operation) => operation.setContext({ response }));
                    return response;
                })
                    .then((0,parseAndCheckHttpResponse/* parseAndCheckHttpResponse */.d)(operations))
                    .then((result) => {
                    controller = undefined;
                    // we have data and can send it to back up the link chain
                    observer.next(result);
                    observer.complete();
                    return result;
                })
                    .catch((err) => {
                    controller = undefined;
                    observer.error(err);
                });
                return () => {
                    // XXX support canceling this request
                    // https://developers.google.com/web/updates/2017/09/abortable-fetch
                    if (controller)
                        controller.abort();
                };
            });
        };
        batchKey =
            batchKey ||
                ((operation) => {
                    const context = operation.getContext();
                    const contextConfig = {
                        http: context.http,
                        options: context.fetchOptions,
                        credentials: context.credentials,
                        headers: context.headers,
                    };
                    //may throw error if config not serializable
                    return (0,selectURI/* selectURI */.r)(operation, uri) + JSON.stringify(contextConfig);
                });
        this.batcher = new BatchLink({
            batchDebounce: this.batchDebounce,
            batchInterval: this.batchInterval,
            batchMax: this.batchMax,
            batchKey,
            batchHandler,
        });
    }
    request(operation, forward) {
        return this.batcher.request(operation, forward);
    }
}
//# sourceMappingURL=BaseBatchHttpLink.js.map
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/link/client-awareness/ClientAwarenessLink.js
var ClientAwarenessLink = __webpack_require__(78568);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/link/batch-http/batchHttpLink.js



/**
 * `BatchHttpLink` is a terminating link that batches array of individual
 * GraphQL operations into a single HTTP request that's sent to a single GraphQL
 * endpoint. It combines the functionality of `BaseBatchHttpLink` and
 * `ClientAwarenessLink` into a single link.
 *
 * @remarks
 *
 * If you use `BatchHttpLink` instead of `HttpLink` as your terminating link,
 * Apollo Client automatically batches executed GraphQL operations and transmits
 * them to your server according to the batching options you provide.
 *
 * @example
 *
 * ```ts
 * import { BatchHttpLink } from "@apollo/client/link/batch-http";
 *
 * const link = new BatchHttpLink({
 *   uri: "http://localhost:4000/graphql",
 *   batchMax: 5, // No more than 5 operations per batch
 *   batchInterval: 20, // Wait no more than 20ms after first batched operation
 * });
 * ```
 */
class BatchHttpLink extends ApolloLink/* ApolloLink */.i {
    constructor(options = {}) {
        const { left, right, request } = ApolloLink/* ApolloLink,from */.i.from([
            new ClientAwarenessLink/* ClientAwarenessLink */.I(options),
            new BaseBatchHttpLink(options),
        ]);
        super(request);
        Object.assign(this, { left, right });
    }
}
//# sourceMappingURL=batchHttpLink.js.map
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/link/batch-http/index.js


//# sourceMappingURL=index.js.map

}),
78568: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  I: () => (ClientAwarenessLink)
});
/* ESM import */var _apollo_client_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44265);
/* ESM import */var _apollo_client_utilities_internal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94169);


/**
 * `ClientAwarenessLink` provides support for providing client awareness
 * features.
 *
 * @remarks
 *
 * Client awareness adds identifying information about the client to HTTP
 * requests for use with metrics reporting tools, such as [Apollo GraphOS](https://apollographql.com/docs/graphos/platform).
 * It is included in the functionality of [`HttpLink`](https://apollographql.com/docs/react/api/link/apollo-link-http) by default.
 *
 * Client awareness distinguishes between user-provided client awareness
 * (provided by the `clientAwareness` option) and enhanced client awareness
 * (provided by the `enhancedClientAwareness` option). User-provided client
 * awareness enables you to set a customized client name and version for
 * identification in metrics reporting tools. Enhanced client awareness enables
 * the identification of the Apollo Client package name and version.
 *
 * @example
 *
 * ```ts
 * import { ClientAwarenessLink } from "@apollo/client/link/client-awareness";
 *
 * const link = new ClientAwarenessLink({
 *   clientAwareness: {
 *     name: "My Client",
 *     version: "1",
 *   },
 *   enhancedClientAwareness: {
 *     transport: "extensions",
 *   },
 * });
 * ```
 */
class ClientAwarenessLink extends _apollo_client_link__WEBPACK_IMPORTED_MODULE_0__/* .ApolloLink */.i {
    constructor(options = {}) {
        super((operation, forward) => {
            const client = operation.client;
            const clientOptions = client["queryManager"].clientOptions;
            const context = operation.getContext();
            {
                const { name, version, transport = "headers", } = (0,_apollo_client_utilities_internal__WEBPACK_IMPORTED_MODULE_1__/* .compact */.o)({}, clientOptions.clientAwareness, options.clientAwareness, context.clientAwareness);
                if (transport === "headers") {
                    operation.setContext(({ headers, extensions }) => {
                        return {
                            headers: (0,_apollo_client_utilities_internal__WEBPACK_IMPORTED_MODULE_1__/* .compact */.o)(
                            // setting these first so that they can be overridden by user-provided headers
                            {
                                "apollographql-client-name": name,
                                "apollographql-client-version": version,
                            }, headers),
                        };
                    });
                }
            }
            {
                const { transport = "extensions" } = (0,_apollo_client_utilities_internal__WEBPACK_IMPORTED_MODULE_1__/* .compact */.o)({}, clientOptions.enhancedClientAwareness, options.enhancedClientAwareness);
                if (transport === "extensions") {
                    operation.extensions = (0,_apollo_client_utilities_internal__WEBPACK_IMPORTED_MODULE_1__/* .compact */.o)(
                    // setting these first so that it can be overridden by user-provided extensions
                    {
                        clientLibrary: {
                            name: "@apollo/client",
                            version: client.version,
                        },
                    }, operation.extensions);
                }
            }
            return forward(operation);
        });
    }
}
//# sourceMappingURL=ClientAwarenessLink.js.map

}),
44265: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  i: () => (/* binding */ ApolloLink)
});

// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/observable/empty.js
var empty = __webpack_require__(21287);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/getOperationName.js
var getOperationName = __webpack_require__(26802);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/getOperationDefinition.js
var getOperationDefinition = __webpack_require__(76260);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/link/utils/createOperation.js

function createOperation(request, { client }) {
    const operation = {
        query: request.query,
        variables: request.variables || {},
        extensions: request.extensions || {},
        operationName: (0,getOperationName/* getOperationName */.r)(request.query),
        operationType: (0,getOperationDefinition/* getOperationDefinition */.$)(request.query).operation,
    };
    let context = { ...request.context };
    const setContext = (next) => {
        if (typeof next === "function") {
            context = { ...context, ...next(getContext()) };
        }
        else {
            context = { ...context, ...next };
        }
    };
    const getContext = () => Object.freeze({ ...context });
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext,
    });
    Object.defineProperty(operation, "client", {
        enumerable: false,
        value: client,
    });
    return operation;
}
//# sourceMappingURL=createOperation.js.map
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/environment/index.production.js
var index_production = __webpack_require__(64744);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/invariant/index.js
var invariant = __webpack_require__(85401);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/link/core/ApolloLink.js




/**
 * The base class for all links in Apollo Client. A link represents either a
 * self-contained modification to a GraphQL operation or a side effect (such as
 * logging).
 *
 * @remarks
 *
 * Links enable you to customize Apollo Client's request flow by composing
 * together different pieces of functionality into a chain of links. Each
 * link represents a specific capability, such as adding authentication headers,
 * retrying failed requests, batching operations, or sending requests to a
 * GraphQL server.
 *
 * Every link must define a request handler via its constructor or by extending
 * this class and implementing the `request` method.
 *
 * @example
 *
 * ```ts
 * import { ApolloLink } from "@apollo/client";
 *
 * const link = new ApolloLink((operation, forward) => {
 *   console.log("Operation:", operation.operationName);
 *   return forward(operation);
 * });
 * ```
 */
class ApolloLink {
    /**
     * Creates a link that completes immediately and does not emit a result.
     *
     * @example
     *
     * ```ts
     * const link = ApolloLink.empty();
     * ```
     */
    static empty() {
        return new ApolloLink(() => empty/* EMPTY */.E);
    }
    /**
     * Composes multiple links into a single composed link that executes each
     * provided link in serial order.
     *
     * @example
     *
     * ```ts
     * import { from, HttpLink, ApolloLink } from "@apollo/client";
     * import { RetryLink } from "@apollo/client/link/retry";
     * import MyAuthLink from "../auth";
     *
     * const link = ApolloLink.from([
     *   new RetryLink(),
     *   new MyAuthLink(),
     *   new HttpLink({ uri: "http://localhost:4000/graphql" }),
     * ]);
     * ```
     *
     * @param links - An array of `ApolloLink` instances or request handlers that
     * are executed in serial order.
     */
    static from(links) {
        if (links.length === 0)
            return ApolloLink.empty();
        const [first, ...rest] = links;
        return first.concat(...rest);
    }
    /**
     * Creates a link that conditionally routes a request to different links.
     *
     * @example
     *
     * ```ts
     * import { ApolloLink, HttpLink } from "@apollo/client";
     *
     * const link = ApolloLink.split(
     *   (operation) => operation.getContext().version === 1,
     *   new HttpLink({ uri: "http://localhost:4000/v1/graphql" }),
     *   new HttpLink({ uri: "http://localhost:4000/v2/graphql" })
     * );
     * ```
     *
     * @param test - A predicate function that receives the current `operation`
     * and returns a boolean indicating which link to execute. Returning `true`
     * executes the `left` link. Returning `false` executes the `right` link.
     *
     * @param left - The link that executes when the `test` function returns
     * `true`.
     *
     * @param right - The link that executes when the `test` function returns
     * `false`. If the `right` link is not provided, the request is forwarded to
     * the next link in the chain.
     */
    static split(test, left, right = new ApolloLink((op, forward) => forward(op))) {
        const link = new ApolloLink((operation, forward) => {
            const result = test(operation);
            if (index_production/* __DEV__ */.T) {
                if (typeof result !== "boolean") {
                    index_production/* __DEV__ */.T && invariant/* invariant,warn */.kG.warn(61, result);
                }
            }
            return result ?
                left.request(operation, forward)
                : right.request(operation, forward);
        });
        return Object.assign(link, { left, right });
    }
    /**
     * Executes a GraphQL request against a link. The `execute` function begins
     * the request by calling the request handler of the link.
     *
     * @example
     *
     * ```ts
     * const observable = ApolloLink.execute(link, { query, variables }, { client });
     *
     * observable.subscribe({
     *   next(value) {
     *     console.log("Received", value);
     *   },
     *   error(error) {
     *     console.error("Oops got error", error);
     *   },
     *   complete() {
     *     console.log("Request complete");
     *   },
     * });
     * ```
     *
     * @param link - The `ApolloLink` instance to execute the request.
     *
     * @param request - The GraphQL request details, such as the `query` and
     * `variables`.
     *
     * @param context - The execution context for the request, such as the
     * `client` making the request.
     */
    static execute(link, request, context) {
        return link.request(createOperation(request, context), () => {
            if (index_production/* __DEV__ */.T) {
                index_production/* __DEV__ */.T && invariant/* invariant,warn */.kG.warn(62);
            }
            return empty/* EMPTY */.E;
        });
    }
    /**
     * Combines multiple links into a single composed link.
     *
     * @example
     *
     * ```ts
     * const link = ApolloLink.concat(firstLink, secondLink, thirdLink);
     * ```
     *
     * @param links - The links to concatenate into a single link. Each link will
     * execute in serial order.
     *
     * @deprecated Use `ApolloLink.from` instead. `ApolloLink.concat` will be
     * removed in a future major version.
     */
    static concat(...links) {
        return ApolloLink.from(links);
    }
    constructor(request) {
        if (request)
            this.request = request;
    }
    /**
     * Concatenates a link that conditionally routes a request to different links.
     *
     * @example
     *
     * ```ts
     * import { ApolloLink, HttpLink } from "@apollo/client";
     *
     * const previousLink = new ApolloLink((operation, forward) => {
     *   // Handle the request
     *
     *   return forward(operation);
     * });
     *
     * const link = previousLink.split(
     *   (operation) => operation.getContext().version === 1,
     *   new HttpLink({ uri: "http://localhost:4000/v1/graphql" }),
     *   new HttpLink({ uri: "http://localhost:4000/v2/graphql" })
     * );
     * ```
     *
     * @param test - A predicate function that receives the current `operation`
     * and returns a boolean indicating which link to execute. Returning `true`
     * executes the `left` link. Returning `false` executes the `right` link.
     *
     * @param left - The link that executes when the `test` function returns
     * `true`.
     *
     * @param right - The link that executes when the `test` function returns
     * `false`. If the `right` link is not provided, the request is forwarded to
     * the next link in the chain.
     */
    split(test, left, right) {
        return this.concat(ApolloLink.split(test, left, right));
    }
    /**
     * Combines the link with other links into a single composed link.
     *
     * @example
     *
     * ```ts
     * import { ApolloLink, HttpLink } from "@apollo/client";
     *
     * const previousLink = new ApolloLink((operation, forward) => {
     *   // Handle the request
     *
     *   return forward(operation);
     * });
     *
     * const link = previousLink.concat(
     *   link1,
     *   link2,
     *   new HttpLink({ uri: "http://localhost:4000/graphql" })
     * );
     * ```
     */
    concat(...links) {
        if (links.length === 0) {
            return this;
        }
        return links.reduce(this.combine.bind(this), this);
    }
    combine(left, right) {
        const link = new ApolloLink((operation, forward) => {
            return left.request(operation, (op) => right.request(op, forward));
        });
        return Object.assign(link, { left, right });
    }
    /**
     * Runs the request handler for the provided operation.
     *
     * > [!NOTE]
     * > This is called by the `ApolloLink.execute` function for you and should
     * > not be called directly. Prefer using `ApolloLink.execute` to make the
     * > request instead.
     */
    request(operation, forward) {
        throw (0,invariant/* newInvariantError */._K)(63);
    }
    /**
    * @internal
    * Used to iterate through all links that are concatenations or `split` links.
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */
    left;
    /**
    * @internal
    * Used to iterate through all links that are concatenations or `split` links.
    * 
    * @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
    */
    right;
}
//# sourceMappingURL=ApolloLink.js.map


}),
7037: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  U: () => (checkFetcher)
});
/* ESM import */var _apollo_client_utilities_invariant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85401);

const checkFetcher = (fetcher) => {
    (0,_apollo_client_utilities_invariant__WEBPACK_IMPORTED_MODULE_0__/* .invariant */.kG)(fetcher || typeof fetch !== "undefined", 59);
};
//# sourceMappingURL=checkFetcher.js.map


}),
97819: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  T: () => (readMultipartBody),
  d: () => (parseAndCheckHttpResponse)
});
/* ESM import */var _apollo_client_errors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39291);
/* ESM import */var _apollo_client_errors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40361);
/* ESM import */var _apollo_client_errors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77232);
/* ESM import */var _apollo_client_errors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47312);
/* ESM import */var _apollo_client_utilities_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46145);
/* ESM import */var _apollo_client_utilities_invariant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85401);



const { hasOwnProperty } = Object.prototype;
/**
 * This function detects an Apollo payload result before it is transformed
 * into a FetchResult via HttpLink; it cannot detect an ApolloPayloadResult
 * once it leaves the link chain.
 */
function isApolloPayloadResult(value) {
    return (0,_apollo_client_utilities_internal__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */.s)(value) && "payload" in value;
}
async function* consumeMultipartBody(response) {
    const decoder = new TextDecoder("utf-8");
    const contentType = response.headers?.get("content-type");
    // parse boundary value and ignore any subsequent name/value pairs after ;
    // https://www.rfc-editor.org/rfc/rfc9110.html#name-parameters
    // e.g. multipart/mixed;boundary="graphql";deferSpec=20220824
    // if no boundary is specified, default to -
    const match = contentType?.match(
    /*
      ;\s*boundary=                # Match the boundary parameter
      (?:                          # either
        '([^']*)'                  # a string starting with ' doesn't contain ', ends with '
        |                          # or
        "([^"]*)"                  # a string starting with " doesn't contain ", ends with "
        |                          # or
        ([^"'].*?)                 # a string that doesn't start with ' or ", parsed non-greedily
        )                          # end of the group
      \s*                          # optional whitespace
      (?:;|$)                        # match a semicolon or end of string
    */
    /;\s*boundary=(?:'([^']+)'|"([^"]+)"|([^"'].+?))\s*(?:;|$)/i);
    const boundary = "\r\n--" + (match?.findLast((val) => !!val) || "-");
    let buffer = "";
    (0,_apollo_client_utilities_invariant__WEBPACK_IMPORTED_MODULE_1__/* .invariant */.kG)(response.body && typeof response.body.getReader === "function", 60);
    const stream = response.body;
    const reader = stream.getReader();
    let done = false;
    let encounteredBoundary = false;
    let value;
    // check to see if we received the final boundary, which is a normal boundary followed by "--"
    // as described in https://www.rfc-editor.org/rfc/rfc2046#section-5.1.1
    const passedFinalBoundary = () => encounteredBoundary && buffer[0] == "-" && buffer[1] == "-";
    try {
        while (!done) {
            ({ value, done } = await reader.read());
            const chunk = typeof value === "string" ? value : decoder.decode(value);
            const searchFrom = buffer.length - boundary.length + 1;
            buffer += chunk;
            let bi = buffer.indexOf(boundary, searchFrom);
            while (bi > -1 && !passedFinalBoundary()) {
                encounteredBoundary = true;
                let message;
                [message, buffer] = [
                    buffer.slice(0, bi),
                    buffer.slice(bi + boundary.length),
                ];
                const i = message.indexOf("\r\n\r\n");
                const headers = parseHeaders(message.slice(0, i));
                const contentType = headers["content-type"];
                if (contentType &&
                    contentType.toLowerCase().indexOf("application/json") === -1) {
                    throw new Error("Unsupported patch content type: application/json is required.");
                }
                // nb: Technically you'd want to slice off the beginning "\r\n" but since
                // this is going to be `JSON.parse`d there is no need.
                const body = message.slice(i);
                if (body) {
                    yield body;
                }
                bi = buffer.indexOf(boundary);
            }
            if (passedFinalBoundary()) {
                return;
            }
        }
        throw new Error("premature end of multipart body");
    }
    finally {
        reader.cancel();
    }
}
async function readMultipartBody(response, nextValue) {
    for await (const body of consumeMultipartBody(response)) {
        const result = parseJsonEncoding(response, body);
        if (Object.keys(result).length == 0)
            continue;
        if (isApolloPayloadResult(result)) {
            if (Object.keys(result).length === 1 && result.payload === null) {
                return;
            }
            let next = { ...result.payload };
            if ("errors" in result) {
                next.extensions = {
                    ...next.extensions,
                    [_apollo_client_errors__WEBPACK_IMPORTED_MODULE_2__/* .PROTOCOL_ERRORS_SYMBOL */.YG]: new _apollo_client_errors__WEBPACK_IMPORTED_MODULE_3__/* .CombinedProtocolErrors */.b(result.errors ?? []),
                };
            }
            nextValue(next);
        }
        else {
            nextValue(result);
        }
    }
}
function parseHeaders(headerText) {
    const headersInit = {};
    headerText.split("\n").forEach((line) => {
        const i = line.indexOf(":");
        if (i > -1) {
            // normalize headers to lowercase
            const name = line.slice(0, i).trim().toLowerCase();
            const value = line.slice(i + 1).trim();
            headersInit[name] = value;
        }
    });
    return headersInit;
}
function parseJsonEncoding(response, bodyText) {
    if (response.status >= 300) {
        throw new _apollo_client_errors__WEBPACK_IMPORTED_MODULE_4__/* .ServerError */.n(`Response not successful: Received status code ${response.status}`, { response, bodyText });
    }
    try {
        return JSON.parse(bodyText);
    }
    catch (err) {
        throw new _apollo_client_errors__WEBPACK_IMPORTED_MODULE_5__/* .ServerParseError */.x(err, { response, bodyText });
    }
}
function parseGraphQLResponseJsonEncoding(response, bodyText) {
    try {
        return JSON.parse(bodyText);
    }
    catch (err) {
        throw new _apollo_client_errors__WEBPACK_IMPORTED_MODULE_5__/* .ServerParseError */.x(err, { response, bodyText });
    }
}
function parseResponse(response, bodyText) {
    const contentType = response.headers.get("content-type");
    if (contentType?.includes("application/graphql-response+json")) {
        return parseGraphQLResponseJsonEncoding(response, bodyText);
    }
    return parseJsonEncoding(response, bodyText);
}
function parseAndCheckHttpResponse(operations) {
    return (response) => response.text().then((bodyText) => {
        const result = parseResponse(response, bodyText);
        if (!Array.isArray(result) &&
            !hasOwnProperty.call(result, "data") &&
            !hasOwnProperty.call(result, "errors")) {
            throw new _apollo_client_errors__WEBPACK_IMPORTED_MODULE_4__/* .ServerError */.n(`Server response was malformed for query '${Array.isArray(operations) ?
                operations.map((op) => op.operationName)
                : operations.operationName}'.`, { response, bodyText });
        }
        return result;
    });
}
//# sourceMappingURL=parseAndCheckHttpResponse.js.map


}),
28575: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  E4: () => (selectHttpOptionsAndBody),
  SC: () => (fallbackHttpConfig),
  sb: () => (defaultPrinter),
  ve: () => (selectHttpOptionsAndBodyInternal)
});
/* ESM import */var _apollo_client_utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60827);

const defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: true,
    preserveHeaderCase: false,
};
const defaultHeaders = {
    // headers are case insensitive (https://stackoverflow.com/a/5259004)
    accept: "application/graphql-response+json,application/json;q=0.9",
    // The content-type header describes the type of the body of the request, and
    // so it typically only is sent with requests that actually have bodies. One
    // could imagine that Apollo Client would remove this header when constructing
    // a GET request (which has no body), but we historically have not done that.
    // This means that browsers will preflight all Apollo Client requests (even
    // GET requests). Apollo Server's CSRF prevention feature (introduced in
    // AS3.7) takes advantage of this fact and does not block requests with this
    // header. If you want to drop this header from GET requests, then you should
    // probably replace it with a `apollo-require-preflight` header, or servers
    // with CSRF prevention enabled might block your GET request. See
    // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
    // for more details.
    "content-type": "application/json",
};
const defaultOptions = {
    method: "POST",
};
const fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions,
};
const defaultPrinter = (ast, printer) => printer(ast);
function selectHttpOptionsAndBody(operation, fallbackConfig, ...configs) {
    configs.unshift(fallbackConfig);
    return selectHttpOptionsAndBodyInternal(operation, defaultPrinter, ...configs);
}
function selectHttpOptionsAndBodyInternal(operation, printer, ...configs) {
    let options = {};
    let http = {};
    configs.forEach((config) => {
        options = {
            ...options,
            ...config.options,
            headers: {
                ...options.headers,
                ...config.headers,
            },
        };
        if (config.credentials) {
            options.credentials = config.credentials;
        }
        options.headers.accept = (config.http?.accept || [])
            .concat(options.headers.accept)
            .join(",");
        http = {
            ...http,
            ...config.http,
        };
    });
    options.headers = removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    //The body depends on the http options
    const { operationName, extensions, variables, query } = operation;
    const body = { operationName, variables };
    if (http.includeExtensions && Object.keys(extensions || {}).length)
        body.extensions = extensions;
    // not sending the query (i.e persisted queries)
    if (http.includeQuery)
        body.query = printer(query, _apollo_client_utilities__WEBPACK_IMPORTED_MODULE_0__/* .print */.S);
    return {
        options,
        body,
    };
}
// Remove potential duplicate header names, preserving last (by insertion order).
// This is done to prevent unintentionally duplicating a header instead of
// overwriting it (See #8447 and #8449).
function removeDuplicateHeaders(headers, preserveHeaderCase) {
    // If we're not preserving the case, just remove duplicates w/ normalization.
    if (!preserveHeaderCase) {
        const normalizedHeaders = {};
        Object.keys(Object(headers)).forEach((name) => {
            normalizedHeaders[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders;
    }
    // If we are preserving the case, remove duplicates w/ normalization,
    // preserving the original name.
    // This allows for non-http-spec-compliant servers that expect intentionally
    // capitalized header names (See #6741).
    const headerData = {};
    Object.keys(Object(headers)).forEach((name) => {
        headerData[name.toLowerCase()] = {
            originalName: name,
            value: headers[name],
        };
    });
    const normalizedHeaders = {};
    Object.keys(headerData).forEach((name) => {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}
//# sourceMappingURL=selectHttpOptionsAndBody.js.map

}),
1658: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  r: () => (selectURI)
});
const selectURI = (operation, fallbackURI) => {
    const context = operation.getContext();
    const contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === "function") {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || "/graphql";
    }
};
//# sourceMappingURL=selectURI.js.map

}),
65822: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  RetryLink: () => (/* reexport */ RetryLink)
});

// EXTERNAL MODULE: ../../app/node_modules/rxjs/dist/esm5/internal/Observable.js + 1 modules
var Observable = __webpack_require__(87252);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/errors/index.js + 1 modules
var errors = __webpack_require__(39291);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/link/core/ApolloLink.js + 1 modules
var ApolloLink = __webpack_require__(44265);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/link/retry/delayFunction.js
function buildDelayFunction(delayOptions) {
    const { initial = 300, jitter = true, max = Infinity } = delayOptions || {};
    // If we're jittering, baseDelay is half of the maximum delay for that
    // attempt (and is, on average, the delay we will encounter).
    // If we're not jittering, adjust baseDelay so that the first attempt
    // lines up with initialDelay, for everyone's sanity.
    const baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        let delay = Math.min(max, baseDelay * 2 ** count);
        if (jitter) {
            // We opt for a full jitter approach for a mostly uniform distribution,
            // but bound it within initialDelay and delay for everyone's sanity.
            delay = Math.random() * delay;
        }
        return delay;
    };
}
//# sourceMappingURL=delayFunction.js.map
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/link/retry/retryFunction.js
function buildRetryFunction(retryOptions) {
    const { retryIf, max = 5 } = retryOptions || {};
    return function retryFunction(count, operation, error) {
        if (count >= max)
            return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
//# sourceMappingURL=retryFunction.js.map
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/link/retry/retryLink.js





class RetryableOperation {
    observer;
    operation;
    forward;
    delayFor;
    retryIf;
    retryCount = 0;
    currentSubscription = null;
    timerId;
    constructor(observer, operation, forward, delayFor, retryIf) {
        this.observer = observer;
        this.operation = operation;
        this.forward = forward;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.try();
    }
    /**
     * Stop retrying for the operation, and cancel any in-progress requests.
     */
    cancel() {
        if (this.currentSubscription) {
            this.currentSubscription.unsubscribe();
        }
        clearTimeout(this.timerId);
        this.timerId = undefined;
        this.currentSubscription = null;
    }
    try() {
        this.currentSubscription = this.forward(this.operation).subscribe({
            next: (result) => {
                if ((0,errors/* graphQLResultHasProtocolErrors */.ls)(result)) {
                    this.onError(result.extensions[errors/* PROTOCOL_ERRORS_SYMBOL */.YG], () => 
                    // Pretend like we never encountered this error and move the result
                    // along for Apollo Client core to handle this error.
                    this.observer.next(result));
                    // Unsubscribe from the current subscription to prevent the `complete`
                    // handler to be called as a result of the stream closing.
                    this.currentSubscription?.unsubscribe();
                    return;
                }
                this.observer.next(result);
            },
            error: (error) => this.onError(error, () => this.observer.error(error)),
            complete: this.observer.complete.bind(this.observer),
        });
    }
    onError = async (error, onContinue) => {
        this.retryCount += 1;
        const errorLike = (0,errors/* toErrorLike */.Nh)(error);
        const shouldRetry = await this.retryIf(this.retryCount, this.operation, errorLike);
        if (shouldRetry) {
            this.scheduleRetry(this.delayFor(this.retryCount, this.operation, errorLike));
            return;
        }
        onContinue();
    };
    scheduleRetry(delay) {
        if (this.timerId) {
            throw new Error(`RetryLink BUG! Encountered overlapping retries`);
        }
        this.timerId = setTimeout(() => {
            this.timerId = undefined;
            this.try();
        }, delay);
    }
}
/**
 * `RetryLink` is a non-terminating link that attempts to retry operations that
 * fail due to network errors. It enables resilient GraphQL operations by
 * automatically retrying failed requests with configurable delay and retry
 * strategies.
 *
 * @remarks
 *
 * `RetryLink` is particularly useful for handling unreliable network conditions
 * where you would rather wait longer than explicitly fail an operation. It
 * provides exponential backoff and jitters delays between attempts by default.
 *
 * > [!NOTE]
 * > This link does not handle retries for GraphQL errors in the response. Use
 * > `ErrorLink` to retry an operation after a GraphQL error. For more
 * > information, see the [Error handling documentation](https://apollographql.com/docs/react/data/error-handling#on-graphql-errors).
 *
 * @example
 *
 * ```ts
 * import { RetryLink } from "@apollo/client/link/retry";
 *
 * const link = new RetryLink();
 * ```
 */
class RetryLink extends ApolloLink/* ApolloLink */.i {
    delayFor;
    retryIf;
    constructor(options) {
        super();
        const { attempts, delay } = options || {};
        this.delayFor =
            typeof delay === "function" ? delay : buildDelayFunction(delay);
        this.retryIf =
            typeof attempts === "function" ? attempts : buildRetryFunction(attempts);
    }
    request(operation, forward) {
        return new Observable/* Observable */.y((observer) => {
            const retryable = new RetryableOperation(observer, operation, forward, this.delayFor, this.retryIf);
            return () => {
                retryable.cancel();
            };
        });
    }
}
//# sourceMappingURL=retryLink.js.map
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/link/retry/index.js

//# sourceMappingURL=index.js.map

}),
64437: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  e: () => (filterOperationVariables)
});
/* ESM import */var graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51371);

function filterOperationVariables(variables, query) {
    const result = { ...variables };
    const unusedNames = new Set(Object.keys(variables));
    (0,graphql__WEBPACK_IMPORTED_MODULE_0__/* .visit */.Vn)(query, {
        Variable(node, _key, parent) {
            // A variable type definition at the top level of a query is not
            // enough to silence server-side errors about the variable being
            // unused, so variable definitions do not count as usage.
            // https://spec.graphql.org/draft/#sec-All-Variables-Used
            if (parent &&
                parent.kind !== "VariableDefinition") {
                unusedNames.delete(node.name.value);
            }
        },
    });
    unusedNames.forEach((name) => {
        delete result[name];
    });
    return result;
}
//# sourceMappingURL=filterOperationVariables.js.map

}),
48234: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  LocalState: () => (/* reexport */ LocalState)
});

// EXTERNAL MODULE: ../../app/node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(44361);
// EXTERNAL MODULE: ../../app/node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(51371);
;// CONCATENATED MODULE: ../../app/node_modules/graphql/language/predicates.mjs

function isDefinitionNode(node) {
  return (
    isExecutableDefinitionNode(node) ||
    isTypeSystemDefinitionNode(node) ||
    isTypeSystemExtensionNode(node)
  );
}
function isExecutableDefinitionNode(node) {
  return (
    node.kind === Kind.OPERATION_DEFINITION ||
    node.kind === Kind.FRAGMENT_DEFINITION
  );
}
function isSelectionNode(node) {
  return (
    node.kind === kinds/* Kind,FIELD */.h.FIELD ||
    node.kind === kinds/* Kind,FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD ||
    node.kind === kinds/* Kind,INLINE_FRAGMENT */.h.INLINE_FRAGMENT
  );
}
function isValueNode(node) {
  return (
    node.kind === Kind.VARIABLE ||
    node.kind === Kind.INT ||
    node.kind === Kind.FLOAT ||
    node.kind === Kind.STRING ||
    node.kind === Kind.BOOLEAN ||
    node.kind === Kind.NULL ||
    node.kind === Kind.ENUM ||
    node.kind === Kind.LIST ||
    node.kind === Kind.OBJECT
  );
}
function isConstValueNode(node) {
  return (
    isValueNode(node) &&
    (node.kind === Kind.LIST
      ? node.values.some(isConstValueNode)
      : node.kind === Kind.OBJECT
      ? node.fields.some((field) => isConstValueNode(field.value))
      : node.kind !== Kind.VARIABLE)
  );
}
function isTypeNode(node) {
  return (
    node.kind === Kind.NAMED_TYPE ||
    node.kind === Kind.LIST_TYPE ||
    node.kind === Kind.NON_NULL_TYPE
  );
}
function isTypeSystemDefinitionNode(node) {
  return (
    node.kind === Kind.SCHEMA_DEFINITION ||
    isTypeDefinitionNode(node) ||
    node.kind === Kind.DIRECTIVE_DEFINITION
  );
}
function isTypeDefinitionNode(node) {
  return (
    node.kind === Kind.SCALAR_TYPE_DEFINITION ||
    node.kind === Kind.OBJECT_TYPE_DEFINITION ||
    node.kind === Kind.INTERFACE_TYPE_DEFINITION ||
    node.kind === Kind.UNION_TYPE_DEFINITION ||
    node.kind === Kind.ENUM_TYPE_DEFINITION ||
    node.kind === Kind.INPUT_OBJECT_TYPE_DEFINITION
  );
}
function isTypeSystemExtensionNode(node) {
  return node.kind === Kind.SCHEMA_EXTENSION || isTypeExtensionNode(node);
}
function isTypeExtensionNode(node) {
  return (
    node.kind === Kind.SCALAR_TYPE_EXTENSION ||
    node.kind === Kind.OBJECT_TYPE_EXTENSION ||
    node.kind === Kind.INTERFACE_TYPE_EXTENSION ||
    node.kind === Kind.UNION_TYPE_EXTENSION ||
    node.kind === Kind.ENUM_TYPE_EXTENSION ||
    node.kind === Kind.INPUT_OBJECT_TYPE_EXTENSION
  );
}

// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/cache/inmemory/reactiveVars.js
var reactiveVars = __webpack_require__(52926);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/errors/LocalStateError.js
var LocalStateError = __webpack_require__(41919);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/errors/index.js + 1 modules
var client_errors = __webpack_require__(39291);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/isPlainObject.js
/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function isPlainObject(obj) {
    return (obj !== null &&
        typeof obj === "object" &&
        (Object.getPrototypeOf(obj) === Object.prototype ||
            Object.getPrototypeOf(obj) === null));
}
//# sourceMappingURL=isPlainObject.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/omitDeep.js

/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function omitDeep(value, key) {
    return __omitDeep(value, key);
}
function __omitDeep(value, key, known = new Map()) {
    if (known.has(value)) {
        return known.get(value);
    }
    let modified = false;
    if (Array.isArray(value)) {
        const array = [];
        known.set(value, array);
        value.forEach((value, index) => {
            const result = __omitDeep(value, key, known);
            modified ||= result !== value;
            array[index] = result;
        });
        if (modified) {
            return array;
        }
    }
    else if (isPlainObject(value)) {
        const obj = Object.create(Object.getPrototypeOf(value));
        known.set(value, obj);
        Object.keys(value).forEach((k) => {
            if (k === key) {
                modified = true;
                return;
            }
            const result = __omitDeep(value[k], key, known);
            modified ||= result !== value[k];
            obj[k] = result;
        });
        if (modified) {
            return obj;
        }
    }
    return value;
}
//# sourceMappingURL=omitDeep.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/common/stripTypename.js

/**
 * Deeply removes all `__typename` properties in the given object or array.
 *
 * @param value - The object or array that should have `__typename` removed.
 * @returns The object with all `__typename` properties removed.
 *
 * @example
 *
 * ```ts
 * stripTypename({
 *   __typename: "User",
 *   id: 1,
 *   profile: { __typename: "Profile", name: "John Doe" },
 * });
 * // => { id: 1, profile: { name: "John Doe"}}
 * ```
 */
function stripTypename(value) {
    return omitDeep(value, "__typename");
}
//# sourceMappingURL=stripTypename.js.map
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/environment/index.production.js
var index_production = __webpack_require__(64744);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/mergeDeepArray.js
var mergeDeepArray = __webpack_require__(89465);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/mergeDeep.js

// These mergeDeep and mergeDeepArray utilities merge any number of objects
// together, sharing as much memory as possible with the source objects, while
// remaining careful to avoid modifying any source objects.
// Logically, the return type of mergeDeep should be the intersection of
// all the argument types. The binary call signature is by far the most
// common, but we support 0- through 5-ary as well. After that, the
// resulting type is just the inferred array element type. Note to nerds:
// there is a more clever way of doing this that converts the tuple type
// first to a union type (easy enough: T[number]) and then converts the
// union to an intersection type using distributive conditional type
// inference, but that approach has several fatal flaws (boolean becomes
// true & false, and the inferred type ends up as unknown in many cases),
// in addition to being nearly impossible to explain/understand.
/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function mergeDeep(...sources) {
    return (0,mergeDeepArray/* mergeDeepArray */.b)(sources);
}
//# sourceMappingURL=mergeDeep.js.map

// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/hasDirectives.js
var hasDirectives = __webpack_require__(27184);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/shouldInclude.js
var shouldInclude = __webpack_require__(32303);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/resultKeyNameFromField.js
var resultKeyNameFromField = __webpack_require__(87193);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/internal/dealias.js

// Note: this is a shallow dealias function. We might consider a future
// improvement of dealiasing all nested data. Until that need arises, we can
// keep this simple.
function dealias(fieldValue, selectionSet) {
    if (!fieldValue) {
        return fieldValue;
    }
    const data = { ...fieldValue };
    for (const selection of selectionSet.selections) {
        if (selection.kind === kinds/* Kind,FIELD */.h.FIELD && selection.alias) {
            data[selection.name.value] = fieldValue[selection.alias.value];
            delete data[selection.alias.value];
        }
    }
    return data;
}
//# sourceMappingURL=dealias.js.map
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/argumentsObjectFromField.js
var argumentsObjectFromField = __webpack_require__(27494);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/getMainDefinition.js
var getMainDefinition = __webpack_require__(2918);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/getFragmentDefinitions.js
var getFragmentDefinitions = __webpack_require__(5087);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/createFragmentMap.js
var createFragmentMap = __webpack_require__(21956);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/invariant/index.js
var invariant = __webpack_require__(85401);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/local-state/LocalState.js







/**
 * LocalState enables the use of `@client` fields in GraphQL operations.
 *
 * `@client` fields are resolved locally using resolver functions rather than
 * being sent to the GraphQL server. This allows you to mix local and remote
 * data in a single query.
 *
 * @example
 *
 * ```ts
 * import { LocalState } from "@apollo/client/local-state";
 *
 * const localState = new LocalState({
 *   resolvers: {
 *     Query: {
 *       isLoggedIn: () => !!localStorage.getItem("token"),
 *     },
 *   },
 * });
 *
 * const client = new ApolloClient({
 *   cache: new InMemoryCache(),
 *   localState,
 * });
 * ```
 *
 * @template TResolvers - The type of resolvers map for type checking
 * @template TContext - The type of context value for resolvers
 */
class LocalState {
    context;
    resolvers = {};
    traverseCache = new WeakMap();
    constructor(...[options]) {
        this.context = options?.context;
        if (options?.resolvers) {
            this.addResolvers(options.resolvers);
        }
    }
    /**
     * Add resolvers to the local state. New resolvers will be merged with
     * existing ones, with new resolvers taking precedence over existing ones
     * for the same field.
     *
     * @param resolvers - The resolvers to add
     *
     * @example
     *
     * ```ts
     * localState.addResolvers({
     *   Query: {
     *     newField: () => "Hello World",
     *   },
     * });
     * ```
     */
    addResolvers(resolvers) {
        this.resolvers = mergeDeep(this.resolvers, resolvers);
    }
    async execute({ document, client, context, remoteResult, variables = {}, onlyRunForcedResolvers = false, returnPartialData = false, }) {
        if (index_production/* __DEV__ */.T) {
            (0,invariant/* invariant */.kG)((0,hasDirectives/* hasDirectives */.F)(["client"], document), 47);
            validateCacheImplementation(client.cache);
        }
        // note: if `remoteResult` is `undefined`, we will execute resolvers since
        // undefined remote data reflects a client-only query. We specifically want
        // to avoid trying to run local resolvers if the server returned `data` as
        // `null`.
        if (remoteResult?.data === null) {
            return remoteResult;
        }
        const { selectionsToResolve, exportedVariableDefs, operationDefinition, fragmentMap, } = this.collectQueryDetail(document);
        const rootValue = remoteResult ? remoteResult.data : {};
        const diff = client.cache.diff({
            query: toQueryOperation(document),
            variables,
            returnPartialData: true,
            optimistic: false,
        });
        const requestContext = { ...client.defaultContext, ...context };
        const execContext = {
            client,
            operationDefinition,
            fragmentMap,
            context: this.context?.({
                requestContext,
                document,
                client,
                phase: "resolve",
                variables: variables ?? {},
            }) ?? requestContext,
            variables,
            exportedVariables: {},
            selectionsToResolve,
            onlyRunForcedResolvers,
            errors: [],
            phase: "resolve",
            exportedVariableDefs,
            diff,
            returnPartialData,
        };
        const localResult = await this.resolveSelectionSet(operationDefinition.selectionSet, false, rootValue, execContext, []);
        const errors = (remoteResult?.errors ?? []).concat(execContext.errors);
        const result = {
            ...remoteResult,
            data: mergeDeep(rootValue, localResult),
        };
        if (errors.length > 0) {
            result.errors = errors;
        }
        return result;
    }
    async getExportedVariables({ document, client, context, variables, }) {
        if (index_production/* __DEV__ */.T) {
            (0,invariant/* invariant */.kG)((0,hasDirectives/* hasDirectives */.F)(["client"], document), 48);
            validateCacheImplementation(client.cache);
        }
        const { exportsToResolve, exportedVariableDefs, fragmentMap, operationDefinition, } = this.collectQueryDetail(document);
        const diff = client.cache.diff({
            query: toQueryOperation(document),
            variables,
            returnPartialData: true,
            optimistic: false,
        });
        const requestContext = { ...client.defaultContext, ...context };
        const execContext = {
            client,
            operationDefinition,
            fragmentMap,
            context: this.context?.({
                requestContext,
                document,
                client,
                phase: "resolve",
                variables: variables ?? {},
            }) ?? requestContext,
            variables,
            exportedVariables: {},
            selectionsToResolve: exportsToResolve,
            onlyRunForcedResolvers: false,
            errors: [],
            phase: "exports",
            exportedVariableDefs,
            diff,
            returnPartialData: false,
        };
        await this.resolveSelectionSet(operationDefinition.selectionSet, false, diff.result, execContext, []);
        return stripTypename({
            ...variables,
            ...execContext.exportedVariables,
        });
    }
    async resolveSelectionSet(selectionSet, isClientFieldDescendant, rootValue, execContext, path) {
        const { client, fragmentMap, variables, operationDefinition } = execContext;
        const { cache } = client;
        const resultsToMerge = [];
        const execute = async (selection) => {
            if (!isClientFieldDescendant &&
                !execContext.selectionsToResolve.has(selection)) {
                // Skip selections without @client directives
                // (still processing if one of the ancestors or one of the child fields has @client directive)
                return;
            }
            if (!(0,shouldInclude/* shouldInclude */.L)(selection, variables)) {
                // Skip this entirely.
                return;
            }
            if (selection.kind === kinds/* Kind,FIELD */.h.FIELD) {
                const isRootField = selectionSet === operationDefinition.selectionSet;
                const isClientField = isClientFieldDescendant ||
                    (selection.directives?.some((d) => d.name.value === "client") ??
                        false);
                const fieldResult = isClientField ?
                    await this.resolveClientField(selection, isClientFieldDescendant, rootValue, execContext, selectionSet, path.concat(selection.name.value))
                    : await this.resolveServerField(selection, rootValue, execContext, path.concat(selection.name.value));
                // Don't attempt to merge the client field result if the server result
                // was null
                if (fieldResult !== undefined && (!isRootField || rootValue !== null)) {
                    resultsToMerge.push({
                        [(0,resultKeyNameFromField/* resultKeyNameFromField */.u)(selection)]: fieldResult,
                    });
                }
                return;
            }
            if (selection.kind === kinds/* Kind,INLINE_FRAGMENT */.h.INLINE_FRAGMENT &&
                selection.typeCondition &&
                rootValue?.__typename &&
                cache.fragmentMatches(selection, rootValue.__typename)) {
                const fragmentResult = await this.resolveSelectionSet(selection.selectionSet, isClientFieldDescendant, rootValue, execContext, path);
                if (fragmentResult) {
                    resultsToMerge.push(fragmentResult);
                }
                return;
            }
            if (selection.kind === kinds/* Kind,FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD) {
                const fragment = fragmentMap[selection.name.value];
                (0,invariant/* invariant */.kG)(fragment, 49, selection.name.value);
                const typename = rootValue?.__typename;
                const typeCondition = fragment.typeCondition.name.value;
                const matches = typename === typeCondition ||
                    cache.fragmentMatches(fragment, typename ?? "");
                if (matches) {
                    const fragmentResult = await this.resolveSelectionSet(fragment.selectionSet, isClientFieldDescendant, rootValue, execContext, path);
                    if (fragmentResult) {
                        resultsToMerge.push(fragmentResult);
                    }
                }
                return;
            }
        };
        await Promise.all(selectionSet.selections.map(execute));
        return resultsToMerge.length > 0 ?
            (0,mergeDeepArray/* mergeDeepArray */.b)(resultsToMerge)
            : rootValue;
    }
    resolveServerField(field, rootValue, execContext, path) {
        const result = rootValue?.[field.name.value];
        if (!field.selectionSet) {
            return result;
        }
        if (result == null) {
            if (execContext.phase === "exports") {
                for (const [name, def] of Object.entries(execContext.exportedVariableDefs)) {
                    if (def.ancestors.has(field) && def.required) {
                        throw new LocalStateError/* LocalStateError */.x(`${"Field"} '${field.name.value}' is \`${result}\` which contains exported required variable '${name}'. Ensure this value is in the cache or make the variable optional.`, { path });
                    }
                }
            }
            return result;
        }
        if (Array.isArray(result)) {
            return this.resolveSubSelectedArray(field, false, result, execContext, path);
        }
        return this.resolveSelectionSet(field.selectionSet, false, result, execContext, path);
    }
    async resolveClientField(field, isClientFieldDescendant, rootValue, execContext, parentSelectionSet, path) {
        const { client, diff, variables, operationDefinition, phase, returnPartialData, onlyRunForcedResolvers, } = execContext;
        const isRootField = parentSelectionSet === operationDefinition.selectionSet;
        const fieldName = field.name.value;
        const typename = isRootField ?
            rootValue?.__typename || inferRootTypename(operationDefinition)
            : rootValue?.__typename;
        const resolverName = `${typename}.${fieldName}`;
        function readField() {
            const fieldResult = rootValue?.[fieldName];
            if (fieldResult !== undefined) {
                return fieldResult;
            }
            return getCacheResultAtPath(diff, path);
        }
        const defaultResolver = isClientFieldDescendant ? readField
            // We expect a resolver to be defined for all `@client` root fields.
            // Warn when a resolver is not defined.
            : (() => {
                const fieldFromCache = getCacheResultAtPath(diff, path);
                if (fieldFromCache !== undefined) {
                    return fieldFromCache;
                }
                if (!returnPartialData) {
                    return null;
                }
            });
        const resolver = this.getResolver(typename, fieldName);
        let result;
        try {
            // Avoid running the resolver if we are only trying to run forced
            // resolvers. Fallback to read the value from the root field or the cache
            // value
            if (!onlyRunForcedResolvers || isForcedResolver(field)) {
                result =
                    resolver ?
                        await Promise.resolve(
                        // In case the resolve function accesses reactive variables,
                        // set cacheSlot to the current cache instance.
                        reactiveVars/* cacheSlot,withValue */.ab.withValue(client.cache, resolver, [
                            rootValue ? dealias(rootValue, parentSelectionSet) : {},
                            ((0,argumentsObjectFromField/* argumentsObjectFromField */.N)(field, variables) ?? {}),
                            { requestContext: execContext.context, client, phase },
                            { field, fragmentMap: execContext.fragmentMap, path },
                        ]))
                        : defaultResolver();
            }
            else {
                result = readField();
            }
        }
        catch (e) {
            if (phase === "exports") {
                for (const [name, def] of Object.entries(execContext.exportedVariableDefs)) {
                    if (def.ancestors.has(field)) {
                        throw new LocalStateError/* LocalStateError */.x(`An error was thrown from resolver '${resolverName}' while resolving ${def.required ? "required" : "optional"} variable '${name}'. Use a try/catch and return \`undefined\` to suppress this error and omit the variable from the request.`, { path, sourceError: e });
                    }
                }
            }
            this.addError((0,client_errors/* toErrorLike */.Nh)(e), path, execContext, {
                resolver: resolverName,
                cause: e,
            });
            return null;
        }
        if (phase === "exports") {
            field.directives?.forEach((directive) => {
                if (directive.name.value !== "export") {
                    return;
                }
                const name = getExportedVariableName(directive);
                if (!name) {
                    return;
                }
                if (result !== undefined) {
                    execContext.exportedVariables[name] = result;
                }
            });
            if (result == null) {
                for (const [name, def] of Object.entries(execContext.exportedVariableDefs)) {
                    if (def.ancestors.has(field) && def.required) {
                        throw new LocalStateError/* LocalStateError */.x(`${resolver ? "Resolver" : "Field"} '${resolverName}' returned \`${result}\` ${def.field === field ? "for" : "which contains exported"} required variable '${name}'.`, { path });
                    }
                }
            }
        }
        if (result === undefined && !returnPartialData) {
            if (index_production/* __DEV__ */.T && phase === "resolve") {
                if (resolver && !onlyRunForcedResolvers) {
                    index_production/* __DEV__ */.T && invariant/* invariant,warn */.kG.warn(50, resolverName);
                }
                else if (onlyRunForcedResolvers) {
                    index_production/* __DEV__ */.T && invariant/* invariant,warn */.kG.warn(51, resolverName);
                }
                else {
                    index_production/* __DEV__ */.T && invariant/* invariant,warn */.kG.warn(52, fieldName, rootValue);
                }
            }
            result = null;
        }
        if (result == null || !field.selectionSet) {
            return result;
        }
        if (Array.isArray(result)) {
            return this.resolveSubSelectedArray(field, true, result, execContext, path);
        }
        if (phase === "resolve" && !result.__typename) {
            this.addError((0,invariant/* newInvariantError */._K)(53, result, resolverName), path, execContext, { resolver: resolverName });
            return null;
        }
        return this.resolveSelectionSet(field.selectionSet, true, result, execContext, path);
    }
    addError(error, path, execContext, meta) {
        execContext.errors.push(addExtension(isGraphQLError(error) ?
            { ...error.toJSON(), path }
            : { message: error.message, path }, meta));
    }
    getResolver(typename, fieldName) {
        return this.resolvers[typename]?.[fieldName];
    }
    resolveSubSelectedArray(field, isClientFieldDescendant, result, execContext, path) {
        return Promise.all(result.map((item, idx) => {
            if (item === null) {
                return null;
            }
            // This is a nested array, recurse.
            if (Array.isArray(item)) {
                return this.resolveSubSelectedArray(field, isClientFieldDescendant, item, execContext, path.concat(idx));
            }
            // This is an object, run the selection set on it.
            if (field.selectionSet) {
                return this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant, item, execContext, path.concat(idx));
            }
        }));
    }
    // Collect selection nodes on paths from document root down to all @client directives.
    // This function takes into account transitive fragment spreads.
    // Complexity equals to a single `visit` over the full document.
    collectQueryDetail(document) {
        const operationDefinition = (0,getMainDefinition/* getMainDefinition */.p)(document);
        const fragments = (0,getFragmentDefinitions/* getFragmentDefinitions */.k)(document);
        const fragmentMap = (0,createFragmentMap/* createFragmentMap */.F)(fragments);
        const isSingleASTNode = (node) => !Array.isArray(node);
        const fields = [];
        let rootClientField;
        function getCurrentPath() {
            return fields.map((field) => field.name.value);
        }
        const traverse = (definitionNode) => {
            if (this.traverseCache.has(definitionNode)) {
                return this.traverseCache.get(definitionNode);
            }
            // Track a separate list of all variable definitions since not all variable
            // definitions are used as exports of an `@export` field.
            const allVariableDefinitions = {};
            const cache = {
                exportedVariableDefs: {},
                exportsToResolve: new Set(),
                selectionsToResolve: new Set(),
            };
            this.traverseCache.set(definitionNode, cache);
            (0,visitor/* visit */.Vn)(definitionNode, {
                VariableDefinition: (definition) => {
                    allVariableDefinitions[definition.variable.name.value] = {
                        required: definition.type.kind === kinds/* Kind,NON_NULL_TYPE */.h.NON_NULL_TYPE,
                        ancestors: new WeakSet(),
                    };
                },
                Field: {
                    enter(field) {
                        fields.push(field);
                    },
                    leave() {
                        const removed = fields.pop();
                        if (removed === rootClientField) {
                            rootClientField = undefined;
                        }
                    },
                },
                Directive(node, _, __, ___, ancestors) {
                    const field = fields.at(-1);
                    if (!field) {
                        return;
                    }
                    if (node.name.value === "export" &&
                        // Ignore export directives that aren't inside client fields.
                        // These will get sent to the server
                        rootClientField) {
                        const fieldName = field.name.value;
                        const variableName = getExportedVariableName(node);
                        if (!variableName) {
                            throw new LocalStateError/* LocalStateError */.x(`Cannot determine the variable name from the \`@export\` directive used on field '${fieldName}'. Perhaps you forgot the \`as\` argument?`, { path: getCurrentPath() });
                        }
                        if (!allVariableDefinitions[variableName]) {
                            throw new LocalStateError/* LocalStateError */.x(`\`@export\` directive on field '${fieldName}' cannot export the '$${variableName}' variable as it is missing in the ${operationDefinition.operation} definition.`, { path: getCurrentPath() });
                        }
                        cache.exportedVariableDefs[variableName] = {
                            ...allVariableDefinitions[variableName],
                            field,
                        };
                        ancestors.forEach((node) => {
                            if (isSingleASTNode(node) && isSelectionNode(node)) {
                                cache.exportsToResolve.add(node);
                                cache.exportedVariableDefs[variableName].ancestors.add(node);
                            }
                        });
                    }
                    if (node.name.value === "client") {
                        rootClientField ??= field;
                        ancestors.forEach((node) => {
                            if (isSingleASTNode(node) && isSelectionNode(node)) {
                                cache.selectionsToResolve.add(node);
                            }
                        });
                    }
                },
                FragmentSpread(spread, _, __, ___, ancestors) {
                    const fragment = fragmentMap[spread.name.value];
                    (0,invariant/* invariant */.kG)(fragment, 54, spread.name.value);
                    const { selectionsToResolve: fragmentSelections } = traverse(fragment);
                    if (fragmentSelections.size > 0) {
                        // Fragment for this spread contains @client directive (either directly or transitively)
                        // Collect selection nodes on paths from the root down to fields with the @client directive
                        ancestors.forEach((node) => {
                            if (isSingleASTNode(node) && isSelectionNode(node)) {
                                cache.selectionsToResolve.add(node);
                            }
                        });
                        cache.selectionsToResolve.add(spread);
                        fragmentSelections.forEach((selection) => {
                            cache.selectionsToResolve.add(selection);
                        });
                    }
                },
            });
            return cache;
        };
        return {
            ...traverse(operationDefinition),
            operationDefinition,
            fragmentMap,
        };
    }
}
function inferRootTypename({ operation }) {
    return operation.charAt(0).toUpperCase() + operation.slice(1);
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
function isGraphQLError(error) {
    return (error.name === "GraphQLError" &&
        // Check to see if the error contains keys returned in toJSON. The values
        // might be `undefined` if not set, but we don't care about those as we
        // can be reasonably sure this is a GraphQLError if all of these properties
        // exist on the error
        "path" in error &&
        "locations" in error &&
        "extensions" in error);
}
function addExtension(error, meta) {
    return {
        ...error,
        extensions: {
            ...error.extensions,
            localState: meta,
        },
    };
}
function getExportedVariableName(directive) {
    if (directive.arguments) {
        for (const arg of directive.arguments) {
            if (arg.name.value === "as" && arg.value.kind === kinds/* Kind,STRING */.h.STRING) {
                return arg.value.value;
            }
        }
    }
}
function validateCacheImplementation(cache) {
    (0,invariant/* invariant */.kG)(cache.fragmentMatches, 55);
}
function getCacheResultAtPath(diff, path) {
    if (diff.result === null) {
        // Intentionally return undefined to signal we have no cache data
        return;
    }
    return path.reduce((value, segment) => value?.[segment], diff.result);
}
function isForcedResolver(field) {
    return (field.directives?.some((directive) => {
        if (directive.name.value !== "client" || !directive.arguments) {
            return false;
        }
        return directive.arguments.some((arg) => arg.name.value === "always" &&
            arg.value.kind === "BooleanValue" &&
            arg.value.value === true);
    }) ?? false);
}
// If the incoming document is a query, return it as is. Otherwise, build a
// new document containing a query operation based on the selection set
// of the previous main operation.
function toQueryOperation(document) {
    const definition = (0,getMainDefinition/* getMainDefinition */.p)(document);
    const definitionOperation = definition.operation;
    if (definitionOperation === "query") {
        // Already a query, so return the existing document.
        return document;
    }
    // Build a new query using the selection set of the main operation.
    const modifiedDoc = (0,visitor/* visit */.Vn)(document, {
        OperationDefinition: {
            enter(node) {
                return {
                    ...node,
                    operation: "query",
                };
            },
        },
    });
    return modifiedDoc;
}
//# sourceMappingURL=LocalState.js.map

;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/local-state/index.js

//# sourceMappingURL=index.js.map

}),
15313: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  Q: () => (cacheSizes)
});
/* ESM import */var _apollo_client_utilities_internal_globals__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97027);

const cacheSizeSymbol = Symbol.for("apollo.cacheSize");
/**
 * The global cache size configuration for Apollo Client.
 *
 * @remarks
 *
 * You can directly modify this object, but any modification will
 * only have an effect on caches that are created after the modification.
 *
 * So for global caches, such as `canonicalStringify` and `print`,
 * you might need to call `.reset` on them, which will essentially re-create them.
 *
 * Alternatively, you can set `globalThis[Symbol.for("apollo.cacheSize")]` before
 * you load the Apollo Client package:
 *
 * @example
 *
 * ```ts
 * globalThis[Symbol.for("apollo.cacheSize")] = {
 *   print: 100,
 * } satisfies Partial<CacheSizes>; // the `satisfies` is optional if using TypeScript
 * ```
 */
const cacheSizes = { ..._apollo_client_utilities_internal_globals__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */.Z[cacheSizeSymbol] };
//# sourceMappingURL=sizes.js.map

}),
64744: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  T: () => (__DEV__)
});
const __DEV__ = false;
//# sourceMappingURL=index.production.js.map

}),
60827: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  S: () => (/* binding */ print_print)
});

// EXTERNAL MODULE: ../../app/node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(44885);
;// CONCATENATED MODULE: ../../app/node_modules/graphql/language/printString.mjs
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */
function printString(str) {
  return `"${str.replace(escapedRegExp, escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex

const escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;

function escapedReplacer(str) {
  return escapeSequences[str.charCodeAt(0)];
} // prettier-ignore

const escapeSequences = [
  '\\u0000',
  '\\u0001',
  '\\u0002',
  '\\u0003',
  '\\u0004',
  '\\u0005',
  '\\u0006',
  '\\u0007',
  '\\b',
  '\\t',
  '\\n',
  '\\u000B',
  '\\f',
  '\\r',
  '\\u000E',
  '\\u000F',
  '\\u0010',
  '\\u0011',
  '\\u0012',
  '\\u0013',
  '\\u0014',
  '\\u0015',
  '\\u0016',
  '\\u0017',
  '\\u0018',
  '\\u0019',
  '\\u001A',
  '\\u001B',
  '\\u001C',
  '\\u001D',
  '\\u001E',
  '\\u001F',
  '',
  '',
  '\\"',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 2F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 3F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 4F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\\\',
  '',
  '',
  '', // 5F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 6F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\u007F',
  '\\u0080',
  '\\u0081',
  '\\u0082',
  '\\u0083',
  '\\u0084',
  '\\u0085',
  '\\u0086',
  '\\u0087',
  '\\u0088',
  '\\u0089',
  '\\u008A',
  '\\u008B',
  '\\u008C',
  '\\u008D',
  '\\u008E',
  '\\u008F',
  '\\u0090',
  '\\u0091',
  '\\u0092',
  '\\u0093',
  '\\u0094',
  '\\u0095',
  '\\u0096',
  '\\u0097',
  '\\u0098',
  '\\u0099',
  '\\u009A',
  '\\u009B',
  '\\u009C',
  '\\u009D',
  '\\u009E',
  '\\u009F',
];

// EXTERNAL MODULE: ../../app/node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(51371);
;// CONCATENATED MODULE: ../../app/node_modules/graphql/language/printer.mjs



/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return (0,visitor/* visit */.Vn)(ast, printDocASTReducer);
}
const MAX_LINE_LENGTH = 80;
const printDocASTReducer = {
  Name: {
    leave: (node) => node.value,
  },
  Variable: {
    leave: (node) => '$' + node.name,
  },
  // Document
  Document: {
    leave: (node) => join(node.definitions, '\n\n'),
  },
  OperationDefinition: {
    leave(node) {
      const varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
      const prefix = join(
        [
          node.operation,
          join([node.name, varDefs]),
          join(node.directives, ' '),
        ],
        ' ',
      ); // Anonymous queries with no directives or variable definitions can use
      // the query short form.

      return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
    },
  },
  VariableDefinition: {
    leave: ({ variable, type, defaultValue, directives }) =>
      variable +
      ': ' +
      type +
      wrap(' = ', defaultValue) +
      wrap(' ', join(directives, ' ')),
  },
  SelectionSet: {
    leave: ({ selections }) => block(selections),
  },
  Field: {
    leave({ alias, name, arguments: args, directives, selectionSet }) {
      const prefix = wrap('', alias, ': ') + name;
      let argsLine = prefix + wrap('(', join(args, ', '), ')');

      if (argsLine.length > MAX_LINE_LENGTH) {
        argsLine = prefix + wrap('(\n', indent(join(args, '\n')), '\n)');
      }

      return join([argsLine, join(directives, ' '), selectionSet], ' ');
    },
  },
  Argument: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name, directives }) =>
      '...' + name + wrap(' ', join(directives, ' ')),
  },
  InlineFragment: {
    leave: ({ typeCondition, directives, selectionSet }) =>
      join(
        [
          '...',
          wrap('on ', typeCondition),
          join(directives, ' '),
          selectionSet,
        ],
        ' ',
      ),
  },
  FragmentDefinition: {
    leave: (
      { name, typeCondition, variableDefinitions, directives, selectionSet }, // Note: fragment variable definitions are experimental and may be changed
    ) =>
      // or removed in the future.
      `fragment ${name}${wrap('(', join(variableDefinitions, ', '), ')')} ` +
      `on ${typeCondition} ${wrap('', join(directives, ' '), ' ')}` +
      selectionSet,
  },
  // Value
  IntValue: {
    leave: ({ value }) => value,
  },
  FloatValue: {
    leave: ({ value }) => value,
  },
  StringValue: {
    leave: ({ value, block: isBlockString }) =>
      isBlockString ? (0,blockString/* printBlockString */.LZ)(value) : printString(value),
  },
  BooleanValue: {
    leave: ({ value }) => (value ? 'true' : 'false'),
  },
  NullValue: {
    leave: () => 'null',
  },
  EnumValue: {
    leave: ({ value }) => value,
  },
  ListValue: {
    leave: ({ values }) => '[' + join(values, ', ') + ']',
  },
  ObjectValue: {
    leave: ({ fields }) => '{' + join(fields, ', ') + '}',
  },
  ObjectField: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Directive
  Directive: {
    leave: ({ name, arguments: args }) =>
      '@' + name + wrap('(', join(args, ', '), ')'),
  },
  // Type
  NamedType: {
    leave: ({ name }) => name,
  },
  ListType: {
    leave: ({ type }) => '[' + type + ']',
  },
  NonNullType: {
    leave: ({ type }) => type + '!',
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description, directives, operationTypes }) =>
      wrap('', description, '\n') +
      join(['schema', join(directives, ' '), block(operationTypes)], ' '),
  },
  OperationTypeDefinition: {
    leave: ({ operation, type }) => operation + ': ' + type,
  },
  ScalarTypeDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') +
      join(['scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  FieldDefinition: {
    leave: ({ description, name, arguments: args, type, directives }) =>
      wrap('', description, '\n') +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      ': ' +
      type +
      wrap(' ', join(directives, ' ')),
  },
  InputValueDefinition: {
    leave: ({ description, name, type, defaultValue, directives }) =>
      wrap('', description, '\n') +
      join(
        [name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')],
        ' ',
      ),
  },
  InterfaceTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeDefinition: {
    leave: ({ description, name, directives, types }) =>
      wrap('', description, '\n') +
      join(
        ['union', name, join(directives, ' '), wrap('= ', join(types, ' | '))],
        ' ',
      ),
  },
  EnumTypeDefinition: {
    leave: ({ description, name, directives, values }) =>
      wrap('', description, '\n') +
      join(['enum', name, join(directives, ' '), block(values)], ' '),
  },
  EnumValueDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') + join([name, join(directives, ' ')], ' '),
  },
  InputObjectTypeDefinition: {
    leave: ({ description, name, directives, fields }) =>
      wrap('', description, '\n') +
      join(['input', name, join(directives, ' '), block(fields)], ' '),
  },
  DirectiveDefinition: {
    leave: ({ description, name, arguments: args, repeatable, locations }) =>
      wrap('', description, '\n') +
      'directive @' +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      (repeatable ? ' repeatable' : '') +
      ' on ' +
      join(locations, ' | '),
  },
  SchemaExtension: {
    leave: ({ directives, operationTypes }) =>
      join(
        ['extend schema', join(directives, ' '), block(operationTypes)],
        ' ',
      ),
  },
  ScalarTypeExtension: {
    leave: ({ name, directives }) =>
      join(['extend scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  InterfaceTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeExtension: {
    leave: ({ name, directives, types }) =>
      join(
        [
          'extend union',
          name,
          join(directives, ' '),
          wrap('= ', join(types, ' | ')),
        ],
        ' ',
      ),
  },
  EnumTypeExtension: {
    leave: ({ name, directives, values }) =>
      join(['extend enum', name, join(directives, ' '), block(values)], ' '),
  },
  InputObjectTypeExtension: {
    leave: ({ name, directives, fields }) =>
      join(['extend input', name, join(directives, ' '), block(fields)], ' '),
  },
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */

function join(maybeArray, separator = '') {
  var _maybeArray$filter$jo;

  return (_maybeArray$filter$jo =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.filter((x) => x).join(separator)) !== null &&
    _maybeArray$filter$jo !== void 0
    ? _maybeArray$filter$jo
    : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */

function block(array) {
  return wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */

function wrap(start, maybeString, end = '') {
  return maybeString != null && maybeString !== ''
    ? start + maybeString + end
    : '';
}

function indent(str) {
  return wrap('  ', str.replace(/\n/g, '\n  '));
}

function hasMultilineItems(maybeArray) {
  var _maybeArray$some;

  // FIXME: https://github.com/graphql/graphql-js/issues/2203

  /* c8 ignore next */
  return (_maybeArray$some =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.some((str) => str.includes('\n'))) !== null &&
    _maybeArray$some !== void 0
    ? _maybeArray$some
    : false;
}

// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/environment/index.production.js
var index_production = __webpack_require__(64744);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/caches.js
var caches = __webpack_require__(88926);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/internal/getMemoryInternals.js
var getMemoryInternals = __webpack_require__(56552);
// EXTERNAL MODULE: ../../app/node_modules/@apollo/client/utilities/caching/sizes.js
var sizes = __webpack_require__(15313);
;// CONCATENATED MODULE: ../../app/node_modules/@apollo/client/utilities/graphql/print.js




let printCache;
/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 *
 * @remarks This is the same function as the GraphQL.js `print` function but
 * with an added cache to avoid recomputation when encountering the same
 * `ASTNode` more than once.
 */
const print_print = Object.assign((ast) => {
    let result = printCache.get(ast);
    if (!result) {
        result = print(ast);
        printCache.set(ast, result);
    }
    return result;
}, {
    reset() {
        printCache = new caches/* AutoCleanedWeakCache */.s(sizes/* cacheSizes,print */.Q.print || 2000 /* defaultCacheSizes.print */);
    },
});
print_print.reset();
if (index_production/* __DEV__ */.T) {
    (0,getMemoryInternals/* registerGlobalCache */.zP)("print", () => (printCache ? printCache.size : 0));
}
//# sourceMappingURL=print.js.map

}),
19317: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  w: () => (DeepMerger)
});
/* ESM import */var _isNonNullObject_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46145);

const { hasOwnProperty } = Object.prototype;
const defaultReconciler = function (target, source, property) {
    return this.merge(target[property], source[property]);
};
/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
class DeepMerger {
    reconciler;
    constructor(reconciler = defaultReconciler) {
        this.reconciler = reconciler;
    }
    merge(target, source, ...context) {
        if ((0,_isNonNullObject_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */.s)(source) && (0,_isNonNullObject_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */.s)(target)) {
            Object.keys(source).forEach((sourceKey) => {
                if (hasOwnProperty.call(target, sourceKey)) {
                    const targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        const result = this.reconciler(target, source, sourceKey, ...context);
                        // A well-implemented reconciler may return targetValue to indicate
                        // the merge changed nothing about the structure of the target.
                        if (result !== targetValue) {
                            target = this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                }
                else {
                    // If there is no collision, the target can safely share memory with
                    // the source, and the recursion can terminate here.
                    target = this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        // If source (or target) is not an object, let source replace target.
        return source;
    }
    isObject = _isNonNullObject_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */.s;
    pastCopies = new Set();
    shallowCopyForMerge(value) {
        if ((0,_isNonNullObject_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */.s)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) {
                    value = value.slice(0);
                }
                else {
                    value = {
                        __proto__: Object.getPrototypeOf(value),
                        ...value,
                    };
                }
                this.pastCopies.add(value);
            }
        }
        return value;
    }
}
//# sourceMappingURL=DeepMerger.js.map


}),
27494: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  N: () => (argumentsObjectFromField)
});
/* ESM import */var _valueToObjectRepresentation_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21124);

/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        const argObj = {};
        field.arguments.forEach(({ name, value }) => (0,_valueToObjectRepresentation_js__WEBPACK_IMPORTED_MODULE_0__/* .valueToObjectRepresentation */.v)(argObj, name, value, variables));
        return argObj;
    }
    return null;
}
//# sourceMappingURL=argumentsObjectFromField.js.map


}),
88926: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  L: () => (AutoCleanedStrongCache),
  s: () => (AutoCleanedWeakCache)
});
/* ESM import */var _wry_caches__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53077);
/* ESM import */var _wry_caches__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59831);

const scheduledCleanup = new WeakSet();
function schedule(cache) {
    if (cache.size <= (cache.max || -1)) {
        return;
    }
    if (!scheduledCleanup.has(cache)) {
        scheduledCleanup.add(cache);
        setTimeout(() => {
            cache.clean();
            scheduledCleanup.delete(cache);
        }, 100);
    }
}
/**
* @internal
* A version of WeakCache that will auto-schedule a cleanup of the cache when
* a new item is added and the cache reached maximum size.
* Throttled to once per 100ms.
*
* @privateRemarks
* Should be used throughout the rest of the codebase instead of WeakCache,
* with the notable exception of usage in `wrap` from `optimism` - that one
* already handles cleanup and should remain a `WeakCache`.
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
const AutoCleanedWeakCache = function (max, dispose) {
    /*
    Some builds of `WeakCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */
    const cache = new _wry_caches__WEBPACK_IMPORTED_MODULE_0__/* .WeakCache */.k(max, dispose);
    cache.set = function (key, value) {
        const ret = _wry_caches__WEBPACK_IMPORTED_MODULE_0__/* .WeakCache.prototype.set.call */.k.prototype.set.call(this, key, value);
        schedule(this);
        return ret;
    };
    return cache;
};
/**
* @internal
* A version of StrongCache that will auto-schedule a cleanup of the cache when
* a new item is added and the cache reached maximum size.
* Throttled to once per 100ms.
*
* @privateRemarks
* Should be used throughout the rest of the codebase instead of StrongCache,
* with the notable exception of usage in `wrap` from `optimism` - that one
* already handles cleanup and should remain a `StrongCache`.
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
const AutoCleanedStrongCache = function (max, dispose) {
    /*
    Some builds of `StrongCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */
    const cache = new _wry_caches__WEBPACK_IMPORTED_MODULE_1__/* .StrongCache */.e(max, dispose);
    cache.set = function (key, value) {
        const ret = _wry_caches__WEBPACK_IMPORTED_MODULE_1__/* .StrongCache.prototype.set.call */.e.prototype.set.call(this, key, value);
        schedule(this);
        return ret;
    };
    return cache;
};
//# sourceMappingURL=caches.js.map


}),
48537: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  A: () => (checkDocument)
});
/* ESM import */var _wry_caches__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53077);
/* ESM import */var graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51371);
/* ESM import */var graphql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44361);
/* ESM import */var optimism__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11349);
/* ESM import */var _apollo_client_utilities_environment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64744);
/* ESM import */var _apollo_client_utilities_invariant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85401);
/* ESM import */var _caching_sizes_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15313);
/* ESM import */var _getOperationName_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26802);
// Checks the document for errors and throws an exception if there is an error.







/**
* Checks the document for errors and throws an exception if there is an error.
*
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
const checkDocument = (0,optimism__WEBPACK_IMPORTED_MODULE_0__/* .wrap */.re)((doc, expectedType) => {
    (0,_apollo_client_utilities_invariant__WEBPACK_IMPORTED_MODULE_1__/* .invariant */.kG)(doc && doc.kind === "Document", 1);
    const operations = doc.definitions.filter((d) => d.kind === "OperationDefinition");
    if (_apollo_client_utilities_environment__WEBPACK_IMPORTED_MODULE_2__/* .__DEV__ */.T) {
        doc.definitions.forEach((definition) => {
            if (definition.kind !== "OperationDefinition" &&
                definition.kind !== "FragmentDefinition") {
                throw (0,_apollo_client_utilities_invariant__WEBPACK_IMPORTED_MODULE_1__/* .newInvariantError */._K)(2, definition.kind);
            }
        });
        (0,_apollo_client_utilities_invariant__WEBPACK_IMPORTED_MODULE_1__/* .invariant */.kG)(operations.length <= 1, 3, operations.length);
    }
    if (expectedType) {
        (0,_apollo_client_utilities_invariant__WEBPACK_IMPORTED_MODULE_1__/* .invariant */.kG)(
            operations.length == 1 && operations[0].operation === expectedType,
            4,
            expectedType,
            expectedType,
            operations[0].operation
        );
    }
    (0,graphql__WEBPACK_IMPORTED_MODULE_3__/* .visit */.Vn)(doc, {
        Field(field, _, __, path) {
            if (field.alias &&
                (field.alias.value === "__typename" ||
                    field.alias.value.startsWith("__ac_")) &&
                field.alias.value !== field.name.value) {
                // not using `invariant` so path calculation only happens in error case
                let current = doc, fieldPath = [];
                for (const key of path) {
                    current = current[key];
                    if (current.kind === graphql__WEBPACK_IMPORTED_MODULE_4__/* .Kind.FIELD */.h.FIELD) {
                        fieldPath.push(current.alias?.value || current.name.value);
                    }
                }
                fieldPath.splice(-1, 1, field.name.value);
                throw (0,_apollo_client_utilities_invariant__WEBPACK_IMPORTED_MODULE_1__/* .newInvariantError */._K)(
                    5,
                    field.alias.value,
                    fieldPath.join("."),
                    operations[0].operation,
                    (0,_getOperationName_js__WEBPACK_IMPORTED_MODULE_5__/* .getOperationName */.r)(doc, "(anonymous)")
                );
            }
        },
    });
}, {
    max: _caching_sizes_js__WEBPACK_IMPORTED_MODULE_6__/* .cacheSizes.checkDocument */.Q.checkDocument || 2000 /* defaultCacheSizes["checkDocument"] */,
    cache: _wry_caches__WEBPACK_IMPORTED_MODULE_7__/* .WeakCache */.k,
});
//# sourceMappingURL=checkDocument.js.map


}),
94169: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  o: () => (compact)
});
/**
* Merges the provided objects shallowly and removes
* all properties with an `undefined` value
*
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function compact(...objects) {
    const result = {};
    objects.forEach((obj) => {
        if (!obj)
            return;
        Object.keys(obj).forEach((key) => {
            const value = obj[key];
            if (value !== void 0) {
                result[key] = value;
            }
        });
    });
    return result;
}
//# sourceMappingURL=compact.js.map


}),
21956: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  F: () => (createFragmentMap)
});
/**
* Utility function that takes a list of fragment definitions and makes a hash out of them
* that maps the name of the fragment to the fragment definition.
*
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function createFragmentMap(fragments = []) {
    const symTable = {};
    fragments.forEach((fragment) => {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
//# sourceMappingURL=createFragmentMap.js.map


}),
5087: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  k: () => (getFragmentDefinitions)
});
/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function getFragmentDefinitions(doc) {
    return doc.definitions.filter((definition) => definition.kind === "FragmentDefinition");
}
//# sourceMappingURL=getFragmentDefinitions.js.map


}),
2918: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  p: () => (getMainDefinition)
});
/* ESM import */var _apollo_client_utilities_invariant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85401);
/* ESM import */var _checkDocument_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48537);


/**
 * Returns the first operation definition from a GraphQL document. The function
 * prioritizes operation definitions over fragment definitions, which makes it
 * suitable for documents that may contain both. If no operation definition is
 * found, the first fragment definition will be returned. If no definitions are
 * found, an error is thrown.
 *
 * @remarks
 *
 * Use this function when you need to perform more advanced tasks with the main
 * definition AST node. If you want to determine when a document is a specific
 * operation type, prefer the `isQueryOperation`, `isMutationOperation`, and
 * `isSubscriptionOperation` utility functions instead.
 *
 * @param queryDoc - The GraphQL document to extract the definition from
 * @returns The main operation or fragment definition AST node
 *
 * @example
 *
 * ```ts
 * import { gql } from "@apollo/client";
 * import { getMainDefinition } from "@apollo/client/utilities";
 *
 * const query = gql`
 *   query GetUser($id: ID!) {
 *     user(id: $id) {
 *       name
 *       email
 *     }
 *   }
 * `;
 *
 * const definition = getMainDefinition(query);
 * ```
 *
 * @throws When the document contains no operation or fragment definitions
 */
function getMainDefinition(queryDoc) {
    (0,_checkDocument_js__WEBPACK_IMPORTED_MODULE_0__/* .checkDocument */.A)(queryDoc);
    let fragmentDefinition;
    for (let definition of queryDoc.definitions) {
        if (definition.kind === "OperationDefinition") {
            return definition;
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) {
            // we do this because we want to allow multiple fragment definitions
            // to precede an operation definition.
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw (0,_apollo_client_utilities_invariant__WEBPACK_IMPORTED_MODULE_1__/* .newInvariantError */._K)(12);
}
//# sourceMappingURL=getMainDefinition.js.map


}),
56552: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  zP: () => (registerGlobalCache)
});


const globalCaches = {};
function registerGlobalCache(name, getSize) {
    globalCaches[name] = getSize;
}
/**
* For internal purposes only - please call `ApolloClient.getMemoryInternals` instead
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
const getApolloClientMemoryInternals = (/* unused pure expression or super */ null && (__DEV__ ?
    _getApolloClientMemoryInternals
    : undefined));
/**
* For internal purposes only - please call `ApolloClient.getMemoryInternals` instead
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
const getInMemoryCacheMemoryInternals = (/* unused pure expression or super */ null && (__DEV__ ?
    _getInMemoryCacheMemoryInternals
    : undefined));
/**
* For internal purposes only - please call `ApolloClient.getMemoryInternals` instead
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
const getApolloCacheMemoryInternals = (/* unused pure expression or super */ null && (__DEV__ ?
    _getApolloCacheMemoryInternals
    : undefined));
function getCurrentCacheSizes() {
    // `defaultCacheSizes` is a `const enum` that will be inlined during build, so we have to reconstruct it's shape here
    const defaults = {
        canonicalStringify: 1000 /* defaultCacheSizes["canonicalStringify"] */,
        checkDocument: 2000 /* defaultCacheSizes["checkDocument"] */,
        print: 2000 /* defaultCacheSizes["print"] */,
        "documentTransform.cache": 2000 /* defaultCacheSizes["documentTransform.cache"] */,
        "queryManager.getDocumentInfo": 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */,
        "PersistedQueryLink.persistedQueryHashes": 2000 /* defaultCacheSizes["PersistedQueryLink.persistedQueryHashes"] */,
        "fragmentRegistry.transform": 2000 /* defaultCacheSizes["fragmentRegistry.transform"] */,
        "fragmentRegistry.lookup": 1000 /* defaultCacheSizes["fragmentRegistry.lookup"] */,
        "fragmentRegistry.findFragmentSpreads": 4000 /* defaultCacheSizes["fragmentRegistry.findFragmentSpreads"] */,
        "cache.fragmentQueryDocuments": 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */,
        "removeTypenameFromVariables.getVariableDefinitions": 2000 /* defaultCacheSizes["removeTypenameFromVariables.getVariableDefinitions"] */,
        "inMemoryCache.maybeBroadcastWatch": 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */,
        "inMemoryCache.executeSelectionSet": 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */,
        "inMemoryCache.executeSubSelectedArray": 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */,
    };
    return Object.fromEntries(Object.entries(defaults).map(([k, v]) => [
        k,
        cacheSizes[k] || v,
    ]));
}
function _getApolloClientMemoryInternals() {
    if (!__DEV__)
        throw new Error("only supported in development mode");
    return {
        limits: getCurrentCacheSizes(),
        sizes: {
            print: globalCaches.print?.(),
            canonicalStringify: globalCaches.canonicalStringify?.(),
            links: linkInfo(this.link),
            queryManager: {
                getDocumentInfo: this["queryManager"]["transformCache"].size,
                documentTransforms: transformInfo(this["queryManager"].documentTransform),
            },
            ...this.cache.getMemoryInternals?.(),
        },
    };
}
function _getApolloCacheMemoryInternals() {
    return {
        cache: {
            fragmentQueryDocuments: getWrapperInformation(this["getFragmentDoc"]),
        },
    };
}
function _getInMemoryCacheMemoryInternals() {
    const fragments = this.config.fragments;
    return {
        ..._getApolloCacheMemoryInternals.apply(this),
        addTypenameDocumentTransform: transformInfo(this["addTypenameTransform"]),
        inMemoryCache: {
            executeSelectionSet: getWrapperInformation(this["storeReader"]["executeSelectionSet"]),
            executeSubSelectedArray: getWrapperInformation(this["storeReader"]["executeSubSelectedArray"]),
            maybeBroadcastWatch: getWrapperInformation(this["maybeBroadcastWatch"]),
        },
        fragmentRegistry: {
            findFragmentSpreads: getWrapperInformation(fragments?.findFragmentSpreads),
            lookup: getWrapperInformation(fragments?.lookup),
            transform: getWrapperInformation(fragments?.transform),
        },
    };
}
function isWrapper(f) {
    return !!f && "dirtyKey" in f;
}
function getWrapperInformation(f) {
    return isWrapper(f) ? f.size : undefined;
}
function isDefined(value) {
    return value != null;
}
function transformInfo(transform) {
    return recurseTransformInfo(transform).map((cache) => ({ cache }));
}
function recurseTransformInfo(transform) {
    return transform ?
        [
            getWrapperInformation(transform?.["performWork"]),
            ...recurseTransformInfo(transform?.["left"]),
            ...recurseTransformInfo(transform?.["right"]),
        ].filter(isDefined)
        : [];
}
function linkInfo(link) {
    return link ?
        [
            link?.getMemoryInternals?.(),
            ...linkInfo(link?.left),
            ...linkInfo(link?.right),
        ].filter(isDefined)
        : [];
}
//# sourceMappingURL=getMemoryInternals.js.map


}),
76260: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  $: () => (getOperationDefinition)
});
/* ESM import */var _checkDocument_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48537);

/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function getOperationDefinition(doc) {
    (0,_checkDocument_js__WEBPACK_IMPORTED_MODULE_0__/* .checkDocument */.A)(doc);
    return doc.definitions.filter((definition) => definition.kind === "OperationDefinition")[0];
}
//# sourceMappingURL=getOperationDefinition.js.map


}),
26802: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  r: () => (getOperationName)
});
/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function getOperationName(doc, fallback) {
    return (doc.definitions.find((definition) => definition.kind === "OperationDefinition" && !!definition.name)?.name.value ?? fallback);
}
//# sourceMappingURL=getOperationName.js.map


}),
97027: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  Z: () => (__WEBPACK_DEFAULT_EXPORT__)
});
/* ESM import */var _maybe_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33089);

/* ESM default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((// We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
(0,_maybe_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */.w)(() => globalThis) ||
    (0,_maybe_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */.w)(() => window) ||
    (0,_maybe_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */.w)(() => self) ||
    (0,_maybe_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */.w)(() => global) || // improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
(0,_maybe_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */.w)(function () {
    return _maybe_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe.constructor */.w.constructor("return this")();
})));
//# sourceMappingURL=global.js.map


}),
33089: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  w: () => (maybe)
});
function maybe(thunk) {
    try {
        return thunk();
    }
    catch { }
}
//# sourceMappingURL=maybe.js.map

}),
27184: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  F: () => (hasDirectives)
});
/* ESM import */var graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51371);

/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function hasDirectives(names, root, all) {
    const nameSet = new Set(names);
    const uniqueCount = nameSet.size;
    (0,graphql__WEBPACK_IMPORTED_MODULE_0__/* .visit */.Vn)(root, {
        Directive(node) {
            if (nameSet.delete(node.name.value) && (!all || !nameSet.size)) {
                return graphql__WEBPACK_IMPORTED_MODULE_0__/* .BREAK */.$_;
            }
        },
    });
    // If we found all the names, nameSet will be empty. If we only care about
    // finding some of them, the < condition is sufficient.
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
//# sourceMappingURL=hasDirectives.js.map


}),
46145: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  s: () => (isNonNullObject)
});
/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function isNonNullObject(obj) {
    return obj !== null && typeof obj === "object";
}
//# sourceMappingURL=isNonNullObject.js.map


}),
7671: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  X: () => (makeUniqueId)
});
const prefixCounts = new Map();
/**
* These IDs won't be globally unique, but they will be unique within this
* process, thanks to the counter, and unguessable thanks to the random suffix.
*
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function makeUniqueId(prefix) {
    const count = prefixCounts.get(prefix) || 1;
    prefixCounts.set(prefix, count + 1);
    return `${prefix}:${count}:${Math.random().toString(36).slice(2)}`;
}
//# sourceMappingURL=makeUniqueId.js.map


}),
89465: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  b: () => (mergeDeepArray)
});
/* ESM import */var _DeepMerger_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19317);

// In almost any situation where you could succeed in getting the
// TypeScript compiler to infer a tuple type for the sources array, you
// could just use mergeDeep instead of mergeDeepArray, so instead of
// trying to convert T[] to an intersection type we just infer the array
// element type, which works perfectly when the sources array has a
// consistent element type.
/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function mergeDeepArray(sources) {
    let target = sources[0] || {};
    const count = sources.length;
    if (count > 1) {
        const merger = new _DeepMerger_js__WEBPACK_IMPORTED_MODULE_0__/* .DeepMerger */.w();
        for (let i = 1; i < count; ++i) {
            target = merger.merge(target, sources[i]);
        }
    }
    return target;
}
//# sourceMappingURL=mergeDeepArray.js.map


}),
87193: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  u: () => (resultKeyNameFromField)
});
/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
//# sourceMappingURL=resultKeyNameFromField.js.map


}),
32303: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  L: () => (shouldInclude)
});
/* ESM import */var _apollo_client_utilities_invariant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85401);

/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function shouldInclude({ directives }, variables) {
    if (!directives || !directives.length) {
        return true;
    }
    return getInclusionDirectives(directives).every(({ directive, ifArgument }) => {
        let evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue =
                variables && variables[ifArgument.value.name.value];
            (0,_apollo_client_utilities_invariant__WEBPACK_IMPORTED_MODULE_0__/* .invariant */.kG)(evaledValue !== void 0, 15, directive.name.value);
        }
        else {
            evaledValue = ifArgument.value.value;
        }
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function isInclusionDirective({ name: { value } }) {
    return value === "skip" || value === "include";
}
function getInclusionDirectives(directives) {
    const result = [];
    if (directives && directives.length) {
        directives.forEach((directive) => {
            if (!isInclusionDirective(directive))
                return;
            const directiveArguments = directive.arguments;
            const directiveName = directive.name.value;
            (0,_apollo_client_utilities_invariant__WEBPACK_IMPORTED_MODULE_0__/* .invariant */.kG)(directiveArguments && directiveArguments.length === 1, 16, directiveName);
            const ifArgument = directiveArguments[0];
            (0,_apollo_client_utilities_invariant__WEBPACK_IMPORTED_MODULE_0__/* .invariant */.kG)(ifArgument.name && ifArgument.name.value === "if", 17, directiveName);
            const ifValue = ifArgument.value;
            // means it has to be a variable value if this is a valid @skip or @include directive
            (0,_apollo_client_utilities_invariant__WEBPACK_IMPORTED_MODULE_0__/* .invariant */.kG)(ifValue &&
                (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 18, directiveName);
            result.push({ directive, ifArgument });
        });
    }
    return result;
}
//# sourceMappingURL=shouldInclude.js.map


}),
81654: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  v: () => (stringifyForDisplay)
});
/* ESM import */var _makeUniqueId_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7671);

/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function stringifyForDisplay(value, space = 0) {
    const undefId = (0,_makeUniqueId_js__WEBPACK_IMPORTED_MODULE_0__/* .makeUniqueId */.X)("stringifyForDisplay");
    return JSON.stringify(value, (_, value) => {
        return value === void 0 ? undefId : value;
    }, space)
        .split(JSON.stringify(undefId))
        .join("<undefined>");
}
//# sourceMappingURL=stringifyForDisplay.js.map


}),
21124: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  v: () => (valueToObjectRepresentation)
});
/* ESM import */var graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44361);
/* ESM import */var _apollo_client_utilities_invariant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85401);


/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (value.kind === graphql__WEBPACK_IMPORTED_MODULE_0__/* .Kind.INT */.h.INT || value.kind === graphql__WEBPACK_IMPORTED_MODULE_0__/* .Kind.FLOAT */.h.FLOAT) {
        argObj[name.value] = Number(value.value);
    }
    else if (value.kind === graphql__WEBPACK_IMPORTED_MODULE_0__/* .Kind.BOOLEAN */.h.BOOLEAN || value.kind === graphql__WEBPACK_IMPORTED_MODULE_0__/* .Kind.STRING */.h.STRING) {
        argObj[name.value] = value.value;
    }
    else if (value.kind === graphql__WEBPACK_IMPORTED_MODULE_0__/* .Kind.OBJECT */.h.OBJECT) {
        const nestedArgObj = {};
        value.fields.map((obj) => valueToObjectRepresentation(nestedArgObj, obj.name, obj.value, variables));
        argObj[name.value] = nestedArgObj;
    }
    else if (value.kind === graphql__WEBPACK_IMPORTED_MODULE_0__/* .Kind.VARIABLE */.h.VARIABLE) {
        const variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (value.kind === graphql__WEBPACK_IMPORTED_MODULE_0__/* .Kind.LIST */.h.LIST) {
        argObj[name.value] = value.values.map((listValue) => {
            const nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (value.kind === graphql__WEBPACK_IMPORTED_MODULE_0__/* .Kind.ENUM */.h.ENUM) {
        argObj[name.value] = value.value;
    }
    else if (value.kind === graphql__WEBPACK_IMPORTED_MODULE_0__/* .Kind.NULL */.h.NULL) {
        argObj[name.value] = null;
    }
    else {
        throw (0,_apollo_client_utilities_invariant__WEBPACK_IMPORTED_MODULE_1__/* .newInvariantError */._K)(19, name.value, value.kind);
    }
}
//# sourceMappingURL=valueToObjectRepresentation.js.map


}),
85401: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  U6: () => (setVerbosity),
  _K: () => (newInvariantError),
  kG: () => (invariant)
});
/* ESM import */var _apollo_client_utilities_environment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64744);
/* ESM import */var _apollo_client_utilities_internal_globals__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97027);
/* ESM import */var _version_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81293);
/* ESM import */var _internal_stringifyForDisplay_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81654);



// eslint-disable-next-line local-rules/import-from-inside-other-export

const genericMessage = "Invariant Violation";
class InvariantError extends Error {
    constructor(message = genericMessage) {
        super(message);
        this.name = genericMessage;
        Object.setPrototypeOf(this, InvariantError.prototype);
    }
}
const verbosityLevels = ["debug", "log", "warn", "error", "silent"];
let verbosityLevel = verbosityLevels.indexOf(_apollo_client_utilities_environment__WEBPACK_IMPORTED_MODULE_0__/* .__DEV__ */.T ? "log" : "silent");
function invariant(condition, ...args) {
    if (!condition) {
        throw newInvariantError(...args);
    }
}
function wrapConsoleMethod(name) {
    return function (message, ...args) {
        if (verbosityLevels.indexOf(name) >= verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            const method = console[name] || console.log;
            if (typeof message === "number") {
                const arg0 = message;
                message = getHandledErrorMsg(arg0);
                if (!message) {
                    message = getFallbackErrorMsg(arg0, args);
                    args = [];
                }
            }
            method(message, ...args);
        }
    };
}
invariant.debug = wrapConsoleMethod("debug");
invariant.log = wrapConsoleMethod("log");
invariant.warn = wrapConsoleMethod("warn");
invariant.error = wrapConsoleMethod("error");
function setVerbosity(level) {
    const old = verbosityLevels[verbosityLevel];
    verbosityLevel = Math.max(0, verbosityLevels.indexOf(level));
    return old;
}
/**
 * Returns an InvariantError.
 *
 * `message` can only be a string, a concatenation of strings, or a ternary statement
 * that results in a string. This will be enforced on build, where the message will
 * be replaced with a message number.
 * String substitutions with %s are supported and will also return
 * pretty-stringified objects.
 * Excess `optionalParams` will be swallowed.
 */
function newInvariantError(message, ...optionalParams) {
    return new InvariantError(getHandledErrorMsg(message, optionalParams) ||
        getFallbackErrorMsg(message, optionalParams));
}
// This is duplicated between `@apollo/client/dev` and `@apollo/client/utilities/invariant` to prevent circular references.
const ApolloErrorMessageHandler = Symbol.for("ApolloErrorMessageHandler_" + _version_js__WEBPACK_IMPORTED_MODULE_1__/* .version */.i);
function stringify(arg) {
    if (typeof arg == "string") {
        return arg;
    }
    try {
        return (0,_internal_stringifyForDisplay_js__WEBPACK_IMPORTED_MODULE_2__/* .stringifyForDisplay */.v)(arg, 2).slice(0, 1000);
    }
    catch {
        return "<non-serializable>";
    }
}
function getHandledErrorMsg(message, messageArgs = []) {
    if (!message)
        return;
    return (_apollo_client_utilities_internal_globals__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */.Z[ApolloErrorMessageHandler] &&
        _apollo_client_utilities_internal_globals__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */.Z[ApolloErrorMessageHandler](message, messageArgs.map(stringify)));
}
function getFallbackErrorMsg(message, messageArgs = []) {
    if (!message)
        return;
    if (typeof message === "string") {
        return messageArgs.reduce((msg, arg) => msg.replace(/%[sdfo]/, stringify(arg)), message);
    }
    return `An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#${encodeURIComponent(JSON.stringify({
        version: _version_js__WEBPACK_IMPORTED_MODULE_1__/* .version */.i,
        message,
        args: messageArgs.map(stringify),
    }))}`;
}
//# sourceMappingURL=index.js.map

}),
81293: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  J: () => (build),
  i: () => (version)
});
const version = "4.0.8";
const build = "esm";
//# sourceMappingURL=version.js.map


}),
59831: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  e: () => (StrongCache)
});
function defaultDispose() { }
class StrongCache {
    constructor(max = Infinity, dispose = defaultDispose) {
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    get size() {
        return this.map.size;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older, newer } = node;
            if (newer) {
                newer.older = older;
            }
            if (older) {
                older.newer = newer;
            }
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) {
                this.oldest = newer;
            }
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) {
            return node.value = value;
        }
        node = {
            key,
            value,
            newer: null,
            older: this.newest
        };
        if (this.newest) {
            this.newest.newer = node;
        }
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    }
    clean() {
        while (this.oldest && this.map.size > this.max) {
            this.delete(this.oldest.key);
        }
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            if (node === this.newest) {
                this.newest = node.older;
            }
            if (node === this.oldest) {
                this.oldest = node.newer;
            }
            if (node.newer) {
                node.newer.older = node.older;
            }
            if (node.older) {
                node.older.newer = node.newer;
            }
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    }
}
//# sourceMappingURL=strong.js.map

}),
53077: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  k: () => (WeakCache)
});
function noop() { }
const defaultDispose = noop;
const _WeakRef = typeof WeakRef !== "undefined"
    ? WeakRef
    : function (value) {
        return { deref: () => value };
    };
const _WeakMap = typeof WeakMap !== "undefined" ? WeakMap : Map;
const _FinalizationRegistry = typeof FinalizationRegistry !== "undefined"
    ? FinalizationRegistry
    : function () {
        return {
            register: noop,
            unregister: noop,
        };
    };
const finalizationBatchSize = 10024;
class WeakCache {
    constructor(max = Infinity, dispose = defaultDispose) {
        this.max = max;
        this.dispose = dispose;
        this.map = new _WeakMap();
        this.newest = null;
        this.oldest = null;
        this.unfinalizedNodes = new Set();
        this.finalizationScheduled = false;
        this.size = 0;
        this.finalize = () => {
            const iterator = this.unfinalizedNodes.values();
            for (let i = 0; i < finalizationBatchSize; i++) {
                const node = iterator.next().value;
                if (!node)
                    break;
                this.unfinalizedNodes.delete(node);
                const key = node.key;
                delete node.key;
                node.keyRef = new _WeakRef(key);
                this.registry.register(key, node, node);
            }
            if (this.unfinalizedNodes.size > 0) {
                queueMicrotask(this.finalize);
            }
            else {
                this.finalizationScheduled = false;
            }
        };
        this.registry = new _FinalizationRegistry(this.deleteNode.bind(this));
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older, newer } = node;
            if (newer) {
                newer.older = older;
            }
            if (older) {
                older.newer = newer;
            }
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) {
                this.oldest = newer;
            }
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) {
            return (node.value = value);
        }
        node = {
            key,
            value,
            newer: null,
            older: this.newest,
        };
        if (this.newest) {
            this.newest.newer = node;
        }
        this.newest = node;
        this.oldest = this.oldest || node;
        this.scheduleFinalization(node);
        this.map.set(key, node);
        this.size++;
        return node.value;
    }
    clean() {
        while (this.oldest && this.size > this.max) {
            this.deleteNode(this.oldest);
        }
    }
    deleteNode(node) {
        if (node === this.newest) {
            this.newest = node.older;
        }
        if (node === this.oldest) {
            this.oldest = node.newer;
        }
        if (node.newer) {
            node.newer.older = node.older;
        }
        if (node.older) {
            node.older.newer = node.newer;
        }
        this.size--;
        const key = node.key || (node.keyRef && node.keyRef.deref());
        this.dispose(node.value, key);
        if (!node.keyRef) {
            this.unfinalizedNodes.delete(node);
        }
        else {
            this.registry.unregister(node);
        }
        if (key)
            this.map.delete(key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            this.deleteNode(node);
            return true;
        }
        return false;
    }
    scheduleFinalization(node) {
        this.unfinalizedNodes.add(node);
        if (!this.finalizationScheduled) {
            this.finalizationScheduled = true;
            queueMicrotask(this.finalize);
        }
    }
}
//# sourceMappingURL=weak.js.map

}),
3606: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  a: () => (devAssert)
});
function devAssert(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(message);
  }
}


}),
44498: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  X: () => (inspect)
});
const MAX_ARRAY_LENGTH = 10;
const MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (typeof value) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? `[function ${value.name}]` : '[function]';

    case 'object':
      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (value === null) {
    return 'null';
  }

  if (previouslySeenValues.includes(value)) {
    return '[Circular]';
  }

  const seenValues = [...previouslySeenValues, value];

  if (isJSONable(value)) {
    const jsonValue = value.toJSON(); // check for infinite recursion

    if (jsonValue !== value) {
      return typeof jsonValue === 'string'
        ? jsonValue
        : formatValue(jsonValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function isJSONable(value) {
  return typeof value.toJSON === 'function';
}

function formatObject(object, seenValues) {
  const entries = Object.entries(object);

  if (entries.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  const properties = entries.map(
    ([key, value]) => key + ': ' + formatValue(value, seenValues),
  );
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  const len = Math.min(MAX_ARRAY_LENGTH, array.length);
  const remaining = array.length - len;
  const items = [];

  for (let i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push(`... ${remaining} more items`);
  }

  return '[' + items.join(', ') + ']';
}

function getObjectTag(object) {
  const tag = Object.prototype.toString
    .call(object)
    .replace(/^\[object /, '')
    .replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    const name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}


}),
61432: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  UG: () => (isNode),
  WU: () => (Token),
  Ye: () => (Location),
  h8: () => (QueryDocumentKeys),
  ku: () => (OperationTypeNode)
});
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
class Location {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  constructor(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  get [Symbol.toStringTag]() {
    return 'Location';
  }

  toJSON() {
    return {
      start: this.start,
      end: this.end,
    };
  }
}
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

class Token {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(kind, start, end, line, column, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

    this.value = value;
    this.prev = null;
    this.next = null;
  }

  get [Symbol.toStringTag]() {
    return 'Token';
  }

  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column,
    };
  }
}
/**
 * The list of all possible AST node types.
 */

/**
 * @internal
 */
const QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: [
    'name',
    'variableDefinitions',
    'directives',
    'selectionSet',
  ],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: [
    'name', // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    'variableDefinitions',
    'typeCondition',
    'directives',
    'selectionSet',
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: [
    'description',
    'name',
    'type',
    'defaultValue',
    'directives',
  ],
  InterfaceTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields'],
};
const kindValues = new Set(Object.keys(QueryDocumentKeys));
/**
 * @internal
 */

function isNode(maybeNode) {
  const maybeKind =
    maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
  return typeof maybeKind === 'string' && kindValues.has(maybeKind);
}
/** Name */

var OperationTypeNode;

(function (OperationTypeNode) {
  OperationTypeNode['QUERY'] = 'query';
  OperationTypeNode['MUTATION'] = 'mutation';
  OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})(OperationTypeNode || (OperationTypeNode = {}));




}),
44885: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  LZ: () => (printBlockString),
  wv: () => (dedentBlockStringLines)
});
/* ESM import */var _characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56763);

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */

function dedentBlockStringLines(lines) {
  var _firstNonEmptyLine2;

  let commonIndent = Number.MAX_SAFE_INTEGER;
  let firstNonEmptyLine = null;
  let lastNonEmptyLine = -1;

  for (let i = 0; i < lines.length; ++i) {
    var _firstNonEmptyLine;

    const line = lines[i];
    const indent = leadingWhitespace(line);

    if (indent === line.length) {
      continue; // skip empty lines
    }

    firstNonEmptyLine =
      (_firstNonEmptyLine = firstNonEmptyLine) !== null &&
      _firstNonEmptyLine !== void 0
        ? _firstNonEmptyLine
        : i;
    lastNonEmptyLine = i;

    if (i !== 0 && indent < commonIndent) {
      commonIndent = indent;
    }
  }

  return lines // Remove common indentation from all lines but first.
    .map((line, i) => (i === 0 ? line : line.slice(commonIndent))) // Remove leading and trailing blank lines.
    .slice(
      (_firstNonEmptyLine2 = firstNonEmptyLine) !== null &&
        _firstNonEmptyLine2 !== void 0
        ? _firstNonEmptyLine2
        : 0,
      lastNonEmptyLine + 1,
    );
}

function leadingWhitespace(str) {
  let i = 0;

  while (i < str.length && (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */.FD)(str.charCodeAt(i))) {
    ++i;
  }

  return i;
}
/**
 * @internal
 */

function isPrintableAsBlockString(value) {
  if (value === '') {
    return true; // empty string is printable
  }

  let isEmptyLine = true;
  let hasIndent = false;
  let hasCommonIndent = true;
  let seenNonEmptyLine = false;

  for (let i = 0; i < value.length; ++i) {
    switch (value.codePointAt(i)) {
      case 0x0000:
      case 0x0001:
      case 0x0002:
      case 0x0003:
      case 0x0004:
      case 0x0005:
      case 0x0006:
      case 0x0007:
      case 0x0008:
      case 0x000b:
      case 0x000c:
      case 0x000e:
      case 0x000f:
        return false;
      // Has non-printable characters

      case 0x000d:
        //  \r
        return false;
      // Has \r or \r\n which will be replaced as \n

      case 10:
        //  \n
        if (isEmptyLine && !seenNonEmptyLine) {
          return false; // Has leading new line
        }

        seenNonEmptyLine = true;
        isEmptyLine = true;
        hasIndent = false;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        hasIndent || (hasIndent = isEmptyLine);
        break;

      default:
        hasCommonIndent && (hasCommonIndent = hasIndent);
        isEmptyLine = false;
    }
  }

  if (isEmptyLine) {
    return false; // Has trailing empty lines
  }

  if (hasCommonIndent && seenNonEmptyLine) {
    return false; // Has internal indent
  }

  return true;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value, options) {
  const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.

  const lines = escapedValue.split(/\r\n|[\n\r]/g);
  const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line

  const forceLeadingNewLine =
    lines.length > 1 &&
    lines
      .slice(1)
      .every((line) => line.length === 0 || (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */.FD)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line

  const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line

  const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
  const hasTrailingSlash = value.endsWith('\\');
  const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
  const printAsMultipleLines =
    !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine ||
      value.length > 70 ||
      forceTrailingNewline ||
      forceLeadingNewLine ||
      hasTrailingTripleQuotes);
  let result = ''; // Format a multi-line block quote to account for leading space.

  const skipLeadingNewLine = isSingleLine && (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */.FD)(value.charCodeAt(0));

  if ((printAsMultipleLines && !skipLeadingNewLine) || forceLeadingNewLine) {
    result += '\n';
  }

  result += escapedValue;

  if (printAsMultipleLines || forceTrailingNewline) {
    result += '\n';
  }

  return '"""' + result + '"""';
}


}),
56763: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  FD: () => (isWhiteSpace),
  HQ: () => (isNameContinue),
  LQ: () => (isNameStart),
  X1: () => (isDigit)
});
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */
function isWhiteSpace(code) {
  return code === 0x0009 || code === 0x0020;
}
/**
 * ```
 * Digit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 * ```
 * @internal
 */

function isDigit(code) {
  return code >= 0x0030 && code <= 0x0039;
}
/**
 * ```
 * Letter :: one of
 *   - `A` `B` `C` `D` `E` `F` `G` `H` `I` `J` `K` `L` `M`
 *   - `N` `O` `P` `Q` `R` `S` `T` `U` `V` `W` `X` `Y` `Z`
 *   - `a` `b` `c` `d` `e` `f` `g` `h` `i` `j` `k` `l` `m`
 *   - `n` `o` `p` `q` `r` `s` `t` `u` `v` `w` `x` `y` `z`
 * ```
 * @internal
 */

function isLetter(code) {
  return (
    (code >= 0x0061 && code <= 0x007a) || // A-Z
    (code >= 0x0041 && code <= 0x005a) // a-z
  );
}
/**
 * ```
 * NameStart ::
 *   - Letter
 *   - `_`
 * ```
 * @internal
 */

function isNameStart(code) {
  return isLetter(code) || code === 0x005f;
}
/**
 * ```
 * NameContinue ::
 *   - Letter
 *   - Digit
 *   - `_`
 * ```
 * @internal
 */

function isNameContinue(code) {
  return isLetter(code) || isDigit(code) || code === 0x005f;
}


}),
44361: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  h: () => (Kind)
});
/**
 * The set of allowed kind values for AST nodes.
 */
var Kind;

(function (Kind) {
  Kind['NAME'] = 'Name';
  Kind['DOCUMENT'] = 'Document';
  Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
  Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
  Kind['SELECTION_SET'] = 'SelectionSet';
  Kind['FIELD'] = 'Field';
  Kind['ARGUMENT'] = 'Argument';
  Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
  Kind['INLINE_FRAGMENT'] = 'InlineFragment';
  Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
  Kind['VARIABLE'] = 'Variable';
  Kind['INT'] = 'IntValue';
  Kind['FLOAT'] = 'FloatValue';
  Kind['STRING'] = 'StringValue';
  Kind['BOOLEAN'] = 'BooleanValue';
  Kind['NULL'] = 'NullValue';
  Kind['ENUM'] = 'EnumValue';
  Kind['LIST'] = 'ListValue';
  Kind['OBJECT'] = 'ObjectValue';
  Kind['OBJECT_FIELD'] = 'ObjectField';
  Kind['DIRECTIVE'] = 'Directive';
  Kind['NAMED_TYPE'] = 'NamedType';
  Kind['LIST_TYPE'] = 'ListType';
  Kind['NON_NULL_TYPE'] = 'NonNullType';
  Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
  Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
  Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
  Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
  Kind['FIELD_DEFINITION'] = 'FieldDefinition';
  Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
  Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
  Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
  Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
  Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
  Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
  Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
  Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
  Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
  Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
  Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
  Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
  Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
  Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})(Kind || (Kind = {}));


/**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */


}),
51371: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  $_: () => (BREAK),
  Vn: () => (visit)
});
/* ESM import */var _jsutils_devAssert_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3606);
/* ESM import */var _jsutils_inspect_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44498);
/* ESM import */var _ast_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61432);
/* ESM import */var _kinds_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44361);




/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

const BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 * ```ts
 * const editedAST = visit(ast, {
 *   enter(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: skip visiting this node
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   },
 *   leave(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: no action
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   }
 * });
 * ```
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to three permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind(node) {
 *     // enter the "Kind" node
 *   }
 * })
 * ```
 *
 * 2) Named visitors that trigger upon entering and leaving a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind: {
 *     enter(node) {
 *       // enter the "Kind" node
 *     }
 *     leave(node) {
 *       // leave the "Kind" node
 *     }
 *   }
 * })
 * ```
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 * ```ts
 * visit(ast, {
 *   enter(node) {
 *     // enter any node
 *   },
 *   leave(node) {
 *     // leave any node
 *   }
 * })
 * ```
 */

function visit(root, visitor, visitorKeys = _ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .QueryDocumentKeys */.h8) {
  const enterLeaveMap = new Map();

  for (const kind of Object.values(_kinds_mjs__WEBPACK_IMPORTED_MODULE_1__/* .Kind */.h)) {
    enterLeaveMap.set(kind, getEnterLeaveForKind(visitor, kind));
  }
  /* eslint-disable no-undef-init */

  let stack = undefined;
  let inArray = Array.isArray(root);
  let keys = [root];
  let index = -1;
  let edits = [];
  let node = root;
  let key = undefined;
  let parent = undefined;
  const path = [];
  const ancestors = [];
  /* eslint-enable no-undef-init */

  do {
    index++;
    const isLeaving = index === keys.length;
    const isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
          let editOffset = 0;

          for (const [editKey, editValue] of edits) {
            const arrayKey = editKey - editOffset;

            if (editValue === null) {
              node.splice(arrayKey, 1);
              editOffset++;
            } else {
              node[arrayKey] = editValue;
            }
          }
        } else {
          node = { ...node };

          for (const [editKey, editValue] of edits) {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else if (parent) {
      key = inArray ? index : keys[index];
      node = parent[key];

      if (node === null || node === undefined) {
        continue;
      }

      path.push(key);
    }

    let result;

    if (!Array.isArray(node)) {
      var _enterLeaveMap$get, _enterLeaveMap$get2;

      (0,_ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isNode */.UG)(node) || (0,_jsutils_devAssert_mjs__WEBPACK_IMPORTED_MODULE_2__/* .devAssert */.a)(false, `Invalid AST Node: ${(0,_jsutils_inspect_mjs__WEBPACK_IMPORTED_MODULE_3__/* .inspect */.X)(node)}.`);
      const visitFn = isLeaving
        ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get === void 0
          ? void 0
          : _enterLeaveMap$get.leave
        : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get2 === void 0
        ? void 0
        : _enterLeaveMap$get2.enter;
      result =
        visitFn === null || visitFn === void 0
          ? void 0
          : visitFn.call(visitor, node, key, parent, path, ancestors);

      if (result === BREAK) {
        break;
      }

      if (result === false) {
        if (!isLeaving) {
          path.pop();
          continue;
        }
      } else if (result !== undefined) {
        edits.push([key, result]);

        if (!isLeaving) {
          if ((0,_ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isNode */.UG)(result)) {
            node = result;
          } else {
            path.pop();
            continue;
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _node$kind;

      stack = {
        inArray,
        index,
        keys,
        edits,
        prev: stack,
      };
      inArray = Array.isArray(node);
      keys = inArray
        ? node
        : (_node$kind = visitorKeys[node.kind]) !== null &&
          _node$kind !== void 0
        ? _node$kind
        : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    // New root
    return edits[edits.length - 1][1];
  }

  return root;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */

function visitInParallel(visitors) {
  const skipping = new Array(visitors.length).fill(null);
  const mergedVisitor = Object.create(null);

  for (const kind of Object.values(Kind)) {
    let hasVisitor = false;
    const enterList = new Array(visitors.length).fill(undefined);
    const leaveList = new Array(visitors.length).fill(undefined);

    for (let i = 0; i < visitors.length; ++i) {
      const { enter, leave } = getEnterLeaveForKind(visitors[i], kind);
      hasVisitor || (hasVisitor = enter != null || leave != null);
      enterList[i] = enter;
      leaveList[i] = leave;
    }

    if (!hasVisitor) {
      continue;
    }

    const mergedEnterLeave = {
      enter(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _enterList$i;

            const result =
              (_enterList$i = enterList[i]) === null || _enterList$i === void 0
                ? void 0
                : _enterList$i.apply(visitors[i], args);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      },

      leave(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _leaveList$i;

            const result =
              (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0
                ? void 0
                : _leaveList$i.apply(visitors[i], args);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          } else if (skipping[i] === node) {
            skipping[i] = null;
          }
        }
      },
    };
    mergedVisitor[kind] = mergedEnterLeave;
  }

  return mergedVisitor;
}
/**
 * Given a visitor instance and a node kind, return EnterLeaveVisitor for that kind.
 */

function getEnterLeaveForKind(visitor, kind) {
  const kindVisitor = visitor[kind];

  if (typeof kindVisitor === 'object') {
    // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
  } else if (typeof kindVisitor === 'function') {
    // { Kind() {} }
    return {
      enter: kindVisitor,
      leave: undefined,
    };
  } // { enter() {}, leave() {} }

  return {
    enter: visitor.enter,
    leave: visitor.leave,
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 *
 * @deprecated Please use `getEnterLeaveForKind` instead. Will be removed in v17
 */

/* c8 ignore next 8 */

function getVisitFn(visitor, kind, isLeaving) {
  const { enter, leave } = getEnterLeaveForKind(visitor, kind);
  return isLeaving ? leave : enter;
}


}),
11349: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  g7: () => (/* reexport */ slot_Slot),
  dP: () => (/* reexport */ dep_dep),
  re: () => (/* binding */ lib_wrap)
});

// UNUSED EXPORTS: setTimeout, asyncFromGen, bindContext, noContext, KeyTrie, nonReactive, defaultMakeCacheKey

;// CONCATENATED MODULE: ../../app/node_modules/optimism/node_modules/@wry/trie/lib/index.js
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const defaultMakeData = () => Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach, slice } = Array.prototype;
const { hasOwnProperty: lib_hasOwnProperty } = Object.prototype;
class Trie {
    constructor(weakness = true, makeData = defaultMakeData) {
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup(...array) {
        return this.lookupArray(array);
    }
    lookupArray(array) {
        let node = this;
        forEach.call(array, key => node = node.getChildTrie(key));
        return lib_hasOwnProperty.call(node, "data")
            ? node.data
            : node.data = this.makeData(slice.call(array));
    }
    peek(...array) {
        return this.peekArray(array);
    }
    peekArray(array) {
        let node = this;
        for (let i = 0, len = array.length; node && i < len; ++i) {
            const map = this.weakness && isObjRef(array[i]) ? node.weak : node.strong;
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    getChildTrie(key) {
        const map = this.weakness && isObjRef(key)
            ? this.weak || (this.weak = new WeakMap())
            : this.strong || (this.strong = new Map());
        let child = map.get(key);
        if (!child)
            map.set(key, child = new Trie(this.weakness, this.makeData));
        return child;
    }
}
function isObjRef(value) {
    switch (typeof value) {
        case "object":
            if (value === null)
                break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../app/node_modules/@wry/caches/lib/strong.js
var strong = __webpack_require__(59831);
;// CONCATENATED MODULE: ../../app/node_modules/@wry/context/lib/slot.js
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
let currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const MISSING_VALUE = {};
let idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const makeSlotClass = () => class Slot {
    constructor() {
        // If you have a Slot object, you can find out its slot.id, but you cannot
        // guess the slot.id of a Slot you don't have access to, thanks to the
        // randomized suffix.
        this.id = [
            "slot",
            idCounter++,
            Date.now(),
            Math.random().toString(36).slice(2),
        ].join(":");
    }
    hasValue() {
        for (let context = currentContext; context; context = context.parent) {
            // We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === MISSING_VALUE)
                    break;
                if (context !== currentContext) {
                    // Cache the value in currentContext.slots so the next lookup will
                    // be faster. This caching is safe because the tree of contexts and
                    // the values of the slots are logically immutable.
                    currentContext.slots[this.id] = value;
                }
                return true;
            }
        }
        if (currentContext) {
            // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            currentContext.slots[this.id] = MISSING_VALUE;
        }
        return false;
    }
    getValue() {
        if (this.hasValue()) {
            return currentContext.slots[this.id];
        }
    }
    withValue(value, callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        const slots = {
            __proto__: null,
            [this.id]: value,
        };
        const parent = currentContext;
        currentContext = { parent, slots };
        try {
            // Function.prototype.apply allows the arguments array argument to be
            // omitted or undefined, so args! is fine here.
            return callback.apply(thisArg, args);
        }
        finally {
            currentContext = parent;
        }
    }
    // Capture the current context and wrap a callback function so that it
    // reestablishes the captured context when called.
    static bind(callback) {
        const context = currentContext;
        return function () {
            const saved = currentContext;
            try {
                currentContext = context;
                return callback.apply(this, arguments);
            }
            finally {
                currentContext = saved;
            }
        };
    }
    // Immediately run a callback function without any captured context.
    static noContext(callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        if (currentContext) {
            const saved = currentContext;
            try {
                currentContext = null;
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            }
            finally {
                currentContext = saved;
            }
        }
        else {
            return callback.apply(thisArg, args);
        }
    }
};
function maybe(fn) {
    try {
        return fn();
    }
    catch (ignored) { }
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const globalKey = "@wry/context:Slot";
const host = 
// Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
maybe(() => globalThis) ||
    // Fall back to global, which works in Node.js and may be converted by some
    // bundlers to the appropriate identifier (window, self, ...) depending on the
    // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
    maybe(() => global) ||
    // Otherwise, use a dummy host that's local to this module. We used to fall
    // back to using the Array constructor as a namespace, but that was flagged in
    // https://github.com/benjamn/wryware/issues/347, and can be avoided.
    Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const globalHost = host;
const slot_Slot = globalHost[globalKey] ||
    // Earlier versions of this package stored the globalKey property on the Array
    // constructor, so we check there as well, to prevent Slot class duplication.
    Array[globalKey] ||
    (function (Slot) {
        try {
            Object.defineProperty(globalHost, globalKey, {
                value: Slot,
                enumerable: false,
                writable: false,
                // When it was possible for globalHost to be the Array constructor (a
                // legacy Slot dedup strategy), it was important for the property to be
                // configurable:true so it could be deleted. That does not seem to be as
                // important when globalHost is the global object, but I don't want to
                // cause similar problems again, and configurable:true seems safest.
                // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
                configurable: true
            });
        }
        finally {
            return Slot;
        }
    })(makeSlotClass());
//# sourceMappingURL=slot.js.map
;// CONCATENATED MODULE: ../../app/node_modules/@wry/context/lib/index.js


const { bind, noContext } = slot_Slot;
// Like global.setTimeout, except the callback runs with captured context.

function setTimeoutWithContext(callback, delay) {
    return setTimeout(bind(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function asyncFromGen(genFn) {
    return function () {
        const gen = genFn.apply(this, arguments);
        const boundNext = bind(gen.next);
        const boundThrow = bind(gen.throw);
        return new Promise((resolve, reject) => {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                }
                catch (error) {
                    return reject(error);
                }
                const next = result.done ? resolve : invokeNext;
                if (isPromiseLike(result.value)) {
                    result.value.then(next, result.done ? reject : invokeThrow);
                }
                else {
                    next(result.value);
                }
            }
            const invokeNext = (value) => invoke(boundNext, value);
            const invokeThrow = (error) => invoke(boundThrow, error);
            invokeNext();
        });
    };
}
function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
const wrappedFibers = (/* unused pure expression or super */ null && ([]));
function wrapYieldingFiberMethods(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if (wrappedFibers.indexOf(Fiber) < 0) {
        const wrap = (obj, method) => {
            const fn = obj[method];
            obj[method] = function () {
                return noContext(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        wrappedFibers.push(Fiber);
    }
    return Fiber;
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../app/node_modules/optimism/lib/context.js

const parentEntrySlot = new slot_Slot();
function nonReactive(fn) {
    return parentEntrySlot.withValue(void 0, fn);
}


//# sourceMappingURL=context.js.map
;// CONCATENATED MODULE: ../../app/node_modules/optimism/lib/helpers.js
const { hasOwnProperty: helpers_hasOwnProperty, } = Object.prototype;
const arrayFromSet = Array.from ||
    function (set) {
        const array = [];
        set.forEach(item => array.push(item));
        return array;
    };
function maybeUnsubscribe(entryOrDep) {
    const { unsubscribe } = entryOrDep;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}
//# sourceMappingURL=helpers.js.map
;// CONCATENATED MODULE: ../../app/node_modules/optimism/lib/entry.js


const emptySetPool = [];
const POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function assert(condition, optionalMessage) {
    if (!condition) {
        throw new Error(optionalMessage || "assertion failure");
    }
}
function valueIs(a, b) {
    const len = a.length;
    return (
    // Unknown values are not equal to each other.
    len > 0 &&
        // Both values must be ordinary (or both exceptional) to be equal.
        len === b.length &&
        // The underlying value or exception must be the same.
        a[len - 1] === b[len - 1]);
}
function valueGet(value) {
    switch (value.length) {
        case 0: throw new Error("unknown value");
        case 1: return value[0];
        case 2: throw value[1];
    }
}
function valueCopy(value) {
    return value.slice(0);
}
class Entry {
    constructor(fn) {
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++Entry.count;
    }
    peek() {
        if (this.value.length === 1 && !mightBeDirty(this)) {
            rememberParent(this);
            return this.value[0];
        }
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    recompute(args) {
        assert(!this.recomputing, "already recomputing");
        rememberParent(this);
        return mightBeDirty(this)
            ? reallyRecompute(this, args)
            : valueGet(this.value);
    }
    setDirty() {
        if (this.dirty)
            return;
        this.dirty = true;
        reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        maybeUnsubscribe(this);
    }
    dispose() {
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        eachParent(this, (parent, child) => {
            parent.setDirty();
            forgetChild(parent, this);
        });
    }
    forget() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    }
    dependOn(dep) {
        dep.add(this);
        if (!this.deps) {
            this.deps = emptySetPool.pop() || new Set();
        }
        this.deps.add(dep);
    }
    forgetDeps() {
        if (this.deps) {
            arrayFromSet(this.deps).forEach(dep => dep.delete(this));
            this.deps.clear();
            emptySetPool.push(this.deps);
            this.deps = null;
        }
    }
}
Entry.count = 0;
function rememberParent(child) {
    const parent = parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) {
            parent.childValues.set(child, []);
        }
        if (mightBeDirty(child)) {
            reportDirtyChild(parent, child);
        }
        else {
            reportCleanChild(parent, child);
        }
        return parent;
    }
}
function reallyRecompute(entry, args) {
    forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    parentEntrySlot.withValue(entry, recomputeNewValue, [entry, args]);
    if (maybeSubscribe(entry, args)) {
        // If we successfully recomputed entry.value and did not fail to
        // (re)subscribe, then this Entry is no longer explicitly dirty.
        setClean(entry);
    }
    return valueGet(entry.value);
}
function recomputeNewValue(entry, args) {
    entry.recomputing = true;
    const { normalizeResult } = entry;
    let oldValueCopy;
    if (normalizeResult && entry.value.length === 1) {
        oldValueCopy = valueCopy(entry.value);
    }
    // Make entry.value an empty array, representing an unknown value.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
        // If we have a viable oldValueCopy to compare with the (successfully
        // recomputed) new entry.value, and they are not already === identical, give
        // normalizeResult a chance to pick/choose/reuse parts of oldValueCopy[0]
        // and/or entry.value[0] to determine the final cached entry.value.
        if (normalizeResult && oldValueCopy && !valueIs(oldValueCopy, entry.value)) {
            try {
                entry.value[0] = normalizeResult(entry.value[0], oldValueCopy[0]);
            }
            catch (_a) {
                // If normalizeResult throws, just use the newer value, rather than
                // saving the exception as entry.value[1].
            }
        }
    }
    catch (e) {
        // If entry.fn throws, entry.value will hold that exception.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function setClean(entry) {
    entry.dirty = false;
    if (mightBeDirty(entry)) {
        // This Entry may still have dirty children, in which case we can't
        // let our parents know we're clean just yet.
        return;
    }
    reportClean(entry);
}
function reportDirty(child) {
    eachParent(child, reportDirtyChild);
}
function reportClean(child) {
    eachParent(child, reportCleanChild);
}
function eachParent(child, callback) {
    const parentCount = child.parents.size;
    if (parentCount) {
        const parents = arrayFromSet(child.parents);
        for (let i = 0; i < parentCount; ++i) {
            callback(parents[i], child);
        }
    }
}
// Let a parent Entry know that one of its children may be dirty.
function reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    assert(parent.childValues.has(child));
    assert(mightBeDirty(child));
    const parentWasClean = !mightBeDirty(parent);
    if (!parent.dirtyChildren) {
        parent.dirtyChildren = emptySetPool.pop() || new Set;
    }
    else if (parent.dirtyChildren.has(child)) {
        // If we already know this child is dirty, then we must have already
        // informed our own parents that we are dirty, so we can terminate
        // the recursion early.
        return;
    }
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) {
        reportDirty(parent);
    }
}
// Let a parent Entry know that one of its children is no longer dirty.
function reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    assert(parent.childValues.has(child));
    assert(!mightBeDirty(child));
    const childValue = parent.childValues.get(child);
    if (childValue.length === 0) {
        parent.childValues.set(child, valueCopy(child.value));
    }
    else if (!valueIs(childValue, child.value)) {
        parent.setDirty();
    }
    removeDirtyChild(parent, child);
    if (mightBeDirty(parent)) {
        return;
    }
    reportClean(parent);
}
function removeDirtyChild(parent, child) {
    const dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if (emptySetPool.length < POOL_TARGET_SIZE) {
                emptySetPool.push(dc);
            }
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function forgetChildren(parent) {
    if (parent.childValues.size > 0) {
        parent.childValues.forEach((_value, child) => {
            forgetChild(parent, child);
        });
    }
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    assert(parent.dirtyChildren === null);
}
function forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    removeDirtyChild(parent, child);
}
function maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") {
        try {
            maybeUnsubscribe(entry); // Prevent double subscriptions.
            entry.unsubscribe = entry.subscribe.apply(null, args);
        }
        catch (e) {
            // If this Entry has a subscribe function and it threw an exception
            // (or an unsubscribe function it previously returned now throws),
            // return false to indicate that we were not able to subscribe (or
            // unsubscribe), and this Entry should remain dirty.
            entry.setDirty();
            return false;
        }
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
//# sourceMappingURL=entry.js.map
;// CONCATENATED MODULE: ../../app/node_modules/optimism/lib/dep.js


const EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true, // Fully remove parent Entry from LRU cache and computation graph
};
function dep_dep(options) {
    const depsByKey = new Map();
    const subscribe = options && options.subscribe;
    function depend(key) {
        const parent = parentEntrySlot.getValue();
        if (parent) {
            let dep = depsByKey.get(key);
            if (!dep) {
                depsByKey.set(key, dep = new Set);
            }
            parent.dependOn(dep);
            if (typeof subscribe === "function") {
                maybeUnsubscribe(dep);
                dep.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        const dep = depsByKey.get(key);
        if (dep) {
            const m = (entryMethodName &&
                helpers_hasOwnProperty.call(EntryMethods, entryMethodName)) ? entryMethodName : "setDirty";
            // We have to use arrayFromSet(dep).forEach instead of dep.forEach,
            // because modifying a Set while iterating over it can cause elements in
            // the Set to be removed from the Set before they've been iterated over.
            arrayFromSet(dep).forEach(entry => entry[m]());
            depsByKey.delete(key);
            maybeUnsubscribe(dep);
        }
    };
    return depend;
}
//# sourceMappingURL=dep.js.map
;// CONCATENATED MODULE: ../../app/node_modules/optimism/lib/index.js




// These helper functions are important for making optimism work with
// asynchronous code. In order to register parent-child dependencies,
// optimism needs to know about any currently active parent computations.
// In ordinary synchronous code, the parent context is implicit in the
// execution stack, but asynchronous code requires some extra guidance in
// order to propagate context from one async task segment to the next.

// A lighter-weight dependency, similar to OptimisticWrapperFunction, except
// with only one argument, no makeCacheKey, no wrapped function to recompute,
// and no result value. Useful for representing dependency leaves in the graph
// of computation. Subscriptions are supported.

// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
let defaultKeyTrie;
function defaultMakeCacheKey(...args) {
    const trie = defaultKeyTrie || (defaultKeyTrie = new Trie(typeof WeakMap === "function"));
    return trie.lookupArray(args);
}
// If you're paranoid about memory leaks, or you want to avoid using WeakMap
// under the hood, but you still need the behavior of defaultMakeCacheKey,
// import this constructor to create your own tries.

;
const caches = new Set();
function lib_wrap(originalFunction, { max = Math.pow(2, 16), keyArgs, makeCacheKey = defaultMakeCacheKey, normalizeResult, subscribe, cache: cacheOption = strong/* StrongCache */.e, } = Object.create(null)) {
    const cache = typeof cacheOption === "function"
        ? new cacheOption(max, entry => entry.dispose())
        : cacheOption;
    const optimistic = function () {
        const key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) {
            return originalFunction.apply(null, arguments);
        }
        let entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new Entry(originalFunction));
            entry.normalizeResult = normalizeResult;
            entry.subscribe = subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = () => cache.delete(key);
        }
        const value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!parentEntrySlot.hasValue()) {
            caches.forEach(cache => cache.clean());
            caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: () => cache.size,
        configurable: false,
        enumerable: false,
    });
    Object.freeze(optimistic.options = {
        max,
        keyArgs,
        makeCacheKey,
        normalizeResult,
        subscribe,
        cache,
    });
    function dirtyKey(key) {
        const entry = key && cache.get(key);
        if (entry) {
            entry.setDirty();
        }
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        const entry = key && cache.get(key);
        if (entry) {
            return entry.peek();
        }
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return key ? cache.delete(key) : false;
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}
//# sourceMappingURL=index.js.map

}),
68948: (function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
"use strict";
__webpack_require__.d(__webpack_exports__, {
  CR: () => (__read),
  FC: () => (__asyncGenerator),
  Jh: () => (__generator),
  KL: () => (__asyncValues),
  XA: () => (__values),
  ZT: () => (__extends),
  ev: () => (__spreadArray),
  mG: () => (__awaiter),
  pi: () => (__assign),
  qq: () => (__await)
});
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

var ownKeys = function(o) {
  ownKeys = Object.getOwnPropertyNames || function (o) {
    var ar = [];
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
    return ar;
  };
  return ownKeys(o);
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = (/* unused pure expression or super */ null && (typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
}));

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r, s = 0;
  function next() {
    while (r = env.stack.pop()) {
      try {
        if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
        if (r.dispose) {
          var result = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
        }
        else s |= 1;
      }
      catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
  if (typeof path === "string" && /^\.\.?\//.test(path)) {
      return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
          return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
      });
  }
  return path;
}

/* unused ESM default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension,
})));


}),
94530: (function (module) {
"use strict";
module.exports = JSON.parse('{"version":"2020a","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|01010230405656565656565656565656565656565656565656565656565656565656565656565656565656565657|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|01010230405656565656565656565656565656565656565656565656565656565656565656565656565656565657|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|0101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Pacific/Port_Moresby|+10|-a0|0||25e4","Etc/GMT-11|+11|-b0|0||","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0||","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Port_of_Spain America/Antigua","AI|America/Port_of_Spain America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Currie Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Curacao America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Port_of_Spain America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Brunei","BO|America/La_Paz","BQ|America/Curacao America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Vancouver America/Whitehorse America/Dawson","CC|Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Curacao","CX|Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Copenhagen","DM|America/Port_of_Spain America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Port_of_Spain America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Port_of_Spain America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Port_of_Spain America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Port_of_Spain America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Port_of_Spain America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Majuro Pacific/Kwajalein","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Port_of_Spain America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas","MY|Asia/Kuala_Lumpur Asia/Kuching","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Amsterdam","NO|Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Astrakhan Europe/Volgograd Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Oslo Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Curacao America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Indian/Reunion Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Port_of_Spain","TV|Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Port_of_Spain America/St_Vincent","VE|America/Caracas","VG|America/Port_of_Spain America/Tortola","VI|America/Port_of_Spain America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}')

}),

});
/************************************************************************/
// The module cache
var __webpack_module_cache__ = {};

// The require function
function __webpack_require__(moduleId) {

// Check if module is in cache
var cachedModule = __webpack_module_cache__[moduleId];
if (cachedModule !== undefined) {
return cachedModule.exports;
}
// Create a new module (and put it into the cache)
var module = (__webpack_module_cache__[moduleId] = {
id: moduleId,
loaded: false,
exports: {}
});
// Execute the module function
__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);

// Flag the module as loaded
module.loaded = true;
// Return the exports of the module
return module.exports;

}

/************************************************************************/
// webpack/runtime/define_property_getters
(() => {
__webpack_require__.d = (exports, definition) => {
	for(var key in definition) {
        if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
            Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
        }
    }
};
})();
// webpack/runtime/esm_module_decorator
(() => {
__webpack_require__.hmd = (module) => {
  module = Object.create(module);
  if (!module.children) module.children = [];
  Object.defineProperty(module, 'exports', {
      enumerable: true,
      set: () => {
          throw new Error('ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: ' + module.id);
      }
  });
  return module;
};
})();
// webpack/runtime/global
(() => {
__webpack_require__.g = (() => {
	if (typeof globalThis === 'object') return globalThis;
	try {
		return this || new Function('return this')();
	} catch (e) {
		if (typeof window === 'object') return window;
	}
})();
})();
// webpack/runtime/has_own_property
(() => {
__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
})();
// webpack/runtime/make_namespace_object
(() => {
// define __esModule on exports
__webpack_require__.r = (exports) => {
	if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	}
	Object.defineProperty(exports, '__esModule', { value: true });
};
})();
// webpack/runtime/node_module_decorator
(() => {
__webpack_require__.nmd = (module) => {
  module.paths = [];
  if (!module.children) module.children = [];
  return module;
};
})();
// webpack/runtime/rspack_version
(() => {
__webpack_require__.rv = () => ("1.3.9")
})();
// webpack/runtime/rspack_unique_id
(() => {
__webpack_require__.ruid = "bundler=rspack@1.3.9";

})();
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
(() => {
__webpack_require__(9461);__webpack_require__(27624);__webpack_require__(30286);__webpack_require__(8334);__webpack_require__(12338);__webpack_require__(93695);__webpack_require__(41655);__webpack_require__(79858);__webpack_require__(64054);__webpack_require__(40941);__webpack_require__(65134);__webpack_require__(84345);__webpack_require__(27527);__webpack_require__(80334);
})();

})()
;